var N5 = Object.defineProperty;
var Hw = (e) => {
  throw TypeError(e);
};
var L5 = (e, t, n) => t in e ? N5(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var Qt = (e, t, n) => L5(e, typeof t != "symbol" ? t + "" : t, n), $5 = (e, t, n) => t.has(e) || Hw("Cannot " + n);
var Gw = (e, t, n) => t.has(e) ? Hw("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, n);
var Yw = (e, t, n) => ($5(e, t, "access private method"), n);
import * as Kw from "vue";
import { getCurrentInstance as np, inject as br, computed as ce, watch as Ln, onMounted as Ft, onUnmounted as cr, ref as ge, shallowRef as rp, effectScope as xP, isRef as Vs, defineComponent as dt, h as $t, Fragment as Re, createVNode as W, Text as V5, openBlock as _, createElementBlock as O, createElementVNode as k, createTextVNode as Me, toDisplayString as j, createCommentVNode as L, normalizeClass as Pe, resolveComponent as U, withDirectives as ur, vModelText as tl, renderList as Ke, reactive as nl, useSlots as e0, toRef as vh, unref as re, mergeProps as or, createSlots as Gr, withCtx as ie, renderSlot as xe, normalizeProps as yi, guardReactiveProps as ns, createBlock as ae, Teleport as wP, nextTick as Nn, withKeys as bt, withModifiers as sn, Transition as Ea, normalizeStyle as Zn, resolveDynamicComponent as Lr, vShow as Ws, getCurrentScope as B5, onScopeDispose as U5, onBeforeUpdate as q5, watchEffect as _r, cloneVNode as j5, provide as Zr, toRaw as aa, resolveDirective as kP, vModelCheckbox as W5, vModelSelect as z5, vModelRadio as H5, createStaticVNode as G5, onBeforeUnmount as Y5 } from "vue";
import { Field as cu, ErrorMessage as K5 } from "vee-validate";
import { TrashIcon as t0, CloudUploadIcon as X5, SearchIcon as Fc, InformationCircleIcon as ds, ChevronUpIcon as SP, ChevronDownIcon as CP, SelectorIcon as Z5, EyeIcon as TP, PencilAltIcon as Q5, DownloadIcon as bh, CheckCircleIcon as AP, ExclamationCircleIcon as J5, XIcon as Zc, DocumentTextIcon as ip, ExternalLinkIcon as DP, ChevronRightIcon as eB, ClipboardListIcon as tB, PencilIcon as nB, PlusIcon as rB, PlayIcon as iB, ClipboardCheckIcon as aB, AcademicCapIcon as sB, EyeOffIcon as oB } from "@heroicons/vue/outline";
import { ChevronDownIcon as Qc, XIcon as EP, CheckIcon as ap, SearchIcon as lB, InformationCircleIcon as uB, CheckCircleIcon as n0, ExclamationIcon as _h, ExclamationCircleIcon as uh, PhotographIcon as gg, FolderIcon as Xw, HomeIcon as Zw, DocumentTextIcon as Af, EyeIcon as cB, PaperClipIcon as Qw, PlusIcon as dB, ArrowRightIcon as fB, StarIcon as hB, CreditCardIcon as pB, ReceiptTaxIcon as mB, CashIcon as gB, BanIcon as vB, CogIcon as bB, ClockIcon as _B, ChevronDoubleUpIcon as yB } from "@heroicons/vue/solid";
import xB from "axios";
import PP, { isIdempotentRequestError as wB } from "axios-retry";
import kB from "rollbar";
/*!
  * shared v9.14.5
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function Ki(e, t) {
  typeof console < "u" && (console.warn("[intlify] " + e), t && console.warn(t.stack));
}
const Jw = {};
function OP(e) {
  Jw[e] || (Jw[e] = !0, Ki(e));
}
const ca = typeof window < "u";
let xi, Ho;
if (process.env.NODE_ENV !== "production") {
  const e = ca && window.performance;
  e && e.mark && e.measure && e.clearMarks && // @ts-ignore browser compat
  e.clearMeasures && (xi = (t) => {
    e.mark(t);
  }, Ho = (t, n, r) => {
    e.measure(t, n, r), e.clearMarks(n), e.clearMarks(r);
  });
}
const SB = /\{([0-9a-zA-Z]+)\}/g;
function r0(e, ...t) {
  return t.length === 1 && Rt(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(SB, (n, r) => t.hasOwnProperty(r) ? t[r] : "");
}
const Pa = (e, t = !1) => t ? Symbol.for(e) : Symbol(e), CB = (e, t, n) => TB({ l: e, k: t, s: n }), TB = (e) => JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), Qn = (e) => typeof e == "number" && isFinite(e), AB = (e) => IP(e) === "[object Date]", yh = (e) => IP(e) === "[object RegExp]", sp = (e) => It(e) && Object.keys(e).length === 0, $r = Object.assign, DB = Object.create, en = (e = null) => DB(e);
let ek;
const i0 = () => ek || (ek = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : en());
function tk(e) {
  return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/\//g, "&#x2F;").replace(/=/g, "&#x3D;");
}
function nk(e) {
  return e.replace(/&(?![a-zA-Z0-9#]{2,6};)/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function EB(e) {
  return e = e.replace(/(\w+)\s*=\s*"([^"]*)"/g, (r, i, a) => `${i}="${nk(a)}"`), e = e.replace(/(\w+)\s*=\s*'([^']*)'/g, (r, i, a) => `${i}='${nk(a)}'`), /\s*on\w+\s*=\s*["']?[^"'>]+["']?/gi.test(e) && (process.env.NODE_ENV !== "production" && Ki("Potentially dangerous event handlers detected in translation. Consider removing onclick, onerror, etc. from your translation messages."), e = e.replace(/(\s+)(on)(\w+\s*=)/gi, "$1&#111;n$3")), [
    // In href, src, action, formaction attributes
    /(\s+(?:href|src|action|formaction)\s*=\s*["']?)\s*javascript:/gi,
    // In style attributes within url()
    /(style\s*=\s*["'][^"']*url\s*\(\s*)javascript:/gi
  ].forEach((r) => {
    e = e.replace(r, "$1javascript&#58;");
  }), e;
}
const PB = Object.prototype.hasOwnProperty;
function la(e, t) {
  return PB.call(e, t);
}
const Jn = Array.isArray, yn = (e) => typeof e == "function", We = (e) => typeof e == "string", xn = (e) => typeof e == "boolean", Rt = (e) => e !== null && typeof e == "object", OB = (e) => Rt(e) && yn(e.then) && yn(e.catch), MP = Object.prototype.toString, IP = (e) => MP.call(e), It = (e) => {
  if (!Rt(e))
    return !1;
  const t = Object.getPrototypeOf(e);
  return t === null || t.constructor === Object;
}, MB = (e) => e == null ? "" : Jn(e) || It(e) && e.toString === MP ? JSON.stringify(e, null, 2) : String(e);
function IB(e, t = "") {
  return e.reduce((n, r, i) => i === 0 ? n + r : n + t + r, "");
}
const rk = 2;
function RB(e, t = 0, n = e.length) {
  const r = e.split(/\r?\n/);
  let i = 0;
  const a = [];
  for (let s = 0; s < r.length; s++)
    if (i += r[s].length + 1, i >= t) {
      for (let o = s - rk; o <= s + rk || n > i; o++) {
        if (o < 0 || o >= r.length)
          continue;
        const l = o + 1;
        a.push(`${l}${" ".repeat(3 - String(l).length)}|  ${r[o]}`);
        const c = r[o].length;
        if (o === s) {
          const f = t - (i - c) + 1, h = Math.max(1, n > i ? c - f : n - t);
          a.push("   |  " + " ".repeat(f) + "^".repeat(h));
        } else if (o > s) {
          if (n > i) {
            const f = Math.max(Math.min(n - i, c), 1);
            a.push("   |  " + "^".repeat(f));
          }
          i += c + 1;
        }
      }
      break;
    }
  return a.join(`
`);
}
function op(e) {
  let t = e;
  return () => ++t;
}
function RP() {
  const e = /* @__PURE__ */ new Map();
  return {
    events: e,
    on(n, r) {
      const i = e.get(n);
      i && i.push(r) || e.set(n, [r]);
    },
    off(n, r) {
      const i = e.get(n);
      i && i.splice(i.indexOf(r) >>> 0, 1);
    },
    emit(n, r) {
      (e.get(n) || []).slice().map((i) => i(r)), (e.get("*") || []).slice().map((i) => i(n, r));
    }
  };
}
const Df = (e) => !Rt(e) || Jn(e);
function ch(e, t) {
  if (Df(e) || Df(t))
    throw new Error("Invalid value");
  const n = [{ src: e, des: t }];
  for (; n.length; ) {
    const { src: r, des: i } = n.pop();
    Object.keys(r).forEach((a) => {
      a !== "__proto__" && (Rt(r[a]) && !Rt(i[a]) && (i[a] = Array.isArray(r[a]) ? [] : en()), Df(i[a]) || Df(r[a]) ? i[a] = r[a] : n.push({ src: r[a], des: i[a] }));
    });
  }
}
/*!
  * message-compiler v9.14.5
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function FB(e, t, n) {
  return { line: e, column: t, offset: n };
}
function xh(e, t, n) {
  return { start: e, end: t };
}
const NB = /\{([0-9a-zA-Z]+)\}/g;
function FP(e, ...t) {
  return t.length === 1 && LB(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(NB, (n, r) => t.hasOwnProperty(r) ? t[r] : "");
}
const NP = Object.assign, ik = (e) => typeof e == "string", LB = (e) => e !== null && typeof e == "object";
function LP(e, t = "") {
  return e.reduce((n, r, i) => i === 0 ? n + r : n + t + r, "");
}
const lp = {
  USE_MODULO_SYNTAX: 1,
  __EXTEND_POINT__: 2
}, $B = {
  [lp.USE_MODULO_SYNTAX]: "Use modulo before '{{0}}'."
};
function VB(e, t, ...n) {
  const r = FP($B[e], ...n || []), i = { message: String(r), code: e };
  return t && (i.location = t), i;
}
const st = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16,
  // Special value for higher-order compilers to pick up the last code
  // to avoid collision of error codes. This should always be kept as the last
  // item.
  __EXTEND_POINT__: 17
}, BB = {
  // tokenizer error messages
  [st.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [st.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [st.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [st.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [st.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [st.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [st.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [st.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [st.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [st.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [st.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [st.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [st.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [st.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [st.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [st.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function du(e, t, n = {}) {
  const { domain: r, messages: i, args: a } = n, s = FP((i || BB)[e] || "", ...a || []), o = new SyntaxError(String(s));
  return o.code = e, t && (o.location = t), o.domain = r, o;
}
function UB(e) {
  throw e;
}
const qB = /<\/?[\w\s="/.':;#-\/]+>/, jB = (e) => qB.test(e), za = " ", WB = "\r", Wr = `
`, zB = "\u2028", HB = "\u2029";
function GB(e) {
  const t = e;
  let n = 0, r = 1, i = 1, a = 0;
  const s = (T) => t[T] === WB && t[T + 1] === Wr, o = (T) => t[T] === Wr, l = (T) => t[T] === HB, c = (T) => t[T] === zB, f = (T) => s(T) || o(T) || l(T) || c(T), h = () => n, p = () => r, g = () => i, v = () => a, y = (T) => s(T) || l(T) || c(T) ? Wr : t[T], S = () => y(n), x = () => y(n + a);
  function E() {
    return a = 0, f(n) && (r++, i = 0), s(n) && n++, n++, i++, t[n];
  }
  function w() {
    return s(n + a) && a++, a++, t[n + a];
  }
  function C() {
    n = 0, r = 1, i = 1, a = 0;
  }
  function P(T = 0) {
    a = T;
  }
  function M() {
    const T = n + a;
    for (; T !== n; )
      E();
    a = 0;
  }
  return {
    index: h,
    line: p,
    column: g,
    peekOffset: v,
    charAt: y,
    currentChar: S,
    currentPeek: x,
    next: E,
    peek: w,
    reset: C,
    resetPeek: P,
    skipToPeek: M
  };
}
const Ms = void 0, YB = ".", ak = "'", KB = "tokenizer";
function XB(e, t = {}) {
  const n = t.location !== !1, r = GB(e), i = () => r.index(), a = () => FB(r.line(), r.column(), r.index()), s = a(), o = i(), l = {
    currentType: 14,
    offset: o,
    startLoc: s,
    endLoc: s,
    lastType: 14,
    lastOffset: o,
    lastStartLoc: s,
    lastEndLoc: s,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, c = () => l, { onError: f } = t;
  function h(B, z, ye, ...$e) {
    const Ct = c();
    if (z.column += ye, z.offset += ye, f) {
      const At = n ? xh(Ct.startLoc, z) : null, mt = du(B, At, {
        domain: KB,
        args: $e
      });
      f(mt);
    }
  }
  function p(B, z, ye) {
    B.endLoc = a(), B.currentType = z;
    const $e = { type: z };
    return n && ($e.loc = xh(B.startLoc, B.endLoc)), ye != null && ($e.value = ye), $e;
  }
  const g = (B) => p(
    B,
    14
    /* TokenTypes.EOF */
  );
  function v(B, z) {
    return B.currentChar() === z ? (B.next(), z) : (h(st.EXPECTED_TOKEN, a(), 0, z), "");
  }
  function y(B) {
    let z = "";
    for (; B.currentPeek() === za || B.currentPeek() === Wr; )
      z += B.currentPeek(), B.peek();
    return z;
  }
  function S(B) {
    const z = y(B);
    return B.skipToPeek(), z;
  }
  function x(B) {
    if (B === Ms)
      return !1;
    const z = B.charCodeAt(0);
    return z >= 97 && z <= 122 || // a-z
    z >= 65 && z <= 90 || // A-Z
    z === 95;
  }
  function E(B) {
    if (B === Ms)
      return !1;
    const z = B.charCodeAt(0);
    return z >= 48 && z <= 57;
  }
  function w(B, z) {
    const { currentType: ye } = z;
    if (ye !== 2)
      return !1;
    y(B);
    const $e = x(B.currentPeek());
    return B.resetPeek(), $e;
  }
  function C(B, z) {
    const { currentType: ye } = z;
    if (ye !== 2)
      return !1;
    y(B);
    const $e = B.currentPeek() === "-" ? B.peek() : B.currentPeek(), Ct = E($e);
    return B.resetPeek(), Ct;
  }
  function P(B, z) {
    const { currentType: ye } = z;
    if (ye !== 2)
      return !1;
    y(B);
    const $e = B.currentPeek() === ak;
    return B.resetPeek(), $e;
  }
  function M(B, z) {
    const { currentType: ye } = z;
    if (ye !== 8)
      return !1;
    y(B);
    const $e = B.currentPeek() === ".";
    return B.resetPeek(), $e;
  }
  function T(B, z) {
    const { currentType: ye } = z;
    if (ye !== 9)
      return !1;
    y(B);
    const $e = x(B.currentPeek());
    return B.resetPeek(), $e;
  }
  function N(B, z) {
    const { currentType: ye } = z;
    if (!(ye === 8 || ye === 12))
      return !1;
    y(B);
    const $e = B.currentPeek() === ":";
    return B.resetPeek(), $e;
  }
  function $(B, z) {
    const { currentType: ye } = z;
    if (ye !== 10)
      return !1;
    const $e = () => {
      const At = B.currentPeek();
      return At === "{" ? x(B.peek()) : At === "@" || At === "%" || At === "|" || At === ":" || At === "." || At === za || !At ? !1 : At === Wr ? (B.peek(), $e()) : te(B, !1);
    }, Ct = $e();
    return B.resetPeek(), Ct;
  }
  function ne(B) {
    y(B);
    const z = B.currentPeek() === "|";
    return B.resetPeek(), z;
  }
  function Y(B) {
    const z = y(B), ye = B.currentPeek() === "%" && B.peek() === "{";
    return B.resetPeek(), {
      isModulo: ye,
      hasSpace: z.length > 0
    };
  }
  function te(B, z = !0) {
    const ye = (Ct = !1, At = "", mt = !1) => {
      const he = B.currentPeek();
      return he === "{" ? At === "%" ? !1 : Ct : he === "@" || !he ? At === "%" ? !0 : Ct : he === "%" ? (B.peek(), ye(Ct, "%", !0)) : he === "|" ? At === "%" || mt ? !0 : !(At === za || At === Wr) : he === za ? (B.peek(), ye(!0, za, mt)) : he === Wr ? (B.peek(), ye(!0, Wr, mt)) : !0;
    }, $e = ye();
    return z && B.resetPeek(), $e;
  }
  function _e(B, z) {
    const ye = B.currentChar();
    return ye === Ms ? Ms : z(ye) ? (B.next(), ye) : null;
  }
  function Fe(B) {
    const z = B.charCodeAt(0);
    return z >= 97 && z <= 122 || // a-z
    z >= 65 && z <= 90 || // A-Z
    z >= 48 && z <= 57 || // 0-9
    z === 95 || // _
    z === 36;
  }
  function J(B) {
    return _e(B, Fe);
  }
  function oe(B) {
    const z = B.charCodeAt(0);
    return z >= 97 && z <= 122 || // a-z
    z >= 65 && z <= 90 || // A-Z
    z >= 48 && z <= 57 || // 0-9
    z === 95 || // _
    z === 36 || // $
    z === 45;
  }
  function A(B) {
    return _e(B, oe);
  }
  function X(B) {
    const z = B.charCodeAt(0);
    return z >= 48 && z <= 57;
  }
  function pe(B) {
    return _e(B, X);
  }
  function le(B) {
    const z = B.charCodeAt(0);
    return z >= 48 && z <= 57 || // 0-9
    z >= 65 && z <= 70 || // A-F
    z >= 97 && z <= 102;
  }
  function ue(B) {
    return _e(B, le);
  }
  function Te(B) {
    let z = "", ye = "";
    for (; z = pe(B); )
      ye += z;
    return ye;
  }
  function Ne(B) {
    S(B);
    const z = B.currentChar();
    return z !== "%" && h(st.EXPECTED_TOKEN, a(), 0, z), B.next(), "%";
  }
  function Z(B) {
    let z = "";
    for (; ; ) {
      const ye = B.currentChar();
      if (ye === "{" || ye === "}" || ye === "@" || ye === "|" || !ye)
        break;
      if (ye === "%")
        if (te(B))
          z += ye, B.next();
        else
          break;
      else if (ye === za || ye === Wr)
        if (te(B))
          z += ye, B.next();
        else {
          if (ne(B))
            break;
          z += ye, B.next();
        }
      else
        z += ye, B.next();
    }
    return z;
  }
  function G(B) {
    S(B);
    let z = "", ye = "";
    for (; z = A(B); )
      ye += z;
    return B.currentChar() === Ms && h(st.UNTERMINATED_CLOSING_BRACE, a(), 0), ye;
  }
  function se(B) {
    S(B);
    let z = "";
    return B.currentChar() === "-" ? (B.next(), z += `-${Te(B)}`) : z += Te(B), B.currentChar() === Ms && h(st.UNTERMINATED_CLOSING_BRACE, a(), 0), z;
  }
  function St(B) {
    return B !== ak && B !== Wr;
  }
  function Sn(B) {
    S(B), v(B, "'");
    let z = "", ye = "";
    for (; z = _e(B, St); )
      z === "\\" ? ye += Vt(B) : ye += z;
    const $e = B.currentChar();
    return $e === Wr || $e === Ms ? (h(st.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, a(), 0), $e === Wr && (B.next(), v(B, "'")), ye) : (v(B, "'"), ye);
  }
  function Vt(B) {
    const z = B.currentChar();
    switch (z) {
      case "\\":
      case "'":
        return B.next(), `\\${z}`;
      case "u":
        return nn(B, z, 4);
      case "U":
        return nn(B, z, 6);
      default:
        return h(st.UNKNOWN_ESCAPE_SEQUENCE, a(), 0, z), "";
    }
  }
  function nn(B, z, ye) {
    v(B, z);
    let $e = "";
    for (let Ct = 0; Ct < ye; Ct++) {
      const At = ue(B);
      if (!At) {
        h(st.INVALID_UNICODE_ESCAPE_SEQUENCE, a(), 0, `\\${z}${$e}${B.currentChar()}`);
        break;
      }
      $e += At;
    }
    return `\\${z}${$e}`;
  }
  function rr(B) {
    return B !== "{" && B !== "}" && B !== za && B !== Wr;
  }
  function Qe(B) {
    S(B);
    let z = "", ye = "";
    for (; z = _e(B, rr); )
      ye += z;
    return ye;
  }
  function Je(B) {
    let z = "", ye = "";
    for (; z = J(B); )
      ye += z;
    return ye;
  }
  function Pt(B) {
    const z = (ye) => {
      const $e = B.currentChar();
      return $e === "{" || $e === "%" || $e === "@" || $e === "|" || $e === "(" || $e === ")" || !$e || $e === za ? ye : (ye += $e, B.next(), z(ye));
    };
    return z("");
  }
  function Xe(B) {
    S(B);
    const z = v(
      B,
      "|"
      /* TokenChars.Pipe */
    );
    return S(B), z;
  }
  function pt(B, z) {
    let ye = null;
    switch (B.currentChar()) {
      case "{":
        return z.braceNest >= 1 && h(st.NOT_ALLOW_NEST_PLACEHOLDER, a(), 0), B.next(), ye = p(
          z,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), S(B), z.braceNest++, ye;
      case "}":
        return z.braceNest > 0 && z.currentType === 2 && h(st.EMPTY_PLACEHOLDER, a(), 0), B.next(), ye = p(
          z,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), z.braceNest--, z.braceNest > 0 && S(B), z.inLinked && z.braceNest === 0 && (z.inLinked = !1), ye;
      case "@":
        return z.braceNest > 0 && h(st.UNTERMINATED_CLOSING_BRACE, a(), 0), ye = Cn(B, z) || g(z), z.braceNest = 0, ye;
      default: {
        let Ct = !0, At = !0, mt = !0;
        if (ne(B))
          return z.braceNest > 0 && h(st.UNTERMINATED_CLOSING_BRACE, a(), 0), ye = p(z, 1, Xe(B)), z.braceNest = 0, z.inLinked = !1, ye;
        if (z.braceNest > 0 && (z.currentType === 5 || z.currentType === 6 || z.currentType === 7))
          return h(st.UNTERMINATED_CLOSING_BRACE, a(), 0), z.braceNest = 0, ut(B, z);
        if (Ct = w(B, z))
          return ye = p(z, 5, G(B)), S(B), ye;
        if (At = C(B, z))
          return ye = p(z, 6, se(B)), S(B), ye;
        if (mt = P(B, z))
          return ye = p(z, 7, Sn(B)), S(B), ye;
        if (!Ct && !At && !mt)
          return ye = p(z, 13, Qe(B)), h(st.INVALID_TOKEN_IN_PLACEHOLDER, a(), 0, ye.value), S(B), ye;
        break;
      }
    }
    return ye;
  }
  function Cn(B, z) {
    const { currentType: ye } = z;
    let $e = null;
    const Ct = B.currentChar();
    switch ((ye === 8 || ye === 9 || ye === 12 || ye === 10) && (Ct === Wr || Ct === za) && h(st.INVALID_LINKED_FORMAT, a(), 0), Ct) {
      case "@":
        return B.next(), $e = p(
          z,
          8,
          "@"
          /* TokenChars.LinkedAlias */
        ), z.inLinked = !0, $e;
      case ".":
        return S(B), B.next(), p(
          z,
          9,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return S(B), B.next(), p(
          z,
          10,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return ne(B) ? ($e = p(z, 1, Xe(B)), z.braceNest = 0, z.inLinked = !1, $e) : M(B, z) || N(B, z) ? (S(B), Cn(B, z)) : T(B, z) ? (S(B), p(z, 12, Je(B))) : $(B, z) ? (S(B), Ct === "{" ? pt(B, z) || $e : p(z, 11, Pt(B))) : (ye === 8 && h(st.INVALID_LINKED_FORMAT, a(), 0), z.braceNest = 0, z.inLinked = !1, ut(B, z));
    }
  }
  function ut(B, z) {
    let ye = {
      type: 14
      /* TokenTypes.EOF */
    };
    if (z.braceNest > 0)
      return pt(B, z) || g(z);
    if (z.inLinked)
      return Cn(B, z) || g(z);
    switch (B.currentChar()) {
      case "{":
        return pt(B, z) || g(z);
      case "}":
        return h(st.UNBALANCED_CLOSING_BRACE, a(), 0), B.next(), p(
          z,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return Cn(B, z) || g(z);
      default: {
        if (ne(B))
          return ye = p(z, 1, Xe(B)), z.braceNest = 0, z.inLinked = !1, ye;
        const { isModulo: Ct, hasSpace: At } = Y(B);
        if (Ct)
          return At ? p(z, 0, Z(B)) : p(z, 4, Ne(B));
        if (te(B))
          return p(z, 0, Z(B));
        break;
      }
    }
    return ye;
  }
  function dr() {
    const { currentType: B, offset: z, startLoc: ye, endLoc: $e } = l;
    return l.lastType = B, l.lastOffset = z, l.lastStartLoc = ye, l.lastEndLoc = $e, l.offset = i(), l.startLoc = a(), r.currentChar() === Ms ? p(
      l,
      14
      /* TokenTypes.EOF */
    ) : ut(r, l);
  }
  return {
    nextToken: dr,
    currentOffset: i,
    currentPosition: a,
    context: c
  };
}
const ZB = "parser", QB = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function JB(e, t, n) {
  switch (e) {
    case "\\\\":
      return "\\";
    // eslint-disable-next-line no-useless-escape
    case "\\'":
      return "'";
    default: {
      const r = parseInt(t || n, 16);
      return r <= 55295 || r >= 57344 ? String.fromCodePoint(r) : "�";
    }
  }
}
function eU(e = {}) {
  const t = e.location !== !1, { onError: n, onWarn: r } = e;
  function i(w, C, P, M, ...T) {
    const N = w.currentPosition();
    if (N.offset += M, N.column += M, n) {
      const $ = t ? xh(P, N) : null, ne = du(C, $, {
        domain: ZB,
        args: T
      });
      n(ne);
    }
  }
  function a(w, C, P, M, ...T) {
    const N = w.currentPosition();
    if (N.offset += M, N.column += M, r) {
      const $ = t ? xh(P, N) : null;
      r(VB(C, $, T));
    }
  }
  function s(w, C, P) {
    const M = { type: w };
    return t && (M.start = C, M.end = C, M.loc = { start: P, end: P }), M;
  }
  function o(w, C, P, M) {
    t && (w.end = C, w.loc && (w.loc.end = P));
  }
  function l(w, C) {
    const P = w.context(), M = s(3, P.offset, P.startLoc);
    return M.value = C, o(M, w.currentOffset(), w.currentPosition()), M;
  }
  function c(w, C) {
    const P = w.context(), { lastOffset: M, lastStartLoc: T } = P, N = s(5, M, T);
    return N.index = parseInt(C, 10), w.nextToken(), o(N, w.currentOffset(), w.currentPosition()), N;
  }
  function f(w, C, P) {
    const M = w.context(), { lastOffset: T, lastStartLoc: N } = M, $ = s(4, T, N);
    return $.key = C, P === !0 && ($.modulo = !0), w.nextToken(), o($, w.currentOffset(), w.currentPosition()), $;
  }
  function h(w, C) {
    const P = w.context(), { lastOffset: M, lastStartLoc: T } = P, N = s(9, M, T);
    return N.value = C.replace(QB, JB), w.nextToken(), o(N, w.currentOffset(), w.currentPosition()), N;
  }
  function p(w) {
    const C = w.nextToken(), P = w.context(), { lastOffset: M, lastStartLoc: T } = P, N = s(8, M, T);
    return C.type !== 12 ? (i(w, st.UNEXPECTED_EMPTY_LINKED_MODIFIER, P.lastStartLoc, 0), N.value = "", o(N, M, T), {
      nextConsumeToken: C,
      node: N
    }) : (C.value == null && i(w, st.UNEXPECTED_LEXICAL_ANALYSIS, P.lastStartLoc, 0, ra(C)), N.value = C.value || "", o(N, w.currentOffset(), w.currentPosition()), {
      node: N
    });
  }
  function g(w, C) {
    const P = w.context(), M = s(7, P.offset, P.startLoc);
    return M.value = C, o(M, w.currentOffset(), w.currentPosition()), M;
  }
  function v(w) {
    const C = w.context(), P = s(6, C.offset, C.startLoc);
    let M = w.nextToken();
    if (M.type === 9) {
      const T = p(w);
      P.modifier = T.node, M = T.nextConsumeToken || w.nextToken();
    }
    switch (M.type !== 10 && i(w, st.UNEXPECTED_LEXICAL_ANALYSIS, C.lastStartLoc, 0, ra(M)), M = w.nextToken(), M.type === 2 && (M = w.nextToken()), M.type) {
      case 11:
        M.value == null && i(w, st.UNEXPECTED_LEXICAL_ANALYSIS, C.lastStartLoc, 0, ra(M)), P.key = g(w, M.value || "");
        break;
      case 5:
        M.value == null && i(w, st.UNEXPECTED_LEXICAL_ANALYSIS, C.lastStartLoc, 0, ra(M)), P.key = f(w, M.value || "");
        break;
      case 6:
        M.value == null && i(w, st.UNEXPECTED_LEXICAL_ANALYSIS, C.lastStartLoc, 0, ra(M)), P.key = c(w, M.value || "");
        break;
      case 7:
        M.value == null && i(w, st.UNEXPECTED_LEXICAL_ANALYSIS, C.lastStartLoc, 0, ra(M)), P.key = h(w, M.value || "");
        break;
      default: {
        i(w, st.UNEXPECTED_EMPTY_LINKED_KEY, C.lastStartLoc, 0);
        const T = w.context(), N = s(7, T.offset, T.startLoc);
        return N.value = "", o(N, T.offset, T.startLoc), P.key = N, o(P, T.offset, T.startLoc), {
          nextConsumeToken: M,
          node: P
        };
      }
    }
    return o(P, w.currentOffset(), w.currentPosition()), {
      node: P
    };
  }
  function y(w) {
    const C = w.context(), P = C.currentType === 1 ? w.currentOffset() : C.offset, M = C.currentType === 1 ? C.endLoc : C.startLoc, T = s(2, P, M);
    T.items = [];
    let N = null, $ = null;
    do {
      const te = N || w.nextToken();
      switch (N = null, te.type) {
        case 0:
          te.value == null && i(w, st.UNEXPECTED_LEXICAL_ANALYSIS, C.lastStartLoc, 0, ra(te)), T.items.push(l(w, te.value || ""));
          break;
        case 6:
          te.value == null && i(w, st.UNEXPECTED_LEXICAL_ANALYSIS, C.lastStartLoc, 0, ra(te)), T.items.push(c(w, te.value || ""));
          break;
        case 4:
          $ = !0;
          break;
        case 5:
          te.value == null && i(w, st.UNEXPECTED_LEXICAL_ANALYSIS, C.lastStartLoc, 0, ra(te)), T.items.push(f(w, te.value || "", !!$)), $ && (a(w, lp.USE_MODULO_SYNTAX, C.lastStartLoc, 0, ra(te)), $ = null);
          break;
        case 7:
          te.value == null && i(w, st.UNEXPECTED_LEXICAL_ANALYSIS, C.lastStartLoc, 0, ra(te)), T.items.push(h(w, te.value || ""));
          break;
        case 8: {
          const _e = v(w);
          T.items.push(_e.node), N = _e.nextConsumeToken || null;
          break;
        }
      }
    } while (C.currentType !== 14 && C.currentType !== 1);
    const ne = C.currentType === 1 ? C.lastOffset : w.currentOffset(), Y = C.currentType === 1 ? C.lastEndLoc : w.currentPosition();
    return o(T, ne, Y), T;
  }
  function S(w, C, P, M) {
    const T = w.context();
    let N = M.items.length === 0;
    const $ = s(1, C, P);
    $.cases = [], $.cases.push(M);
    do {
      const ne = y(w);
      N || (N = ne.items.length === 0), $.cases.push(ne);
    } while (T.currentType !== 14);
    return N && i(w, st.MUST_HAVE_MESSAGES_IN_PLURAL, P, 0), o($, w.currentOffset(), w.currentPosition()), $;
  }
  function x(w) {
    const C = w.context(), { offset: P, startLoc: M } = C, T = y(w);
    return C.currentType === 14 ? T : S(w, P, M, T);
  }
  function E(w) {
    const C = XB(w, NP({}, e)), P = C.context(), M = s(0, P.offset, P.startLoc);
    return t && M.loc && (M.loc.source = w), M.body = x(C), e.onCacheKey && (M.cacheKey = e.onCacheKey(w)), P.currentType !== 14 && i(C, st.UNEXPECTED_LEXICAL_ANALYSIS, P.lastStartLoc, 0, w[P.offset] || ""), o(M, C.currentOffset(), C.currentPosition()), M;
  }
  return { parse: E };
}
function ra(e) {
  if (e.type === 14)
    return "EOF";
  const t = (e.value || "").replace(/\r?\n/gu, "\\n");
  return t.length > 10 ? t.slice(0, 9) + "…" : t;
}
function tU(e, t = {}) {
  const n = {
    ast: e,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => n, helper: (a) => (n.helpers.add(a), a) };
}
function sk(e, t) {
  for (let n = 0; n < e.length; n++)
    a0(e[n], t);
}
function a0(e, t) {
  switch (e.type) {
    case 1:
      sk(e.cases, t), t.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      sk(e.items, t);
      break;
    case 6: {
      a0(e.key, t), t.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), t.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    }
    case 5:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function nU(e, t = {}) {
  const n = tU(e);
  n.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), e.body && a0(e.body, n);
  const r = n.context();
  e.helpers = Array.from(r.helpers);
}
function rU(e) {
  const t = e.body;
  return t.type === 2 ? ok(t) : t.cases.forEach((n) => ok(n)), e;
}
function ok(e) {
  if (e.items.length === 1) {
    const t = e.items[0];
    (t.type === 3 || t.type === 9) && (e.static = t.value, delete t.value);
  } else {
    const t = [];
    for (let n = 0; n < e.items.length; n++) {
      const r = e.items[n];
      if (!(r.type === 3 || r.type === 9) || r.value == null)
        break;
      t.push(r.value);
    }
    if (t.length === e.items.length) {
      e.static = LP(t);
      for (let n = 0; n < e.items.length; n++) {
        const r = e.items[n];
        (r.type === 3 || r.type === 9) && delete r.value;
      }
    }
  }
}
const iU = "minifier";
function Wl(e) {
  switch (e.t = e.type, e.type) {
    case 0: {
      const t = e;
      Wl(t.body), t.b = t.body, delete t.body;
      break;
    }
    case 1: {
      const t = e, n = t.cases;
      for (let r = 0; r < n.length; r++)
        Wl(n[r]);
      t.c = n, delete t.cases;
      break;
    }
    case 2: {
      const t = e, n = t.items;
      for (let r = 0; r < n.length; r++)
        Wl(n[r]);
      t.i = n, delete t.items, t.static && (t.s = t.static, delete t.static);
      break;
    }
    case 3:
    case 9:
    case 8:
    case 7: {
      const t = e;
      t.value && (t.v = t.value, delete t.value);
      break;
    }
    case 6: {
      const t = e;
      Wl(t.key), t.k = t.key, delete t.key, t.modifier && (Wl(t.modifier), t.m = t.modifier, delete t.modifier);
      break;
    }
    case 5: {
      const t = e;
      t.i = t.index, delete t.index;
      break;
    }
    case 4: {
      const t = e;
      t.k = t.key, delete t.key;
      break;
    }
    default:
      throw du(st.UNHANDLED_MINIFIER_NODE_TYPE, null, {
        domain: iU,
        args: [e.type]
      });
  }
  delete e.type;
}
const aU = "parser";
function sU(e, t) {
  const { filename: n, breakLineCode: r, needIndent: i } = t, a = t.location !== !1, s = {
    filename: n,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: r,
    needIndent: i,
    indentLevel: 0
  };
  a && e.loc && (s.source = e.loc.source);
  const o = () => s;
  function l(y, S) {
    s.code += y;
  }
  function c(y, S = !0) {
    const x = S ? r : "";
    l(i ? x + "  ".repeat(y) : x);
  }
  function f(y = !0) {
    const S = ++s.indentLevel;
    y && c(S);
  }
  function h(y = !0) {
    const S = --s.indentLevel;
    y && c(S);
  }
  function p() {
    c(s.indentLevel);
  }
  return {
    context: o,
    push: l,
    indent: f,
    deindent: h,
    newline: p,
    helper: (y) => `_${y}`,
    needIndent: () => s.needIndent
  };
}
function oU(e, t) {
  const { helper: n } = e;
  e.push(`${n(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), Xl(e, t.key), t.modifier ? (e.push(", "), Xl(e, t.modifier), e.push(", _type")) : e.push(", undefined, _type"), e.push(")");
}
function lU(e, t) {
  const { helper: n, needIndent: r } = e;
  e.push(`${n(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), e.indent(r());
  const i = t.items.length;
  for (let a = 0; a < i && (Xl(e, t.items[a]), a !== i - 1); a++)
    e.push(", ");
  e.deindent(r()), e.push("])");
}
function uU(e, t) {
  const { helper: n, needIndent: r } = e;
  if (t.cases.length > 1) {
    e.push(`${n(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), e.indent(r());
    const i = t.cases.length;
    for (let a = 0; a < i && (Xl(e, t.cases[a]), a !== i - 1); a++)
      e.push(", ");
    e.deindent(r()), e.push("])");
  }
}
function cU(e, t) {
  t.body ? Xl(e, t.body) : e.push("null");
}
function Xl(e, t) {
  const { helper: n } = e;
  switch (t.type) {
    case 0:
      cU(e, t);
      break;
    case 1:
      uU(e, t);
      break;
    case 2:
      lU(e, t);
      break;
    case 6:
      oU(e, t);
      break;
    case 8:
      e.push(JSON.stringify(t.value), t);
      break;
    case 7:
      e.push(JSON.stringify(t.value), t);
      break;
    case 5:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "list"
        /* HelperNameMap.LIST */
      )}(${t.index}))`, t);
      break;
    case 4:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(t.key)}))`, t);
      break;
    case 9:
      e.push(JSON.stringify(t.value), t);
      break;
    case 3:
      e.push(JSON.stringify(t.value), t);
      break;
    default:
      throw du(st.UNHANDLED_CODEGEN_NODE_TYPE, null, {
        domain: aU,
        args: [t.type]
      });
  }
}
const dU = (e, t = {}) => {
  const n = ik(t.mode) ? t.mode : "normal", r = ik(t.filename) ? t.filename : "message.intl";
  t.sourceMap;
  const i = t.breakLineCode != null ? t.breakLineCode : n === "arrow" ? ";" : `
`, a = t.needIndent ? t.needIndent : n !== "arrow", s = e.helpers || [], o = sU(e, {
    filename: r,
    breakLineCode: i,
    needIndent: a
  });
  o.push(n === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), o.indent(a), s.length > 0 && (o.push(`const { ${LP(s.map((f) => `${f}: _${f}`), ", ")} } = ctx`), o.newline()), o.push("return "), Xl(o, e), o.deindent(a), o.push("}"), delete e.helpers;
  const { code: l, map: c } = o.context();
  return {
    ast: e,
    code: l,
    map: c ? c.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function fU(e, t = {}) {
  const n = NP({}, t), r = !!n.jit, i = !!n.minify, a = n.optimize == null ? !0 : n.optimize, o = eU(n).parse(e);
  return r ? (a && rU(o), i && Wl(o), { ast: o, code: "" }) : (nU(o, n), dU(o, n));
}
/*!
  * core-base v9.14.5
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function hU() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (i0().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
function zi(e) {
  return Rt(e) && s0(e) === 0 && (la(e, "b") || la(e, "body"));
}
const $P = ["b", "body"];
function pU(e) {
  return to(e, $P);
}
const VP = ["c", "cases"];
function mU(e) {
  return to(e, VP, []);
}
const BP = ["s", "static"];
function gU(e) {
  return to(e, BP);
}
const UP = ["i", "items"];
function vU(e) {
  return to(e, UP, []);
}
const qP = ["t", "type"];
function s0(e) {
  return to(e, qP);
}
const jP = ["v", "value"];
function Ef(e, t) {
  const n = to(e, jP);
  if (n != null)
    return n;
  throw Nc(t);
}
const WP = ["m", "modifier"];
function bU(e) {
  return to(e, WP);
}
const zP = ["k", "key"];
function _U(e) {
  const t = to(e, zP);
  if (t)
    return t;
  throw Nc(
    6
    /* NodeTypes.Linked */
  );
}
function to(e, t, n) {
  for (let r = 0; r < t.length; r++) {
    const i = t[r];
    if (la(e, i) && e[i] != null)
      return e[i];
  }
  return n;
}
const HP = [
  ...$P,
  ...VP,
  ...BP,
  ...UP,
  ...zP,
  ...WP,
  ...jP,
  ...qP
];
function Nc(e) {
  return new Error(`unhandled node type: ${e}`);
}
const no = [];
no[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
no[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
no[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
no[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
no[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
no[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
no[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const yU = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function xU(e) {
  return yU.test(e);
}
function wU(e) {
  const t = e.charCodeAt(0), n = e.charCodeAt(e.length - 1);
  return t === n && (t === 34 || t === 39) ? e.slice(1, -1) : e;
}
function kU(e) {
  if (e == null)
    return "o";
  switch (e.charCodeAt(0)) {
    case 91:
    // [
    case 93:
    // ]
    case 46:
    // .
    case 34:
    // "
    case 39:
      return e;
    case 95:
    // _
    case 36:
    // $
    case 45:
      return "i";
    case 9:
    // Tab (HT)
    case 10:
    // Newline (LF)
    case 13:
    // Return (CR)
    case 160:
    // No-break space (NBSP)
    case 65279:
    // Byte Order Mark (BOM)
    case 8232:
    // Line Separator (LS)
    case 8233:
      return "w";
  }
  return "i";
}
function SU(e) {
  const t = e.trim();
  return e.charAt(0) === "0" && isNaN(parseInt(e)) ? !1 : xU(t) ? wU(t) : "*" + t;
}
function CU(e) {
  const t = [];
  let n = -1, r = 0, i = 0, a, s, o, l, c, f, h;
  const p = [];
  p[
    0
    /* Actions.APPEND */
  ] = () => {
    s === void 0 ? s = o : s += o;
  }, p[
    1
    /* Actions.PUSH */
  ] = () => {
    s !== void 0 && (t.push(s), s = void 0);
  }, p[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    p[
      0
      /* Actions.APPEND */
    ](), i++;
  }, p[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (i > 0)
      i--, r = 4, p[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (i = 0, s === void 0 || (s = SU(s), s === !1))
        return !1;
      p[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function g() {
    const v = e[n + 1];
    if (r === 5 && v === "'" || r === 6 && v === '"')
      return n++, o = "\\" + v, p[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; r !== null; )
    if (n++, a = e[n], !(a === "\\" && g())) {
      if (l = kU(a), h = no[r], c = h[l] || h.l || 8, c === 8 || (r = c[0], c[1] !== void 0 && (f = p[c[1]], f && (o = a, f() === !1))))
        return;
      if (r === 7)
        return t;
    }
}
const lk = /* @__PURE__ */ new Map();
function TU(e, t) {
  return Rt(e) ? e[t] : null;
}
function AU(e, t) {
  if (!Rt(e))
    return null;
  let n = lk.get(t);
  if (n || (n = CU(t), n && lk.set(t, n)), !n)
    return null;
  const r = n.length;
  let i = e, a = 0;
  for (; a < r; ) {
    const s = n[a];
    if (HP.includes(s) && zi(i))
      return null;
    const o = i[s];
    if (o === void 0 || yn(i))
      return null;
    i = o, a++;
  }
  return i;
}
const DU = (e) => e, EU = (e) => "", PU = "text", OU = (e) => e.length === 0 ? "" : IB(e), MU = MB;
function uk(e, t) {
  return e = Math.abs(e), t === 2 ? e ? e > 1 ? 1 : 0 : 1 : e ? Math.min(e, 2) : 0;
}
function IU(e) {
  const t = Qn(e.pluralIndex) ? e.pluralIndex : -1;
  return e.named && (Qn(e.named.count) || Qn(e.named.n)) ? Qn(e.named.count) ? e.named.count : Qn(e.named.n) ? e.named.n : t : t;
}
function RU(e, t) {
  t.count || (t.count = e), t.n || (t.n = e);
}
function FU(e = {}) {
  const t = e.locale, n = IU(e), r = Rt(e.pluralRules) && We(t) && yn(e.pluralRules[t]) ? e.pluralRules[t] : uk, i = Rt(e.pluralRules) && We(t) && yn(e.pluralRules[t]) ? uk : void 0, a = (x) => x[r(n, x.length, i)], s = e.list || [], o = (x) => s[x], l = e.named || en();
  Qn(e.pluralIndex) && RU(n, l);
  const c = (x) => l[x];
  function f(x) {
    const E = yn(e.messages) ? e.messages(x) : Rt(e.messages) ? e.messages[x] : !1;
    return E || (e.parent ? e.parent.message(x) : EU);
  }
  const h = (x) => e.modifiers ? e.modifiers[x] : DU, p = It(e.processor) && yn(e.processor.normalize) ? e.processor.normalize : OU, g = It(e.processor) && yn(e.processor.interpolate) ? e.processor.interpolate : MU, v = It(e.processor) && We(e.processor.type) ? e.processor.type : PU, S = {
    list: o,
    named: c,
    plural: a,
    linked: (x, ...E) => {
      const [w, C] = E;
      let P = "text", M = "";
      E.length === 1 ? Rt(w) ? (M = w.modifier || M, P = w.type || P) : We(w) && (M = w || M) : E.length === 2 && (We(w) && (M = w || M), We(C) && (P = C || P));
      const T = f(x)(S), N = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        P === "vnode" && Jn(T) && M ? T[0] : T
      );
      return M ? h(M)(N, P) : N;
    },
    message: f,
    type: v,
    interpolate: g,
    normalize: p,
    values: $r(en(), s, l)
  };
  return S;
}
let Lc = null;
function NU(e) {
  Lc = e;
}
function LU(e, t, n) {
  Lc && Lc.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: e,
    version: t,
    meta: n
  });
}
const $U = /* @__PURE__ */ VU(
  "function:translate"
  /* IntlifyDevToolsHooks.FunctionTranslate */
);
function VU(e) {
  return (t) => Lc && Lc.emit(e, t);
}
const GP = lp.__EXTEND_POINT__, So = op(GP), zr = {
  NOT_FOUND_KEY: GP,
  // 2
  FALLBACK_TO_TRANSLATE: So(),
  // 3
  CANNOT_FORMAT_NUMBER: So(),
  // 4
  FALLBACK_TO_NUMBER_FORMAT: So(),
  // 5
  CANNOT_FORMAT_DATE: So(),
  // 6
  FALLBACK_TO_DATE_FORMAT: So(),
  // 7
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: So(),
  // 8
  __EXTEND_POINT__: So()
  // 9
}, BU = {
  [zr.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [zr.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [zr.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [zr.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [zr.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [zr.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [zr.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future."
};
function Go(e, ...t) {
  return r0(BU[e], ...t);
}
const YP = st.__EXTEND_POINT__, Co = op(YP), Sr = {
  INVALID_ARGUMENT: YP,
  // 17
  INVALID_DATE_ARGUMENT: Co(),
  // 18
  INVALID_ISO_DATE_ARGUMENT: Co(),
  // 19
  NOT_SUPPORT_NON_STRING_MESSAGE: Co(),
  // 20
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: Co(),
  // 21
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: Co(),
  // 22
  NOT_SUPPORT_LOCALE_TYPE: Co(),
  // 23
  __EXTEND_POINT__: Co()
  // 24
};
function rs(e) {
  return du(e, null, process.env.NODE_ENV !== "production" ? { messages: UU } : void 0);
}
const UU = {
  [Sr.INVALID_ARGUMENT]: "Invalid arguments",
  [Sr.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [Sr.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [Sr.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
  [Sr.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
  [Sr.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
  [Sr.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
function o0(e, t) {
  return t.locale != null ? ck(t.locale) : ck(e.locale);
}
let vg;
function ck(e) {
  if (We(e))
    return e;
  if (yn(e)) {
    if (e.resolvedOnce && vg != null)
      return vg;
    if (e.constructor.name === "Function") {
      const t = e();
      if (OB(t))
        throw rs(Sr.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return vg = t;
    } else
      throw rs(Sr.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw rs(Sr.NOT_SUPPORT_LOCALE_TYPE);
}
function qU(e, t, n) {
  return [.../* @__PURE__ */ new Set([
    n,
    ...Jn(t) ? t : Rt(t) ? Object.keys(t) : We(t) ? [t] : [n]
  ])];
}
function KP(e, t, n) {
  const r = We(n) ? n : wh, i = e;
  i.__localeChainCache || (i.__localeChainCache = /* @__PURE__ */ new Map());
  let a = i.__localeChainCache.get(r);
  if (!a) {
    a = [];
    let s = [n];
    for (; Jn(s); )
      s = dk(a, s, t);
    const o = Jn(t) || !It(t) ? t : t.default ? t.default : null;
    s = We(o) ? [o] : o, Jn(s) && dk(a, s, !1), i.__localeChainCache.set(r, a);
  }
  return a;
}
function dk(e, t, n) {
  let r = !0;
  for (let i = 0; i < t.length && xn(r); i++) {
    const a = t[i];
    We(a) && (r = jU(e, t[i], n));
  }
  return r;
}
function jU(e, t, n) {
  let r;
  const i = t.split("-");
  do {
    const a = i.join("-");
    r = WU(e, a, n), i.splice(-1, 1);
  } while (i.length && r === !0);
  return r;
}
function WU(e, t, n) {
  let r = !1;
  if (!e.includes(t) && (r = !0, t)) {
    r = t[t.length - 1] !== "!";
    const i = t.replace(/!/g, "");
    e.push(i), (Jn(n) || It(n)) && n[i] && (r = n[i]);
  }
  return r;
}
const zU = "9.14.5", up = -1, wh = "en-US", kh = "", fk = (e) => `${e.charAt(0).toLocaleUpperCase()}${e.substr(1)}`;
function HU() {
  return {
    upper: (e, t) => t === "text" && We(e) ? e.toUpperCase() : t === "vnode" && Rt(e) && "__v_isVNode" in e ? e.children.toUpperCase() : e,
    lower: (e, t) => t === "text" && We(e) ? e.toLowerCase() : t === "vnode" && Rt(e) && "__v_isVNode" in e ? e.children.toLowerCase() : e,
    capitalize: (e, t) => t === "text" && We(e) ? fk(e) : t === "vnode" && Rt(e) && "__v_isVNode" in e ? fk(e.children) : e
  };
}
let XP;
function GU(e) {
  XP = e;
}
let ZP;
function YU(e) {
  ZP = e;
}
let QP;
function KU(e) {
  QP = e;
}
let JP = null;
const XU = /* @__NO_SIDE_EFFECTS__ */ (e) => {
  JP = e;
}, ZU = /* @__NO_SIDE_EFFECTS__ */ () => JP;
let e2 = null;
const hk = (e) => {
  e2 = e;
}, QU = () => e2;
let pk = 0;
function JU(e = {}) {
  const t = yn(e.onWarn) ? e.onWarn : Ki, n = We(e.version) ? e.version : zU, r = We(e.locale) || yn(e.locale) ? e.locale : wh, i = yn(r) ? wh : r, a = Jn(e.fallbackLocale) || It(e.fallbackLocale) || We(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : i, s = It(e.messages) ? e.messages : bg(i), o = It(e.datetimeFormats) ? e.datetimeFormats : bg(i), l = It(e.numberFormats) ? e.numberFormats : bg(i), c = $r(en(), e.modifiers, HU()), f = e.pluralRules || en(), h = yn(e.missing) ? e.missing : null, p = xn(e.missingWarn) || yh(e.missingWarn) ? e.missingWarn : !0, g = xn(e.fallbackWarn) || yh(e.fallbackWarn) ? e.fallbackWarn : !0, v = !!e.fallbackFormat, y = !!e.unresolving, S = yn(e.postTranslation) ? e.postTranslation : null, x = It(e.processor) ? e.processor : null, E = xn(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, w = !!e.escapeParameter, C = yn(e.messageCompiler) ? e.messageCompiler : XP;
  process.env.NODE_ENV !== "production" && yn(e.messageCompiler) && OP(Go(zr.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const P = yn(e.messageResolver) ? e.messageResolver : ZP || TU, M = yn(e.localeFallbacker) ? e.localeFallbacker : QP || qU, T = Rt(e.fallbackContext) ? e.fallbackContext : void 0, N = e, $ = Rt(N.__datetimeFormatters) ? N.__datetimeFormatters : /* @__PURE__ */ new Map(), ne = Rt(N.__numberFormatters) ? N.__numberFormatters : /* @__PURE__ */ new Map(), Y = Rt(N.__meta) ? N.__meta : {};
  pk++;
  const te = {
    version: n,
    cid: pk,
    locale: r,
    fallbackLocale: a,
    messages: s,
    modifiers: c,
    pluralRules: f,
    missing: h,
    missingWarn: p,
    fallbackWarn: g,
    fallbackFormat: v,
    unresolving: y,
    postTranslation: S,
    processor: x,
    warnHtmlMessage: E,
    escapeParameter: w,
    messageCompiler: C,
    messageResolver: P,
    localeFallbacker: M,
    fallbackContext: T,
    onWarn: t,
    __meta: Y
  };
  return te.datetimeFormats = o, te.numberFormats = l, te.__datetimeFormatters = $, te.__numberFormatters = ne, process.env.NODE_ENV !== "production" && (te.__v_emitter = N.__v_emitter != null ? N.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && LU(te, n, Y), te;
}
const bg = (e) => ({ [e]: en() });
function cp(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function t2(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function l0(e, t, n, r, i) {
  const { missing: a, onWarn: s } = e;
  if (process.env.NODE_ENV !== "production") {
    const o = e.__v_emitter;
    o && o.emit("missing", {
      locale: n,
      key: t,
      type: i,
      groupId: `${i}:${t}`
    });
  }
  if (a !== null) {
    const o = a(e, n, t, i);
    return We(o) ? o : t;
  } else
    return process.env.NODE_ENV !== "production" && t2(r, t) && s(Go(zr.NOT_FOUND_KEY, { key: t, locale: n })), t;
}
function Ku(e, t, n) {
  const r = e;
  r.__localeChainCache = /* @__PURE__ */ new Map(), e.localeFallbacker(e, n, t);
}
function n2(e, t) {
  return e === t ? !1 : e.split("-")[0] === t.split("-")[0];
}
function eq(e, t) {
  const n = t.indexOf(e);
  if (n === -1)
    return !1;
  for (let r = n + 1; r < t.length; r++)
    if (n2(e, t[r]))
      return !0;
  return !1;
}
function _g(e) {
  return (n) => tq(n, e);
}
function tq(e, t) {
  const n = pU(t);
  if (n == null)
    throw Nc(
      0
      /* NodeTypes.Resource */
    );
  if (s0(n) === 1) {
    const a = mU(n);
    return e.plural(a.reduce((s, o) => [
      ...s,
      mk(e, o)
    ], []));
  } else
    return mk(e, n);
}
function mk(e, t) {
  const n = gU(t);
  if (n != null)
    return e.type === "text" ? n : e.normalize([n]);
  {
    const r = vU(t).reduce((i, a) => [...i, X_(e, a)], []);
    return e.normalize(r);
  }
}
function X_(e, t) {
  const n = s0(t);
  switch (n) {
    case 3:
      return Ef(t, n);
    case 9:
      return Ef(t, n);
    case 4: {
      const r = t;
      if (la(r, "k") && r.k)
        return e.interpolate(e.named(r.k));
      if (la(r, "key") && r.key)
        return e.interpolate(e.named(r.key));
      throw Nc(n);
    }
    case 5: {
      const r = t;
      if (la(r, "i") && Qn(r.i))
        return e.interpolate(e.list(r.i));
      if (la(r, "index") && Qn(r.index))
        return e.interpolate(e.list(r.index));
      throw Nc(n);
    }
    case 6: {
      const r = t, i = bU(r), a = _U(r);
      return e.linked(X_(e, a), i ? X_(e, i) : void 0, e.type);
    }
    case 7:
      return Ef(t, n);
    case 8:
      return Ef(t, n);
    default:
      throw new Error(`unhandled node on format message part: ${n}`);
  }
}
const nq = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function rq(e, t) {
  t && jB(e) && Ki(r0(nq, { source: e }));
}
const iq = (e) => e;
let Pf = en();
function aq(e) {
  e.code === lp.USE_MODULO_SYNTAX && Ki(`The use of named interpolation with modulo syntax is deprecated. It will be removed in v10.
reference: https://vue-i18n.intlify.dev/guide/essentials/syntax#rails-i18n-format 
(message compiler warning message: ${e.message})`);
}
function sq(e, t = {}) {
  let n = !1;
  const r = t.onError || UB;
  return t.onError = (i) => {
    n = !0, r(i);
  }, { ...fU(e, t), detectError: n };
}
function oq(e, t) {
  if (process.env.NODE_ENV !== "production" && (t.onWarn = aq), We(e)) {
    const n = xn(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && rq(e, n);
    const i = (t.onCacheKey || iq)(e), a = Pf[i];
    if (a)
      return a;
    const { ast: s, detectError: o } = sq(e, {
      ...t,
      location: process.env.NODE_ENV !== "production",
      jit: !0
    }), l = _g(s);
    return o ? l : Pf[i] = l;
  } else {
    if (process.env.NODE_ENV !== "production" && !zi(e))
      return Ki(`the message that is resolve with key '${t.key}' is not supported for jit compilation`), (() => e);
    const n = e.cacheKey;
    if (n) {
      const r = Pf[n];
      return r || (Pf[n] = _g(e));
    } else
      return _g(e);
  }
}
const gk = () => "", Ui = (e) => yn(e);
function vk(e, ...t) {
  const { fallbackFormat: n, postTranslation: r, unresolving: i, messageCompiler: a, fallbackLocale: s, messages: o } = e, [l, c] = Z_(...t), f = xn(c.missingWarn) ? c.missingWarn : e.missingWarn, h = xn(c.fallbackWarn) ? c.fallbackWarn : e.fallbackWarn, p = xn(c.escapeParameter) ? c.escapeParameter : e.escapeParameter, g = !!c.resolvedMessage, v = We(c.default) || xn(c.default) ? xn(c.default) ? a ? l : () => l : c.default : n ? a ? l : () => l : "", y = n || v !== "", S = o0(e, c);
  p && lq(c);
  let [x, E, w] = g ? [
    l,
    S,
    o[S] || en()
  ] : r2(e, l, S, s, h, f), C = x, P = l;
  if (!g && !(We(C) || zi(C) || Ui(C)) && y && (C = v, P = C), !g && (!(We(C) || zi(C) || Ui(C)) || !We(E)))
    return i ? up : l;
  if (process.env.NODE_ENV !== "production" && We(C) && e.messageCompiler == null)
    return Ki(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${l}'.`), l;
  let M = !1;
  const T = () => {
    M = !0;
  }, N = Ui(C) ? C : i2(e, l, E, C, P, T);
  if (M)
    return C;
  const $ = fq(e, E, w, c), ne = FU($), Y = uq(e, N, ne);
  let te = r ? r(Y, l) : Y;
  if (p && We(te) && (te = EB(te)), process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const _e = {
      timestamp: Date.now(),
      key: We(l) ? l : Ui(C) ? C.key : "",
      locale: E || (Ui(C) ? C.locale : ""),
      format: We(C) ? C : Ui(C) ? C.source : "",
      message: te
    };
    _e.meta = $r({}, e.__meta, /* @__PURE__ */ ZU() || {}), $U(_e);
  }
  return te;
}
function lq(e) {
  Jn(e.list) ? e.list = e.list.map((t) => We(t) ? tk(t) : t) : Rt(e.named) && Object.keys(e.named).forEach((t) => {
    We(e.named[t]) && (e.named[t] = tk(e.named[t]));
  });
}
function r2(e, t, n, r, i, a) {
  const { messages: s, onWarn: o, messageResolver: l, localeFallbacker: c } = e, f = c(e, r, n);
  let h = en(), p, g = null, v = n, y = null;
  const S = "translate";
  for (let x = 0; x < f.length; x++) {
    if (p = y = f[x], process.env.NODE_ENV !== "production" && n !== p && !n2(n, p) && cp(i, t) && o(Go(zr.FALLBACK_TO_TRANSLATE, {
      key: t,
      target: p
    })), process.env.NODE_ENV !== "production" && n !== p) {
      const P = e.__v_emitter;
      P && P.emit("fallback", {
        type: S,
        key: t,
        from: v,
        to: y,
        groupId: `${S}:${t}`
      });
    }
    h = s[p] || en();
    let E = null, w, C;
    if (process.env.NODE_ENV !== "production" && ca && (E = window.performance.now(), w = "intlify-message-resolve-start", C = "intlify-message-resolve-end", xi && xi(w)), (g = l(h, t)) === null && (g = h[t]), process.env.NODE_ENV !== "production" && ca) {
      const P = window.performance.now(), M = e.__v_emitter;
      M && E && g && M.emit("message-resolve", {
        type: "message-resolve",
        key: t,
        message: g,
        time: P - E,
        groupId: `${S}:${t}`
      }), w && C && xi && Ho && (xi(C), Ho("intlify message resolve", w, C));
    }
    if (We(g) || zi(g) || Ui(g))
      break;
    if (!eq(p, f)) {
      const P = l0(
        e,
        // eslint-disable-line @typescript-eslint/no-explicit-any
        t,
        p,
        a,
        S
      );
      P !== t && (g = P);
    }
    v = y;
  }
  return [g, p, h];
}
function i2(e, t, n, r, i, a) {
  const { messageCompiler: s, warnHtmlMessage: o } = e;
  if (Ui(r)) {
    const p = r;
    return p.locale = p.locale || n, p.key = p.key || t, p;
  }
  if (s == null) {
    const p = (() => r);
    return p.locale = n, p.key = t, p;
  }
  let l = null, c, f;
  process.env.NODE_ENV !== "production" && ca && (l = window.performance.now(), c = "intlify-message-compilation-start", f = "intlify-message-compilation-end", xi && xi(c));
  const h = s(r, cq(e, n, i, r, o, a));
  if (process.env.NODE_ENV !== "production" && ca) {
    const p = window.performance.now(), g = e.__v_emitter;
    g && l && g.emit("message-compilation", {
      type: "message-compilation",
      message: r,
      time: p - l,
      groupId: `translate:${t}`
    }), c && f && xi && Ho && (xi(f), Ho("intlify message compilation", c, f));
  }
  return h.locale = n, h.key = t, h.source = r, h;
}
function uq(e, t, n) {
  let r = null, i, a;
  process.env.NODE_ENV !== "production" && ca && (r = window.performance.now(), i = "intlify-message-evaluation-start", a = "intlify-message-evaluation-end", xi && xi(i));
  const s = t(n);
  if (process.env.NODE_ENV !== "production" && ca) {
    const o = window.performance.now(), l = e.__v_emitter;
    l && r && l.emit("message-evaluation", {
      type: "message-evaluation",
      value: s,
      time: o - r,
      groupId: `translate:${t.key}`
    }), i && a && xi && Ho && (xi(a), Ho("intlify message evaluation", i, a));
  }
  return s;
}
function Z_(...e) {
  const [t, n, r] = e, i = en();
  if (!We(t) && !Qn(t) && !Ui(t) && !zi(t))
    throw rs(Sr.INVALID_ARGUMENT);
  const a = Qn(t) ? String(t) : (Ui(t), t);
  return Qn(n) ? i.plural = n : We(n) ? i.default = n : It(n) && !sp(n) ? i.named = n : Jn(n) && (i.list = n), Qn(r) ? i.plural = r : We(r) ? i.default = r : It(r) && $r(i, r), [a, i];
}
function cq(e, t, n, r, i, a) {
  return {
    locale: t,
    key: n,
    warnHtmlMessage: i,
    onError: (s) => {
      if (a && a(s), process.env.NODE_ENV !== "production") {
        const o = dq(r), l = `Message compilation error: ${s.message}`, c = s.location && o && RB(o, s.location.start.offset, s.location.end.offset), f = e.__v_emitter;
        f && o && f.emit("compile-error", {
          message: o,
          error: s.message,
          start: s.location && s.location.start.offset,
          end: s.location && s.location.end.offset,
          groupId: `translate:${n}`
        }), console.error(c ? `${l}
${c}` : l);
      } else
        throw s;
    },
    onCacheKey: (s) => CB(t, n, s)
  };
}
function dq(e) {
  if (We(e))
    return e;
  if (e.loc && e.loc.source)
    return e.loc.source;
}
function fq(e, t, n, r) {
  const { modifiers: i, pluralRules: a, messageResolver: s, fallbackLocale: o, fallbackWarn: l, missingWarn: c, fallbackContext: f } = e, p = {
    locale: t,
    modifiers: i,
    pluralRules: a,
    messages: (g) => {
      let v = s(n, g);
      if (v == null && f) {
        const [, , y] = r2(f, g, t, o, l, c);
        v = s(y, g);
      }
      if (We(v) || zi(v)) {
        let y = !1;
        const x = i2(e, g, t, v, g, () => {
          y = !0;
        });
        return y ? gk : x;
      } else return Ui(v) ? v : gk;
    }
  };
  return e.processor && (p.processor = e.processor), r.list && (p.list = r.list), r.named && (p.named = r.named), Qn(r.plural) && (p.pluralIndex = r.plural), p;
}
const bk = typeof Intl < "u", a2 = {
  dateTimeFormat: bk && typeof Intl.DateTimeFormat < "u",
  numberFormat: bk && typeof Intl.NumberFormat < "u"
};
function _k(e, ...t) {
  const { datetimeFormats: n, unresolving: r, fallbackLocale: i, onWarn: a, localeFallbacker: s } = e, { __datetimeFormatters: o } = e;
  if (process.env.NODE_ENV !== "production" && !a2.dateTimeFormat)
    return a(Go(zr.CANNOT_FORMAT_DATE)), kh;
  const [l, c, f, h] = Q_(...t), p = xn(f.missingWarn) ? f.missingWarn : e.missingWarn, g = xn(f.fallbackWarn) ? f.fallbackWarn : e.fallbackWarn, v = !!f.part, y = o0(e, f), S = s(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    i,
    y
  );
  if (!We(l) || l === "")
    return new Intl.DateTimeFormat(y, h).format(c);
  let x = {}, E, w = null, C = y, P = null;
  const M = "datetime format";
  for (let $ = 0; $ < S.length; $++) {
    if (E = P = S[$], process.env.NODE_ENV !== "production" && y !== E && cp(g, l) && a(Go(zr.FALLBACK_TO_DATE_FORMAT, {
      key: l,
      target: E
    })), process.env.NODE_ENV !== "production" && y !== E) {
      const ne = e.__v_emitter;
      ne && ne.emit("fallback", {
        type: M,
        key: l,
        from: C,
        to: P,
        groupId: `${M}:${l}`
      });
    }
    if (x = n[E] || {}, w = x[l], It(w))
      break;
    l0(e, l, E, p, M), C = P;
  }
  if (!It(w) || !We(E))
    return r ? up : l;
  let T = `${E}__${l}`;
  sp(h) || (T = `${T}__${JSON.stringify(h)}`);
  let N = o.get(T);
  return N || (N = new Intl.DateTimeFormat(E, $r({}, w, h)), o.set(T, N)), v ? N.formatToParts(c) : N.format(c);
}
const s2 = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function Q_(...e) {
  const [t, n, r, i] = e, a = en();
  let s = en(), o;
  if (We(t)) {
    const l = t.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!l)
      throw rs(Sr.INVALID_ISO_DATE_ARGUMENT);
    const c = l[3] ? l[3].trim().startsWith("T") ? `${l[1].trim()}${l[3].trim()}` : `${l[1].trim()}T${l[3].trim()}` : l[1].trim();
    o = new Date(c);
    try {
      o.toISOString();
    } catch {
      throw rs(Sr.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (AB(t)) {
    if (isNaN(t.getTime()))
      throw rs(Sr.INVALID_DATE_ARGUMENT);
    o = t;
  } else if (Qn(t))
    o = t;
  else
    throw rs(Sr.INVALID_ARGUMENT);
  return We(n) ? a.key = n : It(n) && Object.keys(n).forEach((l) => {
    s2.includes(l) ? s[l] = n[l] : a[l] = n[l];
  }), We(r) ? a.locale = r : It(r) && (s = r), It(i) && (s = i), [a.key || "", o, a, s];
}
function yk(e, t, n) {
  const r = e;
  for (const i in n) {
    const a = `${t}__${i}`;
    r.__datetimeFormatters.has(a) && r.__datetimeFormatters.delete(a);
  }
}
function xk(e, ...t) {
  const { numberFormats: n, unresolving: r, fallbackLocale: i, onWarn: a, localeFallbacker: s } = e, { __numberFormatters: o } = e;
  if (process.env.NODE_ENV !== "production" && !a2.numberFormat)
    return a(Go(zr.CANNOT_FORMAT_NUMBER)), kh;
  const [l, c, f, h] = J_(...t), p = xn(f.missingWarn) ? f.missingWarn : e.missingWarn, g = xn(f.fallbackWarn) ? f.fallbackWarn : e.fallbackWarn, v = !!f.part, y = o0(e, f), S = s(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    i,
    y
  );
  if (!We(l) || l === "")
    return new Intl.NumberFormat(y, h).format(c);
  let x = {}, E, w = null, C = y, P = null;
  const M = "number format";
  for (let $ = 0; $ < S.length; $++) {
    if (E = P = S[$], process.env.NODE_ENV !== "production" && y !== E && cp(g, l) && a(Go(zr.FALLBACK_TO_NUMBER_FORMAT, {
      key: l,
      target: E
    })), process.env.NODE_ENV !== "production" && y !== E) {
      const ne = e.__v_emitter;
      ne && ne.emit("fallback", {
        type: M,
        key: l,
        from: C,
        to: P,
        groupId: `${M}:${l}`
      });
    }
    if (x = n[E] || {}, w = x[l], It(w))
      break;
    l0(e, l, E, p, M), C = P;
  }
  if (!It(w) || !We(E))
    return r ? up : l;
  let T = `${E}__${l}`;
  sp(h) || (T = `${T}__${JSON.stringify(h)}`);
  let N = o.get(T);
  return N || (N = new Intl.NumberFormat(E, $r({}, w, h)), o.set(T, N)), v ? N.formatToParts(c) : N.format(c);
}
const o2 = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function J_(...e) {
  const [t, n, r, i] = e, a = en();
  let s = en();
  if (!Qn(t))
    throw rs(Sr.INVALID_ARGUMENT);
  const o = t;
  return We(n) ? a.key = n : It(n) && Object.keys(n).forEach((l) => {
    o2.includes(l) ? s[l] = n[l] : a[l] = n[l];
  }), We(r) ? a.locale = r : It(r) && (s = r), It(i) && (s = i), [a.key || "", o, a, s];
}
function wk(e, t, n) {
  const r = e;
  for (const i in n) {
    const a = `${t}__${i}`;
    r.__numberFormatters.has(a) && r.__numberFormatters.delete(a);
  }
}
hU();
function hq() {
  return l2().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function l2() {
  return typeof navigator < "u" && typeof window < "u" ? window : typeof globalThis < "u" ? globalThis : {};
}
const pq = typeof Proxy == "function", mq = "devtools-plugin:setup", gq = "plugin:settings:set";
let Nl, ey;
function vq() {
  var e;
  return Nl !== void 0 || (typeof window < "u" && window.performance ? (Nl = !0, ey = window.performance) : typeof globalThis < "u" && (!((e = globalThis.perf_hooks) === null || e === void 0) && e.performance) ? (Nl = !0, ey = globalThis.perf_hooks.performance) : Nl = !1), Nl;
}
function bq() {
  return vq() ? ey.now() : Date.now();
}
class _q {
  constructor(t, n) {
    this.target = null, this.targetQueue = [], this.onQueue = [], this.plugin = t, this.hook = n;
    const r = {};
    if (t.settings)
      for (const s in t.settings) {
        const o = t.settings[s];
        r[s] = o.defaultValue;
      }
    const i = `__vue-devtools-plugin-settings__${t.id}`;
    let a = Object.assign({}, r);
    try {
      const s = localStorage.getItem(i), o = JSON.parse(s);
      Object.assign(a, o);
    } catch {
    }
    this.fallbacks = {
      getSettings() {
        return a;
      },
      setSettings(s) {
        try {
          localStorage.setItem(i, JSON.stringify(s));
        } catch {
        }
        a = s;
      },
      now() {
        return bq();
      }
    }, n && n.on(gq, (s, o) => {
      s === this.plugin.id && this.fallbacks.setSettings(o);
    }), this.proxiedOn = new Proxy({}, {
      get: (s, o) => this.target ? this.target.on[o] : (...l) => {
        this.onQueue.push({
          method: o,
          args: l
        });
      }
    }), this.proxiedTarget = new Proxy({}, {
      get: (s, o) => this.target ? this.target[o] : o === "on" ? this.proxiedOn : Object.keys(this.fallbacks).includes(o) ? (...l) => (this.targetQueue.push({
        method: o,
        args: l,
        resolve: () => {
        }
      }), this.fallbacks[o](...l)) : (...l) => new Promise((c) => {
        this.targetQueue.push({
          method: o,
          args: l,
          resolve: c
        });
      })
    });
  }
  async setRealTarget(t) {
    this.target = t;
    for (const n of this.onQueue)
      this.target.on[n.method](...n.args);
    for (const n of this.targetQueue)
      n.resolve(await this.target[n.method](...n.args));
  }
}
function u2(e, t) {
  const n = e, r = l2(), i = hq(), a = pq && n.enableEarlyProxy;
  if (i && (r.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !a))
    i.emit(mq, e, t);
  else {
    const s = a ? new _q(n, i) : null;
    (r.__VUE_DEVTOOLS_PLUGINS__ = r.__VUE_DEVTOOLS_PLUGINS__ || []).push({
      pluginDescriptor: n,
      setupFn: t,
      proxy: s
    }), s && t(s.proxiedTarget);
  }
}
/*!
  * vue-i18n v9.14.5
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
const yq = "9.14.5";
function xq() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (i0().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const c2 = zr.__EXTEND_POINT__, Ha = op(c2), Rr = {
  FALLBACK_TO_ROOT: c2,
  // 9
  NOT_SUPPORTED_PRESERVE: Ha(),
  // 10
  NOT_SUPPORTED_FORMATTER: Ha(),
  // 11
  NOT_SUPPORTED_PRESERVE_DIRECTIVE: Ha(),
  // 12
  NOT_SUPPORTED_GET_CHOICE_INDEX: Ha(),
  // 13
  COMPONENT_NAME_LEGACY_COMPATIBLE: Ha(),
  // 14
  NOT_FOUND_PARENT_SCOPE: Ha(),
  // 15
  IGNORE_OBJ_FLATTEN: Ha(),
  // 16
  NOTICE_DROP_ALLOW_COMPOSITION: Ha(),
  // 17
  NOTICE_DROP_TRANSLATE_EXIST_COMPATIBLE_FLAG: Ha()
  // 18
}, wq = {
  [Rr.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [Rr.NOT_SUPPORTED_PRESERVE]: "Not supported 'preserve'.",
  [Rr.NOT_SUPPORTED_FORMATTER]: "Not supported 'formatter'.",
  [Rr.NOT_SUPPORTED_PRESERVE_DIRECTIVE]: "Not supported 'preserveDirectiveContent'.",
  [Rr.NOT_SUPPORTED_GET_CHOICE_INDEX]: "Not supported 'getChoiceIndex'.",
  [Rr.COMPONENT_NAME_LEGACY_COMPATIBLE]: "Component name legacy compatible: '{name}' -> 'i18n'",
  [Rr.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [Rr.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  [Rr.NOTICE_DROP_ALLOW_COMPOSITION]: "'allowComposition' option will be dropped in the next major version. For more information, please see 👉 https://tinyurl.com/2p97mcze",
  [Rr.NOTICE_DROP_TRANSLATE_EXIST_COMPATIBLE_FLAG]: "'translateExistCompatible' option will be dropped in the next major version."
};
function Zl(e, ...t) {
  return r0(wq[e], ...t);
}
const d2 = Sr.__EXTEND_POINT__, ri = op(d2), an = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: d2,
  // 24
  // legacy module errors
  INVALID_ARGUMENT: ri(),
  // 25
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: ri(),
  // 26
  NOT_INSTALLED: ri(),
  // 27
  NOT_AVAILABLE_IN_LEGACY_MODE: ri(),
  // 28
  // directive module errors
  REQUIRED_VALUE: ri(),
  // 29
  INVALID_VALUE: ri(),
  // 30
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: ri(),
  // 31
  NOT_INSTALLED_WITH_PROVIDE: ri(),
  // 32
  // unexpected error
  UNEXPECTED_ERROR: ri(),
  // 33
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: ri(),
  // 34
  // bridge support vue 2.x only
  BRIDGE_SUPPORT_VUE_2_ONLY: ri(),
  // 35
  // need to define `i18n` option in `allowComposition: true` and `useScope: 'local' at `useI18n``
  MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION: ri(),
  // 36
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: ri(),
  // 37
  // for enhancement
  __EXTEND_POINT__: ri()
  // 38
};
function Hi(e, ...t) {
  return du(e, null, process.env.NODE_ENV !== "production" ? { messages: kq, args: t } : void 0);
}
const kq = {
  [an.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [an.INVALID_ARGUMENT]: "Invalid argument",
  [an.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [an.NOT_INSTALLED]: "Need to install with `app.use` function",
  [an.UNEXPECTED_ERROR]: "Unexpected error",
  [an.NOT_AVAILABLE_IN_LEGACY_MODE]: "Not available in legacy mode",
  [an.REQUIRED_VALUE]: "Required in value: {0}",
  [an.INVALID_VALUE]: "Invalid value",
  [an.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [an.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [an.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [an.BRIDGE_SUPPORT_VUE_2_ONLY]: "vue-i18n-bridge support Vue 2.x only",
  [an.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION]: "Must define ‘i18n’ option or custom block in Composition API with using local scope in Legacy API mode",
  [an.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, ty = /* @__PURE__ */ Pa("__translateVNode"), ny = /* @__PURE__ */ Pa("__datetimeParts"), ry = /* @__PURE__ */ Pa("__numberParts"), $c = /* @__PURE__ */ Pa("__enableEmitter"), iy = /* @__PURE__ */ Pa("__disableEmitter"), Sq = Pa("__setPluralRules"), Cq = /* @__PURE__ */ Pa("__injectWithOption"), ay = /* @__PURE__ */ Pa("__dispose");
function Vc(e) {
  if (!Rt(e) || zi(e))
    return e;
  for (const t in e)
    if (la(e, t))
      if (!t.includes("."))
        Rt(e[t]) && Vc(e[t]);
      else {
        const n = t.split("."), r = n.length - 1;
        let i = e, a = !1;
        for (let s = 0; s < r; s++) {
          if (n[s] === "__proto__")
            throw new Error(`unsafe key: ${n[s]}`);
          if (n[s] in i || (i[n[s]] = en()), !Rt(i[n[s]])) {
            process.env.NODE_ENV !== "production" && Ki(Zl(Rr.IGNORE_OBJ_FLATTEN, {
              key: n[s]
            })), a = !0;
            break;
          }
          i = i[n[s]];
        }
        if (a || (zi(i) ? HP.includes(n[r]) || delete e[t] : (i[n[r]] = e[t], delete e[t])), !zi(i)) {
          const s = i[n[r]];
          Rt(s) && Vc(s);
        }
      }
  return e;
}
function f2(e, t) {
  const { messages: n, __i18n: r, messageResolver: i, flatJson: a } = t, s = It(n) ? n : Jn(r) ? en() : { [e]: en() };
  if (Jn(r) && r.forEach((o) => {
    if ("locale" in o && "resource" in o) {
      const { locale: l, resource: c } = o;
      l ? (s[l] = s[l] || en(), ch(c, s[l])) : ch(c, s);
    } else
      We(o) && ch(JSON.parse(o), s);
  }), i == null && a)
    for (const o in s)
      la(s, o) && Vc(s[o]);
  return s;
}
function h2(e) {
  return e.type;
}
function Tq(e, t, n) {
  let r = Rt(t.messages) ? t.messages : en();
  "__i18nGlobal" in n && (r = f2(e.locale.value, {
    messages: r,
    __i18n: n.__i18nGlobal
  }));
  const i = Object.keys(r);
  i.length && i.forEach((a) => {
    e.mergeLocaleMessage(a, r[a]);
  });
  {
    if (Rt(t.datetimeFormats)) {
      const a = Object.keys(t.datetimeFormats);
      a.length && a.forEach((s) => {
        e.mergeDateTimeFormat(s, t.datetimeFormats[s]);
      });
    }
    if (Rt(t.numberFormats)) {
      const a = Object.keys(t.numberFormats);
      a.length && a.forEach((s) => {
        e.mergeNumberFormat(s, t.numberFormats[s]);
      });
    }
  }
}
function kk(e) {
  return W(V5, null, e, 0);
}
const Sk = "__INTLIFY_META__", Ck = () => [], Aq = () => !1;
let Tk = 0;
function Ak(e) {
  return ((t, n, r, i) => e(n, r, np() || void 0, i));
}
const Dq = /* @__NO_SIDE_EFFECTS__ */ () => {
  const e = np();
  let t = null;
  return e && (t = h2(e)[Sk]) ? { [Sk]: t } : null;
};
function p2(e = {}, t) {
  const { __root: n, __injectWithOption: r } = e, i = n === void 0, a = e.flatJson, s = ca ? ge : rp, o = !!e.translateExistCompatible;
  process.env.NODE_ENV !== "production" && o && OP(Zl(Rr.NOTICE_DROP_TRANSLATE_EXIST_COMPATIBLE_FLAG));
  let l = xn(e.inheritLocale) ? e.inheritLocale : !0;
  const c = s(
    // prettier-ignore
    n && l ? n.locale.value : We(e.locale) ? e.locale : wh
  ), f = s(
    // prettier-ignore
    n && l ? n.fallbackLocale.value : We(e.fallbackLocale) || Jn(e.fallbackLocale) || It(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : c.value
  ), h = s(f2(c.value, e)), p = s(It(e.datetimeFormats) ? e.datetimeFormats : { [c.value]: {} }), g = s(It(e.numberFormats) ? e.numberFormats : { [c.value]: {} });
  let v = n ? n.missingWarn : xn(e.missingWarn) || yh(e.missingWarn) ? e.missingWarn : !0, y = n ? n.fallbackWarn : xn(e.fallbackWarn) || yh(e.fallbackWarn) ? e.fallbackWarn : !0, S = n ? n.fallbackRoot : xn(e.fallbackRoot) ? e.fallbackRoot : !0, x = !!e.fallbackFormat, E = yn(e.missing) ? e.missing : null, w = yn(e.missing) ? Ak(e.missing) : null, C = yn(e.postTranslation) ? e.postTranslation : null, P = n ? n.warnHtmlMessage : xn(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, M = !!e.escapeParameter;
  const T = n ? n.modifiers : It(e.modifiers) ? e.modifiers : {};
  let N = e.pluralRules || n && n.pluralRules, $;
  $ = (() => {
    i && hk(null);
    const he = {
      version: yq,
      locale: c.value,
      fallbackLocale: f.value,
      messages: h.value,
      modifiers: T,
      pluralRules: N,
      missing: w === null ? void 0 : w,
      missingWarn: v,
      fallbackWarn: y,
      fallbackFormat: x,
      unresolving: !0,
      postTranslation: C === null ? void 0 : C,
      warnHtmlMessage: P,
      escapeParameter: M,
      messageResolver: e.messageResolver,
      messageCompiler: e.messageCompiler,
      __meta: { framework: "vue" }
    };
    he.datetimeFormats = p.value, he.numberFormats = g.value, he.__datetimeFormatters = It($) ? $.__datetimeFormatters : void 0, he.__numberFormatters = It($) ? $.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (he.__v_emitter = It($) ? $.__v_emitter : void 0);
    const Ae = JU(he);
    return i && hk(Ae), Ae;
  })(), Ku($, c.value, f.value);
  function Y() {
    return [
      c.value,
      f.value,
      h.value,
      p.value,
      g.value
    ];
  }
  const te = ce({
    get: () => c.value,
    set: (he) => {
      c.value = he, $.locale = c.value;
    }
  }), _e = ce({
    get: () => f.value,
    set: (he) => {
      f.value = he, $.fallbackLocale = f.value, Ku($, c.value, he);
    }
  }), Fe = ce(() => h.value), J = /* @__PURE__ */ ce(() => p.value), oe = /* @__PURE__ */ ce(() => g.value);
  function A() {
    return yn(C) ? C : null;
  }
  function X(he) {
    C = he, $.postTranslation = he;
  }
  function pe() {
    return E;
  }
  function le(he) {
    he !== null && (w = Ak(he)), E = he, $.missing = w;
  }
  function ue(he, Ae) {
    return he !== "translate" || !Ae.resolvedMessage;
  }
  const Te = (he, Ae, q, me, Be, He) => {
    Y();
    let gt;
    try {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, i || ($.fallbackContext = n ? QU() : void 0), gt = he($);
    } finally {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, i || ($.fallbackContext = void 0);
    }
    if (q !== "translate exists" && // for not `te` (e.g `t`)
    Qn(gt) && gt === up || q === "translate exists" && !gt) {
      const [cn, Yn] = Ae();
      if (process.env.NODE_ENV !== "production" && n && We(cn) && ue(q, Yn) && (S && (cp(y, cn) || t2(v, cn)) && Ki(Zl(Rr.FALLBACK_TO_ROOT, {
        key: cn,
        type: q
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: be } = $;
        be && S && be.emit("fallback", {
          type: q,
          key: cn,
          to: "global",
          groupId: `${q}:${cn}`
        });
      }
      return n && S ? me(n) : Be(cn);
    } else {
      if (He(gt))
        return gt;
      throw Hi(an.UNEXPECTED_RETURN_TYPE);
    }
  };
  function Ne(...he) {
    return Te((Ae) => Reflect.apply(vk, null, [Ae, ...he]), () => Z_(...he), "translate", (Ae) => Reflect.apply(Ae.t, Ae, [...he]), (Ae) => Ae, (Ae) => We(Ae));
  }
  function Z(...he) {
    const [Ae, q, me] = he;
    if (me && !Rt(me))
      throw Hi(an.INVALID_ARGUMENT);
    return Ne(Ae, q, $r({ resolvedMessage: !0 }, me || {}));
  }
  function G(...he) {
    return Te((Ae) => Reflect.apply(_k, null, [Ae, ...he]), () => Q_(...he), "datetime format", (Ae) => Reflect.apply(Ae.d, Ae, [...he]), () => kh, (Ae) => We(Ae));
  }
  function se(...he) {
    return Te((Ae) => Reflect.apply(xk, null, [Ae, ...he]), () => J_(...he), "number format", (Ae) => Reflect.apply(Ae.n, Ae, [...he]), () => kh, (Ae) => We(Ae));
  }
  function St(he) {
    return he.map((Ae) => We(Ae) || Qn(Ae) || xn(Ae) ? kk(String(Ae)) : Ae);
  }
  const Vt = {
    normalize: St,
    interpolate: (he) => he,
    type: "vnode"
  };
  function nn(...he) {
    return Te(
      (Ae) => {
        let q;
        const me = Ae;
        try {
          me.processor = Vt, q = Reflect.apply(vk, null, [me, ...he]);
        } finally {
          me.processor = null;
        }
        return q;
      },
      () => Z_(...he),
      "translate",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (Ae) => Ae[ty](...he),
      (Ae) => [kk(Ae)],
      (Ae) => Jn(Ae)
    );
  }
  function rr(...he) {
    return Te(
      (Ae) => Reflect.apply(xk, null, [Ae, ...he]),
      () => J_(...he),
      "number format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (Ae) => Ae[ry](...he),
      Ck,
      (Ae) => We(Ae) || Jn(Ae)
    );
  }
  function Qe(...he) {
    return Te(
      (Ae) => Reflect.apply(_k, null, [Ae, ...he]),
      () => Q_(...he),
      "datetime format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (Ae) => Ae[ny](...he),
      Ck,
      (Ae) => We(Ae) || Jn(Ae)
    );
  }
  function Je(he) {
    N = he, $.pluralRules = N;
  }
  function Pt(he, Ae) {
    return Te(() => {
      if (!he)
        return !1;
      const q = We(Ae) ? Ae : c.value, me = Cn(q), Be = $.messageResolver(me, he);
      return o ? Be != null : zi(Be) || Ui(Be) || We(Be);
    }, () => [he], "translate exists", (q) => Reflect.apply(q.te, q, [he, Ae]), Aq, (q) => xn(q));
  }
  function Xe(he) {
    let Ae = null;
    const q = KP($, f.value, c.value);
    for (let me = 0; me < q.length; me++) {
      const Be = h.value[q[me]] || {}, He = $.messageResolver(Be, he);
      if (He != null) {
        Ae = He;
        break;
      }
    }
    return Ae;
  }
  function pt(he) {
    const Ae = Xe(he);
    return Ae ?? (n ? n.tm(he) || {} : {});
  }
  function Cn(he) {
    return h.value[he] || {};
  }
  function ut(he, Ae) {
    if (a) {
      const q = { [he]: Ae };
      for (const me in q)
        la(q, me) && Vc(q[me]);
      Ae = q[he];
    }
    h.value[he] = Ae, $.messages = h.value;
  }
  function dr(he, Ae) {
    h.value[he] = h.value[he] || {};
    const q = { [he]: Ae };
    if (a)
      for (const me in q)
        la(q, me) && Vc(q[me]);
    Ae = q[he], ch(Ae, h.value[he]), $.messages = h.value;
  }
  function B(he) {
    return p.value[he] || {};
  }
  function z(he, Ae) {
    p.value[he] = Ae, $.datetimeFormats = p.value, yk($, he, Ae);
  }
  function ye(he, Ae) {
    p.value[he] = $r(p.value[he] || {}, Ae), $.datetimeFormats = p.value, yk($, he, Ae);
  }
  function $e(he) {
    return g.value[he] || {};
  }
  function Ct(he, Ae) {
    g.value[he] = Ae, $.numberFormats = g.value, wk($, he, Ae);
  }
  function At(he, Ae) {
    g.value[he] = $r(g.value[he] || {}, Ae), $.numberFormats = g.value, wk($, he, Ae);
  }
  Tk++, n && ca && (Ln(n.locale, (he) => {
    l && (c.value = he, $.locale = he, Ku($, c.value, f.value));
  }), Ln(n.fallbackLocale, (he) => {
    l && (f.value = he, $.fallbackLocale = he, Ku($, c.value, f.value));
  }));
  const mt = {
    id: Tk,
    locale: te,
    fallbackLocale: _e,
    get inheritLocale() {
      return l;
    },
    set inheritLocale(he) {
      l = he, he && n && (c.value = n.locale.value, f.value = n.fallbackLocale.value, Ku($, c.value, f.value));
    },
    get availableLocales() {
      return Object.keys(h.value).sort();
    },
    messages: Fe,
    get modifiers() {
      return T;
    },
    get pluralRules() {
      return N || {};
    },
    get isGlobal() {
      return i;
    },
    get missingWarn() {
      return v;
    },
    set missingWarn(he) {
      v = he, $.missingWarn = v;
    },
    get fallbackWarn() {
      return y;
    },
    set fallbackWarn(he) {
      y = he, $.fallbackWarn = y;
    },
    get fallbackRoot() {
      return S;
    },
    set fallbackRoot(he) {
      S = he;
    },
    get fallbackFormat() {
      return x;
    },
    set fallbackFormat(he) {
      x = he, $.fallbackFormat = x;
    },
    get warnHtmlMessage() {
      return P;
    },
    set warnHtmlMessage(he) {
      P = he, $.warnHtmlMessage = he;
    },
    get escapeParameter() {
      return M;
    },
    set escapeParameter(he) {
      M = he, $.escapeParameter = he;
    },
    t: Ne,
    getLocaleMessage: Cn,
    setLocaleMessage: ut,
    mergeLocaleMessage: dr,
    getPostTranslationHandler: A,
    setPostTranslationHandler: X,
    getMissingHandler: pe,
    setMissingHandler: le,
    [Sq]: Je
  };
  return mt.datetimeFormats = J, mt.numberFormats = oe, mt.rt = Z, mt.te = Pt, mt.tm = pt, mt.d = G, mt.n = se, mt.getDateTimeFormat = B, mt.setDateTimeFormat = z, mt.mergeDateTimeFormat = ye, mt.getNumberFormat = $e, mt.setNumberFormat = Ct, mt.mergeNumberFormat = At, mt[Cq] = r, mt[ty] = nn, mt[ny] = Qe, mt[ry] = rr, process.env.NODE_ENV !== "production" && (mt[$c] = (he) => {
    $.__v_emitter = he;
  }, mt[iy] = () => {
    $.__v_emitter = void 0;
  }), mt;
}
const u0 = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (e) => e === "parent" || e === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function Eq({ slots: e }, t) {
  return t.length === 1 && t[0] === "default" ? (e.default ? e.default() : []).reduce((r, i) => [
    ...r,
    // prettier-ignore
    ...i.type === Re ? i.children : [i]
  ], []) : t.reduce((n, r) => {
    const i = e[r];
    return i && (n[r] = i()), n;
  }, en());
}
function m2(e) {
  return Re;
}
const Pq = /* @__PURE__ */ dt({
  /* eslint-disable */
  name: "i18n-t",
  props: $r({
    keypath: {
      type: String,
      required: !0
    },
    plural: {
      type: [Number, String],
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      validator: (e) => Qn(e) || !isNaN(e)
    }
  }, u0),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(e, t) {
    const { slots: n, attrs: r } = t, i = e.i18n || nr({
      useScope: e.scope,
      __useComponent: !0
    });
    return () => {
      const a = Object.keys(n).filter((h) => h !== "_"), s = en();
      e.locale && (s.locale = e.locale), e.plural !== void 0 && (s.plural = We(e.plural) ? +e.plural : e.plural);
      const o = Eq(t, a), l = i[ty](e.keypath, o, s), c = $r(en(), r), f = We(e.tag) || Rt(e.tag) ? e.tag : m2();
      return $t(f, c, l);
    };
  }
}), yg = Pq;
function Oq(e) {
  return Jn(e) && !We(e[0]);
}
function g2(e, t, n, r) {
  const { slots: i, attrs: a } = t;
  return () => {
    const s = { part: !0 };
    let o = en();
    e.locale && (s.locale = e.locale), We(e.format) ? s.key = e.format : Rt(e.format) && (We(e.format.key) && (s.key = e.format.key), o = Object.keys(e.format).reduce((p, g) => n.includes(g) ? $r(en(), p, { [g]: e.format[g] }) : p, en()));
    const l = r(e.value, s, o);
    let c = [s.key];
    Jn(l) ? c = l.map((p, g) => {
      const v = i[p.type], y = v ? v({ [p.type]: p.value, index: g, parts: l }) : [p.value];
      return Oq(y) && (y[0].key = `${p.type}-${g}`), y;
    }) : We(l) && (c = [l]);
    const f = $r(en(), a), h = We(e.tag) || Rt(e.tag) ? e.tag : m2();
    return $t(h, f, c);
  };
}
const Mq = /* @__PURE__ */ dt({
  /* eslint-disable */
  name: "i18n-n",
  props: $r({
    value: {
      type: Number,
      required: !0
    },
    format: {
      type: [String, Object]
    }
  }, u0),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(e, t) {
    const n = e.i18n || nr({
      useScope: e.scope,
      __useComponent: !0
    });
    return g2(e, t, o2, (...r) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      n[ry](...r)
    ));
  }
}), Dk = Mq, Iq = /* @__PURE__ */ dt({
  /* eslint-disable */
  name: "i18n-d",
  props: $r({
    value: {
      type: [Number, Date],
      required: !0
    },
    format: {
      type: [String, Object]
    }
  }, u0),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(e, t) {
    const n = e.i18n || nr({
      useScope: e.scope,
      __useComponent: !0
    });
    return g2(e, t, s2, (...r) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      n[ny](...r)
    ));
  }
}), Ek = Iq;
function Rq(e, t) {
  const n = e;
  if (e.mode === "composition")
    return n.__getInstance(t) || e.global;
  {
    const r = n.__getInstance(t);
    return r != null ? r.__composer : e.global.__composer;
  }
}
function Fq(e) {
  const t = (s) => {
    const { instance: o, modifiers: l, value: c } = s;
    if (!o || !o.$)
      throw Hi(an.UNEXPECTED_ERROR);
    const f = Rq(e, o.$);
    process.env.NODE_ENV !== "production" && l.preserve && Ki(Zl(Rr.NOT_SUPPORTED_PRESERVE));
    const h = Pk(c);
    return [
      Reflect.apply(f.t, f, [...Ok(h)]),
      f
    ];
  };
  return {
    created: (s, o) => {
      const [l, c] = t(o);
      ca && e.global === c && (s.__i18nWatcher = Ln(c.locale, () => {
        o.instance && o.instance.$forceUpdate();
      })), s.__composer = c, s.textContent = l;
    },
    unmounted: (s) => {
      ca && s.__i18nWatcher && (s.__i18nWatcher(), s.__i18nWatcher = void 0, delete s.__i18nWatcher), s.__composer && (s.__composer = void 0, delete s.__composer);
    },
    beforeUpdate: (s, { value: o }) => {
      if (s.__composer) {
        const l = s.__composer, c = Pk(o);
        s.textContent = Reflect.apply(l.t, l, [
          ...Ok(c)
        ]);
      }
    },
    getSSRProps: (s) => {
      const [o] = t(s);
      return { textContent: o };
    }
  };
}
function Pk(e) {
  if (We(e))
    return { path: e };
  if (It(e)) {
    if (!("path" in e))
      throw Hi(an.REQUIRED_VALUE, "path");
    return e;
  } else
    throw Hi(an.INVALID_VALUE);
}
function Ok(e) {
  const { path: t, locale: n, args: r, choice: i, plural: a } = e, s = {}, o = r || {};
  return We(n) && (s.locale = n), Qn(i) && (s.plural = i), Qn(a) && (s.plural = a), [t, o, s];
}
function Nq(e, t, ...n) {
  const r = It(n[0]) ? n[0] : {}, i = !!r.useI18nComponentName, a = xn(r.globalInstall) ? r.globalInstall : !0;
  process.env.NODE_ENV !== "production" && a && i && Ki(Zl(Rr.COMPONENT_NAME_LEGACY_COMPATIBLE, {
    name: yg.name
  })), a && ([i ? "i18n" : yg.name, "I18nT"].forEach((s) => e.component(s, yg)), [Dk.name, "I18nN"].forEach((s) => e.component(s, Dk)), [Ek.name, "I18nD"].forEach((s) => e.component(s, Ek))), e.directive("t", Fq(t));
}
const xg = {
  "vue-devtools-plugin-vue-i18n": "Vue I18n devtools",
  "vue-i18n-resource-inspector": "I18n Resources",
  "vue-i18n-timeline": "Vue I18n"
}, Lq = {
  "vue-i18n-resource-inspector": "Search for scopes ..."
}, $q = {
  "vue-i18n-timeline": 16764185
}, v2 = "vue-i18n: composer properties";
let sy;
async function Vq(e, t) {
  return new Promise((n, r) => {
    try {
      u2({
        id: "vue-devtools-plugin-vue-i18n",
        label: xg[
          "vue-devtools-plugin-vue-i18n"
          /* VueDevToolsIDs.PLUGIN */
        ],
        packageName: "vue-i18n",
        homepage: "https://vue-i18n.intlify.dev",
        logo: "https://vue-i18n.intlify.dev/vue-i18n-devtools-logo.png",
        componentStateTypes: [v2],
        app: e
        // eslint-disable-line @typescript-eslint/no-explicit-any
      }, (i) => {
        sy = i, i.on.visitComponentTree(({ componentInstance: s, treeNode: o }) => {
          Bq(s, o, t);
        }), i.on.inspectComponent(({ componentInstance: s, instanceData: o }) => {
          s.vnode.el && s.vnode.el.__VUE_I18N__ && o && (t.mode === "legacy" ? s.vnode.el.__VUE_I18N__ !== t.global.__composer && Mk(o, s.vnode.el.__VUE_I18N__) : Mk(o, s.vnode.el.__VUE_I18N__));
        }), i.addInspector({
          id: "vue-i18n-resource-inspector",
          label: xg[
            "vue-i18n-resource-inspector"
            /* VueDevToolsIDs.CUSTOM_INSPECTOR */
          ],
          icon: "language",
          treeFilterPlaceholder: Lq[
            "vue-i18n-resource-inspector"
            /* VueDevToolsIDs.CUSTOM_INSPECTOR */
          ]
        }), i.on.getInspectorTree((s) => {
          s.app === e && s.inspectorId === "vue-i18n-resource-inspector" && zq(s, t);
        });
        const a = /* @__PURE__ */ new Map();
        i.on.getInspectorState(async (s) => {
          if (s.app === e && s.inspectorId === "vue-i18n-resource-inspector")
            if (i.unhighlightElement(), Gq(s, t), s.nodeId === "global") {
              if (!a.has(s.app)) {
                const [o] = await i.getComponentInstances(s.app);
                a.set(s.app, o);
              }
              i.highlightElement(a.get(s.app));
            } else {
              const o = Hq(s.nodeId, t);
              o && i.highlightElement(o);
            }
        }), i.on.editInspectorState((s) => {
          s.app === e && s.inspectorId === "vue-i18n-resource-inspector" && Kq(s, t);
        }), i.addTimelineLayer({
          id: "vue-i18n-timeline",
          label: xg[
            "vue-i18n-timeline"
            /* VueDevToolsIDs.TIMELINE */
          ],
          color: $q[
            "vue-i18n-timeline"
            /* VueDevToolsIDs.TIMELINE */
          ]
        }), n(!0);
      });
    } catch (i) {
      console.error(i), r(!1);
    }
  });
}
function b2(e) {
  return e.type.name || e.type.displayName || e.type.__file || "Anonymous";
}
function Bq(e, t, n) {
  const r = n.mode === "composition" ? n.global : n.global.__composer;
  if (e && e.vnode.el && e.vnode.el.__VUE_I18N__ && e.vnode.el.__VUE_I18N__ !== r) {
    const i = {
      label: `i18n (${b2(e)} Scope)`,
      textColor: 0,
      backgroundColor: 16764185
    };
    t.tags.push(i);
  }
}
function Mk(e, t) {
  const n = v2;
  e.state.push({
    type: n,
    key: "locale",
    editable: !0,
    value: t.locale.value
  }), e.state.push({
    type: n,
    key: "availableLocales",
    editable: !1,
    value: t.availableLocales
  }), e.state.push({
    type: n,
    key: "fallbackLocale",
    editable: !0,
    value: t.fallbackLocale.value
  }), e.state.push({
    type: n,
    key: "inheritLocale",
    editable: !0,
    value: t.inheritLocale
  }), e.state.push({
    type: n,
    key: "messages",
    editable: !1,
    value: c0(t.messages.value)
  }), e.state.push({
    type: n,
    key: "datetimeFormats",
    editable: !1,
    value: t.datetimeFormats.value
  }), e.state.push({
    type: n,
    key: "numberFormats",
    editable: !1,
    value: t.numberFormats.value
  });
}
function c0(e) {
  const t = {};
  return Object.keys(e).forEach((n) => {
    const r = e[n];
    yn(r) && "source" in r ? t[n] = Wq(r) : zi(r) && r.loc && r.loc.source ? t[n] = r.loc.source : Rt(r) ? t[n] = c0(r) : t[n] = r;
  }), t;
}
const Uq = {
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "&": "&amp;"
};
function qq(e) {
  return e.replace(/[<>"&]/g, jq);
}
function jq(e) {
  return Uq[e] || e;
}
function Wq(e) {
  return {
    _custom: {
      type: "function",
      display: `<span>ƒ</span> ${e.source ? `("${qq(e.source)}")` : "(?)"}`
    }
  };
}
function zq(e, t) {
  e.rootNodes.push({
    id: "global",
    label: "Global Scope"
  });
  const n = t.mode === "composition" ? t.global : t.global.__composer;
  for (const [r, i] of t.__instances) {
    const a = t.mode === "composition" ? i : i.__composer;
    n !== a && e.rootNodes.push({
      id: a.id.toString(),
      label: `${b2(r)} Scope`
    });
  }
}
function Hq(e, t) {
  let n = null;
  if (e !== "global") {
    for (const [r, i] of t.__instances.entries())
      if (i.id.toString() === e) {
        n = r;
        break;
      }
  }
  return n;
}
function _2(e, t) {
  if (e === "global")
    return t.mode === "composition" ? t.global : t.global.__composer;
  {
    const n = Array.from(t.__instances.values()).find((r) => r.id.toString() === e);
    return n ? t.mode === "composition" ? n : n.__composer : null;
  }
}
function Gq(e, t) {
  const n = _2(e.nodeId, t);
  return n && (e.state = Yq(n)), null;
}
function Yq(e) {
  const t = {}, n = "Locale related info", r = [
    {
      type: n,
      key: "locale",
      editable: !0,
      value: e.locale.value
    },
    {
      type: n,
      key: "fallbackLocale",
      editable: !0,
      value: e.fallbackLocale.value
    },
    {
      type: n,
      key: "availableLocales",
      editable: !1,
      value: e.availableLocales
    },
    {
      type: n,
      key: "inheritLocale",
      editable: !0,
      value: e.inheritLocale
    }
  ];
  t[n] = r;
  const i = "Locale messages info", a = [
    {
      type: i,
      key: "messages",
      editable: !1,
      value: c0(e.messages.value)
    }
  ];
  t[i] = a;
  {
    const s = "Datetime formats info", o = [
      {
        type: s,
        key: "datetimeFormats",
        editable: !1,
        value: e.datetimeFormats.value
      }
    ];
    t[s] = o;
    const l = "Datetime formats info", c = [
      {
        type: l,
        key: "numberFormats",
        editable: !1,
        value: e.numberFormats.value
      }
    ];
    t[l] = c;
  }
  return t;
}
function oy(e, t) {
  if (sy) {
    let n;
    t && "groupId" in t && (n = t.groupId, delete t.groupId), sy.addTimelineEvent({
      layerId: "vue-i18n-timeline",
      event: {
        title: e,
        groupId: n,
        time: Date.now(),
        meta: {},
        data: t || {},
        logType: e === "compile-error" ? "error" : e === "fallback" || e === "missing" ? "warning" : "default"
      }
    });
  }
}
function Kq(e, t) {
  const n = _2(e.nodeId, t);
  if (n) {
    const [r] = e.path;
    r === "locale" && We(e.state.value) ? n.locale.value = e.state.value : r === "fallbackLocale" && (We(e.state.value) || Jn(e.state.value) || Rt(e.state.value)) ? n.fallbackLocale.value = e.state.value : r === "inheritLocale" && xn(e.state.value) && (n.inheritLocale = e.state.value);
  }
}
const Xq = /* @__PURE__ */ Pa("global-vue-i18n");
function Zq(e = {}, t) {
  const n = xn(e.globalInjection) ? e.globalInjection : !0, r = !0, i = /* @__PURE__ */ new Map(), [a, s] = Qq(e), o = /* @__PURE__ */ Pa(process.env.NODE_ENV !== "production" ? "vue-i18n" : "");
  process.env.NODE_ENV;
  function l(h) {
    return i.get(h) || null;
  }
  function c(h, p) {
    i.set(h, p);
  }
  function f(h) {
    i.delete(h);
  }
  {
    const h = {
      // mode
      get mode() {
        return "composition";
      },
      // allowComposition
      get allowComposition() {
        return r;
      },
      // install plugin
      async install(p, ...g) {
        if (process.env.NODE_ENV !== "production" && (p.__VUE_I18N__ = h), p.__VUE_I18N_SYMBOL__ = o, p.provide(p.__VUE_I18N_SYMBOL__, h), It(g[0])) {
          const S = g[0];
          h.__composerExtend = S.__composerExtend, h.__vueI18nExtend = S.__vueI18nExtend;
        }
        let v = null;
        n && (v = s4(p, h.global)), Nq(p, h, ...g);
        const y = p.unmount;
        if (p.unmount = () => {
          v && v(), h.dispose(), y();
        }, process.env.NODE_ENV !== "production") {
          if (!await Vq(p, h))
            throw Hi(an.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN);
          const x = RP();
          {
            const E = s;
            E[$c] && E[$c](x);
          }
          x.on("*", oy);
        }
      },
      // global accessor
      get global() {
        return s;
      },
      dispose() {
        a.stop();
      },
      // @internal
      __instances: i,
      // @internal
      __getInstance: l,
      // @internal
      __setInstance: c,
      // @internal
      __deleteInstance: f
    };
    return h;
  }
}
function nr(e = {}) {
  const t = np();
  if (t == null)
    throw Hi(an.MUST_BE_CALL_SETUP_TOP);
  if (!t.isCE && t.appContext.app != null && !t.appContext.app.__VUE_I18N_SYMBOL__)
    throw Hi(an.NOT_INSTALLED);
  const n = Jq(t), r = t4(n), i = h2(t), a = e4(e, i);
  if (a === "global")
    return Tq(r, e, i), r;
  if (a === "parent") {
    let l = n4(n, t, e.__useComponent);
    return l == null && (process.env.NODE_ENV !== "production" && Ki(Zl(Rr.NOT_FOUND_PARENT_SCOPE)), l = r), l;
  }
  const s = n;
  let o = s.__getInstance(t);
  if (o == null) {
    const l = $r({}, e);
    "__i18n" in i && (l.__i18n = i.__i18n), r && (l.__root = r), o = p2(l), s.__composerExtend && (o[ay] = s.__composerExtend(o)), i4(s, t, o), s.__setInstance(t, o);
  }
  return o;
}
function Qq(e, t, n) {
  const r = xP();
  {
    const i = r.run(() => p2(e));
    if (i == null)
      throw Hi(an.UNEXPECTED_ERROR);
    return [r, i];
  }
}
function Jq(e) {
  {
    const t = br(e.isCE ? Xq : e.appContext.app.__VUE_I18N_SYMBOL__);
    if (!t)
      throw Hi(e.isCE ? an.NOT_INSTALLED_WITH_PROVIDE : an.UNEXPECTED_ERROR);
    return t;
  }
}
function e4(e, t) {
  return sp(e) ? "__i18n" in t ? "local" : "global" : e.useScope ? e.useScope : "local";
}
function t4(e) {
  return e.mode === "composition" ? e.global : e.global.__composer;
}
function n4(e, t, n = !1) {
  let r = null;
  const i = t.root;
  let a = r4(t, n);
  for (; a != null; ) {
    const s = e;
    if (e.mode === "composition" && (r = s.__getInstance(a)), r != null || i === a)
      break;
    a = a.parent;
  }
  return r;
}
function r4(e, t = !1) {
  return e == null ? null : t && e.vnode.ctx || e.parent;
}
function i4(e, t, n) {
  let r = null;
  Ft(() => {
    if (process.env.NODE_ENV !== "production" && t.vnode.el) {
      t.vnode.el.__VUE_I18N__ = n, r = RP();
      const i = n;
      i[$c] && i[$c](r), r.on("*", oy);
    }
  }, t), cr(() => {
    const i = n;
    process.env.NODE_ENV !== "production" && t.vnode.el && t.vnode.el.__VUE_I18N__ && (r && r.off("*", oy), i[iy] && i[iy](), delete t.vnode.el.__VUE_I18N__), e.__deleteInstance(t);
    const a = i[ay];
    a && (a(), delete i[ay]);
  }, t);
}
const a4 = [
  "locale",
  "fallbackLocale",
  "availableLocales"
], Ik = ["t", "rt", "d", "n", "tm", "te"];
function s4(e, t) {
  const n = /* @__PURE__ */ Object.create(null);
  return a4.forEach((i) => {
    const a = Object.getOwnPropertyDescriptor(t, i);
    if (!a)
      throw Hi(an.UNEXPECTED_ERROR);
    const s = Vs(a.value) ? {
      get() {
        return a.value.value;
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      set(o) {
        a.value.value = o;
      }
    } : {
      get() {
        return a.get && a.get();
      }
    };
    Object.defineProperty(n, i, s);
  }), e.config.globalProperties.$i18n = n, Ik.forEach((i) => {
    const a = Object.getOwnPropertyDescriptor(t, i);
    if (!a || !a.value)
      throw Hi(an.UNEXPECTED_ERROR);
    Object.defineProperty(e.config.globalProperties, `$${i}`, a);
  }), () => {
    delete e.config.globalProperties.$i18n, Ik.forEach((i) => {
      delete e.config.globalProperties[`$${i}`];
    });
  };
}
xq();
GU(oq);
YU(AU);
KU(KP);
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const e = i0();
  e.__INTLIFY__ = !0, NU(e.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
function Gi(e) {
  "@babel/helpers - typeof";
  return Gi = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Gi(e);
}
function it(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function Ye(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function at(e) {
  Ye(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || Gi(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function os(e, t) {
  Ye(2, arguments);
  var n = at(e), r = it(t);
  return isNaN(r) ? /* @__PURE__ */ new Date(NaN) : (r && n.setDate(n.getDate() + r), n);
}
function Sa(e, t) {
  Ye(2, arguments);
  var n = at(e), r = it(t);
  if (isNaN(r))
    return /* @__PURE__ */ new Date(NaN);
  if (!r)
    return n;
  var i = n.getDate(), a = new Date(n.getTime());
  a.setMonth(n.getMonth() + r + 1, 0);
  var s = a.getDate();
  return i >= s ? a : (n.setFullYear(a.getFullYear(), a.getMonth(), i), n);
}
function y2(e, t) {
  if (Ye(2, arguments), !t || Gi(t) !== "object") return /* @__PURE__ */ new Date(NaN);
  var n = t.years ? it(t.years) : 0, r = t.months ? it(t.months) : 0, i = t.weeks ? it(t.weeks) : 0, a = t.days ? it(t.days) : 0, s = t.hours ? it(t.hours) : 0, o = t.minutes ? it(t.minutes) : 0, l = t.seconds ? it(t.seconds) : 0, c = at(e), f = r || n ? Sa(c, r + n * 12) : c, h = a || i ? os(f, a + i * 7) : f, p = o + s * 60, g = l + p * 60, v = g * 1e3, y = new Date(h.getTime() + v);
  return y;
}
function o4(e, t) {
  Ye(2, arguments);
  var n = at(e).getTime(), r = it(t);
  return new Date(n + r);
}
var l4 = {};
function ro() {
  return l4;
}
function Yo(e, t) {
  var n, r, i, a, s, o, l, c;
  Ye(1, arguments);
  var f = ro(), h = it((n = (r = (i = (a = t == null ? void 0 : t.weekStartsOn) !== null && a !== void 0 ? a : t == null || (s = t.locale) === null || s === void 0 || (o = s.options) === null || o === void 0 ? void 0 : o.weekStartsOn) !== null && i !== void 0 ? i : f.weekStartsOn) !== null && r !== void 0 ? r : (l = f.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(h >= 0 && h <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var p = at(e), g = p.getDay(), v = (g < h ? 7 : 0) + g - h;
  return p.setDate(p.getDate() - v), p.setHours(0, 0, 0, 0), p;
}
function Sh(e) {
  return Ye(1, arguments), Yo(e, {
    weekStartsOn: 1
  });
}
function u4(e) {
  Ye(1, arguments);
  var t = at(e), n = t.getFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  var i = Sh(r), a = /* @__PURE__ */ new Date(0);
  a.setFullYear(n, 0, 4), a.setHours(0, 0, 0, 0);
  var s = Sh(a);
  return t.getTime() >= i.getTime() ? n + 1 : t.getTime() >= s.getTime() ? n : n - 1;
}
function c4(e) {
  Ye(1, arguments);
  var t = u4(e), n = /* @__PURE__ */ new Date(0);
  n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0);
  var r = Sh(n);
  return r;
}
function Ch(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
function Rk(e) {
  Ye(1, arguments);
  var t = at(e);
  return t.setHours(0, 0, 0, 0), t;
}
var d4 = 864e5;
function f4(e, t) {
  Ye(2, arguments);
  var n = Rk(e), r = Rk(t), i = n.getTime() - Ch(n), a = r.getTime() - Ch(r);
  return Math.round((i - a) / d4);
}
function h4(e, t) {
  Ye(2, arguments);
  var n = it(t), r = n * 7;
  return os(e, r);
}
function x2(e, t) {
  Ye(2, arguments);
  var n = it(t);
  return Sa(e, n * 12);
}
var d0 = 6e4, f0 = 36e5, p4 = 1e3;
function w2(e) {
  return Ye(1, arguments), e instanceof Date || Gi(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Sc(e) {
  if (Ye(1, arguments), !w2(e) && typeof e != "number")
    return !1;
  var t = at(e);
  return !isNaN(Number(t));
}
function h0(e) {
  Ye(1, arguments);
  var t = at(e), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function Fk(e, t) {
  var n;
  Ye(1, arguments);
  var r = e || {}, i = at(r.start), a = at(r.end), s = a.getTime();
  if (!(i.getTime() <= s))
    throw new RangeError("Invalid interval");
  var o = [], l = i;
  l.setHours(0, 0, 0, 0);
  var c = Number((n = void 0) !== null && n !== void 0 ? n : 1);
  if (c < 1 || isNaN(c)) throw new RangeError("`options.step` must be a number greater than 1");
  for (; l.getTime() <= s; )
    o.push(at(l)), l.setDate(l.getDate() + c), l.setHours(0, 0, 0, 0);
  return o;
}
function Jc(e) {
  Ye(1, arguments);
  var t = at(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function k2(e) {
  Ye(1, arguments);
  var t = at(e), n = /* @__PURE__ */ new Date(0);
  return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function p0(e, t) {
  var n, r, i, a, s, o, l, c;
  Ye(1, arguments);
  var f = ro(), h = it((n = (r = (i = (a = t == null ? void 0 : t.weekStartsOn) !== null && a !== void 0 ? a : t == null || (s = t.locale) === null || s === void 0 || (o = s.options) === null || o === void 0 ? void 0 : o.weekStartsOn) !== null && i !== void 0 ? i : f.weekStartsOn) !== null && r !== void 0 ? r : (l = f.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(h >= 0 && h <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var p = at(e), g = p.getDay(), v = (g < h ? -7 : 0) + 6 - (g - h);
  return p.setDate(p.getDate() + v), p.setHours(23, 59, 59, 999), p;
}
function S2(e, t) {
  Ye(2, arguments);
  var n = it(t);
  return o4(e, -n);
}
var m4 = 864e5;
function g4(e) {
  Ye(1, arguments);
  var t = at(e), n = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var r = t.getTime(), i = n - r;
  return Math.floor(i / m4) + 1;
}
function Ql(e) {
  Ye(1, arguments);
  var t = 1, n = at(e), r = n.getUTCDay(), i = (r < t ? 7 : 0) + r - t;
  return n.setUTCDate(n.getUTCDate() - i), n.setUTCHours(0, 0, 0, 0), n;
}
function C2(e) {
  Ye(1, arguments);
  var t = at(e), n = t.getUTCFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var i = Ql(r), a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(n, 0, 4), a.setUTCHours(0, 0, 0, 0);
  var s = Ql(a);
  return t.getTime() >= i.getTime() ? n + 1 : t.getTime() >= s.getTime() ? n : n - 1;
}
function v4(e) {
  Ye(1, arguments);
  var t = C2(e), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(t, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var r = Ql(n);
  return r;
}
var b4 = 6048e5;
function T2(e) {
  Ye(1, arguments);
  var t = at(e), n = Ql(t).getTime() - v4(t).getTime();
  return Math.round(n / b4) + 1;
}
function Ko(e, t) {
  var n, r, i, a, s, o, l, c;
  Ye(1, arguments);
  var f = ro(), h = it((n = (r = (i = (a = t == null ? void 0 : t.weekStartsOn) !== null && a !== void 0 ? a : t == null || (s = t.locale) === null || s === void 0 || (o = s.options) === null || o === void 0 ? void 0 : o.weekStartsOn) !== null && i !== void 0 ? i : f.weekStartsOn) !== null && r !== void 0 ? r : (l = f.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(h >= 0 && h <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var p = at(e), g = p.getUTCDay(), v = (g < h ? 7 : 0) + g - h;
  return p.setUTCDate(p.getUTCDate() - v), p.setUTCHours(0, 0, 0, 0), p;
}
function m0(e, t) {
  var n, r, i, a, s, o, l, c;
  Ye(1, arguments);
  var f = at(e), h = f.getUTCFullYear(), p = ro(), g = it((n = (r = (i = (a = t == null ? void 0 : t.firstWeekContainsDate) !== null && a !== void 0 ? a : t == null || (s = t.locale) === null || s === void 0 || (o = s.options) === null || o === void 0 ? void 0 : o.firstWeekContainsDate) !== null && i !== void 0 ? i : p.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = p.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(g >= 1 && g <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var v = /* @__PURE__ */ new Date(0);
  v.setUTCFullYear(h + 1, 0, g), v.setUTCHours(0, 0, 0, 0);
  var y = Ko(v, t), S = /* @__PURE__ */ new Date(0);
  S.setUTCFullYear(h, 0, g), S.setUTCHours(0, 0, 0, 0);
  var x = Ko(S, t);
  return f.getTime() >= y.getTime() ? h + 1 : f.getTime() >= x.getTime() ? h : h - 1;
}
function _4(e, t) {
  var n, r, i, a, s, o, l, c;
  Ye(1, arguments);
  var f = ro(), h = it((n = (r = (i = (a = t == null ? void 0 : t.firstWeekContainsDate) !== null && a !== void 0 ? a : t == null || (s = t.locale) === null || s === void 0 || (o = s.options) === null || o === void 0 ? void 0 : o.firstWeekContainsDate) !== null && i !== void 0 ? i : f.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = f.locale) === null || l === void 0 || (c = l.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), p = m0(e, t), g = /* @__PURE__ */ new Date(0);
  g.setUTCFullYear(p, 0, h), g.setUTCHours(0, 0, 0, 0);
  var v = Ko(g, t);
  return v;
}
var y4 = 6048e5;
function A2(e, t) {
  Ye(1, arguments);
  var n = at(e), r = Ko(n, t).getTime() - _4(n, t).getTime();
  return Math.round(r / y4) + 1;
}
function Kt(e, t) {
  for (var n = e < 0 ? "-" : "", r = Math.abs(e).toString(); r.length < t; )
    r = "0" + r;
  return n + r;
}
var Is = {
  // Year
  y: function(t, n) {
    var r = t.getUTCFullYear(), i = r > 0 ? r : 1 - r;
    return Kt(n === "yy" ? i % 100 : i, n.length);
  },
  // Month
  M: function(t, n) {
    var r = t.getUTCMonth();
    return n === "M" ? String(r + 1) : Kt(r + 1, 2);
  },
  // Day of the month
  d: function(t, n) {
    return Kt(t.getUTCDate(), n.length);
  },
  // AM or PM
  a: function(t, n) {
    var r = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(t, n) {
    return Kt(t.getUTCHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H: function(t, n) {
    return Kt(t.getUTCHours(), n.length);
  },
  // Minute
  m: function(t, n) {
    return Kt(t.getUTCMinutes(), n.length);
  },
  // Second
  s: function(t, n) {
    return Kt(t.getUTCSeconds(), n.length);
  },
  // Fraction of second
  S: function(t, n) {
    var r = n.length, i = t.getUTCMilliseconds(), a = Math.floor(i * Math.pow(10, r - 3));
    return Kt(a, n.length);
  }
}, Ll = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, x4 = {
  // Era
  G: function(t, n, r) {
    var i = t.getUTCFullYear() > 0 ? 1 : 0;
    switch (n) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return r.era(i, {
          width: "abbreviated"
        });
      // A, B
      case "GGGGG":
        return r.era(i, {
          width: "narrow"
        });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return r.era(i, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(t, n, r) {
    if (n === "yo") {
      var i = t.getUTCFullYear(), a = i > 0 ? i : 1 - i;
      return r.ordinalNumber(a, {
        unit: "year"
      });
    }
    return Is.y(t, n);
  },
  // Local week-numbering year
  Y: function(t, n, r, i) {
    var a = m0(t, i), s = a > 0 ? a : 1 - a;
    if (n === "YY") {
      var o = s % 100;
      return Kt(o, 2);
    }
    return n === "Yo" ? r.ordinalNumber(s, {
      unit: "year"
    }) : Kt(s, n.length);
  },
  // ISO week-numbering year
  R: function(t, n) {
    var r = C2(t);
    return Kt(r, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, n) {
    var r = t.getUTCFullYear();
    return Kt(r, n.length);
  },
  // Quarter
  Q: function(t, n, r) {
    var i = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (n) {
      // 1, 2, 3, 4
      case "Q":
        return String(i);
      // 01, 02, 03, 04
      case "QQ":
        return Kt(i, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return r.ordinalNumber(i, {
          unit: "quarter"
        });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return r.quarter(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return r.quarter(i, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return r.quarter(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, n, r) {
    var i = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (n) {
      // 1, 2, 3, 4
      case "q":
        return String(i);
      // 01, 02, 03, 04
      case "qq":
        return Kt(i, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return r.ordinalNumber(i, {
          unit: "quarter"
        });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return r.quarter(i, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return r.quarter(i, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return r.quarter(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, n, r) {
    var i = t.getUTCMonth();
    switch (n) {
      case "M":
      case "MM":
        return Is.M(t, n);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return r.ordinalNumber(i + 1, {
          unit: "month"
        });
      // Jan, Feb, ..., Dec
      case "MMM":
        return r.month(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return r.month(i, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return r.month(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(t, n, r) {
    var i = t.getUTCMonth();
    switch (n) {
      // 1, 2, ..., 12
      case "L":
        return String(i + 1);
      // 01, 02, ..., 12
      case "LL":
        return Kt(i + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return r.ordinalNumber(i + 1, {
          unit: "month"
        });
      // Jan, Feb, ..., Dec
      case "LLL":
        return r.month(i, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return r.month(i, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return r.month(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(t, n, r, i) {
    var a = A2(t, i);
    return n === "wo" ? r.ordinalNumber(a, {
      unit: "week"
    }) : Kt(a, n.length);
  },
  // ISO week of year
  I: function(t, n, r) {
    var i = T2(t);
    return n === "Io" ? r.ordinalNumber(i, {
      unit: "week"
    }) : Kt(i, n.length);
  },
  // Day of the month
  d: function(t, n, r) {
    return n === "do" ? r.ordinalNumber(t.getUTCDate(), {
      unit: "date"
    }) : Is.d(t, n);
  },
  // Day of year
  D: function(t, n, r) {
    var i = g4(t);
    return n === "Do" ? r.ordinalNumber(i, {
      unit: "dayOfYear"
    }) : Kt(i, n.length);
  },
  // Day of week
  E: function(t, n, r) {
    var i = t.getUTCDay();
    switch (n) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return r.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return r.day(i, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return r.day(i, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return r.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, n, r, i) {
    var a = t.getUTCDay(), s = (a - i.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(s);
      // Padded numerical value
      case "ee":
        return Kt(s, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return r.ordinalNumber(s, {
          unit: "day"
        });
      case "eee":
        return r.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return r.day(a, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return r.day(a, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return r.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, n, r, i) {
    var a = t.getUTCDay(), s = (a - i.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      // Numerical value (same as in `e`)
      case "c":
        return String(s);
      // Padded numerical value
      case "cc":
        return Kt(s, n.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return r.ordinalNumber(s, {
          unit: "day"
        });
      case "ccc":
        return r.day(a, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return r.day(a, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return r.day(a, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return r.day(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, n, r) {
    var i = t.getUTCDay(), a = i === 0 ? 7 : i;
    switch (n) {
      // 2
      case "i":
        return String(a);
      // 02
      case "ii":
        return Kt(a, n.length);
      // 2nd
      case "io":
        return r.ordinalNumber(a, {
          unit: "day"
        });
      // Tue
      case "iii":
        return r.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return r.day(i, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return r.day(i, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return r.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, n, r) {
    var i = t.getUTCHours(), a = i / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, n, r) {
    var i = t.getUTCHours(), a;
    switch (i === 12 ? a = Ll.noon : i === 0 ? a = Ll.midnight : a = i / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, n, r) {
    var i = t.getUTCHours(), a;
    switch (i >= 17 ? a = Ll.evening : i >= 12 ? a = Ll.afternoon : i >= 4 ? a = Ll.morning : a = Ll.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(a, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, n, r) {
    if (n === "ho") {
      var i = t.getUTCHours() % 12;
      return i === 0 && (i = 12), r.ordinalNumber(i, {
        unit: "hour"
      });
    }
    return Is.h(t, n);
  },
  // Hour [0-23]
  H: function(t, n, r) {
    return n === "Ho" ? r.ordinalNumber(t.getUTCHours(), {
      unit: "hour"
    }) : Is.H(t, n);
  },
  // Hour [0-11]
  K: function(t, n, r) {
    var i = t.getUTCHours() % 12;
    return n === "Ko" ? r.ordinalNumber(i, {
      unit: "hour"
    }) : Kt(i, n.length);
  },
  // Hour [1-24]
  k: function(t, n, r) {
    var i = t.getUTCHours();
    return i === 0 && (i = 24), n === "ko" ? r.ordinalNumber(i, {
      unit: "hour"
    }) : Kt(i, n.length);
  },
  // Minute
  m: function(t, n, r) {
    return n === "mo" ? r.ordinalNumber(t.getUTCMinutes(), {
      unit: "minute"
    }) : Is.m(t, n);
  },
  // Second
  s: function(t, n, r) {
    return n === "so" ? r.ordinalNumber(t.getUTCSeconds(), {
      unit: "second"
    }) : Is.s(t, n);
  },
  // Fraction of second
  S: function(t, n) {
    return Is.S(t, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, n, r, i) {
    var a = i._originalDate || t, s = a.getTimezoneOffset();
    if (s === 0)
      return "Z";
    switch (n) {
      // Hours and optional minutes
      case "X":
        return Lk(s);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return Oo(s);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return Oo(s, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, n, r, i) {
    var a = i._originalDate || t, s = a.getTimezoneOffset();
    switch (n) {
      // Hours and optional minutes
      case "x":
        return Lk(s);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return Oo(s);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return Oo(s, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, n, r, i) {
    var a = i._originalDate || t, s = a.getTimezoneOffset();
    switch (n) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Nk(s, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + Oo(s, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, n, r, i) {
    var a = i._originalDate || t, s = a.getTimezoneOffset();
    switch (n) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Nk(s, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + Oo(s, ":");
    }
  },
  // Seconds timestamp
  t: function(t, n, r, i) {
    var a = i._originalDate || t, s = Math.floor(a.getTime() / 1e3);
    return Kt(s, n.length);
  },
  // Milliseconds timestamp
  T: function(t, n, r, i) {
    var a = i._originalDate || t, s = a.getTime();
    return Kt(s, n.length);
  }
};
function Nk(e, t) {
  var n = e > 0 ? "-" : "+", r = Math.abs(e), i = Math.floor(r / 60), a = r % 60;
  if (a === 0)
    return n + String(i);
  var s = t;
  return n + String(i) + s + Kt(a, 2);
}
function Lk(e, t) {
  if (e % 60 === 0) {
    var n = e > 0 ? "-" : "+";
    return n + Kt(Math.abs(e) / 60, 2);
  }
  return Oo(e, t);
}
function Oo(e, t) {
  var n = t || "", r = e > 0 ? "-" : "+", i = Math.abs(e), a = Kt(Math.floor(i / 60), 2), s = Kt(i % 60, 2);
  return r + a + n + s;
}
var $k = function(t, n) {
  switch (t) {
    case "P":
      return n.date({
        width: "short"
      });
    case "PP":
      return n.date({
        width: "medium"
      });
    case "PPP":
      return n.date({
        width: "long"
      });
    case "PPPP":
    default:
      return n.date({
        width: "full"
      });
  }
}, D2 = function(t, n) {
  switch (t) {
    case "p":
      return n.time({
        width: "short"
      });
    case "pp":
      return n.time({
        width: "medium"
      });
    case "ppp":
      return n.time({
        width: "long"
      });
    case "pppp":
    default:
      return n.time({
        width: "full"
      });
  }
}, w4 = function(t, n) {
  var r = t.match(/(P+)(p+)?/) || [], i = r[1], a = r[2];
  if (!a)
    return $k(t, n);
  var s;
  switch (i) {
    case "P":
      s = n.dateTime({
        width: "short"
      });
      break;
    case "PP":
      s = n.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      s = n.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      s = n.dateTime({
        width: "full"
      });
      break;
  }
  return s.replace("{{date}}", $k(i, n)).replace("{{time}}", D2(a, n));
}, ly = {
  p: D2,
  P: w4
}, k4 = ["D", "DD"], S4 = ["YY", "YYYY"];
function E2(e) {
  return k4.indexOf(e) !== -1;
}
function P2(e) {
  return S4.indexOf(e) !== -1;
}
function Th(e, t, n) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var C4 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, T4 = function(t, n, r) {
  var i, a = C4[t];
  return typeof a == "string" ? i = a : n === 1 ? i = a.one : i = a.other.replace("{{count}}", n.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + i : i + " ago" : i;
};
function Gl(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.width ? String(t.width) : e.defaultWidth, r = e.formats[n] || e.formats[e.defaultWidth];
    return r;
  };
}
var A4 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, D4 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, E4 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, P4 = {
  date: Gl({
    formats: A4,
    defaultWidth: "full"
  }),
  time: Gl({
    formats: D4,
    defaultWidth: "full"
  }),
  dateTime: Gl({
    formats: E4,
    defaultWidth: "full"
  })
}, O4 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, M4 = function(t, n, r, i) {
  return O4[t];
};
function ya(e) {
  return function(t, n) {
    var r = n != null && n.context ? String(n.context) : "standalone", i;
    if (r === "formatting" && e.formattingValues) {
      var a = e.defaultFormattingWidth || e.defaultWidth, s = n != null && n.width ? String(n.width) : a;
      i = e.formattingValues[s] || e.formattingValues[a];
    } else {
      var o = e.defaultWidth, l = n != null && n.width ? String(n.width) : e.defaultWidth;
      i = e.values[l] || e.values[o];
    }
    var c = e.argumentCallback ? e.argumentCallback(t) : t;
    return i[c];
  };
}
var I4 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, R4 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, F4 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, N4 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, L4 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, $4 = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, V4 = function(t, n) {
  var r = Number(t), i = r % 100;
  if (i > 20 || i < 10)
    switch (i % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, B4 = {
  ordinalNumber: V4,
  era: ya({
    values: I4,
    defaultWidth: "wide"
  }),
  quarter: ya({
    values: R4,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: ya({
    values: F4,
    defaultWidth: "wide"
  }),
  day: ya({
    values: N4,
    defaultWidth: "wide"
  }),
  dayPeriod: ya({
    values: L4,
    defaultWidth: "wide",
    formattingValues: $4,
    defaultFormattingWidth: "wide"
  })
};
function xa(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.width, i = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], a = t.match(i);
    if (!a)
      return null;
    var s = a[0], o = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(o) ? q4(o, function(h) {
      return h.test(s);
    }) : U4(o, function(h) {
      return h.test(s);
    }), c;
    c = e.valueCallback ? e.valueCallback(l) : l, c = n.valueCallback ? n.valueCallback(c) : c;
    var f = t.slice(s.length);
    return {
      value: c,
      rest: f
    };
  };
}
function U4(e, t) {
  for (var n in e)
    if (e.hasOwnProperty(n) && t(e[n]))
      return n;
}
function q4(e, t) {
  for (var n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function O2(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.match(e.matchPattern);
    if (!r) return null;
    var i = r[0], a = t.match(e.parsePattern);
    if (!a) return null;
    var s = e.valueCallback ? e.valueCallback(a[0]) : a[0];
    s = n.valueCallback ? n.valueCallback(s) : s;
    var o = t.slice(i.length);
    return {
      value: s,
      rest: o
    };
  };
}
var j4 = /^(\d+)(th|st|nd|rd)?/i, W4 = /\d+/i, z4 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, H4 = {
  any: [/^b/i, /^(a|c)/i]
}, G4 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Y4 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, K4 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, X4 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Z4 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Q4 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, J4 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, e8 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, t8 = {
  ordinalNumber: O2({
    matchPattern: j4,
    parsePattern: W4,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: xa({
    matchPatterns: z4,
    defaultMatchWidth: "wide",
    parsePatterns: H4,
    defaultParseWidth: "any"
  }),
  quarter: xa({
    matchPatterns: G4,
    defaultMatchWidth: "wide",
    parsePatterns: Y4,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: xa({
    matchPatterns: K4,
    defaultMatchWidth: "wide",
    parsePatterns: X4,
    defaultParseWidth: "any"
  }),
  day: xa({
    matchPatterns: Z4,
    defaultMatchWidth: "wide",
    parsePatterns: Q4,
    defaultParseWidth: "any"
  }),
  dayPeriod: xa({
    matchPatterns: J4,
    defaultMatchWidth: "any",
    parsePatterns: e8,
    defaultParseWidth: "any"
  })
}, M2 = {
  code: "en-US",
  formatDistance: T4,
  formatLong: P4,
  formatRelative: M4,
  localize: B4,
  match: t8,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, n8 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, r8 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, i8 = /^'([^]*?)'?$/, a8 = /''/g, s8 = /[a-zA-Z]/;
function ua(e, t, n) {
  var r, i, a, s, o, l, c, f, h, p, g, v, y, S, x, E, w, C;
  Ye(2, arguments);
  var P = String(t), M = ro(), T = (r = (i = n == null ? void 0 : n.locale) !== null && i !== void 0 ? i : M.locale) !== null && r !== void 0 ? r : M2, N = it((a = (s = (o = (l = n == null ? void 0 : n.firstWeekContainsDate) !== null && l !== void 0 ? l : n == null || (c = n.locale) === null || c === void 0 || (f = c.options) === null || f === void 0 ? void 0 : f.firstWeekContainsDate) !== null && o !== void 0 ? o : M.firstWeekContainsDate) !== null && s !== void 0 ? s : (h = M.locale) === null || h === void 0 || (p = h.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && a !== void 0 ? a : 1);
  if (!(N >= 1 && N <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var $ = it((g = (v = (y = (S = n == null ? void 0 : n.weekStartsOn) !== null && S !== void 0 ? S : n == null || (x = n.locale) === null || x === void 0 || (E = x.options) === null || E === void 0 ? void 0 : E.weekStartsOn) !== null && y !== void 0 ? y : M.weekStartsOn) !== null && v !== void 0 ? v : (w = M.locale) === null || w === void 0 || (C = w.options) === null || C === void 0 ? void 0 : C.weekStartsOn) !== null && g !== void 0 ? g : 0);
  if (!($ >= 0 && $ <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!T.localize)
    throw new RangeError("locale must contain localize property");
  if (!T.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var ne = at(e);
  if (!Sc(ne))
    throw new RangeError("Invalid time value");
  var Y = Ch(ne), te = S2(ne, Y), _e = {
    firstWeekContainsDate: N,
    weekStartsOn: $,
    locale: T,
    _originalDate: ne
  }, Fe = P.match(r8).map(function(J) {
    var oe = J[0];
    if (oe === "p" || oe === "P") {
      var A = ly[oe];
      return A(J, T.formatLong);
    }
    return J;
  }).join("").match(n8).map(function(J) {
    if (J === "''")
      return "'";
    var oe = J[0];
    if (oe === "'")
      return o8(J);
    var A = x4[oe];
    if (A)
      return !(n != null && n.useAdditionalWeekYearTokens) && P2(J) && Th(J, t, String(e)), !(n != null && n.useAdditionalDayOfYearTokens) && E2(J) && Th(J, t, String(e)), A(te, J, T.localize, _e);
    if (oe.match(s8))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + oe + "`");
    return J;
  }).join("");
  return Fe;
}
function o8(e) {
  var t = e.match(i8);
  return t ? t[1].replace(a8, "'") : e;
}
function l8(e, t) {
  if (e == null)
    throw new TypeError("assign requires that input parameter not be null or undefined");
  for (var n in t)
    Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
  return e;
}
function u8(e) {
  Ye(1, arguments);
  var t = at(e), n = t.getDay();
  return n;
}
function c8(e) {
  Ye(1, arguments);
  var t = at(e), n = t.getFullYear(), r = t.getMonth(), i = /* @__PURE__ */ new Date(0);
  return i.setFullYear(n, r + 1, 0), i.setHours(0, 0, 0, 0), i.getDate();
}
function es(e) {
  Ye(1, arguments);
  var t = at(e), n = t.getHours();
  return n;
}
var d8 = 6048e5;
function f8(e) {
  Ye(1, arguments);
  var t = at(e), n = Sh(t).getTime() - c4(t).getTime();
  return Math.round(n / d8) + 1;
}
function ts(e) {
  Ye(1, arguments);
  var t = at(e), n = t.getMinutes();
  return n;
}
function mn(e) {
  Ye(1, arguments);
  var t = at(e), n = t.getMonth();
  return n;
}
function Jl(e) {
  Ye(1, arguments);
  var t = at(e), n = t.getSeconds();
  return n;
}
function gn(e) {
  return Ye(1, arguments), at(e).getFullYear();
}
function g0(e, t) {
  Ye(2, arguments);
  var n = at(e), r = at(t);
  return n.getTime() > r.getTime();
}
function v0(e, t) {
  Ye(2, arguments);
  var n = at(e), r = at(t);
  return n.getTime() < r.getTime();
}
function I2(e, t) {
  Ye(2, arguments);
  var n = at(e), r = at(t);
  return n.getTime() === r.getTime();
}
function Vk(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function h8(e, t) {
  if (e) {
    if (typeof e == "string") return Vk(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? Vk(e, t) : void 0;
  }
}
function Bk(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = h8(e)) || t) {
      n && (e = n);
      var r = 0, i = function() {
      };
      return {
        s: i,
        n: function() {
          return r >= e.length ? {
            done: !0
          } : {
            done: !1,
            value: e[r++]
          };
        },
        e: function(c) {
          throw c;
        },
        f: i
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var a, s = !0, o = !1;
  return {
    s: function() {
      n = n.call(e);
    },
    n: function() {
      var c = n.next();
      return s = c.done, c;
    },
    e: function(c) {
      o = !0, a = c;
    },
    f: function() {
      try {
        s || n.return == null || n.return();
      } finally {
        if (o) throw a;
      }
    }
  };
}
function ze(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function uy(e, t) {
  return uy = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, uy(e, t);
}
function Ut(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && uy(e, t);
}
function Ah(e) {
  return Ah = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Ah(e);
}
function R2() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (R2 = function() {
    return !!e;
  })();
}
function p8(e, t) {
  if (t && (Gi(t) == "object" || typeof t == "function")) return t;
  if (t !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return ze(e);
}
function qt(e) {
  var t = R2();
  return function() {
    var n, r = Ah(e);
    if (t) {
      var i = Ah(this).constructor;
      n = Reflect.construct(r, arguments, i);
    } else n = r.apply(this, arguments);
    return p8(this, n);
  };
}
function Nt(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function m8(e, t) {
  if (Gi(e) != "object" || !e) return e;
  var n;
  if (typeof Symbol < "u" && (n = e[Symbol.toPrimitive]) !== void 0) {
    var r = n.call(e, t);
    if (Gi(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function F2(e) {
  var t = m8(e, "string");
  return Gi(t) == "symbol" ? t : t + "";
}
function g8(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, F2(r.key), r);
  }
}
function Lt(e, t, n) {
  return t && g8(e.prototype, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function qe(e, t, n) {
  return (t = F2(t)) in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
var v8 = 10, N2 = /* @__PURE__ */ (function() {
  function e() {
    Nt(this, e), qe(this, "priority", void 0), qe(this, "subPriority", 0);
  }
  return Lt(e, [{
    key: "validate",
    value: function(n, r) {
      return !0;
    }
  }]), e;
})(), b8 = /* @__PURE__ */ (function(e) {
  Ut(n, e);
  var t = qt(n);
  function n(r, i, a, s, o) {
    var l;
    return Nt(this, n), l = t.call(this), l.value = r, l.validateValue = i, l.setValue = a, l.priority = s, o && (l.subPriority = o), l;
  }
  return Lt(n, [{
    key: "validate",
    value: function(i, a) {
      return this.validateValue(i, this.value, a);
    }
  }, {
    key: "set",
    value: function(i, a, s) {
      return this.setValue(i, a, this.value, s);
    }
  }]), n;
})(N2), _8 = /* @__PURE__ */ (function(e) {
  Ut(n, e);
  var t = qt(n);
  function n() {
    var r;
    Nt(this, n);
    for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++)
      a[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(a)), qe(ze(r), "priority", v8), qe(ze(r), "subPriority", -1), r;
  }
  return Lt(n, [{
    key: "set",
    value: function(i, a) {
      if (a.timestampIsSet)
        return i;
      var s = /* @__PURE__ */ new Date(0);
      return s.setFullYear(i.getUTCFullYear(), i.getUTCMonth(), i.getUTCDate()), s.setHours(i.getUTCHours(), i.getUTCMinutes(), i.getUTCSeconds(), i.getUTCMilliseconds()), s;
    }
  }]), n;
})(N2), zt = /* @__PURE__ */ (function() {
  function e() {
    Nt(this, e), qe(this, "incompatibleTokens", void 0), qe(this, "priority", void 0), qe(this, "subPriority", void 0);
  }
  return Lt(e, [{
    key: "run",
    value: function(n, r, i, a) {
      var s = this.parse(n, r, i, a);
      return s ? {
        setter: new b8(s.value, this.validate, this.set, this.priority, this.subPriority),
        rest: s.rest
      } : null;
    }
  }, {
    key: "validate",
    value: function(n, r, i) {
      return !0;
    }
  }]), e;
})(), y8 = /* @__PURE__ */ (function(e) {
  Ut(n, e);
  var t = qt(n);
  function n() {
    var r;
    Nt(this, n);
    for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++)
      a[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(a)), qe(ze(r), "priority", 140), qe(ze(r), "incompatibleTokens", ["R", "u", "t", "T"]), r;
  }
  return Lt(n, [{
    key: "parse",
    value: function(i, a, s) {
      switch (a) {
        // AD, BC
        case "G":
        case "GG":
        case "GGG":
          return s.era(i, {
            width: "abbreviated"
          }) || s.era(i, {
            width: "narrow"
          });
        // A, B
        case "GGGGG":
          return s.era(i, {
            width: "narrow"
          });
        // Anno Domini, Before Christ
        case "GGGG":
        default:
          return s.era(i, {
            width: "wide"
          }) || s.era(i, {
            width: "abbreviated"
          }) || s.era(i, {
            width: "narrow"
          });
      }
    }
  }, {
    key: "set",
    value: function(i, a, s) {
      return a.era = s, i.setUTCFullYear(s, 0, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), n;
})(zt), jn = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, wa = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function Wn(e, t) {
  return e && {
    value: t(e.value),
    rest: e.rest
  };
}
function En(e, t) {
  var n = t.match(e);
  return n ? {
    value: parseInt(n[0], 10),
    rest: t.slice(n[0].length)
  } : null;
}
function ka(e, t) {
  var n = t.match(e);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: t.slice(1)
    };
  var r = n[1] === "+" ? 1 : -1, i = n[2] ? parseInt(n[2], 10) : 0, a = n[3] ? parseInt(n[3], 10) : 0, s = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: r * (i * f0 + a * d0 + s * p4),
    rest: t.slice(n[0].length)
  };
}
function L2(e) {
  return En(jn.anyDigitsSigned, e);
}
function $n(e, t) {
  switch (e) {
    case 1:
      return En(jn.singleDigit, t);
    case 2:
      return En(jn.twoDigits, t);
    case 3:
      return En(jn.threeDigits, t);
    case 4:
      return En(jn.fourDigits, t);
    default:
      return En(new RegExp("^\\d{1," + e + "}"), t);
  }
}
function Dh(e, t) {
  switch (e) {
    case 1:
      return En(jn.singleDigitSigned, t);
    case 2:
      return En(jn.twoDigitsSigned, t);
    case 3:
      return En(jn.threeDigitsSigned, t);
    case 4:
      return En(jn.fourDigitsSigned, t);
    default:
      return En(new RegExp("^-?\\d{1," + e + "}"), t);
  }
}
function b0(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function $2(e, t) {
  var n = t > 0, r = n ? t : 1 - t, i;
  if (r <= 50)
    i = e || 100;
  else {
    var a = r + 50, s = Math.floor(a / 100) * 100, o = e >= a % 100;
    i = e + s - (o ? 100 : 0);
  }
  return n ? i : 1 - i;
}
function V2(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
var x8 = /* @__PURE__ */ (function(e) {
  Ut(n, e);
  var t = qt(n);
  function n() {
    var r;
    Nt(this, n);
    for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++)
      a[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(a)), qe(ze(r), "priority", 130), qe(ze(r), "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]), r;
  }
  return Lt(n, [{
    key: "parse",
    value: function(i, a, s) {
      var o = function(c) {
        return {
          year: c,
          isTwoDigitYear: a === "yy"
        };
      };
      switch (a) {
        case "y":
          return Wn($n(4, i), o);
        case "yo":
          return Wn(s.ordinalNumber(i, {
            unit: "year"
          }), o);
        default:
          return Wn($n(a.length, i), o);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a.isTwoDigitYear || a.year > 0;
    }
  }, {
    key: "set",
    value: function(i, a, s) {
      var o = i.getUTCFullYear();
      if (s.isTwoDigitYear) {
        var l = $2(s.year, o);
        return i.setUTCFullYear(l, 0, 1), i.setUTCHours(0, 0, 0, 0), i;
      }
      var c = !("era" in a) || a.era === 1 ? s.year : 1 - s.year;
      return i.setUTCFullYear(c, 0, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), n;
})(zt), w8 = /* @__PURE__ */ (function(e) {
  Ut(n, e);
  var t = qt(n);
  function n() {
    var r;
    Nt(this, n);
    for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++)
      a[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(a)), qe(ze(r), "priority", 130), qe(ze(r), "incompatibleTokens", ["y", "R", "u", "Q", "q", "M", "L", "I", "d", "D", "i", "t", "T"]), r;
  }
  return Lt(n, [{
    key: "parse",
    value: function(i, a, s) {
      var o = function(c) {
        return {
          year: c,
          isTwoDigitYear: a === "YY"
        };
      };
      switch (a) {
        case "Y":
          return Wn($n(4, i), o);
        case "Yo":
          return Wn(s.ordinalNumber(i, {
            unit: "year"
          }), o);
        default:
          return Wn($n(a.length, i), o);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a.isTwoDigitYear || a.year > 0;
    }
  }, {
    key: "set",
    value: function(i, a, s, o) {
      var l = m0(i, o);
      if (s.isTwoDigitYear) {
        var c = $2(s.year, l);
        return i.setUTCFullYear(c, 0, o.firstWeekContainsDate), i.setUTCHours(0, 0, 0, 0), Ko(i, o);
      }
      var f = !("era" in a) || a.era === 1 ? s.year : 1 - s.year;
      return i.setUTCFullYear(f, 0, o.firstWeekContainsDate), i.setUTCHours(0, 0, 0, 0), Ko(i, o);
    }
  }]), n;
})(zt), k8 = /* @__PURE__ */ (function(e) {
  Ut(n, e);
  var t = qt(n);
  function n() {
    var r;
    Nt(this, n);
    for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++)
      a[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(a)), qe(ze(r), "priority", 130), qe(ze(r), "incompatibleTokens", ["G", "y", "Y", "u", "Q", "q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), r;
  }
  return Lt(n, [{
    key: "parse",
    value: function(i, a) {
      return Dh(a === "R" ? 4 : a.length, i);
    }
  }, {
    key: "set",
    value: function(i, a, s) {
      var o = /* @__PURE__ */ new Date(0);
      return o.setUTCFullYear(s, 0, 4), o.setUTCHours(0, 0, 0, 0), Ql(o);
    }
  }]), n;
})(zt), S8 = /* @__PURE__ */ (function(e) {
  Ut(n, e);
  var t = qt(n);
  function n() {
    var r;
    Nt(this, n);
    for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++)
      a[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(a)), qe(ze(r), "priority", 130), qe(ze(r), "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]), r;
  }
  return Lt(n, [{
    key: "parse",
    value: function(i, a) {
      return Dh(a === "u" ? 4 : a.length, i);
    }
  }, {
    key: "set",
    value: function(i, a, s) {
      return i.setUTCFullYear(s, 0, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), n;
})(zt), C8 = /* @__PURE__ */ (function(e) {
  Ut(n, e);
  var t = qt(n);
  function n() {
    var r;
    Nt(this, n);
    for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++)
      a[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(a)), qe(ze(r), "priority", 120), qe(ze(r), "incompatibleTokens", ["Y", "R", "q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), r;
  }
  return Lt(n, [{
    key: "parse",
    value: function(i, a, s) {
      switch (a) {
        // 1, 2, 3, 4
        case "Q":
        case "QQ":
          return $n(a.length, i);
        // 1st, 2nd, 3rd, 4th
        case "Qo":
          return s.ordinalNumber(i, {
            unit: "quarter"
          });
        // Q1, Q2, Q3, Q4
        case "QQQ":
          return s.quarter(i, {
            width: "abbreviated",
            context: "formatting"
          }) || s.quarter(i, {
            width: "narrow",
            context: "formatting"
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case "QQQQQ":
          return s.quarter(i, {
            width: "narrow",
            context: "formatting"
          });
        // 1st quarter, 2nd quarter, ...
        case "QQQQ":
        default:
          return s.quarter(i, {
            width: "wide",
            context: "formatting"
          }) || s.quarter(i, {
            width: "abbreviated",
            context: "formatting"
          }) || s.quarter(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 4;
    }
  }, {
    key: "set",
    value: function(i, a, s) {
      return i.setUTCMonth((s - 1) * 3, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), n;
})(zt), T8 = /* @__PURE__ */ (function(e) {
  Ut(n, e);
  var t = qt(n);
  function n() {
    var r;
    Nt(this, n);
    for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++)
      a[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(a)), qe(ze(r), "priority", 120), qe(ze(r), "incompatibleTokens", ["Y", "R", "Q", "M", "L", "w", "I", "d", "D", "i", "e", "c", "t", "T"]), r;
  }
  return Lt(n, [{
    key: "parse",
    value: function(i, a, s) {
      switch (a) {
        // 1, 2, 3, 4
        case "q":
        case "qq":
          return $n(a.length, i);
        // 1st, 2nd, 3rd, 4th
        case "qo":
          return s.ordinalNumber(i, {
            unit: "quarter"
          });
        // Q1, Q2, Q3, Q4
        case "qqq":
          return s.quarter(i, {
            width: "abbreviated",
            context: "standalone"
          }) || s.quarter(i, {
            width: "narrow",
            context: "standalone"
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case "qqqqq":
          return s.quarter(i, {
            width: "narrow",
            context: "standalone"
          });
        // 1st quarter, 2nd quarter, ...
        case "qqqq":
        default:
          return s.quarter(i, {
            width: "wide",
            context: "standalone"
          }) || s.quarter(i, {
            width: "abbreviated",
            context: "standalone"
          }) || s.quarter(i, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 4;
    }
  }, {
    key: "set",
    value: function(i, a, s) {
      return i.setUTCMonth((s - 1) * 3, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), n;
})(zt), A8 = /* @__PURE__ */ (function(e) {
  Ut(n, e);
  var t = qt(n);
  function n() {
    var r;
    Nt(this, n);
    for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++)
      a[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(a)), qe(ze(r), "incompatibleTokens", ["Y", "R", "q", "Q", "L", "w", "I", "D", "i", "e", "c", "t", "T"]), qe(ze(r), "priority", 110), r;
  }
  return Lt(n, [{
    key: "parse",
    value: function(i, a, s) {
      var o = function(c) {
        return c - 1;
      };
      switch (a) {
        // 1, 2, ..., 12
        case "M":
          return Wn(En(jn.month, i), o);
        // 01, 02, ..., 12
        case "MM":
          return Wn($n(2, i), o);
        // 1st, 2nd, ..., 12th
        case "Mo":
          return Wn(s.ordinalNumber(i, {
            unit: "month"
          }), o);
        // Jan, Feb, ..., Dec
        case "MMM":
          return s.month(i, {
            width: "abbreviated",
            context: "formatting"
          }) || s.month(i, {
            width: "narrow",
            context: "formatting"
          });
        // J, F, ..., D
        case "MMMMM":
          return s.month(i, {
            width: "narrow",
            context: "formatting"
          });
        // January, February, ..., December
        case "MMMM":
        default:
          return s.month(i, {
            width: "wide",
            context: "formatting"
          }) || s.month(i, {
            width: "abbreviated",
            context: "formatting"
          }) || s.month(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 11;
    }
  }, {
    key: "set",
    value: function(i, a, s) {
      return i.setUTCMonth(s, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), n;
})(zt), D8 = /* @__PURE__ */ (function(e) {
  Ut(n, e);
  var t = qt(n);
  function n() {
    var r;
    Nt(this, n);
    for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++)
      a[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(a)), qe(ze(r), "priority", 110), qe(ze(r), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "w", "I", "D", "i", "e", "c", "t", "T"]), r;
  }
  return Lt(n, [{
    key: "parse",
    value: function(i, a, s) {
      var o = function(c) {
        return c - 1;
      };
      switch (a) {
        // 1, 2, ..., 12
        case "L":
          return Wn(En(jn.month, i), o);
        // 01, 02, ..., 12
        case "LL":
          return Wn($n(2, i), o);
        // 1st, 2nd, ..., 12th
        case "Lo":
          return Wn(s.ordinalNumber(i, {
            unit: "month"
          }), o);
        // Jan, Feb, ..., Dec
        case "LLL":
          return s.month(i, {
            width: "abbreviated",
            context: "standalone"
          }) || s.month(i, {
            width: "narrow",
            context: "standalone"
          });
        // J, F, ..., D
        case "LLLLL":
          return s.month(i, {
            width: "narrow",
            context: "standalone"
          });
        // January, February, ..., December
        case "LLLL":
        default:
          return s.month(i, {
            width: "wide",
            context: "standalone"
          }) || s.month(i, {
            width: "abbreviated",
            context: "standalone"
          }) || s.month(i, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 11;
    }
  }, {
    key: "set",
    value: function(i, a, s) {
      return i.setUTCMonth(s, 1), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), n;
})(zt);
function E8(e, t, n) {
  Ye(2, arguments);
  var r = at(e), i = it(t), a = A2(r, n) - i;
  return r.setUTCDate(r.getUTCDate() - a * 7), r;
}
var P8 = /* @__PURE__ */ (function(e) {
  Ut(n, e);
  var t = qt(n);
  function n() {
    var r;
    Nt(this, n);
    for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++)
      a[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(a)), qe(ze(r), "priority", 100), qe(ze(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "i", "t", "T"]), r;
  }
  return Lt(n, [{
    key: "parse",
    value: function(i, a, s) {
      switch (a) {
        case "w":
          return En(jn.week, i);
        case "wo":
          return s.ordinalNumber(i, {
            unit: "week"
          });
        default:
          return $n(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 53;
    }
  }, {
    key: "set",
    value: function(i, a, s, o) {
      return Ko(E8(i, s, o), o);
    }
  }]), n;
})(zt);
function O8(e, t) {
  Ye(2, arguments);
  var n = at(e), r = it(t), i = T2(n) - r;
  return n.setUTCDate(n.getUTCDate() - i * 7), n;
}
var M8 = /* @__PURE__ */ (function(e) {
  Ut(n, e);
  var t = qt(n);
  function n() {
    var r;
    Nt(this, n);
    for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++)
      a[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(a)), qe(ze(r), "priority", 100), qe(ze(r), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "e", "c", "t", "T"]), r;
  }
  return Lt(n, [{
    key: "parse",
    value: function(i, a, s) {
      switch (a) {
        case "I":
          return En(jn.week, i);
        case "Io":
          return s.ordinalNumber(i, {
            unit: "week"
          });
        default:
          return $n(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 53;
    }
  }, {
    key: "set",
    value: function(i, a, s) {
      return Ql(O8(i, s));
    }
  }]), n;
})(zt), I8 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], R8 = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], F8 = /* @__PURE__ */ (function(e) {
  Ut(n, e);
  var t = qt(n);
  function n() {
    var r;
    Nt(this, n);
    for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++)
      a[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(a)), qe(ze(r), "priority", 90), qe(ze(r), "subPriority", 1), qe(ze(r), "incompatibleTokens", ["Y", "R", "q", "Q", "w", "I", "D", "i", "e", "c", "t", "T"]), r;
  }
  return Lt(n, [{
    key: "parse",
    value: function(i, a, s) {
      switch (a) {
        case "d":
          return En(jn.date, i);
        case "do":
          return s.ordinalNumber(i, {
            unit: "date"
          });
        default:
          return $n(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      var s = i.getUTCFullYear(), o = V2(s), l = i.getUTCMonth();
      return o ? a >= 1 && a <= R8[l] : a >= 1 && a <= I8[l];
    }
  }, {
    key: "set",
    value: function(i, a, s) {
      return i.setUTCDate(s), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), n;
})(zt), N8 = /* @__PURE__ */ (function(e) {
  Ut(n, e);
  var t = qt(n);
  function n() {
    var r;
    Nt(this, n);
    for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++)
      a[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(a)), qe(ze(r), "priority", 90), qe(ze(r), "subpriority", 1), qe(ze(r), "incompatibleTokens", ["Y", "R", "q", "Q", "M", "L", "w", "I", "d", "E", "i", "e", "c", "t", "T"]), r;
  }
  return Lt(n, [{
    key: "parse",
    value: function(i, a, s) {
      switch (a) {
        case "D":
        case "DD":
          return En(jn.dayOfYear, i);
        case "Do":
          return s.ordinalNumber(i, {
            unit: "date"
          });
        default:
          return $n(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      var s = i.getUTCFullYear(), o = V2(s);
      return o ? a >= 1 && a <= 366 : a >= 1 && a <= 365;
    }
  }, {
    key: "set",
    value: function(i, a, s) {
      return i.setUTCMonth(0, s), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), n;
})(zt);
function _0(e, t, n) {
  var r, i, a, s, o, l, c, f;
  Ye(2, arguments);
  var h = ro(), p = it((r = (i = (a = (s = n == null ? void 0 : n.weekStartsOn) !== null && s !== void 0 ? s : n == null || (o = n.locale) === null || o === void 0 || (l = o.options) === null || l === void 0 ? void 0 : l.weekStartsOn) !== null && a !== void 0 ? a : h.weekStartsOn) !== null && i !== void 0 ? i : (c = h.locale) === null || c === void 0 || (f = c.options) === null || f === void 0 ? void 0 : f.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(p >= 0 && p <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var g = at(e), v = it(t), y = g.getUTCDay(), S = v % 7, x = (S + 7) % 7, E = (x < p ? 7 : 0) + v - y;
  return g.setUTCDate(g.getUTCDate() + E), g;
}
var L8 = /* @__PURE__ */ (function(e) {
  Ut(n, e);
  var t = qt(n);
  function n() {
    var r;
    Nt(this, n);
    for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++)
      a[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(a)), qe(ze(r), "priority", 90), qe(ze(r), "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]), r;
  }
  return Lt(n, [{
    key: "parse",
    value: function(i, a, s) {
      switch (a) {
        // Tue
        case "E":
        case "EE":
        case "EEE":
          return s.day(i, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(i, {
            width: "short",
            context: "formatting"
          }) || s.day(i, {
            width: "narrow",
            context: "formatting"
          });
        // T
        case "EEEEE":
          return s.day(i, {
            width: "narrow",
            context: "formatting"
          });
        // Tu
        case "EEEEEE":
          return s.day(i, {
            width: "short",
            context: "formatting"
          }) || s.day(i, {
            width: "narrow",
            context: "formatting"
          });
        // Tuesday
        case "EEEE":
        default:
          return s.day(i, {
            width: "wide",
            context: "formatting"
          }) || s.day(i, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(i, {
            width: "short",
            context: "formatting"
          }) || s.day(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 6;
    }
  }, {
    key: "set",
    value: function(i, a, s, o) {
      return i = _0(i, s, o), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), n;
})(zt), $8 = /* @__PURE__ */ (function(e) {
  Ut(n, e);
  var t = qt(n);
  function n() {
    var r;
    Nt(this, n);
    for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++)
      a[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(a)), qe(ze(r), "priority", 90), qe(ze(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "c", "t", "T"]), r;
  }
  return Lt(n, [{
    key: "parse",
    value: function(i, a, s, o) {
      var l = function(f) {
        var h = Math.floor((f - 1) / 7) * 7;
        return (f + o.weekStartsOn + 6) % 7 + h;
      };
      switch (a) {
        // 3
        case "e":
        case "ee":
          return Wn($n(a.length, i), l);
        // 3rd
        case "eo":
          return Wn(s.ordinalNumber(i, {
            unit: "day"
          }), l);
        // Tue
        case "eee":
          return s.day(i, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(i, {
            width: "short",
            context: "formatting"
          }) || s.day(i, {
            width: "narrow",
            context: "formatting"
          });
        // T
        case "eeeee":
          return s.day(i, {
            width: "narrow",
            context: "formatting"
          });
        // Tu
        case "eeeeee":
          return s.day(i, {
            width: "short",
            context: "formatting"
          }) || s.day(i, {
            width: "narrow",
            context: "formatting"
          });
        // Tuesday
        case "eeee":
        default:
          return s.day(i, {
            width: "wide",
            context: "formatting"
          }) || s.day(i, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(i, {
            width: "short",
            context: "formatting"
          }) || s.day(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 6;
    }
  }, {
    key: "set",
    value: function(i, a, s, o) {
      return i = _0(i, s, o), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), n;
})(zt), V8 = /* @__PURE__ */ (function(e) {
  Ut(n, e);
  var t = qt(n);
  function n() {
    var r;
    Nt(this, n);
    for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++)
      a[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(a)), qe(ze(r), "priority", 90), qe(ze(r), "incompatibleTokens", ["y", "R", "u", "q", "Q", "M", "L", "I", "d", "D", "E", "i", "e", "t", "T"]), r;
  }
  return Lt(n, [{
    key: "parse",
    value: function(i, a, s, o) {
      var l = function(f) {
        var h = Math.floor((f - 1) / 7) * 7;
        return (f + o.weekStartsOn + 6) % 7 + h;
      };
      switch (a) {
        // 3
        case "c":
        case "cc":
          return Wn($n(a.length, i), l);
        // 3rd
        case "co":
          return Wn(s.ordinalNumber(i, {
            unit: "day"
          }), l);
        // Tue
        case "ccc":
          return s.day(i, {
            width: "abbreviated",
            context: "standalone"
          }) || s.day(i, {
            width: "short",
            context: "standalone"
          }) || s.day(i, {
            width: "narrow",
            context: "standalone"
          });
        // T
        case "ccccc":
          return s.day(i, {
            width: "narrow",
            context: "standalone"
          });
        // Tu
        case "cccccc":
          return s.day(i, {
            width: "short",
            context: "standalone"
          }) || s.day(i, {
            width: "narrow",
            context: "standalone"
          });
        // Tuesday
        case "cccc":
        default:
          return s.day(i, {
            width: "wide",
            context: "standalone"
          }) || s.day(i, {
            width: "abbreviated",
            context: "standalone"
          }) || s.day(i, {
            width: "short",
            context: "standalone"
          }) || s.day(i, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 6;
    }
  }, {
    key: "set",
    value: function(i, a, s, o) {
      return i = _0(i, s, o), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), n;
})(zt);
function B8(e, t) {
  Ye(2, arguments);
  var n = it(t);
  n % 7 === 0 && (n = n - 7);
  var r = 1, i = at(e), a = i.getUTCDay(), s = n % 7, o = (s + 7) % 7, l = (o < r ? 7 : 0) + n - a;
  return i.setUTCDate(i.getUTCDate() + l), i;
}
var U8 = /* @__PURE__ */ (function(e) {
  Ut(n, e);
  var t = qt(n);
  function n() {
    var r;
    Nt(this, n);
    for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++)
      a[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(a)), qe(ze(r), "priority", 90), qe(ze(r), "incompatibleTokens", ["y", "Y", "u", "q", "Q", "M", "L", "w", "d", "D", "E", "e", "c", "t", "T"]), r;
  }
  return Lt(n, [{
    key: "parse",
    value: function(i, a, s) {
      var o = function(c) {
        return c === 0 ? 7 : c;
      };
      switch (a) {
        // 2
        case "i":
        case "ii":
          return $n(a.length, i);
        // 2nd
        case "io":
          return s.ordinalNumber(i, {
            unit: "day"
          });
        // Tue
        case "iii":
          return Wn(s.day(i, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(i, {
            width: "short",
            context: "formatting"
          }) || s.day(i, {
            width: "narrow",
            context: "formatting"
          }), o);
        // T
        case "iiiii":
          return Wn(s.day(i, {
            width: "narrow",
            context: "formatting"
          }), o);
        // Tu
        case "iiiiii":
          return Wn(s.day(i, {
            width: "short",
            context: "formatting"
          }) || s.day(i, {
            width: "narrow",
            context: "formatting"
          }), o);
        // Tuesday
        case "iiii":
        default:
          return Wn(s.day(i, {
            width: "wide",
            context: "formatting"
          }) || s.day(i, {
            width: "abbreviated",
            context: "formatting"
          }) || s.day(i, {
            width: "short",
            context: "formatting"
          }) || s.day(i, {
            width: "narrow",
            context: "formatting"
          }), o);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 7;
    }
  }, {
    key: "set",
    value: function(i, a, s) {
      return i = B8(i, s), i.setUTCHours(0, 0, 0, 0), i;
    }
  }]), n;
})(zt), q8 = /* @__PURE__ */ (function(e) {
  Ut(n, e);
  var t = qt(n);
  function n() {
    var r;
    Nt(this, n);
    for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++)
      a[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(a)), qe(ze(r), "priority", 80), qe(ze(r), "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]), r;
  }
  return Lt(n, [{
    key: "parse",
    value: function(i, a, s) {
      switch (a) {
        case "a":
        case "aa":
        case "aaa":
          return s.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return s.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return s.dayPeriod(i, {
            width: "wide",
            context: "formatting"
          }) || s.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(i, a, s) {
      return i.setUTCHours(b0(s), 0, 0, 0), i;
    }
  }]), n;
})(zt), j8 = /* @__PURE__ */ (function(e) {
  Ut(n, e);
  var t = qt(n);
  function n() {
    var r;
    Nt(this, n);
    for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++)
      a[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(a)), qe(ze(r), "priority", 80), qe(ze(r), "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]), r;
  }
  return Lt(n, [{
    key: "parse",
    value: function(i, a, s) {
      switch (a) {
        case "b":
        case "bb":
        case "bbb":
          return s.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return s.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return s.dayPeriod(i, {
            width: "wide",
            context: "formatting"
          }) || s.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(i, a, s) {
      return i.setUTCHours(b0(s), 0, 0, 0), i;
    }
  }]), n;
})(zt), W8 = /* @__PURE__ */ (function(e) {
  Ut(n, e);
  var t = qt(n);
  function n() {
    var r;
    Nt(this, n);
    for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++)
      a[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(a)), qe(ze(r), "priority", 80), qe(ze(r), "incompatibleTokens", ["a", "b", "t", "T"]), r;
  }
  return Lt(n, [{
    key: "parse",
    value: function(i, a, s) {
      switch (a) {
        case "B":
        case "BB":
        case "BBB":
          return s.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return s.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return s.dayPeriod(i, {
            width: "wide",
            context: "formatting"
          }) || s.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }) || s.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
  }, {
    key: "set",
    value: function(i, a, s) {
      return i.setUTCHours(b0(s), 0, 0, 0), i;
    }
  }]), n;
})(zt), z8 = /* @__PURE__ */ (function(e) {
  Ut(n, e);
  var t = qt(n);
  function n() {
    var r;
    Nt(this, n);
    for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++)
      a[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(a)), qe(ze(r), "priority", 70), qe(ze(r), "incompatibleTokens", ["H", "K", "k", "t", "T"]), r;
  }
  return Lt(n, [{
    key: "parse",
    value: function(i, a, s) {
      switch (a) {
        case "h":
          return En(jn.hour12h, i);
        case "ho":
          return s.ordinalNumber(i, {
            unit: "hour"
          });
        default:
          return $n(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 12;
    }
  }, {
    key: "set",
    value: function(i, a, s) {
      var o = i.getUTCHours() >= 12;
      return o && s < 12 ? i.setUTCHours(s + 12, 0, 0, 0) : !o && s === 12 ? i.setUTCHours(0, 0, 0, 0) : i.setUTCHours(s, 0, 0, 0), i;
    }
  }]), n;
})(zt), H8 = /* @__PURE__ */ (function(e) {
  Ut(n, e);
  var t = qt(n);
  function n() {
    var r;
    Nt(this, n);
    for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++)
      a[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(a)), qe(ze(r), "priority", 70), qe(ze(r), "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]), r;
  }
  return Lt(n, [{
    key: "parse",
    value: function(i, a, s) {
      switch (a) {
        case "H":
          return En(jn.hour23h, i);
        case "Ho":
          return s.ordinalNumber(i, {
            unit: "hour"
          });
        default:
          return $n(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 23;
    }
  }, {
    key: "set",
    value: function(i, a, s) {
      return i.setUTCHours(s, 0, 0, 0), i;
    }
  }]), n;
})(zt), G8 = /* @__PURE__ */ (function(e) {
  Ut(n, e);
  var t = qt(n);
  function n() {
    var r;
    Nt(this, n);
    for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++)
      a[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(a)), qe(ze(r), "priority", 70), qe(ze(r), "incompatibleTokens", ["h", "H", "k", "t", "T"]), r;
  }
  return Lt(n, [{
    key: "parse",
    value: function(i, a, s) {
      switch (a) {
        case "K":
          return En(jn.hour11h, i);
        case "Ko":
          return s.ordinalNumber(i, {
            unit: "hour"
          });
        default:
          return $n(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 11;
    }
  }, {
    key: "set",
    value: function(i, a, s) {
      var o = i.getUTCHours() >= 12;
      return o && s < 12 ? i.setUTCHours(s + 12, 0, 0, 0) : i.setUTCHours(s, 0, 0, 0), i;
    }
  }]), n;
})(zt), Y8 = /* @__PURE__ */ (function(e) {
  Ut(n, e);
  var t = qt(n);
  function n() {
    var r;
    Nt(this, n);
    for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++)
      a[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(a)), qe(ze(r), "priority", 70), qe(ze(r), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), r;
  }
  return Lt(n, [{
    key: "parse",
    value: function(i, a, s) {
      switch (a) {
        case "k":
          return En(jn.hour24h, i);
        case "ko":
          return s.ordinalNumber(i, {
            unit: "hour"
          });
        default:
          return $n(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 1 && a <= 24;
    }
  }, {
    key: "set",
    value: function(i, a, s) {
      var o = s <= 24 ? s % 24 : s;
      return i.setUTCHours(o, 0, 0, 0), i;
    }
  }]), n;
})(zt), K8 = /* @__PURE__ */ (function(e) {
  Ut(n, e);
  var t = qt(n);
  function n() {
    var r;
    Nt(this, n);
    for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++)
      a[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(a)), qe(ze(r), "priority", 60), qe(ze(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return Lt(n, [{
    key: "parse",
    value: function(i, a, s) {
      switch (a) {
        case "m":
          return En(jn.minute, i);
        case "mo":
          return s.ordinalNumber(i, {
            unit: "minute"
          });
        default:
          return $n(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 59;
    }
  }, {
    key: "set",
    value: function(i, a, s) {
      return i.setUTCMinutes(s, 0, 0), i;
    }
  }]), n;
})(zt), X8 = /* @__PURE__ */ (function(e) {
  Ut(n, e);
  var t = qt(n);
  function n() {
    var r;
    Nt(this, n);
    for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++)
      a[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(a)), qe(ze(r), "priority", 50), qe(ze(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return Lt(n, [{
    key: "parse",
    value: function(i, a, s) {
      switch (a) {
        case "s":
          return En(jn.second, i);
        case "so":
          return s.ordinalNumber(i, {
            unit: "second"
          });
        default:
          return $n(a.length, i);
      }
    }
  }, {
    key: "validate",
    value: function(i, a) {
      return a >= 0 && a <= 59;
    }
  }, {
    key: "set",
    value: function(i, a, s) {
      return i.setUTCSeconds(s, 0), i;
    }
  }]), n;
})(zt), Z8 = /* @__PURE__ */ (function(e) {
  Ut(n, e);
  var t = qt(n);
  function n() {
    var r;
    Nt(this, n);
    for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++)
      a[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(a)), qe(ze(r), "priority", 30), qe(ze(r), "incompatibleTokens", ["t", "T"]), r;
  }
  return Lt(n, [{
    key: "parse",
    value: function(i, a) {
      var s = function(l) {
        return Math.floor(l * Math.pow(10, -a.length + 3));
      };
      return Wn($n(a.length, i), s);
    }
  }, {
    key: "set",
    value: function(i, a, s) {
      return i.setUTCMilliseconds(s), i;
    }
  }]), n;
})(zt), Q8 = /* @__PURE__ */ (function(e) {
  Ut(n, e);
  var t = qt(n);
  function n() {
    var r;
    Nt(this, n);
    for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++)
      a[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(a)), qe(ze(r), "priority", 10), qe(ze(r), "incompatibleTokens", ["t", "T", "x"]), r;
  }
  return Lt(n, [{
    key: "parse",
    value: function(i, a) {
      switch (a) {
        case "X":
          return ka(wa.basicOptionalMinutes, i);
        case "XX":
          return ka(wa.basic, i);
        case "XXXX":
          return ka(wa.basicOptionalSeconds, i);
        case "XXXXX":
          return ka(wa.extendedOptionalSeconds, i);
        case "XXX":
        default:
          return ka(wa.extended, i);
      }
    }
  }, {
    key: "set",
    value: function(i, a, s) {
      return a.timestampIsSet ? i : new Date(i.getTime() - s);
    }
  }]), n;
})(zt), J8 = /* @__PURE__ */ (function(e) {
  Ut(n, e);
  var t = qt(n);
  function n() {
    var r;
    Nt(this, n);
    for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++)
      a[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(a)), qe(ze(r), "priority", 10), qe(ze(r), "incompatibleTokens", ["t", "T", "X"]), r;
  }
  return Lt(n, [{
    key: "parse",
    value: function(i, a) {
      switch (a) {
        case "x":
          return ka(wa.basicOptionalMinutes, i);
        case "xx":
          return ka(wa.basic, i);
        case "xxxx":
          return ka(wa.basicOptionalSeconds, i);
        case "xxxxx":
          return ka(wa.extendedOptionalSeconds, i);
        case "xxx":
        default:
          return ka(wa.extended, i);
      }
    }
  }, {
    key: "set",
    value: function(i, a, s) {
      return a.timestampIsSet ? i : new Date(i.getTime() - s);
    }
  }]), n;
})(zt), ej = /* @__PURE__ */ (function(e) {
  Ut(n, e);
  var t = qt(n);
  function n() {
    var r;
    Nt(this, n);
    for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++)
      a[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(a)), qe(ze(r), "priority", 40), qe(ze(r), "incompatibleTokens", "*"), r;
  }
  return Lt(n, [{
    key: "parse",
    value: function(i) {
      return L2(i);
    }
  }, {
    key: "set",
    value: function(i, a, s) {
      return [new Date(s * 1e3), {
        timestampIsSet: !0
      }];
    }
  }]), n;
})(zt), tj = /* @__PURE__ */ (function(e) {
  Ut(n, e);
  var t = qt(n);
  function n() {
    var r;
    Nt(this, n);
    for (var i = arguments.length, a = new Array(i), s = 0; s < i; s++)
      a[s] = arguments[s];
    return r = t.call.apply(t, [this].concat(a)), qe(ze(r), "priority", 20), qe(ze(r), "incompatibleTokens", "*"), r;
  }
  return Lt(n, [{
    key: "parse",
    value: function(i) {
      return L2(i);
    }
  }, {
    key: "set",
    value: function(i, a, s) {
      return [new Date(s), {
        timestampIsSet: !0
      }];
    }
  }]), n;
})(zt), nj = {
  G: new y8(),
  y: new x8(),
  Y: new w8(),
  R: new k8(),
  u: new S8(),
  Q: new C8(),
  q: new T8(),
  M: new A8(),
  L: new D8(),
  w: new P8(),
  I: new M8(),
  d: new F8(),
  D: new N8(),
  E: new L8(),
  e: new $8(),
  c: new V8(),
  i: new U8(),
  a: new q8(),
  b: new j8(),
  B: new W8(),
  h: new z8(),
  H: new H8(),
  K: new G8(),
  k: new Y8(),
  m: new K8(),
  s: new X8(),
  S: new Z8(),
  X: new Q8(),
  x: new J8(),
  t: new ej(),
  T: new tj()
}, rj = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, ij = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, aj = /^'([^]*?)'?$/, sj = /''/g, oj = /\S/, lj = /[a-zA-Z]/;
function cy(e, t, n, r) {
  var i, a, s, o, l, c, f, h, p, g, v, y, S, x;
  Ye(3, arguments);
  var E = String(e), w = String(t), C = ro(), P = (i = (a = void 0) !== null && a !== void 0 ? a : C.locale) !== null && i !== void 0 ? i : M2;
  if (!P.match)
    throw new RangeError("locale must contain match property");
  var M = it((s = (o = (l = (c = void 0) !== null && c !== void 0 ? c : void 0) !== null && l !== void 0 ? l : C.firstWeekContainsDate) !== null && o !== void 0 ? o : (f = C.locale) === null || f === void 0 || (h = f.options) === null || h === void 0 ? void 0 : h.firstWeekContainsDate) !== null && s !== void 0 ? s : 1);
  if (!(M >= 1 && M <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var T = it((p = (g = (v = (y = void 0) !== null && y !== void 0 ? y : void 0) !== null && v !== void 0 ? v : C.weekStartsOn) !== null && g !== void 0 ? g : (S = C.locale) === null || S === void 0 || (x = S.options) === null || x === void 0 ? void 0 : x.weekStartsOn) !== null && p !== void 0 ? p : 0);
  if (!(T >= 0 && T <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (w === "")
    return E === "" ? at(n) : /* @__PURE__ */ new Date(NaN);
  var N = {
    firstWeekContainsDate: M,
    weekStartsOn: T,
    locale: P
  }, $ = [new _8()], ne = w.match(ij).map(function(Z) {
    var G = Z[0];
    if (G in ly) {
      var se = ly[G];
      return se(Z, P.formatLong);
    }
    return Z;
  }).join("").match(rj), Y = [], te = Bk(ne), _e;
  try {
    var Fe = function() {
      var G = _e.value;
      !(r != null && r.useAdditionalWeekYearTokens) && P2(G) && Th(G, w, e), !(r != null && r.useAdditionalDayOfYearTokens) && E2(G) && Th(G, w, e);
      var se = G[0], St = nj[se];
      if (St) {
        var Sn = St.incompatibleTokens;
        if (Array.isArray(Sn)) {
          var Vt = Y.find(function(rr) {
            return Sn.includes(rr.token) || rr.token === se;
          });
          if (Vt)
            throw new RangeError("The format string mustn't contain `".concat(Vt.fullToken, "` and `").concat(G, "` at the same time"));
        } else if (St.incompatibleTokens === "*" && Y.length > 0)
          throw new RangeError("The format string mustn't contain `".concat(G, "` and any other token at the same time"));
        Y.push({
          token: se,
          fullToken: G
        });
        var nn = St.run(E, G, P.match, N);
        if (!nn)
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
        $.push(nn.setter), E = nn.rest;
      } else {
        if (se.match(lj))
          throw new RangeError("Format string contains an unescaped latin alphabet character `" + se + "`");
        if (G === "''" ? G = "'" : se === "'" && (G = uj(G)), E.indexOf(G) === 0)
          E = E.slice(G.length);
        else
          return {
            v: /* @__PURE__ */ new Date(NaN)
          };
      }
    };
    for (te.s(); !(_e = te.n()).done; ) {
      var J = Fe();
      if (Gi(J) === "object") return J.v;
    }
  } catch (Z) {
    te.e(Z);
  } finally {
    te.f();
  }
  if (E.length > 0 && oj.test(E))
    return /* @__PURE__ */ new Date(NaN);
  var oe = $.map(function(Z) {
    return Z.priority;
  }).sort(function(Z, G) {
    return G - Z;
  }).filter(function(Z, G, se) {
    return se.indexOf(Z) === G;
  }).map(function(Z) {
    return $.filter(function(G) {
      return G.priority === Z;
    }).sort(function(G, se) {
      return se.subPriority - G.subPriority;
    });
  }).map(function(Z) {
    return Z[0];
  }), A = at(n);
  if (isNaN(A.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var X = S2(A, Ch(A)), pe = {}, le = Bk(oe), ue;
  try {
    for (le.s(); !(ue = le.n()).done; ) {
      var Te = ue.value;
      if (!Te.validate(X, N))
        return /* @__PURE__ */ new Date(NaN);
      var Ne = Te.set(X, pe, N);
      Array.isArray(Ne) ? (X = Ne[0], l8(pe, Ne[1])) : X = Ne;
    }
  } catch (Z) {
    le.e(Z);
  } finally {
    le.f();
  }
  return X;
}
function uj(e) {
  return e.match(aj)[1].replace(sj, "'");
}
function eu(e, t) {
  Ye(2, arguments);
  var n = it(t);
  return os(e, -n);
}
function cj(e, t) {
  var n;
  Ye(1, arguments);
  var r = it((n = void 0) !== null && n !== void 0 ? n : 2);
  if (r !== 2 && r !== 1 && r !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var i = pj(e), a;
  if (i.date) {
    var s = mj(i.date, r);
    a = gj(s.restDateString, s.year);
  }
  if (!a || isNaN(a.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  var o = a.getTime(), l = 0, c;
  if (i.time && (l = vj(i.time), isNaN(l)))
    return /* @__PURE__ */ new Date(NaN);
  if (i.timezone) {
    if (c = bj(i.timezone), isNaN(c))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    var f = new Date(o + l), h = /* @__PURE__ */ new Date(0);
    return h.setFullYear(f.getUTCFullYear(), f.getUTCMonth(), f.getUTCDate()), h.setHours(f.getUTCHours(), f.getUTCMinutes(), f.getUTCSeconds(), f.getUTCMilliseconds()), h;
  }
  return new Date(o + l + c);
}
var Of = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, dj = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, fj = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, hj = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function pj(e) {
  var t = {}, n = e.split(Of.dateTimeDelimiter), r;
  if (n.length > 2)
    return t;
  if (/:/.test(n[0]) ? r = n[0] : (t.date = n[0], r = n[1], Of.timeZoneDelimiter.test(t.date) && (t.date = e.split(Of.timeZoneDelimiter)[0], r = e.substr(t.date.length, e.length))), r) {
    var i = Of.timezone.exec(r);
    i ? (t.time = r.replace(i[1], ""), t.timezone = i[1]) : t.time = r;
  }
  return t;
}
function mj(e, t) {
  var n = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + t) + "})|(\\d{2}|[+-]\\d{" + (2 + t) + "})$)"), r = e.match(n);
  if (!r) return {
    year: NaN,
    restDateString: ""
  };
  var i = r[1] ? parseInt(r[1]) : null, a = r[2] ? parseInt(r[2]) : null;
  return {
    year: a === null ? i : a * 100,
    restDateString: e.slice((r[1] || r[2]).length)
  };
}
function gj(e, t) {
  if (t === null) return /* @__PURE__ */ new Date(NaN);
  var n = e.match(dj);
  if (!n) return /* @__PURE__ */ new Date(NaN);
  var r = !!n[4], i = Xu(n[1]), a = Xu(n[2]) - 1, s = Xu(n[3]), o = Xu(n[4]), l = Xu(n[5]) - 1;
  if (r)
    return kj(t, o, l) ? _j(t, o, l) : /* @__PURE__ */ new Date(NaN);
  var c = /* @__PURE__ */ new Date(0);
  return !xj(t, a, s) || !wj(t, i) ? /* @__PURE__ */ new Date(NaN) : (c.setUTCFullYear(t, a, Math.max(i, s)), c);
}
function Xu(e) {
  return e ? parseInt(e) : 1;
}
function vj(e) {
  var t = e.match(fj);
  if (!t) return NaN;
  var n = wg(t[1]), r = wg(t[2]), i = wg(t[3]);
  return Sj(n, r, i) ? n * f0 + r * d0 + i * 1e3 : NaN;
}
function wg(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function bj(e) {
  if (e === "Z") return 0;
  var t = e.match(hj);
  if (!t) return 0;
  var n = t[1] === "+" ? -1 : 1, r = parseInt(t[2]), i = t[3] && parseInt(t[3]) || 0;
  return Cj(r, i) ? n * (r * f0 + i * d0) : NaN;
}
function _j(e, t, n) {
  var r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(e, 0, 4);
  var i = r.getUTCDay() || 7, a = (t - 1) * 7 + n + 1 - i;
  return r.setUTCDate(r.getUTCDate() + a), r;
}
var yj = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function B2(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function xj(e, t, n) {
  return t >= 0 && t <= 11 && n >= 1 && n <= (yj[t] || (B2(e) ? 29 : 28));
}
function wj(e, t) {
  return t >= 1 && t <= (B2(e) ? 366 : 365);
}
function kj(e, t, n) {
  return t >= 1 && t <= 53 && n >= 0 && n <= 6;
}
function Sj(e, t, n) {
  return e === 24 ? t === 0 && n === 0 : n >= 0 && n < 60 && t >= 0 && t < 60 && e >= 0 && e < 25;
}
function Cj(e, t) {
  return t >= 0 && t <= 59;
}
function Cc(e, t) {
  Ye(2, arguments);
  var n = at(e), r = it(t), i = n.getFullYear(), a = n.getDate(), s = /* @__PURE__ */ new Date(0);
  s.setFullYear(i, r, 15), s.setHours(0, 0, 0, 0);
  var o = c8(s);
  return n.setMonth(r, Math.min(a, o)), n;
}
function Hr(e, t) {
  if (Ye(2, arguments), Gi(t) !== "object" || t === null)
    throw new RangeError("values parameter must be an object");
  var n = at(e);
  return isNaN(n.getTime()) ? /* @__PURE__ */ new Date(NaN) : (t.year != null && n.setFullYear(t.year), t.month != null && (n = Cc(n, t.month)), t.date != null && n.setDate(it(t.date)), t.hours != null && n.setHours(it(t.hours)), t.minutes != null && n.setMinutes(it(t.minutes)), t.seconds != null && n.setSeconds(it(t.seconds)), t.milliseconds != null && n.setMilliseconds(it(t.milliseconds)), n);
}
function U2(e, t) {
  Ye(2, arguments);
  var n = at(e), r = it(t);
  return n.setHours(r), n;
}
function y0(e, t) {
  Ye(2, arguments);
  var n = at(e), r = it(t);
  return n.setMilliseconds(r), n;
}
function q2(e, t) {
  Ye(2, arguments);
  var n = at(e), r = it(t);
  return n.setMinutes(r), n;
}
function j2(e, t) {
  Ye(2, arguments);
  var n = at(e), r = it(t);
  return n.setSeconds(r), n;
}
function qo(e, t) {
  Ye(2, arguments);
  var n = at(e), r = it(t);
  return isNaN(n.getTime()) ? /* @__PURE__ */ new Date(NaN) : (n.setFullYear(r), n);
}
function Xr(e, t) {
  Ye(2, arguments);
  var n = it(t);
  return Sa(e, -n);
}
function Tj(e, t) {
  if (Ye(2, arguments), !t || Gi(t) !== "object") return /* @__PURE__ */ new Date(NaN);
  var n = t.years ? it(t.years) : 0, r = t.months ? it(t.months) : 0, i = t.weeks ? it(t.weeks) : 0, a = t.days ? it(t.days) : 0, s = t.hours ? it(t.hours) : 0, o = t.minutes ? it(t.minutes) : 0, l = t.seconds ? it(t.seconds) : 0, c = Xr(e, r + n * 12), f = eu(c, a + i * 7), h = o + s * 60, p = l + h * 60, g = p * 1e3, v = new Date(f.getTime() - g);
  return v;
}
function tu(e, t) {
  Ye(2, arguments);
  var n = it(t);
  return h4(e, -n);
}
function Aj(e, t) {
  Ye(2, arguments);
  var n = it(t);
  return x2(e, -n);
}
function On(e, t) {
  return e.getFullYear() === t.getFullYear() && e.getMonth() === t.getMonth() && e.getDate() === t.getDate();
}
function Dj(e, t) {
  const n = /* @__PURE__ */ new Date();
  return On(e, n) && On(t, n);
}
function Ej() {
  return [/* @__PURE__ */ new Date(), /* @__PURE__ */ new Date()];
}
function Pj(e, t) {
  const n = eu(/* @__PURE__ */ new Date(), 1);
  return On(e, n) && On(t, n);
}
function Oj() {
  return [eu(/* @__PURE__ */ new Date(), 1), eu(/* @__PURE__ */ new Date(), 1)];
}
function W2(e, t) {
  const n = /* @__PURE__ */ new Date();
  return On(e, Jc(n)) && On(t, n);
}
function Mj(e, t) {
  const n = /* @__PURE__ */ new Date(), r = Jc(Xr(n, 1)), i = h0(Xr(n, 1));
  return On(e, r) && On(t, i);
}
function z2(e, t) {
  const n = /* @__PURE__ */ new Date();
  return On(e, Yo(n, { weekStartsOn: 1 })) && On(t, n);
}
function Ij(e, t) {
  const n = /* @__PURE__ */ new Date(), r = tu(Yo(n, { weekStartsOn: 1 }), 1), i = tu(p0(n, { weekStartsOn: 1 }), 1);
  return On(e, r) && On(t, i);
}
function H2() {
  const e = /* @__PURE__ */ new Date();
  return [Jc(e), e];
}
function Rj() {
  return [
    Jc(Xr(/* @__PURE__ */ new Date(), 1)),
    h0(Xr(/* @__PURE__ */ new Date(), 1))
  ];
}
function G2() {
  return [Yo(/* @__PURE__ */ new Date(), { weekStartsOn: 1 }), /* @__PURE__ */ new Date()];
}
function Fj() {
  return [
    tu(Yo(/* @__PURE__ */ new Date(), { weekStartsOn: 1 }), 1),
    tu(p0(/* @__PURE__ */ new Date(), { weekStartsOn: 1 }), 1)
  ];
}
function Nj(e, t) {
  const n = /* @__PURE__ */ new Date();
  return On(e, eu(n, 6)) && On(t, n);
}
function Lj() {
  return [eu(/* @__PURE__ */ new Date(), 6), /* @__PURE__ */ new Date()];
}
function $j(e, t) {
  const n = /* @__PURE__ */ new Date();
  return On(e, tu(n, 4)) && On(t, n);
}
function Vj() {
  return [tu(/* @__PURE__ */ new Date(), 4), /* @__PURE__ */ new Date()];
}
function Bj(e, t) {
  const n = /* @__PURE__ */ new Date();
  return On(e, Xr(n, 3)) && On(t, n);
}
function Uj() {
  return [Xr(/* @__PURE__ */ new Date(), 3), /* @__PURE__ */ new Date()];
}
function qj(e, t) {
  const n = /* @__PURE__ */ new Date();
  return On(e, Xr(n, 12)) && On(t, n);
}
function jj() {
  return [Xr(/* @__PURE__ */ new Date(), 12), /* @__PURE__ */ new Date()];
}
function Wj(e, t) {
  const n = /* @__PURE__ */ new Date();
  return On(e, k2(n)) && On(t, n);
}
function zj() {
  return [k2(/* @__PURE__ */ new Date()), /* @__PURE__ */ new Date()];
}
function Bc(e) {
  return ua(e, "yyyy-MM-dd");
}
function Hj(e) {
  const [t, n, r] = e.split("/");
  return new Date(r, n - 1, t);
}
function Xye(e) {
  if (!e) return !1;
  const t = e.replace(/"/g, ""), n = Hj(t);
  return isNaN(n.getTime()) ? !1 : On(n, /* @__PURE__ */ new Date());
}
function Zye(e) {
  if (!e) return !1;
  const [t, n, r] = e.replace(/"/g, "").split("/"), i = Date.UTC(r, n - 1, t);
  if (isNaN(i)) return !1;
  const a = /* @__PURE__ */ new Date(), o = (Date.UTC(a.getFullYear(), a.getMonth(), a.getDate()) - i) / (1e3 * 60 * 60 * 24);
  return o >= 0 && o < 30;
}
function Qye(e) {
  if (!e) return null;
  const [t, n] = e.split(" "), [r, i, a] = t.split("-").map(Number);
  if (!isFinite(r) || !isFinite(i) || !isFinite(a)) return null;
  if (n) {
    const [s, o, l] = n.split(":").map(Number);
    return !isFinite(s) || !isFinite(o) || !isFinite(l) ? null : new Date(a, i - 1, r, s, o, l);
  }
  return new Date(a, i - 1, r);
}
function Jye(e) {
  if (e instanceof Date) {
    if (isNaN(e.getTime())) return !1;
    const o = /* @__PURE__ */ new Date(), l = new Date(
      o.getFullYear() - 18,
      o.getMonth(),
      o.getDate()
    );
    return e <= l;
  }
  const [t, n, r] = String(e).split("-").map(Number);
  if (!t || !n || !r) return !1;
  const i = new Date(t, n - 1, r);
  if (isNaN(i.getTime())) return !1;
  const a = /* @__PURE__ */ new Date(), s = new Date(
    a.getFullYear() - 18,
    a.getMonth(),
    a.getDate()
  );
  return i <= s;
}
function Y2(e) {
  if (e && e.includes("/")) {
    const [t, n, r] = e.split("/");
    return `${r}-${n.padStart(2, "0")}-${t.padStart(2, "0")}`;
  }
  return e && e.includes("-") ? e.split("T")[0] : e;
}
function Uk(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "",
    resource: {
      fr: {
        default_label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Date de naissance" } },
        placeholder: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "JJ/MM/AAAA" } },
        incomplete_date: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez saisir une date complète" } },
        invalid_date: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Cette date est invalide" } },
        min_age_error: { t: 0, b: { t: 2, i: [{ t: 3, v: "Vous devez avoir au moins " }, { t: 4, k: "minAge" }, { t: 3, v: " ans" }] } },
        max_age_error: { t: 0, b: { t: 2, i: [{ t: 3, v: "L'âge ne peut pas dépasser " }, { t: 4, k: "maxAge" }, { t: 3, v: " ans" }] } }
      },
      en: {
        default_label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Date of birth" } },
        placeholder: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "DD/MM/YYYY" } },
        incomplete_date: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please enter a complete date" } },
        invalid_date: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "This date is invalid" } },
        min_age_error: { t: 0, b: { t: 2, i: [{ t: 3, v: "You must be at least " }, { t: 4, k: "minAge" }, { t: 3, v: " years old" }] } },
        max_age_error: { t: 0, b: { t: 2, i: [{ t: 3, v: "Age cannot exceed " }, { t: 4, k: "maxAge" }, { t: 3, v: " years" }] } }
      }
    }
  });
}
const we = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, i] of t)
    n[r] = i;
  return n;
}, K2 = {
  name: "BirthDateInput",
  setup() {
    const { t: e } = nr();
    return { t: e };
  },
  props: {
    id: { type: String, default: "birthDate" },
    name: { type: String, default: "birthDate" },
    label: { type: String, default: null },
    required: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    modelValue: { type: String, default: "" },
    minAge: { type: Number, default: null },
    maxAge: { type: Number, default: null }
  },
  emits: ["update:modelValue", "update:valid"],
  data() {
    return {
      displayValue: "",
      error: "",
      touched: !1,
      lastEmittedValue: ""
    };
  },
  computed: {
    displayLabel() {
      return this.label || this.t("default_label");
    }
  },
  created() {
    this.validate();
  },
  watch: {
    modelValue: {
      handler(e) {
        if (e === this.lastEmittedValue) {
          this.lastEmittedValue = "";
          return;
        }
        const t = this.isoToDisplay(e);
        t !== this.displayValue && (this.displayValue = t), this.validate();
      },
      immediate: !0
    },
    minAge() {
      this.validate();
    },
    maxAge() {
      this.validate();
    }
  },
  methods: {
    isoToDisplay(e) {
      if (!e) return "";
      const t = e.match(/^(\d{4})-(\d{2})-(\d{2})/);
      return t ? `${t[3]}/${t[2]}/${t[1]}` : "";
    },
    formatDigits(e) {
      let t = "";
      for (let n = 0; n < e.length && n < 8; n++)
        (n === 2 || n === 4) && (t += "/"), t += e[n];
      return t;
    },
    validate(e = this.displayValue) {
      let t = "";
      if (!e)
        this.required && (t = this.t("incomplete_date"));
      else if (e.length < 10)
        t = this.t("incomplete_date");
      else {
        const [n, r, i] = e.split("/"), a = parseInt(n, 10), s = parseInt(r, 10), o = parseInt(i, 10);
        if (s < 1 || s > 12 || a < 1 || a > 31)
          t = this.t("invalid_date");
        else {
          const l = new Date(o, s - 1, a);
          if (l.getFullYear() !== o || l.getMonth() !== s - 1 || l.getDate() !== a)
            t = this.t("invalid_date");
          else {
            const c = /* @__PURE__ */ new Date();
            if (this.maxAge != null) {
              const f = new Date(
                c.getFullYear() - this.maxAge,
                c.getMonth(),
                c.getDate()
              );
              l < f && (t = this.t("max_age_error", { maxAge: this.maxAge }));
            }
            if (!t && this.minAge != null) {
              const f = new Date(
                c.getFullYear() - this.minAge,
                c.getMonth(),
                c.getDate()
              );
              l > f && (t = this.t("min_age_error", { minAge: this.minAge }));
            }
          }
        }
      }
      this.touched && (this.error = t), this.$emit("update:valid", !t);
    },
    onInput(e) {
      const t = e.target, n = t.selectionStart, r = t.value.slice(0, n).replace(/\D/g, "").length, i = t.value.replace(/\D/g, "").slice(0, 8), a = this.formatDigits(i);
      this.displayValue = a, t.value = a;
      let s = 0, o = 0;
      for (let l = 0; l < a.length; l++)
        if (a[l] !== "/" && o++, o === r) {
          s = l + 1;
          break;
        }
      o < r && (s = a.length), t.setSelectionRange(s, s), a.length === 10 ? this.lastEmittedValue = Y2(a) : this.lastEmittedValue = "", this.$emit("update:modelValue", this.lastEmittedValue), this.validate(a);
    },
    onBlur() {
      this.touched = !0, this.validate();
    }
  }
}, Gj = ["for"], Yj = {
  key: 0,
  class: "text-red-600"
}, Kj = ["id", "name", "value", "placeholder", "disabled", "aria-invalid", "aria-describedby"], Xj = ["id"];
function Zj(e, t, n, r, i, a) {
  return _(), O("div", null, [
    k("label", {
      for: n.id,
      class: "block text-sm leading-6 text-gray-900 sm:pt-1.5 mb-1 font-semibold"
    }, [
      Me(j(a.displayLabel) + " ", 1),
      n.required ? (_(), O("span", Yj, "*")) : L("", !0)
    ], 8, Gj),
    k("input", {
      id: n.id,
      name: n.name,
      type: "text",
      inputmode: "numeric",
      autocomplete: "bday",
      value: i.displayValue,
      placeholder: r.t("placeholder"),
      disabled: n.disabled,
      maxlength: "10",
      "aria-invalid": !!i.error,
      "aria-describedby": i.error ? `${n.id}-error` : void 0,
      class: Pe(["block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6", { "bg-gray-200": n.disabled }]),
      onInput: t[0] || (t[0] = (...s) => a.onInput && a.onInput(...s)),
      onBlur: t[1] || (t[1] = (...s) => a.onBlur && a.onBlur(...s))
    }, null, 42, Kj),
    i.error ? (_(), O("p", {
      key: 0,
      id: `${n.id}-error`,
      class: "mt-1 text-sm text-red-600"
    }, j(i.error), 9, Xj)) : L("", !0)
  ]);
}
typeof Uk == "function" && Uk(K2);
const Qj = /* @__PURE__ */ we(K2, [["render", Zj]]), Jj = {
  components: {
    Field: cu
  },
  props: {
    id: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      required: !0
    },
    labelClass: {
      type: String,
      default: "font-semibold"
    },
    name: {
      type: String,
      required: !0
    },
    uncheckedValue: {
      type: [String, Number, Boolean],
      default: !1
    },
    checkedValue: {
      type: [String, Number, Boolean],
      default: !0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    modelValue: {
      required: !0
    },
    fieldClass: {
      type: String,
      default: "block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
    }
  },
  emits: ["update:modelValue"],
  computed: {
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    }
  }
}, eW = { class: "flex items-start sm:pt-1.5" }, tW = ["for"], nW = {
  key: 0,
  class: "text-red-600"
};
function rW(e, t, n, r, i, a) {
  const s = U("Field");
  return _(), O("div", eW, [
    W(s, {
      class: Pe([
        "cursor-pointer mt-0.5 h-4 w-4 border-gray-500 rounded-sm text-primary-dark focus:ring-primary",
        n.disabled ? "bg-gray-200" : ""
      ]),
      id: n.id,
      name: n.name,
      type: "checkbox",
      disabled: n.disabled,
      "aria-required": n.required ? "true" : void 0,
      value: n.checkedValue,
      "unchecked-value": n.uncheckedValue,
      modelValue: a.internalValue,
      "onUpdate:modelValue": t[0] || (t[0] = (o) => a.internalValue = o)
    }, null, 8, ["class", "id", "name", "disabled", "aria-required", "value", "unchecked-value", "modelValue"]),
    k("label", {
      for: n.id,
      class: Pe(`ml-3 text-sm ${n.labelClass}`)
    }, [
      Me(j(e.$t(n.label)), 1),
      n.required ? (_(), O("span", nW, " *")) : L("", !0)
    ], 10, tW)
  ]);
}
const fs = /* @__PURE__ */ we(Jj, [["render", rW]]), iW = {
  props: {
    name: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      required: !0
    },
    placeholder: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      required: !0
    },
    modelValue: {
      type: [String, null],
      required: !0
    },
    required: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      searchKeyword: "",
      debounce: null
    };
  },
  computed: {
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    }
  },
  watch: {
    options(e) {
      e.length === 1 && (this.internalValue = e[0].label);
    }
  }
}, aW = ["for"], sW = {
  key: 0,
  class: "text-red-600"
}, oW = ["list", "id", "name"], lW = ["id"], uW = ["value"];
function cW(e, t, n, r, i, a) {
  return _(), O("div", null, [
    k("label", {
      for: n.name,
      class: "block text-sm font-semibold leading-6 text-gray-900 sm:pt-1.5 mb-2"
    }, [
      Me(j(n.label) + " ", 1),
      n.required ? (_(), O("span", sW, "*")) : L("", !0)
    ], 8, aW),
    ur(k("input", {
      list: `${n.name}-list`,
      id: n.name,
      name: n.name,
      "onUpdate:modelValue": t[0] || (t[0] = (s) => a.internalValue = s),
      class: "block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6 pl-3"
    }, null, 8, oW), [
      [tl, a.internalValue]
    ]),
    k("datalist", {
      id: `${n.name}-list`
    }, [
      (_(!0), O(Re, null, Ke(n.options, (s) => (_(), O("option", {
        key: s.value,
        value: s.label
      }, j(s.label), 9, uW))), 128))
    ], 8, lW)
  ]);
}
const e0e = /* @__PURE__ */ we(iW, [["render", cW]]), rl = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, i] of t)
    n[r] = i;
  return n;
}, dW = {}, fW = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  class: "dp__icon"
}, hW = /* @__PURE__ */ k("path", { d: "M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z" }, null, -1), pW = /* @__PURE__ */ k("path", { d: "M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z" }, null, -1), mW = /* @__PURE__ */ k("path", { d: "M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z" }, null, -1), gW = /* @__PURE__ */ k("path", { d: "M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z" }, null, -1), vW = [
  hW,
  pW,
  mW,
  gW
];
function bW(e, t) {
  return _(), O("svg", fW, vW);
}
const dp = /* @__PURE__ */ rl(dW, [["render", bW]]), _W = {}, yW = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  class: "dp__icon"
}, xW = /* @__PURE__ */ k("path", { d: "M23.057 7.057l-16 16c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l16-16c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0z" }, null, -1), wW = /* @__PURE__ */ k("path", { d: "M7.057 8.943l16 16c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885l-16-16c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z" }, null, -1), kW = [
  xW,
  wW
];
function SW(e, t) {
  return _(), O("svg", yW, kW);
}
const CW = /* @__PURE__ */ rl(_W, [["render", SW]]), TW = {}, AW = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  class: "dp__icon"
}, DW = /* @__PURE__ */ k("path", { d: "M20.943 23.057l-7.057-7.057c0 0 7.057-7.057 7.057-7.057 0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-8 8c-0.521 0.521-0.521 1.365 0 1.885l8 8c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z" }, null, -1), EW = [
  DW
];
function PW(e, t) {
  return _(), O("svg", AW, EW);
}
const qk = /* @__PURE__ */ rl(TW, [["render", PW]]), OW = {}, MW = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  class: "dp__icon"
}, IW = /* @__PURE__ */ k("path", { d: "M12.943 24.943l8-8c0.521-0.521 0.521-1.365 0-1.885l-8-8c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885l7.057 7.057c0 0-7.057 7.057-7.057 7.057-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0z" }, null, -1), RW = [
  IW
];
function FW(e, t) {
  return _(), O("svg", MW, RW);
}
const jk = /* @__PURE__ */ rl(OW, [["render", FW]]), NW = {}, LW = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  class: "dp__icon"
}, $W = /* @__PURE__ */ k("path", { d: "M16 1.333c-8.095 0-14.667 6.572-14.667 14.667s6.572 14.667 14.667 14.667c8.095 0 14.667-6.572 14.667-14.667s-6.572-14.667-14.667-14.667zM16 4c6.623 0 12 5.377 12 12s-5.377 12-12 12c-6.623 0-12-5.377-12-12s5.377-12 12-12z" }, null, -1), VW = /* @__PURE__ */ k("path", { d: "M14.667 8v8c0 0.505 0.285 0.967 0.737 1.193l5.333 2.667c0.658 0.329 1.46 0.062 1.789-0.596s0.062-1.46-0.596-1.789l-4.596-2.298c0 0 0-7.176 0-7.176 0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z" }, null, -1), BW = [
  $W,
  VW
];
function UW(e, t) {
  return _(), O("svg", LW, BW);
}
const X2 = /* @__PURE__ */ rl(NW, [["render", UW]]), qW = {}, jW = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  class: "dp__icon"
}, WW = /* @__PURE__ */ k("path", { d: "M24.943 19.057l-8-8c-0.521-0.521-1.365-0.521-1.885 0l-8 8c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l7.057-7.057c0 0 7.057 7.057 7.057 7.057 0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z" }, null, -1), zW = [
  WW
];
function HW(e, t) {
  return _(), O("svg", jW, zW);
}
const Z2 = /* @__PURE__ */ rl(qW, [["render", HW]]), GW = {}, YW = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  class: "dp__icon"
}, KW = /* @__PURE__ */ k("path", { d: "M7.057 12.943l8 8c0.521 0.521 1.365 0.521 1.885 0l8-8c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-7.057 7.057c0 0-7.057-7.057-7.057-7.057-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z" }, null, -1), XW = [
  KW
];
function ZW(e, t) {
  return _(), O("svg", YW, XW);
}
const Q2 = /* @__PURE__ */ rl(GW, [["render", ZW]]), Wk = (e, t) => {
  const n = cy(e, t.slice(0, e.length), /* @__PURE__ */ new Date());
  return Sc(n) && w2(n) ? n : null;
}, QW = (e, t) => {
  if (typeof t == "string")
    return Wk(e, t);
  if (Array.isArray(t)) {
    let n = null;
    for (const r of t)
      if (n = Wk(e, r), n)
        break;
    return n;
  }
  return typeof t == "function" ? t(e) : null;
}, Oe = (e) => e ? new Date(e) : /* @__PURE__ */ new Date(), JW = (e, t) => {
  if (t) {
    const r = (e.getMonth() + 1).toString().padStart(2, "0"), i = e.getDate().toString().padStart(2, "0"), a = e.getHours().toString().padStart(2, "0"), s = e.getMinutes().toString().padStart(2, "0");
    return `${e.getFullYear()}-${r}-${i}T${a}:${s}:00.000Z`;
  }
  const n = Date.UTC(
    e.getUTCFullYear(),
    e.getUTCMonth(),
    e.getUTCDate(),
    e.getUTCHours(),
    e.getUTCMinutes(),
    e.getUTCSeconds()
  );
  return new Date(n).toISOString();
}, Aa = (e) => {
  let t = Oe(JSON.parse(JSON.stringify(e)));
  return t = U2(t, 0), t = q2(t, 0), t = j2(t, 0), t = y0(t, 0), t;
}, Vi = (e, t, n, r) => {
  let i = e ? Oe(e) : Oe();
  return (t || t === 0) && (i = U2(i, +t)), (n || n === 0) && (i = q2(i, +n)), (r || r === 0) && (i = j2(i, +r)), y0(i, 0);
}, Fr = (e, t) => !e || !t ? !1 : v0(Aa(e), Aa(t)), _n = (e, t) => !e || !t ? !1 : I2(Aa(e), Aa(t)), Kr = (e, t) => !e || !t ? !1 : g0(Aa(e), Aa(t)), J2 = (e, t, n) => e && e[0] && e[1] ? Kr(n, e[0]) && Fr(n, e[1]) : e && e[0] && t ? Kr(n, e[0]) && Fr(n, t) || Fr(n, e[0]) && Kr(n, t) : !1, Zu = nl({
  menuFocused: !1,
  shiftKeyInMenu: !1
}), eO = () => {
  const e = (n) => {
    Zu.menuFocused = n;
  }, t = (n) => {
    Zu.shiftKeyInMenu !== n && (Zu.shiftKeyInMenu = n);
  };
  return {
    control: ce(() => ({ shiftKeyInMenu: Zu.shiftKeyInMenu, menuFocused: Zu.menuFocused })),
    setMenuFocused: e,
    setShiftKey: t
  };
};
function x0(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Eh = {}, ez = {
  get exports() {
    return Eh;
  },
  set exports(e) {
    Eh = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  function n(r) {
    if (r === null || r === !0 || r === !1)
      return NaN;
    var i = Number(r);
    return isNaN(i) ? i : i < 0 ? Math.ceil(i) : Math.floor(i);
  }
  e.exports = t.default;
})(ez, Eh);
const tz = /* @__PURE__ */ x0(Eh);
var Ph = {}, nz = {
  get exports() {
    return Ph;
  },
  set exports(e) {
    Ph = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  function n(r) {
    var i = new Date(Date.UTC(r.getFullYear(), r.getMonth(), r.getDate(), r.getHours(), r.getMinutes(), r.getSeconds(), r.getMilliseconds()));
    return i.setUTCFullYear(r.getFullYear()), r.getTime() - i.getTime();
  }
  e.exports = t.default;
})(nz, Ph);
const zk = /* @__PURE__ */ x0(Ph);
function rz(e, t) {
  var n = oz(t);
  return n.formatToParts ? az(n, e) : sz(n, e);
}
var iz = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function az(e, t) {
  try {
    for (var n = e.formatToParts(t), r = [], i = 0; i < n.length; i++) {
      var a = iz[n[i].type];
      a >= 0 && (r[a] = parseInt(n[i].value, 10));
    }
    return r;
  } catch (s) {
    if (s instanceof RangeError)
      return [NaN];
    throw s;
  }
}
function sz(e, t) {
  var n = e.format(t).replace(/\u200E/g, ""), r = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(n);
  return [r[3], r[1], r[2], r[4], r[5], r[6]];
}
var kg = {};
function oz(e) {
  if (!kg[e]) {
    var t = new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: "America/New_York",
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), n = t === "06/25/2014, 00:00:00" || t === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    kg[e] = n ? new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: e,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return kg[e];
}
function w0(e, t, n, r, i, a, s) {
  var o = /* @__PURE__ */ new Date(0);
  return o.setUTCFullYear(e, t, n), o.setUTCHours(r, i, a, s), o;
}
var Hk = 36e5, lz = 6e4, Sg = {
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
};
function k0(e, t, n) {
  var r, i;
  if (!e || (r = Sg.timezoneZ.exec(e), r))
    return 0;
  var a;
  if (r = Sg.timezoneHH.exec(e), r)
    return a = parseInt(r[1], 10), Gk(a) ? -(a * Hk) : NaN;
  if (r = Sg.timezoneHHMM.exec(e), r) {
    a = parseInt(r[1], 10);
    var s = parseInt(r[2], 10);
    return Gk(a, s) ? (i = Math.abs(a) * Hk + s * lz, a > 0 ? -i : i) : NaN;
  }
  if (dz(e)) {
    t = new Date(t || Date.now());
    var o = n ? t : uz(t), l = dy(o, e), c = n ? l : cz(t, l, e);
    return -c;
  }
  return NaN;
}
function uz(e) {
  return w0(
    e.getFullYear(),
    e.getMonth(),
    e.getDate(),
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  );
}
function dy(e, t) {
  var n = rz(e, t), r = w0(
    n[0],
    n[1] - 1,
    n[2],
    n[3] % 24,
    n[4],
    n[5],
    0
  ).getTime(), i = e.getTime(), a = i % 1e3;
  return i -= a >= 0 ? a : 1e3 + a, r - i;
}
function cz(e, t, n) {
  var r = e.getTime(), i = r - t, a = dy(new Date(i), n);
  if (t === a)
    return t;
  i -= a - t;
  var s = dy(new Date(i), n);
  return a === s ? a : Math.max(a, s);
}
function Gk(e, t) {
  return -23 <= e && e <= 23 && (t == null || 0 <= t && t <= 59);
}
var Yk = {};
function dz(e) {
  if (Yk[e])
    return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: e }), Yk[e] = !0, !0;
  } catch {
    return !1;
  }
}
var fz = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
const tO = fz;
var Cg = 36e5, Kk = 6e4, hz = 2, Yr = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: tO
};
function fy(e, t) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (e === null)
    return /* @__PURE__ */ new Date(NaN);
  var n = t || {}, r = n.additionalDigits == null ? hz : tz(n.additionalDigits);
  if (r !== 2 && r !== 1 && r !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]")
    return new Date(e.getTime());
  if (typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]")
    return new Date(e);
  if (!(typeof e == "string" || Object.prototype.toString.call(e) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var i = pz(e), a = mz(i.date, r), s = a.year, o = a.restDateString, l = gz(o, s);
  if (isNaN(l))
    return /* @__PURE__ */ new Date(NaN);
  if (l) {
    var c = l.getTime(), f = 0, h;
    if (i.time && (f = vz(i.time), isNaN(f)))
      return /* @__PURE__ */ new Date(NaN);
    if (i.timeZone || n.timeZone) {
      if (h = k0(i.timeZone || n.timeZone, new Date(c + f)), isNaN(h))
        return /* @__PURE__ */ new Date(NaN);
    } else
      h = zk(new Date(c + f)), h = zk(new Date(c + f + h));
    return new Date(c + f + h);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function pz(e) {
  var t = {}, n = Yr.dateTimePattern.exec(e), r;
  if (n ? (t.date = n[1], r = n[3]) : (n = Yr.datePattern.exec(e), n ? (t.date = n[1], r = n[2]) : (t.date = null, r = e)), r) {
    var i = Yr.timeZone.exec(r);
    i ? (t.time = r.replace(i[1], ""), t.timeZone = i[1].trim()) : t.time = r;
  }
  return t;
}
function mz(e, t) {
  var n = Yr.YYY[t], r = Yr.YYYYY[t], i;
  if (i = Yr.YYYY.exec(e) || r.exec(e), i) {
    var a = i[1];
    return {
      year: parseInt(a, 10),
      restDateString: e.slice(a.length)
    };
  }
  if (i = Yr.YY.exec(e) || n.exec(e), i) {
    var s = i[1];
    return {
      year: parseInt(s, 10) * 100,
      restDateString: e.slice(s.length)
    };
  }
  return {
    year: null
  };
}
function gz(e, t) {
  if (t === null)
    return null;
  var n, r, i, a;
  if (e.length === 0)
    return r = /* @__PURE__ */ new Date(0), r.setUTCFullYear(t), r;
  if (n = Yr.MM.exec(e), n)
    return r = /* @__PURE__ */ new Date(0), i = parseInt(n[1], 10) - 1, Zk(t, i) ? (r.setUTCFullYear(t, i), r) : /* @__PURE__ */ new Date(NaN);
  if (n = Yr.DDD.exec(e), n) {
    r = /* @__PURE__ */ new Date(0);
    var s = parseInt(n[1], 10);
    return yz(t, s) ? (r.setUTCFullYear(t, 0, s), r) : /* @__PURE__ */ new Date(NaN);
  }
  if (n = Yr.MMDD.exec(e), n) {
    r = /* @__PURE__ */ new Date(0), i = parseInt(n[1], 10) - 1;
    var o = parseInt(n[2], 10);
    return Zk(t, i, o) ? (r.setUTCFullYear(t, i, o), r) : /* @__PURE__ */ new Date(NaN);
  }
  if (n = Yr.Www.exec(e), n)
    return a = parseInt(n[1], 10) - 1, Qk(t, a) ? Xk(t, a) : /* @__PURE__ */ new Date(NaN);
  if (n = Yr.WwwD.exec(e), n) {
    a = parseInt(n[1], 10) - 1;
    var l = parseInt(n[2], 10) - 1;
    return Qk(t, a, l) ? Xk(t, a, l) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function vz(e) {
  var t, n, r;
  if (t = Yr.HH.exec(e), t)
    return n = parseFloat(t[1].replace(",", ".")), Tg(n) ? n % 24 * Cg : NaN;
  if (t = Yr.HHMM.exec(e), t)
    return n = parseInt(t[1], 10), r = parseFloat(t[2].replace(",", ".")), Tg(n, r) ? n % 24 * Cg + r * Kk : NaN;
  if (t = Yr.HHMMSS.exec(e), t) {
    n = parseInt(t[1], 10), r = parseInt(t[2], 10);
    var i = parseFloat(t[3].replace(",", "."));
    return Tg(n, r, i) ? n % 24 * Cg + r * Kk + i * 1e3 : NaN;
  }
  return null;
}
function Xk(e, t, n) {
  t = t || 0, n = n || 0;
  var r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(e, 0, 4);
  var i = r.getUTCDay() || 7, a = t * 7 + n + 1 - i;
  return r.setUTCDate(r.getUTCDate() + a), r;
}
var bz = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], _z = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function nO(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function Zk(e, t, n) {
  if (t < 0 || t > 11)
    return !1;
  if (n != null) {
    if (n < 1)
      return !1;
    var r = nO(e);
    if (r && n > _z[t] || !r && n > bz[t])
      return !1;
  }
  return !0;
}
function yz(e, t) {
  if (t < 1)
    return !1;
  var n = nO(e);
  return !(n && t > 366 || !n && t > 365);
}
function Qk(e, t, n) {
  return !(t < 0 || t > 52 || n != null && (n < 0 || n > 6));
}
function Tg(e, t, n) {
  return !(e != null && (e < 0 || e >= 25) || t != null && (t < 0 || t >= 60) || n != null && (n < 0 || n >= 60));
}
var Oh = {}, xz = {
  get exports() {
    return Oh;
  },
  set exports(e) {
    Oh = e;
  }
}, Mh = {}, wz = {
  get exports() {
    return Mh;
  },
  set exports(e) {
    Mh = e;
  }
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = n;
  function n(r, i) {
    if (r == null)
      throw new TypeError("assign requires that input parameter not be null or undefined");
    for (var a in i)
      Object.prototype.hasOwnProperty.call(i, a) && (r[a] = i[a]);
    return r;
  }
  e.exports = t.default;
})(wz, Mh);
(function(e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = i;
  var n = r(Mh);
  function r(a) {
    return a && a.__esModule ? a : { default: a };
  }
  function i(a) {
    return (0, n.default)({}, a);
  }
  e.exports = t.default;
})(xz, Oh);
const kz = /* @__PURE__ */ x0(Oh);
function Sz(e, t, n) {
  var r = fy(e, n), i = k0(t, r, !0), a = new Date(r.getTime() - i), s = /* @__PURE__ */ new Date(0);
  return s.setFullYear(a.getUTCFullYear(), a.getUTCMonth(), a.getUTCDate()), s.setHours(a.getUTCHours(), a.getUTCMinutes(), a.getUTCSeconds(), a.getUTCMilliseconds()), s;
}
function Cz(e, t, n) {
  if (typeof e == "string" && !e.match(tO)) {
    var r = kz(n);
    return r.timeZone = t, fy(e, r);
  }
  var i = fy(e, n), a = w0(
    i.getFullYear(),
    i.getMonth(),
    i.getDate(),
    i.getHours(),
    i.getMinutes(),
    i.getSeconds(),
    i.getMilliseconds()
  ).getTime(), s = k0(t, new Date(a));
  return new Date(a + s);
}
const Tz = (e, t = 3) => {
  const n = [];
  for (let r = 0; r < e.length; r += t)
    n.push([e[r], e[r + 1], e[r + 2]]);
  return n;
}, Az = (e, t) => {
  const n = [1, 2, 3, 4, 5, 6, 7].map((a) => new Intl.DateTimeFormat(e, { weekday: "short", timeZone: "UTC" }).format(/* @__PURE__ */ new Date(`2017-01-0${a}T00:00:00+00:00`)).slice(0, 2)), r = n.slice(0, t), i = n.slice(t + 1, n.length);
  return [n[t]].concat(...i).concat(...r);
}, Dz = (e) => {
  const t = [];
  for (let n = +e[0]; n <= +e[1]; n++)
    t.push({ value: +n, text: `${n}` });
  return t;
}, Ez = (e, t) => {
  const n = new Intl.DateTimeFormat(e, { month: t, timeZone: "UTC" });
  return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((r) => {
    const i = r < 10 ? `0${r}` : r;
    return /* @__PURE__ */ new Date(`2017-${i}-01T00:00:00+00:00`);
  }).map((r, i) => ({
    text: n.format(r),
    value: i
  }));
}, Pz = (e) => [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11][e], lr = (e) => {
  const t = re(e);
  return t != null && t.$el ? t == null ? void 0 : t.$el : t;
}, Oz = (e) => Object.assign({ type: "dot" }, e), rO = (e) => Array.isArray(e) ? !!e[0] && !!e[1] : !1, Ih = {
  prop: (e) => `"${e}" prop must be enabled!`,
  dateArr: (e) => `You need to use array as "model-value" binding in order to support "${e}"`
}, Mr = (e) => e, Jk = (e) => e === 0 ? e : !e || isNaN(+e) ? null : +e, eS = (e) => Object.assign(
  {
    menuAppear: "dp-menu-appear",
    open: "dp-slide-down",
    close: "dp-slide-up",
    next: "calendar-next",
    previous: "calendar-prev",
    vNext: "dp-slide-up",
    vPrevious: "dp-slide-down"
  },
  e
), Mz = (e) => Object.assign(
  {
    toggleOverlay: "Toggle overlay",
    menu: "Datepicker menu",
    input: "Datepicker input",
    calendarWrap: "Calendar wrapper",
    calendarDays: "Calendar days",
    openTimePicker: "Open time picker",
    closeTimePicker: "Close time Picker",
    incrementValue: (t) => `Increment ${t}`,
    decrementValue: (t) => `Decrement ${t}`,
    openTpOverlay: (t) => `Open ${t} overlay`,
    amPmButton: "Switch AM/PM mode",
    openYearsOverlay: "Open years overlay",
    openMonthsOverlay: "Open months overlay",
    nextMonth: "Next month",
    prevMonth: "Previous month",
    day: () => ""
  },
  e
), Iz = (e) => e === null ? 0 : typeof e == "boolean" ? e ? 2 : 0 : +e >= 2 ? +e : 2, Rz = (e, t, n) => e || (typeof n == "string" ? n : t), Fz = (e) => typeof e == "boolean" ? e ? eS({}) : !1 : eS(e), Nz = () => ({
  enterSubmit: !0,
  tabSubmit: !0,
  openMenu: !0,
  rangeSeparator: " - "
}), Lz = (e) => Object.assign({ months: [], years: [], times: { hours: [], minutes: [], seconds: [] } }, e), Ci = (e) => {
  const t = () => {
    if (e.partialRange)
      return null;
    throw new Error(Ih.prop("partial-range"));
  }, n = ce(() => ({
    ariaLabels: Mz(e.ariaLabels),
    textInputOptions: Object.assign(Nz(), e.textInputOptions),
    multiCalendars: Iz(e.multiCalendars),
    previewFormat: Rz(e.previewFormat, e.format, a()),
    filters: Lz(e.filters),
    transitions: Fz(e.transitions),
    startTime: p()
  })), r = (A) => {
    if (e.range)
      return A();
    throw new Error(Ih.prop("range"));
  }, i = () => {
    const A = e.enableSeconds ? ":ss" : "";
    return e.is24 ? `HH:mm${A}` : `hh:mm${A} aa`;
  }, a = () => e.format ? e.format : e.monthPicker ? "MM/yyyy" : e.timePicker ? i() : e.weekPicker ? "MM/dd/yyyy" : e.yearPicker ? "yyyy" : e.enableTimePicker ? `MM/dd/yyyy, ${i()}` : "MM/dd/yyyy", s = (A, X) => {
    if (typeof e.format == "function")
      return e.format(A);
    const pe = X || a(), le = e.formatLocale ? { locale: e.formatLocale } : void 0;
    return Array.isArray(A) ? `${ua(A[0], pe, le)} ${e.modelAuto && !A[1] ? "" : n.value.textInputOptions.rangeSeparator || "-"} ${A[1] ? ua(A[1], pe, le) : ""}` : ua(A, pe, le);
  }, o = (A) => e.timezone ? Sz(A, e.timezone) : A, l = (A) => e.timezone ? Cz(A, e.timezone) : A, c = ce(() => (A) => {
    var X;
    return (X = e.hideNavigation) == null ? void 0 : X.includes(A);
  }), f = (A) => {
    const X = e.maxDate ? Kr(o(A), o(Oe(e.maxDate))) : !1, pe = e.minDate ? Fr(o(A), o(Oe(e.minDate))) : !1, le = x(A, e.disabledDates), ue = n.value.filters.months.map((se) => +se).includes(mn(A)), Te = e.disabledWeekDays.length ? e.disabledWeekDays.some((se) => +se === u8(A)) : !1, Ne = e.allowedDates.length ? !e.allowedDates.some((se) => _n(o(Oe(se)), o(A))) : !1, Z = gn(A), G = Z < +e.yearRange[0] || Z > +e.yearRange[1];
    return !(X || pe || le || ue || G || Te || Ne);
  }, h = (A) => {
    const X = {
      hours: es(Oe()),
      minutes: ts(Oe()),
      seconds: Jl(Oe())
    };
    return Object.assign(X, A);
  }, p = () => e.range ? e.startTime && Array.isArray(e.startTime) ? [h(e.startTime[0]), h(e.startTime[1])] : null : e.startTime && !Array.isArray(e.startTime) ? h(e.startTime) : null, g = (A) => !f(A), v = (A) => Array.isArray(A) ? Sc(A[0]) && (A[1] ? Sc(A[1]) : !0) : A ? Sc(A) : !1, y = (A) => A instanceof Date ? A : cj(A), S = (A) => {
    const X = Yo(o(A), { weekStartsOn: +e.weekStart }), pe = p0(o(A), { weekStartsOn: +e.weekStart });
    return [X, pe];
  }, x = (A, X) => Array.isArray(X) ? X.some((pe) => _n(o(Oe(pe)), o(A))) : X(A), E = (A, X, pe) => {
    let le = A ? Oe(A) : Oe();
    return (X || X === 0) && (le = Cc(le, X)), pe && (le = qo(le, pe)), le;
  }, w = (A) => Hr(Oe(), { hours: es(A), minutes: ts(A), seconds: Jl(A) }), C = (A) => Hr(Oe(), {
    hours: +A.hours || 0,
    minutes: +A.minutes || 0,
    seconds: +A.seconds || 0
  }), P = (A, X, pe, le) => {
    if (!A)
      return !0;
    if (le) {
      const ue = pe === "max" ? v0(A, X) : g0(A, X), Te = { seconds: 0, milliseconds: 0 };
      return ue || I2(Hr(A, Te), Hr(X, Te));
    }
    return pe === "max" ? A.getTime() <= X.getTime() : A.getTime() >= X.getTime();
  }, M = () => !e.enableTimePicker || e.monthPicker || e.yearPicker || e.ignoreTimeValidation, T = (A) => Array.isArray(A) ? [A[0] ? w(A[0]) : null, A[1] ? w(A[1]) : null] : w(A), N = (A) => {
    const X = e.maxTime ? C(e.maxTime) : Oe(e.maxDate);
    return Array.isArray(A) ? P(A[0], X, "max", !!e.maxDate) && P(A[1], X, "max", !!e.maxDate) : P(A, X, "max", !!e.maxDate);
  }, $ = (A, X) => {
    const pe = e.minTime ? C(e.minTime) : Oe(e.minDate);
    return Array.isArray(A) ? P(A[0], pe, "min", !!e.minDate) && P(A[1], pe, "min", !!e.minDate) && X : P(A, pe, "min", !!e.minDate) && X;
  }, ne = (A) => {
    let X = !0;
    if (!A || M())
      return !0;
    const pe = !e.minDate && !e.maxDate ? T(A) : A;
    return (e.maxTime || e.maxDate) && (X = N(Mr(pe))), (e.minTime || e.minDate) && (X = $(Mr(pe), X)), X;
  }, Y = (A, X) => {
    const pe = Oe(JSON.parse(JSON.stringify(A))), le = [];
    for (let ue = 0; ue < 7; ue++) {
      const Te = os(pe, ue), Ne = mn(Te) !== X;
      le.push({
        text: e.hideOffsetDates && Ne ? "" : Te.getDate(),
        value: Te,
        current: !Ne,
        classData: {}
      });
    }
    return le;
  }, te = (A, X) => {
    const pe = [], le = Oe(o(new Date(X, A))), ue = Oe(o(new Date(X, A + 1, 0))), Te = Yo(le, { weekStartsOn: e.weekStart }), Ne = (Z) => {
      const G = Y(Z, A);
      if (pe.push({ days: G }), !pe[pe.length - 1].days.some(
        (se) => _n(Aa(se.value), Aa(ue))
      )) {
        const se = os(Z, 7);
        Ne(se);
      }
    };
    if (Ne(Te), e.sixWeeks && pe.length < 6) {
      const Z = 6 - pe.length;
      for (let G = 1; G <= Z; G++) {
        const se = pe[pe.length - 1], St = se.days[se.days.length - 1], Sn = Y(os(St.value, 1), mn(le));
        pe.push({ days: Sn });
      }
    }
    return pe;
  }, _e = (A, X, pe) => [Hr(Oe(A), { date: 1 }), Hr(Oe(), { month: X, year: pe, date: 1 })], Fe = (A, X) => Fr(..._e(e.minDate, A, X)) || _n(..._e(e.minDate, A, X)), J = (A, X) => Kr(..._e(e.maxDate, A, X)) || _n(..._e(e.maxDate, A, X)), oe = (A, X, pe) => {
    let le = !1;
    return e.maxDate && pe && J(A, X) && (le = !0), e.minDate && !pe && Fe(A, X) && (le = !0), le;
  };
  return {
    checkPartialRangeValue: t,
    checkRangeEnabled: r,
    getZonedDate: o,
    getZonedToUtc: l,
    formatDate: s,
    getDefaultPattern: a,
    validateDate: f,
    getDefaultStartTime: p,
    isDisabled: g,
    isValidDate: v,
    sanitizeDate: y,
    getWeekFromDate: S,
    matchDate: x,
    setDateMonthOrYear: E,
    isValidTime: ne,
    getCalendarDays: te,
    validateMonthYearInRange: (A, X, pe, le) => {
      let ue = !1;
      return le ? e.minDate && e.maxDate ? ue = oe(A, X, pe) : (e.minDate && Fe(A, X) || e.maxDate && J(A, X)) && (ue = !0) : ue = !0, ue;
    },
    validateMaxDate: J,
    validateMinDate: Fe,
    defaults: n,
    hideNavigationButtons: c
  };
}, fn = nl({
  monthYear: [],
  calendar: [],
  time: [],
  actionRow: [],
  selectionGrid: [],
  timePicker: {
    0: [],
    1: []
  },
  monthPicker: []
}), Ag = ge(null), Mf = ge(!1), Dg = ge(!1), Eg = ge(!1), Pg = ge(!1), jr = ge(0), wr = ge(0), io = () => {
  const e = ce(() => Mf.value ? [...fn.selectionGrid, fn.actionRow].filter((h) => h.length) : Dg.value ? [
    ...fn.timePicker[0],
    ...fn.timePicker[1],
    Pg.value ? [] : [Ag.value],
    fn.actionRow
  ].filter((h) => h.length) : Eg.value ? [...fn.monthPicker, fn.actionRow] : [fn.monthYear, ...fn.calendar, fn.time, fn.actionRow].filter((h) => h.length)), t = (h) => {
    jr.value = h ? jr.value + 1 : jr.value - 1;
    let p = null;
    e.value[wr.value] && (p = e.value[wr.value][jr.value]), p || (jr.value = h ? jr.value - 1 : jr.value + 1);
  }, n = (h) => {
    wr.value === 0 && !h || wr.value === e.value.length && h || (wr.value = h ? wr.value + 1 : wr.value - 1, e.value[wr.value] ? e.value[wr.value] && !e.value[wr.value][jr.value] && jr.value !== 0 && (jr.value = e.value[wr.value].length - 1) : wr.value = h ? wr.value - 1 : wr.value + 1);
  }, r = (h) => {
    let p = null;
    e.value[wr.value] && (p = e.value[wr.value][jr.value]), p ? p.focus({ preventScroll: !Mf.value }) : jr.value = h ? jr.value - 1 : jr.value + 1;
  }, i = () => {
    t(!0), r(!0);
  }, a = () => {
    t(!1), r(!1);
  }, s = () => {
    n(!1), r(!0);
  }, o = () => {
    n(!0), r(!0);
  }, l = (h, p) => {
    fn[p] = h;
  }, c = (h, p) => {
    fn[p] = h;
  }, f = () => {
    jr.value = 0, wr.value = 0;
  };
  return {
    buildMatrix: l,
    buildMultiLevelMatrix: c,
    setTimePickerBackRef: (h) => {
      Ag.value = h;
    },
    setSelectionGrid: (h) => {
      Mf.value = h, f(), h || (fn.selectionGrid = []);
    },
    setTimePicker: (h, p = !1) => {
      Dg.value = h, Pg.value = p, f(), h || (fn.timePicker[0] = [], fn.timePicker[1] = []);
    },
    setTimePickerElements: (h, p = 0) => {
      fn.timePicker[p] = h;
    },
    arrowRight: i,
    arrowLeft: a,
    arrowUp: s,
    arrowDown: o,
    clearArrowNav: () => {
      fn.monthYear = [], fn.calendar = [], fn.time = [], fn.actionRow = [], fn.selectionGrid = [], fn.timePicker[0] = [], fn.timePicker[1] = [], Mf.value = !1, Dg.value = !1, Pg.value = !1, Eg.value = !1, f(), Ag.value = null;
    },
    setMonthPicker: (h) => {
      Eg.value = h, f();
    },
    refSets: fn
    // exposed for testing
  };
}, tS = (e) => Array.isArray(e), To = (e) => Array.isArray(e), nS = (e) => Array.isArray(e) && e.length === 2, $z = (e, t, n, r, i) => {
  const {
    getDefaultStartTime: a,
    isDisabled: s,
    sanitizeDate: o,
    getWeekFromDate: l,
    setDateMonthOrYear: c,
    validateMonthYearInRange: f,
    defaults: h
  } = Ci(e), p = ce({
    get: () => e.internalModelValue,
    set: (q) => {
      !e.readonly && !e.disabled && t("update:internal-model-value", q);
    }
  }), g = ge([]);
  Ln(p, () => {
    e.multiCalendars || P();
  });
  const v = ge([{ month: mn(Oe()), year: gn(Oe()) }]), y = nl({
    hours: e.range ? [es(Oe()), es(Oe())] : es(Oe()),
    minutes: e.range ? [ts(Oe()), ts(Oe())] : ts(Oe()),
    seconds: e.range ? [0, 0] : 0
  }), S = ce(
    () => (q) => v.value[q] ? v.value[q].month : 0
  ), x = ce(
    () => (q) => v.value[q] ? v.value[q].year : 0
  ), E = ce(() => e.flow && e.flow.length ? i.value === e.flow.length : !0), w = (q, me, Be) => {
    var He, gt;
    v.value[q] || (v.value[q] = { month: 0, year: 0 }), v.value[q].month = me === null ? (He = v.value[q]) == null ? void 0 : He.month : me, v.value[q].year = Be === null ? (gt = v.value[q]) == null ? void 0 : gt.year : Be;
  }, C = (q, me) => {
    y[q] = me;
  };
  Ft(() => {
    p.value || (e.startDate && (w(0, mn(Oe(e.startDate)), gn(Oe(e.startDate))), h.value.multiCalendars && ut(0)), h.value.startTime && J()), P(!0);
  });
  const P = (q = !1) => {
    if (p.value)
      return Array.isArray(p.value) ? (g.value = p.value, ne(q)) : T(p.value);
    if (e.timePicker)
      return Y();
    if (e.monthPicker && !e.range)
      return te();
    if (e.yearPicker && !e.range)
      return _e();
    if (h.value.multiCalendars && q && !e.startDate)
      return M(Oe(), q);
  }, M = (q, me = !1) => {
    if ((!h.value.multiCalendars || !e.multiStatic || me) && w(0, mn(q), gn(q)), h.value.multiCalendars)
      for (let Be = 1; Be < h.value.multiCalendars; Be++) {
        const He = Hr(Oe(), { month: S.value(Be - 1), year: x.value(Be - 1) }), gt = y2(He, { months: 1 });
        v.value[Be] = { month: mn(gt), year: gn(gt) };
      }
  }, T = (q) => {
    M(q), C("hours", es(q)), C("minutes", ts(q)), C("seconds", Jl(q));
  }, N = (q, me) => {
    M(q[0], me);
    const Be = (He, gt) => [
      He(q[0]),
      q[1] ? He(q[1]) : y[gt][1]
    ];
    C("hours", Be(es, "hours")), C("minutes", Be(ts, "minutes")), C("seconds", Be(Jl, "seconds"));
  }, $ = (q, me) => {
    if ((e.range || e.weekPicker) && !e.multiDates)
      return N(q, me);
    if (e.multiDates) {
      const Be = q[q.length - 1];
      return T(Be);
    }
  }, ne = (q) => {
    const me = p.value;
    $(me, q), h.value.multiCalendars && e.multiCalendarsSolo && A();
  }, Y = () => {
    if (J(), !e.range)
      p.value = Vi(Oe(), y.hours, y.minutes, Fe());
    else {
      const q = y.hours, me = y.minutes;
      p.value = [
        Vi(Oe(), q[0], me[0], Fe()),
        Vi(Oe(), q[1], me[1], Fe(!1))
      ];
    }
  }, te = () => {
    p.value = c(Oe(), S.value(0), x.value(0));
  }, _e = () => {
    p.value = Oe();
  }, Fe = (q = !0) => e.enableSeconds ? Array.isArray(y.seconds) ? q ? y.seconds[0] : y.seconds[1] : y.seconds : 0, J = () => {
    const q = a();
    if (q) {
      const me = Array.isArray(q), Be = me ? [+q[0].hours, +q[1].hours] : +q.hours, He = me ? [+q[0].minutes, +q[1].minutes] : +q.minutes, gt = me ? [+q[0].seconds, +q[1].seconds] : +q.seconds;
      C("hours", Be), C("minutes", He), e.enableSeconds && C("seconds", gt);
    }
  }, oe = () => Array.isArray(p.value) && p.value.length ? p.value[p.value.length - 1] : null, A = () => {
    if (Array.isArray(p.value) && p.value.length === 2) {
      const q = Oe(
        Oe(p.value[1] ? p.value[1] : Sa(p.value[0], 1))
      ), [me, Be] = [mn(p.value[0]), gn(p.value[0])], [He, gt] = [mn(p.value[1]), gn(p.value[1])];
      (me !== He || me === He && Be !== gt) && e.multiCalendarsSolo && w(1, mn(q), gn(q));
    }
  }, X = (q) => {
    const me = Sa(q, 1);
    return { month: mn(me), year: gn(me) };
  }, pe = (q) => {
    const me = mn(Oe(q)), Be = gn(Oe(q));
    if (w(0, me, Be), h.value.multiCalendars > 0)
      for (let He = 1; He < h.value.multiCalendars; He++) {
        const gt = X(
          Hr(Oe(q), { year: S.value(He - 1), month: x.value(He - 1) })
        );
        w(He, gt.month, gt.year);
      }
  }, le = (q) => {
    if (p.value && Array.isArray(p.value))
      if (p.value.some((me) => _n(q, me))) {
        const me = p.value.filter((Be) => !_n(Be, q));
        p.value = me.length ? me : null;
      } else
        (e.multiDatesLimit && +e.multiDatesLimit > p.value.length || !e.multiDatesLimit) && p.value.push(q);
    else
      p.value = [q];
  }, ue = (q, me) => {
    const Be = Kr(q, me) ? me : q, He = Kr(me, q) ? me : q;
    return Fk({ start: Be, end: He });
  }, Te = (q) => {
    if (Array.isArray(p.value) && p.value[0]) {
      const me = f4(q, p.value[0]), Be = ue(p.value[0], q), He = Be.length === 1 ? 0 : Be.filter((cn) => s(cn)).length, gt = Math.abs(me) - He;
      if (e.minRange && e.maxRange)
        return gt >= +e.minRange && gt <= +e.maxRange;
      if (e.minRange)
        return gt >= +e.minRange;
      if (e.maxRange)
        return gt <= +e.maxRange;
    }
    return !0;
  }, Ne = (q) => Array.isArray(p.value) && p.value.length === 2 ? e.fixedStart && (Kr(q, p.value[0]) || _n(q, p.value[0])) ? [p.value[0], q] : e.fixedEnd && (Fr(q, p.value[1]) || _n(q, p.value[1])) ? [q, p.value[1]] : (t("invalid-fixed-range", q), p.value) : [], Z = () => {
    e.autoApply && E.value && t("auto-apply");
  }, G = () => {
    e.autoApply && t("select-date");
  }, se = (q) => !Fk({ start: q[0], end: q[1] }).some((me) => s(me)), St = (q) => (p.value = l(Oe(q.value)), Z()), Sn = (q) => {
    const me = Vi(Oe(q.value), y.hours, y.minutes, Fe());
    e.multiDates ? le(me) : p.value = me, n(), Z();
  }, Vt = () => {
    g.value = p.value ? p.value.slice() : [], g.value.length === 2 && !(e.fixedStart || e.fixedEnd) && (g.value = []);
  }, nn = (q, me) => {
    const Be = [Oe(q.value), os(Oe(q.value), +e.autoRange)];
    se(Be) && (me && pe(q.value), g.value = Be);
  }, rr = (q) => {
    Qe(q.value) || (g.value = Ne(Oe(q.value)));
  }, Qe = (q) => e.noDisabledRange ? ue(g.value[0], q).some((me) => s(me)) : !1, Je = (q, me) => {
    if (Vt(), e.autoRange)
      return nn(q, me);
    if (e.fixedStart || e.fixedEnd)
      return rr(q);
    g.value[0] ? Te(Oe(q.value)) && !Qe(q.value) && (Fr(Oe(q.value), Oe(g.value[0])) ? g.value.unshift(Oe(q.value)) : g.value[1] = Oe(q.value)) : g.value[0] = Oe(q.value);
  }, Pt = (q) => {
    g.value[q] = Vi(
      g.value[q],
      y.hours[q],
      y.minutes[q],
      Fe(q !== 1)
    );
  }, Xe = () => {
    g.value.length && (g.value[0] && !g.value[1] ? Pt(0) : (Pt(0), Pt(1), n()), p.value = g.value.slice(), g.value[0] && g.value[1] && e.autoApply && t("auto-apply"), g.value[0] && !g.value[1] && e.modelAuto && e.autoApply && t("auto-apply"));
  }, pt = (q, me = !1) => {
    if (!(s(q.value) || !q.current && e.hideOffsetDates)) {
      if (e.weekPicker)
        return St(q);
      if (!e.range)
        return Sn(q);
      To(y.hours) && To(y.minutes) && !e.multiDates && (Je(q, me), Xe());
    }
  }, Cn = (q) => {
    const me = q.find((Be) => Be.current);
    return me ? f8(me.value) : "";
  }, ut = (q) => {
    for (let me = q - 1; me >= 0; me--) {
      const Be = Xr(Hr(Oe(), { month: S.value(me + 1), year: x.value(me + 1) }), 1);
      w(me, mn(Be), gn(Be));
    }
    for (let me = q + 1; me <= h.value.multiCalendars - 1; me++) {
      const Be = Sa(Hr(Oe(), { month: S.value(me - 1), year: x.value(me - 1) }), 1);
      w(me, mn(Be), gn(Be));
    }
  }, dr = (q) => c(Oe(), S.value(q), x.value(q)), B = (q) => Vi(q, y.hours, y.minutes, Fe()), z = (q, me) => {
    const Be = e.monthPicker ? S.value(q) !== me.month || !me.fromNav : x.value(q) !== me.year;
    if (w(q, me.month, me.year), h.value.multiCalendars && !e.multiCalendarsSolo && ut(q), e.monthPicker || e.yearPicker)
      if (e.range) {
        if (Be) {
          let He = p.value ? p.value.slice() : [];
          He.length === 2 && He[1] !== null && (He = []), He.length ? Fr(dr(q), He[0]) ? He.unshift(dr(q)) : He[1] = dr(q) : He = [dr(q)], p.value = He;
        }
      } else
        p.value = dr(q);
    t("update-month-year", { instance: q, month: me.month, year: me.year }), r(e.multiCalendarsSolo ? q : void 0);
  }, ye = async (q = !1) => {
    if (e.autoApply && (e.monthPicker || e.yearPicker)) {
      await Nn();
      const me = e.monthPicker ? q : !1;
      e.range ? t("auto-apply", me || !p.value || p.value.length === 1) : t("auto-apply", me);
    }
    n();
  }, $e = (q, me) => {
    const Be = Hr(Oe(), { month: S.value(me), year: x.value(me) }), He = q < 0 ? Sa(Be, 1) : Xr(Be, 1);
    f(mn(He), gn(He), q < 0, e.preventMinMaxNavigation) && (w(me, mn(He), gn(He)), h.value.multiCalendars && !e.multiCalendarsSolo && ut(me), t("update-month-year", { instance: me, month: mn(He), year: gn(He) }), r());
  }, Ct = (q) => {
    tS(q) && tS(p.value) && To(y.hours) && To(y.minutes) ? (q[0] && p.value[0] && (p.value[0] = Vi(q[0], y.hours[0], y.minutes[0], Fe())), q[1] && p.value[1] && (p.value[1] = Vi(q[1], y.hours[1], y.minutes[1], Fe(!1)))) : e.multiDates && Array.isArray(p.value) ? p.value[p.value.length - 1] = B(q) : !e.range && !nS(q) && (p.value = B(q)), t("time-update");
  }, At = (q, me = !0, Be = !1) => {
    const He = me ? q : y.hours, gt = !me && !Be ? q : y.minutes, cn = Be ? q : y.seconds;
    if (e.range && nS(p.value) && To(He) && To(gt) && To(cn) && !e.disableTimeRangeValidation) {
      const Yn = (Ue) => Vi(p.value[Ue], He[Ue], gt[Ue], cn[Ue]), be = (Ue) => y0(p.value[Ue], 0);
      if (_n(p.value[0], p.value[1]) && (g0(Yn(0), be(1)) || v0(Yn(1), be(0))))
        return;
    }
    if (C("hours", He), C("minutes", gt), C("seconds", cn), p.value)
      if (e.multiDates) {
        const Yn = oe();
        Yn && Ct(Yn);
      } else
        Ct(p.value);
    else
      e.timePicker && Ct(e.range ? [Oe(), Oe()] : Oe());
    n();
  }, mt = (q, me) => {
    e.monthChangeOnScroll && $e(e.monthChangeOnScroll !== "inverse" ? -q.deltaY : q.deltaY, me);
  }, he = (q, me, Be = !1) => {
    e.monthChangeOnArrows && e.vertical === Be && Ae(q, me);
  }, Ae = (q, me) => {
    $e(q === "right" ? -1 : 1, me);
  };
  return {
    time: y,
    month: S,
    year: x,
    modelValue: p,
    calendars: v,
    monthYearSelect: ye,
    isDisabled: s,
    updateTime: At,
    getWeekNum: Cn,
    selectDate: pt,
    updateMonthYear: z,
    handleScroll: mt,
    getMarker: (q) => e.markers.find((me) => _n(o(q.value), o(me.date))),
    handleArrow: he,
    handleSwipe: Ae,
    selectCurrentDate: () => {
      e.range ? p.value && Array.isArray(p.value) && p.value[0] ? p.value = Fr(Oe(), p.value[0]) ? [Oe(), p.value[0]] : [p.value[0], Oe()] : p.value = [Oe()] : p.value = Oe(), G();
    },
    presetDateRange: (q, me) => {
      me || q.length && q.length <= 2 && e.range && (p.value = q.map((Be) => Oe(Be)), G(), e.multiCalendars && Nn().then(() => P(!0)));
    }
  };
}, Vz = (e, t, n) => {
  const r = ge(), {
    getZonedToUtc: i,
    getZonedDate: a,
    formatDate: s,
    getDefaultPattern: o,
    checkRangeEnabled: l,
    checkPartialRangeValue: c,
    isValidDate: f,
    setDateMonthOrYear: h,
    defaults: p
  } = Ci(t), g = ge(""), v = vh(t, "format");
  Ln(r, () => {
    e("internal-model-change", r.value);
  }), Ln(v, () => {
    X();
  });
  const y = (Z) => {
    const G = Z || Oe();
    return t.modelType ? le(G) : {
      hours: es(G),
      minutes: ts(G),
      seconds: t.enableSeconds ? Jl(G) : 0
    };
  }, S = (Z) => t.modelType ? le(Z) : { month: mn(Z), year: gn(Z) }, x = (Z) => Array.isArray(Z) ? l(() => [
    qo(Oe(), Z[0]),
    Z[1] ? qo(Oe(), Z[1]) : c()
  ]) : qo(Oe(), +Z), E = (Z, G) => (typeof Z == "string" || typeof Z == "number") && t.modelType ? pe(Z) : G, w = (Z) => Array.isArray(Z) ? [
    E(
      Z[0],
      Vi(null, +Z[0].hours, +Z[0].minutes, Z[0].seconds)
    ),
    E(
      Z[1],
      Vi(null, +Z[1].hours, +Z[1].minutes, Z[1].seconds)
    )
  ] : E(Z, Vi(null, Z.hours, Z.minutes, Z.seconds)), C = (Z) => Array.isArray(Z) ? l(() => [
    E(Z[0], h(null, +Z[0].month, +Z[0].year)),
    E(
      Z[1],
      Z[1] ? h(null, +Z[1].month, +Z[1].year) : c()
    )
  ]) : E(Z, h(null, +Z.month, +Z.year)), P = (Z) => {
    if (Array.isArray(Z))
      return Z.map((G) => pe(G));
    throw new Error(Ih.dateArr("multi-dates"));
  }, M = (Z) => {
    if (Array.isArray(Z))
      return [Oe(Z[0]), Oe(Z[1])];
    throw new Error(Ih.dateArr("week-picker"));
  }, T = (Z) => t.modelAuto ? Array.isArray(Z) ? [pe(Z[0]), pe(Z[1])] : t.autoApply ? [pe(Z)] : [pe(Z), null] : Array.isArray(Z) ? l(() => [
    pe(Z[0]),
    Z[1] ? pe(Z[1]) : c()
  ]) : pe(Z), N = () => {
    Array.isArray(r.value) && t.range && r.value.length === 1 && r.value.push(c());
  }, $ = () => {
    const Z = r.value;
    return [
      le(Z[0]),
      Z[1] ? le(Z[1]) : c()
    ];
  }, ne = () => r.value[1] ? $() : le(Mr(r.value[0])), Y = () => (r.value || []).map((Z) => le(Z)), te = () => (N(), t.modelAuto ? ne() : t.multiDates ? Y() : Array.isArray(r.value) ? l(() => $()) : le(Mr(r.value))), _e = (Z) => Z ? t.timePicker ? w(Mr(Z)) : t.monthPicker ? C(Mr(Z)) : t.yearPicker ? x(Mr(Z)) : t.multiDates ? P(Mr(Z)) : t.weekPicker ? M(Mr(Z)) : T(Mr(Z)) : null, Fe = (Z) => {
    const G = _e(Z);
    f(Mr(G)) ? (r.value = Mr(G), X()) : (r.value = null, g.value = "");
  }, J = () => {
    var Z;
    const G = (se) => {
      var St;
      return ua(se, (St = p.value.textInputOptions) == null ? void 0 : St.format);
    };
    return `${G(r.value[0])} ${(Z = p.value.textInputOptions) == null ? void 0 : Z.rangeSeparator} ${r.value[1] ? G(r.value[1]) : ""}`;
  }, oe = () => {
    var Z;
    return n.value && r.value ? Array.isArray(r.value) ? J() : ua(r.value, (Z = p.value.textInputOptions) == null ? void 0 : Z.format) : s(r.value);
  }, A = () => {
    var Z;
    return r.value ? t.multiDates ? r.value.map((G) => s(G)).join("; ") : t.textInput && typeof ((Z = p.value.textInputOptions) == null ? void 0 : Z.format) == "string" ? oe() : s(r.value) : "";
  }, X = () => {
    !t.format || typeof t.format == "string" ? g.value = A() : g.value = t.format(r.value);
  }, pe = (Z) => {
    if (t.utc) {
      const G = new Date(Z);
      return t.utc === "preserve" ? new Date(G.getTime() + G.getTimezoneOffset() * 6e4) : G;
    }
    return t.modelType ? t.modelType === "date" || t.modelType === "timestamp" ? a(new Date(Z)) : t.modelType === "format" && (typeof t.format == "string" || !t.format) ? cy(Z, o(), /* @__PURE__ */ new Date()) : a(cy(Z, t.modelType, /* @__PURE__ */ new Date())) : a(new Date(Z));
  }, le = (Z) => t.utc ? JW(Z, t.utc === "preserve") : t.modelType ? t.modelType === "timestamp" ? +i(Z) : t.modelType === "format" && (typeof t.format == "string" || !t.format) ? s(i(Z)) : s(i(Z), t.modelType) : i(Z), ue = (Z) => {
    e("update:model-value", Z);
  }, Te = (Z) => Array.isArray(r.value) ? [
    Z(r.value[0]),
    r.value[1] ? Z(r.value[1]) : c()
  ] : Z(Mr(r.value)), Ne = (Z) => ue(Mr(Te(Z)));
  return {
    inputValue: g,
    internalModelValue: r,
    checkBeforeEmit: () => r.value ? t.range ? t.partialRange ? r.value.length >= 1 : r.value.length === 2 : !!r.value : !1,
    parseExternalModelValue: Fe,
    formatInputValue: X,
    emitModelValue: () => (X(), t.monthPicker ? Ne(S) : t.timePicker ? Ne(y) : t.yearPicker ? Ne(gn) : t.weekPicker ? ue(r.value) : ue(te()))
  };
}, Bz = (e, t) => {
  const { validateMonthYearInRange: n, validateMaxDate: r, validateMinDate: i, defaults: a } = Ci(e), s = (h, p) => {
    let g = h;
    return a.value.filters.months.includes(mn(g)) ? (g = p ? Sa(h, 1) : Xr(h, 1), s(g, p)) : g;
  }, o = (h, p) => {
    let g = h;
    return a.value.filters.years.includes(gn(g)) ? (g = p ? x2(h, 1) : Aj(h, 1), o(g, p)) : g;
  }, l = (h) => {
    const p = Hr(/* @__PURE__ */ new Date(), { month: e.month, year: e.year });
    let g = h ? Sa(p, 1) : Xr(p, 1), v = mn(g), y = gn(g);
    a.value.filters.months.includes(v) && (g = s(g, h), v = mn(g), y = gn(g)), a.value.filters.years.includes(y) && (g = o(g, h), y = gn(g)), n(v, y, h, e.preventMinMaxNavigation) && c(v, y);
  }, c = (h, p) => {
    t("update-month-year", { month: h, year: p });
  }, f = ce(() => (h) => {
    if (!e.preventMinMaxNavigation || h && !e.maxDate || !h && !e.minDate)
      return !1;
    const p = Hr(/* @__PURE__ */ new Date(), { month: e.month, year: e.year }), g = h ? Sa(p, 1) : Xr(p, 1), v = [mn(g), gn(g)];
    return h ? !r(...v) : !i(...v);
  });
  return { handleMonthYearChange: l, isDisabled: f, updateMonthYear: c };
};
var dh = /* @__PURE__ */ ((e) => (e.center = "center", e.left = "left", e.right = "right", e))(dh || {});
const Uz = (e, t, n, r) => {
  const i = ge({
    top: "0",
    left: "0",
    transform: "none"
  }), a = ge(!1), s = vh(r, "teleportCenter");
  Ln(s, () => {
    S();
  });
  const o = (T) => {
    const N = T.getBoundingClientRect();
    return {
      left: N.left + window.scrollX,
      top: N.top + window.scrollY
    };
  }, l = (T) => {
    const N = T.getBoundingClientRect();
    let $ = 0, ne = 0;
    for (; T && !isNaN(T.offsetLeft) && !isNaN(T.offsetTop); )
      $ += T.offsetLeft - T.scrollLeft, ne = N.top + T.scrollTop, T = T.offsetParent;
    return { top: ne, left: $ };
  }, c = (T, N) => {
    i.value.left = `${T + N}px`, i.value.transform = "translateX(-100%)";
  }, f = (T) => {
    i.value.left = `${T}px`, i.value.transform = "translateX(0)";
  }, h = (T, N, $ = !1) => {
    r.position === dh.left && f(T), r.position === dh.right && c(T, N), r.position === dh.center && (i.value.left = `${T + N / 2}px`, i.value.transform = $ ? "translate(-50%, -50%)" : "translateX(-50%)");
  }, p = (T) => {
    const { width: N, height: $ } = T.getBoundingClientRect(), { top: ne, left: Y } = r.altPosition ? l(T) : o(T);
    return { top: ne, left: Y, width: N, height: $ };
  }, g = () => {
    const T = lr(t);
    if (T) {
      const { top: N, left: $, width: ne, height: Y } = p(T);
      i.value.top = `${N + Y / 2}px`, i.value.transform = "translateY(-50%)", h($, ne, !0);
    }
  }, v = () => {
    i.value.left = "50%", i.value.top = "50%", i.value.transform = "translate(-50%, -50%)", i.value.position = "fixed";
  }, y = () => {
    const T = lr(t);
    i.value = r.altPosition(T);
  }, S = (T = !0) => {
    if (!r.inline)
      return s.value ? v() : r.altPosition && typeof r.altPosition != "boolean" ? y() : (T && n("recalculate-position"), M());
  }, x = ({
    inputEl: T,
    menuEl: N,
    left: $,
    width: ne
  }) => {
    window.screen.width > 768 && h($, ne), C(T, N);
  }, E = (T, N) => {
    const { top: $, left: ne, height: Y, width: te } = p(T);
    i.value.top = `${Y + $ + +r.offset}px`, x({ inputEl: T, menuEl: N, left: ne, width: te }), a.value = !1;
  }, w = (T, N) => {
    const { top: $, left: ne, width: Y } = p(T), { height: te } = N.getBoundingClientRect();
    i.value.top = `${$ - te - +r.offset}px`, x({ inputEl: T, menuEl: N, left: ne, width: Y }), a.value = !0;
  }, C = (T, N) => {
    if (r.autoPosition) {
      const { left: $, width: ne } = p(T), { left: Y, right: te } = N.getBoundingClientRect();
      if (Y < 0)
        return f($);
      if (te > document.documentElement.clientWidth)
        return c($, ne);
    }
  }, P = (T, N) => {
    const { height: $ } = N.getBoundingClientRect(), { top: ne, height: Y } = T.getBoundingClientRect(), te = window.innerHeight - ne - Y, _e = ne;
    return $ <= te ? E(T, N) : $ > te && $ <= _e ? w(T, N) : te >= _e ? E(T, N) : w(T, N);
  }, M = () => {
    const T = lr(t), N = lr(e);
    if (T && N)
      return r.autoPosition ? P(T, N) : E(T, N);
  };
  return { openOnTop: a, menuPosition: i, setMenuPosition: S, setInitialPosition: g };
}, $l = [
  { name: "clock-icon", use: ["time", "calendar"] },
  { name: "arrow-left", use: ["month-year", "calendar"] },
  { name: "arrow-right", use: ["month-year", "calendar"] },
  { name: "arrow-up", use: ["time", "calendar"] },
  { name: "arrow-down", use: ["time", "calendar"] },
  { name: "calendar-icon", use: ["month-year", "time", "calendar"] },
  { name: "day", use: ["calendar"] },
  { name: "month-overlay-value", use: ["calendar", "month-year"] },
  { name: "year-overlay-value", use: ["calendar", "month-year"] },
  { name: "year-overlay", use: ["month-year"] },
  { name: "month-overlay", use: ["month-year"] },
  { name: "month-overlay-header", use: ["month-year"] },
  { name: "year-overlay-header", use: ["month-year"] },
  { name: "hours-overlay-value", use: ["calendar", "time"] },
  { name: "minutes-overlay-value", use: ["calendar", "time"] },
  { name: "seconds-overlay-value", use: ["calendar", "time"] },
  { name: "hours", use: ["calendar", "time"] },
  { name: "minutes", use: ["calendar", "time"] },
  { name: "month", use: ["calendar", "month-year"] },
  { name: "year", use: ["calendar", "month-year"] },
  { name: "action-select", use: ["action"] },
  { name: "action-preview", use: ["action"] },
  { name: "calendar-header", use: ["calendar"] },
  { name: "marker-tooltip", use: ["calendar"] },
  { name: "now-button", use: [] },
  { name: "time-picker-overlay", use: ["calendar", "time"] },
  { name: "am-pm-button", use: ["calendar", "time"] },
  { name: "left-sidebar", use: ["menu"] },
  { name: "right-sidebar", use: ["menu"] },
  { name: "month-year", use: ["month-year"] },
  { name: "time-picker", use: ["menu"] },
  { name: "action-row", use: ["action"] }
], qz = [{ name: "trigger" }, { name: "input-icon" }, { name: "clear-icon" }, { name: "dp-input" }], jz = {
  all: () => $l,
  monthYear: () => $l.filter((e) => e.use.includes("month-year")),
  input: () => qz,
  timePicker: () => $l.filter((e) => e.use.includes("time")),
  action: () => $l.filter((e) => e.use.includes("action")),
  calendar: () => $l.filter((e) => e.use.includes("calendar")),
  menu: () => $l.filter((e) => e.use.includes("menu"))
}, $o = (e, t, n) => {
  const r = [];
  return jz[t]().forEach((i) => {
    e[i.name] && r.push(i.name);
  }), n && n.length && n.forEach((i) => {
    i.slot && r.push(i.slot);
  }), r;
}, fp = (e) => ({ transitionName: ce(() => (t) => e && typeof e != "boolean" ? t ? e.open : e.close : ""), showTransition: !!e }), ao = {
  multiCalendars: { type: [Boolean, Number, String], default: null },
  modelValue: { type: [String, Date, Array, Object, Number], default: null },
  modelType: { type: String, default: null },
  position: { type: String, default: "center" },
  dark: { type: Boolean, default: !1 },
  format: {
    type: [String, Function],
    default: () => null
  },
  closeOnScroll: { type: Boolean, default: !1 },
  autoPosition: { type: Boolean, default: !0 },
  closeOnAutoApply: { type: Boolean, default: !0 },
  teleport: { type: [String, Object], default: "body" },
  altPosition: { type: [Boolean, Function], default: !1 },
  transitions: { type: [Boolean, Object], default: !0 },
  formatLocale: { type: Object, default: null },
  utc: { type: [Boolean, String], default: !1 },
  ariaLabels: { type: Object, default: () => ({}) },
  offset: { type: [Number, String], default: 10 },
  hideNavigation: { type: Array, default: () => [] },
  timezone: { type: String, default: null },
  vertical: { type: Boolean, default: !1 },
  disableMonthYearSelect: { type: Boolean, default: !1 },
  menuClassName: { type: String, default: null },
  dayClass: { type: Function, default: null },
  yearRange: { type: Array, default: () => [1900, 2100] },
  multiCalendarsSolo: { type: Boolean, default: !1 },
  calendarCellClassName: { type: String, default: null },
  enableTimePicker: { type: Boolean, default: !0 },
  autoApply: { type: Boolean, default: !1 },
  disabledDates: { type: [Array, Function], default: () => [] },
  monthNameFormat: { type: String, default: "short" },
  startDate: { type: [Date, String], default: null },
  startTime: { type: [Object, Array], default: null },
  monthYearComponent: { type: Object, default: null },
  timePickerComponent: { type: Object, default: null },
  actionRowComponent: { type: Object, default: null },
  hideOffsetDates: { type: Boolean, default: !1 },
  autoRange: { type: [Number, String], default: null },
  noToday: { type: Boolean, default: !1 },
  disabledWeekDays: { type: Array, default: () => [] },
  allowedDates: { type: Array, default: () => [] },
  showNowButton: { type: Boolean, default: !1 },
  nowButtonLabel: { type: String, default: "Now" },
  markers: { type: Array, default: () => [] },
  modeHeight: { type: [Number, String], default: 255 },
  escClose: { type: Boolean, default: !0 },
  spaceConfirm: { type: Boolean, default: !0 },
  monthChangeOnArrows: { type: Boolean, default: !0 },
  presetRanges: { type: Array, default: () => [] },
  flow: { type: Array, default: () => [] },
  preventMinMaxNavigation: { type: Boolean, default: !1 },
  minRange: { type: [Number, String], default: null },
  maxRange: { type: [Number, String], default: null },
  multiDatesLimit: { type: [Number, String], default: null },
  reverseYears: { type: Boolean, default: !1 },
  keepActionRow: { type: Boolean, default: !1 },
  weekPicker: { type: Boolean, default: !1 },
  filters: { type: Object, default: () => ({}) },
  arrowNavigation: { type: Boolean, default: !1 },
  multiStatic: { type: Boolean, default: !0 },
  disableTimeRangeValidation: { type: Boolean, default: !1 },
  highlight: {
    type: [Array, Function],
    default: null
  },
  highlightWeekDays: {
    type: Array,
    default: null
  },
  highlightDisabledDays: { type: Boolean, default: !1 },
  teleportCenter: { type: Boolean, default: !1 },
  locale: { type: String, default: "en-Us" },
  weekNumName: { type: String, default: "W" },
  weekStart: { type: [Number, String], default: 1 },
  weekNumbers: { type: Boolean, default: !1 },
  calendarClassName: { type: String, default: null },
  noSwipe: { type: Boolean, default: !1 },
  monthChangeOnScroll: { type: [Boolean, String], default: !0 },
  dayNames: {
    type: [Function, Array],
    default: null
  },
  monthPicker: { type: Boolean, default: !1 },
  customProps: { type: Object, default: null },
  yearPicker: { type: Boolean, default: !1 },
  modelAuto: { type: Boolean, default: !1 },
  selectText: { type: String, default: "Select" },
  cancelText: { type: String, default: "Cancel" },
  previewFormat: {
    type: [String, Function],
    default: () => ""
  },
  multiDates: { type: Boolean, default: !1 },
  partialRange: { type: Boolean, default: !0 },
  ignoreTimeValidation: { type: Boolean, default: !1 },
  minDate: { type: [Date, String], default: null },
  maxDate: { type: [Date, String], default: null },
  minTime: { type: Object, default: null },
  maxTime: { type: Object, default: null },
  name: { type: String, default: null },
  placeholder: { type: String, default: "" },
  hideInputIcon: { type: Boolean, default: !1 },
  clearable: { type: Boolean, default: !0 },
  state: { type: Boolean, default: null },
  required: { type: Boolean, default: !1 },
  autocomplete: { type: String, default: "off" },
  inputClassName: { type: String, default: null },
  inlineWithInput: { type: Boolean, default: !1 },
  textInputOptions: { type: Object, default: () => null },
  fixedStart: { type: Boolean, default: !1 },
  fixedEnd: { type: Boolean, default: !1 },
  timePicker: { type: Boolean, default: !1 },
  enableSeconds: { type: Boolean, default: !1 },
  is24: { type: Boolean, default: !0 },
  noHoursOverlay: { type: Boolean, default: !1 },
  noMinutesOverlay: { type: Boolean, default: !1 },
  noSecondsOverlay: { type: Boolean, default: !1 },
  hoursGridIncrement: { type: [String, Number], default: 1 },
  minutesGridIncrement: { type: [String, Number], default: 5 },
  secondsGridIncrement: { type: [String, Number], default: 5 },
  hoursIncrement: { type: [Number, String], default: 1 },
  minutesIncrement: { type: [Number, String], default: 1 },
  secondsIncrement: { type: [Number, String], default: 1 },
  range: { type: Boolean, default: !1 },
  uid: { type: String, default: null },
  disabled: { type: Boolean, default: !1 },
  readonly: { type: Boolean, default: !1 },
  inline: { type: Boolean, default: !1 },
  textInput: { type: Boolean, default: !1 },
  onClickOutside: { type: Function, default: null },
  noDisabledRange: { type: Boolean, default: !1 },
  sixWeeks: { type: Boolean, default: !1 }
}, Wz = ["aria-label", "aria-disabled", "aria-readonly"], zz = {
  key: 1,
  class: "dp__input_wrap"
}, Hz = ["id", "name", "inputmode", "placeholder", "disabled", "readonly", "required", "value", "autocomplete", "onKeydown"], Gz = {
  key: 2,
  class: "dp__input_icon"
}, Yz = {
  key: 4,
  class: "dp__clear_icon"
}, Kz = /* @__PURE__ */ dt({
  __name: "DatepickerInput",
  props: {
    isMenuOpen: { type: Boolean, default: !1 },
    inputValue: { type: String, default: "" },
    ...ao
  },
  emits: [
    "clear",
    "open",
    "update:input-value",
    "set-input-date",
    "close",
    "select-date",
    "set-empty-date",
    "toggle",
    "focus-prev",
    "focus",
    "blur"
  ],
  setup(e, { expose: t, emit: n }) {
    const r = e, { getDefaultPattern: i, isValidDate: a, defaults: s } = Ci(r), o = ge(), l = ge(null), c = ge(!1), f = ce(
      () => ({
        dp__pointer: !r.disabled && !r.readonly && !r.textInput,
        dp__disabled: r.disabled,
        dp__input_readonly: !r.textInput,
        dp__input: !0,
        dp__input_icon_pad: !r.hideInputIcon,
        dp__input_valid: r.state,
        dp__input_invalid: r.state === !1,
        dp__input_focus: c.value || r.isMenuOpen,
        dp__input_reg: !r.textInput,
        [r.inputClassName]: !!r.inputClassName
      })
    ), h = () => {
      n("set-input-date", null), r.autoApply && (n("set-empty-date"), o.value = null);
    }, p = (T) => {
      var N;
      return QW(T, ((N = s.value.textInputOptions) == null ? void 0 : N.format) || i());
    }, g = (T) => {
      const { rangeSeparator: N } = s.value.textInputOptions, [$, ne] = T.split(`${N}`);
      if ($) {
        const Y = p($.trim()), te = ne ? p(ne.trim()) : null, _e = Y && te ? [Y, te] : [Y];
        o.value = Y ? _e : null;
      }
    }, v = (T) => {
      if (r.range)
        g(T);
      else if (r.multiDates) {
        const N = T.split(";");
        o.value = N.map(($) => p($.trim())).filter(($) => $);
      } else
        o.value = p(T);
    }, y = (T) => {
      var N;
      const { value: $ } = T.target;
      $ !== "" ? ((N = s.value.textInputOptions) != null && N.openMenu && !r.isMenuOpen && n("open"), v($), n("set-input-date", o.value)) : h(), n("update:input-value", $);
    }, S = () => {
      var T, N;
      (T = s.value.textInputOptions) != null && T.enterSubmit && a(o.value) && r.inputValue !== "" ? (n("set-input-date", o.value, !0), o.value = null) : (N = s.value.textInputOptions) != null && N.enterSubmit && r.inputValue === "" && (o.value = null, n("clear"));
    }, x = () => {
      var T, N;
      (T = s.value.textInputOptions) != null && T.tabSubmit && a(o.value) && r.inputValue !== "" ? (n("set-input-date", o.value, !0), o.value = null) : (N = s.value.textInputOptions) != null && N.tabSubmit && r.inputValue === "" && (o.value = null, n("clear"));
    }, E = () => {
      c.value = !0, n("focus");
    }, w = (T) => {
      var N;
      T.preventDefault(), T.stopImmediatePropagation(), T.stopPropagation(), r.textInput && (N = s.value.textInputOptions) != null && N.openMenu && !r.inlineWithInput ? r.isMenuOpen ? s.value.textInputOptions.enterSubmit && n("select-date") : n("open") : r.textInput || n("toggle");
    }, C = () => {
      c.value = !1, r.isMenuOpen || n("blur"), r.autoApply && r.textInput && o.value && (n("set-input-date", o.value), n("select-date"), o.value = null);
    }, P = () => {
      n("clear");
    }, M = (T) => {
      r.textInput || T.preventDefault();
    };
    return t({
      focusInput: () => {
        l.value && l.value.focus({ preventScroll: !0 });
      }
    }), (T, N) => {
      var $;
      return _(), O("div", {
        onClick: w,
        "aria-label": ($ = re(s).ariaLabels) == null ? void 0 : $.input,
        role: "textbox",
        "aria-multiline": "false",
        "aria-disabled": T.disabled,
        "aria-readonly": T.readonly
      }, [
        T.$slots.trigger && !T.$slots["dp-input"] && !T.inline ? xe(T.$slots, "trigger", { key: 0 }) : L("", !0),
        !T.$slots.trigger && (!T.inline || T.inlineWithInput) ? (_(), O("div", zz, [
          T.$slots["dp-input"] && !T.$slots.trigger && !T.inline ? xe(T.$slots, "dp-input", {
            key: 0,
            value: e.inputValue,
            onInput: y,
            onEnter: S,
            onTab: x,
            onClear: P
          }) : L("", !0),
          T.$slots["dp-input"] ? L("", !0) : (_(), O("input", {
            key: 1,
            ref_key: "inputRef",
            ref: l,
            id: T.uid ? `dp-input-${T.uid}` : void 0,
            name: T.name,
            class: Pe(re(f)),
            inputmode: T.textInput ? "text" : "none",
            placeholder: T.placeholder,
            disabled: T.disabled,
            readonly: T.readonly,
            required: T.required,
            value: e.inputValue,
            autocomplete: T.autocomplete,
            onInput: y,
            onKeydown: [
              bt(w, ["enter"]),
              bt(x, ["tab"])
            ],
            onBlur: C,
            onFocus: E,
            onKeypress: M
          }, null, 42, Hz)),
          T.$slots["input-icon"] && !T.hideInputIcon ? (_(), O("span", Gz, [
            xe(T.$slots, "input-icon")
          ])) : L("", !0),
          !T.$slots["input-icon"] && !T.hideInputIcon && !T.$slots["dp-input"] ? (_(), ae(re(dp), {
            key: 3,
            class: "dp__input_icon dp__input_icons"
          })) : L("", !0),
          T.$slots["clear-icon"] && e.inputValue && T.clearable && !T.disabled && !T.readonly ? (_(), O("span", Yz, [
            xe(T.$slots, "clear-icon", { clear: P })
          ])) : L("", !0),
          T.clearable && !T.$slots["clear-icon"] && e.inputValue && !T.disabled && !T.readonly ? (_(), ae(re(CW), {
            key: 5,
            class: "dp__clear_icon dp__input_icons",
            "data-test": "clear-icon",
            onClick: sn(P, ["stop", "prevent"])
          }, null, 8, ["onClick"])) : L("", !0)
        ])) : L("", !0)
      ], 8, Wz);
    };
  }
}), Xz = { class: "dp__selection_preview" }, Zz = { class: "dp__action_buttons" }, Qz = ["onKeydown"], Jz = /* @__PURE__ */ dt({
  __name: "ActionRow",
  props: {
    calendarWidth: { type: Number, default: 0 },
    menuMount: { type: Boolean, default: !1 },
    internalModelValue: { type: [Date, Array], default: null },
    ...ao
  },
  emits: ["close-picker", "select-date", "invalid-select"],
  setup(e, { emit: t }) {
    const n = e, { formatDate: r, isValidTime: i, defaults: a } = Ci(n), { buildMatrix: s } = io(), o = ge(null), l = ge(null);
    Ft(() => {
      n.arrowNavigation && s([lr(o), lr(l)], "actionRow");
    });
    const c = ce(() => n.range && !n.partialRange && n.internalModelValue ? n.internalModelValue.length === 2 : !0), f = ce(() => !p.value || !g.value || !c.value), h = ce(() => ({
      dp__action: !0,
      dp__select: !0,
      dp__action_disabled: f.value
    })), p = ce(() => !n.enableTimePicker || n.ignoreTimeValidation ? !0 : i(n.internalModelValue)), g = ce(() => n.monthPicker ? x(n.internalModelValue) : !0), v = () => {
      const w = a.value.previewFormat;
      return n.timePicker || n.monthPicker, w(Mr(n.internalModelValue));
    }, y = () => {
      const w = n.internalModelValue;
      return a.value.multiCalendars > 0 ? `${r(w[0])} - ${r(w[1])}` : [r(w[0]), r(w[1])];
    }, S = ce(() => !n.internalModelValue || !n.menuMount ? "" : typeof a.value.previewFormat == "string" ? Array.isArray(n.internalModelValue) ? n.internalModelValue.length === 2 && n.internalModelValue[1] ? y() : n.multiDates ? n.internalModelValue.map((w) => `${r(w)}`) : n.modelAuto ? `${r(n.internalModelValue[0])}` : `${r(n.internalModelValue[0])} -` : r(n.internalModelValue) : v()), x = (w) => {
      if (!n.monthPicker)
        return !0;
      let C = !0;
      return n.minDate && n.maxDate ? Kr(Oe(w), Oe(n.minDate)) && Fr(Oe(w), Oe(n.maxDate)) : (n.minDate && (C = Kr(Oe(w), Oe(n.minDate))), n.maxDate && (C = Fr(Oe(w), Oe(n.maxDate))), C);
    }, E = () => {
      p.value && g.value && c.value ? t("select-date") : t("invalid-select");
    };
    return (w, C) => (_(), O("div", {
      class: "dp__action_row",
      style: Zn(e.calendarWidth ? { width: `${e.calendarWidth}px` } : {})
    }, [
      w.$slots["action-row"] ? xe(w.$slots, "action-row", yi(or({ key: 0 }, {
        internalModelValue: e.internalModelValue,
        disabled: re(f),
        selectDate: () => w.$emit("select-date"),
        closePicker: () => w.$emit("close-picker")
      }))) : (_(), O(Re, { key: 1 }, [
        k("div", Xz, [
          w.$slots["action-preview"] ? xe(w.$slots, "action-preview", {
            key: 0,
            value: e.internalModelValue
          }) : L("", !0),
          w.$slots["action-preview"] ? L("", !0) : (_(), O(Re, { key: 1 }, [
            Array.isArray(re(S)) ? L("", !0) : (_(), O(Re, { key: 0 }, [
              Me(j(re(S)), 1)
            ], 64)),
            Array.isArray(re(S)) ? (_(!0), O(Re, { key: 1 }, Ke(re(S), (P, M) => (_(), O("div", { key: M }, j(P), 1))), 128)) : L("", !0)
          ], 64))
        ]),
        k("div", Zz, [
          w.$slots["action-select"] ? xe(w.$slots, "action-select", {
            key: 0,
            value: e.internalModelValue
          }) : L("", !0),
          w.$slots["action-select"] ? L("", !0) : (_(), O(Re, { key: 1 }, [
            w.inline ? L("", !0) : (_(), O("span", {
              key: 0,
              class: "dp__action dp__cancel",
              ref_key: "cancelButtonRef",
              ref: o,
              tabindex: "0",
              onClick: C[0] || (C[0] = (P) => w.$emit("close-picker")),
              onKeydown: [
                C[1] || (C[1] = bt((P) => w.$emit("close-picker"), ["enter"])),
                C[2] || (C[2] = bt((P) => w.$emit("close-picker"), ["space"]))
              ]
            }, j(w.cancelText), 545)),
            k("span", {
              class: Pe(re(h)),
              tabindex: "0",
              onKeydown: [
                bt(E, ["enter"]),
                bt(E, ["space"])
              ],
              onClick: E,
              "data-test": "select-button",
              ref_key: "selectButtonRef",
              ref: l
            }, j(w.selectText), 43, Qz)
          ], 64))
        ])
      ], 64))
    ], 4));
  }
}), eH = ["aria-label"], tH = {
  class: "dp__calendar_header",
  role: "row"
}, nH = {
  key: 0,
  class: "dp__calendar_header_item",
  role: "gridcell"
}, rH = /* @__PURE__ */ k("div", { class: "dp__calendar_header_separator" }, null, -1), iH = ["aria-label"], aH = {
  key: 0,
  role: "gridcell",
  class: "dp__calendar_item dp__week_num"
}, sH = { class: "dp__cell_inner" }, oH = ["aria-selected", "aria-disabled", "aria-label", "data-test", "onClick", "onKeydown", "onMouseenter", "onMouseleave"], lH = /* @__PURE__ */ k("div", { class: "dp__arrow_bottom_tp" }, null, -1), uH = /* @__PURE__ */ dt({
  __name: "Calendar",
  props: {
    mappedDates: { type: Array, default: () => [] },
    getWeekNum: {
      type: Function,
      default: () => ""
    },
    specificMode: { type: Boolean, default: !1 },
    instance: { type: Number, default: 0 },
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    ...ao
  },
  emits: [
    "select-date",
    "set-hover-date",
    "handle-scroll",
    "mount",
    "handle-swipe",
    "handle-space",
    "tooltip-open",
    "tooltip-close"
  ],
  setup(e, { expose: t, emit: n }) {
    const r = e, { buildMultiLevelMatrix: i } = io(), { setDateMonthOrYear: a, defaults: s } = Ci(r), o = ge(null), l = ge({ bottom: "", left: "", transform: "" }), c = ge([]), f = ge(null), h = ge(!0), p = ge(""), g = ge({ startX: 0, endX: 0, startY: 0, endY: 0 }), v = ce(() => r.dayNames ? Array.isArray(r.dayNames) ? r.dayNames : r.dayNames(r.locale, +r.weekStart) : Az(r.locale, +r.weekStart));
    Ft(() => {
      n("mount", { cmp: "calendar", refs: c }), r.noSwipe || f.value && (f.value.addEventListener("touchstart", $, { passive: !1 }), f.value.addEventListener("touchend", ne, { passive: !1 }), f.value.addEventListener("touchmove", Y, { passive: !1 })), r.monthChangeOnScroll && f.value && f.value.addEventListener("wheel", Fe, { passive: !1 });
    });
    const y = (J) => J ? r.vertical ? "vNext" : "next" : r.vertical ? "vPrevious" : "previous", S = (J, oe) => {
      if (r.transitions) {
        const A = Aa(a(Oe(), r.month, r.year));
        p.value = Kr(Aa(a(Oe(), J, oe)), A) ? s.value.transitions[y(!0)] : s.value.transitions[y(!1)], h.value = !1, Nn(() => {
          h.value = !0;
        });
      }
    }, x = ce(
      () => ({
        dp__calendar_wrap: !0,
        [r.calendarClassName]: !!r.calendarClassName
      })
    ), E = ce(() => (J) => {
      const oe = Oz(J);
      return {
        dp__marker_dot: oe.type === "dot",
        dp__marker_line: oe.type === "line"
      };
    }), w = ce(() => (J) => _n(J, o.value)), C = ce(() => ({
      dp__calendar: !0,
      dp__calendar_next: s.value.multiCalendars > 0 && r.instance !== 0
    })), P = ce(() => (J) => r.hideOffsetDates ? J.current : !0), M = ce(() => r.specificMode ? { height: `${r.modeHeight}px` } : void 0), T = (J, oe, A) => {
      var X, pe;
      if (n("set-hover-date", J), (pe = (X = J.marker) == null ? void 0 : X.tooltip) != null && pe.length) {
        const le = lr(c.value[oe][A]);
        if (le) {
          const { width: ue, height: Te } = le.getBoundingClientRect();
          l.value = {
            bottom: `${Te}px`,
            left: `${ue / 2}px`,
            transform: "translateX(-50%)"
          }, o.value = J.value, n("tooltip-open", J.value);
        }
      }
    }, N = (J) => {
      o.value && (o.value = null, n("tooltip-close", J.value));
    }, $ = (J) => {
      g.value.startX = J.changedTouches[0].screenX, g.value.startY = J.changedTouches[0].screenY;
    }, ne = (J) => {
      g.value.endX = J.changedTouches[0].screenX, g.value.endY = J.changedTouches[0].screenY, te();
    }, Y = (J) => {
      r.vertical && !r.inline && J.preventDefault();
    }, te = () => {
      const J = r.vertical ? "Y" : "X";
      Math.abs(g.value[`start${J}`] - g.value[`end${J}`]) > 10 && n("handle-swipe", g.value[`start${J}`] > g.value[`end${J}`] ? "right" : "left");
    }, _e = (J, oe, A) => {
      J && (Array.isArray(c.value[oe]) ? c.value[oe][A] = J : c.value[oe] = [J]), r.arrowNavigation && i(c.value, "calendar");
    }, Fe = (J) => {
      r.monthChangeOnScroll && (J.preventDefault(), n("handle-scroll", J));
    };
    return t({ triggerTransition: S }), (J, oe) => {
      var A;
      return _(), O("div", {
        class: Pe(re(C))
      }, [
        k("div", {
          style: Zn(re(M))
        }, [
          e.specificMode ? L("", !0) : (_(), O("div", {
            key: 0,
            ref_key: "calendarWrapRef",
            ref: f,
            class: Pe(re(x)),
            role: "grid",
            "aria-label": (A = re(s).ariaLabels) == null ? void 0 : A.calendarWrap
          }, [
            k("div", tH, [
              J.weekNumbers ? (_(), O("div", nH, j(J.weekNumName), 1)) : L("", !0),
              (_(!0), O(Re, null, Ke(re(v), (X, pe) => (_(), O("div", {
                class: "dp__calendar_header_item",
                role: "gridcell",
                key: pe,
                "data-test": "calendar-header"
              }, [
                J.$slots["calendar-header"] ? xe(J.$slots, "calendar-header", {
                  key: 0,
                  day: X,
                  index: pe
                }) : L("", !0),
                J.$slots["calendar-header"] ? L("", !0) : (_(), O(Re, { key: 1 }, [
                  Me(j(X), 1)
                ], 64))
              ]))), 128))
            ]),
            rH,
            W(Ea, {
              name: p.value,
              css: !!J.transitions
            }, {
              default: ie(() => {
                var X;
                return [
                  h.value ? (_(), O("div", {
                    key: 0,
                    class: "dp__calendar",
                    role: "grid",
                    "aria-label": (X = re(s).ariaLabels) == null ? void 0 : X.calendarDays
                  }, [
                    (_(!0), O(Re, null, Ke(e.mappedDates, (pe, le) => (_(), O("div", {
                      class: "dp__calendar_row",
                      role: "row",
                      key: le
                    }, [
                      J.weekNumbers ? (_(), O("div", aH, [
                        k("div", sH, j(e.getWeekNum(pe.days)), 1)
                      ])) : L("", !0),
                      (_(!0), O(Re, null, Ke(pe.days, (ue, Te) => {
                        var Ne, Z, G;
                        return _(), O("div", {
                          role: "gridcell",
                          class: "dp__calendar_item",
                          ref_for: !0,
                          ref: (se) => _e(se, le, Te),
                          key: Te + le,
                          "aria-selected": ue.classData.dp__active_date || ue.classData.dp__range_start || ue.classData.dp__range_start,
                          "aria-disabled": ue.classData.dp__cell_disabled,
                          "aria-label": (Z = (Ne = re(s).ariaLabels) == null ? void 0 : Ne.day) == null ? void 0 : Z.call(Ne, ue),
                          tabindex: "0",
                          "data-test": ue.value,
                          onClick: sn((se) => J.$emit("select-date", ue), ["stop", "prevent"]),
                          onKeydown: [
                            bt((se) => J.$emit("select-date", ue), ["enter"]),
                            bt((se) => J.$emit("handle-space", ue), ["space"])
                          ],
                          onMouseenter: (se) => T(ue, le, Te),
                          onMouseleave: (se) => N(ue)
                        }, [
                          k("div", {
                            class: Pe(["dp__cell_inner", ue.classData])
                          }, [
                            J.$slots.day && re(P)(ue) ? xe(J.$slots, "day", {
                              key: 0,
                              day: +ue.text,
                              date: ue.value
                            }) : L("", !0),
                            J.$slots.day ? L("", !0) : (_(), O(Re, { key: 1 }, [
                              Me(j(ue.text), 1)
                            ], 64)),
                            ue.marker && re(P)(ue) ? (_(), O("div", {
                              key: 2,
                              class: Pe(re(E)(ue.marker)),
                              style: Zn(ue.marker.color ? { backgroundColor: ue.marker.color } : {})
                            }, null, 6)) : L("", !0),
                            re(w)(ue.value) ? (_(), O("div", {
                              key: 3,
                              class: "dp__marker_tooltip",
                              style: Zn(l.value)
                            }, [
                              (G = ue.marker) != null && G.tooltip ? (_(), O("div", {
                                key: 0,
                                class: "dp__tooltip_content",
                                onClick: oe[0] || (oe[0] = sn(() => {
                                }, ["stop"]))
                              }, [
                                (_(!0), O(Re, null, Ke(ue.marker.tooltip, (se, St) => (_(), O("div", {
                                  key: St,
                                  class: "dp__tooltip_text"
                                }, [
                                  J.$slots["marker-tooltip"] ? xe(J.$slots, "marker-tooltip", {
                                    key: 0,
                                    tooltip: se,
                                    day: ue.value
                                  }) : L("", !0),
                                  J.$slots["marker-tooltip"] ? L("", !0) : (_(), O(Re, { key: 1 }, [
                                    k("div", {
                                      class: "dp__tooltip_mark",
                                      style: Zn(se.color ? { backgroundColor: se.color } : {})
                                    }, null, 4),
                                    k("div", null, j(se.text), 1)
                                  ], 64))
                                ]))), 128)),
                                lH
                              ])) : L("", !0)
                            ], 4)) : L("", !0)
                          ], 2)
                        ], 40, oH);
                      }), 128))
                    ]))), 128))
                  ], 8, iH)) : L("", !0)
                ];
              }),
              _: 3
            }, 8, ["name", "css"])
          ], 10, eH))
        ], 4)
      ], 2);
    };
  }
}), cH = ["aria-label", "aria-disabled"], Og = /* @__PURE__ */ dt({
  __name: "ActionIcon",
  props: {
    ariaLabel: { type: String, default: "" },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["activate", "set-ref"],
  setup(e, { emit: t }) {
    const n = ge(null);
    return Ft(() => t("set-ref", n)), (r, i) => (_(), O("div", {
      class: "dp__month_year_col_nav",
      onClick: i[0] || (i[0] = (a) => r.$emit("activate")),
      onKeydown: [
        i[1] || (i[1] = bt((a) => r.$emit("activate"), ["enter"])),
        i[2] || (i[2] = bt((a) => r.$emit("activate"), ["space"]))
      ],
      tabindex: "0",
      role: "button",
      "aria-label": e.ariaLabel,
      "aria-disabled": e.disabled,
      ref_key: "elRef",
      ref: n
    }, [
      k("div", {
        class: Pe(["dp__inner_nav", { dp__inner_nav_disabled: e.disabled }])
      }, [
        xe(r.$slots, "default")
      ], 2)
    ], 40, cH));
  }
}), dH = ["onKeydown"], fH = { class: "dp__selection_grid_header" }, hH = ["aria-selected", "aria-disabled", "data-test", "onClick", "onKeydown", "onMouseover"], pH = ["aria-label", "onKeydown"], Tc = /* @__PURE__ */ dt({
  __name: "SelectionGrid",
  props: {
    items: { type: Array, default: () => [] },
    modelValue: { type: [String, Number], default: null },
    multiModelValue: { type: Array, default: () => [] },
    disabledValues: { type: Array, default: () => [] },
    minValue: { type: [Number, String], default: null },
    maxValue: { type: [Number, String], default: null },
    year: { type: Number, default: 0 },
    skipActive: { type: Boolean, default: !1 },
    headerRefs: { type: Array, default: () => [] },
    skipButtonRef: { type: Boolean, default: !1 },
    monthPicker: { type: Boolean, default: !1 },
    yearPicker: { type: Boolean, default: !1 },
    escClose: { type: Boolean, default: !0 },
    type: { type: String, default: null },
    arrowNavigation: { type: Boolean, default: !1 },
    autoApply: { type: Boolean, default: !1 },
    textInput: { type: Boolean, default: !1 },
    ariaLabels: { type: Object, default: () => ({}) },
    hideNavigation: { type: Array, default: () => [] }
  },
  emits: ["update:model-value", "selected", "toggle", "reset-flow"],
  setup(e, { expose: t, emit: n }) {
    const r = e, { setSelectionGrid: i, buildMultiLevelMatrix: a, setMonthPicker: s } = io(), { hideNavigationButtons: o } = Ci(r), l = ge(!1), c = ge(null), f = ge(null), h = ge([]), p = ge(), g = ge(null), v = ge(0), y = ge(null);
    q5(() => {
      c.value = null;
    }), Ft(() => {
      Nn().then(() => $()), x(), S(!0);
    }), cr(() => S(!1));
    const S = (oe) => {
      var A;
      r.arrowNavigation && ((A = r.headerRefs) != null && A.length ? s(oe) : i(oe));
    }, x = () => {
      const oe = lr(f);
      oe && (r.textInput || oe.focus({ preventScroll: !0 }), l.value = oe.clientHeight < oe.scrollHeight);
    }, E = ce(
      () => ({
        dp__overlay: !0
      })
    ), w = ce(() => ({
      dp__overlay_col: !0
    })), C = (oe) => r.skipActive ? !1 : oe.value === r.modelValue, P = ce(() => r.items.map((oe) => oe.filter((A) => A).map((A) => {
      var X, pe, le;
      const ue = r.disabledValues.some((Ne) => Ne === A.value) || N(A.value), Te = (X = r.multiModelValue) != null && X.length ? (pe = r.multiModelValue) == null ? void 0 : pe.some(
        (Ne) => _n(
          Ne,
          qo(
            r.monthPicker ? Cc(/* @__PURE__ */ new Date(), A.value) : /* @__PURE__ */ new Date(),
            r.monthPicker ? r.year : A.value
          )
        )
      ) : C(A);
      return {
        ...A,
        className: {
          dp__overlay_cell_active: Te,
          dp__overlay_cell: !Te,
          dp__overlay_cell_disabled: ue,
          dp__overlay_cell_active_disabled: ue && Te,
          dp__overlay_cell_pad: !0,
          dp__cell_in_between: (le = r.multiModelValue) != null && le.length ? Y(A.value) : !1
        }
      };
    }))), M = ce(
      () => ({
        dp__button: !0,
        dp__overlay_action: !0,
        dp__over_action_scroll: l.value,
        dp__button_bottom: r.autoApply
      })
    ), T = ce(() => {
      var oe, A;
      return {
        dp__overlay_container: !0,
        dp__container_flex: ((oe = r.items) == null ? void 0 : oe.length) <= 6,
        dp__container_block: ((A = r.items) == null ? void 0 : A.length) > 6
      };
    }), N = (oe) => {
      const A = r.maxValue || r.maxValue === 0, X = r.minValue || r.minValue === 0;
      return !A && !X ? !1 : A && X ? +oe > +r.maxValue || +oe < +r.minValue : A ? +oe > +r.maxValue : X ? +oe < +r.minValue : !1;
    }, $ = () => {
      const oe = lr(c), A = lr(f), X = lr(g), pe = lr(y), le = X ? X.getBoundingClientRect().height : 0;
      A && (v.value = A.getBoundingClientRect().height - le), oe && pe && (pe.scrollTop = oe.offsetTop - pe.offsetTop - (v.value / 2 - oe.getBoundingClientRect().height) - le);
    }, ne = (oe) => {
      !r.disabledValues.some((A) => A === oe) && !N(oe) && (n("update:model-value", oe), n("selected"));
    }, Y = (oe) => {
      const A = r.monthPicker ? r.year : oe;
      return J2(
        r.multiModelValue,
        qo(
          r.monthPicker ? Cc(/* @__PURE__ */ new Date(), p.value || 0) : /* @__PURE__ */ new Date(),
          r.monthPicker ? A : p.value || A
        ),
        qo(r.monthPicker ? Cc(/* @__PURE__ */ new Date(), oe) : /* @__PURE__ */ new Date(), A)
      );
    }, te = () => {
      n("toggle"), n("reset-flow");
    }, _e = () => {
      r.escClose && te();
    }, Fe = (oe, A, X, pe) => {
      oe && (A.value === +r.modelValue && !r.disabledValues.includes(A.value) && (c.value = oe), r.arrowNavigation && (Array.isArray(h.value[X]) ? h.value[X][pe] = oe : h.value[X] = [oe], J()));
    }, J = () => {
      var oe, A;
      const X = (oe = r.headerRefs) != null && oe.length ? [r.headerRefs].concat(h.value) : h.value.concat([r.skipButtonRef ? [] : [g.value]]);
      a(Mr(X), (A = r.headerRefs) != null && A.length ? "monthPicker" : "selectionGrid");
    };
    return t({ focusGrid: x }), (oe, A) => {
      var X;
      return _(), O("div", {
        ref_key: "gridWrapRef",
        ref: f,
        class: Pe(re(E)),
        role: "dialog",
        tabindex: "0",
        onKeydown: bt(_e, ["esc"])
      }, [
        k("div", {
          class: Pe(re(T)),
          ref_key: "containerRef",
          ref: y,
          role: "grid",
          style: Zn({ height: `${v.value}px` })
        }, [
          k("div", fH, [
            xe(oe.$slots, "header")
          ]),
          oe.$slots.overlay ? xe(oe.$slots, "overlay", { key: 0 }) : (_(!0), O(Re, { key: 1 }, Ke(re(P), (pe, le) => (_(), O("div", {
            class: "dp__overlay_row",
            key: le,
            role: "row"
          }, [
            (_(!0), O(Re, null, Ke(pe, (ue, Te) => (_(), O("div", {
              role: "gridcell",
              class: Pe(re(w)),
              key: ue.value,
              "aria-selected": ue.value === e.modelValue && !e.disabledValues.includes(ue.value),
              "aria-disabled": ue.className.dp__overlay_cell_disabled,
              ref_for: !0,
              ref: (Ne) => Fe(Ne, ue, le, Te),
              tabindex: "0",
              "data-test": ue.text,
              onClick: (Ne) => ne(ue.value),
              onKeydown: [
                bt((Ne) => ne(ue.value), ["enter"]),
                bt((Ne) => ne(ue.value), ["space"])
              ],
              onMouseover: (Ne) => p.value = ue.value
            }, [
              k("div", {
                class: Pe(ue.className)
              }, [
                oe.$slots.item ? xe(oe.$slots, "item", {
                  key: 0,
                  item: ue
                }) : L("", !0),
                oe.$slots.item ? L("", !0) : (_(), O(Re, { key: 1 }, [
                  Me(j(ue.text), 1)
                ], 64))
              ], 2)
            ], 42, hH))), 128))
          ]))), 128))
        ], 6),
        oe.$slots["button-icon"] ? ur((_(), O("div", {
          key: 0,
          role: "button",
          "aria-label": (X = e.ariaLabels) == null ? void 0 : X.toggleOverlay,
          class: Pe(re(M)),
          tabindex: "0",
          ref_key: "toggleButton",
          ref: g,
          onClick: te,
          onKeydown: bt(te, ["enter"])
        }, [
          xe(oe.$slots, "button-icon")
        ], 42, pH)), [
          [Ws, !re(o)(e.type)]
        ]) : L("", !0)
      ], 42, dH);
    };
  }
}), mH = ["aria-label"], rS = /* @__PURE__ */ dt({
  __name: "RegularPicker",
  props: {
    ariaLabel: { type: String, default: "" },
    showSelectionGrid: { type: Boolean, default: !1 },
    modelValue: { type: Number, default: null },
    items: { type: Array, default: () => [] },
    disabledValues: { type: Array, default: () => [] },
    minValue: { type: Number, default: null },
    maxValue: { type: Number, default: null },
    slotName: { type: String, default: "" },
    overlaySlot: { type: String, default: "" },
    headerRefs: { type: Array, default: () => [] },
    escClose: { type: Boolean, default: !0 },
    type: { type: String, default: null },
    transitions: { type: [Object, Boolean], default: !1 },
    arrowNavigation: { type: Boolean, default: !1 },
    autoApply: { type: Boolean, default: !1 },
    textInput: { type: Boolean, default: !1 },
    ariaLabels: { type: Object, default: () => ({}) },
    hideNavigation: { type: Array, default: () => [] }
  },
  emits: ["update:model-value", "toggle", "set-ref"],
  setup(e, { emit: t }) {
    const n = e, { transitionName: r, showTransition: i } = fp(n.transitions), a = ge(null);
    return Ft(() => t("set-ref", a)), (s, o) => (_(), O(Re, null, [
      k("div", {
        class: "dp__month_year_select",
        onClick: o[0] || (o[0] = (l) => s.$emit("toggle")),
        onKeydown: [
          o[1] || (o[1] = bt((l) => s.$emit("toggle"), ["enter"])),
          o[2] || (o[2] = bt((l) => s.$emit("toggle"), ["space"]))
        ],
        role: "button",
        "aria-label": e.ariaLabel,
        tabindex: "0",
        ref_key: "elRef",
        ref: a
      }, [
        xe(s.$slots, "default")
      ], 40, mH),
      W(Ea, {
        name: re(r)(e.showSelectionGrid),
        css: re(i)
      }, {
        default: ie(() => [
          e.showSelectionGrid ? (_(), ae(Tc, or({ key: 0 }, {
            modelValue: e.modelValue,
            items: e.items,
            disabledValues: e.disabledValues,
            minValue: e.minValue,
            maxValue: e.maxValue,
            escClose: e.escClose,
            type: e.type,
            arrowNavigation: e.arrowNavigation,
            textInput: e.textInput,
            autoApply: e.autoApply,
            ariaLabels: e.ariaLabels,
            hideNavigation: e.hideNavigation
          }, {
            "header-refs": [],
            "onUpdate:modelValue": o[3] || (o[3] = (l) => s.$emit("update:model-value", l)),
            onToggle: o[4] || (o[4] = (l) => s.$emit("toggle"))
          }), Gr({
            "button-icon": ie(() => [
              s.$slots["calendar-icon"] ? xe(s.$slots, "calendar-icon", { key: 0 }) : L("", !0),
              s.$slots["calendar-icon"] ? L("", !0) : (_(), ae(re(dp), { key: 1 }))
            ]),
            _: 2
          }, [
            s.$slots[e.slotName] ? {
              name: "item",
              fn: ie(({ item: l }) => [
                xe(s.$slots, e.slotName, { item: l })
              ]),
              key: "0"
            } : void 0,
            s.$slots[e.overlaySlot] ? {
              name: "overlay",
              fn: ie(() => [
                xe(s.$slots, e.overlaySlot)
              ]),
              key: "1"
            } : void 0,
            s.$slots[`${e.overlaySlot}-header`] ? {
              name: "header",
              fn: ie(() => [
                xe(s.$slots, `${e.overlaySlot}-header`)
              ]),
              key: "2"
            } : void 0
          ]), 1040)) : L("", !0)
        ]),
        _: 3
      }, 8, ["name", "css"])
    ], 64));
  }
}), gH = { class: "dp__month_year_row" }, vH = { class: "dp__month_year_wrap" }, bH = { class: "dp__month_picker_header" }, _H = ["aria-label"], yH = ["aria-label"], xH = ["aria-label"], wH = /* @__PURE__ */ dt({
  __name: "MonthYearPicker",
  props: {
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    instance: { type: Number, default: 0 },
    years: { type: Array, default: () => [] },
    months: { type: Array, default: () => [] },
    internalModelValue: { type: [Date, Array], default: null },
    ...ao
  },
  emits: ["update-month-year", "month-year-select", "mount", "reset-flow", "overlay-closed"],
  setup(e, { expose: t, emit: n }) {
    const r = e, { defaults: i } = Ci(r), { transitionName: a, showTransition: s } = fp(i.value.transitions), { buildMatrix: o } = io(), { handleMonthYearChange: l, isDisabled: c, updateMonthYear: f } = Bz(r, n), h = ge(!1), p = ge(!1), g = ge([null, null, null, null]), v = ge(null), y = ge(null), S = ge(null);
    Ft(() => {
      n("mount");
    });
    const x = (G) => ({
      get: () => r[G],
      set: (se) => {
        const St = G === "month" ? "year" : "month";
        n("update-month-year", { [G]: se, [St]: r[St] }), n("month-year-select", G === "year"), G === "month" ? le(!0) : ue(!0);
      }
    }), E = ce(x("month")), w = ce(x("year")), C = (G) => {
      const se = gn(Oe(G));
      return r.year === se;
    }, P = ce(() => r.monthPicker ? Array.isArray(r.disabledDates) ? r.disabledDates.map((G) => Oe(G)).filter((G) => C(G)).map((G) => mn(G)) : [] : []), M = ce(() => (G) => {
      const se = G === "month";
      return {
        showSelectionGrid: (se ? h : p).value,
        items: (se ? oe : A).value,
        disabledValues: i.value.filters[se ? "months" : "years"].concat(P.value),
        minValue: (se ? ne : N).value,
        maxValue: (se ? Y : $).value,
        headerRefs: se && r.monthPicker ? [v.value, y.value, S.value] : [],
        escClose: r.escClose,
        transitions: i.value.transitions,
        ariaLabels: i.value.ariaLabels,
        textInput: r.textInput,
        autoApply: r.autoApply,
        arrowNavigation: r.arrowNavigation,
        hideNavigation: r.hideNavigation
      };
    }), T = ce(() => (G) => ({
      month: r.month,
      year: r.year,
      items: G === "month" ? r.months : r.years,
      instance: r.instance,
      updateMonthYear: f,
      toggle: G === "month" ? le : ue
    })), N = ce(() => r.minDate ? gn(Oe(r.minDate)) : null), $ = ce(() => r.maxDate ? gn(Oe(r.maxDate)) : null), ne = ce(() => {
      if (r.minDate && N.value) {
        if (N.value > r.year)
          return 12;
        if (N.value === r.year)
          return mn(Oe(r.minDate));
      }
      return null;
    }), Y = ce(() => r.maxDate && $.value ? $.value < r.year ? -1 : $.value === r.year ? mn(Oe(r.maxDate)) : null : null), te = ce(() => r.range && r.internalModelValue && (r.monthPicker || r.yearPicker) ? r.internalModelValue : []), _e = (G) => G.reverse(), Fe = (G, se = !1) => {
      const St = [], Sn = (Vt) => se ? _e(Vt) : Vt;
      for (let Vt = 0; Vt < G.length; Vt += 3) {
        const nn = [G[Vt], G[Vt + 1], G[Vt + 2]];
        St.push(Sn(nn));
      }
      return se ? St.reverse() : St;
    }, J = ce(() => r.months.find((se) => se.value === r.month) || { text: "", value: 0 }), oe = ce(() => Fe(r.months)), A = ce(() => Fe(r.years, r.reverseYears)), X = ce(() => i.value.multiCalendars ? r.multiCalendarsSolo ? !0 : r.instance === 0 : !0), pe = ce(() => i.value.multiCalendars ? r.multiCalendarsSolo ? !0 : r.instance === i.value.multiCalendars - 1 : !0), le = (G = !1) => {
      Te(G), h.value = !h.value, h.value || n("overlay-closed");
    }, ue = (G = !1) => {
      Te(G), p.value = !p.value, p.value || n("overlay-closed");
    }, Te = (G) => {
      G || n("reset-flow");
    }, Ne = (G = !1) => {
      c.value(G) || n("update-month-year", {
        year: G ? r.year + 1 : r.year - 1,
        month: r.month,
        fromNav: !0
      });
    }, Z = (G, se) => {
      r.arrowNavigation && (g.value[se] = lr(G), o(g.value, "monthYear"));
    };
    return t({
      toggleMonthPicker: le,
      toggleYearPicker: ue
    }), (G, se) => {
      var St, Sn, Vt, nn, rr;
      return _(), O("div", gH, [
        G.$slots["month-year"] ? xe(G.$slots, "month-year", yi(or({ key: 0 }, { month: e.month, year: e.year, months: e.months, years: e.years, updateMonthYear: re(f), handleMonthYearChange: re(l), instance: e.instance }))) : (_(), O(Re, { key: 1 }, [
          !G.monthPicker && !G.yearPicker ? (_(), O(Re, { key: 0 }, [
            re(X) && !G.vertical ? (_(), ae(Og, {
              key: 0,
              "aria-label": (St = re(i).ariaLabels) == null ? void 0 : St.prevMonth,
              disabled: re(c)(!1),
              onActivate: se[0] || (se[0] = (Qe) => re(l)(!1)),
              onSetRef: se[1] || (se[1] = (Qe) => Z(Qe, 0))
            }, {
              default: ie(() => [
                G.$slots["arrow-left"] ? xe(G.$slots, "arrow-left", { key: 0 }) : L("", !0),
                G.$slots["arrow-left"] ? L("", !0) : (_(), ae(re(qk), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled"])) : L("", !0),
            k("div", vH, [
              W(rS, or({
                type: "month",
                "slot-name": "month-overlay-val",
                "overlay-slot": "overlay-month",
                "aria-label": (Sn = re(i).ariaLabels) == null ? void 0 : Sn.openMonthsOverlay,
                modelValue: re(E),
                "onUpdate:modelValue": se[2] || (se[2] = (Qe) => Vs(E) ? E.value = Qe : null)
              }, re(M)("month"), {
                onToggle: le,
                onSetRef: se[3] || (se[3] = (Qe) => Z(Qe, 1))
              }), Gr({
                default: ie(() => [
                  G.$slots.month ? xe(G.$slots, "month", yi(or({ key: 0 }, re(J)))) : L("", !0),
                  G.$slots.month ? L("", !0) : (_(), O(Re, { key: 1 }, [
                    Me(j(re(J).text), 1)
                  ], 64))
                ]),
                _: 2
              }, [
                G.$slots["calendar-icon"] ? {
                  name: "calendar-icon",
                  fn: ie(() => [
                    xe(G.$slots, "calendar-icon")
                  ]),
                  key: "0"
                } : void 0,
                G.$slots["month-overlay-value"] ? {
                  name: "month-overlay-val",
                  fn: ie(({ item: Qe }) => [
                    xe(G.$slots, "month-overlay-value", {
                      text: Qe.text,
                      value: Qe.value
                    })
                  ]),
                  key: "1"
                } : void 0,
                G.$slots["month-overlay"] ? {
                  name: "overlay-month",
                  fn: ie(() => [
                    xe(G.$slots, "month-overlay", yi(ns(re(T)("month"))))
                  ]),
                  key: "2"
                } : void 0,
                G.$slots["month-overlay-header"] ? {
                  name: "overlay-month-header",
                  fn: ie(() => [
                    xe(G.$slots, "month-overlay-header", { toggle: le })
                  ]),
                  key: "3"
                } : void 0
              ]), 1040, ["aria-label", "modelValue"]),
              W(rS, or({
                type: "year",
                "slot-name": "year-overlay-val",
                "overlay-slot": "overlay-year",
                "aria-label": (Vt = re(i).ariaLabels) == null ? void 0 : Vt.openYearsOverlay,
                modelValue: re(w),
                "onUpdate:modelValue": se[4] || (se[4] = (Qe) => Vs(w) ? w.value = Qe : null)
              }, re(M)("year"), {
                onToggle: ue,
                onSetRef: se[5] || (se[5] = (Qe) => Z(Qe, 2))
              }), Gr({
                default: ie(() => [
                  G.$slots.year ? xe(G.$slots, "year", {
                    key: 0,
                    year: e.year
                  }) : L("", !0),
                  G.$slots.year ? L("", !0) : (_(), O(Re, { key: 1 }, [
                    Me(j(e.year), 1)
                  ], 64))
                ]),
                _: 2
              }, [
                G.$slots["calendar-icon"] ? {
                  name: "calendar-icon",
                  fn: ie(() => [
                    xe(G.$slots, "calendar-icon")
                  ]),
                  key: "0"
                } : void 0,
                G.$slots["year-overlay-value"] ? {
                  name: "year-overlay-val",
                  fn: ie(({ item: Qe }) => [
                    xe(G.$slots, "year-overlay-value", {
                      text: Qe.text,
                      value: Qe.value
                    })
                  ]),
                  key: "1"
                } : void 0,
                G.$slots["year-overlay"] ? {
                  name: "overlay-year",
                  fn: ie(() => [
                    xe(G.$slots, "year-overlay", yi(ns(re(T)("year"))))
                  ]),
                  key: "2"
                } : void 0,
                G.$slots["year-overlay-header"] ? {
                  name: "overlay-year-header",
                  fn: ie(() => [
                    xe(G.$slots, "year-overlay-header", { toggle: ue })
                  ]),
                  key: "3"
                } : void 0
              ]), 1040, ["aria-label", "modelValue"])
            ]),
            re(X) && G.vertical ? (_(), ae(Og, {
              key: 1,
              "aria-label": (nn = re(i).ariaLabels) == null ? void 0 : nn.prevMonth,
              disabled: re(c)(!1),
              onActivate: se[6] || (se[6] = (Qe) => re(l)(!1))
            }, {
              default: ie(() => [
                G.$slots["arrow-up"] ? xe(G.$slots, "arrow-up", { key: 0 }) : L("", !0),
                G.$slots["arrow-up"] ? L("", !0) : (_(), ae(re(Z2), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled"])) : L("", !0),
            re(pe) ? (_(), ae(Og, {
              key: 2,
              ref: "rightIcon",
              disabled: re(c)(!0),
              "aria-label": (rr = re(i).ariaLabels) == null ? void 0 : rr.nextMonth,
              onActivate: se[7] || (se[7] = (Qe) => re(l)(!0)),
              onSetRef: se[8] || (se[8] = (Qe) => Z(Qe, 3))
            }, {
              default: ie(() => [
                G.$slots[G.vertical ? "arrow-down" : "arrow-right"] ? xe(G.$slots, G.vertical ? "arrow-down" : "arrow-right", { key: 0 }) : L("", !0),
                G.$slots[G.vertical ? "arrow-down" : "arrow-right"] ? L("", !0) : (_(), ae(Lr(G.vertical ? re(Q2) : re(jk)), { key: 1 }))
              ]),
              _: 3
            }, 8, ["disabled", "aria-label"])) : L("", !0)
          ], 64)) : L("", !0),
          G.monthPicker ? (_(), ae(Tc, or({ key: 1 }, re(M)("month"), {
            "skip-active": G.range,
            year: e.year,
            "multi-model-value": re(te),
            "month-picker": "",
            modelValue: re(E),
            "onUpdate:modelValue": se[17] || (se[17] = (Qe) => Vs(E) ? E.value = Qe : null),
            onToggle: le,
            onSelected: se[18] || (se[18] = (Qe) => G.$emit("overlay-closed"))
          }), Gr({
            header: ie(() => {
              var Qe, Je, Pt;
              return [
                k("div", bH, [
                  k("div", {
                    class: "dp__month_year_col_nav",
                    tabindex: "0",
                    ref_key: "mpPrevIconRef",
                    ref: v,
                    onClick: se[9] || (se[9] = (Xe) => Ne(!1)),
                    onKeydown: se[10] || (se[10] = bt((Xe) => Ne(!1), ["enter"]))
                  }, [
                    k("div", {
                      class: Pe(["dp__inner_nav", { dp__inner_nav_disabled: re(c)(!1) }]),
                      role: "button",
                      "aria-label": (Qe = re(i).ariaLabels) == null ? void 0 : Qe.prevMonth
                    }, [
                      G.$slots["arrow-left"] ? xe(G.$slots, "arrow-left", { key: 0 }) : L("", !0),
                      G.$slots["arrow-left"] ? L("", !0) : (_(), ae(re(qk), { key: 1 }))
                    ], 10, _H)
                  ], 544),
                  k("div", {
                    class: "dp__pointer",
                    role: "button",
                    ref_key: "mpYearButtonRef",
                    ref: y,
                    "aria-label": (Je = re(i).ariaLabels) == null ? void 0 : Je.openYearsOverlay,
                    tabindex: "0",
                    onClick: se[11] || (se[11] = () => ue(!1)),
                    onKeydown: se[12] || (se[12] = bt(() => ue(!1), ["enter"]))
                  }, [
                    G.$slots.year ? xe(G.$slots, "year", {
                      key: 0,
                      year: e.year
                    }) : L("", !0),
                    G.$slots.year ? L("", !0) : (_(), O(Re, { key: 1 }, [
                      Me(j(e.year), 1)
                    ], 64))
                  ], 40, yH),
                  k("div", {
                    class: "dp__month_year_col_nav",
                    tabindex: "0",
                    ref_key: "mpNextIconRef",
                    ref: S,
                    onClick: se[13] || (se[13] = (Xe) => Ne(!0)),
                    onKeydown: se[14] || (se[14] = bt((Xe) => Ne(!0), ["enter"]))
                  }, [
                    k("div", {
                      class: Pe(["dp__inner_nav", { dp__inner_nav_disabled: re(c)(!0) }]),
                      role: "button",
                      "aria-label": (Pt = re(i).ariaLabels) == null ? void 0 : Pt.nextMonth
                    }, [
                      G.$slots["arrow-right"] ? xe(G.$slots, "arrow-right", { key: 0 }) : L("", !0),
                      G.$slots["arrow-right"] ? L("", !0) : (_(), ae(re(jk), { key: 1 }))
                    ], 10, xH)
                  ], 544)
                ]),
                W(Ea, {
                  name: re(a)(p.value),
                  css: re(s)
                }, {
                  default: ie(() => [
                    p.value ? (_(), ae(Tc, or({ key: 0 }, re(M)("year"), {
                      modelValue: re(w),
                      "onUpdate:modelValue": se[15] || (se[15] = (Xe) => Vs(w) ? w.value = Xe : null),
                      onToggle: ue,
                      onSelected: se[16] || (se[16] = (Xe) => G.$emit("overlay-closed"))
                    }), Gr({
                      "button-icon": ie(() => [
                        G.$slots["calendar-icon"] ? xe(G.$slots, "calendar-icon", { key: 0 }) : L("", !0),
                        G.$slots["calendar-icon"] ? L("", !0) : (_(), ae(re(dp), { key: 1 }))
                      ]),
                      _: 2
                    }, [
                      G.$slots["year-overlay-value"] ? {
                        name: "item",
                        fn: ie(({ item: Xe }) => [
                          xe(G.$slots, "year-overlay-value", {
                            text: Xe.text,
                            value: Xe.value
                          })
                        ]),
                        key: "0"
                      } : void 0
                    ]), 1040, ["modelValue"])) : L("", !0)
                  ]),
                  _: 3
                }, 8, ["name", "css"])
              ];
            }),
            _: 2
          }, [
            G.$slots["month-overlay-value"] ? {
              name: "item",
              fn: ie(({ item: Qe }) => [
                xe(G.$slots, "month-overlay-value", {
                  text: Qe.text,
                  value: Qe.value
                })
              ]),
              key: "0"
            } : void 0
          ]), 1040, ["skip-active", "year", "multi-model-value", "modelValue"])) : L("", !0),
          G.yearPicker ? (_(), ae(Tc, or({ key: 2 }, re(M)("year"), {
            modelValue: re(w),
            "onUpdate:modelValue": se[19] || (se[19] = (Qe) => Vs(w) ? w.value = Qe : null),
            "multi-model-value": re(te),
            "skip-active": G.range,
            "skip-button-ref": "",
            "year-picker": "",
            onToggle: ue,
            onSelected: se[20] || (se[20] = (Qe) => G.$emit("overlay-closed"))
          }), Gr({ _: 2 }, [
            G.$slots["year-overlay-value"] ? {
              name: "item",
              fn: ie(({ item: Qe }) => [
                xe(G.$slots, "year-overlay-value", {
                  text: Qe.text,
                  value: Qe.value
                })
              ]),
              key: "0"
            } : void 0
          ]), 1040, ["modelValue", "multi-model-value", "skip-active"])) : L("", !0)
        ], 64))
      ]);
    };
  }
}), kH = {
  key: 0,
  class: "dp__time_input"
}, SH = ["aria-label", "onKeydown", "onClick"], CH = ["aria-label", "data-test", "onKeydown", "onClick"], TH = ["aria-label", "onKeydown", "onClick"], AH = { key: 0 }, DH = ["aria-label", "onKeydown"], EH = /* @__PURE__ */ dt({
  __name: "TimeInput",
  props: {
    hours: { type: Number, default: 0 },
    minutes: { type: Number, default: 0 },
    seconds: { type: Number, default: 0 },
    closeTimePickerBtn: { type: Object, default: null },
    order: { type: Number, default: 0 },
    ...ao
  },
  emits: [
    "set-hours",
    "set-minutes",
    "update:hours",
    "update:minutes",
    "update:seconds",
    "reset-flow",
    "mounted",
    "overlay-closed"
  ],
  setup(e, { expose: t, emit: n }) {
    const r = e, { setTimePickerElements: i, setTimePickerBackRef: a } = io(), { defaults: s } = Ci(r), { transitionName: o, showTransition: l } = fp(s.value.transitions), c = nl({
      hours: !1,
      minutes: !1,
      seconds: !1
    }), f = ge("AM"), h = ge(null), p = ge([]);
    Ft(() => {
      n("mounted");
    });
    const g = ce(() => (A) => !!(r.maxTime && r.maxTime[A] && r.maxTime[A] < r[A] + +r[`${A}Increment`])), v = ce(() => (A) => !!(r.minTime && r.minTime[A] && r.minTime[A] > r[A] - +r[`${A}Increment`])), y = (A, X) => y2(Hr(Oe(), A), X), S = (A, X) => Tj(Hr(Oe(), A), X), x = ce(
      () => ({
        dp__time_col: !0,
        dp__time_col_reg: !r.enableSeconds && r.is24,
        dp__time_col_reg_with_button: !r.enableSeconds && !r.is24,
        dp__time_col_sec: r.enableSeconds && r.is24,
        dp__time_col_sec_with_button: r.enableSeconds && !r.is24
      })
    ), E = ce(() => {
      const A = [{ type: "hours" }, { type: "", separator: !0 }, { type: "minutes" }];
      return r.enableSeconds ? A.concat([{ type: "", separator: !0 }, { type: "seconds" }]) : A;
    }), w = ce(() => E.value.filter((A) => !A.separator)), C = ce(() => (A) => {
      if (A === "hours") {
        const X = te(r.hours);
        return { text: X < 10 ? `0${X}` : `${X}`, value: X };
      }
      return { text: r[A] < 10 ? `0${r[A]}` : `${r[A]}`, value: r[A] };
    }), P = (A) => {
      const X = r.is24 ? 24 : 12, pe = A === "hours" ? X : 60, le = +r[`${A}GridIncrement`], ue = A === "hours" && !r.is24 ? le : 0, Te = [];
      for (let Ne = ue; Ne < pe; Ne += le)
        Te.push({ value: Ne, text: Ne < 10 ? `0${Ne}` : `${Ne}` });
      return A === "hours" && !r.is24 && Te.push({ value: 0, text: "12" }), Tz(Te);
    }, M = (A, X) => {
      const pe = r.minTime && r.minTime[X], le = r.maxTime && r.maxTime[X];
      return pe && le ? A < pe || A > le : pe ? A < pe : le ? A > le : !1;
    }, T = ce(() => (A) => P(A).flat().map((X) => X.value).filter((X) => M(X, A))), N = (A) => r[`no${A[0].toUpperCase() + A.slice(1)}Overlay`], $ = (A) => {
      N(A) || (c[A] = !c[A], c[A] || n("overlay-closed"));
    }, ne = (A) => A === "hours" ? es : A === "minutes" ? ts : Jl, Y = (A, X = !0) => {
      const pe = X ? y : S;
      (X ? g.value(A) : v.value(A)) || n(
        `update:${A}`,
        ne(A)(pe({ [A]: +r[A] }, { [A]: +r[`${A}Increment`] }))
      );
    }, te = (A) => r.is24 ? A : (A >= 12 ? f.value = "PM" : f.value = "AM", Pz(A)), _e = () => {
      f.value === "PM" ? (f.value = "AM", n("update:hours", r.hours - 12)) : (f.value = "PM", n("update:hours", r.hours + 12));
    }, Fe = (A) => {
      c[A] = !0;
    }, J = (A, X, pe) => {
      if (A && r.arrowNavigation) {
        Array.isArray(p.value[X]) ? p.value[X][pe] = A : p.value[X] = [A];
        const le = p.value.reduce(
          (ue, Te) => Te.map((Ne, Z) => [...ue[Z] || [], Te[Z]]),
          []
        );
        a(r.closeTimePickerBtn), h.value && (le[1] = le[1].concat(h.value)), i(le, r.order);
      }
    }, oe = (A, X) => A === "hours" && !r.is24 ? n(`update:${A}`, f.value === "PM" ? X + 12 : X) : n(`update:${A}`, X);
    return t({ openChildCmp: Fe }), (A, X) => {
      var pe;
      return A.disabled ? L("", !0) : (_(), O("div", kH, [
        (_(!0), O(Re, null, Ke(re(E), (le, ue) => {
          var Te, Ne, Z;
          return _(), O("div", {
            key: ue,
            class: Pe(re(x))
          }, [
            le.separator ? (_(), O(Re, { key: 0 }, [
              Me(" : ")
            ], 64)) : (_(), O(Re, { key: 1 }, [
              k("div", {
                class: Pe({
                  dp__inc_dec_button: !0,
                  dp__inc_dec_button_disabled: re(g)(le.type)
                }),
                role: "button",
                "data-test": "time-inc-btn",
                "aria-label": (Te = re(s).ariaLabels) == null ? void 0 : Te.incrementValue(le.type),
                tabindex: "0",
                onKeydown: [
                  bt((G) => Y(le.type), ["enter"]),
                  bt((G) => Y(le.type), ["space"])
                ],
                onClick: (G) => Y(le.type),
                ref_for: !0,
                ref: (G) => J(G, ue, 0)
              }, [
                A.$slots["arrow-up"] ? xe(A.$slots, "arrow-up", { key: 0 }) : L("", !0),
                A.$slots["arrow-up"] ? L("", !0) : (_(), ae(re(Z2), { key: 1 }))
              ], 42, SH),
              k("div", {
                role: "button",
                "aria-label": (Ne = re(s).ariaLabels) == null ? void 0 : Ne.openTpOverlay(le.type),
                class: Pe(N(le.type) ? "" : "dp__time_display"),
                tabindex: "0",
                "data-test": `${le.type}-toggle-overlay-btn`,
                onKeydown: [
                  bt((G) => $(le.type), ["enter"]),
                  bt((G) => $(le.type), ["space"])
                ],
                onClick: (G) => $(le.type),
                ref_for: !0,
                ref: (G) => J(G, ue, 1)
              }, [
                A.$slots[le.type] ? xe(A.$slots, le.type, {
                  key: 0,
                  text: re(C)(le.type).text,
                  value: re(C)(le.type).value
                }) : L("", !0),
                A.$slots[le.type] ? L("", !0) : (_(), O(Re, { key: 1 }, [
                  Me(j(re(C)(le.type).text), 1)
                ], 64))
              ], 42, CH),
              k("div", {
                class: Pe({
                  dp__inc_dec_button: !0,
                  dp__inc_dec_button_disabled: re(v)(le.type)
                }),
                role: "button",
                "data-test": "time-dec-btn",
                "aria-label": (Z = re(s).ariaLabels) == null ? void 0 : Z.decrementValue(le.type),
                tabindex: "0",
                onKeydown: [
                  bt((G) => Y(le.type, !1), ["enter"]),
                  bt((G) => Y(le.type, !1), ["space"])
                ],
                onClick: (G) => Y(le.type, !1),
                ref_for: !0,
                ref: (G) => J(G, ue, 2)
              }, [
                A.$slots["arrow-down"] ? xe(A.$slots, "arrow-down", { key: 0 }) : L("", !0),
                A.$slots["arrow-down"] ? L("", !0) : (_(), ae(re(Q2), { key: 1 }))
              ], 42, TH)
            ], 64))
          ], 2);
        }), 128)),
        A.is24 ? L("", !0) : (_(), O("div", AH, [
          A.$slots["am-pm-button"] ? xe(A.$slots, "am-pm-button", {
            key: 0,
            toggle: _e,
            value: f.value
          }) : L("", !0),
          A.$slots["am-pm-button"] ? L("", !0) : (_(), O("button", {
            key: 1,
            ref_key: "amPmButton",
            ref: h,
            type: "button",
            class: "dp__pm_am_button",
            role: "button",
            "aria-label": (pe = re(s).ariaLabels) == null ? void 0 : pe.amPmButton,
            tabindex: "0",
            onClick: _e,
            onKeydown: [
              bt(sn(_e, ["prevent"]), ["enter"]),
              bt(sn(_e, ["prevent"]), ["space"])
            ]
          }, j(f.value), 41, DH))
        ])),
        (_(!0), O(Re, null, Ke(re(w), (le, ue) => (_(), ae(Ea, {
          key: ue,
          name: re(o)(c[le.type]),
          css: re(l)
        }, {
          default: ie(() => [
            c[le.type] ? (_(), ae(Tc, {
              key: 0,
              items: P(le.type),
              "disabled-values": re(s).filters.times[le.type].concat(re(T)(le.type)),
              "esc-close": A.escClose,
              "aria-labels": re(s).ariaLabels,
              "hide-navigation": A.hideNavigation,
              "onUpdate:modelValue": (Te) => oe(le.type, Te),
              onSelected: (Te) => $(le.type),
              onToggle: (Te) => $(le.type),
              onResetFlow: X[0] || (X[0] = (Te) => A.$emit("reset-flow")),
              type: le.type
            }, Gr({
              "button-icon": ie(() => [
                A.$slots["clock-icon"] ? xe(A.$slots, "clock-icon", { key: 0 }) : L("", !0),
                A.$slots["clock-icon"] ? L("", !0) : (_(), ae(re(X2), { key: 1 }))
              ]),
              _: 2
            }, [
              A.$slots[`${le.type}-overlay-value`] ? {
                name: "item",
                fn: ie(({ item: Te }) => [
                  xe(A.$slots, `${le.type}-overlay-value`, {
                    text: Te.text,
                    value: Te.value
                  })
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["items", "disabled-values", "esc-close", "aria-labels", "hide-navigation", "onUpdate:modelValue", "onSelected", "onToggle", "type"])) : L("", !0)
          ]),
          _: 2
        }, 1032, ["name", "css"]))), 128))
      ]));
    };
  }
}), PH = ["aria-label"], OH = { class: "dp__overlay_container dp__container_flex dp__time_picker_overlay_container" }, MH = {
  key: 1,
  class: "dp__overlay_row"
}, IH = ["aria-label"], RH = /* @__PURE__ */ dt({
  __name: "TimePicker",
  props: {
    hours: { type: [Number, Array], default: 0 },
    minutes: { type: [Number, Array], default: 0 },
    seconds: { type: [Number, Array], default: 0 },
    internalModelValue: { type: [Date, Array], default: null },
    ...ao
  },
  emits: [
    "update:hours",
    "update:minutes",
    "update:seconds",
    "mount",
    "reset-flow",
    "overlay-closed"
  ],
  setup(e, { expose: t, emit: n }) {
    const r = e, { buildMatrix: i, setTimePicker: a } = io(), s = e0(), { hideNavigationButtons: o, defaults: l } = Ci(r), { transitionName: c, showTransition: f } = fp(l.value.transitions), h = ge(null), p = ge(null), g = ge([]), v = ge(null);
    Ft(() => {
      n("mount"), !r.timePicker && r.arrowNavigation ? i([lr(h.value)], "time") : a(!0, r.timePicker);
    });
    const y = ce(() => r.range && r.modelAuto ? rO(r.internalModelValue) : !0), S = ge(!1), x = (Y) => ({
      hours: Array.isArray(r.hours) ? r.hours[Y] : r.hours,
      minutes: Array.isArray(r.minutes) ? r.minutes[Y] : r.minutes,
      seconds: Array.isArray(r.seconds) ? r.seconds[Y] : r.seconds
    }), E = ce(() => {
      const Y = [];
      if (r.range)
        for (let te = 0; te < 2; te++)
          Y.push(x(te));
      else
        Y.push(x(0));
      return Y;
    }), w = (Y, te = !1, _e = "") => {
      te || n("reset-flow"), S.value = Y, r.arrowNavigation && (a(Y), Y || n("overlay-closed")), Nn(() => {
        _e !== "" && g.value[0] && g.value[0].openChildCmp(_e);
      });
    }, C = ce(() => ({
      dp__button: !0,
      dp__button_bottom: r.autoApply
    })), P = $o(s, "timePicker"), M = (Y, te, _e) => r.range ? te === 0 ? [Y, E.value[1][_e]] : [E.value[0][_e], Y] : Y, T = (Y) => {
      n("update:hours", Y);
    }, N = (Y) => {
      n("update:minutes", Y);
    }, $ = (Y) => {
      n("update:seconds", Y);
    }, ne = () => {
      v.value && r.arrowNavigation && v.value.focus({ preventScroll: !0 });
    };
    return t({ toggleTimePicker: w }), (Y, te) => {
      var _e;
      return _(), O("div", null, [
        Y.timePicker ? L("", !0) : ur((_(), O("div", {
          key: 0,
          class: Pe(re(C)),
          role: "button",
          "aria-label": (_e = re(l).ariaLabels) == null ? void 0 : _e.openTimePicker,
          tabindex: "0",
          "data-test": "open-time-picker-btn",
          ref_key: "openTimePickerBtn",
          ref: h,
          onKeydown: [
            te[0] || (te[0] = bt((Fe) => w(!0), ["enter"])),
            te[1] || (te[1] = bt((Fe) => w(!0), ["space"]))
          ],
          onClick: te[2] || (te[2] = (Fe) => w(!0))
        }, [
          Y.$slots["clock-icon"] ? xe(Y.$slots, "clock-icon", { key: 0 }) : L("", !0),
          Y.$slots["clock-icon"] ? L("", !0) : (_(), ae(re(X2), { key: 1 }))
        ], 42, PH)), [
          [Ws, !re(o)("time")]
        ]),
        W(Ea, {
          name: re(c)(S.value),
          css: re(f)
        }, {
          default: ie(() => {
            var Fe;
            return [
              S.value || Y.timePicker ? (_(), O("div", {
                key: 0,
                class: "dp__overlay",
                ref_key: "overlayRef",
                ref: v,
                tabindex: "0"
              }, [
                k("div", OH, [
                  Y.$slots["time-picker-overlay"] ? xe(Y.$slots, "time-picker-overlay", {
                    key: 0,
                    hours: e.hours,
                    minutes: e.minutes,
                    seconds: e.seconds,
                    setHours: T,
                    setMinutes: N,
                    setSeconds: $
                  }) : L("", !0),
                  Y.$slots["time-picker-overlay"] ? L("", !0) : (_(), O("div", MH, [
                    (_(!0), O(Re, null, Ke(re(E), (J, oe) => ur((_(), ae(EH, or({ key: oe }, {
                      ...Y.$props,
                      order: oe,
                      hours: J.hours,
                      minutes: J.minutes,
                      seconds: J.seconds,
                      closeTimePickerBtn: p.value,
                      disabled: oe === 0 ? Y.fixedStart : Y.fixedEnd
                    }, {
                      ref_for: !0,
                      ref_key: "timeInputRefs",
                      ref: g,
                      "onUpdate:hours": (A) => T(M(A, oe, "hours")),
                      "onUpdate:minutes": (A) => N(M(A, oe, "minutes")),
                      "onUpdate:seconds": (A) => $(M(A, oe, "seconds")),
                      onMounted: ne,
                      onOverlayClosed: ne
                    }), Gr({ _: 2 }, [
                      Ke(re(P), (A, X) => ({
                        name: A,
                        fn: ie((pe) => [
                          xe(Y.$slots, A, yi(ns(pe)))
                        ])
                      }))
                    ]), 1040, ["onUpdate:hours", "onUpdate:minutes", "onUpdate:seconds"])), [
                      [Ws, oe === 0 ? !0 : re(y)]
                    ])), 128))
                  ])),
                  Y.timePicker ? L("", !0) : ur((_(), O("div", {
                    key: 2,
                    ref_key: "closeTimePickerBtn",
                    ref: p,
                    class: Pe(re(C)),
                    role: "button",
                    "aria-label": (Fe = re(l).ariaLabels) == null ? void 0 : Fe.closeTimePicker,
                    tabindex: "0",
                    onKeydown: [
                      te[3] || (te[3] = bt((J) => w(!1), ["enter"])),
                      te[4] || (te[4] = bt((J) => w(!1), ["space"]))
                    ],
                    onClick: te[5] || (te[5] = (J) => w(!1))
                  }, [
                    Y.$slots["calendar-icon"] ? xe(Y.$slots, "calendar-icon", { key: 0 }) : L("", !0),
                    Y.$slots["calendar-icon"] ? L("", !0) : (_(), ae(re(dp), { key: 1 }))
                  ], 42, IH)), [
                    [Ws, !re(o)("time")]
                  ])
                ])
              ], 512)) : L("", !0)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ]);
    };
  }
}), FH = (e, t) => {
  const { isDisabled: n, matchDate: r, getWeekFromDate: i } = Ci(t), a = ge(null), s = ge(Oe()), o = (A) => {
    !A.current && t.hideOffsetDates || (a.value = A.value);
  }, l = () => {
    a.value = null;
  }, c = (A) => Array.isArray(e.value) && t.range && e.value[0] && a.value ? A ? Kr(a.value, e.value[0]) : Fr(a.value, e.value[0]) : !0, f = (A, X) => {
    const pe = () => e.value ? X ? e.value[0] || null : e.value[1] : null, le = e.value && Array.isArray(e.value) ? pe() : null;
    return _n(Oe(A.value), le);
  }, h = (A) => {
    const X = Array.isArray(e.value) ? e.value[0] : null;
    return A ? !Fr(a.value || null, X) : !0;
  }, p = (A, X = !0) => (t.range || t.weekPicker) && Array.isArray(e.value) ? t.hideOffsetDates && !A.current ? !1 : _n(Oe(A.value), e.value[X ? 0 : 1]) : t.range ? f(A, X) && h(X) || _n(A.value, Array.isArray(e.value) ? e.value[0] : null) && c(X) : !1, g = (A, X, pe) => Array.isArray(e.value) && e.value[0] && e.value.length === 1 ? A ? !1 : pe ? Kr(e.value[0], X.value) : Fr(e.value[0], X.value) : !1, v = (A) => !e.value || t.hideOffsetDates && !A.current ? !1 : t.range ? t.modelAuto && Array.isArray(e.value) ? _n(A.value, e.value[0] ? e.value[0] : s.value) : !1 : t.multiDates && Array.isArray(e.value) ? e.value.some((X) => _n(X, A.value)) : _n(A.value, e.value ? e.value : s.value), y = (A) => {
    if (t.autoRange || t.weekPicker) {
      if (a.value) {
        if (t.hideOffsetDates && !A.current)
          return !1;
        const X = os(a.value, +t.autoRange), pe = i(Oe(a.value));
        return t.weekPicker ? _n(pe[1], Oe(A.value)) : _n(X, Oe(A.value));
      }
      return !1;
    }
    return !1;
  }, S = (A) => {
    if (t.autoRange || t.weekPicker) {
      if (a.value) {
        const X = os(a.value, +t.autoRange);
        if (t.hideOffsetDates && !A.current)
          return !1;
        const pe = i(Oe(a.value));
        return t.weekPicker ? Kr(A.value, pe[0]) && Fr(A.value, pe[1]) : Kr(A.value, a.value) && Fr(A.value, X);
      }
      return !1;
    }
    return !1;
  }, x = (A) => {
    if (t.autoRange || t.weekPicker) {
      if (a.value) {
        if (t.hideOffsetDates && !A.current)
          return !1;
        const X = i(Oe(a.value));
        return t.weekPicker ? _n(X[0], A.value) : _n(a.value, A.value);
      }
      return !1;
    }
    return !1;
  }, E = (A) => J2(e.value, a.value, A.value), w = () => t.modelAuto && Array.isArray(t.internalModelValue) ? !!t.internalModelValue[0] : !1, C = () => t.modelAuto ? rO(t.internalModelValue) : !0, P = (A) => {
    if (Array.isArray(e.value) && e.value.length || t.weekPicker)
      return !1;
    const X = t.range ? !p(A) && !p(A, !1) : !0;
    return !n(A.value) && !v(A) && !(!A.current && t.hideOffsetDates) && X;
  }, M = (A) => t.range ? t.modelAuto ? w() && v(A) : !1 : v(A), T = (A) => t.highlight ? r(A.value, t.highlight) : !1, N = (A) => n(A.value) && t.highlightDisabledDays === !1, $ = (A) => t.highlightWeekDays && t.highlightWeekDays.includes(A.value.getDay()), ne = (A) => (t.range || t.weekPicker) && (!(t.multiCalendars > 0) || A.current) && C() && !(!A.current && t.hideOffsetDates) && !v(A) ? E(A) : !1, Y = (A) => ({
    dp__cell_offset: !A.current,
    dp__pointer: !t.disabled && !(!A.current && t.hideOffsetDates) && !n(A.value),
    dp__cell_disabled: n(A.value),
    dp__cell_highlight: !N(A) && (T(A) || $(A)) && !M(A),
    dp__cell_highlight_active: !N(A) && (T(A) || $(A)) && M(A),
    dp__today: !t.noToday && _n(A.value, s.value) && A.current
  }), te = (A) => ({
    dp__active_date: M(A),
    dp__date_hover: P(A)
  }), _e = (A) => ({
    ...Fe(A),
    ...J(A),
    dp__range_between_week: ne(A) && t.weekPicker
  }), Fe = (A) => ({
    dp__range_start: t.multiCalendars > 0 ? A.current && p(A) && C() : p(A) && C(),
    dp__range_end: t.multiCalendars > 0 ? A.current && p(A, !1) && C() : p(A, !1) && C(),
    dp__range_between: ne(A) && !t.weekPicker,
    dp__date_hover_start: g(P(A), A, !0),
    dp__date_hover_end: g(P(A), A, !1)
  }), J = (A) => ({
    ...Fe(A),
    dp__cell_auto_range: S(A),
    dp__cell_auto_range_start: x(A),
    dp__cell_auto_range_end: y(A)
  }), oe = (A) => t.range ? t.autoRange ? J(A) : t.modelAuto ? { ...te(A), ...Fe(A) } : Fe(A) : t.weekPicker ? _e(A) : te(A);
  return {
    setHoverDate: o,
    clearHoverDate: l,
    getDayClassData: (A) => ({
      ...Y(A),
      ...oe(A),
      [t.dayClass ? t.dayClass(A.value) : ""]: !0,
      [t.calendarCellClassName]: !!t.calendarCellClassName
    })
  };
}, NH = ["id", "onKeydown"], LH = {
  key: 0,
  class: "dp__sidebar_left"
}, $H = {
  key: 1,
  class: "dp__preset_ranges"
}, VH = ["onClick"], BH = {
  key: 2,
  class: "dp__sidebar_right"
}, UH = {
  key: 3,
  class: "dp__now_wrap"
}, qH = /* @__PURE__ */ dt({
  __name: "DatepickerMenu",
  props: {
    openOnTop: { type: Boolean, default: !1 },
    internalModelValue: { type: [Date, Array], default: null },
    ...ao
  },
  emits: [
    "close-picker",
    "select-date",
    "auto-apply",
    "time-update",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "update:internal-model-value",
    "recalculate-position",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close"
  ],
  setup(e, { expose: t, emit: n }) {
    const r = e, { setMenuFocused: i, setShiftKey: a, control: s } = eO(), { getCalendarDays: o, defaults: l } = Ci(r), c = e0(), f = ge(null), h = nl({
      timePicker: !!(!r.enableTimePicker || r.timePicker || r.monthPicker),
      monthYearInput: !!r.timePicker,
      calendar: !1
    }), p = ge([]), g = ge([]), v = ge(null), y = ge(null), S = ge(0), x = ge(!1), E = ge(0);
    Ft(() => {
      var be;
      x.value = !0, !((be = r.presetRanges) != null && be.length) && !c["left-sidebar"] && !c["right-sidebar"] && Cn();
      const Ue = lr(y);
      if (Ue && !r.textInput && !r.inline && (i(!0), N()), Ue) {
        const Mn = (ir) => {
          !r.monthYearComponent && !r.timePickerComponent && !Object.keys(c).length && ir.preventDefault(), ir.stopImmediatePropagation(), ir.stopPropagation();
        };
        Ue.addEventListener("pointerdown", Mn), Ue.addEventListener("mousedown", Mn);
      }
      window.addEventListener("resize", Cn);
    }), cr(() => {
      window.removeEventListener("resize", Cn);
    });
    const { arrowRight: w, arrowLeft: C, arrowDown: P, arrowUp: M } = io(), T = (be) => {
      be || be === 0 ? g.value[be].triggerTransition(
        _e.value(be),
        Fe.value(be)
      ) : g.value.forEach(
        (Ue, Mn) => Ue.triggerTransition(_e.value(Mn), Fe.value(Mn))
      );
    }, N = () => {
      const be = lr(y);
      be && be.focus({ preventScroll: !0 });
    }, $ = () => {
      var be;
      (be = r.flow) != null && be.length && E.value !== -1 && (E.value += 1, n("flow-step", E.value), gt());
    }, ne = () => {
      E.value = -1;
    }, {
      calendars: Y,
      modelValue: te,
      month: _e,
      year: Fe,
      time: J,
      updateTime: oe,
      updateMonthYear: A,
      selectDate: X,
      getWeekNum: pe,
      monthYearSelect: le,
      handleScroll: ue,
      handleArrow: Te,
      handleSwipe: Ne,
      getMarker: Z,
      selectCurrentDate: G,
      presetDateRange: se
    } = $z(r, n, $, T, E), { setHoverDate: St, clearHoverDate: Sn, getDayClassData: Vt } = FH(te, r);
    Ln(
      Y,
      () => {
        r.openOnTop && setTimeout(() => {
          n("recalculate-position");
        }, 0);
      },
      { deep: !0 }
    );
    const nn = $o(c, "calendar"), rr = $o(c, "action"), Qe = $o(c, "timePicker"), Je = $o(c, "monthYear"), Pt = ce(() => r.openOnTop ? "dp__arrow_bottom" : "dp__arrow_top"), Xe = ce(() => Dz(r.yearRange)), pt = ce(() => Ez(r.locale, r.monthNameFormat)), Cn = () => {
      const be = lr(f);
      be && (S.value = be.getBoundingClientRect().width);
    }, ut = ce(() => (be) => o(_e.value(be), Fe.value(be))), dr = ce(
      () => l.value.multiCalendars > 0 && r.range ? [...Array(l.value.multiCalendars).keys()] : [0]
    ), B = ce(
      () => (be) => be === 1
    ), z = ce(() => r.monthPicker || r.timePicker || r.yearPicker), ye = ce(
      () => ({
        dp__flex_display: l.value.multiCalendars > 0
      })
    ), $e = ce(() => ({
      dp__instance_calendar: l.value.multiCalendars > 0
    })), Ct = ce(() => ({
      dp__menu_disabled: r.disabled,
      dp__menu_readonly: r.readonly
    })), At = ce(
      () => (be) => he(ut, be)
    ), mt = ce(
      () => ({
        dp__menu: !0,
        dp__menu_index: !r.inline,
        dp__relative: r.inline,
        [r.menuClassName]: !!r.menuClassName
      })
    ), he = (be, Ue) => be.value(Ue).map((Mn) => ({
      ...Mn,
      days: Mn.days.map((ir) => (ir.marker = Z(ir), ir.classData = Vt(ir), ir))
    })), Ae = (be) => {
      be.stopPropagation(), be.stopImmediatePropagation();
    }, q = () => {
      r.escClose && n("close-picker");
    }, me = (be, Ue = !1) => {
      X(be, Ue), r.spaceConfirm && n("select-date");
    }, Be = (be) => {
      var Ue;
      (Ue = r.flow) != null && Ue.length && (h[be] = !0, Object.keys(h).filter((Mn) => !h[Mn]).length || gt());
    }, He = (be, Ue, Mn, ir, ...Ia) => {
      if (r.flow[E.value] === be) {
        const Ze = ir ? Ue.value[0] : Ue.value;
        Ze && Ze[Mn](...Ia);
      }
    }, gt = () => {
      He("month", p, "toggleMonthPicker", !0, !0), He("year", p, "toggleYearPicker", !0, !0), He("calendar", v, "toggleTimePicker", !1, !1, !0), He("time", v, "toggleTimePicker", !1, !0, !0);
      const be = r.flow[E.value];
      (be === "hours" || be === "minutes" || be === "seconds") && He(be, v, "toggleTimePicker", !1, !0, !0, be);
    }, cn = (be) => {
      if (r.arrowNavigation) {
        if (be === "up")
          return M();
        if (be === "down")
          return P();
        if (be === "left")
          return C();
        if (be === "right")
          return w();
      } else
        be === "left" || be === "up" ? Te("left", 0, be === "up") : Te("right", 0, be === "down");
    }, Yn = (be) => {
      a(be.shiftKey), !r.disableMonthYearSelect && be.code === "Tab" && be.target.classList.contains("dp__menu") && s.value.shiftKeyInMenu && (be.preventDefault(), be.stopImmediatePropagation(), n("close-picker"));
    };
    return t({
      updateMonthYear: A
    }), (be, Ue) => {
      var Mn;
      return _(), ae(Ea, {
        appear: "",
        name: (Mn = re(l).transitions) == null ? void 0 : Mn.menuAppear,
        mode: "out-in",
        css: !!be.transitions
      }, {
        default: ie(() => {
          var ir, Ia;
          return [
            k("div", {
              id: be.uid ? `dp-menu-${be.uid}` : void 0,
              tabindex: "0",
              ref_key: "dpMenuRef",
              ref: y,
              role: "dialog",
              class: Pe(re(mt)),
              onMouseleave: Ue[14] || (Ue[14] = //@ts-ignore
              (...Ze) => re(Sn) && re(Sn)(...Ze)),
              onClick: Ae,
              onKeydown: [
                bt(q, ["esc"]),
                Ue[15] || (Ue[15] = bt(sn((Ze) => cn("left"), ["prevent"]), ["left"])),
                Ue[16] || (Ue[16] = bt(sn((Ze) => cn("up"), ["prevent"]), ["up"])),
                Ue[17] || (Ue[17] = bt(sn((Ze) => cn("down"), ["prevent"]), ["down"])),
                Ue[18] || (Ue[18] = bt(sn((Ze) => cn("right"), ["prevent"]), ["right"])),
                Yn
              ]
            }, [
              (be.disabled || be.readonly) && be.inline ? (_(), O("div", {
                key: 0,
                class: Pe(re(Ct))
              }, null, 2)) : L("", !0),
              !be.inline && !be.teleportCenter ? (_(), O("div", {
                key: 1,
                class: Pe(re(Pt))
              }, null, 2)) : L("", !0),
              k("div", {
                class: Pe({
                  dp__menu_content_wrapper: ((ir = be.presetRanges) == null ? void 0 : ir.length) || !!be.$slots["left-sidebar"] || !!be.$slots["right-sidebar"]
                })
              }, [
                be.$slots["left-sidebar"] ? (_(), O("div", LH, [
                  xe(be.$slots, "left-sidebar")
                ])) : L("", !0),
                (Ia = be.presetRanges) != null && Ia.length ? (_(), O("div", $H, [
                  (_(!0), O(Re, null, Ke(be.presetRanges, (Ze, li) => (_(), O("div", {
                    key: li,
                    style: Zn(Ze.style || {}),
                    class: "dp__preset_range",
                    onClick: (ot) => re(se)(Ze.range, !!Ze.slot)
                  }, [
                    Ze.slot ? xe(be.$slots, Ze.slot, {
                      key: 0,
                      presetDateRange: re(se),
                      label: Ze.label,
                      range: Ze.range
                    }) : (_(), O(Re, { key: 1 }, [
                      Me(j(Ze.label), 1)
                    ], 64))
                  ], 12, VH))), 128))
                ])) : L("", !0),
                k("div", {
                  class: "dp__instance_calendar",
                  ref_key: "calendarWrapperRef",
                  ref: f,
                  role: "document"
                }, [
                  k("div", {
                    class: Pe(re(ye))
                  }, [
                    (_(!0), O(Re, null, Ke(re(dr), (Ze, li) => (_(), O("div", {
                      key: Ze,
                      class: Pe(re($e))
                    }, [
                      !be.disableMonthYearSelect && !be.timePicker ? (_(), ae(Lr(be.monthYearComponent ? be.monthYearComponent : wH), or({
                        key: 0,
                        ref_for: !0,
                        ref: (ot) => {
                          ot && (p.value[li] = ot);
                        },
                        months: re(pt),
                        years: re(Xe),
                        month: re(_e)(Ze),
                        year: re(Fe)(Ze),
                        instance: Ze,
                        "internal-model-value": e.internalModelValue
                      }, be.$props, {
                        onMount: Ue[0] || (Ue[0] = (ot) => Be("monthYearInput")),
                        onResetFlow: ne,
                        onUpdateMonthYear: (ot) => re(A)(Ze, ot),
                        onMonthYearSelect: re(le),
                        onOverlayClosed: N
                      }), Gr({ _: 2 }, [
                        Ke(re(Je), (ot, pa) => ({
                          name: ot,
                          fn: ie((ui) => [
                            xe(be.$slots, ot, yi(ns(ui)))
                          ])
                        }))
                      ]), 1040, ["months", "years", "month", "year", "instance", "internal-model-value", "onUpdateMonthYear", "onMonthYearSelect"])) : L("", !0),
                      W(uH, or({
                        ref_for: !0,
                        ref: (ot) => {
                          ot && (g.value[li] = ot);
                        },
                        "specific-mode": re(z),
                        "get-week-num": re(pe),
                        instance: Ze,
                        "mapped-dates": re(At)(Ze),
                        month: re(_e)(Ze),
                        year: re(Fe)(Ze)
                      }, be.$props, {
                        "flow-step": E.value,
                        "onUpdate:flowStep": Ue[1] || (Ue[1] = (ot) => E.value = ot),
                        onSelectDate: (ot) => re(X)(ot, !re(B)(Ze)),
                        onHandleSpace: (ot) => me(ot, !re(B)(Ze)),
                        onSetHoverDate: Ue[2] || (Ue[2] = (ot) => re(St)(ot)),
                        onHandleScroll: (ot) => re(ue)(ot, Ze),
                        onHandleSwipe: (ot) => re(Ne)(ot, Ze),
                        onMount: Ue[3] || (Ue[3] = (ot) => Be("calendar")),
                        onResetFlow: ne,
                        onTooltipOpen: Ue[4] || (Ue[4] = (ot) => be.$emit("tooltip-open", ot)),
                        onTooltipClose: Ue[5] || (Ue[5] = (ot) => be.$emit("tooltip-close", ot))
                      }), Gr({ _: 2 }, [
                        Ke(re(nn), (ot, pa) => ({
                          name: ot,
                          fn: ie((ui) => [
                            xe(be.$slots, ot, yi(ns({ ...ui })))
                          ])
                        }))
                      ]), 1040, ["specific-mode", "get-week-num", "instance", "mapped-dates", "month", "year", "flow-step", "onSelectDate", "onHandleSpace", "onHandleScroll", "onHandleSwipe"])
                    ], 2))), 128))
                  ], 2),
                  k("div", null, [
                    be.$slots["time-picker"] ? xe(be.$slots, "time-picker", yi(or({ key: 0 }, { time: re(J), updateTime: re(oe) }))) : (_(), O(Re, { key: 1 }, [
                      be.enableTimePicker && !be.monthPicker && !be.weekPicker ? (_(), ae(Lr(be.timePickerComponent ? be.timePickerComponent : RH), or({
                        key: 0,
                        ref_key: "timePickerRef",
                        ref: v,
                        hours: re(J).hours,
                        minutes: re(J).minutes,
                        seconds: re(J).seconds,
                        "internal-model-value": e.internalModelValue
                      }, be.$props, {
                        onMount: Ue[6] || (Ue[6] = (Ze) => Be("timePicker")),
                        "onUpdate:hours": Ue[7] || (Ue[7] = (Ze) => re(oe)(Ze)),
                        "onUpdate:minutes": Ue[8] || (Ue[8] = (Ze) => re(oe)(Ze, !1)),
                        "onUpdate:seconds": Ue[9] || (Ue[9] = (Ze) => re(oe)(Ze, !1, !0)),
                        onResetFlow: ne,
                        onOverlayClosed: N
                      }), Gr({ _: 2 }, [
                        Ke(re(Qe), (Ze, li) => ({
                          name: Ze,
                          fn: ie((ot) => [
                            xe(be.$slots, Ze, yi(ns(ot)))
                          ])
                        }))
                      ]), 1040, ["hours", "minutes", "seconds", "internal-model-value"])) : L("", !0)
                    ], 64))
                  ])
                ], 512),
                be.$slots["right-sidebar"] ? (_(), O("div", BH, [
                  xe(be.$slots, "right-sidebar")
                ])) : L("", !0),
                be.showNowButton ? (_(), O("div", UH, [
                  be.$slots["now-button"] ? xe(be.$slots, "now-button", {
                    key: 0,
                    selectCurrentDate: re(G)
                  }) : L("", !0),
                  be.$slots["now-button"] ? L("", !0) : (_(), O("button", {
                    key: 1,
                    type: "button",
                    role: "button",
                    class: "dp__now_button",
                    onClick: Ue[10] || (Ue[10] = //@ts-ignore
                    (...Ze) => re(G) && re(G)(...Ze))
                  }, j(be.nowButtonLabel), 1))
                ])) : L("", !0)
              ], 2),
              !be.autoApply || be.keepActionRow ? (_(), ae(Lr(be.actionRowComponent ? be.actionRowComponent : Jz), or({
                key: 2,
                "menu-mount": x.value,
                "calendar-width": S.value,
                "internal-model-value": e.internalModelValue
              }, be.$props, {
                onClosePicker: Ue[11] || (Ue[11] = (Ze) => be.$emit("close-picker")),
                onSelectDate: Ue[12] || (Ue[12] = (Ze) => be.$emit("select-date")),
                onInvalidSelect: Ue[13] || (Ue[13] = (Ze) => be.$emit("invalid-select"))
              }), Gr({ _: 2 }, [
                Ke(re(rr), (Ze, li) => ({
                  name: Ze,
                  fn: ie((ot) => [
                    xe(be.$slots, Ze, yi(ns({ ...ot })))
                  ])
                }))
              ]), 1040, ["menu-mount", "calendar-width", "internal-model-value"])) : L("", !0)
            ], 42, NH)
          ];
        }),
        _: 3
      }, 8, ["name", "css"]);
    };
  }
}), jH = typeof window < "u" ? window : void 0, Mg = () => {
}, WH = (e) => B5() ? (U5(e), !0) : !1, zH = (e, t, n, r) => {
  if (!e)
    return Mg;
  let i = Mg;
  const a = Ln(
    () => re(e),
    (o) => {
      i(), o && (o.addEventListener(t, n, r), i = () => {
        o.removeEventListener(t, n, r), i = Mg;
      });
    },
    { immediate: !0, flush: "post" }
  ), s = () => {
    a(), i();
  };
  return WH(s), s;
}, HH = (e, t, n, r = {}) => {
  const { window: i = jH, event: a = "pointerdown" } = r;
  return i ? zH(i, a, (s) => {
    const o = lr(e), l = lr(t);
    !o || !l || o === s.target || s.composedPath().includes(o) || s.composedPath().includes(l) || n(s);
  }, { passive: !0 }) : void 0;
}, GH = /* @__PURE__ */ dt({
  __name: "VueDatePicker",
  props: {
    ...ao
  },
  emits: [
    "update:model-value",
    "text-submit",
    "closed",
    "cleared",
    "open",
    "focus",
    "blur",
    "internal-model-change",
    "recalculate-position",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close"
  ],
  setup(e, { expose: t, emit: n }) {
    const r = e, i = e0(), a = ge(!1), s = vh(r, "modelValue"), o = vh(r, "timezone"), l = ge(null), c = ge(null), f = ge(!1), { setMenuFocused: h, setShiftKey: p } = eO(), { clearArrowNav: g } = io(), { validateDate: v, isValidTime: y, defaults: S } = Ci(r);
    Ft(() => {
      $(r.modelValue), r.inline || (window.addEventListener("scroll", J), window.addEventListener("resize", oe)), r.inline && (a.value = !0);
    }), cr(() => {
      r.inline || (window.removeEventListener("scroll", J), window.removeEventListener("resize", oe));
    });
    const x = $o(i, "all", r.presetRanges), E = $o(i, "input");
    Ln(
      [s, o],
      () => {
        $(s.value);
      },
      { deep: !0 }
    );
    const { openOnTop: w, menuPosition: C, setMenuPosition: P, setInitialPosition: M } = Uz(
      l,
      c,
      n,
      r
    ), {
      inputValue: T,
      internalModelValue: N,
      parseExternalModelValue: $,
      emitModelValue: ne,
      formatInputValue: Y,
      checkBeforeEmit: te
    } = Vz(n, r, f), _e = ce(
      () => ({
        dp__main: !0,
        dp__theme_dark: r.dark,
        dp__theme_light: !r.dark,
        dp__flex_display: r.inline,
        dp__flex_display_with_input: r.inlineWithInput
      })
    ), Fe = ce(() => r.dark ? "dp__theme_dark" : "dp__theme_light"), J = () => {
      a.value && (r.closeOnScroll ? Z() : r.autoPosition && P());
    }, oe = () => {
      a.value && P();
    }, A = () => {
      !r.disabled && !r.readonly && (M(), a.value = !0, Nn().then(() => {
        P(), a.value && n("open");
      }), a.value || Ne(), $(r.modelValue));
    }, X = () => {
      T.value = "", Ne(), n("update:model-value", null), n("cleared"), Z();
    }, pe = () => {
      const Je = N.value;
      return !Je || !Array.isArray(Je) && v(Je) ? !0 : Array.isArray(Je) ? Je.length === 2 && v(Je[0]) && v(Je[1]) ? !0 : v(Je[0]) : !1;
    }, le = () => {
      te() && pe() ? (ne(), Z()) : n("invalid-select", N.value);
    }, ue = (Je) => {
      ne(), r.closeOnAutoApply && !Je && Z();
    }, Te = (Je = !1) => {
      r.autoApply && y(N.value) && pe() && (r.range && Array.isArray(N.value) ? (r.partialRange || N.value.length === 2) && ue(Je) : ue(Je));
    }, Ne = () => {
      r.textInput || (N.value = null);
    }, Z = () => {
      r.inline || (a.value && (a.value = !1, h(!1), p(!1), g(), n("closed"), M(), T.value && $(s.value)), Ne(), c.value && c.value.focusInput());
    }, G = (Je, Pt) => {
      if (!Je) {
        N.value = null;
        return;
      }
      N.value = Je, Pt && (le(), n("text-submit"));
    }, se = () => {
      r.autoApply && y(N.value) && ne();
    }, St = () => a.value ? Z() : A(), Sn = (Je) => {
      N.value = Je;
    }, Vt = ce(() => r.textInput && S.value.textInputOptions.format), nn = () => {
      Vt.value && (f.value = !0, Y()), n("focus");
    }, rr = () => {
      Vt.value && (f.value = !1, Y()), n("blur");
    }, Qe = (Je) => {
      l.value && l.value.updateMonthYear(0, {
        month: Jk(Je.month),
        year: Jk(Je.year)
      });
    };
    return HH(
      l,
      c,
      r.onClickOutside ? () => r.onClickOutside(pe) : Z
    ), t({
      closeMenu: Z,
      selectDate: le,
      clearValue: X,
      openMenu: A,
      onScroll: J,
      formatInputValue: Y,
      // exposed for testing purposes
      updateInternalModelValue: Sn,
      // modify internal modelValue
      setMonthYear: Qe
    }), (Je, Pt) => (_(), O("div", {
      class: Pe(re(_e))
    }, [
      W(Kz, or({
        ref_key: "inputRef",
        ref: c,
        "is-menu-open": a.value,
        "input-value": re(T),
        "onUpdate:inputValue": Pt[0] || (Pt[0] = (Xe) => Vs(T) ? T.value = Xe : null)
      }, Je.$props, {
        onClear: X,
        onOpen: A,
        onSetInputDate: G,
        onSetEmptyDate: re(ne),
        onSelectDate: le,
        onToggle: St,
        onClose: Z,
        onFocus: nn,
        onBlur: rr
      }), Gr({ _: 2 }, [
        Ke(re(E), (Xe, pt) => ({
          name: Xe,
          fn: ie((Cn) => [
            xe(Je.$slots, Xe, yi(ns(Cn)))
          ])
        }))
      ]), 1040, ["is-menu-open", "input-value", "onSetEmptyDate"]),
      a.value ? (_(), ae(wP, {
        key: 0,
        to: Je.teleport,
        disabled: Je.inline
      }, [
        a.value ? (_(), ae(qH, or({
          key: 0,
          ref_key: "dpMenuRef",
          ref: l,
          class: re(Fe),
          style: re(C),
          "open-on-top": re(w)
        }, Je.$props, {
          "internal-model-value": re(N),
          "onUpdate:internalModelValue": Pt[1] || (Pt[1] = (Xe) => Vs(N) ? N.value = Xe : null),
          onClosePicker: Z,
          onSelectDate: le,
          onAutoApply: Te,
          onTimeUpdate: se,
          onFlowStep: Pt[2] || (Pt[2] = (Xe) => Je.$emit("flow-step", Xe)),
          onUpdateMonthYear: Pt[3] || (Pt[3] = (Xe) => Je.$emit("update-month-year", Xe)),
          onInvalidSelect: Pt[4] || (Pt[4] = (Xe) => Je.$emit("invalid-select", re(N))),
          onInvalidFixedRange: Pt[5] || (Pt[5] = (Xe) => Je.$emit("invalid-fixed-range", Xe)),
          onRecalculatePosition: re(P),
          onTooltipOpen: Pt[6] || (Pt[6] = (Xe) => Je.$emit("tooltip-open", Xe)),
          onTooltipClose: Pt[7] || (Pt[7] = (Xe) => Je.$emit("tooltip-close", Xe))
        }), Gr({ _: 2 }, [
          Ke(re(x), (Xe, pt) => ({
            name: Xe,
            fn: ie((Cn) => [
              xe(Je.$slots, Xe, yi(ns({ ...Cn })))
            ])
          }))
        ]), 1040, ["class", "style", "open-on-top", "internal-model-value", "onRecalculatePosition"])) : L("", !0)
      ], 8, ["to", "disabled"])) : L("", !0)
    ], 2));
  }
}), fu = /* @__PURE__ */ (() => {
  const e = GH;
  return e.install = (t) => {
    t.component("Vue3DatePicker", e);
  }, e;
})(), YH = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: fu
}, Symbol.toStringTag, { value: "Module" }));
Object.entries(YH).forEach(([e, t]) => {
  e !== "default" && (fu[e] = t);
});
const KH = {
  components: { Datepicker: fu },
  props: {
    placeholder: {
      type: String
    },
    modelValue: {
      type: Array,
      required: !0
    },
    useQueryParams: {
      type: Boolean,
      default: !1
      // Store values in query params (start_date, end_date), useful for navigation persistence/link sharing
    },
    ranges: {
      type: Array,
      default: () => []
    }
  },
  beforeMount() {
    this.useQueryParams && this.loadQueryParams();
  },
  data: () => ({
    defaultRanges: [
      {
        id: 1,
        label: "Mois en cours",
        range: H2()
      },
      {
        id: 2,
        label: "Semaine en cours",
        range: G2()
      },
      {
        id: 3,
        label: "Mois précédent",
        range: Rj()
      },
      {
        id: 4,
        label: "Semaine précédente",
        range: Fj()
      }
    ]
  }),
  computed: {
    presetRanges() {
      const e = this.ranges.map((t, n) => ({
        id: n + this.defaultRanges.length + 1,
        label: t.label,
        range: t.range
      }));
      return [...this.defaultRanges, ...e];
    },
    internalValue: {
      get() {
        var e;
        return (e = this.modelValue) != null && e.every((t) => t == null) ? null : this.modelValue;
      },
      set(e) {
        let t = null, n = null;
        e && (t = Bc(e[0]), n = Bc(e[1])), this.useQueryParams && this.updateQueryParams(t, n), this.$emit("update:modelValue", [t, n]);
      }
    }
  },
  methods: {
    datePickerFormat(e) {
      const t = e[0], n = e[1];
      if (!t || !n) return "";
      if (t instanceof Date && n instanceof Date) {
        if (W2(t, n)) return "Mois en cours";
        if (Mj(t, n)) return "Mois précédent";
        if (z2(t, n)) return "Semaine en cours";
        if (Ij(t, n)) return "Semaine précédente";
      }
      const r = ua(t, "dd/MM/yyyy"), i = ua(n, "dd/MM/yyyy");
      return `Du ${r} au ${i}`;
    },
    loadQueryParams() {
      const e = this.$route.query.start_date, t = this.$route.query.end_date;
      e && t && (this.internalValue = [new Date(e), new Date(t)]);
    },
    updateQueryParams(e, t) {
      const n = { ...this.$route.query };
      !e || !t ? (delete n.start_date, delete n.end_date) : (n.start_date = e, n.end_date = t), this.$router.push({ query: n });
    }
  }
};
function XH(e, t, n, r, i, a) {
  const s = U("Datepicker");
  return _(), ae(s, {
    placeholder: n.placeholder,
    class: "text-sm w-full rounded-md",
    modelValue: a.internalValue,
    "onUpdate:modelValue": t[0] || (t[0] = (o) => a.internalValue = o),
    range: "",
    multiCalendars: "",
    presetRanges: a.presetRanges,
    autoApply: "",
    enableTimePicker: !1,
    format: a.datePickerFormat,
    locale: "fr",
    "max-date": /* @__PURE__ */ new Date()
  }, null, 8, ["placeholder", "modelValue", "presetRanges", "format", "max-date"]);
}
const t0e = /* @__PURE__ */ we(KH, [["render", XH]]);
function ZH(e) {
  return e == null;
}
function QH(e) {
  return !e && e !== 0 || e.length === 0 || Object.getPrototypeOf(e) === Object.prototype && Object.getOwnPropertyNames(e).length === 0;
}
function JH(e) {
  return ZH(e) || QH(e);
}
function Cr(e) {
  return !JH(e);
}
function iS(e) {
  return e != null && e !== "";
}
function n0e(e) {
  return e != null;
}
function r0e(e) {
  return !Array.isArray(e) || e.length === 0;
}
function i0e(e) {
  return Array.isArray(e) && e.length > 0;
}
const a0e = /^(?:(?:\+33|0033)\s*0?[67]\s*(?:\d\s*){8}|0[67](?:\d\s*){8}|(?:\+590|00590|(?:\+596|00596)|(?:\+594|00594)|(?:\+262|00262)|(?:\+41|0041)|(?:\+32|0032))\s*(?:\d\s*){9})$/, aS = 2e3, e6 = 0.85, t6 = 1e6;
function n6(e) {
  return e.type.startsWith("image/") && e.type !== "image/gif";
}
function r6({ width: e, height: t }) {
  const n = Math.max(e, t);
  if (n <= aS) return { width: e, height: t };
  const r = aS / n;
  return {
    width: Math.round(e * r),
    height: Math.round(t * r)
  };
}
function i6(e) {
  return `${e.replace(/\.[^.]+$/, "")}.jpg`;
}
function a6(e) {
  return new Promise(
    (t) => e.toBlob(t, "image/jpeg", e6)
  );
}
function s6(e) {
  return createImageBitmap(e, { imageOrientation: "from-image" });
}
async function iO(e) {
  var r;
  if (!n6(e) || e.size <= t6) return e;
  let t = null;
  const n = document.createElement("canvas");
  try {
    t = await s6(e);
    const { width: i, height: a } = r6(t);
    n.width = i, n.height = a;
    const s = n.getContext("2d");
    s.fillStyle = "#ffffff", s.fillRect(0, 0, i, a), s.drawImage(t, 0, 0, i, a);
    const o = await a6(n);
    return !o || o.size >= e.size ? e : new File([o], i6(e.name), {
      type: "image/jpeg",
      lastModified: e.lastModified
    });
  } catch {
    return e;
  } finally {
    (r = t == null ? void 0 : t.close) == null || r.call(t), n.width = 0, n.height = 0;
  }
}
const o6 = {
  components: {
    CloudUploadIcon: X5,
    TrashIcon: t0,
    Field: cu
  },
  props: {
    formData: {
      type: Object,
      required: !0
    },
    id: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      required: !1,
      default: null
    },
    labelClass: {
      type: String,
      default: "font-semibold"
    },
    placeholder: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: !1
    },
    multiple: {
      type: Boolean,
      default: !1
    },
    accept: {
      type: String,
      default: null
    },
    minFiles: {
      type: Number,
      default: 1
    },
    minFilesError: {
      type: String,
      default: null
    },
    // Sans limite par défaut : c'est à l'appelant de déclarer la sienne.
    maxFiles: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      files: [],
      fileError: null,
      compressing: !1
    };
  },
  mounted() {
    this.files = this.formData.getAll(this.id), this.files.length && this.$emit("files", this.files.length);
  },
  methods: {
    isPresent: Cr,
    async handleFileUpload(e) {
      this.fileError = null;
      const t = Array.from(e.target.files || []);
      if (e.target.value = "", t.length === 0) return;
      if (!this.allAccepted(t)) {
        this.fileError = this.$t("file_field.invalid_type", {
          types: this.accept
        });
        return;
      }
      if (this.maxFiles && this.files.length + t.length > this.maxFiles) {
        this.fileError = this.$t("file_field.too_many_files", {
          max: this.maxFiles
        });
        return;
      }
      let n;
      try {
        n = await this.compress(t);
      } catch {
        this.fileError = this.$t("file_field.unreadable");
        return;
      }
      this.files = this.multiple ? [...this.files, ...n] : [n[0]], this.updateFormData();
    },
    // Séquentiel et non en parallèle : décoder une photo de 12 Mpx mobilise ~48 Mo,
    // cinq d'un coup suffisent à faire sauter l'onglet sur mobile.
    async compress(e) {
      this.compressing = !0;
      try {
        const t = [];
        for (const n of e)
          t.push(await this.compressWithinAccept(n));
        return t;
      } finally {
        this.compressing = !1;
      }
    },
    // La compression réencode en JPEG : si le format déclaré par `accept` ne
    // l'autorise pas, on garde l'original plutôt que de rompre le contrat du champ.
    async compressWithinAccept(e) {
      const t = await iO(e), n = this.allAccepted([t]) ? t : e;
      return n === e ? this.copyInMemory(e) : n;
    },
    // Sur Android, un fichier choisi n'est qu'une référence : Chrome ne le lit qu'à
    // l'envoi, et s'il n'y parvient plus l'upload échoue en « erreur réseau » à chaque
    // tentative (EST-742). On le lit dès la sélection pour ne plus en dépendre.
    async copyInMemory(e) {
      return new File([await e.arrayBuffer()], e.name, {
        type: e.type,
        lastModified: e.lastModified
      });
    },
    allAccepted(e) {
      if (!this.accept) return !0;
      const t = this.accept.split(",").map((n) => n.trim().toLowerCase()).filter((n) => n !== "");
      return e.every((n) => {
        const r = "." + n.name.toLowerCase().split(".").pop(), i = n.type.toLowerCase();
        return t.some((a) => {
          if (a.startsWith("."))
            return a === r;
          if (a.endsWith("/*")) {
            const s = a.slice(0, -2);
            return i.startsWith(s + "/");
          }
          return a === i;
        });
      });
    },
    removeFile(e) {
      this.fileError = null, this.files.splice(e, 1), this.updateFormData();
    },
    updateFormData() {
      this.formData.delete(this.id);
      for (let e = 0; e < this.files.length; e++)
        this.formData.append(this.id, this.files[e], this.files[e].name);
      this.$emit("files", this.files.length);
    }
  },
  computed: {
    belowMinFiles() {
      return this.files.length > 0 && this.files.length < this.minFiles;
    }
  }
}, l6 = ["for"], u6 = {
  key: 0,
  class: "text-red-600"
}, c6 = ["id"], d6 = { class: "flex flex-col justify-center px-6 pt-5 pb-6 space-y-1 border-2 border-primary border-dashed rounded-md bg-white text-center text-sm text-primary-dark font-medium focus-within:outline-hidden" }, f6 = ["id", "multiple", "accept", "disabled"], h6 = {
  key: 0,
  class: "text-xs text-primary-dark"
}, p6 = {
  key: 1,
  class: "text-xs text-primary-dark"
}, m6 = {
  key: 1,
  class: "mt-2 text-sm text-red-600"
}, g6 = {
  key: 2,
  class: "mt-2 text-sm text-red-600"
}, v6 = {
  key: 3,
  class: "mt-4 grid grid-cols-1 gap-1 place-items-center"
}, b6 = { class: "text-sm font-medium text-gray-900" }, _6 = ["onClick"];
function y6(e, t, n, r, i, a) {
  const s = U("CloudUploadIcon"), o = U("TrashIcon");
  return _(), O("div", null, [
    a.isPresent(n.label) ? (_(), O("label", {
      key: 0,
      for: n.id,
      class: Pe(`block text-sm leading-6 text-gray-900 sm:pt-1.5 mb-2 ${n.labelClass}`)
    }, [
      Me(j(e.$t(n.label)) + " ", 1),
      n.required ? (_(), O("span", u6, "*")) : L("", !0)
    ], 10, l6)) : L("", !0),
    k("label", {
      id: n.id,
      class: "cursor-pointer"
    }, [
      k("div", d6, [
        W(s, { class: "mx-auto h-12 w-12 text-primary-dark" }),
        k("span", null, j(i.compressing ? e.$t("file_field.compressing") : n.placeholder), 1),
        k("input", {
          id: n.id,
          type: "file",
          class: "sr-only",
          multiple: n.multiple,
          accept: n.accept,
          disabled: i.compressing,
          onChange: t[0] || (t[0] = (...l) => a.handleFileUpload && a.handleFileUpload(...l))
        }, null, 40, f6),
        n.accept ? (_(), O("p", h6, j(e.$t("file_field.accepted_formats", { formats: n.accept })), 1)) : (_(), O("p", p6, j(e.$t("PNG, JPG, GIF up to 10MB")), 1))
      ])
    ], 8, c6),
    i.fileError ? (_(), O("p", m6, j(i.fileError), 1)) : L("", !0),
    a.belowMinFiles && n.minFilesError ? (_(), O("p", g6, j(n.minFilesError), 1)) : L("", !0),
    a.isPresent(i.files) ? (_(), O("div", v6, [
      k("legend", b6, j(e.$t("Uploaded files")), 1),
      (_(!0), O(Re, null, Ke(i.files, (l, c) => (_(), O("div", {
        class: "border-t border-gray-200 px-4 py-5 sm:p-0 flex",
        key: l
      }, [
        k("span", null, j(l.name), 1),
        k("button", {
          onClick: (f) => a.removeFile(c),
          class: "pl-2 w-0"
        }, [
          W(o, {
            class: "h-5 w-5 text-primary",
            "aria-hidden": "true"
          })
        ], 8, _6)
      ]))), 128))
    ])) : L("", !0)
  ]);
}
const hs = /* @__PURE__ */ we(o6, [["render", y6]]), x6 = {
  components: {
    Field: cu
  },
  props: {
    id: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      required: !1,
      default: null
    },
    labelClass: {
      type: String,
      default: "font-semibold"
    },
    labelStyle: {
      type: Object,
      default: () => ({})
    },
    name: {
      type: String,
      required: !1,
      default: (e) => e.id
    },
    type: {
      type: String,
      default: "text"
    },
    placeholder: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    modelValue: {
      required: !0
    },
    fieldClass: {
      type: String,
      default: "block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
    },
    trailingAddOns: {
      type: String
    },
    error: {
      type: String,
      default: null
    }
  },
  emits: ["update:modelValue"],
  computed: {
    isLabelPresent() {
      var e;
      return !(this.label === null || ((e = this.label) == null ? void 0 : e.length) === 0);
    },
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(e) {
        if (this.pendingFile = e instanceof File ? e : null, this.type === "file" && e instanceof File) {
          this.emitCompressed(e);
          return;
        }
        this.$emit("update:modelValue", e);
      }
    }
  },
  methods: {
    // Les factures et devis photographiés au téléphone pèsent plusieurs Mo : envoyés
    // tels quels, l'upload dépasse le timeout sur réseau mobile (EST-681). On émet la
    // version réencodée, ce qui allège à la fois l'extraction des coûts (déclenchée
    // dès la sélection) et la soumission finale.
    async emitCompressed(e) {
      const t = await iO(e);
      this.pendingFile === e && this.$emit("update:modelValue", t);
    }
  }
}, w6 = ["for"], k6 = {
  key: 0,
  class: "text-red-600"
}, S6 = { class: "relative" }, C6 = {
  key: 0,
  class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
}, T6 = {
  key: 1,
  class: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
}, A6 = { class: "text-gray-500 sm:text-sm" }, D6 = {
  key: 1,
  class: "mt-1 text-sm text-red-600"
};
function E6(e, t, n, r, i, a) {
  const s = U("Field");
  return _(), O("div", null, [
    a.isLabelPresent ? (_(), O("label", {
      key: 0,
      for: n.id,
      class: Pe(`block text-sm leading-6 text-gray-900 sm:pt-1.5 mb-1 ${n.labelClass}`),
      style: Zn(n.labelStyle)
    }, [
      Me(j(e.$t(n.label)) + " ", 1),
      n.required ? (_(), O("span", k6, "*")) : L("", !0)
    ], 14, w6)) : L("", !0),
    k("div", S6, [
      e.$slots.prependIcon ? (_(), O("div", C6, [
        xe(e.$slots, "prependIcon")
      ])) : L("", !0),
      W(s, {
        id: n.id,
        name: n.name,
        type: n.type,
        class: Pe([
          n.fieldClass,
          e.$slots.prependIcon ? "pl-8" : "",
          n.disabled ? "bg-gray-200" : ""
        ]),
        placeholder: n.placeholder,
        disabled: n.disabled,
        modelValue: a.internalValue,
        "onUpdate:modelValue": t[0] || (t[0] = (o) => a.internalValue = o)
      }, null, 8, ["id", "name", "type", "class", "placeholder", "disabled", "modelValue"]),
      n.trailingAddOns ? (_(), O("div", T6, [
        k("span", A6, j(n.trailingAddOns), 1)
      ])) : L("", !0)
    ]),
    n.error ? (_(), O("p", D6, j(n.error), 1)) : L("", !0)
  ]);
}
const hu = /* @__PURE__ */ we(x6, [["render", E6]]), P6 = {
  props: ["initialAddress"],
  data: () => ({
    address: {
      street: "",
      city: "",
      province: "",
      country: "",
      zipCode: ""
    }
  }),
  mounted() {
    this.setupAutocomplete(), this.setInitialAddress();
  },
  methods: {
    setupAutocomplete() {
      if (window.google) {
        const e = window.google;
        this.autocomplete = new e.maps.places.Autocomplete(
          document.getElementById("autocomplete")
        ), this.autocomplete.setComponentRestrictions({
          // restrict the country
          country: ["fr", "mq", "gp", "re"]
        }), this.autocomplete.addListener("place_changed", () => {
          let t = this.autocomplete.getPlace(), n = t.address_components;
          const r = this.findDataShortName(n, "street_number"), i = this.findDataShortName(n, "route");
          this.address.street = iS(r) && iS(i) ? `${r} ${i}` : t.formatted_address, this.address.city = this.findDataShortName(n, "locality"), this.address.province = this.findDataShortName(
            n,
            "administrative_area_level_1"
          ), this.address.country = this.findDataShortName(n, "country"), this.address.zipCode = this.findDataShortName(n, "postal_code"), this.$emit("newAddress", this.address);
        });
      }
    },
    findDataShortName(e, t) {
      var n;
      return (n = e == null ? void 0 : e.find((r) => r.types.includes(t))) == null ? void 0 : n.short_name;
    },
    setInitialAddress() {
      this.initialAddress && this.initialAddress.address && (this.$refs.autocompleteInput.value = this.initialAddress.address);
    },
    resetGoogleAddress() {
      this.address = {
        street: "",
        city: "",
        province: "",
        country: "",
        zipCode: ""
      }, this.$refs.autocompleteInput && (this.$refs.autocompleteInput.value = "");
    }
  }
}, O6 = { class: "mb-1" }, M6 = {
  key: 0,
  class: "mt-2 text-sm text-red-600"
};
function I6(e, t, n, r, i, a) {
  return _(), O("div", null, [
    k("form", null, [
      t[1] || (t[1] = k("p", { class: "block text-sm text-gray-600" }, [
        Me(" Adresse "),
        k("span", { class: "ml-1 text-red-600" }, "*")
      ], -1)),
      k("div", O6, [
        k("input", {
          ref: "autocompleteInput",
          id: "autocomplete",
          type: "text",
          placeholder: "58 rue de la Victoire, Paris, France",
          class: "shadow-xs focus:ring-primary focus:border-primary block w-full sm:text-sm border-gray-300 rounded-md",
          onKeydown: t[0] || (t[0] = bt(sn(() => {
          }, ["prevent"]), ["enter"]))
        }, null, 544)
      ]),
      k("div", null, [
        e.addressError ? (_(), O("p", M6, " Une adresse valide est requise. ")) : L("", !0)
      ])
    ])
  ]);
}
const s0e = /* @__PURE__ */ we(P6, [["render", I6]]);
function R6(e) {
  if (!e) return "";
  let t = e.address1;
  return Cr(e.address2) && (t += `, ${e.address2}`), Cr(e.city) && (t += `, ${e.city}`), Cr(e.zipCode) && (t += `, ${e.zipCode}`), Cr(e.country) && (t += `, ${e.country}`), t;
}
const F6 = {
  props: {
    id: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      required: !1,
      default: null
    },
    labelClass: {
      type: String,
      default: "block text-sm leading-6 text-gray-900 sm:pt-1.5 mb-2"
    },
    placeholder: {
      type: String,
      default: ""
    },
    modelValue: {
      type: Object,
      required: !0
    },
    required: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      countries: ["fr", "mq", "gp", "re"]
      // restrict the country
    };
  },
  mounted() {
    this.setupAutocomplete();
  },
  computed: {
    isLabelPresent() {
      var e;
      return !(this.label === null || ((e = this.label) == null ? void 0 : e.length) === 0);
    },
    internalValue: {
      get() {
        return typeof this.modelValue != "object" ? this.modelValue : R6(this.modelValue);
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    },
    input() {
      return document.getElementById(this.id);
    }
  },
  methods: {
    setupAutocomplete() {
      if (!window.google) return console.error("Google API not loaded");
      const e = window.google;
      this.autocomplete = new e.maps.places.Autocomplete(this.input), this.autocomplete.setComponentRestrictions({ country: this.countries }), this.autocomplete.addListener("place_changed", () => {
        let t = this.autocomplete.getPlace(), n = t.address_components;
        const r = this.findDataShortName(n, "street_number"), i = this.findDataShortName(n, "route"), a = Cr(r) && Cr(i) ? `${r} ${i}` : t.formatted_address, s = this.findDataShortName(n, "locality"), o = this.findDataShortName(
          n,
          "administrative_area_level_1"
        ), l = this.findDataShortName(n, "country"), c = this.findDataShortName(n, "postal_code");
        let f = this.findDataShortName(n, "subpremise") || t.name;
        f === a && (f = ""), this.internalValue = {
          address1: a,
          address2: f,
          city: s,
          province: o,
          country: l,
          zipCode: c
        };
      });
    },
    findDataShortName(e, t) {
      var n;
      return (n = e == null ? void 0 : e.find((r) => r.types.includes(t))) == null ? void 0 : n.short_name;
    },
    resetLocation() {
      this.internalValue = {
        address1: "",
        address2: "",
        city: "",
        province: "",
        country: "",
        zipCode: ""
      };
    }
  }
}, N6 = ["for"], L6 = {
  key: 0,
  class: "text-red-600"
}, $6 = { class: "relative" }, V6 = ["id", "placeholder"];
function B6(e, t, n, r, i, a) {
  return _(), O("div", null, [
    a.isLabelPresent ? (_(), O("label", {
      key: 0,
      for: n.id,
      class: Pe(n.labelClass)
    }, [
      Me(j(e.$t(n.label)) + " ", 1),
      n.required ? (_(), O("span", L6, "*")) : L("", !0)
    ], 10, N6)) : L("", !0),
    k("div", $6, [
      ur(k("input", {
        id: n.id,
        placeholder: n.placeholder,
        "onUpdate:modelValue": t[0] || (t[0] = (s) => a.internalValue = s),
        type: "text",
        class: "shadow-xs focus:ring-primary focus:border-primary block w-full sm:text-sm border-gray-300 rounded-md",
        onKeydown: t[1] || (t[1] = bt(sn(() => {
        }, ["prevent"]), ["enter"]))
      }, null, 40, V6), [
        [tl, a.internalValue]
      ])
    ])
  ]);
}
const o0e = /* @__PURE__ */ we(F6, [["render", B6]]);
function U6(e, t, n) {
  let r = ge(n == null ? void 0 : n.value), i = ce(() => e.value !== void 0);
  return [ce(() => i.value ? e.value : r.value), function(a) {
    return i.value || (r.value = a), t == null ? void 0 : t(a);
  }];
}
function S0(e) {
  typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((t) => setTimeout(() => {
    throw t;
  }));
}
function ed() {
  let e = [], t = { addEventListener(n, r, i, a) {
    return n.addEventListener(r, i, a), t.add(() => n.removeEventListener(r, i, a));
  }, requestAnimationFrame(...n) {
    let r = requestAnimationFrame(...n);
    t.add(() => cancelAnimationFrame(r));
  }, nextFrame(...n) {
    t.requestAnimationFrame(() => {
      t.requestAnimationFrame(...n);
    });
  }, setTimeout(...n) {
    let r = setTimeout(...n);
    t.add(() => clearTimeout(r));
  }, microTask(...n) {
    let r = { current: !0 };
    return S0(() => {
      r.current && n[0]();
    }), t.add(() => {
      r.current = !1;
    });
  }, style(n, r, i) {
    let a = n.style.getPropertyValue(r);
    return Object.assign(n.style, { [r]: i }), this.add(() => {
      Object.assign(n.style, { [r]: a });
    });
  }, group(n) {
    let r = ed();
    return n(r), this.add(() => r.dispose());
  }, add(n) {
    return e.push(n), () => {
      let r = e.indexOf(n);
      if (r >= 0) for (let i of e.splice(r, 1)) i();
    };
  }, dispose() {
    for (let n of e.splice(0)) n();
  } };
  return t;
}
var sS;
let q6 = Symbol("headlessui.useid"), j6 = 0;
const tr = (sS = Kw.useId) != null ? sS : function() {
  return Kw.inject(q6, () => `${++j6}`)();
};
function Ie(e) {
  var t;
  if (e == null || e.value == null) return null;
  let n = (t = e.value.$el) != null ? t : e.value;
  return n instanceof Node ? n : null;
}
function vn(e, t, ...n) {
  if (e in t) {
    let i = t[e];
    return typeof i == "function" ? i(...n) : i;
  }
  let r = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(t).map((i) => `"${i}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(r, vn), r;
}
var W6 = Object.defineProperty, z6 = (e, t, n) => t in e ? W6(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, oS = (e, t, n) => (z6(e, typeof t != "symbol" ? t + "" : t, n), n);
let H6 = class {
  constructor() {
    oS(this, "current", this.detect()), oS(this, "currentId", 0);
  }
  set(t) {
    this.current !== t && (this.currentId = 0, this.current = t);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
}, td = new H6();
function Xi(e) {
  if (td.isServer) return null;
  if (e instanceof Node) return e.ownerDocument;
  if (e != null && e.hasOwnProperty("value")) {
    let t = Ie(e);
    if (t) return t.ownerDocument;
  }
  return document;
}
let hy = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e) => `${e}:not([tabindex='-1'])`).join(",");
var pr = ((e) => (e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e))(pr || {}), Uc = ((e) => (e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))(Uc || {}), G6 = ((e) => (e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))(G6 || {});
function nd(e = document.body) {
  return e == null ? [] : Array.from(e.querySelectorAll(hy)).sort((t, n) => Math.sign((t.tabIndex || Number.MAX_SAFE_INTEGER) - (n.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var rd = ((e) => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(rd || {});
function id(e, t = 0) {
  var n;
  return e === ((n = Xi(e)) == null ? void 0 : n.body) ? !1 : vn(t, { 0() {
    return e.matches(hy);
  }, 1() {
    let r = e;
    for (; r !== null; ) {
      if (r.matches(hy)) return !0;
      r = r.parentElement;
    }
    return !1;
  } });
}
function aO(e) {
  let t = Xi(e);
  Nn(() => {
    t && !id(t.activeElement, 0) && zs(e);
  });
}
var Y6 = ((e) => (e[e.Keyboard = 0] = "Keyboard", e[e.Mouse = 1] = "Mouse", e))(Y6 || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (e) => {
  e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e) => {
  e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function zs(e) {
  e == null || e.focus({ preventScroll: !0 });
}
let K6 = ["textarea", "input"].join(",");
function X6(e) {
  var t, n;
  return (n = (t = e == null ? void 0 : e.matches) == null ? void 0 : t.call(e, K6)) != null ? n : !1;
}
function C0(e, t = (n) => n) {
  return e.slice().sort((n, r) => {
    let i = t(n), a = t(r);
    if (i === null || a === null) return 0;
    let s = i.compareDocumentPosition(a);
    return s & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : s & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function Z6(e, t) {
  return Wi(nd(), t, { relativeTo: e });
}
function Wi(e, t, { sorted: n = !0, relativeTo: r = null, skipElements: i = [] } = {}) {
  var a;
  let s = (a = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e == null ? void 0 : e.ownerDocument) != null ? a : document, o = Array.isArray(e) ? n ? C0(e) : e : nd(e);
  i.length > 0 && o.length > 1 && (o = o.filter((v) => !i.includes(v))), r = r ?? s.activeElement;
  let l = (() => {
    if (t & 5) return 1;
    if (t & 10) return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), c = (() => {
    if (t & 1) return 0;
    if (t & 2) return Math.max(0, o.indexOf(r)) - 1;
    if (t & 4) return Math.max(0, o.indexOf(r)) + 1;
    if (t & 8) return o.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), f = t & 32 ? { preventScroll: !0 } : {}, h = 0, p = o.length, g;
  do {
    if (h >= p || h + p <= 0) return 0;
    let v = c + h;
    if (t & 16) v = (v + p) % p;
    else {
      if (v < 0) return 3;
      if (v >= p) return 1;
    }
    g = o[v], g == null || g.focus(f), h += l;
  } while (g !== s.activeElement);
  return t & 6 && X6(g) && g.select(), 2;
}
function sO() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function Q6() {
  return /Android/gi.test(window.navigator.userAgent);
}
function J6() {
  return sO() || Q6();
}
function If(e, t, n) {
  td.isServer || _r((r) => {
    document.addEventListener(e, t, n), r(() => document.removeEventListener(e, t, n));
  });
}
function oO(e, t, n) {
  td.isServer || _r((r) => {
    window.addEventListener(e, t, n), r(() => window.removeEventListener(e, t, n));
  });
}
function hp(e, t, n = ce(() => !0)) {
  function r(a, s) {
    if (!n.value || a.defaultPrevented) return;
    let o = s(a);
    if (o === null || !o.getRootNode().contains(o)) return;
    let l = (function c(f) {
      return typeof f == "function" ? c(f()) : Array.isArray(f) || f instanceof Set ? f : [f];
    })(e);
    for (let c of l) {
      if (c === null) continue;
      let f = c instanceof HTMLElement ? c : Ie(c);
      if (f != null && f.contains(o) || a.composed && a.composedPath().includes(f)) return;
    }
    return !id(o, rd.Loose) && o.tabIndex !== -1 && a.preventDefault(), t(a, o);
  }
  let i = ge(null);
  If("pointerdown", (a) => {
    var s, o;
    n.value && (i.value = ((o = (s = a.composedPath) == null ? void 0 : s.call(a)) == null ? void 0 : o[0]) || a.target);
  }, !0), If("mousedown", (a) => {
    var s, o;
    n.value && (i.value = ((o = (s = a.composedPath) == null ? void 0 : s.call(a)) == null ? void 0 : o[0]) || a.target);
  }, !0), If("click", (a) => {
    J6() || i.value && (r(a, () => i.value), i.value = null);
  }, !0), If("touchend", (a) => r(a, () => a.target instanceof HTMLElement ? a.target : null), !0), oO("blur", (a) => r(a, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
function lS(e, t) {
  if (e) return e;
  let n = t ?? "button";
  if (typeof n == "string" && n.toLowerCase() === "button") return "button";
}
function T0(e, t) {
  let n = ge(lS(e.value.type, e.value.as));
  return Ft(() => {
    n.value = lS(e.value.type, e.value.as);
  }), _r(() => {
    var r;
    n.value || Ie(t) && Ie(t) instanceof HTMLButtonElement && !((r = Ie(t)) != null && r.hasAttribute("type")) && (n.value = "button");
  }), n;
}
function uS(e) {
  return [e.screenX, e.screenY];
}
function lO() {
  let e = ge([-1, -1]);
  return { wasMoved(t) {
    let n = uS(t);
    return e.value[0] === n[0] && e.value[1] === n[1] ? !1 : (e.value = n, !0);
  }, update(t) {
    e.value = uS(t);
  } };
}
function e7({ container: e, accept: t, walk: n, enabled: r }) {
  _r(() => {
    let i = e.value;
    if (!i || r !== void 0 && !r.value) return;
    let a = Xi(e);
    if (!a) return;
    let s = Object.assign((l) => t(l), { acceptNode: t }), o = a.createTreeWalker(i, NodeFilter.SHOW_ELEMENT, s, !1);
    for (; o.nextNode(); ) n(o.currentNode);
  });
}
var Yi = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(Yi || {}), Bs = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(Bs || {});
function un({ visible: e = !0, features: t = 0, ourProps: n, theirProps: r, ...i }) {
  var a;
  let s = cO(r, n), o = Object.assign(i, { props: s });
  if (e || t & 2 && s.static) return Ig(o);
  if (t & 1) {
    let l = (a = s.unmount) == null || a ? 0 : 1;
    return vn(l, { 0() {
      return null;
    }, 1() {
      return Ig({ ...i, props: { ...s, hidden: !0, style: { display: "none" } } });
    } });
  }
  return Ig(o);
}
function Ig({ props: e, attrs: t, slots: n, slot: r, name: i }) {
  var a, s;
  let { as: o, ...l } = A0(e, ["unmount", "static"]), c = (a = n.default) == null ? void 0 : a.call(n, r), f = {};
  if (r) {
    let h = !1, p = [];
    for (let [g, v] of Object.entries(r)) typeof v == "boolean" && (h = !0), v === !0 && p.push(g);
    h && (f["data-headlessui-state"] = p.join(" "));
  }
  if (o === "template") {
    if (c = uO(c ?? []), Object.keys(l).length > 0 || Object.keys(t).length > 0) {
      let [h, ...p] = c ?? [];
      if (!n7(h) || p.length > 0) throw new Error(['Passing props on "template"!', "", `The current component <${i} /> is rendering a "template".`, "However we need to passthrough the following props:", Object.keys(l).concat(Object.keys(t)).map((y) => y.trim()).filter((y, S, x) => x.indexOf(y) === S).sort((y, S) => y.localeCompare(S)).map((y) => `  - ${y}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "template".', "Render a single element as the child so that we can forward the props onto that element."].map((y) => `  - ${y}`).join(`
`)].join(`
`));
      let g = cO((s = h.props) != null ? s : {}, l, f), v = j5(h, g, !0);
      for (let y in g) y.startsWith("on") && (v.props || (v.props = {}), v.props[y] = g[y]);
      return v;
    }
    return Array.isArray(c) && c.length === 1 ? c[0] : c;
  }
  return $t(o, Object.assign({}, l, f), { default: () => c });
}
function uO(e) {
  return e.flatMap((t) => t.type === Re ? uO(t.children) : [t]);
}
function cO(...e) {
  if (e.length === 0) return {};
  if (e.length === 1) return e[0];
  let t = {}, n = {};
  for (let r of e) for (let i in r) i.startsWith("on") && typeof r[i] == "function" ? (n[i] != null || (n[i] = []), n[i].push(r[i])) : t[i] = r[i];
  if (t.disabled || t["aria-disabled"]) return Object.assign(t, Object.fromEntries(Object.keys(n).map((r) => [r, void 0])));
  for (let r in n) Object.assign(t, { [r](i, ...a) {
    let s = n[r];
    for (let o of s) {
      if (i instanceof Event && i.defaultPrevented) return;
      o(i, ...a);
    }
  } });
  return t;
}
function t7(e) {
  let t = Object.assign({}, e);
  for (let n in t) t[n] === void 0 && delete t[n];
  return t;
}
function A0(e, t = []) {
  let n = Object.assign({}, e);
  for (let r of t) r in n && delete n[r];
  return n;
}
function n7(e) {
  return e == null ? !1 : typeof e.type == "string" || typeof e.type == "object" || typeof e.type == "function";
}
var cs = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(cs || {});
let Xs = dt({ name: "Hidden", props: { as: { type: [Object, String], default: "div" }, features: { type: Number, default: 1 } }, setup(e, { slots: t, attrs: n }) {
  return () => {
    var r;
    let { features: i, ...a } = e, s = { "aria-hidden": (i & 2) === 2 ? !0 : (r = a["aria-hidden"]) != null ? r : void 0, hidden: (i & 4) === 4 ? !0 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(i & 4) === 4 && (i & 2) !== 2 && { display: "none" } } };
    return un({ ourProps: s, theirProps: a, slot: {}, attrs: n, slots: t, name: "Hidden" });
  };
} }), dO = Symbol("Context");
var on = ((e) => (e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))(on || {});
function r7() {
  return il() !== null;
}
function il() {
  return br(dO, null);
}
function pp(e) {
  Zr(dO, e);
}
var vt = ((e) => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))(vt || {});
function i7(e) {
  function t() {
    document.readyState !== "loading" && (e(), document.removeEventListener("DOMContentLoaded", t));
  }
  typeof window < "u" && typeof document < "u" && (document.addEventListener("DOMContentLoaded", t), t());
}
let No = [];
i7(() => {
  function e(t) {
    t.target instanceof HTMLElement && t.target !== document.body && No[0] !== t.target && (No.unshift(t.target), No = No.filter((n) => n != null && n.isConnected), No.splice(10));
  }
  window.addEventListener("click", e, { capture: !0 }), window.addEventListener("mousedown", e, { capture: !0 }), window.addEventListener("focus", e, { capture: !0 }), document.body.addEventListener("click", e, { capture: !0 }), document.body.addEventListener("mousedown", e, { capture: !0 }), document.body.addEventListener("focus", e, { capture: !0 });
});
function a7(e) {
  throw new Error("Unexpected object: " + e);
}
var ln = ((e) => (e[e.First = 0] = "First", e[e.Previous = 1] = "Previous", e[e.Next = 2] = "Next", e[e.Last = 3] = "Last", e[e.Specific = 4] = "Specific", e[e.Nothing = 5] = "Nothing", e))(ln || {});
function fO(e, t) {
  let n = t.resolveItems();
  if (n.length <= 0) return null;
  let r = t.resolveActiveIndex(), i = r ?? -1;
  switch (e.focus) {
    case 0: {
      for (let a = 0; a < n.length; ++a) if (!t.resolveDisabled(n[a], a, n)) return a;
      return r;
    }
    case 1: {
      i === -1 && (i = n.length);
      for (let a = i - 1; a >= 0; --a) if (!t.resolveDisabled(n[a], a, n)) return a;
      return r;
    }
    case 2: {
      for (let a = i + 1; a < n.length; ++a) if (!t.resolveDisabled(n[a], a, n)) return a;
      return r;
    }
    case 3: {
      for (let a = n.length - 1; a >= 0; --a) if (!t.resolveDisabled(n[a], a, n)) return a;
      return r;
    }
    case 4: {
      for (let a = 0; a < n.length; ++a) if (t.resolveId(n[a], a, n) === e.id) return a;
      return r;
    }
    case 5:
      return null;
    default:
      a7(e);
  }
}
function hO(e = {}, t = null, n = []) {
  for (let [r, i] of Object.entries(e)) mO(n, pO(t, r), i);
  return n;
}
function pO(e, t) {
  return e ? e + "[" + t + "]" : t;
}
function mO(e, t, n) {
  if (Array.isArray(n)) for (let [r, i] of n.entries()) mO(e, pO(t, r.toString()), i);
  else n instanceof Date ? e.push([t, n.toISOString()]) : typeof n == "boolean" ? e.push([t, n ? "1" : "0"]) : typeof n == "string" ? e.push([t, n]) : typeof n == "number" ? e.push([t, `${n}`]) : n == null ? e.push([t, ""]) : hO(n, t, e);
}
function D0(e, t, n, r) {
  td.isServer || _r((i) => {
    e = e ?? window, e.addEventListener(t, n, r), i(() => e.removeEventListener(t, n, r));
  });
}
var wi = ((e) => (e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))(wi || {});
function E0() {
  let e = ge(0);
  return oO("keydown", (t) => {
    t.key === "Tab" && (e.value = t.shiftKey ? 1 : 0);
  }), e;
}
function gO(e) {
  if (!e) return /* @__PURE__ */ new Set();
  if (typeof e == "function") return new Set(e());
  let t = /* @__PURE__ */ new Set();
  for (let n of e.value) {
    let r = Ie(n);
    r instanceof HTMLElement && t.add(r);
  }
  return t;
}
var vO = ((e) => (e[e.None = 1] = "None", e[e.InitialFocus = 2] = "InitialFocus", e[e.TabLock = 4] = "TabLock", e[e.FocusLock = 8] = "FocusLock", e[e.RestoreFocus = 16] = "RestoreFocus", e[e.All = 30] = "All", e))(vO || {});
let Qu = Object.assign(dt({ name: "FocusTrap", props: { as: { type: [Object, String], default: "div" }, initialFocus: { type: Object, default: null }, features: { type: Number, default: 30 }, containers: { type: [Object, Function], default: ge(/* @__PURE__ */ new Set()) } }, inheritAttrs: !1, setup(e, { attrs: t, slots: n, expose: r }) {
  let i = ge(null);
  r({ el: i, $el: i });
  let a = ce(() => Xi(i)), s = ge(!1);
  Ft(() => s.value = !0), cr(() => s.value = !1), o7({ ownerDocument: a }, ce(() => s.value && !!(e.features & 16)));
  let o = l7({ ownerDocument: a, container: i, initialFocus: ce(() => e.initialFocus) }, ce(() => s.value && !!(e.features & 2)));
  u7({ ownerDocument: a, container: i, containers: e.containers, previousActiveElement: o }, ce(() => s.value && !!(e.features & 8)));
  let l = E0();
  function c(g) {
    let v = Ie(i);
    v && ((y) => y())(() => {
      vn(l.value, { [wi.Forwards]: () => {
        Wi(v, pr.First, { skipElements: [g.relatedTarget] });
      }, [wi.Backwards]: () => {
        Wi(v, pr.Last, { skipElements: [g.relatedTarget] });
      } });
    });
  }
  let f = ge(!1);
  function h(g) {
    g.key === "Tab" && (f.value = !0, requestAnimationFrame(() => {
      f.value = !1;
    }));
  }
  function p(g) {
    if (!s.value) return;
    let v = gO(e.containers);
    Ie(i) instanceof HTMLElement && v.add(Ie(i));
    let y = g.relatedTarget;
    y instanceof HTMLElement && y.dataset.headlessuiFocusGuard !== "true" && (bO(v, y) || (f.value ? Wi(Ie(i), vn(l.value, { [wi.Forwards]: () => pr.Next, [wi.Backwards]: () => pr.Previous }) | pr.WrapAround, { relativeTo: g.target }) : g.target instanceof HTMLElement && zs(g.target)));
  }
  return () => {
    let g = {}, v = { ref: i, onKeydown: h, onFocusout: p }, { features: y, initialFocus: S, containers: x, ...E } = e;
    return $t(Re, [!!(y & 4) && $t(Xs, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: c, features: cs.Focusable }), un({ ourProps: v, theirProps: { ...t, ...E }, slot: g, attrs: t, slots: n, name: "FocusTrap" }), !!(y & 4) && $t(Xs, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: c, features: cs.Focusable })]);
  };
} }), { features: vO });
function s7(e) {
  let t = ge(No.slice());
  return Ln([e], ([n], [r]) => {
    r === !0 && n === !1 ? S0(() => {
      t.value.splice(0);
    }) : r === !1 && n === !0 && (t.value = No.slice());
  }, { flush: "post" }), () => {
    var n;
    return (n = t.value.find((r) => r != null && r.isConnected)) != null ? n : null;
  };
}
function o7({ ownerDocument: e }, t) {
  let n = s7(t);
  Ft(() => {
    _r(() => {
      var r, i;
      t.value || ((r = e.value) == null ? void 0 : r.activeElement) === ((i = e.value) == null ? void 0 : i.body) && zs(n());
    }, { flush: "post" });
  }), cr(() => {
    t.value && zs(n());
  });
}
function l7({ ownerDocument: e, container: t, initialFocus: n }, r) {
  let i = ge(null), a = ge(!1);
  return Ft(() => a.value = !0), cr(() => a.value = !1), Ft(() => {
    Ln([t, n, r], (s, o) => {
      if (s.every((c, f) => (o == null ? void 0 : o[f]) === c) || !r.value) return;
      let l = Ie(t);
      l && S0(() => {
        var c, f;
        if (!a.value) return;
        let h = Ie(n), p = (c = e.value) == null ? void 0 : c.activeElement;
        if (h) {
          if (h === p) {
            i.value = p;
            return;
          }
        } else if (l.contains(p)) {
          i.value = p;
          return;
        }
        h ? zs(h) : Wi(l, pr.First | pr.NoScroll) === Uc.Error && console.warn("There are no focusable elements inside the <FocusTrap />"), i.value = (f = e.value) == null ? void 0 : f.activeElement;
      });
    }, { immediate: !0, flush: "post" });
  }), i;
}
function u7({ ownerDocument: e, container: t, containers: n, previousActiveElement: r }, i) {
  var a;
  D0((a = e.value) == null ? void 0 : a.defaultView, "focus", (s) => {
    if (!i.value) return;
    let o = gO(n);
    Ie(t) instanceof HTMLElement && o.add(Ie(t));
    let l = r.value;
    if (!l) return;
    let c = s.target;
    c && c instanceof HTMLElement ? bO(o, c) ? (r.value = c, zs(c)) : (s.preventDefault(), s.stopPropagation(), zs(l)) : zs(r.value);
  }, !0);
}
function bO(e, t) {
  for (let n of e) if (n.contains(t)) return !0;
  return !1;
}
function c7(e) {
  let t = rp(e.getSnapshot());
  return cr(e.subscribe(() => {
    t.value = e.getSnapshot();
  })), t;
}
function d7(e, t) {
  let n = e(), r = /* @__PURE__ */ new Set();
  return { getSnapshot() {
    return n;
  }, subscribe(i) {
    return r.add(i), () => r.delete(i);
  }, dispatch(i, ...a) {
    let s = t[i].call(n, ...a);
    s && (n = s, r.forEach((o) => o()));
  } };
}
function f7() {
  let e;
  return { before({ doc: t }) {
    var n;
    let r = t.documentElement;
    e = ((n = t.defaultView) != null ? n : window).innerWidth - r.clientWidth;
  }, after({ doc: t, d: n }) {
    let r = t.documentElement, i = r.clientWidth - r.offsetWidth, a = e - i;
    n.style(r, "paddingRight", `${a}px`);
  } };
}
function h7() {
  return sO() ? { before({ doc: e, d: t, meta: n }) {
    function r(i) {
      return n.containers.flatMap((a) => a()).some((a) => a.contains(i));
    }
    t.microTask(() => {
      var i;
      if (window.getComputedStyle(e.documentElement).scrollBehavior !== "auto") {
        let o = ed();
        o.style(e.documentElement, "scrollBehavior", "auto"), t.add(() => t.microTask(() => o.dispose()));
      }
      let a = (i = window.scrollY) != null ? i : window.pageYOffset, s = null;
      t.addEventListener(e, "click", (o) => {
        if (o.target instanceof HTMLElement) try {
          let l = o.target.closest("a");
          if (!l) return;
          let { hash: c } = new URL(l.href), f = e.querySelector(c);
          f && !r(f) && (s = f);
        } catch {
        }
      }, !0), t.addEventListener(e, "touchstart", (o) => {
        if (o.target instanceof HTMLElement) if (r(o.target)) {
          let l = o.target;
          for (; l.parentElement && r(l.parentElement); ) l = l.parentElement;
          t.style(l, "overscrollBehavior", "contain");
        } else t.style(o.target, "touchAction", "none");
      }), t.addEventListener(e, "touchmove", (o) => {
        if (o.target instanceof HTMLElement) {
          if (o.target.tagName === "INPUT") return;
          if (r(o.target)) {
            let l = o.target;
            for (; l.parentElement && l.dataset.headlessuiPortal !== "" && !(l.scrollHeight > l.clientHeight || l.scrollWidth > l.clientWidth); ) l = l.parentElement;
            l.dataset.headlessuiPortal === "" && o.preventDefault();
          } else o.preventDefault();
        }
      }, { passive: !1 }), t.add(() => {
        var o;
        let l = (o = window.scrollY) != null ? o : window.pageYOffset;
        a !== l && window.scrollTo(0, a), s && s.isConnected && (s.scrollIntoView({ block: "nearest" }), s = null);
      });
    });
  } } : {};
}
function p7() {
  return { before({ doc: e, d: t }) {
    t.style(e.documentElement, "overflow", "hidden");
  } };
}
function m7(e) {
  let t = {};
  for (let n of e) Object.assign(t, n(t));
  return t;
}
let Vo = d7(() => /* @__PURE__ */ new Map(), { PUSH(e, t) {
  var n;
  let r = (n = this.get(e)) != null ? n : { doc: e, count: 0, d: ed(), meta: /* @__PURE__ */ new Set() };
  return r.count++, r.meta.add(t), this.set(e, r), this;
}, POP(e, t) {
  let n = this.get(e);
  return n && (n.count--, n.meta.delete(t)), this;
}, SCROLL_PREVENT({ doc: e, d: t, meta: n }) {
  let r = { doc: e, d: t, meta: m7(n) }, i = [h7(), f7(), p7()];
  i.forEach(({ before: a }) => a == null ? void 0 : a(r)), i.forEach(({ after: a }) => a == null ? void 0 : a(r));
}, SCROLL_ALLOW({ d: e }) {
  e.dispose();
}, TEARDOWN({ doc: e }) {
  this.delete(e);
} });
Vo.subscribe(() => {
  let e = Vo.getSnapshot(), t = /* @__PURE__ */ new Map();
  for (let [n] of e) t.set(n, n.documentElement.style.overflow);
  for (let n of e.values()) {
    let r = t.get(n.doc) === "hidden", i = n.count !== 0;
    (i && !r || !i && r) && Vo.dispatch(n.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", n), n.count === 0 && Vo.dispatch("TEARDOWN", n);
  }
});
function g7(e, t, n) {
  let r = c7(Vo), i = ce(() => {
    let a = e.value ? r.value.get(e.value) : void 0;
    return a ? a.count > 0 : !1;
  });
  return Ln([e, t], ([a, s], [o], l) => {
    if (!a || !s) return;
    Vo.dispatch("PUSH", a, n);
    let c = !1;
    l(() => {
      c || (Vo.dispatch("POP", o ?? a, n), c = !0);
    });
  }, { immediate: !0 }), i;
}
let Rg = /* @__PURE__ */ new Map(), Ju = /* @__PURE__ */ new Map();
function cS(e, t = ge(!0)) {
  _r((n) => {
    var r;
    if (!t.value) return;
    let i = Ie(e);
    if (!i) return;
    n(function() {
      var s;
      if (!i) return;
      let o = (s = Ju.get(i)) != null ? s : 1;
      if (o === 1 ? Ju.delete(i) : Ju.set(i, o - 1), o !== 1) return;
      let l = Rg.get(i);
      l && (l["aria-hidden"] === null ? i.removeAttribute("aria-hidden") : i.setAttribute("aria-hidden", l["aria-hidden"]), i.inert = l.inert, Rg.delete(i));
    });
    let a = (r = Ju.get(i)) != null ? r : 0;
    Ju.set(i, a + 1), a === 0 && (Rg.set(i, { "aria-hidden": i.getAttribute("aria-hidden"), inert: i.inert }), i.setAttribute("aria-hidden", "true"), i.inert = !0);
  });
}
function _O({ defaultContainers: e = [], portals: t, mainTreeNodeRef: n } = {}) {
  let r = ge(null), i = Xi(r);
  function a() {
    var s, o, l;
    let c = [];
    for (let f of e) f !== null && (f instanceof HTMLElement ? c.push(f) : "value" in f && f.value instanceof HTMLElement && c.push(f.value));
    if (t != null && t.value) for (let f of t.value) c.push(f);
    for (let f of (s = i == null ? void 0 : i.querySelectorAll("html > *, body > *")) != null ? s : []) f !== document.body && f !== document.head && f instanceof HTMLElement && f.id !== "headlessui-portal-root" && (f.contains(Ie(r)) || f.contains((l = (o = Ie(r)) == null ? void 0 : o.getRootNode()) == null ? void 0 : l.host) || c.some((h) => f.contains(h)) || c.push(f));
    return c;
  }
  return { resolveContainers: a, contains(s) {
    return a().some((o) => o.contains(s));
  }, mainTreeNodeRef: r, MainTreeNode() {
    return n != null ? null : $t(Xs, { features: cs.Hidden, ref: r });
  } };
}
function v7() {
  let e = ge(null);
  return { mainTreeNodeRef: e, MainTreeNode() {
    return $t(Xs, { features: cs.Hidden, ref: e });
  } };
}
let yO = Symbol("ForcePortalRootContext");
function b7() {
  return br(yO, !1);
}
let py = dt({ name: "ForcePortalRoot", props: { as: { type: [Object, String], default: "template" }, force: { type: Boolean, default: !1 } }, setup(e, { slots: t, attrs: n }) {
  return Zr(yO, e.force), () => {
    let { force: r, ...i } = e;
    return un({ theirProps: i, ourProps: {}, slot: {}, slots: t, attrs: n, name: "ForcePortalRoot" });
  };
} }), xO = Symbol("StackContext");
var my = ((e) => (e[e.Add = 0] = "Add", e[e.Remove = 1] = "Remove", e))(my || {});
function _7() {
  return br(xO, () => {
  });
}
function y7({ type: e, enabled: t, element: n, onUpdate: r }) {
  let i = _7();
  function a(...s) {
    r == null || r(...s), i(...s);
  }
  Ft(() => {
    Ln(t, (s, o) => {
      s ? a(0, e, n) : o === !0 && a(1, e, n);
    }, { immediate: !0, flush: "sync" });
  }), cr(() => {
    t.value && a(1, e, n);
  }), Zr(xO, a);
}
let wO = Symbol("DescriptionContext");
function x7() {
  let e = br(wO, null);
  if (e === null) throw new Error("Missing parent");
  return e;
}
function w7({ slot: e = ge({}), name: t = "Description", props: n = {} } = {}) {
  let r = ge([]);
  function i(a) {
    return r.value.push(a), () => {
      let s = r.value.indexOf(a);
      s !== -1 && r.value.splice(s, 1);
    };
  }
  return Zr(wO, { register: i, slot: e, name: t, props: n }), ce(() => r.value.length > 0 ? r.value.join(" ") : void 0);
}
dt({ name: "Description", props: { as: { type: [Object, String], default: "p" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: n }) {
  var r;
  let i = (r = e.id) != null ? r : `headlessui-description-${tr()}`, a = x7();
  return Ft(() => cr(a.register(i))), () => {
    let { name: s = "Description", slot: o = ge({}), props: l = {} } = a, { ...c } = e, f = { ...Object.entries(l).reduce((h, [p, g]) => Object.assign(h, { [p]: re(g) }), {}), id: i };
    return un({ ourProps: f, theirProps: c, slot: o.value, attrs: t, slots: n, name: s });
  };
} });
function k7(e) {
  let t = Xi(e);
  if (!t) {
    if (e === null) return null;
    throw new Error(`[Headless UI]: Cannot find ownerDocument for contextElement: ${e}`);
  }
  let n = t.getElementById("headlessui-portal-root");
  if (n) return n;
  let r = t.createElement("div");
  return r.setAttribute("id", "headlessui-portal-root"), t.body.appendChild(r);
}
const gy = /* @__PURE__ */ new WeakMap();
function S7(e) {
  var t;
  return (t = gy.get(e)) != null ? t : 0;
}
function dS(e, t) {
  let n = t(S7(e));
  return n <= 0 ? gy.delete(e) : gy.set(e, n), n;
}
let kO = dt({ name: "Portal", props: { as: { type: [Object, String], default: "div" } }, setup(e, { slots: t, attrs: n }) {
  let r = ge(null), i = ce(() => Xi(r)), a = b7(), s = br(CO, null), o = ge(a === !0 || s == null ? k7(r.value) : s.resolveTarget());
  o.value && dS(o.value, (p) => p + 1);
  let l = ge(!1);
  Ft(() => {
    l.value = !0;
  }), _r(() => {
    a || s != null && (o.value = s.resolveTarget());
  });
  let c = br(vy, null), f = !1, h = np();
  return Ln(r, () => {
    if (f || !c) return;
    let p = Ie(r);
    p && (cr(c.register(p), h), f = !0);
  }), cr(() => {
    var p, g;
    let v = (p = i.value) == null ? void 0 : p.getElementById("headlessui-portal-root");
    !v || o.value !== v || dS(o.value, (y) => y - 1) || o.value.children.length > 0 || (g = o.value.parentElement) == null || g.removeChild(o.value);
  }), () => {
    if (!l.value || o.value === null) return null;
    let p = { ref: r, "data-headlessui-portal": "" };
    return $t(wP, { to: o.value }, un({ ourProps: p, theirProps: e, slot: {}, attrs: n, slots: t, name: "Portal" }));
  };
} }), vy = Symbol("PortalParentContext");
function SO() {
  let e = br(vy, null), t = ge([]);
  function n(a) {
    return t.value.push(a), e && e.register(a), () => r(a);
  }
  function r(a) {
    let s = t.value.indexOf(a);
    s !== -1 && t.value.splice(s, 1), e && e.unregister(a);
  }
  let i = { register: n, unregister: r, portals: t };
  return [t, dt({ name: "PortalWrapper", setup(a, { slots: s }) {
    return Zr(vy, i), () => {
      var o;
      return (o = s.default) == null ? void 0 : o.call(s);
    };
  } })];
}
let CO = Symbol("PortalGroupContext"), C7 = dt({ name: "PortalGroup", props: { as: { type: [Object, String], default: "template" }, target: { type: Object, default: null } }, setup(e, { attrs: t, slots: n }) {
  let r = nl({ resolveTarget() {
    return e.target;
  } });
  return Zr(CO, r), () => {
    let { target: i, ...a } = e;
    return un({ theirProps: a, ourProps: {}, slot: {}, attrs: t, slots: n, name: "PortalGroup" });
  };
} });
var T7 = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(T7 || {});
let by = Symbol("DialogContext");
function ad(e) {
  let t = br(by, null);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Dialog /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, ad), n;
  }
  return t;
}
let Rf = "DC8F892D-2EBD-447C-A4C8-A03058436FF4", P0 = dt({ name: "Dialog", inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, open: { type: [Boolean, String], default: Rf }, initialFocus: { type: Object, default: null }, id: { type: String, default: null }, role: { type: String, default: "dialog" } }, emits: { close: (e) => !0 }, setup(e, { emit: t, attrs: n, slots: r, expose: i }) {
  var a, s;
  let o = (a = e.id) != null ? a : `headlessui-dialog-${tr()}`, l = ge(!1);
  Ft(() => {
    l.value = !0;
  });
  let c = !1, f = ce(() => e.role === "dialog" || e.role === "alertdialog" ? e.role : (c || (c = !0, console.warn(`Invalid role [${f}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`)), "dialog")), h = ge(0), p = il(), g = ce(() => e.open === Rf && p !== null ? (p.value & on.Open) === on.Open : e.open), v = ge(null), y = ce(() => Xi(v));
  if (i({ el: v, $el: v }), !(e.open !== Rf || p !== null)) throw new Error("You forgot to provide an `open` prop to the `Dialog`.");
  if (typeof g.value != "boolean") throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${g.value === Rf ? void 0 : e.open}`);
  let S = ce(() => l.value && g.value ? 0 : 1), x = ce(() => S.value === 0), E = ce(() => h.value > 1), w = br(by, null) !== null, [C, P] = SO(), { resolveContainers: M, mainTreeNodeRef: T, MainTreeNode: N } = _O({ portals: C, defaultContainers: [ce(() => {
    var ue;
    return (ue = A.panelRef.value) != null ? ue : v.value;
  })] }), $ = ce(() => E.value ? "parent" : "leaf"), ne = ce(() => p !== null ? (p.value & on.Closing) === on.Closing : !1), Y = ce(() => w || ne.value ? !1 : x.value), te = ce(() => {
    var ue, Te, Ne;
    return (Ne = Array.from((Te = (ue = y.value) == null ? void 0 : ue.querySelectorAll("body > *")) != null ? Te : []).find((Z) => Z.id === "headlessui-portal-root" ? !1 : Z.contains(Ie(T)) && Z instanceof HTMLElement)) != null ? Ne : null;
  });
  cS(te, Y);
  let _e = ce(() => E.value ? !0 : x.value), Fe = ce(() => {
    var ue, Te, Ne;
    return (Ne = Array.from((Te = (ue = y.value) == null ? void 0 : ue.querySelectorAll("[data-headlessui-portal]")) != null ? Te : []).find((Z) => Z.contains(Ie(T)) && Z instanceof HTMLElement)) != null ? Ne : null;
  });
  cS(Fe, _e), y7({ type: "Dialog", enabled: ce(() => S.value === 0), element: v, onUpdate: (ue, Te) => {
    if (Te === "Dialog") return vn(ue, { [my.Add]: () => h.value += 1, [my.Remove]: () => h.value -= 1 });
  } });
  let J = w7({ name: "DialogDescription", slot: ce(() => ({ open: g.value })) }), oe = ge(null), A = { titleId: oe, panelRef: ge(null), dialogState: S, setTitleId(ue) {
    oe.value !== ue && (oe.value = ue);
  }, close() {
    t("close", !1);
  } };
  Zr(by, A);
  let X = ce(() => !(!x.value || E.value));
  hp(M, (ue, Te) => {
    ue.preventDefault(), A.close(), Nn(() => Te == null ? void 0 : Te.focus());
  }, X);
  let pe = ce(() => !(E.value || S.value !== 0));
  D0((s = y.value) == null ? void 0 : s.defaultView, "keydown", (ue) => {
    pe.value && (ue.defaultPrevented || ue.key === vt.Escape && (ue.preventDefault(), ue.stopPropagation(), A.close()));
  });
  let le = ce(() => !(ne.value || S.value !== 0 || w));
  return g7(y, le, (ue) => {
    var Te;
    return { containers: [...(Te = ue.containers) != null ? Te : [], M] };
  }), _r((ue) => {
    if (S.value !== 0) return;
    let Te = Ie(v);
    if (!Te) return;
    let Ne = new ResizeObserver((Z) => {
      for (let G of Z) {
        let se = G.target.getBoundingClientRect();
        se.x === 0 && se.y === 0 && se.width === 0 && se.height === 0 && A.close();
      }
    });
    Ne.observe(Te), ue(() => Ne.disconnect());
  }), () => {
    let { open: ue, initialFocus: Te, ...Ne } = e, Z = { ...n, ref: v, id: o, role: f.value, "aria-modal": S.value === 0 ? !0 : void 0, "aria-labelledby": oe.value, "aria-describedby": J.value }, G = { open: S.value === 0 };
    return $t(py, { force: !0 }, () => [$t(kO, () => $t(C7, { target: v.value }, () => $t(py, { force: !1 }, () => $t(Qu, { initialFocus: Te, containers: M, features: x.value ? vn($.value, { parent: Qu.features.RestoreFocus, leaf: Qu.features.All & ~Qu.features.FocusLock }) : Qu.features.None }, () => $t(P, {}, () => un({ ourProps: Z, theirProps: { ...Ne, ...n }, slot: G, attrs: n, slots: r, visible: S.value === 0, features: Yi.RenderStrategy | Yi.Static, name: "Dialog" })))))), $t(N)]);
  };
} }), A7 = dt({ name: "DialogOverlay", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: n }) {
  var r;
  let i = (r = e.id) != null ? r : `headlessui-dialog-overlay-${tr()}`, a = ad("DialogOverlay");
  function s(o) {
    o.target === o.currentTarget && (o.preventDefault(), o.stopPropagation(), a.close());
  }
  return () => {
    let { ...o } = e;
    return un({ ourProps: { id: i, "aria-hidden": !0, onClick: s }, theirProps: o, slot: { open: a.dialogState.value === 0 }, attrs: t, slots: n, name: "DialogOverlay" });
  };
} });
dt({ name: "DialogBackdrop", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, inheritAttrs: !1, setup(e, { attrs: t, slots: n, expose: r }) {
  var i;
  let a = (i = e.id) != null ? i : `headlessui-dialog-backdrop-${tr()}`, s = ad("DialogBackdrop"), o = ge(null);
  return r({ el: o, $el: o }), Ft(() => {
    if (s.panelRef.value === null) throw new Error("A <DialogBackdrop /> component is being used, but a <DialogPanel /> component is missing.");
  }), () => {
    let { ...l } = e, c = { id: a, ref: o, "aria-hidden": !0 };
    return $t(py, { force: !0 }, () => $t(kO, () => un({ ourProps: c, theirProps: { ...t, ...l }, slot: { open: s.dialogState.value === 0 }, attrs: t, slots: n, name: "DialogBackdrop" })));
  };
} });
let TO = dt({ name: "DialogPanel", props: { as: { type: [Object, String], default: "div" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: n, expose: r }) {
  var i;
  let a = (i = e.id) != null ? i : `headlessui-dialog-panel-${tr()}`, s = ad("DialogPanel");
  r({ el: s.panelRef, $el: s.panelRef });
  function o(l) {
    l.stopPropagation();
  }
  return () => {
    let { ...l } = e, c = { id: a, ref: s.panelRef, onClick: o };
    return un({ ourProps: c, theirProps: l, slot: { open: s.dialogState.value === 0 }, attrs: t, slots: n, name: "DialogPanel" });
  };
} }), D7 = dt({ name: "DialogTitle", props: { as: { type: [Object, String], default: "h2" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: n }) {
  var r;
  let i = (r = e.id) != null ? r : `headlessui-dialog-title-${tr()}`, a = ad("DialogTitle");
  return Ft(() => {
    a.setTitleId(i), cr(() => a.setTitleId(null));
  }), () => {
    let { ...s } = e;
    return un({ ourProps: { id: i }, theirProps: s, slot: { open: a.dialogState.value === 0 }, attrs: t, slots: n, name: "DialogTitle" });
  };
} }), fS = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function hS(e) {
  var t, n;
  let r = (t = e.innerText) != null ? t : "", i = e.cloneNode(!0);
  if (!(i instanceof HTMLElement)) return r;
  let a = !1;
  for (let o of i.querySelectorAll('[hidden],[aria-hidden],[role="img"]')) o.remove(), a = !0;
  let s = a ? (n = i.innerText) != null ? n : "" : r;
  return fS.test(s) && (s = s.replace(fS, "")), s;
}
function E7(e) {
  let t = e.getAttribute("aria-label");
  if (typeof t == "string") return t.trim();
  let n = e.getAttribute("aria-labelledby");
  if (n) {
    let r = n.split(" ").map((i) => {
      let a = document.getElementById(i);
      if (a) {
        let s = a.getAttribute("aria-label");
        return typeof s == "string" ? s.trim() : hS(a).trim();
      }
      return null;
    }).filter(Boolean);
    if (r.length > 0) return r.join(", ");
  }
  return hS(e).trim();
}
function AO(e) {
  let t = ge(""), n = ge("");
  return () => {
    let r = Ie(e);
    if (!r) return "";
    let i = r.innerText;
    if (t.value === i) return n.value;
    let a = E7(r).trim().toLowerCase();
    return t.value = i, n.value = a, a;
  };
}
function P7(e, t) {
  return e === t;
}
var O7 = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(O7 || {}), M7 = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(M7 || {}), I7 = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(I7 || {});
function R7(e) {
  requestAnimationFrame(() => requestAnimationFrame(e));
}
let DO = Symbol("ListboxContext");
function sd(e) {
  let t = br(DO, null);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, sd), n;
  }
  return t;
}
let EO = dt({ name: "Listbox", emits: { "update:modelValue": (e) => !0 }, props: { as: { type: [Object, String], default: "template" }, disabled: { type: [Boolean], default: !1 }, by: { type: [String, Function], default: () => P7 }, horizontal: { type: [Boolean], default: !1 }, modelValue: { type: [Object, String, Number, Boolean], default: void 0 }, defaultValue: { type: [Object, String, Number, Boolean], default: void 0 }, form: { type: String, optional: !0 }, name: { type: String, optional: !0 }, multiple: { type: [Boolean], default: !1 } }, inheritAttrs: !1, setup(e, { slots: t, attrs: n, emit: r }) {
  let i = ge(1), a = ge(null), s = ge(null), o = ge(null), l = ge([]), c = ge(""), f = ge(null), h = ge(1);
  function p(w = (C) => C) {
    let C = f.value !== null ? l.value[f.value] : null, P = C0(w(l.value.slice()), (T) => Ie(T.dataRef.domRef)), M = C ? P.indexOf(C) : null;
    return M === -1 && (M = null), { options: P, activeOptionIndex: M };
  }
  let g = ce(() => e.multiple ? 1 : 0), [v, y] = U6(ce(() => e.modelValue), (w) => r("update:modelValue", w), ce(() => e.defaultValue)), S = ce(() => v.value === void 0 ? vn(g.value, { 1: [], 0: void 0 }) : v.value), x = { listboxState: i, value: S, mode: g, compare(w, C) {
    if (typeof e.by == "string") {
      let P = e.by;
      return (w == null ? void 0 : w[P]) === (C == null ? void 0 : C[P]);
    }
    return e.by(w, C);
  }, orientation: ce(() => e.horizontal ? "horizontal" : "vertical"), labelRef: a, buttonRef: s, optionsRef: o, disabled: ce(() => e.disabled), options: l, searchQuery: c, activeOptionIndex: f, activationTrigger: h, closeListbox() {
    e.disabled || i.value !== 1 && (i.value = 1, f.value = null);
  }, openListbox() {
    e.disabled || i.value !== 0 && (i.value = 0);
  }, goToOption(w, C, P) {
    if (e.disabled || i.value === 1) return;
    let M = p(), T = fO(w === ln.Specific ? { focus: ln.Specific, id: C } : { focus: w }, { resolveItems: () => M.options, resolveActiveIndex: () => M.activeOptionIndex, resolveId: (N) => N.id, resolveDisabled: (N) => N.dataRef.disabled });
    c.value = "", f.value = T, h.value = P ?? 1, l.value = M.options;
  }, search(w) {
    if (e.disabled || i.value === 1) return;
    let C = c.value !== "" ? 0 : 1;
    c.value += w.toLowerCase();
    let P = (f.value !== null ? l.value.slice(f.value + C).concat(l.value.slice(0, f.value + C)) : l.value).find((T) => T.dataRef.textValue.startsWith(c.value) && !T.dataRef.disabled), M = P ? l.value.indexOf(P) : -1;
    M === -1 || M === f.value || (f.value = M, h.value = 1);
  }, clearSearch() {
    e.disabled || i.value !== 1 && c.value !== "" && (c.value = "");
  }, registerOption(w, C) {
    let P = p((M) => [...M, { id: w, dataRef: C }]);
    l.value = P.options, f.value = P.activeOptionIndex;
  }, unregisterOption(w) {
    let C = p((P) => {
      let M = P.findIndex((T) => T.id === w);
      return M !== -1 && P.splice(M, 1), P;
    });
    l.value = C.options, f.value = C.activeOptionIndex, h.value = 1;
  }, theirOnChange(w) {
    e.disabled || y(w);
  }, select(w) {
    e.disabled || y(vn(g.value, { 0: () => w, 1: () => {
      let C = aa(x.value.value).slice(), P = aa(w), M = C.findIndex((T) => x.compare(P, aa(T)));
      return M === -1 ? C.push(P) : C.splice(M, 1), C;
    } }));
  } };
  hp([s, o], (w, C) => {
    var P;
    x.closeListbox(), id(C, rd.Loose) || (w.preventDefault(), (P = Ie(s)) == null || P.focus());
  }, ce(() => i.value === 0)), Zr(DO, x), pp(ce(() => vn(i.value, { 0: on.Open, 1: on.Closed })));
  let E = ce(() => {
    var w;
    return (w = Ie(s)) == null ? void 0 : w.closest("form");
  });
  return Ft(() => {
    Ln([E], () => {
      if (!E.value || e.defaultValue === void 0) return;
      function w() {
        x.theirOnChange(e.defaultValue);
      }
      return E.value.addEventListener("reset", w), () => {
        var C;
        (C = E.value) == null || C.removeEventListener("reset", w);
      };
    }, { immediate: !0 });
  }), () => {
    let { name: w, modelValue: C, disabled: P, form: M, ...T } = e, N = { open: i.value === 0, disabled: P, value: S.value };
    return $t(Re, [...w != null && S.value != null ? hO({ [w]: S.value }).map(([$, ne]) => $t(Xs, t7({ features: cs.Hidden, key: $, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: M, disabled: P, name: $, value: ne }))) : [], un({ ourProps: {}, theirProps: { ...n, ...A0(T, ["defaultValue", "onUpdate:modelValue", "horizontal", "multiple", "by"]) }, slot: N, slots: t, attrs: n, name: "Listbox" })]);
  };
} });
dt({ name: "ListboxLabel", props: { as: { type: [Object, String], default: "label" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: n }) {
  var r;
  let i = (r = e.id) != null ? r : `headlessui-listbox-label-${tr()}`, a = sd("ListboxLabel");
  function s() {
    var o;
    (o = Ie(a.buttonRef)) == null || o.focus({ preventScroll: !0 });
  }
  return () => {
    let o = { open: a.listboxState.value === 0, disabled: a.disabled.value }, { ...l } = e, c = { id: i, ref: a.labelRef, onClick: s };
    return un({ ourProps: c, theirProps: l, slot: o, attrs: t, slots: n, name: "ListboxLabel" });
  };
} });
let PO = dt({ name: "ListboxButton", props: { as: { type: [Object, String], default: "button" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: n, expose: r }) {
  var i;
  let a = (i = e.id) != null ? i : `headlessui-listbox-button-${tr()}`, s = sd("ListboxButton");
  r({ el: s.buttonRef, $el: s.buttonRef });
  function o(h) {
    switch (h.key) {
      case vt.Space:
      case vt.Enter:
      case vt.ArrowDown:
        h.preventDefault(), s.openListbox(), Nn(() => {
          var p;
          (p = Ie(s.optionsRef)) == null || p.focus({ preventScroll: !0 }), s.value.value || s.goToOption(ln.First);
        });
        break;
      case vt.ArrowUp:
        h.preventDefault(), s.openListbox(), Nn(() => {
          var p;
          (p = Ie(s.optionsRef)) == null || p.focus({ preventScroll: !0 }), s.value.value || s.goToOption(ln.Last);
        });
        break;
    }
  }
  function l(h) {
    switch (h.key) {
      case vt.Space:
        h.preventDefault();
        break;
    }
  }
  function c(h) {
    s.disabled.value || (s.listboxState.value === 0 ? (s.closeListbox(), Nn(() => {
      var p;
      return (p = Ie(s.buttonRef)) == null ? void 0 : p.focus({ preventScroll: !0 });
    })) : (h.preventDefault(), s.openListbox(), R7(() => {
      var p;
      return (p = Ie(s.optionsRef)) == null ? void 0 : p.focus({ preventScroll: !0 });
    })));
  }
  let f = T0(ce(() => ({ as: e.as, type: t.type })), s.buttonRef);
  return () => {
    var h, p;
    let g = { open: s.listboxState.value === 0, disabled: s.disabled.value, value: s.value.value }, { ...v } = e, y = { ref: s.buttonRef, id: a, type: f.value, "aria-haspopup": "listbox", "aria-controls": (h = Ie(s.optionsRef)) == null ? void 0 : h.id, "aria-expanded": s.listboxState.value === 0, "aria-labelledby": s.labelRef.value ? [(p = Ie(s.labelRef)) == null ? void 0 : p.id, a].join(" ") : void 0, disabled: s.disabled.value === !0 ? !0 : void 0, onKeydown: o, onKeyup: l, onClick: c };
    return un({ ourProps: y, theirProps: v, slot: g, attrs: t, slots: n, name: "ListboxButton" });
  };
} }), OO = dt({ name: "ListboxOptions", props: { as: { type: [Object, String], default: "ul" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: n, expose: r }) {
  var i;
  let a = (i = e.id) != null ? i : `headlessui-listbox-options-${tr()}`, s = sd("ListboxOptions"), o = ge(null);
  r({ el: s.optionsRef, $el: s.optionsRef });
  function l(h) {
    switch (o.value && clearTimeout(o.value), h.key) {
      case vt.Space:
        if (s.searchQuery.value !== "") return h.preventDefault(), h.stopPropagation(), s.search(h.key);
      case vt.Enter:
        if (h.preventDefault(), h.stopPropagation(), s.activeOptionIndex.value !== null) {
          let p = s.options.value[s.activeOptionIndex.value];
          s.select(p.dataRef.value);
        }
        s.mode.value === 0 && (s.closeListbox(), Nn(() => {
          var p;
          return (p = Ie(s.buttonRef)) == null ? void 0 : p.focus({ preventScroll: !0 });
        }));
        break;
      case vn(s.orientation.value, { vertical: vt.ArrowDown, horizontal: vt.ArrowRight }):
        return h.preventDefault(), h.stopPropagation(), s.goToOption(ln.Next);
      case vn(s.orientation.value, { vertical: vt.ArrowUp, horizontal: vt.ArrowLeft }):
        return h.preventDefault(), h.stopPropagation(), s.goToOption(ln.Previous);
      case vt.Home:
      case vt.PageUp:
        return h.preventDefault(), h.stopPropagation(), s.goToOption(ln.First);
      case vt.End:
      case vt.PageDown:
        return h.preventDefault(), h.stopPropagation(), s.goToOption(ln.Last);
      case vt.Escape:
        h.preventDefault(), h.stopPropagation(), s.closeListbox(), Nn(() => {
          var p;
          return (p = Ie(s.buttonRef)) == null ? void 0 : p.focus({ preventScroll: !0 });
        });
        break;
      case vt.Tab:
        h.preventDefault(), h.stopPropagation();
        break;
      default:
        h.key.length === 1 && (s.search(h.key), o.value = setTimeout(() => s.clearSearch(), 350));
        break;
    }
  }
  let c = il(), f = ce(() => c !== null ? (c.value & on.Open) === on.Open : s.listboxState.value === 0);
  return () => {
    var h, p;
    let g = { open: s.listboxState.value === 0 }, { ...v } = e, y = { "aria-activedescendant": s.activeOptionIndex.value === null || (h = s.options.value[s.activeOptionIndex.value]) == null ? void 0 : h.id, "aria-multiselectable": s.mode.value === 1 ? !0 : void 0, "aria-labelledby": (p = Ie(s.buttonRef)) == null ? void 0 : p.id, "aria-orientation": s.orientation.value, id: a, onKeydown: l, role: "listbox", tabIndex: 0, ref: s.optionsRef };
    return un({ ourProps: y, theirProps: v, slot: g, attrs: t, slots: n, features: Yi.RenderStrategy | Yi.Static, visible: f.value, name: "ListboxOptions" });
  };
} }), MO = dt({ name: "ListboxOption", props: { as: { type: [Object, String], default: "li" }, value: { type: [Object, String, Number, Boolean] }, disabled: { type: Boolean, default: !1 }, id: { type: String, default: null } }, setup(e, { slots: t, attrs: n, expose: r }) {
  var i;
  let a = (i = e.id) != null ? i : `headlessui-listbox-option-${tr()}`, s = sd("ListboxOption"), o = ge(null);
  r({ el: o, $el: o });
  let l = ce(() => s.activeOptionIndex.value !== null ? s.options.value[s.activeOptionIndex.value].id === a : !1), c = ce(() => vn(s.mode.value, { 0: () => s.compare(aa(s.value.value), aa(e.value)), 1: () => aa(s.value.value).some((w) => s.compare(aa(w), aa(e.value))) })), f = ce(() => vn(s.mode.value, { 1: () => {
    var w;
    let C = aa(s.value.value);
    return ((w = s.options.value.find((P) => C.some((M) => s.compare(aa(M), aa(P.dataRef.value))))) == null ? void 0 : w.id) === a;
  }, 0: () => c.value })), h = AO(o), p = ce(() => ({ disabled: e.disabled, value: e.value, get textValue() {
    return h();
  }, domRef: o }));
  Ft(() => s.registerOption(a, p)), cr(() => s.unregisterOption(a)), Ft(() => {
    Ln([s.listboxState, c], () => {
      s.listboxState.value === 0 && c.value && vn(s.mode.value, { 1: () => {
        f.value && s.goToOption(ln.Specific, a);
      }, 0: () => {
        s.goToOption(ln.Specific, a);
      } });
    }, { immediate: !0 });
  }), _r(() => {
    s.listboxState.value === 0 && l.value && s.activationTrigger.value !== 0 && Nn(() => {
      var w, C;
      return (C = (w = Ie(o)) == null ? void 0 : w.scrollIntoView) == null ? void 0 : C.call(w, { block: "nearest" });
    });
  });
  function g(w) {
    if (e.disabled) return w.preventDefault();
    s.select(e.value), s.mode.value === 0 && (s.closeListbox(), Nn(() => {
      var C;
      return (C = Ie(s.buttonRef)) == null ? void 0 : C.focus({ preventScroll: !0 });
    }));
  }
  function v() {
    if (e.disabled) return s.goToOption(ln.Nothing);
    s.goToOption(ln.Specific, a);
  }
  let y = lO();
  function S(w) {
    y.update(w);
  }
  function x(w) {
    y.wasMoved(w) && (e.disabled || l.value || s.goToOption(ln.Specific, a, 0));
  }
  function E(w) {
    y.wasMoved(w) && (e.disabled || l.value && s.goToOption(ln.Nothing));
  }
  return () => {
    let { disabled: w } = e, C = { active: l.value, selected: c.value, disabled: w }, { value: P, disabled: M, ...T } = e, N = { id: a, ref: o, role: "option", tabIndex: w === !0 ? void 0 : -1, "aria-disabled": w === !0 ? !0 : void 0, "aria-selected": c.value, disabled: void 0, onClick: g, onFocus: v, onPointerenter: S, onMouseenter: S, onPointermove: x, onMousemove: x, onPointerleave: E, onMouseleave: E };
    return un({ ourProps: N, theirProps: T, slot: C, attrs: n, slots: t, name: "ListboxOption" });
  };
} });
var F7 = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(F7 || {}), N7 = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(N7 || {});
function L7(e) {
  requestAnimationFrame(() => requestAnimationFrame(e));
}
let IO = Symbol("MenuContext");
function mp(e) {
  let t = br(IO, null);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Menu /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, mp), n;
  }
  return t;
}
let $7 = dt({ name: "Menu", props: { as: { type: [Object, String], default: "template" } }, setup(e, { slots: t, attrs: n }) {
  let r = ge(1), i = ge(null), a = ge(null), s = ge([]), o = ge(""), l = ge(null), c = ge(1);
  function f(p = (g) => g) {
    let g = l.value !== null ? s.value[l.value] : null, v = C0(p(s.value.slice()), (S) => Ie(S.dataRef.domRef)), y = g ? v.indexOf(g) : null;
    return y === -1 && (y = null), { items: v, activeItemIndex: y };
  }
  let h = { menuState: r, buttonRef: i, itemsRef: a, items: s, searchQuery: o, activeItemIndex: l, activationTrigger: c, closeMenu: () => {
    r.value = 1, l.value = null;
  }, openMenu: () => r.value = 0, goToItem(p, g, v) {
    let y = f(), S = fO(p === ln.Specific ? { focus: ln.Specific, id: g } : { focus: p }, { resolveItems: () => y.items, resolveActiveIndex: () => y.activeItemIndex, resolveId: (x) => x.id, resolveDisabled: (x) => x.dataRef.disabled });
    o.value = "", l.value = S, c.value = v ?? 1, s.value = y.items;
  }, search(p) {
    let g = o.value !== "" ? 0 : 1;
    o.value += p.toLowerCase();
    let v = (l.value !== null ? s.value.slice(l.value + g).concat(s.value.slice(0, l.value + g)) : s.value).find((S) => S.dataRef.textValue.startsWith(o.value) && !S.dataRef.disabled), y = v ? s.value.indexOf(v) : -1;
    y === -1 || y === l.value || (l.value = y, c.value = 1);
  }, clearSearch() {
    o.value = "";
  }, registerItem(p, g) {
    let v = f((y) => [...y, { id: p, dataRef: g }]);
    s.value = v.items, l.value = v.activeItemIndex, c.value = 1;
  }, unregisterItem(p) {
    let g = f((v) => {
      let y = v.findIndex((S) => S.id === p);
      return y !== -1 && v.splice(y, 1), v;
    });
    s.value = g.items, l.value = g.activeItemIndex, c.value = 1;
  } };
  return hp([i, a], (p, g) => {
    var v;
    h.closeMenu(), id(g, rd.Loose) || (p.preventDefault(), (v = Ie(i)) == null || v.focus());
  }, ce(() => r.value === 0)), Zr(IO, h), pp(ce(() => vn(r.value, { 0: on.Open, 1: on.Closed }))), () => {
    let p = { open: r.value === 0, close: h.closeMenu };
    return un({ ourProps: {}, theirProps: e, slot: p, slots: t, attrs: n, name: "Menu" });
  };
} }), V7 = dt({ name: "MenuButton", props: { disabled: { type: Boolean, default: !1 }, as: { type: [Object, String], default: "button" }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: n, expose: r }) {
  var i;
  let a = (i = e.id) != null ? i : `headlessui-menu-button-${tr()}`, s = mp("MenuButton");
  r({ el: s.buttonRef, $el: s.buttonRef });
  function o(h) {
    switch (h.key) {
      case vt.Space:
      case vt.Enter:
      case vt.ArrowDown:
        h.preventDefault(), h.stopPropagation(), s.openMenu(), Nn(() => {
          var p;
          (p = Ie(s.itemsRef)) == null || p.focus({ preventScroll: !0 }), s.goToItem(ln.First);
        });
        break;
      case vt.ArrowUp:
        h.preventDefault(), h.stopPropagation(), s.openMenu(), Nn(() => {
          var p;
          (p = Ie(s.itemsRef)) == null || p.focus({ preventScroll: !0 }), s.goToItem(ln.Last);
        });
        break;
    }
  }
  function l(h) {
    switch (h.key) {
      case vt.Space:
        h.preventDefault();
        break;
    }
  }
  function c(h) {
    e.disabled || (s.menuState.value === 0 ? (s.closeMenu(), Nn(() => {
      var p;
      return (p = Ie(s.buttonRef)) == null ? void 0 : p.focus({ preventScroll: !0 });
    })) : (h.preventDefault(), s.openMenu(), L7(() => {
      var p;
      return (p = Ie(s.itemsRef)) == null ? void 0 : p.focus({ preventScroll: !0 });
    })));
  }
  let f = T0(ce(() => ({ as: e.as, type: t.type })), s.buttonRef);
  return () => {
    var h;
    let p = { open: s.menuState.value === 0 }, { ...g } = e, v = { ref: s.buttonRef, id: a, type: f.value, "aria-haspopup": "menu", "aria-controls": (h = Ie(s.itemsRef)) == null ? void 0 : h.id, "aria-expanded": s.menuState.value === 0, onKeydown: o, onKeyup: l, onClick: c };
    return un({ ourProps: v, theirProps: g, slot: p, attrs: t, slots: n, name: "MenuButton" });
  };
} }), B7 = dt({ name: "MenuItems", props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, id: { type: String, default: null } }, setup(e, { attrs: t, slots: n, expose: r }) {
  var i;
  let a = (i = e.id) != null ? i : `headlessui-menu-items-${tr()}`, s = mp("MenuItems"), o = ge(null);
  r({ el: s.itemsRef, $el: s.itemsRef }), e7({ container: ce(() => Ie(s.itemsRef)), enabled: ce(() => s.menuState.value === 0), accept(p) {
    return p.getAttribute("role") === "menuitem" ? NodeFilter.FILTER_REJECT : p.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(p) {
    p.setAttribute("role", "none");
  } });
  function l(p) {
    var g;
    switch (o.value && clearTimeout(o.value), p.key) {
      case vt.Space:
        if (s.searchQuery.value !== "") return p.preventDefault(), p.stopPropagation(), s.search(p.key);
      case vt.Enter:
        if (p.preventDefault(), p.stopPropagation(), s.activeItemIndex.value !== null) {
          let v = s.items.value[s.activeItemIndex.value];
          (g = Ie(v.dataRef.domRef)) == null || g.click();
        }
        s.closeMenu(), aO(Ie(s.buttonRef));
        break;
      case vt.ArrowDown:
        return p.preventDefault(), p.stopPropagation(), s.goToItem(ln.Next);
      case vt.ArrowUp:
        return p.preventDefault(), p.stopPropagation(), s.goToItem(ln.Previous);
      case vt.Home:
      case vt.PageUp:
        return p.preventDefault(), p.stopPropagation(), s.goToItem(ln.First);
      case vt.End:
      case vt.PageDown:
        return p.preventDefault(), p.stopPropagation(), s.goToItem(ln.Last);
      case vt.Escape:
        p.preventDefault(), p.stopPropagation(), s.closeMenu(), Nn(() => {
          var v;
          return (v = Ie(s.buttonRef)) == null ? void 0 : v.focus({ preventScroll: !0 });
        });
        break;
      case vt.Tab:
        p.preventDefault(), p.stopPropagation(), s.closeMenu(), Nn(() => Z6(Ie(s.buttonRef), p.shiftKey ? pr.Previous : pr.Next));
        break;
      default:
        p.key.length === 1 && (s.search(p.key), o.value = setTimeout(() => s.clearSearch(), 350));
        break;
    }
  }
  function c(p) {
    switch (p.key) {
      case vt.Space:
        p.preventDefault();
        break;
    }
  }
  let f = il(), h = ce(() => f !== null ? (f.value & on.Open) === on.Open : s.menuState.value === 0);
  return () => {
    var p, g;
    let v = { open: s.menuState.value === 0 }, { ...y } = e, S = { "aria-activedescendant": s.activeItemIndex.value === null || (p = s.items.value[s.activeItemIndex.value]) == null ? void 0 : p.id, "aria-labelledby": (g = Ie(s.buttonRef)) == null ? void 0 : g.id, id: a, onKeydown: l, onKeyup: c, role: "menu", tabIndex: 0, ref: s.itemsRef };
    return un({ ourProps: S, theirProps: y, slot: v, attrs: t, slots: n, features: Yi.RenderStrategy | Yi.Static, visible: h.value, name: "MenuItems" });
  };
} }), U7 = dt({ name: "MenuItem", inheritAttrs: !1, props: { as: { type: [Object, String], default: "template" }, disabled: { type: Boolean, default: !1 }, id: { type: String, default: null } }, setup(e, { slots: t, attrs: n, expose: r }) {
  var i;
  let a = (i = e.id) != null ? i : `headlessui-menu-item-${tr()}`, s = mp("MenuItem"), o = ge(null);
  r({ el: o, $el: o });
  let l = ce(() => s.activeItemIndex.value !== null ? s.items.value[s.activeItemIndex.value].id === a : !1), c = AO(o), f = ce(() => ({ disabled: e.disabled, get textValue() {
    return c();
  }, domRef: o }));
  Ft(() => s.registerItem(a, f)), cr(() => s.unregisterItem(a)), _r(() => {
    s.menuState.value === 0 && l.value && s.activationTrigger.value !== 0 && Nn(() => {
      var x, E;
      return (E = (x = Ie(o)) == null ? void 0 : x.scrollIntoView) == null ? void 0 : E.call(x, { block: "nearest" });
    });
  });
  function h(x) {
    if (e.disabled) return x.preventDefault();
    s.closeMenu(), aO(Ie(s.buttonRef));
  }
  function p() {
    if (e.disabled) return s.goToItem(ln.Nothing);
    s.goToItem(ln.Specific, a);
  }
  let g = lO();
  function v(x) {
    g.update(x);
  }
  function y(x) {
    g.wasMoved(x) && (e.disabled || l.value || s.goToItem(ln.Specific, a, 0));
  }
  function S(x) {
    g.wasMoved(x) && (e.disabled || l.value && s.goToItem(ln.Nothing));
  }
  return () => {
    let { disabled: x, ...E } = e, w = { active: l.value, disabled: x, close: s.closeMenu };
    return un({ ourProps: { id: a, ref: o, role: "menuitem", tabIndex: x === !0 ? void 0 : -1, "aria-disabled": x === !0 ? !0 : void 0, onClick: h, onFocus: p, onPointerenter: v, onMouseenter: v, onPointermove: y, onMousemove: y, onPointerleave: S, onMouseleave: S }, theirProps: { ...n, ...E }, slot: w, attrs: n, slots: t, name: "MenuItem" });
  };
} });
var q7 = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(q7 || {});
let RO = Symbol("PopoverContext");
function gp(e) {
  let t = br(RO, null);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <${O0.name} /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, gp), n;
  }
  return t;
}
let FO = Symbol("PopoverGroupContext");
function NO() {
  return br(FO, null);
}
let LO = Symbol("PopoverPanelContext");
function j7() {
  return br(LO, null);
}
let O0 = dt({ name: "Popover", inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" } }, setup(e, { slots: t, attrs: n, expose: r }) {
  var i;
  let a = ge(null);
  r({ el: a, $el: a });
  let s = ge(1), o = ge(null), l = ge(null), c = ge(null), f = ge(null), h = ce(() => Xi(a)), p = ce(() => {
    var P, M;
    if (!Ie(o) || !Ie(f)) return !1;
    for (let _e of document.querySelectorAll("body > *")) if (Number(_e == null ? void 0 : _e.contains(Ie(o))) ^ Number(_e == null ? void 0 : _e.contains(Ie(f)))) return !0;
    let T = nd(), N = T.indexOf(Ie(o)), $ = (N + T.length - 1) % T.length, ne = (N + 1) % T.length, Y = T[$], te = T[ne];
    return !((P = Ie(f)) != null && P.contains(Y)) && !((M = Ie(f)) != null && M.contains(te));
  }), g = { popoverState: s, buttonId: ge(null), panelId: ge(null), panel: f, button: o, isPortalled: p, beforePanelSentinel: l, afterPanelSentinel: c, togglePopover() {
    s.value = vn(s.value, { 0: 1, 1: 0 });
  }, closePopover() {
    s.value !== 1 && (s.value = 1);
  }, close(P) {
    g.closePopover();
    let M = P ? P instanceof HTMLElement ? P : P.value instanceof HTMLElement ? Ie(P) : Ie(g.button) : Ie(g.button);
    M == null || M.focus();
  } };
  Zr(RO, g), pp(ce(() => vn(s.value, { 0: on.Open, 1: on.Closed })));
  let v = { buttonId: g.buttonId, panelId: g.panelId, close() {
    g.closePopover();
  } }, y = NO(), S = y == null ? void 0 : y.registerPopover, [x, E] = SO(), w = _O({ mainTreeNodeRef: y == null ? void 0 : y.mainTreeNodeRef, portals: x, defaultContainers: [o, f] });
  function C() {
    var P, M, T, N;
    return (N = y == null ? void 0 : y.isFocusWithinPopoverGroup()) != null ? N : ((P = h.value) == null ? void 0 : P.activeElement) && (((M = Ie(o)) == null ? void 0 : M.contains(h.value.activeElement)) || ((T = Ie(f)) == null ? void 0 : T.contains(h.value.activeElement)));
  }
  return _r(() => S == null ? void 0 : S(v)), D0((i = h.value) == null ? void 0 : i.defaultView, "focus", (P) => {
    var M, T;
    P.target !== window && P.target instanceof HTMLElement && s.value === 0 && (C() || o && f && (w.contains(P.target) || (M = Ie(g.beforePanelSentinel)) != null && M.contains(P.target) || (T = Ie(g.afterPanelSentinel)) != null && T.contains(P.target) || g.closePopover()));
  }, !0), hp(w.resolveContainers, (P, M) => {
    var T;
    g.closePopover(), id(M, rd.Loose) || (P.preventDefault(), (T = Ie(o)) == null || T.focus());
  }, ce(() => s.value === 0)), () => {
    let P = { open: s.value === 0, close: g.close };
    return $t(Re, [$t(E, {}, () => un({ theirProps: { ...e, ...n }, ourProps: { ref: a }, slot: P, slots: t, attrs: n, name: "Popover" })), $t(w.MainTreeNode)]);
  };
} }), $O = dt({ name: "PopoverButton", props: { as: { type: [Object, String], default: "button" }, disabled: { type: [Boolean], default: !1 }, id: { type: String, default: null } }, inheritAttrs: !1, setup(e, { attrs: t, slots: n, expose: r }) {
  var i;
  let a = (i = e.id) != null ? i : `headlessui-popover-button-${tr()}`, s = gp("PopoverButton"), o = ce(() => Xi(s.button));
  r({ el: s.button, $el: s.button }), Ft(() => {
    s.buttonId.value = a;
  }), cr(() => {
    s.buttonId.value = null;
  });
  let l = NO(), c = l == null ? void 0 : l.closeOthers, f = j7(), h = ce(() => f === null ? !1 : f.value === s.panelId.value), p = ge(null), g = `headlessui-focus-sentinel-${tr()}`;
  h.value || _r(() => {
    s.button.value = Ie(p);
  });
  let v = T0(ce(() => ({ as: e.as, type: t.type })), p);
  function y(P) {
    var M, T, N, $, ne;
    if (h.value) {
      if (s.popoverState.value === 1) return;
      switch (P.key) {
        case vt.Space:
        case vt.Enter:
          P.preventDefault(), (T = (M = P.target).click) == null || T.call(M), s.closePopover(), (N = Ie(s.button)) == null || N.focus();
          break;
      }
    } else switch (P.key) {
      case vt.Space:
      case vt.Enter:
        P.preventDefault(), P.stopPropagation(), s.popoverState.value === 1 && (c == null || c(s.buttonId.value)), s.togglePopover();
        break;
      case vt.Escape:
        if (s.popoverState.value !== 0) return c == null ? void 0 : c(s.buttonId.value);
        if (!Ie(s.button) || ($ = o.value) != null && $.activeElement && !((ne = Ie(s.button)) != null && ne.contains(o.value.activeElement))) return;
        P.preventDefault(), P.stopPropagation(), s.closePopover();
        break;
    }
  }
  function S(P) {
    h.value || P.key === vt.Space && P.preventDefault();
  }
  function x(P) {
    var M, T;
    e.disabled || (h.value ? (s.closePopover(), (M = Ie(s.button)) == null || M.focus()) : (P.preventDefault(), P.stopPropagation(), s.popoverState.value === 1 && (c == null || c(s.buttonId.value)), s.togglePopover(), (T = Ie(s.button)) == null || T.focus()));
  }
  function E(P) {
    P.preventDefault(), P.stopPropagation();
  }
  let w = E0();
  function C() {
    let P = Ie(s.panel);
    if (!P) return;
    function M() {
      vn(w.value, { [wi.Forwards]: () => Wi(P, pr.First), [wi.Backwards]: () => Wi(P, pr.Last) }) === Uc.Error && Wi(nd().filter((T) => T.dataset.headlessuiFocusGuard !== "true"), vn(w.value, { [wi.Forwards]: pr.Next, [wi.Backwards]: pr.Previous }), { relativeTo: Ie(s.button) });
    }
    M();
  }
  return () => {
    let P = s.popoverState.value === 0, M = { open: P }, { ...T } = e, N = h.value ? { ref: p, type: v.value, onKeydown: y, onClick: x } : { ref: p, id: a, type: v.value, "aria-expanded": s.popoverState.value === 0, "aria-controls": Ie(s.panel) ? s.panelId.value : void 0, disabled: e.disabled ? !0 : void 0, onKeydown: y, onKeyup: S, onClick: x, onMousedown: E };
    return $t(Re, [un({ ourProps: N, theirProps: { ...t, ...T }, slot: M, attrs: t, slots: n, name: "PopoverButton" }), P && !h.value && s.isPortalled.value && $t(Xs, { id: g, features: cs.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: C })]);
  };
} });
dt({ name: "PopoverOverlay", props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 } }, setup(e, { attrs: t, slots: n }) {
  let r = gp("PopoverOverlay"), i = `headlessui-popover-overlay-${tr()}`, a = il(), s = ce(() => a !== null ? (a.value & on.Open) === on.Open : r.popoverState.value === 0);
  function o() {
    r.closePopover();
  }
  return () => {
    let l = { open: r.popoverState.value === 0 };
    return un({ ourProps: { id: i, "aria-hidden": !0, onClick: o }, theirProps: e, slot: l, attrs: t, slots: n, features: Yi.RenderStrategy | Yi.Static, visible: s.value, name: "PopoverOverlay" });
  };
} });
let VO = dt({ name: "PopoverPanel", props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, focus: { type: Boolean, default: !1 }, id: { type: String, default: null } }, inheritAttrs: !1, setup(e, { attrs: t, slots: n, expose: r }) {
  var i;
  let a = (i = e.id) != null ? i : `headlessui-popover-panel-${tr()}`, { focus: s } = e, o = gp("PopoverPanel"), l = ce(() => Xi(o.panel)), c = `headlessui-focus-sentinel-before-${tr()}`, f = `headlessui-focus-sentinel-after-${tr()}`;
  r({ el: o.panel, $el: o.panel }), Ft(() => {
    o.panelId.value = a;
  }), cr(() => {
    o.panelId.value = null;
  }), Zr(LO, o.panelId), _r(() => {
    var E, w;
    if (!s || o.popoverState.value !== 0 || !o.panel) return;
    let C = (E = l.value) == null ? void 0 : E.activeElement;
    (w = Ie(o.panel)) != null && w.contains(C) || Wi(Ie(o.panel), pr.First);
  });
  let h = il(), p = ce(() => h !== null ? (h.value & on.Open) === on.Open : o.popoverState.value === 0);
  function g(E) {
    var w, C;
    switch (E.key) {
      case vt.Escape:
        if (o.popoverState.value !== 0 || !Ie(o.panel) || l.value && !((w = Ie(o.panel)) != null && w.contains(l.value.activeElement))) return;
        E.preventDefault(), E.stopPropagation(), o.closePopover(), (C = Ie(o.button)) == null || C.focus();
        break;
    }
  }
  function v(E) {
    var w, C, P, M, T;
    let N = E.relatedTarget;
    N && Ie(o.panel) && ((w = Ie(o.panel)) != null && w.contains(N) || (o.closePopover(), ((P = (C = Ie(o.beforePanelSentinel)) == null ? void 0 : C.contains) != null && P.call(C, N) || (T = (M = Ie(o.afterPanelSentinel)) == null ? void 0 : M.contains) != null && T.call(M, N)) && N.focus({ preventScroll: !0 })));
  }
  let y = E0();
  function S() {
    let E = Ie(o.panel);
    if (!E) return;
    function w() {
      vn(y.value, { [wi.Forwards]: () => {
        var C;
        Wi(E, pr.First) === Uc.Error && ((C = Ie(o.afterPanelSentinel)) == null || C.focus());
      }, [wi.Backwards]: () => {
        var C;
        (C = Ie(o.button)) == null || C.focus({ preventScroll: !0 });
      } });
    }
    w();
  }
  function x() {
    let E = Ie(o.panel);
    if (!E) return;
    function w() {
      vn(y.value, { [wi.Forwards]: () => {
        let C = Ie(o.button), P = Ie(o.panel);
        if (!C) return;
        let M = nd(), T = M.indexOf(C), N = M.slice(0, T + 1), $ = [...M.slice(T + 1), ...N];
        for (let ne of $.slice()) if (ne.dataset.headlessuiFocusGuard === "true" || P != null && P.contains(ne)) {
          let Y = $.indexOf(ne);
          Y !== -1 && $.splice(Y, 1);
        }
        Wi($, pr.First, { sorted: !1 });
      }, [wi.Backwards]: () => {
        var C;
        Wi(E, pr.Previous) === Uc.Error && ((C = Ie(o.button)) == null || C.focus());
      } });
    }
    w();
  }
  return () => {
    let E = { open: o.popoverState.value === 0, close: o.close }, { focus: w, ...C } = e, P = { ref: o.panel, id: a, onKeydown: g, onFocusout: s && o.popoverState.value === 0 ? v : void 0, tabIndex: -1 };
    return un({ ourProps: P, theirProps: { ...t, ...C }, attrs: t, slot: E, slots: { ...n, default: (...M) => {
      var T;
      return [$t(Re, [p.value && o.isPortalled.value && $t(Xs, { id: c, ref: o.beforePanelSentinel, features: cs.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: S }), (T = n.default) == null ? void 0 : T.call(n, ...M), p.value && o.isPortalled.value && $t(Xs, { id: f, ref: o.afterPanelSentinel, features: cs.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: x })])];
    } }, features: Yi.RenderStrategy | Yi.Static, visible: p.value, name: "PopoverPanel" });
  };
} });
dt({ name: "PopoverGroup", inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" } }, setup(e, { attrs: t, slots: n, expose: r }) {
  let i = ge(null), a = rp([]), s = ce(() => Xi(i)), o = v7();
  r({ el: i, $el: i });
  function l(p) {
    let g = a.value.indexOf(p);
    g !== -1 && a.value.splice(g, 1);
  }
  function c(p) {
    return a.value.push(p), () => {
      l(p);
    };
  }
  function f() {
    var p;
    let g = s.value;
    if (!g) return !1;
    let v = g.activeElement;
    return (p = Ie(i)) != null && p.contains(v) ? !0 : a.value.some((y) => {
      var S, x;
      return ((S = g.getElementById(y.buttonId.value)) == null ? void 0 : S.contains(v)) || ((x = g.getElementById(y.panelId.value)) == null ? void 0 : x.contains(v));
    });
  }
  function h(p) {
    for (let g of a.value) g.buttonId.value !== p && g.close();
  }
  return Zr(FO, { registerPopover: c, unregisterPopover: l, isFocusWithinPopoverGroup: f, closeOthers: h, mainTreeNodeRef: o.mainTreeNodeRef }), () => $t(Re, [un({ ourProps: { ref: i }, theirProps: { ...e, ...t }, slot: {}, attrs: t, slots: n, name: "PopoverGroup" }), $t(o.MainTreeNode)]);
} });
function W7(e) {
  let t = { called: !1 };
  return (...n) => {
    if (!t.called) return t.called = !0, e(...n);
  };
}
function Fg(e, ...t) {
  e && t.length > 0 && e.classList.add(...t);
}
function Ff(e, ...t) {
  e && t.length > 0 && e.classList.remove(...t);
}
var _y = ((e) => (e.Finished = "finished", e.Cancelled = "cancelled", e))(_y || {});
function z7(e, t) {
  let n = ed();
  if (!e) return n.dispose;
  let { transitionDuration: r, transitionDelay: i } = getComputedStyle(e), [a, s] = [r, i].map((o) => {
    let [l = 0] = o.split(",").filter(Boolean).map((c) => c.includes("ms") ? parseFloat(c) : parseFloat(c) * 1e3).sort((c, f) => f - c);
    return l;
  });
  return a !== 0 ? n.setTimeout(() => t("finished"), a + s) : t("finished"), n.add(() => t("cancelled")), n.dispose;
}
function pS(e, t, n, r, i, a) {
  let s = ed(), o = a !== void 0 ? W7(a) : () => {
  };
  return Ff(e, ...i), Fg(e, ...t, ...n), s.nextFrame(() => {
    Ff(e, ...n), Fg(e, ...r), s.add(z7(e, (l) => (Ff(e, ...r, ...t), Fg(e, ...i), o(l))));
  }), s.add(() => Ff(e, ...t, ...n, ...r, ...i)), s.add(() => o("cancelled")), s.dispose;
}
function Ao(e = "") {
  return e.split(/\s+/).filter((t) => t.length > 1);
}
let M0 = Symbol("TransitionContext");
var H7 = ((e) => (e.Visible = "visible", e.Hidden = "hidden", e))(H7 || {});
function G7() {
  return br(M0, null) !== null;
}
function Y7() {
  let e = br(M0, null);
  if (e === null) throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return e;
}
function K7() {
  let e = br(I0, null);
  if (e === null) throw new Error("A <TransitionChild /> is used but it is missing a parent <TransitionRoot />.");
  return e;
}
let I0 = Symbol("NestingContext");
function vp(e) {
  return "children" in e ? vp(e.children) : e.value.filter(({ state: t }) => t === "visible").length > 0;
}
function BO(e) {
  let t = ge([]), n = ge(!1);
  Ft(() => n.value = !0), cr(() => n.value = !1);
  function r(a, s = Bs.Hidden) {
    let o = t.value.findIndex(({ id: l }) => l === a);
    o !== -1 && (vn(s, { [Bs.Unmount]() {
      t.value.splice(o, 1);
    }, [Bs.Hidden]() {
      t.value[o].state = "hidden";
    } }), !vp(t) && n.value && (e == null || e()));
  }
  function i(a) {
    let s = t.value.find(({ id: o }) => o === a);
    return s ? s.state !== "visible" && (s.state = "visible") : t.value.push({ id: a, state: "visible" }), () => r(a, Bs.Unmount);
  }
  return { children: t, register: i, unregister: r };
}
let UO = Yi.RenderStrategy, bp = dt({ props: { as: { type: [Object, String], default: "div" }, show: { type: [Boolean], default: null }, unmount: { type: [Boolean], default: !0 }, appear: { type: [Boolean], default: !1 }, enter: { type: [String], default: "" }, enterFrom: { type: [String], default: "" }, enterTo: { type: [String], default: "" }, entered: { type: [String], default: "" }, leave: { type: [String], default: "" }, leaveFrom: { type: [String], default: "" }, leaveTo: { type: [String], default: "" } }, emits: { beforeEnter: () => !0, afterEnter: () => !0, beforeLeave: () => !0, afterLeave: () => !0 }, setup(e, { emit: t, attrs: n, slots: r, expose: i }) {
  let a = ge(0);
  function s() {
    a.value |= on.Opening, t("beforeEnter");
  }
  function o() {
    a.value &= ~on.Opening, t("afterEnter");
  }
  function l() {
    a.value |= on.Closing, t("beforeLeave");
  }
  function c() {
    a.value &= ~on.Closing, t("afterLeave");
  }
  if (!G7() && r7()) return () => $t(_p, { ...e, onBeforeEnter: s, onAfterEnter: o, onBeforeLeave: l, onAfterLeave: c }, r);
  let f = ge(null), h = ce(() => e.unmount ? Bs.Unmount : Bs.Hidden);
  i({ el: f, $el: f });
  let { show: p, appear: g } = Y7(), { register: v, unregister: y } = K7(), S = ge(p.value ? "visible" : "hidden"), x = { value: !0 }, E = tr(), w = { value: !1 }, C = BO(() => {
    !w.value && S.value !== "hidden" && (S.value = "hidden", y(E), c());
  });
  Ft(() => {
    let _e = v(E);
    cr(_e);
  }), _r(() => {
    if (h.value === Bs.Hidden && E) {
      if (p.value && S.value !== "visible") {
        S.value = "visible";
        return;
      }
      vn(S.value, { hidden: () => y(E), visible: () => v(E) });
    }
  });
  let P = Ao(e.enter), M = Ao(e.enterFrom), T = Ao(e.enterTo), N = Ao(e.entered), $ = Ao(e.leave), ne = Ao(e.leaveFrom), Y = Ao(e.leaveTo);
  Ft(() => {
    _r(() => {
      if (S.value === "visible") {
        let _e = Ie(f);
        if (_e instanceof Comment && _e.data === "") throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
      }
    });
  });
  function te(_e) {
    let Fe = x.value && !g.value, J = Ie(f);
    !J || !(J instanceof HTMLElement) || Fe || (w.value = !0, p.value && s(), p.value || l(), _e(p.value ? pS(J, P, M, T, N, (oe) => {
      w.value = !1, oe === _y.Finished && o();
    }) : pS(J, $, ne, Y, N, (oe) => {
      w.value = !1, oe === _y.Finished && (vp(C) || (S.value = "hidden", y(E), c()));
    })));
  }
  return Ft(() => {
    Ln([p], (_e, Fe, J) => {
      te(J), x.value = !1;
    }, { immediate: !0 });
  }), Zr(I0, C), pp(ce(() => vn(S.value, { visible: on.Open, hidden: on.Closed }) | a.value)), () => {
    let { appear: _e, show: Fe, enter: J, enterFrom: oe, enterTo: A, entered: X, leave: pe, leaveFrom: le, leaveTo: ue, ...Te } = e, Ne = { ref: f }, Z = { ...Te, ...g.value && p.value && td.isServer ? { class: Pe([n.class, Te.class, ...P, ...M]) } : {} };
    return un({ theirProps: Z, ourProps: Ne, slot: {}, slots: r, attrs: n, features: UO, visible: S.value === "visible", name: "TransitionChild" });
  };
} }), X7 = bp, _p = dt({ inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" }, show: { type: [Boolean], default: null }, unmount: { type: [Boolean], default: !0 }, appear: { type: [Boolean], default: !1 }, enter: { type: [String], default: "" }, enterFrom: { type: [String], default: "" }, enterTo: { type: [String], default: "" }, entered: { type: [String], default: "" }, leave: { type: [String], default: "" }, leaveFrom: { type: [String], default: "" }, leaveTo: { type: [String], default: "" } }, emits: { beforeEnter: () => !0, afterEnter: () => !0, beforeLeave: () => !0, afterLeave: () => !0 }, setup(e, { emit: t, attrs: n, slots: r }) {
  let i = il(), a = ce(() => e.show === null && i !== null ? (i.value & on.Open) === on.Open : e.show);
  _r(() => {
    if (![!0, !1].includes(a.value)) throw new Error('A <Transition /> is used but it is missing a `:show="true | false"` prop.');
  });
  let s = ge(a.value ? "visible" : "hidden"), o = BO(() => {
    s.value = "hidden";
  }), l = ge(!0), c = { show: a, appear: ce(() => e.appear || !l.value) };
  return Ft(() => {
    _r(() => {
      l.value = !1, a.value ? s.value = "visible" : vp(o) || (s.value = "hidden");
    });
  }), Zr(I0, o), Zr(M0, c), () => {
    let f = A0(e, ["show", "appear", "unmount", "onBeforeEnter", "onBeforeLeave", "onAfterEnter", "onAfterLeave"]), h = { unmount: e.unmount };
    return un({ ourProps: { ...h, as: "template" }, theirProps: {}, slot: {}, slots: { ...r, default: () => [$t(X7, { onBeforeEnter: () => t("beforeEnter"), onAfterEnter: () => t("afterEnter"), onBeforeLeave: () => t("beforeLeave"), onAfterLeave: () => t("afterLeave"), ...n, ...h, ...f }, r.default)] }, attrs: {}, features: UO, visible: s.value === "visible", name: "Transition" });
  };
} });
const ec = 12;
function Z7(e) {
  const t = window.innerWidth, n = t - 2 * ec;
  e.style.maxWidth = n + "px";
  const r = e.getBoundingClientRect(), i = parseFloat(getComputedStyle(e).right) || 0;
  r.left < ec ? e.style.right = i - (ec - r.left) + "px" : r.right > t - ec && (e.style.right = i + (r.right - t + ec) + "px");
}
const Q7 = {
  mounted(e) {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        Z7(e);
      });
    });
  }
}, J7 = {
  directives: {
    containInViewport: Q7
  },
  components: {
    Popover: O0,
    PopoverButton: $O,
    PopoverPanel: VO,
    SearchIcon: Fc,
    ChevronDownIcon: Qc
  },
  props: {
    name: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      required: !0
    },
    options: {
      type: Array,
      required: !0
    },
    modelValue: {
      type: Array,
      required: !0
    },
    enableSelectAll: {
      type: Boolean,
      default: !0
    },
    searchKeywordThreshold: {
      type: Number,
      default: 9
    }
  },
  emits: ["update:modelValue", "keyword"],
  data() {
    return {
      searchKeyword: "",
      debounce: null,
      focusTimer: null
    };
  },
  computed: {
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    },
    filteredOptions() {
      var e;
      return (e = this.searchKeyword) != null && e.trim() ? this.options.filter((t) => this.$t(t.label).toLowerCase().includes(this.searchKeyword.toLowerCase())) : this.options;
    }
  },
  watch: {
    searchKeyword(e) {
      this.$emit("keyword", e);
    }
  },
  methods: {
    debounceSearch(e) {
      clearTimeout(this.debounce), this.debounce = setTimeout(() => {
        this.searchKeyword = e.target.value;
      }, 500);
    },
    clear() {
      this.internalValue = [], this.searchKeyword = "";
    },
    selectAll() {
      this.internalValue = [
        .../* @__PURE__ */ new Set([
          ...this.internalValue,
          ...this.filteredOptions.map((e) => e.value)
        ])
      ];
    },
    scheduleFocus() {
      this.options.length < this.searchKeywordThreshold || (clearTimeout(this.focusTimer), this.focusTimer = setTimeout(() => {
        var e, t;
        (e = this.$refs.mobileSearchInput) == null || e.focus(), (t = this.$refs.desktopSearchInput) == null || t.focus();
      }, 150));
    }
  },
  beforeUnmount() {
    clearTimeout(this.focusTimer), clearTimeout(this.debounce);
  }
}, eG = {
  key: 0,
  class: "ml-1.5 rounded-full py-0 px-1.5 bg-gray-200 text-xs font-semibold text-gray-700 tabular-nums leading-4"
}, tG = {
  key: 0,
  class: "rounded-md shadow-xs mx-3 mt-3 mb-2 max-w-full"
}, nG = { class: "relative grow" }, rG = { class: "absolute inset-y-0 left-0 pl-2 flex items-center pointer-events-none" }, iG = ["name", "id", "placeholder", "value"], aG = ["name", "id", "placeholder", "value"], sG = { class: "max-h-48 overflow-y-auto px-3 py-1" }, oG = ["id", "value"], lG = ["for"], uG = {
  key: 1,
  class: "flex gap-2 items-center px-3 py-2 border-t border-gray-100"
};
function cG(e, t, n, r, i, a) {
  const s = U("ChevronDownIcon"), o = U("PopoverButton"), l = U("SearchIcon"), c = U("PopoverPanel"), f = U("Popover"), h = kP("contain-in-viewport");
  return _(), O("div", null, [
    W(f, {
      as: "div",
      id: "desktop-menu",
      class: "relative inline-block text-left"
    }, {
      default: ie(() => [
        k("div", null, [
          W(o, {
            class: Pe(["z-30 group inline-flex items-center justify-center px-2 py-1 rounded-md text-xs font-medium text-gray-600 hover:text-gray-800 hover:bg-gray-50 focus:outline-hidden transition-colors duration-150", a.internalValue.length > 0 ? "text-gray-800" : ""]),
            onClick: a.scheduleFocus
          }, {
            default: ie(() => [
              k("span", null, j(e.$t(n.label)), 1),
              a.internalValue.length > 0 ? (_(), O("span", eG, j(a.internalValue.length), 1)) : L("", !0),
              W(s, {
                class: "shrink-0 ml-1 h-3.5 w-3.5 text-gray-400 group-hover:text-gray-500",
                "aria-hidden": "true"
              })
            ]),
            _: 1
          }, 8, ["class", "onClick"])
        ]),
        W(Ea, {
          "enter-active-class": "transition ease-out duration-100",
          "enter-from-class": "transform opacity-0 scale-95",
          "enter-to-class": "transform opacity-100 scale-100",
          "leave-active-class": "transition ease-in duration-75",
          "leave-from-class": "transform opacity-100 scale-100",
          "leave-to-class": "transform opacity-0 scale-95"
        }, {
          default: ie(() => [
            ur((_(), ae(c, { class: "z-40 origin-top-right absolute right-0 mt-1.5 bg-white rounded-lg shadow-lg ring-1 ring-gray-200 focus:outline-hidden flex flex-col overflow-hidden" }, {
              default: ie(() => [
                n.options.length >= n.searchKeywordThreshold ? (_(), O("div", tG, [
                  k("div", nG, [
                    k("div", rG, [
                      W(l, {
                        class: "h-3 w-3 text-gray-400",
                        "aria-hidden": "true"
                      })
                    ]),
                    k("input", {
                      ref: "mobileSearchInput",
                      type: "text",
                      name: `search-mobile-filter-${n.name}`,
                      id: `search-mobile-filter-${n.name}`,
                      class: "focus:ring-primary focus:border-primary block w-full rounded-md pl-10 sm:hidden border-gray-300",
                      placeholder: e.$t("Rechercher"),
                      onInput: t[0] || (t[0] = (...p) => a.debounceSearch && a.debounceSearch(...p)),
                      value: i.searchKeyword
                    }, null, 40, iG),
                    k("input", {
                      ref: "desktopSearchInput",
                      type: "text",
                      name: `search-desktop-filter-${n.name}`,
                      id: `search-desktop-filter-${n.name}`,
                      class: "hidden focus:ring-primary focus:border-primary min-w-full rounded-md pl-6 sm:block sm:text-xs border-gray-300 py-1",
                      placeholder: e.$t("Rechercher"),
                      onInput: t[1] || (t[1] = (...p) => a.debounceSearch && a.debounceSearch(...p)),
                      value: i.searchKeyword
                    }, null, 40, aG)
                  ])
                ])) : L("", !0),
                k("div", sG, [
                  (_(!0), O(Re, null, Ke(a.filteredOptions, (p) => (_(), O("div", {
                    key: p.value,
                    class: "flex items-center max-w-full"
                  }, [
                    ur(k("input", {
                      id: `filter-${n.name}-${p.value}`,
                      type: "checkbox",
                      class: "h-4 w-4 border-gray-300 rounded-sm text-primary-dark focus:ring-0 focus:ring-offset-0 cursor-pointer",
                      value: p.value,
                      "onUpdate:modelValue": t[2] || (t[2] = (g) => a.internalValue = g)
                    }, null, 8, oG), [
                      [W5, a.internalValue]
                    ]),
                    k("label", {
                      for: `filter-${n.name}-${p.value}`,
                      class: "ml-3 pr-6 text-sm font-medium text-gray-900 whitespace-nowrap cursor-pointer"
                    }, j(p.label ? e.$t(p.label) : null), 9, lG)
                  ]))), 128))
                ]),
                a.internalValue.length > 0 || n.enableSelectAll && n.options.length !== a.internalValue.length ? (_(), O("div", uG, [
                  a.internalValue.length > 0 ? (_(), O("div", {
                    key: 0,
                    class: "text-center cursor-pointer inline-flex items-center px-2 py-1 text-xs font-medium rounded-sm text-gray-500 hover:text-gray-700 hover:bg-gray-50",
                    onClick: t[3] || (t[3] = (...p) => a.clear && a.clear(...p))
                  }, j(e.$t("Clear")), 1)) : L("", !0),
                  n.enableSelectAll && n.options.length !== a.internalValue.length ? (_(), O("div", {
                    key: 1,
                    class: "text-center cursor-pointer px-2 py-1 text-xs rounded-sm text-gray-500 hover:text-gray-700 hover:bg-gray-50",
                    onClick: t[4] || (t[4] = (...p) => a.selectAll && a.selectAll(...p))
                  }, j(e.$t("Select All")), 1)) : L("", !0)
                ])) : L("", !0)
              ]),
              _: 1
            })), [
              [h]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]);
}
const dG = /* @__PURE__ */ we(J7, [["render", cG]]), fG = {
  name: "MultiSelectSearch",
  components: {
    SearchIcon: Fc
  },
  props: {
    searchGroups: {
      type: Array,
      required: !0,
      validator: (e) => e.every(
        (t) => t.key && t.label && Array.isArray(t.items) && typeof t.getDisplayName == "function" && typeof t.isSelected == "function" && typeof t.toggle == "function"
      )
    },
    placeholder: {
      type: String,
      default: "Rechercher..."
    },
    inputId: {
      type: String,
      default: "multi-select-search"
    },
    minSearchLength: {
      type: Number,
      default: 0
    },
    debounceDelay: {
      type: Number,
      default: 300
    },
    showComponent: {
      type: Boolean,
      default: !0
    },
    icon: {
      type: [Object, Function],
      default: null
    },
    // État initial
    initialSelections: {
      type: Object,
      default: () => ({})
    },
    selectedItems: {
      type: Array,
      default: () => []
    }
  },
  emits: ["update-selections", "search", "toggle-item", "clear-results"],
  data() {
    return {
      searchKeyword: "",
      showDropdown: !1,
      isLoading: !1,
      selectedIndex: -1,
      debounce: null,
      selections: { ...this.initialSelections }
    };
  },
  computed: {
    iconComponent() {
      return this.icon || Fc;
    },
    hasSelections() {
      return this.selectedItems.length > 0 || Object.values(this.selections).some((e) => e.length > 0);
    },
    selectedItemIds() {
      return new Set(
        this.selectedItems.map((e) => `${e.groupKey}-${e.id}`)
      );
    },
    totalResults() {
      return this.searchGroups.reduce((e, t) => e + this.unselectedItems(t).length, 0);
    }
  },
  watch: {
    searchKeyword(e) {
      this.debounceSearch(e);
    },
    initialSelections: {
      handler(e) {
        this.selections = { ...e };
      },
      deep: !0
    }
  },
  methods: {
    debounceSearch(e) {
      clearTimeout(this.debounce), this.debounce = setTimeout(() => {
        e.length >= this.minSearchLength ? this.performSearch(e) : this.clearResults();
      }, this.debounceDelay);
    },
    async performSearch(e) {
      if (!(!e || e.length < this.minSearchLength)) {
        this.isLoading = !0, this.selectedIndex = -1;
        try {
          await this.$emit("search", e);
        } catch (t) {
          console.error("Error searching:", t), this.clearResults();
        } finally {
          this.isLoading = !1;
        }
      }
    },
    clearResults() {
      this.$emit("clear-results"), this.selectedIndex = -1;
    },
    toggleItem(e, t) {
      this.$emit("toggle-item", { item: e, groupKey: t });
    },
    isItemSelected(e, t) {
      const n = this.searchGroups.find((r) => r.key === t);
      return n ? n.isSelected(e, this.selections) : !1;
    },
    getItemDisplayName(e) {
      const t = this.searchGroups.find((n) => n.items.includes(e));
      return t ? t.getDisplayName(e) : "";
    },
    getItemSelectedIndex(e, t) {
      let n = 0;
      for (let r = 0; r < e; r++)
        n += this.unselectedItems(this.searchGroups[r]).length;
      return n + t;
    },
    emitSelections() {
      this.$emit("update-selections", this.selections);
    },
    selectItem() {
      if (this.selectedIndex >= 0 && this.selectedIndex < this.totalResults) {
        let e = 0;
        for (const t of this.searchGroups) {
          const n = this.unselectedItems(t);
          if (this.selectedIndex < e + n.length) {
            const r = this.selectedIndex - e, i = n[r];
            this.toggleItem(i, t.key);
            break;
          }
          e += n.length;
        }
      }
    },
    navigateDown() {
      this.selectedIndex < this.totalResults - 1 && this.selectedIndex++;
    },
    navigateUp() {
      this.selectedIndex > 0 && this.selectedIndex--;
    },
    handleFocus() {
      this.showDropdown = !0, this.searchKeyword.length >= this.minSearchLength && this.performSearch(this.searchKeyword);
    },
    handleBlur() {
      setTimeout(() => {
        this.showDropdown = !1;
      }, 200);
    },
    hideDropdown() {
      this.showDropdown = !1, this.selectedIndex = -1;
    },
    unselectedItems(e) {
      return this.selectedItems.length === 0 ? e.items : e.items.filter(
        (t) => !this.selectedItemIds.has(`${e.key}-${t.id}`)
      );
    },
    removeSelectedItem(e) {
      this.$emit("toggle-item", { item: e, groupKey: e.groupKey });
    },
    clearAllSelections() {
      [...this.selectedItems].forEach((e) => {
        this.removeSelectedItem(e);
      }), this.selections = {}, this.searchKeyword = "", this.emitSelections();
    }
  }
}, hG = {
  key: 0,
  class: "relative"
}, pG = { class: "relative" }, mG = { class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" }, gG = ["id", "placeholder"], vG = {
  key: 0,
  class: "flex flex-wrap gap-1 mt-1.5"
}, bG = ["aria-label", "onClick"], _G = {
  key: 0,
  class: "px-4 py-2 text-gray-500 text-center"
}, yG = { key: 1 }, xG = ["onClick"], wG = { class: "flex items-center" }, kG = ["onClick"], SG = { class: "font-medium" }, CG = {
  key: 0,
  class: "px-4 py-2 text-xs font-semibold text-gray-500 uppercase tracking-wide border-b border-gray-100"
}, TG = ["onClick", "onMouseenter"], AG = { class: "flex items-center" }, DG = ["checked", "onClick"], EG = { class: "font-medium" }, PG = {
  key: 1,
  class: "px-4 py-2 text-gray-500 text-center"
};
function OG(e, t, n, r, i, a) {
  return n.showComponent ? (_(), O("div", hG, [
    k("div", pG, [
      k("div", mG, [
        (_(), ae(Lr(a.iconComponent), {
          class: "h-5 w-5 text-gray-400",
          "aria-hidden": "true"
        }))
      ]),
      ur(k("input", {
        id: n.inputId,
        type: "text",
        "onUpdate:modelValue": t[0] || (t[0] = (s) => i.searchKeyword = s),
        class: "focus:ring-primary focus:border-primary block w-full rounded-md pl-10 pr-10 py-2 text-sm border-gray-300",
        placeholder: n.placeholder,
        onFocus: t[1] || (t[1] = (...s) => a.handleFocus && a.handleFocus(...s)),
        onBlur: t[2] || (t[2] = (...s) => a.handleBlur && a.handleBlur(...s)),
        onKeydown: [
          t[3] || (t[3] = bt(sn((...s) => a.navigateDown && a.navigateDown(...s), ["prevent"]), ["arrow-down"])),
          t[4] || (t[4] = bt(sn((...s) => a.navigateUp && a.navigateUp(...s), ["prevent"]), ["arrow-up"])),
          t[5] || (t[5] = bt(sn((...s) => a.selectItem && a.selectItem(...s), ["prevent"]), ["enter"])),
          t[6] || (t[6] = bt((...s) => a.hideDropdown && a.hideDropdown(...s), ["escape"]))
        ]
      }, null, 40, gG), [
        [tl, i.searchKeyword]
      ]),
      a.hasSelections ? (_(), O("button", {
        key: 0,
        onClick: t[7] || (t[7] = (...s) => a.clearAllSelections && a.clearAllSelections(...s)),
        class: "absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600",
        type: "button"
      }, [...t[9] || (t[9] = [
        k("svg", {
          class: "h-4 w-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [
          k("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })
        ], -1)
      ])])) : L("", !0)
    ]),
    n.selectedItems.length > 0 ? (_(), O("div", vG, [
      (_(!0), O(Re, null, Ke(n.selectedItems, (s) => (_(), O("span", {
        key: `tag-${s.groupKey}-${s.id}`,
        class: "inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-primary-light text-primary"
      }, [
        Me(j(s.label) + " ", 1),
        k("button", {
          type: "button",
          "aria-label": `Retirer ${s.label}`,
          class: "inline-flex items-center justify-center h-3.5 w-3.5 rounded-full hover:bg-primary hover:text-white transition-colors",
          onClick: (o) => a.removeSelectedItem(s)
        }, [...t[10] || (t[10] = [
          k("svg", {
            class: "h-2.5 w-2.5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [
            k("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "3",
              d: "M6 18L18 6M6 6l12 12"
            })
          ], -1)
        ])], 8, bG)
      ]))), 128))
    ])) : L("", !0),
    i.showDropdown ? (_(), O("div", {
      key: 1,
      class: "absolute z-50 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black/5 overflow-auto focus:outline-hidden sm:text-sm",
      onMousedown: t[8] || (t[8] = sn(() => {
      }, ["prevent"]))
    }, [
      i.isLoading ? (_(), O("div", _G, " Recherche en cours... ")) : (_(), O("div", yG, [
        n.selectedItems.length > 0 ? (_(), O(Re, { key: 0 }, [
          t[11] || (t[11] = k("div", { class: "px-4 py-2 text-xs font-semibold text-gray-500 uppercase tracking-wide border-b border-gray-100" }, " Sélectionnés ", -1)),
          (_(!0), O(Re, null, Ke(n.selectedItems, (s) => (_(), O("div", {
            key: `selected-${s.groupKey}-${s.id}`,
            class: "px-4 py-2 cursor-pointer text-sm text-gray-900 hover:bg-gray-100",
            onClick: (o) => a.removeSelectedItem(s)
          }, [
            k("div", wG, [
              k("input", {
                type: "checkbox",
                checked: "",
                class: "h-4 w-4 text-primary focus:ring-primary border-gray-300 rounded-sm mr-3",
                onClick: sn((o) => a.removeSelectedItem(s), ["stop"])
              }, null, 8, kG),
              k("div", null, [
                k("div", SG, j(s.label), 1)
              ])
            ])
          ], 8, xG))), 128))
        ], 64)) : L("", !0),
        (_(!0), O(Re, null, Ke(n.searchGroups, (s, o) => (_(), O(Re, {
          key: s.key
        }, [
          a.unselectedItems(s).length > 0 ? (_(), O("div", CG, j(s.label), 1)) : L("", !0),
          (_(!0), O(Re, null, Ke(a.unselectedItems(s), (l, c) => (_(), O("div", {
            key: `${s.key}-${l.id}`,
            class: Pe([
              "px-4 py-2 cursor-pointer text-sm",
              a.getItemSelectedIndex(o, c) === i.selectedIndex ? "bg-primary text-white" : "text-gray-900 hover:bg-gray-100"
            ]),
            onClick: (f) => a.toggleItem(l, s.key),
            onMouseenter: (f) => i.selectedIndex = a.getItemSelectedIndex(o, c)
          }, [
            k("div", AG, [
              k("input", {
                type: "checkbox",
                checked: a.isItemSelected(l.id, s.key),
                class: "h-4 w-4 text-primary focus:ring-primary border-gray-300 rounded-sm mr-3",
                onClick: sn((f) => a.toggleItem(l, s.key), ["stop"])
              }, null, 8, DG),
              k("div", null, [
                k("div", EG, j(a.getItemDisplayName(l)), 1)
              ])
            ])
          ], 42, TG))), 128))
        ], 64))), 128)),
        a.totalResults === 0 && n.selectedItems.length === 0 ? (_(), O("div", PG, " Aucun résultat trouvé ")) : L("", !0)
      ]))
    ], 32)) : L("", !0)
  ])) : L("", !0);
}
const u0e = /* @__PURE__ */ we(fG, [["render", OG]]);
function mS(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "",
    resource: {
      fr: {
        search_placeholder: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Rechercher..." } },
        select_all: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Tout sélectionner" } },
        selection_title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sélection" } },
        clear_all: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Vider" } },
        no_results: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Aucun résultat" } },
        no_selection: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Aucun élément sélectionné" } }
      },
      en: {
        search_placeholder: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Search..." } },
        select_all: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Select all" } },
        selection_title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Selection" } },
        clear_all: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Clear" } },
        no_results: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "No results" } },
        no_selection: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "No item selected" } }
      }
    }
  });
}
const qO = dt({
  name: "CardSelector",
  components: { SearchIcon: lB, CheckIcon: ap, XIcon: EP },
  props: {
    items: { type: Array, required: !0 },
    modelValue: { type: Array, required: !0 },
    labelKey: { type: String, default: "label" },
    valueKey: { type: String, default: "id" },
    searchable: { type: Boolean, default: !0 },
    placeholder: { type: String, default: null },
    maxHeight: { type: String, default: "24rem" },
    maxSelections: { type: Number, default: null },
    disabled: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup() {
    const { t: e } = nr();
    return { t: e };
  },
  data() {
    return { searchKeyword: "" };
  },
  computed: {
    isMaxSingle() {
      return this.maxSelections === 1;
    },
    filteredItems() {
      if (!this.searchKeyword) return this.items;
      const e = this.normalizeString(this.searchKeyword);
      return this.items.filter((t) => this.normalizeString(t[this.labelKey]).includes(e));
    },
    selectedItems() {
      return this.items.filter((e) => this.modelValue.includes(e[this.valueKey]));
    },
    isMaxReached() {
      return this.maxSelections != null && this.modelValue.length >= this.maxSelections;
    }
  },
  methods: {
    normalizeString(e) {
      return (e || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
    },
    isSelected(e) {
      return this.modelValue.includes(e[this.valueKey]);
    },
    isItemDisabled(e) {
      return this.disabled || this.isMaxReached && !this.isSelected(e);
    },
    toggle(e) {
      if (this.isItemDisabled(e)) return;
      const t = e[this.valueKey];
      this.isSelected(e) ? this.$emit("update:modelValue", this.modelValue.filter((n) => n !== t)) : this.maxSelections === 1 ? this.$emit("update:modelValue", [t]) : this.$emit("update:modelValue", [...this.modelValue, t]);
    },
    remove(e) {
      this.$emit("update:modelValue", this.modelValue.filter((t) => t !== e[this.valueKey]));
    },
    selectAll() {
      const e = this.filteredItems.map((n) => n[this.valueKey]);
      let t = [.../* @__PURE__ */ new Set([...this.modelValue, ...e])];
      this.maxSelections != null && (t = t.slice(0, this.maxSelections)), this.$emit("update:modelValue", t);
    },
    clearAll() {
      this.$emit("update:modelValue", []);
    },
    itemClasses(e) {
      return this.isItemDisabled(e) ? "text-gray-400 cursor-not-allowed" : this.isSelected(e) ? " cursor-pointer" : "hover:bg-gray-100 cursor-pointer";
    },
    checkboxClasses(e) {
      return this.isSelected(e) ? "border-primary bg-primary" : this.isItemDisabled(e) ? "border-gray-200 bg-gray-100" : "border-gray-300 bg-white";
    }
  }
}), MG = { class: "flex flex-col w-2/3 border-r border-gray-200" }, IG = { class: "p-3 border-b border-gray-200 space-y-2" }, RG = {
  key: 0,
  class: "relative"
}, FG = { class: "pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3" }, NG = ["placeholder"], LG = ["disabled"], $G = {
  key: 0,
  class: "flex-1 overflow-y-auto p-2 space-y-1"
}, VG = ["disabled", "onClick"], BG = { class: "truncate" }, UG = {
  key: 1,
  class: "flex-1 flex items-center justify-center text-sm text-gray-400"
}, qG = { class: "flex flex-col w-1/3 bg-gray-50" }, jG = { class: "flex items-center justify-between p-3 border-b border-gray-200" }, WG = { class: "text-sm font-medium text-gray-700" }, zG = {
  key: 0,
  class: "flex-1 overflow-y-auto p-3"
}, HG = { class: "flex flex-wrap gap-2" }, GG = ["onClick"], YG = {
  key: 1,
  class: "flex-1 flex items-center justify-center text-sm text-gray-400"
};
function KG(e, t, n, r, i, a) {
  const s = U("SearchIcon"), o = U("CheckIcon"), l = U("XIcon");
  return _(), O("div", {
    class: "flex rounded-lg border border-gray-200 overflow-hidden",
    style: Zn({ height: e.maxHeight })
  }, [
    k("div", MG, [
      k("div", IG, [
        e.searchable ? (_(), O("div", RG, [
          k("div", FG, [
            W(s, { class: "h-4 w-4 text-gray-400" })
          ]),
          ur(k("input", {
            "onUpdate:modelValue": t[0] || (t[0] = (c) => e.searchKeyword = c),
            type: "text",
            placeholder: e.placeholder || e.t("search_placeholder"),
            class: "block w-full rounded-md border border-gray-300 py-1.5 pl-9 pr-3 text-sm focus:border-primary focus:ring-primary focus:outline-hidden"
          }, null, 8, NG), [
            [tl, e.searchKeyword]
          ])
        ])) : L("", !0),
        e.isMaxSingle ? L("", !0) : (_(), O("button", {
          key: 1,
          type: "button",
          class: "text-xs font-medium text-primary hover:text-primary-dark",
          disabled: e.disabled,
          onClick: t[1] || (t[1] = (...c) => e.selectAll && e.selectAll(...c))
        }, j(e.t("select_all")), 9, LG))
      ]),
      e.filteredItems.length > 0 ? (_(), O("ul", $G, [
        (_(!0), O(Re, null, Ke(e.filteredItems, (c) => (_(), O("li", {
          key: c[e.valueKey]
        }, [
          k("button", {
            type: "button",
            class: Pe(["flex w-full items-center gap-2.5 rounded-md px-2.5 py-2 text-left text-sm transition-colors", e.itemClasses(c)]),
            disabled: e.isItemDisabled(c),
            onClick: (f) => e.toggle(c)
          }, [
            k("span", {
              class: Pe(["flex h-4 w-4 items-center justify-center rounded-sm border", e.checkboxClasses(c)])
            }, [
              e.isSelected(c) ? (_(), ae(o, {
                key: 0,
                class: "h-3 w-3 text-white"
              })) : L("", !0)
            ], 2),
            k("span", BG, j(c[e.labelKey]), 1)
          ], 10, VG)
        ]))), 128))
      ])) : (_(), O("p", UG, j(e.t("no_results")), 1))
    ]),
    k("div", qG, [
      k("div", jG, [
        k("span", WG, j(e.t("selection_title")) + " · " + j(e.modelValue.length), 1),
        e.modelValue.length > 0 ? (_(), O("button", {
          key: 0,
          type: "button",
          class: "text-xs font-medium text-primary hover:text-primary-dark",
          onClick: t[2] || (t[2] = (...c) => e.clearAll && e.clearAll(...c))
        }, j(e.t("clear_all")), 1)) : L("", !0)
      ]),
      e.selectedItems.length > 0 ? (_(), O("div", zG, [
        k("div", HG, [
          (_(!0), O(Re, null, Ke(e.selectedItems, (c) => (_(), O("span", {
            key: c[e.valueKey],
            class: "inline-flex items-center gap-1 rounded-full bg-primary-light text-primary-dark px-3 py-1 text-xs font-medium"
          }, [
            Me(j(c[e.labelKey]) + " ", 1),
            k("button", {
              type: "button",
              class: "hover:text-primary ml-0.5",
              onClick: (f) => e.remove(c)
            }, [
              W(l, { class: "h-3.5 w-3.5" })
            ], 8, GG)
          ]))), 128))
        ])
      ])) : (_(), O("p", YG, j(e.t("no_selection")), 1))
    ])
  ], 4);
}
typeof mS == "function" && mS(qO);
const c0e = /* @__PURE__ */ we(qO, [["render", KG]]), XG = {
  components: {
    Popover: O0,
    PopoverButton: $O,
    PopoverPanel: VO,
    SearchIcon: Fc,
    ChevronDownIcon: Qc,
    CheckIcon: ap
  },
  props: {
    name: {
      type: String,
      required: !0
    },
    id: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      required: !0
    },
    modelValue: {
      required: !0
    },
    defaultOptionText: {
      type: String,
      default: "Choisir une option"
    },
    required: {
      type: Boolean,
      default: !1
    },
    searchKeywordThreshold: {
      type: Number,
      default: 9
    },
    searchPlaceholder: {
      type: String,
      default: "Rechercher..."
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue", "keyword"],
  data() {
    return {
      searchKeyword: "",
      debounce: null
    };
  },
  computed: {
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    },
    filteredOptions() {
      var t;
      if (!((t = this.searchKeyword) != null && t.trim())) return this.options;
      const e = this.searchKeyword.toLowerCase();
      return this.options.filter((n) => (n.label || "").toLowerCase().includes(e));
    },
    selectedLabel() {
      const e = this.options.find(
        (t) => this.isSelected(t.value)
      );
      return e != null && e.label ? this.$t(e.label) : (e == null ? void 0 : e.value) || "";
    }
  },
  watch: {
    searchKeyword(e) {
      this.$emit("keyword", e);
    }
  },
  methods: {
    debounceSearch(e) {
      clearTimeout(this.debounce), this.debounce = setTimeout(() => {
        this.searchKeyword = e.target.value;
      }, 300);
    },
    selectOption(e, t) {
      this.internalValue = e, this.searchKeyword = "", t && t(), this.$nextTick(() => {
        this.blurTrigger();
      });
    },
    isSelected(e) {
      return String(e) === String(this.internalValue);
    },
    blurTrigger() {
      const e = this.$refs.trigger, t = e && e.$el || (typeof e == "function" ? e() : e) || null;
      t && typeof t.blur == "function" && t.blur();
    },
    focusSearchInput() {
      this.$nextTick(() => {
        const e = this.$refs.searchInput;
        e && typeof e.focus == "function" && e.focus();
      });
    }
  }
}, ZG = {
  key: 0,
  class: "mb-2 block text-sm leading-6 text-gray-900 font-bold"
}, QG = { class: "flex flex-col text-left" }, JG = { class: "text-sm text-gray-900" }, eY = {
  key: 0,
  class: "relative"
}, tY = { class: "absolute inset-y-0 left-0 pl-1 flex items-center pointer-events-none" }, nY = ["placeholder", "value"], rY = ["onClick"], iY = { class: "whitespace-pre-wrap text-left" };
function aY(e, t, n, r, i, a) {
  const s = U("SearchIcon"), o = U("ChevronDownIcon"), l = U("PopoverButton"), c = U("CheckIcon"), f = U("PopoverPanel"), h = U("Popover");
  return _(), ae(h, {
    as: "div",
    class: "relative inline-block text-left w-full"
  }, {
    default: ie(({ open: p }) => [
      n.label ? (_(), O("p", ZG, j(n.label), 1)) : L("", !0),
      k("div", null, [
        W(l, {
          id: n.id,
          ref: "trigger",
          class: Pe([
            "w-full inline-flex items-center justify-between rounded-md bg-white px-3 py-2 text-sm font-medium text-gray-700 shadow-xs hover:bg-gray-50 focus:outline-hidden focus:ring-0 focus:shadow-none transition-colors border border-gray-300",
            p ? "bg-gray-50" : "",
            n.disabled ? "bg-gray-200 cursor-not-allowed opacity-70" : ""
          ]),
          disabled: n.disabled,
          "aria-required": n.required
        }, {
          default: ie(() => [
            k("div", QG, [
              k("span", JG, [
                p ? (_(), O("div", eY, [
                  k("div", tY, [
                    W(s, {
                      class: "h-3 w-3 text-gray-400",
                      "aria-hidden": "true"
                    })
                  ]),
                  k("input", {
                    ref: "searchInput",
                    type: "text",
                    class: "w-full border-0 bg-transparent pl-6 pr-2 py-0 text-sm text-gray-900 focus:outline-hidden focus:ring-0",
                    placeholder: n.searchPlaceholder,
                    onInput: t[0] || (t[0] = (...g) => a.debounceSearch && a.debounceSearch(...g)),
                    value: i.searchKeyword
                  }, null, 40, nY)
                ])) : (_(), O(Re, { key: 1 }, [
                  Me(j(a.selectedLabel || n.defaultOptionText), 1)
                ], 64))
              ])
            ]),
            W(o, {
              class: "h-5 w-5 text-gray-400",
              "aria-hidden": "true"
            })
          ]),
          _: 2
        }, 1032, ["id", "class", "disabled", "aria-required"])
      ]),
      W(Ea, {
        "enter-active-class": "transition ease-out duration-100",
        "enter-from-class": "transform opacity-0 scale-95",
        "enter-to-class": "transform opacity-100 scale-100",
        "leave-active-class": "transition ease-in duration-75",
        "leave-from-class": "transform opacity-100 scale-100",
        "leave-to-class": "transform opacity-0 scale-95",
        onAfterEnter: a.focusSearchInput
      }, {
        default: ie(() => [
          W(f, { class: "z-40 origin-top-right absolute right-0 mt-2 w-full bg-white rounded-md shadow-2xl p-4 ring-1 ring-black/5 focus:outline-hidden max-h-64 overflow-y-auto" }, {
            default: ie(({ close: g }) => [
              (_(!0), O(Re, null, Ke(a.filteredOptions, (v) => (_(), O("div", {
                key: v.value,
                class: "w-full"
              }, [
                k("button", {
                  type: "button",
                  class: "flex items-center justify-between w-full px-2 py-1 rounded-sm hover:bg-gray-100 text-sm text-gray-900",
                  onClick: (y) => a.selectOption(v.value, g)
                }, [
                  k("span", iY, j(v.label ? e.$t(v.label) : v.value), 1),
                  a.isSelected(v.value) ? (_(), ae(c, {
                    key: 0,
                    class: "h-4 w-4 text-primary-dark"
                  })) : L("", !0)
                ], 8, rY)
              ]))), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onAfterEnter"])
    ]),
    _: 1
  });
}
const d0e = /* @__PURE__ */ we(XG, [["render", aY]]), sY = {
  props: {
    id: {
      type: String,
      required: !0
    },
    label: {
      type: String
    },
    labelClass: {
      type: String,
      default: "font-semibold my-2"
    },
    labelStyle: {
      type: Object,
      default: () => ({})
    },
    name: {
      type: String,
      required: !0
    },
    required: {
      type: Boolean,
      default: !1
    },
    modelValue: {
      required: !0
    },
    options: {
      type: Array,
      required: !0
    },
    defaultOptionText: {
      type: String,
      default: "Choisir une option"
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      default: "normal"
    },
    fieldClass: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue"],
  computed: {
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    }
  }
}, oY = ["for"], lY = {
  key: 0,
  class: "text-red-600"
}, uY = ["id", "name", "value", "disabled"], cY = {
  disabled: "",
  key: "default",
  value: ""
}, dY = ["value"];
function fY(e, t, n, r, i, a) {
  return _(), O("div", null, [
    n.label ? (_(), O("label", {
      key: 0,
      for: n.id,
      class: Pe(`block text-sm leading-6 text-gray-900 ${n.labelClass}`),
      style: Zn(n.labelStyle)
    }, [
      Me(j(e.$t(n.label)) + " ", 1),
      n.required ? (_(), O("span", lY, "*")) : L("", !0)
    ], 14, oY)) : L("", !0),
    ur(k("select", {
      id: n.id,
      name: n.name,
      value: n.modelValue,
      "onUpdate:modelValue": t[0] || (t[0] = (s) => a.internalValue = s),
      disabled: n.disabled,
      class: Pe([
        n.fieldClass,
        "block w-full rounded-md border-0 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-1 focus:ring-gray-300",
        n.size === "small" ? "py-1 text-xs leading-5" : "py-1.5 sm:text-sm sm:leading-6",
        n.disabled ? "bg-gray-200" : ""
      ])
    }, [
      k("option", cY, j(n.defaultOptionText), 1),
      (_(!0), O(Re, null, Ke(n.options, (s) => (_(), O("option", {
        key: s.value,
        value: s.value
      }, j(s.label), 9, dY))), 128))
    ], 10, uY), [
      [z5, a.internalValue]
    ])
  ]);
}
const hY = /* @__PURE__ */ we(sY, [["render", fY]]), pY = {
  components: {
    Field: cu
  },
  props: {
    id: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      required: !1,
      default: null
    },
    labelClass: {
      type: String,
      default: "font-semibold"
    },
    required: {
      type: Boolean,
      default: !1
    },
    modelValue: {
      required: !0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    minLength: {
      type: Number,
      default: null
    },
    error: {
      type: String,
      default: null
    }
  },
  emits: ["update:modelValue"],
  computed: {
    charCount() {
      var e;
      return ((e = this.modelValue) == null ? void 0 : e.trim().length) || 0;
    },
    isMinLengthMet() {
      return this.charCount >= this.minLength;
    },
    counterClass() {
      return this.isMinLengthMet ? "text-green-600" : "text-red-600 font-bold";
    },
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    }
  },
  methods: {
    isPresent: Cr
  }
}, mY = ["for"], gY = {
  key: 0,
  class: "text-red-600"
}, vY = { class: "relative" }, bY = ["id", "name", "disabled"], _Y = ["id"];
function yY(e, t, n, r, i, a) {
  return _(), O("div", null, [
    a.isPresent(n.label) ? (_(), O("label", {
      key: 0,
      for: n.id,
      class: Pe(`block text-sm leading-6 text-gray-900 sm:pt-1.5 mb-2 ${n.labelClass}`)
    }, [
      Me(j(e.$t(n.label)) + " ", 1),
      n.required ? (_(), O("span", gY, "*")) : L("", !0)
    ], 10, mY)) : L("", !0),
    k("div", vY, [
      ur(k("textarea", {
        id: n.id,
        name: n.id,
        class: Pe([
          "shadow-xs focus:ring-primary focus:border-primary block w-full sm:text-sm border-gray-300 rounded-md",
          n.disabled ? "bg-gray-200" : ""
        ]),
        rows: "5",
        disabled: n.disabled,
        "onUpdate:modelValue": t[0] || (t[0] = (s) => a.internalValue = s)
      }, null, 10, bY), [
        [tl, a.internalValue]
      ])
    ]),
    n.minLength ? (_(), O("p", {
      key: 1,
      class: Pe(["mt-1 text-sm", a.counterClass])
    }, j(a.charCount) + " / " + j(n.minLength), 3)) : L("", !0),
    n.error ? (_(), O("p", {
      key: 2,
      id: `${n.id}-error`,
      class: "mt-1 text-sm text-red-600"
    }, j(n.error), 9, _Y)) : L("", !0)
  ]);
}
const xY = /* @__PURE__ */ we(pY, [["render", yY]]), wY = {
  name: "Alert",
  props: {
    type: {
      type: String,
      default: "info",
      validator: (e) => ["info", "success", "warning", "error"].includes(e)
    }
  },
  computed: {
    iconComponent() {
      switch (this.type) {
        case "error":
          return uh;
        case "warning":
          return _h;
        case "success":
          return n0;
        default:
          return uB;
      }
    },
    boxClass() {
      switch (this.type) {
        case "error":
          return "bg-red-50 border-red-500 text-red-700";
        case "warning":
          return "bg-yellow-50 border-yellow-500 text-yellow-700";
        case "success":
          return "bg-green-50 border-green-500 text-green-700";
        default:
          return "bg-blue-50 border-blue-500 text-blue-700";
      }
    },
    iconClass() {
      switch (this.type) {
        case "error":
          return "text-red-500";
        case "warning":
          return "text-yellow-500";
        case "success":
          return "text-green-500";
        default:
          return "text-blue-500";
      }
    }
  }
}, kY = { class: "shrink-0" }, SY = { class: "text-xs leading-snug font-light" }, CY = {
  key: 0,
  class: "font-bold"
};
function TY(e, t, n, r, i, a) {
  return _(), O("div", {
    class: Pe(["flex items-center gap-2 rounded-md border-l-2 px-3 py-2", a.boxClass])
  }, [
    k("div", kY, [
      xe(e.$slots, "icon", {}, () => [
        (_(), ae(Lr(a.iconComponent), {
          class: Pe(["w-4 h-4", a.iconClass])
        }, null, 8, ["class"]))
      ])
    ]),
    k("div", SY, [
      e.$slots.title ? (_(), O("span", CY, [
        xe(e.$slots, "title")
      ])) : L("", !0),
      xe(e.$slots, "default")
    ])
  ], 2);
}
const so = /* @__PURE__ */ we(wY, [["render", TY]]);
function R0() {
  return { async: !1, breaks: !1, extensions: null, gfm: !0, hooks: null, pedantic: !1, renderer: null, silent: !1, tokenizer: null, walkTokens: null };
}
var al = R0();
function jO(e) {
  al = e;
}
var Lo = { exec: () => null };
function Vl(e) {
  let t = [];
  return (n) => {
    let r = Math.max(0, Math.min(3, n - 1)), i = t[r];
    return i || (i = e(r), t[r] = i), i;
  };
}
function ht(e, t = "") {
  let n = typeof e == "string" ? e : e.source, r = { replace: (i, a) => {
    let s = typeof a == "string" ? a : a.source;
    return s = s.replace(mr.caret, "$1"), n = n.replace(i, s), r;
  }, getRegex: () => new RegExp(n, t) };
  return r;
}
var AY = ((e = "") => {
  try {
    return !!new RegExp("(?<=1)(?<!1)" + e);
  } catch {
    return !1;
  }
})(), mr = { codeRemoveIndent: /^(?: {0,3}\t| {1,4})/gm, outputLinkReplace: /\\([\[\]])/g, indentCodeCompensation: /^(\s+)(?:```)/, beginningSpace: /^\s+/, endingHash: /#$/, startingSpaceChar: /^ /, endingSpaceChar: / $/, endingSpaceTabChar: /[ \t]$/, nonSpaceChar: /[^ ]/, newLineCharGlobal: /\n/g, tabCharGlobal: /\t/g, leadingSpaceTab: /^[ \t]+/, multipleSpaceGlobal: /\s+/g, blankLine: /^[ \t]*$/, doubleBlankLine: /\n[ \t]*\n[ \t]*$/, blockquoteStart: /^ {0,3}>/, blockquoteSetextReplace: /\n {0,3}((?:=+|-+) *)(?=\n|$)/g, blockquoteSetextReplace2: /^ {0,3}>[ \t]?/gm, listReplaceNesting: /^ {1,4}(?=( {4})*[^ ])/g, listIsTask: /^\[[ xX]\] +\S/, listReplaceTask: /^\[[ xX]\] +/, listTaskCheckbox: /\[[ xX]\]/, anyLine: /\n.*\n/, hrefBrackets: /^<(.*)>$/, tableDelimiter: /[:|]/, tableAlignChars: /^\||\| *$/g, tableRowBlankLine: /\n[ \t]*$/, tableAlignRight: /^ *-+: *$/, tableAlignCenter: /^ *:-+: *$/, tableAlignLeft: /^ *:-+ *$/, startATag: /^<a /i, endATag: /^<\/a>/i, startPreScriptTag: /^<(pre|code|kbd|script)(\s|>)/i, endPreScriptTag: /^<\/(pre|code|kbd|script)(\s|>)/i, startAngleBracket: /^</, endAngleBracket: />$/, pedanticHrefTitle: /^([^'"]*[^\s])\s+(['"])(.*)\2/, unicodeAlphaNumeric: /[\p{L}\p{N}]/u, numericCharacterReference: /&#(?:(\d{1,7})|[Xx]([A-Fa-f0-9]{1,6}));/, numericCharacterReferenceOrAmpersand: /&#(?:(\d{1,7})|[Xx]([A-Fa-f0-9]{1,6}));|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g, escapeTest: /[&<>"']/, escapeReplace: /[&<>"']/g, escapeTestNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/, escapeReplaceNoEncode: /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/g, caret: /(^|[^\[])\^/g, percentDecode: /%25/g, findPipe: /\|/g, splitPipe: / \|/, slashPipe: /\\\|/g, carriageReturn: /\r\n|\r/g, spaceLine: /^ +$/gm, notSpaceStart: /^\S*/, endingNewline: /\n$/, listItemRegex: (e) => new RegExp(`^( {0,3}${e})((?:[	 ][^\\n]*)?(?:\\n|$))`), nextBulletRegex: Vl((e) => new RegExp(`^ {0,${e}}(?:[*+-]|\\d{1,9}[.)])((?:[ 	][^\\n]*)?(?:\\n|$))`)), hrRegex: Vl((e) => new RegExp(`^ {0,${e}}((?:-[ 	]*){3,}|(?:_[ 	]*){3,}|(?:\\*[ 	]*){3,})(?:\\n+|$)`)), fencesBeginRegex: Vl((e) => new RegExp(`^ {0,${e}}(?:\`\`\`|~~~)`)), headingBeginRegex: Vl((e) => new RegExp(`^ {0,${e}}#`)), htmlBeginRegex: Vl((e) => new RegExp(`^ {0,${e}}(?:</?(?:${ld})(?: +|$|/?>)|<(?:(?:script|pre|style|textarea)(?:[\\s>]|$)|!--)|<\\?|<![A-Za-z]|<!\\[CDATA\\[)`, "i")), blockquoteBeginRegex: Vl((e) => new RegExp(`^ {0,${e}}>`)) }, DY = /^(?:[ \t]*(?:\n|$))+/, EY = /^((?: {4}| {0,3}\t)[^\n]+(?:\n(?:[ \t]*(?:\n|$))*)?)+/, PY = /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/, od = /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/, OY = /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/, F0 = / {0,3}(?:[*+-]|\d{1,9}[.)])/, WO = /^(?!bull |blockCode|fences|blockquote|heading|html|table)((?:.|\n(?!\s*?\n|bull |fences|blockquote|heading|hr|html|table))+?)\n {0,3}(=+|-+) *(?:\n+|$)/, zO = ht(WO).replace(/bull/g, F0).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}(?:\s|$)/).replace(/hr/g, / {0,3}(?:(?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/\|table/g, "").getRegex(), MY = ht(WO).replace(/bull/g, F0).replace(/blockCode/g, /(?: {4}| {0,3}\t)/).replace(/fences/g, / {0,3}(?:`{3,}|~{3,})/).replace(/blockquote/g, / {0,3}>/).replace(/heading/g, / {0,3}#{1,6}(?:\s|$)/).replace(/hr/g, / {0,3}(?:(?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/).replace(/html/g, / {0,3}<[^\n>]+>\n/).replace(/table/g, / {0,3}\|?(?:[:\- ]*\|)+[\:\- ]*\n/).getRegex(), N0 = /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table|[ \t]+\n)[^\n]+)*)/, IY = /^[^\n]+/, L0 = /(?!\s*\])(?:\\[\s\S]|[^\[\]\\])+/, RY = ht(/^ {0,3}\[(label)\]: *(?:\n[ \t]*)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n[ \t]*)?| *\n[ \t]*)(title))? *(?:\n+|$)/).replace("label", L0).replace("title", /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/).getRegex(), FY = ht(/^(bull)([ \t][^\n]*?)?(?:\n|$)/).replace(/bull/g, F0).getRegex(), ld = "address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option|p|param|search|section|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul", $0 = /<!--(?:-?>|[\s\S]*?(?:-->|$))/, NY = ht("^ {0,3}(?:<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n*|$)|comment[^\\n]*(\\n+|$)|<\\?[\\s\\S]*?(?:\\?>[^\\n]*\\n*|$)|<![A-Z][\\s\\S]*?(?:>[^\\n]*\\n*|$)|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>[^\\n]*\\n*|$)|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|<(?!(?:script|pre|style|textarea)(?![a-z0-9-]))([a-z][a-z0-9-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$)|</[a-z][a-z0-9-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n[ 	]*)+\\n|$))", "i").replace("comment", $0).replace("tag", ld).replace("attribute", / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex(), HO = (e) => ht(N0).replace("hr", od).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("|table", "").replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*(?:\\n|$))|~~~)[^\\n]*(?:\\n|$)").replace("list", e).replace("html", " {0,3}(?:</?(?:tag)(?: +|\\n|/?>)|<(?:(?:script|pre|style|textarea)(?:[\\s>]|$)|!--)|<\\?|<![A-Za-z]|<!\\[CDATA\\[)").replace("tag", ld).getRegex(), LY = HO(/ {0,3}(?:[*+-]|1[.)])[ \t]+[^ \t\n]/), $Y = HO(/ {0,3}(?:[*+-]|\d{1,9}[.)])(?:[ \t]|\n|$)/), VY = ht(/^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/).replace("paragraph", $Y).getRegex(), V0 = { blockquote: VY, code: EY, def: RY, fences: PY, heading: OY, hr: od, html: NY, lheading: zO, list: FY, newline: DY, paragraph: LY, table: Lo, text: IY }, gS = ht("^ *([^\\n ].*)\\n {0,3}((?:\\| *)?:?-+:? *(?:\\| *:?-+:? *)*(?:\\| *)?)(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)").replace("hr", od).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("blockquote", " {0,3}>").replace("code", "(?: {4}| {0,3}	)[^\\n]").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*(?:\\n|$))|~~~)[^\\n]*(?:\\n|$)").replace("list", " {0,3}(?:[*+-]|1[.)])[ \\t]").replace("html", " {0,3}(?:</?(?:tag)(?: +|\\n|/?>)|<(?:(?:script|pre|style|textarea)(?:[\\s>]|$)|!--)|<\\?|<![A-Za-z]|<!\\[CDATA\\[)").replace("tag", ld).getRegex(), BY = { ...V0, lheading: MY, table: gS, paragraph: ht(N0).replace("hr", od).replace("heading", " {0,3}#{1,6}(?:\\s|$)").replace("|lheading", "").replace("table", gS).replace("blockquote", " {0,3}>").replace("fences", " {0,3}(?:`{3,}(?=[^`\\n]*(?:\\n|$))|~~~)[^\\n]*(?:\\n|$)").replace("list", " {0,3}(?:[*+-]|1[.)])[ \\t]+[^ \\t\\n]").replace("html", " {0,3}(?:</?(?:tag)(?: +|\\n|/?>)|<(?:(?:script|pre|style|textarea)(?:[\\s>]|$)|!--)|<\\?|<![A-Za-z]|<!\\[CDATA\\[)").replace("tag", ld).getRegex() }, UY = { ...V0, html: ht(`^ *(?:comment *(?:\\n|\\s*$)|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)|<tag(?:"[^"]*"|'[^']*'|\\s[^'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))`).replace("comment", $0).replace(/tag/g, "(?!(?:a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)\\b)\\w+(?!:|[^\\w\\s@]*@)\\b").getRegex(), def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/, heading: /^(#{1,6})(.*)(?:\n+|$)/, fences: Lo, lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/, paragraph: ht(N0).replace("hr", od).replace("heading", ` *#{1,6} *[^
]`).replace("lheading", zO).replace("|table", "").replace("blockquote", " {0,3}>").replace("|fences", "").replace("|list", "").replace("|html", "").replace("|tag", "").getRegex() }, qY = /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/, jY = /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/, GO = /^( {2,}|\\)\n(?!\s*$)[ \t]*/, WY = /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/, Oa = /[\p{P}\p{S}]/u, pu = /[\s\p{P}\p{S}]/u, ud = /[^\s\p{P}\p{S}]/u, zY = ht(/^((?![*_])punctSpace)/, "u").replace(/punctSpace/g, pu).getRegex(), HY = /[\p{Pi}\p{Ps}"']/u, YO = /(?!~)[\p{P}\p{S}]/u, GY = /(?!~)[\s\p{P}\p{S}]/u, YY = /(?:[^\s\p{P}\p{S}]|~)/u, KY = ht(/link|precode-code|html/, "g").replace("link", /\[(?:[^\[\]`]|(?<a>`+)[^`]+\k<a>(?!`))*?\]\((?:\\[\s\S]|[^\\\(\)]|\((?:\\[\s\S]|[^\\\(\)])*\))*\)/).replace("precode-", AY ? "(?<!`)()" : "(^^|[^`])").replace("code", /(?<b>`+)[^`]+\k<b>(?!`)/).replace("html", /<(?! )[^<>]*?>/).getRegex(), KO = /^(?:\*+(?:((?!\*)punct)|([^\s*]))?)|^_+(?:((?!_)punct)|([^\s_]))?/, XY = ht(KO, "u").replace(/punct/g, Oa).getRegex(), ZY = ht(KO, "u").replace(/punct/g, YO).getRegex(), QY = /^(?:\*+(?:((?!\*)(?!openQuote)punct)|([^\s*]))?)|^_+(?:((?!_)(?!openQuote)punct)|([^\s_]))?/, JY = ht(QY, "u").replace(/openQuote/g, HY).replace(/punct/g, Oa).getRegex(), XO = "^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)punctSpace(\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|notPunctSpace(\\*+)(?=notPunctSpace)", e9 = ht(XO, "gu").replace(/notPunctSpace/g, ud).replace(/punctSpace/g, pu).replace(/punct/g, Oa).getRegex(), t9 = ht(XO, "gu").replace(/notPunctSpace/g, YY).replace(/punctSpace/g, GY).replace(/punct/g, YO).getRegex(), n9 = "^[^_*]*?__[^_*]*?\\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\\*)punct(\\*+)(?=[\\s]|$)|notPunctSpace(\\*+)(?!\\*)(?=punctSpace|$)|(?!\\*)[\\s](\\*+)(?=notPunctSpace)|[\\s](\\*+)(?!\\*)(?=punct)|(?!\\*)punct(\\*+)(?!\\*)(?=punct)|(?:(?!\\*)punct|notPunctSpace)(\\*+)(?!\\*)(?=notPunctSpace)", r9 = ht(n9, "gu").replace(/notPunctSpace/g, ud).replace(/punctSpace/g, pu).replace(/punct/g, Oa).getRegex(), i9 = ht("^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)punctSpace(_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)", "gu").replace(/notPunctSpace/g, ud).replace(/punctSpace/g, pu).replace(/punct/g, Oa).getRegex(), a9 = "^[^_*]*?\\*\\*[^_*]*?_[^_*]*?(?=\\*\\*)|[^_]+(?=[^_])|(?!_)punct(_+)(?=[\\s]|$)|notPunctSpace(_+)(?!_)(?=punctSpace|$)|(?!_)[\\s](_+)(?=notPunctSpace)|[\\s](_+)(?!_)(?=punct)|(?!_)punct(_+)(?!_)(?=punct)|(?:(?!_)punct|notPunctSpace)(_+)(?!_)(?=notPunctSpace)", s9 = ht(a9, "gu").replace(/notPunctSpace/g, ud).replace(/punctSpace/g, pu).replace(/punct/g, Oa).getRegex(), o9 = ht(/^~~?(?:((?!~)punct)|[^\s~])/, "u").replace(/punct/g, Oa).getRegex(), l9 = "^[^~]+(?=[^~])|(?!~)punct(~~?)(?=[\\s]|$)|notPunctSpace(~~?)(?!~)(?=punctSpace|$)|(?!~)punctSpace(~~?)(?=notPunctSpace)|[\\s](~~?)(?!~)(?=punct)|(?!~)punct(~~?)(?!~)(?=punct)|notPunctSpace(~~?)(?=notPunctSpace)", u9 = ht(l9, "gu").replace(/notPunctSpace/g, ud).replace(/punctSpace/g, pu).replace(/punct/g, Oa).getRegex(), c9 = ht(/\\(punct)/, "gu").replace(/punct/g, Oa).getRegex(), d9 = ht(/(`+)(?:[^`]|[^`][\s\S]*?[^`])\1(?!`)|`+|\\(punct)/, "gu").replace(/punct/g, Oa).getRegex(), f9 = ht(/^<(scheme:[^\s\x00-\x1f<>]*|email)>/).replace("scheme", /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/).replace("email", /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/).getRegex(), h9 = ht($0).replace("(?:-->|$)", "-->").getRegex(), p9 = ht("^comment|^</[a-zA-Z][a-zA-Z0-9-]*\\s*>|^<[a-zA-Z][a-zA-Z0-9-]*(?:attribute)*?\\s*/?>|^<\\?[\\s\\S]*?\\?>|^<![a-zA-Z]+\\s[\\s\\S]*?>|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>").replace("comment", h9).replace("attribute", /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/).getRegex(), ZO = /\[(?:\\[\s\S]|[^\[\]\\])*\]/, Rh = ht(/(?:\[(?:brackets|\\[\s\S]|[^\[\]\\])*\]|\\[\s\S]|`+(?!`)[^`]*?`+(?!`)|``+(?=\])|[^\[\]\\`])*?/).replace("brackets", ZO).getRegex(), m9 = ht(/^!?\[(label)\]\([ \t\n]*(href)(?:(?:[ \t]+(?:\n[ \t]*)?|\n[ \t]*)(title))?[ \t\n]*\)/).replace("label", Rh).replace("href", /<(?:\\.|[^\n<>\\])+>|[^ \t\n\x00-\x1f]+|(?=\))/).replace("title", /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/).getRegex(), g9 = ht(/^!?\[(label)\]\[(ref)\]/).replace("label", Rh).replace("ref", L0).getRegex(), v9 = ht(/^!?\[(ref)\](?:\[\])?/).replace("ref", L0).getRegex(), vS = /(?!\s*\])(?:\\[\s\S]|[^\[\]\\]){1,999}/, b9 = ht(/(?:[^\[\]\\`]*(?:\[(?:brackets|\\[\s\S]|[^\[\]\\])*\]|\\[\s\S]|`+(?!`)[^`]*?`+(?!`)|``+(?=\]))){0,999}?[^\[\]\\`]*?/).replace("brackets", ZO).getRegex(), _9 = ht("reflink|nolink(?!\\()", "g").replace("reflink", ht(/^!?\[(label)\]\[(ref)\]/).replace("label", b9).replace("ref", vS).getRegex()).replace("nolink", ht(/^!?\[(ref)\](?:\[\])?/).replace("ref", vS).getRegex()).getRegex(), bS = /[hH][tT][tT][pP][sS]?|[fF][tT][pP]/, y9 = /[A-Za-z0-9._+-]+@[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![\w-])/, x9 = ht(/(?:mailto:email|xmpp:email(?:\/[A-Za-z0-9@.]+)?)/).replace(/email/g, y9).getRegex(), B0 = { _backpedal: Lo, anyPunctuation: c9, anyPunctuationOutsideCode: d9, autolink: f9, blockSkip: KY, br: GO, code: jY, del: Lo, delLDelim: Lo, delRDelim: Lo, emStrongLDelim: XY, emStrongRDelimAst: e9, emStrongRDelimUnd: i9, escape: qY, link: m9, nolink: v9, punctuation: zY, reflink: g9, reflinkSearch: _9, tag: p9, text: WY, url: Lo }, w9 = { ...B0, emStrongLDelim: JY, emStrongRDelimAst: r9, emStrongRDelimUnd: s9, link: ht(/^!?\[(label)\]\((.*?)\)/).replace("label", Rh).getRegex(), reflink: ht(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace("label", Rh).getRegex() }, yy = { ...B0, emStrongRDelimAst: t9, emStrongLDelim: ZY, delLDelim: o9, delRDelim: u9, url: ht(/^emailProtocol|^((?:protocol):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/).replace("emailProtocol", x9).replace("protocol", bS).replace("email", /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![\w-])/).getRegex(), _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/, del: /^(~~?)(?=[^\s~])((?:\\[\s\S]|[^\\])*?(?:\\[\s\S]|[^\s~\\]))\1(?=[^~]|$)/, text: ht(/^(?:[^a-zA-Z0-9](?=emailProtocol)|(`+|~+|[^`~])(?:(?=[`~])|(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|protocol:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9](?=emailProtocol)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@))))/).replace("protocol", bS).replace(/emailProtocol/g, /(?:mailto|xmpp):/).getRegex() }, k9 = { ...yy, br: ht(GO).replace("{2,}", "*").getRegex(), text: ht(yy.text).replace("\\b_", "\\b_| {2,}\\n").replace(/\{2,\}/g, "*").getRegex() }, Nf = { normal: V0, gfm: BY, pedantic: UY }, tc = { normal: B0, gfm: yy, breaks: k9, pedantic: w9 }, S9 = { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }, _S = (e) => S9[e];
function vi(e, t) {
  if (t) {
    if (mr.escapeTest.test(e)) return e.replace(mr.escapeReplace, _S);
  } else if (mr.escapeTestNoEncode.test(e)) return e.replace(mr.escapeReplaceNoEncode, _S);
  return e;
}
function C9(e) {
  return mr.numericCharacterReference.test(e) ? e.replace(mr.numericCharacterReferenceOrAmpersand, (t, n, r) => {
    if (n === void 0 && r === void 0) return "&amp;";
    let i = n === void 0 ? Number.parseInt(r, 16) : Number.parseInt(n, 10);
    return i === 0 || i > 1114111 || i >= 55296 && i <= 57343 ? "�" : i === 38 ? "&amp;" : String.fromCodePoint(i);
  }) : e;
}
function yS(e) {
  try {
    e = encodeURI(e).replace(mr.percentDecode, "%");
  } catch {
    return null;
  }
  return e;
}
function xS(e, t) {
  var a;
  let n = e.replace(mr.findPipe, (s, o, l) => {
    let c = !1, f = o;
    for (; --f >= 0 && l[f] === "\\"; ) c = !c;
    return c ? "|" : " |";
  }), r = n.split(mr.splitPipe), i = 0;
  if (r[0].trim() || r.shift(), r.length > 0 && !((a = r.at(-1)) != null && a.trim()) && r.pop(), t) if (r.length > t) r.splice(t);
  else for (; r.length < t; ) r.push("");
  for (; i < r.length; i++) r[i] = r[i].trim().replace(mr.slashPipe, "|");
  return r;
}
function Rs(e, t, n) {
  let r = e.length;
  if (r === 0) return "";
  let i = 0;
  for (; i < r && e.charAt(r - i - 1) === t; )
    i++;
  return e.slice(0, r - i);
}
function wS(e) {
  let t = e.split(`
`), n = t.length - 1;
  for (; n >= 0 && mr.blankLine.test(t[n]); ) n--;
  return t.length - n <= 2 ? e : t.slice(0, n + 1).join(`
`);
}
function Fh(e) {
  return e.trim().toLowerCase().toUpperCase().toLowerCase();
}
function kS(e, t) {
  if (e.indexOf(t[0]) === -1 && e.indexOf(t[1]) === -1) return -1;
  let n = 0;
  for (let r = 0; r < e.length; r++) if (e[r] === "\\") r++;
  else if (e[r] === t[0]) n++;
  else if (e[r] === t[1] && (n--, n < 0)) return r;
  return n > 0 ? -2 : -1;
}
function Ng(e, t = 0) {
  let n = t, r = "";
  for (let i of e) if (i === "	") {
    let a = 4 - n % 4;
    r += " ".repeat(a), n += a;
  } else r += i, n++;
  return r;
}
function SS(e, t, n, r, i) {
  let a = t.href, s = t.title || null, o = e[1].replace(i.other.outputLinkReplace, "$1"), l = e[0].charAt(0) === "!", c = r.state.inLink, f = r.state.linkEmitted, h = r.state.inRawBlock;
  r.state.inLink = !0, r.state.linkEmitted = !1;
  let p = r.inlineTokens(o), g = r.state.linkEmitted;
  if (r.state.linkEmitted = f, r.state.inLink = c, !l) {
    if (g) {
      r.state.inRawBlock = h;
      return;
    }
    r.state.linkEmitted = !0;
  }
  return { type: l ? "image" : "link", raw: n, href: a, title: s, text: o, tokens: p };
}
function T9(e, t, n) {
  let r = e.match(n.other.indentCodeCompensation);
  if (r === null) return t;
  let i = r[1];
  return t.split(`
`).map((a) => {
    let s = a.match(n.other.beginningSpace);
    if (s === null) return a;
    let [o] = s;
    return a.slice(Math.min(o.length, i.length));
  }).join(`
`);
}
function CS(e, t, n, r) {
  if (!t.includes("<")) return !1;
  for (let i = 0; i < t.length; i++) {
    if (t[i] === "\\") {
      i++;
      continue;
    }
    if (t[i] === "`") {
      let o = r.inline.code.exec(t.slice(i));
      if (o) {
        i += o[0].length - 1;
        continue;
      }
    }
    if (t[i] !== "<") continue;
    let a = e.slice(n + i), s = r.inline.tag.exec(a) || r.inline.autolink.exec(a);
    if (s) {
      if (s[0].length > t.length - i) return !0;
      i += s[0].length - 1;
    }
  }
  return !1;
}
var Nh = class {
  constructor(t) {
    Qt(this, "options");
    Qt(this, "rules");
    Qt(this, "lexer");
    this.options = t || al;
  }
  space(t) {
    let n = this.rules.block.newline.exec(t);
    if (n && n[0].length > 0) return { type: "space", raw: n[0] };
  }
  code(t) {
    let n = this.rules.block.code.exec(t);
    if (n) {
      let r = this.options.pedantic ? n[0] : wS(n[0]), i = r.replace(this.rules.other.codeRemoveIndent, "");
      return { type: "code", raw: r, codeBlockStyle: "indented", text: i };
    }
  }
  fences(t) {
    let n = this.rules.block.fences.exec(t);
    if (n) {
      let r = n[0], i = T9(r, n[3] || "", this.rules);
      return { type: "code", raw: r, lang: n[2] ? n[2].trim().replace(this.rules.inline.anyPunctuation, "$1") : n[2], text: i };
    }
  }
  heading(t) {
    let n = this.rules.block.heading.exec(t);
    if (n) {
      let r = n[2].trim();
      if (this.rules.other.endingHash.test(r)) {
        let i = Rs(r, "#");
        (this.options.pedantic || !i || this.rules.other.endingSpaceTabChar.test(i)) && (r = i.trim());
      }
      return { type: "heading", raw: Rs(n[0], `
`), depth: n[1].length, text: r, tokens: this.lexer.inline(r) };
    }
  }
  hr(t) {
    let n = this.rules.block.hr.exec(t);
    if (n) return { type: "hr", raw: Rs(n[0], `
`) };
  }
  blockquote(t) {
    let n = this.rules.block.blockquote.exec(t);
    if (n) {
      let r = Rs(n[0], `
`).split(`
`), i = "", a = "", s = [];
      for (; r.length > 0; ) {
        let o = !1, l = [], c;
        for (c = 0; c < r.length; c++) if (this.rules.other.blockquoteStart.test(r[c])) l.push(r[c]), o = !0;
        else if (!o) l.push(r[c]);
        else break;
        r = r.slice(c);
        let f = l.join(`
`), h = f.replace(this.rules.other.blockquoteSetextReplace, `
    $1`).replace(this.rules.other.blockquoteSetextReplace2, "");
        i = i ? `${i}
${f}` : f, a = a ? `${a}
${h}` : h;
        let p = this.lexer.state.top;
        if (this.lexer.state.top = !0, this.lexer.blockTokens(h, s, !0), this.lexer.state.top = p, r.length === 0) break;
        let g = s.at(-1);
        if ((g == null ? void 0 : g.type) === "code" || (g == null ? void 0 : g.type) === "heading" || (g == null ? void 0 : g.type) === "hr" || (g == null ? void 0 : g.type) === "html") break;
        if ((g == null ? void 0 : g.type) === "blockquote") {
          let v = g, y = r.join(`
`), S = v.raw + `
` + y.replace(this.rules.other.blockquoteSetextReplace2, ""), x = this.blockquote(S);
          s[s.length - 1] = x;
          let E = S.substring(x.raw.length).replace(/^\n/, ""), w = E ? E.split(`
`).length : 0, C = w ? r.slice(0, -w) : r;
          C.length > 0 && (i = `${i}
${C.join(`
`)}`), a = a.substring(0, a.length - v.text.length) + x.text;
          break;
        } else if ((g == null ? void 0 : g.type) === "list") {
          let v = g, y = v.raw + `
` + r.join(`
`), S = this.list(y);
          s[s.length - 1] = S, i = i.substring(0, i.length - g.raw.length) + S.raw, a = a.substring(0, a.length - v.raw.length) + S.raw, r = y.substring(s.at(-1).raw.length).split(`
`);
          continue;
        }
      }
      return { type: "blockquote", raw: i, tokens: s, text: a };
    }
  }
  list(t) {
    let n = this.rules.block.list.exec(t);
    if (n) {
      let r = t, i = () => r.length - t.length, a = n[1].trim(), s = a.length > 1, o = { type: "list", raw: "", ordered: s, start: s ? +a.slice(0, -1) : "", loose: !1, items: [] };
      a = s ? `\\d{1,9}\\${a.slice(-1)}` : `\\${a}`, this.options.pedantic && (a = s ? a : "[*+-]");
      let l = this.rules.other.listItemRegex(a), c = !1;
      for (; t; ) {
        let h = !1, p = "";
        if (!(n = l.exec(t)) || this.rules.block.hr.test(t)) break;
        let g = i();
        t = t.substring(n[0].length);
        let v = n[2].split(`
`, 1)[0], y = n[1].length, S = this.options.pedantic ? Ng(v, y) : v.replace(this.rules.other.leadingSpaceTab, (P) => Ng(P, y)), x = t.split(`
`, 1)[0], E = !S.trim(), w = 0;
        if (this.options.pedantic ? (w = 2, p = S.trimStart()) : E ? w = y + 1 : (w = S.search(this.rules.other.nonSpaceChar), w = w > 4 ? 1 : w, p = S.slice(w), w += y), E && this.rules.other.blankLine.test(x) && (t = t.substring(x.length + 1), h = !0), !h) {
          let P = this.rules.other.nextBulletRegex(w), M = this.rules.other.hrRegex(w), T = this.rules.other.fencesBeginRegex(w), N = this.rules.other.headingBeginRegex(w), $ = this.rules.other.htmlBeginRegex(w), ne = this.rules.other.blockquoteBeginRegex(w);
          for (; t; ) {
            let Y = t.split(`
`, 1)[0], te;
            if (x = Y, this.options.pedantic ? (x = x.replace(this.rules.other.listReplaceNesting, "  "), te = x) : te = x.replace(this.rules.other.leadingSpaceTab, (_e) => Ng(_e)), T.test(x) || N.test(x) || $.test(x) || ne.test(x) || P.test(x) || M.test(x)) break;
            if (te.search(this.rules.other.nonSpaceChar) >= w || !x.trim()) p += `
` + te.slice(w);
            else {
              if (E || S.replace(this.rules.other.tabCharGlobal, "    ").search(this.rules.other.nonSpaceChar) >= 4 || T.test(S) || N.test(S) || M.test(S)) break;
              p += `
` + x;
            }
            E = !x.trim(), t = t.substring(Y.length + 1), S = te.slice(w);
          }
        }
        let C = r.slice(g, i());
        o.loose || (c ? o.loose = !0 : this.rules.other.doubleBlankLine.test(C) && (c = !0)), o.items.push({ type: "list_item", raw: C, task: !!this.options.gfm && this.rules.other.listIsTask.test(p), loose: !1, text: p, tokens: [] });
      }
      let f = o.items.at(-1);
      if (f) f.raw = f.raw.trimEnd(), f.text = f.text.trimEnd();
      else return;
      o.raw = r.slice(0, i()).trimEnd();
      for (let h of o.items) if (this.lexer.state.top = !1, h.tokens = this.lexer.blockTokens(h.text, []), !o.loose) {
        let p = h.tokens.filter((v) => v.type === "space"), g = p.length > 0 && p.some((v) => this.rules.other.anyLine.test(v.raw));
        o.loose = g;
      }
      for (let h of o.items) {
        let p = h.tokens[0];
        if (h.task && ((p == null ? void 0 : p.type) === "text" || (p == null ? void 0 : p.type) === "paragraph")) {
          h.text = h.text.replace(this.rules.other.listReplaceTask, ""), p.raw = p.raw.replace(this.rules.other.listReplaceTask, ""), p.text = p.text.replace(this.rules.other.listReplaceTask, "");
          for (let v = this.lexer.inlineQueue.length - 1; v >= 0; v--) if (this.rules.other.listIsTask.test(this.lexer.inlineQueue[v].src)) {
            this.lexer.inlineQueue[v].src = this.lexer.inlineQueue[v].src.replace(this.rules.other.listReplaceTask, "");
            break;
          }
          let g = this.rules.other.listTaskCheckbox.exec(h.raw);
          if (g) {
            let v = { type: "checkbox", raw: g[0] + " ", checked: g[0] !== "[ ]" };
            h.checked = v.checked, o.loose ? h.tokens[0] && ["paragraph", "text"].includes(h.tokens[0].type) && "tokens" in h.tokens[0] && h.tokens[0].tokens ? (h.tokens[0].raw = v.raw + h.tokens[0].raw, h.tokens[0].text = v.raw + h.tokens[0].text, h.tokens[0].tokens.unshift(v)) : h.tokens.unshift({ type: "paragraph", raw: v.raw, text: v.raw, tokens: [v] }) : h.tokens.unshift(v);
          }
        } else h.task && (h.task = !1);
      }
      if (o.loose) for (let h of o.items) {
        h.loose = !0;
        for (let p of h.tokens) p.type === "text" && (p.type = "paragraph");
      }
      return o;
    }
  }
  html(t) {
    let n = this.rules.block.html.exec(t);
    if (n) {
      let r = wS(n[0]);
      return { type: "html", block: !0, raw: r, pre: n[1] === "pre" || n[1] === "script" || n[1] === "style", text: r };
    }
  }
  def(t) {
    let n = this.rules.block.def.exec(t);
    if (n) {
      if (!this.rules.other.startAngleBracket.test(n[2]) && kS(n[2], "()") !== -1) return;
      let r = Fh(n[1]).replace(this.rules.other.multipleSpaceGlobal, " "), i = n[2] ? n[2].replace(this.rules.other.hrefBrackets, "$1").replace(this.rules.inline.anyPunctuation, "$1") : "", a = n[3] ? n[3].substring(1, n[3].length - 1).replace(this.rules.inline.anyPunctuation, "$1") : n[3];
      return { type: "def", tag: r, raw: Rs(n[0], `
`), href: i, title: a };
    }
  }
  table(t) {
    var o;
    let n = this.rules.block.table.exec(t);
    if (!n || !this.rules.other.tableDelimiter.test(n[2])) return;
    let r = xS(n[1]), i = n[2].replace(this.rules.other.tableAlignChars, "").split("|"), a = (o = n[3]) != null && o.trim() ? n[3].replace(this.rules.other.tableRowBlankLine, "").split(`
`) : [], s = { type: "table", raw: Rs(n[0], `
`), header: [], align: [], rows: [] };
    if (r.length === i.length) {
      for (let l of i) this.rules.other.tableAlignRight.test(l) ? s.align.push("right") : this.rules.other.tableAlignCenter.test(l) ? s.align.push("center") : this.rules.other.tableAlignLeft.test(l) ? s.align.push("left") : s.align.push(null);
      for (let l = 0; l < r.length; l++) s.header.push({ text: r[l], tokens: this.lexer.inline(r[l]), header: !0, align: s.align[l] });
      for (let l of a) s.rows.push(xS(l, s.header.length).map((c, f) => ({ text: c, tokens: this.lexer.inline(c), header: !1, align: s.align[f] })));
      return s;
    }
  }
  lheading(t) {
    let n = this.rules.block.lheading.exec(t);
    if (n) {
      let r = n[1].trim();
      return { type: "heading", raw: Rs(n[0], `
`), depth: n[2].charAt(0) === "=" ? 1 : 2, text: r, tokens: this.lexer.inline(r) };
    }
  }
  paragraph(t) {
    let n = this.rules.block.paragraph.exec(t);
    if (n) {
      let r = n[1].charAt(n[1].length - 1) === `
` ? n[1].slice(0, -1) : n[1];
      return { type: "paragraph", raw: n[0], text: r, tokens: this.lexer.inline(r) };
    }
  }
  text(t) {
    let n = this.rules.block.text.exec(t);
    if (n) return { type: "text", raw: n[0], text: n[0], tokens: this.lexer.inline(n[0]) };
  }
  escape(t) {
    let n = this.rules.inline.escape.exec(t);
    if (n) return { type: "escape", raw: n[0], text: n[1] };
  }
  tag(t) {
    let n = this.rules.inline.tag.exec(t);
    if (n) return !this.lexer.state.inLink && this.rules.other.startATag.test(n[0]) ? this.lexer.state.inLink = !0 : this.lexer.state.inLink && this.rules.other.endATag.test(n[0]) && (this.lexer.state.inLink = !1), !this.lexer.state.inRawBlock && this.rules.other.startPreScriptTag.test(n[0]) ? this.lexer.state.inRawBlock = !0 : this.lexer.state.inRawBlock && this.rules.other.endPreScriptTag.test(n[0]) && (this.lexer.state.inRawBlock = !1), { type: "html", raw: n[0], inLink: this.lexer.state.inLink, inRawBlock: this.lexer.state.inRawBlock, block: !1, text: n[0] };
  }
  link(t) {
    if (this.lexer.state.linkParenPossible === !1) return;
    let n = this.rules.inline.link.exec(t);
    if (n) {
      let r = n[0].charAt(0) === "!" ? 2 : 1;
      if (!this.options.pedantic && CS(t, n[1], r, this.rules)) return;
      let i = n[2].trim();
      if (!this.options.pedantic && this.rules.other.startAngleBracket.test(i)) {
        if (!this.rules.other.endAngleBracket.test(i)) return;
        let o = Rs(i.slice(0, -1), "\\");
        if ((i.length - o.length) % 2 === 0) return;
      } else {
        let o = kS(n[2], "()");
        if (o === -2) return;
        if (o > -1) {
          let l = (n[0].indexOf("!") === 0 ? 5 : 4) + n[1].length + o;
          n[2] = n[2].substring(0, o), n[0] = n[0].substring(0, l).trim(), n[3] = "";
        }
      }
      let a = n[2], s = "";
      if (this.options.pedantic) {
        let o = this.rules.other.pedanticHrefTitle.exec(a);
        o && (a = o[1], s = o[3]);
      } else s = n[3] ? n[3].slice(1, -1) : "";
      return a = a.trim(), this.rules.other.startAngleBracket.test(a) && (this.options.pedantic && !this.rules.other.endAngleBracket.test(i) ? a = a.slice(1) : a = a.slice(1, -1)), SS(n, { href: a && a.replace(this.rules.inline.anyPunctuation, "$1"), title: s && s.replace(this.rules.inline.anyPunctuation, "$1") }, n[0], this.lexer, this.rules);
    }
  }
  reflink(t, n) {
    let r;
    if ((r = this.rules.inline.reflink.exec(t)) || (r = this.rules.inline.nolink.exec(t))) {
      let i = r[0].charAt(0) === "!" ? 2 : 1;
      if (!this.options.pedantic && CS(t, r[1], i, this.rules)) return;
      let a = (r[2] || r[1]).replace(this.rules.other.multipleSpaceGlobal, " "), s = n[Fh(a)];
      if (!s) {
        let o = r[0].charAt(0);
        return { type: "text", raw: o, text: o };
      }
      return SS(r, s, r[0], this.lexer, this.rules);
    }
  }
  emStrong(t, n, r = "") {
    let i = this.rules.inline.emStrongLDelim.exec(t);
    if (!(!i || !i[1] && !i[2] && !i[3] && !i[4] || i[4] && r.match(this.rules.other.unicodeAlphaNumeric)) && (!(i[1] || i[3]) || !r || this.rules.inline.punctuation.exec(r))) {
      let a = [...i[0]].length - 1, s, o, l = a, c = 0, f = i[0][0], h = r === f, p = f === "*" ? this.rules.inline.emStrongRDelimAst : this.rules.inline.emStrongRDelimUnd;
      for (p.lastIndex = 0, n = n.slice(-1 * t.length + a); (i = p.exec(n)) !== null; ) {
        if (s = i[1] || i[2] || i[3] || i[4] || i[5] || i[6], !s) continue;
        if (o = [...s].length, i[3] || i[4]) {
          l += o;
          continue;
        } else if (i[5] || i[6]) {
          if (a % 3 && !((a + o) % 3)) {
            c += o;
            continue;
          }
          if (h) break;
        }
        if (l -= o, l > 0) continue;
        o = Math.min(o, o + l + c);
        let g = [...i[0]][0].length, v = t.slice(0, a + i.index + g + o);
        if (Math.min(a, o) % 2) {
          let S = v.slice(1, -1);
          return { type: "em", raw: v, text: S, tokens: this.lexer.inlineTokens(S) };
        }
        let y = v.slice(2, -2);
        return { type: "strong", raw: v, text: y, tokens: this.lexer.inlineTokens(y) };
      }
    }
  }
  codespan(t) {
    let n = this.rules.inline.code.exec(t);
    if (n) {
      let r = n[2].replace(this.rules.other.newLineCharGlobal, " "), i = this.rules.other.nonSpaceChar.test(r), a = this.rules.other.startingSpaceChar.test(r) && this.rules.other.endingSpaceChar.test(r);
      return i && a && (r = r.substring(1, r.length - 1)), { type: "codespan", raw: n[0], text: r };
    }
  }
  br(t) {
    let n = this.rules.inline.br.exec(t);
    if (n) return { type: "br", raw: n[0] };
  }
  del(t, n, r = "") {
    let i = this.rules.inline.delLDelim.exec(t);
    if (i && (!i[1] || !r || this.rules.inline.punctuation.exec(r))) {
      let a = [...i[0]].length - 1, s, o, l = a, c = this.rules.inline.delRDelim;
      for (c.lastIndex = 0, n = n.slice(-1 * t.length + a); (i = c.exec(n)) !== null; ) {
        if (s = i[1] || i[2] || i[3] || i[4] || i[5] || i[6], !s || (o = [...s].length, o !== a)) continue;
        if (i[3] || i[4]) {
          l += o;
          continue;
        }
        if (l -= o, l > 0) continue;
        o = Math.min(o, o + l);
        let f = [...i[0]][0].length, h = t.slice(0, a + i.index + f + o), p = h.slice(a, -a);
        return { type: "del", raw: h, text: p, tokens: this.lexer.inlineTokens(p) };
      }
    }
  }
  autolink(t) {
    let n = this.rules.inline.autolink.exec(t);
    if (n) {
      let r, i;
      return n[2] === "@" ? (r = n[1], i = "mailto:" + r) : (r = n[1], i = r), { type: "link", raw: n[0], text: r, href: i, autolink: !0, tokens: [{ type: "text", raw: r, text: r }] };
    }
  }
  url(t) {
    var r;
    let n;
    if (n = this.rules.inline.url.exec(t)) {
      let i, a;
      if (n[2] === "@") i = n[0], a = "mailto:" + i;
      else {
        let s;
        do
          s = n[0], n[0] = ((r = this.rules.inline._backpedal.exec(n[0])) == null ? void 0 : r[0]) ?? "";
        while (s !== n[0]);
        i = n[0], n[1] === "www." ? a = "http://" + n[0] : a = n[0];
      }
      return { type: "link", raw: n[0], text: i, href: a, autolink: !0, tokens: [{ type: "text", raw: i, text: i }] };
    }
  }
  inlineText(t) {
    let n = this.rules.inline.text.exec(t);
    if (n) {
      let r = this.lexer.state.inRawBlock;
      return { type: "text", raw: n[0], text: r ? n[0] : C9(n[0]), escaped: r };
    }
  }
}, tp, QO, zo, sa = (zo = class {
  constructor(t) {
    Gw(this, tp);
    Qt(this, "tokens");
    Qt(this, "options");
    Qt(this, "state");
    Qt(this, "inlineQueue");
    Qt(this, "tokenizer");
    this.tokens = [], this.tokens.links = /* @__PURE__ */ Object.create(null), this.options = t || al, this.options.tokenizer = this.options.tokenizer || new Nh(), this.tokenizer = this.options.tokenizer, this.tokenizer.options = this.options, this.tokenizer.lexer = this, this.inlineQueue = [], this.state = { inLink: !1, inRawBlock: !1, linkEmitted: !1, linkParenPossible: !0, top: !0 };
    let n = { other: mr, block: Nf.normal, inline: tc.normal };
    this.options.pedantic ? (n.block = Nf.pedantic, n.inline = tc.pedantic) : this.options.gfm && (n.block = Nf.gfm, this.options.breaks ? n.inline = tc.breaks : n.inline = tc.gfm), this.tokenizer.rules = n;
  }
  static get rules() {
    return { block: Nf, inline: tc };
  }
  static lex(t, n) {
    return new zo(n).lex(t);
  }
  static lexInline(t, n) {
    return new zo(n).inlineTokens(t);
  }
  lex(t) {
    t = t.replace(mr.carriageReturn, `
`), this.blockTokens(t, this.tokens);
    for (let n = 0; n < this.inlineQueue.length; n++) {
      let r = this.inlineQueue[n];
      this.inlineTokens(r.src, r.tokens);
    }
    return this.inlineQueue = [], this.tokens;
  }
  blockTokens(t, n = [], r = !1) {
    var a, s, o;
    this.tokenizer.lexer = this, this.options.pedantic && (t = t.replace(mr.tabCharGlobal, "    ").replace(mr.spaceLine, ""));
    let i = 1 / 0;
    for (; t; ) {
      if (t.length < i) i = t.length;
      else {
        this.infiniteLoopError(t.charCodeAt(0));
        break;
      }
      let l;
      if ((s = (a = this.options.extensions) == null ? void 0 : a.block) != null && s.some((f) => (l = f.call({ lexer: this }, t, n)) ? (t = t.substring(l.raw.length), n.push(l), !0) : !1)) continue;
      if (l = this.tokenizer.space(t)) {
        t = t.substring(l.raw.length);
        let f = n.at(-1);
        l.raw.length === 1 && f !== void 0 ? f.raw += `
` : n.push(l);
        continue;
      }
      if (l = this.tokenizer.code(t)) {
        t = t.substring(l.raw.length);
        let f = n.at(-1);
        (f == null ? void 0 : f.type) === "paragraph" || (f == null ? void 0 : f.type) === "text" ? (f.raw += (f.raw.endsWith(`
`) ? "" : `
`) + l.raw, f.text += `
` + l.text, this.inlineQueue.at(-1).src = f.text) : n.push(l);
        continue;
      }
      if (l = this.tokenizer.fences(t)) {
        t = t.substring(l.raw.length), n.push(l);
        continue;
      }
      if (l = this.tokenizer.heading(t)) {
        t = t.substring(l.raw.length), n.push(l);
        continue;
      }
      if (l = this.tokenizer.hr(t)) {
        t = t.substring(l.raw.length), n.push(l);
        continue;
      }
      if (l = this.tokenizer.blockquote(t)) {
        t = t.substring(l.raw.length), n.push(l);
        continue;
      }
      if (l = this.tokenizer.list(t)) {
        t = t.substring(l.raw.length), n.push(l);
        continue;
      }
      if (l = this.tokenizer.html(t)) {
        t = t.substring(l.raw.length), n.push(l);
        continue;
      }
      if (l = this.tokenizer.def(t)) {
        t = t.substring(l.raw.length);
        let f = n.at(-1);
        (f == null ? void 0 : f.type) === "paragraph" || (f == null ? void 0 : f.type) === "text" ? (f.raw += (f.raw.endsWith(`
`) ? "" : `
`) + l.raw, f.text += `
` + l.raw, this.inlineQueue.at(-1).src = f.text) : this.tokens.links[l.tag] || (this.tokens.links[l.tag] = { href: l.href, title: l.title }, n.push(l));
        continue;
      }
      if (l = this.tokenizer.table(t)) {
        t = t.substring(l.raw.length), n.push(l);
        continue;
      }
      if (l = this.tokenizer.lheading(t)) {
        t = t.substring(l.raw.length), n.push(l);
        continue;
      }
      let c = t;
      if ((o = this.options.extensions) != null && o.startBlock) {
        let f = 1 / 0, h = t.slice(1), p;
        this.options.extensions.startBlock.forEach((g) => {
          p = g.call({ lexer: this }, h), typeof p == "number" && p >= 0 && (f = Math.min(f, p));
        }), f < 1 / 0 && f >= 0 && (c = t.substring(0, f + 1));
      }
      if (this.state.top && (l = this.tokenizer.paragraph(c))) {
        let f = n.at(-1);
        r && (f == null ? void 0 : f.type) === "paragraph" ? (f.raw += (f.raw.endsWith(`
`) ? "" : `
`) + l.raw, f.text += `
` + l.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = f.text) : n.push(l), r = c.length !== t.length, t = t.substring(l.raw.length);
        continue;
      }
      if (l = this.tokenizer.text(t)) {
        t = t.substring(l.raw.length);
        let f = n.at(-1);
        (f == null ? void 0 : f.type) === "text" ? (f.raw += (f.raw.endsWith(`
`) ? "" : `
`) + l.raw, f.text += `
` + l.text, this.inlineQueue.pop(), this.inlineQueue.at(-1).src = f.text) : n.push(l);
        continue;
      }
      if (t) {
        this.infiniteLoopError(t.charCodeAt(0));
        break;
      }
    }
    return this.state.top = !0, n;
  }
  inline(t, n = []) {
    return this.inlineQueue.push({ src: t, tokens: n }), n;
  }
  linkInText(t) {
    if (!t.includes("[")) return !1;
    let n = this.tokenizer.rules.inline.link;
    for (let r of t.matchAll(this.tokenizer.rules.inline.blockSkip)) if (n.test(r[0]) && t.charAt(r.index - 1) !== "!") return !0;
    for (let r of t.matchAll(this.tokenizer.rules.inline.reflinkSearch)) {
      let i = r[0], a = i.lastIndexOf("[");
      if (!(i.charAt(0) === "!" || !Object.hasOwn(this.tokens.links, Fh(i.slice(a + 1, -1)))) && !(a > 1 && this.linkInText(i.slice(1, a - 1)))) return !0;
    }
    return !1;
  }
  inlineTokens(t, n = []) {
    this.tokenizer.lexer = this;
    let r = this.state.linkParenPossible;
    this.state.linkParenPossible = r && t.includes(")");
    try {
      return Yw(this, tp, QO).call(this, t, n);
    } finally {
      this.state.linkParenPossible = r;
    }
  }
  infiniteLoopError(t) {
    let n = "Infinite loop on byte: " + t;
    if (this.options.silent) console.error(n);
    else throw new Error(n);
  }
}, tp = new WeakSet(), QO = function(t, n) {
  var o, l, c, f, h;
  let r = t;
  if (this.tokens.links && t.includes("[")) {
    let p = this.tokenizer.rules.inline.reflinkSearch, g = (v) => {
      let y = v.lastIndexOf("[");
      if (!Object.hasOwn(this.tokens.links, Fh(v.slice(y + 1, -1)))) return v;
      if (y > 1 && v.charAt(0) !== "!") {
        let S = v.slice(1, y - 1);
        if (this.linkInText(S)) return "[" + S.replace(p, g) + "][" + "a".repeat(v.length - y - 2) + "]";
      }
      return "[" + "a".repeat(v.length - 2) + "]";
    };
    r = r.replace(p, g);
  }
  r = r.replace(this.tokenizer.rules.inline.anyPunctuationOutsideCode, (p, g, v) => v ? "+".repeat(p.length) : g ? g + p.slice(g.length, -g.length).replace(/`/g, "+") + g : p), r = r.replace(this.tokenizer.rules.inline.blockSkip, (p, g, v) => {
    let y = v ? v.length : 0;
    return p.slice(0, y) + "[" + "a".repeat(p.length - y - 2) + "]";
  }), r = ((l = (o = this.options.hooks) == null ? void 0 : o.emStrongMask) == null ? void 0 : l.call({ lexer: this }, r)) ?? r;
  let i = !1, a = "", s = 1 / 0;
  for (; t; ) {
    if (t.length < s) s = t.length;
    else {
      this.infiniteLoopError(t.charCodeAt(0));
      break;
    }
    i || (a = ""), i = !1;
    let p;
    if ((f = (c = this.options.extensions) == null ? void 0 : c.inline) != null && f.some((v) => (p = v.call({ lexer: this }, t, n)) ? (t = t.substring(p.raw.length), n.push(p), !0) : !1)) continue;
    if (p = this.tokenizer.escape(t)) {
      t = t.substring(p.raw.length), n.push(p);
      continue;
    }
    if (p = this.tokenizer.tag(t)) {
      t = t.substring(p.raw.length), n.push(p);
      continue;
    }
    if (p = this.tokenizer.link(t)) {
      t = t.substring(p.raw.length), n.push(p);
      continue;
    }
    if (p = this.tokenizer.reflink(t, this.tokens.links)) {
      t = t.substring(p.raw.length);
      let v = n.at(-1);
      p.type === "text" && (v == null ? void 0 : v.type) === "text" ? (v.raw += p.raw, v.text += p.text) : n.push(p);
      continue;
    }
    if (p = this.tokenizer.emStrong(t, r, a)) {
      t = t.substring(p.raw.length), n.push(p);
      continue;
    }
    if (p = this.tokenizer.codespan(t)) {
      t = t.substring(p.raw.length), n.push(p);
      continue;
    }
    if (p = this.tokenizer.br(t)) {
      t = t.substring(p.raw.length), n.push(p);
      continue;
    }
    if (p = this.tokenizer.del(t, r, a)) {
      t = t.substring(p.raw.length), n.push(p);
      continue;
    }
    if (p = this.tokenizer.autolink(t)) {
      t = t.substring(p.raw.length), n.push(p);
      continue;
    }
    if (!this.state.inLink && (p = this.tokenizer.url(t))) {
      t = t.substring(p.raw.length), n.push(p);
      continue;
    }
    let g = t;
    if ((h = this.options.extensions) != null && h.startInline) {
      let v = 1 / 0, y = t.slice(1), S;
      this.options.extensions.startInline.forEach((x) => {
        S = x.call({ lexer: this }, y), typeof S == "number" && S >= 0 && (v = Math.min(v, S));
      }), v < 1 / 0 && v >= 0 && (g = t.substring(0, v + 1));
    }
    if (p = this.tokenizer.inlineText(g)) {
      t = t.substring(p.raw.length), p.raw.slice(-1) !== "_" && (a = p.raw.slice(-1)), i = !0;
      let v = n.at(-1);
      (v == null ? void 0 : v.type) === "text" ? (v.raw += p.raw, v.text += p.text) : n.push(p);
      continue;
    }
    if (t) {
      this.infiniteLoopError(t.charCodeAt(0));
      break;
    }
  }
  return n;
}, zo), Lh = class {
  constructor(e) {
    Qt(this, "options");
    Qt(this, "parser");
    this.options = e || al;
  }
  space(e) {
    return "";
  }
  code({ text: e, lang: t, escaped: n }) {
    var a;
    let r = (a = (t || "").match(mr.notSpaceStart)) == null ? void 0 : a[0], i = e ? e.replace(mr.endingNewline, "") + `
` : "";
    return r ? '<pre><code class="language-' + vi(r) + '">' + (n ? i : vi(i, !0)) + `</code></pre>
` : "<pre><code>" + (n ? i : vi(i, !0)) + `</code></pre>
`;
  }
  blockquote({ tokens: e }) {
    return `<blockquote>
${this.parser.parse(e)}</blockquote>
`;
  }
  html({ text: e }) {
    return e;
  }
  def(e) {
    return "";
  }
  heading({ tokens: e, depth: t }) {
    return `<h${t}>${this.parser.parseInline(e)}</h${t}>
`;
  }
  hr(e) {
    return `<hr>
`;
  }
  list(e) {
    let t = e.ordered, n = e.start, r = "";
    for (let s = 0; s < e.items.length; s++) {
      let o = e.items[s];
      r += this.listitem(o);
    }
    let i = t ? "ol" : "ul", a = t && n !== 1 ? ' start="' + n + '"' : "";
    return "<" + i + a + `>
` + r + "</" + i + `>
`;
  }
  listitem(e) {
    return `<li>${this.parser.parse(e.tokens)}</li>
`;
  }
  checkbox({ checked: e }) {
    return "<input " + (e ? 'checked="" ' : "") + 'disabled="" type="checkbox"> ';
  }
  paragraph({ tokens: e }) {
    return `<p>${this.parser.parseInline(e)}</p>
`;
  }
  table(e) {
    let t = "", n = "";
    for (let i = 0; i < e.header.length; i++) n += this.tablecell(e.header[i]);
    t += this.tablerow({ text: n });
    let r = "";
    for (let i = 0; i < e.rows.length; i++) {
      let a = e.rows[i];
      n = "";
      for (let s = 0; s < a.length; s++) n += this.tablecell(a[s]);
      r += this.tablerow({ text: n });
    }
    return r && (r = `<tbody>${r}</tbody>`), `<table>
<thead>
` + t + `</thead>
` + r + `</table>
`;
  }
  tablerow({ text: e }) {
    return `<tr>
${e}</tr>
`;
  }
  tablecell(e) {
    let t = this.parser.parseInline(e.tokens), n = e.header ? "th" : "td";
    return (e.align ? `<${n} align="${e.align}">` : `<${n}>`) + t + `</${n}>
`;
  }
  strong({ tokens: e }) {
    return `<strong>${this.parser.parseInline(e)}</strong>`;
  }
  em({ tokens: e }) {
    return `<em>${this.parser.parseInline(e)}</em>`;
  }
  codespan({ text: e }) {
    return `<code>${vi(e, !0)}</code>`;
  }
  br(e) {
    return "<br>";
  }
  del({ tokens: e }) {
    return `<del>${this.parser.parseInline(e)}</del>`;
  }
  link({ href: e, title: t, text: n, tokens: r, autolink: i }) {
    let a = i ? vi(n, !0) : this.parser.parseInline(r), s = yS(e);
    if (s === null) return a;
    e = vi(s, i);
    let o = '<a href="' + e + '"';
    return t && (o += ' title="' + vi(t) + '"'), o += ">" + a + "</a>", o;
  }
  image({ href: e, title: t, text: n, tokens: r }) {
    r && (n = this.parser.parseInline(r, this.parser.textRenderer));
    let i = yS(e);
    if (i === null) return vi(n);
    e = i;
    let a = `<img src="${vi(e)}" alt="${vi(n)}"`;
    return t && (a += ` title="${vi(t)}"`), a += ">", a;
  }
  text(e) {
    return "tokens" in e && e.tokens ? this.parser.parseInline(e.tokens) : "escaped" in e && e.escaped ? e.text : vi(e.text);
  }
}, U0 = class {
  strong({ text: e }) {
    return e;
  }
  em({ text: e }) {
    return e;
  }
  codespan({ text: e }) {
    return e;
  }
  del({ text: e }) {
    return e;
  }
  html({ text: e }) {
    return e;
  }
  text({ text: e }) {
    return e;
  }
  link({ text: e }) {
    return "" + e;
  }
  image({ text: e }) {
    return "" + e;
  }
  br() {
    return "";
  }
  checkbox({ raw: e }) {
    return e;
  }
}, oa = class xy {
  constructor(t) {
    Qt(this, "options");
    Qt(this, "renderer");
    Qt(this, "textRenderer");
    this.options = t || al, this.options.renderer = this.options.renderer || new Lh(), this.renderer = this.options.renderer, this.renderer.options = this.options, this.renderer.parser = this, this.textRenderer = new U0();
  }
  static parse(t, n) {
    return new xy(n).parse(t);
  }
  static parseInline(t, n) {
    return new xy(n).parseInline(t);
  }
  parse(t) {
    var r, i;
    this.renderer.parser = this;
    let n = "";
    for (let a = 0; a < t.length; a++) {
      let s = t[a];
      if ((i = (r = this.options.extensions) == null ? void 0 : r.renderers) != null && i[s.type]) {
        let l = s, c = this.options.extensions.renderers[l.type].call({ parser: this }, l);
        if (c !== !1 || !["space", "hr", "heading", "code", "table", "blockquote", "list", "checkbox", "html", "def", "paragraph", "text"].includes(l.type)) {
          n += c || "";
          continue;
        }
      }
      let o = s;
      switch (o.type) {
        case "space": {
          n += this.renderer.space(o);
          break;
        }
        case "hr": {
          n += this.renderer.hr(o);
          break;
        }
        case "heading": {
          n += this.renderer.heading(o);
          break;
        }
        case "code": {
          n += this.renderer.code(o);
          break;
        }
        case "table": {
          n += this.renderer.table(o);
          break;
        }
        case "blockquote": {
          n += this.renderer.blockquote(o);
          break;
        }
        case "list": {
          n += this.renderer.list(o);
          break;
        }
        case "checkbox": {
          n += this.renderer.checkbox(o);
          break;
        }
        case "html": {
          n += this.renderer.html(o);
          break;
        }
        case "def": {
          n += this.renderer.def(o);
          break;
        }
        case "paragraph": {
          n += this.renderer.paragraph(o);
          break;
        }
        case "text": {
          n += this.renderer.text(o);
          break;
        }
        default: {
          let l = 'Token with "' + o.type + '" type was not found.';
          if (this.options.silent) return console.error(l), "";
          throw new Error(l);
        }
      }
    }
    return n;
  }
  parseInline(t, n = this.renderer) {
    var i, a;
    this.renderer.parser = this;
    let r = "";
    for (let s = 0; s < t.length; s++) {
      let o = t[s];
      if ((a = (i = this.options.extensions) == null ? void 0 : i.renderers) != null && a[o.type]) {
        let c = this.options.extensions.renderers[o.type].call({ parser: this }, o);
        if (c !== !1 || !["escape", "html", "link", "image", "checkbox", "strong", "em", "codespan", "br", "del", "text"].includes(o.type)) {
          r += c || "";
          continue;
        }
      }
      let l = o;
      switch (l.type) {
        case "escape": {
          r += n.text(l);
          break;
        }
        case "html": {
          r += n.html(l);
          break;
        }
        case "link": {
          r += n.link(l);
          break;
        }
        case "image": {
          r += n.image(l);
          break;
        }
        case "checkbox": {
          r += n.checkbox(l);
          break;
        }
        case "strong": {
          r += n.strong(l);
          break;
        }
        case "em": {
          r += n.em(l);
          break;
        }
        case "codespan": {
          r += n.codespan(l);
          break;
        }
        case "br": {
          r += n.br(l);
          break;
        }
        case "del": {
          r += n.del(l);
          break;
        }
        case "text": {
          r += n.text(l);
          break;
        }
        default: {
          let c = 'Token with "' + l.type + '" type was not found.';
          if (this.options.silent) return console.error(c), "";
          throw new Error(c);
        }
      }
    }
    return r;
  }
}, lh, gc = (lh = class {
  constructor(e) {
    Qt(this, "options");
    Qt(this, "block");
    this.options = e || al;
  }
  preprocess(e) {
    return e;
  }
  postprocess(e) {
    return e;
  }
  processAllTokens(e) {
    return e;
  }
  emStrongMask(e) {
    return e;
  }
  provideLexer(e = this.block) {
    return e ? sa.lex : sa.lexInline;
  }
  provideParser(e = this.block) {
    return e ? oa.parse : oa.parseInline;
  }
}, Qt(lh, "passThroughHooks", /* @__PURE__ */ new Set(["preprocess", "postprocess", "processAllTokens", "emStrongMask"])), Qt(lh, "passThroughHooksRespectAsync", /* @__PURE__ */ new Set(["preprocess", "postprocess", "processAllTokens"])), lh);
function Do(e, t) {
  if (Array.isArray(t)) for (let n = 0; n < t.length; n++) e.push(t[n]);
  else e.push(t);
}
var A9 = class {
  constructor(...e) {
    Qt(this, "defaults", R0());
    Qt(this, "options", this.setOptions);
    Qt(this, "parse", this.parseMarkdown(!0));
    Qt(this, "parseInline", this.parseMarkdown(!1));
    Qt(this, "Parser", oa);
    Qt(this, "Renderer", Lh);
    Qt(this, "TextRenderer", U0);
    Qt(this, "Lexer", sa);
    Qt(this, "Tokenizer", Nh);
    Qt(this, "Hooks", gc);
    this.use(...e);
  }
  walkTokens(e, t) {
    var r, i;
    let n = [];
    for (let a of e) switch (Do(n, t.call(this, a)), a.type) {
      case "table": {
        let s = a;
        for (let o of s.header) Do(n, this.walkTokens(o.tokens, t));
        for (let o of s.rows) for (let l of o) Do(n, this.walkTokens(l.tokens, t));
        break;
      }
      case "list": {
        let s = a;
        Do(n, this.walkTokens(s.items, t));
        break;
      }
      default: {
        let s = a;
        (i = (r = this.defaults.extensions) == null ? void 0 : r.childTokens) != null && i[s.type] ? this.defaults.extensions.childTokens[s.type].forEach((o) => {
          let l = s[o].flat(1 / 0);
          Do(n, this.walkTokens(l, t));
        }) : s.tokens && Do(n, this.walkTokens(s.tokens, t));
      }
    }
    return n;
  }
  use(...e) {
    let t = this.defaults.extensions || { renderers: {}, childTokens: {} };
    return e.forEach((n) => {
      let r = { ...n };
      if (r.async = this.defaults.async || r.async || !1, n.extensions && (n.extensions.forEach((i) => {
        if (!i.name) throw new Error("extension name required");
        if ("renderer" in i) {
          let a = t.renderers[i.name];
          a ? t.renderers[i.name] = function(...s) {
            let o = i.renderer.apply(this, s);
            return o === !1 && (o = a.apply(this, s)), o;
          } : t.renderers[i.name] = i.renderer;
        }
        if ("tokenizer" in i) {
          if (!i.level || i.level !== "block" && i.level !== "inline") throw new Error("extension level must be 'block' or 'inline'");
          let a = t[i.level];
          a ? a.unshift(i.tokenizer) : t[i.level] = [i.tokenizer], i.start && (i.level === "block" ? t.startBlock ? t.startBlock.push(i.start) : t.startBlock = [i.start] : i.level === "inline" && (t.startInline ? t.startInline.push(i.start) : t.startInline = [i.start]));
        }
        "childTokens" in i && i.childTokens && (t.childTokens[i.name] = i.childTokens);
      }), r.extensions = t), n.renderer) {
        let i = this.defaults.renderer || new Lh(this.defaults);
        for (let a in n.renderer) {
          if (!(a in i)) throw new Error(`renderer '${a}' does not exist`);
          if (["options", "parser"].includes(a)) continue;
          let s = a, o = n.renderer[s], l = i[s];
          i[s] = (...c) => {
            let f = o.apply(i, c);
            return f === !1 && (f = l.apply(i, c)), f || "";
          };
        }
        r.renderer = i;
      }
      if (n.tokenizer) {
        let i = this.defaults.tokenizer || new Nh(this.defaults);
        for (let a in n.tokenizer) {
          if (!(a in i)) throw new Error(`tokenizer '${a}' does not exist`);
          if (["options", "rules", "lexer"].includes(a)) continue;
          let s = a, o = n.tokenizer[s], l = i[s];
          i[s] = (...c) => {
            let f = o.apply(i, c);
            return f === !1 && (f = l.apply(i, c)), f;
          };
        }
        r.tokenizer = i;
      }
      if (n.hooks) {
        let i = this.defaults.hooks || new gc();
        for (let a in n.hooks) {
          if (!(a in i)) throw new Error(`hook '${a}' does not exist`);
          if (["options", "block"].includes(a)) continue;
          let s = a, o = n.hooks[s], l = i[s];
          gc.passThroughHooks.has(a) ? i[s] = (c) => {
            if (this.defaults.async && gc.passThroughHooksRespectAsync.has(a)) return (async () => {
              let h = await o.call(i, c);
              return l.call(i, h);
            })();
            let f = o.call(i, c);
            return l.call(i, f);
          } : i[s] = (...c) => {
            if (this.defaults.async) return (async () => {
              let h = await o.apply(i, c);
              return h === !1 && (h = await l.apply(i, c)), h;
            })();
            let f = o.apply(i, c);
            return f === !1 && (f = l.apply(i, c)), f;
          };
        }
        r.hooks = i;
      }
      if (n.walkTokens) {
        let i = this.defaults.walkTokens, a = n.walkTokens;
        r.walkTokens = function(s) {
          let o = [];
          return o.push(a.call(this, s)), i && Do(o, i.call(this, s)), o;
        };
      }
      this.defaults = { ...this.defaults, ...r };
    }), this;
  }
  setOptions(e) {
    return this.defaults = { ...this.defaults, ...e }, this;
  }
  lexer(e, t) {
    return sa.lex(e, t ?? this.defaults);
  }
  parser(e, t) {
    return oa.parse(e, t ?? this.defaults);
  }
  parseMarkdown(e) {
    return (t, n) => {
      let r = { ...n }, i = { ...this.defaults, ...r }, a = this.onError(!!i.silent, !!i.async);
      if (this.defaults.async === !0 && r.async === !1) return a(new Error("marked(): The async option was set to true by an extension. Remove async: false from the parse options object to return a Promise."));
      if (typeof t > "u" || t === null) return a(new Error("marked(): input parameter is undefined or null"));
      if (typeof t != "string") return a(new Error("marked(): input parameter is of type " + Object.prototype.toString.call(t) + ", string expected"));
      if (i.hooks && (i.hooks.options = i, i.hooks.block = e), i.async) return (async () => {
        let s = i.hooks ? await i.hooks.preprocess(t) : t, o = await (i.hooks ? await i.hooks.provideLexer(e) : e ? sa.lex : sa.lexInline)(s, i), l = i.hooks ? await i.hooks.processAllTokens(o) : o;
        i.walkTokens && await Promise.all(this.walkTokens(l, i.walkTokens));
        let c = await (i.hooks ? await i.hooks.provideParser(e) : e ? oa.parse : oa.parseInline)(l, i);
        return i.hooks ? await i.hooks.postprocess(c) : c;
      })().catch(a);
      try {
        i.hooks && (t = i.hooks.preprocess(t));
        let s = (i.hooks ? i.hooks.provideLexer(e) : e ? sa.lex : sa.lexInline)(t, i);
        i.hooks && (s = i.hooks.processAllTokens(s)), i.walkTokens && this.walkTokens(s, i.walkTokens);
        let o = (i.hooks ? i.hooks.provideParser(e) : e ? oa.parse : oa.parseInline)(s, i);
        return i.hooks && (o = i.hooks.postprocess(o)), o;
      } catch (s) {
        return a(s);
      }
    };
  }
  onError(e, t) {
    return (n) => {
      if (n.message += `
Please report this to https://github.com/markedjs/marked.`, e) {
        let r = "<p>An error occurred:</p><pre>" + vi(n.message + "", !0) + "</pre>";
        return t ? Promise.resolve(r) : r;
      }
      if (t) return Promise.reject(n);
      throw n;
    };
  }
}, Xo = new A9();
function Jt(e, t) {
  return Xo.parse(e, t);
}
Jt.options = Jt.setOptions = function(e) {
  return Xo.setOptions(e), Jt.defaults = Xo.defaults, jO(Jt.defaults), Jt;
};
Jt.getDefaults = R0;
Jt.defaults = al;
function D9(...e) {
  return Xo.use(...e), Jt.defaults = Xo.defaults, jO(Jt.defaults), Jt;
}
Jt.use = D9;
Jt.walkTokens = function(e, t) {
  return Xo.walkTokens(e, t);
};
Jt.parseInline = Xo.parseInline;
Jt.Parser = oa;
Jt.parser = oa.parse;
Jt.Renderer = Lh;
Jt.TextRenderer = U0;
Jt.Lexer = sa;
Jt.lexer = sa.lex;
Jt.Tokenizer = Nh;
Jt.Hooks = gc;
Jt.parse = Jt;
Jt.options;
Jt.setOptions;
Jt.walkTokens;
Jt.parseInline;
oa.parse;
sa.lex;
/*! @license DOMPurify 3.4.17 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.4.17/LICENSE */
function TS(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
  return r;
}
function E9(e) {
  if (Array.isArray(e)) return e;
}
function P9(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r, i, a, s, o = [], l = !0, c = !1;
    try {
      if (a = (n = n.call(e)).next, t !== 0) for (; !(l = (r = a.call(n)).done) && (o.push(r.value), o.length !== t); l = !0) ;
    } catch (f) {
      c = !0, i = f;
    } finally {
      try {
        if (!l && n.return != null && (s = n.return(), Object(s) !== s)) return;
      } finally {
        if (c) throw i;
      }
    }
    return o;
  }
}
function O9() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
/*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
function M9(e, t) {
  return E9(e) || P9(e, t) || I9(e, t) || O9();
}
function I9(e, t) {
  if (e) {
    if (typeof e == "string") return TS(e, t);
    var n = {}.toString.call(e).slice(8, -1);
    return n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set" ? Array.from(e) : n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? TS(e, t) : void 0;
  }
}
const JO = Object.entries, AS = Object.setPrototypeOf, R9 = Object.isFrozen, eM = Object.getPrototypeOf, tM = Object.getOwnPropertyDescriptor;
let gr = Object.freeze, Tr = Object.seal, zl = Object.create, nM = typeof Reflect < "u" && Reflect, wy = nM.apply, ky = nM.construct;
gr || (gr = function(t) {
  return t;
});
Tr || (Tr = function(t) {
  return t;
});
wy || (wy = function(t, n) {
  for (var r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), a = 2; a < r; a++) i[a - 2] = arguments[a];
  return t.apply(n, i);
});
ky || (ky = function(t) {
  for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) r[i - 1] = arguments[i];
  return new t(...r);
});
const Ga = wn(Array.prototype.forEach), F9 = wn(Array.prototype.lastIndexOf), DS = wn(Array.prototype.pop), nc = wn(Array.prototype.push), N9 = wn(Array.prototype.slice), L9 = wn(Array.prototype.splice), Yl = Array.isArray, Lg = rM(Set), $g = wn(Set.prototype.add), rc = wn(Set.prototype.has), Mo = wn(String.prototype.toLowerCase), Vg = wn(String.prototype.toString), ES = wn(String.prototype.match), ic = wn(String.prototype.replace), PS = wn(String.prototype.indexOf), $9 = wn(String.prototype.trim), V9 = wn(Number.prototype.toString), B9 = wn(Boolean.prototype.toString), OS = typeof BigInt > "u" ? null : wn(BigInt.prototype.toString), MS = typeof Symbol > "u" ? null : wn(Symbol.prototype.toString), ai = wn(Object.prototype.hasOwnProperty), ac = wn(Object.prototype.toString), kr = wn(RegExp.prototype.test), Ya = rM(TypeError);
function wn(e) {
  return function(t) {
    t instanceof RegExp && (t.lastIndex = 0);
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++) r[i - 1] = arguments[i];
    return wy(e, t, r);
  };
}
function rM(e) {
  return function() {
    for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
    return ky(e, n);
  };
}
function Bt(e, t) {
  let n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Mo;
  if (AS && AS(e, null), !Yl(t)) return e;
  let r = t.length;
  for (; r--; ) {
    let i = t[r];
    if (typeof i == "string") {
      const a = n(i);
      a !== i && (R9(t) || (t[r] = a), i = a);
    }
    e[i] = !0;
  }
  return e;
}
function U9(e) {
  for (let t = 0; t < e.length; t++) ai(e, t) || (e[t] = null);
  return e;
}
function bi(e) {
  const t = zl(null);
  for (const r of JO(e)) {
    var n = M9(r, 2);
    const i = n[0], a = n[1];
    ai(e, i) && (Yl(a) ? t[i] = U9(a) : a && typeof a == "object" && a.constructor === Object ? t[i] = bi(a) : t[i] = a);
  }
  return t;
}
function q9(e) {
  switch (typeof e) {
    case "string":
      return e;
    case "number":
      return V9(e);
    case "boolean":
      return B9(e);
    case "bigint":
      return OS ? OS(e) : "0";
    case "symbol":
      return MS ? MS(e) : "Symbol()";
    case "undefined":
      return ac(e);
    case "function":
    case "object": {
      if (e === null) return ac(e);
      const t = e, n = Li(t, "toString");
      if (typeof n == "function") {
        const r = n(t);
        return typeof r == "string" ? r : ac(r);
      }
      return ac(e);
    }
    default:
      return ac(e);
  }
}
function Li(e, t) {
  for (; e !== null; ) {
    const r = tM(e, t);
    if (r) {
      if (r.get) return wn(r.get);
      if (typeof r.value == "function") return wn(r.value);
    }
    e = eM(e);
  }
  function n() {
    return null;
  }
  return n;
}
function j9(e, t) {
  for (; e !== null; ) {
    const n = tM(e, t);
    if (n) return n.get ? wn(n.get) : null;
    e = eM(e);
  }
  return null;
}
function W9(e) {
  try {
    return kr(e, ""), !0;
  } catch {
    return !1;
  }
}
const IS = gr([
  "a",
  "abbr",
  "acronym",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "bdi",
  "bdo",
  "big",
  "blink",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "center",
  "cite",
  "code",
  "col",
  "colgroup",
  "content",
  "data",
  "datalist",
  "dd",
  "decorator",
  "del",
  "details",
  "dfn",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "element",
  "em",
  "fieldset",
  "figcaption",
  "figure",
  "font",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "img",
  "input",
  "ins",
  "kbd",
  "label",
  "legend",
  "li",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meter",
  "nav",
  "nobr",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "search",
  "section",
  "select",
  "shadow",
  "slot",
  "small",
  "source",
  "spacer",
  "span",
  "strike",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "template",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "tr",
  "track",
  "tt",
  "u",
  "ul",
  "var",
  "video",
  "wbr"
]), Bg = gr([
  "svg",
  "a",
  "altglyph",
  "altglyphdef",
  "altglyphitem",
  "animatecolor",
  "animatemotion",
  "animatetransform",
  "circle",
  "clippath",
  "defs",
  "desc",
  "ellipse",
  "enterkeyhint",
  "exportparts",
  "filter",
  "font",
  "g",
  "glyph",
  "glyphref",
  "hkern",
  "image",
  "inputmode",
  "line",
  "lineargradient",
  "marker",
  "mask",
  "metadata",
  "mpath",
  "part",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialgradient",
  "rect",
  "stop",
  "style",
  "switch",
  "symbol",
  "text",
  "textpath",
  "title",
  "tref",
  "tspan",
  "view",
  "vkern"
]), Ug = gr([
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDistantLight",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence"
]), z9 = gr([
  "animate",
  "color-profile",
  "cursor",
  "discard",
  "font-face",
  "font-face-format",
  "font-face-name",
  "font-face-src",
  "font-face-uri",
  "foreignobject",
  "hatch",
  "hatchpath",
  "mesh",
  "meshgradient",
  "meshpatch",
  "meshrow",
  "missing-glyph",
  "script",
  "set",
  "solidcolor",
  "unknown",
  "use"
]), qg = gr([
  "math",
  "menclose",
  "merror",
  "mfenced",
  "mfrac",
  "mglyph",
  "mi",
  "mlabeledtr",
  "mmultiscripts",
  "mn",
  "mo",
  "mover",
  "mpadded",
  "mphantom",
  "mroot",
  "mrow",
  "ms",
  "mspace",
  "msqrt",
  "mstyle",
  "msub",
  "msup",
  "msubsup",
  "mtable",
  "mtd",
  "mtext",
  "mtr",
  "munder",
  "munderover",
  "mprescripts"
]), H9 = gr([
  "maction",
  "maligngroup",
  "malignmark",
  "mlongdiv",
  "mscarries",
  "mscarry",
  "msgroup",
  "mstack",
  "msline",
  "msrow",
  "semantics",
  "annotation",
  "annotation-xml",
  "mprescripts",
  "none"
]), RS = gr(["#text"]), FS = gr([
  "accept",
  "action",
  "align",
  "alt",
  "autocapitalize",
  "autocomplete",
  "autopictureinpicture",
  "autoplay",
  "background",
  "bgcolor",
  "border",
  "capture",
  "cellpadding",
  "cellspacing",
  "checked",
  "cite",
  "class",
  "clear",
  "color",
  "cols",
  "colspan",
  "command",
  "commandfor",
  "controls",
  "controlslist",
  "coords",
  "crossorigin",
  "datetime",
  "decoding",
  "default",
  "dir",
  "disabled",
  "disablepictureinpicture",
  "disableremoteplayback",
  "download",
  "draggable",
  "enctype",
  "enterkeyhint",
  "exportparts",
  "face",
  "for",
  "headers",
  "height",
  "hidden",
  "high",
  "href",
  "hreflang",
  "id",
  "inert",
  "inputmode",
  "integrity",
  "ismap",
  "kind",
  "label",
  "lang",
  "list",
  "loading",
  "loop",
  "low",
  "max",
  "maxlength",
  "media",
  "method",
  "min",
  "minlength",
  "multiple",
  "muted",
  "name",
  "nonce",
  "noshade",
  "novalidate",
  "nowrap",
  "open",
  "optimum",
  "part",
  "pattern",
  "placeholder",
  "playsinline",
  "popover",
  "popovertarget",
  "popovertargetaction",
  "poster",
  "preload",
  "pubdate",
  "radiogroup",
  "readonly",
  "rel",
  "required",
  "rev",
  "reversed",
  "role",
  "rows",
  "rowspan",
  "spellcheck",
  "scope",
  "selected",
  "shape",
  "size",
  "sizes",
  "slot",
  "span",
  "srclang",
  "start",
  "src",
  "srcset",
  "step",
  "style",
  "summary",
  "tabindex",
  "title",
  "translate",
  "type",
  "usemap",
  "valign",
  "value",
  "width",
  "wrap",
  "xmlns"
]), jg = gr([
  "accent-height",
  "accumulate",
  "additive",
  "alignment-baseline",
  "amplitude",
  "ascent",
  "attributename",
  "attributetype",
  "azimuth",
  "basefrequency",
  "baseline-shift",
  "begin",
  "bias",
  "by",
  "class",
  "clip",
  "clippathunits",
  "clip-path",
  "clip-rule",
  "color",
  "color-interpolation",
  "color-interpolation-filters",
  "color-profile",
  "color-rendering",
  "cx",
  "cy",
  "d",
  "dx",
  "dy",
  "diffuseconstant",
  "direction",
  "display",
  "divisor",
  "dominant-baseline",
  "dur",
  "edgemode",
  "elevation",
  "end",
  "exponent",
  "fill",
  "fill-opacity",
  "fill-rule",
  "filter",
  "filterunits",
  "flood-color",
  "flood-opacity",
  "font-family",
  "font-size",
  "font-size-adjust",
  "font-stretch",
  "font-style",
  "font-variant",
  "font-weight",
  "fx",
  "fy",
  "g1",
  "g2",
  "glyph-name",
  "glyphref",
  "gradientunits",
  "gradienttransform",
  "height",
  "href",
  "id",
  "image-rendering",
  "in",
  "in2",
  "intercept",
  "k",
  "k1",
  "k2",
  "k3",
  "k4",
  "kerning",
  "keypoints",
  "keysplines",
  "keytimes",
  "lang",
  "lengthadjust",
  "letter-spacing",
  "kernelmatrix",
  "kernelunitlength",
  "lighting-color",
  "local",
  "marker-end",
  "marker-mid",
  "marker-start",
  "markerheight",
  "markerunits",
  "markerwidth",
  "maskcontentunits",
  "maskunits",
  "max",
  "mask",
  "mask-type",
  "media",
  "method",
  "mode",
  "min",
  "name",
  "numoctaves",
  "offset",
  "operator",
  "opacity",
  "order",
  "orient",
  "orientation",
  "origin",
  "overflow",
  "paint-order",
  "path",
  "pathlength",
  "patterncontentunits",
  "patterntransform",
  "patternunits",
  "pointer-events",
  "points",
  "preservealpha",
  "preserveaspectratio",
  "primitiveunits",
  "r",
  "rx",
  "ry",
  "radius",
  "refx",
  "refy",
  "repeatcount",
  "repeatdur",
  "restart",
  "result",
  "rotate",
  "scale",
  "seed",
  "shape-rendering",
  "slope",
  "specularconstant",
  "specularexponent",
  "spreadmethod",
  "startoffset",
  "stddeviation",
  "stitchtiles",
  "stop-color",
  "stop-opacity",
  "stroke-dasharray",
  "stroke-dashoffset",
  "stroke-linecap",
  "stroke-linejoin",
  "stroke-miterlimit",
  "stroke-opacity",
  "stroke",
  "stroke-width",
  "style",
  "surfacescale",
  "systemlanguage",
  "tabindex",
  "tablevalues",
  "targetx",
  "targety",
  "transform",
  "transform-origin",
  "text-anchor",
  "text-decoration",
  "text-orientation",
  "text-rendering",
  "textlength",
  "type",
  "u1",
  "u2",
  "unicode",
  "values",
  "vector-effect",
  "viewbox",
  "visibility",
  "version",
  "vert-adv-y",
  "vert-origin-x",
  "vert-origin-y",
  "width",
  "word-spacing",
  "wrap",
  "writing-mode",
  "xchannelselector",
  "ychannelselector",
  "x",
  "x1",
  "x2",
  "xmlns",
  "y",
  "y1",
  "y2",
  "z",
  "zoomandpan"
]), NS = gr([
  "accent",
  "accentunder",
  "align",
  "bevelled",
  "close",
  "columnalign",
  "columnlines",
  "columnspacing",
  "columnspan",
  "denomalign",
  "depth",
  "dir",
  "display",
  "displaystyle",
  "encoding",
  "fence",
  "frame",
  "height",
  "href",
  "id",
  "largeop",
  "length",
  "linethickness",
  "lquote",
  "lspace",
  "mathbackground",
  "mathcolor",
  "mathsize",
  "mathvariant",
  "maxsize",
  "minsize",
  "movablelimits",
  "notation",
  "numalign",
  "open",
  "rowalign",
  "rowlines",
  "rowspacing",
  "rowspan",
  "rspace",
  "rquote",
  "scriptlevel",
  "scriptminsize",
  "scriptsizemultiplier",
  "selection",
  "separator",
  "separators",
  "stretchy",
  "subscriptshift",
  "supscriptshift",
  "symmetric",
  "voffset",
  "width",
  "xmlns"
]), Lf = gr([
  "xlink:href",
  "xml:id",
  "xlink:title",
  "xml:space",
  "xmlns:xlink"
]), G9 = Tr(/{{[\w\W]*|^[\w\W]*}}/g), Y9 = Tr(/<%[\w\W]*|^[\w\W]*%>/g), K9 = Tr(/\${[\w\W]*/g), X9 = Tr(/^data-[\-\w.\u00B7-\uFFFF]+$/), Z9 = Tr(/^aria-[\-\w]+$/), LS = Tr(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp|matrix):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i), Q9 = Tr(/^(?:\w+script|data):/i), J9 = Tr(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g), eK = Tr(/^html$/i), tK = Tr(/^[a-z][.\w]*(-[.\w]+)+$/i), Wg = Tr(/<[/\w!]/g), $S = Tr(/<[/\w]/g), nK = Tr(/<\/no(script|embed|frames)/i), VS = Tr(/\/>/i), Xn = {
  element: 1,
  attribute: 2,
  text: 3,
  cdataSection: 4,
  entityReference: 5,
  entityNode: 6,
  processingInstruction: 7,
  comment: 8,
  document: 9,
  documentType: 10,
  documentFragment: 11,
  notation: 12
}, rK = gr(Bt({}, [
  "style",
  "script",
  "xmp",
  "iframe",
  "noembed",
  "noframes",
  "plaintext",
  "noscript"
])), iK = function() {
  return typeof window > "u" ? null : window;
}, aK = function(t, n) {
  if (typeof t != "object" || typeof t.createPolicy != "function") return null;
  let r = null;
  const i = "data-tt-policy-suffix";
  n && n.hasAttribute(i) && (r = n.getAttribute(i));
  const a = "dompurify" + (r ? "#" + r : "");
  try {
    return t.createPolicy(a, {
      createHTML(s) {
        return s;
      },
      createScriptURL(s) {
        return s;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + a + " could not be created."), null;
  }
}, BS = function() {
  return {
    afterSanitizeAttributes: [],
    afterSanitizeElements: [],
    afterSanitizeShadowDOM: [],
    beforeSanitizeAttributes: [],
    beforeSanitizeElements: [],
    beforeSanitizeShadowDOM: [],
    uponSanitizeAttribute: [],
    uponSanitizeElement: [],
    uponSanitizeShadowNode: []
  };
}, Fs = function(t, n, r, i) {
  return ai(t, n) && Yl(t[n]) ? Bt(i.base ? bi(i.base) : {}, t[n], i.transform) : r;
}, zg = function(t, n, r) {
  const i = ai(t, n) ? t[n] : void 0;
  return i && typeof i == "object" ? bi(i) : r();
};
function iM() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : iK();
  const t = (De) => iM(De);
  if (t.version = "3.4.17", t.removed = [], !e || !e.document || e.document.nodeType !== Xn.document || !e.Element)
    return t.isSupported = !1, t;
  let n = e.document;
  const r = n, i = r.currentScript;
  e.DocumentFragment;
  const a = e.HTMLTemplateElement, s = e.Node, o = e.Element, l = e.NodeFilter;
  e.NamedNodeMap === void 0 && (e.NamedNodeMap || e.MozNamedAttrMap), e.HTMLFormElement;
  const c = e.DOMParser, f = e.trustedTypes, h = o.prototype, p = Li(h, "cloneNode"), g = Li(h, "remove"), v = Li(h, "removeAttributeNode"), y = Li(h, "nextSibling"), S = Li(h, "childNodes"), x = Li(h, "parentNode"), E = Li(h, "shadowRoot"), w = Li(h, "attributes"), C = s && s.prototype ? Li(s.prototype, "nodeType") : null, P = s && s.prototype ? Li(s.prototype, "nodeName") : null, M = s && s.prototype ? Li(s.prototype, "ownerDocument") : null, T = function(F) {
    return C ? C(F) : F.nodeType;
  }, N = function(F) {
    return P ? P(F) : F.nodeName;
  }, $ = j9(h, "namespaceURI"), ne = function(F) {
    return $ ? $(F) : F.namespaceURI;
  };
  if (typeof a == "function") {
    const De = n.createElement("template");
    De.content && De.content.ownerDocument && (n = De.content.ownerDocument);
  }
  let Y, te = "", _e, Fe = !1, J = 0;
  const oe = function() {
    if (J > 0) throw Ya('A configured TRUSTED_TYPES_POLICY callback (createHTML or createScriptURL) must not call DOMPurify.sanitize, as that causes infinite recursion. Do not pass a policy whose callbacks wrap DOMPurify as TRUSTED_TYPES_POLICY; see the "DOMPurify and Trusted Types" section of the README.');
  }, A = function(F) {
    oe(), J++;
    try {
      return Y.createHTML(F);
    } finally {
      J--;
    }
  }, X = function(F) {
    oe(), J++;
    try {
      return Y.createScriptURL(F);
    } finally {
      J--;
    }
  }, pe = function() {
    return Fe || (_e = aK(f, i), Fe = !0), _e;
  }, le = n, ue = le.implementation, Te = le.createNodeIterator, Ne = le.createDocumentFragment, Z = le.getElementsByTagName, G = r.importNode;
  let se = BS();
  t.isSupported = typeof JO == "function" && typeof x == "function" && ue && ue.createHTMLDocument !== void 0;
  const St = G9, Sn = Y9, Vt = K9, nn = X9, rr = Z9, Qe = Q9, Je = J9, Pt = tK;
  let Xe = LS, pt = null;
  const Cn = Bt({}, [
    ...IS,
    ...Bg,
    ...Ug,
    ...qg,
    ...RS
  ]);
  let ut = null;
  const dr = Bt({}, [
    ...FS,
    ...jg,
    ...NS,
    ...Lf
  ]);
  let B = Object.seal(zl(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), z = null, ye = null;
  const $e = Object.seal(zl(null, {
    tagCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    }
  }));
  let Ct = !0, At = !0, mt = !1, he = !0, Ae = !1, q = !0, me = !1, Be = !1, He = null, gt = null, cn = !1, Yn = !1, be = !1, Ue = !1, Mn = !0, ir = !1;
  const Ia = "user-content-";
  let Ze = !0, li = !1, ot = null, pa = {}, ui = null;
  const Cd = Bt({}, [
    "annotation-xml",
    "audio",
    "colgroup",
    "desc",
    "foreignobject",
    "head",
    "iframe",
    "math",
    "mi",
    "mn",
    "mo",
    "ms",
    "mtext",
    "noembed",
    "noframes",
    "noscript",
    "plaintext",
    "script",
    "selectedcontent",
    "style",
    "svg",
    "template",
    "thead",
    "title",
    "video",
    "xmp"
  ]);
  let Td = null;
  const _u = Bt({}, [
    "audio",
    "video",
    "img",
    "source",
    "image",
    "track"
  ]);
  let Ad = null;
  const Dd = Bt({}, [
    "alt",
    "class",
    "for",
    "id",
    "label",
    "name",
    "pattern",
    "placeholder",
    "role",
    "summary",
    "title",
    "value",
    "style",
    "xmlns"
  ]), ml = "http://www.w3.org/1998/Math/MathML", gs = "http://www.w3.org/2000/svg", Ai = "http://www.w3.org/1999/xhtml";
  let ma = Ai, yu = !1, xu = null;
  const Zp = Bt({}, [
    ml,
    gs,
    Ai
  ], Vg), Ed = gr([
    "mi",
    "mo",
    "mn",
    "ms",
    "mtext"
  ]);
  let wu = Bt({}, Ed);
  const ku = gr(["annotation-xml"]);
  let Su = Bt({}, ku);
  const Qp = Bt({}, [
    "title",
    "style",
    "font",
    "a",
    "script"
  ]);
  let vs = null;
  const Jp = ["application/xhtml+xml", "text/html"], em = "text/html";
  let Tn = null, bs = null;
  const tm = n.createElement("form"), Pd = function(F) {
    return F instanceof RegExp || F instanceof Function;
  }, _s = function() {
    let F = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (bs && bs === F) return;
    (!F || typeof F != "object") && (F = {}), F = bi(F), vs = Jp.indexOf(F.PARSER_MEDIA_TYPE) === -1 ? em : F.PARSER_MEDIA_TYPE, Tn = vs === "application/xhtml+xml" ? Vg : Mo, pt = Fs(F, "ALLOWED_TAGS", Cn, { transform: Tn }), ut = Fs(F, "ALLOWED_ATTR", dr, { transform: Tn }), xu = Fs(F, "ALLOWED_NAMESPACES", Zp, { transform: Vg }), Ad = Fs(F, "ADD_URI_SAFE_ATTR", Dd, {
      transform: Tn,
      base: Dd
    }), Td = Fs(F, "ADD_DATA_URI_TAGS", _u, {
      transform: Tn,
      base: _u
    }), ui = Fs(F, "FORBID_CONTENTS", Cd, { transform: Tn }), z = Fs(F, "FORBID_TAGS", bi({}), { transform: Tn }), ye = Fs(F, "FORBID_ATTR", bi({}), { transform: Tn }), pa = ai(F, "USE_PROFILES") ? F.USE_PROFILES && typeof F.USE_PROFILES == "object" ? bi(F.USE_PROFILES) : F.USE_PROFILES : !1, Ct = F.ALLOW_ARIA_ATTR !== !1, At = F.ALLOW_DATA_ATTR !== !1, mt = F.ALLOW_UNKNOWN_PROTOCOLS || !1, he = F.ALLOW_SELF_CLOSE_IN_ATTR !== !1, Ae = F.SAFE_FOR_TEMPLATES || !1, q = F.SAFE_FOR_XML !== !1, me = F.WHOLE_DOCUMENT || !1, Yn = F.RETURN_DOM || !1, be = F.RETURN_DOM_FRAGMENT || !1, Ue = F.RETURN_TRUSTED_TYPE || !1, cn = F.FORCE_BODY || !1, Mn = F.SANITIZE_DOM !== !1, ir = F.SANITIZE_NAMED_PROPS || !1, Ze = F.KEEP_CONTENT !== !1, li = F.IN_PLACE || !1, Xe = W9(F.ALLOWED_URI_REGEXP) ? F.ALLOWED_URI_REGEXP : LS, ma = typeof F.NAMESPACE == "string" ? F.NAMESPACE : Ai, wu = zg(F, "MATHML_TEXT_INTEGRATION_POINTS", () => Bt({}, Ed)), Su = zg(F, "HTML_INTEGRATION_POINTS", () => Bt({}, ku));
    const K = zg(F, "CUSTOM_ELEMENT_HANDLING", () => zl(null));
    if (B = zl(null), ai(K, "tagNameCheck") && Pd(K.tagNameCheck) && (B.tagNameCheck = K.tagNameCheck), ai(K, "attributeNameCheck") && Pd(K.attributeNameCheck) && (B.attributeNameCheck = K.attributeNameCheck), ai(K, "allowCustomizedBuiltInElements") && typeof K.allowCustomizedBuiltInElements == "boolean" && (B.allowCustomizedBuiltInElements = K.allowCustomizedBuiltInElements), Tr(B), Ae && (At = !1), be && (Yn = !0), pa && (pt = Bt({}, RS), ut = zl(null), pa.html === !0 && (Bt(pt, IS), Bt(ut, FS)), pa.svg === !0 && (Bt(pt, Bg), Bt(ut, jg), Bt(ut, Lf)), pa.svgFilters === !0 && (Bt(pt, Ug), Bt(ut, jg), Bt(ut, Lf)), pa.mathMl === !0 && (Bt(pt, qg), Bt(ut, NS), Bt(ut, Lf))), $e.tagCheck = null, $e.attributeCheck = null, ai(F, "ADD_TAGS") && (typeof F.ADD_TAGS == "function" ? $e.tagCheck = F.ADD_TAGS : Yl(F.ADD_TAGS) && (pt === Cn && (pt = bi(pt)), Bt(pt, F.ADD_TAGS, Tn))), ai(F, "ADD_ATTR") && (typeof F.ADD_ATTR == "function" ? $e.attributeCheck = F.ADD_ATTR : Yl(F.ADD_ATTR) && (ut === dr && (ut = bi(ut)), Bt(ut, F.ADD_ATTR, Tn))), ai(F, "ADD_FORBID_CONTENTS") && Yl(F.ADD_FORBID_CONTENTS) && (ui === Cd && (ui = bi(ui)), Bt(ui, F.ADD_FORBID_CONTENTS, Tn)), Ze && (pt["#text"] = !0), me && Bt(pt, [
      "html",
      "head",
      "body"
    ]), pt.table && (Bt(pt, ["tbody"]), delete z.tbody), F.TRUSTED_TYPES_POLICY) {
      if (typeof F.TRUSTED_TYPES_POLICY.createHTML != "function") throw Ya('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
      if (typeof F.TRUSTED_TYPES_POLICY.createScriptURL != "function") throw Ya('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
      const ke = Y;
      Y = F.TRUSTED_TYPES_POLICY;
      try {
        te = A("");
      } catch (fe) {
        throw Y = ke, fe;
      }
    } else F.TRUSTED_TYPES_POLICY === null ? (Y = void 0, te = "") : (Y === void 0 && (Y = pe()), Y && typeof te == "string" && (te = A("")));
    gr && gr(F), bs = F;
  }, Od = Bt({}, [
    ...Bg,
    ...Ug,
    ...z9
  ]), fo = Bt({}, [...qg, ...H9]), nm = function(F, K, ke) {
    return K.namespaceURI === Ai ? F === "svg" : K.namespaceURI === ml ? F === "svg" && (ke === "annotation-xml" || wu[ke]) : !!Od[F];
  }, rm = function(F, K, ke) {
    return K.namespaceURI === Ai ? F === "math" : K.namespaceURI === gs ? F === "math" && Su[ke] : !!fo[F];
  }, im = function(F, K, ke) {
    return K.namespaceURI === gs && !Su[ke] || K.namespaceURI === ml && !wu[ke] ? !1 : !fo[F] && (Qp[F] || !Od[F]);
  }, Md = function(F) {
    const K = ne(F), ke = Mo(N(F)), fe = x(F);
    let Le, nt;
    return fe && T(fe) === Xn.element ? (Le = { namespaceURI: ne(fe) }, nt = Mo(N(fe))) : (Le = { namespaceURI: ma }, nt = "template"), xu[K] ? K === gs ? nm(ke, Le, nt) : K === ml ? rm(ke, Le, nt) : K === Ai ? im(ke, Le, nt) : !!(vs === "application/xhtml+xml" && xu[K]) : !1;
  }, Zi = function(F) {
    nc(t.removed, { element: F });
    try {
      x(F).removeChild(F);
    } catch {
      if (g(F), !x(F)) throw Ya("a node selected for removal could not be detached from its tree and cannot be safely returned; refusing to sanitize in place");
    }
  }, Cu = function(F, K, ke) {
    try {
      v(F, K);
    } catch {
      try {
        F.removeAttribute(ke);
      } catch {
      }
    }
  }, Tu = function(F) {
    gl(F);
    const K = S(F);
    K && Ga(N9(K), (fe) => {
      try {
        g(fe);
      } catch {
      }
    });
    const ke = T(F) === Xn.element ? w(F) : null;
    if (ke) for (let fe = ke.length - 1; fe >= 0; --fe) {
      const Le = ke[fe], nt = Le && Le.name;
      typeof nt == "string" && Cu(F, Le, nt);
    }
  }, ys = function(F, K, ke) {
    if (!ke) try {
      ke = K.getAttributeNode(F);
    } catch {
      ke = null;
    }
    nc(t.removed, {
      attribute: ke || null,
      from: K
    });
    try {
      ke ? v(K, ke) : K.removeAttribute(F);
    } catch {
      try {
        K.removeAttribute(F);
      } catch {
      }
    }
    if (F === "is")
      if (Yn || be) try {
        Zi(K);
      } catch {
      }
      else try {
        K.setAttribute(F, "");
      } catch {
      }
  }, Id = function(F) {
    const K = w(F);
    if (K)
      for (let ke = K.length - 1; ke >= 0; --ke) {
        const fe = K[ke], Le = fe && fe.name;
        typeof Le != "string" || ut[Tn(Le)] || Cu(F, fe, Le);
      }
  }, Au = function(F, K) {
    let ke = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
    const fe = [F];
    for (; fe.length > 0; ) {
      const Le = fe.pop();
      if (K(Le) === !1) continue;
      if (ke && T(Le) === Xn.element) {
        const xt = E(Le);
        Vr(xt) && fe.push(xt);
      }
      const nt = S(Le);
      if (nt) for (let xt = nt.length - 1; xt >= 0; --xt) fe.push(nt[xt]);
    }
  }, gl = function(F) {
    Au(F, (K) => {
      T(K) === Xn.element && Id(K);
    });
  }, vl = function(F) {
    const K = [];
    return Au(F, (ke) => {
      K.push(ke);
    }, !0), K;
  }, Rd = function(F, K) {
    const ke = Lg();
    Ga(vl(F), (fe) => {
      T(fe) === Xn.element && $g(ke, fe);
    }), Ga(K, (fe) => {
      T(fe) === Xn.element && !rc(ke, fe) && Id(fe);
    });
  }, bl = function(F, K) {
    let ke = !1;
    return Ga(t.removed, (fe) => {
      fe.element && (ke = ke || fe.element === F, gl(fe.element));
    }), Rd(F, K), ke;
  }, am = 8, Fd = function(F, K) {
    const ke = ot;
    let fe = null;
    const Le = () => (fe || (fe = Lg(), Ga(K, (nt) => {
      $g(fe, nt);
    })), fe);
    for (let nt = 0; ; nt++) {
      const xt = vl(F), Bn = [F];
      let Di = !1;
      if (Ga(xt, (yr) => {
        T(yr) === Xn.documentFragment ? nc(Bn, yr) : !Di && !rc(ke, yr) && (Di = rc(Le(), yr));
      }), !Di) return;
      if (nt >= am) throw Ya("the tree kept changing during in-place sanitization; refusing to return it");
      Ga(Bn, (yr, Dr) => {
        _l(yr, Dr > 0, F, Le());
      });
    }
  }, _l = function(F, K, ke, fe) {
    const Le = ho(F);
    let nt;
    for (; nt = Le.nextNode(); )
      !rc(fe, nt) || rc(ot, nt) || (K && Qr(se.uponSanitizeShadowNode, nt, null), Pu(nt, ke), Mu(nt, ke), Vr(nt.content) && Fa(nt.content));
  }, Nd = function(F) {
    ot && $g(ot, F);
  }, Ld = function(F, K) {
    return q ? F === "patchsrc" ? !0 : F === "for" && K !== "label" && K !== "output" : !1;
  }, $d = function(F) {
    q && Au(F, (K) => {
      const ke = T(K);
      if (ke === Xn.processingInstruction || ke === Xn.comment && kr($S, K.data)) {
        try {
          g(K);
        } catch {
        }
        return !1;
      }
      if (ke === Xn.element) {
        const fe = K, Le = Tn(N(K));
        try {
          fe.hasAttribute && fe.hasAttribute("patchsrc") && fe.removeAttribute("patchsrc"), fe.hasAttribute && fe.hasAttribute("for") && Ld("for", Le) && fe.removeAttribute("for");
        } catch {
        }
      }
      return !0;
    });
  }, Du = function(F) {
    let K = null, ke = null;
    if (cn) F = "<remove></remove>" + F;
    else {
      const nt = ES(F, /^[\r\n\t ]+/);
      ke = nt && nt[0];
    }
    vs === "application/xhtml+xml" && ma === Ai && (F = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + F + "</body></html>");
    const fe = Y ? A(F) : F;
    if (ma === Ai) try {
      K = new c().parseFromString(fe, vs);
    } catch {
    }
    if (!K || !K.documentElement) {
      K = ue.createDocument(ma, "template", null);
      try {
        K.documentElement.innerHTML = yu ? te : fe;
      } catch {
      }
    }
    const Le = K.body || K.documentElement;
    return F && ke && Le.insertBefore(n.createTextNode(ke), Le.childNodes[0] || null), ma === Ai ? Z.call(K, me ? "html" : "body")[0] : me ? K.documentElement : Le;
  }, ho = function(F) {
    const K = M ? M(F) : F.ownerDocument;
    return Te.call(K || F, F, l.SHOW_ELEMENT | l.SHOW_COMMENT | l.SHOW_TEXT | l.SHOW_PROCESSING_INSTRUCTION | l.SHOW_CDATA_SECTION, null);
  }, yl = function(F) {
    return F = ic(F, St, " "), F = ic(F, Sn, " "), F = ic(F, Vt, " "), F;
  }, xl = function(F) {
    var K;
    wl(F);
    const ke = (K = F.querySelectorAll) === null || K === void 0 ? void 0 : K.call(F, "template");
    ke && Ga(ke, (fe) => {
      Vr(fe.content) && xl(fe.content);
    });
  }, wl = function(F) {
    F.normalize();
    const K = M ? M(F) : F.ownerDocument, ke = Te.call(K || F, F, l.SHOW_TEXT | l.SHOW_COMMENT | l.SHOW_CDATA_SECTION | l.SHOW_PROCESSING_INSTRUCTION, null);
    let fe = ke.nextNode();
    for (; fe; )
      fe.data = yl(fe.data), fe = ke.nextNode();
  }, xs = function(F) {
    const K = P ? P(F) : null;
    return typeof K != "string" || Tn(K) !== "form" ? !1 : typeof F.nodeName != "string" || typeof F.textContent != "string" || typeof F.removeChild != "function" || F.attributes !== w(F) || typeof F.removeAttribute != "function" || typeof F.removeAttributeNode != "function" || typeof F.getAttributeNode != "function" || typeof F.setAttribute != "function" || typeof F.namespaceURI != "string" || typeof F.insertBefore != "function" || typeof F.hasChildNodes != "function" || F.nodeType !== C(F) || F.childNodes !== S(F);
  }, Vr = function(F) {
    if (!C || typeof F != "object" || F === null) return !1;
    try {
      return C(F) === Xn.documentFragment;
    } catch {
      return !1;
    }
  }, ws = function(F) {
    if (!C || typeof F != "object" || F === null) return !1;
    try {
      return typeof C(F) == "number";
    } catch {
      return !1;
    }
  };
  function Qr(De, F, K) {
    De.length !== 0 && Ga(De, (ke) => {
      ke.call(t, F, K, bs);
    });
  }
  const sm = function(F, K) {
    return !!(q && F.hasChildNodes() && !ws(F.firstElementChild) && kr(Wg, F.textContent) && kr(Wg, F.innerHTML) || q && rK[K] && T(F) === Xn.element && ne(F) === Ai && (ws(F.firstElementChild) || typeof F.textContent == "string" && kr(Wg, F.textContent)) || F.nodeType === Xn.processingInstruction || q && F.nodeType === Xn.comment && kr($S, F.data));
  }, po = function(F, K) {
    if (F instanceof RegExp) return kr(F, K);
    if (F instanceof Function) {
      for (var ke = arguments.length, fe = new Array(ke > 2 ? ke - 2 : 0), Le = 2; Le < ke; Le++) fe[Le - 2] = arguments[Le];
      return !!F(K, ...fe);
    }
    return !1;
  }, Vd = function(F, K, ke) {
    if (!z[K] && Ou(K) && po(B.tagNameCheck, K)) return !1;
    if (Ze && !ui[K] && !ui[Mo(K)]) {
      const fe = x(F), Le = S(F);
      if (Le && fe) {
        const nt = Le.length;
        for (let xt = nt - 1; xt >= 0; --xt) {
          const Bn = F === ke ? p(Le[xt], !0) : Le[xt];
          fe.insertBefore(Bn, y(F));
        }
      }
    }
    return Zi(F), !0;
  }, Eu = function(F, K, ke, fe) {
    return F.length === 0 ? K : K === ke || K === fe ? bi(K) : K;
  }, Ra = function(F, K) {
    return F === K || x(F) !== null ? !1 : (li && gl(F), !0);
  }, Pu = function(F, K) {
    if (Nd(F), Qr(se.beforeSanitizeElements, F, null), Ra(F, K)) return !0;
    if (xs(F))
      return Zi(F), !0;
    const ke = Tn(N(F));
    if (pt = Eu(se.uponSanitizeElement, pt, Cn, He), Qr(se.uponSanitizeElement, F, {
      tagName: ke,
      allowedTags: pt
    }), Ra(F, K)) return !0;
    if (sm(F, ke))
      return Zi(F), !0;
    if (z[ke] || !($e.tagCheck instanceof Function && $e.tagCheck(ke)) && !pt[ke]) {
      const fe = Vd(F, ke, K);
      return fe === !1 && (Qr(se.afterSanitizeElements, F, null), Ra(F, K)) ? !0 : fe;
    }
    if (T(F) === Xn.element && !Md(F) || (ke === "noscript" || ke === "noembed" || ke === "noframes") && kr(nK, F.innerHTML))
      return Zi(F), !0;
    if (Ae && F.nodeType === Xn.text) {
      const fe = yl(F.textContent);
      F.textContent !== fe && (nc(t.removed, { element: F.cloneNode() }), F.textContent = fe);
    }
    return Qr(se.afterSanitizeElements, F, null), Ra(F, K);
  }, Bd = function(F, K, ke) {
    if (ye[K] || Ld(K, F) || Mn && (K === "id" || K === "name") && (ke in n || ke in tm)) return !1;
    const fe = ut[K] || $e.attributeCheck instanceof Function && $e.attributeCheck(K, F);
    return At && kr(nn, K) || Ct && kr(rr, K) ? !0 : fe ? Ad[K] || kr(Xe, ic(ke, Je, "")) || (K === "src" || K === "xlink:href" || K === "href") && F !== "script" && PS(ke, "data:") === 0 && Td[F] || mt && !kr(Qe, ic(ke, Je, "")) ? !0 : !ke : Ou(F) && po(B.tagNameCheck, F) && po(B.attributeNameCheck, K, F) || K === "is" && B.allowCustomizedBuiltInElements && po(B.tagNameCheck, ke);
  }, om = Bt({}, [
    "annotation-xml",
    "color-profile",
    "font-face",
    "font-face-format",
    "font-face-name",
    "font-face-src",
    "font-face-uri",
    "missing-glyph"
  ]), Ou = function(F) {
    return !om[Mo(F)] && kr(Pt, F);
  }, lm = function(F, K, ke, fe) {
    if (Y && typeof f == "object" && typeof f.getAttributeType == "function" && !ke) switch (f.getAttributeType(F, K)) {
      case "TrustedHTML":
        return A(fe);
      case "TrustedScriptURL":
        return X(fe);
    }
    return fe;
  }, um = function(F, K, ke, fe) {
    try {
      return ke ? F.setAttributeNS(ke, K, fe) : F.setAttribute(K, fe), xs(F) ? (Zi(F), !1) : !0;
    } catch {
      return ys(K, F), !1;
    }
  }, Ud = function(F, K) {
    return q && kr(/((--!?|])>)|<\/(style|script|title|xmp|textarea|noscript|iframe|noembed|noframes)/i, K) ? !0 : Mo(F) === "attributename" && ES(K, "href") !== null;
  }, Mu = function(F, K) {
    if (Qr(se.beforeSanitizeAttributes, F, null), Ra(F, K)) return;
    const ke = F.attributes;
    if (!ke || xs(F)) return;
    ut = Eu(se.uponSanitizeAttribute, ut, dr, gt);
    const fe = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: ut,
      forceKeepAttr: void 0
    };
    let Le = ke.length;
    const nt = Tn(F.nodeName);
    for (; Le--; ) {
      const xt = ke[Le], Bn = xt.name, Di = xt.namespaceURI, yr = xt.value, Dr = Tn(Bn), Na = yr;
      let Er = Bn === "value" ? Na : $9(Na), Kn = !1;
      if (fe.attrName = Dr, fe.attrValue = Er, fe.keepAttr = !0, fe.forceKeepAttr = void 0, Qr(se.uponSanitizeAttribute, F, fe), Er = fe.attrValue, ir && (Dr === "id" || Dr === "name") && PS(Er, Ia) !== 0 && (ys(Bn, F, xt), Er = Ia + Er, Kn = !0), Ud(Bn, Er)) {
        ys(Bn, F, xt);
        continue;
      }
      if (!fe.forceKeepAttr) {
        if (!fe.keepAttr) {
          ys(Bn, F, xt);
          continue;
        }
        if (!he && kr(VS, Er)) {
          ys(Bn, F, xt);
          continue;
        }
        if (Ae && (Er = yl(Er)), !Bd(nt, Dr, Er)) {
          ys(Bn, F, xt);
          continue;
        }
        Er = lm(nt, Dr, Di, Er), Er !== Na && um(F, Bn, Di, Er) && Kn && DS(t.removed);
      }
    }
    Qr(se.afterSanitizeAttributes, F, null), Ra(F, K);
  }, Fa = function(F) {
    let K = null;
    const ke = ho(F);
    for (Qr(se.beforeSanitizeShadowDOM, F, null); K = ke.nextNode(); )
      if (Qr(se.uponSanitizeShadowNode, K, null), Pu(K, F), Mu(K, F), Vr(K.content) && Fa(K.content), T(K) === Xn.element) {
        const fe = E(K);
        Vr(fe) && (Iu(fe), Fa(fe));
      }
    Ae && wl(F), Qr(se.afterSanitizeShadowDOM, F, null);
  }, Iu = function(F) {
    const K = [{
      node: F,
      shadow: null
    }];
    for (; K.length > 0; ) {
      const ke = K.pop();
      if (ke.shadow) {
        Fa(ke.shadow);
        continue;
      }
      const fe = ke.node, Le = T(fe) === Xn.element, nt = S(fe);
      if (nt) for (let xt = nt.length - 1; xt >= 0; --xt) K.push({
        node: nt[xt],
        shadow: null
      });
      if (Le) {
        const xt = P ? P(fe) : null;
        if (typeof xt == "string" && Tn(xt) === "template") {
          const Bn = fe.content;
          Vr(Bn) && K.push({
            node: Bn,
            shadow: null
          });
        }
      }
      if (Le) {
        const xt = E(fe);
        Vr(xt) && K.push({
          node: null,
          shadow: xt
        }, {
          node: xt,
          shadow: null
        });
      }
    }
  };
  return t.sanitize = function(De) {
    let F = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, K = null, ke = null, fe = null, Le = null;
    if (yu = !De, yu && (De = "<!-->"), typeof De != "string" && !ws(De) && (De = q9(De), typeof De != "string"))
      throw Ya("dirty is not a string, aborting");
    if (!t.isSupported) return De;
    Be ? (pt = He, ut = gt) : _s(F), (se.uponSanitizeElement.length > 0 || se.uponSanitizeAttribute.length > 0) && (pt = bi(pt)), se.uponSanitizeAttribute.length > 0 && (ut = bi(ut)), t.removed = [];
    const nt = li && typeof De != "string" && ws(De);
    let xt = [];
    const Bn = ot;
    if (nt) {
      $d(De);
      const Dr = N(De);
      if (typeof Dr == "string") {
        const Na = Tn(Dr);
        if (!pt[Na] || z[Na])
          throw Tu(De), Ya("root node is forbidden and cannot be sanitized in-place");
      }
      if (xs(De))
        throw Tu(De), Ya("root node is clobbered and cannot be sanitized in-place");
      xt = vl(De), ot = Lg();
    } else if (ws(De))
      K = Du("<!---->"), ke = K.ownerDocument.importNode(De, !0), ke.nodeType === Xn.element && ke.nodeName === "BODY" || ke.nodeName === "HTML" ? K = ke : K.appendChild(ke), Iu(K);
    else {
      if (!Yn && !Ae && !me && De.indexOf("<") === -1) return Y && Ue ? A(De) : De;
      if (K = Du(De), !K) return Yn ? null : Ue ? te : "";
    }
    K && cn && Zi(K.firstChild);
    const Di = nt ? De : K;
    try {
      nt && Iu(De);
      const Dr = ho(Di);
      for (; fe = Dr.nextNode(); )
        Pu(fe, Di), Mu(fe, Di), Vr(fe.content) && Fa(fe.content);
      nt && Fd(De, xt);
    } catch (Dr) {
      throw nt && (Tu(De), bl(De, xt)), Dr;
    } finally {
      ot = Bn;
    }
    if (nt) {
      if (bl(De, xt)) throw Ya("a node selected for removal could not be safely returned; refusing to sanitize in place");
      return Ae && xl(De), De;
    }
    if (Yn) {
      if (Ae && xl(K), be)
        for (Le = Ne.call(K.ownerDocument); K.firstChild; ) Le.appendChild(K.firstChild);
      else Le = K;
      return (ut.shadowroot || ut.shadowrootmode) && (Le = G.call(r, Le, !0)), Le;
    }
    let yr = me ? K.outerHTML : K.innerHTML;
    return me && pt["!doctype"] && K.ownerDocument && K.ownerDocument.doctype && K.ownerDocument.doctype.name && kr(eK, K.ownerDocument.doctype.name) && (yr = "<!DOCTYPE " + K.ownerDocument.doctype.name + `>
` + yr), Ae && (yr = yl(yr)), Y && Ue ? A(yr) : yr;
  }, t.setConfig = function() {
    let De = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    _s(De), Be = !0, He = pt, gt = ut;
  }, t.clearConfig = function() {
    bs = null, Be = !1, He = null, gt = null, Y = _e, te = "";
  }, t.isValidAttribute = function(De, F, K) {
    bs || _s({});
    const ke = Tn(De), fe = Tn(F);
    return typeof K == "string" && (Ud(F, K) || !he && kr(VS, K)) ? !1 : Bd(ke, fe, K);
  }, t.addHook = function(De, F) {
    typeof F == "function" && ai(se, De) && nc(se[De], F);
  }, t.removeHook = function(De, F) {
    if (ai(se, De)) {
      if (F !== void 0) {
        const K = F9(se[De], F);
        return K === -1 ? void 0 : L9(se[De], K, 1)[0];
      }
      return DS(se[De]);
    }
  }, t.removeHooks = function(De) {
    ai(se, De) && (se[De] = []);
  }, t.removeAllHooks = function() {
    se = BS();
  }, t;
}
var sK = iM();
const oK = {
  props: {
    content: {
      type: String,
      default: ""
    }
  },
  computed: {
    html() {
      if (!this.content) return "";
      const e = Jt.parse(this.content, { gfm: !0, breaks: !0, async: !1 });
      return sK.sanitize(e, {
        FORBID_TAGS: ["style", "img"],
        FORBID_ATTR: ["style"]
      });
    }
  }
}, lK = ["innerHTML"];
function uK(e, t, n, r, i, a) {
  return a.html ? (_(), O("div", {
    key: 0,
    class: "markdown-text",
    innerHTML: a.html
  }, null, 8, lK)) : L("", !0);
}
const h0e = /* @__PURE__ */ we(oK, [["render", uK], ["__scopeId", "data-v-1500984e"]]), cK = {
  components: { Datepicker: fu },
  props: {
    placeholder: {
      type: String
    },
    modelValue: {
      type: Array,
      required: !0
    },
    useQueryParams: {
      type: Boolean,
      default: !1
    },
    ranges: {
      type: Array,
      default: () => []
    }
  },
  beforeMount() {
    this.useQueryParams && this.loadQueryParams();
  },
  mounted() {
    this._onResize = () => {
      this.isDesktop = window.innerWidth >= 640;
    }, window.addEventListener("resize", this._onResize);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this._onResize);
  },
  data() {
    return {
      isDesktop: window.innerWidth >= 640,
      defaultRanges: [
        {
          id: 1,
          label: "Aujourd'hui",
          range: Ej()
        },
        {
          id: 2,
          label: "Hier",
          range: Oj()
        },
        {
          id: 3,
          label: "7 derniers jours",
          range: Lj()
        },
        {
          id: 4,
          label: "4 dernières semaines",
          range: Vj()
        },
        {
          id: 5,
          label: "3 derniers mois",
          range: Uj()
        },
        {
          id: 6,
          label: "12 derniers mois",
          range: jj()
        },
        {
          id: 7,
          label: "Semaine en cours",
          range: G2()
        },
        {
          id: 8,
          label: "Mois en cours",
          range: H2()
        },
        {
          id: 9,
          label: "Année en cours",
          range: zj()
        }
      ]
    };
  },
  computed: {
    presetRanges() {
      const e = this.ranges.map((t, n) => ({
        id: n + this.defaultRanges.length + 1,
        label: t.label,
        range: t.range
      }));
      return [...this.defaultRanges, ...e];
    },
    internalValue: {
      get() {
        var e;
        return (e = this.modelValue) != null && e.every((t) => t == null) ? null : this.modelValue;
      },
      set(e) {
        let t = null, n = null;
        e && (t = Bc(e[0]), n = Bc(e[1])), this.useQueryParams && this.updateQueryParams(t, n), this.$emit("update:modelValue", [t, n]);
      }
    }
  },
  methods: {
    datePickerFormat(e) {
      const t = e[0], n = e[1];
      if (!t || !n) return "";
      if (t instanceof Date && n instanceof Date) {
        if (Dj(t, n)) return "Aujourd'hui";
        if (Pj(t, n)) return "Hier";
        if (Nj(t, n)) return "7 derniers jours";
        if ($j(t, n)) return "4 dernières semaines";
        if (Bj(t, n)) return "3 derniers mois";
        if (qj(t, n)) return "12 derniers mois";
        if (z2(t, n)) return "Semaine en cours";
        if (W2(t, n)) return "Mois en cours";
        if (Wj(t, n)) return "Année en cours";
      }
      const r = this.$d(t, "long"), i = this.$d(n, "long");
      return `${r} → ${i}`;
    },
    loadQueryParams() {
      const e = this.$route.query.start_date, t = this.$route.query.end_date;
      e && t && (this.internalValue = [new Date(e), new Date(t)]);
    },
    updateQueryParams(e, t) {
      const n = { ...this.$route.query };
      !e || !t ? (delete n.start_date, delete n.end_date) : (n.start_date = e, n.end_date = t), this.$router.push({ query: n });
    }
  }
};
function dK(e, t, n, r, i, a) {
  const s = U("Datepicker");
  return _(), ae(s, {
    placeholder: n.placeholder,
    class: "text-xs rounded-lg border-gray-300 shadow-xs",
    modelValue: a.internalValue,
    "onUpdate:modelValue": t[0] || (t[0] = (o) => a.internalValue = o),
    range: "",
    multiCalendars: i.isDesktop,
    presetRanges: a.presetRanges,
    autoApply: "",
    enableTimePicker: !1,
    format: a.datePickerFormat,
    locale: "fr",
    "max-date": /* @__PURE__ */ new Date(),
    position: i.isDesktop ? "left" : "center"
  }, null, 8, ["placeholder", "modelValue", "multiCalendars", "presetRanges", "format", "max-date", "position"]);
}
const p0e = /* @__PURE__ */ we(cK, [["render", dK]]), fK = {
  name: "StackedField",
  components: {
    InformationCircleIcon: ds
  },
  props: {
    label: {
      type: String,
      required: !0
    },
    value: {
      type: [String, Number],
      default: null
    },
    tooltip: {
      type: String,
      default: null
    }
  },
  computed: {
    displayValue() {
      return this.value != null && this.value !== "" ? this.value : "—";
    }
  }
}, hK = { class: "flex gap-x-1 items-center" }, pK = { class: "text-sm font-semibold text-gray-900" }, mK = { class: "text-sm text-gray-600 mt-1" };
function gK(e, t, n, r, i, a) {
  const s = U("InformationCircleIcon"), o = U("VTooltip");
  return _(), O("div", null, [
    k("div", hK, [
      k("span", pK, j(n.label), 1),
      n.tooltip ? (_(), ae(o, {
        key: 0,
        theme: "info-tooltip"
      }, {
        popper: ie(() => [
          k("span", null, j(n.tooltip), 1)
        ]),
        default: ie(() => [
          W(s, {
            class: "cursor-pointer h-4 w-4 text-gray-400",
            "aria-hidden": "true"
          })
        ]),
        _: 1
      })) : L("", !0)
    ]),
    k("div", mK, [
      xe(e.$slots, "default", {}, () => [
        Me(j(a.displayValue), 1)
      ])
    ])
  ]);
}
const yp = /* @__PURE__ */ we(fK, [["render", gK]]), vK = {
  components: {
    PaperClipIcon: Qw,
    EyeIcon: cB,
    ExclamationCircleIcon: uh,
    DocumentTextIcon: Af,
    HomeIcon: Zw,
    FolderIcon: Xw,
    PhotographIcon: gg,
    StackedField: yp
  },
  props: {
    declaration: {
      type: Object,
      required: !0
    },
    showAcknowledgments: {
      type: Boolean,
      default: !1
    },
    visibleFields: {
      type: Array,
      default: null
    }
  },
  computed: {
    hasPersonalInfoVisible() {
      return this.isAnyVisible([
        "last_name",
        "first_name",
        "email",
        "phone",
        "birth_date",
        "street_number",
        "street",
        "zip_code",
        "city",
        "country"
      ]);
    },
    hasClaimInfoVisible() {
      return this.isAnyVisible([
        "occurrence_date",
        "occurred_at_home",
        "occurrence_place",
        "coverage",
        "theft_type",
        "description",
        "marking_number",
        "fraudulent_sim_use",
        "is_invoice_holder",
        "breakdown_repaired_by_manufacturer",
        "breakdown_impact_or_drop"
      ]);
    },
    documentGroups() {
      return [
        {
          key: "idCard",
          field: "id_card",
          label: "Carte d'identité",
          icon: Qw
        },
        {
          key: "complaintsReceipt",
          field: "complaints_receipt",
          label: "Dépôt de plainte",
          icon: uh
        },
        {
          key: "productInvoice",
          field: "product_invoice",
          label: "Facture d'achat du produit",
          icon: Af
        },
        {
          key: "antiTheftDeviceInvoice",
          field: "anti_theft_device_invoice",
          label: "Facture d'achat de l'anti-vol",
          icon: Af
        },
        {
          key: "productPhotos",
          field: "product_photos",
          label: "Photos du produit",
          icon: gg
        },
        {
          key: "markingNumberPhotos",
          field: "marking_number_photos",
          label: "Photos du numéro de marquage",
          icon: gg
        },
        {
          key: "fraudulentSimUseProof",
          field: "fraudulent_sim_use_proof",
          label: "Justificatif utilisation frauduleuse SIM",
          icon: uh
        },
        {
          key: "invoiceHolderProof",
          field: "invoice_holder_proof",
          label: "Justificatif titulaire de la facture",
          icon: Af
        },
        {
          key: "homeInsuranceCertificate",
          field: "home_insurance_certificate",
          label: "Assurance habitation",
          icon: Zw
        },
        {
          key: "othersDocuments",
          field: "others_documents",
          label: "Autre(s) documents",
          icon: Xw
        }
      ].map((t) => {
        const n = this.declaration[t.key], r = Array.isArray(n) ? n : n ? [n] : [];
        return { ...t, files: r };
      }).filter((t) => t.files.length && this.isVisible(t.field));
    }
  },
  methods: {
    isVisible(e) {
      return !this.visibleFields || this.visibleFields.length === 0 ? !0 : this.visibleFields.includes(e);
    },
    isAnyVisible(e) {
      return !this.visibleFields || this.visibleFields.length === 0 ? !0 : e.some((t) => this.visibleFields.includes(t));
    },
    formatAddress() {
      const e = [];
      return this.isVisible("street_number") && this.declaration.streetNumber && e.push(this.declaration.streetNumber), this.isVisible("street") && this.declaration.street && e.push(this.declaration.street), this.isVisible("zip_code") && this.declaration.zipCode && e.push(this.declaration.zipCode), this.isVisible("city") && this.declaration.city && e.push(this.declaration.city), this.isVisible("country") && this.declaration.country && e.push(this.declaration.country), e.length > 0 ? e.join(", ") : null;
    },
    formatOccurrencePlace() {
      return this.isVisible("occurred_at_home") && this.declaration.occurredAtHome ? "Au domicile" : this.isVisible("occurrence_place") && this.declaration.occurrencePlace || null;
    }
  }
}, bK = { class: "space-y-6" }, _K = {
  key: 0,
  class: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-8 gap-y-2"
}, yK = { class: "space-y-2" }, xK = { class: "space-y-2" }, wK = { class: "space-y-2" }, kK = { key: 1 }, SK = { class: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-8 gap-y-2" }, CK = {
  key: 0,
  class: "my-2"
}, TK = { class: "whitespace-pre-line" }, AK = { class: "grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2" }, DK = { key: 2 }, EK = { class: "grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3" }, PK = { class: "flex gap-x-1.5 items-center" }, OK = { class: "text-sm font-semibold text-gray-900" }, MK = { class: "text-sm text-gray-600 mt-1" }, IK = { class: "flex flex-wrap gap-1.5" }, RK = ["href"], FK = { class: "shrink-0 w-5 h-5 rounded-full flex items-center justify-center mr-2 bg-gray-200" }, NK = { class: "text-xs text-gray-600 truncate" };
function LK(e, t, n, r, i, a) {
  const s = U("StackedField"), o = U("EyeIcon");
  return _(), O("div", null, [
    xe(e.$slots, "default"),
    k("div", bK, [
      a.hasPersonalInfoVisible ? (_(), O("div", _K, [
        k("div", yK, [
          a.isVisible("last_name") ? (_(), ae(s, {
            key: 0,
            label: "Nom",
            value: n.declaration.lastName
          }, null, 8, ["value"])) : L("", !0),
          a.isVisible("email") ? (_(), ae(s, {
            key: 1,
            label: "Email",
            value: n.declaration.email
          }, null, 8, ["value"])) : L("", !0),
          a.isVisible("birth_date") ? (_(), ae(s, {
            key: 2,
            label: "Date de naissance",
            value: n.declaration.birthDate ? e.$d(n.declaration.birthDate) : null
          }, null, 8, ["value"])) : L("", !0)
        ]),
        k("div", xK, [
          a.isVisible("first_name") ? (_(), ae(s, {
            key: 0,
            label: "Prénom",
            value: n.declaration.firstName
          }, null, 8, ["value"])) : L("", !0),
          a.isVisible("phone") ? (_(), ae(s, {
            key: 1,
            label: "Téléphone",
            value: n.declaration.phone
          }, null, 8, ["value"])) : L("", !0)
        ]),
        k("div", wK, [
          a.isAnyVisible([
            "street_number",
            "street",
            "zip_code",
            "city",
            "country"
          ]) ? (_(), ae(s, {
            key: 0,
            label: "Adresse",
            value: a.formatAddress()
          }, null, 8, ["value"])) : L("", !0)
        ])
      ])) : L("", !0),
      a.hasClaimInfoVisible ? (_(), O("div", kK, [
        t[0] || (t[0] = k("h3", { class: "text-lg font-bold text-gray-900 mb-4" }, "Sinistre", -1)),
        k("div", SK, [
          a.isVisible("occurrence_date") ? (_(), ae(s, {
            key: 0,
            label: "Date du sinistre",
            value: n.declaration.occurrenceDate ? e.$d(n.declaration.occurrenceDate) : null
          }, null, 8, ["value"])) : L("", !0),
          a.isAnyVisible(["occurred_at_home", "occurrence_place"]) ? (_(), ae(s, {
            key: 1,
            label: "Lieu du sinistre",
            value: a.formatOccurrencePlace()
          }, null, 8, ["value"])) : L("", !0),
          a.isVisible("coverage") ? (_(), ae(s, {
            key: 2,
            label: "Couverture",
            value: e.$t(`claim.coverage.${n.declaration.coverage}`)
          }, null, 8, ["value"])) : L("", !0),
          a.isVisible("theft_type") && n.declaration.theftType != null && ["theft", "partial_theft"].includes(n.declaration.coverage) ? (_(), ae(s, {
            key: 3,
            label: "Type de vol",
            value: n.declaration.theftType
          }, null, 8, ["value"])) : L("", !0)
        ]),
        a.isVisible("description") ? (_(), O("div", CK, [
          W(s, { label: "Description" }, {
            default: ie(() => [
              k("span", TK, j(n.declaration.description), 1)
            ]),
            _: 1
          })
        ])) : L("", !0),
        k("div", AK, [
          a.isVisible("marking_number") && n.declaration.markingNumber ? (_(), ae(s, {
            key: 0,
            label: "Marquage",
            value: n.declaration.markingNumber
          }, null, 8, ["value"])) : L("", !0),
          a.isVisible("fraudulent_sim_use") && n.declaration.fraudulentSimUse != null ? (_(), ae(s, {
            key: 1,
            label: "Utilisation frauduleuse SIM",
            value: n.declaration.fraudulentSimUse ? "Oui" : "Non"
          }, null, 8, ["value"])) : L("", !0),
          a.isVisible("is_invoice_holder") && n.declaration.isInvoiceHolder != null ? (_(), ae(s, {
            key: 2,
            label: "Titulaire de la facture",
            value: n.declaration.isInvoiceHolder ? "Oui" : "Non"
          }, null, 8, ["value"])) : L("", !0),
          a.isVisible("breakdown_repaired_by_manufacturer") && n.declaration.breakdownRepairedByManufacturer != null && n.declaration.coverage === "breakdown" ? (_(), ae(s, {
            key: 3,
            label: "Réparé par le constructeur",
            value: n.declaration.breakdownRepairedByManufacturer ? "Oui" : "Non"
          }, null, 8, ["value"])) : L("", !0),
          a.isVisible("breakdown_impact_or_drop") && n.declaration.breakdownImpactOrDrop != null && n.declaration.coverage === "breakdown" ? (_(), ae(s, {
            key: 4,
            label: "Choc ou chute",
            value: n.declaration.breakdownImpactOrDrop ? "Oui" : "Non"
          }, null, 8, ["value"])) : L("", !0)
        ])
      ])) : L("", !0),
      a.documentGroups.length ? (_(), O("div", DK, [
        t[1] || (t[1] = k("h3", { class: "text-lg font-bold text-gray-900 mb-4" }, "Documents", -1)),
        k("div", EK, [
          (_(!0), O(Re, null, Ke(a.documentGroups, (l) => (_(), O("div", {
            key: l.label
          }, [
            k("div", null, [
              k("div", PK, [
                k("span", OK, j(l.label), 1),
                xe(e.$slots, `doc-extra-${l.key}`)
              ]),
              k("div", MK, [
                k("div", IK, [
                  (_(!0), O(Re, null, Ke(l.files, (c) => (_(), O("a", {
                    key: c.name,
                    href: c.link,
                    target: "_blank",
                    class: "flex items-center rounded-md px-1.5 py-1 border min-w-0 max-w-xs transition-colors border-gray-300 bg-gray-100"
                  }, [
                    k("div", FK, [
                      (_(), ae(Lr(l.icon), { class: "h-3 w-3 text-gray-600" }))
                    ]),
                    k("span", NK, j(c.name), 1),
                    W(o, { class: "shrink-0 ml-1.5 h-3 w-3 text-gray-600" })
                  ], 8, RK))), 128))
                ])
              ])
            ])
          ]))), 128))
        ])
      ])) : L("", !0)
    ])
  ]);
}
const $K = /* @__PURE__ */ we(vK, [["render", LK]]);
/*!
 * vuex v4.1.0
 * (c) 2022 Evan You
 * @license MIT
 */
var VK = "store";
function sl(e, t) {
  Object.keys(e).forEach(function(n) {
    return t(e[n], n);
  });
}
function aM(e) {
  return e !== null && typeof e == "object";
}
function BK(e) {
  return e && typeof e.then == "function";
}
function da(e, t) {
  if (!e)
    throw new Error("[vuex] " + t);
}
function UK(e, t) {
  return function() {
    return e(t);
  };
}
function sM(e, t, n) {
  return t.indexOf(e) < 0 && (n && n.prepend ? t.unshift(e) : t.push(e)), function() {
    var r = t.indexOf(e);
    r > -1 && t.splice(r, 1);
  };
}
function oM(e, t) {
  e._actions = /* @__PURE__ */ Object.create(null), e._mutations = /* @__PURE__ */ Object.create(null), e._wrappedGetters = /* @__PURE__ */ Object.create(null), e._modulesNamespaceMap = /* @__PURE__ */ Object.create(null);
  var n = e.state;
  xp(e, n, [], e._modules.root, !0), q0(e, n, t);
}
function q0(e, t, n) {
  var r = e._state, i = e._scope;
  e.getters = {}, e._makeLocalGettersCache = /* @__PURE__ */ Object.create(null);
  var a = e._wrappedGetters, s = {}, o = {}, l = xP(!0);
  l.run(function() {
    sl(a, function(c, f) {
      s[f] = UK(c, e), o[f] = ce(function() {
        return s[f]();
      }), Object.defineProperty(e.getters, f, {
        get: function() {
          return o[f].value;
        },
        enumerable: !0
        // for local getters
      });
    });
  }), e._state = nl({
    data: t
  }), e._scope = l, e.strict && HK(e), r && n && e._withCommit(function() {
    r.data = null;
  }), i && i.stop();
}
function xp(e, t, n, r, i) {
  var a = !n.length, s = e._modules.getNamespace(n);
  if (r.namespaced && (e._modulesNamespaceMap[s] && process.env.NODE_ENV !== "production" && console.error("[vuex] duplicate namespace " + s + " for the namespaced module " + n.join("/")), e._modulesNamespaceMap[s] = r), !a && !i) {
    var o = j0(t, n.slice(0, -1)), l = n[n.length - 1];
    e._withCommit(function() {
      process.env.NODE_ENV !== "production" && l in o && console.warn(
        '[vuex] state field "' + l + '" was overridden by a module with the same name at "' + n.join(".") + '"'
      ), o[l] = r.state;
    });
  }
  var c = r.context = qK(e, s, n);
  r.forEachMutation(function(f, h) {
    var p = s + h;
    jK(e, p, f, c);
  }), r.forEachAction(function(f, h) {
    var p = f.root ? h : s + h, g = f.handler || f;
    WK(e, p, g, c);
  }), r.forEachGetter(function(f, h) {
    var p = s + h;
    zK(e, p, f, c);
  }), r.forEachChild(function(f, h) {
    xp(e, t, n.concat(h), f, i);
  });
}
function qK(e, t, n) {
  var r = t === "", i = {
    dispatch: r ? e.dispatch : function(a, s, o) {
      var l = $h(a, s, o), c = l.payload, f = l.options, h = l.type;
      if ((!f || !f.root) && (h = t + h, process.env.NODE_ENV !== "production" && !e._actions[h])) {
        console.error("[vuex] unknown local action type: " + l.type + ", global type: " + h);
        return;
      }
      return e.dispatch(h, c);
    },
    commit: r ? e.commit : function(a, s, o) {
      var l = $h(a, s, o), c = l.payload, f = l.options, h = l.type;
      if ((!f || !f.root) && (h = t + h, process.env.NODE_ENV !== "production" && !e._mutations[h])) {
        console.error("[vuex] unknown local mutation type: " + l.type + ", global type: " + h);
        return;
      }
      e.commit(h, c, f);
    }
  };
  return Object.defineProperties(i, {
    getters: {
      get: r ? function() {
        return e.getters;
      } : function() {
        return lM(e, t);
      }
    },
    state: {
      get: function() {
        return j0(e.state, n);
      }
    }
  }), i;
}
function lM(e, t) {
  if (!e._makeLocalGettersCache[t]) {
    var n = {}, r = t.length;
    Object.keys(e.getters).forEach(function(i) {
      if (i.slice(0, r) === t) {
        var a = i.slice(r);
        Object.defineProperty(n, a, {
          get: function() {
            return e.getters[i];
          },
          enumerable: !0
        });
      }
    }), e._makeLocalGettersCache[t] = n;
  }
  return e._makeLocalGettersCache[t];
}
function jK(e, t, n, r) {
  var i = e._mutations[t] || (e._mutations[t] = []);
  i.push(function(s) {
    n.call(e, r.state, s);
  });
}
function WK(e, t, n, r) {
  var i = e._actions[t] || (e._actions[t] = []);
  i.push(function(s) {
    var o = n.call(e, {
      dispatch: r.dispatch,
      commit: r.commit,
      getters: r.getters,
      state: r.state,
      rootGetters: e.getters,
      rootState: e.state
    }, s);
    return BK(o) || (o = Promise.resolve(o)), e._devtoolHook ? o.catch(function(l) {
      throw e._devtoolHook.emit("vuex:error", l), l;
    }) : o;
  });
}
function zK(e, t, n, r) {
  if (e._wrappedGetters[t]) {
    process.env.NODE_ENV !== "production" && console.error("[vuex] duplicate getter key: " + t);
    return;
  }
  e._wrappedGetters[t] = function(a) {
    return n(
      r.state,
      // local state
      r.getters,
      // local getters
      a.state,
      // root state
      a.getters
      // root getters
    );
  };
}
function HK(e) {
  Ln(function() {
    return e._state.data;
  }, function() {
    process.env.NODE_ENV !== "production" && da(e._committing, "do not mutate vuex store state outside mutation handlers.");
  }, { deep: !0, flush: "sync" });
}
function j0(e, t) {
  return t.reduce(function(n, r) {
    return n[r];
  }, e);
}
function $h(e, t, n) {
  return aM(e) && e.type && (n = t, t = e, e = e.type), process.env.NODE_ENV !== "production" && da(typeof e == "string", "expects string as the type, but found " + typeof e + "."), { type: e, payload: t, options: n };
}
var GK = "vuex bindings", US = "vuex:mutations", Hg = "vuex:actions", Bl = "vuex", YK = 0;
function KK(e, t) {
  u2(
    {
      id: "org.vuejs.vuex",
      app: e,
      label: "Vuex",
      homepage: "https://next.vuex.vuejs.org/",
      logo: "https://vuejs.org/images/icons/favicon-96x96.png",
      packageName: "vuex",
      componentStateTypes: [GK]
    },
    function(n) {
      n.addTimelineLayer({
        id: US,
        label: "Vuex Mutations",
        color: qS
      }), n.addTimelineLayer({
        id: Hg,
        label: "Vuex Actions",
        color: qS
      }), n.addInspector({
        id: Bl,
        label: "Vuex",
        icon: "storage",
        treeFilterPlaceholder: "Filter stores..."
      }), n.on.getInspectorTree(function(r) {
        if (r.app === e && r.inspectorId === Bl)
          if (r.filter) {
            var i = [];
            fM(i, t._modules.root, r.filter, ""), r.rootNodes = i;
          } else
            r.rootNodes = [
              dM(t._modules.root, "")
            ];
      }), n.on.getInspectorState(function(r) {
        if (r.app === e && r.inspectorId === Bl) {
          var i = r.nodeId;
          lM(t, i), r.state = QK(
            eX(t._modules, i),
            i === "root" ? t.getters : t._makeLocalGettersCache,
            i
          );
        }
      }), n.on.editInspectorState(function(r) {
        if (r.app === e && r.inspectorId === Bl) {
          var i = r.nodeId, a = r.path;
          i !== "root" && (a = i.split("/").filter(Boolean).concat(a)), t._withCommit(function() {
            r.set(t._state.data, a, r.state.value);
          });
        }
      }), t.subscribe(function(r, i) {
        var a = {};
        r.payload && (a.payload = r.payload), a.state = i, n.notifyComponentUpdate(), n.sendInspectorTree(Bl), n.sendInspectorState(Bl), n.addTimelineEvent({
          layerId: US,
          event: {
            time: Date.now(),
            title: r.type,
            data: a
          }
        });
      }), t.subscribeAction({
        before: function(r, i) {
          var a = {};
          r.payload && (a.payload = r.payload), r._id = YK++, r._time = Date.now(), a.state = i, n.addTimelineEvent({
            layerId: Hg,
            event: {
              time: r._time,
              title: r.type,
              groupId: r._id,
              subtitle: "start",
              data: a
            }
          });
        },
        after: function(r, i) {
          var a = {}, s = Date.now() - r._time;
          a.duration = {
            _custom: {
              type: "duration",
              display: s + "ms",
              tooltip: "Action duration",
              value: s
            }
          }, r.payload && (a.payload = r.payload), a.state = i, n.addTimelineEvent({
            layerId: Hg,
            event: {
              time: Date.now(),
              title: r.type,
              groupId: r._id,
              subtitle: "end",
              data: a
            }
          });
        }
      });
    }
  );
}
var qS = 8702998, XK = 6710886, ZK = 16777215, uM = {
  label: "namespaced",
  textColor: ZK,
  backgroundColor: XK
};
function cM(e) {
  return e && e !== "root" ? e.split("/").slice(-2, -1)[0] : "Root";
}
function dM(e, t) {
  return {
    id: t || "root",
    // all modules end with a `/`, we want the last segment only
    // cart/ -> cart
    // nested/cart/ -> cart
    label: cM(t),
    tags: e.namespaced ? [uM] : [],
    children: Object.keys(e._children).map(
      function(n) {
        return dM(
          e._children[n],
          t + n + "/"
        );
      }
    )
  };
}
function fM(e, t, n, r) {
  r.includes(n) && e.push({
    id: r || "root",
    label: r.endsWith("/") ? r.slice(0, r.length - 1) : r || "Root",
    tags: t.namespaced ? [uM] : []
  }), Object.keys(t._children).forEach(function(i) {
    fM(e, t._children[i], n, r + i + "/");
  });
}
function QK(e, t, n) {
  t = n === "root" ? t : t[n];
  var r = Object.keys(t), i = {
    state: Object.keys(e.state).map(function(s) {
      return {
        key: s,
        editable: !0,
        value: e.state[s]
      };
    })
  };
  if (r.length) {
    var a = JK(t);
    i.getters = Object.keys(a).map(function(s) {
      return {
        key: s.endsWith("/") ? cM(s) : s,
        editable: !1,
        value: Sy(function() {
          return a[s];
        })
      };
    });
  }
  return i;
}
function JK(e) {
  var t = {};
  return Object.keys(e).forEach(function(n) {
    var r = n.split("/");
    if (r.length > 1) {
      var i = t, a = r.pop();
      r.forEach(function(s) {
        i[s] || (i[s] = {
          _custom: {
            value: {},
            display: s,
            tooltip: "Module",
            abstract: !0
          }
        }), i = i[s]._custom.value;
      }), i[a] = Sy(function() {
        return e[n];
      });
    } else
      t[n] = Sy(function() {
        return e[n];
      });
  }), t;
}
function eX(e, t) {
  var n = t.split("/").filter(function(r) {
    return r;
  });
  return n.reduce(
    function(r, i, a) {
      var s = r[i];
      if (!s)
        throw new Error('Missing module "' + i + '" for path "' + t + '".');
      return a === n.length - 1 ? s : s._children;
    },
    t === "root" ? e : e.root._children
  );
}
function Sy(e) {
  try {
    return e();
  } catch (t) {
    return t;
  }
}
var fa = function(t, n) {
  this.runtime = n, this._children = /* @__PURE__ */ Object.create(null), this._rawModule = t;
  var r = t.state;
  this.state = (typeof r == "function" ? r() : r) || {};
}, hM = { namespaced: { configurable: !0 } };
hM.namespaced.get = function() {
  return !!this._rawModule.namespaced;
};
fa.prototype.addChild = function(t, n) {
  this._children[t] = n;
};
fa.prototype.removeChild = function(t) {
  delete this._children[t];
};
fa.prototype.getChild = function(t) {
  return this._children[t];
};
fa.prototype.hasChild = function(t) {
  return t in this._children;
};
fa.prototype.update = function(t) {
  this._rawModule.namespaced = t.namespaced, t.actions && (this._rawModule.actions = t.actions), t.mutations && (this._rawModule.mutations = t.mutations), t.getters && (this._rawModule.getters = t.getters);
};
fa.prototype.forEachChild = function(t) {
  sl(this._children, t);
};
fa.prototype.forEachGetter = function(t) {
  this._rawModule.getters && sl(this._rawModule.getters, t);
};
fa.prototype.forEachAction = function(t) {
  this._rawModule.actions && sl(this._rawModule.actions, t);
};
fa.prototype.forEachMutation = function(t) {
  this._rawModule.mutations && sl(this._rawModule.mutations, t);
};
Object.defineProperties(fa.prototype, hM);
var ol = function(t) {
  this.register([], t, !1);
};
ol.prototype.get = function(t) {
  return t.reduce(function(n, r) {
    return n.getChild(r);
  }, this.root);
};
ol.prototype.getNamespace = function(t) {
  var n = this.root;
  return t.reduce(function(r, i) {
    return n = n.getChild(i), r + (n.namespaced ? i + "/" : "");
  }, "");
};
ol.prototype.update = function(t) {
  pM([], this.root, t);
};
ol.prototype.register = function(t, n, r) {
  var i = this;
  r === void 0 && (r = !0), process.env.NODE_ENV !== "production" && mM(t, n);
  var a = new fa(n, r);
  if (t.length === 0)
    this.root = a;
  else {
    var s = this.get(t.slice(0, -1));
    s.addChild(t[t.length - 1], a);
  }
  n.modules && sl(n.modules, function(o, l) {
    i.register(t.concat(l), o, r);
  });
};
ol.prototype.unregister = function(t) {
  var n = this.get(t.slice(0, -1)), r = t[t.length - 1], i = n.getChild(r);
  if (!i) {
    process.env.NODE_ENV !== "production" && console.warn(
      "[vuex] trying to unregister module '" + r + "', which is not registered"
    );
    return;
  }
  i.runtime && n.removeChild(r);
};
ol.prototype.isRegistered = function(t) {
  var n = this.get(t.slice(0, -1)), r = t[t.length - 1];
  return n ? n.hasChild(r) : !1;
};
function pM(e, t, n) {
  if (process.env.NODE_ENV !== "production" && mM(e, n), t.update(n), n.modules)
    for (var r in n.modules) {
      if (!t.getChild(r)) {
        process.env.NODE_ENV !== "production" && console.warn(
          "[vuex] trying to add a new module '" + r + "' on hot reloading, manual reload is needed"
        );
        return;
      }
      pM(
        e.concat(r),
        t.getChild(r),
        n.modules[r]
      );
    }
}
var jS = {
  assert: function(e) {
    return typeof e == "function";
  },
  expected: "function"
}, tX = {
  assert: function(e) {
    return typeof e == "function" || typeof e == "object" && typeof e.handler == "function";
  },
  expected: 'function or object with "handler" function'
}, WS = {
  getters: jS,
  mutations: jS,
  actions: tX
};
function mM(e, t) {
  Object.keys(WS).forEach(function(n) {
    if (t[n]) {
      var r = WS[n];
      sl(t[n], function(i, a) {
        da(
          r.assert(i),
          nX(e, n, a, i, r.expected)
        );
      });
    }
  });
}
function nX(e, t, n, r, i) {
  var a = t + " should be " + i + ' but "' + t + "." + n + '"';
  return e.length > 0 && (a += ' in module "' + e.join(".") + '"'), a += " is " + JSON.stringify(r) + ".", a;
}
var Ti = function e(t) {
  var n = this;
  t === void 0 && (t = {}), process.env.NODE_ENV !== "production" && (da(typeof Promise < "u", "vuex requires a Promise polyfill in this browser."), da(this instanceof e, "store must be called with the new operator."));
  var r = t.plugins;
  r === void 0 && (r = []);
  var i = t.strict;
  i === void 0 && (i = !1);
  var a = t.devtools;
  this._committing = !1, this._actions = /* @__PURE__ */ Object.create(null), this._actionSubscribers = [], this._mutations = /* @__PURE__ */ Object.create(null), this._wrappedGetters = /* @__PURE__ */ Object.create(null), this._modules = new ol(t), this._modulesNamespaceMap = /* @__PURE__ */ Object.create(null), this._subscribers = [], this._makeLocalGettersCache = /* @__PURE__ */ Object.create(null), this._scope = null, this._devtools = a;
  var s = this, o = this, l = o.dispatch, c = o.commit;
  this.dispatch = function(p, g) {
    return l.call(s, p, g);
  }, this.commit = function(p, g, v) {
    return c.call(s, p, g, v);
  }, this.strict = i;
  var f = this._modules.root.state;
  xp(this, f, [], this._modules.root), q0(this, f), r.forEach(function(h) {
    return h(n);
  });
}, W0 = { state: { configurable: !0 } };
Ti.prototype.install = function(t, n) {
  t.provide(n || VK, this), t.config.globalProperties.$store = this;
  var r = this._devtools !== void 0 ? this._devtools : process.env.NODE_ENV !== "production" || !1;
  r && KK(t, this);
};
W0.state.get = function() {
  return this._state.data;
};
W0.state.set = function(e) {
  process.env.NODE_ENV !== "production" && da(!1, "use store.replaceState() to explicit replace store state.");
};
Ti.prototype.commit = function(t, n, r) {
  var i = this, a = $h(t, n, r), s = a.type, o = a.payload, l = a.options, c = { type: s, payload: o }, f = this._mutations[s];
  if (!f) {
    process.env.NODE_ENV !== "production" && console.error("[vuex] unknown mutation type: " + s);
    return;
  }
  this._withCommit(function() {
    f.forEach(function(p) {
      p(o);
    });
  }), this._subscribers.slice().forEach(function(h) {
    return h(c, i.state);
  }), process.env.NODE_ENV !== "production" && l && l.silent && console.warn(
    "[vuex] mutation type: " + s + ". Silent option has been removed. Use the filter functionality in the vue-devtools"
  );
};
Ti.prototype.dispatch = function(t, n) {
  var r = this, i = $h(t, n), a = i.type, s = i.payload, o = { type: a, payload: s }, l = this._actions[a];
  if (!l) {
    process.env.NODE_ENV !== "production" && console.error("[vuex] unknown action type: " + a);
    return;
  }
  try {
    this._actionSubscribers.slice().filter(function(f) {
      return f.before;
    }).forEach(function(f) {
      return f.before(o, r.state);
    });
  } catch (f) {
    process.env.NODE_ENV !== "production" && (console.warn("[vuex] error in before action subscribers: "), console.error(f));
  }
  var c = l.length > 1 ? Promise.all(l.map(function(f) {
    return f(s);
  })) : l[0](s);
  return new Promise(function(f, h) {
    c.then(function(p) {
      try {
        r._actionSubscribers.filter(function(g) {
          return g.after;
        }).forEach(function(g) {
          return g.after(o, r.state);
        });
      } catch (g) {
        process.env.NODE_ENV !== "production" && (console.warn("[vuex] error in after action subscribers: "), console.error(g));
      }
      f(p);
    }, function(p) {
      try {
        r._actionSubscribers.filter(function(g) {
          return g.error;
        }).forEach(function(g) {
          return g.error(o, r.state, p);
        });
      } catch (g) {
        process.env.NODE_ENV !== "production" && (console.warn("[vuex] error in error action subscribers: "), console.error(g));
      }
      h(p);
    });
  });
};
Ti.prototype.subscribe = function(t, n) {
  return sM(t, this._subscribers, n);
};
Ti.prototype.subscribeAction = function(t, n) {
  var r = typeof t == "function" ? { before: t } : t;
  return sM(r, this._actionSubscribers, n);
};
Ti.prototype.watch = function(t, n, r) {
  var i = this;
  return process.env.NODE_ENV !== "production" && da(typeof t == "function", "store.watch only accepts a function."), Ln(function() {
    return t(i.state, i.getters);
  }, n, Object.assign({}, r));
};
Ti.prototype.replaceState = function(t) {
  var n = this;
  this._withCommit(function() {
    n._state.data = t;
  });
};
Ti.prototype.registerModule = function(t, n, r) {
  r === void 0 && (r = {}), typeof t == "string" && (t = [t]), process.env.NODE_ENV !== "production" && (da(Array.isArray(t), "module path must be a string or an Array."), da(t.length > 0, "cannot register the root module by using registerModule.")), this._modules.register(t, n), xp(this, this.state, t, this._modules.get(t), r.preserveState), q0(this, this.state);
};
Ti.prototype.unregisterModule = function(t) {
  var n = this;
  typeof t == "string" && (t = [t]), process.env.NODE_ENV !== "production" && da(Array.isArray(t), "module path must be a string or an Array."), this._modules.unregister(t), this._withCommit(function() {
    var r = j0(n.state, t.slice(0, -1));
    delete r[t[t.length - 1]];
  }), oM(this);
};
Ti.prototype.hasModule = function(t) {
  return typeof t == "string" && (t = [t]), process.env.NODE_ENV !== "production" && da(Array.isArray(t), "module path must be a string or an Array."), this._modules.isRegistered(t);
};
Ti.prototype.hotUpdate = function(t) {
  this._modules.update(t), oM(this, !0);
};
Ti.prototype._withCommit = function(t) {
  var n = this._committing;
  this._committing = !0, t(), this._committing = n;
};
Object.defineProperties(Ti.prototype, W0);
var gM = H0(function(e, t) {
  var n = {};
  return process.env.NODE_ENV !== "production" && !kp(t) && console.error("[vuex] mapState: mapper parameter must be either an Array or an Object"), z0(t).forEach(function(r) {
    var i = r.key, a = r.val;
    n[i] = function() {
      var o = this.$store.state, l = this.$store.getters;
      if (e) {
        var c = G0(this.$store, "mapState", e);
        if (!c)
          return;
        o = c.context.state, l = c.context.getters;
      }
      return typeof a == "function" ? a.call(this, o, l) : o[a];
    }, n[i].vuex = !0;
  }), n;
}), wp = H0(function(e, t) {
  var n = {};
  return process.env.NODE_ENV !== "production" && !kp(t) && console.error("[vuex] mapMutations: mapper parameter must be either an Array or an Object"), z0(t).forEach(function(r) {
    var i = r.key, a = r.val;
    n[i] = function() {
      for (var o = [], l = arguments.length; l--; ) o[l] = arguments[l];
      var c = this.$store.commit;
      if (e) {
        var f = G0(this.$store, "mapMutations", e);
        if (!f)
          return;
        c = f.context.commit;
      }
      return typeof a == "function" ? a.apply(this, [c].concat(o)) : c.apply(this.$store, [a].concat(o));
    };
  }), n;
}), qc = H0(function(e, t) {
  var n = {};
  return process.env.NODE_ENV !== "production" && !kp(t) && console.error("[vuex] mapActions: mapper parameter must be either an Array or an Object"), z0(t).forEach(function(r) {
    var i = r.key, a = r.val;
    n[i] = function() {
      for (var o = [], l = arguments.length; l--; ) o[l] = arguments[l];
      var c = this.$store.dispatch;
      if (e) {
        var f = G0(this.$store, "mapActions", e);
        if (!f)
          return;
        c = f.context.dispatch;
      }
      return typeof a == "function" ? a.apply(this, [c].concat(o)) : c.apply(this.$store, [a].concat(o));
    };
  }), n;
});
function z0(e) {
  return kp(e) ? Array.isArray(e) ? e.map(function(t) {
    return { key: t, val: t };
  }) : Object.keys(e).map(function(t) {
    return { key: t, val: e[t] };
  }) : [];
}
function kp(e) {
  return Array.isArray(e) || aM(e);
}
function H0(e) {
  return function(t, n) {
    return typeof t != "string" ? (n = t, t = "") : t.charAt(t.length - 1) !== "/" && (t += "/"), e(t, n);
  };
}
function G0(e, t, n) {
  var r = e._modulesNamespaceMap[n];
  return process.env.NODE_ENV !== "production" && !r && console.error("[vuex] module namespace not found in " + t + "(): " + n), r;
}
const Vn = {
  props: {
    componentStep: {
      type: Number,
      required: !0
    },
    currentStep: {
      type: Number,
      required: !0
    },
    originalDeclaration: {
      type: Object,
      required: !1
    },
    declarationUpdateRequest: {
      type: Object,
      required: !1
    }
  },
  emits: ["next", "previous"],
  data() {
    return {
      formData: new FormData(),
      saving: !1,
      uploadProgress: null,
      abortController: null
    };
  },
  computed: {
    ...gM("claimDeclarations", [
      "contractCategory",
      "products",
      "coverages",
      "coverage",
      "occurredAtHome",
      "fraudulentSimUse",
      "isInvoiceHolder"
    ]),
    newVersionDeclaration() {
      return !!(this.originalDeclaration && this.declarationUpdateRequest);
    }
  },
  methods: {
    ...qc("claimDeclarations", ["update"]),
    async save() {
      if ([...this.formData.entries()].length === 0) return;
      this.saving = !0, this.uploadProgress = null, this.abortController = new AbortController();
      let e;
      try {
        e = await this.update({
          formData: this.formData,
          signal: this.abortController.signal,
          onUploadProgress: this.trackUploadProgress
        });
      } catch (t) {
        if (t.name === "AbortError" || t.message === "canceled") return;
        throw t;
      } finally {
        this.saving = !1, this.uploadProgress = null;
      }
      return e;
    },
    // Sur une étape sans pièce jointe l'envoi est instantané et la progression n'a
    // rien à montrer : on ne l'expose qu'à partir d'une charge significative.
    trackUploadProgress({ loaded: e, total: t }) {
      !t || t < 2e5 || (this.uploadProgress = Math.round(e / t * 100));
    },
    async nextStep() {
      const e = await this.save();
      e != null && e.success && this.$emit("next");
    },
    async previousStep() {
      var e;
      (e = this.abortController) == null || e.abort(), this.$emit("previous");
    },
    setFormData(e, t) {
      t != null ? this.formData.set(e, t) : this.formData.delete(e);
    },
    validateFormField(e, t = e) {
      return !this.enabled(e) || this.formData.get(t);
    },
    enabled(e) {
      return this.newVersionDeclaration ? this.declarationUpdateRequest.fields.includes(e) : !0;
    },
    anyEnabled(e) {
      return e.some(
        (t) => this.enabled(t)
      );
    },
    disabled(e) {
      return !this.enabled(e);
    }
  }
}, rX = {
  props: {
    secondary: {
      type: Boolean,
      default: !1
    },
    noScaling: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    defaultStyle: {
      type: String,
      default: "bg-primary border-transparent text-button-font-primary"
    }
  },
  computed: {
    cls() {
      return this.disabled ? "bg-gray-300 border-transparent text-gray-700 cursor-not-allowed" : this.secondary ? "bg-white border-gray-300 text-gray-700" : this.defaultStyle;
    }
  }
}, iX = ["disabled"];
function aX(e, t, n, r, i, a) {
  return _(), O("button", {
    class: Pe([
      "px-4 py-2",
      "border shadow-xs rounded-lg focus:outline-hidden focus:ring-primary",
      "text-sm font-medium",
      "inline-flex items-center",
      n.noScaling ? "" : "transition duration-300 transform hover:scale-105",
      a.cls
    ]),
    disabled: n.disabled
  }, [
    xe(e.$slots, "default")
  ], 10, iX);
}
const kn = /* @__PURE__ */ we(rX, [["render", aX]]);
function zS(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "",
    resource: {
      fr: {
        next: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Suivant" } },
        saving: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Enregistrement..." } },
        sending: { t: 0, b: { t: 2, i: [{ t: 3, v: "Envoi... " }, { t: 4, k: "progress" }, { t: 3, v: " %" }] } }
      },
      en: {
        next: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Next" } },
        saving: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Saving..." } },
        sending: { t: 0, b: { t: 2, i: [{ t: 3, v: "Uploading... " }, { t: 4, k: "progress" }, { t: 3, v: "%" }] } }
      }
    }
  });
}
const vM = {
  components: {
    GenericButton: kn
  },
  setup() {
    const { t: e } = nr();
    return { t: e };
  },
  props: {
    disabled: {
      type: Boolean,
      default: !1
    },
    saving: {
      type: Boolean,
      default: !1
    },
    // Pourcentage d'upload, `null` tant qu'il n'y a rien de significatif à afficher.
    progress: {
      type: Number,
      default: null
    }
  }
};
function sX(e, t, n, r, i, a) {
  const s = U("GenericButton");
  return _(), O("div", null, [
    W(s, {
      onClick: t[0] || (t[0] = sn((o) => e.$emit("click"), ["stop"])),
      "no-scaling": "",
      disabled: n.disabled || n.saving,
      class: "w-full"
    }, {
      default: ie(() => [
        n.saving && n.progress !== null ? (_(), O(Re, { key: 0 }, [
          Me(j(r.t("sending", { progress: n.progress })), 1)
        ], 64)) : n.saving ? (_(), O(Re, { key: 1 }, [
          Me(j(r.t("saving")), 1)
        ], 64)) : (_(), O(Re, { key: 2 }, [
          Me(j(r.t("next")), 1)
        ], 64))
      ]),
      _: 1
    }, 8, ["disabled"])
  ]);
}
typeof zS == "function" && zS(vM);
const Gn = /* @__PURE__ */ we(vM, [["render", sX]]), oX = {
  extends: Vn,
  requestFields: ["first_name", "last_name", "phone", "birth_date", "id_card"],
  components: {
    FormField: hu,
    BirthDateInput: Qj,
    FileField: hs,
    NextButton: Gn,
    GenericButton: kn
  },
  data() {
    return {
      requiredFieldsFilled: !1,
      firstName: null,
      lastName: null,
      phone: null,
      birthDate: null,
      birthDateValid: !1
    };
  },
  created() {
    this.newVersionDeclaration && !this.notSkippable && this.$emit("next"), this.prefillDataIfNeeded();
  },
  computed: {
    notSkippable() {
      return this.anyEnabled([
        "first_name",
        "last_name",
        "phone",
        "birth_date",
        "id_card"
      ]);
    }
  },
  watch: {
    firstName(e) {
      this.setFormData("first_name", e), this.updateRequiredFieldsFilled();
    },
    lastName(e) {
      this.setFormData("last_name", e), this.updateRequiredFieldsFilled();
    },
    phone(e) {
      this.setFormData("phone", e), this.updateRequiredFieldsFilled();
    },
    birthDate(e) {
      this.setFormData("birth_date", e), this.updateRequiredFieldsFilled();
    },
    currentStep(e, t) {
      e === this.componentStep && (this.notSkippable || (this.save(), t < e ? this.$emit("next") : this.$emit("previous")));
    }
  },
  methods: {
    prefillDataIfNeeded() {
      this.newVersionDeclaration && (this.firstName = this.originalDeclaration.firstName, this.lastName = this.originalDeclaration.lastName, this.phone = this.originalDeclaration.phone, this.birthDate = this.originalDeclaration.birthDate);
    },
    updateRequiredFieldsFilled() {
      this.requiredFieldsFilled = this.formData.get("first_name") && this.formData.get("last_name") && this.formData.get("phone") && this.formData.get("birth_date") && this.birthDateValid && this.validateFormField("id_card", "id_card[]");
    }
  }
}, lX = { class: "mt-5 flex justify-between gap-5" }, uX = { class: "pl-2" };
function cX(e, t, n, r, i, a) {
  const s = U("FormField"), o = U("BirthDateInput"), l = U("FileField"), c = U("GenericButton"), f = U("NextButton");
  return _(), O("div", null, [
    t[6] || (t[6] = k("h1", { class: "my-5 text-4xl font-extrabold tracking-tight text-gray-900" }, " Renseignez vos informations personnelles ", -1)),
    W(s, {
      id: "firstName",
      name: "firstName",
      class: "mt-5",
      modelValue: i.firstName,
      "onUpdate:modelValue": t[0] || (t[0] = (h) => i.firstName = h),
      label: "Prénom",
      disabled: e.disabled("first_name"),
      required: ""
    }, null, 8, ["modelValue", "disabled"]),
    W(s, {
      id: "lastName",
      name: "lastName",
      class: "mt-5",
      modelValue: i.lastName,
      "onUpdate:modelValue": t[1] || (t[1] = (h) => i.lastName = h),
      label: "Nom",
      disabled: e.disabled("last_name"),
      required: ""
    }, null, 8, ["modelValue", "disabled"]),
    W(s, {
      id: "phone",
      name: "phone",
      class: "mt-5",
      modelValue: i.phone,
      "onUpdate:modelValue": t[2] || (t[2] = (h) => i.phone = h),
      label: "Numéro de téléphone",
      disabled: e.disabled("phone"),
      required: ""
    }, null, 8, ["modelValue", "disabled"]),
    W(o, {
      id: "birthDate",
      name: "birthDate",
      class: "mt-5",
      modelValue: i.birthDate,
      "onUpdate:modelValue": t[3] || (t[3] = (h) => i.birthDate = h),
      disabled: e.disabled("birth_date"),
      minAge: 18,
      maxAge: 100,
      required: "",
      "onUpdate:valid": t[4] || (t[4] = (h) => {
        i.birthDateValid = h, a.updateRequiredFieldsFilled();
      })
    }, null, 8, ["modelValue", "disabled"]),
    e.enabled("id_card") ? (_(), ae(l, {
      key: 0,
      id: "id_card[]",
      class: "mt-5",
      multiple: "",
      maxFiles: 5,
      formData: e.formData,
      onFiles: a.updateRequiredFieldsFilled,
      label: "Justificatif d'identité",
      placeholder: "Choisir un fichier",
      required: ""
    }, null, 8, ["formData", "onFiles"])) : L("", !0),
    k("div", lX, [
      e.currentStep > 1 ? (_(), ae(c, {
        key: 0,
        onClick: e.previousStep,
        secondary: "",
        "no-scaling": "",
        class: "mr-2"
      }, {
        default: ie(() => [...t[5] || (t[5] = [
          Me(" Précédent ", -1)
        ])]),
        _: 1
      }, 8, ["onClick"])) : L("", !0),
      k("div", uX, [
        W(f, {
          onClick: e.nextStep,
          disabled: !i.requiredFieldsFilled,
          saving: e.saving,
          progress: e.uploadProgress
        }, null, 8, ["onClick", "disabled", "saving", "progress"])
      ])
    ])
  ]);
}
const HS = /* @__PURE__ */ we(oX, [["render", cX]]), bM = [
  { code: "AF", name: "Afghanistan", nameFr: "Afghanistan" },
  { code: "AL", name: "Albania", nameFr: "Albanie" },
  { code: "DZ", name: "Algeria", nameFr: "Algérie" },
  { code: "AD", name: "Andorra", nameFr: "Andorre" },
  { code: "AO", name: "Angola", nameFr: "Angola" },
  { code: "AI", name: "Anguilla", nameFr: "Anguilla" },
  { code: "AG", name: "Antigua & Barbuda", nameFr: "Antigua-et-Barbuda" },
  { code: "AR", name: "Argentina", nameFr: "Argentine" },
  { code: "AM", name: "Armenia", nameFr: "Arménie" },
  { code: "AW", name: "Aruba", nameFr: "Aruba" },
  { code: "AU", name: "Australia", nameFr: "Australie" },
  { code: "AT", name: "Austria", nameFr: "Autriche" },
  { code: "AZ", name: "Azerbaijan", nameFr: "Azerbaïdjan" },
  { code: "BS", name: "Bahamas", nameFr: "Bahamas" },
  { code: "BH", name: "Bahrain", nameFr: "Bahreïn" },
  { code: "BD", name: "Bangladesh", nameFr: "Bangladesh" },
  { code: "BB", name: "Barbados", nameFr: "Barbade" },
  { code: "BY", name: "Belarus", nameFr: "Biélorussie" },
  { code: "BE", name: "Belgium", nameFr: "Belgique" },
  { code: "BZ", name: "Belize", nameFr: "Belize" },
  { code: "BJ", name: "Benin", nameFr: "Bénin" },
  { code: "BM", name: "Bermuda", nameFr: "Bermudes" },
  { code: "BT", name: "Bhutan", nameFr: "Bhoutan" },
  { code: "BO", name: "Bolivia", nameFr: "Bolivie" },
  { code: "BA", name: "Bosnia Herzegovina", nameFr: "Bosnie-Herzégovine" },
  { code: "BW", name: "Botswana", nameFr: "Botswana" },
  { code: "BR", name: "Brazil", nameFr: "Brésil" },
  { code: "BN", name: "Brunei", nameFr: "Brunei" },
  { code: "BG", name: "Bulgaria", nameFr: "Bulgarie" },
  { code: "BF", name: "Burkina Faso", nameFr: "Burkina Faso" },
  { code: "BI", name: "Burundi", nameFr: "Burundi" },
  { code: "KH", name: "Cambodia", nameFr: "Cambodge" },
  { code: "CM", name: "Cameroon", nameFr: "Cameroun" },
  { code: "CA", name: "Canada", nameFr: "Canada" },
  { code: "CV", name: "Cape Verde Islands", nameFr: "Cap-Vert" },
  { code: "KY", name: "Cayman Islands", nameFr: "Îles Caïmans" },
  {
    code: "CF",
    name: "Central African Republic",
    nameFr: "République centrafricaine"
  },
  { code: "TD", name: "Chad", nameFr: "Tchad" },
  { code: "CL", name: "Chile", nameFr: "Chili" },
  { code: "CN", name: "China", nameFr: "Chine" },
  { code: "CO", name: "Colombia", nameFr: "Colombie" },
  { code: "KM", name: "Comoros", nameFr: "Comores" },
  { code: "CG", name: "Congo", nameFr: "Congo" },
  {
    code: "CD",
    name: "Congo, Democratic Republic",
    nameFr: "Rép. dém. du Congo"
  },
  { code: "CK", name: "Cook Islands", nameFr: "Îles Cook" },
  { code: "CR", name: "Costa Rica", nameFr: "Costa Rica" },
  { code: "CI", name: "Côte d'Ivoire", nameFr: "Côte d'Ivoire" },
  { code: "HR", name: "Croatia", nameFr: "Croatie" },
  { code: "CU", name: "Cuba", nameFr: "Cuba" },
  { code: "CY", name: "Cyprus", nameFr: "Chypre" },
  { code: "CZ", name: "Czech Republic", nameFr: "République tchèque" },
  { code: "DK", name: "Denmark", nameFr: "Danemark" },
  { code: "DJ", name: "Djibouti", nameFr: "Djibouti" },
  { code: "DM", name: "Dominica", nameFr: "Dominique" },
  { code: "DO", name: "Dominican Republic", nameFr: "République dominicaine" },
  { code: "EC", name: "Ecuador", nameFr: "Équateur" },
  { code: "EG", name: "Egypt", nameFr: "Égypte" },
  { code: "SV", name: "El Salvador", nameFr: "Salvador" },
  { code: "GQ", name: "Equatorial Guinea", nameFr: "Guinée équatoriale" },
  { code: "ER", name: "Eritrea", nameFr: "Érythrée" },
  { code: "EE", name: "Estonia", nameFr: "Estonie" },
  { code: "ET", name: "Ethiopia", nameFr: "Éthiopie" },
  { code: "FK", name: "Falkland Islands", nameFr: "Îles Malouines" },
  { code: "FO", name: "Faroe Islands", nameFr: "Îles Féroé" },
  { code: "FJ", name: "Fiji", nameFr: "Fidji" },
  { code: "FI", name: "Finland", nameFr: "Finlande" },
  { code: "FR", name: "France", nameFr: "France" },
  { code: "GF", name: "French Guiana", nameFr: "Guyane française" },
  { code: "PF", name: "French Polynesia", nameFr: "Polynésie française" },
  { code: "GA", name: "Gabon", nameFr: "Gabon" },
  { code: "GM", name: "Gambia", nameFr: "Gambie" },
  { code: "GE", name: "Georgia", nameFr: "Géorgie" },
  { code: "DE", name: "Germany", nameFr: "Allemagne" },
  { code: "GH", name: "Ghana", nameFr: "Ghana" },
  { code: "GI", name: "Gibraltar", nameFr: "Gibraltar" },
  { code: "GR", name: "Greece", nameFr: "Grèce" },
  { code: "GL", name: "Greenland", nameFr: "Groenland" },
  { code: "GD", name: "Grenada", nameFr: "Grenade" },
  { code: "GP", name: "Guadeloupe", nameFr: "Guadeloupe" },
  { code: "GU", name: "Guam", nameFr: "Guam" },
  { code: "GT", name: "Guatemala", nameFr: "Guatemala" },
  { code: "GN", name: "Guinea", nameFr: "Guinée" },
  { code: "GW", name: "Guinea - Bissau", nameFr: "Guinée-Bissau" },
  { code: "GY", name: "Guyana", nameFr: "Guyane" },
  { code: "HT", name: "Haiti", nameFr: "Haïti" },
  { code: "HN", name: "Honduras", nameFr: "Honduras" },
  { code: "HK", name: "Hong Kong", nameFr: "Hong Kong" },
  { code: "HU", name: "Hungary", nameFr: "Hongrie" },
  { code: "IS", name: "Iceland", nameFr: "Islande" },
  { code: "IN", name: "India", nameFr: "Inde" },
  { code: "ID", name: "Indonesia", nameFr: "Indonésie" },
  { code: "IR", name: "Iran", nameFr: "Iran" },
  { code: "IQ", name: "Iraq", nameFr: "Irak" },
  { code: "IE", name: "Ireland", nameFr: "Irlande" },
  { code: "IL", name: "Israel", nameFr: "Israël" },
  { code: "IT", name: "Italy", nameFr: "Italie" },
  { code: "JM", name: "Jamaica", nameFr: "Jamaïque" },
  { code: "JP", name: "Japan", nameFr: "Japon" },
  { code: "JO", name: "Jordan", nameFr: "Jordanie" },
  { code: "KZ", name: "Kazakhstan", nameFr: "Kazakhstan" },
  { code: "KE", name: "Kenya", nameFr: "Kenya" },
  { code: "KI", name: "Kiribati", nameFr: "Kiribati" },
  { code: "KP", name: "Korea North", nameFr: "Corée du Nord" },
  { code: "KR", name: "Korea South", nameFr: "Corée du Sud" },
  { code: "KW", name: "Kuwait", nameFr: "Koweït" },
  { code: "KG", name: "Kyrgyzstan", nameFr: "Kirghizistan" },
  { code: "LA", name: "Laos", nameFr: "Laos" },
  { code: "LV", name: "Latvia", nameFr: "Lettonie" },
  { code: "LB", name: "Lebanon", nameFr: "Liban" },
  { code: "LS", name: "Lesotho", nameFr: "Lesotho" },
  { code: "LR", name: "Liberia", nameFr: "Liberia" },
  { code: "LY", name: "Libya", nameFr: "Libye" },
  { code: "LI", name: "Liechtenstein", nameFr: "Liechtenstein" },
  { code: "LT", name: "Lithuania", nameFr: "Lituanie" },
  { code: "LU", name: "Luxembourg", nameFr: "Luxembourg" },
  { code: "MO", name: "Macao", nameFr: "Macao" },
  { code: "MK", name: "Macedonia", nameFr: "Macédoine" },
  { code: "MG", name: "Madagascar", nameFr: "Madagascar" },
  { code: "MW", name: "Malawi", nameFr: "Malawi" },
  { code: "MY", name: "Malaysia", nameFr: "Malaisie" },
  { code: "MV", name: "Maldives", nameFr: "Maldives" },
  { code: "ML", name: "Mali", nameFr: "Mali" },
  { code: "MT", name: "Malta", nameFr: "Malte" },
  { code: "MH", name: "Marshall Islands", nameFr: "Îles Marshall" },
  { code: "MQ", name: "Martinique", nameFr: "Martinique" },
  { code: "MR", name: "Mauritania", nameFr: "Mauritanie" },
  { code: "MU", name: "Mauritius", nameFr: "Maurice" },
  { code: "YT", name: "Mayotte", nameFr: "Mayotte" },
  { code: "MX", name: "Mexico", nameFr: "Mexique" },
  { code: "FM", name: "Micronesia", nameFr: "Micronésie" },
  { code: "MD", name: "Moldova", nameFr: "Moldavie" },
  { code: "MC", name: "Monaco", nameFr: "Monaco" },
  { code: "MN", name: "Mongolia", nameFr: "Mongolie" },
  { code: "ME", name: "Montenegro", nameFr: "Monténégro" },
  { code: "MS", name: "Montserrat", nameFr: "Montserrat" },
  { code: "MA", name: "Morocco", nameFr: "Maroc" },
  { code: "MZ", name: "Mozambique", nameFr: "Mozambique" },
  { code: "MM", name: "Myanmar", nameFr: "Myanmar" },
  { code: "NA", name: "Namibia", nameFr: "Namibie" },
  { code: "NR", name: "Nauru", nameFr: "Nauru" },
  { code: "NP", name: "Nepal", nameFr: "Népal" },
  { code: "NL", name: "Netherlands", nameFr: "Pays-Bas" },
  { code: "NC", name: "New Caledonia", nameFr: "Nouvelle-Calédonie" },
  { code: "NZ", name: "New Zealand", nameFr: "Nouvelle-Zélande" },
  { code: "NI", name: "Nicaragua", nameFr: "Nicaragua" },
  { code: "NE", name: "Niger", nameFr: "Niger" },
  { code: "NG", name: "Nigeria", nameFr: "Nigeria" },
  { code: "NU", name: "Niue", nameFr: "Niue" },
  { code: "NF", name: "Norfolk Islands", nameFr: "Île Norfolk" },
  { code: "MP", name: "Northern Marianas", nameFr: "Îles Mariannes du Nord" },
  { code: "NO", name: "Norway", nameFr: "Norvège" },
  { code: "OM", name: "Oman", nameFr: "Oman" },
  { code: "PK", name: "Pakistan", nameFr: "Pakistan" },
  { code: "PW", name: "Palau", nameFr: "Palaos" },
  { code: "PA", name: "Panama", nameFr: "Panama" },
  { code: "PG", name: "Papua New Guinea", nameFr: "Papouasie-Nouvelle-Guinée" },
  { code: "PY", name: "Paraguay", nameFr: "Paraguay" },
  { code: "PE", name: "Peru", nameFr: "Pérou" },
  { code: "PH", name: "Philippines", nameFr: "Philippines" },
  { code: "PL", name: "Poland", nameFr: "Pologne" },
  { code: "PT", name: "Portugal", nameFr: "Portugal" },
  { code: "PR", name: "Puerto Rico", nameFr: "Porto Rico" },
  { code: "QA", name: "Qatar", nameFr: "Qatar" },
  { code: "RE", name: "Reunion", nameFr: "La Réunion" },
  { code: "RO", name: "Romania", nameFr: "Roumanie" },
  { code: "RU", name: "Russia", nameFr: "Russie" },
  { code: "RW", name: "Rwanda", nameFr: "Rwanda" },
  { code: "WS", name: "Samoa", nameFr: "Samoa" },
  { code: "SM", name: "San Marino", nameFr: "Saint-Marin" },
  {
    code: "ST",
    name: "Sao Tome & Principe",
    nameFr: "Sao Tomé-et-Principe"
  },
  { code: "SA", name: "Saudi Arabia", nameFr: "Arabie saoudite" },
  { code: "SN", name: "Senegal", nameFr: "Sénégal" },
  { code: "RS", name: "Serbia", nameFr: "Serbie" },
  { code: "SC", name: "Seychelles", nameFr: "Seychelles" },
  { code: "SL", name: "Sierra Leone", nameFr: "Sierra Leone" },
  { code: "SG", name: "Singapore", nameFr: "Singapour" },
  { code: "SK", name: "Slovak Republic", nameFr: "Slovaquie" },
  { code: "SI", name: "Slovenia", nameFr: "Slovénie" },
  { code: "SB", name: "Solomon Islands", nameFr: "Îles Salomon" },
  { code: "SO", name: "Somalia", nameFr: "Somalie" },
  { code: "ZA", name: "South Africa", nameFr: "Afrique du Sud" },
  { code: "SS", name: "South Sudan", nameFr: "Soudan du Sud" },
  { code: "ES", name: "Spain", nameFr: "Espagne" },
  { code: "LK", name: "Sri Lanka", nameFr: "Sri Lanka" },
  { code: "SH", name: "St. Helena", nameFr: "Sainte-Hélène" },
  { code: "KN", name: "St. Kitts", nameFr: "Saint-Kitts-et-Nevis" },
  { code: "LC", name: "St. Lucia", nameFr: "Sainte-Lucie" },
  {
    code: "VC",
    name: "St. Vincent & Grenadines",
    nameFr: "Saint-Vincent-et-les-Grenadines"
  },
  { code: "SD", name: "Sudan", nameFr: "Soudan" },
  { code: "SR", name: "Suriname", nameFr: "Suriname" },
  { code: "SZ", name: "Swaziland", nameFr: "Eswatini" },
  { code: "SE", name: "Sweden", nameFr: "Suède" },
  { code: "CH", name: "Switzerland", nameFr: "Suisse" },
  { code: "SY", name: "Syria", nameFr: "Syrie" },
  { code: "TW", name: "Taiwan", nameFr: "Taïwan" },
  { code: "TJ", name: "Tajikstan", nameFr: "Tadjikistan" },
  { code: "TZ", name: "Tanzania", nameFr: "Tanzanie" },
  { code: "TH", name: "Thailand", nameFr: "Thaïlande" },
  { code: "TL", name: "Timor-Leste", nameFr: "Timor oriental" },
  { code: "TG", name: "Togo", nameFr: "Togo" },
  { code: "TO", name: "Tonga", nameFr: "Tonga" },
  { code: "TT", name: "Trinidad & Tobago", nameFr: "Trinité-et-Tobago" },
  { code: "TN", name: "Tunisia", nameFr: "Tunisie" },
  { code: "TR", name: "Turkey", nameFr: "Turquie" },
  { code: "TM", name: "Turkmenistan", nameFr: "Turkménistan" },
  {
    code: "TC",
    name: "Turks & Caicos Islands",
    nameFr: "Îles Turques-et-Caïques"
  },
  { code: "TV", name: "Tuvalu", nameFr: "Tuvalu" },
  { code: "UG", name: "Uganda", nameFr: "Ouganda" },
  { code: "GB", name: "UK", nameFr: "Royaume-Uni" },
  { code: "UA", name: "Ukraine", nameFr: "Ukraine" },
  { code: "AE", name: "United Arab Emirates", nameFr: "Émirats arabes unis" },
  { code: "UY", name: "Uruguay", nameFr: "Uruguay" },
  { code: "US", name: "USA", nameFr: "États-Unis" },
  { code: "UZ", name: "Uzbekistan", nameFr: "Ouzbékistan" },
  { code: "VU", name: "Vanuatu", nameFr: "Vanuatu" },
  { code: "VA", name: "Vatican City", nameFr: "Vatican" },
  { code: "VE", name: "Venezuela", nameFr: "Venezuela" },
  { code: "VN", name: "Vietnam", nameFr: "Viêt Nam" },
  {
    code: "VG",
    name: "Virgin Islands - British",
    nameFr: "Îles Vierges britanniques"
  },
  {
    code: "VI",
    name: "Virgin Islands - US",
    nameFr: "Îles Vierges américaines"
  },
  { code: "YE", name: "Yemen", nameFr: "Yémen" },
  { code: "ZM", name: "Zambia", nameFr: "Zambie" },
  { code: "ZW", name: "Zimbabwe", nameFr: "Zimbabwe" }
], dX = {
  extends: Vn,
  requestFields: ["street_number", "street", "zip_code", "city", "country"],
  components: {
    FormField: hu,
    NextButton: Gn,
    GenericButton: kn,
    Selector: hY
  },
  data() {
    return {
      requiredFieldsFilled: !1,
      streetNumber: null,
      street: null,
      zipCode: null,
      city: null,
      country: null
    };
  },
  created() {
    this.newVersionDeclaration && this.notSkippable && (this.streetNumber = this.originalDeclaration.streetNumber, this.street = this.originalDeclaration.street, this.zipCode = this.originalDeclaration.zipCode, this.city = this.originalDeclaration.city, this.country = this.originalDeclaration.country);
  },
  computed: {
    countryOptions() {
      return bM.map((e) => ({
        label: e.name,
        value: e.code
      }));
    },
    notSkippable() {
      return this.anyEnabled(["street_number", "street", "zip_code", "city", "country"]);
    }
  },
  watch: {
    streetNumber(e) {
      this.setFormData("street_number", e), this.updateRequiredFieldsFilled();
    },
    street(e) {
      this.setFormData("street", e), this.updateRequiredFieldsFilled();
    },
    zipCode(e) {
      this.setFormData("zip_code", e), this.updateRequiredFieldsFilled();
    },
    city(e) {
      this.setFormData("city", e), this.updateRequiredFieldsFilled();
    },
    country(e) {
      this.setFormData("country", e), this.updateRequiredFieldsFilled();
    },
    currentStep(e, t) {
      e === this.componentStep && (this.notSkippable || (this.save(), t < e ? this.$emit("next") : this.$emit("previous")));
    }
  },
  methods: {
    updateRequiredFieldsFilled() {
      this.requiredFieldsFilled = this.formData.get("street_number") && this.formData.get("street") && this.formData.get("zip_code") && this.formData.get("city") && this.formData.get("country");
    }
  }
}, fX = { class: "md:flex justify-between gap-5" }, hX = { class: "flex-1 md:pl-2" }, pX = { class: "md:flex justify-between gap-5" }, mX = { class: "flex-1 md:pl-2" }, gX = { class: "mt-5 flex justify-between gap-5" }, vX = { class: "pl-2" };
function bX(e, t, n, r, i, a) {
  const s = U("FormField"), o = U("Selector"), l = U("GenericButton"), c = U("NextButton");
  return _(), O("div", null, [
    t[6] || (t[6] = k("h1", { class: "my-5 text-4xl font-extrabold tracking-tight text-gray-900" }, "Renseignez votre adresse postale", -1)),
    t[7] || (t[7] = k("p", null, "Cette adresse sera utilisée pour l'envoi de votre produit en cas de remplacement ou de réparation.", -1)),
    k("div", fX, [
      W(s, {
        id: "streetNumber",
        name: "streetNumber",
        class: "mt-5",
        modelValue: i.streetNumber,
        "onUpdate:modelValue": t[0] || (t[0] = (f) => i.streetNumber = f),
        label: "Numéro",
        disabled: e.disabled("street_number"),
        required: ""
      }, null, 8, ["modelValue", "disabled"]),
      k("div", hX, [
        W(s, {
          id: "street",
          name: "street",
          class: "mt-5",
          modelValue: i.street,
          "onUpdate:modelValue": t[1] || (t[1] = (f) => i.street = f),
          label: "Rue",
          disabled: e.disabled("street"),
          required: ""
        }, null, 8, ["modelValue", "disabled"])
      ])
    ]),
    k("div", pX, [
      W(s, {
        id: "zipCode",
        name: "zipCode",
        class: "mt-5",
        modelValue: i.zipCode,
        "onUpdate:modelValue": t[2] || (t[2] = (f) => i.zipCode = f),
        label: "Code postal",
        disabled: e.disabled("zip_code"),
        required: ""
      }, null, 8, ["modelValue", "disabled"]),
      k("div", mX, [
        W(s, {
          id: "city",
          name: "city",
          class: "mt-5",
          modelValue: i.city,
          "onUpdate:modelValue": t[3] || (t[3] = (f) => i.city = f),
          label: "Ville",
          disabled: e.disabled("city"),
          required: ""
        }, null, 8, ["modelValue", "disabled"])
      ])
    ]),
    W(o, {
      id: "country",
      label: "Pays",
      name: "country",
      class: "mt-5",
      modelValue: i.country,
      "onUpdate:modelValue": t[4] || (t[4] = (f) => i.country = f),
      options: a.countryOptions,
      disabled: e.disabled("country"),
      required: ""
    }, null, 8, ["modelValue", "options", "disabled"]),
    k("div", gX, [
      e.currentStep > 1 ? (_(), ae(l, {
        key: 0,
        onClick: e.previousStep,
        secondary: "",
        "no-scaling": "",
        class: "mr-2"
      }, {
        default: ie(() => [...t[5] || (t[5] = [
          Me(" Précédent ", -1)
        ])]),
        _: 1
      }, 8, ["onClick"])) : L("", !0),
      k("div", vX, [
        W(c, {
          onClick: e.nextStep,
          disabled: !i.requiredFieldsFilled,
          saving: e.saving
        }, null, 8, ["onClick", "disabled", "saving"])
      ])
    ])
  ]);
}
const GS = /* @__PURE__ */ we(dX, [["render", bX]]), _X = {
  fr: {
    future_date_error: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "La date du sinistre ne peut pas être dans le futur." } }
  },
  en: {
    future_date_error: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "The incident date cannot be in the future." } }
  }
}, yX = {
  extends: Vn,
  requestFields: ["occurrence_date"],
  components: {
    FormField: hu,
    NextButton: Gn,
    GenericButton: kn
  },
  setup() {
    const { t: e } = nr({ messages: _X });
    return { t: e };
  },
  data() {
    return {
      requiredFieldsFilled: !1,
      occurrenceDate: null
    };
  },
  created() {
    this.newVersionDeclaration && this.notSkippable && (this.occurrenceDate = this.originalDeclaration.occurrenceDate);
  },
  watch: {
    occurrenceDate(e) {
      this.setFormData("occurrence_date", e), this.updateRequiredFieldsFilled();
    },
    currentStep(e, t) {
      e === this.componentStep && (this.notSkippable || (this.save(), t < e ? this.$emit("next") : this.$emit("previous")));
    }
  },
  computed: {
    notSkippable() {
      return this.enabled("occurrence_date");
    },
    isInFuture() {
      return this.occurrenceDate ? Y2(this.occurrenceDate) > Bc(/* @__PURE__ */ new Date()) : !1;
    }
  },
  methods: {
    updateRequiredFieldsFilled() {
      this.requiredFieldsFilled = !!this.formData.get("occurrence_date") && !this.isInFuture;
    }
  }
}, xX = { class: "mt-5 flex justify-between gap-5" }, wX = { class: "pl-2" };
function kX(e, t, n, r, i, a) {
  const s = U("FormField"), o = U("GenericButton"), l = U("NextButton");
  return _(), O("div", null, [
    t[2] || (t[2] = k("h1", { class: "my-5 text-4xl font-extrabold tracking-tight text-gray-900" }, "Quand le sinistre a-t-il eu lieu ?", -1)),
    W(s, {
      id: "occurrenceDate",
      name: "occurrenceDate",
      class: "mt-5",
      type: "date",
      modelValue: i.occurrenceDate,
      "onUpdate:modelValue": t[0] || (t[0] = (c) => i.occurrenceDate = c),
      disabled: e.disabled("occurrence_date"),
      label: "Date de survenance du sinistre",
      error: a.isInFuture ? r.t("future_date_error") : null,
      required: ""
    }, null, 8, ["modelValue", "disabled", "error"]),
    k("div", xX, [
      e.currentStep > 1 ? (_(), ae(o, {
        key: 0,
        onClick: e.previousStep,
        secondary: "",
        "no-scaling": "",
        class: "mr-2"
      }, {
        default: ie(() => [...t[1] || (t[1] = [
          Me(" Précédent ", -1)
        ])]),
        _: 1
      }, 8, ["onClick"])) : L("", !0),
      k("div", wX, [
        W(l, {
          onClick: e.nextStep,
          disabled: !i.requiredFieldsFilled,
          saving: e.saving
        }, null, 8, ["onClick", "disabled", "saving"])
      ])
    ])
  ]);
}
const YS = /* @__PURE__ */ we(yX, [["render", kX]]), SX = {
  extends: Vn,
  requestFields: ["occurred_at_home", "occurrence_place"],
  components: {
    Checkbox: fs,
    FormField: hu,
    NextButton: Gn,
    GenericButton: kn
  },
  data() {
    return {
      occurrencePlace: null,
      requiredFieldsFilled: !1
    };
  },
  created() {
    this.newVersionDeclaration && this.notSkippable ? (this.occurredAtHome = this.originalDeclaration.occurredAtHome, this.occurrencePlace = this.originalDeclaration.occurrencePlace) : this.occurredAtHome = null;
  },
  watch: {
    occurredAtHome: {
      immediate: !0,
      handler(e) {
        this.setFormData("occurred_at_home", e), e === !0 && (this.occurrencePlace = null), this.updateRequiredFieldsFilled();
      }
    },
    occurrencePlace(e) {
      this.setFormData("occurrence_place", e), this.updateRequiredFieldsFilled();
    },
    currentStep(e, t) {
      e === this.componentStep && (this.notSkippable || (this.save(), t < e ? this.$emit("next") : this.$emit("previous")));
    }
  },
  computed: {
    occurredAtHome: {
      get() {
        return this.$store.state.claimDeclarations.occurredAtHome;
      },
      set(e) {
        this.setOccurredAtHome(e);
      }
    },
    notSkippable() {
      return this.anyEnabled(["occurrence_place", "occurred_at_home"]);
    }
  },
  methods: {
    ...wp("claimDeclarations", ["setOccurredAtHome"]),
    updateRequiredFieldsFilled() {
      this.requiredFieldsFilled = this.occurredAtHome !== null && (this.occurredAtHome || this.formData.get("occurrence_place"));
    }
  }
}, CX = { class: "mt-5 flex justify-between gap-5" }, TX = { class: "pl-2" };
function AX(e, t, n, r, i, a) {
  const s = U("Checkbox"), o = U("FormField"), l = U("GenericButton"), c = U("NextButton");
  return _(), O("div", null, [
    t[4] || (t[4] = k("h1", { class: "my-5 text-4xl font-extrabold tracking-tight text-gray-900" }, " Le sinistre a-t-il eu lieu à votre domicile ? ", -1)),
    W(s, {
      id: "occurredAtHome",
      class: "mt-5",
      name: "occurredAtHome",
      label: "Oui",
      checkedValue: !0,
      disabled: e.disabled("occurred_at_home"),
      modelValue: a.occurredAtHome,
      "onUpdate:modelValue": t[0] || (t[0] = (f) => a.occurredAtHome = f)
    }, null, 8, ["disabled", "modelValue"]),
    W(s, {
      id: "occurredElseWhere",
      class: "mt-3",
      name: "occurredElseWhere",
      label: "Non",
      checkedValue: !1,
      disabled: e.disabled("occurred_at_home"),
      modelValue: a.occurredAtHome,
      "onUpdate:modelValue": t[1] || (t[1] = (f) => a.occurredAtHome = f)
    }, null, 8, ["disabled", "modelValue"]),
    a.occurredAtHome === !1 ? (_(), ae(o, {
      key: 0,
      id: "occurrencePlace",
      name: "occurrencePlace",
      class: "mt-5",
      modelValue: i.occurrencePlace,
      "onUpdate:modelValue": t[2] || (t[2] = (f) => i.occurrencePlace = f),
      label: "Où le sinistre a-t-il eu lieu ?",
      disabled: e.disabled("occurrence_place"),
      required: ""
    }, null, 8, ["modelValue", "disabled"])) : L("", !0),
    k("div", CX, [
      e.currentStep > 1 ? (_(), ae(l, {
        key: 0,
        onClick: e.previousStep,
        secondary: "",
        "no-scaling": "",
        class: "mr-2"
      }, {
        default: ie(() => [...t[3] || (t[3] = [
          Me(" Précédent ", -1)
        ])]),
        _: 1
      }, 8, ["onClick"])) : L("", !0),
      k("div", TX, [
        W(c, {
          onClick: e.nextStep,
          disabled: !i.requiredFieldsFilled,
          saving: e.saving
        }, null, 8, ["onClick", "disabled", "saving"])
      ])
    ])
  ]);
}
const KS = /* @__PURE__ */ we(SX, [["render", AX]]), DX = {
  extends: Vn,
  requestFields: ["coverage"],
  components: {
    Checkbox: fs,
    NextButton: Gn,
    GenericButton: kn
  },
  data() {
    return {
      requiredFieldsFilled: !1,
      coverageInternalValue: null
    };
  },
  created() {
    this.newVersionDeclaration && this.notSkippable && (this.coverageInternalValue = this.originalDeclaration.coverage);
  },
  computed: {
    options() {
      return this.coverages.map((e) => ({
        label: this.$t(`claim.coverage.${e}`),
        value: e
      }));
    },
    notSkippable() {
      return this.enabled("coverage");
    }
  },
  watch: {
    coverageInternalValue(e) {
      this.setCoverage(e), e ? this.formData.set("coverage", e) : this.formData.delete("coverage"), this.updateRequiredFieldsFilled();
    },
    currentStep(e, t) {
      e === this.componentStep && (this.notSkippable || (this.save(), t < e ? this.$emit("next") : this.$emit("previous")));
    }
  },
  methods: {
    ...wp("claimDeclarations", ["setCoverage"]),
    updateRequiredFieldsFilled() {
      this.requiredFieldsFilled = this.formData.get("coverage");
    }
  }
}, EX = { class: "mt-5 flex justify-between gap-5" }, PX = { class: "pl-2" };
function OX(e, t, n, r, i, a) {
  const s = U("Checkbox"), o = U("GenericButton"), l = U("NextButton");
  return _(), O("div", null, [
    t[2] || (t[2] = k("h1", { class: "my-5 text-4xl font-extrabold tracking-tight text-gray-900" }, "Que s’est-il passé ?", -1)),
    (_(!0), O(Re, null, Ke(a.options, (c, f) => (_(), ae(s, {
      key: f,
      id: `coverage${f}`,
      class: "mt-5",
      name: "coverage",
      label: c.label,
      checkedValue: c.value,
      uncheckedValue: null,
      disabled: e.disabled("coverage"),
      modelValue: i.coverageInternalValue,
      "onUpdate:modelValue": t[0] || (t[0] = (h) => i.coverageInternalValue = h)
    }, null, 8, ["id", "label", "checkedValue", "disabled", "modelValue"]))), 128)),
    k("div", EX, [
      e.currentStep > 1 ? (_(), ae(o, {
        key: 0,
        onClick: e.previousStep,
        secondary: "",
        "no-scaling": "",
        class: "mr-2"
      }, {
        default: ie(() => [...t[1] || (t[1] = [
          Me(" Précédent ", -1)
        ])]),
        _: 1
      }, 8, ["onClick"])) : L("", !0),
      k("div", PX, [
        W(l, {
          onClick: e.nextStep,
          disabled: !i.requiredFieldsFilled,
          saving: e.saving
        }, null, 8, ["onClick", "disabled", "saving"])
      ])
    ])
  ]);
}
const XS = /* @__PURE__ */ we(DX, [["render", OX]]), MX = {
  extends: Vn,
  requestFields: ["theft_type"],
  components: {
    Checkbox: fs,
    NextButton: Gn,
    GenericButton: kn
  },
  data() {
    return {
      requiredFieldsFilled: !1,
      theftType: null,
      options: [
        { label: "Vol par effraction", value: "Vol par effraction" },
        { label: "Vol par agression", value: "Vol par agression" },
        { label: "Vol suite à un cambriolage", value: "Vol suite à un cambriolage" },
        { label: "Autre", value: "Autre" }
      ]
    };
  },
  created() {
    this.newVersionDeclaration && this.notSkippable && (this.theftType = this.originalDeclaration.theftType);
  },
  computed: {
    notSkippable() {
      return this.enabled("theft_type");
    }
  },
  watch: {
    theftType(e) {
      this.setFormData("theft_type", e), this.updateRequiredFieldsFilled();
    },
    currentStep(e, t) {
      if (e === this.componentStep) {
        if (this.newVersionDeclaration) {
          if (this.notSkippable) return;
        } else {
          if (["theft", "partial_theft"].includes(this.coverage)) return;
          this.formData.delete("theft_type");
        }
        this.save(), t < e ? this.$emit("next") : this.$emit("previous");
      }
    }
  },
  methods: {
    updateRequiredFieldsFilled() {
      this.requiredFieldsFilled = this.formData.get("theft_type");
    }
  }
}, IX = { class: "mt-5 flex justify-between gap-5" }, RX = { class: "pl-2" };
function FX(e, t, n, r, i, a) {
  const s = U("Checkbox"), o = U("GenericButton"), l = U("NextButton");
  return _(), O("div", null, [
    t[2] || (t[2] = k("h1", { class: "my-5 text-4xl font-extrabold tracking-tight text-gray-900" }, "Type de vol", -1)),
    (_(!0), O(Re, null, Ke(i.options, (c, f) => (_(), ae(s, {
      key: f,
      id: `theftType${f}`,
      class: "mt-5",
      name: "theftType",
      label: c.label,
      checkedValue: c.value,
      uncheckedValue: null,
      disabled: e.disabled("theft_type"),
      modelValue: i.theftType,
      "onUpdate:modelValue": t[0] || (t[0] = (h) => i.theftType = h)
    }, null, 8, ["id", "label", "checkedValue", "disabled", "modelValue"]))), 128)),
    k("div", IX, [
      e.currentStep > 1 ? (_(), ae(o, {
        key: 0,
        onClick: e.previousStep,
        secondary: "",
        "no-scaling": "",
        class: "mr-2"
      }, {
        default: ie(() => [...t[1] || (t[1] = [
          Me(" Précédent ", -1)
        ])]),
        _: 1
      }, 8, ["onClick"])) : L("", !0),
      k("div", RX, [
        W(l, {
          onClick: e.nextStep,
          disabled: !i.requiredFieldsFilled,
          saving: e.saving
        }, null, 8, ["onClick", "disabled", "saving"])
      ])
    ])
  ]);
}
const ZS = /* @__PURE__ */ we(MX, [["render", FX]]), NX = {
  extends: Vn,
  requestFields: ["breakdown_repaired_by_manufacturer"],
  components: {
    Checkbox: fs,
    NextButton: Gn,
    GenericButton: kn
  },
  data() {
    return {
      requiredFieldsFilled: !1,
      repairedByManufacturer: null
    };
  },
  created() {
    this.newVersionDeclaration && this.notSkippable && (this.repairedByManufacturer = this.originalDeclaration.breakdownRepairedByManufacturer);
  },
  computed: {
    notSkippable() {
      return this.anyEnabled(["breakdown_repaired_by_manufacturer"]);
    }
  },
  watch: {
    repairedByManufacturer(e) {
      this.formData.set(
        "breakdown_repaired_by_manufacturer",
        e ? "true" : "false"
      ), this.updateRequiredFieldsFilled();
    },
    currentStep(e, t) {
      if (e === this.componentStep) {
        if (this.newVersionDeclaration) {
          if (this.notSkippable) return;
        } else {
          if (this.coverage === "breakdown") return;
          this.formData.delete("breakdown_repaired_by_manufacturer");
        }
        this.save(), t < e ? this.$emit("next") : this.$emit("previous");
      }
    }
  },
  methods: {
    updateRequiredFieldsFilled() {
      this.requiredFieldsFilled = this.repairedByManufacturer !== null && this.repairedByManufacturer !== void 0;
    }
  }
}, LX = { class: "mt-5 flex justify-between gap-5" }, $X = { class: "pl-2" };
function VX(e, t, n, r, i, a) {
  const s = U("Checkbox"), o = U("GenericButton"), l = U("NextButton");
  return _(), O("div", null, [
    t[3] || (t[3] = k("h1", { class: "my-5 text-4xl font-extrabold tracking-tight text-gray-900" }, " L'appareil a-t-il déjà été réparé par le constructeur ? ", -1)),
    W(s, {
      id: "repairedByManufacturer",
      class: "mt-5",
      name: "repairedByManufacturer",
      label: "Oui",
      checkedValue: !0,
      disabled: e.disabled("breakdown_repaired_by_manufacturer"),
      modelValue: i.repairedByManufacturer,
      "onUpdate:modelValue": t[0] || (t[0] = (c) => i.repairedByManufacturer = c)
    }, null, 8, ["disabled", "modelValue"]),
    W(s, {
      id: "notRepairedByManufacturer",
      class: "mt-3",
      name: "notRepairedByManufacturer",
      label: "Non",
      checkedValue: !1,
      disabled: e.disabled("breakdown_repaired_by_manufacturer"),
      modelValue: i.repairedByManufacturer,
      "onUpdate:modelValue": t[1] || (t[1] = (c) => i.repairedByManufacturer = c)
    }, null, 8, ["disabled", "modelValue"]),
    k("div", LX, [
      e.currentStep > 1 ? (_(), ae(o, {
        key: 0,
        onClick: e.previousStep,
        secondary: "",
        "no-scaling": "",
        class: "mr-2"
      }, {
        default: ie(() => [...t[2] || (t[2] = [
          Me(" Précédent ", -1)
        ])]),
        _: 1
      }, 8, ["onClick"])) : L("", !0),
      k("div", $X, [
        W(l, {
          onClick: e.nextStep,
          disabled: !i.requiredFieldsFilled,
          saving: e.saving
        }, null, 8, ["onClick", "disabled", "saving"])
      ])
    ])
  ]);
}
const QS = /* @__PURE__ */ we(NX, [["render", VX]]), BX = {
  extends: Vn,
  requestFields: ["breakdown_impact_or_drop"],
  components: {
    Checkbox: fs,
    NextButton: Gn,
    GenericButton: kn
  },
  data() {
    return {
      requiredFieldsFilled: !1,
      impactOrDrop: null
    };
  },
  created() {
    this.newVersionDeclaration && this.notSkippable && (this.impactOrDrop = this.originalDeclaration.breakdownImpactOrDrop);
  },
  computed: {
    notSkippable() {
      return this.anyEnabled(["breakdown_impact_or_drop"]);
    }
  },
  watch: {
    impactOrDrop(e) {
      this.formData.set("breakdown_impact_or_drop", e ? "true" : "false"), this.updateRequiredFieldsFilled();
    },
    currentStep(e, t) {
      if (e === this.componentStep) {
        if (this.newVersionDeclaration) {
          if (this.notSkippable) return;
        } else {
          if (this.coverage === "breakdown") return;
          this.formData.delete("breakdown_impact_or_drop");
        }
        this.save(), t < e ? this.$emit("next") : this.$emit("previous");
      }
    }
  },
  methods: {
    updateRequiredFieldsFilled() {
      this.requiredFieldsFilled = this.impactOrDrop !== null && this.impactOrDrop !== void 0;
    }
  }
}, UX = { class: "mt-5 flex justify-between gap-5" }, qX = { class: "pl-2" };
function jX(e, t, n, r, i, a) {
  const s = U("Checkbox"), o = U("GenericButton"), l = U("NextButton");
  return _(), O("div", null, [
    t[3] || (t[3] = k("h1", { class: "my-5 text-4xl font-extrabold tracking-tight text-gray-900" }, " Le produit a-t-il subi un choc ou une chute pouvant expliquer ce dysfonctionnement ? ", -1)),
    W(s, {
      id: "impactOrDrop",
      class: "mt-5",
      name: "impactOrDrop",
      label: "Oui",
      checkedValue: !0,
      disabled: e.disabled("breakdown_impact_or_drop"),
      modelValue: i.impactOrDrop,
      "onUpdate:modelValue": t[0] || (t[0] = (c) => i.impactOrDrop = c)
    }, null, 8, ["disabled", "modelValue"]),
    W(s, {
      id: "notImpactOrDrop",
      class: "mt-3",
      name: "notImpactOrDrop",
      label: "Non",
      checkedValue: !1,
      disabled: e.disabled("breakdown_impact_or_drop"),
      modelValue: i.impactOrDrop,
      "onUpdate:modelValue": t[1] || (t[1] = (c) => i.impactOrDrop = c)
    }, null, 8, ["disabled", "modelValue"]),
    k("div", UX, [
      e.currentStep > 1 ? (_(), ae(o, {
        key: 0,
        onClick: e.previousStep,
        secondary: "",
        "no-scaling": "",
        class: "mr-2"
      }, {
        default: ie(() => [...t[2] || (t[2] = [
          Me(" Précédent ", -1)
        ])]),
        _: 1
      }, 8, ["onClick"])) : L("", !0),
      k("div", qX, [
        W(l, {
          onClick: e.nextStep,
          disabled: !i.requiredFieldsFilled,
          saving: e.saving
        }, null, 8, ["onClick", "disabled", "saving"])
      ])
    ])
  ]);
}
const JS = /* @__PURE__ */ we(BX, [["render", jX]]), WX = {
  props: {
    label: {
      type: String
    },
    labelClass: {
      type: String,
      default: "font-semibold"
    },
    valueOptions: {
      type: Array,
      required: !0
    },
    name: {
      type: String,
      required: !0
    },
    modelValue: {
      required: !0
    },
    required: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["update:modelValue"],
  computed: {
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    }
  }
}, zX = {
  key: 0,
  class: "text-red-600"
}, HX = { class: "flex space-x-4" }, GX = ["name", "value", "disabled"], YX = { class: "text-sm" };
function KX(e, t, n, r, i, a) {
  return _(), O("div", null, [
    n.label ? (_(), O("label", {
      key: 0,
      class: Pe(`my-2 block text-sm leading-6 text-gray-900 ${n.labelClass}`)
    }, [
      Me(j(n.label) + " ", 1),
      n.required ? (_(), O("span", zX, "*")) : L("", !0)
    ], 2)) : L("", !0),
    k("div", HX, [
      (_(!0), O(Re, null, Ke(n.valueOptions, (s) => (_(), O("label", {
        key: s.value,
        class: "flex items-center"
      }, [
        ur(k("input", {
          type: "radio",
          name: n.name,
          value: s.value,
          "onUpdate:modelValue": t[0] || (t[0] = (o) => a.internalValue = o),
          disabled: n.disabled,
          class: "mr-2 text-primary focus:text-primary-dark disabled:opacity-50"
        }, null, 8, GX), [
          [H5, a.internalValue]
        ]),
        k("span", YX, j(s.label), 1)
      ]))), 128))
    ])
  ]);
}
const XX = /* @__PURE__ */ we(WX, [["render", KX]]), ZX = ["breakage", "breakdown", "oxidation", "stains", "rips", "burn", "scratch", "chip"], QX = ["breakage", "breakdown", "oxidation"], JX = ["works_normally", "works_with_bugs", "does_not_work", "other"];
function eZ({ whatHappened: e, damagedPart: t, functionalState: n, functionalStateDetails: r } = {}, i = (a) => a) {
  const a = [];
  if (e && a.push(`${i("what_happened_label")}
${e}`), t && a.push(`${i("damaged_part_label")}
${t}`), n) {
    const s = n === "other" ? `${i("functional_state_other")} : ${r || ""}` : i(`functional_state_${n}`);
    a.push(`${i("functional_state_summary_label")}
${s}`);
  }
  return a.join(`

`);
}
const tZ = {
  fr: {
    title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Description" } },
    what_happened_label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Qu'est-ce qui s'est passé ?" } },
    what_happened_min_length_error: { t: 0, b: { t: 2, i: [{ t: 3, v: "Merci de décrire ce qui s'est passé en " }, { t: 4, k: "min" }, { t: 3, v: " caractères minimum (encore " }, { t: 4, k: "remaining" }, { t: 3, v: ")." }] } },
    detail_hint: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Merci de détailler au maximum pour éviter que nous revenions vers vous." } },
    damaged_part_label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Quelle partie du produit est endommagée ?" } },
    functional_state_label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Décrivez l'état fonctionnel du produit" } },
    functional_state_summary_label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "État fonctionnel du produit :" } },
    functional_state_works_normally: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Fonctionne normalement" } },
    functional_state_works_with_bugs: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Fonctionne mais bug" } },
    functional_state_does_not_work: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ne fonctionne pas" } },
    functional_state_other: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Autre" } },
    precise_label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Précisez" } }
  },
  en: {
    title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Description" } },
    what_happened_label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "What happened?" } },
    what_happened_min_length_error: { t: 0, b: { t: 2, i: [{ t: 3, v: "Please describe what happened in at least " }, { t: 4, k: "min" }, { t: 3, v: " characters (" }, { t: 4, k: "remaining" }, { t: 3, v: " more to go)." }] } },
    detail_hint: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please provide as much detail as possible so we don't have to come back to you." } },
    damaged_part_label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Which part of the product is damaged?" } },
    functional_state_label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Describe the functional state of the product" } },
    functional_state_summary_label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Functional state of the product:" } },
    functional_state_works_normally: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Works normally" } },
    functional_state_works_with_bugs: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Works but has bugs" } },
    functional_state_does_not_work: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Does not work" } },
    functional_state_other: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Other" } },
    precise_label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please specify" } }
  }
}, Ul = 50, nZ = {
  extends: Vn,
  requestFields: ["description"],
  components: {
    Textarea: xY,
    RadioButtons: XX,
    NextButton: Gn,
    GenericButton: kn
  },
  setup() {
    const { t: e } = nr({ messages: tZ });
    return { t: e };
  },
  data() {
    return {
      WHAT_HAPPENED_MIN_LENGTH: Ul,
      requiredFieldsFilled: !1,
      minLengthErrorShown: !1,
      whatHappened: null,
      damagedPart: null,
      functionalState: null,
      functionalStateDetails: null
    };
  },
  created() {
    this.newVersionDeclaration && this.notSkippable && this.prefillFromOriginal();
  },
  computed: {
    notSkippable() {
      return this.enabled("description");
    },
    // En mode « nouvelle version », le store `coverage` n'est pas peuplé (CoverageStep est skippé car
    // la couverture n'est pas modifiable), on lit donc la couverture de la déclaration d'origine.
    effectiveCoverage() {
      var e;
      return this.newVersionDeclaration ? (e = this.originalDeclaration) == null ? void 0 : e.coverage : this.coverage;
    },
    whatHappenedLength() {
      var e;
      return ((e = this.whatHappened) == null ? void 0 : e.trim().length) || 0;
    },
    whatHappenedError() {
      return !this.minLengthErrorShown || this.whatHappenedLength >= Ul ? null : this.t("what_happened_min_length_error", {
        min: Ul,
        remaining: Ul - this.whatHappenedLength
      });
    },
    showDamagedPart() {
      return ZX.includes(this.effectiveCoverage);
    },
    showFunctionalState() {
      return QX.includes(this.effectiveCoverage);
    },
    functionalStateOptions() {
      return JX.map((e) => ({
        value: e,
        label: this.t(`functional_state_${e}`)
      }));
    }
  },
  watch: {
    // La couverture peut changer si l'utilisateur revient à l'étape couverture : resynchronise
    // description_parts et requiredFieldsFilled selon la visibilité des blocs (partie endommagée / état
    // fonctionnel), tous deux dérivés de effectiveCoverage.
    effectiveCoverage() {
      this.updateFormData();
    },
    whatHappened() {
      this.updateFormData();
    },
    damagedPart() {
      this.updateFormData();
    },
    functionalState() {
      this.updateFormData();
    },
    functionalStateDetails() {
      this.updateFormData();
    },
    currentStep(e, t) {
      e === this.componentStep && (this.notSkippable || (this.save(), t < e ? this.$emit("next") : this.$emit("previous")));
    }
  },
  methods: {
    async nextStep() {
      if (this.whatHappenedLength < Ul) {
        this.minLengthErrorShown = !0;
        return;
      }
      this.requiredFieldsFilled && await Vn.methods.nextStep.call(this);
    },
    prefillFromOriginal() {
      const e = this.originalDeclaration.descriptionParts;
      e ? (this.whatHappened = e.whatHappened || null, this.damagedPart = e.damagedPart || null, this.functionalState = e.functionalState || null, this.functionalStateDetails = e.functionalStateDetails || null) : this.whatHappened = this.originalDeclaration.description || null;
    },
    updateFormData() {
      this.setFormData("description", this.descriptionText()), this.formData.set(
        "description_parts[what_happened]",
        this.whatHappened || ""
      ), this.formData.set(
        "description_parts[damaged_part]",
        this.showDamagedPart && this.damagedPart || ""
      ), this.formData.set(
        "description_parts[functional_state]",
        this.showFunctionalState && this.functionalState || ""
      ), this.formData.set(
        "description_parts[functional_state_details]",
        this.showFunctionalState && this.functionalState === "other" && this.functionalStateDetails || ""
      ), this.updateRequiredFieldsFilled();
    },
    descriptionText() {
      return eZ(
        {
          whatHappened: this.whatHappened,
          damagedPart: this.showDamagedPart ? this.damagedPart : null,
          functionalState: this.showFunctionalState ? this.functionalState : null,
          functionalStateDetails: this.functionalStateDetails
        },
        (e) => this.t(e, {}, { locale: "fr" })
      );
    },
    updateRequiredFieldsFilled() {
      var i, a, s;
      const e = (((i = this.whatHappened) == null ? void 0 : i.trim().length) || 0) >= Ul, t = !this.showDamagedPart || !!((a = this.damagedPart) != null && a.trim()), n = !this.showFunctionalState || !!this.functionalState, r = !(this.showFunctionalState && this.functionalState === "other") || !!((s = this.functionalStateDetails) != null && s.trim());
      this.requiredFieldsFilled = e && t && n && r;
    }
  }
}, rZ = { class: "my-5 text-4xl font-extrabold tracking-tight text-gray-900" }, iZ = { class: "text-sm text-gray-500" }, aZ = {
  key: 1,
  class: "mt-5"
}, sZ = { class: "mt-5 flex justify-between gap-5" }, oZ = { class: "pl-2" };
function lZ(e, t, n, r, i, a) {
  const s = U("Textarea"), o = U("RadioButtons"), l = U("GenericButton"), c = U("NextButton");
  return _(), O("div", null, [
    k("h1", rZ, j(r.t("title")), 1),
    W(s, {
      id: "whatHappened",
      class: "mt-5",
      modelValue: i.whatHappened,
      "onUpdate:modelValue": t[0] || (t[0] = (f) => i.whatHappened = f),
      label: r.t("what_happened_label"),
      disabled: e.disabled("description"),
      minLength: i.WHAT_HAPPENED_MIN_LENGTH,
      error: a.whatHappenedError,
      required: ""
    }, null, 8, ["modelValue", "label", "disabled", "minLength", "error"]),
    k("p", iZ, j(r.t("detail_hint")), 1),
    a.showDamagedPart ? (_(), ae(s, {
      key: 0,
      id: "damagedPart",
      class: "mt-5",
      modelValue: i.damagedPart,
      "onUpdate:modelValue": t[1] || (t[1] = (f) => i.damagedPart = f),
      label: r.t("damaged_part_label"),
      disabled: e.disabled("description"),
      required: ""
    }, null, 8, ["modelValue", "label", "disabled"])) : L("", !0),
    a.showFunctionalState ? (_(), O("div", aZ, [
      W(o, {
        name: "functionalState",
        label: r.t("functional_state_label"),
        valueOptions: a.functionalStateOptions,
        modelValue: i.functionalState,
        "onUpdate:modelValue": t[2] || (t[2] = (f) => i.functionalState = f),
        disabled: e.disabled("description"),
        required: ""
      }, null, 8, ["label", "valueOptions", "modelValue", "disabled"]),
      i.functionalState === "other" ? (_(), ae(s, {
        key: 0,
        id: "functionalStateDetails",
        class: "mt-3",
        modelValue: i.functionalStateDetails,
        "onUpdate:modelValue": t[3] || (t[3] = (f) => i.functionalStateDetails = f),
        label: r.t("precise_label"),
        disabled: e.disabled("description"),
        required: ""
      }, null, 8, ["modelValue", "label", "disabled"])) : L("", !0)
    ])) : L("", !0),
    k("div", sZ, [
      e.currentStep > 1 ? (_(), ae(l, {
        key: 0,
        onClick: e.previousStep,
        secondary: "",
        "no-scaling": "",
        class: "mr-2"
      }, {
        default: ie(() => [...t[4] || (t[4] = [
          Me(" Précédent ", -1)
        ])]),
        _: 1
      }, 8, ["onClick"])) : L("", !0),
      k("div", oZ, [
        W(c, {
          onClick: a.nextStep,
          saving: e.saving
        }, null, 8, ["onClick", "saving"])
      ])
    ])
  ]);
}
const eC = /* @__PURE__ */ we(nZ, [["render", lZ]]), uZ = {
  extends: Vn,
  requestFields: ["complaints_receipt"],
  components: {
    FileField: hs,
    NextButton: Gn,
    GenericButton: kn
  },
  data() {
    return {
      requiredFieldsFilled: !1
    };
  },
  watch: {
    currentStep(e, t) {
      if (e === this.componentStep) {
        if (this.newVersionDeclaration) {
          if (this.enabled("complaints_receipt")) return;
        } else {
          if (["theft", "partial_theft"].includes(this.coverage)) return;
          this.formData.delete("complaints_receipt");
        }
        this.save(), t < e ? this.$emit("next") : this.$emit("previous");
      }
    }
  },
  methods: {
    updateRequiredFieldsFilled() {
      this.requiredFieldsFilled = this.formData.get("complaints_receipt[]");
    }
  }
}, cZ = { class: "mt-5 flex justify-between gap-5" }, dZ = { class: "pl-2" };
function fZ(e, t, n, r, i, a) {
  const s = U("FileField"), o = U("GenericButton"), l = U("NextButton");
  return _(), O("div", null, [
    t[1] || (t[1] = k("h1", { class: "my-5 text-4xl font-extrabold tracking-tight text-gray-900" }, "Dépôt de plainte", -1)),
    W(s, {
      id: "complaints_receipt[]",
      class: "mt-5",
      multiple: "",
      maxFiles: 5,
      formData: e.formData,
      accept: "application/pdf,image/png,image/jpeg,image/jpg,image/tiff,image/webp",
      onFiles: a.updateRequiredFieldsFilled,
      label: "Ajoutez le procès-verbal du dépôt de plainte effectué auprès des autorités",
      placeholder: "Choisir un fichier",
      disabled: e.disabled("complaints_receipt"),
      required: ""
    }, null, 8, ["formData", "onFiles", "disabled"]),
    k("div", cZ, [
      e.currentStep > 1 ? (_(), ae(o, {
        key: 0,
        onClick: e.previousStep,
        secondary: "",
        "no-scaling": "",
        class: "mr-2"
      }, {
        default: ie(() => [...t[0] || (t[0] = [
          Me(" Précédent ", -1)
        ])]),
        _: 1
      }, 8, ["onClick"])) : L("", !0),
      k("div", dZ, [
        W(l, {
          onClick: e.nextStep,
          disabled: !i.requiredFieldsFilled,
          saving: e.saving,
          progress: e.uploadProgress
        }, null, 8, ["onClick", "disabled", "saving", "progress"])
      ])
    ])
  ]);
}
const tC = /* @__PURE__ */ we(uZ, [["render", fZ]]), hZ = {
  extends: Vn,
  requestFields: ["product_invoice"],
  components: {
    Alert: so,
    FileField: hs,
    NextButton: Gn,
    GenericButton: kn
  },
  data() {
    return {
      requiredFieldsFilled: !1
    };
  },
  watch: {
    currentStep(e, t) {
      e === this.componentStep && (this.enabled("product_invoice") || (this.save(), t < e ? this.$emit("next") : this.$emit("previous")));
    }
  },
  methods: {
    updateRequiredFieldsFilled() {
      this.requiredFieldsFilled = this.formData.get("product_invoice[]");
    }
  }
}, pZ = { class: "mt-5 flex justify-between gap-5" }, mZ = { class: "pl-2" };
function gZ(e, t, n, r, i, a) {
  const s = U("Alert"), o = U("FileField"), l = U("GenericButton"), c = U("NextButton");
  return _(), O("div", null, [
    t[2] || (t[2] = k("h1", { class: "my-5 text-4xl font-extrabold tracking-tight text-gray-900" }, "Facture d’achat du produit", -1)),
    W(s, { class: "mt-5" }, {
      default: ie(() => [...t[0] || (t[0] = [
        Me(" Le ticket de caisse n’est pas une facture. Si vous n’êtes pas en possession de la facture, merci de la demander au marchand. ", -1)
      ])]),
      _: 1
    }),
    W(o, {
      id: "product_invoice[]",
      class: "mt-5",
      formData: e.formData,
      onFiles: a.updateRequiredFieldsFilled,
      label: "Ajoutez la facture d’achat de votre produit",
      placeholder: "Choisir un fichier",
      disabled: e.disabled("product_invoice"),
      required: "",
      accept: ".pdf,.png,.jpg,.jpeg"
    }, null, 8, ["formData", "onFiles", "disabled"]),
    k("div", pZ, [
      e.currentStep > 1 ? (_(), ae(l, {
        key: 0,
        onClick: e.previousStep,
        secondary: "",
        "no-scaling": "",
        class: "mr-2"
      }, {
        default: ie(() => [...t[1] || (t[1] = [
          Me(" Précédent ", -1)
        ])]),
        _: 1
      }, 8, ["onClick"])) : L("", !0),
      k("div", mZ, [
        W(c, {
          onClick: e.nextStep,
          disabled: !i.requiredFieldsFilled,
          saving: e.saving,
          progress: e.uploadProgress
        }, null, 8, ["onClick", "disabled", "saving", "progress"])
      ])
    ])
  ]);
}
const nC = /* @__PURE__ */ we(hZ, [["render", gZ]]), vZ = {
  extends: Vn,
  requestFields: ["anti_theft_device_invoice"],
  components: {
    FileField: hs,
    NextButton: Gn,
    GenericButton: kn
  },
  data() {
    return {
      requiredFieldsFilled: !1
    };
  },
  watch: {
    currentStep(e, t) {
      if (e === this.componentStep) {
        if (this.newVersionDeclaration) {
          if (this.enabled("anti_theft_device_invoice")) return;
        } else {
          if (["bikes", "edpm", "bikes_simple", "bikes_premium", "bikes_v2"].includes(this.contractCategory) && ["theft", "partial_theft"].includes(this.coverage))
            return;
          this.formData.delete("anti_theft_device_invoice");
        }
        this.save(), t < e ? this.$emit("next") : this.$emit("previous");
      }
    }
  },
  methods: {
    updateRequiredFieldsFilled() {
      this.requiredFieldsFilled = this.formData.get("anti_theft_device_invoice[]");
    }
  }
}, bZ = { class: "mt-5 flex justify-between gap-5" }, _Z = { class: "pl-2" };
function yZ(e, t, n, r, i, a) {
  const s = U("FileField"), o = U("GenericButton"), l = U("NextButton");
  return _(), O("div", null, [
    t[1] || (t[1] = k("h1", { class: "my-5 text-4xl font-extrabold tracking-tight text-gray-900" }, "Facture d’achat de l’antivol agréé", -1)),
    W(s, {
      id: "anti_theft_device_invoice[]",
      class: "mt-5",
      multiple: "",
      maxFiles: 5,
      formData: e.formData,
      onFiles: a.updateRequiredFieldsFilled,
      label: "Ajoutez la facture d’achat de l’antivol agréé",
      placeholder: "Choisir un fichier",
      disabled: e.disabled("anti_theft_device_invoice"),
      required: ""
    }, null, 8, ["formData", "onFiles", "disabled"]),
    k("div", bZ, [
      e.currentStep > 1 ? (_(), ae(o, {
        key: 0,
        onClick: e.previousStep,
        secondary: "",
        "no-scaling": "",
        class: "mr-2"
      }, {
        default: ie(() => [...t[0] || (t[0] = [
          Me(" Précédent ", -1)
        ])]),
        _: 1
      }, 8, ["onClick"])) : L("", !0),
      k("div", _Z, [
        W(l, {
          onClick: e.nextStep,
          disabled: !i.requiredFieldsFilled,
          saving: e.saving,
          progress: e.uploadProgress
        }, null, 8, ["onClick", "disabled", "saving", "progress"])
      ])
    ])
  ]);
}
const rC = /* @__PURE__ */ we(vZ, [["render", yZ]]), xZ = {
  fr: {
    page_title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Photos du produit" } },
    alert_message: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Prenez des photos de l'ensemble du produit sous différents angles, y compris les parties non endommagées. Si le numéro de série ou l'IMEI est visible, assurez-vous qu'il soit lisible sur une des photos." } },
    label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ajoutez plusieurs photos de l'ensemble du produit endommagé" } },
    placeholder: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Choisir un fichier" } },
    previous: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Précédent" } },
    min_files_error: { t: 0, b: { t: 2, i: [{ t: 3, v: "Veuillez ajouter au moins " }, { t: 4, k: "count" }, { t: 3, v: " photos." }] } }
  },
  en: {
    page_title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Product photos" } },
    alert_message: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Take photos of the entire product from different angles, including undamaged parts. If the serial number or IMEI is visible, make sure it is readable in one of the photos." } },
    label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Add multiple photos of the entire damaged product" } },
    placeholder: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Choose a file" } },
    previous: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Previous" } },
    min_files_error: { t: 0, b: { t: 2, i: [{ t: 3, v: "Please add at least " }, { t: 4, k: "count" }, { t: 3, v: " photos." }] } }
  }
}, wZ = {
  extends: Vn,
  requestFields: ["product_photos"],
  components: {
    Alert: so,
    FileField: hs,
    NextButton: Gn,
    GenericButton: kn
  },
  setup() {
    const { t: e } = nr({ messages: xZ });
    return { t: e };
  },
  data() {
    return {
      requiredFieldsFilled: !1
    };
  },
  watch: {
    currentStep(e, t) {
      if (e === this.componentStep) {
        if (this.newVersionDeclaration) {
          if (this.enabled("product_photos")) return;
        } else {
          if ([
            "breakage",
            "breakdown",
            "stains",
            "rips",
            "burn",
            "error_margin",
            "partial_theft",
            "oxidation",
            "scratch",
            "chip"
          ].includes(this.coverage))
            return;
          this.formData.delete("product_photos");
        }
        this.save(), t < e ? this.$emit("next") : this.$emit("previous");
      }
    }
  },
  methods: {
    updateRequiredFieldsFilled(e) {
      this.requiredFieldsFilled = e >= 2;
    }
  }
}, kZ = { class: "my-5 text-4xl font-extrabold tracking-tight text-gray-900" }, SZ = { class: "mt-5 flex justify-between gap-5" }, CZ = { class: "pl-2" };
function TZ(e, t, n, r, i, a) {
  const s = U("Alert"), o = U("FileField"), l = U("GenericButton"), c = U("NextButton");
  return _(), O("div", null, [
    k("h1", kZ, j(r.t("page_title")), 1),
    W(s, {
      class: "mt-5",
      type: "error"
    }, {
      default: ie(() => [
        Me(j(r.t("alert_message")), 1)
      ]),
      _: 1
    }),
    W(o, {
      id: "product_photos[]",
      class: "mt-5",
      multiple: "",
      accept: ".png,.jpg,.jpeg,.tif,.tiff,.webp,.heic,.heif",
      maxFiles: 5,
      formData: e.formData,
      onFiles: a.updateRequiredFieldsFilled,
      label: r.t("label"),
      placeholder: r.t("placeholder"),
      disabled: e.disabled("product_photos"),
      minFiles: 2,
      minFilesError: r.t("min_files_error", { count: 2 }),
      required: ""
    }, null, 8, ["formData", "onFiles", "label", "placeholder", "disabled", "minFilesError"]),
    k("div", SZ, [
      e.currentStep > 1 ? (_(), ae(l, {
        key: 0,
        onClick: e.previousStep,
        secondary: "",
        "no-scaling": "",
        class: "mr-2"
      }, {
        default: ie(() => [
          Me(j(r.t("previous")), 1)
        ]),
        _: 1
      }, 8, ["onClick"])) : L("", !0),
      k("div", CZ, [
        W(c, {
          onClick: e.nextStep,
          disabled: !i.requiredFieldsFilled,
          saving: e.saving,
          progress: e.uploadProgress
        }, null, 8, ["onClick", "disabled", "saving", "progress"])
      ])
    ])
  ]);
}
const iC = /* @__PURE__ */ we(wZ, [["render", TZ]]), AZ = {
  extends: Vn,
  requestFields: ["marking_number"],
  components: {
    NextButton: Gn,
    GenericButton: kn
  },
  data() {
    return {
      requiredFieldsFilled: !1,
      markingNumber: ""
    };
  },
  created() {
    this.newVersionDeclaration && this.notSkippable && (this.markingNumber = this.originalDeclaration.markingNumber);
  },
  watch: {
    markingNumber(e) {
      this.setFormData("marking_number", e), this.updateRequiredFieldsFilled();
    },
    currentStep(e, t) {
      if (e === this.componentStep) {
        if (this.newVersionDeclaration) {
          if (this.notSkippable) return;
        } else {
          if (["bikes", "edpm", "bikes_simple", "bikes_premium", "bikes_v2"].includes(this.contractCategory)) return;
          this.formData.delete("marking_number");
        }
        this.save(), t < e ? this.$emit("next") : this.$emit("previous");
      }
    }
  },
  computed: {
    notSkippable() {
      return this.enabled("marking_number");
    }
  },
  methods: {
    updateRequiredFieldsFilled() {
      this.requiredFieldsFilled = !this.markingNumber || this.markingNumber.trim() !== "";
    }
  }
}, DZ = { class: "mt-5" }, EZ = ["disabled"], PZ = { class: "mt-5 flex justify-between gap-5" }, OZ = { class: "pl-2" };
function MZ(e, t, n, r, i, a) {
  const s = U("GenericButton"), o = U("NextButton");
  return _(), O("div", null, [
    t[3] || (t[3] = k("h1", { class: "my-5 text-4xl font-extrabold tracking-tight text-gray-900" }, "Numéro de marquage", -1)),
    k("div", DZ, [
      t[1] || (t[1] = k("label", {
        for: "markingNumber",
        class: "block text-sm font-medium text-gray-700"
      }, " Renseignez le numéro de marquage du produit ", -1)),
      ur(k("input", {
        type: "text",
        id: "markingNumber",
        "onUpdate:modelValue": t[0] || (t[0] = (l) => i.markingNumber = l),
        disabled: e.disabled("marking_number"),
        class: "mt-1 block w-full rounded-md border-gray-300 shadow-xs focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm",
        required: ""
      }, null, 8, EZ), [
        [tl, i.markingNumber]
      ])
    ]),
    k("div", PZ, [
      e.currentStep > 1 ? (_(), ae(s, {
        key: 0,
        onClick: e.previousStep,
        secondary: "",
        "no-scaling": "",
        class: "mr-2"
      }, {
        default: ie(() => [...t[2] || (t[2] = [
          Me(" Précédent ", -1)
        ])]),
        _: 1
      }, 8, ["onClick"])) : L("", !0),
      k("div", OZ, [
        W(o, {
          onClick: e.nextStep,
          disabled: !i.requiredFieldsFilled,
          saving: e.saving
        }, null, 8, ["onClick", "disabled", "saving"])
      ])
    ])
  ]);
}
const aC = /* @__PURE__ */ we(AZ, [["render", MZ]]), IZ = {
  extends: Vn,
  requestFields: ["marking_number_photos"],
  components: {
    Alert: so,
    FileField: hs,
    NextButton: Gn,
    GenericButton: kn
  },
  data() {
    return {
      requiredFieldsFilled: !1
    };
  },
  watch: {
    currentStep(e, t) {
      if (e === this.componentStep) {
        if (this.newVersionDeclaration) {
          if (this.enabled("marking_number_photos")) return;
        } else {
          if (["bikes_v2"].includes(this.contractCategory) && ["breakage", "breakdown"].includes(this.coverage))
            return;
          this.formData.delete("marking_number_photos");
        }
        this.save(), t < e ? this.$emit("next") : this.$emit("previous");
      }
    }
  },
  methods: {
    updateRequiredFieldsFilled() {
      this.requiredFieldsFilled = this.formData.get("marking_number_photos[]");
    }
  }
}, RZ = { class: "mt-5 flex justify-between gap-5" }, FZ = { class: "pl-2" };
function NZ(e, t, n, r, i, a) {
  const s = U("Alert"), o = U("FileField"), l = U("GenericButton"), c = U("NextButton");
  return _(), O("div", null, [
    t[2] || (t[2] = k("h1", { class: "my-5 text-4xl font-extrabold tracking-tight text-gray-900" }, "Photos du numéro de marquage", -1)),
    W(s, { class: "mt-5" }, {
      default: ie(() => [...t[0] || (t[0] = [
        Me("Le vélo doit être clairement visible dans la photo, ainsi que le numéro de marquage.", -1)
      ])]),
      _: 1
    }),
    W(o, {
      id: "marking_number_photos[]",
      class: "mt-5",
      multiple: "",
      maxFiles: 5,
      formData: e.formData,
      onFiles: a.updateRequiredFieldsFilled,
      label: "Ajoutez une photo du numéro de marquage du vélo endommagé",
      placeholder: "Choisir un fichier",
      disabled: e.disabled("marking_number_photos"),
      required: ""
    }, null, 8, ["formData", "onFiles", "disabled"]),
    k("div", RZ, [
      e.currentStep > 1 ? (_(), ae(l, {
        key: 0,
        onClick: e.previousStep,
        secondary: "",
        "no-scaling": "",
        class: "mr-2"
      }, {
        default: ie(() => [...t[1] || (t[1] = [
          Me(" Précédent ", -1)
        ])]),
        _: 1
      }, 8, ["onClick"])) : L("", !0),
      k("div", FZ, [
        W(c, {
          onClick: e.nextStep,
          disabled: !i.requiredFieldsFilled,
          saving: e.saving,
          progress: e.uploadProgress
        }, null, 8, ["onClick", "disabled", "saving", "progress"])
      ])
    ])
  ]);
}
const sC = /* @__PURE__ */ we(IZ, [["render", NZ]]), LZ = {
  extends: Vn,
  requestFields: ["fraudulent_sim_use"],
  components: {
    Checkbox: fs,
    NextButton: Gn,
    GenericButton: kn
  },
  data() {
    return {
      requiredFieldsFilled: !1,
      fraudulentSimUseValue: null
    };
  },
  created() {
    this.newVersionDeclaration && this.notSkippable && (this.fraudulentSimUseValue = this.originalDeclaration.fraudulentSimUse);
  },
  computed: {
    notSkippable() {
      return this.anyEnabled(["fraudulent_sim_use"]);
    }
  },
  watch: {
    fraudulentSimUseValue(e) {
      this.setFraudulentSimUse(e), e != null ? this.formData.set("fraudulent_sim_use", e ? "true" : "false") : this.formData.delete("fraudulent_sim_use"), this.updateRequiredFieldsFilled();
    },
    currentStep(e, t) {
      if (e === this.componentStep) {
        if (this.newVersionDeclaration) {
          if (this.notSkippable) return;
        } else {
          if (this.contractCategory === "mobile_protection" && ["theft", "partial_theft"].includes(this.coverage))
            return;
          this.formData.delete("fraudulent_sim_use"), this.setFraudulentSimUse(null);
        }
        this.save(), t < e ? this.$emit("next") : this.$emit("previous");
      }
    }
  },
  methods: {
    ...wp("claimDeclarations", ["setFraudulentSimUse"]),
    updateRequiredFieldsFilled() {
      this.requiredFieldsFilled = this.fraudulentSimUseValue !== null && this.fraudulentSimUseValue !== void 0;
    }
  }
}, $Z = { class: "mt-5 flex justify-between gap-5" }, VZ = { class: "pl-2" };
function BZ(e, t, n, r, i, a) {
  const s = U("Checkbox"), o = U("GenericButton"), l = U("NextButton");
  return _(), O("div", null, [
    t[3] || (t[3] = k("h1", { class: "my-5 text-4xl font-extrabold tracking-tight text-gray-900" }, " Utilisation frauduleuse de la carte SIM ", -1)),
    t[4] || (t[4] = k("p", { class: "text-sm text-gray-600 mb-4" }, " Suite au vol de votre appareil, avez-vous constaté une utilisation frauduleuse de votre carte SIM (appels, SMS ou consommation de données non effectués par vous) ? ", -1)),
    W(s, {
      id: "fraudulentSimUseYes",
      class: "mt-5",
      name: "fraudulentSimUseYes",
      label: "Oui",
      checkedValue: !0,
      disabled: e.disabled("fraudulent_sim_use"),
      modelValue: i.fraudulentSimUseValue,
      "onUpdate:modelValue": t[0] || (t[0] = (c) => i.fraudulentSimUseValue = c)
    }, null, 8, ["disabled", "modelValue"]),
    W(s, {
      id: "fraudulentSimUseNo",
      class: "mt-3",
      name: "fraudulentSimUseNo",
      label: "Non",
      checkedValue: !1,
      disabled: e.disabled("fraudulent_sim_use"),
      modelValue: i.fraudulentSimUseValue,
      "onUpdate:modelValue": t[1] || (t[1] = (c) => i.fraudulentSimUseValue = c)
    }, null, 8, ["disabled", "modelValue"]),
    k("div", $Z, [
      e.currentStep > 1 ? (_(), ae(o, {
        key: 0,
        onClick: e.previousStep,
        secondary: "",
        "no-scaling": "",
        class: "mr-2"
      }, {
        default: ie(() => [...t[2] || (t[2] = [
          Me(" Précédent ", -1)
        ])]),
        _: 1
      }, 8, ["onClick"])) : L("", !0),
      k("div", VZ, [
        W(l, {
          onClick: e.nextStep,
          disabled: !i.requiredFieldsFilled,
          saving: e.saving
        }, null, 8, ["onClick", "disabled", "saving"])
      ])
    ])
  ]);
}
const oC = /* @__PURE__ */ we(LZ, [["render", BZ]]), UZ = {
  extends: Vn,
  requestFields: ["fraudulent_sim_use_proof"],
  components: {
    Alert: so,
    FileField: hs,
    NextButton: Gn,
    GenericButton: kn
  },
  data() {
    return {
      requiredFieldsFilled: !1
    };
  },
  watch: {
    currentStep(e, t) {
      if (e === this.componentStep) {
        if (this.newVersionDeclaration) {
          if (this.enabled("fraudulent_sim_use_proof")) {
            this.updateRequiredFieldsFilled();
            return;
          }
          this.formData.delete("fraudulent_sim_use_proof[]");
        } else {
          if (this.contractCategory === "mobile_protection" && this.fraudulentSimUse === !0) {
            this.updateRequiredFieldsFilled();
            return;
          }
          this.formData.delete("fraudulent_sim_use_proof[]");
        }
        this.save(), t < e ? this.$emit("next") : this.$emit("previous");
      }
    }
  },
  methods: {
    updateRequiredFieldsFilled() {
      const e = this.formData.get("fraudulent_sim_use_proof[]");
      this.requiredFieldsFilled = Array.isArray(e) ? e.length > 0 : !!e;
    }
  }
}, qZ = { class: "mt-5 flex justify-between gap-5" }, jZ = { class: "pl-2" };
function WZ(e, t, n, r, i, a) {
  const s = U("Alert"), o = U("FileField"), l = U("GenericButton"), c = U("NextButton");
  return _(), O("div", null, [
    t[2] || (t[2] = k("h1", { class: "my-5 text-4xl font-extrabold tracking-tight text-gray-900" }, " Justificatif d'utilisation frauduleuse ", -1)),
    W(s, { class: "mt-5" }, {
      default: ie(() => [...t[0] || (t[0] = [
        Me(" Veuillez fournir un justificatif attestant de l'utilisation frauduleuse de votre carte SIM (par exemple : relevé détaillé de votre opérateur, courrier de l'opérateur, etc.). ", -1)
      ])]),
      _: 1
    }),
    W(o, {
      id: "fraudulent_sim_use_proof[]",
      class: "mt-5",
      multiple: "",
      maxFiles: 5,
      formData: e.formData,
      onFiles: a.updateRequiredFieldsFilled,
      label: "Ajoutez le justificatif d'utilisation frauduleuse",
      placeholder: "Choisir un fichier",
      disabled: e.disabled("fraudulent_sim_use_proof"),
      required: ""
    }, null, 8, ["formData", "onFiles", "disabled"]),
    k("div", qZ, [
      e.currentStep > 1 ? (_(), ae(l, {
        key: 0,
        onClick: e.previousStep,
        secondary: "",
        "no-scaling": "",
        class: "mr-2"
      }, {
        default: ie(() => [...t[1] || (t[1] = [
          Me(" Précédent ", -1)
        ])]),
        _: 1
      }, 8, ["onClick"])) : L("", !0),
      k("div", jZ, [
        W(c, {
          onClick: e.nextStep,
          disabled: !i.requiredFieldsFilled,
          saving: e.saving,
          progress: e.uploadProgress
        }, null, 8, ["onClick", "disabled", "saving", "progress"])
      ])
    ])
  ]);
}
const lC = /* @__PURE__ */ we(UZ, [["render", WZ]]), zZ = {
  fr: {
    title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Êtes-vous le titulaire de la facture ?" } },
    description: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "La facture d'achat du produit doit être au nom de l'adhérent du contrat d'assurance. Si ce n'est pas le cas, un justificatif vous sera demandé." } },
    yes: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Oui" } },
    no: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Non" } }
  },
  en: {
    title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Are you the invoice holder?" } },
    description: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "The product purchase invoice must be in the name of the insurance contract subscriber. If not, you will be asked for supporting documentation." } },
    yes: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Yes" } },
    no: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "No" } }
  }
}, HZ = {
  extends: Vn,
  requestFields: ["is_invoice_holder"],
  components: {
    Checkbox: fs,
    NextButton: Gn,
    GenericButton: kn
  },
  setup() {
    const { t: e } = nr({ messages: zZ });
    return { t: e };
  },
  data() {
    return {
      requiredFieldsFilled: !1,
      isInvoiceHolderValue: null
    };
  },
  created() {
    this.newVersionDeclaration && this.notSkippable && (this.isInvoiceHolderValue = this.originalDeclaration.isInvoiceHolder);
  },
  computed: {
    notSkippable() {
      return this.anyEnabled(["is_invoice_holder"]);
    }
  },
  watch: {
    isInvoiceHolderValue(e) {
      this.setIsInvoiceHolder(e), e != null ? this.formData.set("is_invoice_holder", e ? "true" : "false") : this.formData.delete("is_invoice_holder"), this.updateRequiredFieldsFilled();
    },
    currentStep(e, t) {
      if (e === this.componentStep) {
        if (this.newVersionDeclaration) {
          if (this.notSkippable) return;
        } else
          return;
        this.save(), t < e ? this.$emit("next") : this.$emit("previous");
      }
    }
  },
  methods: {
    ...wp("claimDeclarations", ["setIsInvoiceHolder"]),
    updateRequiredFieldsFilled() {
      this.requiredFieldsFilled = this.isInvoiceHolderValue !== null && this.isInvoiceHolderValue !== void 0;
    }
  }
}, GZ = { class: "my-5 text-4xl font-extrabold tracking-tight text-gray-900" }, YZ = { class: "text-sm text-gray-600 mb-4" }, KZ = { class: "mt-5 flex justify-between gap-5" }, XZ = { class: "pl-2" };
function ZZ(e, t, n, r, i, a) {
  const s = U("Checkbox"), o = U("GenericButton"), l = U("NextButton");
  return _(), O("div", null, [
    k("h1", GZ, j(r.t("title")), 1),
    k("p", YZ, j(r.t("description")), 1),
    W(s, {
      id: "isInvoiceHolderYes",
      class: "mt-5",
      name: "isInvoiceHolderYes",
      label: r.t("yes"),
      checkedValue: !0,
      disabled: e.disabled("is_invoice_holder"),
      modelValue: i.isInvoiceHolderValue,
      "onUpdate:modelValue": t[0] || (t[0] = (c) => i.isInvoiceHolderValue = c)
    }, null, 8, ["label", "disabled", "modelValue"]),
    W(s, {
      id: "isInvoiceHolderNo",
      class: "mt-3",
      name: "isInvoiceHolderNo",
      label: r.t("no"),
      checkedValue: !1,
      disabled: e.disabled("is_invoice_holder"),
      modelValue: i.isInvoiceHolderValue,
      "onUpdate:modelValue": t[1] || (t[1] = (c) => i.isInvoiceHolderValue = c)
    }, null, 8, ["label", "disabled", "modelValue"]),
    k("div", KZ, [
      e.currentStep > 1 ? (_(), ae(o, {
        key: 0,
        onClick: e.previousStep,
        secondary: "",
        "no-scaling": "",
        class: "mr-2"
      }, {
        default: ie(() => [...t[2] || (t[2] = [
          Me(" Précédent ", -1)
        ])]),
        _: 1
      }, 8, ["onClick"])) : L("", !0),
      k("div", XZ, [
        W(l, {
          onClick: e.nextStep,
          disabled: !i.requiredFieldsFilled,
          saving: e.saving
        }, null, 8, ["onClick", "disabled", "saving"])
      ])
    ])
  ]);
}
const uC = /* @__PURE__ */ we(HZ, [["render", ZZ]]), QZ = {
  fr: {
    title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Justificatif du titulaire de la facture" } },
    alert: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Veuillez fournir un justificatif liant le titulaire de la facture à l'adhérent du contrat d'assurance (par exemple : attestation sur l'honneur, livret de famille, etc.)." } },
    label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ajoutez un ou plusieurs justificatifs" } },
    placeholder: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Choisir un ou plusieurs fichiers" } }
  },
  en: {
    title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Invoice holder proof" } },
    alert: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please provide a document linking the invoice holder to the insurance contract subscriber (e.g., sworn statement, family record book, etc.)." } },
    label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Add one or more supporting documents" } },
    placeholder: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Choose one or more files" } }
  }
}, JZ = {
  extends: Vn,
  requestFields: ["invoice_holder_proof"],
  components: {
    Alert: so,
    FileField: hs,
    NextButton: Gn,
    GenericButton: kn
  },
  setup() {
    const { t: e } = nr({ messages: QZ });
    return { t: e };
  },
  data() {
    return {
      requiredFieldsFilled: !1
    };
  },
  computed: {
    // Réponse titulaire effective : le store quand l'étape titulaire est éditable,
    // sinon la valeur d'origine (le store n'est pas synchronisé dans ce cas).
    effectiveIsInvoiceHolder() {
      var e;
      return this.newVersionDeclaration && !this.enabled("is_invoice_holder") ? (e = this.originalDeclaration) == null ? void 0 : e.isInvoiceHolder : this.isInvoiceHolder;
    },
    proofNeeded() {
      return this.newVersionDeclaration ? this.effectiveIsInvoiceHolder === !1 && this.anyEnabled(["is_invoice_holder", "invoice_holder_proof"]) : this.isInvoiceHolder === !1;
    }
  },
  watch: {
    currentStep(e, t) {
      if (e === this.componentStep) {
        if (this.proofNeeded) {
          this.updateRequiredFieldsFilled();
          return;
        }
        this.formData.delete("invoice_holder_proof[]"), this.save(), t < e ? this.$emit("next") : this.$emit("previous");
      }
    }
  },
  methods: {
    updateRequiredFieldsFilled() {
      this.requiredFieldsFilled = this.formData.getAll("invoice_holder_proof[]").length > 0;
    }
  }
}, eQ = { class: "my-5 text-4xl font-extrabold tracking-tight text-gray-900" }, tQ = { class: "mt-5 flex justify-between gap-5" }, nQ = { class: "pl-2" };
function rQ(e, t, n, r, i, a) {
  const s = U("Alert"), o = U("FileField"), l = U("GenericButton"), c = U("NextButton");
  return _(), O("div", null, [
    k("h1", eQ, j(r.t("title")), 1),
    W(s, { class: "mt-5" }, {
      default: ie(() => [
        Me(j(r.t("alert")), 1)
      ]),
      _: 1
    }),
    W(o, {
      id: "invoice_holder_proof[]",
      class: "mt-5",
      multiple: "",
      formData: e.formData,
      onFiles: a.updateRequiredFieldsFilled,
      label: r.t("label"),
      placeholder: r.t("placeholder"),
      disabled: e.disabled("invoice_holder_proof"),
      required: ""
    }, null, 8, ["formData", "onFiles", "label", "placeholder", "disabled"]),
    k("div", tQ, [
      e.currentStep > 1 ? (_(), ae(l, {
        key: 0,
        onClick: e.previousStep,
        secondary: "",
        "no-scaling": "",
        class: "mr-2"
      }, {
        default: ie(() => [...t[0] || (t[0] = [
          Me(" Précédent ", -1)
        ])]),
        _: 1
      }, 8, ["onClick"])) : L("", !0),
      k("div", nQ, [
        W(c, {
          onClick: e.nextStep,
          disabled: !i.requiredFieldsFilled,
          saving: e.saving,
          progress: e.uploadProgress
        }, null, 8, ["onClick", "disabled", "saving", "progress"])
      ])
    ])
  ]);
}
const cC = /* @__PURE__ */ we(JZ, [["render", rQ]]), iQ = {
  extends: Vn,
  requestFields: ["home_insurance_certificate", "no_other_compensation_attested"],
  components: {
    Checkbox: fs,
    FileField: hs,
    NextButton: Gn,
    GenericButton: kn
  },
  data() {
    return {
      requiredFieldsFilled: !1,
      noOtherCompensationAttested: null
    };
  },
  watch: {
    noOtherCompensationAttested(e) {
      this.setFormData("no_other_compensation_attested", e), this.updateRequiredFieldsFilled();
    },
    currentStep(e, t) {
      if (e === this.componentStep) {
        if (this.newVersionDeclaration) {
          if (this.anyEnabled(["home_insurance_certificate", "no_other_compensation_attested"])) return;
        } else {
          if (this.occurredAtHome === !0) return;
          this.formData.delete("home_insurance_certificate[]"), this.formData.delete("no_other_compensation_attested");
        }
        this.save(), t < e ? this.$emit("next") : this.$emit("previous");
      }
    }
  },
  methods: {
    updateRequiredFieldsFilled() {
      this.requiredFieldsFilled = this.formData.get("home_insurance_certificate[]") && this.formData.get("no_other_compensation_attested") === "true";
    }
  }
}, aQ = { class: "mt-5 flex justify-between gap-5" }, sQ = { class: "pl-2" };
function oQ(e, t, n, r, i, a) {
  const s = U("FileField"), o = U("Checkbox"), l = U("GenericButton"), c = U("NextButton");
  return _(), O("div", null, [
    t[2] || (t[2] = k("h1", { class: "my-5 text-4xl font-extrabold tracking-tight text-gray-900" }, "Attestation d’assurance habitation", -1)),
    W(s, {
      id: "home_insurance_certificate[]",
      class: "mt-5",
      multiple: "",
      maxFiles: 5,
      formData: e.formData,
      onFiles: a.updateRequiredFieldsFilled,
      label: "Ajoutez une copie de votre attestation d’assurance habitation ",
      placeholder: "Choisir un fichier",
      disabled: e.disabled("home_insurance_certificate"),
      required: ""
    }, null, 8, ["formData", "onFiles", "disabled"]),
    W(o, {
      id: "noOtherCompensationAttested",
      name: "noOtherCompensationAttested",
      class: "mt-5",
      label: "J'atteste sur l'honneur que je n'ai pas perçu / je ne percevrai pas une autre indemnité pour ce sinistre. Si une indemnité a été perçue, je vous adresse en pièce jointe l'attestation de mon assurance avec le montant indemnisé.",
      checkedValue: "true",
      uncheckedValue: "false",
      modelValue: i.noOtherCompensationAttested,
      "onUpdate:modelValue": t[0] || (t[0] = (f) => i.noOtherCompensationAttested = f),
      disabled: e.disabled("no_other_compensation_attested"),
      required: ""
    }, null, 8, ["modelValue", "disabled"]),
    k("div", aQ, [
      e.currentStep > 1 ? (_(), ae(l, {
        key: 0,
        onClick: e.previousStep,
        secondary: "",
        "no-scaling": "",
        class: "mr-2"
      }, {
        default: ie(() => [...t[1] || (t[1] = [
          Me(" Précédent ", -1)
        ])]),
        _: 1
      }, 8, ["onClick"])) : L("", !0),
      k("div", sQ, [
        W(c, {
          onClick: e.nextStep,
          disabled: !i.requiredFieldsFilled,
          saving: e.saving,
          progress: e.uploadProgress
        }, null, 8, ["onClick", "disabled", "saving", "progress"])
      ])
    ])
  ]);
}
const dC = /* @__PURE__ */ we(iQ, [["render", oQ]]), lQ = {
  props: {
    color: {
      type: String,
      default: "text-primary"
    }
  }
};
function uQ(e, t, n, r, i, a) {
  return _(), O("svg", {
    class: Pe([" animate-spin -ml-1 mr-3 h-5 w-5", n.color]),
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, [...t[0] || (t[0] = [
    k("circle", {
      class: "opacity-25",
      cx: "12",
      cy: "12",
      r: "10",
      stroke: "currentColor",
      "stroke-width": "4"
    }, null, -1),
    k("path", {
      class: "opacity-75",
      fill: "currentColor",
      d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    }, null, -1)
  ])], 2);
}
const Y0 = /* @__PURE__ */ we(lQ, [["render", uQ]]);
function fC(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "",
    resource: {
      fr: {
        title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Récapitulatif et validation" } },
        subtitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Vérifiez les informations saisies avant de valider votre déclaration." } },
        certification_label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Je certifie que les informations fournies dans cette déclaration sont exactes et complètes à ma connaissance. Je comprends que toute fausse déclaration ou omission pourrait entraîner l'annulation de ma couverture ou le refus d'une indemnisation. En cochant cette case, je m'engage à ce que cette déclaration soit conforme à la réalité." } },
        fraud_warning: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nous rappelons à l'ensemble de nos clients que l'article 313-1 du Code pénal prévoit qu'une fraude à l'assurance peut être punie d'une amende allant jusqu'à 375 000 € et d'une peine d'emprisonnement de 5 ans." } },
        previous: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Précédent" } }
      },
      en: {
        title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Summary and confirmation" } },
        subtitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Please review the information you provided before submitting your claim." } },
        certification_label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "I certify that the information provided in this claim is accurate and complete to the best of my knowledge. I understand that any false statement or omission may result in the cancellation of my coverage or the denial of compensation. By checking this box, I confirm that this claim is truthful." } },
        fraud_warning: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "We remind all our customers that under Article 313-1 of the French Penal Code, insurance fraud may be punished by a fine of up to €375,000 and a prison sentence of up to 5 years." } },
        previous: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Previous" } }
      }
    }
  });
}
const _M = {
  extends: Vn,
  components: {
    Checkbox: fs,
    Alert: so,
    NextButton: Gn,
    GenericButton: kn,
    ClaimDeclaration: $K,
    Spinner: Y0
  },
  setup() {
    const { t: e } = nr();
    return { t: e };
  },
  data() {
    return {
      requiredFieldsFilled: !1,
      declarationCompleted: "false",
      loading: !1
    };
  },
  computed: {
    ...gM("claimDeclarations", { recapDeclaration: "declaration" }),
    recapVisibleFields() {
      var e;
      return ((e = this.declarationUpdateRequest) == null ? void 0 : e.fields) || null;
    }
  },
  watch: {
    declarationCompleted(e) {
      this.setFormData("declaration_completed", e), this.updateRequiredFieldsFilled();
    },
    async currentStep(e) {
      if (e === this.componentStep) {
        this.loading = !0;
        try {
          await this.fetchDeclaration();
        } finally {
          this.loading = !1;
        }
      }
    }
  },
  methods: {
    ...qc("notifications", ["notify"]),
    ...qc("claimDeclarations", ["fetchDeclaration"]),
    updateRequiredFieldsFilled() {
      this.requiredFieldsFilled = this.formData.get("declaration_completed") === "true";
    }
  }
}, cQ = { class: "my-5 text-4xl font-extrabold tracking-tight text-gray-900" }, dQ = { class: "text-base" }, fQ = { class: "mt-5 flex justify-between gap-5" }, hQ = { class: "pl-2" };
function pQ(e, t, n, r, i, a) {
  const s = U("Spinner"), o = U("ClaimDeclaration"), l = U("Checkbox"), c = U("Alert"), f = U("GenericButton"), h = U("NextButton");
  return _(), O("div", null, [
    k("h1", cQ, j(r.t("title")), 1),
    k("p", null, j(r.t("subtitle")), 1),
    i.loading ? (_(), ae(s, {
      key: 0,
      class: "mt-5"
    })) : e.recapDeclaration ? (_(), ae(o, {
      key: 1,
      declaration: e.recapDeclaration,
      "visible-fields": a.recapVisibleFields,
      class: "mt-5"
    }, null, 8, ["declaration", "visible-fields"])) : L("", !0),
    W(l, {
      id: "declarationCompleted",
      name: "declarationCompleted",
      class: "mt-5",
      label: r.t("certification_label"),
      checkedValue: "true",
      uncheckedValue: "false",
      modelValue: i.declarationCompleted,
      "onUpdate:modelValue": t[0] || (t[0] = (p) => i.declarationCompleted = p)
    }, null, 8, ["label", "modelValue"]),
    W(c, {
      type: "error",
      class: "mt-5"
    }, {
      icon: ie(() => [...t[1] || (t[1] = [
        Me("🚨", -1)
      ])]),
      default: ie(() => [
        k("p", dQ, j(r.t("fraud_warning")), 1)
      ]),
      _: 1
    }),
    k("div", fQ, [
      W(f, {
        onClick: e.previousStep,
        secondary: "",
        "no-scaling": "",
        class: "mr-2"
      }, {
        default: ie(() => [
          Me(j(r.t("previous")), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      k("div", hQ, [
        W(h, {
          onClick: e.nextStep,
          disabled: !i.requiredFieldsFilled,
          saving: e.saving
        }, null, 8, ["onClick", "disabled", "saving"])
      ])
    ])
  ]);
}
typeof fC == "function" && fC(_M);
const hC = /* @__PURE__ */ we(_M, [["render", pQ]]), mQ = {
  props: {
    max: {
      type: Number,
      required: !0
    },
    value: {
      type: Number,
      required: !0
    },
    color: {
      type: String,
      default: "#B46CFE"
    },
    size: {
      type: String,
      default: "h-2"
    }
  },
  computed: {
    progressStyle() {
      return this.color.startsWith("#") ? {
        "--progress-color": this.color
      } : {
        "--progress-color": colors[this.color] || "#B46CFE"
      };
    }
  }
}, gQ = ["max", "value"];
function vQ(e, t, n, r, i, a) {
  return _(), O("progress", {
    max: n.max,
    value: n.value,
    class: Pe(["w-full", n.size]),
    style: Zn(a.progressStyle)
  }, null, 14, gQ);
}
const bQ = /* @__PURE__ */ we(mQ, [["render", vQ], ["__scopeId", "data-v-cb588a90"]]), _Q = {
  components: {
    ExclamationIcon: _h,
    ProgressionBar: bQ,
    PersonalInformationStep: HS,
    AddressStep: GS,
    OccurrenceDateStep: YS,
    OccurrencePlaceStep: KS,
    CoverageStep: XS,
    TheftTypeStep: ZS,
    BreakdownQuestionStep: QS,
    BreakdownImpactOrDropStep: JS,
    DescriptionStep: eC,
    ComplaintsReceiptStep: tC,
    ProductInvoiceStep: nC,
    AntiTheftDeviceInvoiceStep: rC,
    ProductPhotosStep: iC,
    MarkingNumberStep: aC,
    MarkingNumberPhotosStep: sC,
    FraudulentSimUseStep: oC,
    FraudulentSimUseProofStep: lC,
    InvoiceHolderStep: uC,
    InvoiceHolderProofStep: cC,
    HomeInsuranceCertificateStep: dC,
    DeclarationCompletedStep: hC
  },
  props: {
    declarationUpdateRequest: {
      type: Object,
      required: !0
    },
    declaration: {
      type: Object,
      required: !0
    }
  },
  data() {
    return {
      step: 1,
      stepComponents: [
        HS,
        GS,
        YS,
        KS,
        XS,
        ZS,
        QS,
        JS,
        eC,
        tC,
        nC,
        uC,
        cC,
        rC,
        iC,
        aC,
        sC,
        oC,
        lC,
        dC,
        hC
      ]
    };
  },
  computed: {
    // Champs demandés que l'étape affichée permet de modifier (option `requestFields`
    // déclarée par chaque étape), avec le message de l'ops pour ce champ s'il y en a un.
    requestedItems() {
      var i;
      const e = ((i = this.stepComponents[this.step - 1]) == null ? void 0 : i.requestFields) || [], {
        fields: t,
        translatedFields: n,
        fieldMessages: r = []
      } = this.declarationUpdateRequest;
      return t.map((a, s) => {
        var o;
        return {
          field: a,
          label: n[s],
          message: (o = r.find((l) => l.field === a)) == null ? void 0 : o.message
        };
      }).filter((a) => e.includes(a.field));
    }
  },
  created() {
    this.createNewVersion({ claimDeclarationId: this.declaration.id });
  },
  methods: {
    ...qc("notifications", ["notify"]),
    ...qc("claimDeclarations", ["createNewVersion"]),
    async nextStep() {
      this.step++, this.step > this.stepComponents.length && await this.declarationCompleted();
    },
    previousStep() {
      this.step !== 1 && this.step--;
    },
    async declarationCompleted() {
      await this.notify({
        category: "simple",
        type: "success",
        title: "Your claim has been submitted!",
        text: "It's being reviewed by our team and you will hear back from a representative within 1-2 business days."
      }), this.$router.push("/claims");
    }
  }
}, yQ = { class: "w-full md:w-2/3 mx-auto" }, xQ = {
  key: 0,
  class: "mt-3 flex items-start space-x-4 rounded-md bg-yellow-50 p-4 border border-yellow-200"
}, wQ = { class: "text-sm text-yellow-800" }, kQ = { class: "list-disc list-inside text-sm font-normal text-yellow-800" }, SQ = { class: "font-medium" }, CQ = { key: 0 };
function TQ(e, t, n, r, i, a) {
  const s = U("ProgressionBar"), o = U("ExclamationIcon");
  return _(), O("div", yQ, [
    W(s, {
      max: i.stepComponents.length,
      value: i.step
    }, null, 8, ["max", "value"]),
    a.requestedItems.length ? (_(), O("div", xQ, [
      W(o, { class: "w-6 h-6 text-yellow-500 mt-1" }),
      k("div", wQ, [
        t[0] || (t[0] = k("p", { class: "font-medium mb-1" }, " Veuillez modifier les informations suivantes : ", -1)),
        k("ul", kQ, [
          (_(!0), O(Re, null, Ke(a.requestedItems, (l) => (_(), O("li", {
            key: l.field
          }, [
            k("span", SQ, j(l.label), 1),
            l.message ? (_(), O("span", CQ, ": " + j(l.message), 1)) : L("", !0)
          ]))), 128))
        ])
      ])
    ])) : L("", !0),
    (_(!0), O(Re, null, Ke(i.stepComponents, (l, c) => ur((_(), ae(Lr(l), {
      key: c,
      componentStep: c + 1,
      currentStep: i.step,
      "original-declaration": n.declaration,
      "declaration-update-request": n.declarationUpdateRequest,
      onNext: a.nextStep,
      onPrevious: a.previousStep
    }, null, 40, ["componentStep", "currentStep", "original-declaration", "declaration-update-request", "onNext", "onPrevious"])), [
      [Ws, i.step === c + 1]
    ])), 128))
  ]);
}
const m0e = /* @__PURE__ */ we(_Q, [["render", TQ]]), AQ = {
  props: ["title", "value", "tooltipText"],
  components: {
    InformationCircleIcon: ds
  }
}, DQ = { class: "overflow-hidden rounded-lg bg-white px-2 py-4 shadow-lg sm:p-4" }, EQ = { class: "flex gap-x-2" }, PQ = { class: "truncate text-sm font-medium text-gray-500" }, OQ = { class: "mt-1 text-2xl font-semibold tracking-tight text-gray-900" };
function MQ(e, t, n, r, i, a) {
  const s = U("InformationCircleIcon"), o = U("VTooltip");
  return _(), O("div", DQ, [
    k("div", EQ, [
      k("dt", PQ, j(n.title), 1),
      n.tooltipText || e.$slots.tooltip ? (_(), ae(o, {
        key: 0,
        theme: "info-tooltip"
      }, {
        popper: ie(() => [
          xe(e.$slots, "tooltip", {}, () => [
            k("span", null, j(n.tooltipText), 1)
          ])
        ]),
        default: ie(() => [
          W(s, {
            class: "cursor-pointer h-5 w-4 text-gray-400",
            "aria-hidden": "true"
          })
        ]),
        _: 3
      })) : L("", !0)
    ]),
    k("dd", OQ, j(n.value), 1)
  ]);
}
const IQ = /* @__PURE__ */ we(AQ, [["render", MQ]]), RQ = {
  components: { ChevronDownIcon: CP, ChevronUpIcon: SP },
  props: {
    open: {
      type: Boolean,
      default: !0,
      required: !1
    },
    title: {
      type: String,
      required: !1,
      default: ""
    },
    subtitle: {
      type: String,
      required: !1,
      default: ""
    }
  },
  data() {
    return {
      collapsed: !1
    };
  },
  methods: {
    toggleCollapse() {
      this.collapsed = !this.collapsed, this.collapsed || this.$emit("openCollapse");
    }
  },
  watch: {
    open: {
      immediate: !0,
      handler() {
        this.collapsed = !this.open;
      }
    }
  }
}, FQ = { class: "bg-white shadow-sm overflow-hidden sm:rounded-lg" }, NQ = { class: "flex items-center items-stretch justify-between px-4 py-4 text-lg leading-6 font-medium text-gray-900" }, LQ = { class: "font-semibold" }, $Q = { class: "text-xs" }, VQ = { class: "flex" }, BQ = {
  key: 0,
  class: "flex flex-col border-t border-gray-200 bg-white"
};
function UQ(e, t, n, r, i, a) {
  const s = U("ChevronDownIcon"), o = U("ChevronUpIcon");
  return _(), O("div", FQ, [
    k("div", NQ, [
      k("div", {
        class: "cursor-pointer grow flex flex-col",
        onClick: t[0] || (t[0] = (...l) => a.toggleCollapse && a.toggleCollapse(...l))
      }, [
        k("h3", LQ, j(n.title), 1),
        k("p", $Q, j(n.subtitle), 1)
      ]),
      k("div", VQ, [
        xe(e.$slots, "header"),
        k("div", {
          class: "w-10 ml-2 cursor-pointer",
          onClick: t[1] || (t[1] = (...l) => a.toggleCollapse && a.toggleCollapse(...l))
        }, [
          i.collapsed ? (_(), ae(s, { key: 0 })) : (_(), ae(o, { key: 1 }))
        ])
      ])
    ]),
    i.collapsed ? L("", !0) : (_(), O("div", BQ, [
      xe(e.$slots, "default")
    ]))
  ]);
}
const g0e = /* @__PURE__ */ we(RQ, [["render", UQ]]), qQ = {
  fr: {
    monthly: {
      year: "numeric",
      month: "short"
    },
    long: {
      year: "numeric",
      month: "short",
      day: "numeric"
    },
    shortDate: {
      weekday: "short",
      day: "numeric",
      month: "short"
    },
    fullDate: {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric"
    },
    fullDateTime: {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }
  },
  "en-US": {
    monthly: {
      year: "numeric",
      month: "short"
    },
    long: {
      year: "numeric",
      month: "short",
      day: "numeric"
    },
    shortDate: {
      weekday: "short",
      day: "numeric",
      month: "short"
    },
    fullDate: {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric"
    },
    fullDateTime: {
      weekday: "long",
      day: "numeric",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }
  }
}, jQ = {
  fr: {
    currency: {
      style: "currency",
      currency: "EUR",
      useGrouping: !0,
      currencyDisplay: "symbol",
      trailingZeroDisplay: "stripIfInteger"
    },
    decimal: {
      style: "decimal",
      minimumSignificantDigits: 3,
      maximumSignificantDigits: 5
    },
    percent: {
      style: "percent",
      useGrouping: !1
    }
  },
  "en-US": {
    currency: {
      style: "currency",
      currency: "USD",
      notation: "standard"
    },
    decimal: {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    },
    percent: {
      style: "percent",
      useGrouping: !1
    }
  }
};
let jo;
function K0(e = { locale: "fr" }) {
  return jo || (jo = Zq({
    ...e,
    missingWarn: !1,
    globalInjection: !0,
    datetimeFormats: qQ,
    numberFormats: jQ
  })), jo;
}
function v0e(e = { locale: "fr" }) {
  return jo = K0(e), WQ(jo, e.locale, e.importMessages), jo;
}
function WQ(e, t, n) {
  e.mode === "legacy" ? e.global.locale = t : e.global.locale.value = t, document.querySelector("html").setAttribute("lang", t), zQ(e, t, n);
}
async function zQ(e, t, n) {
  const r = await n(t);
  return e.global.setLocaleMessage(t, r.default), Nn();
}
const b0e = {
  install: (e) => {
    e.config.globalProperties.$t = (t, n) => {
      if (t == null) {
        const r = window.location.pathname, i = new Error(`Missing key for $t in ${r} (key: ${t})`);
        return console.error(i), setTimeout(() => {
          var a, s;
          return (s = (a = e.config).errorHandler) == null ? void 0 : s.call(a, i);
        }, 0), "";
      }
      return jo.global.t(t, n);
    };
  }
};
function Si(e, t) {
  const n = parseFloat(e);
  if (isNaN(n) || !isFinite(n)) return null;
  let r = {};
  return Cr(t) && (r = { currency: t }), K0().global.n(n, "currency", r);
}
function _0e(e, t) {
  const n = Si(e, t);
  return n == null ? null : `${n} TTC`;
}
function X0(e) {
  return Cr(e) ? `${parseFloat((e * 100).toFixed(2))} %` : null;
}
const HQ = {
  components: { Alert: so },
  props: ["selectedRows", "selectableRows"]
}, GQ = { class: "ml-3 flex-1 md:flex md:justify-between" }, YQ = { class: "text-sm text-blue-500" }, KQ = { class: "font-bold" }, XQ = { class: "mt-3 text-sm md:ml-6 md:mt-0" };
function ZQ(e, t, n, r, i, a) {
  const s = U("Alert");
  return n.selectedRows.length > 0 ? (_(), ae(s, {
    key: 0,
    class: "mb-4"
  }, {
    title: ie(() => [
      k("div", GQ, [
        k("p", YQ, [
          t[2] || (t[2] = Me("Vous avez sélectionné ", -1)),
          k("span", KQ, j(n.selectedRows.length) + " éléments sur " + j(n.selectableRows.length), 1)
        ]),
        k("p", XQ, [
          n.selectedRows.length < n.selectableRows.length ? (_(), O("button", {
            key: 0,
            type: "button",
            class: "whitespace-nowrap underline font-medium text-blue-500 flex items-center gap-1",
            onClick: t[0] || (t[0] = (o) => e.$emit("selectAll"))
          }, " Tout sélectionner ")) : (_(), O("button", {
            key: 1,
            type: "button",
            class: "whitespace-nowrap underline font-medium text-blue-500 flex items-center gap-1",
            onClick: t[1] || (t[1] = (o) => e.$emit("unselectAll"))
          }, " Tout désélectionner "))
        ])
      ])
    ]),
    _: 1
  })) : L("", !0);
}
const QQ = /* @__PURE__ */ we(HQ, [["render", ZQ]]), JQ = {}, eJ = { class: "flex items-end m-2" };
function tJ(e, t, n, r, i, a) {
  return _(), O("span", eJ, [
    Me(j(e.$t("Loading")) + " ", 1),
    t[0] || (t[0] = G5('<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><circle cx="4" cy="12" r="3" opacity="1"><animate id="spinner_qYjJ" begin="0;spinner_t4KZ.end-0.25s" attributeName="opacity" dur="0.75s" values="1;.2" fill="freeze"></animate></circle><circle cx="12" cy="12" r="3" opacity=".4"><animate begin="spinner_qYjJ.begin+0.15s" attributeName="opacity" dur="0.75s" values="1;.2" fill="freeze"></animate></circle><circle cx="20" cy="12" r="3" opacity=".3"><animate id="spinner_t4KZ" begin="spinner_qYjJ.begin+0.3s" attributeName="opacity" dur="0.75s" values="1;.2" fill="freeze"></animate></circle></svg>', 1))
  ]);
}
const nJ = /* @__PURE__ */ we(JQ, [["render", tJ]]), rJ = {
  components: {
    SelectableTableAlert: QQ,
    Loading: nJ,
    TrashIcon: t0,
    DownloadIcon: bh,
    PencilAltIcon: Q5,
    EyeIcon: TP,
    ChevronUpIcon: SP,
    ChevronDownIcon: CP,
    SelectorIcon: Z5,
    InformationCircleIcon: ds
  },
  props: {
    columns: {
      type: Array,
      required: !0
    },
    data: {
      type: Array,
      required: !0
    },
    isDeletable: {
      type: Boolean,
      default: !1
    },
    isDownloadable: {
      type: Boolean,
      default: !1
    },
    isUpdatable: {
      type: Boolean,
      default: !1
    },
    isAccessible: {
      type: Boolean,
      default: !1
    },
    isRowClickable: {
      type: Boolean,
      default: !1
    },
    isSelectable: {
      type: Boolean,
      default: !1
    },
    isLoading: {
      type: Boolean,
      default: !1
    },
    noDataMsg: {
      type: String,
      default: ""
    },
    selectableRowFilter: {
      type: Function,
      required: !1
    },
    order: {
      type: String,
      default: null
    }
  },
  emits: [
    "sort",
    "rowClick",
    "delete",
    "update",
    "view",
    "download",
    "newSelectedRows"
  ],
  data() {
    return {
      headerGroupBorderClass: "border-l border-gray-200",
      selectedRows: [],
      canScrollLeft: !1,
      canScrollRight: !1
    };
  },
  mounted() {
    this.$nextTick(() => this.updateScrollIndicators()), this._resizeObserver = new ResizeObserver(
      () => this.updateScrollIndicators()
    ), this.$refs.scrollContainer && this._resizeObserver.observe(this.$refs.scrollContainer);
  },
  beforeUnmount() {
    this._resizeObserver && this._resizeObserver.disconnect();
  },
  watch: {
    selectedRows() {
      const e = this.selectedRows.map(
        (t) => this.data[t]
      );
      this.$emit("newSelectedRows", e);
    },
    data() {
      this.selectedRows = [];
    }
  },
  computed: {
    headerGroups() {
      const e = [];
      let t = { label: void 0, colspan: 0 };
      return this.columns.forEach((n) => {
        n.headerGroup !== t.label ? (t.colspan > 0 && e.push(t), t = { label: n.headerGroup, colspan: 1 }) : t.colspan += 1;
      }), e.push(t), e;
    },
    groupsBordersIndex() {
      return this.headerGroups.reduce((e, t, n) => (e.push(t.colspan + (e[n - 1] || 0)), e), []);
    },
    totalColumns() {
      let e = this.columns.length;
      return this.isDeletable && (e += 1), this.isDownloadable && (e += 1), this.isUpdatable && (e += 1), this.isAccessible && (e += 1), e;
    },
    orderDirection() {
      var e;
      return (e = this.order) != null && e.startsWith("-") ? "desc" : "asc";
    },
    orderField() {
      var e;
      return (e = this.order) == null ? void 0 : e.replace(/^-/, "");
    },
    selectableRows() {
      return this.selectableRowFilter ? this.data.filter((e) => this.selectableRowFilter(e)) : this.data;
    },
    anyLabelizedColumn() {
      return this.columns.some((e) => e.label);
    }
  },
  methods: {
    formatPrice: Si,
    formatPercentage: X0,
    isPresent: Cr,
    isHeaderGroupBorder(e) {
      return this.groupsBordersIndex.includes(e);
    },
    isFullRow(e) {
      return e.fullRow;
    },
    formatValue(e, t) {
      if (!Cr(e))
        return "—";
      if (typeof e == "number") {
        if (t.price) return this.formatPrice(e);
        if (t.percentage) return this.formatPercentage(e);
      }
      return typeof e == "string" ? t.price ? this.formatPrice(e) : this.$t(e) : e;
    },
    getCellClass(e, t) {
      const n = ["px-3 py-2.5 whitespace-nowrap text-gray-700 text-xs"];
      e.bold && n.push("text-black font-semibold"), (e.numeric || e.price) && n.push("text-right"), this.isHeaderGroupBorder(t) && n.push(this.headerGroupBorderClass);
      const r = this.getColumnWidthClass(e);
      return r && n.push(r), n;
    },
    getColumnWidthClass(e) {
      return e.widthClass ? e.widthClass : e.width ? null : "w-auto";
    },
    updateScrollIndicators() {
      const e = this.$refs.scrollContainer;
      e && (this.canScrollLeft = e.scrollLeft > 0, this.canScrollRight = e.scrollLeft + e.clientWidth < e.scrollWidth - 1);
    },
    getAriaSort(e) {
      return this.orderField !== e.field ? "none" : this.orderDirection === "asc" ? "ascending" : "descending";
    },
    emitSort(e) {
      e.sortable && this.$emit("sort", e);
    },
    onChangeRowSelection(e, t) {
      e.target.checked ? this.selectedRows.includes(t) || (this.selectedRows = [...this.selectedRows, t]) : this.selectedRows = this.selectedRows.filter(
        (r) => r !== t
      );
    },
    onChangeAllRowsSelection(e) {
      e.target.checked ? this.selectAll() : this.unselectAll();
    },
    selectAll() {
      this.selectableRowFilter ? this.selectedRows = this.data.map((e, t) => this.selectableRowFilter(e) ? t : null).filter((e) => e !== null) : this.selectedRows = this.selectableRows.map((e, t) => t);
    },
    unselectAll() {
      this.selectedRows = [];
    }
  }
}, iJ = { class: "relative" }, aJ = {
  class: /* @__PURE__ */ Pe("table-auto min-w-full divide-y divide-gray-200 text-sm")
}, sJ = {
  key: 0,
  class: "border-b border-gray-200"
}, oJ = { key: 0 }, lJ = ["colspan"], uJ = {
  key: 0,
  class: "px-3 py-2 w-auto"
}, cJ = {
  key: 1,
  class: "px-3 py-2 w-auto"
}, dJ = {
  key: 2,
  class: "px-3 py-2 w-auto"
}, fJ = {
  key: 3,
  class: "px-3 py-2 w-auto"
}, hJ = { key: 0 }, pJ = { class: "ml-2 flex items-center justify-center" }, mJ = ["checked"], gJ = ["aria-sort", "onClick"], vJ = { class: "inline-flex items-center gap-1" }, bJ = { class: "block max-w-xs whitespace-normal" }, _J = {
  key: 1,
  class: "w-1 px-3 py-2 w-auto"
}, yJ = {
  key: 2,
  class: "w-1 px-3 py-2 w-auto"
}, xJ = {
  key: 3,
  class: "w-1 px-3 py-2 w-auto"
}, wJ = {
  key: 4,
  class: "w-1 px-3 py-2 w-auto"
}, kJ = {
  key: 5,
  class: "w-1 px-3 py-2 w-auto"
}, SJ = { key: 1 }, CJ = { key: 2 }, TJ = ["colspan"], AJ = {
  key: 3,
  class: /* @__PURE__ */ Pe("divide-y divide-gray-100")
}, DJ = ["onClick"], EJ = {
  key: 0,
  class: "ml-2 flex items-center justify-center"
}, PJ = ["id", "name", "checked", "onChange"], OJ = ["innerHTML"], MJ = {
  key: 1,
  class: "text-right w-1 whitespace-nowrap pr-2"
}, IJ = {
  key: 1,
  class: "w-5 inline-block"
}, RJ = {
  key: 2,
  class: "text-right w-1 whitespace-nowrap pr-2"
}, FJ = {
  key: 3,
  class: "text-right w-1 whitespace-nowrap pr-2"
}, NJ = {
  key: 4,
  class: "text-right w-1 whitespace-nowrap pr-2"
}, LJ = { key: 5 }, $J = {
  class: "absolute top-0 left-0 bottom-0 w-6 pointer-events-none",
  style: { background: `linear-gradient(
            to right,
            rgba(0, 0, 0, 0.06),
            transparent
          )` }
}, VJ = {
  class: "absolute top-0 right-0 bottom-0 w-6 pointer-events-none",
  style: { background: `linear-gradient(
            to left,
            rgba(0, 0, 0, 0.06),
            transparent
          )` }
};
function BJ(e, t, n, r, i, a) {
  const s = U("SelectableTableAlert"), o = U("InformationCircleIcon"), l = U("VTooltip"), c = U("ChevronUpIcon"), f = U("ChevronDownIcon"), h = U("SelectorIcon"), p = U("Loading"), g = U("EyeIcon"), v = U("PencilAltIcon"), y = U("DownloadIcon"), S = U("TrashIcon");
  return _(), O("div", null, [
    n.isSelectable ? (_(), ae(s, {
      key: 0,
      "selectable-rows": a.selectableRows,
      "selected-rows": i.selectedRows,
      onSelectAll: a.selectAll,
      onUnselectAll: a.unselectAll
    }, null, 8, ["selectable-rows", "selected-rows", "onSelectAll", "onUnselectAll"])) : L("", !0),
    k("div", iJ, [
      k("div", {
        ref: "scrollContainer",
        class: "bg-white overflow-x-auto",
        onScroll: t[3] || (t[3] = (...x) => a.updateScrollIndicators && a.updateScrollIndicators(...x))
      }, [
        k("table", aJ, [
          a.anyLabelizedColumn ? (_(), O("thead", sJ, [
            a.headerGroups.length > 1 ? (_(), O("tr", oJ, [
              (_(!0), O(Re, null, Ke(a.headerGroups, (x, E) => (_(), O("th", {
                key: E,
                colspan: x.colspan,
                scope: "col",
                class: Pe(["px-3 py-2.5 text-center text-xs font-semibold text-gray-700 whitespace-nowrap w-auto", E > 0 ? i.headerGroupBorderClass : ""])
              }, j(x.label), 11, lJ))), 128)),
              n.isDeletable ? (_(), O("th", uJ)) : L("", !0),
              n.isDownloadable ? (_(), O("th", cJ)) : L("", !0),
              n.isUpdatable ? (_(), O("th", dJ)) : L("", !0),
              n.isAccessible ? (_(), O("th", fJ)) : L("", !0)
            ])) : L("", !0),
            k("tr", null, [
              n.isSelectable && a.selectableRows.length > 0 ? (_(), O("th", hJ, [
                k("div", pJ, [
                  k("input", {
                    id: "select-all-checkbox",
                    "aria-describedby": "select-all-checkbox",
                    name: "select-all-checkbox",
                    type: "checkbox",
                    onChange: t[0] || (t[0] = (...x) => a.onChangeAllRowsSelection && a.onChangeAllRowsSelection(...x)),
                    class: "cursor-pointer col-start-1 row-start-1 appearance-none rounded-sm border border-gray-300 bg-white transition-colors",
                    checked: i.selectedRows.length === a.selectableRows.length && a.selectableRows.length > 0
                  }, null, 40, mJ)
                ])
              ])) : L("", !0),
              (_(!0), O(Re, null, Ke(n.columns, (x, E) => (_(), O("th", {
                key: E,
                scope: "col",
                class: Pe([
                  "px-3 py-2.5 text-left text-xs font-semibold text-gray-700 whitespace-nowrap",
                  x.numeric || x.price ? "text-right" : "",
                  a.isHeaderGroupBorder(E) ? i.headerGroupBorderClass : "",
                  x.sortable ? "cursor-pointer select-none group" : "",
                  a.getColumnWidthClass(x)
                ]),
                "aria-sort": x.sortable ? a.getAriaSort(x) : void 0,
                onClick: sn((w) => a.emitSort(x), ["stop"])
              }, [
                k("span", vJ, [
                  Me(j(x.label) + " ", 1),
                  x.tooltip ? (_(), ae(l, {
                    key: 0,
                    theme: "info-tooltip",
                    class: "inline-flex",
                    onClick: t[1] || (t[1] = sn(() => {
                    }, ["stop"]))
                  }, {
                    popper: ie(() => [
                      k("span", bJ, j(x.tooltip), 1)
                    ]),
                    default: ie(() => [
                      W(o, {
                        class: "cursor-pointer h-4 w-4 text-gray-400",
                        "aria-hidden": "true"
                      })
                    ]),
                    _: 2
                  }, 1024)) : L("", !0),
                  x.sortable && a.orderField === x.field && a.orderDirection === "asc" ? (_(), ae(c, {
                    key: 1,
                    class: "h-4 w-4 text-primary group-hover:opacity-70 transition-opacity duration-150"
                  })) : x.sortable && a.orderField === x.field && a.orderDirection === "desc" ? (_(), ae(f, {
                    key: 2,
                    class: "h-4 w-4 text-primary group-hover:opacity-70 transition-opacity duration-150"
                  })) : x.sortable ? (_(), ae(h, {
                    key: 3,
                    class: "h-4 w-4 text-gray-300 group-hover:text-gray-500 transition-colors duration-150"
                  })) : L("", !0)
                ])
              ], 10, gJ))), 128)),
              n.isDeletable ? (_(), O("th", _J)) : L("", !0),
              n.isDownloadable ? (_(), O("th", yJ)) : L("", !0),
              n.isUpdatable ? (_(), O("th", xJ)) : L("", !0),
              n.isAccessible ? (_(), O("th", wJ)) : L("", !0),
              e.$slots.header ? (_(), O("th", kJ)) : L("", !0)
            ])
          ])) : L("", !0),
          n.isLoading ? (_(), O("tbody", SJ, [
            W(p)
          ])) : a.isPresent(n.noDataMsg) && n.data.length === 0 ? (_(), O("tbody", CJ, [
            k("tr", null, [
              k("td", {
                colspan: a.totalColumns,
                class: "text-center text-gray-400 text-sm py-8"
              }, j(n.noDataMsg), 9, TJ)
            ])
          ])) : (_(), O("tbody", AJ, [
            (_(!0), O(Re, null, Ke(n.data, (x, E) => (_(), O("tr", {
              key: E,
              class: Pe([
                "transition-colors duration-150",
                "group",
                ...n.isRowClickable && x.clickable !== !1 ? ["cursor-pointer", "hover:bg-gray-100"] : [],
                ...!a.selectableRows.includes(x) && a.selectableRows.length > 0 ? ["bg-gray-50"] : [],
                x.rowClass
              ]),
              onClick: (w) => n.isRowClickable && x.clickable !== !1 ? e.$emit("rowClick", x) : null
            }, [
              a.isFullRow(x) ? xe(e.$slots, x.slot, {
                row: x,
                colspan: a.totalColumns
              }, void 0, void 0, 0) : (_(), O(Re, { key: 1 }, [
                n.isSelectable && a.selectableRows.length > 0 ? (_(), O("td", {
                  key: 0,
                  onClick: t[2] || (t[2] = sn(() => {
                  }, ["stop"]))
                }, [
                  a.selectableRows.includes(x) ? (_(), O("div", EJ, [
                    k("input", {
                      id: "checkbox-" + E,
                      "aria-describedby": "checkbox",
                      name: "checkbox-" + E,
                      type: "checkbox",
                      class: "cursor-pointer col-start-1 row-start-1 appearance-none rounded-sm border border-gray-300 bg-white transition-colors",
                      checked: i.selectedRows.includes(E),
                      onChange: (w) => a.onChangeRowSelection(w, E)
                    }, null, 40, PJ)
                  ])) : L("", !0)
                ])) : L("", !0),
                (_(!0), O(Re, null, Ke(n.columns, (w, C) => (_(), O("td", {
                  key: C,
                  class: Pe(a.getCellClass(w, C))
                }, [
                  w.slot ? xe(e.$slots, w.slot, {
                    row: x,
                    column: w
                  }, void 0, void 0, 0) : (_(), O("span", {
                    key: 1,
                    innerHTML: a.formatValue(x[w.field], w),
                    class: Pe(
                      w.class ? w.class[x[w.field]] : ""
                    )
                  }, null, 10, OJ))
                ], 2))), 128)),
                n.isAccessible ? (_(), O("td", MJ, [
                  x.isAccessible !== !1 ? (_(), ae(g, {
                    key: 0,
                    class: "h-4 w-4 cursor-pointer inline-block text-gray-400 hover:text-gray-600 transition-colors duration-150",
                    onClick: sn(() => e.$emit("view", x), ["stop"])
                  }, null, 8, ["onClick"])) : (_(), O("span", IJ))
                ])) : L("", !0),
                n.isUpdatable && x.isUpdatable !== !1 ? (_(), O("td", RJ, [
                  W(v, {
                    class: "h-4 w-4 cursor-pointer inline-block text-gray-400 hover:text-gray-600 transition-colors duration-150",
                    onClick: sn(() => e.$emit("update", x), ["stop"])
                  }, null, 8, ["onClick"])
                ])) : L("", !0),
                n.isDownloadable ? (_(), O("td", FJ, [
                  W(y, {
                    class: "h-4 w-4 cursor-pointer inline-block text-gray-400 hover:text-gray-600 transition-colors duration-150",
                    onClick: sn(() => e.$emit("download", x), ["stop"])
                  }, null, 8, ["onClick"])
                ])) : L("", !0),
                n.isDeletable && x.isDeletable !== !1 ? (_(), O("td", NJ, [
                  W(S, {
                    class: "h-4 w-4 cursor-pointer inline-block text-gray-400 hover:text-red-500 transition-colors duration-150",
                    onClick: sn(() => e.$emit("delete", x), ["stop"])
                  }, null, 8, ["onClick"])
                ])) : L("", !0),
                e.$slots.customButton ? (_(), O("td", LJ, [
                  xe(e.$slots, "customButton", { row: x })
                ])) : L("", !0)
              ], 64))
            ], 10, DJ))), 128))
          ]))
        ])
      ], 544),
      ur(k("div", $J, null, 512), [
        [Ws, i.canScrollLeft]
      ]),
      ur(k("div", VJ, null, 512), [
        [Ws, i.canScrollRight]
      ])
    ])
  ]);
}
const yM = /* @__PURE__ */ we(rJ, [["render", BJ]]);
function pC(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "",
    resource: {
      fr: {
        seller_column_label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Vendeur" } },
        store_column_label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Point de vente" } },
        sales_column_label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ventes" } }
      },
      en: {
        seller_column_label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Seller" } },
        store_column_label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Store" } },
        sales_column_label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sales" } }
      }
    }
  });
}
const xM = {
  components: { Table: yM },
  props: {
    data: {
      type: Array,
      required: !0
    },
    salesColumnLabel: {
      type: String,
      default: ""
    }
  },
  setup() {
    const { t: e } = nr();
    return { t: e };
  },
  computed: {
    columns() {
      return [
        { label: this.t("seller_column_label"), field: "name", slot: "name" },
        {
          label: this.t("store_column_label"),
          field: "salesChannel",
          slot: "salesChannel",
          widthClass: "hidden md:table-cell"
        },
        {
          label: this.salesColumnLabel || this.t("sales_column_label"),
          field: "salesCount",
          slot: "salesCount",
          numeric: !0,
          widthClass: "w-20"
        }
      ];
    }
  }
}, UJ = { class: "text-sm font-semibold text-gray-900" }, qJ = {
  key: 0,
  class: "block md:hidden text-xs text-gray-400"
}, jJ = { class: "text-sm text-gray-600" }, WJ = { class: "text-sm text-gray-600" };
function zJ(e, t, n, r, i, a) {
  const s = U("Table");
  return _(), ae(s, {
    columns: a.columns,
    data: n.data
  }, {
    name: ie(({ row: o }) => [
      k("span", UJ, j(o.name), 1),
      o.salesChannel ? (_(), O("span", qJ, j(o.salesChannel), 1)) : L("", !0)
    ]),
    salesChannel: ie(({ row: o }) => [
      k("span", jJ, j(o.salesChannel), 1)
    ]),
    salesCount: ie(({ row: o }) => [
      k("span", WJ, j(o.salesCount), 1)
    ]),
    _: 1
  }, 8, ["columns", "data"]);
}
typeof pC == "function" && pC(xM);
const HJ = /* @__PURE__ */ we(xM, [["render", zJ]]);
function mC(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "",
    resource: {
      fr: {
        store_column_label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Point de vente" } },
        sales_column_label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ventes" } }
      },
      en: {
        store_column_label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Store" } },
        sales_column_label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sales" } }
      }
    }
  });
}
const wM = {
  components: { Table: yM },
  props: {
    data: {
      type: Array,
      required: !0
    },
    salesColumnLabel: {
      type: String,
      default: ""
    }
  },
  setup() {
    const { t: e } = nr();
    return { t: e };
  },
  computed: {
    columns() {
      return [
        { label: this.t("store_column_label"), field: "name", slot: "name" },
        {
          label: this.salesColumnLabel || this.t("sales_column_label"),
          field: "salesCount",
          slot: "salesCount",
          numeric: !0,
          widthClass: "w-20"
        }
      ];
    }
  }
}, GJ = { class: "text-sm font-semibold text-gray-900" }, YJ = { class: "text-sm text-gray-600" };
function KJ(e, t, n, r, i, a) {
  const s = U("Table");
  return _(), ae(s, {
    columns: a.columns,
    data: n.data
  }, {
    name: ie(({ row: o }) => [
      k("span", GJ, j(o.name), 1)
    ]),
    salesCount: ie(({ row: o }) => [
      k("span", YJ, j(o.salesCount), 1)
    ]),
    _: 1
  }, 8, ["columns", "data"]);
}
typeof mC == "function" && mC(wM);
const XJ = /* @__PURE__ */ we(wM, [["render", KJ]]);
/*!
 * Chart.js v3.9.1
 * https://www.chartjs.org
 * (c) 2022 Chart.js Contributors
 * Released under the MIT License
 */
function Ka() {
}
const ZJ = /* @__PURE__ */ (function() {
  let e = 0;
  return function() {
    return e++;
  };
})();
function Tt(e) {
  return e === null || typeof e > "u";
}
function Zt(e) {
  if (Array.isArray && Array.isArray(e))
    return !0;
  const t = Object.prototype.toString.call(e);
  return t.slice(0, 7) === "[object" && t.slice(-6) === "Array]";
}
function _t(e) {
  return e !== null && Object.prototype.toString.call(e) === "[object Object]";
}
const Pn = (e) => (typeof e == "number" || e instanceof Number) && isFinite(+e);
function $i(e, t) {
  return Pn(e) ? e : t;
}
function lt(e, t) {
  return typeof e > "u" ? t : e;
}
const QJ = (e, t) => typeof e == "string" && e.endsWith("%") ? parseFloat(e) / 100 : e / t, kM = (e, t) => typeof e == "string" && e.endsWith("%") ? parseFloat(e) / 100 * t : +e;
function Xt(e, t, n) {
  if (e && typeof e.call == "function")
    return e.apply(n, t);
}
function Yt(e, t, n, r) {
  let i, a, s;
  if (Zt(e))
    for (a = e.length, i = 0; i < a; i++)
      t.call(n, e[i], i);
  else if (_t(e))
    for (s = Object.keys(e), a = s.length, i = 0; i < a; i++)
      t.call(n, e[s[i]], s[i]);
}
function Vh(e, t) {
  let n, r, i, a;
  if (!e || !t || e.length !== t.length)
    return !1;
  for (n = 0, r = e.length; n < r; ++n)
    if (i = e[n], a = t[n], i.datasetIndex !== a.datasetIndex || i.index !== a.index)
      return !1;
  return !0;
}
function Bh(e) {
  if (Zt(e))
    return e.map(Bh);
  if (_t(e)) {
    const t = /* @__PURE__ */ Object.create(null), n = Object.keys(e), r = n.length;
    let i = 0;
    for (; i < r; ++i)
      t[n[i]] = Bh(e[n[i]]);
    return t;
  }
  return e;
}
function SM(e) {
  return ["__proto__", "prototype", "constructor"].indexOf(e) === -1;
}
function JJ(e, t, n, r) {
  if (!SM(e))
    return;
  const i = t[e], a = n[e];
  _t(i) && _t(a) ? Da(i, a, r) : t[e] = Bh(a);
}
function Da(e, t, n) {
  const r = Zt(t) ? t : [t], i = r.length;
  if (!_t(e))
    return e;
  n = n || {};
  const a = n.merger || JJ;
  for (let s = 0; s < i; ++s) {
    if (t = r[s], !_t(t))
      continue;
    const o = Object.keys(t);
    for (let l = 0, c = o.length; l < c; ++l)
      a(o[l], e, t, n);
  }
  return e;
}
function Ac(e, t) {
  return Da(e, t, { merger: eee });
}
function eee(e, t, n) {
  if (!SM(e))
    return;
  const r = t[e], i = n[e];
  _t(r) && _t(i) ? Ac(r, i) : Object.prototype.hasOwnProperty.call(t, e) || (t[e] = Bh(i));
}
const gC = {
  "": (e) => e,
  x: (e) => e.x,
  y: (e) => e.y
};
function Zs(e, t) {
  return (gC[t] || (gC[t] = tee(t)))(e);
}
function tee(e) {
  const t = nee(e);
  return (n) => {
    for (const r of t) {
      if (r === "")
        break;
      n = n && n[r];
    }
    return n;
  };
}
function nee(e) {
  const t = e.split("."), n = [];
  let r = "";
  for (const i of t)
    r += i, r.endsWith("\\") ? r = r.slice(0, -1) + "." : (n.push(r), r = "");
  return n;
}
function Z0(e) {
  return e.charAt(0).toUpperCase() + e.slice(1);
}
const zn = (e) => typeof e < "u", Qs = (e) => typeof e == "function", vC = (e, t) => {
  if (e.size !== t.size)
    return !1;
  for (const n of e)
    if (!t.has(n))
      return !1;
  return !0;
};
function ree(e) {
  return e.type === "mouseup" || e.type === "click" || e.type === "contextmenu";
}
const Wt = Math.PI, tn = 2 * Wt, iee = tn + Wt, Uh = Number.POSITIVE_INFINITY, CM = Wt / 180, Rn = Wt / 2, sc = Wt / 4, bC = Wt * 2 / 3, ji = Math.log10, Ta = Math.sign;
function _C(e) {
  const t = Math.round(e);
  e = Dc(e, t, e / 1e3) ? t : e;
  const n = Math.pow(10, Math.floor(ji(e))), r = e / n;
  return (r <= 1 ? 1 : r <= 2 ? 2 : r <= 5 ? 5 : 10) * n;
}
function aee(e) {
  const t = [], n = Math.sqrt(e);
  let r;
  for (r = 1; r < n; r++)
    e % r === 0 && (t.push(r), t.push(e / r));
  return n === (n | 0) && t.push(n), t.sort((i, a) => i - a).pop(), t;
}
function nu(e) {
  return !isNaN(parseFloat(e)) && isFinite(e);
}
function Dc(e, t, n) {
  return Math.abs(e - t) < n;
}
function see(e, t) {
  const n = Math.round(e);
  return n - t <= e && n + t >= e;
}
function TM(e, t, n) {
  let r, i, a;
  for (r = 0, i = e.length; r < i; r++)
    a = e[r][n], isNaN(a) || (t.min = Math.min(t.min, a), t.max = Math.max(t.max, a));
}
function er(e) {
  return e * (Wt / 180);
}
function Sp(e) {
  return e * (180 / Wt);
}
function yC(e) {
  if (!Pn(e))
    return;
  let t = 1, n = 0;
  for (; Math.round(e * t) / t !== e; )
    t *= 10, n++;
  return n;
}
function AM(e, t) {
  const n = t.x - e.x, r = t.y - e.y, i = Math.sqrt(n * n + r * r);
  let a = Math.atan2(r, n);
  return a < -0.5 * Wt && (a += tn), {
    angle: a,
    distance: i
  };
}
function jc(e, t) {
  return Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2));
}
function oee(e, t) {
  return (e - t + iee) % tn - Wt;
}
function _i(e) {
  return (e % tn + tn) % tn;
}
function Wc(e, t, n, r) {
  const i = _i(e), a = _i(t), s = _i(n), o = _i(a - i), l = _i(s - i), c = _i(i - a), f = _i(i - s);
  return i === a || i === s || r && a === s || o > l && c < f;
}
function vr(e, t, n) {
  return Math.max(t, Math.min(n, e));
}
function lee(e) {
  return vr(e, -32768, 32767);
}
function is(e, t, n, r = 1e-6) {
  return e >= Math.min(t, n) - r && e <= Math.max(t, n) + r;
}
function Q0(e, t, n) {
  n = n || ((s) => e[s] < t);
  let r = e.length - 1, i = 0, a;
  for (; r - i > 1; )
    a = i + r >> 1, n(a) ? i = a : r = a;
  return { lo: i, hi: r };
}
const as = (e, t, n, r) => Q0(e, n, r ? (i) => e[i][t] <= n : (i) => e[i][t] < n), uee = (e, t, n) => Q0(e, n, (r) => e[r][t] >= n);
function cee(e, t, n) {
  let r = 0, i = e.length;
  for (; r < i && e[r] < t; )
    r++;
  for (; i > r && e[i - 1] > n; )
    i--;
  return r > 0 || i < e.length ? e.slice(r, i) : e;
}
const DM = ["push", "pop", "shift", "splice", "unshift"];
function dee(e, t) {
  if (e._chartjs) {
    e._chartjs.listeners.push(t);
    return;
  }
  Object.defineProperty(e, "_chartjs", {
    configurable: !0,
    enumerable: !1,
    value: {
      listeners: [t]
    }
  }), DM.forEach((n) => {
    const r = "_onData" + Z0(n), i = e[n];
    Object.defineProperty(e, n, {
      configurable: !0,
      enumerable: !1,
      value(...a) {
        const s = i.apply(this, a);
        return e._chartjs.listeners.forEach((o) => {
          typeof o[r] == "function" && o[r](...a);
        }), s;
      }
    });
  });
}
function xC(e, t) {
  const n = e._chartjs;
  if (!n)
    return;
  const r = n.listeners, i = r.indexOf(t);
  i !== -1 && r.splice(i, 1), !(r.length > 0) && (DM.forEach((a) => {
    delete e[a];
  }), delete e._chartjs);
}
function EM(e) {
  const t = /* @__PURE__ */ new Set();
  let n, r;
  for (n = 0, r = e.length; n < r; ++n)
    t.add(e[n]);
  return t.size === r ? e : Array.from(t);
}
const PM = (function() {
  return typeof window > "u" ? function(e) {
    return e();
  } : window.requestAnimationFrame;
})();
function OM(e, t, n) {
  const r = n || ((s) => Array.prototype.slice.call(s));
  let i = !1, a = [];
  return function(...s) {
    a = r(s), i || (i = !0, PM.call(window, () => {
      i = !1, e.apply(t, a);
    }));
  };
}
function fee(e, t) {
  let n;
  return function(...r) {
    return t ? (clearTimeout(n), n = setTimeout(e, t, r)) : e.apply(this, r), t;
  };
}
const J0 = (e) => e === "start" ? "left" : e === "end" ? "right" : "center", Ir = (e, t, n) => e === "start" ? t : e === "end" ? n : (t + n) / 2, hee = (e, t, n, r) => e === (r ? "left" : "right") ? n : e === "center" ? (t + n) / 2 : t;
function MM(e, t, n) {
  const r = t.length;
  let i = 0, a = r;
  if (e._sorted) {
    const { iScale: s, _parsed: o } = e, l = s.axis, { min: c, max: f, minDefined: h, maxDefined: p } = s.getUserBounds();
    h && (i = vr(
      Math.min(
        as(o, s.axis, c).lo,
        n ? r : as(t, l, s.getPixelForValue(c)).lo
      ),
      0,
      r - 1
    )), p ? a = vr(
      Math.max(
        as(o, s.axis, f, !0).hi + 1,
        n ? 0 : as(t, l, s.getPixelForValue(f), !0).hi + 1
      ),
      i,
      r
    ) - i : a = r - i;
  }
  return { start: i, count: a };
}
function IM(e) {
  const { xScale: t, yScale: n, _scaleRanges: r } = e, i = {
    xmin: t.min,
    xmax: t.max,
    ymin: n.min,
    ymax: n.max
  };
  if (!r)
    return e._scaleRanges = i, !0;
  const a = r.xmin !== t.min || r.xmax !== t.max || r.ymin !== n.min || r.ymax !== n.max;
  return Object.assign(r, i), a;
}
const $f = (e) => e === 0 || e === 1, wC = (e, t, n) => -(Math.pow(2, 10 * (e -= 1)) * Math.sin((e - t) * tn / n)), kC = (e, t, n) => Math.pow(2, -10 * e) * Math.sin((e - t) * tn / n) + 1, Ec = {
  linear: (e) => e,
  easeInQuad: (e) => e * e,
  easeOutQuad: (e) => -e * (e - 2),
  easeInOutQuad: (e) => (e /= 0.5) < 1 ? 0.5 * e * e : -0.5 * (--e * (e - 2) - 1),
  easeInCubic: (e) => e * e * e,
  easeOutCubic: (e) => (e -= 1) * e * e + 1,
  easeInOutCubic: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e : 0.5 * ((e -= 2) * e * e + 2),
  easeInQuart: (e) => e * e * e * e,
  easeOutQuart: (e) => -((e -= 1) * e * e * e - 1),
  easeInOutQuart: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e * e : -0.5 * ((e -= 2) * e * e * e - 2),
  easeInQuint: (e) => e * e * e * e * e,
  easeOutQuint: (e) => (e -= 1) * e * e * e * e + 1,
  easeInOutQuint: (e) => (e /= 0.5) < 1 ? 0.5 * e * e * e * e * e : 0.5 * ((e -= 2) * e * e * e * e + 2),
  easeInSine: (e) => -Math.cos(e * Rn) + 1,
  easeOutSine: (e) => Math.sin(e * Rn),
  easeInOutSine: (e) => -0.5 * (Math.cos(Wt * e) - 1),
  easeInExpo: (e) => e === 0 ? 0 : Math.pow(2, 10 * (e - 1)),
  easeOutExpo: (e) => e === 1 ? 1 : -Math.pow(2, -10 * e) + 1,
  easeInOutExpo: (e) => $f(e) ? e : e < 0.5 ? 0.5 * Math.pow(2, 10 * (e * 2 - 1)) : 0.5 * (-Math.pow(2, -10 * (e * 2 - 1)) + 2),
  easeInCirc: (e) => e >= 1 ? e : -(Math.sqrt(1 - e * e) - 1),
  easeOutCirc: (e) => Math.sqrt(1 - (e -= 1) * e),
  easeInOutCirc: (e) => (e /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - e * e) - 1) : 0.5 * (Math.sqrt(1 - (e -= 2) * e) + 1),
  easeInElastic: (e) => $f(e) ? e : wC(e, 0.075, 0.3),
  easeOutElastic: (e) => $f(e) ? e : kC(e, 0.075, 0.3),
  easeInOutElastic(e) {
    return $f(e) ? e : e < 0.5 ? 0.5 * wC(e * 2, 0.1125, 0.45) : 0.5 + 0.5 * kC(e * 2 - 1, 0.1125, 0.45);
  },
  easeInBack(e) {
    return e * e * ((1.70158 + 1) * e - 1.70158);
  },
  easeOutBack(e) {
    return (e -= 1) * e * ((1.70158 + 1) * e + 1.70158) + 1;
  },
  easeInOutBack(e) {
    let t = 1.70158;
    return (e /= 0.5) < 1 ? 0.5 * (e * e * (((t *= 1.525) + 1) * e - t)) : 0.5 * ((e -= 2) * e * (((t *= 1.525) + 1) * e + t) + 2);
  },
  easeInBounce: (e) => 1 - Ec.easeOutBounce(1 - e),
  easeOutBounce(e) {
    return e < 1 / 2.75 ? 7.5625 * e * e : e < 2 / 2.75 ? 7.5625 * (e -= 1.5 / 2.75) * e + 0.75 : e < 2.5 / 2.75 ? 7.5625 * (e -= 2.25 / 2.75) * e + 0.9375 : 7.5625 * (e -= 2.625 / 2.75) * e + 0.984375;
  },
  easeInOutBounce: (e) => e < 0.5 ? Ec.easeInBounce(e * 2) * 0.5 : Ec.easeOutBounce(e * 2 - 1) * 0.5 + 0.5
};
/*!
 * @kurkle/color v0.2.1
 * https://github.com/kurkle/color#readme
 * (c) 2022 Jukka Kurkela
 * Released under the MIT License
 */
function cd(e) {
  return e + 0.5 | 0;
}
const Us = (e, t, n) => Math.max(Math.min(e, n), t);
function vc(e) {
  return Us(cd(e * 2.55), 0, 255);
}
function Hs(e) {
  return Us(cd(e * 255), 0, 255);
}
function Qa(e) {
  return Us(cd(e / 2.55) / 100, 0, 1);
}
function SC(e) {
  return Us(cd(e * 100), 0, 100);
}
const Ni = { 0: 0, 1: 1, 2: 2, 3: 3, 4: 4, 5: 5, 6: 6, 7: 7, 8: 8, 9: 9, A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, a: 10, b: 11, c: 12, d: 13, e: 14, f: 15 }, Cy = [..."0123456789ABCDEF"], pee = (e) => Cy[e & 15], mee = (e) => Cy[(e & 240) >> 4] + Cy[e & 15], Vf = (e) => (e & 240) >> 4 === (e & 15), gee = (e) => Vf(e.r) && Vf(e.g) && Vf(e.b) && Vf(e.a);
function vee(e) {
  var t = e.length, n;
  return e[0] === "#" && (t === 4 || t === 5 ? n = {
    r: 255 & Ni[e[1]] * 17,
    g: 255 & Ni[e[2]] * 17,
    b: 255 & Ni[e[3]] * 17,
    a: t === 5 ? Ni[e[4]] * 17 : 255
  } : (t === 7 || t === 9) && (n = {
    r: Ni[e[1]] << 4 | Ni[e[2]],
    g: Ni[e[3]] << 4 | Ni[e[4]],
    b: Ni[e[5]] << 4 | Ni[e[6]],
    a: t === 9 ? Ni[e[7]] << 4 | Ni[e[8]] : 255
  })), n;
}
const bee = (e, t) => e < 255 ? t(e) : "";
function _ee(e) {
  var t = gee(e) ? pee : mee;
  return e ? "#" + t(e.r) + t(e.g) + t(e.b) + bee(e.a, t) : void 0;
}
const yee = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function RM(e, t, n) {
  const r = t * Math.min(n, 1 - n), i = (a, s = (a + e / 30) % 12) => n - r * Math.max(Math.min(s - 3, 9 - s, 1), -1);
  return [i(0), i(8), i(4)];
}
function xee(e, t, n) {
  const r = (i, a = (i + e / 60) % 6) => n - n * t * Math.max(Math.min(a, 4 - a, 1), 0);
  return [r(5), r(3), r(1)];
}
function wee(e, t, n) {
  const r = RM(e, 1, 0.5);
  let i;
  for (t + n > 1 && (i = 1 / (t + n), t *= i, n *= i), i = 0; i < 3; i++)
    r[i] *= 1 - t - n, r[i] += t;
  return r;
}
function kee(e, t, n, r, i) {
  return e === i ? (t - n) / r + (t < n ? 6 : 0) : t === i ? (n - e) / r + 2 : (e - t) / r + 4;
}
function ex(e) {
  const n = e.r / 255, r = e.g / 255, i = e.b / 255, a = Math.max(n, r, i), s = Math.min(n, r, i), o = (a + s) / 2;
  let l, c, f;
  return a !== s && (f = a - s, c = o > 0.5 ? f / (2 - a - s) : f / (a + s), l = kee(n, r, i, f, a), l = l * 60 + 0.5), [l | 0, c || 0, o];
}
function tx(e, t, n, r) {
  return (Array.isArray(t) ? e(t[0], t[1], t[2]) : e(t, n, r)).map(Hs);
}
function nx(e, t, n) {
  return tx(RM, e, t, n);
}
function See(e, t, n) {
  return tx(wee, e, t, n);
}
function Cee(e, t, n) {
  return tx(xee, e, t, n);
}
function FM(e) {
  return (e % 360 + 360) % 360;
}
function Tee(e) {
  const t = yee.exec(e);
  let n = 255, r;
  if (!t)
    return;
  t[5] !== r && (n = t[6] ? vc(+t[5]) : Hs(+t[5]));
  const i = FM(+t[2]), a = +t[3] / 100, s = +t[4] / 100;
  return t[1] === "hwb" ? r = See(i, a, s) : t[1] === "hsv" ? r = Cee(i, a, s) : r = nx(i, a, s), {
    r: r[0],
    g: r[1],
    b: r[2],
    a: n
  };
}
function Aee(e, t) {
  var n = ex(e);
  n[0] = FM(n[0] + t), n = nx(n), e.r = n[0], e.g = n[1], e.b = n[2];
}
function Dee(e) {
  if (!e)
    return;
  const t = ex(e), n = t[0], r = SC(t[1]), i = SC(t[2]);
  return e.a < 255 ? `hsla(${n}, ${r}%, ${i}%, ${Qa(e.a)})` : `hsl(${n}, ${r}%, ${i}%)`;
}
const CC = {
  x: "dark",
  Z: "light",
  Y: "re",
  X: "blu",
  W: "gr",
  V: "medium",
  U: "slate",
  A: "ee",
  T: "ol",
  S: "or",
  B: "ra",
  C: "lateg",
  D: "ights",
  R: "in",
  Q: "turquois",
  E: "hi",
  P: "ro",
  O: "al",
  N: "le",
  M: "de",
  L: "yello",
  F: "en",
  K: "ch",
  G: "arks",
  H: "ea",
  I: "ightg",
  J: "wh"
}, TC = {
  OiceXe: "f0f8ff",
  antiquewEte: "faebd7",
  aqua: "ffff",
  aquamarRe: "7fffd4",
  azuY: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "0",
  blanKedOmond: "ffebcd",
  Xe: "ff",
  XeviTet: "8a2be2",
  bPwn: "a52a2a",
  burlywood: "deb887",
  caMtXe: "5f9ea0",
  KartYuse: "7fff00",
  KocTate: "d2691e",
  cSO: "ff7f50",
  cSnflowerXe: "6495ed",
  cSnsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "ffff",
  xXe: "8b",
  xcyan: "8b8b",
  xgTMnPd: "b8860b",
  xWay: "a9a9a9",
  xgYF: "6400",
  xgYy: "a9a9a9",
  xkhaki: "bdb76b",
  xmagFta: "8b008b",
  xTivegYF: "556b2f",
  xSange: "ff8c00",
  xScEd: "9932cc",
  xYd: "8b0000",
  xsOmon: "e9967a",
  xsHgYF: "8fbc8f",
  xUXe: "483d8b",
  xUWay: "2f4f4f",
  xUgYy: "2f4f4f",
  xQe: "ced1",
  xviTet: "9400d3",
  dAppRk: "ff1493",
  dApskyXe: "bfff",
  dimWay: "696969",
  dimgYy: "696969",
  dodgerXe: "1e90ff",
  fiYbrick: "b22222",
  flSOwEte: "fffaf0",
  foYstWAn: "228b22",
  fuKsia: "ff00ff",
  gaRsbSo: "dcdcdc",
  ghostwEte: "f8f8ff",
  gTd: "ffd700",
  gTMnPd: "daa520",
  Way: "808080",
  gYF: "8000",
  gYFLw: "adff2f",
  gYy: "808080",
  honeyMw: "f0fff0",
  hotpRk: "ff69b4",
  RdianYd: "cd5c5c",
  Rdigo: "4b0082",
  ivSy: "fffff0",
  khaki: "f0e68c",
  lavFMr: "e6e6fa",
  lavFMrXsh: "fff0f5",
  lawngYF: "7cfc00",
  NmoncEffon: "fffacd",
  ZXe: "add8e6",
  ZcSO: "f08080",
  Zcyan: "e0ffff",
  ZgTMnPdLw: "fafad2",
  ZWay: "d3d3d3",
  ZgYF: "90ee90",
  ZgYy: "d3d3d3",
  ZpRk: "ffb6c1",
  ZsOmon: "ffa07a",
  ZsHgYF: "20b2aa",
  ZskyXe: "87cefa",
  ZUWay: "778899",
  ZUgYy: "778899",
  ZstAlXe: "b0c4de",
  ZLw: "ffffe0",
  lime: "ff00",
  limegYF: "32cd32",
  lRF: "faf0e6",
  magFta: "ff00ff",
  maPon: "800000",
  VaquamarRe: "66cdaa",
  VXe: "cd",
  VScEd: "ba55d3",
  VpurpN: "9370db",
  VsHgYF: "3cb371",
  VUXe: "7b68ee",
  VsprRggYF: "fa9a",
  VQe: "48d1cc",
  VviTetYd: "c71585",
  midnightXe: "191970",
  mRtcYam: "f5fffa",
  mistyPse: "ffe4e1",
  moccasR: "ffe4b5",
  navajowEte: "ffdead",
  navy: "80",
  Tdlace: "fdf5e6",
  Tive: "808000",
  TivedBb: "6b8e23",
  Sange: "ffa500",
  SangeYd: "ff4500",
  ScEd: "da70d6",
  pOegTMnPd: "eee8aa",
  pOegYF: "98fb98",
  pOeQe: "afeeee",
  pOeviTetYd: "db7093",
  papayawEp: "ffefd5",
  pHKpuff: "ffdab9",
  peru: "cd853f",
  pRk: "ffc0cb",
  plum: "dda0dd",
  powMrXe: "b0e0e6",
  purpN: "800080",
  YbeccapurpN: "663399",
  Yd: "ff0000",
  Psybrown: "bc8f8f",
  PyOXe: "4169e1",
  saddNbPwn: "8b4513",
  sOmon: "fa8072",
  sandybPwn: "f4a460",
  sHgYF: "2e8b57",
  sHshell: "fff5ee",
  siFna: "a0522d",
  silver: "c0c0c0",
  skyXe: "87ceeb",
  UXe: "6a5acd",
  UWay: "708090",
  UgYy: "708090",
  snow: "fffafa",
  sprRggYF: "ff7f",
  stAlXe: "4682b4",
  tan: "d2b48c",
  teO: "8080",
  tEstN: "d8bfd8",
  tomato: "ff6347",
  Qe: "40e0d0",
  viTet: "ee82ee",
  JHt: "f5deb3",
  wEte: "ffffff",
  wEtesmoke: "f5f5f5",
  Lw: "ffff00",
  LwgYF: "9acd32"
};
function Eee() {
  const e = {}, t = Object.keys(TC), n = Object.keys(CC);
  let r, i, a, s, o;
  for (r = 0; r < t.length; r++) {
    for (s = o = t[r], i = 0; i < n.length; i++)
      a = n[i], o = o.replace(a, CC[a]);
    a = parseInt(TC[s], 16), e[o] = [a >> 16 & 255, a >> 8 & 255, a & 255];
  }
  return e;
}
let Bf;
function Pee(e) {
  Bf || (Bf = Eee(), Bf.transparent = [0, 0, 0, 0]);
  const t = Bf[e.toLowerCase()];
  return t && {
    r: t[0],
    g: t[1],
    b: t[2],
    a: t.length === 4 ? t[3] : 255
  };
}
const Oee = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function Mee(e) {
  const t = Oee.exec(e);
  let n = 255, r, i, a;
  if (t) {
    if (t[7] !== r) {
      const s = +t[7];
      n = t[8] ? vc(s) : Us(s * 255, 0, 255);
    }
    return r = +t[1], i = +t[3], a = +t[5], r = 255 & (t[2] ? vc(r) : Us(r, 0, 255)), i = 255 & (t[4] ? vc(i) : Us(i, 0, 255)), a = 255 & (t[6] ? vc(a) : Us(a, 0, 255)), {
      r,
      g: i,
      b: a,
      a: n
    };
  }
}
function Iee(e) {
  return e && (e.a < 255 ? `rgba(${e.r}, ${e.g}, ${e.b}, ${Qa(e.a)})` : `rgb(${e.r}, ${e.g}, ${e.b})`);
}
const Gg = (e) => e <= 31308e-7 ? e * 12.92 : Math.pow(e, 1 / 2.4) * 1.055 - 0.055, ql = (e) => e <= 0.04045 ? e / 12.92 : Math.pow((e + 0.055) / 1.055, 2.4);
function Ree(e, t, n) {
  const r = ql(Qa(e.r)), i = ql(Qa(e.g)), a = ql(Qa(e.b));
  return {
    r: Hs(Gg(r + n * (ql(Qa(t.r)) - r))),
    g: Hs(Gg(i + n * (ql(Qa(t.g)) - i))),
    b: Hs(Gg(a + n * (ql(Qa(t.b)) - a))),
    a: e.a + n * (t.a - e.a)
  };
}
function Uf(e, t, n) {
  if (e) {
    let r = ex(e);
    r[t] = Math.max(0, Math.min(r[t] + r[t] * n, t === 0 ? 360 : 1)), r = nx(r), e.r = r[0], e.g = r[1], e.b = r[2];
  }
}
function NM(e, t) {
  return e && Object.assign(t || {}, e);
}
function AC(e) {
  var t = { r: 0, g: 0, b: 0, a: 255 };
  return Array.isArray(e) ? e.length >= 3 && (t = { r: e[0], g: e[1], b: e[2], a: 255 }, e.length > 3 && (t.a = Hs(e[3]))) : (t = NM(e, { r: 0, g: 0, b: 0, a: 1 }), t.a = Hs(t.a)), t;
}
function Fee(e) {
  return e.charAt(0) === "r" ? Mee(e) : Tee(e);
}
class qh {
  constructor(t) {
    if (t instanceof qh)
      return t;
    const n = typeof t;
    let r;
    n === "object" ? r = AC(t) : n === "string" && (r = vee(t) || Pee(t) || Fee(t)), this._rgb = r, this._valid = !!r;
  }
  get valid() {
    return this._valid;
  }
  get rgb() {
    var t = NM(this._rgb);
    return t && (t.a = Qa(t.a)), t;
  }
  set rgb(t) {
    this._rgb = AC(t);
  }
  rgbString() {
    return this._valid ? Iee(this._rgb) : void 0;
  }
  hexString() {
    return this._valid ? _ee(this._rgb) : void 0;
  }
  hslString() {
    return this._valid ? Dee(this._rgb) : void 0;
  }
  mix(t, n) {
    if (t) {
      const r = this.rgb, i = t.rgb;
      let a;
      const s = n === a ? 0.5 : n, o = 2 * s - 1, l = r.a - i.a, c = ((o * l === -1 ? o : (o + l) / (1 + o * l)) + 1) / 2;
      a = 1 - c, r.r = 255 & c * r.r + a * i.r + 0.5, r.g = 255 & c * r.g + a * i.g + 0.5, r.b = 255 & c * r.b + a * i.b + 0.5, r.a = s * r.a + (1 - s) * i.a, this.rgb = r;
    }
    return this;
  }
  interpolate(t, n) {
    return t && (this._rgb = Ree(this._rgb, t._rgb, n)), this;
  }
  clone() {
    return new qh(this.rgb);
  }
  alpha(t) {
    return this._rgb.a = Hs(t), this;
  }
  clearer(t) {
    const n = this._rgb;
    return n.a *= 1 - t, this;
  }
  greyscale() {
    const t = this._rgb, n = cd(t.r * 0.3 + t.g * 0.59 + t.b * 0.11);
    return t.r = t.g = t.b = n, this;
  }
  opaquer(t) {
    const n = this._rgb;
    return n.a *= 1 + t, this;
  }
  negate() {
    const t = this._rgb;
    return t.r = 255 - t.r, t.g = 255 - t.g, t.b = 255 - t.b, this;
  }
  lighten(t) {
    return Uf(this._rgb, 2, t), this;
  }
  darken(t) {
    return Uf(this._rgb, 2, -t), this;
  }
  saturate(t) {
    return Uf(this._rgb, 1, t), this;
  }
  desaturate(t) {
    return Uf(this._rgb, 1, -t), this;
  }
  rotate(t) {
    return Aee(this._rgb, t), this;
  }
}
function LM(e) {
  return new qh(e);
}
function $M(e) {
  if (e && typeof e == "object") {
    const t = e.toString();
    return t === "[object CanvasPattern]" || t === "[object CanvasGradient]";
  }
  return !1;
}
function DC(e) {
  return $M(e) ? e : LM(e);
}
function Yg(e) {
  return $M(e) ? e : LM(e).saturate(0.5).darken(0.1).hexString();
}
const Zo = /* @__PURE__ */ Object.create(null), Ty = /* @__PURE__ */ Object.create(null);
function Pc(e, t) {
  if (!t)
    return e;
  const n = t.split(".");
  for (let r = 0, i = n.length; r < i; ++r) {
    const a = n[r];
    e = e[a] || (e[a] = /* @__PURE__ */ Object.create(null));
  }
  return e;
}
function Kg(e, t, n) {
  return typeof t == "string" ? Da(Pc(e, t), n) : Da(Pc(e, ""), t);
}
class Nee {
  constructor(t) {
    this.animation = void 0, this.backgroundColor = "rgba(0,0,0,0.1)", this.borderColor = "rgba(0,0,0,0.1)", this.color = "#666", this.datasets = {}, this.devicePixelRatio = (n) => n.chart.platform.getDevicePixelRatio(), this.elements = {}, this.events = [
      "mousemove",
      "mouseout",
      "click",
      "touchstart",
      "touchmove"
    ], this.font = {
      family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      size: 12,
      style: "normal",
      lineHeight: 1.2,
      weight: null
    }, this.hover = {}, this.hoverBackgroundColor = (n, r) => Yg(r.backgroundColor), this.hoverBorderColor = (n, r) => Yg(r.borderColor), this.hoverColor = (n, r) => Yg(r.color), this.indexAxis = "x", this.interaction = {
      mode: "nearest",
      intersect: !0,
      includeInvisible: !1
    }, this.maintainAspectRatio = !0, this.onHover = null, this.onClick = null, this.parsing = !0, this.plugins = {}, this.responsive = !0, this.scale = void 0, this.scales = {}, this.showLine = !0, this.drawActiveElementsOnTop = !0, this.describe(t);
  }
  set(t, n) {
    return Kg(this, t, n);
  }
  get(t) {
    return Pc(this, t);
  }
  describe(t, n) {
    return Kg(Ty, t, n);
  }
  override(t, n) {
    return Kg(Zo, t, n);
  }
  route(t, n, r, i) {
    const a = Pc(this, t), s = Pc(this, r), o = "_" + n;
    Object.defineProperties(a, {
      [o]: {
        value: a[n],
        writable: !0
      },
      [n]: {
        enumerable: !0,
        get() {
          const l = this[o], c = s[i];
          return _t(l) ? Object.assign({}, c, l) : lt(l, c);
        },
        set(l) {
          this[o] = l;
        }
      }
    });
  }
}
var Et = new Nee({
  _scriptable: (e) => !e.startsWith("on"),
  _indexable: (e) => e !== "events",
  hover: {
    _fallback: "interaction"
  },
  interaction: {
    _scriptable: !1,
    _indexable: !1
  }
});
function Lee(e) {
  return !e || Tt(e.size) || Tt(e.family) ? null : (e.style ? e.style + " " : "") + (e.weight ? e.weight + " " : "") + e.size + "px " + e.family;
}
function jh(e, t, n, r, i) {
  let a = t[i];
  return a || (a = t[i] = e.measureText(i).width, n.push(i)), a > r && (r = a), r;
}
function $ee(e, t, n, r) {
  r = r || {};
  let i = r.data = r.data || {}, a = r.garbageCollect = r.garbageCollect || [];
  r.font !== t && (i = r.data = {}, a = r.garbageCollect = [], r.font = t), e.save(), e.font = t;
  let s = 0;
  const o = n.length;
  let l, c, f, h, p;
  for (l = 0; l < o; l++)
    if (h = n[l], h != null && Zt(h) !== !0)
      s = jh(e, i, a, s, h);
    else if (Zt(h))
      for (c = 0, f = h.length; c < f; c++)
        p = h[c], p != null && !Zt(p) && (s = jh(e, i, a, s, p));
  e.restore();
  const g = a.length / 2;
  if (g > n.length) {
    for (l = 0; l < g; l++)
      delete i[a[l]];
    a.splice(0, g);
  }
  return s;
}
function Eo(e, t, n) {
  const r = e.currentDevicePixelRatio, i = n !== 0 ? Math.max(n / 2, 0.5) : 0;
  return Math.round((t - i) * r) / r + i;
}
function EC(e, t) {
  t = t || e.getContext("2d"), t.save(), t.resetTransform(), t.clearRect(0, 0, e.width, e.height), t.restore();
}
function Wh(e, t, n, r) {
  VM(e, t, n, r, null);
}
function VM(e, t, n, r, i) {
  let a, s, o, l, c, f;
  const h = t.pointStyle, p = t.rotation, g = t.radius;
  let v = (p || 0) * CM;
  if (h && typeof h == "object" && (a = h.toString(), a === "[object HTMLImageElement]" || a === "[object HTMLCanvasElement]")) {
    e.save(), e.translate(n, r), e.rotate(v), e.drawImage(h, -h.width / 2, -h.height / 2, h.width, h.height), e.restore();
    return;
  }
  if (!(isNaN(g) || g <= 0)) {
    switch (e.beginPath(), h) {
      default:
        i ? e.ellipse(n, r, i / 2, g, 0, 0, tn) : e.arc(n, r, g, 0, tn), e.closePath();
        break;
      case "triangle":
        e.moveTo(n + Math.sin(v) * g, r - Math.cos(v) * g), v += bC, e.lineTo(n + Math.sin(v) * g, r - Math.cos(v) * g), v += bC, e.lineTo(n + Math.sin(v) * g, r - Math.cos(v) * g), e.closePath();
        break;
      case "rectRounded":
        c = g * 0.516, l = g - c, s = Math.cos(v + sc) * l, o = Math.sin(v + sc) * l, e.arc(n - s, r - o, c, v - Wt, v - Rn), e.arc(n + o, r - s, c, v - Rn, v), e.arc(n + s, r + o, c, v, v + Rn), e.arc(n - o, r + s, c, v + Rn, v + Wt), e.closePath();
        break;
      case "rect":
        if (!p) {
          l = Math.SQRT1_2 * g, f = i ? i / 2 : l, e.rect(n - f, r - l, 2 * f, 2 * l);
          break;
        }
        v += sc;
      case "rectRot":
        s = Math.cos(v) * g, o = Math.sin(v) * g, e.moveTo(n - s, r - o), e.lineTo(n + o, r - s), e.lineTo(n + s, r + o), e.lineTo(n - o, r + s), e.closePath();
        break;
      case "crossRot":
        v += sc;
      case "cross":
        s = Math.cos(v) * g, o = Math.sin(v) * g, e.moveTo(n - s, r - o), e.lineTo(n + s, r + o), e.moveTo(n + o, r - s), e.lineTo(n - o, r + s);
        break;
      case "star":
        s = Math.cos(v) * g, o = Math.sin(v) * g, e.moveTo(n - s, r - o), e.lineTo(n + s, r + o), e.moveTo(n + o, r - s), e.lineTo(n - o, r + s), v += sc, s = Math.cos(v) * g, o = Math.sin(v) * g, e.moveTo(n - s, r - o), e.lineTo(n + s, r + o), e.moveTo(n + o, r - s), e.lineTo(n - o, r + s);
        break;
      case "line":
        s = i ? i / 2 : Math.cos(v) * g, o = Math.sin(v) * g, e.moveTo(n - s, r - o), e.lineTo(n + s, r + o);
        break;
      case "dash":
        e.moveTo(n, r), e.lineTo(n + Math.cos(v) * g, r + Math.sin(v) * g);
        break;
    }
    e.fill(), t.borderWidth > 0 && e.stroke();
  }
}
function zc(e, t, n) {
  return n = n || 0.5, !t || e && e.x > t.left - n && e.x < t.right + n && e.y > t.top - n && e.y < t.bottom + n;
}
function dd(e, t) {
  e.save(), e.beginPath(), e.rect(t.left, t.top, t.right - t.left, t.bottom - t.top), e.clip();
}
function fd(e) {
  e.restore();
}
function Vee(e, t, n, r, i) {
  if (!t)
    return e.lineTo(n.x, n.y);
  if (i === "middle") {
    const a = (t.x + n.x) / 2;
    e.lineTo(a, t.y), e.lineTo(a, n.y);
  } else i === "after" != !!r ? e.lineTo(t.x, n.y) : e.lineTo(n.x, t.y);
  e.lineTo(n.x, n.y);
}
function Bee(e, t, n, r) {
  if (!t)
    return e.lineTo(n.x, n.y);
  e.bezierCurveTo(
    r ? t.cp1x : t.cp2x,
    r ? t.cp1y : t.cp2y,
    r ? n.cp2x : n.cp1x,
    r ? n.cp2y : n.cp1y,
    n.x,
    n.y
  );
}
function Qo(e, t, n, r, i, a = {}) {
  const s = Zt(t) ? t : [t], o = a.strokeWidth > 0 && a.strokeColor !== "";
  let l, c;
  for (e.save(), e.font = i.string, Uee(e, a), l = 0; l < s.length; ++l)
    c = s[l], o && (a.strokeColor && (e.strokeStyle = a.strokeColor), Tt(a.strokeWidth) || (e.lineWidth = a.strokeWidth), e.strokeText(c, n, r, a.maxWidth)), e.fillText(c, n, r, a.maxWidth), qee(e, n, r, c, a), r += i.lineHeight;
  e.restore();
}
function Uee(e, t) {
  t.translation && e.translate(t.translation[0], t.translation[1]), Tt(t.rotation) || e.rotate(t.rotation), t.color && (e.fillStyle = t.color), t.textAlign && (e.textAlign = t.textAlign), t.textBaseline && (e.textBaseline = t.textBaseline);
}
function qee(e, t, n, r, i) {
  if (i.strikethrough || i.underline) {
    const a = e.measureText(r), s = t - a.actualBoundingBoxLeft, o = t + a.actualBoundingBoxRight, l = n - a.actualBoundingBoxAscent, c = n + a.actualBoundingBoxDescent, f = i.strikethrough ? (l + c) / 2 : c;
    e.strokeStyle = e.fillStyle, e.beginPath(), e.lineWidth = i.decorationWidth || 2, e.moveTo(s, f), e.lineTo(o, f), e.stroke();
  }
}
function ru(e, t) {
  const { x: n, y: r, w: i, h: a, radius: s } = t;
  e.arc(n + s.topLeft, r + s.topLeft, s.topLeft, -Rn, Wt, !0), e.lineTo(n, r + a - s.bottomLeft), e.arc(n + s.bottomLeft, r + a - s.bottomLeft, s.bottomLeft, Wt, Rn, !0), e.lineTo(n + i - s.bottomRight, r + a), e.arc(n + i - s.bottomRight, r + a - s.bottomRight, s.bottomRight, Rn, 0, !0), e.lineTo(n + i, r + s.topRight), e.arc(n + i - s.topRight, r + s.topRight, s.topRight, 0, -Rn, !0), e.lineTo(n + s.topLeft, r);
}
const jee = new RegExp(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/), Wee = new RegExp(/^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/);
function zee(e, t) {
  const n = ("" + e).match(jee);
  if (!n || n[1] === "normal")
    return t * 1.2;
  switch (e = +n[2], n[3]) {
    case "px":
      return e;
    case "%":
      e /= 100;
      break;
  }
  return t * e;
}
const Hee = (e) => +e || 0;
function rx(e, t) {
  const n = {}, r = _t(t), i = r ? Object.keys(t) : t, a = _t(e) ? r ? (s) => lt(e[s], e[t[s]]) : (s) => e[s] : () => e;
  for (const s of i)
    n[s] = Hee(a(s));
  return n;
}
function BM(e) {
  return rx(e, { top: "y", right: "x", bottom: "y", left: "x" });
}
function Gs(e) {
  return rx(e, ["topLeft", "topRight", "bottomLeft", "bottomRight"]);
}
function Hn(e) {
  const t = BM(e);
  return t.width = t.left + t.right, t.height = t.top + t.bottom, t;
}
function Fn(e, t) {
  e = e || {}, t = t || Et.font;
  let n = lt(e.size, t.size);
  typeof n == "string" && (n = parseInt(n, 10));
  let r = lt(e.style, t.style);
  r && !("" + r).match(Wee) && (console.warn('Invalid font style specified: "' + r + '"'), r = "");
  const i = {
    family: lt(e.family, t.family),
    lineHeight: zee(lt(e.lineHeight, t.lineHeight), n),
    size: n,
    style: r,
    weight: lt(e.weight, t.weight),
    string: ""
  };
  return i.string = Lee(i), i;
}
function hn(e, t, n, r) {
  let i, a, s;
  for (i = 0, a = e.length; i < a; ++i)
    if (s = e[i], s !== void 0 && (t !== void 0 && typeof s == "function" && (s = s(t)), n !== void 0 && Zt(s) && (s = s[n % s.length]), s !== void 0))
      return s;
}
function Gee(e, t, n) {
  const { min: r, max: i } = e, a = kM(t, (i - r) / 2), s = (o, l) => n && o === 0 ? 0 : o + l;
  return {
    min: s(r, -Math.abs(a)),
    max: s(i, a)
  };
}
function oo(e, t) {
  return Object.assign(Object.create(e), t);
}
function ix(e, t = [""], n = e, r, i = () => e[0]) {
  zn(r) || (r = WM("_fallback", e));
  const a = {
    [Symbol.toStringTag]: "Object",
    _cacheable: !0,
    _scopes: e,
    _rootScopes: n,
    _fallback: r,
    _getTarget: i,
    override: (s) => ix([s, ...e], t, n, r)
  };
  return new Proxy(a, {
    deleteProperty(s, o) {
      return delete s[o], delete s._keys, delete e[0][o], !0;
    },
    get(s, o) {
      return qM(
        s,
        o,
        () => tte(o, t, e, s)
      );
    },
    getOwnPropertyDescriptor(s, o) {
      return Reflect.getOwnPropertyDescriptor(s._scopes[0], o);
    },
    getPrototypeOf() {
      return Reflect.getPrototypeOf(e[0]);
    },
    has(s, o) {
      return OC(s).includes(o);
    },
    ownKeys(s) {
      return OC(s);
    },
    set(s, o, l) {
      const c = s._storage || (s._storage = i());
      return s[o] = c[o] = l, delete s._keys, !0;
    }
  });
}
function iu(e, t, n, r) {
  const i = {
    _cacheable: !1,
    _proxy: e,
    _context: t,
    _subProxy: n,
    _stack: /* @__PURE__ */ new Set(),
    _descriptors: UM(e, r),
    setContext: (a) => iu(e, a, n, r),
    override: (a) => iu(e.override(a), t, n, r)
  };
  return new Proxy(i, {
    deleteProperty(a, s) {
      return delete a[s], delete e[s], !0;
    },
    get(a, s, o) {
      return qM(
        a,
        s,
        () => Kee(a, s, o)
      );
    },
    getOwnPropertyDescriptor(a, s) {
      return a._descriptors.allKeys ? Reflect.has(e, s) ? { enumerable: !0, configurable: !0 } : void 0 : Reflect.getOwnPropertyDescriptor(e, s);
    },
    getPrototypeOf() {
      return Reflect.getPrototypeOf(e);
    },
    has(a, s) {
      return Reflect.has(e, s);
    },
    ownKeys() {
      return Reflect.ownKeys(e);
    },
    set(a, s, o) {
      return e[s] = o, delete a[s], !0;
    }
  });
}
function UM(e, t = { scriptable: !0, indexable: !0 }) {
  const { _scriptable: n = t.scriptable, _indexable: r = t.indexable, _allKeys: i = t.allKeys } = e;
  return {
    allKeys: i,
    scriptable: n,
    indexable: r,
    isScriptable: Qs(n) ? n : () => n,
    isIndexable: Qs(r) ? r : () => r
  };
}
const Yee = (e, t) => e ? e + Z0(t) : t, ax = (e, t) => _t(t) && e !== "adapters" && (Object.getPrototypeOf(t) === null || t.constructor === Object);
function qM(e, t, n) {
  if (Object.prototype.hasOwnProperty.call(e, t))
    return e[t];
  const r = n();
  return e[t] = r, r;
}
function Kee(e, t, n) {
  const { _proxy: r, _context: i, _subProxy: a, _descriptors: s } = e;
  let o = r[t];
  return Qs(o) && s.isScriptable(t) && (o = Xee(t, o, e, n)), Zt(o) && o.length && (o = Zee(t, o, e, s.isIndexable)), ax(t, o) && (o = iu(o, i, a && a[t], s)), o;
}
function Xee(e, t, n, r) {
  const { _proxy: i, _context: a, _subProxy: s, _stack: o } = n;
  if (o.has(e))
    throw new Error("Recursion detected: " + Array.from(o).join("->") + "->" + e);
  return o.add(e), t = t(a, s || r), o.delete(e), ax(e, t) && (t = sx(i._scopes, i, e, t)), t;
}
function Zee(e, t, n, r) {
  const { _proxy: i, _context: a, _subProxy: s, _descriptors: o } = n;
  if (zn(a.index) && r(e))
    t = t[a.index % t.length];
  else if (_t(t[0])) {
    const l = t, c = i._scopes.filter((f) => f !== l);
    t = [];
    for (const f of l) {
      const h = sx(c, i, e, f);
      t.push(iu(h, a, s && s[e], o));
    }
  }
  return t;
}
function jM(e, t, n) {
  return Qs(e) ? e(t, n) : e;
}
const Qee = (e, t) => e === !0 ? t : typeof e == "string" ? Zs(t, e) : void 0;
function Jee(e, t, n, r, i) {
  for (const a of t) {
    const s = Qee(n, a);
    if (s) {
      e.add(s);
      const o = jM(s._fallback, n, i);
      if (zn(o) && o !== n && o !== r)
        return o;
    } else if (s === !1 && zn(r) && n !== r)
      return null;
  }
  return !1;
}
function sx(e, t, n, r) {
  const i = t._rootScopes, a = jM(t._fallback, n, r), s = [...e, ...i], o = /* @__PURE__ */ new Set();
  o.add(r);
  let l = PC(o, s, n, a || n, r);
  return l === null || zn(a) && a !== n && (l = PC(o, s, a, l, r), l === null) ? !1 : ix(
    Array.from(o),
    [""],
    i,
    a,
    () => ete(t, n, r)
  );
}
function PC(e, t, n, r, i) {
  for (; n; )
    n = Jee(e, t, n, r, i);
  return n;
}
function ete(e, t, n) {
  const r = e._getTarget();
  t in r || (r[t] = {});
  const i = r[t];
  return Zt(i) && _t(n) ? n : i;
}
function tte(e, t, n, r) {
  let i;
  for (const a of t)
    if (i = WM(Yee(a, e), n), zn(i))
      return ax(e, i) ? sx(n, r, e, i) : i;
}
function WM(e, t) {
  for (const n of t) {
    if (!n)
      continue;
    const r = n[e];
    if (zn(r))
      return r;
  }
}
function OC(e) {
  let t = e._keys;
  return t || (t = e._keys = nte(e._scopes)), t;
}
function nte(e) {
  const t = /* @__PURE__ */ new Set();
  for (const n of e)
    for (const r of Object.keys(n).filter((i) => !i.startsWith("_")))
      t.add(r);
  return Array.from(t);
}
function zM(e, t, n, r) {
  const { iScale: i } = e, { key: a = "r" } = this._parsing, s = new Array(r);
  let o, l, c, f;
  for (o = 0, l = r; o < l; ++o)
    c = o + n, f = t[c], s[o] = {
      r: i.parse(Zs(f, a), c)
    };
  return s;
}
const rte = Number.EPSILON || 1e-14, au = (e, t) => t < e.length && !e[t].skip && e[t], HM = (e) => e === "x" ? "y" : "x";
function ite(e, t, n, r) {
  const i = e.skip ? t : e, a = t, s = n.skip ? t : n, o = jc(a, i), l = jc(s, a);
  let c = o / (o + l), f = l / (o + l);
  c = isNaN(c) ? 0 : c, f = isNaN(f) ? 0 : f;
  const h = r * c, p = r * f;
  return {
    previous: {
      x: a.x - h * (s.x - i.x),
      y: a.y - h * (s.y - i.y)
    },
    next: {
      x: a.x + p * (s.x - i.x),
      y: a.y + p * (s.y - i.y)
    }
  };
}
function ate(e, t, n) {
  const r = e.length;
  let i, a, s, o, l, c = au(e, 0);
  for (let f = 0; f < r - 1; ++f)
    if (l = c, c = au(e, f + 1), !(!l || !c)) {
      if (Dc(t[f], 0, rte)) {
        n[f] = n[f + 1] = 0;
        continue;
      }
      i = n[f] / t[f], a = n[f + 1] / t[f], o = Math.pow(i, 2) + Math.pow(a, 2), !(o <= 9) && (s = 3 / Math.sqrt(o), n[f] = i * s * t[f], n[f + 1] = a * s * t[f]);
    }
}
function ste(e, t, n = "x") {
  const r = HM(n), i = e.length;
  let a, s, o, l = au(e, 0);
  for (let c = 0; c < i; ++c) {
    if (s = o, o = l, l = au(e, c + 1), !o)
      continue;
    const f = o[n], h = o[r];
    s && (a = (f - s[n]) / 3, o[`cp1${n}`] = f - a, o[`cp1${r}`] = h - a * t[c]), l && (a = (l[n] - f) / 3, o[`cp2${n}`] = f + a, o[`cp2${r}`] = h + a * t[c]);
  }
}
function ote(e, t = "x") {
  const n = HM(t), r = e.length, i = Array(r).fill(0), a = Array(r);
  let s, o, l, c = au(e, 0);
  for (s = 0; s < r; ++s)
    if (o = l, l = c, c = au(e, s + 1), !!l) {
      if (c) {
        const f = c[t] - l[t];
        i[s] = f !== 0 ? (c[n] - l[n]) / f : 0;
      }
      a[s] = o ? c ? Ta(i[s - 1]) !== Ta(i[s]) ? 0 : (i[s - 1] + i[s]) / 2 : i[s - 1] : i[s];
    }
  ate(e, i, a), ste(e, a, t);
}
function qf(e, t, n) {
  return Math.max(Math.min(e, n), t);
}
function lte(e, t) {
  let n, r, i, a, s, o = zc(e[0], t);
  for (n = 0, r = e.length; n < r; ++n)
    s = a, a = o, o = n < r - 1 && zc(e[n + 1], t), a && (i = e[n], s && (i.cp1x = qf(i.cp1x, t.left, t.right), i.cp1y = qf(i.cp1y, t.top, t.bottom)), o && (i.cp2x = qf(i.cp2x, t.left, t.right), i.cp2y = qf(i.cp2y, t.top, t.bottom)));
}
function ute(e, t, n, r, i) {
  let a, s, o, l;
  if (t.spanGaps && (e = e.filter((c) => !c.skip)), t.cubicInterpolationMode === "monotone")
    ote(e, i);
  else {
    let c = r ? e[e.length - 1] : e[0];
    for (a = 0, s = e.length; a < s; ++a)
      o = e[a], l = ite(
        c,
        o,
        e[Math.min(a + 1, s - (r ? 0 : 1)) % s],
        t.tension
      ), o.cp1x = l.previous.x, o.cp1y = l.previous.y, o.cp2x = l.next.x, o.cp2y = l.next.y, c = o;
  }
  t.capBezierPoints && lte(e, n);
}
function GM() {
  return typeof window < "u" && typeof document < "u";
}
function ox(e) {
  let t = e.parentNode;
  return t && t.toString() === "[object ShadowRoot]" && (t = t.host), t;
}
function zh(e, t, n) {
  let r;
  return typeof e == "string" ? (r = parseInt(e, 10), e.indexOf("%") !== -1 && (r = r / 100 * t.parentNode[n])) : r = e, r;
}
const Cp = (e) => window.getComputedStyle(e, null);
function cte(e, t) {
  return Cp(e).getPropertyValue(t);
}
const dte = ["top", "right", "bottom", "left"];
function Wo(e, t, n) {
  const r = {};
  n = n ? "-" + n : "";
  for (let i = 0; i < 4; i++) {
    const a = dte[i];
    r[a] = parseFloat(e[t + "-" + a + n]) || 0;
  }
  return r.width = r.left + r.right, r.height = r.top + r.bottom, r;
}
const fte = (e, t, n) => (e > 0 || t > 0) && (!n || !n.shadowRoot);
function hte(e, t) {
  const n = e.touches, r = n && n.length ? n[0] : e, { offsetX: i, offsetY: a } = r;
  let s = !1, o, l;
  if (fte(i, a, e.target))
    o = i, l = a;
  else {
    const c = t.getBoundingClientRect();
    o = r.clientX - c.left, l = r.clientY - c.top, s = !0;
  }
  return { x: o, y: l, box: s };
}
function Io(e, t) {
  if ("native" in e)
    return e;
  const { canvas: n, currentDevicePixelRatio: r } = t, i = Cp(n), a = i.boxSizing === "border-box", s = Wo(i, "padding"), o = Wo(i, "border", "width"), { x: l, y: c, box: f } = hte(e, n), h = s.left + (f && o.left), p = s.top + (f && o.top);
  let { width: g, height: v } = t;
  return a && (g -= s.width + o.width, v -= s.height + o.height), {
    x: Math.round((l - h) / g * n.width / r),
    y: Math.round((c - p) / v * n.height / r)
  };
}
function pte(e, t, n) {
  let r, i;
  if (t === void 0 || n === void 0) {
    const a = ox(e);
    if (!a)
      t = e.clientWidth, n = e.clientHeight;
    else {
      const s = a.getBoundingClientRect(), o = Cp(a), l = Wo(o, "border", "width"), c = Wo(o, "padding");
      t = s.width - c.width - l.width, n = s.height - c.height - l.height, r = zh(o.maxWidth, a, "clientWidth"), i = zh(o.maxHeight, a, "clientHeight");
    }
  }
  return {
    width: t,
    height: n,
    maxWidth: r || Uh,
    maxHeight: i || Uh
  };
}
const Xg = (e) => Math.round(e * 10) / 10;
function mte(e, t, n, r) {
  const i = Cp(e), a = Wo(i, "margin"), s = zh(i.maxWidth, e, "clientWidth") || Uh, o = zh(i.maxHeight, e, "clientHeight") || Uh, l = pte(e, t, n);
  let { width: c, height: f } = l;
  if (i.boxSizing === "content-box") {
    const h = Wo(i, "border", "width"), p = Wo(i, "padding");
    c -= p.width + h.width, f -= p.height + h.height;
  }
  return c = Math.max(0, c - a.width), f = Math.max(0, r ? Math.floor(c / r) : f - a.height), c = Xg(Math.min(c, s, l.maxWidth)), f = Xg(Math.min(f, o, l.maxHeight)), c && !f && (f = Xg(c / 2)), {
    width: c,
    height: f
  };
}
function MC(e, t, n) {
  const r = t || 1, i = Math.floor(e.height * r), a = Math.floor(e.width * r);
  e.height = i / r, e.width = a / r;
  const s = e.canvas;
  return s.style && (n || !s.style.height && !s.style.width) && (s.style.height = `${e.height}px`, s.style.width = `${e.width}px`), e.currentDevicePixelRatio !== r || s.height !== i || s.width !== a ? (e.currentDevicePixelRatio = r, s.height = i, s.width = a, e.ctx.setTransform(r, 0, 0, r, 0, 0), !0) : !1;
}
const gte = (function() {
  let e = !1;
  try {
    const t = {
      get passive() {
        return e = !0, !1;
      }
    };
    window.addEventListener("test", null, t), window.removeEventListener("test", null, t);
  } catch {
  }
  return e;
})();
function IC(e, t) {
  const n = cte(e, t), r = n && n.match(/^(\d+)(\.\d+)?px$/);
  return r ? +r[1] : void 0;
}
function Ro(e, t, n, r) {
  return {
    x: e.x + n * (t.x - e.x),
    y: e.y + n * (t.y - e.y)
  };
}
function vte(e, t, n, r) {
  return {
    x: e.x + n * (t.x - e.x),
    y: r === "middle" ? n < 0.5 ? e.y : t.y : r === "after" ? n < 1 ? e.y : t.y : n > 0 ? t.y : e.y
  };
}
function bte(e, t, n, r) {
  const i = { x: e.cp2x, y: e.cp2y }, a = { x: t.cp1x, y: t.cp1y }, s = Ro(e, i, n), o = Ro(i, a, n), l = Ro(a, t, n), c = Ro(s, o, n), f = Ro(o, l, n);
  return Ro(c, f, n);
}
const RC = /* @__PURE__ */ new Map();
function _te(e, t) {
  t = t || {};
  const n = e + JSON.stringify(t);
  let r = RC.get(n);
  return r || (r = new Intl.NumberFormat(e, t), RC.set(n, r)), r;
}
function hd(e, t, n) {
  return _te(t, n).format(e);
}
const yte = function(e, t) {
  return {
    x(n) {
      return e + e + t - n;
    },
    setWidth(n) {
      t = n;
    },
    textAlign(n) {
      return n === "center" ? n : n === "right" ? "left" : "right";
    },
    xPlus(n, r) {
      return n - r;
    },
    leftForLtr(n, r) {
      return n - r;
    }
  };
}, xte = function() {
  return {
    x(e) {
      return e;
    },
    setWidth(e) {
    },
    textAlign(e) {
      return e;
    },
    xPlus(e, t) {
      return e + t;
    },
    leftForLtr(e, t) {
      return e;
    }
  };
};
function Kl(e, t, n) {
  return e ? yte(t, n) : xte();
}
function YM(e, t) {
  let n, r;
  (t === "ltr" || t === "rtl") && (n = e.canvas.style, r = [
    n.getPropertyValue("direction"),
    n.getPropertyPriority("direction")
  ], n.setProperty("direction", t, "important"), e.prevTextDirection = r);
}
function KM(e, t) {
  t !== void 0 && (delete e.prevTextDirection, e.canvas.style.setProperty("direction", t[0], t[1]));
}
function XM(e) {
  return e === "angle" ? {
    between: Wc,
    compare: oee,
    normalize: _i
  } : {
    between: is,
    compare: (t, n) => t - n,
    normalize: (t) => t
  };
}
function FC({ start: e, end: t, count: n, loop: r, style: i }) {
  return {
    start: e % n,
    end: t % n,
    loop: r && (t - e + 1) % n === 0,
    style: i
  };
}
function wte(e, t, n) {
  const { property: r, start: i, end: a } = n, { between: s, normalize: o } = XM(r), l = t.length;
  let { start: c, end: f, loop: h } = e, p, g;
  if (h) {
    for (c += l, f += l, p = 0, g = l; p < g && s(o(t[c % l][r]), i, a); ++p)
      c--, f--;
    c %= l, f %= l;
  }
  return f < c && (f += l), { start: c, end: f, loop: h, style: e.style };
}
function ZM(e, t, n) {
  if (!n)
    return [e];
  const { property: r, start: i, end: a } = n, s = t.length, { compare: o, between: l, normalize: c } = XM(r), { start: f, end: h, loop: p, style: g } = wte(e, t, n), v = [];
  let y = !1, S = null, x, E, w;
  const C = () => l(i, w, x) && o(i, w) !== 0, P = () => o(a, x) === 0 || l(a, w, x), M = () => y || C(), T = () => !y || P();
  for (let N = f, $ = f; N <= h; ++N)
    E = t[N % s], !E.skip && (x = c(E[r]), x !== w && (y = l(x, i, a), S === null && M() && (S = o(x, i) === 0 ? N : $), S !== null && T() && (v.push(FC({ start: S, end: N, loop: p, count: s, style: g })), S = null), $ = N, w = x));
  return S !== null && v.push(FC({ start: S, end: h, loop: p, count: s, style: g })), v;
}
function QM(e, t) {
  const n = [], r = e.segments;
  for (let i = 0; i < r.length; i++) {
    const a = ZM(r[i], e.points, t);
    a.length && n.push(...a);
  }
  return n;
}
function kte(e, t, n, r) {
  let i = 0, a = t - 1;
  if (n && !r)
    for (; i < t && !e[i].skip; )
      i++;
  for (; i < t && e[i].skip; )
    i++;
  for (i %= t, n && (a += i); a > i && e[a % t].skip; )
    a--;
  return a %= t, { start: i, end: a };
}
function Ste(e, t, n, r) {
  const i = e.length, a = [];
  let s = t, o = e[t], l;
  for (l = t + 1; l <= n; ++l) {
    const c = e[l % i];
    c.skip || c.stop ? o.skip || (r = !1, a.push({ start: t % i, end: (l - 1) % i, loop: r }), t = s = c.stop ? l : null) : (s = l, o.skip && (t = l)), o = c;
  }
  return s !== null && a.push({ start: t % i, end: s % i, loop: r }), a;
}
function Cte(e, t) {
  const n = e.points, r = e.options.spanGaps, i = n.length;
  if (!i)
    return [];
  const a = !!e._loop, { start: s, end: o } = kte(n, i, a, r);
  if (r === !0)
    return NC(e, [{ start: s, end: o, loop: a }], n, t);
  const l = o < s ? o + i : o, c = !!e._fullLoop && s === 0 && o === i - 1;
  return NC(e, Ste(n, s, l, c), n, t);
}
function NC(e, t, n, r) {
  return !r || !r.setContext || !n ? t : Tte(e, t, n, r);
}
function Tte(e, t, n, r) {
  const i = e._chart.getContext(), a = LC(e.options), { _datasetIndex: s, options: { spanGaps: o } } = e, l = n.length, c = [];
  let f = a, h = t[0].start, p = h;
  function g(v, y, S, x) {
    const E = o ? -1 : 1;
    if (v !== y) {
      for (v += l; n[v % l].skip; )
        v -= E;
      for (; n[y % l].skip; )
        y += E;
      v % l !== y % l && (c.push({ start: v % l, end: y % l, loop: S, style: x }), f = x, h = y % l);
    }
  }
  for (const v of t) {
    h = o ? h : v.start;
    let y = n[h % l], S;
    for (p = h + 1; p <= v.end; p++) {
      const x = n[p % l];
      S = LC(r.setContext(oo(i, {
        type: "segment",
        p0: y,
        p1: x,
        p0DataIndex: (p - 1) % l,
        p1DataIndex: p % l,
        datasetIndex: s
      }))), Ate(S, f) && g(h, p - 1, v.loop, f), y = x, f = S;
    }
    h < p - 1 && g(h, p - 1, v.loop, f);
  }
  return c;
}
function LC(e) {
  return {
    backgroundColor: e.backgroundColor,
    borderCapStyle: e.borderCapStyle,
    borderDash: e.borderDash,
    borderDashOffset: e.borderDashOffset,
    borderJoinStyle: e.borderJoinStyle,
    borderWidth: e.borderWidth,
    borderColor: e.borderColor
  };
}
function Ate(e, t) {
  return t && JSON.stringify(e) !== JSON.stringify(t);
}
/*!
 * Chart.js v3.9.1
 * https://www.chartjs.org
 * (c) 2022 Chart.js Contributors
 * Released under the MIT License
 */
class Dte {
  constructor() {
    this._request = null, this._charts = /* @__PURE__ */ new Map(), this._running = !1, this._lastDate = void 0;
  }
  _notify(t, n, r, i) {
    const a = n.listeners[i], s = n.duration;
    a.forEach((o) => o({
      chart: t,
      initial: n.initial,
      numSteps: s,
      currentStep: Math.min(r - n.start, s)
    }));
  }
  _refresh() {
    this._request || (this._running = !0, this._request = PM.call(window, () => {
      this._update(), this._request = null, this._running && this._refresh();
    }));
  }
  _update(t = Date.now()) {
    let n = 0;
    this._charts.forEach((r, i) => {
      if (!r.running || !r.items.length)
        return;
      const a = r.items;
      let s = a.length - 1, o = !1, l;
      for (; s >= 0; --s)
        l = a[s], l._active ? (l._total > r.duration && (r.duration = l._total), l.tick(t), o = !0) : (a[s] = a[a.length - 1], a.pop());
      o && (i.draw(), this._notify(i, r, t, "progress")), a.length || (r.running = !1, this._notify(i, r, t, "complete"), r.initial = !1), n += a.length;
    }), this._lastDate = t, n === 0 && (this._running = !1);
  }
  _getAnims(t) {
    const n = this._charts;
    let r = n.get(t);
    return r || (r = {
      running: !1,
      initial: !0,
      items: [],
      listeners: {
        complete: [],
        progress: []
      }
    }, n.set(t, r)), r;
  }
  listen(t, n, r) {
    this._getAnims(t).listeners[n].push(r);
  }
  add(t, n) {
    !n || !n.length || this._getAnims(t).items.push(...n);
  }
  has(t) {
    return this._getAnims(t).items.length > 0;
  }
  start(t) {
    const n = this._charts.get(t);
    n && (n.running = !0, n.start = Date.now(), n.duration = n.items.reduce((r, i) => Math.max(r, i._duration), 0), this._refresh());
  }
  running(t) {
    if (!this._running)
      return !1;
    const n = this._charts.get(t);
    return !(!n || !n.running || !n.items.length);
  }
  stop(t) {
    const n = this._charts.get(t);
    if (!n || !n.items.length)
      return;
    const r = n.items;
    let i = r.length - 1;
    for (; i >= 0; --i)
      r[i].cancel();
    n.items = [], this._notify(t, n, Date.now(), "complete");
  }
  remove(t) {
    return this._charts.delete(t);
  }
}
var Xa = new Dte();
const $C = "transparent", Ete = {
  boolean(e, t, n) {
    return n > 0.5 ? t : e;
  },
  color(e, t, n) {
    const r = DC(e || $C), i = r.valid && DC(t || $C);
    return i && i.valid ? i.mix(r, n).hexString() : t;
  },
  number(e, t, n) {
    return e + (t - e) * n;
  }
};
class Pte {
  constructor(t, n, r, i) {
    const a = n[r];
    i = hn([t.to, i, a, t.from]);
    const s = hn([t.from, a, i]);
    this._active = !0, this._fn = t.fn || Ete[t.type || typeof s], this._easing = Ec[t.easing] || Ec.linear, this._start = Math.floor(Date.now() + (t.delay || 0)), this._duration = this._total = Math.floor(t.duration), this._loop = !!t.loop, this._target = n, this._prop = r, this._from = s, this._to = i, this._promises = void 0;
  }
  active() {
    return this._active;
  }
  update(t, n, r) {
    if (this._active) {
      this._notify(!1);
      const i = this._target[this._prop], a = r - this._start, s = this._duration - a;
      this._start = r, this._duration = Math.floor(Math.max(s, t.duration)), this._total += a, this._loop = !!t.loop, this._to = hn([t.to, n, i, t.from]), this._from = hn([t.from, i, n]);
    }
  }
  cancel() {
    this._active && (this.tick(Date.now()), this._active = !1, this._notify(!1));
  }
  tick(t) {
    const n = t - this._start, r = this._duration, i = this._prop, a = this._from, s = this._loop, o = this._to;
    let l;
    if (this._active = a !== o && (s || n < r), !this._active) {
      this._target[i] = o, this._notify(!0);
      return;
    }
    if (n < 0) {
      this._target[i] = a;
      return;
    }
    l = n / r % 2, l = s && l > 1 ? 2 - l : l, l = this._easing(Math.min(1, Math.max(0, l))), this._target[i] = this._fn(a, o, l);
  }
  wait() {
    const t = this._promises || (this._promises = []);
    return new Promise((n, r) => {
      t.push({ res: n, rej: r });
    });
  }
  _notify(t) {
    const n = t ? "res" : "rej", r = this._promises || [];
    for (let i = 0; i < r.length; i++)
      r[i][n]();
  }
}
const Ote = ["x", "y", "borderWidth", "radius", "tension"], Mte = ["color", "borderColor", "backgroundColor"];
Et.set("animation", {
  delay: void 0,
  duration: 1e3,
  easing: "easeOutQuart",
  fn: void 0,
  from: void 0,
  loop: void 0,
  to: void 0,
  type: void 0
});
const Ite = Object.keys(Et.animation);
Et.describe("animation", {
  _fallback: !1,
  _indexable: !1,
  _scriptable: (e) => e !== "onProgress" && e !== "onComplete" && e !== "fn"
});
Et.set("animations", {
  colors: {
    type: "color",
    properties: Mte
  },
  numbers: {
    type: "number",
    properties: Ote
  }
});
Et.describe("animations", {
  _fallback: "animation"
});
Et.set("transitions", {
  active: {
    animation: {
      duration: 400
    }
  },
  resize: {
    animation: {
      duration: 0
    }
  },
  show: {
    animations: {
      colors: {
        from: "transparent"
      },
      visible: {
        type: "boolean",
        duration: 0
      }
    }
  },
  hide: {
    animations: {
      colors: {
        to: "transparent"
      },
      visible: {
        type: "boolean",
        easing: "linear",
        fn: (e) => e | 0
      }
    }
  }
});
class lx {
  constructor(t, n) {
    this._chart = t, this._properties = /* @__PURE__ */ new Map(), this.configure(n);
  }
  configure(t) {
    if (!_t(t))
      return;
    const n = this._properties;
    Object.getOwnPropertyNames(t).forEach((r) => {
      const i = t[r];
      if (!_t(i))
        return;
      const a = {};
      for (const s of Ite)
        a[s] = i[s];
      (Zt(i.properties) && i.properties || [r]).forEach((s) => {
        (s === r || !n.has(s)) && n.set(s, a);
      });
    });
  }
  _animateOptions(t, n) {
    const r = n.options, i = Fte(t, r);
    if (!i)
      return [];
    const a = this._createAnimations(i, r);
    return r.$shared && Rte(t.options.$animations, r).then(() => {
      t.options = r;
    }, () => {
    }), a;
  }
  _createAnimations(t, n) {
    const r = this._properties, i = [], a = t.$animations || (t.$animations = {}), s = Object.keys(n), o = Date.now();
    let l;
    for (l = s.length - 1; l >= 0; --l) {
      const c = s[l];
      if (c.charAt(0) === "$")
        continue;
      if (c === "options") {
        i.push(...this._animateOptions(t, n));
        continue;
      }
      const f = n[c];
      let h = a[c];
      const p = r.get(c);
      if (h)
        if (p && h.active()) {
          h.update(p, f, o);
          continue;
        } else
          h.cancel();
      if (!p || !p.duration) {
        t[c] = f;
        continue;
      }
      a[c] = h = new Pte(p, t, c, f), i.push(h);
    }
    return i;
  }
  update(t, n) {
    if (this._properties.size === 0) {
      Object.assign(t, n);
      return;
    }
    const r = this._createAnimations(t, n);
    if (r.length)
      return Xa.add(this._chart, r), !0;
  }
}
function Rte(e, t) {
  const n = [], r = Object.keys(t);
  for (let i = 0; i < r.length; i++) {
    const a = e[r[i]];
    a && a.active() && n.push(a.wait());
  }
  return Promise.all(n);
}
function Fte(e, t) {
  if (!t)
    return;
  let n = e.options;
  if (!n) {
    e.options = t;
    return;
  }
  return n.$shared && (e.options = n = Object.assign({}, n, { $shared: !1, $animations: {} })), n;
}
function VC(e, t) {
  const n = e && e.options || {}, r = n.reverse, i = n.min === void 0 ? t : 0, a = n.max === void 0 ? t : 0;
  return {
    start: r ? a : i,
    end: r ? i : a
  };
}
function Nte(e, t, n) {
  if (n === !1)
    return !1;
  const r = VC(e, n), i = VC(t, n);
  return {
    top: i.end,
    right: r.end,
    bottom: i.start,
    left: r.start
  };
}
function Lte(e) {
  let t, n, r, i;
  return _t(e) ? (t = e.top, n = e.right, r = e.bottom, i = e.left) : t = n = r = i = e, {
    top: t,
    right: n,
    bottom: r,
    left: i,
    disabled: e === !1
  };
}
function JM(e, t) {
  const n = [], r = e._getSortedDatasetMetas(t);
  let i, a;
  for (i = 0, a = r.length; i < a; ++i)
    n.push(r[i].index);
  return n;
}
function BC(e, t, n, r = {}) {
  const i = e.keys, a = r.mode === "single";
  let s, o, l, c;
  if (t !== null) {
    for (s = 0, o = i.length; s < o; ++s) {
      if (l = +i[s], l === n) {
        if (r.all)
          continue;
        break;
      }
      c = e.values[l], Pn(c) && (a || t === 0 || Ta(t) === Ta(c)) && (t += c);
    }
    return t;
  }
}
function $te(e) {
  const t = Object.keys(e), n = new Array(t.length);
  let r, i, a;
  for (r = 0, i = t.length; r < i; ++r)
    a = t[r], n[r] = {
      x: a,
      y: e[a]
    };
  return n;
}
function UC(e, t) {
  const n = e && e.options.stacked;
  return n || n === void 0 && t.stack !== void 0;
}
function Vte(e, t, n) {
  return `${e.id}.${t.id}.${n.stack || n.type}`;
}
function Bte(e) {
  const { min: t, max: n, minDefined: r, maxDefined: i } = e.getUserBounds();
  return {
    min: r ? t : Number.NEGATIVE_INFINITY,
    max: i ? n : Number.POSITIVE_INFINITY
  };
}
function Ute(e, t, n) {
  const r = e[t] || (e[t] = {});
  return r[n] || (r[n] = {});
}
function qC(e, t, n, r) {
  for (const i of t.getMatchingVisibleMetas(r).reverse()) {
    const a = e[i.index];
    if (n && a > 0 || !n && a < 0)
      return i.index;
  }
  return null;
}
function jC(e, t) {
  const { chart: n, _cachedMeta: r } = e, i = n._stacks || (n._stacks = {}), { iScale: a, vScale: s, index: o } = r, l = a.axis, c = s.axis, f = Vte(a, s, r), h = t.length;
  let p;
  for (let g = 0; g < h; ++g) {
    const v = t[g], { [l]: y, [c]: S } = v, x = v._stacks || (v._stacks = {});
    p = x[c] = Ute(i, f, y), p[o] = S, p._top = qC(p, s, !0, r.type), p._bottom = qC(p, s, !1, r.type);
  }
}
function Zg(e, t) {
  const n = e.scales;
  return Object.keys(n).filter((r) => n[r].axis === t).shift();
}
function qte(e, t) {
  return oo(
    e,
    {
      active: !1,
      dataset: void 0,
      datasetIndex: t,
      index: t,
      mode: "default",
      type: "dataset"
    }
  );
}
function jte(e, t, n) {
  return oo(e, {
    active: !1,
    dataIndex: t,
    parsed: void 0,
    raw: void 0,
    element: n,
    index: t,
    mode: "default",
    type: "data"
  });
}
function oc(e, t) {
  const n = e.controller.index, r = e.vScale && e.vScale.axis;
  if (r) {
    t = t || e._parsed;
    for (const i of t) {
      const a = i._stacks;
      if (!a || a[r] === void 0 || a[r][n] === void 0)
        return;
      delete a[r][n];
    }
  }
}
const Qg = (e) => e === "reset" || e === "none", WC = (e, t) => t ? e : Object.assign({}, e), Wte = (e, t, n) => e && !t.hidden && t._stacked && { keys: JM(n, !0), values: null };
class ha {
  constructor(t, n) {
    this.chart = t, this._ctx = t.ctx, this.index = n, this._cachedDataOpts = {}, this._cachedMeta = this.getMeta(), this._type = this._cachedMeta.type, this.options = void 0, this._parsing = !1, this._data = void 0, this._objectData = void 0, this._sharedOptions = void 0, this._drawStart = void 0, this._drawCount = void 0, this.enableOptionSharing = !1, this.supportsDecimation = !1, this.$context = void 0, this._syncList = [], this.initialize();
  }
  initialize() {
    const t = this._cachedMeta;
    this.configure(), this.linkScales(), t._stacked = UC(t.vScale, t), this.addElements();
  }
  updateIndex(t) {
    this.index !== t && oc(this._cachedMeta), this.index = t;
  }
  linkScales() {
    const t = this.chart, n = this._cachedMeta, r = this.getDataset(), i = (h, p, g, v) => h === "x" ? p : h === "r" ? v : g, a = n.xAxisID = lt(r.xAxisID, Zg(t, "x")), s = n.yAxisID = lt(r.yAxisID, Zg(t, "y")), o = n.rAxisID = lt(r.rAxisID, Zg(t, "r")), l = n.indexAxis, c = n.iAxisID = i(l, a, s, o), f = n.vAxisID = i(l, s, a, o);
    n.xScale = this.getScaleForId(a), n.yScale = this.getScaleForId(s), n.rScale = this.getScaleForId(o), n.iScale = this.getScaleForId(c), n.vScale = this.getScaleForId(f);
  }
  getDataset() {
    return this.chart.data.datasets[this.index];
  }
  getMeta() {
    return this.chart.getDatasetMeta(this.index);
  }
  getScaleForId(t) {
    return this.chart.scales[t];
  }
  _getOtherScale(t) {
    const n = this._cachedMeta;
    return t === n.iScale ? n.vScale : n.iScale;
  }
  reset() {
    this._update("reset");
  }
  _destroy() {
    const t = this._cachedMeta;
    this._data && xC(this._data, this), t._stacked && oc(t);
  }
  _dataCheck() {
    const t = this.getDataset(), n = t.data || (t.data = []), r = this._data;
    if (_t(n))
      this._data = $te(n);
    else if (r !== n) {
      if (r) {
        xC(r, this);
        const i = this._cachedMeta;
        oc(i), i._parsed = [];
      }
      n && Object.isExtensible(n) && dee(n, this), this._syncList = [], this._data = n;
    }
  }
  addElements() {
    const t = this._cachedMeta;
    this._dataCheck(), this.datasetElementType && (t.dataset = new this.datasetElementType());
  }
  buildOrUpdateElements(t) {
    const n = this._cachedMeta, r = this.getDataset();
    let i = !1;
    this._dataCheck();
    const a = n._stacked;
    n._stacked = UC(n.vScale, n), n.stack !== r.stack && (i = !0, oc(n), n.stack = r.stack), this._resyncElements(t), (i || a !== n._stacked) && jC(this, n._parsed);
  }
  configure() {
    const t = this.chart.config, n = t.datasetScopeKeys(this._type), r = t.getOptionScopes(this.getDataset(), n, !0);
    this.options = t.createResolver(r, this.getContext()), this._parsing = this.options.parsing, this._cachedDataOpts = {};
  }
  parse(t, n) {
    const { _cachedMeta: r, _data: i } = this, { iScale: a, _stacked: s } = r, o = a.axis;
    let l = t === 0 && n === i.length ? !0 : r._sorted, c = t > 0 && r._parsed[t - 1], f, h, p;
    if (this._parsing === !1)
      r._parsed = i, r._sorted = !0, p = i;
    else {
      Zt(i[t]) ? p = this.parseArrayData(r, i, t, n) : _t(i[t]) ? p = this.parseObjectData(r, i, t, n) : p = this.parsePrimitiveData(r, i, t, n);
      const g = () => h[o] === null || c && h[o] < c[o];
      for (f = 0; f < n; ++f)
        r._parsed[f + t] = h = p[f], l && (g() && (l = !1), c = h);
      r._sorted = l;
    }
    s && jC(this, p);
  }
  parsePrimitiveData(t, n, r, i) {
    const { iScale: a, vScale: s } = t, o = a.axis, l = s.axis, c = a.getLabels(), f = a === s, h = new Array(i);
    let p, g, v;
    for (p = 0, g = i; p < g; ++p)
      v = p + r, h[p] = {
        [o]: f || a.parse(c[v], v),
        [l]: s.parse(n[v], v)
      };
    return h;
  }
  parseArrayData(t, n, r, i) {
    const { xScale: a, yScale: s } = t, o = new Array(i);
    let l, c, f, h;
    for (l = 0, c = i; l < c; ++l)
      f = l + r, h = n[f], o[l] = {
        x: a.parse(h[0], f),
        y: s.parse(h[1], f)
      };
    return o;
  }
  parseObjectData(t, n, r, i) {
    const { xScale: a, yScale: s } = t, { xAxisKey: o = "x", yAxisKey: l = "y" } = this._parsing, c = new Array(i);
    let f, h, p, g;
    for (f = 0, h = i; f < h; ++f)
      p = f + r, g = n[p], c[f] = {
        x: a.parse(Zs(g, o), p),
        y: s.parse(Zs(g, l), p)
      };
    return c;
  }
  getParsed(t) {
    return this._cachedMeta._parsed[t];
  }
  getDataElement(t) {
    return this._cachedMeta.data[t];
  }
  applyStack(t, n, r) {
    const i = this.chart, a = this._cachedMeta, s = n[t.axis], o = {
      keys: JM(i, !0),
      values: n._stacks[t.axis]
    };
    return BC(o, s, a.index, { mode: r });
  }
  updateRangeFromParsed(t, n, r, i) {
    const a = r[n.axis];
    let s = a === null ? NaN : a;
    const o = i && r._stacks[n.axis];
    i && o && (i.values = o, s = BC(i, a, this._cachedMeta.index)), t.min = Math.min(t.min, s), t.max = Math.max(t.max, s);
  }
  getMinMax(t, n) {
    const r = this._cachedMeta, i = r._parsed, a = r._sorted && t === r.iScale, s = i.length, o = this._getOtherScale(t), l = Wte(n, r, this.chart), c = { min: Number.POSITIVE_INFINITY, max: Number.NEGATIVE_INFINITY }, { min: f, max: h } = Bte(o);
    let p, g;
    function v() {
      g = i[p];
      const y = g[o.axis];
      return !Pn(g[t.axis]) || f > y || h < y;
    }
    for (p = 0; p < s && !(!v() && (this.updateRangeFromParsed(c, t, g, l), a)); ++p)
      ;
    if (a) {
      for (p = s - 1; p >= 0; --p)
        if (!v()) {
          this.updateRangeFromParsed(c, t, g, l);
          break;
        }
    }
    return c;
  }
  getAllParsedValues(t) {
    const n = this._cachedMeta._parsed, r = [];
    let i, a, s;
    for (i = 0, a = n.length; i < a; ++i)
      s = n[i][t.axis], Pn(s) && r.push(s);
    return r;
  }
  getMaxOverflow() {
    return !1;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, r = n.iScale, i = n.vScale, a = this.getParsed(t);
    return {
      label: r ? "" + r.getLabelForValue(a[r.axis]) : "",
      value: i ? "" + i.getLabelForValue(a[i.axis]) : ""
    };
  }
  _update(t) {
    const n = this._cachedMeta;
    this.update(t || "default"), n._clip = Lte(lt(this.options.clip, Nte(n.xScale, n.yScale, this.getMaxOverflow())));
  }
  update(t) {
  }
  draw() {
    const t = this._ctx, n = this.chart, r = this._cachedMeta, i = r.data || [], a = n.chartArea, s = [], o = this._drawStart || 0, l = this._drawCount || i.length - o, c = this.options.drawActiveElementsOnTop;
    let f;
    for (r.dataset && r.dataset.draw(t, a, o, l), f = o; f < o + l; ++f) {
      const h = i[f];
      h.hidden || (h.active && c ? s.push(h) : h.draw(t, a));
    }
    for (f = 0; f < s.length; ++f)
      s[f].draw(t, a);
  }
  getStyle(t, n) {
    const r = n ? "active" : "default";
    return t === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(r) : this.resolveDataElementOptions(t || 0, r);
  }
  getContext(t, n, r) {
    const i = this.getDataset();
    let a;
    if (t >= 0 && t < this._cachedMeta.data.length) {
      const s = this._cachedMeta.data[t];
      a = s.$context || (s.$context = jte(this.getContext(), t, s)), a.parsed = this.getParsed(t), a.raw = i.data[t], a.index = a.dataIndex = t;
    } else
      a = this.$context || (this.$context = qte(this.chart.getContext(), this.index)), a.dataset = i, a.index = a.datasetIndex = this.index;
    return a.active = !!n, a.mode = r, a;
  }
  resolveDatasetElementOptions(t) {
    return this._resolveElementOptions(this.datasetElementType.id, t);
  }
  resolveDataElementOptions(t, n) {
    return this._resolveElementOptions(this.dataElementType.id, n, t);
  }
  _resolveElementOptions(t, n = "default", r) {
    const i = n === "active", a = this._cachedDataOpts, s = t + "-" + n, o = a[s], l = this.enableOptionSharing && zn(r);
    if (o)
      return WC(o, l);
    const c = this.chart.config, f = c.datasetElementScopeKeys(this._type, t), h = i ? [`${t}Hover`, "hover", t, ""] : [t, ""], p = c.getOptionScopes(this.getDataset(), f), g = Object.keys(Et.elements[t]), v = () => this.getContext(r, i), y = c.resolveNamedOptions(p, g, v, h);
    return y.$shared && (y.$shared = l, a[s] = Object.freeze(WC(y, l))), y;
  }
  _resolveAnimations(t, n, r) {
    const i = this.chart, a = this._cachedDataOpts, s = `animation-${n}`, o = a[s];
    if (o)
      return o;
    let l;
    if (i.options.animation !== !1) {
      const f = this.chart.config, h = f.datasetAnimationScopeKeys(this._type, n), p = f.getOptionScopes(this.getDataset(), h);
      l = f.createResolver(p, this.getContext(t, r, n));
    }
    const c = new lx(i, l && l.animations);
    return l && l._cacheable && (a[s] = Object.freeze(c)), c;
  }
  getSharedOptions(t) {
    if (t.$shared)
      return this._sharedOptions || (this._sharedOptions = Object.assign({}, t));
  }
  includeOptions(t, n) {
    return !n || Qg(t) || this.chart._animationsDisabled;
  }
  _getSharedOptions(t, n) {
    const r = this.resolveDataElementOptions(t, n), i = this._sharedOptions, a = this.getSharedOptions(r), s = this.includeOptions(n, a) || a !== i;
    return this.updateSharedOptions(a, n, r), { sharedOptions: a, includeOptions: s };
  }
  updateElement(t, n, r, i) {
    Qg(i) ? Object.assign(t, r) : this._resolveAnimations(n, i).update(t, r);
  }
  updateSharedOptions(t, n, r) {
    t && !Qg(n) && this._resolveAnimations(void 0, n).update(t, r);
  }
  _setStyle(t, n, r, i) {
    t.active = i;
    const a = this.getStyle(n, i);
    this._resolveAnimations(n, r, i).update(t, {
      options: !i && this.getSharedOptions(a) || a
    });
  }
  removeHoverStyle(t, n, r) {
    this._setStyle(t, r, "active", !1);
  }
  setHoverStyle(t, n, r) {
    this._setStyle(t, r, "active", !0);
  }
  _removeDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !1);
  }
  _setDatasetHoverStyle() {
    const t = this._cachedMeta.dataset;
    t && this._setStyle(t, void 0, "active", !0);
  }
  _resyncElements(t) {
    const n = this._data, r = this._cachedMeta.data;
    for (const [o, l, c] of this._syncList)
      this[o](l, c);
    this._syncList = [];
    const i = r.length, a = n.length, s = Math.min(a, i);
    s && this.parse(0, s), a > i ? this._insertElements(i, a - i, t) : a < i && this._removeElements(a, i - a);
  }
  _insertElements(t, n, r = !0) {
    const i = this._cachedMeta, a = i.data, s = t + n;
    let o;
    const l = (c) => {
      for (c.length += n, o = c.length - 1; o >= s; o--)
        c[o] = c[o - n];
    };
    for (l(a), o = t; o < s; ++o)
      a[o] = new this.dataElementType();
    this._parsing && l(i._parsed), this.parse(t, n), r && this.updateElements(a, t, n, "reset");
  }
  updateElements(t, n, r, i) {
  }
  _removeElements(t, n) {
    const r = this._cachedMeta;
    if (this._parsing) {
      const i = r._parsed.splice(t, n);
      r._stacked && oc(r, i);
    }
    r.data.splice(t, n);
  }
  _sync(t) {
    if (this._parsing)
      this._syncList.push(t);
    else {
      const [n, r, i] = t;
      this[n](r, i);
    }
    this.chart._dataChanges.push([this.index, ...t]);
  }
  _onDataPush() {
    const t = arguments.length;
    this._sync(["_insertElements", this.getDataset().data.length - t, t]);
  }
  _onDataPop() {
    this._sync(["_removeElements", this._cachedMeta.data.length - 1, 1]);
  }
  _onDataShift() {
    this._sync(["_removeElements", 0, 1]);
  }
  _onDataSplice(t, n) {
    n && this._sync(["_removeElements", t, n]);
    const r = arguments.length - 2;
    r && this._sync(["_insertElements", t, r]);
  }
  _onDataUnshift() {
    this._sync(["_insertElements", 0, arguments.length]);
  }
}
ha.defaults = {};
ha.prototype.datasetElementType = null;
ha.prototype.dataElementType = null;
function zte(e, t) {
  if (!e._cache.$bar) {
    const n = e.getMatchingVisibleMetas(t);
    let r = [];
    for (let i = 0, a = n.length; i < a; i++)
      r = r.concat(n[i].controller.getAllParsedValues(e));
    e._cache.$bar = EM(r.sort((i, a) => i - a));
  }
  return e._cache.$bar;
}
function Hte(e) {
  const t = e.iScale, n = zte(t, e.type);
  let r = t._length, i, a, s, o;
  const l = () => {
    s === 32767 || s === -32768 || (zn(o) && (r = Math.min(r, Math.abs(s - o) || r)), o = s);
  };
  for (i = 0, a = n.length; i < a; ++i)
    s = t.getPixelForValue(n[i]), l();
  for (o = void 0, i = 0, a = t.ticks.length; i < a; ++i)
    s = t.getPixelForTick(i), l();
  return r;
}
function Gte(e, t, n, r) {
  const i = n.barThickness;
  let a, s;
  return Tt(i) ? (a = t.min * n.categoryPercentage, s = n.barPercentage) : (a = i * r, s = 1), {
    chunk: a / r,
    ratio: s,
    start: t.pixels[e] - a / 2
  };
}
function Yte(e, t, n, r) {
  const i = t.pixels, a = i[e];
  let s = e > 0 ? i[e - 1] : null, o = e < i.length - 1 ? i[e + 1] : null;
  const l = n.categoryPercentage;
  s === null && (s = a - (o === null ? t.end - t.start : o - a)), o === null && (o = a + a - s);
  const c = a - (a - Math.min(s, o)) / 2 * l;
  return {
    chunk: Math.abs(o - s) / 2 * l / r,
    ratio: n.barPercentage,
    start: c
  };
}
function Kte(e, t, n, r) {
  const i = n.parse(e[0], r), a = n.parse(e[1], r), s = Math.min(i, a), o = Math.max(i, a);
  let l = s, c = o;
  Math.abs(s) > Math.abs(o) && (l = o, c = s), t[n.axis] = c, t._custom = {
    barStart: l,
    barEnd: c,
    start: i,
    end: a,
    min: s,
    max: o
  };
}
function eI(e, t, n, r) {
  return Zt(e) ? Kte(e, t, n, r) : t[n.axis] = n.parse(e, r), t;
}
function zC(e, t, n, r) {
  const i = e.iScale, a = e.vScale, s = i.getLabels(), o = i === a, l = [];
  let c, f, h, p;
  for (c = n, f = n + r; c < f; ++c)
    p = t[c], h = {}, h[i.axis] = o || i.parse(s[c], c), l.push(eI(p, h, a, c));
  return l;
}
function Jg(e) {
  return e && e.barStart !== void 0 && e.barEnd !== void 0;
}
function Xte(e, t, n) {
  return e !== 0 ? Ta(e) : (t.isHorizontal() ? 1 : -1) * (t.min >= n ? 1 : -1);
}
function Zte(e) {
  let t, n, r, i, a;
  return e.horizontal ? (t = e.base > e.x, n = "left", r = "right") : (t = e.base < e.y, n = "bottom", r = "top"), t ? (i = "end", a = "start") : (i = "start", a = "end"), { start: n, end: r, reverse: t, top: i, bottom: a };
}
function Qte(e, t, n, r) {
  let i = t.borderSkipped;
  const a = {};
  if (!i) {
    e.borderSkipped = a;
    return;
  }
  if (i === !0) {
    e.borderSkipped = { top: !0, right: !0, bottom: !0, left: !0 };
    return;
  }
  const { start: s, end: o, reverse: l, top: c, bottom: f } = Zte(e);
  i === "middle" && n && (e.enableBorderRadius = !0, (n._top || 0) === r ? i = c : (n._bottom || 0) === r ? i = f : (a[HC(f, s, o, l)] = !0, i = c)), a[HC(i, s, o, l)] = !0, e.borderSkipped = a;
}
function HC(e, t, n, r) {
  return r ? (e = Jte(e, t, n), e = GC(e, n, t)) : e = GC(e, t, n), e;
}
function Jte(e, t, n) {
  return e === t ? n : e === n ? t : e;
}
function GC(e, t, n) {
  return e === "start" ? t : e === "end" ? n : e;
}
function ene(e, { inflateAmount: t }, n) {
  e.inflateAmount = t === "auto" ? n === 1 ? 0.33 : 0 : t;
}
class Tp extends ha {
  parsePrimitiveData(t, n, r, i) {
    return zC(t, n, r, i);
  }
  parseArrayData(t, n, r, i) {
    return zC(t, n, r, i);
  }
  parseObjectData(t, n, r, i) {
    const { iScale: a, vScale: s } = t, { xAxisKey: o = "x", yAxisKey: l = "y" } = this._parsing, c = a.axis === "x" ? o : l, f = s.axis === "x" ? o : l, h = [];
    let p, g, v, y;
    for (p = r, g = r + i; p < g; ++p)
      y = n[p], v = {}, v[a.axis] = a.parse(Zs(y, c), p), h.push(eI(Zs(y, f), v, s, p));
    return h;
  }
  updateRangeFromParsed(t, n, r, i) {
    super.updateRangeFromParsed(t, n, r, i);
    const a = r._custom;
    a && n === this._cachedMeta.vScale && (t.min = Math.min(t.min, a.min), t.max = Math.max(t.max, a.max));
  }
  getMaxOverflow() {
    return 0;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, { iScale: r, vScale: i } = n, a = this.getParsed(t), s = a._custom, o = Jg(s) ? "[" + s.start + ", " + s.end + "]" : "" + i.getLabelForValue(a[i.axis]);
    return {
      label: "" + r.getLabelForValue(a[r.axis]),
      value: o
    };
  }
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
    const t = this._cachedMeta;
    t.stack = this.getDataset().stack;
  }
  update(t) {
    const n = this._cachedMeta;
    this.updateElements(n.data, 0, n.data.length, t);
  }
  updateElements(t, n, r, i) {
    const a = i === "reset", { index: s, _cachedMeta: { vScale: o } } = this, l = o.getBasePixel(), c = o.isHorizontal(), f = this._getRuler(), { sharedOptions: h, includeOptions: p } = this._getSharedOptions(n, i);
    for (let g = n; g < n + r; g++) {
      const v = this.getParsed(g), y = a || Tt(v[o.axis]) ? { base: l, head: l } : this._calculateBarValuePixels(g), S = this._calculateBarIndexPixels(g, f), x = (v._stacks || {})[o.axis], E = {
        horizontal: c,
        base: y.base,
        enableBorderRadius: !x || Jg(v._custom) || s === x._top || s === x._bottom,
        x: c ? y.head : S.center,
        y: c ? S.center : y.head,
        height: c ? S.size : Math.abs(y.size),
        width: c ? Math.abs(y.size) : S.size
      };
      p && (E.options = h || this.resolveDataElementOptions(g, t[g].active ? "active" : i));
      const w = E.options || t[g].options;
      Qte(E, w, x, s), ene(E, w, f.ratio), this.updateElement(t[g], g, E, i);
    }
  }
  _getStacks(t, n) {
    const { iScale: r } = this._cachedMeta, i = r.getMatchingVisibleMetas(this._type).filter((l) => l.controller.options.grouped), a = r.options.stacked, s = [], o = (l) => {
      const c = l.controller.getParsed(n), f = c && c[l.vScale.axis];
      if (Tt(f) || isNaN(f))
        return !0;
    };
    for (const l of i)
      if (!(n !== void 0 && o(l)) && ((a === !1 || s.indexOf(l.stack) === -1 || a === void 0 && l.stack === void 0) && s.push(l.stack), l.index === t))
        break;
    return s.length || s.push(void 0), s;
  }
  _getStackCount(t) {
    return this._getStacks(void 0, t).length;
  }
  _getStackIndex(t, n, r) {
    const i = this._getStacks(t, r), a = n !== void 0 ? i.indexOf(n) : -1;
    return a === -1 ? i.length - 1 : a;
  }
  _getRuler() {
    const t = this.options, n = this._cachedMeta, r = n.iScale, i = [];
    let a, s;
    for (a = 0, s = n.data.length; a < s; ++a)
      i.push(r.getPixelForValue(this.getParsed(a)[r.axis], a));
    const o = t.barThickness;
    return {
      min: o || Hte(n),
      pixels: i,
      start: r._startPixel,
      end: r._endPixel,
      stackCount: this._getStackCount(),
      scale: r,
      grouped: t.grouped,
      ratio: o ? 1 : t.categoryPercentage * t.barPercentage
    };
  }
  _calculateBarValuePixels(t) {
    const { _cachedMeta: { vScale: n, _stacked: r }, options: { base: i, minBarLength: a } } = this, s = i || 0, o = this.getParsed(t), l = o._custom, c = Jg(l);
    let f = o[n.axis], h = 0, p = r ? this.applyStack(n, o, r) : f, g, v;
    p !== f && (h = p - f, p = f), c && (f = l.barStart, p = l.barEnd - l.barStart, f !== 0 && Ta(f) !== Ta(l.barEnd) && (h = 0), h += f);
    const y = !Tt(i) && !c ? i : h;
    let S = n.getPixelForValue(y);
    if (this.chart.getDataVisibility(t) ? g = n.getPixelForValue(h + p) : g = S, v = g - S, Math.abs(v) < a) {
      v = Xte(v, n, s) * a, f === s && (S -= v / 2);
      const x = n.getPixelForDecimal(0), E = n.getPixelForDecimal(1), w = Math.min(x, E), C = Math.max(x, E);
      S = Math.max(Math.min(S, C), w), g = S + v;
    }
    if (S === n.getPixelForValue(s)) {
      const x = Ta(v) * n.getLineWidthForValue(s) / 2;
      S += x, v -= x;
    }
    return {
      size: v,
      base: S,
      head: g,
      center: g + v / 2
    };
  }
  _calculateBarIndexPixels(t, n) {
    const r = n.scale, i = this.options, a = i.skipNull, s = lt(i.maxBarThickness, 1 / 0);
    let o, l;
    if (n.grouped) {
      const c = a ? this._getStackCount(t) : n.stackCount, f = i.barThickness === "flex" ? Yte(t, n, i, c) : Gte(t, n, i, c), h = this._getStackIndex(this.index, this._cachedMeta.stack, a ? t : void 0);
      o = f.start + f.chunk * h + f.chunk / 2, l = Math.min(s, f.chunk * f.ratio);
    } else
      o = r.getPixelForValue(this.getParsed(t)[r.axis], t), l = Math.min(s, n.min * n.ratio);
    return {
      base: o - l / 2,
      head: o + l / 2,
      center: o,
      size: l
    };
  }
  draw() {
    const t = this._cachedMeta, n = t.vScale, r = t.data, i = r.length;
    let a = 0;
    for (; a < i; ++a)
      this.getParsed(a)[n.axis] !== null && r[a].draw(this._ctx);
  }
}
Tp.id = "bar";
Tp.defaults = {
  datasetElementType: !1,
  dataElementType: "bar",
  categoryPercentage: 0.8,
  barPercentage: 0.9,
  grouped: !0,
  animations: {
    numbers: {
      type: "number",
      properties: ["x", "y", "base", "width", "height"]
    }
  }
};
Tp.overrides = {
  scales: {
    _index_: {
      type: "category",
      offset: !0,
      grid: {
        offset: !0
      }
    },
    _value_: {
      type: "linear",
      beginAtZero: !0
    }
  }
};
class Ap extends ha {
  initialize() {
    this.enableOptionSharing = !0, super.initialize();
  }
  parsePrimitiveData(t, n, r, i) {
    const a = super.parsePrimitiveData(t, n, r, i);
    for (let s = 0; s < a.length; s++)
      a[s]._custom = this.resolveDataElementOptions(s + r).radius;
    return a;
  }
  parseArrayData(t, n, r, i) {
    const a = super.parseArrayData(t, n, r, i);
    for (let s = 0; s < a.length; s++) {
      const o = n[r + s];
      a[s]._custom = lt(o[2], this.resolveDataElementOptions(s + r).radius);
    }
    return a;
  }
  parseObjectData(t, n, r, i) {
    const a = super.parseObjectData(t, n, r, i);
    for (let s = 0; s < a.length; s++) {
      const o = n[r + s];
      a[s]._custom = lt(o && o.r && +o.r, this.resolveDataElementOptions(s + r).radius);
    }
    return a;
  }
  getMaxOverflow() {
    const t = this._cachedMeta.data;
    let n = 0;
    for (let r = t.length - 1; r >= 0; --r)
      n = Math.max(n, t[r].size(this.resolveDataElementOptions(r)) / 2);
    return n > 0 && n;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, { xScale: r, yScale: i } = n, a = this.getParsed(t), s = r.getLabelForValue(a.x), o = i.getLabelForValue(a.y), l = a._custom;
    return {
      label: n.label,
      value: "(" + s + ", " + o + (l ? ", " + l : "") + ")"
    };
  }
  update(t) {
    const n = this._cachedMeta.data;
    this.updateElements(n, 0, n.length, t);
  }
  updateElements(t, n, r, i) {
    const a = i === "reset", { iScale: s, vScale: o } = this._cachedMeta, { sharedOptions: l, includeOptions: c } = this._getSharedOptions(n, i), f = s.axis, h = o.axis;
    for (let p = n; p < n + r; p++) {
      const g = t[p], v = !a && this.getParsed(p), y = {}, S = y[f] = a ? s.getPixelForDecimal(0.5) : s.getPixelForValue(v[f]), x = y[h] = a ? o.getBasePixel() : o.getPixelForValue(v[h]);
      y.skip = isNaN(S) || isNaN(x), c && (y.options = l || this.resolveDataElementOptions(p, g.active ? "active" : i), a && (y.options.radius = 0)), this.updateElement(g, p, y, i);
    }
  }
  resolveDataElementOptions(t, n) {
    const r = this.getParsed(t);
    let i = super.resolveDataElementOptions(t, n);
    i.$shared && (i = Object.assign({}, i, { $shared: !1 }));
    const a = i.radius;
    return n !== "active" && (i.radius = 0), i.radius += lt(r && r._custom, a), i;
  }
}
Ap.id = "bubble";
Ap.defaults = {
  datasetElementType: !1,
  dataElementType: "point",
  animations: {
    numbers: {
      type: "number",
      properties: ["x", "y", "borderWidth", "radius"]
    }
  }
};
Ap.overrides = {
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  },
  plugins: {
    tooltip: {
      callbacks: {
        title() {
          return "";
        }
      }
    }
  }
};
function tne(e, t, n) {
  let r = 1, i = 1, a = 0, s = 0;
  if (t < tn) {
    const o = e, l = o + t, c = Math.cos(o), f = Math.sin(o), h = Math.cos(l), p = Math.sin(l), g = (w, C, P) => Wc(w, o, l, !0) ? 1 : Math.max(C, C * n, P, P * n), v = (w, C, P) => Wc(w, o, l, !0) ? -1 : Math.min(C, C * n, P, P * n), y = g(0, c, h), S = g(Rn, f, p), x = v(Wt, c, h), E = v(Wt + Rn, f, p);
    r = (y - x) / 2, i = (S - E) / 2, a = -(y + x) / 2, s = -(S + E) / 2;
  }
  return { ratioX: r, ratioY: i, offsetX: a, offsetY: s };
}
class mu extends ha {
  constructor(t, n) {
    super(t, n), this.enableOptionSharing = !0, this.innerRadius = void 0, this.outerRadius = void 0, this.offsetX = void 0, this.offsetY = void 0;
  }
  linkScales() {
  }
  parse(t, n) {
    const r = this.getDataset().data, i = this._cachedMeta;
    if (this._parsing === !1)
      i._parsed = r;
    else {
      let a = (l) => +r[l];
      if (_t(r[t])) {
        const { key: l = "value" } = this._parsing;
        a = (c) => +Zs(r[c], l);
      }
      let s, o;
      for (s = t, o = t + n; s < o; ++s)
        i._parsed[s] = a(s);
    }
  }
  _getRotation() {
    return er(this.options.rotation - 90);
  }
  _getCircumference() {
    return er(this.options.circumference);
  }
  _getRotationExtents() {
    let t = tn, n = -tn;
    for (let r = 0; r < this.chart.data.datasets.length; ++r)
      if (this.chart.isDatasetVisible(r)) {
        const i = this.chart.getDatasetMeta(r).controller, a = i._getRotation(), s = i._getCircumference();
        t = Math.min(t, a), n = Math.max(n, a + s);
      }
    return {
      rotation: t,
      circumference: n - t
    };
  }
  update(t) {
    const n = this.chart, { chartArea: r } = n, i = this._cachedMeta, a = i.data, s = this.getMaxBorderWidth() + this.getMaxOffset(a) + this.options.spacing, o = Math.max((Math.min(r.width, r.height) - s) / 2, 0), l = Math.min(QJ(this.options.cutout, o), 1), c = this._getRingWeight(this.index), { circumference: f, rotation: h } = this._getRotationExtents(), { ratioX: p, ratioY: g, offsetX: v, offsetY: y } = tne(h, f, l), S = (r.width - s) / p, x = (r.height - s) / g, E = Math.max(Math.min(S, x) / 2, 0), w = kM(this.options.radius, E), C = Math.max(w * l, 0), P = (w - C) / this._getVisibleDatasetWeightTotal();
    this.offsetX = v * w, this.offsetY = y * w, i.total = this.calculateTotal(), this.outerRadius = w - P * this._getRingWeightOffset(this.index), this.innerRadius = Math.max(this.outerRadius - P * c, 0), this.updateElements(a, 0, a.length, t);
  }
  _circumference(t, n) {
    const r = this.options, i = this._cachedMeta, a = this._getCircumference();
    return n && r.animation.animateRotate || !this.chart.getDataVisibility(t) || i._parsed[t] === null || i.data[t].hidden ? 0 : this.calculateCircumference(i._parsed[t] * a / tn);
  }
  updateElements(t, n, r, i) {
    const a = i === "reset", s = this.chart, o = s.chartArea, c = s.options.animation, f = (o.left + o.right) / 2, h = (o.top + o.bottom) / 2, p = a && c.animateScale, g = p ? 0 : this.innerRadius, v = p ? 0 : this.outerRadius, { sharedOptions: y, includeOptions: S } = this._getSharedOptions(n, i);
    let x = this._getRotation(), E;
    for (E = 0; E < n; ++E)
      x += this._circumference(E, a);
    for (E = n; E < n + r; ++E) {
      const w = this._circumference(E, a), C = t[E], P = {
        x: f + this.offsetX,
        y: h + this.offsetY,
        startAngle: x,
        endAngle: x + w,
        circumference: w,
        outerRadius: v,
        innerRadius: g
      };
      S && (P.options = y || this.resolveDataElementOptions(E, C.active ? "active" : i)), x += w, this.updateElement(C, E, P, i);
    }
  }
  calculateTotal() {
    const t = this._cachedMeta, n = t.data;
    let r = 0, i;
    for (i = 0; i < n.length; i++) {
      const a = t._parsed[i];
      a !== null && !isNaN(a) && this.chart.getDataVisibility(i) && !n[i].hidden && (r += Math.abs(a));
    }
    return r;
  }
  calculateCircumference(t) {
    const n = this._cachedMeta.total;
    return n > 0 && !isNaN(t) ? tn * (Math.abs(t) / n) : 0;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, r = this.chart, i = r.data.labels || [], a = hd(n._parsed[t], r.options.locale);
    return {
      label: i[t] || "",
      value: a
    };
  }
  getMaxBorderWidth(t) {
    let n = 0;
    const r = this.chart;
    let i, a, s, o, l;
    if (!t) {
      for (i = 0, a = r.data.datasets.length; i < a; ++i)
        if (r.isDatasetVisible(i)) {
          s = r.getDatasetMeta(i), t = s.data, o = s.controller;
          break;
        }
    }
    if (!t)
      return 0;
    for (i = 0, a = t.length; i < a; ++i)
      l = o.resolveDataElementOptions(i), l.borderAlign !== "inner" && (n = Math.max(n, l.borderWidth || 0, l.hoverBorderWidth || 0));
    return n;
  }
  getMaxOffset(t) {
    let n = 0;
    for (let r = 0, i = t.length; r < i; ++r) {
      const a = this.resolveDataElementOptions(r);
      n = Math.max(n, a.offset || 0, a.hoverOffset || 0);
    }
    return n;
  }
  _getRingWeightOffset(t) {
    let n = 0;
    for (let r = 0; r < t; ++r)
      this.chart.isDatasetVisible(r) && (n += this._getRingWeight(r));
    return n;
  }
  _getRingWeight(t) {
    return Math.max(lt(this.chart.data.datasets[t].weight, 1), 0);
  }
  _getVisibleDatasetWeightTotal() {
    return this._getRingWeightOffset(this.chart.data.datasets.length) || 1;
  }
}
mu.id = "doughnut";
mu.defaults = {
  datasetElementType: !1,
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !1
  },
  animations: {
    numbers: {
      type: "number",
      properties: ["circumference", "endAngle", "innerRadius", "outerRadius", "startAngle", "x", "y", "offset", "borderWidth", "spacing"]
    }
  },
  cutout: "50%",
  rotation: 0,
  circumference: 360,
  radius: "100%",
  spacing: 0,
  indexAxis: "r"
};
mu.descriptors = {
  _scriptable: (e) => e !== "spacing",
  _indexable: (e) => e !== "spacing"
};
mu.overrides = {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(e) {
          const t = e.data;
          if (t.labels.length && t.datasets.length) {
            const { labels: { pointStyle: n } } = e.legend.options;
            return t.labels.map((r, i) => {
              const s = e.getDatasetMeta(0).controller.getStyle(i);
              return {
                text: r,
                fillStyle: s.backgroundColor,
                strokeStyle: s.borderColor,
                lineWidth: s.borderWidth,
                pointStyle: n,
                hidden: !e.getDataVisibility(i),
                index: i
              };
            });
          }
          return [];
        }
      },
      onClick(e, t, n) {
        n.chart.toggleDataVisibility(t.index), n.chart.update();
      }
    },
    tooltip: {
      callbacks: {
        title() {
          return "";
        },
        label(e) {
          let t = e.label;
          const n = ": " + e.formattedValue;
          return Zt(t) ? (t = t.slice(), t[0] += n) : t += n, t;
        }
      }
    }
  }
};
class Dp extends ha {
  initialize() {
    this.enableOptionSharing = !0, this.supportsDecimation = !0, super.initialize();
  }
  update(t) {
    const n = this._cachedMeta, { dataset: r, data: i = [], _dataset: a } = n, s = this.chart._animationsDisabled;
    let { start: o, count: l } = MM(n, i, s);
    this._drawStart = o, this._drawCount = l, IM(n) && (o = 0, l = i.length), r._chart = this.chart, r._datasetIndex = this.index, r._decimated = !!a._decimated, r.points = i;
    const c = this.resolveDatasetElementOptions(t);
    this.options.showLine || (c.borderWidth = 0), c.segment = this.options.segment, this.updateElement(r, void 0, {
      animated: !s,
      options: c
    }, t), this.updateElements(i, o, l, t);
  }
  updateElements(t, n, r, i) {
    const a = i === "reset", { iScale: s, vScale: o, _stacked: l, _dataset: c } = this._cachedMeta, { sharedOptions: f, includeOptions: h } = this._getSharedOptions(n, i), p = s.axis, g = o.axis, { spanGaps: v, segment: y } = this.options, S = nu(v) ? v : Number.POSITIVE_INFINITY, x = this.chart._animationsDisabled || a || i === "none";
    let E = n > 0 && this.getParsed(n - 1);
    for (let w = n; w < n + r; ++w) {
      const C = t[w], P = this.getParsed(w), M = x ? C : {}, T = Tt(P[g]), N = M[p] = s.getPixelForValue(P[p], w), $ = M[g] = a || T ? o.getBasePixel() : o.getPixelForValue(l ? this.applyStack(o, P, l) : P[g], w);
      M.skip = isNaN(N) || isNaN($) || T, M.stop = w > 0 && Math.abs(P[p] - E[p]) > S, y && (M.parsed = P, M.raw = c.data[w]), h && (M.options = f || this.resolveDataElementOptions(w, C.active ? "active" : i)), x || this.updateElement(C, w, M, i), E = P;
    }
  }
  getMaxOverflow() {
    const t = this._cachedMeta, n = t.dataset, r = n.options && n.options.borderWidth || 0, i = t.data || [];
    if (!i.length)
      return r;
    const a = i[0].size(this.resolveDataElementOptions(0)), s = i[i.length - 1].size(this.resolveDataElementOptions(i.length - 1));
    return Math.max(r, a, s) / 2;
  }
  draw() {
    const t = this._cachedMeta;
    t.dataset.updateControlPoints(this.chart.chartArea, t.iScale.axis), super.draw();
  }
}
Dp.id = "line";
Dp.defaults = {
  datasetElementType: "line",
  dataElementType: "point",
  showLine: !0,
  spanGaps: !1
};
Dp.overrides = {
  scales: {
    _index_: {
      type: "category"
    },
    _value_: {
      type: "linear"
    }
  }
};
class Ep extends ha {
  constructor(t, n) {
    super(t, n), this.innerRadius = void 0, this.outerRadius = void 0;
  }
  getLabelAndValue(t) {
    const n = this._cachedMeta, r = this.chart, i = r.data.labels || [], a = hd(n._parsed[t].r, r.options.locale);
    return {
      label: i[t] || "",
      value: a
    };
  }
  parseObjectData(t, n, r, i) {
    return zM.bind(this)(t, n, r, i);
  }
  update(t) {
    const n = this._cachedMeta.data;
    this._updateRadius(), this.updateElements(n, 0, n.length, t);
  }
  getMinMax() {
    const t = this._cachedMeta, n = { min: Number.POSITIVE_INFINITY, max: Number.NEGATIVE_INFINITY };
    return t.data.forEach((r, i) => {
      const a = this.getParsed(i).r;
      !isNaN(a) && this.chart.getDataVisibility(i) && (a < n.min && (n.min = a), a > n.max && (n.max = a));
    }), n;
  }
  _updateRadius() {
    const t = this.chart, n = t.chartArea, r = t.options, i = Math.min(n.right - n.left, n.bottom - n.top), a = Math.max(i / 2, 0), s = Math.max(r.cutoutPercentage ? a / 100 * r.cutoutPercentage : 1, 0), o = (a - s) / t.getVisibleDatasetCount();
    this.outerRadius = a - o * this.index, this.innerRadius = this.outerRadius - o;
  }
  updateElements(t, n, r, i) {
    const a = i === "reset", s = this.chart, l = s.options.animation, c = this._cachedMeta.rScale, f = c.xCenter, h = c.yCenter, p = c.getIndexAngle(0) - 0.5 * Wt;
    let g = p, v;
    const y = 360 / this.countVisibleElements();
    for (v = 0; v < n; ++v)
      g += this._computeAngle(v, i, y);
    for (v = n; v < n + r; v++) {
      const S = t[v];
      let x = g, E = g + this._computeAngle(v, i, y), w = s.getDataVisibility(v) ? c.getDistanceFromCenterForValue(this.getParsed(v).r) : 0;
      g = E, a && (l.animateScale && (w = 0), l.animateRotate && (x = E = p));
      const C = {
        x: f,
        y: h,
        innerRadius: 0,
        outerRadius: w,
        startAngle: x,
        endAngle: E,
        options: this.resolveDataElementOptions(v, S.active ? "active" : i)
      };
      this.updateElement(S, v, C, i);
    }
  }
  countVisibleElements() {
    const t = this._cachedMeta;
    let n = 0;
    return t.data.forEach((r, i) => {
      !isNaN(this.getParsed(i).r) && this.chart.getDataVisibility(i) && n++;
    }), n;
  }
  _computeAngle(t, n, r) {
    return this.chart.getDataVisibility(t) ? er(this.resolveDataElementOptions(t, n).angle || r) : 0;
  }
}
Ep.id = "polarArea";
Ep.defaults = {
  dataElementType: "arc",
  animation: {
    animateRotate: !0,
    animateScale: !0
  },
  animations: {
    numbers: {
      type: "number",
      properties: ["x", "y", "startAngle", "endAngle", "innerRadius", "outerRadius"]
    }
  },
  indexAxis: "r",
  startAngle: 0
};
Ep.overrides = {
  aspectRatio: 1,
  plugins: {
    legend: {
      labels: {
        generateLabels(e) {
          const t = e.data;
          if (t.labels.length && t.datasets.length) {
            const { labels: { pointStyle: n } } = e.legend.options;
            return t.labels.map((r, i) => {
              const s = e.getDatasetMeta(0).controller.getStyle(i);
              return {
                text: r,
                fillStyle: s.backgroundColor,
                strokeStyle: s.borderColor,
                lineWidth: s.borderWidth,
                pointStyle: n,
                hidden: !e.getDataVisibility(i),
                index: i
              };
            });
          }
          return [];
        }
      },
      onClick(e, t, n) {
        n.chart.toggleDataVisibility(t.index), n.chart.update();
      }
    },
    tooltip: {
      callbacks: {
        title() {
          return "";
        },
        label(e) {
          return e.chart.data.labels[e.dataIndex] + ": " + e.formattedValue;
        }
      }
    }
  },
  scales: {
    r: {
      type: "radialLinear",
      angleLines: {
        display: !1
      },
      beginAtZero: !0,
      grid: {
        circular: !0
      },
      pointLabels: {
        display: !1
      },
      startAngle: 0
    }
  }
};
class ux extends mu {
}
ux.id = "pie";
ux.defaults = {
  cutout: 0,
  rotation: 0,
  circumference: 360,
  radius: "100%"
};
class Pp extends ha {
  getLabelAndValue(t) {
    const n = this._cachedMeta.vScale, r = this.getParsed(t);
    return {
      label: n.getLabels()[t],
      value: "" + n.getLabelForValue(r[n.axis])
    };
  }
  parseObjectData(t, n, r, i) {
    return zM.bind(this)(t, n, r, i);
  }
  update(t) {
    const n = this._cachedMeta, r = n.dataset, i = n.data || [], a = n.iScale.getLabels();
    if (r.points = i, t !== "resize") {
      const s = this.resolveDatasetElementOptions(t);
      this.options.showLine || (s.borderWidth = 0);
      const o = {
        _loop: !0,
        _fullLoop: a.length === i.length,
        options: s
      };
      this.updateElement(r, void 0, o, t);
    }
    this.updateElements(i, 0, i.length, t);
  }
  updateElements(t, n, r, i) {
    const a = this._cachedMeta.rScale, s = i === "reset";
    for (let o = n; o < n + r; o++) {
      const l = t[o], c = this.resolveDataElementOptions(o, l.active ? "active" : i), f = a.getPointPositionForValue(o, this.getParsed(o).r), h = s ? a.xCenter : f.x, p = s ? a.yCenter : f.y, g = {
        x: h,
        y: p,
        angle: f.angle,
        skip: isNaN(h) || isNaN(p),
        options: c
      };
      this.updateElement(l, o, g, i);
    }
  }
}
Pp.id = "radar";
Pp.defaults = {
  datasetElementType: "line",
  dataElementType: "point",
  indexAxis: "r",
  showLine: !0,
  elements: {
    line: {
      fill: "start"
    }
  }
};
Pp.overrides = {
  aspectRatio: 1,
  scales: {
    r: {
      type: "radialLinear"
    }
  }
};
class Ar {
  constructor() {
    this.x = void 0, this.y = void 0, this.active = !1, this.options = void 0, this.$animations = void 0;
  }
  tooltipPosition(t) {
    const { x: n, y: r } = this.getProps(["x", "y"], t);
    return { x: n, y: r };
  }
  hasValue() {
    return nu(this.x) && nu(this.y);
  }
  getProps(t, n) {
    const r = this.$animations;
    if (!n || !r)
      return this;
    const i = {};
    return t.forEach((a) => {
      i[a] = r[a] && r[a].active() ? r[a]._to : this[a];
    }), i;
  }
}
Ar.defaults = {};
Ar.defaultRoutes = void 0;
const tI = {
  values(e) {
    return Zt(e) ? e : "" + e;
  },
  numeric(e, t, n) {
    if (e === 0)
      return "0";
    const r = this.chart.options.locale;
    let i, a = e;
    if (n.length > 1) {
      const c = Math.max(Math.abs(n[0].value), Math.abs(n[n.length - 1].value));
      (c < 1e-4 || c > 1e15) && (i = "scientific"), a = nne(e, n);
    }
    const s = ji(Math.abs(a)), o = Math.max(Math.min(-1 * Math.floor(s), 20), 0), l = { notation: i, minimumFractionDigits: o, maximumFractionDigits: o };
    return Object.assign(l, this.options.ticks.format), hd(e, r, l);
  },
  logarithmic(e, t, n) {
    if (e === 0)
      return "0";
    const r = e / Math.pow(10, Math.floor(ji(e)));
    return r === 1 || r === 2 || r === 5 ? tI.numeric.call(this, e, t, n) : "";
  }
};
function nne(e, t) {
  let n = t.length > 3 ? t[2].value - t[1].value : t[1].value - t[0].value;
  return Math.abs(n) >= 1 && e !== Math.floor(e) && (n = e - Math.floor(e)), n;
}
var Op = { formatters: tI };
Et.set("scale", {
  display: !0,
  offset: !1,
  reverse: !1,
  beginAtZero: !1,
  bounds: "ticks",
  grace: 0,
  grid: {
    display: !0,
    lineWidth: 1,
    drawBorder: !0,
    drawOnChartArea: !0,
    drawTicks: !0,
    tickLength: 8,
    tickWidth: (e, t) => t.lineWidth,
    tickColor: (e, t) => t.color,
    offset: !1,
    borderDash: [],
    borderDashOffset: 0,
    borderWidth: 1
  },
  title: {
    display: !1,
    text: "",
    padding: {
      top: 4,
      bottom: 4
    }
  },
  ticks: {
    minRotation: 0,
    maxRotation: 50,
    mirror: !1,
    textStrokeWidth: 0,
    textStrokeColor: "",
    padding: 3,
    display: !0,
    autoSkip: !0,
    autoSkipPadding: 3,
    labelOffset: 0,
    callback: Op.formatters.values,
    minor: {},
    major: {},
    align: "center",
    crossAlign: "near",
    showLabelBackdrop: !1,
    backdropColor: "rgba(255, 255, 255, 0.75)",
    backdropPadding: 2
  }
});
Et.route("scale.ticks", "color", "", "color");
Et.route("scale.grid", "color", "", "borderColor");
Et.route("scale.grid", "borderColor", "", "borderColor");
Et.route("scale.title", "color", "", "color");
Et.describe("scale", {
  _fallback: !1,
  _scriptable: (e) => !e.startsWith("before") && !e.startsWith("after") && e !== "callback" && e !== "parser",
  _indexable: (e) => e !== "borderDash" && e !== "tickBorderDash"
});
Et.describe("scales", {
  _fallback: "scale"
});
Et.describe("scale.ticks", {
  _scriptable: (e) => e !== "backdropPadding" && e !== "callback",
  _indexable: (e) => e !== "backdropPadding"
});
function rne(e, t) {
  const n = e.options.ticks, r = n.maxTicksLimit || ine(e), i = n.major.enabled ? sne(t) : [], a = i.length, s = i[0], o = i[a - 1], l = [];
  if (a > r)
    return one(t, l, i, a / r), l;
  const c = ane(i, t, r);
  if (a > 0) {
    let f, h;
    const p = a > 1 ? Math.round((o - s) / (a - 1)) : null;
    for (jf(t, l, c, Tt(p) ? 0 : s - p, s), f = 0, h = a - 1; f < h; f++)
      jf(t, l, c, i[f], i[f + 1]);
    return jf(t, l, c, o, Tt(p) ? t.length : o + p), l;
  }
  return jf(t, l, c), l;
}
function ine(e) {
  const t = e.options.offset, n = e._tickSize(), r = e._length / n + (t ? 0 : 1), i = e._maxLength / n;
  return Math.floor(Math.min(r, i));
}
function ane(e, t, n) {
  const r = lne(e), i = t.length / n;
  if (!r)
    return Math.max(i, 1);
  const a = aee(r);
  for (let s = 0, o = a.length - 1; s < o; s++) {
    const l = a[s];
    if (l > i)
      return l;
  }
  return Math.max(i, 1);
}
function sne(e) {
  const t = [];
  let n, r;
  for (n = 0, r = e.length; n < r; n++)
    e[n].major && t.push(n);
  return t;
}
function one(e, t, n, r) {
  let i = 0, a = n[0], s;
  for (r = Math.ceil(r), s = 0; s < e.length; s++)
    s === a && (t.push(e[s]), i++, a = n[i * r]);
}
function jf(e, t, n, r, i) {
  const a = lt(r, 0), s = Math.min(lt(i, e.length), e.length);
  let o = 0, l, c, f;
  for (n = Math.ceil(n), i && (l = i - r, n = l / Math.floor(l / n)), f = a; f < 0; )
    o++, f = Math.round(a + o * n);
  for (c = Math.max(a, 0); c < s; c++)
    c === f && (t.push(e[c]), o++, f = Math.round(a + o * n));
}
function lne(e) {
  const t = e.length;
  let n, r;
  if (t < 2)
    return !1;
  for (r = e[0], n = 1; n < t; ++n)
    if (e[n] - e[n - 1] !== r)
      return !1;
  return r;
}
const une = (e) => e === "left" ? "right" : e === "right" ? "left" : e, YC = (e, t, n) => t === "top" || t === "left" ? e[t] + n : e[t] - n;
function KC(e, t) {
  const n = [], r = e.length / t, i = e.length;
  let a = 0;
  for (; a < i; a += r)
    n.push(e[Math.floor(a)]);
  return n;
}
function cne(e, t, n) {
  const r = e.ticks.length, i = Math.min(t, r - 1), a = e._startPixel, s = e._endPixel, o = 1e-6;
  let l = e.getPixelForTick(i), c;
  if (!(n && (r === 1 ? c = Math.max(l - a, s - l) : t === 0 ? c = (e.getPixelForTick(1) - l) / 2 : c = (l - e.getPixelForTick(i - 1)) / 2, l += i < t ? c : -c, l < a - o || l > s + o)))
    return l;
}
function dne(e, t) {
  Yt(e, (n) => {
    const r = n.gc, i = r.length / 2;
    let a;
    if (i > t) {
      for (a = 0; a < i; ++a)
        delete n.data[r[a]];
      r.splice(0, i);
    }
  });
}
function lc(e) {
  return e.drawTicks ? e.tickLength : 0;
}
function XC(e, t) {
  if (!e.display)
    return 0;
  const n = Fn(e.font, t), r = Hn(e.padding);
  return (Zt(e.text) ? e.text.length : 1) * n.lineHeight + r.height;
}
function fne(e, t) {
  return oo(e, {
    scale: t,
    type: "scale"
  });
}
function hne(e, t, n) {
  return oo(e, {
    tick: n,
    index: t,
    type: "tick"
  });
}
function pne(e, t, n) {
  let r = J0(e);
  return (n && t !== "right" || !n && t === "right") && (r = une(r)), r;
}
function mne(e, t, n, r) {
  const { top: i, left: a, bottom: s, right: o, chart: l } = e, { chartArea: c, scales: f } = l;
  let h = 0, p, g, v;
  const y = s - i, S = o - a;
  if (e.isHorizontal()) {
    if (g = Ir(r, a, o), _t(n)) {
      const x = Object.keys(n)[0], E = n[x];
      v = f[x].getPixelForValue(E) + y - t;
    } else n === "center" ? v = (c.bottom + c.top) / 2 + y - t : v = YC(e, n, t);
    p = o - a;
  } else {
    if (_t(n)) {
      const x = Object.keys(n)[0], E = n[x];
      g = f[x].getPixelForValue(E) - S + t;
    } else n === "center" ? g = (c.left + c.right) / 2 - S + t : g = YC(e, n, t);
    v = Ir(r, s, i), h = n === "left" ? -Rn : Rn;
  }
  return { titleX: g, titleY: v, maxWidth: p, rotation: h };
}
class ll extends Ar {
  constructor(t) {
    super(), this.id = t.id, this.type = t.type, this.options = void 0, this.ctx = t.ctx, this.chart = t.chart, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this._margins = {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, this.maxWidth = void 0, this.maxHeight = void 0, this.paddingTop = void 0, this.paddingBottom = void 0, this.paddingLeft = void 0, this.paddingRight = void 0, this.axis = void 0, this.labelRotation = void 0, this.min = void 0, this.max = void 0, this._range = void 0, this.ticks = [], this._gridLineItems = null, this._labelItems = null, this._labelSizes = null, this._length = 0, this._maxLength = 0, this._longestTextCache = {}, this._startPixel = void 0, this._endPixel = void 0, this._reversePixels = !1, this._userMax = void 0, this._userMin = void 0, this._suggestedMax = void 0, this._suggestedMin = void 0, this._ticksLength = 0, this._borderValue = 0, this._cache = {}, this._dataLimitsCached = !1, this.$context = void 0;
  }
  init(t) {
    this.options = t.setContext(this.getContext()), this.axis = t.axis, this._userMin = this.parse(t.min), this._userMax = this.parse(t.max), this._suggestedMin = this.parse(t.suggestedMin), this._suggestedMax = this.parse(t.suggestedMax);
  }
  parse(t, n) {
    return t;
  }
  getUserBounds() {
    let { _userMin: t, _userMax: n, _suggestedMin: r, _suggestedMax: i } = this;
    return t = $i(t, Number.POSITIVE_INFINITY), n = $i(n, Number.NEGATIVE_INFINITY), r = $i(r, Number.POSITIVE_INFINITY), i = $i(i, Number.NEGATIVE_INFINITY), {
      min: $i(t, r),
      max: $i(n, i),
      minDefined: Pn(t),
      maxDefined: Pn(n)
    };
  }
  getMinMax(t) {
    let { min: n, max: r, minDefined: i, maxDefined: a } = this.getUserBounds(), s;
    if (i && a)
      return { min: n, max: r };
    const o = this.getMatchingVisibleMetas();
    for (let l = 0, c = o.length; l < c; ++l)
      s = o[l].controller.getMinMax(this, t), i || (n = Math.min(n, s.min)), a || (r = Math.max(r, s.max));
    return n = a && n > r ? r : n, r = i && n > r ? n : r, {
      min: $i(n, $i(r, n)),
      max: $i(r, $i(n, r))
    };
  }
  getPadding() {
    return {
      left: this.paddingLeft || 0,
      top: this.paddingTop || 0,
      right: this.paddingRight || 0,
      bottom: this.paddingBottom || 0
    };
  }
  getTicks() {
    return this.ticks;
  }
  getLabels() {
    const t = this.chart.data;
    return this.options.labels || (this.isHorizontal() ? t.xLabels : t.yLabels) || t.labels || [];
  }
  beforeLayout() {
    this._cache = {}, this._dataLimitsCached = !1;
  }
  beforeUpdate() {
    Xt(this.options.beforeUpdate, [this]);
  }
  update(t, n, r) {
    const { beginAtZero: i, grace: a, ticks: s } = this.options, o = s.sampleSize;
    this.beforeUpdate(), this.maxWidth = t, this.maxHeight = n, this._margins = r = Object.assign({
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    }, r), this.ticks = null, this._labelSizes = null, this._gridLineItems = null, this._labelItems = null, this.beforeSetDimensions(), this.setDimensions(), this.afterSetDimensions(), this._maxLength = this.isHorizontal() ? this.width + r.left + r.right : this.height + r.top + r.bottom, this._dataLimitsCached || (this.beforeDataLimits(), this.determineDataLimits(), this.afterDataLimits(), this._range = Gee(this, a, i), this._dataLimitsCached = !0), this.beforeBuildTicks(), this.ticks = this.buildTicks() || [], this.afterBuildTicks();
    const l = o < this.ticks.length;
    this._convertTicksToLabels(l ? KC(this.ticks, o) : this.ticks), this.configure(), this.beforeCalculateLabelRotation(), this.calculateLabelRotation(), this.afterCalculateLabelRotation(), s.display && (s.autoSkip || s.source === "auto") && (this.ticks = rne(this, this.ticks), this._labelSizes = null, this.afterAutoSkip()), l && this._convertTicksToLabels(this.ticks), this.beforeFit(), this.fit(), this.afterFit(), this.afterUpdate();
  }
  configure() {
    let t = this.options.reverse, n, r;
    this.isHorizontal() ? (n = this.left, r = this.right) : (n = this.top, r = this.bottom, t = !t), this._startPixel = n, this._endPixel = r, this._reversePixels = t, this._length = r - n, this._alignToPixels = this.options.alignToPixels;
  }
  afterUpdate() {
    Xt(this.options.afterUpdate, [this]);
  }
  beforeSetDimensions() {
    Xt(this.options.beforeSetDimensions, [this]);
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = 0, this.right = this.width) : (this.height = this.maxHeight, this.top = 0, this.bottom = this.height), this.paddingLeft = 0, this.paddingTop = 0, this.paddingRight = 0, this.paddingBottom = 0;
  }
  afterSetDimensions() {
    Xt(this.options.afterSetDimensions, [this]);
  }
  _callHooks(t) {
    this.chart.notifyPlugins(t, this.getContext()), Xt(this.options[t], [this]);
  }
  beforeDataLimits() {
    this._callHooks("beforeDataLimits");
  }
  determineDataLimits() {
  }
  afterDataLimits() {
    this._callHooks("afterDataLimits");
  }
  beforeBuildTicks() {
    this._callHooks("beforeBuildTicks");
  }
  buildTicks() {
    return [];
  }
  afterBuildTicks() {
    this._callHooks("afterBuildTicks");
  }
  beforeTickToLabelConversion() {
    Xt(this.options.beforeTickToLabelConversion, [this]);
  }
  generateTickLabels(t) {
    const n = this.options.ticks;
    let r, i, a;
    for (r = 0, i = t.length; r < i; r++)
      a = t[r], a.label = Xt(n.callback, [a.value, r, t], this);
  }
  afterTickToLabelConversion() {
    Xt(this.options.afterTickToLabelConversion, [this]);
  }
  beforeCalculateLabelRotation() {
    Xt(this.options.beforeCalculateLabelRotation, [this]);
  }
  calculateLabelRotation() {
    const t = this.options, n = t.ticks, r = this.ticks.length, i = n.minRotation || 0, a = n.maxRotation;
    let s = i, o, l, c;
    if (!this._isVisible() || !n.display || i >= a || r <= 1 || !this.isHorizontal()) {
      this.labelRotation = i;
      return;
    }
    const f = this._getLabelSizes(), h = f.widest.width, p = f.highest.height, g = vr(this.chart.width - h, 0, this.maxWidth);
    o = t.offset ? this.maxWidth / r : g / (r - 1), h + 6 > o && (o = g / (r - (t.offset ? 0.5 : 1)), l = this.maxHeight - lc(t.grid) - n.padding - XC(t.title, this.chart.options.font), c = Math.sqrt(h * h + p * p), s = Sp(Math.min(
      Math.asin(vr((f.highest.height + 6) / o, -1, 1)),
      Math.asin(vr(l / c, -1, 1)) - Math.asin(vr(p / c, -1, 1))
    )), s = Math.max(i, Math.min(a, s))), this.labelRotation = s;
  }
  afterCalculateLabelRotation() {
    Xt(this.options.afterCalculateLabelRotation, [this]);
  }
  afterAutoSkip() {
  }
  beforeFit() {
    Xt(this.options.beforeFit, [this]);
  }
  fit() {
    const t = {
      width: 0,
      height: 0
    }, { chart: n, options: { ticks: r, title: i, grid: a } } = this, s = this._isVisible(), o = this.isHorizontal();
    if (s) {
      const l = XC(i, n.options.font);
      if (o ? (t.width = this.maxWidth, t.height = lc(a) + l) : (t.height = this.maxHeight, t.width = lc(a) + l), r.display && this.ticks.length) {
        const { first: c, last: f, widest: h, highest: p } = this._getLabelSizes(), g = r.padding * 2, v = er(this.labelRotation), y = Math.cos(v), S = Math.sin(v);
        if (o) {
          const x = r.mirror ? 0 : S * h.width + y * p.height;
          t.height = Math.min(this.maxHeight, t.height + x + g);
        } else {
          const x = r.mirror ? 0 : y * h.width + S * p.height;
          t.width = Math.min(this.maxWidth, t.width + x + g);
        }
        this._calculatePadding(c, f, S, y);
      }
    }
    this._handleMargins(), o ? (this.width = this._length = n.width - this._margins.left - this._margins.right, this.height = t.height) : (this.width = t.width, this.height = this._length = n.height - this._margins.top - this._margins.bottom);
  }
  _calculatePadding(t, n, r, i) {
    const { ticks: { align: a, padding: s }, position: o } = this.options, l = this.labelRotation !== 0, c = o !== "top" && this.axis === "x";
    if (this.isHorizontal()) {
      const f = this.getPixelForTick(0) - this.left, h = this.right - this.getPixelForTick(this.ticks.length - 1);
      let p = 0, g = 0;
      l ? c ? (p = i * t.width, g = r * n.height) : (p = r * t.height, g = i * n.width) : a === "start" ? g = n.width : a === "end" ? p = t.width : a !== "inner" && (p = t.width / 2, g = n.width / 2), this.paddingLeft = Math.max((p - f + s) * this.width / (this.width - f), 0), this.paddingRight = Math.max((g - h + s) * this.width / (this.width - h), 0);
    } else {
      let f = n.height / 2, h = t.height / 2;
      a === "start" ? (f = 0, h = t.height) : a === "end" && (f = n.height, h = 0), this.paddingTop = f + s, this.paddingBottom = h + s;
    }
  }
  _handleMargins() {
    this._margins && (this._margins.left = Math.max(this.paddingLeft, this._margins.left), this._margins.top = Math.max(this.paddingTop, this._margins.top), this._margins.right = Math.max(this.paddingRight, this._margins.right), this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom));
  }
  afterFit() {
    Xt(this.options.afterFit, [this]);
  }
  isHorizontal() {
    const { axis: t, position: n } = this.options;
    return n === "top" || n === "bottom" || t === "x";
  }
  isFullSize() {
    return this.options.fullSize;
  }
  _convertTicksToLabels(t) {
    this.beforeTickToLabelConversion(), this.generateTickLabels(t);
    let n, r;
    for (n = 0, r = t.length; n < r; n++)
      Tt(t[n].label) && (t.splice(n, 1), r--, n--);
    this.afterTickToLabelConversion();
  }
  _getLabelSizes() {
    let t = this._labelSizes;
    if (!t) {
      const n = this.options.ticks.sampleSize;
      let r = this.ticks;
      n < r.length && (r = KC(r, n)), this._labelSizes = t = this._computeLabelSizes(r, r.length);
    }
    return t;
  }
  _computeLabelSizes(t, n) {
    const { ctx: r, _longestTextCache: i } = this, a = [], s = [];
    let o = 0, l = 0, c, f, h, p, g, v, y, S, x, E, w;
    for (c = 0; c < n; ++c) {
      if (p = t[c].label, g = this._resolveTickFontOptions(c), r.font = v = g.string, y = i[v] = i[v] || { data: {}, gc: [] }, S = g.lineHeight, x = E = 0, !Tt(p) && !Zt(p))
        x = jh(r, y.data, y.gc, x, p), E = S;
      else if (Zt(p))
        for (f = 0, h = p.length; f < h; ++f)
          w = p[f], !Tt(w) && !Zt(w) && (x = jh(r, y.data, y.gc, x, w), E += S);
      a.push(x), s.push(E), o = Math.max(x, o), l = Math.max(E, l);
    }
    dne(i, n);
    const C = a.indexOf(o), P = s.indexOf(l), M = (T) => ({ width: a[T] || 0, height: s[T] || 0 });
    return {
      first: M(0),
      last: M(n - 1),
      widest: M(C),
      highest: M(P),
      widths: a,
      heights: s
    };
  }
  getLabelForValue(t) {
    return t;
  }
  getPixelForValue(t, n) {
    return NaN;
  }
  getValueForPixel(t) {
  }
  getPixelForTick(t) {
    const n = this.ticks;
    return t < 0 || t > n.length - 1 ? null : this.getPixelForValue(n[t].value);
  }
  getPixelForDecimal(t) {
    this._reversePixels && (t = 1 - t);
    const n = this._startPixel + t * this._length;
    return lee(this._alignToPixels ? Eo(this.chart, n, 0) : n);
  }
  getDecimalForPixel(t) {
    const n = (t - this._startPixel) / this._length;
    return this._reversePixels ? 1 - n : n;
  }
  getBasePixel() {
    return this.getPixelForValue(this.getBaseValue());
  }
  getBaseValue() {
    const { min: t, max: n } = this;
    return t < 0 && n < 0 ? n : t > 0 && n > 0 ? t : 0;
  }
  getContext(t) {
    const n = this.ticks || [];
    if (t >= 0 && t < n.length) {
      const r = n[t];
      return r.$context || (r.$context = hne(this.getContext(), t, r));
    }
    return this.$context || (this.$context = fne(this.chart.getContext(), this));
  }
  _tickSize() {
    const t = this.options.ticks, n = er(this.labelRotation), r = Math.abs(Math.cos(n)), i = Math.abs(Math.sin(n)), a = this._getLabelSizes(), s = t.autoSkipPadding || 0, o = a ? a.widest.width + s : 0, l = a ? a.highest.height + s : 0;
    return this.isHorizontal() ? l * r > o * i ? o / r : l / i : l * i < o * r ? l / r : o / i;
  }
  _isVisible() {
    const t = this.options.display;
    return t !== "auto" ? !!t : this.getMatchingVisibleMetas().length > 0;
  }
  _computeGridLineItems(t) {
    const n = this.axis, r = this.chart, i = this.options, { grid: a, position: s } = i, o = a.offset, l = this.isHorizontal(), f = this.ticks.length + (o ? 1 : 0), h = lc(a), p = [], g = a.setContext(this.getContext()), v = g.drawBorder ? g.borderWidth : 0, y = v / 2, S = function(J) {
      return Eo(r, J, v);
    };
    let x, E, w, C, P, M, T, N, $, ne, Y, te;
    if (s === "top")
      x = S(this.bottom), M = this.bottom - h, N = x - y, ne = S(t.top) + y, te = t.bottom;
    else if (s === "bottom")
      x = S(this.top), ne = t.top, te = S(t.bottom) - y, M = x + y, N = this.top + h;
    else if (s === "left")
      x = S(this.right), P = this.right - h, T = x - y, $ = S(t.left) + y, Y = t.right;
    else if (s === "right")
      x = S(this.left), $ = t.left, Y = S(t.right) - y, P = x + y, T = this.left + h;
    else if (n === "x") {
      if (s === "center")
        x = S((t.top + t.bottom) / 2 + 0.5);
      else if (_t(s)) {
        const J = Object.keys(s)[0], oe = s[J];
        x = S(this.chart.scales[J].getPixelForValue(oe));
      }
      ne = t.top, te = t.bottom, M = x + y, N = M + h;
    } else if (n === "y") {
      if (s === "center")
        x = S((t.left + t.right) / 2);
      else if (_t(s)) {
        const J = Object.keys(s)[0], oe = s[J];
        x = S(this.chart.scales[J].getPixelForValue(oe));
      }
      P = x - y, T = P - h, $ = t.left, Y = t.right;
    }
    const _e = lt(i.ticks.maxTicksLimit, f), Fe = Math.max(1, Math.ceil(f / _e));
    for (E = 0; E < f; E += Fe) {
      const J = a.setContext(this.getContext(E)), oe = J.lineWidth, A = J.color, X = J.borderDash || [], pe = J.borderDashOffset, le = J.tickWidth, ue = J.tickColor, Te = J.tickBorderDash || [], Ne = J.tickBorderDashOffset;
      w = cne(this, E, o), w !== void 0 && (C = Eo(r, w, oe), l ? P = T = $ = Y = C : M = N = ne = te = C, p.push({
        tx1: P,
        ty1: M,
        tx2: T,
        ty2: N,
        x1: $,
        y1: ne,
        x2: Y,
        y2: te,
        width: oe,
        color: A,
        borderDash: X,
        borderDashOffset: pe,
        tickWidth: le,
        tickColor: ue,
        tickBorderDash: Te,
        tickBorderDashOffset: Ne
      }));
    }
    return this._ticksLength = f, this._borderValue = x, p;
  }
  _computeLabelItems(t) {
    const n = this.axis, r = this.options, { position: i, ticks: a } = r, s = this.isHorizontal(), o = this.ticks, { align: l, crossAlign: c, padding: f, mirror: h } = a, p = lc(r.grid), g = p + f, v = h ? -f : g, y = -er(this.labelRotation), S = [];
    let x, E, w, C, P, M, T, N, $, ne, Y, te, _e = "middle";
    if (i === "top")
      M = this.bottom - v, T = this._getXAxisLabelAlignment();
    else if (i === "bottom")
      M = this.top + v, T = this._getXAxisLabelAlignment();
    else if (i === "left") {
      const J = this._getYAxisLabelAlignment(p);
      T = J.textAlign, P = J.x;
    } else if (i === "right") {
      const J = this._getYAxisLabelAlignment(p);
      T = J.textAlign, P = J.x;
    } else if (n === "x") {
      if (i === "center")
        M = (t.top + t.bottom) / 2 + g;
      else if (_t(i)) {
        const J = Object.keys(i)[0], oe = i[J];
        M = this.chart.scales[J].getPixelForValue(oe) + g;
      }
      T = this._getXAxisLabelAlignment();
    } else if (n === "y") {
      if (i === "center")
        P = (t.left + t.right) / 2 - g;
      else if (_t(i)) {
        const J = Object.keys(i)[0], oe = i[J];
        P = this.chart.scales[J].getPixelForValue(oe);
      }
      T = this._getYAxisLabelAlignment(p).textAlign;
    }
    n === "y" && (l === "start" ? _e = "top" : l === "end" && (_e = "bottom"));
    const Fe = this._getLabelSizes();
    for (x = 0, E = o.length; x < E; ++x) {
      w = o[x], C = w.label;
      const J = a.setContext(this.getContext(x));
      N = this.getPixelForTick(x) + a.labelOffset, $ = this._resolveTickFontOptions(x), ne = $.lineHeight, Y = Zt(C) ? C.length : 1;
      const oe = Y / 2, A = J.color, X = J.textStrokeColor, pe = J.textStrokeWidth;
      let le = T;
      s ? (P = N, T === "inner" && (x === E - 1 ? le = this.options.reverse ? "left" : "right" : x === 0 ? le = this.options.reverse ? "right" : "left" : le = "center"), i === "top" ? c === "near" || y !== 0 ? te = -Y * ne + ne / 2 : c === "center" ? te = -Fe.highest.height / 2 - oe * ne + ne : te = -Fe.highest.height + ne / 2 : c === "near" || y !== 0 ? te = ne / 2 : c === "center" ? te = Fe.highest.height / 2 - oe * ne : te = Fe.highest.height - Y * ne, h && (te *= -1)) : (M = N, te = (1 - Y) * ne / 2);
      let ue;
      if (J.showLabelBackdrop) {
        const Te = Hn(J.backdropPadding), Ne = Fe.heights[x], Z = Fe.widths[x];
        let G = M + te - Te.top, se = P - Te.left;
        switch (_e) {
          case "middle":
            G -= Ne / 2;
            break;
          case "bottom":
            G -= Ne;
            break;
        }
        switch (T) {
          case "center":
            se -= Z / 2;
            break;
          case "right":
            se -= Z;
            break;
        }
        ue = {
          left: se,
          top: G,
          width: Z + Te.width,
          height: Ne + Te.height,
          color: J.backdropColor
        };
      }
      S.push({
        rotation: y,
        label: C,
        font: $,
        color: A,
        strokeColor: X,
        strokeWidth: pe,
        textOffset: te,
        textAlign: le,
        textBaseline: _e,
        translation: [P, M],
        backdrop: ue
      });
    }
    return S;
  }
  _getXAxisLabelAlignment() {
    const { position: t, ticks: n } = this.options;
    if (-er(this.labelRotation))
      return t === "top" ? "left" : "right";
    let i = "center";
    return n.align === "start" ? i = "left" : n.align === "end" ? i = "right" : n.align === "inner" && (i = "inner"), i;
  }
  _getYAxisLabelAlignment(t) {
    const { position: n, ticks: { crossAlign: r, mirror: i, padding: a } } = this.options, s = this._getLabelSizes(), o = t + a, l = s.widest.width;
    let c, f;
    return n === "left" ? i ? (f = this.right + a, r === "near" ? c = "left" : r === "center" ? (c = "center", f += l / 2) : (c = "right", f += l)) : (f = this.right - o, r === "near" ? c = "right" : r === "center" ? (c = "center", f -= l / 2) : (c = "left", f = this.left)) : n === "right" ? i ? (f = this.left + a, r === "near" ? c = "right" : r === "center" ? (c = "center", f -= l / 2) : (c = "left", f -= l)) : (f = this.left + o, r === "near" ? c = "left" : r === "center" ? (c = "center", f += l / 2) : (c = "right", f = this.right)) : c = "right", { textAlign: c, x: f };
  }
  _computeLabelArea() {
    if (this.options.ticks.mirror)
      return;
    const t = this.chart, n = this.options.position;
    if (n === "left" || n === "right")
      return { top: 0, left: this.left, bottom: t.height, right: this.right };
    if (n === "top" || n === "bottom")
      return { top: this.top, left: 0, bottom: this.bottom, right: t.width };
  }
  drawBackground() {
    const { ctx: t, options: { backgroundColor: n }, left: r, top: i, width: a, height: s } = this;
    n && (t.save(), t.fillStyle = n, t.fillRect(r, i, a, s), t.restore());
  }
  getLineWidthForValue(t) {
    const n = this.options.grid;
    if (!this._isVisible() || !n.display)
      return 0;
    const i = this.ticks.findIndex((a) => a.value === t);
    return i >= 0 ? n.setContext(this.getContext(i)).lineWidth : 0;
  }
  drawGrid(t) {
    const n = this.options.grid, r = this.ctx, i = this._gridLineItems || (this._gridLineItems = this._computeGridLineItems(t));
    let a, s;
    const o = (l, c, f) => {
      !f.width || !f.color || (r.save(), r.lineWidth = f.width, r.strokeStyle = f.color, r.setLineDash(f.borderDash || []), r.lineDashOffset = f.borderDashOffset, r.beginPath(), r.moveTo(l.x, l.y), r.lineTo(c.x, c.y), r.stroke(), r.restore());
    };
    if (n.display)
      for (a = 0, s = i.length; a < s; ++a) {
        const l = i[a];
        n.drawOnChartArea && o(
          { x: l.x1, y: l.y1 },
          { x: l.x2, y: l.y2 },
          l
        ), n.drawTicks && o(
          { x: l.tx1, y: l.ty1 },
          { x: l.tx2, y: l.ty2 },
          {
            color: l.tickColor,
            width: l.tickWidth,
            borderDash: l.tickBorderDash,
            borderDashOffset: l.tickBorderDashOffset
          }
        );
      }
  }
  drawBorder() {
    const { chart: t, ctx: n, options: { grid: r } } = this, i = r.setContext(this.getContext()), a = r.drawBorder ? i.borderWidth : 0;
    if (!a)
      return;
    const s = r.setContext(this.getContext(0)).lineWidth, o = this._borderValue;
    let l, c, f, h;
    this.isHorizontal() ? (l = Eo(t, this.left, a) - a / 2, c = Eo(t, this.right, s) + s / 2, f = h = o) : (f = Eo(t, this.top, a) - a / 2, h = Eo(t, this.bottom, s) + s / 2, l = c = o), n.save(), n.lineWidth = i.borderWidth, n.strokeStyle = i.borderColor, n.beginPath(), n.moveTo(l, f), n.lineTo(c, h), n.stroke(), n.restore();
  }
  drawLabels(t) {
    if (!this.options.ticks.display)
      return;
    const r = this.ctx, i = this._computeLabelArea();
    i && dd(r, i);
    const a = this._labelItems || (this._labelItems = this._computeLabelItems(t));
    let s, o;
    for (s = 0, o = a.length; s < o; ++s) {
      const l = a[s], c = l.font, f = l.label;
      l.backdrop && (r.fillStyle = l.backdrop.color, r.fillRect(l.backdrop.left, l.backdrop.top, l.backdrop.width, l.backdrop.height));
      let h = l.textOffset;
      Qo(r, f, 0, h, c, l);
    }
    i && fd(r);
  }
  drawTitle() {
    const { ctx: t, options: { position: n, title: r, reverse: i } } = this;
    if (!r.display)
      return;
    const a = Fn(r.font), s = Hn(r.padding), o = r.align;
    let l = a.lineHeight / 2;
    n === "bottom" || n === "center" || _t(n) ? (l += s.bottom, Zt(r.text) && (l += a.lineHeight * (r.text.length - 1))) : l += s.top;
    const { titleX: c, titleY: f, maxWidth: h, rotation: p } = mne(this, l, n, o);
    Qo(t, r.text, 0, 0, a, {
      color: r.color,
      maxWidth: h,
      rotation: p,
      textAlign: pne(o, n, i),
      textBaseline: "middle",
      translation: [c, f]
    });
  }
  draw(t) {
    this._isVisible() && (this.drawBackground(), this.drawGrid(t), this.drawBorder(), this.drawTitle(), this.drawLabels(t));
  }
  _layers() {
    const t = this.options, n = t.ticks && t.ticks.z || 0, r = lt(t.grid && t.grid.z, -1);
    return !this._isVisible() || this.draw !== ll.prototype.draw ? [{
      z: n,
      draw: (i) => {
        this.draw(i);
      }
    }] : [{
      z: r,
      draw: (i) => {
        this.drawBackground(), this.drawGrid(i), this.drawTitle();
      }
    }, {
      z: r + 1,
      draw: () => {
        this.drawBorder();
      }
    }, {
      z: n,
      draw: (i) => {
        this.drawLabels(i);
      }
    }];
  }
  getMatchingVisibleMetas(t) {
    const n = this.chart.getSortedVisibleDatasetMetas(), r = this.axis + "AxisID", i = [];
    let a, s;
    for (a = 0, s = n.length; a < s; ++a) {
      const o = n[a];
      o[r] === this.id && (!t || o.type === t) && i.push(o);
    }
    return i;
  }
  _resolveTickFontOptions(t) {
    const n = this.options.ticks.setContext(this.getContext(t));
    return Fn(n.font);
  }
  _maxDigits() {
    const t = this._resolveTickFontOptions(0).lineHeight;
    return (this.isHorizontal() ? this.width : this.height) / t;
  }
}
class Wf {
  constructor(t, n, r) {
    this.type = t, this.scope = n, this.override = r, this.items = /* @__PURE__ */ Object.create(null);
  }
  isForType(t) {
    return Object.prototype.isPrototypeOf.call(this.type.prototype, t.prototype);
  }
  register(t) {
    const n = Object.getPrototypeOf(t);
    let r;
    bne(n) && (r = this.register(n));
    const i = this.items, a = t.id, s = this.scope + "." + a;
    if (!a)
      throw new Error("class does not have id: " + t);
    return a in i || (i[a] = t, gne(t, s, r), this.override && Et.override(t.id, t.overrides)), s;
  }
  get(t) {
    return this.items[t];
  }
  unregister(t) {
    const n = this.items, r = t.id, i = this.scope;
    r in n && delete n[r], i && r in Et[i] && (delete Et[i][r], this.override && delete Zo[r]);
  }
}
function gne(e, t, n) {
  const r = Da(/* @__PURE__ */ Object.create(null), [
    n ? Et.get(n) : {},
    Et.get(t),
    e.defaults
  ]);
  Et.set(t, r), e.defaultRoutes && vne(t, e.defaultRoutes), e.descriptors && Et.describe(t, e.descriptors);
}
function vne(e, t) {
  Object.keys(t).forEach((n) => {
    const r = n.split("."), i = r.pop(), a = [e].concat(r).join("."), s = t[n].split("."), o = s.pop(), l = s.join(".");
    Et.route(a, i, l, o);
  });
}
function bne(e) {
  return "id" in e && "defaults" in e;
}
class _ne {
  constructor() {
    this.controllers = new Wf(ha, "datasets", !0), this.elements = new Wf(Ar, "elements"), this.plugins = new Wf(Object, "plugins"), this.scales = new Wf(ll, "scales"), this._typedRegistries = [this.controllers, this.scales, this.elements];
  }
  add(...t) {
    this._each("register", t);
  }
  remove(...t) {
    this._each("unregister", t);
  }
  addControllers(...t) {
    this._each("register", t, this.controllers);
  }
  addElements(...t) {
    this._each("register", t, this.elements);
  }
  addPlugins(...t) {
    this._each("register", t, this.plugins);
  }
  addScales(...t) {
    this._each("register", t, this.scales);
  }
  getController(t) {
    return this._get(t, this.controllers, "controller");
  }
  getElement(t) {
    return this._get(t, this.elements, "element");
  }
  getPlugin(t) {
    return this._get(t, this.plugins, "plugin");
  }
  getScale(t) {
    return this._get(t, this.scales, "scale");
  }
  removeControllers(...t) {
    this._each("unregister", t, this.controllers);
  }
  removeElements(...t) {
    this._each("unregister", t, this.elements);
  }
  removePlugins(...t) {
    this._each("unregister", t, this.plugins);
  }
  removeScales(...t) {
    this._each("unregister", t, this.scales);
  }
  _each(t, n, r) {
    [...n].forEach((i) => {
      const a = r || this._getRegistryForType(i);
      r || a.isForType(i) || a === this.plugins && i.id ? this._exec(t, a, i) : Yt(i, (s) => {
        const o = r || this._getRegistryForType(s);
        this._exec(t, o, s);
      });
    });
  }
  _exec(t, n, r) {
    const i = Z0(t);
    Xt(r["before" + i], [], r), n[t](r), Xt(r["after" + i], [], r);
  }
  _getRegistryForType(t) {
    for (let n = 0; n < this._typedRegistries.length; n++) {
      const r = this._typedRegistries[n];
      if (r.isForType(t))
        return r;
    }
    return this.plugins;
  }
  _get(t, n, r) {
    const i = n.get(t);
    if (i === void 0)
      throw new Error('"' + t + '" is not a registered ' + r + ".");
    return i;
  }
}
var Ca = new _ne();
class Mp extends ha {
  update(t) {
    const n = this._cachedMeta, { data: r = [] } = n, i = this.chart._animationsDisabled;
    let { start: a, count: s } = MM(n, r, i);
    if (this._drawStart = a, this._drawCount = s, IM(n) && (a = 0, s = r.length), this.options.showLine) {
      const { dataset: o, _dataset: l } = n;
      o._chart = this.chart, o._datasetIndex = this.index, o._decimated = !!l._decimated, o.points = r;
      const c = this.resolveDatasetElementOptions(t);
      c.segment = this.options.segment, this.updateElement(o, void 0, {
        animated: !i,
        options: c
      }, t);
    }
    this.updateElements(r, a, s, t);
  }
  addElements() {
    const { showLine: t } = this.options;
    !this.datasetElementType && t && (this.datasetElementType = Ca.getElement("line")), super.addElements();
  }
  updateElements(t, n, r, i) {
    const a = i === "reset", { iScale: s, vScale: o, _stacked: l, _dataset: c } = this._cachedMeta, f = this.resolveDataElementOptions(n, i), h = this.getSharedOptions(f), p = this.includeOptions(i, h), g = s.axis, v = o.axis, { spanGaps: y, segment: S } = this.options, x = nu(y) ? y : Number.POSITIVE_INFINITY, E = this.chart._animationsDisabled || a || i === "none";
    let w = n > 0 && this.getParsed(n - 1);
    for (let C = n; C < n + r; ++C) {
      const P = t[C], M = this.getParsed(C), T = E ? P : {}, N = Tt(M[v]), $ = T[g] = s.getPixelForValue(M[g], C), ne = T[v] = a || N ? o.getBasePixel() : o.getPixelForValue(l ? this.applyStack(o, M, l) : M[v], C);
      T.skip = isNaN($) || isNaN(ne) || N, T.stop = C > 0 && Math.abs(M[g] - w[g]) > x, S && (T.parsed = M, T.raw = c.data[C]), p && (T.options = h || this.resolveDataElementOptions(C, P.active ? "active" : i)), E || this.updateElement(P, C, T, i), w = M;
    }
    this.updateSharedOptions(h, i, f);
  }
  getMaxOverflow() {
    const t = this._cachedMeta, n = t.data || [];
    if (!this.options.showLine) {
      let o = 0;
      for (let l = n.length - 1; l >= 0; --l)
        o = Math.max(o, n[l].size(this.resolveDataElementOptions(l)) / 2);
      return o > 0 && o;
    }
    const r = t.dataset, i = r.options && r.options.borderWidth || 0;
    if (!n.length)
      return i;
    const a = n[0].size(this.resolveDataElementOptions(0)), s = n[n.length - 1].size(this.resolveDataElementOptions(n.length - 1));
    return Math.max(i, a, s) / 2;
  }
}
Mp.id = "scatter";
Mp.defaults = {
  datasetElementType: !1,
  dataElementType: "point",
  showLine: !1,
  fill: !1
};
Mp.overrides = {
  interaction: {
    mode: "point"
  },
  plugins: {
    tooltip: {
      callbacks: {
        title() {
          return "";
        },
        label(e) {
          return "(" + e.label + ", " + e.formattedValue + ")";
        }
      }
    }
  },
  scales: {
    x: {
      type: "linear"
    },
    y: {
      type: "linear"
    }
  }
};
var yne = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  BarController: Tp,
  BubbleController: Ap,
  DoughnutController: mu,
  LineController: Dp,
  PolarAreaController: Ep,
  PieController: ux,
  RadarController: Pp,
  ScatterController: Mp
});
function Po() {
  throw new Error("This method is not implemented: Check that a complete date adapter is provided.");
}
class Ay {
  constructor(t) {
    this.options = t || {};
  }
  init(t) {
  }
  formats() {
    return Po();
  }
  parse(t, n) {
    return Po();
  }
  format(t, n) {
    return Po();
  }
  add(t, n, r) {
    return Po();
  }
  diff(t, n, r) {
    return Po();
  }
  startOf(t, n, r) {
    return Po();
  }
  endOf(t, n) {
    return Po();
  }
}
Ay.override = function(e) {
  Object.assign(Ay.prototype, e);
};
var xne = {
  _date: Ay
};
function wne(e, t, n, r) {
  const { controller: i, data: a, _sorted: s } = e, o = i._cachedMeta.iScale;
  if (o && t === o.axis && t !== "r" && s && a.length) {
    const l = o._reversePixels ? uee : as;
    if (r) {
      if (i._sharedOptions) {
        const c = a[0], f = typeof c.getRange == "function" && c.getRange(t);
        if (f) {
          const h = l(a, t, n - f), p = l(a, t, n + f);
          return { lo: h.lo, hi: p.hi };
        }
      }
    } else return l(a, t, n);
  }
  return { lo: 0, hi: a.length - 1 };
}
function Ip(e, t, n, r, i) {
  const a = e.getSortedVisibleDatasetMetas(), s = n[t];
  for (let o = 0, l = a.length; o < l; ++o) {
    const { index: c, data: f } = a[o], { lo: h, hi: p } = wne(a[o], t, s, i);
    for (let g = h; g <= p; ++g) {
      const v = f[g];
      v.skip || r(v, c, g);
    }
  }
}
function kne(e) {
  const t = e.indexOf("x") !== -1, n = e.indexOf("y") !== -1;
  return function(r, i) {
    const a = t ? Math.abs(r.x - i.x) : 0, s = n ? Math.abs(r.y - i.y) : 0;
    return Math.sqrt(Math.pow(a, 2) + Math.pow(s, 2));
  };
}
function ev(e, t, n, r, i) {
  const a = [];
  return !i && !e.isPointInArea(t) || Ip(e, n, t, function(o, l, c) {
    !i && !zc(o, e.chartArea, 0) || o.inRange(t.x, t.y, r) && a.push({ element: o, datasetIndex: l, index: c });
  }, !0), a;
}
function Sne(e, t, n, r) {
  let i = [];
  function a(s, o, l) {
    const { startAngle: c, endAngle: f } = s.getProps(["startAngle", "endAngle"], r), { angle: h } = AM(s, { x: t.x, y: t.y });
    Wc(h, c, f) && i.push({ element: s, datasetIndex: o, index: l });
  }
  return Ip(e, n, t, a), i;
}
function Cne(e, t, n, r, i, a) {
  let s = [];
  const o = kne(n);
  let l = Number.POSITIVE_INFINITY;
  function c(f, h, p) {
    const g = f.inRange(t.x, t.y, i);
    if (r && !g)
      return;
    const v = f.getCenterPoint(i);
    if (!(!!a || e.isPointInArea(v)) && !g)
      return;
    const S = o(t, v);
    S < l ? (s = [{ element: f, datasetIndex: h, index: p }], l = S) : S === l && s.push({ element: f, datasetIndex: h, index: p });
  }
  return Ip(e, n, t, c), s;
}
function tv(e, t, n, r, i, a) {
  return !a && !e.isPointInArea(t) ? [] : n === "r" && !r ? Sne(e, t, n, i) : Cne(e, t, n, r, i, a);
}
function ZC(e, t, n, r, i) {
  const a = [], s = n === "x" ? "inXRange" : "inYRange";
  let o = !1;
  return Ip(e, n, t, (l, c, f) => {
    l[s](t[n], i) && (a.push({ element: l, datasetIndex: c, index: f }), o = o || l.inRange(t.x, t.y, i));
  }), r && !o ? [] : a;
}
var Tne = {
  modes: {
    index(e, t, n, r) {
      const i = Io(t, e), a = n.axis || "x", s = n.includeInvisible || !1, o = n.intersect ? ev(e, i, a, r, s) : tv(e, i, a, !1, r, s), l = [];
      return o.length ? (e.getSortedVisibleDatasetMetas().forEach((c) => {
        const f = o[0].index, h = c.data[f];
        h && !h.skip && l.push({ element: h, datasetIndex: c.index, index: f });
      }), l) : [];
    },
    dataset(e, t, n, r) {
      const i = Io(t, e), a = n.axis || "xy", s = n.includeInvisible || !1;
      let o = n.intersect ? ev(e, i, a, r, s) : tv(e, i, a, !1, r, s);
      if (o.length > 0) {
        const l = o[0].datasetIndex, c = e.getDatasetMeta(l).data;
        o = [];
        for (let f = 0; f < c.length; ++f)
          o.push({ element: c[f], datasetIndex: l, index: f });
      }
      return o;
    },
    point(e, t, n, r) {
      const i = Io(t, e), a = n.axis || "xy", s = n.includeInvisible || !1;
      return ev(e, i, a, r, s);
    },
    nearest(e, t, n, r) {
      const i = Io(t, e), a = n.axis || "xy", s = n.includeInvisible || !1;
      return tv(e, i, a, n.intersect, r, s);
    },
    x(e, t, n, r) {
      const i = Io(t, e);
      return ZC(e, i, "x", n.intersect, r);
    },
    y(e, t, n, r) {
      const i = Io(t, e);
      return ZC(e, i, "y", n.intersect, r);
    }
  }
};
const nI = ["left", "top", "right", "bottom"];
function uc(e, t) {
  return e.filter((n) => n.pos === t);
}
function QC(e, t) {
  return e.filter((n) => nI.indexOf(n.pos) === -1 && n.box.axis === t);
}
function cc(e, t) {
  return e.sort((n, r) => {
    const i = t ? r : n, a = t ? n : r;
    return i.weight === a.weight ? i.index - a.index : i.weight - a.weight;
  });
}
function Ane(e) {
  const t = [];
  let n, r, i, a, s, o;
  for (n = 0, r = (e || []).length; n < r; ++n)
    i = e[n], { position: a, options: { stack: s, stackWeight: o = 1 } } = i, t.push({
      index: n,
      box: i,
      pos: a,
      horizontal: i.isHorizontal(),
      weight: i.weight,
      stack: s && a + s,
      stackWeight: o
    });
  return t;
}
function Dne(e) {
  const t = {};
  for (const n of e) {
    const { stack: r, pos: i, stackWeight: a } = n;
    if (!r || !nI.includes(i))
      continue;
    const s = t[r] || (t[r] = { count: 0, placed: 0, weight: 0, size: 0 });
    s.count++, s.weight += a;
  }
  return t;
}
function Ene(e, t) {
  const n = Dne(e), { vBoxMaxWidth: r, hBoxMaxHeight: i } = t;
  let a, s, o;
  for (a = 0, s = e.length; a < s; ++a) {
    o = e[a];
    const { fullSize: l } = o.box, c = n[o.stack], f = c && o.stackWeight / c.weight;
    o.horizontal ? (o.width = f ? f * r : l && t.availableWidth, o.height = i) : (o.width = r, o.height = f ? f * i : l && t.availableHeight);
  }
  return n;
}
function Pne(e) {
  const t = Ane(e), n = cc(t.filter((c) => c.box.fullSize), !0), r = cc(uc(t, "left"), !0), i = cc(uc(t, "right")), a = cc(uc(t, "top"), !0), s = cc(uc(t, "bottom")), o = QC(t, "x"), l = QC(t, "y");
  return {
    fullSize: n,
    leftAndTop: r.concat(a),
    rightAndBottom: i.concat(l).concat(s).concat(o),
    chartArea: uc(t, "chartArea"),
    vertical: r.concat(i).concat(l),
    horizontal: a.concat(s).concat(o)
  };
}
function JC(e, t, n, r) {
  return Math.max(e[n], t[n]) + Math.max(e[r], t[r]);
}
function rI(e, t) {
  e.top = Math.max(e.top, t.top), e.left = Math.max(e.left, t.left), e.bottom = Math.max(e.bottom, t.bottom), e.right = Math.max(e.right, t.right);
}
function One(e, t, n, r) {
  const { pos: i, box: a } = n, s = e.maxPadding;
  if (!_t(i)) {
    n.size && (e[i] -= n.size);
    const h = r[n.stack] || { size: 0, count: 1 };
    h.size = Math.max(h.size, n.horizontal ? a.height : a.width), n.size = h.size / h.count, e[i] += n.size;
  }
  a.getPadding && rI(s, a.getPadding());
  const o = Math.max(0, t.outerWidth - JC(s, e, "left", "right")), l = Math.max(0, t.outerHeight - JC(s, e, "top", "bottom")), c = o !== e.w, f = l !== e.h;
  return e.w = o, e.h = l, n.horizontal ? { same: c, other: f } : { same: f, other: c };
}
function Mne(e) {
  const t = e.maxPadding;
  function n(r) {
    const i = Math.max(t[r] - e[r], 0);
    return e[r] += i, i;
  }
  e.y += n("top"), e.x += n("left"), n("right"), n("bottom");
}
function Ine(e, t) {
  const n = t.maxPadding;
  function r(i) {
    const a = { left: 0, top: 0, right: 0, bottom: 0 };
    return i.forEach((s) => {
      a[s] = Math.max(t[s], n[s]);
    }), a;
  }
  return r(e ? ["left", "right"] : ["top", "bottom"]);
}
function bc(e, t, n, r) {
  const i = [];
  let a, s, o, l, c, f;
  for (a = 0, s = e.length, c = 0; a < s; ++a) {
    o = e[a], l = o.box, l.update(
      o.width || t.w,
      o.height || t.h,
      Ine(o.horizontal, t)
    );
    const { same: h, other: p } = One(t, n, o, r);
    c |= h && i.length, f = f || p, l.fullSize || i.push(o);
  }
  return c && bc(i, t, n, r) || f;
}
function zf(e, t, n, r, i) {
  e.top = n, e.left = t, e.right = t + r, e.bottom = n + i, e.width = r, e.height = i;
}
function eT(e, t, n, r) {
  const i = n.padding;
  let { x: a, y: s } = t;
  for (const o of e) {
    const l = o.box, c = r[o.stack] || { placed: 0, weight: 1 }, f = o.stackWeight / c.weight || 1;
    if (o.horizontal) {
      const h = t.w * f, p = c.size || l.height;
      zn(c.start) && (s = c.start), l.fullSize ? zf(l, i.left, s, n.outerWidth - i.right - i.left, p) : zf(l, t.left + c.placed, s, h, p), c.start = s, c.placed += h, s = l.bottom;
    } else {
      const h = t.h * f, p = c.size || l.width;
      zn(c.start) && (a = c.start), l.fullSize ? zf(l, a, i.top, p, n.outerHeight - i.bottom - i.top) : zf(l, a, t.top + c.placed, p, h), c.start = a, c.placed += h, a = l.right;
    }
  }
  t.x = a, t.y = s;
}
Et.set("layout", {
  autoPadding: !0,
  padding: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  }
});
var Nr = {
  addBox(e, t) {
    e.boxes || (e.boxes = []), t.fullSize = t.fullSize || !1, t.position = t.position || "top", t.weight = t.weight || 0, t._layers = t._layers || function() {
      return [{
        z: 0,
        draw(n) {
          t.draw(n);
        }
      }];
    }, e.boxes.push(t);
  },
  removeBox(e, t) {
    const n = e.boxes ? e.boxes.indexOf(t) : -1;
    n !== -1 && e.boxes.splice(n, 1);
  },
  configure(e, t, n) {
    t.fullSize = n.fullSize, t.position = n.position, t.weight = n.weight;
  },
  update(e, t, n, r) {
    if (!e)
      return;
    const i = Hn(e.options.layout.padding), a = Math.max(t - i.width, 0), s = Math.max(n - i.height, 0), o = Pne(e.boxes), l = o.vertical, c = o.horizontal;
    Yt(e.boxes, (y) => {
      typeof y.beforeLayout == "function" && y.beforeLayout();
    });
    const f = l.reduce((y, S) => S.box.options && S.box.options.display === !1 ? y : y + 1, 0) || 1, h = Object.freeze({
      outerWidth: t,
      outerHeight: n,
      padding: i,
      availableWidth: a,
      availableHeight: s,
      vBoxMaxWidth: a / 2 / f,
      hBoxMaxHeight: s / 2
    }), p = Object.assign({}, i);
    rI(p, Hn(r));
    const g = Object.assign({
      maxPadding: p,
      w: a,
      h: s,
      x: i.left,
      y: i.top
    }, i), v = Ene(l.concat(c), h);
    bc(o.fullSize, g, h, v), bc(l, g, h, v), bc(c, g, h, v) && bc(l, g, h, v), Mne(g), eT(o.leftAndTop, g, h, v), g.x += g.w, g.y += g.h, eT(o.rightAndBottom, g, h, v), e.chartArea = {
      left: g.left,
      top: g.top,
      right: g.left + g.w,
      bottom: g.top + g.h,
      height: g.h,
      width: g.w
    }, Yt(o.chartArea, (y) => {
      const S = y.box;
      Object.assign(S, e.chartArea), S.update(g.w, g.h, { left: 0, top: 0, right: 0, bottom: 0 });
    });
  }
};
class iI {
  acquireContext(t, n) {
  }
  releaseContext(t) {
    return !1;
  }
  addEventListener(t, n, r) {
  }
  removeEventListener(t, n, r) {
  }
  getDevicePixelRatio() {
    return 1;
  }
  getMaximumSize(t, n, r, i) {
    return n = Math.max(0, n || t.width), r = r || t.height, {
      width: n,
      height: Math.max(0, i ? Math.floor(n / i) : r)
    };
  }
  isAttached(t) {
    return !0;
  }
  updateConfig(t) {
  }
}
class Rne extends iI {
  acquireContext(t) {
    return t && t.getContext && t.getContext("2d") || null;
  }
  updateConfig(t) {
    t.options.animation = !1;
  }
}
const fh = "$chartjs", Fne = {
  touchstart: "mousedown",
  touchmove: "mousemove",
  touchend: "mouseup",
  pointerenter: "mouseenter",
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointerleave: "mouseout",
  pointerout: "mouseout"
}, tT = (e) => e === null || e === "";
function Nne(e, t) {
  const n = e.style, r = e.getAttribute("height"), i = e.getAttribute("width");
  if (e[fh] = {
    initial: {
      height: r,
      width: i,
      style: {
        display: n.display,
        height: n.height,
        width: n.width
      }
    }
  }, n.display = n.display || "block", n.boxSizing = n.boxSizing || "border-box", tT(i)) {
    const a = IC(e, "width");
    a !== void 0 && (e.width = a);
  }
  if (tT(r))
    if (e.style.height === "")
      e.height = e.width / (t || 2);
    else {
      const a = IC(e, "height");
      a !== void 0 && (e.height = a);
    }
  return e;
}
const aI = gte ? { passive: !0 } : !1;
function Lne(e, t, n) {
  e.addEventListener(t, n, aI);
}
function $ne(e, t, n) {
  e.canvas.removeEventListener(t, n, aI);
}
function Vne(e, t) {
  const n = Fne[e.type] || e.type, { x: r, y: i } = Io(e, t);
  return {
    type: n,
    chart: t,
    native: e,
    x: r !== void 0 ? r : null,
    y: i !== void 0 ? i : null
  };
}
function Hh(e, t) {
  for (const n of e)
    if (n === t || n.contains(t))
      return !0;
}
function Bne(e, t, n) {
  const r = e.canvas, i = new MutationObserver((a) => {
    let s = !1;
    for (const o of a)
      s = s || Hh(o.addedNodes, r), s = s && !Hh(o.removedNodes, r);
    s && n();
  });
  return i.observe(document, { childList: !0, subtree: !0 }), i;
}
function Une(e, t, n) {
  const r = e.canvas, i = new MutationObserver((a) => {
    let s = !1;
    for (const o of a)
      s = s || Hh(o.removedNodes, r), s = s && !Hh(o.addedNodes, r);
    s && n();
  });
  return i.observe(document, { childList: !0, subtree: !0 }), i;
}
const Hc = /* @__PURE__ */ new Map();
let nT = 0;
function sI() {
  const e = window.devicePixelRatio;
  e !== nT && (nT = e, Hc.forEach((t, n) => {
    n.currentDevicePixelRatio !== e && t();
  }));
}
function qne(e, t) {
  Hc.size || window.addEventListener("resize", sI), Hc.set(e, t);
}
function jne(e) {
  Hc.delete(e), Hc.size || window.removeEventListener("resize", sI);
}
function Wne(e, t, n) {
  const r = e.canvas, i = r && ox(r);
  if (!i)
    return;
  const a = OM((o, l) => {
    const c = i.clientWidth;
    n(o, l), c < i.clientWidth && n();
  }, window), s = new ResizeObserver((o) => {
    const l = o[0], c = l.contentRect.width, f = l.contentRect.height;
    c === 0 && f === 0 || a(c, f);
  });
  return s.observe(i), qne(e, a), s;
}
function nv(e, t, n) {
  n && n.disconnect(), t === "resize" && jne(e);
}
function zne(e, t, n) {
  const r = e.canvas, i = OM((a) => {
    e.ctx !== null && n(Vne(a, e));
  }, e, (a) => {
    const s = a[0];
    return [s, s.offsetX, s.offsetY];
  });
  return Lne(r, t, i), i;
}
class Hne extends iI {
  acquireContext(t, n) {
    const r = t && t.getContext && t.getContext("2d");
    return r && r.canvas === t ? (Nne(t, n), r) : null;
  }
  releaseContext(t) {
    const n = t.canvas;
    if (!n[fh])
      return !1;
    const r = n[fh].initial;
    ["height", "width"].forEach((a) => {
      const s = r[a];
      Tt(s) ? n.removeAttribute(a) : n.setAttribute(a, s);
    });
    const i = r.style || {};
    return Object.keys(i).forEach((a) => {
      n.style[a] = i[a];
    }), n.width = n.width, delete n[fh], !0;
  }
  addEventListener(t, n, r) {
    this.removeEventListener(t, n);
    const i = t.$proxies || (t.$proxies = {}), s = {
      attach: Bne,
      detach: Une,
      resize: Wne
    }[n] || zne;
    i[n] = s(t, n, r);
  }
  removeEventListener(t, n) {
    const r = t.$proxies || (t.$proxies = {}), i = r[n];
    if (!i)
      return;
    ({
      attach: nv,
      detach: nv,
      resize: nv
    }[n] || $ne)(t, n, i), r[n] = void 0;
  }
  getDevicePixelRatio() {
    return window.devicePixelRatio;
  }
  getMaximumSize(t, n, r, i) {
    return mte(t, n, r, i);
  }
  isAttached(t) {
    const n = ox(t);
    return !!(n && n.isConnected);
  }
}
function Gne(e) {
  return !GM() || typeof OffscreenCanvas < "u" && e instanceof OffscreenCanvas ? Rne : Hne;
}
class Yne {
  constructor() {
    this._init = [];
  }
  notify(t, n, r, i) {
    n === "beforeInit" && (this._init = this._createDescriptors(t, !0), this._notify(this._init, t, "install"));
    const a = i ? this._descriptors(t).filter(i) : this._descriptors(t), s = this._notify(a, t, n, r);
    return n === "afterDestroy" && (this._notify(a, t, "stop"), this._notify(this._init, t, "uninstall")), s;
  }
  _notify(t, n, r, i) {
    i = i || {};
    for (const a of t) {
      const s = a.plugin, o = s[r], l = [n, i, a.options];
      if (Xt(o, l, s) === !1 && i.cancelable)
        return !1;
    }
    return !0;
  }
  invalidate() {
    Tt(this._cache) || (this._oldCache = this._cache, this._cache = void 0);
  }
  _descriptors(t) {
    if (this._cache)
      return this._cache;
    const n = this._cache = this._createDescriptors(t);
    return this._notifyStateChanges(t), n;
  }
  _createDescriptors(t, n) {
    const r = t && t.config, i = lt(r.options && r.options.plugins, {}), a = Kne(r);
    return i === !1 && !n ? [] : Zne(t, a, i, n);
  }
  _notifyStateChanges(t) {
    const n = this._oldCache || [], r = this._cache, i = (a, s) => a.filter((o) => !s.some((l) => o.plugin.id === l.plugin.id));
    this._notify(i(n, r), t, "stop"), this._notify(i(r, n), t, "start");
  }
}
function Kne(e) {
  const t = {}, n = [], r = Object.keys(Ca.plugins.items);
  for (let a = 0; a < r.length; a++)
    n.push(Ca.getPlugin(r[a]));
  const i = e.plugins || [];
  for (let a = 0; a < i.length; a++) {
    const s = i[a];
    n.indexOf(s) === -1 && (n.push(s), t[s.id] = !0);
  }
  return { plugins: n, localIds: t };
}
function Xne(e, t) {
  return !t && e === !1 ? null : e === !0 ? {} : e;
}
function Zne(e, { plugins: t, localIds: n }, r, i) {
  const a = [], s = e.getContext();
  for (const o of t) {
    const l = o.id, c = Xne(r[l], i);
    c !== null && a.push({
      plugin: o,
      options: Qne(e.config, { plugin: o, local: n[l] }, c, s)
    });
  }
  return a;
}
function Qne(e, { plugin: t, local: n }, r, i) {
  const a = e.pluginScopeKeys(t), s = e.getOptionScopes(r, a);
  return n && t.defaults && s.push(t.defaults), e.createResolver(s, i, [""], {
    scriptable: !1,
    indexable: !1,
    allKeys: !0
  });
}
function Dy(e, t) {
  const n = Et.datasets[e] || {};
  return ((t.datasets || {})[e] || {}).indexAxis || t.indexAxis || n.indexAxis || "x";
}
function Jne(e, t) {
  let n = e;
  return e === "_index_" ? n = t : e === "_value_" && (n = t === "x" ? "y" : "x"), n;
}
function ere(e, t) {
  return e === t ? "_index_" : "_value_";
}
function tre(e) {
  if (e === "top" || e === "bottom")
    return "x";
  if (e === "left" || e === "right")
    return "y";
}
function Ey(e, t) {
  return e === "x" || e === "y" ? e : t.axis || tre(t.position) || e.charAt(0).toLowerCase();
}
function nre(e, t) {
  const n = Zo[e.type] || { scales: {} }, r = t.scales || {}, i = Dy(e.type, t), a = /* @__PURE__ */ Object.create(null), s = /* @__PURE__ */ Object.create(null);
  return Object.keys(r).forEach((o) => {
    const l = r[o];
    if (!_t(l))
      return console.error(`Invalid scale configuration for scale: ${o}`);
    if (l._proxy)
      return console.warn(`Ignoring resolver passed as options for scale: ${o}`);
    const c = Ey(o, l), f = ere(c, i), h = n.scales || {};
    a[c] = a[c] || o, s[o] = Ac(/* @__PURE__ */ Object.create(null), [{ axis: c }, l, h[c], h[f]]);
  }), e.data.datasets.forEach((o) => {
    const l = o.type || e.type, c = o.indexAxis || Dy(l, t), h = (Zo[l] || {}).scales || {};
    Object.keys(h).forEach((p) => {
      const g = Jne(p, c), v = o[g + "AxisID"] || a[g] || g;
      s[v] = s[v] || /* @__PURE__ */ Object.create(null), Ac(s[v], [{ axis: g }, r[v], h[p]]);
    });
  }), Object.keys(s).forEach((o) => {
    const l = s[o];
    Ac(l, [Et.scales[l.type], Et.scale]);
  }), s;
}
function oI(e) {
  const t = e.options || (e.options = {});
  t.plugins = lt(t.plugins, {}), t.scales = nre(e, t);
}
function lI(e) {
  return e = e || {}, e.datasets = e.datasets || [], e.labels = e.labels || [], e;
}
function rre(e) {
  return e = e || {}, e.data = lI(e.data), oI(e), e;
}
const rT = /* @__PURE__ */ new Map(), uI = /* @__PURE__ */ new Set();
function Hf(e, t) {
  let n = rT.get(e);
  return n || (n = t(), rT.set(e, n), uI.add(n)), n;
}
const dc = (e, t, n) => {
  const r = Zs(t, n);
  r !== void 0 && e.add(r);
};
class ire {
  constructor(t) {
    this._config = rre(t), this._scopeCache = /* @__PURE__ */ new Map(), this._resolverCache = /* @__PURE__ */ new Map();
  }
  get platform() {
    return this._config.platform;
  }
  get type() {
    return this._config.type;
  }
  set type(t) {
    this._config.type = t;
  }
  get data() {
    return this._config.data;
  }
  set data(t) {
    this._config.data = lI(t);
  }
  get options() {
    return this._config.options;
  }
  set options(t) {
    this._config.options = t;
  }
  get plugins() {
    return this._config.plugins;
  }
  update() {
    const t = this._config;
    this.clearCache(), oI(t);
  }
  clearCache() {
    this._scopeCache.clear(), this._resolverCache.clear();
  }
  datasetScopeKeys(t) {
    return Hf(
      t,
      () => [[
        `datasets.${t}`,
        ""
      ]]
    );
  }
  datasetAnimationScopeKeys(t, n) {
    return Hf(
      `${t}.transition.${n}`,
      () => [
        [
          `datasets.${t}.transitions.${n}`,
          `transitions.${n}`
        ],
        [
          `datasets.${t}`,
          ""
        ]
      ]
    );
  }
  datasetElementScopeKeys(t, n) {
    return Hf(
      `${t}-${n}`,
      () => [[
        `datasets.${t}.elements.${n}`,
        `datasets.${t}`,
        `elements.${n}`,
        ""
      ]]
    );
  }
  pluginScopeKeys(t) {
    const n = t.id, r = this.type;
    return Hf(
      `${r}-plugin-${n}`,
      () => [[
        `plugins.${n}`,
        ...t.additionalOptionScopes || []
      ]]
    );
  }
  _cachedScopes(t, n) {
    const r = this._scopeCache;
    let i = r.get(t);
    return (!i || n) && (i = /* @__PURE__ */ new Map(), r.set(t, i)), i;
  }
  getOptionScopes(t, n, r) {
    const { options: i, type: a } = this, s = this._cachedScopes(t, r), o = s.get(n);
    if (o)
      return o;
    const l = /* @__PURE__ */ new Set();
    n.forEach((f) => {
      t && (l.add(t), f.forEach((h) => dc(l, t, h))), f.forEach((h) => dc(l, i, h)), f.forEach((h) => dc(l, Zo[a] || {}, h)), f.forEach((h) => dc(l, Et, h)), f.forEach((h) => dc(l, Ty, h));
    });
    const c = Array.from(l);
    return c.length === 0 && c.push(/* @__PURE__ */ Object.create(null)), uI.has(n) && s.set(n, c), c;
  }
  chartOptionScopes() {
    const { options: t, type: n } = this;
    return [
      t,
      Zo[n] || {},
      Et.datasets[n] || {},
      { type: n },
      Et,
      Ty
    ];
  }
  resolveNamedOptions(t, n, r, i = [""]) {
    const a = { $shared: !0 }, { resolver: s, subPrefixes: o } = iT(this._resolverCache, t, i);
    let l = s;
    if (sre(s, n)) {
      a.$shared = !1, r = Qs(r) ? r() : r;
      const c = this.createResolver(t, r, o);
      l = iu(s, r, c);
    }
    for (const c of n)
      a[c] = l[c];
    return a;
  }
  createResolver(t, n, r = [""], i) {
    const { resolver: a } = iT(this._resolverCache, t, r);
    return _t(n) ? iu(a, n, void 0, i) : a;
  }
}
function iT(e, t, n) {
  let r = e.get(t);
  r || (r = /* @__PURE__ */ new Map(), e.set(t, r));
  const i = n.join();
  let a = r.get(i);
  return a || (a = {
    resolver: ix(t, n),
    subPrefixes: n.filter((o) => !o.toLowerCase().includes("hover"))
  }, r.set(i, a)), a;
}
const are = (e) => _t(e) && Object.getOwnPropertyNames(e).reduce((t, n) => t || Qs(e[n]), !1);
function sre(e, t) {
  const { isScriptable: n, isIndexable: r } = UM(e);
  for (const i of t) {
    const a = n(i), s = r(i), o = (s || a) && e[i];
    if (a && (Qs(o) || are(o)) || s && Zt(o))
      return !0;
  }
  return !1;
}
var ore = "3.9.1";
const lre = ["top", "bottom", "left", "right", "chartArea"];
function aT(e, t) {
  return e === "top" || e === "bottom" || lre.indexOf(e) === -1 && t === "x";
}
function sT(e, t) {
  return function(n, r) {
    return n[e] === r[e] ? n[t] - r[t] : n[e] - r[e];
  };
}
function oT(e) {
  const t = e.chart, n = t.options.animation;
  t.notifyPlugins("afterRender"), Xt(n && n.onComplete, [e], t);
}
function ure(e) {
  const t = e.chart, n = t.options.animation;
  Xt(n && n.onProgress, [e], t);
}
function cI(e) {
  return GM() && typeof e == "string" ? e = document.getElementById(e) : e && e.length && (e = e[0]), e && e.canvas && (e = e.canvas), e;
}
const Gh = {}, dI = (e) => {
  const t = cI(e);
  return Object.values(Gh).filter((n) => n.canvas === t).pop();
};
function cre(e, t, n) {
  const r = Object.keys(e);
  for (const i of r) {
    const a = +i;
    if (a >= t) {
      const s = e[i];
      delete e[i], (n > 0 || a > t) && (e[a + n] = s);
    }
  }
}
function dre(e, t, n, r) {
  return !n || e.type === "mouseout" ? null : r ? t : e;
}
class ls {
  constructor(t, n) {
    const r = this.config = new ire(n), i = cI(t), a = dI(i);
    if (a)
      throw new Error(
        "Canvas is already in use. Chart with ID '" + a.id + "' must be destroyed before the canvas with ID '" + a.canvas.id + "' can be reused."
      );
    const s = r.createResolver(r.chartOptionScopes(), this.getContext());
    this.platform = new (r.platform || Gne(i))(), this.platform.updateConfig(r);
    const o = this.platform.acquireContext(i, s.aspectRatio), l = o && o.canvas, c = l && l.height, f = l && l.width;
    if (this.id = ZJ(), this.ctx = o, this.canvas = l, this.width = f, this.height = c, this._options = s, this._aspectRatio = this.aspectRatio, this._layers = [], this._metasets = [], this._stacks = void 0, this.boxes = [], this.currentDevicePixelRatio = void 0, this.chartArea = void 0, this._active = [], this._lastEvent = void 0, this._listeners = {}, this._responsiveListeners = void 0, this._sortedMetasets = [], this.scales = {}, this._plugins = new Yne(), this.$proxies = {}, this._hiddenIndices = {}, this.attached = !1, this._animationsDisabled = void 0, this.$context = void 0, this._doResize = fee((h) => this.update(h), s.resizeDelay || 0), this._dataChanges = [], Gh[this.id] = this, !o || !l) {
      console.error("Failed to create chart: can't acquire context from the given item");
      return;
    }
    Xa.listen(this, "complete", oT), Xa.listen(this, "progress", ure), this._initialize(), this.attached && this.update();
  }
  get aspectRatio() {
    const { options: { aspectRatio: t, maintainAspectRatio: n }, width: r, height: i, _aspectRatio: a } = this;
    return Tt(t) ? n && a ? a : i ? r / i : null : t;
  }
  get data() {
    return this.config.data;
  }
  set data(t) {
    this.config.data = t;
  }
  get options() {
    return this._options;
  }
  set options(t) {
    this.config.options = t;
  }
  _initialize() {
    return this.notifyPlugins("beforeInit"), this.options.responsive ? this.resize() : MC(this, this.options.devicePixelRatio), this.bindEvents(), this.notifyPlugins("afterInit"), this;
  }
  clear() {
    return EC(this.canvas, this.ctx), this;
  }
  stop() {
    return Xa.stop(this), this;
  }
  resize(t, n) {
    Xa.running(this) ? this._resizeBeforeDraw = { width: t, height: n } : this._resize(t, n);
  }
  _resize(t, n) {
    const r = this.options, i = this.canvas, a = r.maintainAspectRatio && this.aspectRatio, s = this.platform.getMaximumSize(i, t, n, a), o = r.devicePixelRatio || this.platform.getDevicePixelRatio(), l = this.width ? "resize" : "attach";
    this.width = s.width, this.height = s.height, this._aspectRatio = this.aspectRatio, MC(this, o, !0) && (this.notifyPlugins("resize", { size: s }), Xt(r.onResize, [this, s], this), this.attached && this._doResize(l) && this.render());
  }
  ensureScalesHaveIDs() {
    const n = this.options.scales || {};
    Yt(n, (r, i) => {
      r.id = i;
    });
  }
  buildOrUpdateScales() {
    const t = this.options, n = t.scales, r = this.scales, i = Object.keys(r).reduce((s, o) => (s[o] = !1, s), {});
    let a = [];
    n && (a = a.concat(
      Object.keys(n).map((s) => {
        const o = n[s], l = Ey(s, o), c = l === "r", f = l === "x";
        return {
          options: o,
          dposition: c ? "chartArea" : f ? "bottom" : "left",
          dtype: c ? "radialLinear" : f ? "category" : "linear"
        };
      })
    )), Yt(a, (s) => {
      const o = s.options, l = o.id, c = Ey(l, o), f = lt(o.type, s.dtype);
      (o.position === void 0 || aT(o.position, c) !== aT(s.dposition)) && (o.position = s.dposition), i[l] = !0;
      let h = null;
      if (l in r && r[l].type === f)
        h = r[l];
      else {
        const p = Ca.getScale(f);
        h = new p({
          id: l,
          type: f,
          ctx: this.ctx,
          chart: this
        }), r[h.id] = h;
      }
      h.init(o, t);
    }), Yt(i, (s, o) => {
      s || delete r[o];
    }), Yt(r, (s) => {
      Nr.configure(this, s, s.options), Nr.addBox(this, s);
    });
  }
  _updateMetasets() {
    const t = this._metasets, n = this.data.datasets.length, r = t.length;
    if (t.sort((i, a) => i.index - a.index), r > n) {
      for (let i = n; i < r; ++i)
        this._destroyDatasetMeta(i);
      t.splice(n, r - n);
    }
    this._sortedMetasets = t.slice(0).sort(sT("order", "index"));
  }
  _removeUnreferencedMetasets() {
    const { _metasets: t, data: { datasets: n } } = this;
    t.length > n.length && delete this._stacks, t.forEach((r, i) => {
      n.filter((a) => a === r._dataset).length === 0 && this._destroyDatasetMeta(i);
    });
  }
  buildOrUpdateControllers() {
    const t = [], n = this.data.datasets;
    let r, i;
    for (this._removeUnreferencedMetasets(), r = 0, i = n.length; r < i; r++) {
      const a = n[r];
      let s = this.getDatasetMeta(r);
      const o = a.type || this.config.type;
      if (s.type && s.type !== o && (this._destroyDatasetMeta(r), s = this.getDatasetMeta(r)), s.type = o, s.indexAxis = a.indexAxis || Dy(o, this.options), s.order = a.order || 0, s.index = r, s.label = "" + a.label, s.visible = this.isDatasetVisible(r), s.controller)
        s.controller.updateIndex(r), s.controller.linkScales();
      else {
        const l = Ca.getController(o), { datasetElementType: c, dataElementType: f } = Et.datasets[o];
        Object.assign(l.prototype, {
          dataElementType: Ca.getElement(f),
          datasetElementType: c && Ca.getElement(c)
        }), s.controller = new l(this, r), t.push(s.controller);
      }
    }
    return this._updateMetasets(), t;
  }
  _resetElements() {
    Yt(this.data.datasets, (t, n) => {
      this.getDatasetMeta(n).controller.reset();
    }, this);
  }
  reset() {
    this._resetElements(), this.notifyPlugins("reset");
  }
  update(t) {
    const n = this.config;
    n.update();
    const r = this._options = n.createResolver(n.chartOptionScopes(), this.getContext()), i = this._animationsDisabled = !r.animation;
    if (this._updateScales(), this._checkEventBindings(), this._updateHiddenIndices(), this._plugins.invalidate(), this.notifyPlugins("beforeUpdate", { mode: t, cancelable: !0 }) === !1)
      return;
    const a = this.buildOrUpdateControllers();
    this.notifyPlugins("beforeElementsUpdate");
    let s = 0;
    for (let c = 0, f = this.data.datasets.length; c < f; c++) {
      const { controller: h } = this.getDatasetMeta(c), p = !i && a.indexOf(h) === -1;
      h.buildOrUpdateElements(p), s = Math.max(+h.getMaxOverflow(), s);
    }
    s = this._minPadding = r.layout.autoPadding ? s : 0, this._updateLayout(s), i || Yt(a, (c) => {
      c.reset();
    }), this._updateDatasets(t), this.notifyPlugins("afterUpdate", { mode: t }), this._layers.sort(sT("z", "_idx"));
    const { _active: o, _lastEvent: l } = this;
    l ? this._eventHandler(l, !0) : o.length && this._updateHoverStyles(o, o, !0), this.render();
  }
  _updateScales() {
    Yt(this.scales, (t) => {
      Nr.removeBox(this, t);
    }), this.ensureScalesHaveIDs(), this.buildOrUpdateScales();
  }
  _checkEventBindings() {
    const t = this.options, n = new Set(Object.keys(this._listeners)), r = new Set(t.events);
    (!vC(n, r) || !!this._responsiveListeners !== t.responsive) && (this.unbindEvents(), this.bindEvents());
  }
  _updateHiddenIndices() {
    const { _hiddenIndices: t } = this, n = this._getUniformDataChanges() || [];
    for (const { method: r, start: i, count: a } of n) {
      const s = r === "_removeElements" ? -a : a;
      cre(t, i, s);
    }
  }
  _getUniformDataChanges() {
    const t = this._dataChanges;
    if (!t || !t.length)
      return;
    this._dataChanges = [];
    const n = this.data.datasets.length, r = (a) => new Set(
      t.filter((s) => s[0] === a).map((s, o) => o + "," + s.splice(1).join(","))
    ), i = r(0);
    for (let a = 1; a < n; a++)
      if (!vC(i, r(a)))
        return;
    return Array.from(i).map((a) => a.split(",")).map((a) => ({ method: a[1], start: +a[2], count: +a[3] }));
  }
  _updateLayout(t) {
    if (this.notifyPlugins("beforeLayout", { cancelable: !0 }) === !1)
      return;
    Nr.update(this, this.width, this.height, t);
    const n = this.chartArea, r = n.width <= 0 || n.height <= 0;
    this._layers = [], Yt(this.boxes, (i) => {
      r && i.position === "chartArea" || (i.configure && i.configure(), this._layers.push(...i._layers()));
    }, this), this._layers.forEach((i, a) => {
      i._idx = a;
    }), this.notifyPlugins("afterLayout");
  }
  _updateDatasets(t) {
    if (this.notifyPlugins("beforeDatasetsUpdate", { mode: t, cancelable: !0 }) !== !1) {
      for (let n = 0, r = this.data.datasets.length; n < r; ++n)
        this.getDatasetMeta(n).controller.configure();
      for (let n = 0, r = this.data.datasets.length; n < r; ++n)
        this._updateDataset(n, Qs(t) ? t({ datasetIndex: n }) : t);
      this.notifyPlugins("afterDatasetsUpdate", { mode: t });
    }
  }
  _updateDataset(t, n) {
    const r = this.getDatasetMeta(t), i = { meta: r, index: t, mode: n, cancelable: !0 };
    this.notifyPlugins("beforeDatasetUpdate", i) !== !1 && (r.controller._update(n), i.cancelable = !1, this.notifyPlugins("afterDatasetUpdate", i));
  }
  render() {
    this.notifyPlugins("beforeRender", { cancelable: !0 }) !== !1 && (Xa.has(this) ? this.attached && !Xa.running(this) && Xa.start(this) : (this.draw(), oT({ chart: this })));
  }
  draw() {
    let t;
    if (this._resizeBeforeDraw) {
      const { width: r, height: i } = this._resizeBeforeDraw;
      this._resize(r, i), this._resizeBeforeDraw = null;
    }
    if (this.clear(), this.width <= 0 || this.height <= 0 || this.notifyPlugins("beforeDraw", { cancelable: !0 }) === !1)
      return;
    const n = this._layers;
    for (t = 0; t < n.length && n[t].z <= 0; ++t)
      n[t].draw(this.chartArea);
    for (this._drawDatasets(); t < n.length; ++t)
      n[t].draw(this.chartArea);
    this.notifyPlugins("afterDraw");
  }
  _getSortedDatasetMetas(t) {
    const n = this._sortedMetasets, r = [];
    let i, a;
    for (i = 0, a = n.length; i < a; ++i) {
      const s = n[i];
      (!t || s.visible) && r.push(s);
    }
    return r;
  }
  getSortedVisibleDatasetMetas() {
    return this._getSortedDatasetMetas(!0);
  }
  _drawDatasets() {
    if (this.notifyPlugins("beforeDatasetsDraw", { cancelable: !0 }) === !1)
      return;
    const t = this.getSortedVisibleDatasetMetas();
    for (let n = t.length - 1; n >= 0; --n)
      this._drawDataset(t[n]);
    this.notifyPlugins("afterDatasetsDraw");
  }
  _drawDataset(t) {
    const n = this.ctx, r = t._clip, i = !r.disabled, a = this.chartArea, s = {
      meta: t,
      index: t.index,
      cancelable: !0
    };
    this.notifyPlugins("beforeDatasetDraw", s) !== !1 && (i && dd(n, {
      left: r.left === !1 ? 0 : a.left - r.left,
      right: r.right === !1 ? this.width : a.right + r.right,
      top: r.top === !1 ? 0 : a.top - r.top,
      bottom: r.bottom === !1 ? this.height : a.bottom + r.bottom
    }), t.controller.draw(), i && fd(n), s.cancelable = !1, this.notifyPlugins("afterDatasetDraw", s));
  }
  isPointInArea(t) {
    return zc(t, this.chartArea, this._minPadding);
  }
  getElementsAtEventForMode(t, n, r, i) {
    const a = Tne.modes[n];
    return typeof a == "function" ? a(this, t, r, i) : [];
  }
  getDatasetMeta(t) {
    const n = this.data.datasets[t], r = this._metasets;
    let i = r.filter((a) => a && a._dataset === n).pop();
    return i || (i = {
      type: null,
      data: [],
      dataset: null,
      controller: null,
      hidden: null,
      xAxisID: null,
      yAxisID: null,
      order: n && n.order || 0,
      index: t,
      _dataset: n,
      _parsed: [],
      _sorted: !1
    }, r.push(i)), i;
  }
  getContext() {
    return this.$context || (this.$context = oo(null, { chart: this, type: "chart" }));
  }
  getVisibleDatasetCount() {
    return this.getSortedVisibleDatasetMetas().length;
  }
  isDatasetVisible(t) {
    const n = this.data.datasets[t];
    if (!n)
      return !1;
    const r = this.getDatasetMeta(t);
    return typeof r.hidden == "boolean" ? !r.hidden : !n.hidden;
  }
  setDatasetVisibility(t, n) {
    const r = this.getDatasetMeta(t);
    r.hidden = !n;
  }
  toggleDataVisibility(t) {
    this._hiddenIndices[t] = !this._hiddenIndices[t];
  }
  getDataVisibility(t) {
    return !this._hiddenIndices[t];
  }
  _updateVisibility(t, n, r) {
    const i = r ? "show" : "hide", a = this.getDatasetMeta(t), s = a.controller._resolveAnimations(void 0, i);
    zn(n) ? (a.data[n].hidden = !r, this.update()) : (this.setDatasetVisibility(t, r), s.update(a, { visible: r }), this.update((o) => o.datasetIndex === t ? i : void 0));
  }
  hide(t, n) {
    this._updateVisibility(t, n, !1);
  }
  show(t, n) {
    this._updateVisibility(t, n, !0);
  }
  _destroyDatasetMeta(t) {
    const n = this._metasets[t];
    n && n.controller && n.controller._destroy(), delete this._metasets[t];
  }
  _stop() {
    let t, n;
    for (this.stop(), Xa.remove(this), t = 0, n = this.data.datasets.length; t < n; ++t)
      this._destroyDatasetMeta(t);
  }
  destroy() {
    this.notifyPlugins("beforeDestroy");
    const { canvas: t, ctx: n } = this;
    this._stop(), this.config.clearCache(), t && (this.unbindEvents(), EC(t, n), this.platform.releaseContext(n), this.canvas = null, this.ctx = null), this.notifyPlugins("destroy"), delete Gh[this.id], this.notifyPlugins("afterDestroy");
  }
  toBase64Image(...t) {
    return this.canvas.toDataURL(...t);
  }
  bindEvents() {
    this.bindUserEvents(), this.options.responsive ? this.bindResponsiveEvents() : this.attached = !0;
  }
  bindUserEvents() {
    const t = this._listeners, n = this.platform, r = (a, s) => {
      n.addEventListener(this, a, s), t[a] = s;
    }, i = (a, s, o) => {
      a.offsetX = s, a.offsetY = o, this._eventHandler(a);
    };
    Yt(this.options.events, (a) => r(a, i));
  }
  bindResponsiveEvents() {
    this._responsiveListeners || (this._responsiveListeners = {});
    const t = this._responsiveListeners, n = this.platform, r = (l, c) => {
      n.addEventListener(this, l, c), t[l] = c;
    }, i = (l, c) => {
      t[l] && (n.removeEventListener(this, l, c), delete t[l]);
    }, a = (l, c) => {
      this.canvas && this.resize(l, c);
    };
    let s;
    const o = () => {
      i("attach", o), this.attached = !0, this.resize(), r("resize", a), r("detach", s);
    };
    s = () => {
      this.attached = !1, i("resize", a), this._stop(), this._resize(0, 0), r("attach", o);
    }, n.isAttached(this.canvas) ? o() : s();
  }
  unbindEvents() {
    Yt(this._listeners, (t, n) => {
      this.platform.removeEventListener(this, n, t);
    }), this._listeners = {}, Yt(this._responsiveListeners, (t, n) => {
      this.platform.removeEventListener(this, n, t);
    }), this._responsiveListeners = void 0;
  }
  updateHoverStyle(t, n, r) {
    const i = r ? "set" : "remove";
    let a, s, o, l;
    for (n === "dataset" && (a = this.getDatasetMeta(t[0].datasetIndex), a.controller["_" + i + "DatasetHoverStyle"]()), o = 0, l = t.length; o < l; ++o) {
      s = t[o];
      const c = s && this.getDatasetMeta(s.datasetIndex).controller;
      c && c[i + "HoverStyle"](s.element, s.datasetIndex, s.index);
    }
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t) {
    const n = this._active || [], r = t.map(({ datasetIndex: a, index: s }) => {
      const o = this.getDatasetMeta(a);
      if (!o)
        throw new Error("No dataset found at index " + a);
      return {
        datasetIndex: a,
        element: o.data[s],
        index: s
      };
    });
    !Vh(r, n) && (this._active = r, this._lastEvent = null, this._updateHoverStyles(r, n));
  }
  notifyPlugins(t, n, r) {
    return this._plugins.notify(this, t, n, r);
  }
  _updateHoverStyles(t, n, r) {
    const i = this.options.hover, a = (l, c) => l.filter((f) => !c.some((h) => f.datasetIndex === h.datasetIndex && f.index === h.index)), s = a(n, t), o = r ? t : a(t, n);
    s.length && this.updateHoverStyle(s, i.mode, !1), o.length && i.mode && this.updateHoverStyle(o, i.mode, !0);
  }
  _eventHandler(t, n) {
    const r = {
      event: t,
      replay: n,
      cancelable: !0,
      inChartArea: this.isPointInArea(t)
    }, i = (s) => (s.options.events || this.options.events).includes(t.native.type);
    if (this.notifyPlugins("beforeEvent", r, i) === !1)
      return;
    const a = this._handleEvent(t, n, r.inChartArea);
    return r.cancelable = !1, this.notifyPlugins("afterEvent", r, i), (a || r.changed) && this.render(), this;
  }
  _handleEvent(t, n, r) {
    const { _active: i = [], options: a } = this, s = n, o = this._getActiveElements(t, i, r, s), l = ree(t), c = dre(t, this._lastEvent, r, l);
    r && (this._lastEvent = null, Xt(a.onHover, [t, o, this], this), l && Xt(a.onClick, [t, o, this], this));
    const f = !Vh(o, i);
    return (f || n) && (this._active = o, this._updateHoverStyles(o, i, n)), this._lastEvent = c, f;
  }
  _getActiveElements(t, n, r, i) {
    if (t.type === "mouseout")
      return [];
    if (!r)
      return n;
    const a = this.options.hover;
    return this.getElementsAtEventForMode(t, a.mode, a, i);
  }
}
const lT = () => Yt(ls.instances, (e) => e._plugins.invalidate()), Ns = !0;
Object.defineProperties(ls, {
  defaults: {
    enumerable: Ns,
    value: Et
  },
  instances: {
    enumerable: Ns,
    value: Gh
  },
  overrides: {
    enumerable: Ns,
    value: Zo
  },
  registry: {
    enumerable: Ns,
    value: Ca
  },
  version: {
    enumerable: Ns,
    value: ore
  },
  getChart: {
    enumerable: Ns,
    value: dI
  },
  register: {
    enumerable: Ns,
    value: (...e) => {
      Ca.add(...e), lT();
    }
  },
  unregister: {
    enumerable: Ns,
    value: (...e) => {
      Ca.remove(...e), lT();
    }
  }
});
function fI(e, t, n) {
  const { startAngle: r, pixelMargin: i, x: a, y: s, outerRadius: o, innerRadius: l } = t;
  let c = i / o;
  e.beginPath(), e.arc(a, s, o, r - c, n + c), l > i ? (c = i / l, e.arc(a, s, l, n + c, r - c, !0)) : e.arc(a, s, i, n + Rn, r - Rn), e.closePath(), e.clip();
}
function fre(e) {
  return rx(e, ["outerStart", "outerEnd", "innerStart", "innerEnd"]);
}
function hre(e, t, n, r) {
  const i = fre(e.options.borderRadius), a = (n - t) / 2, s = Math.min(a, r * t / 2), o = (l) => {
    const c = (n - Math.min(a, l)) * r / 2;
    return vr(l, 0, Math.min(a, c));
  };
  return {
    outerStart: o(i.outerStart),
    outerEnd: o(i.outerEnd),
    innerStart: vr(i.innerStart, 0, s),
    innerEnd: vr(i.innerEnd, 0, s)
  };
}
function jl(e, t, n, r) {
  return {
    x: n + e * Math.cos(t),
    y: r + e * Math.sin(t)
  };
}
function Py(e, t, n, r, i, a) {
  const { x: s, y: o, startAngle: l, pixelMargin: c, innerRadius: f } = t, h = Math.max(t.outerRadius + r + n - c, 0), p = f > 0 ? f + r + n + c : 0;
  let g = 0;
  const v = i - l;
  if (r) {
    const J = f > 0 ? f - r : 0, oe = h > 0 ? h - r : 0, A = (J + oe) / 2, X = A !== 0 ? v * A / (A + r) : v;
    g = (v - X) / 2;
  }
  const y = Math.max(1e-3, v * h - n / Wt) / h, S = (v - y) / 2, x = l + S + g, E = i - S - g, { outerStart: w, outerEnd: C, innerStart: P, innerEnd: M } = hre(t, p, h, E - x), T = h - w, N = h - C, $ = x + w / T, ne = E - C / N, Y = p + P, te = p + M, _e = x + P / Y, Fe = E - M / te;
  if (e.beginPath(), a) {
    if (e.arc(s, o, h, $, ne), C > 0) {
      const A = jl(N, ne, s, o);
      e.arc(A.x, A.y, C, ne, E + Rn);
    }
    const J = jl(te, E, s, o);
    if (e.lineTo(J.x, J.y), M > 0) {
      const A = jl(te, Fe, s, o);
      e.arc(A.x, A.y, M, E + Rn, Fe + Math.PI);
    }
    if (e.arc(s, o, p, E - M / p, x + P / p, !0), P > 0) {
      const A = jl(Y, _e, s, o);
      e.arc(A.x, A.y, P, _e + Math.PI, x - Rn);
    }
    const oe = jl(T, x, s, o);
    if (e.lineTo(oe.x, oe.y), w > 0) {
      const A = jl(T, $, s, o);
      e.arc(A.x, A.y, w, x - Rn, $);
    }
  } else {
    e.moveTo(s, o);
    const J = Math.cos($) * h + s, oe = Math.sin($) * h + o;
    e.lineTo(J, oe);
    const A = Math.cos(ne) * h + s, X = Math.sin(ne) * h + o;
    e.lineTo(A, X);
  }
  e.closePath();
}
function pre(e, t, n, r, i) {
  const { fullCircles: a, startAngle: s, circumference: o } = t;
  let l = t.endAngle;
  if (a) {
    Py(e, t, n, r, s + tn, i);
    for (let c = 0; c < a; ++c)
      e.fill();
    isNaN(o) || (l = s + o % tn, o % tn === 0 && (l += tn));
  }
  return Py(e, t, n, r, l, i), e.fill(), l;
}
function mre(e, t, n) {
  const { x: r, y: i, startAngle: a, pixelMargin: s, fullCircles: o } = t, l = Math.max(t.outerRadius - s, 0), c = t.innerRadius + s;
  let f;
  for (n && fI(e, t, a + tn), e.beginPath(), e.arc(r, i, c, a + tn, a, !0), f = 0; f < o; ++f)
    e.stroke();
  for (e.beginPath(), e.arc(r, i, l, a, a + tn), f = 0; f < o; ++f)
    e.stroke();
}
function gre(e, t, n, r, i, a) {
  const { options: s } = t, { borderWidth: o, borderJoinStyle: l } = s, c = s.borderAlign === "inner";
  o && (c ? (e.lineWidth = o * 2, e.lineJoin = l || "round") : (e.lineWidth = o, e.lineJoin = l || "bevel"), t.fullCircles && mre(e, t, c), c && fI(e, t, i), Py(e, t, n, r, i, a), e.stroke());
}
class pd extends Ar {
  constructor(t) {
    super(), this.options = void 0, this.circumference = void 0, this.startAngle = void 0, this.endAngle = void 0, this.innerRadius = void 0, this.outerRadius = void 0, this.pixelMargin = 0, this.fullCircles = 0, t && Object.assign(this, t);
  }
  inRange(t, n, r) {
    const i = this.getProps(["x", "y"], r), { angle: a, distance: s } = AM(i, { x: t, y: n }), { startAngle: o, endAngle: l, innerRadius: c, outerRadius: f, circumference: h } = this.getProps([
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius",
      "circumference"
    ], r), p = this.options.spacing / 2, v = lt(h, l - o) >= tn || Wc(a, o, l), y = is(s, c + p, f + p);
    return v && y;
  }
  getCenterPoint(t) {
    const { x: n, y: r, startAngle: i, endAngle: a, innerRadius: s, outerRadius: o } = this.getProps([
      "x",
      "y",
      "startAngle",
      "endAngle",
      "innerRadius",
      "outerRadius",
      "circumference"
    ], t), { offset: l, spacing: c } = this.options, f = (i + a) / 2, h = (s + o + c + l) / 2;
    return {
      x: n + Math.cos(f) * h,
      y: r + Math.sin(f) * h
    };
  }
  tooltipPosition(t) {
    return this.getCenterPoint(t);
  }
  draw(t) {
    const { options: n, circumference: r } = this, i = (n.offset || 0) / 2, a = (n.spacing || 0) / 2, s = n.circular;
    if (this.pixelMargin = n.borderAlign === "inner" ? 0.33 : 0, this.fullCircles = r > tn ? Math.floor(r / tn) : 0, r === 0 || this.innerRadius < 0 || this.outerRadius < 0)
      return;
    t.save();
    let o = 0;
    if (i) {
      o = i / 2;
      const c = (this.startAngle + this.endAngle) / 2;
      t.translate(Math.cos(c) * o, Math.sin(c) * o), this.circumference >= Wt && (o = i);
    }
    t.fillStyle = n.backgroundColor, t.strokeStyle = n.borderColor;
    const l = pre(t, this, o, a, s);
    gre(t, this, o, a, l, s), t.restore();
  }
}
pd.id = "arc";
pd.defaults = {
  borderAlign: "center",
  borderColor: "#fff",
  borderJoinStyle: void 0,
  borderRadius: 0,
  borderWidth: 2,
  offset: 0,
  spacing: 0,
  angle: void 0,
  circular: !0
};
pd.defaultRoutes = {
  backgroundColor: "backgroundColor"
};
function hI(e, t, n = t) {
  e.lineCap = lt(n.borderCapStyle, t.borderCapStyle), e.setLineDash(lt(n.borderDash, t.borderDash)), e.lineDashOffset = lt(n.borderDashOffset, t.borderDashOffset), e.lineJoin = lt(n.borderJoinStyle, t.borderJoinStyle), e.lineWidth = lt(n.borderWidth, t.borderWidth), e.strokeStyle = lt(n.borderColor, t.borderColor);
}
function vre(e, t, n) {
  e.lineTo(n.x, n.y);
}
function bre(e) {
  return e.stepped ? Vee : e.tension || e.cubicInterpolationMode === "monotone" ? Bee : vre;
}
function pI(e, t, n = {}) {
  const r = e.length, { start: i = 0, end: a = r - 1 } = n, { start: s, end: o } = t, l = Math.max(i, s), c = Math.min(a, o), f = i < s && a < s || i > o && a > o;
  return {
    count: r,
    start: l,
    loop: t.loop,
    ilen: c < l && !f ? r + c - l : c - l
  };
}
function _re(e, t, n, r) {
  const { points: i, options: a } = t, { count: s, start: o, loop: l, ilen: c } = pI(i, n, r), f = bre(a);
  let { move: h = !0, reverse: p } = r || {}, g, v, y;
  for (g = 0; g <= c; ++g)
    v = i[(o + (p ? c - g : g)) % s], !v.skip && (h ? (e.moveTo(v.x, v.y), h = !1) : f(e, y, v, p, a.stepped), y = v);
  return l && (v = i[(o + (p ? c : 0)) % s], f(e, y, v, p, a.stepped)), !!l;
}
function yre(e, t, n, r) {
  const i = t.points, { count: a, start: s, ilen: o } = pI(i, n, r), { move: l = !0, reverse: c } = r || {};
  let f = 0, h = 0, p, g, v, y, S, x;
  const E = (C) => (s + (c ? o - C : C)) % a, w = () => {
    y !== S && (e.lineTo(f, S), e.lineTo(f, y), e.lineTo(f, x));
  };
  for (l && (g = i[E(0)], e.moveTo(g.x, g.y)), p = 0; p <= o; ++p) {
    if (g = i[E(p)], g.skip)
      continue;
    const C = g.x, P = g.y, M = C | 0;
    M === v ? (P < y ? y = P : P > S && (S = P), f = (h * f + C) / ++h) : (w(), e.lineTo(C, P), v = M, h = 0, y = S = P), x = P;
  }
  w();
}
function Oy(e) {
  const t = e.options, n = t.borderDash && t.borderDash.length;
  return !e._decimated && !e._loop && !t.tension && t.cubicInterpolationMode !== "monotone" && !t.stepped && !n ? yre : _re;
}
function xre(e) {
  return e.stepped ? vte : e.tension || e.cubicInterpolationMode === "monotone" ? bte : Ro;
}
function wre(e, t, n, r) {
  let i = t._path;
  i || (i = t._path = new Path2D(), t.path(i, n, r) && i.closePath()), hI(e, t.options), e.stroke(i);
}
function kre(e, t, n, r) {
  const { segments: i, options: a } = t, s = Oy(t);
  for (const o of i)
    hI(e, a, o.style), e.beginPath(), s(e, t, o, { start: n, end: n + r - 1 }) && e.closePath(), e.stroke();
}
const Sre = typeof Path2D == "function";
function Cre(e, t, n, r) {
  Sre && !t.options.segment ? wre(e, t, n, r) : kre(e, t, n, r);
}
class lo extends Ar {
  constructor(t) {
    super(), this.animated = !0, this.options = void 0, this._chart = void 0, this._loop = void 0, this._fullLoop = void 0, this._path = void 0, this._points = void 0, this._segments = void 0, this._decimated = !1, this._pointsUpdated = !1, this._datasetIndex = void 0, t && Object.assign(this, t);
  }
  updateControlPoints(t, n) {
    const r = this.options;
    if ((r.tension || r.cubicInterpolationMode === "monotone") && !r.stepped && !this._pointsUpdated) {
      const i = r.spanGaps ? this._loop : this._fullLoop;
      ute(this._points, r, t, i, n), this._pointsUpdated = !0;
    }
  }
  set points(t) {
    this._points = t, delete this._segments, delete this._path, this._pointsUpdated = !1;
  }
  get points() {
    return this._points;
  }
  get segments() {
    return this._segments || (this._segments = Cte(this, this.options.segment));
  }
  first() {
    const t = this.segments, n = this.points;
    return t.length && n[t[0].start];
  }
  last() {
    const t = this.segments, n = this.points, r = t.length;
    return r && n[t[r - 1].end];
  }
  interpolate(t, n) {
    const r = this.options, i = t[n], a = this.points, s = QM(this, { property: n, start: i, end: i });
    if (!s.length)
      return;
    const o = [], l = xre(r);
    let c, f;
    for (c = 0, f = s.length; c < f; ++c) {
      const { start: h, end: p } = s[c], g = a[h], v = a[p];
      if (g === v) {
        o.push(g);
        continue;
      }
      const y = Math.abs((i - g[n]) / (v[n] - g[n])), S = l(g, v, y, r.stepped);
      S[n] = t[n], o.push(S);
    }
    return o.length === 1 ? o[0] : o;
  }
  pathSegment(t, n, r) {
    return Oy(this)(t, this, n, r);
  }
  path(t, n, r) {
    const i = this.segments, a = Oy(this);
    let s = this._loop;
    n = n || 0, r = r || this.points.length - n;
    for (const o of i)
      s &= a(t, this, o, { start: n, end: n + r - 1 });
    return !!s;
  }
  draw(t, n, r, i) {
    const a = this.options || {};
    (this.points || []).length && a.borderWidth && (t.save(), Cre(t, this, r, i), t.restore()), this.animated && (this._pointsUpdated = !1, this._path = void 0);
  }
}
lo.id = "line";
lo.defaults = {
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderWidth: 3,
  capBezierPoints: !0,
  cubicInterpolationMode: "default",
  fill: !1,
  spanGaps: !1,
  stepped: !1,
  tension: 0
};
lo.defaultRoutes = {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
};
lo.descriptors = {
  _scriptable: !0,
  _indexable: (e) => e !== "borderDash" && e !== "fill"
};
function uT(e, t, n, r) {
  const i = e.options, { [n]: a } = e.getProps([n], r);
  return Math.abs(t - a) < i.radius + i.hitRadius;
}
class md extends Ar {
  constructor(t) {
    super(), this.options = void 0, this.parsed = void 0, this.skip = void 0, this.stop = void 0, t && Object.assign(this, t);
  }
  inRange(t, n, r) {
    const i = this.options, { x: a, y: s } = this.getProps(["x", "y"], r);
    return Math.pow(t - a, 2) + Math.pow(n - s, 2) < Math.pow(i.hitRadius + i.radius, 2);
  }
  inXRange(t, n) {
    return uT(this, t, "x", n);
  }
  inYRange(t, n) {
    return uT(this, t, "y", n);
  }
  getCenterPoint(t) {
    const { x: n, y: r } = this.getProps(["x", "y"], t);
    return { x: n, y: r };
  }
  size(t) {
    t = t || this.options || {};
    let n = t.radius || 0;
    n = Math.max(n, n && t.hoverRadius || 0);
    const r = n && t.borderWidth || 0;
    return (n + r) * 2;
  }
  draw(t, n) {
    const r = this.options;
    this.skip || r.radius < 0.1 || !zc(this, n, this.size(r) / 2) || (t.strokeStyle = r.borderColor, t.lineWidth = r.borderWidth, t.fillStyle = r.backgroundColor, Wh(t, r, this.x, this.y));
  }
  getRange() {
    const t = this.options || {};
    return t.radius + t.hitRadius;
  }
}
md.id = "point";
md.defaults = {
  borderWidth: 1,
  hitRadius: 1,
  hoverBorderWidth: 1,
  hoverRadius: 4,
  pointStyle: "circle",
  radius: 3,
  rotation: 0
};
md.defaultRoutes = {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
};
function mI(e, t) {
  const { x: n, y: r, base: i, width: a, height: s } = e.getProps(["x", "y", "base", "width", "height"], t);
  let o, l, c, f, h;
  return e.horizontal ? (h = s / 2, o = Math.min(n, i), l = Math.max(n, i), c = r - h, f = r + h) : (h = a / 2, o = n - h, l = n + h, c = Math.min(r, i), f = Math.max(r, i)), { left: o, top: c, right: l, bottom: f };
}
function qs(e, t, n, r) {
  return e ? 0 : vr(t, n, r);
}
function Tre(e, t, n) {
  const r = e.options.borderWidth, i = e.borderSkipped, a = BM(r);
  return {
    t: qs(i.top, a.top, 0, n),
    r: qs(i.right, a.right, 0, t),
    b: qs(i.bottom, a.bottom, 0, n),
    l: qs(i.left, a.left, 0, t)
  };
}
function Are(e, t, n) {
  const { enableBorderRadius: r } = e.getProps(["enableBorderRadius"]), i = e.options.borderRadius, a = Gs(i), s = Math.min(t, n), o = e.borderSkipped, l = r || _t(i);
  return {
    topLeft: qs(!l || o.top || o.left, a.topLeft, 0, s),
    topRight: qs(!l || o.top || o.right, a.topRight, 0, s),
    bottomLeft: qs(!l || o.bottom || o.left, a.bottomLeft, 0, s),
    bottomRight: qs(!l || o.bottom || o.right, a.bottomRight, 0, s)
  };
}
function Dre(e) {
  const t = mI(e), n = t.right - t.left, r = t.bottom - t.top, i = Tre(e, n / 2, r / 2), a = Are(e, n / 2, r / 2);
  return {
    outer: {
      x: t.left,
      y: t.top,
      w: n,
      h: r,
      radius: a
    },
    inner: {
      x: t.left + i.l,
      y: t.top + i.t,
      w: n - i.l - i.r,
      h: r - i.t - i.b,
      radius: {
        topLeft: Math.max(0, a.topLeft - Math.max(i.t, i.l)),
        topRight: Math.max(0, a.topRight - Math.max(i.t, i.r)),
        bottomLeft: Math.max(0, a.bottomLeft - Math.max(i.b, i.l)),
        bottomRight: Math.max(0, a.bottomRight - Math.max(i.b, i.r))
      }
    }
  };
}
function rv(e, t, n, r) {
  const i = t === null, a = n === null, o = e && !(i && a) && mI(e, r);
  return o && (i || is(t, o.left, o.right)) && (a || is(n, o.top, o.bottom));
}
function Ere(e) {
  return e.topLeft || e.topRight || e.bottomLeft || e.bottomRight;
}
function Pre(e, t) {
  e.rect(t.x, t.y, t.w, t.h);
}
function iv(e, t, n = {}) {
  const r = e.x !== n.x ? -t : 0, i = e.y !== n.y ? -t : 0, a = (e.x + e.w !== n.x + n.w ? t : 0) - r, s = (e.y + e.h !== n.y + n.h ? t : 0) - i;
  return {
    x: e.x + r,
    y: e.y + i,
    w: e.w + a,
    h: e.h + s,
    radius: e.radius
  };
}
class gd extends Ar {
  constructor(t) {
    super(), this.options = void 0, this.horizontal = void 0, this.base = void 0, this.width = void 0, this.height = void 0, this.inflateAmount = void 0, t && Object.assign(this, t);
  }
  draw(t) {
    const { inflateAmount: n, options: { borderColor: r, backgroundColor: i } } = this, { inner: a, outer: s } = Dre(this), o = Ere(s.radius) ? ru : Pre;
    t.save(), (s.w !== a.w || s.h !== a.h) && (t.beginPath(), o(t, iv(s, n, a)), t.clip(), o(t, iv(a, -n, s)), t.fillStyle = r, t.fill("evenodd")), t.beginPath(), o(t, iv(a, n)), t.fillStyle = i, t.fill(), t.restore();
  }
  inRange(t, n, r) {
    return rv(this, t, n, r);
  }
  inXRange(t, n) {
    return rv(this, t, null, n);
  }
  inYRange(t, n) {
    return rv(this, null, t, n);
  }
  getCenterPoint(t) {
    const { x: n, y: r, base: i, horizontal: a } = this.getProps(["x", "y", "base", "horizontal"], t);
    return {
      x: a ? (n + i) / 2 : n,
      y: a ? r : (r + i) / 2
    };
  }
  getRange(t) {
    return t === "x" ? this.width / 2 : this.height / 2;
  }
}
gd.id = "bar";
gd.defaults = {
  borderSkipped: "start",
  borderWidth: 0,
  borderRadius: 0,
  inflateAmount: "auto",
  pointStyle: void 0
};
gd.defaultRoutes = {
  backgroundColor: "backgroundColor",
  borderColor: "borderColor"
};
var Ore = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ArcElement: pd,
  LineElement: lo,
  PointElement: md,
  BarElement: gd
});
function Mre(e, t, n, r, i) {
  const a = i.samples || r;
  if (a >= n)
    return e.slice(t, t + n);
  const s = [], o = (n - 2) / (a - 2);
  let l = 0;
  const c = t + n - 1;
  let f = t, h, p, g, v, y;
  for (s[l++] = e[f], h = 0; h < a - 2; h++) {
    let S = 0, x = 0, E;
    const w = Math.floor((h + 1) * o) + 1 + t, C = Math.min(Math.floor((h + 2) * o) + 1, n) + t, P = C - w;
    for (E = w; E < C; E++)
      S += e[E].x, x += e[E].y;
    S /= P, x /= P;
    const M = Math.floor(h * o) + 1 + t, T = Math.min(Math.floor((h + 1) * o) + 1, n) + t, { x: N, y: $ } = e[f];
    for (g = v = -1, E = M; E < T; E++)
      v = 0.5 * Math.abs(
        (N - S) * (e[E].y - $) - (N - e[E].x) * (x - $)
      ), v > g && (g = v, p = e[E], y = E);
    s[l++] = p, f = y;
  }
  return s[l++] = e[c], s;
}
function Ire(e, t, n, r) {
  let i = 0, a = 0, s, o, l, c, f, h, p, g, v, y;
  const S = [], x = t + n - 1, E = e[t].x, C = e[x].x - E;
  for (s = t; s < t + n; ++s) {
    o = e[s], l = (o.x - E) / C * r, c = o.y;
    const P = l | 0;
    if (P === f)
      c < v ? (v = c, h = s) : c > y && (y = c, p = s), i = (a * i + o.x) / ++a;
    else {
      const M = s - 1;
      if (!Tt(h) && !Tt(p)) {
        const T = Math.min(h, p), N = Math.max(h, p);
        T !== g && T !== M && S.push({
          ...e[T],
          x: i
        }), N !== g && N !== M && S.push({
          ...e[N],
          x: i
        });
      }
      s > 0 && M !== g && S.push(e[M]), S.push(o), f = P, a = 0, v = y = c, h = p = g = s;
    }
  }
  return S;
}
function gI(e) {
  if (e._decimated) {
    const t = e._data;
    delete e._decimated, delete e._data, Object.defineProperty(e, "data", { value: t });
  }
}
function cT(e) {
  e.data.datasets.forEach((t) => {
    gI(t);
  });
}
function Rre(e, t) {
  const n = t.length;
  let r = 0, i;
  const { iScale: a } = e, { min: s, max: o, minDefined: l, maxDefined: c } = a.getUserBounds();
  return l && (r = vr(as(t, a.axis, s).lo, 0, n - 1)), c ? i = vr(as(t, a.axis, o).hi + 1, r, n) - r : i = n - r, { start: r, count: i };
}
var Fre = {
  id: "decimation",
  defaults: {
    algorithm: "min-max",
    enabled: !1
  },
  beforeElementsUpdate: (e, t, n) => {
    if (!n.enabled) {
      cT(e);
      return;
    }
    const r = e.width;
    e.data.datasets.forEach((i, a) => {
      const { _data: s, indexAxis: o } = i, l = e.getDatasetMeta(a), c = s || i.data;
      if (hn([o, e.options.indexAxis]) === "y" || !l.controller.supportsDecimation)
        return;
      const f = e.scales[l.xAxisID];
      if (f.type !== "linear" && f.type !== "time" || e.options.parsing)
        return;
      let { start: h, count: p } = Rre(l, c);
      const g = n.threshold || 4 * r;
      if (p <= g) {
        gI(i);
        return;
      }
      Tt(s) && (i._data = c, delete i.data, Object.defineProperty(i, "data", {
        configurable: !0,
        enumerable: !0,
        get: function() {
          return this._decimated;
        },
        set: function(y) {
          this._data = y;
        }
      }));
      let v;
      switch (n.algorithm) {
        case "lttb":
          v = Mre(c, h, p, r, n);
          break;
        case "min-max":
          v = Ire(c, h, p, r);
          break;
        default:
          throw new Error(`Unsupported decimation algorithm '${n.algorithm}'`);
      }
      i._decimated = v;
    });
  },
  destroy(e) {
    cT(e);
  }
};
function Nre(e, t, n) {
  const r = e.segments, i = e.points, a = t.points, s = [];
  for (const o of r) {
    let { start: l, end: c } = o;
    c = cx(l, c, i);
    const f = My(n, i[l], i[c], o.loop);
    if (!t.segments) {
      s.push({
        source: o,
        target: f,
        start: i[l],
        end: i[c]
      });
      continue;
    }
    const h = QM(t, f);
    for (const p of h) {
      const g = My(n, a[p.start], a[p.end], p.loop), v = ZM(o, i, g);
      for (const y of v)
        s.push({
          source: y,
          target: p,
          start: {
            [n]: dT(f, g, "start", Math.max)
          },
          end: {
            [n]: dT(f, g, "end", Math.min)
          }
        });
    }
  }
  return s;
}
function My(e, t, n, r) {
  if (r)
    return;
  let i = t[e], a = n[e];
  return e === "angle" && (i = _i(i), a = _i(a)), { property: e, start: i, end: a };
}
function Lre(e, t) {
  const { x: n = null, y: r = null } = e || {}, i = t.points, a = [];
  return t.segments.forEach(({ start: s, end: o }) => {
    o = cx(s, o, i);
    const l = i[s], c = i[o];
    r !== null ? (a.push({ x: l.x, y: r }), a.push({ x: c.x, y: r })) : n !== null && (a.push({ x: n, y: l.y }), a.push({ x: n, y: c.y }));
  }), a;
}
function cx(e, t, n) {
  for (; t > e; t--) {
    const r = n[t];
    if (!isNaN(r.x) && !isNaN(r.y))
      break;
  }
  return t;
}
function dT(e, t, n, r) {
  return e && t ? r(e[n], t[n]) : e ? e[n] : t ? t[n] : 0;
}
function vI(e, t) {
  let n = [], r = !1;
  return Zt(e) ? (r = !0, n = e) : n = Lre(e, t), n.length ? new lo({
    points: n,
    options: { tension: 0 },
    _loop: r,
    _fullLoop: r
  }) : null;
}
function fT(e) {
  return e && e.fill !== !1;
}
function $re(e, t, n) {
  let i = e[t].fill;
  const a = [t];
  let s;
  if (!n)
    return i;
  for (; i !== !1 && a.indexOf(i) === -1; ) {
    if (!Pn(i))
      return i;
    if (s = e[i], !s)
      return !1;
    if (s.visible)
      return i;
    a.push(i), i = s.fill;
  }
  return !1;
}
function Vre(e, t, n) {
  const r = jre(e);
  if (_t(r))
    return isNaN(r.value) ? !1 : r;
  let i = parseFloat(r);
  return Pn(i) && Math.floor(i) === i ? Bre(r[0], t, i, n) : ["origin", "start", "end", "stack", "shape"].indexOf(r) >= 0 && r;
}
function Bre(e, t, n, r) {
  return (e === "-" || e === "+") && (n = t + n), n === t || n < 0 || n >= r ? !1 : n;
}
function Ure(e, t) {
  let n = null;
  return e === "start" ? n = t.bottom : e === "end" ? n = t.top : _t(e) ? n = t.getPixelForValue(e.value) : t.getBasePixel && (n = t.getBasePixel()), n;
}
function qre(e, t, n) {
  let r;
  return e === "start" ? r = n : e === "end" ? r = t.options.reverse ? t.min : t.max : _t(e) ? r = e.value : r = t.getBaseValue(), r;
}
function jre(e) {
  const t = e.options, n = t.fill;
  let r = lt(n && n.target, n);
  return r === void 0 && (r = !!t.backgroundColor), r === !1 || r === null ? !1 : r === !0 ? "origin" : r;
}
function Wre(e) {
  const { scale: t, index: n, line: r } = e, i = [], a = r.segments, s = r.points, o = zre(t, n);
  o.push(vI({ x: null, y: t.bottom }, r));
  for (let l = 0; l < a.length; l++) {
    const c = a[l];
    for (let f = c.start; f <= c.end; f++)
      Hre(i, s[f], o);
  }
  return new lo({ points: i, options: {} });
}
function zre(e, t) {
  const n = [], r = e.getMatchingVisibleMetas("line");
  for (let i = 0; i < r.length; i++) {
    const a = r[i];
    if (a.index === t)
      break;
    a.hidden || n.unshift(a.dataset);
  }
  return n;
}
function Hre(e, t, n) {
  const r = [];
  for (let i = 0; i < n.length; i++) {
    const a = n[i], { first: s, last: o, point: l } = Gre(a, t, "x");
    if (!(!l || s && o)) {
      if (s)
        r.unshift(l);
      else if (e.push(l), !o)
        break;
    }
  }
  e.push(...r);
}
function Gre(e, t, n) {
  const r = e.interpolate(t, n);
  if (!r)
    return {};
  const i = r[n], a = e.segments, s = e.points;
  let o = !1, l = !1;
  for (let c = 0; c < a.length; c++) {
    const f = a[c], h = s[f.start][n], p = s[f.end][n];
    if (is(i, h, p)) {
      o = i === h, l = i === p;
      break;
    }
  }
  return { first: o, last: l, point: r };
}
class bI {
  constructor(t) {
    this.x = t.x, this.y = t.y, this.radius = t.radius;
  }
  pathSegment(t, n, r) {
    const { x: i, y: a, radius: s } = this;
    return n = n || { start: 0, end: tn }, t.arc(i, a, s, n.end, n.start, !0), !r.bounds;
  }
  interpolate(t) {
    const { x: n, y: r, radius: i } = this, a = t.angle;
    return {
      x: n + Math.cos(a) * i,
      y: r + Math.sin(a) * i,
      angle: a
    };
  }
}
function Yre(e) {
  const { chart: t, fill: n, line: r } = e;
  if (Pn(n))
    return Kre(t, n);
  if (n === "stack")
    return Wre(e);
  if (n === "shape")
    return !0;
  const i = Xre(e);
  return i instanceof bI ? i : vI(i, r);
}
function Kre(e, t) {
  const n = e.getDatasetMeta(t);
  return n && e.isDatasetVisible(t) ? n.dataset : null;
}
function Xre(e) {
  return (e.scale || {}).getPointPositionForValue ? Qre(e) : Zre(e);
}
function Zre(e) {
  const { scale: t = {}, fill: n } = e, r = Ure(n, t);
  if (Pn(r)) {
    const i = t.isHorizontal();
    return {
      x: i ? r : null,
      y: i ? null : r
    };
  }
  return null;
}
function Qre(e) {
  const { scale: t, fill: n } = e, r = t.options, i = t.getLabels().length, a = r.reverse ? t.max : t.min, s = qre(n, t, a), o = [];
  if (r.grid.circular) {
    const l = t.getPointPositionForValue(0, a);
    return new bI({
      x: l.x,
      y: l.y,
      radius: t.getDistanceFromCenterForValue(s)
    });
  }
  for (let l = 0; l < i; ++l)
    o.push(t.getPointPositionForValue(l, s));
  return o;
}
function av(e, t, n) {
  const r = Yre(t), { line: i, scale: a, axis: s } = t, o = i.options, l = o.fill, c = o.backgroundColor, { above: f = c, below: h = c } = l || {};
  r && i.points.length && (dd(e, n), Jre(e, { line: i, target: r, above: f, below: h, area: n, scale: a, axis: s }), fd(e));
}
function Jre(e, t) {
  const { line: n, target: r, above: i, below: a, area: s, scale: o } = t, l = n._loop ? "angle" : t.axis;
  e.save(), l === "x" && a !== i && (hT(e, r, s.top), pT(e, { line: n, target: r, color: i, scale: o, property: l }), e.restore(), e.save(), hT(e, r, s.bottom)), pT(e, { line: n, target: r, color: a, scale: o, property: l }), e.restore();
}
function hT(e, t, n) {
  const { segments: r, points: i } = t;
  let a = !0, s = !1;
  e.beginPath();
  for (const o of r) {
    const { start: l, end: c } = o, f = i[l], h = i[cx(l, c, i)];
    a ? (e.moveTo(f.x, f.y), a = !1) : (e.lineTo(f.x, n), e.lineTo(f.x, f.y)), s = !!t.pathSegment(e, o, { move: s }), s ? e.closePath() : e.lineTo(h.x, n);
  }
  e.lineTo(t.first().x, n), e.closePath(), e.clip();
}
function pT(e, t) {
  const { line: n, target: r, property: i, color: a, scale: s } = t, o = Nre(n, r, i);
  for (const { source: l, target: c, start: f, end: h } of o) {
    const { style: { backgroundColor: p = a } = {} } = l, g = r !== !0;
    e.save(), e.fillStyle = p, eie(e, s, g && My(i, f, h)), e.beginPath();
    const v = !!n.pathSegment(e, l);
    let y;
    if (g) {
      v ? e.closePath() : mT(e, r, h, i);
      const S = !!r.pathSegment(e, c, { move: v, reverse: !0 });
      y = v && S, y || mT(e, r, f, i);
    }
    e.closePath(), e.fill(y ? "evenodd" : "nonzero"), e.restore();
  }
}
function eie(e, t, n) {
  const { top: r, bottom: i } = t.chart.chartArea, { property: a, start: s, end: o } = n || {};
  a === "x" && (e.beginPath(), e.rect(s, r, o - s, i - r), e.clip());
}
function mT(e, t, n, r) {
  const i = t.interpolate(n, r);
  i && e.lineTo(i.x, i.y);
}
var tie = {
  id: "filler",
  afterDatasetsUpdate(e, t, n) {
    const r = (e.data.datasets || []).length, i = [];
    let a, s, o, l;
    for (s = 0; s < r; ++s)
      a = e.getDatasetMeta(s), o = a.dataset, l = null, o && o.options && o instanceof lo && (l = {
        visible: e.isDatasetVisible(s),
        index: s,
        fill: Vre(o, s, r),
        chart: e,
        axis: a.controller.options.indexAxis,
        scale: a.vScale,
        line: o
      }), a.$filler = l, i.push(l);
    for (s = 0; s < r; ++s)
      l = i[s], !(!l || l.fill === !1) && (l.fill = $re(i, s, n.propagate));
  },
  beforeDraw(e, t, n) {
    const r = n.drawTime === "beforeDraw", i = e.getSortedVisibleDatasetMetas(), a = e.chartArea;
    for (let s = i.length - 1; s >= 0; --s) {
      const o = i[s].$filler;
      o && (o.line.updateControlPoints(a, o.axis), r && o.fill && av(e.ctx, o, a));
    }
  },
  beforeDatasetsDraw(e, t, n) {
    if (n.drawTime !== "beforeDatasetsDraw")
      return;
    const r = e.getSortedVisibleDatasetMetas();
    for (let i = r.length - 1; i >= 0; --i) {
      const a = r[i].$filler;
      fT(a) && av(e.ctx, a, e.chartArea);
    }
  },
  beforeDatasetDraw(e, t, n) {
    const r = t.meta.$filler;
    !fT(r) || n.drawTime !== "beforeDatasetDraw" || av(e.ctx, r, e.chartArea);
  },
  defaults: {
    propagate: !0,
    drawTime: "beforeDatasetDraw"
  }
};
const gT = (e, t) => {
  let { boxHeight: n = t, boxWidth: r = t } = e;
  return e.usePointStyle && (n = Math.min(n, t), r = e.pointStyleWidth || Math.min(r, t)), {
    boxWidth: r,
    boxHeight: n,
    itemHeight: Math.max(t, n)
  };
}, nie = (e, t) => e !== null && t !== null && e.datasetIndex === t.datasetIndex && e.index === t.index;
class vT extends Ar {
  constructor(t) {
    super(), this._added = !1, this.legendHitBoxes = [], this._hoveredItem = null, this.doughnutMode = !1, this.chart = t.chart, this.options = t.options, this.ctx = t.ctx, this.legendItems = void 0, this.columnSizes = void 0, this.lineWidths = void 0, this.maxHeight = void 0, this.maxWidth = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.height = void 0, this.width = void 0, this._margins = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(t, n, r) {
    this.maxWidth = t, this.maxHeight = n, this._margins = r, this.setDimensions(), this.buildLabels(), this.fit();
  }
  setDimensions() {
    this.isHorizontal() ? (this.width = this.maxWidth, this.left = this._margins.left, this.right = this.width) : (this.height = this.maxHeight, this.top = this._margins.top, this.bottom = this.height);
  }
  buildLabels() {
    const t = this.options.labels || {};
    let n = Xt(t.generateLabels, [this.chart], this) || [];
    t.filter && (n = n.filter((r) => t.filter(r, this.chart.data))), t.sort && (n = n.sort((r, i) => t.sort(r, i, this.chart.data))), this.options.reverse && n.reverse(), this.legendItems = n;
  }
  fit() {
    const { options: t, ctx: n } = this;
    if (!t.display) {
      this.width = this.height = 0;
      return;
    }
    const r = t.labels, i = Fn(r.font), a = i.size, s = this._computeTitleHeight(), { boxWidth: o, itemHeight: l } = gT(r, a);
    let c, f;
    n.font = i.string, this.isHorizontal() ? (c = this.maxWidth, f = this._fitRows(s, a, o, l) + 10) : (f = this.maxHeight, c = this._fitCols(s, a, o, l) + 10), this.width = Math.min(c, t.maxWidth || this.maxWidth), this.height = Math.min(f, t.maxHeight || this.maxHeight);
  }
  _fitRows(t, n, r, i) {
    const { ctx: a, maxWidth: s, options: { labels: { padding: o } } } = this, l = this.legendHitBoxes = [], c = this.lineWidths = [0], f = i + o;
    let h = t;
    a.textAlign = "left", a.textBaseline = "middle";
    let p = -1, g = -f;
    return this.legendItems.forEach((v, y) => {
      const S = r + n / 2 + a.measureText(v.text).width;
      (y === 0 || c[c.length - 1] + S + 2 * o > s) && (h += f, c[c.length - (y > 0 ? 0 : 1)] = 0, g += f, p++), l[y] = { left: 0, top: g, row: p, width: S, height: i }, c[c.length - 1] += S + o;
    }), h;
  }
  _fitCols(t, n, r, i) {
    const { ctx: a, maxHeight: s, options: { labels: { padding: o } } } = this, l = this.legendHitBoxes = [], c = this.columnSizes = [], f = s - t;
    let h = o, p = 0, g = 0, v = 0, y = 0;
    return this.legendItems.forEach((S, x) => {
      const E = r + n / 2 + a.measureText(S.text).width;
      x > 0 && g + i + 2 * o > f && (h += p + o, c.push({ width: p, height: g }), v += p + o, y++, p = g = 0), l[x] = { left: v, top: g, col: y, width: E, height: i }, p = Math.max(p, E), g += i + o;
    }), h += p, c.push({ width: p, height: g }), h;
  }
  adjustHitBoxes() {
    if (!this.options.display)
      return;
    const t = this._computeTitleHeight(), { legendHitBoxes: n, options: { align: r, labels: { padding: i }, rtl: a } } = this, s = Kl(a, this.left, this.width);
    if (this.isHorizontal()) {
      let o = 0, l = Ir(r, this.left + i, this.right - this.lineWidths[o]);
      for (const c of n)
        o !== c.row && (o = c.row, l = Ir(r, this.left + i, this.right - this.lineWidths[o])), c.top += this.top + t + i, c.left = s.leftForLtr(s.x(l), c.width), l += c.width + i;
    } else {
      let o = 0, l = Ir(r, this.top + t + i, this.bottom - this.columnSizes[o].height);
      for (const c of n)
        c.col !== o && (o = c.col, l = Ir(r, this.top + t + i, this.bottom - this.columnSizes[o].height)), c.top = l, c.left += this.left + i, c.left = s.leftForLtr(s.x(c.left), c.width), l += c.height + i;
    }
  }
  isHorizontal() {
    return this.options.position === "top" || this.options.position === "bottom";
  }
  draw() {
    if (this.options.display) {
      const t = this.ctx;
      dd(t, this), this._draw(), fd(t);
    }
  }
  _draw() {
    const { options: t, columnSizes: n, lineWidths: r, ctx: i } = this, { align: a, labels: s } = t, o = Et.color, l = Kl(t.rtl, this.left, this.width), c = Fn(s.font), { color: f, padding: h } = s, p = c.size, g = p / 2;
    let v;
    this.drawTitle(), i.textAlign = l.textAlign("left"), i.textBaseline = "middle", i.lineWidth = 0.5, i.font = c.string;
    const { boxWidth: y, boxHeight: S, itemHeight: x } = gT(s, p), E = function(T, N, $) {
      if (isNaN(y) || y <= 0 || isNaN(S) || S < 0)
        return;
      i.save();
      const ne = lt($.lineWidth, 1);
      if (i.fillStyle = lt($.fillStyle, o), i.lineCap = lt($.lineCap, "butt"), i.lineDashOffset = lt($.lineDashOffset, 0), i.lineJoin = lt($.lineJoin, "miter"), i.lineWidth = ne, i.strokeStyle = lt($.strokeStyle, o), i.setLineDash(lt($.lineDash, [])), s.usePointStyle) {
        const Y = {
          radius: S * Math.SQRT2 / 2,
          pointStyle: $.pointStyle,
          rotation: $.rotation,
          borderWidth: ne
        }, te = l.xPlus(T, y / 2), _e = N + g;
        VM(i, Y, te, _e, s.pointStyleWidth && y);
      } else {
        const Y = N + Math.max((p - S) / 2, 0), te = l.leftForLtr(T, y), _e = Gs($.borderRadius);
        i.beginPath(), Object.values(_e).some((Fe) => Fe !== 0) ? ru(i, {
          x: te,
          y: Y,
          w: y,
          h: S,
          radius: _e
        }) : i.rect(te, Y, y, S), i.fill(), ne !== 0 && i.stroke();
      }
      i.restore();
    }, w = function(T, N, $) {
      Qo(i, $.text, T, N + x / 2, c, {
        strikethrough: $.hidden,
        textAlign: l.textAlign($.textAlign)
      });
    }, C = this.isHorizontal(), P = this._computeTitleHeight();
    C ? v = {
      x: Ir(a, this.left + h, this.right - r[0]),
      y: this.top + h + P,
      line: 0
    } : v = {
      x: this.left + h,
      y: Ir(a, this.top + P + h, this.bottom - n[0].height),
      line: 0
    }, YM(this.ctx, t.textDirection);
    const M = x + h;
    this.legendItems.forEach((T, N) => {
      i.strokeStyle = T.fontColor || f, i.fillStyle = T.fontColor || f;
      const $ = i.measureText(T.text).width, ne = l.textAlign(T.textAlign || (T.textAlign = s.textAlign)), Y = y + g + $;
      let te = v.x, _e = v.y;
      l.setWidth(this.width), C ? N > 0 && te + Y + h > this.right && (_e = v.y += M, v.line++, te = v.x = Ir(a, this.left + h, this.right - r[v.line])) : N > 0 && _e + M > this.bottom && (te = v.x = te + n[v.line].width + h, v.line++, _e = v.y = Ir(a, this.top + P + h, this.bottom - n[v.line].height));
      const Fe = l.x(te);
      E(Fe, _e, T), te = hee(ne, te + y + g, C ? te + Y : this.right, t.rtl), w(l.x(te), _e, T), C ? v.x += Y + h : v.y += M;
    }), KM(this.ctx, t.textDirection);
  }
  drawTitle() {
    const t = this.options, n = t.title, r = Fn(n.font), i = Hn(n.padding);
    if (!n.display)
      return;
    const a = Kl(t.rtl, this.left, this.width), s = this.ctx, o = n.position, l = r.size / 2, c = i.top + l;
    let f, h = this.left, p = this.width;
    if (this.isHorizontal())
      p = Math.max(...this.lineWidths), f = this.top + c, h = Ir(t.align, h, this.right - p);
    else {
      const v = this.columnSizes.reduce((y, S) => Math.max(y, S.height), 0);
      f = c + Ir(t.align, this.top, this.bottom - v - t.labels.padding - this._computeTitleHeight());
    }
    const g = Ir(o, h, h + p);
    s.textAlign = a.textAlign(J0(o)), s.textBaseline = "middle", s.strokeStyle = n.color, s.fillStyle = n.color, s.font = r.string, Qo(s, n.text, g, f, r);
  }
  _computeTitleHeight() {
    const t = this.options.title, n = Fn(t.font), r = Hn(t.padding);
    return t.display ? n.lineHeight + r.height : 0;
  }
  _getLegendItemAt(t, n) {
    let r, i, a;
    if (is(t, this.left, this.right) && is(n, this.top, this.bottom)) {
      for (a = this.legendHitBoxes, r = 0; r < a.length; ++r)
        if (i = a[r], is(t, i.left, i.left + i.width) && is(n, i.top, i.top + i.height))
          return this.legendItems[r];
    }
    return null;
  }
  handleEvent(t) {
    const n = this.options;
    if (!rie(t.type, n))
      return;
    const r = this._getLegendItemAt(t.x, t.y);
    if (t.type === "mousemove" || t.type === "mouseout") {
      const i = this._hoveredItem, a = nie(i, r);
      i && !a && Xt(n.onLeave, [t, i, this], this), this._hoveredItem = r, r && !a && Xt(n.onHover, [t, r, this], this);
    } else r && Xt(n.onClick, [t, r, this], this);
  }
}
function rie(e, t) {
  return !!((e === "mousemove" || e === "mouseout") && (t.onHover || t.onLeave) || t.onClick && (e === "click" || e === "mouseup"));
}
var iie = {
  id: "legend",
  _element: vT,
  start(e, t, n) {
    const r = e.legend = new vT({ ctx: e.ctx, options: n, chart: e });
    Nr.configure(e, r, n), Nr.addBox(e, r);
  },
  stop(e) {
    Nr.removeBox(e, e.legend), delete e.legend;
  },
  beforeUpdate(e, t, n) {
    const r = e.legend;
    Nr.configure(e, r, n), r.options = n;
  },
  afterUpdate(e) {
    const t = e.legend;
    t.buildLabels(), t.adjustHitBoxes();
  },
  afterEvent(e, t) {
    t.replay || e.legend.handleEvent(t.event);
  },
  defaults: {
    display: !0,
    position: "top",
    align: "center",
    fullSize: !0,
    reverse: !1,
    weight: 1e3,
    onClick(e, t, n) {
      const r = t.datasetIndex, i = n.chart;
      i.isDatasetVisible(r) ? (i.hide(r), t.hidden = !0) : (i.show(r), t.hidden = !1);
    },
    onHover: null,
    onLeave: null,
    labels: {
      color: (e) => e.chart.options.color,
      boxWidth: 40,
      padding: 10,
      generateLabels(e) {
        const t = e.data.datasets, { labels: { usePointStyle: n, pointStyle: r, textAlign: i, color: a } } = e.legend.options;
        return e._getSortedDatasetMetas().map((s) => {
          const o = s.controller.getStyle(n ? 0 : void 0), l = Hn(o.borderWidth);
          return {
            text: t[s.index].label,
            fillStyle: o.backgroundColor,
            fontColor: a,
            hidden: !s.visible,
            lineCap: o.borderCapStyle,
            lineDash: o.borderDash,
            lineDashOffset: o.borderDashOffset,
            lineJoin: o.borderJoinStyle,
            lineWidth: (l.width + l.height) / 4,
            strokeStyle: o.borderColor,
            pointStyle: r || o.pointStyle,
            rotation: o.rotation,
            textAlign: i || o.textAlign,
            borderRadius: 0,
            datasetIndex: s.index
          };
        }, this);
      }
    },
    title: {
      color: (e) => e.chart.options.color,
      display: !1,
      position: "center",
      text: ""
    }
  },
  descriptors: {
    _scriptable: (e) => !e.startsWith("on"),
    labels: {
      _scriptable: (e) => !["generateLabels", "filter", "sort"].includes(e)
    }
  }
};
class dx extends Ar {
  constructor(t) {
    super(), this.chart = t.chart, this.options = t.options, this.ctx = t.ctx, this._padding = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
  }
  update(t, n) {
    const r = this.options;
    if (this.left = 0, this.top = 0, !r.display) {
      this.width = this.height = this.right = this.bottom = 0;
      return;
    }
    this.width = this.right = t, this.height = this.bottom = n;
    const i = Zt(r.text) ? r.text.length : 1;
    this._padding = Hn(r.padding);
    const a = i * Fn(r.font).lineHeight + this._padding.height;
    this.isHorizontal() ? this.height = a : this.width = a;
  }
  isHorizontal() {
    const t = this.options.position;
    return t === "top" || t === "bottom";
  }
  _drawArgs(t) {
    const { top: n, left: r, bottom: i, right: a, options: s } = this, o = s.align;
    let l = 0, c, f, h;
    return this.isHorizontal() ? (f = Ir(o, r, a), h = n + t, c = a - r) : (s.position === "left" ? (f = r + t, h = Ir(o, i, n), l = Wt * -0.5) : (f = a - t, h = Ir(o, n, i), l = Wt * 0.5), c = i - n), { titleX: f, titleY: h, maxWidth: c, rotation: l };
  }
  draw() {
    const t = this.ctx, n = this.options;
    if (!n.display)
      return;
    const r = Fn(n.font), a = r.lineHeight / 2 + this._padding.top, { titleX: s, titleY: o, maxWidth: l, rotation: c } = this._drawArgs(a);
    Qo(t, n.text, 0, 0, r, {
      color: n.color,
      maxWidth: l,
      rotation: c,
      textAlign: J0(n.align),
      textBaseline: "middle",
      translation: [s, o]
    });
  }
}
function aie(e, t) {
  const n = new dx({
    ctx: e.ctx,
    options: t,
    chart: e
  });
  Nr.configure(e, n, t), Nr.addBox(e, n), e.titleBlock = n;
}
var sie = {
  id: "title",
  _element: dx,
  start(e, t, n) {
    aie(e, n);
  },
  stop(e) {
    const t = e.titleBlock;
    Nr.removeBox(e, t), delete e.titleBlock;
  },
  beforeUpdate(e, t, n) {
    const r = e.titleBlock;
    Nr.configure(e, r, n), r.options = n;
  },
  defaults: {
    align: "center",
    display: !1,
    font: {
      weight: "bold"
    },
    fullSize: !0,
    padding: 10,
    position: "top",
    text: "",
    weight: 2e3
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: !0,
    _indexable: !1
  }
};
const Gf = /* @__PURE__ */ new WeakMap();
var oie = {
  id: "subtitle",
  start(e, t, n) {
    const r = new dx({
      ctx: e.ctx,
      options: n,
      chart: e
    });
    Nr.configure(e, r, n), Nr.addBox(e, r), Gf.set(e, r);
  },
  stop(e) {
    Nr.removeBox(e, Gf.get(e)), Gf.delete(e);
  },
  beforeUpdate(e, t, n) {
    const r = Gf.get(e);
    Nr.configure(e, r, n), r.options = n;
  },
  defaults: {
    align: "center",
    display: !1,
    font: {
      weight: "normal"
    },
    fullSize: !0,
    padding: 0,
    position: "top",
    text: "",
    weight: 1500
  },
  defaultRoutes: {
    color: "color"
  },
  descriptors: {
    _scriptable: !0,
    _indexable: !1
  }
};
const Oc = {
  average(e) {
    if (!e.length)
      return !1;
    let t, n, r = 0, i = 0, a = 0;
    for (t = 0, n = e.length; t < n; ++t) {
      const s = e[t].element;
      if (s && s.hasValue()) {
        const o = s.tooltipPosition();
        r += o.x, i += o.y, ++a;
      }
    }
    return {
      x: r / a,
      y: i / a
    };
  },
  nearest(e, t) {
    if (!e.length)
      return !1;
    let n = t.x, r = t.y, i = Number.POSITIVE_INFINITY, a, s, o;
    for (a = 0, s = e.length; a < s; ++a) {
      const l = e[a].element;
      if (l && l.hasValue()) {
        const c = l.getCenterPoint(), f = jc(t, c);
        f < i && (i = f, o = l);
      }
    }
    if (o) {
      const l = o.tooltipPosition();
      n = l.x, r = l.y;
    }
    return {
      x: n,
      y: r
    };
  }
};
function _a(e, t) {
  return t && (Zt(t) ? Array.prototype.push.apply(e, t) : e.push(t)), e;
}
function Za(e) {
  return (typeof e == "string" || e instanceof String) && e.indexOf(`
`) > -1 ? e.split(`
`) : e;
}
function lie(e, t) {
  const { element: n, datasetIndex: r, index: i } = t, a = e.getDatasetMeta(r).controller, { label: s, value: o } = a.getLabelAndValue(i);
  return {
    chart: e,
    label: s,
    parsed: a.getParsed(i),
    raw: e.data.datasets[r].data[i],
    formattedValue: o,
    dataset: a.getDataset(),
    dataIndex: i,
    datasetIndex: r,
    element: n
  };
}
function bT(e, t) {
  const n = e.chart.ctx, { body: r, footer: i, title: a } = e, { boxWidth: s, boxHeight: o } = t, l = Fn(t.bodyFont), c = Fn(t.titleFont), f = Fn(t.footerFont), h = a.length, p = i.length, g = r.length, v = Hn(t.padding);
  let y = v.height, S = 0, x = r.reduce((C, P) => C + P.before.length + P.lines.length + P.after.length, 0);
  if (x += e.beforeBody.length + e.afterBody.length, h && (y += h * c.lineHeight + (h - 1) * t.titleSpacing + t.titleMarginBottom), x) {
    const C = t.displayColors ? Math.max(o, l.lineHeight) : l.lineHeight;
    y += g * C + (x - g) * l.lineHeight + (x - 1) * t.bodySpacing;
  }
  p && (y += t.footerMarginTop + p * f.lineHeight + (p - 1) * t.footerSpacing);
  let E = 0;
  const w = function(C) {
    S = Math.max(S, n.measureText(C).width + E);
  };
  return n.save(), n.font = c.string, Yt(e.title, w), n.font = l.string, Yt(e.beforeBody.concat(e.afterBody), w), E = t.displayColors ? s + 2 + t.boxPadding : 0, Yt(r, (C) => {
    Yt(C.before, w), Yt(C.lines, w), Yt(C.after, w);
  }), E = 0, n.font = f.string, Yt(e.footer, w), n.restore(), S += v.width, { width: S, height: y };
}
function uie(e, t) {
  const { y: n, height: r } = t;
  return n < r / 2 ? "top" : n > e.height - r / 2 ? "bottom" : "center";
}
function cie(e, t, n, r) {
  const { x: i, width: a } = r, s = n.caretSize + n.caretPadding;
  if (e === "left" && i + a + s > t.width || e === "right" && i - a - s < 0)
    return !0;
}
function die(e, t, n, r) {
  const { x: i, width: a } = n, { width: s, chartArea: { left: o, right: l } } = e;
  let c = "center";
  return r === "center" ? c = i <= (o + l) / 2 ? "left" : "right" : i <= a / 2 ? c = "left" : i >= s - a / 2 && (c = "right"), cie(c, e, t, n) && (c = "center"), c;
}
function _T(e, t, n) {
  const r = n.yAlign || t.yAlign || uie(e, n);
  return {
    xAlign: n.xAlign || t.xAlign || die(e, t, n, r),
    yAlign: r
  };
}
function fie(e, t) {
  let { x: n, width: r } = e;
  return t === "right" ? n -= r : t === "center" && (n -= r / 2), n;
}
function hie(e, t, n) {
  let { y: r, height: i } = e;
  return t === "top" ? r += n : t === "bottom" ? r -= i + n : r -= i / 2, r;
}
function yT(e, t, n, r) {
  const { caretSize: i, caretPadding: a, cornerRadius: s } = e, { xAlign: o, yAlign: l } = n, c = i + a, { topLeft: f, topRight: h, bottomLeft: p, bottomRight: g } = Gs(s);
  let v = fie(t, o);
  const y = hie(t, l, c);
  return l === "center" ? o === "left" ? v += c : o === "right" && (v -= c) : o === "left" ? v -= Math.max(f, p) + i : o === "right" && (v += Math.max(h, g) + i), {
    x: vr(v, 0, r.width - t.width),
    y: vr(y, 0, r.height - t.height)
  };
}
function Yf(e, t, n) {
  const r = Hn(n.padding);
  return t === "center" ? e.x + e.width / 2 : t === "right" ? e.x + e.width - r.right : e.x + r.left;
}
function xT(e) {
  return _a([], Za(e));
}
function pie(e, t, n) {
  return oo(e, {
    tooltip: t,
    tooltipItems: n,
    type: "tooltip"
  });
}
function wT(e, t) {
  const n = t && t.dataset && t.dataset.tooltip && t.dataset.tooltip.callbacks;
  return n ? e.override(n) : e;
}
class Iy extends Ar {
  constructor(t) {
    super(), this.opacity = 0, this._active = [], this._eventPosition = void 0, this._size = void 0, this._cachedAnimations = void 0, this._tooltipItems = [], this.$animations = void 0, this.$context = void 0, this.chart = t.chart || t._chart, this._chart = this.chart, this.options = t.options, this.dataPoints = void 0, this.title = void 0, this.beforeBody = void 0, this.body = void 0, this.afterBody = void 0, this.footer = void 0, this.xAlign = void 0, this.yAlign = void 0, this.x = void 0, this.y = void 0, this.height = void 0, this.width = void 0, this.caretX = void 0, this.caretY = void 0, this.labelColors = void 0, this.labelPointStyles = void 0, this.labelTextColors = void 0;
  }
  initialize(t) {
    this.options = t, this._cachedAnimations = void 0, this.$context = void 0;
  }
  _resolveAnimations() {
    const t = this._cachedAnimations;
    if (t)
      return t;
    const n = this.chart, r = this.options.setContext(this.getContext()), i = r.enabled && n.options.animation && r.animations, a = new lx(this.chart, i);
    return i._cacheable && (this._cachedAnimations = Object.freeze(a)), a;
  }
  getContext() {
    return this.$context || (this.$context = pie(this.chart.getContext(), this, this._tooltipItems));
  }
  getTitle(t, n) {
    const { callbacks: r } = n, i = r.beforeTitle.apply(this, [t]), a = r.title.apply(this, [t]), s = r.afterTitle.apply(this, [t]);
    let o = [];
    return o = _a(o, Za(i)), o = _a(o, Za(a)), o = _a(o, Za(s)), o;
  }
  getBeforeBody(t, n) {
    return xT(n.callbacks.beforeBody.apply(this, [t]));
  }
  getBody(t, n) {
    const { callbacks: r } = n, i = [];
    return Yt(t, (a) => {
      const s = {
        before: [],
        lines: [],
        after: []
      }, o = wT(r, a);
      _a(s.before, Za(o.beforeLabel.call(this, a))), _a(s.lines, o.label.call(this, a)), _a(s.after, Za(o.afterLabel.call(this, a))), i.push(s);
    }), i;
  }
  getAfterBody(t, n) {
    return xT(n.callbacks.afterBody.apply(this, [t]));
  }
  getFooter(t, n) {
    const { callbacks: r } = n, i = r.beforeFooter.apply(this, [t]), a = r.footer.apply(this, [t]), s = r.afterFooter.apply(this, [t]);
    let o = [];
    return o = _a(o, Za(i)), o = _a(o, Za(a)), o = _a(o, Za(s)), o;
  }
  _createItems(t) {
    const n = this._active, r = this.chart.data, i = [], a = [], s = [];
    let o = [], l, c;
    for (l = 0, c = n.length; l < c; ++l)
      o.push(lie(this.chart, n[l]));
    return t.filter && (o = o.filter((f, h, p) => t.filter(f, h, p, r))), t.itemSort && (o = o.sort((f, h) => t.itemSort(f, h, r))), Yt(o, (f) => {
      const h = wT(t.callbacks, f);
      i.push(h.labelColor.call(this, f)), a.push(h.labelPointStyle.call(this, f)), s.push(h.labelTextColor.call(this, f));
    }), this.labelColors = i, this.labelPointStyles = a, this.labelTextColors = s, this.dataPoints = o, o;
  }
  update(t, n) {
    const r = this.options.setContext(this.getContext()), i = this._active;
    let a, s = [];
    if (!i.length)
      this.opacity !== 0 && (a = {
        opacity: 0
      });
    else {
      const o = Oc[r.position].call(this, i, this._eventPosition);
      s = this._createItems(r), this.title = this.getTitle(s, r), this.beforeBody = this.getBeforeBody(s, r), this.body = this.getBody(s, r), this.afterBody = this.getAfterBody(s, r), this.footer = this.getFooter(s, r);
      const l = this._size = bT(this, r), c = Object.assign({}, o, l), f = _T(this.chart, r, c), h = yT(r, c, f, this.chart);
      this.xAlign = f.xAlign, this.yAlign = f.yAlign, a = {
        opacity: 1,
        x: h.x,
        y: h.y,
        width: l.width,
        height: l.height,
        caretX: o.x,
        caretY: o.y
      };
    }
    this._tooltipItems = s, this.$context = void 0, a && this._resolveAnimations().update(this, a), t && r.external && r.external.call(this, { chart: this.chart, tooltip: this, replay: n });
  }
  drawCaret(t, n, r, i) {
    const a = this.getCaretPosition(t, r, i);
    n.lineTo(a.x1, a.y1), n.lineTo(a.x2, a.y2), n.lineTo(a.x3, a.y3);
  }
  getCaretPosition(t, n, r) {
    const { xAlign: i, yAlign: a } = this, { caretSize: s, cornerRadius: o } = r, { topLeft: l, topRight: c, bottomLeft: f, bottomRight: h } = Gs(o), { x: p, y: g } = t, { width: v, height: y } = n;
    let S, x, E, w, C, P;
    return a === "center" ? (C = g + y / 2, i === "left" ? (S = p, x = S - s, w = C + s, P = C - s) : (S = p + v, x = S + s, w = C - s, P = C + s), E = S) : (i === "left" ? x = p + Math.max(l, f) + s : i === "right" ? x = p + v - Math.max(c, h) - s : x = this.caretX, a === "top" ? (w = g, C = w - s, S = x - s, E = x + s) : (w = g + y, C = w + s, S = x + s, E = x - s), P = w), { x1: S, x2: x, x3: E, y1: w, y2: C, y3: P };
  }
  drawTitle(t, n, r) {
    const i = this.title, a = i.length;
    let s, o, l;
    if (a) {
      const c = Kl(r.rtl, this.x, this.width);
      for (t.x = Yf(this, r.titleAlign, r), n.textAlign = c.textAlign(r.titleAlign), n.textBaseline = "middle", s = Fn(r.titleFont), o = r.titleSpacing, n.fillStyle = r.titleColor, n.font = s.string, l = 0; l < a; ++l)
        n.fillText(i[l], c.x(t.x), t.y + s.lineHeight / 2), t.y += s.lineHeight + o, l + 1 === a && (t.y += r.titleMarginBottom - o);
    }
  }
  _drawColorBox(t, n, r, i, a) {
    const s = this.labelColors[r], o = this.labelPointStyles[r], { boxHeight: l, boxWidth: c, boxPadding: f } = a, h = Fn(a.bodyFont), p = Yf(this, "left", a), g = i.x(p), v = l < h.lineHeight ? (h.lineHeight - l) / 2 : 0, y = n.y + v;
    if (a.usePointStyle) {
      const S = {
        radius: Math.min(c, l) / 2,
        pointStyle: o.pointStyle,
        rotation: o.rotation,
        borderWidth: 1
      }, x = i.leftForLtr(g, c) + c / 2, E = y + l / 2;
      t.strokeStyle = a.multiKeyBackground, t.fillStyle = a.multiKeyBackground, Wh(t, S, x, E), t.strokeStyle = s.borderColor, t.fillStyle = s.backgroundColor, Wh(t, S, x, E);
    } else {
      t.lineWidth = _t(s.borderWidth) ? Math.max(...Object.values(s.borderWidth)) : s.borderWidth || 1, t.strokeStyle = s.borderColor, t.setLineDash(s.borderDash || []), t.lineDashOffset = s.borderDashOffset || 0;
      const S = i.leftForLtr(g, c - f), x = i.leftForLtr(i.xPlus(g, 1), c - f - 2), E = Gs(s.borderRadius);
      Object.values(E).some((w) => w !== 0) ? (t.beginPath(), t.fillStyle = a.multiKeyBackground, ru(t, {
        x: S,
        y,
        w: c,
        h: l,
        radius: E
      }), t.fill(), t.stroke(), t.fillStyle = s.backgroundColor, t.beginPath(), ru(t, {
        x,
        y: y + 1,
        w: c - 2,
        h: l - 2,
        radius: E
      }), t.fill()) : (t.fillStyle = a.multiKeyBackground, t.fillRect(S, y, c, l), t.strokeRect(S, y, c, l), t.fillStyle = s.backgroundColor, t.fillRect(x, y + 1, c - 2, l - 2));
    }
    t.fillStyle = this.labelTextColors[r];
  }
  drawBody(t, n, r) {
    const { body: i } = this, { bodySpacing: a, bodyAlign: s, displayColors: o, boxHeight: l, boxWidth: c, boxPadding: f } = r, h = Fn(r.bodyFont);
    let p = h.lineHeight, g = 0;
    const v = Kl(r.rtl, this.x, this.width), y = function(N) {
      n.fillText(N, v.x(t.x + g), t.y + p / 2), t.y += p + a;
    }, S = v.textAlign(s);
    let x, E, w, C, P, M, T;
    for (n.textAlign = s, n.textBaseline = "middle", n.font = h.string, t.x = Yf(this, S, r), n.fillStyle = r.bodyColor, Yt(this.beforeBody, y), g = o && S !== "right" ? s === "center" ? c / 2 + f : c + 2 + f : 0, C = 0, M = i.length; C < M; ++C) {
      for (x = i[C], E = this.labelTextColors[C], n.fillStyle = E, Yt(x.before, y), w = x.lines, o && w.length && (this._drawColorBox(n, t, C, v, r), p = Math.max(h.lineHeight, l)), P = 0, T = w.length; P < T; ++P)
        y(w[P]), p = h.lineHeight;
      Yt(x.after, y);
    }
    g = 0, p = h.lineHeight, Yt(this.afterBody, y), t.y -= a;
  }
  drawFooter(t, n, r) {
    const i = this.footer, a = i.length;
    let s, o;
    if (a) {
      const l = Kl(r.rtl, this.x, this.width);
      for (t.x = Yf(this, r.footerAlign, r), t.y += r.footerMarginTop, n.textAlign = l.textAlign(r.footerAlign), n.textBaseline = "middle", s = Fn(r.footerFont), n.fillStyle = r.footerColor, n.font = s.string, o = 0; o < a; ++o)
        n.fillText(i[o], l.x(t.x), t.y + s.lineHeight / 2), t.y += s.lineHeight + r.footerSpacing;
    }
  }
  drawBackground(t, n, r, i) {
    const { xAlign: a, yAlign: s } = this, { x: o, y: l } = t, { width: c, height: f } = r, { topLeft: h, topRight: p, bottomLeft: g, bottomRight: v } = Gs(i.cornerRadius);
    n.fillStyle = i.backgroundColor, n.strokeStyle = i.borderColor, n.lineWidth = i.borderWidth, n.beginPath(), n.moveTo(o + h, l), s === "top" && this.drawCaret(t, n, r, i), n.lineTo(o + c - p, l), n.quadraticCurveTo(o + c, l, o + c, l + p), s === "center" && a === "right" && this.drawCaret(t, n, r, i), n.lineTo(o + c, l + f - v), n.quadraticCurveTo(o + c, l + f, o + c - v, l + f), s === "bottom" && this.drawCaret(t, n, r, i), n.lineTo(o + g, l + f), n.quadraticCurveTo(o, l + f, o, l + f - g), s === "center" && a === "left" && this.drawCaret(t, n, r, i), n.lineTo(o, l + h), n.quadraticCurveTo(o, l, o + h, l), n.closePath(), n.fill(), i.borderWidth > 0 && n.stroke();
  }
  _updateAnimationTarget(t) {
    const n = this.chart, r = this.$animations, i = r && r.x, a = r && r.y;
    if (i || a) {
      const s = Oc[t.position].call(this, this._active, this._eventPosition);
      if (!s)
        return;
      const o = this._size = bT(this, t), l = Object.assign({}, s, this._size), c = _T(n, t, l), f = yT(t, l, c, n);
      (i._to !== f.x || a._to !== f.y) && (this.xAlign = c.xAlign, this.yAlign = c.yAlign, this.width = o.width, this.height = o.height, this.caretX = s.x, this.caretY = s.y, this._resolveAnimations().update(this, f));
    }
  }
  _willRender() {
    return !!this.opacity;
  }
  draw(t) {
    const n = this.options.setContext(this.getContext());
    let r = this.opacity;
    if (!r)
      return;
    this._updateAnimationTarget(n);
    const i = {
      width: this.width,
      height: this.height
    }, a = {
      x: this.x,
      y: this.y
    };
    r = Math.abs(r) < 1e-3 ? 0 : r;
    const s = Hn(n.padding), o = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
    n.enabled && o && (t.save(), t.globalAlpha = r, this.drawBackground(a, t, i, n), YM(t, n.textDirection), a.y += s.top, this.drawTitle(a, t, n), this.drawBody(a, t, n), this.drawFooter(a, t, n), KM(t, n.textDirection), t.restore());
  }
  getActiveElements() {
    return this._active || [];
  }
  setActiveElements(t, n) {
    const r = this._active, i = t.map(({ datasetIndex: o, index: l }) => {
      const c = this.chart.getDatasetMeta(o);
      if (!c)
        throw new Error("Cannot find a dataset at index " + o);
      return {
        datasetIndex: o,
        element: c.data[l],
        index: l
      };
    }), a = !Vh(r, i), s = this._positionChanged(i, n);
    (a || s) && (this._active = i, this._eventPosition = n, this._ignoreReplayEvents = !0, this.update(!0));
  }
  handleEvent(t, n, r = !0) {
    if (n && this._ignoreReplayEvents)
      return !1;
    this._ignoreReplayEvents = !1;
    const i = this.options, a = this._active || [], s = this._getActiveElements(t, a, n, r), o = this._positionChanged(s, t), l = n || !Vh(s, a) || o;
    return l && (this._active = s, (i.enabled || i.external) && (this._eventPosition = {
      x: t.x,
      y: t.y
    }, this.update(!0, n))), l;
  }
  _getActiveElements(t, n, r, i) {
    const a = this.options;
    if (t.type === "mouseout")
      return [];
    if (!i)
      return n;
    const s = this.chart.getElementsAtEventForMode(t, a.mode, a, r);
    return a.reverse && s.reverse(), s;
  }
  _positionChanged(t, n) {
    const { caretX: r, caretY: i, options: a } = this, s = Oc[a.position].call(this, t, n);
    return s !== !1 && (r !== s.x || i !== s.y);
  }
}
Iy.positioners = Oc;
var mie = {
  id: "tooltip",
  _element: Iy,
  positioners: Oc,
  afterInit(e, t, n) {
    n && (e.tooltip = new Iy({ chart: e, options: n }));
  },
  beforeUpdate(e, t, n) {
    e.tooltip && e.tooltip.initialize(n);
  },
  reset(e, t, n) {
    e.tooltip && e.tooltip.initialize(n);
  },
  afterDraw(e) {
    const t = e.tooltip;
    if (t && t._willRender()) {
      const n = {
        tooltip: t
      };
      if (e.notifyPlugins("beforeTooltipDraw", n) === !1)
        return;
      t.draw(e.ctx), e.notifyPlugins("afterTooltipDraw", n);
    }
  },
  afterEvent(e, t) {
    if (e.tooltip) {
      const n = t.replay;
      e.tooltip.handleEvent(t.event, n, t.inChartArea) && (t.changed = !0);
    }
  },
  defaults: {
    enabled: !0,
    external: null,
    position: "average",
    backgroundColor: "rgba(0,0,0,0.8)",
    titleColor: "#fff",
    titleFont: {
      weight: "bold"
    },
    titleSpacing: 2,
    titleMarginBottom: 6,
    titleAlign: "left",
    bodyColor: "#fff",
    bodySpacing: 2,
    bodyFont: {},
    bodyAlign: "left",
    footerColor: "#fff",
    footerSpacing: 2,
    footerMarginTop: 6,
    footerFont: {
      weight: "bold"
    },
    footerAlign: "left",
    padding: 6,
    caretPadding: 2,
    caretSize: 5,
    cornerRadius: 6,
    boxHeight: (e, t) => t.bodyFont.size,
    boxWidth: (e, t) => t.bodyFont.size,
    multiKeyBackground: "#fff",
    displayColors: !0,
    boxPadding: 0,
    borderColor: "rgba(0,0,0,0)",
    borderWidth: 0,
    animation: {
      duration: 400,
      easing: "easeOutQuart"
    },
    animations: {
      numbers: {
        type: "number",
        properties: ["x", "y", "width", "height", "caretX", "caretY"]
      },
      opacity: {
        easing: "linear",
        duration: 200
      }
    },
    callbacks: {
      beforeTitle: Ka,
      title(e) {
        if (e.length > 0) {
          const t = e[0], n = t.chart.data.labels, r = n ? n.length : 0;
          if (this && this.options && this.options.mode === "dataset")
            return t.dataset.label || "";
          if (t.label)
            return t.label;
          if (r > 0 && t.dataIndex < r)
            return n[t.dataIndex];
        }
        return "";
      },
      afterTitle: Ka,
      beforeBody: Ka,
      beforeLabel: Ka,
      label(e) {
        if (this && this.options && this.options.mode === "dataset")
          return e.label + ": " + e.formattedValue || e.formattedValue;
        let t = e.dataset.label || "";
        t && (t += ": ");
        const n = e.formattedValue;
        return Tt(n) || (t += n), t;
      },
      labelColor(e) {
        const n = e.chart.getDatasetMeta(e.datasetIndex).controller.getStyle(e.dataIndex);
        return {
          borderColor: n.borderColor,
          backgroundColor: n.backgroundColor,
          borderWidth: n.borderWidth,
          borderDash: n.borderDash,
          borderDashOffset: n.borderDashOffset,
          borderRadius: 0
        };
      },
      labelTextColor() {
        return this.options.bodyColor;
      },
      labelPointStyle(e) {
        const n = e.chart.getDatasetMeta(e.datasetIndex).controller.getStyle(e.dataIndex);
        return {
          pointStyle: n.pointStyle,
          rotation: n.rotation
        };
      },
      afterLabel: Ka,
      afterBody: Ka,
      beforeFooter: Ka,
      footer: Ka,
      afterFooter: Ka
    }
  },
  defaultRoutes: {
    bodyFont: "font",
    footerFont: "font",
    titleFont: "font"
  },
  descriptors: {
    _scriptable: (e) => e !== "filter" && e !== "itemSort" && e !== "external",
    _indexable: !1,
    callbacks: {
      _scriptable: !1,
      _indexable: !1
    },
    animation: {
      _fallback: !1
    },
    animations: {
      _fallback: "animation"
    }
  },
  additionalOptionScopes: ["interaction"]
}, gie = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Decimation: Fre,
  Filler: tie,
  Legend: iie,
  SubTitle: oie,
  Title: sie,
  Tooltip: mie
});
const vie = (e, t, n, r) => (typeof t == "string" ? (n = e.push(t) - 1, r.unshift({ index: n, label: t })) : isNaN(t) && (n = null), n);
function bie(e, t, n, r) {
  const i = e.indexOf(t);
  if (i === -1)
    return vie(e, t, n, r);
  const a = e.lastIndexOf(t);
  return i !== a ? n : i;
}
const _ie = (e, t) => e === null ? null : vr(Math.round(e), 0, t);
class Yh extends ll {
  constructor(t) {
    super(t), this._startValue = void 0, this._valueRange = 0, this._addedLabels = [];
  }
  init(t) {
    const n = this._addedLabels;
    if (n.length) {
      const r = this.getLabels();
      for (const { index: i, label: a } of n)
        r[i] === a && r.splice(i, 1);
      this._addedLabels = [];
    }
    super.init(t);
  }
  parse(t, n) {
    if (Tt(t))
      return null;
    const r = this.getLabels();
    return n = isFinite(n) && r[n] === t ? n : bie(r, t, lt(n, t), this._addedLabels), _ie(n, r.length - 1);
  }
  determineDataLimits() {
    const { minDefined: t, maxDefined: n } = this.getUserBounds();
    let { min: r, max: i } = this.getMinMax(!0);
    this.options.bounds === "ticks" && (t || (r = 0), n || (i = this.getLabels().length - 1)), this.min = r, this.max = i;
  }
  buildTicks() {
    const t = this.min, n = this.max, r = this.options.offset, i = [];
    let a = this.getLabels();
    a = t === 0 && n === a.length - 1 ? a : a.slice(t, n + 1), this._valueRange = Math.max(a.length - (r ? 0 : 1), 1), this._startValue = this.min - (r ? 0.5 : 0);
    for (let s = t; s <= n; s++)
      i.push({ value: s });
    return i;
  }
  getLabelForValue(t) {
    const n = this.getLabels();
    return t >= 0 && t < n.length ? n[t] : t;
  }
  configure() {
    super.configure(), this.isHorizontal() || (this._reversePixels = !this._reversePixels);
  }
  getPixelForValue(t) {
    return typeof t != "number" && (t = this.parse(t)), t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getPixelForTick(t) {
    const n = this.ticks;
    return t < 0 || t > n.length - 1 ? null : this.getPixelForValue(n[t].value);
  }
  getValueForPixel(t) {
    return Math.round(this._startValue + this.getDecimalForPixel(t) * this._valueRange);
  }
  getBasePixel() {
    return this.bottom;
  }
}
Yh.id = "category";
Yh.defaults = {
  ticks: {
    callback: Yh.prototype.getLabelForValue
  }
};
function yie(e, t) {
  const n = [], { bounds: i, step: a, min: s, max: o, precision: l, count: c, maxTicks: f, maxDigits: h, includeBounds: p } = e, g = a || 1, v = f - 1, { min: y, max: S } = t, x = !Tt(s), E = !Tt(o), w = !Tt(c), C = (S - y) / (h + 1);
  let P = _C((S - y) / v / g) * g, M, T, N, $;
  if (P < 1e-14 && !x && !E)
    return [{ value: y }, { value: S }];
  $ = Math.ceil(S / P) - Math.floor(y / P), $ > v && (P = _C($ * P / v / g) * g), Tt(l) || (M = Math.pow(10, l), P = Math.ceil(P * M) / M), i === "ticks" ? (T = Math.floor(y / P) * P, N = Math.ceil(S / P) * P) : (T = y, N = S), x && E && a && see((o - s) / a, P / 1e3) ? ($ = Math.round(Math.min((o - s) / P, f)), P = (o - s) / $, T = s, N = o) : w ? (T = x ? s : T, N = E ? o : N, $ = c - 1, P = (N - T) / $) : ($ = (N - T) / P, Dc($, Math.round($), P / 1e3) ? $ = Math.round($) : $ = Math.ceil($));
  const ne = Math.max(
    yC(P),
    yC(T)
  );
  M = Math.pow(10, Tt(l) ? ne : l), T = Math.round(T * M) / M, N = Math.round(N * M) / M;
  let Y = 0;
  for (x && (p && T !== s ? (n.push({ value: s }), T < s && Y++, Dc(Math.round((T + Y * P) * M) / M, s, kT(s, C, e)) && Y++) : T < s && Y++); Y < $; ++Y)
    n.push({ value: Math.round((T + Y * P) * M) / M });
  return E && p && N !== o ? n.length && Dc(n[n.length - 1].value, o, kT(o, C, e)) ? n[n.length - 1].value = o : n.push({ value: o }) : (!E || N === o) && n.push({ value: N }), n;
}
function kT(e, t, { horizontal: n, minRotation: r }) {
  const i = er(r), a = (n ? Math.sin(i) : Math.cos(i)) || 1e-3, s = 0.75 * t * ("" + e).length;
  return Math.min(t / a, s);
}
class Kh extends ll {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._endValue = void 0, this._valueRange = 0;
  }
  parse(t, n) {
    return Tt(t) || (typeof t == "number" || t instanceof Number) && !isFinite(+t) ? null : +t;
  }
  handleTickRangeOptions() {
    const { beginAtZero: t } = this.options, { minDefined: n, maxDefined: r } = this.getUserBounds();
    let { min: i, max: a } = this;
    const s = (l) => i = n ? i : l, o = (l) => a = r ? a : l;
    if (t) {
      const l = Ta(i), c = Ta(a);
      l < 0 && c < 0 ? o(0) : l > 0 && c > 0 && s(0);
    }
    if (i === a) {
      let l = 1;
      (a >= Number.MAX_SAFE_INTEGER || i <= Number.MIN_SAFE_INTEGER) && (l = Math.abs(a * 0.05)), o(a + l), t || s(i - l);
    }
    this.min = i, this.max = a;
  }
  getTickLimit() {
    const t = this.options.ticks;
    let { maxTicksLimit: n, stepSize: r } = t, i;
    return r ? (i = Math.ceil(this.max / r) - Math.floor(this.min / r) + 1, i > 1e3 && (console.warn(`scales.${this.id}.ticks.stepSize: ${r} would result generating up to ${i} ticks. Limiting to 1000.`), i = 1e3)) : (i = this.computeTickLimit(), n = n || 11), n && (i = Math.min(n, i)), i;
  }
  computeTickLimit() {
    return Number.POSITIVE_INFINITY;
  }
  buildTicks() {
    const t = this.options, n = t.ticks;
    let r = this.getTickLimit();
    r = Math.max(2, r);
    const i = {
      maxTicks: r,
      bounds: t.bounds,
      min: t.min,
      max: t.max,
      precision: n.precision,
      step: n.stepSize,
      count: n.count,
      maxDigits: this._maxDigits(),
      horizontal: this.isHorizontal(),
      minRotation: n.minRotation || 0,
      includeBounds: n.includeBounds !== !1
    }, a = this._range || this, s = yie(i, a);
    return t.bounds === "ticks" && TM(s, this, "value"), t.reverse ? (s.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), s;
  }
  configure() {
    const t = this.ticks;
    let n = this.min, r = this.max;
    if (super.configure(), this.options.offset && t.length) {
      const i = (r - n) / Math.max(t.length - 1, 1) / 2;
      n -= i, r += i;
    }
    this._startValue = n, this._endValue = r, this._valueRange = r - n;
  }
  getLabelForValue(t) {
    return hd(t, this.chart.options.locale, this.options.ticks.format);
  }
}
class fx extends Kh {
  determineDataLimits() {
    const { min: t, max: n } = this.getMinMax(!0);
    this.min = Pn(t) ? t : 0, this.max = Pn(n) ? n : 1, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    const t = this.isHorizontal(), n = t ? this.width : this.height, r = er(this.options.ticks.minRotation), i = (t ? Math.sin(r) : Math.cos(r)) || 1e-3, a = this._resolveTickFontOptions(0);
    return Math.ceil(n / Math.min(40, a.lineHeight / i));
  }
  getPixelForValue(t) {
    return t === null ? NaN : this.getPixelForDecimal((t - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    return this._startValue + this.getDecimalForPixel(t) * this._valueRange;
  }
}
fx.id = "linear";
fx.defaults = {
  ticks: {
    callback: Op.formatters.numeric
  }
};
function ST(e) {
  return e / Math.pow(10, Math.floor(ji(e))) === 1;
}
function xie(e, t) {
  const n = Math.floor(ji(t.max)), r = Math.ceil(t.max / Math.pow(10, n)), i = [];
  let a = $i(e.min, Math.pow(10, Math.floor(ji(t.min)))), s = Math.floor(ji(a)), o = Math.floor(a / Math.pow(10, s)), l = s < 0 ? Math.pow(10, Math.abs(s)) : 1;
  do
    i.push({ value: a, major: ST(a) }), ++o, o === 10 && (o = 1, ++s, l = s >= 0 ? 1 : l), a = Math.round(o * Math.pow(10, s) * l) / l;
  while (s < n || s === n && o < r);
  const c = $i(e.max, a);
  return i.push({ value: c, major: ST(a) }), i;
}
class hx extends ll {
  constructor(t) {
    super(t), this.start = void 0, this.end = void 0, this._startValue = void 0, this._valueRange = 0;
  }
  parse(t, n) {
    const r = Kh.prototype.parse.apply(this, [t, n]);
    if (r === 0) {
      this._zero = !0;
      return;
    }
    return Pn(r) && r > 0 ? r : null;
  }
  determineDataLimits() {
    const { min: t, max: n } = this.getMinMax(!0);
    this.min = Pn(t) ? Math.max(0, t) : null, this.max = Pn(n) ? Math.max(0, n) : null, this.options.beginAtZero && (this._zero = !0), this.handleTickRangeOptions();
  }
  handleTickRangeOptions() {
    const { minDefined: t, maxDefined: n } = this.getUserBounds();
    let r = this.min, i = this.max;
    const a = (l) => r = t ? r : l, s = (l) => i = n ? i : l, o = (l, c) => Math.pow(10, Math.floor(ji(l)) + c);
    r === i && (r <= 0 ? (a(1), s(10)) : (a(o(r, -1)), s(o(i, 1)))), r <= 0 && a(o(i, -1)), i <= 0 && s(o(r, 1)), this._zero && this.min !== this._suggestedMin && r === o(this.min, 0) && a(o(r, -1)), this.min = r, this.max = i;
  }
  buildTicks() {
    const t = this.options, n = {
      min: this._userMin,
      max: this._userMax
    }, r = xie(n, this);
    return t.bounds === "ticks" && TM(r, this, "value"), t.reverse ? (r.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), r;
  }
  getLabelForValue(t) {
    return t === void 0 ? "0" : hd(t, this.chart.options.locale, this.options.ticks.format);
  }
  configure() {
    const t = this.min;
    super.configure(), this._startValue = ji(t), this._valueRange = ji(this.max) - ji(t);
  }
  getPixelForValue(t) {
    return (t === void 0 || t === 0) && (t = this.min), t === null || isNaN(t) ? NaN : this.getPixelForDecimal(t === this.min ? 0 : (ji(t) - this._startValue) / this._valueRange);
  }
  getValueForPixel(t) {
    const n = this.getDecimalForPixel(t);
    return Math.pow(10, this._startValue + n * this._valueRange);
  }
}
hx.id = "logarithmic";
hx.defaults = {
  ticks: {
    callback: Op.formatters.logarithmic,
    major: {
      enabled: !0
    }
  }
};
function Ry(e) {
  const t = e.ticks;
  if (t.display && e.display) {
    const n = Hn(t.backdropPadding);
    return lt(t.font && t.font.size, Et.font.size) + n.height;
  }
  return 0;
}
function wie(e, t, n) {
  return n = Zt(n) ? n : [n], {
    w: $ee(e, t.string, n),
    h: n.length * t.lineHeight
  };
}
function CT(e, t, n, r, i) {
  return e === r || e === i ? {
    start: t - n / 2,
    end: t + n / 2
  } : e < r || e > i ? {
    start: t - n,
    end: t
  } : {
    start: t,
    end: t + n
  };
}
function kie(e) {
  const t = {
    l: e.left + e._padding.left,
    r: e.right - e._padding.right,
    t: e.top + e._padding.top,
    b: e.bottom - e._padding.bottom
  }, n = Object.assign({}, t), r = [], i = [], a = e._pointLabels.length, s = e.options.pointLabels, o = s.centerPointLabels ? Wt / a : 0;
  for (let l = 0; l < a; l++) {
    const c = s.setContext(e.getPointLabelContext(l));
    i[l] = c.padding;
    const f = e.getPointPosition(l, e.drawingArea + i[l], o), h = Fn(c.font), p = wie(e.ctx, h, e._pointLabels[l]);
    r[l] = p;
    const g = _i(e.getIndexAngle(l) + o), v = Math.round(Sp(g)), y = CT(v, f.x, p.w, 0, 180), S = CT(v, f.y, p.h, 90, 270);
    Sie(n, t, g, y, S);
  }
  e.setCenterPoint(
    t.l - n.l,
    n.r - t.r,
    t.t - n.t,
    n.b - t.b
  ), e._pointLabelItems = Cie(e, r, i);
}
function Sie(e, t, n, r, i) {
  const a = Math.abs(Math.sin(n)), s = Math.abs(Math.cos(n));
  let o = 0, l = 0;
  r.start < t.l ? (o = (t.l - r.start) / a, e.l = Math.min(e.l, t.l - o)) : r.end > t.r && (o = (r.end - t.r) / a, e.r = Math.max(e.r, t.r + o)), i.start < t.t ? (l = (t.t - i.start) / s, e.t = Math.min(e.t, t.t - l)) : i.end > t.b && (l = (i.end - t.b) / s, e.b = Math.max(e.b, t.b + l));
}
function Cie(e, t, n) {
  const r = [], i = e._pointLabels.length, a = e.options, s = Ry(a) / 2, o = e.drawingArea, l = a.pointLabels.centerPointLabels ? Wt / i : 0;
  for (let c = 0; c < i; c++) {
    const f = e.getPointPosition(c, o + s + n[c], l), h = Math.round(Sp(_i(f.angle + Rn))), p = t[c], g = Die(f.y, p.h, h), v = Tie(h), y = Aie(f.x, p.w, v);
    r.push({
      x: f.x,
      y: g,
      textAlign: v,
      left: y,
      top: g,
      right: y + p.w,
      bottom: g + p.h
    });
  }
  return r;
}
function Tie(e) {
  return e === 0 || e === 180 ? "center" : e < 180 ? "left" : "right";
}
function Aie(e, t, n) {
  return n === "right" ? e -= t : n === "center" && (e -= t / 2), e;
}
function Die(e, t, n) {
  return n === 90 || n === 270 ? e -= t / 2 : (n > 270 || n < 90) && (e -= t), e;
}
function Eie(e, t) {
  const { ctx: n, options: { pointLabels: r } } = e;
  for (let i = t - 1; i >= 0; i--) {
    const a = r.setContext(e.getPointLabelContext(i)), s = Fn(a.font), { x: o, y: l, textAlign: c, left: f, top: h, right: p, bottom: g } = e._pointLabelItems[i], { backdropColor: v } = a;
    if (!Tt(v)) {
      const y = Gs(a.borderRadius), S = Hn(a.backdropPadding);
      n.fillStyle = v;
      const x = f - S.left, E = h - S.top, w = p - f + S.width, C = g - h + S.height;
      Object.values(y).some((P) => P !== 0) ? (n.beginPath(), ru(n, {
        x,
        y: E,
        w,
        h: C,
        radius: y
      }), n.fill()) : n.fillRect(x, E, w, C);
    }
    Qo(
      n,
      e._pointLabels[i],
      o,
      l + s.lineHeight / 2,
      s,
      {
        color: a.color,
        textAlign: c,
        textBaseline: "middle"
      }
    );
  }
}
function _I(e, t, n, r) {
  const { ctx: i } = e;
  if (n)
    i.arc(e.xCenter, e.yCenter, t, 0, tn);
  else {
    let a = e.getPointPosition(0, t);
    i.moveTo(a.x, a.y);
    for (let s = 1; s < r; s++)
      a = e.getPointPosition(s, t), i.lineTo(a.x, a.y);
  }
}
function Pie(e, t, n, r) {
  const i = e.ctx, a = t.circular, { color: s, lineWidth: o } = t;
  !a && !r || !s || !o || n < 0 || (i.save(), i.strokeStyle = s, i.lineWidth = o, i.setLineDash(t.borderDash), i.lineDashOffset = t.borderDashOffset, i.beginPath(), _I(e, n, a, r), i.closePath(), i.stroke(), i.restore());
}
function Oie(e, t, n) {
  return oo(e, {
    label: n,
    index: t,
    type: "pointLabel"
  });
}
class vd extends Kh {
  constructor(t) {
    super(t), this.xCenter = void 0, this.yCenter = void 0, this.drawingArea = void 0, this._pointLabels = [], this._pointLabelItems = [];
  }
  setDimensions() {
    const t = this._padding = Hn(Ry(this.options) / 2), n = this.width = this.maxWidth - t.width, r = this.height = this.maxHeight - t.height;
    this.xCenter = Math.floor(this.left + n / 2 + t.left), this.yCenter = Math.floor(this.top + r / 2 + t.top), this.drawingArea = Math.floor(Math.min(n, r) / 2);
  }
  determineDataLimits() {
    const { min: t, max: n } = this.getMinMax(!1);
    this.min = Pn(t) && !isNaN(t) ? t : 0, this.max = Pn(n) && !isNaN(n) ? n : 0, this.handleTickRangeOptions();
  }
  computeTickLimit() {
    return Math.ceil(this.drawingArea / Ry(this.options));
  }
  generateTickLabels(t) {
    Kh.prototype.generateTickLabels.call(this, t), this._pointLabels = this.getLabels().map((n, r) => {
      const i = Xt(this.options.pointLabels.callback, [n, r], this);
      return i || i === 0 ? i : "";
    }).filter((n, r) => this.chart.getDataVisibility(r));
  }
  fit() {
    const t = this.options;
    t.display && t.pointLabels.display ? kie(this) : this.setCenterPoint(0, 0, 0, 0);
  }
  setCenterPoint(t, n, r, i) {
    this.xCenter += Math.floor((t - n) / 2), this.yCenter += Math.floor((r - i) / 2), this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(t, n, r, i));
  }
  getIndexAngle(t) {
    const n = tn / (this._pointLabels.length || 1), r = this.options.startAngle || 0;
    return _i(t * n + er(r));
  }
  getDistanceFromCenterForValue(t) {
    if (Tt(t))
      return NaN;
    const n = this.drawingArea / (this.max - this.min);
    return this.options.reverse ? (this.max - t) * n : (t - this.min) * n;
  }
  getValueForDistanceFromCenter(t) {
    if (Tt(t))
      return NaN;
    const n = t / (this.drawingArea / (this.max - this.min));
    return this.options.reverse ? this.max - n : this.min + n;
  }
  getPointLabelContext(t) {
    const n = this._pointLabels || [];
    if (t >= 0 && t < n.length) {
      const r = n[t];
      return Oie(this.getContext(), t, r);
    }
  }
  getPointPosition(t, n, r = 0) {
    const i = this.getIndexAngle(t) - Rn + r;
    return {
      x: Math.cos(i) * n + this.xCenter,
      y: Math.sin(i) * n + this.yCenter,
      angle: i
    };
  }
  getPointPositionForValue(t, n) {
    return this.getPointPosition(t, this.getDistanceFromCenterForValue(n));
  }
  getBasePosition(t) {
    return this.getPointPositionForValue(t || 0, this.getBaseValue());
  }
  getPointLabelPosition(t) {
    const { left: n, top: r, right: i, bottom: a } = this._pointLabelItems[t];
    return {
      left: n,
      top: r,
      right: i,
      bottom: a
    };
  }
  drawBackground() {
    const { backgroundColor: t, grid: { circular: n } } = this.options;
    if (t) {
      const r = this.ctx;
      r.save(), r.beginPath(), _I(this, this.getDistanceFromCenterForValue(this._endValue), n, this._pointLabels.length), r.closePath(), r.fillStyle = t, r.fill(), r.restore();
    }
  }
  drawGrid() {
    const t = this.ctx, n = this.options, { angleLines: r, grid: i } = n, a = this._pointLabels.length;
    let s, o, l;
    if (n.pointLabels.display && Eie(this, a), i.display && this.ticks.forEach((c, f) => {
      if (f !== 0) {
        o = this.getDistanceFromCenterForValue(c.value);
        const h = i.setContext(this.getContext(f - 1));
        Pie(this, h, o, a);
      }
    }), r.display) {
      for (t.save(), s = a - 1; s >= 0; s--) {
        const c = r.setContext(this.getPointLabelContext(s)), { color: f, lineWidth: h } = c;
        !h || !f || (t.lineWidth = h, t.strokeStyle = f, t.setLineDash(c.borderDash), t.lineDashOffset = c.borderDashOffset, o = this.getDistanceFromCenterForValue(n.ticks.reverse ? this.min : this.max), l = this.getPointPosition(s, o), t.beginPath(), t.moveTo(this.xCenter, this.yCenter), t.lineTo(l.x, l.y), t.stroke());
      }
      t.restore();
    }
  }
  drawBorder() {
  }
  drawLabels() {
    const t = this.ctx, n = this.options, r = n.ticks;
    if (!r.display)
      return;
    const i = this.getIndexAngle(0);
    let a, s;
    t.save(), t.translate(this.xCenter, this.yCenter), t.rotate(i), t.textAlign = "center", t.textBaseline = "middle", this.ticks.forEach((o, l) => {
      if (l === 0 && !n.reverse)
        return;
      const c = r.setContext(this.getContext(l)), f = Fn(c.font);
      if (a = this.getDistanceFromCenterForValue(this.ticks[l].value), c.showLabelBackdrop) {
        t.font = f.string, s = t.measureText(o.label).width, t.fillStyle = c.backdropColor;
        const h = Hn(c.backdropPadding);
        t.fillRect(
          -s / 2 - h.left,
          -a - f.size / 2 - h.top,
          s + h.width,
          f.size + h.height
        );
      }
      Qo(t, o.label, 0, -a, f, {
        color: c.color
      });
    }), t.restore();
  }
  drawTitle() {
  }
}
vd.id = "radialLinear";
vd.defaults = {
  display: !0,
  animate: !0,
  position: "chartArea",
  angleLines: {
    display: !0,
    lineWidth: 1,
    borderDash: [],
    borderDashOffset: 0
  },
  grid: {
    circular: !1
  },
  startAngle: 0,
  ticks: {
    showLabelBackdrop: !0,
    callback: Op.formatters.numeric
  },
  pointLabels: {
    backdropColor: void 0,
    backdropPadding: 2,
    display: !0,
    font: {
      size: 10
    },
    callback(e) {
      return e;
    },
    padding: 5,
    centerPointLabels: !1
  }
};
vd.defaultRoutes = {
  "angleLines.color": "borderColor",
  "pointLabels.color": "color",
  "ticks.color": "color"
};
vd.descriptors = {
  angleLines: {
    _fallback: "grid"
  }
};
const Rp = {
  millisecond: { common: !0, size: 1, steps: 1e3 },
  second: { common: !0, size: 1e3, steps: 60 },
  minute: { common: !0, size: 6e4, steps: 60 },
  hour: { common: !0, size: 36e5, steps: 24 },
  day: { common: !0, size: 864e5, steps: 30 },
  week: { common: !1, size: 6048e5, steps: 4 },
  month: { common: !0, size: 2628e6, steps: 12 },
  quarter: { common: !1, size: 7884e6, steps: 4 },
  year: { common: !0, size: 3154e7 }
}, si = Object.keys(Rp);
function Mie(e, t) {
  return e - t;
}
function TT(e, t) {
  if (Tt(t))
    return null;
  const n = e._adapter, { parser: r, round: i, isoWeekday: a } = e._parseOpts;
  let s = t;
  return typeof r == "function" && (s = r(s)), Pn(s) || (s = typeof r == "string" ? n.parse(s, r) : n.parse(s)), s === null ? null : (i && (s = i === "week" && (nu(a) || a === !0) ? n.startOf(s, "isoWeek", a) : n.startOf(s, i)), +s);
}
function AT(e, t, n, r) {
  const i = si.length;
  for (let a = si.indexOf(e); a < i - 1; ++a) {
    const s = Rp[si[a]], o = s.steps ? s.steps : Number.MAX_SAFE_INTEGER;
    if (s.common && Math.ceil((n - t) / (o * s.size)) <= r)
      return si[a];
  }
  return si[i - 1];
}
function Iie(e, t, n, r, i) {
  for (let a = si.length - 1; a >= si.indexOf(n); a--) {
    const s = si[a];
    if (Rp[s].common && e._adapter.diff(i, r, s) >= t - 1)
      return s;
  }
  return si[n ? si.indexOf(n) : 0];
}
function Rie(e) {
  for (let t = si.indexOf(e) + 1, n = si.length; t < n; ++t)
    if (Rp[si[t]].common)
      return si[t];
}
function DT(e, t, n) {
  if (!n)
    e[t] = !0;
  else if (n.length) {
    const { lo: r, hi: i } = Q0(n, t), a = n[r] >= t ? n[r] : n[i];
    e[a] = !0;
  }
}
function Fie(e, t, n, r) {
  const i = e._adapter, a = +i.startOf(t[0].value, r), s = t[t.length - 1].value;
  let o, l;
  for (o = a; o <= s; o = +i.add(o, 1, r))
    l = n[o], l >= 0 && (t[l].major = !0);
  return t;
}
function ET(e, t, n) {
  const r = [], i = {}, a = t.length;
  let s, o;
  for (s = 0; s < a; ++s)
    o = t[s], i[o] = s, r.push({
      value: o,
      major: !1
    });
  return a === 0 || !n ? r : Fie(e, r, i, n);
}
class bd extends ll {
  constructor(t) {
    super(t), this._cache = {
      data: [],
      labels: [],
      all: []
    }, this._unit = "day", this._majorUnit = void 0, this._offsets = {}, this._normalized = !1, this._parseOpts = void 0;
  }
  init(t, n) {
    const r = t.time || (t.time = {}), i = this._adapter = new xne._date(t.adapters.date);
    i.init(n), Ac(r.displayFormats, i.formats()), this._parseOpts = {
      parser: r.parser,
      round: r.round,
      isoWeekday: r.isoWeekday
    }, super.init(t), this._normalized = n.normalized;
  }
  parse(t, n) {
    return t === void 0 ? null : TT(this, t);
  }
  beforeLayout() {
    super.beforeLayout(), this._cache = {
      data: [],
      labels: [],
      all: []
    };
  }
  determineDataLimits() {
    const t = this.options, n = this._adapter, r = t.time.unit || "day";
    let { min: i, max: a, minDefined: s, maxDefined: o } = this.getUserBounds();
    function l(c) {
      !s && !isNaN(c.min) && (i = Math.min(i, c.min)), !o && !isNaN(c.max) && (a = Math.max(a, c.max));
    }
    (!s || !o) && (l(this._getLabelBounds()), (t.bounds !== "ticks" || t.ticks.source !== "labels") && l(this.getMinMax(!1))), i = Pn(i) && !isNaN(i) ? i : +n.startOf(Date.now(), r), a = Pn(a) && !isNaN(a) ? a : +n.endOf(Date.now(), r) + 1, this.min = Math.min(i, a - 1), this.max = Math.max(i + 1, a);
  }
  _getLabelBounds() {
    const t = this.getLabelTimestamps();
    let n = Number.POSITIVE_INFINITY, r = Number.NEGATIVE_INFINITY;
    return t.length && (n = t[0], r = t[t.length - 1]), { min: n, max: r };
  }
  buildTicks() {
    const t = this.options, n = t.time, r = t.ticks, i = r.source === "labels" ? this.getLabelTimestamps() : this._generate();
    t.bounds === "ticks" && i.length && (this.min = this._userMin || i[0], this.max = this._userMax || i[i.length - 1]);
    const a = this.min, s = this.max, o = cee(i, a, s);
    return this._unit = n.unit || (r.autoSkip ? AT(n.minUnit, this.min, this.max, this._getLabelCapacity(a)) : Iie(this, o.length, n.minUnit, this.min, this.max)), this._majorUnit = !r.major.enabled || this._unit === "year" ? void 0 : Rie(this._unit), this.initOffsets(i), t.reverse && o.reverse(), ET(this, o, this._majorUnit);
  }
  afterAutoSkip() {
    this.options.offsetAfterAutoskip && this.initOffsets(this.ticks.map((t) => +t.value));
  }
  initOffsets(t) {
    let n = 0, r = 0, i, a;
    this.options.offset && t.length && (i = this.getDecimalForValue(t[0]), t.length === 1 ? n = 1 - i : n = (this.getDecimalForValue(t[1]) - i) / 2, a = this.getDecimalForValue(t[t.length - 1]), t.length === 1 ? r = a : r = (a - this.getDecimalForValue(t[t.length - 2])) / 2);
    const s = t.length < 3 ? 0.5 : 0.25;
    n = vr(n, 0, s), r = vr(r, 0, s), this._offsets = { start: n, end: r, factor: 1 / (n + 1 + r) };
  }
  _generate() {
    const t = this._adapter, n = this.min, r = this.max, i = this.options, a = i.time, s = a.unit || AT(a.minUnit, n, r, this._getLabelCapacity(n)), o = lt(a.stepSize, 1), l = s === "week" ? a.isoWeekday : !1, c = nu(l) || l === !0, f = {};
    let h = n, p, g;
    if (c && (h = +t.startOf(h, "isoWeek", l)), h = +t.startOf(h, c ? "day" : s), t.diff(r, n, s) > 1e5 * o)
      throw new Error(n + " and " + r + " are too far apart with stepSize of " + o + " " + s);
    const v = i.ticks.source === "data" && this.getDataTimestamps();
    for (p = h, g = 0; p < r; p = +t.add(p, o, s), g++)
      DT(f, p, v);
    return (p === r || i.bounds === "ticks" || g === 1) && DT(f, p, v), Object.keys(f).sort((y, S) => y - S).map((y) => +y);
  }
  getLabelForValue(t) {
    const n = this._adapter, r = this.options.time;
    return r.tooltipFormat ? n.format(t, r.tooltipFormat) : n.format(t, r.displayFormats.datetime);
  }
  _tickFormatFunction(t, n, r, i) {
    const a = this.options, s = a.time.displayFormats, o = this._unit, l = this._majorUnit, c = o && s[o], f = l && s[l], h = r[n], p = l && f && h && h.major, g = this._adapter.format(t, i || (p ? f : c)), v = a.ticks.callback;
    return v ? Xt(v, [g, n, r], this) : g;
  }
  generateTickLabels(t) {
    let n, r, i;
    for (n = 0, r = t.length; n < r; ++n)
      i = t[n], i.label = this._tickFormatFunction(i.value, n, t);
  }
  getDecimalForValue(t) {
    return t === null ? NaN : (t - this.min) / (this.max - this.min);
  }
  getPixelForValue(t) {
    const n = this._offsets, r = this.getDecimalForValue(t);
    return this.getPixelForDecimal((n.start + r) * n.factor);
  }
  getValueForPixel(t) {
    const n = this._offsets, r = this.getDecimalForPixel(t) / n.factor - n.end;
    return this.min + r * (this.max - this.min);
  }
  _getLabelSize(t) {
    const n = this.options.ticks, r = this.ctx.measureText(t).width, i = er(this.isHorizontal() ? n.maxRotation : n.minRotation), a = Math.cos(i), s = Math.sin(i), o = this._resolveTickFontOptions(0).size;
    return {
      w: r * a + o * s,
      h: r * s + o * a
    };
  }
  _getLabelCapacity(t) {
    const n = this.options.time, r = n.displayFormats, i = r[n.unit] || r.millisecond, a = this._tickFormatFunction(t, 0, ET(this, [t], this._majorUnit), i), s = this._getLabelSize(a), o = Math.floor(this.isHorizontal() ? this.width / s.w : this.height / s.h) - 1;
    return o > 0 ? o : 1;
  }
  getDataTimestamps() {
    let t = this._cache.data || [], n, r;
    if (t.length)
      return t;
    const i = this.getMatchingVisibleMetas();
    if (this._normalized && i.length)
      return this._cache.data = i[0].controller.getAllParsedValues(this);
    for (n = 0, r = i.length; n < r; ++n)
      t = t.concat(i[n].controller.getAllParsedValues(this));
    return this._cache.data = this.normalize(t);
  }
  getLabelTimestamps() {
    const t = this._cache.labels || [];
    let n, r;
    if (t.length)
      return t;
    const i = this.getLabels();
    for (n = 0, r = i.length; n < r; ++n)
      t.push(TT(this, i[n]));
    return this._cache.labels = this._normalized ? t : this.normalize(t);
  }
  normalize(t) {
    return EM(t.sort(Mie));
  }
}
bd.id = "time";
bd.defaults = {
  bounds: "data",
  adapters: {},
  time: {
    parser: !1,
    unit: !1,
    round: !1,
    isoWeekday: !1,
    minUnit: "millisecond",
    displayFormats: {}
  },
  ticks: {
    source: "auto",
    major: {
      enabled: !1
    }
  }
};
function Kf(e, t, n) {
  let r = 0, i = e.length - 1, a, s, o, l;
  n ? (t >= e[r].pos && t <= e[i].pos && ({ lo: r, hi: i } = as(e, "pos", t)), { pos: a, time: o } = e[r], { pos: s, time: l } = e[i]) : (t >= e[r].time && t <= e[i].time && ({ lo: r, hi: i } = as(e, "time", t)), { time: a, pos: o } = e[r], { time: s, pos: l } = e[i]);
  const c = s - a;
  return c ? o + (l - o) * (t - a) / c : o;
}
class px extends bd {
  constructor(t) {
    super(t), this._table = [], this._minPos = void 0, this._tableRange = void 0;
  }
  initOffsets() {
    const t = this._getTimestampsForTable(), n = this._table = this.buildLookupTable(t);
    this._minPos = Kf(n, this.min), this._tableRange = Kf(n, this.max) - this._minPos, super.initOffsets(t);
  }
  buildLookupTable(t) {
    const { min: n, max: r } = this, i = [], a = [];
    let s, o, l, c, f;
    for (s = 0, o = t.length; s < o; ++s)
      c = t[s], c >= n && c <= r && i.push(c);
    if (i.length < 2)
      return [
        { time: n, pos: 0 },
        { time: r, pos: 1 }
      ];
    for (s = 0, o = i.length; s < o; ++s)
      f = i[s + 1], l = i[s - 1], c = i[s], Math.round((f + l) / 2) !== c && a.push({ time: c, pos: s / (o - 1) });
    return a;
  }
  _getTimestampsForTable() {
    let t = this._cache.all || [];
    if (t.length)
      return t;
    const n = this.getDataTimestamps(), r = this.getLabelTimestamps();
    return n.length && r.length ? t = this.normalize(n.concat(r)) : t = n.length ? n : r, t = this._cache.all = t, t;
  }
  getDecimalForValue(t) {
    return (Kf(this._table, t) - this._minPos) / this._tableRange;
  }
  getValueForPixel(t) {
    const n = this._offsets, r = this.getDecimalForPixel(t) / n.factor - n.end;
    return Kf(this._table, r * this._tableRange + this._minPos, !0);
  }
}
px.id = "timeseries";
px.defaults = bd.defaults;
var Nie = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  CategoryScale: Yh,
  LinearScale: fx,
  LogarithmicScale: hx,
  RadialLinearScale: vd,
  TimeScale: bd,
  TimeSeriesScale: px
});
const mx = [
  yne,
  Ore,
  gie,
  Nie
];
var yI = typeof global == "object" && global && global.Object === Object && global, Lie = typeof self == "object" && self && self.Object === Object && self, Ma = yI || Lie || Function("return this")(), Js = Ma.Symbol, xI = Object.prototype, $ie = xI.hasOwnProperty, Vie = xI.toString, fc = Js ? Js.toStringTag : void 0;
function Bie(e) {
  var t = $ie.call(e, fc), n = e[fc];
  try {
    e[fc] = void 0;
    var r = !0;
  } catch {
  }
  var i = Vie.call(e);
  return r && (t ? e[fc] = n : delete e[fc]), i;
}
var Uie = Object.prototype, qie = Uie.toString;
function jie(e) {
  return qie.call(e);
}
var Wie = "[object Null]", zie = "[object Undefined]", PT = Js ? Js.toStringTag : void 0;
function _d(e) {
  return e == null ? e === void 0 ? zie : Wie : PT && PT in Object(e) ? Bie(e) : jie(e);
}
function Jo(e) {
  return e != null && typeof e == "object";
}
var su = Array.isArray;
function Fp(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Hie = "[object AsyncFunction]", Gie = "[object Function]", Yie = "[object GeneratorFunction]", Kie = "[object Proxy]";
function wI(e) {
  if (!Fp(e))
    return !1;
  var t = _d(e);
  return t == Gie || t == Yie || t == Hie || t == Kie;
}
var sv = Ma["__core-js_shared__"], OT = (function() {
  var e = /[^.]+$/.exec(sv && sv.keys && sv.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
})();
function Xie(e) {
  return !!OT && OT in e;
}
var Zie = Function.prototype, Qie = Zie.toString;
function ul(e) {
  if (e != null) {
    try {
      return Qie.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var Jie = /[\\^$.*+?()[\]{}|]/g, eae = /^\[object .+?Constructor\]$/, tae = Function.prototype, nae = Object.prototype, rae = tae.toString, iae = nae.hasOwnProperty, aae = RegExp(
  "^" + rae.call(iae).replace(Jie, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function sae(e) {
  if (!Fp(e) || Xie(e))
    return !1;
  var t = wI(e) ? aae : eae;
  return t.test(ul(e));
}
function oae(e, t) {
  return e == null ? void 0 : e[t];
}
function cl(e, t) {
  var n = oae(e, t);
  return sae(n) ? n : void 0;
}
var Fy = cl(Ma, "WeakMap"), MT = Object.create, lae = /* @__PURE__ */ (function() {
  function e() {
  }
  return function(t) {
    if (!Fp(t))
      return {};
    if (MT)
      return MT(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
})(), IT = (function() {
  try {
    var e = cl(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
})();
function uae(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r && t(e[n], n, e) !== !1; )
    ;
  return e;
}
var cae = 9007199254740991, dae = /^(?:0|[1-9]\d*)$/;
function fae(e, t) {
  var n = typeof e;
  return t = t ?? cae, !!t && (n == "number" || n != "symbol" && dae.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function hae(e, t, n) {
  t == "__proto__" && IT ? IT(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
function gx(e, t) {
  return e === t || e !== e && t !== t;
}
var pae = Object.prototype, mae = pae.hasOwnProperty;
function gae(e, t, n) {
  var r = e[t];
  (!(mae.call(e, t) && gx(r, n)) || n === void 0 && !(t in e)) && hae(e, t, n);
}
var vae = 9007199254740991;
function kI(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= vae;
}
function SI(e) {
  return e != null && kI(e.length) && !wI(e);
}
var bae = Object.prototype;
function vx(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || bae;
  return e === n;
}
function _ae(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
var yae = "[object Arguments]";
function RT(e) {
  return Jo(e) && _d(e) == yae;
}
var CI = Object.prototype, xae = CI.hasOwnProperty, wae = CI.propertyIsEnumerable, TI = RT(/* @__PURE__ */ (function() {
  return arguments;
})()) ? RT : function(e) {
  return Jo(e) && xae.call(e, "callee") && !wae.call(e, "callee");
};
function kae() {
  return !1;
}
var AI = typeof exports == "object" && exports && !exports.nodeType && exports, FT = AI && typeof module == "object" && module && !module.nodeType && module, Sae = FT && FT.exports === AI, NT = Sae ? Ma.Buffer : void 0, Cae = NT ? NT.isBuffer : void 0, Gc = Cae || kae, Tae = "[object Arguments]", Aae = "[object Array]", Dae = "[object Boolean]", Eae = "[object Date]", Pae = "[object Error]", Oae = "[object Function]", Mae = "[object Map]", Iae = "[object Number]", Rae = "[object Object]", Fae = "[object RegExp]", Nae = "[object Set]", Lae = "[object String]", $ae = "[object WeakMap]", Vae = "[object ArrayBuffer]", Bae = "[object DataView]", Uae = "[object Float32Array]", qae = "[object Float64Array]", jae = "[object Int8Array]", Wae = "[object Int16Array]", zae = "[object Int32Array]", Hae = "[object Uint8Array]", Gae = "[object Uint8ClampedArray]", Yae = "[object Uint16Array]", Kae = "[object Uint32Array]", pn = {};
pn[Uae] = pn[qae] = pn[jae] = pn[Wae] = pn[zae] = pn[Hae] = pn[Gae] = pn[Yae] = pn[Kae] = !0;
pn[Tae] = pn[Aae] = pn[Vae] = pn[Dae] = pn[Bae] = pn[Eae] = pn[Pae] = pn[Oae] = pn[Mae] = pn[Iae] = pn[Rae] = pn[Fae] = pn[Nae] = pn[Lae] = pn[$ae] = !1;
function Xae(e) {
  return Jo(e) && kI(e.length) && !!pn[_d(e)];
}
function bx(e) {
  return function(t) {
    return e(t);
  };
}
var DI = typeof exports == "object" && exports && !exports.nodeType && exports, Mc = DI && typeof module == "object" && module && !module.nodeType && module, Zae = Mc && Mc.exports === DI, ov = Zae && yI.process, ou = (function() {
  try {
    var e = Mc && Mc.require && Mc.require("util").types;
    return e || ov && ov.binding && ov.binding("util");
  } catch {
  }
})(), LT = ou && ou.isTypedArray, _x = LT ? bx(LT) : Xae, Qae = Object.prototype, Jae = Qae.hasOwnProperty;
function ese(e, t) {
  var n = su(e), r = !n && TI(e), i = !n && !r && Gc(e), a = !n && !r && !i && _x(e), s = n || r || i || a, o = s ? _ae(e.length, String) : [], l = o.length;
  for (var c in e)
    Jae.call(e, c) && !(s && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    a && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    fae(c, l))) && o.push(c);
  return o;
}
function EI(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var tse = EI(Object.keys, Object), nse = Object.prototype, rse = nse.hasOwnProperty;
function PI(e) {
  if (!vx(e))
    return tse(e);
  var t = [];
  for (var n in Object(e))
    rse.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
function ise(e) {
  return SI(e) ? ese(e) : PI(e);
}
var Yc = cl(Object, "create");
function ase() {
  this.__data__ = Yc ? Yc(null) : {}, this.size = 0;
}
function sse(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var ose = "__lodash_hash_undefined__", lse = Object.prototype, use = lse.hasOwnProperty;
function cse(e) {
  var t = this.__data__;
  if (Yc) {
    var n = t[e];
    return n === ose ? void 0 : n;
  }
  return use.call(t, e) ? t[e] : void 0;
}
var dse = Object.prototype, fse = dse.hasOwnProperty;
function hse(e) {
  var t = this.__data__;
  return Yc ? t[e] !== void 0 : fse.call(t, e);
}
var pse = "__lodash_hash_undefined__";
function mse(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = Yc && t === void 0 ? pse : t, this;
}
function el(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
el.prototype.clear = ase;
el.prototype.delete = sse;
el.prototype.get = cse;
el.prototype.has = hse;
el.prototype.set = mse;
function gse() {
  this.__data__ = [], this.size = 0;
}
function Np(e, t) {
  for (var n = e.length; n--; )
    if (gx(e[n][0], t))
      return n;
  return -1;
}
var vse = Array.prototype, bse = vse.splice;
function _se(e) {
  var t = this.__data__, n = Np(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : bse.call(t, n, 1), --this.size, !0;
}
function yse(e) {
  var t = this.__data__, n = Np(t, e);
  return n < 0 ? void 0 : t[n][1];
}
function xse(e) {
  return Np(this.__data__, e) > -1;
}
function wse(e, t) {
  var n = this.__data__, r = Np(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
function ps(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
ps.prototype.clear = gse;
ps.prototype.delete = _se;
ps.prototype.get = yse;
ps.prototype.has = xse;
ps.prototype.set = wse;
var Kc = cl(Ma, "Map");
function kse() {
  this.size = 0, this.__data__ = {
    hash: new el(),
    map: new (Kc || ps)(),
    string: new el()
  };
}
function Sse(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function Lp(e, t) {
  var n = e.__data__;
  return Sse(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
function Cse(e) {
  var t = Lp(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function Tse(e) {
  return Lp(this, e).get(e);
}
function Ase(e) {
  return Lp(this, e).has(e);
}
function Dse(e, t) {
  var n = Lp(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
function dl(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
dl.prototype.clear = kse;
dl.prototype.delete = Cse;
dl.prototype.get = Tse;
dl.prototype.has = Ase;
dl.prototype.set = Dse;
function Ese(e, t) {
  for (var n = -1, r = t.length, i = e.length; ++n < r; )
    e[i + n] = t[n];
  return e;
}
var Pse = EI(Object.getPrototypeOf, Object);
function Ose() {
  this.__data__ = new ps(), this.size = 0;
}
function Mse(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
function Ise(e) {
  return this.__data__.get(e);
}
function Rse(e) {
  return this.__data__.has(e);
}
var Fse = 200;
function Nse(e, t) {
  var n = this.__data__;
  if (n instanceof ps) {
    var r = n.__data__;
    if (!Kc || r.length < Fse - 1)
      return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new dl(r);
  }
  return n.set(e, t), this.size = n.size, this;
}
function us(e) {
  var t = this.__data__ = new ps(e);
  this.size = t.size;
}
us.prototype.clear = Ose;
us.prototype.delete = Mse;
us.prototype.get = Ise;
us.prototype.has = Rse;
us.prototype.set = Nse;
var OI = typeof exports == "object" && exports && !exports.nodeType && exports, $T = OI && typeof module == "object" && module && !module.nodeType && module, Lse = $T && $T.exports === OI, VT = Lse ? Ma.Buffer : void 0;
VT && VT.allocUnsafe;
function $se(e, t) {
  return e.slice();
}
function Vse(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, i = 0, a = []; ++n < r; ) {
    var s = e[n];
    t(s, n, e) && (a[i++] = s);
  }
  return a;
}
function Bse() {
  return [];
}
var Use = Object.prototype, qse = Use.propertyIsEnumerable, BT = Object.getOwnPropertySymbols, jse = BT ? function(e) {
  return e == null ? [] : (e = Object(e), Vse(BT(e), function(t) {
    return qse.call(e, t);
  }));
} : Bse;
function Wse(e, t, n) {
  var r = t(e);
  return su(e) ? r : Ese(r, n(e));
}
function Ny(e) {
  return Wse(e, ise, jse);
}
var Ly = cl(Ma, "DataView"), $y = cl(Ma, "Promise"), Vy = cl(Ma, "Set"), UT = "[object Map]", zse = "[object Object]", qT = "[object Promise]", jT = "[object Set]", WT = "[object WeakMap]", zT = "[object DataView]", Hse = ul(Ly), Gse = ul(Kc), Yse = ul($y), Kse = ul(Vy), Xse = ul(Fy), qi = _d;
(Ly && qi(new Ly(new ArrayBuffer(1))) != zT || Kc && qi(new Kc()) != UT || $y && qi($y.resolve()) != qT || Vy && qi(new Vy()) != jT || Fy && qi(new Fy()) != WT) && (qi = function(e) {
  var t = _d(e), n = t == zse ? e.constructor : void 0, r = n ? ul(n) : "";
  if (r)
    switch (r) {
      case Hse:
        return zT;
      case Gse:
        return UT;
      case Yse:
        return qT;
      case Kse:
        return jT;
      case Xse:
        return WT;
    }
  return t;
});
var Zse = Object.prototype, Qse = Zse.hasOwnProperty;
function Jse(e) {
  var t = e.length, n = new e.constructor(t);
  return t && typeof e[0] == "string" && Qse.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
var Xh = Ma.Uint8Array;
function yx(e) {
  var t = new e.constructor(e.byteLength);
  return new Xh(t).set(new Xh(e)), t;
}
function eoe(e, t) {
  var n = yx(e.buffer);
  return new e.constructor(n, e.byteOffset, e.byteLength);
}
var toe = /\w*$/;
function noe(e) {
  var t = new e.constructor(e.source, toe.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var HT = Js ? Js.prototype : void 0, GT = HT ? HT.valueOf : void 0;
function roe(e) {
  return GT ? Object(GT.call(e)) : {};
}
function ioe(e, t) {
  var n = yx(e.buffer);
  return new e.constructor(n, e.byteOffset, e.length);
}
var aoe = "[object Boolean]", soe = "[object Date]", ooe = "[object Map]", loe = "[object Number]", uoe = "[object RegExp]", coe = "[object Set]", doe = "[object String]", foe = "[object Symbol]", hoe = "[object ArrayBuffer]", poe = "[object DataView]", moe = "[object Float32Array]", goe = "[object Float64Array]", voe = "[object Int8Array]", boe = "[object Int16Array]", _oe = "[object Int32Array]", yoe = "[object Uint8Array]", xoe = "[object Uint8ClampedArray]", woe = "[object Uint16Array]", koe = "[object Uint32Array]";
function Soe(e, t, n) {
  var r = e.constructor;
  switch (t) {
    case hoe:
      return yx(e);
    case aoe:
    case soe:
      return new r(+e);
    case poe:
      return eoe(e);
    case moe:
    case goe:
    case voe:
    case boe:
    case _oe:
    case yoe:
    case xoe:
    case woe:
    case koe:
      return ioe(e);
    case ooe:
      return new r();
    case loe:
    case doe:
      return new r(e);
    case uoe:
      return noe(e);
    case coe:
      return new r();
    case foe:
      return roe(e);
  }
}
function Coe(e) {
  return typeof e.constructor == "function" && !vx(e) ? lae(Pse(e)) : {};
}
var Toe = "[object Map]";
function Aoe(e) {
  return Jo(e) && qi(e) == Toe;
}
var YT = ou && ou.isMap, Doe = YT ? bx(YT) : Aoe, Eoe = "[object Set]";
function Poe(e) {
  return Jo(e) && qi(e) == Eoe;
}
var KT = ou && ou.isSet, Ooe = KT ? bx(KT) : Poe, MI = "[object Arguments]", Moe = "[object Array]", Ioe = "[object Boolean]", Roe = "[object Date]", Foe = "[object Error]", II = "[object Function]", Noe = "[object GeneratorFunction]", Loe = "[object Map]", $oe = "[object Number]", RI = "[object Object]", Voe = "[object RegExp]", Boe = "[object Set]", Uoe = "[object String]", qoe = "[object Symbol]", joe = "[object WeakMap]", Woe = "[object ArrayBuffer]", zoe = "[object DataView]", Hoe = "[object Float32Array]", Goe = "[object Float64Array]", Yoe = "[object Int8Array]", Koe = "[object Int16Array]", Xoe = "[object Int32Array]", Zoe = "[object Uint8Array]", Qoe = "[object Uint8ClampedArray]", Joe = "[object Uint16Array]", ele = "[object Uint32Array]", dn = {};
dn[MI] = dn[Moe] = dn[Woe] = dn[zoe] = dn[Ioe] = dn[Roe] = dn[Hoe] = dn[Goe] = dn[Yoe] = dn[Koe] = dn[Xoe] = dn[Loe] = dn[$oe] = dn[RI] = dn[Voe] = dn[Boe] = dn[Uoe] = dn[qoe] = dn[Zoe] = dn[Qoe] = dn[Joe] = dn[ele] = !0;
dn[Foe] = dn[II] = dn[joe] = !1;
function hh(e, t, n, r, i, a) {
  var s;
  if (s !== void 0)
    return s;
  if (!Fp(e))
    return e;
  var o = su(e);
  if (o)
    s = Jse(e);
  else {
    var l = qi(e), c = l == II || l == Noe;
    if (Gc(e))
      return $se(e);
    if (l == RI || l == MI || c && !i)
      s = c ? {} : Coe(e);
    else {
      if (!dn[l])
        return i ? e : {};
      s = Soe(e, l);
    }
  }
  a || (a = new us());
  var f = a.get(e);
  if (f)
    return f;
  a.set(e, s), Ooe(e) ? e.forEach(function(g) {
    s.add(hh(g, t, n, g, e, a));
  }) : Doe(e) && e.forEach(function(g, v) {
    s.set(v, hh(g, t, n, v, e, a));
  });
  var h = Ny, p = o ? void 0 : h(e);
  return uae(p || e, function(g, v) {
    p && (v = g, g = e[v]), gae(s, v, hh(g, t, n, v, e, a));
  }), s;
}
var tle = 1, nle = 4;
function hc(e) {
  return hh(e, tle | nle);
}
var rle = "__lodash_hash_undefined__";
function ile(e) {
  return this.__data__.set(e, rle), this;
}
function ale(e) {
  return this.__data__.has(e);
}
function Zh(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new dl(); ++t < n; )
    this.add(e[t]);
}
Zh.prototype.add = Zh.prototype.push = ile;
Zh.prototype.has = ale;
function sle(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
function ole(e, t) {
  return e.has(t);
}
var lle = 1, ule = 2;
function FI(e, t, n, r, i, a) {
  var s = n & lle, o = e.length, l = t.length;
  if (o != l && !(s && l > o))
    return !1;
  var c = a.get(e), f = a.get(t);
  if (c && f)
    return c == t && f == e;
  var h = -1, p = !0, g = n & ule ? new Zh() : void 0;
  for (a.set(e, t), a.set(t, e); ++h < o; ) {
    var v = e[h], y = t[h];
    if (r)
      var S = s ? r(y, v, h, t, e, a) : r(v, y, h, e, t, a);
    if (S !== void 0) {
      if (S)
        continue;
      p = !1;
      break;
    }
    if (g) {
      if (!sle(t, function(x, E) {
        if (!ole(g, E) && (v === x || i(v, x, n, r, a)))
          return g.push(E);
      })) {
        p = !1;
        break;
      }
    } else if (!(v === y || i(v, y, n, r, a))) {
      p = !1;
      break;
    }
  }
  return a.delete(e), a.delete(t), p;
}
function cle(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r, i) {
    n[++t] = [i, r];
  }), n;
}
function dle(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r) {
    n[++t] = r;
  }), n;
}
var fle = 1, hle = 2, ple = "[object Boolean]", mle = "[object Date]", gle = "[object Error]", vle = "[object Map]", ble = "[object Number]", _le = "[object RegExp]", yle = "[object Set]", xle = "[object String]", wle = "[object Symbol]", kle = "[object ArrayBuffer]", Sle = "[object DataView]", XT = Js ? Js.prototype : void 0, lv = XT ? XT.valueOf : void 0;
function Cle(e, t, n, r, i, a, s) {
  switch (n) {
    case Sle:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case kle:
      return !(e.byteLength != t.byteLength || !a(new Xh(e), new Xh(t)));
    case ple:
    case mle:
    case ble:
      return gx(+e, +t);
    case gle:
      return e.name == t.name && e.message == t.message;
    case _le:
    case xle:
      return e == t + "";
    case vle:
      var o = cle;
    case yle:
      var l = r & fle;
      if (o || (o = dle), e.size != t.size && !l)
        return !1;
      var c = s.get(e);
      if (c)
        return c == t;
      r |= hle, s.set(e, t);
      var f = FI(o(e), o(t), r, i, a, s);
      return s.delete(e), f;
    case wle:
      if (lv)
        return lv.call(e) == lv.call(t);
  }
  return !1;
}
var Tle = 1, Ale = Object.prototype, Dle = Ale.hasOwnProperty;
function Ele(e, t, n, r, i, a) {
  var s = n & Tle, o = Ny(e), l = o.length, c = Ny(t), f = c.length;
  if (l != f && !s)
    return !1;
  for (var h = l; h--; ) {
    var p = o[h];
    if (!(s ? p in t : Dle.call(t, p)))
      return !1;
  }
  var g = a.get(e), v = a.get(t);
  if (g && v)
    return g == t && v == e;
  var y = !0;
  a.set(e, t), a.set(t, e);
  for (var S = s; ++h < l; ) {
    p = o[h];
    var x = e[p], E = t[p];
    if (r)
      var w = s ? r(E, x, p, t, e, a) : r(x, E, p, e, t, a);
    if (!(w === void 0 ? x === E || i(x, E, n, r, a) : w)) {
      y = !1;
      break;
    }
    S || (S = p == "constructor");
  }
  if (y && !S) {
    var C = e.constructor, P = t.constructor;
    C != P && "constructor" in e && "constructor" in t && !(typeof C == "function" && C instanceof C && typeof P == "function" && P instanceof P) && (y = !1);
  }
  return a.delete(e), a.delete(t), y;
}
var Ple = 1, ZT = "[object Arguments]", QT = "[object Array]", Xf = "[object Object]", Ole = Object.prototype, JT = Ole.hasOwnProperty;
function Mle(e, t, n, r, i, a) {
  var s = su(e), o = su(t), l = s ? QT : qi(e), c = o ? QT : qi(t);
  l = l == ZT ? Xf : l, c = c == ZT ? Xf : c;
  var f = l == Xf, h = c == Xf, p = l == c;
  if (p && Gc(e)) {
    if (!Gc(t))
      return !1;
    s = !0, f = !1;
  }
  if (p && !f)
    return a || (a = new us()), s || _x(e) ? FI(e, t, n, r, i, a) : Cle(e, t, l, n, r, i, a);
  if (!(n & Ple)) {
    var g = f && JT.call(e, "__wrapped__"), v = h && JT.call(t, "__wrapped__");
    if (g || v) {
      var y = g ? e.value() : e, S = v ? t.value() : t;
      return a || (a = new us()), i(y, S, n, r, a);
    }
  }
  return p ? (a || (a = new us()), Ele(e, t, n, r, i, a)) : !1;
}
function NI(e, t, n, r, i) {
  return e === t ? !0 : e == null || t == null || !Jo(e) && !Jo(t) ? e !== e && t !== t : Mle(e, t, n, r, NI, i);
}
var Ile = "[object Map]", Rle = "[object Set]", Fle = Object.prototype, Nle = Fle.hasOwnProperty;
function Lle(e) {
  if (e == null)
    return !0;
  if (SI(e) && (su(e) || typeof e == "string" || typeof e.splice == "function" || Gc(e) || _x(e) || TI(e)))
    return !e.length;
  var t = qi(e);
  if (t == Ile || t == Rle)
    return !e.size;
  if (vx(e))
    return !PI(e).length;
  for (var n in e)
    if (Nle.call(e, n))
      return !1;
  return !0;
}
function eA(e, t) {
  return NI(e, t);
}
var $le = Object.defineProperty, Vle = Object.defineProperties, Ble = Object.getOwnPropertyDescriptors, tA = Object.getOwnPropertySymbols, Ule = Object.prototype.hasOwnProperty, qle = Object.prototype.propertyIsEnumerable, nA = (e, t, n) => t in e ? $le(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, jle = (e, t) => {
  for (var n in t || (t = {}))
    Ule.call(t, n) && nA(e, n, t[n]);
  if (tA)
    for (var n of tA(t))
      qle.call(t, n) && nA(e, n, t[n]);
  return e;
}, Wle = (e, t) => Vle(e, Ble(t));
function zle(e) {
  return (e.match(/[a-zA-Z0-9]+/g) || []).map((t) => `${t.charAt(0).toUpperCase()}${t.slice(1)}`).join("");
}
var uo = (e, t) => {
  const n = {
    chartData: { type: Object, required: !0 },
    options: { type: Object, required: !1 },
    chartId: { default: e, type: String },
    width: { default: 400, type: Number },
    height: { default: 400, type: Number },
    cssClasses: { type: String, default: "" },
    styles: { type: Object },
    plugins: { type: Array, default: () => [] },
    onLabelsUpdate: { type: Function },
    onChartUpdate: { type: Function },
    onChartDestroy: { type: Function },
    onChartRender: { type: Function }
  }, r = zle(e);
  return dt({
    name: r,
    props: n,
    emits: {
      "labels:update": () => !0,
      "chart:update": (i) => !0,
      "chart:destroy": () => !0,
      "chart:render": (i) => !0
    },
    setup(i, { emit: a, expose: s }) {
      const o = ge(null), l = `${i.chartId}`;
      let c = rp(null);
      Ln(() => i.chartData, f, { deep: !0 }), Ln(() => i.options, (S) => {
        c.value && S && (c.value.options = hc(S), v());
      }, { deep: !0 });
      function f(S) {
        if (c.value) {
          let x = c.value;
          eA(S.labels, c.value.data.labels) || (x.data.labels = S.labels, p()), eA(S.datasets, c.value.data.datasets) || S.datasets.forEach((E, w) => {
            var C, P;
            if (Lle(E))
              x.data.datasets = [];
            else {
              const M = hc(x.data), T = Object.keys((P = (C = M.datasets) == null ? void 0 : C[w]) != null ? P : {}), N = Object.keys(E);
              T.filter((ne) => ne !== "_meta" && N.indexOf(ne) === -1).forEach((ne) => {
                x.data.datasets[w] && delete x.data.datasets[w][ne];
              });
              for (const ne in E) {
                const Y = hc(E[ne]);
                x.data.datasets[w] || (x.data.datasets[w] = {}), E.hasOwnProperty(ne) && Y != null && x && (x.data.datasets[w][ne] = Y);
              }
            }
          }), v();
        } else
          c.value && y(), h();
      }
      function h() {
        o.value ? (c.value = new ls(o.value, {
          data: hc(i.chartData),
          type: t,
          options: hc(i.options),
          plugins: i.plugins
        }), g()) : console.error(`Error on component ${r}, canvas cannot be rendered. Check if the render appends server-side`);
      }
      function p() {
        a("labels:update"), i.onLabelsUpdate && i.onLabelsUpdate();
      }
      function g() {
        c.value && (a("chart:render", c.value), i.onChartRender && i.onChartRender(c.value));
      }
      function v() {
        c.value && (c.value.update(), a("chart:update", c.value), i.onChartUpdate && i.onChartUpdate(c.value));
      }
      function y() {
        c.value && c.value.destroy(), a("chart:destroy"), i.onChartDestroy && i.onChartDestroy();
      }
      return Ft(h), Y5(() => {
        c.value && c.value.destroy();
      }), s({
        canvasRef: o,
        renderChart: h,
        chartInstance: c,
        canvasId: l,
        update: v
      }), () => $t("div", {
        style: Wle(jle({
          maxWidth: "100%"
        }, i.styles), {
          position: "relative"
        }),
        class: i.cssClasses
      }, [
        $t("canvas", {
          style: {
            maxWidth: "100%",
            maxHeight: "100%"
          },
          id: l,
          width: i.width,
          height: i.height,
          ref: o
        })
      ]);
    }
  });
}, Hle = uo("bar-chart", "bar");
uo("doughnut-chart", "doughnut");
var Gle = uo("line-chart", "line"), Yle = uo("pie-chart", "pie");
uo("polar-chart", "polarArea");
uo("radar-chart", "radar");
uo("bubble-chart", "bubble");
uo("scatter-chart", "scatter");
/*!
* chartjs-plugin-annotation v2.0.1
* https://www.chartjs.org/chartjs-plugin-annotation/index
 * (c) 2022 chartjs-plugin-annotation Contributors
 * Released under the MIT License
 */
const rA = {
  modes: {
    /**
     * Point mode returns all elements that hit test based on the event position
     * @param {Object} state - the state of the plugin
     * @param {ChartEvent} event - the event we are find things at
     * @return {AnnotationElement[]} - elements that are found
     */
    point(e, t) {
      return ph(e, t, { intersect: !0 });
    },
    /**
     * Nearest mode returns the element closest to the event position
     * @param {Object} state - the state of the plugin
     * @param {ChartEvent} event - the event we are find things at
     * @param {Object} options - interaction options to use
     * @return {AnnotationElement[]} - elements that are found (only 1 element)
     */
    nearest(e, t, n) {
      return Zle(e, t, n);
    },
    /**
     * x mode returns the elements that hit-test at the current x coordinate
     * @param {Object} state - the state of the plugin
     * @param {ChartEvent} event - the event we are find things at
     * @param {Object} options - interaction options to use
     * @return {AnnotationElement[]} - elements that are found
     */
    x(e, t, n) {
      return ph(e, t, { intersect: n.intersect, axis: "x" });
    },
    /**
     * y mode returns the elements that hit-test at the current y coordinate
     * @param {Object} state - the state of the plugin
     * @param {ChartEvent} event - the event we are find things at
     * @param {Object} options - interaction options to use
     * @return {AnnotationElement[]} - elements that are found
     */
    y(e, t, n) {
      return ph(e, t, { intersect: n.intersect, axis: "y" });
    }
  }
};
function xx(e, t, n) {
  return (rA.modes[n.mode] || rA.modes.nearest)(e, t, n);
}
function Kle(e, t, n) {
  return n !== "x" && n !== "y" ? e.inRange(t.x, t.y, "x", !0) || e.inRange(t.x, t.y, "y", !0) : e.inRange(t.x, t.y, n, !0);
}
function Xle(e, t, n) {
  return n === "x" ? { x: e.x, y: t.y } : n === "y" ? { x: t.x, y: e.y } : t;
}
function ph(e, t, n) {
  return e.visibleElements.filter((r) => n.intersect ? r.inRange(t.x, t.y) : Kle(r, t, n.axis));
}
function Zle(e, t, n) {
  let r = Number.POSITIVE_INFINITY;
  return ph(e, t, n).reduce((i, a) => {
    const s = a.getCenterPoint(), o = Xle(t, s, n.axis), l = jc(t, o);
    return l < r ? (i = [a], r = l) : l === r && i.push(a), i;
  }, []).sort((i, a) => i._index - a._index).slice(0, 1);
}
const By = ["enter", "leave"], wx = By.concat("click");
function Qle(e, t, n) {
  t.listened = !1, t.moveListened = !1, t._getElements = xx, wx.forEach((r) => {
    typeof n[r] == "function" ? (t.listened = !0, t.listeners[r] = n[r]) : zn(t.listeners[r]) && delete t.listeners[r];
  }), By.forEach((r) => {
    typeof n[r] == "function" && (t.moveListened = !0);
  }), (!t.listened || !t.moveListened) && t.annotations.forEach((r) => {
    !t.listened && typeof r.click == "function" && (t.listened = !0), t.moveListened || By.forEach((i) => {
      typeof r[i] == "function" && (t.listened = !0, t.moveListened = !0);
    });
  });
}
function Jle(e, t, n) {
  if (e.listened)
    switch (t.type) {
      case "mousemove":
      case "mouseout":
        return eue(e, t, n);
      case "click":
        return tue(e, t, n);
    }
}
function eue(e, t, n) {
  if (!e.moveListened)
    return;
  let r;
  t.type === "mousemove" ? r = xx(e, t, n.interaction) : r = [];
  const i = e.hovered;
  e.hovered = r;
  const a = { state: e, event: t };
  let s = iA(a, "leave", i, r);
  return iA(a, "enter", r, i) || s;
}
function iA({ state: e, event: t }, n, r, i) {
  let a;
  for (const s of r)
    i.indexOf(s) < 0 && (a = LI(s.options[n] || e.listeners[n], s, t) || a);
  return a;
}
function tue(e, t, n) {
  const r = e.listeners, i = xx(e, t, n.interaction);
  let a;
  for (const s of i)
    a = LI(s.options.click || r.click, s, t) || a;
  return a;
}
function LI(e, t, n) {
  return Xt(e, [t.$context, n]) === !0;
}
const nue = (e, t) => t > e || e.length > t.length && e.slice(0, t.length) === t, Bo = 1e-3, kx = (e, t, n) => Math.min(n, Math.max(t, e));
function rue(e, t, n) {
  for (const r of Object.keys(e))
    e[r] = kx(e[r], t, n);
  return e;
}
function iue(e, t, n, r) {
  if (!e || !t || n <= 0)
    return !1;
  const i = r / 2;
  return Math.pow(e.x - t.x, 2) + Math.pow(e.y - t.y, 2) <= Math.pow(n + i, 2);
}
function $I(e, { x: t, y: n, x2: r, y2: i }, a, s) {
  const o = s / 2, l = e.x >= t - o - Bo && e.x <= r + o + Bo, c = e.y >= n - o - Bo && e.y <= i + o + Bo;
  return a === "x" ? l : (a === "y" || l) && c;
}
function gu(e, t) {
  const { centerX: n, centerY: r } = e.getProps(["centerX", "centerY"], t);
  return { x: n, y: r };
}
function aue(e, t, n, r = !0) {
  const i = n.split(".");
  let a = 0;
  for (const s of t.split(".")) {
    const o = i[a++];
    if (parseInt(s, 10) < parseInt(o, 10))
      break;
    if (nue(o, s)) {
      if (r)
        throw new Error(`${e} v${n} is not supported. v${t} or newer is required.`);
      return !1;
    }
  }
  return !0;
}
const VI = (e) => typeof e == "string" && e.endsWith("%"), BI = (e) => kx(parseFloat(e) / 100, 0, 1);
function Sx(e, t) {
  return t === "start" ? 0 : t === "end" ? e : VI(t) ? BI(t) * e : e / 2;
}
function lu(e, t) {
  return typeof t == "number" ? t : VI(t) ? BI(t) * e : e;
}
function sue(e, t) {
  const { x: n, width: r } = e, i = t.textAlign;
  return i === "center" ? n + r / 2 : i === "end" || i === "right" ? n + r : n;
}
function UI(e) {
  return _t(e) ? {
    x: lt(e.x, "center"),
    y: lt(e.y, "center")
  } : (e = lt(e, "center"), {
    x: e,
    y: e
  });
}
function qI(e) {
  return e && (zn(e.xValue) || zn(e.yValue));
}
const uv = /* @__PURE__ */ new Map();
function Cx(e) {
  if (e && typeof e == "object") {
    const t = e.toString();
    return t === "[object HTMLImageElement]" || t === "[object HTMLCanvasElement]";
  }
}
function Tx(e, { x: t, y: n }, r) {
  r && (e.translate(t, n), e.rotate(er(r)), e.translate(-t, -n));
}
function fl(e, t) {
  if (t && t.borderWidth)
    return e.lineCap = t.borderCapStyle, e.setLineDash(t.borderDash), e.lineDashOffset = t.borderDashOffset, e.lineJoin = t.borderJoinStyle, e.lineWidth = t.borderWidth, e.strokeStyle = t.borderColor, !0;
}
function vu(e, t) {
  e.shadowColor = t.backgroundShadowColor, e.shadowBlur = t.shadowBlur, e.shadowOffsetX = t.shadowOffsetX, e.shadowOffsetY = t.shadowOffsetY;
}
function Ax(e, t) {
  const n = t.content;
  if (Cx(n))
    return {
      width: lu(n.width, t.width),
      height: lu(n.height, t.height)
    };
  const r = Fn(t.font), i = t.textStrokeWidth, a = Zt(n) ? n : [n], s = a.join() + r.string + i + (e._measureText ? "-spriting" : "");
  if (!uv.has(s)) {
    e.save(), e.font = r.string;
    const o = a.length;
    let l = 0;
    for (let f = 0; f < o; f++) {
      const h = a[f];
      l = Math.max(l, e.measureText(h).width + i);
    }
    e.restore();
    const c = o * r.lineHeight + i;
    uv.set(s, { width: l, height: c });
  }
  return uv.get(s);
}
function jI(e, t, n) {
  const { x: r, y: i, width: a, height: s } = t;
  e.save(), vu(e, n);
  const o = fl(e, n);
  e.fillStyle = n.backgroundColor, e.beginPath(), ru(e, {
    x: r,
    y: i,
    w: a,
    h: s,
    radius: rue(Gs(n.borderRadius), 0, Math.min(a, s) / 2)
  }), e.closePath(), e.fill(), o && (e.shadowColor = n.borderShadowColor, e.stroke()), e.restore();
}
function oue(e, t, n) {
  const r = n.content;
  if (Cx(r)) {
    e.drawImage(r, t.x, t.y, t.width, t.height);
    return;
  }
  const i = Zt(r) ? r : [r], a = Fn(n.font), s = a.lineHeight, o = sue(t, n), l = t.y + s / 2 + n.textStrokeWidth / 2;
  e.save(), e.font = a.string, e.textBaseline = "middle", e.textAlign = n.textAlign, lue(e, n) && i.forEach((c, f) => e.strokeText(c, o, l + f * s)), e.fillStyle = n.color, i.forEach((c, f) => e.fillText(c, o, l + f * s)), e.restore();
}
function lue(e, t) {
  if (t.textStrokeWidth > 0)
    return e.lineJoin = "round", e.miterLimit = 2, e.lineWidth = t.textStrokeWidth, e.strokeStyle = t.textStrokeColor, !0;
}
function uu(e, t, n) {
  return t = typeof t == "number" ? t : e.parse(t), Pn(t) ? e.getPixelForValue(t) : n;
}
function eo(e, t, n) {
  const r = t[n];
  if (r || n === "scaleID")
    return r;
  const i = n.charAt(0), a = Object.values(e).filter((s) => s.axis && s.axis === i);
  return a.length ? a[0].id : i;
}
function WI(e, t) {
  if (e) {
    const n = e.options.reverse, r = uu(e, t.min, n ? t.end : t.start), i = uu(e, t.max, n ? t.start : t.end);
    return {
      start: r,
      end: i
    };
  }
}
function zI(e, t) {
  const { chartArea: n, scales: r } = e, i = r[eo(r, t, "xScaleID")], a = r[eo(r, t, "yScaleID")];
  let s = n.width / 2, o = n.height / 2;
  return i && (s = uu(i, t.xValue, i.left + i.width / 2)), a && (o = uu(a, t.yValue, a.top + a.height / 2)), { x: s, y: o };
}
function $p(e, t) {
  const n = e.scales, r = n[eo(n, t, "xScaleID")], i = n[eo(n, t, "yScaleID")];
  if (!r && !i)
    return {};
  let { left: a, right: s } = r || e.chartArea, { top: o, bottom: l } = i || e.chartArea;
  const c = aA(r, { min: t.xMin, max: t.xMax, start: a, end: s });
  a = c.start, s = c.end;
  const f = aA(i, { min: t.yMin, max: t.yMax, start: l, end: o });
  return o = f.start, l = f.end, {
    x: a,
    y: o,
    x2: s,
    y2: l,
    width: s - a,
    height: l - o,
    centerX: a + (s - a) / 2,
    centerY: o + (l - o) / 2
  };
}
function HI(e, t) {
  if (!qI(t)) {
    const n = $p(e, t);
    let r = t.radius;
    (!r || isNaN(r)) && (r = Math.min(n.width, n.height) / 2, t.radius = r);
    const i = r * 2;
    return {
      x: n.x + t.xAdjust,
      y: n.y + t.yAdjust,
      x2: n.x + i + t.xAdjust,
      y2: n.y + i + t.yAdjust,
      centerX: n.centerX + t.xAdjust,
      centerY: n.centerY + t.yAdjust,
      width: i,
      height: i
    };
  }
  return uue(e, t);
}
function uue(e, t) {
  const n = zI(e, t), r = t.radius * 2;
  return {
    x: n.x - t.radius + t.xAdjust,
    y: n.y - t.radius + t.yAdjust,
    x2: n.x + t.radius + t.xAdjust,
    y2: n.y + t.radius + t.yAdjust,
    centerX: n.x + t.xAdjust,
    centerY: n.y + t.yAdjust,
    width: r,
    height: r
  };
}
function aA(e, t) {
  const n = WI(e, t) || t;
  return {
    start: Math.min(n.start, n.end),
    end: Math.max(n.start, n.end)
  };
}
function bu(e, t, n) {
  const r = Math.cos(n), i = Math.sin(n), a = t.x, s = t.y;
  return {
    x: a + r * (e.x - a) - i * (e.y - s),
    y: s + i * (e.x - a) + r * (e.y - s)
  };
}
function cue(e, t, n) {
  const r = mue(e.scales, t, n);
  let i = sA(t, r, "min", "suggestedMin");
  i = sA(t, r, "max", "suggestedMax") || i, i && typeof t.handleTickRangeOptions == "function" && t.handleTickRangeOptions();
}
function due(e, t) {
  for (const n of e)
    hue(n, t);
}
function sA(e, t, n, r) {
  if (Pn(t[n]) && !fue(e.options, n, r)) {
    const i = e[n] !== t[n];
    return e[n] = t[n], i;
  }
}
function fue(e, t, n) {
  return zn(e[t]) || zn(e[n]);
}
function hue(e, t) {
  for (const n of ["scaleID", "xScaleID", "yScaleID"]) {
    const r = eo(t, e, n);
    r && !t[r] && pue(e, n) && console.warn(`No scale found with id '${r}' for annotation '${e.id}'`);
  }
}
function pue(e, t) {
  if (t === "scaleID")
    return !0;
  const n = t.charAt(0);
  for (const r of ["Min", "Max", "Value"])
    if (zn(e[n + r]))
      return !0;
  return !1;
}
function mue(e, t, n) {
  const r = t.axis, i = t.id, a = r + "ScaleID", s = {
    min: lt(t.min, Number.NEGATIVE_INFINITY),
    max: lt(t.max, Number.POSITIVE_INFINITY)
  };
  for (const o of n)
    o.scaleID === i ? oA(o, t, ["value", "endValue"], s) : eo(e, o, a) === i && oA(o, t, [r + "Min", r + "Max", r + "Value"], s);
  return s;
}
function oA(e, t, n, r) {
  for (const i of n) {
    const a = e[i];
    if (zn(a)) {
      const s = t.parse(a);
      r.min = Math.min(r.min, s), r.max = Math.max(r.max, s);
    }
  }
}
class yd extends Ar {
  inRange(t, n, r, i) {
    const { x: a, y: s } = bu({ x: t, y: n }, this.getCenterPoint(i), er(-this.options.rotation));
    return $I({ x: a, y: s }, this.getProps(["x", "y", "x2", "y2"], i), r, this.options.borderWidth);
  }
  getCenterPoint(t) {
    return gu(this, t);
  }
  draw(t) {
    t.save(), Tx(t, this.getCenterPoint(), this.options.rotation), jI(t, this, this.options), t.restore();
  }
  get label() {
    return this.elements && this.elements[0];
  }
  resolveElementProperties(t, n) {
    const r = $p(t, n), { x: i, y: a } = r;
    return r.elements = [{
      type: "label",
      optionScope: "label",
      properties: bue(t, r, n)
    }], r.initProperties = { x: i, y: a }, r;
  }
}
yd.id = "boxAnnotation";
yd.defaults = {
  adjustScaleRange: !0,
  backgroundShadowColor: "transparent",
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderRadius: 0,
  borderShadowColor: "transparent",
  borderWidth: 1,
  display: !0,
  label: {
    backgroundColor: "transparent",
    borderWidth: 0,
    callout: {
      display: !1
    },
    color: "black",
    content: null,
    display: !1,
    drawTime: void 0,
    font: {
      family: void 0,
      lineHeight: void 0,
      size: void 0,
      style: void 0,
      weight: "bold"
    },
    height: void 0,
    padding: 6,
    position: "center",
    rotation: void 0,
    textAlign: "start",
    textStrokeColor: void 0,
    textStrokeWidth: 0,
    width: void 0,
    xAdjust: 0,
    yAdjust: 0,
    z: void 0
  },
  rotation: 0,
  shadowBlur: 0,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  xMax: void 0,
  xMin: void 0,
  xScaleID: void 0,
  yMax: void 0,
  yMin: void 0,
  yScaleID: void 0,
  z: 0
};
yd.defaultRoutes = {
  borderColor: "color",
  backgroundColor: "color"
};
yd.descriptors = {
  label: {
    _fallback: !0
  }
};
function gue({ properties: e, options: t }, n, r, i) {
  const { x: a, x2: s, width: o } = e;
  return GI({ start: a, end: s, borderWidth: t.borderWidth }, {
    position: r.x,
    padding: { start: i.left, end: i.right },
    adjust: t.label.xAdjust,
    size: n.width
  });
}
function vue({ properties: e, options: t }, n, r, i) {
  const { y: a, y2: s, height: o } = e;
  return GI({ start: a, end: s, borderWidth: t.borderWidth }, {
    position: r.y,
    padding: { start: i.top, end: i.bottom },
    adjust: t.label.yAdjust,
    size: n.height
  });
}
function GI(e, t) {
  const { start: n, end: r, borderWidth: i } = e, { position: a, padding: { start: s, end: o }, adjust: l } = t, c = r - i - n - s - o - t.size;
  return n + i / 2 + l + Sx(c, a);
}
function bue(e, t, n) {
  const r = n.label;
  r.backgroundColor = "transparent", r.callout.display = !1;
  const i = UI(r.position), a = Hn(r.padding), s = Ax(e.ctx, r), o = gue({ properties: t, options: n }, s, i, a), l = vue({ properties: t, options: n }, s, i, a), c = s.width + a.width, f = s.height + a.height;
  return {
    x: o,
    y: l,
    x2: o + c,
    y2: l + f,
    width: c,
    height: f,
    centerX: o + c / 2,
    centerY: l + f / 2,
    rotation: r.rotation
  };
}
const Dx = (e, t, n) => ({ x: e.x + n * (t.x - e.x), y: e.y + n * (t.y - e.y) }), Uy = (e, t, n) => Dx(t, n, Math.abs((e - t.y) / (n.y - t.y))).x, lA = (e, t, n) => Dx(t, n, Math.abs((e - t.x) / (n.x - t.x))).y, _c = (e) => e * e, _ue = (e, t, { x: n, y: r, x2: i, y2: a }, s) => s === "y" ? { start: Math.min(r, a), end: Math.max(r, a), value: t } : { start: Math.min(n, i), end: Math.max(n, i), value: e };
class xd extends Ar {
  inRange(t, n, r, i) {
    const a = this.options.borderWidth / 2;
    if (r !== "x" && r !== "y") {
      const o = _c(a), l = { mouseX: t, mouseY: n };
      return wue(this, l, o, i) || dA(this, l, i);
    }
    const s = _ue(t, n, this.getProps(["x", "y", "x2", "y2"], i), r);
    return s.value >= s.start - a && s.value <= s.end + a || dA(this, { mouseX: t, mouseY: n }, i, r);
  }
  getCenterPoint(t) {
    return gu(this, t);
  }
  draw(t) {
    const { x: n, y: r, x2: i, y2: a, options: s } = this;
    if (t.save(), !fl(t, s))
      return t.restore();
    vu(t, s);
    const o = Math.atan2(a - r, i - n), l = Math.sqrt(Math.pow(i - n, 2) + Math.pow(a - r, 2)), { startOpts: c, endOpts: f, startAdjust: h, endAdjust: p } = Eue(this);
    t.translate(n, r), t.rotate(o), t.beginPath(), t.moveTo(0 + h, 0), t.lineTo(l - p, 0), t.shadowColor = s.borderShadowColor, t.stroke(), gA(t, 0, h, c), gA(t, l, -p, f), t.restore();
  }
  get label() {
    return this.elements && this.elements[0];
  }
  resolveElementProperties(t, n) {
    const { scales: r, chartArea: i } = t, a = r[n.scaleID], s = { x: i.left, y: i.top, x2: i.right, y2: i.bottom };
    let o, l;
    if (a)
      o = uu(a, n.value, NaN), l = uu(a, n.endValue, o), a.isHorizontal() ? (s.x = o, s.x2 = l) : (s.y = o, s.y2 = l);
    else {
      const S = r[eo(r, n, "xScaleID")], x = r[eo(r, n, "yScaleID")];
      S && fA(s, S, { min: n.xMin, max: n.xMax, start: S.left, end: S.right, startProp: "x", endProp: "x2" }), x && fA(s, x, { min: n.yMin, max: n.yMax, start: x.bottom, end: x.top, startProp: "y", endProp: "y2" });
    }
    const { x: c, y: f, x2: h, y2: p } = s, g = yue(s, t.chartArea), v = g ? xue({ x: c, y: f }, { x: h, y: p }, t.chartArea) : { x: c, y: f, x2: h, y2: p, width: Math.abs(h - c), height: Math.abs(p - f) };
    v.centerX = (h + c) / 2, v.centerY = (p + f) / 2;
    const y = kue(t, v, n.label);
    return y._visible = g, v.elements = [{
      type: "label",
      optionScope: "label",
      properties: y
    }], v;
  }
}
xd.id = "lineAnnotation";
const uA = {
  backgroundColor: void 0,
  backgroundShadowColor: void 0,
  borderColor: void 0,
  borderDash: void 0,
  borderDashOffset: void 0,
  borderShadowColor: void 0,
  borderWidth: void 0,
  display: void 0,
  fill: void 0,
  length: void 0,
  shadowBlur: void 0,
  shadowOffsetX: void 0,
  shadowOffsetY: void 0,
  width: void 0
};
xd.defaults = {
  adjustScaleRange: !0,
  arrowHeads: {
    display: !1,
    end: Object.assign({}, uA),
    fill: !1,
    length: 12,
    start: Object.assign({}, uA),
    width: 6
  },
  borderDash: [],
  borderDashOffset: 0,
  borderShadowColor: "transparent",
  borderWidth: 2,
  display: !0,
  endValue: void 0,
  label: {
    backgroundColor: "rgba(0,0,0,0.8)",
    backgroundShadowColor: "transparent",
    borderCapStyle: "butt",
    borderColor: "black",
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: "miter",
    borderRadius: 6,
    borderShadowColor: "transparent",
    borderWidth: 0,
    callout: {
      display: !1
    },
    color: "#fff",
    content: null,
    display: !1,
    drawTime: void 0,
    font: {
      family: void 0,
      lineHeight: void 0,
      size: void 0,
      style: void 0,
      weight: "bold"
    },
    height: void 0,
    padding: 6,
    position: "center",
    rotation: 0,
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    textAlign: "center",
    textStrokeColor: void 0,
    textStrokeWidth: 0,
    width: void 0,
    xAdjust: 0,
    yAdjust: 0,
    z: void 0
  },
  scaleID: void 0,
  shadowBlur: 0,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  value: void 0,
  xMax: void 0,
  xMin: void 0,
  xScaleID: void 0,
  yMax: void 0,
  yMin: void 0,
  yScaleID: void 0,
  z: 0
};
xd.descriptors = {
  arrowHeads: {
    start: {
      _fallback: !0
    },
    end: {
      _fallback: !0
    },
    _fallback: !0
  }
};
xd.defaultRoutes = {
  borderColor: "color"
};
function yue({ x: e, y: t, x2: n, y2: r }, { top: i, right: a, bottom: s, left: o }) {
  return !(e < o && n < o || e > a && n > a || t < i && r < i || t > s && r > s);
}
function cA({ x: e, y: t }, n, { top: r, right: i, bottom: a, left: s }) {
  return e < s && (t = lA(s, { x: e, y: t }, n), e = s), e > i && (t = lA(i, { x: e, y: t }, n), e = i), t < r && (e = Uy(r, { x: e, y: t }, n), t = r), t > a && (e = Uy(a, { x: e, y: t }, n), t = a), { x: e, y: t };
}
function xue(e, t, n) {
  const { x: r, y: i } = cA(e, t, n), { x: a, y: s } = cA(t, e, n);
  return { x: r, y: i, x2: a, y2: s, width: Math.abs(a - r), height: Math.abs(s - i) };
}
function wue(e, { mouseX: t, mouseY: n }, r = Bo, i) {
  const { x: a, y: s, x2: o, y2: l } = e.getProps(["x", "y", "x2", "y2"], i), c = o - a, f = l - s, h = _c(c) + _c(f), p = h === 0 ? -1 : ((t - a) * c + (n - s) * f) / h;
  let g, v;
  return p < 0 ? (g = a, v = s) : p > 1 ? (g = o, v = l) : (g = a + p * c, v = s + p * f), _c(t - g) + _c(n - v) <= r;
}
function dA(e, { mouseX: t, mouseY: n }, r, i) {
  const a = e.label;
  return a.options.display && a.inRange(t, n, i, r);
}
function fA(e, t, n) {
  const r = WI(t, n);
  e[n.startProp] = r.start, e[n.endProp] = r.end;
}
function kue(e, t, n) {
  n.callout.display = !1;
  const r = n.borderWidth, i = Hn(n.padding), a = Ax(e.ctx, n), s = a.width + i.width + r, o = a.height + i.height + r;
  return Cue(t, n, { width: s, height: o, padding: i }, e.chartArea);
}
function Sue(e) {
  const { x: t, y: n, x2: r, y2: i } = e, a = Math.atan2(i - n, r - t);
  return a > Wt / 2 ? a - Wt : a < Wt / -2 ? a + Wt : a;
}
function Cue(e, t, n, r) {
  const { width: i, height: a, padding: s } = n, { xAdjust: o, yAdjust: l } = t, c = { x: e.x, y: e.y }, f = { x: e.x2, y: e.y2 }, h = t.rotation === "auto" ? Sue(e) : er(t.rotation), p = Tue(i, a, h), g = Aue(e, t, { labelSize: p, padding: s }, r), v = Dx(c, f, g), y = { size: p.w, min: r.left, max: r.right, padding: s.left }, S = { size: p.h, min: r.top, max: r.bottom, padding: s.top }, x = pA(v.x, y) + o, E = pA(v.y, S) + l;
  return {
    x: x - i / 2,
    y: E - a / 2,
    x2: x + i / 2,
    y2: E + a / 2,
    centerX: x,
    centerY: E,
    width: i,
    height: a,
    rotation: Sp(h)
  };
}
function Tue(e, t, n) {
  const r = Math.cos(n), i = Math.sin(n);
  return {
    w: Math.abs(e * r) + Math.abs(t * i),
    h: Math.abs(e * i) + Math.abs(t * r)
  };
}
function Aue(e, t, n, r) {
  let i;
  const a = Due(e, r);
  return t.position === "start" ? i = hA({ w: e.x2 - e.x, h: e.y2 - e.y }, n, t, a) : t.position === "end" ? i = 1 - hA({ w: e.x - e.x2, h: e.y - e.y2 }, n, t, a) : i = Sx(1, t.position), i;
}
function hA(e, t, n, r) {
  const { labelSize: i, padding: a } = t, s = e.w * r.dx, o = e.h * r.dy, l = s > 0 && (i.w / 2 + a.left - r.x) / s, c = o > 0 && (i.h / 2 + a.top - r.y) / o;
  return kx(Math.max(l, c), 0, 0.25);
}
function Due(e, t) {
  const { x: n, x2: r, y: i, y2: a } = e, s = Math.min(i, a) - t.top, o = Math.min(n, r) - t.left, l = t.bottom - Math.max(i, a), c = t.right - Math.max(n, r);
  return {
    x: Math.min(o, c),
    y: Math.min(s, l),
    dx: o <= c ? 1 : -1,
    dy: s <= l ? 1 : -1
  };
}
function pA(e, t) {
  const { size: n, min: r, max: i, padding: a } = t, s = n / 2;
  return n > i - r ? (i + r) / 2 : (r >= e - a - s && (e = r + a + s), i <= e + a + s && (e = i - a - s), e);
}
function Eue(e) {
  const t = e.options, n = t.arrowHeads && t.arrowHeads.start, r = t.arrowHeads && t.arrowHeads.end;
  return {
    startOpts: n,
    endOpts: r,
    startAdjust: mA(e, n),
    endAdjust: mA(e, r)
  };
}
function mA(e, t) {
  if (!t || !t.display)
    return 0;
  const { length: n, width: r } = t, i = e.options.borderWidth / 2, a = { x: n, y: r + i };
  return Math.abs(Uy(0, a, { x: 0, y: i }));
}
function gA(e, t, n, r) {
  if (!r || !r.display)
    return;
  const { length: i, width: a, fill: s, backgroundColor: o, borderColor: l } = r, c = Math.abs(t - i) + n;
  e.beginPath(), vu(e, r), fl(e, r), e.moveTo(c, -a), e.lineTo(t + n, 0), e.lineTo(c, a), s === !0 ? (e.fillStyle = o || l, e.closePath(), e.fill(), e.shadowColor = "transparent") : e.shadowColor = r.borderShadowColor, e.stroke();
}
class Vp extends Ar {
  inRange(t, n, r, i) {
    const a = this.options.rotation, s = this.options.borderWidth;
    if (r !== "x" && r !== "y")
      return Pue({ x: t, y: n }, this.getProps(["width", "height", "centerX", "centerY"], i), a, s);
    const { x: o, y: l, x2: c, y2: f } = this.getProps(["x", "y", "x2", "y2"], i), h = s / 2, p = r === "y" ? { start: l, end: f } : { start: o, end: c }, g = bu({ x: t, y: n }, this.getCenterPoint(i), er(-a));
    return g[r] >= p.start - h - Bo && g[r] <= p.end + h + Bo;
  }
  getCenterPoint(t) {
    return gu(this, t);
  }
  draw(t) {
    const { width: n, height: r, centerX: i, centerY: a, options: s } = this;
    t.save(), Tx(t, this.getCenterPoint(), s.rotation), vu(t, this.options), t.beginPath(), t.fillStyle = s.backgroundColor;
    const o = fl(t, s);
    t.ellipse(i, a, r / 2, n / 2, Wt / 2, 0, 2 * Wt), t.fill(), o && (t.shadowColor = s.borderShadowColor, t.stroke()), t.restore();
  }
  resolveElementProperties(t, n) {
    return $p(t, n);
  }
}
Vp.id = "ellipseAnnotation";
Vp.defaults = {
  adjustScaleRange: !0,
  backgroundShadowColor: "transparent",
  borderDash: [],
  borderDashOffset: 0,
  borderShadowColor: "transparent",
  borderWidth: 1,
  display: !0,
  rotation: 0,
  shadowBlur: 0,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  xMax: void 0,
  xMin: void 0,
  xScaleID: void 0,
  yMax: void 0,
  yMin: void 0,
  yScaleID: void 0,
  z: 0
};
Vp.defaultRoutes = {
  borderColor: "color",
  backgroundColor: "color"
};
function Pue(e, t, n, r) {
  const { width: i, height: a, centerX: s, centerY: o } = t, l = i / 2, c = a / 2;
  if (l <= 0 || c <= 0)
    return !1;
  const f = er(n || 0), h = r / 2 || 0, p = Math.cos(f), g = Math.sin(f), v = Math.pow(p * (e.x - s) + g * (e.y - o), 2), y = Math.pow(g * (e.x - s) - p * (e.y - o), 2);
  return v / Math.pow(l + h, 2) + y / Math.pow(c + h, 2) <= 1.0001;
}
const YI = ["left", "bottom", "top", "right"];
class Bp extends Ar {
  inRange(t, n, r, i) {
    const { x: a, y: s } = bu({ x: t, y: n }, this.getCenterPoint(i), er(-this.rotation));
    return $I({ x: a, y: s }, this.getProps(["x", "y", "x2", "y2"], i), r, this.options.borderWidth);
  }
  getCenterPoint(t) {
    return gu(this, t);
  }
  draw(t) {
    const n = this.options, r = !zn(this._visible) || this._visible;
    !n.display || !n.content || !r || (t.save(), Tx(t, this.getCenterPoint(), this.rotation), Mue(t, this), jI(t, this, n), oue(t, Vue(this), n), t.restore());
  }
  resolveElementProperties(t, n) {
    let r;
    if (qI(n))
      r = zI(t, n);
    else {
      const { centerX: o, centerY: l } = $p(t, n);
      r = { x: o, y: l };
    }
    const i = Hn(n.padding), a = Ax(t.ctx, n), s = Oue(r, a, n, i);
    return {
      pointX: r.x,
      pointY: r.y,
      ...s,
      rotation: n.rotation
    };
  }
}
Bp.id = "labelAnnotation";
Bp.defaults = {
  adjustScaleRange: !0,
  backgroundColor: "transparent",
  backgroundShadowColor: "transparent",
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderRadius: 0,
  borderShadowColor: "transparent",
  borderWidth: 0,
  callout: {
    borderCapStyle: "butt",
    borderColor: void 0,
    borderDash: [],
    borderDashOffset: 0,
    borderJoinStyle: "miter",
    borderWidth: 1,
    display: !1,
    margin: 5,
    position: "auto",
    side: 5,
    start: "50%"
  },
  color: "black",
  content: null,
  display: !0,
  font: {
    family: void 0,
    lineHeight: void 0,
    size: void 0,
    style: void 0,
    weight: void 0
  },
  height: void 0,
  padding: 6,
  position: "center",
  rotation: 0,
  shadowBlur: 0,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  textAlign: "center",
  textStrokeColor: void 0,
  textStrokeWidth: 0,
  width: void 0,
  xAdjust: 0,
  xMax: void 0,
  xMin: void 0,
  xScaleID: void 0,
  xValue: void 0,
  yAdjust: 0,
  yMax: void 0,
  yMin: void 0,
  yScaleID: void 0,
  yValue: void 0,
  z: 0
};
Bp.defaultRoutes = {
  borderColor: "color"
};
function Oue(e, t, n, r) {
  const i = t.width + r.width + n.borderWidth, a = t.height + r.height + n.borderWidth, s = UI(n.position), o = vA(e.x, i, n.xAdjust, s.x), l = vA(e.y, a, n.yAdjust, s.y);
  return {
    x: o,
    y: l,
    x2: o + i,
    y2: l + a,
    width: i,
    height: a,
    centerX: o + i / 2,
    centerY: l + a / 2
  };
}
function vA(e, t, n = 0, r) {
  return e - Sx(t, r) + n;
}
function Mue(e, t) {
  const { pointX: n, pointY: r, options: i } = t, a = i.callout, s = a && a.display && Lue(t, a);
  if (!s || Bue(t, a, s))
    return;
  if (e.save(), e.beginPath(), !fl(e, a))
    return e.restore();
  const { separatorStart: l, separatorEnd: c } = Iue(t, s), { sideStart: f, sideEnd: h } = Fue(t, s, l);
  (a.margin > 0 || i.borderWidth === 0) && (e.moveTo(l.x, l.y), e.lineTo(c.x, c.y)), e.moveTo(f.x, f.y), e.lineTo(h.x, h.y);
  const p = bu({ x: n, y: r }, t.getCenterPoint(), er(-t.rotation));
  e.lineTo(p.x, p.y), e.stroke(), e.restore();
}
function Iue(e, t) {
  const { x: n, y: r, x2: i, y2: a } = e, s = Rue(e, t);
  let o, l;
  return t === "left" || t === "right" ? (o = { x: n + s, y: r }, l = { x: o.x, y: a }) : (o = { x: n, y: r + s }, l = { x: i, y: o.y }), { separatorStart: o, separatorEnd: l };
}
function Rue(e, t) {
  const { width: n, height: r, options: i } = e, a = i.callout.margin + i.borderWidth / 2;
  return t === "right" ? n + a : t === "bottom" ? r + a : -a;
}
function Fue(e, t, n) {
  const { y: r, width: i, height: a, options: s } = e, o = s.callout.start, l = Nue(t, s.callout);
  let c, f;
  return t === "left" || t === "right" ? (c = { x: n.x, y: r + lu(a, o) }, f = { x: c.x + l, y: c.y }) : (c = { x: n.x + lu(i, o), y: n.y }, f = { x: c.x, y: c.y + l }), { sideStart: c, sideEnd: f };
}
function Nue(e, t) {
  const n = t.side;
  return e === "left" || e === "top" ? -n : n;
}
function Lue(e, t) {
  const n = t.position;
  return YI.includes(n) ? n : $ue(e, t);
}
function $ue(e, t) {
  const { x: n, y: r, x2: i, y2: a, width: s, height: o, pointX: l, pointY: c, centerX: f, centerY: h, rotation: p } = e, g = { x: f, y: h }, v = t.start, y = lu(s, v), S = lu(o, v), x = [n, n + y, n + y, i], E = [r + S, a, r, a], w = [];
  for (let C = 0; C < 4; C++) {
    const P = bu({ x: x[C], y: E[C] }, g, er(p));
    w.push({
      position: YI[C],
      distance: jc(P, { x: l, y: c })
    });
  }
  return w.sort((C, P) => C.distance - P.distance)[0].position;
}
function Vue({ x: e, y: t, width: n, height: r, options: i }) {
  const a = i.borderWidth / 2, s = Hn(i.padding);
  return {
    x: e + s.left + a,
    y: t + s.top + a,
    width: n - s.left - s.right - i.borderWidth,
    height: r - s.top - s.bottom - i.borderWidth
  };
}
function Bue(e, t, n) {
  const { pointX: r, pointY: i } = e, a = t.margin;
  let s = r, o = i;
  return n === "left" ? s += a : n === "right" ? s -= a : n === "top" ? o += a : n === "bottom" && (o -= a), e.inRange(s, o);
}
class Up extends Ar {
  inRange(t, n, r, i) {
    const { x: a, y: s, x2: o, y2: l, width: c } = this.getProps(["x", "y", "x2", "y2", "width"], i), f = this.options.borderWidth;
    if (r !== "x" && r !== "y")
      return iue({ x: t, y: n }, this.getCenterPoint(i), c / 2, f);
    const h = f / 2, p = r === "y" ? { start: s, end: l, value: n } : { start: a, end: o, value: t };
    return p.value >= p.start - h && p.value <= p.end + h;
  }
  getCenterPoint(t) {
    return gu(this, t);
  }
  draw(t) {
    const n = this.options, r = n.borderWidth;
    if (n.radius < 0.1)
      return;
    t.save(), t.fillStyle = n.backgroundColor, vu(t, n);
    const i = fl(t, n);
    n.borderWidth = 0, Wh(t, n, this.centerX, this.centerY), i && !Cx(n.pointStyle) && (t.shadowColor = n.borderShadowColor, t.stroke()), t.restore(), n.borderWidth = r;
  }
  resolveElementProperties(t, n) {
    return HI(t, n);
  }
}
Up.id = "pointAnnotation";
Up.defaults = {
  adjustScaleRange: !0,
  backgroundShadowColor: "transparent",
  borderDash: [],
  borderDashOffset: 0,
  borderShadowColor: "transparent",
  borderWidth: 1,
  display: !0,
  pointStyle: "circle",
  radius: 10,
  rotation: 0,
  shadowBlur: 0,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  xAdjust: 0,
  xMax: void 0,
  xMin: void 0,
  xScaleID: void 0,
  xValue: void 0,
  yAdjust: 0,
  yMax: void 0,
  yMin: void 0,
  yScaleID: void 0,
  yValue: void 0,
  z: 0
};
Up.defaultRoutes = {
  borderColor: "color",
  backgroundColor: "color"
};
class qp extends Ar {
  inRange(t, n, r, i) {
    if (r !== "x" && r !== "y")
      return this.options.radius >= 0.1 && this.elements.length > 1 && que(this.elements, t, n, i);
    const a = bu({ x: t, y: n }, this.getCenterPoint(i), er(-this.options.rotation)), s = this.elements.map((c) => r === "y" ? c.bY : c.bX), o = Math.min(...s), l = Math.max(...s);
    return a[r] >= o && a[r] <= l;
  }
  getCenterPoint(t) {
    return gu(this, t);
  }
  draw(t) {
    const { elements: n, options: r } = this;
    t.save(), t.beginPath(), t.fillStyle = r.backgroundColor, vu(t, r);
    const i = fl(t, r);
    let a = !0;
    for (const s of n)
      a ? (t.moveTo(s.x, s.y), a = !1) : t.lineTo(s.x, s.y);
    t.closePath(), t.fill(), i && (t.shadowColor = r.borderShadowColor, t.stroke()), t.restore();
  }
  resolveElementProperties(t, n) {
    const r = HI(t, n), { x: i, y: a } = r, { sides: s, rotation: o } = n, l = [], c = 2 * Wt / s;
    let f = o * CM;
    for (let h = 0; h < s; h++, f += c)
      l.push(Uue(r, n, f));
    return r.elements = l, r.initProperties = { x: i, y: a }, r;
  }
}
qp.id = "polygonAnnotation";
qp.defaults = {
  adjustScaleRange: !0,
  backgroundShadowColor: "transparent",
  borderCapStyle: "butt",
  borderDash: [],
  borderDashOffset: 0,
  borderJoinStyle: "miter",
  borderShadowColor: "transparent",
  borderWidth: 1,
  display: !0,
  point: {
    radius: 0
  },
  radius: 10,
  rotation: 0,
  shadowBlur: 0,
  shadowOffsetX: 0,
  shadowOffsetY: 0,
  sides: 3,
  xAdjust: 0,
  xMax: void 0,
  xMin: void 0,
  xScaleID: void 0,
  xValue: void 0,
  yAdjust: 0,
  yMax: void 0,
  yMin: void 0,
  yScaleID: void 0,
  yValue: void 0,
  z: 0
};
qp.defaultRoutes = {
  borderColor: "color",
  backgroundColor: "color"
};
function Uue({ centerX: e, centerY: t }, { radius: n, borderWidth: r }, i) {
  const a = r / 2, s = Math.sin(i), o = Math.cos(i), l = { x: e + s * n, y: t - o * n };
  return {
    type: "point",
    optionScope: "point",
    properties: {
      x: l.x,
      y: l.y,
      centerX: l.x,
      centerY: l.y,
      bX: e + s * (n + a),
      bY: t - o * (n + a)
    }
  };
}
function que(e, t, n, r) {
  let i = !1, a = e[e.length - 1].getProps(["bX", "bY"], r);
  for (const s of e) {
    const o = s.getProps(["bX", "bY"], r);
    o.bY > n != a.bY > n && t < (a.bX - o.bX) * (n - o.bY) / (a.bY - o.bY) + o.bX && (i = !i), a = o;
  }
  return i;
}
const Ys = {
  box: yd,
  ellipse: Vp,
  label: Bp,
  line: xd,
  point: Up,
  polygon: qp
};
Object.keys(Ys).forEach((e) => {
  Et.describe(`elements.${Ys[e].id}`, {
    _fallback: "plugins.annotation.common"
  });
});
const jue = {
  update: Object.assign
};
function Ex(e = "line") {
  return Ys[e] ? e : (console.warn(`Unknown annotation type: '${e}', defaulting to 'line'`), "line");
}
function Wue(e, t, n, r) {
  const i = Hue(e, n.animations, r), a = t.annotations, s = Kue(t.elements, a);
  for (let o = 0; o < a.length; o++) {
    const l = a[o], c = KI(s, o, l.type), f = l.setContext(Yue(e, c, l)), h = c.resolveElementProperties(e, f);
    h.skip = zue(h), "elements" in h && (Gue(c, h, f, i), delete h.elements), zn(c.x) || Object.assign(c, h), h.options = XI(f), i.update(c, h);
  }
}
function zue(e) {
  return isNaN(e.x) || isNaN(e.y);
}
function Hue(e, t, n) {
  return n === "reset" || n === "none" || n === "resize" ? jue : new lx(e, t);
}
function Gue(e, { elements: t, initProperties: n }, r, i) {
  const a = e.elements || (e.elements = []);
  a.length = t.length;
  for (let s = 0; s < t.length; s++) {
    const o = t[s], l = o.properties, c = KI(a, s, o.type, n), f = r[o.optionScope].override(o);
    l.options = XI(f), i.update(c, l);
  }
}
function KI(e, t, n, r) {
  const i = Ys[Ex(n)];
  let a = e[t];
  return (!a || !(a instanceof i)) && (a = e[t] = new i(), _t(r) && Object.assign(a, r)), a;
}
function XI(e) {
  const t = Ys[Ex(e.type)], n = {};
  n.id = e.id, n.type = e.type, n.drawTime = e.drawTime, Object.assign(
    n,
    qy(e, t.defaults),
    qy(e, t.defaultRoutes)
  );
  for (const r of wx)
    n[r] = e[r];
  return n;
}
function qy(e, t) {
  const n = {};
  for (const r of Object.keys(t)) {
    const i = t[r], a = e[r];
    n[r] = _t(i) ? qy(a, i) : a;
  }
  return n;
}
function Yue(e, t, n) {
  return t.$context || (t.$context = Object.assign(Object.create(e.getContext()), {
    element: t,
    id: n.id,
    type: "annotation"
  }));
}
function Kue(e, t) {
  const n = t.length, r = e.length;
  if (r < n) {
    const i = n - r;
    e.splice(r, 0, ...new Array(i));
  } else r > n && e.splice(n, r - n);
  return e;
}
var Xue = "2.0.1";
const Ls = /* @__PURE__ */ new Map();
var ZI = {
  id: "annotation",
  version: Xue,
  beforeRegister() {
    aue("chart.js", "3.7", ls.version);
  },
  afterRegister() {
    ls.register(Ys);
  },
  afterUnregister() {
    ls.unregister(Ys);
  },
  beforeInit(e) {
    Ls.set(e, {
      annotations: [],
      elements: [],
      visibleElements: [],
      listeners: {},
      listened: !1,
      moveListened: !1,
      hovered: []
    });
  },
  beforeUpdate(e, t, n) {
    const r = Ls.get(e), i = r.annotations = [];
    let a = n.annotations;
    _t(a) ? Object.keys(a).forEach((s) => {
      const o = a[s];
      _t(o) && (o.id = s, i.push(o));
    }) : Zt(a) && i.push(...a), due(i, e.scales);
  },
  afterDataLimits(e, t) {
    const n = Ls.get(e);
    cue(e, t.scale, n.annotations.filter((r) => r.display && r.adjustScaleRange));
  },
  afterUpdate(e, t, n) {
    const r = Ls.get(e);
    Qle(e, r, n), Wue(e, r, n, t.mode), r.visibleElements = r.elements.filter((i) => !i.skip && i.options.display);
  },
  beforeDatasetsDraw(e, t, n) {
    Zf(e, "beforeDatasetsDraw", n.clip);
  },
  afterDatasetsDraw(e, t, n) {
    Zf(e, "afterDatasetsDraw", n.clip);
  },
  beforeDraw(e, t, n) {
    Zf(e, "beforeDraw", n.clip);
  },
  afterDraw(e, t, n) {
    Zf(e, "afterDraw", n.clip);
  },
  beforeEvent(e, t, n) {
    const r = Ls.get(e);
    Jle(r, t.event, n) && (t.changed = !0);
  },
  destroy(e) {
    Ls.delete(e);
  },
  _getState(e) {
    return Ls.get(e);
  },
  defaults: {
    animations: {
      numbers: {
        properties: ["x", "y", "x2", "y2", "width", "height", "centerX", "centerY", "pointX", "pointY", "radius"],
        type: "number"
      }
    },
    clip: !0,
    interaction: {
      mode: void 0,
      axis: void 0,
      intersect: void 0
    },
    common: {
      drawTime: "afterDatasetsDraw",
      label: {}
    }
  },
  descriptors: {
    _indexable: !1,
    _scriptable: (e) => !wx.includes(e),
    annotations: {
      _allKeys: !1,
      _fallback: (e, t) => `elements.${Ys[Ex(t.type)].id}`
    },
    interaction: {
      _fallback: !0
    },
    common: {
      label: {
        _fallback: !0
      }
    }
  },
  additionalOptionScopes: [""]
};
function Zf(e, t, n) {
  const { ctx: r, chartArea: i } = e, { visibleElements: a } = Ls.get(e);
  n && dd(r, i);
  const s = Zue(a, t).sort((o, l) => o.options.z - l.options.z);
  for (const o of s)
    o.draw(e.ctx, i);
  n && fd(r);
}
function Zue(e, t) {
  const n = [];
  for (const r of e)
    if (r.options.drawTime === t && n.push(r), r.elements && r.elements.length)
      for (const i of r.elements)
        i.options.display && i.options.drawTime === t && n.push(i);
  return n;
}
ls.register(...mx, ZI);
const Que = {
  props: ["title", "data", "options", "plugins", "tooltipText"],
  components: {
    BarChart: Hle,
    InformationCircleIcon: ds
  },
  watch: {
    chartData: {
      handler() {
        this.chartKey = this.chartKey + 1;
      },
      deep: !0
    }
  },
  data: () => ({
    chartKey: 0
  }),
  computed: {
    chartData: function() {
      return {
        datasets: Object.entries(this.data).map(([e, t]) => ({
          backgroundColor: t.color,
          borderColor: t.color,
          borderWidth: 1,
          parsing: !0,
          label: this.$t(e),
          data: t.value.map((n) => ({ x: n.date, y: n.value })),
          // Configuration pour barres simples
          categoryPercentage: 0.8,
          barPercentage: 0.9
        }))
      };
    },
    hasData: function() {
      var t;
      if (!this.data || typeof this.data != "object") return !1;
      const e = ((t = this.chartData) == null ? void 0 : t.datasets) || [];
      return e.length === 0 ? !1 : e.some((n) => n.data && n.data.length > 0 && n.data.some((r) => r && r.y > 0));
    },
    showCart: function() {
      var e, t, n, r;
      return ((r = (n = (t = (e = this.chartData) == null ? void 0 : e.datasets) == null ? void 0 : t[0]) == null ? void 0 : n.data) == null ? void 0 : r.length) > 1;
    }
  }
}, Jue = { class: "bg-white p-6 rounded-lg shadow-lg" }, ece = { class: "flex items-center gap-x-2 pb-2" }, tce = { class: "text-xl pl-2 font-bold tracking-tight text-gray-900 text-left" }, nce = {
  key: 0,
  class: "text-lg pl-2 tracking-tight text-gray-700 text-left"
}, rce = {
  key: 2,
  class: "flex items-center justify-center text-gray-500 py-12"
};
function ice(e, t, n, r, i, a) {
  const s = U("InformationCircleIcon"), o = U("VTooltip"), l = U("BarChart", !0);
  return _(), O("div", Jue, [
    k("div", ece, [
      k("h1", tce, j(n.title), 1),
      n.tooltipText || e.tooltipHtml ? (_(), ae(o, {
        key: 0,
        theme: "info-tooltip"
      }, {
        popper: ie(() => [
          xe(e.$slots, "tooltip", {}, () => [
            k("span", null, j(n.tooltipText), 1)
          ])
        ]),
        default: ie(() => [
          W(s, {
            class: "cursor-pointer h-5 w-4 text-gray-400",
            "aria-hidden": "true"
          })
        ]),
        _: 3
      })) : L("", !0)
    ]),
    e.$slots.subtitle ? (_(), O("div", nce, [
      xe(e.$slots, "subtitle")
    ])) : L("", !0),
    a.hasData && a.showCart ? (_(), ae(l, {
      class: "pt-6",
      chartData: a.chartData,
      options: n.options,
      width: 100,
      height: 300,
      key: e.chartKey
    }, null, 8, ["chartData", "options"])) : a.hasData ? L("", !0) : (_(), O("div", rce, [...t[0] || (t[0] = [
      k("p", { class: "text-lg" }, "Aucune donnée", -1)
    ])]))
  ]);
}
const ace = /* @__PURE__ */ we(Que, [["render", ice]]), sce = {
  props: ["variation"],
  computed: {
    formattedVariation() {
      return this.variation === null || isNaN(this.variation) ? "" : `${this.variation > 0 ? "+" : ""}${this.variation} %`;
    }
  }
};
function oce(e, t, n, r, i, a) {
  return n.variation !== null ? (_(), O("span", {
    key: 0,
    class: Pe(["text-xs font-semibold", {
      "text-green-600 bg-green-50 p-2 rounded-full": n.variation > 0,
      "text-red-600 bg-red-50 p-2 rounded-full": n.variation < 0,
      "text-gray-500 bg-gray-50 p-2 rounded-full": n.variation === 0
    }])
  }, j(a.formattedVariation), 3)) : L("", !0);
}
const QI = /* @__PURE__ */ we(sce, [["render", oce]]);
/*!
 * chartjs-plugin-datalabels v2.2.0
 * https://chartjs-plugin-datalabels.netlify.app
 * (c) 2017-2022 chartjs-plugin-datalabels contributors
 * Released under the MIT license
 */
var bA = (function() {
  if (typeof window < "u") {
    if (window.devicePixelRatio)
      return window.devicePixelRatio;
    var e = window.screen;
    if (e)
      return (e.deviceXDPI || 1) / (e.logicalXDPI || 1);
  }
  return 1;
})(), Ic = {
  // @todo move this in Chart.helpers.toTextLines
  toTextLines: function(e) {
    var t = [], n;
    for (e = [].concat(e); e.length; )
      n = e.pop(), typeof n == "string" ? t.unshift.apply(t, n.split(`
`)) : Array.isArray(n) ? e.push.apply(e, n) : Tt(e) || t.unshift("" + n);
    return t;
  },
  // @todo move this in Chart.helpers.canvas.textSize
  // @todo cache calls of measureText if font doesn't change?!
  textSize: function(e, t, n) {
    var r = [].concat(t), i = r.length, a = e.font, s = 0, o;
    for (e.font = n.string, o = 0; o < i; ++o)
      s = Math.max(e.measureText(r[o]).width, s);
    return e.font = a, {
      height: i * n.lineHeight,
      width: s
    };
  },
  /**
   * Returns value bounded by min and max. This is equivalent to max(min, min(value, max)).
   * @todo move this method in Chart.helpers.bound
   * https://doc.qt.io/qt-5/qtglobal.html#qBound
   */
  bound: function(e, t, n) {
    return Math.max(e, Math.min(t, n));
  },
  /**
   * Returns an array of pair [value, state] where state is:
   * * -1: value is only in a0 (removed)
   * *  1: value is only in a1 (added)
   */
  arrayDiff: function(e, t) {
    var n = e.slice(), r = [], i, a, s, o;
    for (i = 0, s = t.length; i < s; ++i)
      o = t[i], a = n.indexOf(o), a === -1 ? r.push([o, 1]) : n.splice(a, 1);
    for (i = 0, s = n.length; i < s; ++i)
      r.push([n[i], -1]);
    return r;
  },
  /**
   * https://github.com/chartjs/chartjs-plugin-datalabels/issues/70
   */
  rasterize: function(e) {
    return Math.round(e * bA) / bA;
  }
};
function cv(e, t) {
  var n = t.x, r = t.y;
  if (n === null)
    return { x: 0, y: -1 };
  if (r === null)
    return { x: 1, y: 0 };
  var i = e.x - n, a = e.y - r, s = Math.sqrt(i * i + a * a);
  return {
    x: s ? i / s : 0,
    y: s ? a / s : -1
  };
}
function lce(e, t, n, r, i) {
  switch (i) {
    case "center":
      n = r = 0;
      break;
    case "bottom":
      n = 0, r = 1;
      break;
    case "right":
      n = 1, r = 0;
      break;
    case "left":
      n = -1, r = 0;
      break;
    case "top":
      n = 0, r = -1;
      break;
    case "start":
      n = -n, r = -r;
      break;
    case "end":
      break;
    default:
      i *= Math.PI / 180, n = Math.cos(i), r = Math.sin(i);
      break;
  }
  return {
    x: e,
    y: t,
    vx: n,
    vy: r
  };
}
var uce = 0, JI = 1, eR = 2, tR = 4, nR = 8;
function Qf(e, t, n) {
  var r = uce;
  return e < n.left ? r |= JI : e > n.right && (r |= eR), t < n.top ? r |= nR : t > n.bottom && (r |= tR), r;
}
function cce(e, t) {
  for (var n = e.x0, r = e.y0, i = e.x1, a = e.y1, s = Qf(n, r, t), o = Qf(i, a, t), l, c, f; !(!(s | o) || s & o); )
    l = s || o, l & nR ? (c = n + (i - n) * (t.top - r) / (a - r), f = t.top) : l & tR ? (c = n + (i - n) * (t.bottom - r) / (a - r), f = t.bottom) : l & eR ? (f = r + (a - r) * (t.right - n) / (i - n), c = t.right) : l & JI && (f = r + (a - r) * (t.left - n) / (i - n), c = t.left), l === s ? (n = c, r = f, s = Qf(n, r, t)) : (i = c, a = f, o = Qf(i, a, t));
  return {
    x0: n,
    x1: i,
    y0: r,
    y1: a
  };
}
function Jf(e, t) {
  var n = t.anchor, r = e, i, a;
  return t.clamp && (r = cce(r, t.area)), n === "start" ? (i = r.x0, a = r.y0) : n === "end" ? (i = r.x1, a = r.y1) : (i = (r.x0 + r.x1) / 2, a = (r.y0 + r.y1) / 2), lce(i, a, e.vx, e.vy, t.align);
}
var eh = {
  arc: function(e, t) {
    var n = (e.startAngle + e.endAngle) / 2, r = Math.cos(n), i = Math.sin(n), a = e.innerRadius, s = e.outerRadius;
    return Jf({
      x0: e.x + r * a,
      y0: e.y + i * a,
      x1: e.x + r * s,
      y1: e.y + i * s,
      vx: r,
      vy: i
    }, t);
  },
  point: function(e, t) {
    var n = cv(e, t.origin), r = n.x * e.options.radius, i = n.y * e.options.radius;
    return Jf({
      x0: e.x - r,
      y0: e.y - i,
      x1: e.x + r,
      y1: e.y + i,
      vx: n.x,
      vy: n.y
    }, t);
  },
  bar: function(e, t) {
    var n = cv(e, t.origin), r = e.x, i = e.y, a = 0, s = 0;
    return e.horizontal ? (r = Math.min(e.x, e.base), a = Math.abs(e.base - e.x)) : (i = Math.min(e.y, e.base), s = Math.abs(e.base - e.y)), Jf({
      x0: r,
      y0: i + s,
      x1: r + a,
      y1: i,
      vx: n.x,
      vy: n.y
    }, t);
  },
  fallback: function(e, t) {
    var n = cv(e, t.origin);
    return Jf({
      x0: e.x,
      y0: e.y,
      x1: e.x + (e.width || 0),
      y1: e.y + (e.height || 0),
      vx: n.x,
      vy: n.y
    }, t);
  }
}, ss = Ic.rasterize;
function dce(e) {
  var t = e.borderWidth || 0, n = e.padding, r = e.size.height, i = e.size.width, a = -i / 2, s = -r / 2;
  return {
    frame: {
      x: a - n.left - t,
      y: s - n.top - t,
      w: i + n.width + t * 2,
      h: r + n.height + t * 2
    },
    text: {
      x: a,
      y: s,
      w: i,
      h: r
    }
  };
}
function fce(e, t) {
  var n = t.chart.getDatasetMeta(t.datasetIndex).vScale;
  if (!n)
    return null;
  if (n.xCenter !== void 0 && n.yCenter !== void 0)
    return { x: n.xCenter, y: n.yCenter };
  var r = n.getBasePixel();
  return e.horizontal ? { x: r, y: null } : { x: null, y: r };
}
function hce(e) {
  return e instanceof pd ? eh.arc : e instanceof md ? eh.point : e instanceof gd ? eh.bar : eh.fallback;
}
function pce(e, t, n, r, i, a) {
  var s = Math.PI / 2;
  if (a) {
    var o = Math.min(a, i / 2, r / 2), l = t + o, c = n + o, f = t + r - o, h = n + i - o;
    e.moveTo(t, c), l < f && c < h ? (e.arc(l, c, o, -Math.PI, -s), e.arc(f, c, o, -s, 0), e.arc(f, h, o, 0, s), e.arc(l, h, o, s, Math.PI)) : l < f ? (e.moveTo(l, n), e.arc(f, c, o, -s, s), e.arc(l, c, o, s, Math.PI + s)) : c < h ? (e.arc(l, c, o, -Math.PI, 0), e.arc(l, h, o, 0, Math.PI)) : e.arc(l, c, o, -Math.PI, Math.PI), e.closePath(), e.moveTo(t, n);
  } else
    e.rect(t, n, r, i);
}
function mce(e, t, n) {
  var r = n.backgroundColor, i = n.borderColor, a = n.borderWidth;
  !r && (!i || !a) || (e.beginPath(), pce(
    e,
    ss(t.x) + a / 2,
    ss(t.y) + a / 2,
    ss(t.w) - a,
    ss(t.h) - a,
    n.borderRadius
  ), e.closePath(), r && (e.fillStyle = r, e.fill()), i && a && (e.strokeStyle = i, e.lineWidth = a, e.lineJoin = "miter", e.stroke()));
}
function gce(e, t, n) {
  var r = n.lineHeight, i = e.w, a = e.x, s = e.y + r / 2;
  return t === "center" ? a += i / 2 : (t === "end" || t === "right") && (a += i), {
    h: r,
    w: i,
    x: a,
    y: s
  };
}
function vce(e, t, n) {
  var r = e.shadowBlur, i = n.stroked, a = ss(n.x), s = ss(n.y), o = ss(n.w);
  i && e.strokeText(t, a, s, o), n.filled && (r && i && (e.shadowBlur = 0), e.fillText(t, a, s, o), r && i && (e.shadowBlur = r));
}
function bce(e, t, n, r) {
  var i = r.textAlign, a = r.color, s = !!a, o = r.font, l = t.length, c = r.textStrokeColor, f = r.textStrokeWidth, h = c && f, p;
  if (!(!l || !s && !h))
    for (n = gce(n, i, o), e.font = o.string, e.textAlign = i, e.textBaseline = "middle", e.shadowBlur = r.textShadowBlur, e.shadowColor = r.textShadowColor, s && (e.fillStyle = a), h && (e.lineJoin = "round", e.lineWidth = f, e.strokeStyle = c), p = 0, l = t.length; p < l; ++p)
      vce(e, t[p], {
        stroked: h,
        filled: s,
        w: n.w,
        x: n.x,
        y: n.y + n.h * p
      });
}
var rR = function(e, t, n, r) {
  var i = this;
  i._config = e, i._index = r, i._model = null, i._rects = null, i._ctx = t, i._el = n;
};
Da(rR.prototype, {
  /**
   * @private
   */
  _modelize: function(e, t, n, r) {
    var i = this, a = i._index, s = Fn(hn([n.font, {}], r, a)), o = hn([n.color, Et.color], r, a);
    return {
      align: hn([n.align, "center"], r, a),
      anchor: hn([n.anchor, "center"], r, a),
      area: r.chart.chartArea,
      backgroundColor: hn([n.backgroundColor, null], r, a),
      borderColor: hn([n.borderColor, null], r, a),
      borderRadius: hn([n.borderRadius, 0], r, a),
      borderWidth: hn([n.borderWidth, 0], r, a),
      clamp: hn([n.clamp, !1], r, a),
      clip: hn([n.clip, !1], r, a),
      color: o,
      display: e,
      font: s,
      lines: t,
      offset: hn([n.offset, 4], r, a),
      opacity: hn([n.opacity, 1], r, a),
      origin: fce(i._el, r),
      padding: Hn(hn([n.padding, 4], r, a)),
      positioner: hce(i._el),
      rotation: hn([n.rotation, 0], r, a) * (Math.PI / 180),
      size: Ic.textSize(i._ctx, t, s),
      textAlign: hn([n.textAlign, "start"], r, a),
      textShadowBlur: hn([n.textShadowBlur, 0], r, a),
      textShadowColor: hn([n.textShadowColor, o], r, a),
      textStrokeColor: hn([n.textStrokeColor, o], r, a),
      textStrokeWidth: hn([n.textStrokeWidth, 0], r, a)
    };
  },
  update: function(e) {
    var t = this, n = null, r = null, i = t._index, a = t._config, s, o, l, c = hn([a.display, !0], e, i);
    c && (s = e.dataset.data[i], o = lt(Xt(a.formatter, [s, e]), s), l = Tt(o) ? [] : Ic.toTextLines(o), l.length && (n = t._modelize(c, l, a, e), r = dce(n))), t._model = n, t._rects = r;
  },
  geometry: function() {
    return this._rects ? this._rects.frame : {};
  },
  rotation: function() {
    return this._model ? this._model.rotation : 0;
  },
  visible: function() {
    return this._model && this._model.opacity;
  },
  model: function() {
    return this._model;
  },
  draw: function(e, t) {
    var n = this, r = e.ctx, i = n._model, a = n._rects, s;
    this.visible() && (r.save(), i.clip && (s = i.area, r.beginPath(), r.rect(
      s.left,
      s.top,
      s.right - s.left,
      s.bottom - s.top
    ), r.clip()), r.globalAlpha = Ic.bound(0, i.opacity, 1), r.translate(ss(t.x), ss(t.y)), r.rotate(i.rotation), mce(r, a.frame, i), bce(r, i.lines, a.text, i), r.restore());
  }
});
var _ce = Number.MIN_SAFE_INTEGER || -9007199254740991, yce = Number.MAX_SAFE_INTEGER || 9007199254740991;
function pc(e, t, n) {
  var r = Math.cos(n), i = Math.sin(n), a = t.x, s = t.y;
  return {
    x: a + r * (e.x - a) - i * (e.y - s),
    y: s + i * (e.x - a) + r * (e.y - s)
  };
}
function _A(e, t) {
  var n = yce, r = _ce, i = t.origin, a, s, o, l, c;
  for (a = 0; a < e.length; ++a)
    s = e[a], o = s.x - i.x, l = s.y - i.y, c = t.vx * o + t.vy * l, n = Math.min(n, c), r = Math.max(r, c);
  return {
    min: n,
    max: r
  };
}
function th(e, t) {
  var n = t.x - e.x, r = t.y - e.y, i = Math.sqrt(n * n + r * r);
  return {
    vx: (t.x - e.x) / i,
    vy: (t.y - e.y) / i,
    origin: e,
    ln: i
  };
}
var iR = function() {
  this._rotation = 0, this._rect = {
    x: 0,
    y: 0,
    w: 0,
    h: 0
  };
};
Da(iR.prototype, {
  center: function() {
    var e = this._rect;
    return {
      x: e.x + e.w / 2,
      y: e.y + e.h / 2
    };
  },
  update: function(e, t, n) {
    this._rotation = n, this._rect = {
      x: t.x + e.x,
      y: t.y + e.y,
      w: t.w,
      h: t.h
    };
  },
  contains: function(e) {
    var t = this, n = 1, r = t._rect;
    return e = pc(e, t.center(), -t._rotation), !(e.x < r.x - n || e.y < r.y - n || e.x > r.x + r.w + n * 2 || e.y > r.y + r.h + n * 2);
  },
  // Separating Axis Theorem
  // https://gamedevelopment.tutsplus.com/tutorials/collision-detection-using-the-separating-axis-theorem--gamedev-169
  intersects: function(e) {
    var t = this._points(), n = e._points(), r = [
      th(t[0], t[1]),
      th(t[0], t[3])
    ], i, a, s;
    for (this._rotation !== e._rotation && r.push(
      th(n[0], n[1]),
      th(n[0], n[3])
    ), i = 0; i < r.length; ++i)
      if (a = _A(t, r[i]), s = _A(n, r[i]), a.max < s.min || s.max < a.min)
        return !1;
    return !0;
  },
  /**
   * @private
   */
  _points: function() {
    var e = this, t = e._rect, n = e._rotation, r = e.center();
    return [
      pc({ x: t.x, y: t.y }, r, n),
      pc({ x: t.x + t.w, y: t.y }, r, n),
      pc({ x: t.x + t.w, y: t.y + t.h }, r, n),
      pc({ x: t.x, y: t.y + t.h }, r, n)
    ];
  }
});
function aR(e, t, n) {
  var r = t.positioner(e, t), i = r.vx, a = r.vy;
  if (!i && !a)
    return { x: r.x, y: r.y };
  var s = n.w, o = n.h, l = t.rotation, c = Math.abs(s / 2 * Math.cos(l)) + Math.abs(o / 2 * Math.sin(l)), f = Math.abs(s / 2 * Math.sin(l)) + Math.abs(o / 2 * Math.cos(l)), h = 1 / Math.max(Math.abs(i), Math.abs(a));
  return c *= i * h, f *= a * h, c += t.offset * i, f += t.offset * a, {
    x: r.x + c,
    y: r.y + f
  };
}
function xce(e, t) {
  var n, r, i, a;
  for (n = e.length - 1; n >= 0; --n)
    for (i = e[n].$layout, r = n - 1; r >= 0 && i._visible; --r)
      a = e[r].$layout, a._visible && i._box.intersects(a._box) && t(i, a);
  return e;
}
function wce(e) {
  var t, n, r, i, a, s, o;
  for (t = 0, n = e.length; t < n; ++t)
    r = e[t], i = r.$layout, i._visible && (o = new Proxy(r._el, { get: (l, c) => l.getProps([c], !0)[c] }), a = r.geometry(), s = aR(o, r.model(), a), i._box.update(s, a, r.rotation()));
  return xce(e, function(l, c) {
    var f = l._hidable, h = c._hidable;
    f && h || h ? c._visible = !1 : f && (l._visible = !1);
  });
}
var Rc = {
  prepare: function(e) {
    var t = [], n, r, i, a, s;
    for (n = 0, i = e.length; n < i; ++n)
      for (r = 0, a = e[n].length; r < a; ++r)
        s = e[n][r], t.push(s), s.$layout = {
          _box: new iR(),
          _hidable: !1,
          _visible: !0,
          _set: n,
          _idx: s._index
        };
    return t.sort(function(o, l) {
      var c = o.$layout, f = l.$layout;
      return c._idx === f._idx ? f._set - c._set : f._idx - c._idx;
    }), this.update(t), t;
  },
  update: function(e) {
    var t = !1, n, r, i, a, s;
    for (n = 0, r = e.length; n < r; ++n)
      i = e[n], a = i.model(), s = i.$layout, s._hidable = a && a.display === "auto", s._visible = i.visible(), t |= s._hidable;
    t && wce(e);
  },
  lookup: function(e, t) {
    var n, r;
    for (n = e.length - 1; n >= 0; --n)
      if (r = e[n].$layout, r && r._visible && r._box.contains(t))
        return e[n];
    return null;
  },
  draw: function(e, t) {
    var n, r, i, a, s, o;
    for (n = 0, r = t.length; n < r; ++n)
      i = t[n], a = i.$layout, a._visible && (s = i.geometry(), o = aR(i._el, i.model(), s), a._box.update(o, s, i.rotation()), i.draw(e, o));
  }
}, kce = function(e) {
  if (Tt(e))
    return null;
  var t = e, n, r, i;
  if (_t(e))
    if (!Tt(e.label))
      t = e.label;
    else if (!Tt(e.r))
      t = e.r;
    else
      for (t = "", n = Object.keys(e), i = 0, r = n.length; i < r; ++i)
        t += (i !== 0 ? ", " : "") + n[i] + ": " + e[n[i]];
  return "" + t;
}, Sce = {
  align: "center",
  anchor: "center",
  backgroundColor: null,
  borderColor: null,
  borderRadius: 0,
  borderWidth: 0,
  clamp: !1,
  clip: !1,
  color: void 0,
  display: !0,
  font: {
    family: void 0,
    lineHeight: 1.2,
    size: void 0,
    style: void 0,
    weight: null
  },
  formatter: kce,
  labels: void 0,
  listeners: {},
  offset: 4,
  opacity: 1,
  padding: {
    top: 4,
    right: 4,
    bottom: 4,
    left: 4
  },
  rotation: 0,
  textAlign: "start",
  textStrokeColor: void 0,
  textStrokeWidth: 0,
  textShadowBlur: 0,
  textShadowColor: void 0
}, ii = "$datalabels", sR = "$default";
function Cce(e, t) {
  var n = e.datalabels, r = {}, i = [], a, s;
  return n === !1 ? null : (n === !0 && (n = {}), t = Da({}, [t, n]), a = t.labels || {}, s = Object.keys(a), delete t.labels, s.length ? s.forEach(function(o) {
    a[o] && i.push(Da({}, [
      t,
      a[o],
      { _key: o }
    ]));
  }) : i.push(t), r = i.reduce(function(o, l) {
    return Yt(l.listeners || {}, function(c, f) {
      o[f] = o[f] || {}, o[f][l._key || sR] = c;
    }), delete l.listeners, o;
  }, {}), {
    labels: i,
    listeners: r
  });
}
function jy(e, t, n, r) {
  if (t) {
    var i = n.$context, a = n.$groups, s;
    t[a._set] && (s = t[a._set][a._key], s && Xt(s, [i, r]) === !0 && (e[ii]._dirty = !0, n.update(i)));
  }
}
function Tce(e, t, n, r, i) {
  var a, s;
  !n && !r || (n ? r ? n !== r && (s = a = !0) : s = !0 : a = !0, s && jy(e, t.leave, n, i), a && jy(e, t.enter, r, i));
}
function Ace(e, t) {
  var n = e[ii], r = n._listeners, i, a;
  if (!(!r.enter && !r.leave)) {
    if (t.type === "mousemove")
      a = Rc.lookup(n._labels, t);
    else if (t.type !== "mouseout")
      return;
    i = n._hovered, n._hovered = a, Tce(e, r, i, a, t);
  }
}
function Dce(e, t) {
  var n = e[ii], r = n._listeners.click, i = r && Rc.lookup(n._labels, t);
  i && jy(e, r, i, t);
}
var Ece = {
  id: "datalabels",
  defaults: Sce,
  beforeInit: function(e) {
    e[ii] = {
      _actives: []
    };
  },
  beforeUpdate: function(e) {
    var t = e[ii];
    t._listened = !1, t._listeners = {}, t._datasets = [], t._labels = [];
  },
  afterDatasetUpdate: function(e, t, n) {
    var r = t.index, i = e[ii], a = i._datasets[r] = [], s = e.isDatasetVisible(r), o = e.data.datasets[r], l = Cce(o, n), c = t.meta.data || [], f = e.ctx, h, p, g, v, y, S, x, E;
    for (f.save(), h = 0, g = c.length; h < g; ++h)
      if (x = c[h], x[ii] = [], s && x && e.getDataVisibility(h) && !x.skip)
        for (p = 0, v = l.labels.length; p < v; ++p)
          y = l.labels[p], S = y._key, E = new rR(y, f, x, h), E.$groups = {
            _set: r,
            _key: S || sR
          }, E.$context = {
            active: !1,
            chart: e,
            dataIndex: h,
            dataset: o,
            datasetIndex: r
          }, E.update(E.$context), x[ii].push(E), a.push(E);
    f.restore(), Da(i._listeners, l.listeners, {
      merger: function(w, C, P) {
        C[w] = C[w] || {}, C[w][t.index] = P[w], i._listened = !0;
      }
    });
  },
  afterUpdate: function(e) {
    e[ii]._labels = Rc.prepare(e[ii]._datasets);
  },
  // Draw labels on top of all dataset elements
  // https://github.com/chartjs/chartjs-plugin-datalabels/issues/29
  // https://github.com/chartjs/chartjs-plugin-datalabels/issues/32
  afterDatasetsDraw: function(e) {
    Rc.draw(e, e[ii]._labels);
  },
  beforeEvent: function(e, t) {
    if (e[ii]._listened) {
      var n = t.event;
      switch (n.type) {
        case "mousemove":
        case "mouseout":
          Ace(e, n);
          break;
        case "click":
          Dce(e, n);
          break;
      }
    }
  },
  afterEvent: function(e) {
    var t = e[ii], n = t._actives, r = t._actives = e.getActiveElements(), i = Ic.arrayDiff(n, r), a, s, o, l, c, f, h;
    for (a = 0, s = i.length; a < s; ++a)
      if (c = i[a], c[1])
        for (h = c[0].element[ii] || [], o = 0, l = h.length; o < l; ++o)
          f = h[o], f.$context.active = c[1] === 1, f.update(f.$context);
    (t._dirty || i.length) && (Rc.update(t._labels), e.render()), delete t._dirty;
  }
};
ls.register(...mx, Ece);
const Pce = {
  components: { PieChart: Yle, InformationCircleIcon: ds },
  props: ["title", "data", "options", "tooltipText", "maxCategories"],
  computed: {
    hasData() {
      if (!this.data || typeof this.data != "object") return !1;
      const e = Object.values(this.data);
      return e.length > 0 && e.some((t) => t > 0);
    },
    chartData() {
      const e = this.groupTopCategories(
        this.data,
        this.maxCategories
      );
      return {
        labels: Object.keys(e.data),
        datasets: [
          {
            data: Object.values(e.data),
            backgroundColor: this.generateRandomColors(
              Object.keys(e.data).length
            )
          }
        ]
      };
    },
    chartOptions() {
      const e = this.groupTopCategories(
        this.data,
        this.maxCategories
      ).otherDetails;
      return {
        responsive: !0,
        maintainAspectRatio: !1,
        cutout: "60%",
        plugins: {
          legend: {
            display: !0,
            position: "left",
            labels: {
              usePointStyle: !0,
              pointStyle: "circle",
              generateLabels: (t) => {
                let n = t.data;
                if (n.labels.length && n.datasets.length) {
                  let r = n.datasets[0].data.reduce(
                    (i, a) => i + a,
                    0
                  );
                  return n.labels.map((i, a) => {
                    let o = (n.datasets[0].data[a] / r * 100).toFixed(2) + "%";
                    return {
                      text: `${i} (${o})`,
                      fillStyle: n.datasets[0].backgroundColor[a],
                      hidden: !1
                    };
                  });
                }
                return [];
              }
            }
          },
          tooltip: {
            displayColors: !0,
            padding: 10,
            useHTML: !0,
            callbacks: {
              beforeLabel: () => "",
              afterLabel: () => "",
              label: (t) => {
                let n = t.dataset.data.reduce(
                  (a, s) => a + s,
                  0
                ), r = t.raw, i = (r / n * 100).toFixed(2);
                if (t.label === "Autres" && Array.isArray(e) && e.length > 0) {
                  const a = e.map(
                    ([s, o]) => ` • ${s} : ${o} (${(o / n * 100).toFixed(2)}%)`
                  ).join(`\r
`);
                  return [
                    ` Autres : ${r} (${i}%)`,
                    ...a.split(`\r
`)
                  ];
                }
                return ` ${t.label} : ${r} (${i}%)`;
              }
            }
          },
          datalabels: {
            display: !1
          }
        }
      };
    }
  },
  methods: {
    groupTopCategories(e, t = 12) {
      if (!e || typeof e != "object")
        return { data: {}, otherDetails: [] };
      const n = Object.entries(e).sort((o, l) => l[1] - o[1]), r = n.slice(0, t - 1), i = n.slice(t - 1), a = Object.fromEntries(r);
      let s = [];
      return i.length > 0 && (a.Autres = i.reduce((o, [, l]) => o + l, 0), s = i), { data: a, otherDetails: s };
    },
    generateRandomColors(e) {
      const t = [];
      for (let n = 0; n < e; n++) {
        let r;
        do
          r = `rgba(${this.randomMuted255()}, ${this.randomMuted255()}, ${this.randomMuted255()}, 0.6)`;
        while (this.isGray(r));
        t.push(r);
      }
      return t;
    },
    randomMuted255() {
      return Math.floor(Math.random() * 101) + 100;
    },
    isGray(e) {
      const t = e.match(/\d+/g), n = parseInt(t[0]), r = parseInt(t[1]), i = parseInt(t[2]);
      return Math.abs(n - r) < 20 && Math.abs(r - i) < 20 && Math.abs(n - i) < 20;
    }
  }
}, Oce = { class: "flex items-center gap-x-2 pb-4" }, Mce = { class: "text-sm font-medium text-gray-500" }, Ice = {
  key: 1,
  class: "flex items-center justify-center text-gray-500 py-12"
};
function Rce(e, t, n, r, i, a) {
  const s = U("InformationCircleIcon"), o = U("VTooltip"), l = U("PieChart", !0);
  return _(), O("div", null, [
    k("div", Oce, [
      k("h1", Mce, j(n.title), 1),
      n.tooltipText || e.tooltipHtml ? (_(), ae(o, {
        key: 0,
        theme: "info-tooltip"
      }, {
        popper: ie(() => [
          xe(e.$slots, "tooltip", {}, () => [
            k("span", null, j(n.tooltipText), 1)
          ])
        ]),
        default: ie(() => [
          W(s, {
            class: "cursor-pointer h-5 w-4 text-gray-400",
            "aria-hidden": "true"
          })
        ]),
        _: 3
      })) : L("", !0)
    ]),
    a.hasData ? (_(), ae(l, {
      key: 0,
      "chart-data": a.chartData,
      options: a.chartOptions,
      height: "200",
      width: "200"
    }, null, 8, ["chart-data", "options"])) : (_(), O("div", Ice, [...t[0] || (t[0] = [
      k("p", { class: "text-lg" }, "Aucune donnée", -1)
    ])]))
  ]);
}
const Fce = /* @__PURE__ */ we(Pce, [["render", Rce]]), Nce = {
  props: {
    analytics: { type: Object, required: !0 },
    dataSource: { type: String, default: "contracts" },
    showVerticalRepartition: { type: Boolean, default: !0 }
  },
  components: { PieChart: Fce },
  computed: {
    isLeadsView() {
      return this.dataSource !== "contracts";
    },
    gridColumnsClass() {
      return this.isLeadsView ? "" : this.showVerticalRepartition ? "lg:grid-cols-3" : "lg:grid-cols-2";
    }
  },
  methods: {
    format(e) {
      return !e || typeof e != "object" ? {} : Object.values(e).reduce((t, { name: n, value: r }) => (t[n] = r, t), {});
    }
  }
}, Lce = { class: "bg-white p-6 rounded-lg shadow-lg" };
function $ce(e, t, n, r, i, a) {
  var o, l, c;
  const s = U("PieChart");
  return _(), O("div", Lce, [
    k("div", {
      class: Pe(["grid grid-cols-1 gap-6", a.gridColumnsClass])
    }, [
      n.showVerticalRepartition ? (_(), ae(s, {
        key: 0,
        title: "Répartition par formule",
        data: a.format((o = n.analytics.sales) == null ? void 0 : o.verticalRepartition),
        maxCategories: 6,
        tooltipText: "Répartition des ventes selon la formule souscrite."
      }, null, 8, ["data"])) : L("", !0),
      a.isLeadsView ? L("", !0) : (_(), O(Re, { key: 1 }, [
        W(s, {
          title: "Répartition mensuelle/annuelle",
          data: a.format((l = n.analytics.sales) == null ? void 0 : l.monthlyAnnuallyRepartition),
          tooltipText: "Proportion des ventes effectuées avec un paiement mensuel ou annuel."
        }, null, 8, ["data"]),
        W(s, {
          title: "Répartition par durée de contrat",
          data: a.format((c = n.analytics.sales) == null ? void 0 : c.periodRepartition),
          tooltipText: "Répartition des ventes en fonction de la durée d'engagement des contrats."
        }, null, 8, ["data"])
      ], 64))
    ], 2)
  ]);
}
const Vce = /* @__PURE__ */ we(Nce, [["render", $ce]]);
function yA(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "",
    resource: {
      fr: {
        turnover_title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Chiffre d'affaire" } },
        turnover_tooltip: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Chiffre d'affaire prenant en compte les encaissements réussis et les remboursements." } },
        top_stores_title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Meilleurs points de vente" } },
        top_sellers_title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Meilleurs vendeurs" } },
        sales_column_label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ventes" } },
        sales_column_label_leads: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Formulaires complétés" } },
        sales_column_label_gross_sales: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Ventes brutes" } },
        x_axis_label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Mois" } },
        y_axis_label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Chiffre d'affaire" } }
      },
      en: {
        turnover_title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Turnover" } },
        turnover_tooltip: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Turnover taking into account successful payments and refunds." } },
        top_stores_title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Top stores" } },
        top_sellers_title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Top sellers" } },
        sales_column_label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sales" } },
        sales_column_label_leads: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Completed forms" } },
        sales_column_label_gross_sales: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Gross sales" } },
        x_axis_label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Month" } },
        y_axis_label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Turnover" } }
      }
    }
  });
}
const oR = {
  props: {
    analytics: { type: Object },
    comparisonType: { type: String, default: "previousMonth" },
    dataSource: { type: String, default: "contracts" },
    excludedStoreNames: { type: Array, default: () => [] }
  },
  components: {
    Variation: QI,
    BarChart: ace,
    AnalyticsSalesRepartition: Vce,
    SellerRankingTable: HJ,
    StoreRankingTable: XJ
  },
  setup() {
    const { t: e } = nr();
    return { t: e };
  },
  computed: {
    sellersRankingVisible() {
      return ["contracts", "gross_sales"].includes(this.dataSource) && Cr(this.filteredSellersRanking);
    },
    excludedStoreNamesLowercase() {
      return this.excludedStoreNames.map((e) => e.toLowerCase());
    },
    filteredStoresRanking() {
      var t, n;
      return (((n = (t = this.analytics) == null ? void 0 : t.sales) == null ? void 0 : n.storesRanking) ?? []).filter(
        (r) => {
          var i;
          return !this.excludedStoreNamesLowercase.includes((i = r.name) == null ? void 0 : i.toLowerCase());
        }
      );
    },
    filteredSellersRanking() {
      var t, n;
      return (((n = (t = this.analytics) == null ? void 0 : t.sales) == null ? void 0 : n.sellersRanking) ?? []).filter(
        (r) => {
          var i;
          return !this.excludedStoreNamesLowercase.includes(
            (i = r.salesChannel) == null ? void 0 : i.toLowerCase()
          );
        }
      );
    },
    storesRankingVisible() {
      return this.filteredStoresRanking.length >= 3;
    },
    topStoresRanking() {
      return this.filteredStoresRanking.slice(0, 5);
    },
    rankingSalesLabel() {
      const e = {
        contracts: "sales_column_label",
        leads: "sales_column_label_leads",
        gross_sales: "sales_column_label_gross_sales"
      };
      return this.t(e[this.dataSource] || "sales_column_label");
    },
    monthlyEstalyTurnoverData() {
      var t, n, r, i;
      return {
        sold: {
          color: "#8C1EFC",
          value: ((i = (r = (n = (t = this.analytics) == null ? void 0 : t.sales) == null ? void 0 : n.monthlyEstalyTurnover) == null ? void 0 : r.current) == null ? void 0 : i.map((a) => ({
            date: a.date,
            value: a.count
          }))) || []
        }
      };
    },
    monthlyEstalyTurnoverOptions() {
      return {
        responsive: !0,
        maintainAspectRatio: !1,
        interaction: {
          mode: "index",
          intersect: !1
        },
        scales: {
          x: {
            grid: {
              display: !1
            },
            title: {
              display: !0,
              text: this.t("x_axis_label")
            },
            ticks: {
              maxRotation: 0,
              minRotation: 0,
              align: "center",
              textAlign: "center",
              callback: this.monthlyXAxisCallback
            }
          },
          y: {
            grid: {
              display: !1,
              drawBorder: !1
            },
            beginAtZero: !0,
            title: {
              display: !0,
              text: this.t("y_axis_label")
            },
            ticks: {
              maxTicksLimit: 2,
              callback: (e) => this.formatPrice(e) ?? e
            },
            suggestedMax: Math.max(
              1,
              ...this.monthlyEstalyTurnoverData.sold.value.map(
                (e) => e.value
              )
            ) * 1.15,
            max: Math.max(
              1,
              ...this.monthlyEstalyTurnoverData.sold.value.map(
                (e) => e.value
              )
            ) * 1.15
          }
        },
        plugins: {
          annotation: !1,
          datalabels: {
            display: !0,
            color: "#1f2937",
            font: {
              weight: "bold",
              size: 11
            },
            formatter: (e) => {
              const t = (e == null ? void 0 : e.y) ?? e;
              return this.formatPrice(t) ?? t;
            },
            anchor: "end",
            align: "top",
            offset: 6
          },
          legend: { display: !1 },
          tooltip: {
            callbacks: {
              label: (e) => {
                var r, i;
                const t = ((r = e.raw) == null ? void 0 : r.y) ?? ((i = e.parsed) == null ? void 0 : i.y) ?? e.raw ?? 0, n = this.formatPrice(t) ?? t;
                return ` ${e.dataset.label} : ${n}`;
              }
            }
          }
        }
      };
    }
  },
  methods: {
    isPresent: Cr,
    formatPrice: Si,
    monthlyXAxisCallback(e, t, n) {
      var r;
      return this.monthlyEstalyTurnoverData.sold.value.length && (t === 0 || t === n.length - 1 || t % 2 === 0) ? ((r = this.monthlyEstalyTurnoverData.sold.value[t]) == null ? void 0 : r.date) || e : "";
    }
  }
}, Bce = {
  key: 0,
  class: "flex flex-col gap-4"
}, Uce = { class: "text-lg pl-2 tracking-tight text-gray-700 text-left" }, qce = { class: "text-sm ml-4 text-gray-500" }, jce = {
  key: 0,
  class: "bg-white px-6 py-4 rounded-lg shadow-lg"
}, Wce = { class: "flex items-center justify-between mb-2" }, zce = { class: "text-sm font-medium text-gray-500" }, Hce = {
  key: 1,
  class: "bg-white px-6 py-4 rounded-lg shadow-lg"
}, Gce = { class: "flex items-center justify-between mb-2" }, Yce = { class: "text-sm font-medium text-gray-500" };
function Kce(e, t, n, r, i, a) {
  var h, p;
  const s = U("Variation"), o = U("BarChart"), l = U("StoreRankingTable"), c = U("SellerRankingTable"), f = U("AnalyticsSalesRepartition");
  return a.isPresent(n.analytics) ? (_(), O("div", Bce, [
    (p = (h = n.analytics) == null ? void 0 : h.sales) != null && p.monthlyEstalyTurnover ? (_(), ae(o, {
      key: 0,
      title: r.t("turnover_title"),
      tooltipText: r.t("turnover_tooltip"),
      data: a.monthlyEstalyTurnoverData,
      options: a.monthlyEstalyTurnoverOptions
    }, {
      subtitle: ie(() => {
        var g, v, y, S, x, E, w, C, P;
        return [
          k("p", Uce, [
            Me(j(a.formatPrice((y = (v = (g = n.analytics) == null ? void 0 : g.general) == null ? void 0 : v.estalyTurnover) == null ? void 0 : y.current)) + " ", 1),
            k("span", qce, j(a.formatPrice((E = (x = (S = n.analytics) == null ? void 0 : S.general) == null ? void 0 : x.estalyTurnover) == null ? void 0 : E.previous)) + " " + j(n.comparisonType ? e.$t(n.comparisonType) : ""), 1),
            W(s, {
              class: "ml-2",
              variation: (P = (C = (w = n.analytics) == null ? void 0 : w.general) == null ? void 0 : C.estalyTurnover) == null ? void 0 : P.variation
            }, null, 8, ["variation"])
          ])
        ];
      }),
      _: 1
    }, 8, ["title", "tooltipText", "data", "options"])) : L("", !0),
    a.storesRankingVisible || a.sellersRankingVisible ? (_(), O("div", {
      key: 1,
      class: Pe(
        a.storesRankingVisible && a.sellersRankingVisible ? "grid grid-cols-1 lg:grid-cols-2 gap-4" : ""
      )
    }, [
      a.storesRankingVisible ? (_(), O("div", jce, [
        k("div", Wce, [
          k("p", zce, j(r.t("top_stores_title")), 1),
          xe(e.$slots, "stores-ranking-action")
        ]),
        W(l, {
          data: a.topStoresRanking,
          salesColumnLabel: a.rankingSalesLabel
        }, null, 8, ["data", "salesColumnLabel"])
      ])) : L("", !0),
      a.sellersRankingVisible ? (_(), O("div", Hce, [
        k("div", Gce, [
          k("p", Yce, j(r.t("top_sellers_title")), 1),
          xe(e.$slots, "sellers-ranking-action")
        ]),
        W(c, {
          data: a.filteredSellersRanking,
          salesColumnLabel: a.rankingSalesLabel
        }, null, 8, ["data", "salesColumnLabel"])
      ])) : L("", !0)
    ], 2)) : L("", !0),
    W(f, {
      analytics: n.analytics,
      "data-source": n.dataSource
    }, null, 8, ["analytics", "data-source"])
  ])) : L("", !0);
}
typeof yA == "function" && yA(oR);
const y0e = /* @__PURE__ */ we(oR, [["render", Kce]]), Xce = {
  methods: { formatPrice: Si, formatPercentage: X0 },
  components: { DataCard: IQ },
  props: ["analytics"],
  computed: {
    claimAnalytics() {
      var e;
      return (e = this.analytics) == null ? void 0 : e.claims;
    }
  }
}, Zce = { key: 0 }, Qce = { class: "grid grid-cols-1 gap-5 sm:grid-cols-3" };
function Jce(e, t, n, r, i, a) {
  const s = U("DataCard");
  return a.claimAnalytics ? (_(), O("div", Zce, [
    k("dl", Qce, [
      W(s, {
        title: "Sinistres déclarés",
        value: a.claimAnalytics.claimsFiledCount,
        tooltipText: "Nombre de sinistres déclarés pendant la période sélectionnée."
      }, null, 8, ["value"]),
      W(s, {
        title: "Taux d'acceptation",
        value: a.formatPercentage(a.claimAnalytics.acceptedClaimsRate),
        tooltipText: "Pourcentage de sinistres acceptés par rapport aux sinistres déclarés pendant la période sélectionnée."
      }, null, 8, ["value"]),
      W(s, {
        title: "Montant remboursé",
        value: a.formatPrice(a.claimAnalytics.reimbursedClaimsAmount),
        tooltipText: "Montant total remboursé pour les sinistres acceptés pendant la période sélectionnée."
      }, null, 8, ["value"])
    ])
  ])) : L("", !0);
}
const x0e = /* @__PURE__ */ we(Xce, [["render", Jce]]), ede = {
  props: {
    title: String,
    data: {
      type: Object,
      required: !0,
      default: () => ({ current: 0, previous: null, variation: null })
    },
    tooltipText: String,
    comparisonType: String
  },
  components: {
    InformationCircleIcon: ds,
    Variation: QI
  },
  methods: {
    formatData(e) {
      return this.data.type === "amount" ? Si(e) : this.data.type === "percentage" ? X0(e) : e;
    }
  }
}, tde = { class: "p-4" }, nde = { class: "flex gap-x-2 items-center" }, rde = { class: "truncate text-sm font-medium text-gray-500" }, ide = { class: "mt-1 text-2xl font-semibold tracking-tight text-gray-900" }, ade = { key: 0 }, sde = { class: "text-xs text-gray-500" };
function ode(e, t, n, r, i, a) {
  const s = U("InformationCircleIcon"), o = U("VTooltip"), l = U("Variation");
  return _(), O("div", tde, [
    k("div", nde, [
      k("dt", rde, j(n.title), 1),
      n.tooltipText || e.$slots.tooltip ? (_(), ae(o, {
        key: 0,
        theme: "info-tooltip"
      }, {
        popper: ie(() => [
          xe(e.$slots, "tooltip", {}, () => [
            k("span", null, j(n.tooltipText), 1)
          ])
        ]),
        default: ie(() => [
          W(s, {
            class: "cursor-pointer h-5 w-4 text-gray-400",
            "aria-hidden": "true"
          })
        ]),
        _: 3
      })) : L("", !0)
    ]),
    k("dd", ide, [
      Me(j(a.formatData(n.data.current)) + " ", 1),
      W(l, {
        class: "ml-2 inline-flex align-middle",
        variation: n.data.variation
      }, null, 8, ["variation"])
    ]),
    n.data.previous != null ? (_(), O("div", ade, [
      k("span", sde, j(a.formatData(n.data.previous)) + " " + j(n.comparisonType ? e.$t(n.comparisonType) : e.$t("yesterday")), 1)
    ])) : L("", !0)
  ]);
}
const w0e = /* @__PURE__ */ we(ede, [["render", ode]]), lde = {
  components: {
    PlusIcon: dB
  },
  props: {
    loading: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  }
}, ude = ["disabled"];
function cde(e, t, n, r, i, a) {
  const s = U("PlusIcon");
  return _(), O("button", {
    class: "relative inline-flex items-center pl-1 pr-2 py-1 text-sm tracking-wide border border-transparent shadow-xs font-medium text-button-font-primary bg-primary rounded-lg",
    disabled: n.loading || n.disabled
  }, [
    W(s, {
      class: "h-5 w-5 mr-1",
      "aria-hidden": "true"
    }),
    xe(e.$slots, "default")
  ], 8, ude);
}
const k0e = /* @__PURE__ */ we(lde, [["render", cde]]), dde = {
  components: {
    InformationCircleIcon: ds,
    XIcon: Zc,
    ExclamationCircleIcon: J5,
    CheckCircleIcon: AP
  },
  props: {
    message: {
      type: String,
      default: ""
    },
    dismissible: {
      type: Boolean,
      default: !0
    },
    variant: {
      type: String,
      default: "info",
      validator: (e) => ["info", "warning", "success"].includes(e)
    },
    dismissLabel: {
      type: String,
      default: "Fermer"
    }
  },
  emits: ["dismiss"]
}, fde = { class: "flex-1 text-sm font-medium" };
function hde(e, t, n, r, i, a) {
  const s = U("InformationCircleIcon"), o = U("ExclamationCircleIcon"), l = U("CheckCircleIcon"), c = U("XIcon");
  return _(), O("div", {
    class: Pe(["flex items-start gap-3 rounded-lg border px-4 py-3 my-4", [
      n.variant === "info" && "border-blue-200 bg-blue-50/50 text-blue-600",
      n.variant === "warning" && "border-yellow-200 bg-yellow-50/50 text-yellow-800",
      n.variant === "success" && "border-green-200 bg-green-50/50 text-green-800"
    ]]),
    role: "status"
  }, [
    n.variant === "info" ? (_(), ae(s, {
      key: 0,
      class: "h-5 w-5 text-blue-500",
      "aria-hidden": "true"
    })) : n.variant === "warning" ? (_(), ae(o, {
      key: 1,
      class: "h-5 w-5 text-yellow-500",
      "aria-hidden": "true"
    })) : n.variant === "success" ? (_(), ae(l, {
      key: 2,
      class: "h-5 w-5 text-green-500",
      "aria-hidden": "true"
    })) : L("", !0),
    k("p", fde, [
      xe(e.$slots, "default", {}, () => [
        Me(j(n.message), 1)
      ])
    ]),
    n.dismissible ? (_(), ae(c, {
      key: 3,
      class: Pe(["h-4 w-4", [n.variant === "info" && "text-blue-600 focus:ring-blue-400", n.variant === "warning" && "text-yellow-600 focus:ring-yellow-400", n.variant === "success" && "text-green-600 focus:ring-green-400"]]),
      "aria-hidden": "true",
      onClick: t[0] || (t[0] = (f) => e.$emit("dismiss"))
    }, null, 8, ["class"])) : L("", !0)
  ], 2);
}
const pde = /* @__PURE__ */ we(dde, [["render", hde]]), mde = {
  name: "ExtractionStatus",
  components: { InfoBanner: pde },
  props: {
    extracting: { type: Boolean, default: !1 },
    extractionError: { type: Boolean, default: !1 },
    extractionSuccess: { type: Boolean, default: !1 },
    extractingLabel: {
      type: String,
      default: "Extraction automatique des coûts en cours..."
    },
    errorLabel: {
      type: String,
      default: "L'extraction automatique a échoué. Veuillez remplir les coûts manuellement."
    },
    successLabel: {
      type: String,
      default: "Les coûts ont été pré-remplis automatiquement. Veuillez vérifier leur exactitude avant de continuer."
    }
  },
  emits: ["dismiss-success"]
}, gde = {
  key: 0,
  class: "mt-3 flex items-center text-sm text-gray-500"
}, vde = {
  key: 1,
  class: "mt-3 text-sm text-yellow-600"
};
function bde(e, t, n, r, i, a) {
  const s = U("InfoBanner");
  return _(), O("div", null, [
    n.extracting ? (_(), O("div", gde, [
      t[1] || (t[1] = k("svg", {
        class: "animate-spin -ml-1 mr-2 h-4 w-4 text-gray-500",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24"
      }, [
        k("circle", {
          class: "opacity-25",
          cx: "12",
          cy: "12",
          r: "10",
          stroke: "currentColor",
          "stroke-width": "4"
        }),
        k("path", {
          class: "opacity-75",
          fill: "currentColor",
          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        })
      ], -1)),
      Me(" " + j(n.extractingLabel), 1)
    ])) : L("", !0),
    n.extractionError ? (_(), O("div", vde, j(n.errorLabel), 1)) : L("", !0),
    n.extractionSuccess ? (_(), ae(s, {
      key: 2,
      variant: "info",
      onDismiss: t[0] || (t[0] = (o) => e.$emit("dismiss-success"))
    }, {
      default: ie(() => [
        Me(j(n.successLabel), 1)
      ]),
      _: 1
    })) : L("", !0)
  ]);
}
const _de = /* @__PURE__ */ we(mde, [["render", bde]]);
ls.register(...mx, ZI);
const yde = {
  props: {
    data: { type: Object },
    options: { type: Object },
    plugins: { type: Array },
    chartHeight: { type: Number, default: 300 }
  },
  components: {
    LineChart: Gle
  },
  watch: {
    chartData: {
      handler() {
        this.chartKey = this.chartKey + 1;
      },
      deep: !0
    }
  },
  data: () => ({
    chartKey: 0
  }),
  computed: {
    chartData: function() {
      return {
        datasets: Object.entries(this.data).map(([e, t]) => ({
          borderColor: t.color,
          fill: !1,
          borderWidth: 2,
          pointRadius: 0,
          parsing: !0,
          label: this.$t(e),
          data: t.value.map((n) => ({ x: n.date, y: n.value }))
        }))
      };
    },
    hasData: function() {
      var t;
      if (!this.data || typeof this.data != "object") return !1;
      const e = ((t = this.chartData) == null ? void 0 : t.datasets) || [];
      return e.length === 0 ? !1 : e.some((n) => n.data && n.data.length > 0 && n.data.some((r) => r && r.y > 0));
    }
  }
}, xde = {
  key: 1,
  class: "flex items-center justify-center text-gray-500 py-12"
};
function wde(e, t, n, r, i, a) {
  const s = U("LineChart", !0);
  return _(), O("div", null, [
    a.hasData ? (_(), ae(s, {
      chartData: a.chartData,
      options: n.options,
      width: 100,
      height: n.chartHeight,
      key: e.chartKey
    }, null, 8, ["chartData", "options", "height"])) : (_(), O("div", xde, [...t[0] || (t[0] = [
      k("p", { class: "text-lg" }, "Aucune donnée", -1)
    ])]))
  ]);
}
const S0e = /* @__PURE__ */ we(yde, [["render", wde]]), kde = {
  components: {
    Dialog: P0,
    DialogPanel: TO,
    TransitionChild: bp,
    TransitionRoot: _p,
    XIcon: Zc
  },
  props: {
    open: {
      type: Boolean,
      required: !0
    },
    size: {
      type: String,
      default: "small"
    },
    showCloseButton: {
      type: Boolean,
      default: !0
    },
    closeOnEsc: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["close"],
  methods: {
    onDialogClose() {
      this.closeOnEsc && this.$emit("close");
    }
  },
  computed: {
    // Classes complètes (pas d'interpolation) pour que Tailwind les détecte.
    modalWidth() {
      switch (this.size) {
        case "medium":
          return "sm:max-w-4xl";
        case "big":
          return "sm:max-w-6xl";
        default:
          return "sm:max-w-2xl";
      }
    }
  }
}, Sde = { class: "fixed z-10 inset-0 overflow-y-auto" }, Cde = { class: "flex items-center sm:items-center justify-center min-h-full p-4 text-center sm:p-0" };
function Tde(e, t, n, r, i, a) {
  const s = U("TransitionChild"), o = U("XIcon"), l = U("DialogPanel"), c = U("Dialog"), f = U("TransitionRoot");
  return _(), O("div", null, [
    W(f, {
      as: "template",
      show: n.open
    }, {
      default: ie(() => [
        W(c, {
          as: "div",
          class: "relative z-30",
          onClose: a.onDialogClose
        }, {
          default: ie(() => [
            W(s, {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: ie(() => [...t[1] || (t[1] = [
                k("div", { class: "fixed inset-0 bg-gray-500/75 transition-opacity" }, null, -1)
              ])]),
              _: 1
            }),
            k("div", Sde, [
              k("div", Cde, [
                W(s, {
                  as: "template",
                  enter: "ease-out duration-300",
                  "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
                  "enter-to": "opacity-100 translate-y-0 sm:scale-100",
                  leave: "ease-in duration-200",
                  "leave-from": "opacity-100 translate-y-0 sm:scale-100",
                  "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                }, {
                  default: ie(() => [
                    W(l, {
                      class: Pe([
                        "relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-visible shadow-xl transform transition-all sm:mb-16 sm:mt-8 sm:w-full sm:p-8",
                        a.modalWidth
                      ])
                    }, {
                      default: ie(() => [
                        n.showCloseButton ? (_(), ae(o, {
                          key: 0,
                          class: "absolute cursor-pointer top-0 right-0 h-6 w-6 m-2 text-gray-500",
                          onClick: t[0] || (t[0] = (h) => e.$emit("close"))
                        })) : L("", !0),
                        xe(e.$slots, "default")
                      ]),
                      _: 3
                    }, 8, ["class"])
                  ]),
                  _: 3
                })
              ])
            ])
          ]),
          _: 3
        }, 8, ["onClose"])
      ]),
      _: 3
    }, 8, ["show"])
  ]);
}
const C0e = /* @__PURE__ */ we(kde, [["render", Tde]]), Ade = {
  components: {
    Dialog: P0,
    DialogPanel: TO,
    TransitionChild: bp,
    TransitionRoot: _p,
    XIcon: Zc
  },
  props: {
    open: {
      type: Boolean,
      required: !0
    },
    showCloseButton: {
      type: Boolean,
      default: !0
    },
    contentClass: {
      type: String,
      default: "max-w-3xl"
    }
  },
  emits: ["close"]
}, Dde = { class: "sticky top-0 z-10 flex justify-end p-4" };
function Ede(e, t, n, r, i, a) {
  const s = U("XIcon"), o = U("DialogPanel"), l = U("TransitionChild"), c = U("Dialog"), f = U("TransitionRoot");
  return _(), O("div", null, [
    W(f, {
      as: "template",
      show: n.open
    }, {
      default: ie(() => [
        W(c, {
          as: "div",
          class: "relative z-30",
          onClose: t[1] || (t[1] = (h) => e.$emit("close"))
        }, {
          default: ie(() => [
            W(l, {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: ie(() => [
                W(o, { class: "fixed inset-0 bg-white overflow-y-auto" }, {
                  default: ie(() => [
                    k("div", Dde, [
                      n.showCloseButton ? (_(), O("button", {
                        key: 0,
                        type: "button",
                        "aria-label": "Fermer",
                        class: "text-gray-500 hover:text-gray-700 cursor-pointer",
                        onClick: t[0] || (t[0] = (h) => e.$emit("close"))
                      }, [
                        W(s, { class: "h-6 w-6" })
                      ])) : L("", !0)
                    ]),
                    k("div", {
                      class: Pe(["mx-auto px-4 pb-24 sm:pb-8 -mt-4", n.contentClass])
                    }, [
                      xe(e.$slots, "default")
                    ], 2)
                  ]),
                  _: 3
                })
              ]),
              _: 3
            })
          ]),
          _: 3
        })
      ]),
      _: 3
    }, 8, ["show"])
  ]);
}
const Pde = /* @__PURE__ */ we(Ade, [["render", Ede]]);
var Ode = {
  lessThanXSeconds: {
    one: "moins d’une seconde",
    other: "moins de {{count}} secondes"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} secondes"
  },
  halfAMinute: "30 secondes",
  lessThanXMinutes: {
    one: "moins d’une minute",
    other: "moins de {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "environ 1 heure",
    other: "environ {{count}} heures"
  },
  xHours: {
    one: "1 heure",
    other: "{{count}} heures"
  },
  xDays: {
    one: "1 jour",
    other: "{{count}} jours"
  },
  aboutXWeeks: {
    one: "environ 1 semaine",
    other: "environ {{count}} semaines"
  },
  xWeeks: {
    one: "1 semaine",
    other: "{{count}} semaines"
  },
  aboutXMonths: {
    one: "environ 1 mois",
    other: "environ {{count}} mois"
  },
  xMonths: {
    one: "1 mois",
    other: "{{count}} mois"
  },
  aboutXYears: {
    one: "environ 1 an",
    other: "environ {{count}} ans"
  },
  xYears: {
    one: "1 an",
    other: "{{count}} ans"
  },
  overXYears: {
    one: "plus d’un an",
    other: "plus de {{count}} ans"
  },
  almostXYears: {
    one: "presqu’un an",
    other: "presque {{count}} ans"
  }
}, Mde = function(t, n, r) {
  var i, a = Ode[t];
  return typeof a == "string" ? i = a : n === 1 ? i = a.one : i = a.other.replace("{{count}}", String(n)), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "dans " + i : "il y a " + i : i;
}, Ide = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, Rde = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Fde = {
  full: "{{date}} 'à' {{time}}",
  long: "{{date}} 'à' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Nde = {
  date: Gl({
    formats: Ide,
    defaultWidth: "full"
  }),
  time: Gl({
    formats: Rde,
    defaultWidth: "full"
  }),
  dateTime: Gl({
    formats: Fde,
    defaultWidth: "full"
  })
}, Lde = {
  lastWeek: "eeee 'dernier à' p",
  yesterday: "'hier à' p",
  today: "'aujourd’hui à' p",
  tomorrow: "'demain à' p'",
  nextWeek: "eeee 'prochain à' p",
  other: "P"
}, $de = function(t, n, r, i) {
  return Lde[t];
}, Vde = {
  narrow: ["av. J.-C", "ap. J.-C"],
  abbreviated: ["av. J.-C", "ap. J.-C"],
  wide: ["avant Jésus-Christ", "après Jésus-Christ"]
}, Bde = {
  narrow: ["T1", "T2", "T3", "T4"],
  abbreviated: ["1er trim.", "2ème trim.", "3ème trim.", "4ème trim."],
  wide: ["1er trimestre", "2ème trimestre", "3ème trimestre", "4ème trimestre"]
}, Ude = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["janv.", "févr.", "mars", "avr.", "mai", "juin", "juil.", "août", "sept.", "oct.", "nov.", "déc."],
  wide: ["janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre"]
}, qde = {
  narrow: ["D", "L", "M", "M", "J", "V", "S"],
  short: ["di", "lu", "ma", "me", "je", "ve", "sa"],
  abbreviated: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
  wide: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"]
}, jde = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "mat.",
    afternoon: "ap.m.",
    evening: "soir",
    night: "mat."
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "matin",
    afternoon: "après-midi",
    evening: "soir",
    night: "matin"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "du matin",
    afternoon: "de l’après-midi",
    evening: "du soir",
    night: "du matin"
  }
}, Wde = function(t, n) {
  var r = Number(t), i = n == null ? void 0 : n.unit;
  if (r === 0) return "0";
  var a = ["year", "week", "hour", "minute", "second"], s;
  return r === 1 ? s = i && a.includes(i) ? "ère" : "er" : s = "ème", r + s;
}, zde = {
  ordinalNumber: Wde,
  era: ya({
    values: Vde,
    defaultWidth: "wide"
  }),
  quarter: ya({
    values: Bde,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: ya({
    values: Ude,
    defaultWidth: "wide"
  }),
  day: ya({
    values: qde,
    defaultWidth: "wide"
  }),
  dayPeriod: ya({
    values: jde,
    defaultWidth: "wide"
  })
}, Hde = /^(\d+)(ième|ère|ème|er|e)?/i, Gde = /\d+/i, Yde = {
  narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
  abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
  wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
}, Kde = {
  any: [/^av/i, /^ap/i]
}, Xde = {
  narrow: /^T?[1234]/i,
  abbreviated: /^[1234](er|ème|e)? trim\.?/i,
  wide: /^[1234](er|ème|e)? trimestre/i
}, Zde = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Qde = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
  wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
}, Jde = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^av/i, /^ma/i, /^juin/i, /^juil/i, /^ao/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, efe = {
  narrow: /^[lmjvsd]/i,
  short: /^(di|lu|ma|me|je|ve|sa)/i,
  abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
  wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
}, tfe = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i]
}, nfe = {
  narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
  any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
}, rfe = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^min/i,
    noon: /^mid/i,
    morning: /mat/i,
    afternoon: /ap/i,
    evening: /soir/i,
    night: /nuit/i
  }
}, ife = {
  ordinalNumber: O2({
    matchPattern: Hde,
    parsePattern: Gde,
    valueCallback: function(t) {
      return parseInt(t);
    }
  }),
  era: xa({
    matchPatterns: Yde,
    defaultMatchWidth: "wide",
    parsePatterns: Kde,
    defaultParseWidth: "any"
  }),
  quarter: xa({
    matchPatterns: Xde,
    defaultMatchWidth: "wide",
    parsePatterns: Zde,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: xa({
    matchPatterns: Qde,
    defaultMatchWidth: "wide",
    parsePatterns: Jde,
    defaultParseWidth: "any"
  }),
  day: xa({
    matchPatterns: efe,
    defaultMatchWidth: "wide",
    parsePatterns: tfe,
    defaultParseWidth: "any"
  }),
  dayPeriod: xa({
    matchPatterns: nfe,
    defaultMatchWidth: "any",
    parsePatterns: rfe,
    defaultParseWidth: "any"
  })
}, Wy = {
  code: "fr",
  formatDistance: Mde,
  formatLong: Nde,
  formatRelative: $de,
  localize: zde,
  match: ife,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const afe = {
  components: { Datepicker: fu },
  props: {
    placeholder: {
      type: String,
      default: "Sélectionnez un mois"
    },
    modelValue: {
      type: Array,
      required: !0
    }
  },
  computed: {
    internalValue: {
      get() {
        if (!this.modelValue || !Array.isArray(this.modelValue) || this.modelValue.length !== 2)
          return null;
        const [e, t] = this.modelValue;
        return !e && !t ? null : [
          e ? { year: e.getFullYear(), month: e.getMonth() } : null,
          t ? { year: t.getFullYear(), month: t.getMonth() } : null
        ];
      },
      set(e) {
        if (!e) {
          this.$emit("update:modelValue", [null, null]);
          return;
        }
        if (Array.isArray(e) && e.length === 2) {
          const [t, n] = e, r = t ? Jc(new Date(t.year, t.month)) : null, i = n ? h0(new Date(n.year, n.month)) : null;
          r && i ? this.$emit("update:modelValue", [r, i]) : console.warn("Incomplete date range, not emitting update:", e);
        } else
          console.warn("Invalid value passed to setter:", e), this.$emit("update:modelValue", [null, null]);
      }
    }
  },
  methods: {
    formatPicker(e) {
      if (!e || !Array.isArray(e) || e.length < 2)
        return "";
      const [t, n] = e;
      if (!t || !n) return "";
      const r = ua(t, "MMM yyyy", { locale: Wy }), i = ua(n, "MMM yyyy", { locale: Wy });
      return r === i ? r : `${r} - ${i}`;
    }
  }
};
function sfe(e, t, n, r, i, a) {
  const s = U("Datepicker");
  return _(), ae(s, {
    placeholder: n.placeholder,
    class: "text-xs w-full rounded-md",
    modelValue: a.internalValue,
    "onUpdate:modelValue": t[0] || (t[0] = (o) => a.internalValue = o),
    "month-picker": !0,
    "auto-apply": !0,
    locale: "fr",
    "max-date": /* @__PURE__ */ new Date(),
    clearable: !0,
    range: "",
    format: a.formatPicker
  }, null, 8, ["placeholder", "modelValue", "max-date", "format"]);
}
const T0e = /* @__PURE__ */ we(afe, [["render", sfe]]), ofe = {
  components: { Datepicker: fu },
  props: {
    placeholder: {
      type: String,
      default: "Sélectionnez un mois"
    },
    modelValue: {
      type: Date,
      required: !1
    },
    minDate: {
      type: Date,
      required: !1
    }
  },
  computed: {
    internalValue: {
      get() {
        return this.modelValue ? {
          year: this.modelValue.getFullYear(),
          month: this.modelValue.getMonth()
        } : null;
      },
      set(e) {
        if (e && e.year !== void 0 && e.month !== void 0) {
          const t = new Date(e.year, e.month, 1);
          this.$emit("update:modelValue", t);
        } else
          this.$emit("update:modelValue", null);
      }
    }
  },
  methods: {
    formatPicker(e) {
      if (!e) return "";
      const t = /* @__PURE__ */ new Date(), n = t.getMonth(), r = t.getFullYear(), i = e.getMonth(), a = e.getFullYear(), s = Xr(t, 1), o = s.getMonth(), l = s.getFullYear();
      return i === n && a === r ? "Mois en cours" : i === o && a === l ? "Mois précédent" : ua(e, "MMM yyyy", { locale: Wy });
    }
  }
};
function lfe(e, t, n, r, i, a) {
  const s = U("Datepicker");
  return _(), ae(s, {
    placeholder: n.placeholder,
    class: "text-xs w-full rounded-md",
    modelValue: a.internalValue,
    "onUpdate:modelValue": t[0] || (t[0] = (o) => a.internalValue = o),
    "month-picker": !0,
    "auto-apply": !0,
    locale: "fr",
    "max-date": /* @__PURE__ */ new Date(),
    "min-date": n.minDate,
    clearable: !1,
    format: a.formatPicker
  }, null, 8, ["placeholder", "modelValue", "max-date", "min-date", "format"]);
}
const A0e = /* @__PURE__ */ we(ofe, [["render", lfe]]), ufe = {}, cfe = { class: "container mx-auto mt-20" };
function dfe(e, t, n, r, i, a) {
  const s = U("router-link");
  return _(), O("div", cfe, [
    t[1] || (t[1] = k("h1", { class: "text-3xl font-bold text-center" }, "404", -1)),
    t[2] || (t[2] = k("p", { class: "text-center" }, "Page non trouvée", -1)),
    W(s, {
      to: "/",
      class: "block text-center mt-4 text-primary"
    }, {
      default: ie(() => [...t[0] || (t[0] = [
        Me(" Retour à l'accueil ", -1)
      ])]),
      _: 1
    })
  ]);
}
const D0e = /* @__PURE__ */ we(ufe, [["render", dfe]]), ffe = {
  components: {
    Spinner: Y0
  },
  props: {
    loading: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    colorClass: {
      type: String,
      default: "bg-white text-gray-900 hover:bg-gray-50"
    }
  }
}, hfe = ["disabled"];
function pfe(e, t, n, r, i, a) {
  const s = U("Spinner");
  return _(), O("button", {
    type: "button",
    class: Pe(["rounded-md px-2.5 py-1.5 text-sm font-semibold shadow-xs ring-1 ring-inset ring-gray-300 flex items-center", [
      n.loading || n.disabled ? "opacity-60 cursor-not-allowed" : "cursor-pointer",
      n.colorClass
    ]]),
    disabled: n.loading || n.disabled
  }, [
    n.loading ? (_(), ae(s, {
      key: 0,
      class: "mr-2"
    })) : L("", !0),
    xe(e.$slots, "default")
  ], 10, hfe);
}
const lR = /* @__PURE__ */ we(ffe, [["render", pfe]]), mfe = {
  components: {
    SecondaryButton: lR
  },
  props: {
    currentPage: {
      type: Number,
      required: !0
    },
    totalPages: {
      type: Number,
      required: !1
    },
    totalCount: {
      type: Number,
      required: !1
    },
    elementsPerPage: {
      type: Number,
      default: 25
    }
  },
  computed: {
    displayPaginationDetails() {
      return Cr(this.totalPages) && Cr(this.totalCount);
    },
    startIdx() {
      return (this.currentPage - 1) * this.elementsPerPage;
    },
    endIdx() {
      return Math.min(this.startIdx + this.elementsPerPage, this.totalCount);
    }
  },
  methods: {
    changePage(e) {
      e === this.currentPage || e === 0 || this.displayPaginationDetails && e > this.totalPages || this.$emit("changePage", e);
    }
  }
}, gfe = {
  key: 0,
  class: "bg-white px-3 py-2 flex flex-col items-center gap-2 sm:flex-row sm:justify-between border-t border-gray-200 sticky bottom-0 z-10"
}, vfe = { class: "text-xs text-gray-500" }, bfe = { key: 0 }, _fe = { class: "font-medium text-gray-700" }, yfe = { class: "font-medium text-gray-700" }, xfe = { class: "font-medium text-gray-700" }, wfe = { key: 1 }, kfe = {
  key: 0,
  class: "flex items-center gap-1"
};
function Sfe(e, t, n, r, i, a) {
  const s = U("SecondaryButton");
  return n.totalCount === void 0 || n.totalCount > 1 ? (_(), O("div", gfe, [
    k("div", vfe, [
      a.displayPaginationDetails ? (_(), O("p", bfe, [
        t[2] || (t[2] = Me(" Affichage de ", -1)),
        k("span", _fe, j(a.startIdx + 1), 1),
        t[3] || (t[3] = Me(" à ", -1)),
        k("span", yfe, j(a.endIdx), 1),
        t[4] || (t[4] = Me(" sur ", -1)),
        k("span", xfe, j(n.totalCount.toLocaleString()), 1),
        t[5] || (t[5] = Me(" éléments ", -1))
      ])) : (_(), O("p", wfe, "Page " + j(n.currentPage), 1))
    ]),
    this.totalPages > 1 ? (_(), O("div", kfe, [
      W(s, {
        onClick: t[0] || (t[0] = (o) => a.changePage(n.currentPage - 1)),
        disabled: n.currentPage === 1
      }, {
        default: ie(() => [...t[6] || (t[6] = [
          k("span", { class: "text-xs font-normal" }, "Précédent", -1)
        ])]),
        _: 1
      }, 8, ["disabled"]),
      !a.displayPaginationDetails || n.currentPage < n.totalPages ? (_(), ae(s, {
        key: 0,
        onClick: t[1] || (t[1] = (o) => a.changePage(n.currentPage + 1))
      }, {
        default: ie(() => [...t[7] || (t[7] = [
          k("span", { class: "text-xs font-normal" }, "Suivant", -1)
        ])]),
        _: 1
      })) : L("", !0)
    ])) : L("", !0)
  ])) : L("", !0);
}
const E0e = /* @__PURE__ */ we(mfe, [["render", Sfe]]), Cfe = {
  green: {
    inactive: "bg-green-100 text-green-800 ring-1 ring-inset ring-green-200 hover:bg-green-200",
    active: "bg-green-100 text-green-800 ring-2 ring-inset ring-green-500"
  },
  yellow: {
    inactive: "bg-yellow-100 text-yellow-800 ring-1 ring-inset ring-yellow-200 hover:bg-yellow-200",
    active: "bg-yellow-100 text-yellow-800 ring-2 ring-inset ring-yellow-500"
  },
  red: {
    inactive: "bg-red-100 text-red-800 ring-1 ring-inset ring-red-200 hover:bg-red-200",
    active: "bg-red-100 text-red-800 ring-2 ring-inset ring-red-500"
  },
  gray: {
    inactive: "bg-gray-100 text-gray-700 ring-1 ring-inset ring-gray-300 hover:bg-gray-200",
    active: "bg-gray-100 text-gray-700 ring-2 ring-inset ring-gray-500"
  }
}, Tfe = {
  inactive: "bg-white text-gray-600 ring-1 ring-inset ring-gray-300 hover:bg-gray-50",
  active: "bg-primary-light text-primary-dark ring-1 ring-inset ring-primary-lighter"
}, Afe = {
  name: "Pills",
  props: {
    modelValue: {
      type: [String, Number],
      default: null
    },
    options: {
      type: Array,
      required: !0
    },
    // Tonalité de chaque option (tableau parallèle à `options`) parmi
    // "green" | "yellow" | "red" | "gray". Une valeur vide garde l'habillage par défaut.
    tones: {
      type: Array,
      default: () => []
    },
    // Options non sélectionnables (tableau de booléens parallèle à `options`) : affichées
    // pour montrer le parcours, mais estompées et inertes.
    disabled: {
      type: Array,
      default: () => []
    }
  },
  emits: ["update:modelValue"],
  methods: {
    isDisabled(e) {
      return !!this.disabled[e];
    },
    pillClass(e, t) {
      const n = "rounded-full px-3 py-1 text-sm font-medium shadow-xs transition-colors";
      if (this.isDisabled(t))
        return `${n} cursor-not-allowed bg-gray-50 text-gray-400 ring-1 ring-inset ring-gray-200`;
      const r = Cfe[this.tones[t]] || Tfe;
      return `${n} cursor-pointer ${this.modelValue === e ? r.active : r.inactive}`;
    }
  }
}, Dfe = {
  key: 0,
  class: "flex flex-wrap gap-2"
}, Efe = ["disabled", "onClick"];
function Pfe(e, t, n, r, i, a) {
  return n.options.length > 1 ? (_(), O("div", Dfe, [
    (_(!0), O(Re, null, Ke(n.options, (s, o) => (_(), O("button", {
      key: s,
      type: "button",
      class: Pe(a.pillClass(s, o)),
      disabled: a.isDisabled(o),
      onClick: (l) => e.$emit("update:modelValue", s)
    }, j(s), 11, Efe))), 128))
  ])) : L("", !0);
}
const P0e = /* @__PURE__ */ we(Afe, [["render", Pfe]]);
function uR(e) {
  return e !== null ? e.charAt(0).toUpperCase() + e.slice(1) : null;
}
function Ofe(e) {
  return e.replace(/([A-Z]+)/g, " $1").replace(/([A-Z][a-z])/g, "$1").toLowerCase();
}
function O0e(e) {
  return e ? e.replace(/([A-Z])/g, "_$1").toLowerCase() : null;
}
const Mfe = {
  components: {
    MultiSelect: dG
  },
  props: {
    filterName: {
      type: String,
      required: !0
    },
    filterIdx: {
      type: Number,
      required: !0
    },
    availableFilters: {
      type: Array,
      required: !0
    },
    selectedFilters: {
      type: Array,
      required: !0
    },
    enableSelectAll: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  data() {
    return {
      searchKeyword: ""
    };
  },
  computed: {
    selectedOptions: {
      get() {
        return this.selectedFilters[this.filterName];
      },
      set(e) {
        this.updateSelectedOptions(e);
      }
    },
    availableOptions() {
      return this.availableFilters[this.filterName].map((e) => this.hasLabelValue(e) ? { label: e.label, value: e.value } : { label: e, value: e });
    },
    cleanFilterName() {
      return uR(Ofe(this.filterName));
    }
  },
  methods: {
    updateSelectedOptions(e) {
      this.$emit("update-filter-search", this.filterName, e);
    },
    hasLabelValue(e) {
      return e.label !== void 0 && e.value !== void 0;
    }
  }
};
function Ife(e, t, n, r, i, a) {
  const s = U("MultiSelect");
  return _(), ae(s, {
    name: `${n.filterName}${n.filterIdx}`,
    label: e.$t(a.cleanFilterName),
    options: a.availableOptions,
    enableSelectAll: n.enableSelectAll,
    modelValue: a.selectedOptions,
    "onUpdate:modelValue": t[0] || (t[0] = (o) => a.selectedOptions = o)
  }, null, 8, ["name", "label", "options", "enableSelectAll", "modelValue"]);
}
const Rfe = /* @__PURE__ */ we(Mfe, [["render", Ife]]);
function xA(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "",
    resource: {
      fr: {
        clear_filters: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Effacer les filtres" } }
      },
      en: {
        clear_filters: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Clear filters" } }
      }
    }
  });
}
const cR = {
  name: "ClearFiltersButton",
  components: { XIcon: Zc },
  setup() {
    const { t: e } = nr();
    return { t: e };
  }
}, Ffe = {
  type: "button",
  "data-test": "clear-filters",
  class: "inline-flex items-center gap-1 text-sm font-medium text-gray-500 hover:text-gray-900 whitespace-nowrap cursor-pointer"
};
function Nfe(e, t, n, r, i, a) {
  const s = U("XIcon");
  return _(), O("button", Ffe, [
    W(s, {
      class: "h-4 w-4",
      "aria-hidden": "true"
    }),
    Me(" " + j(r.t("clear_filters")), 1)
  ]);
}
typeof xA == "function" && xA(cR);
const Lfe = /* @__PURE__ */ we(cR, [["render", Nfe]]), $fe = {
  name: "SearchToolbar",
  components: {
    SearchIcon: Fc,
    XIcon: Zc,
    SearchBarFilter: Rfe,
    ClearFiltersButton: Lfe
  },
  props: {
    placeholder: {
      type: String,
      default: ""
    },
    availableFilters: {
      type: Object,
      default: () => ({})
    },
    selectedFilters: {
      type: Object,
      default: () => ({})
    },
    initialKeywords: {
      type: String,
      default: null
    },
    hasActivePeriod: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      debounce: null,
      searchContent: this.initialKeywords
    };
  },
  watch: {
    searchContent(e) {
      clearTimeout(this.debounce), this.debounce = setTimeout(() => {
        this.$emit("update-keyword-search", e);
      }, 500);
    }
  },
  computed: {
    availableFiltersWithOptions() {
      return Object.fromEntries(
        Object.entries(this.availableFilters).filter(
          ([e, t]) => e && (t == null ? void 0 : t.length) > 1
        )
      );
    },
    isKeywordsInputNotEmpty() {
      return this.searchContent != null && this.searchContent !== "";
    },
    hasFilters() {
      return Object.keys(this.availableFiltersWithOptions).length > 0;
    },
    activeFilterNames() {
      return Object.keys(this.availableFilters).filter(
        (e) => {
          var t;
          return ((t = this.selectedFilters[e]) == null ? void 0 : t.length) > 0;
        }
      );
    },
    canClearFilters() {
      return this.activeFilterNames.length > 0 || this.hasActivePeriod;
    }
  },
  beforeUnmount() {
    clearTimeout(this.debounce), this.debounce = null;
  },
  methods: {
    clear() {
      this.searchContent = "";
    },
    updateFilterSearch(e, t) {
      this.$emit("update-filter-search", e, t);
    },
    clearFilters() {
      this.activeFilterNames.forEach((e) => {
        this.$emit("update-filter-search", e, []);
      }), this.$emit("clear-filters");
    }
  }
}, Vfe = { class: "bg-white px-4 py-3" }, Bfe = { class: "flex flex-col lg:flex-row lg:items-center gap-3" }, Ufe = { class: "relative lg:flex-1 lg:min-w-0" }, qfe = { class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" }, jfe = ["placeholder", "aria-label"], Wfe = {
  key: 0,
  class: "shrink-0"
}, zfe = {
  key: 1,
  class: "flex flex-wrap lg:flex-nowrap items-center gap-0.5 shrink-0 ml-auto"
}, Hfe = {
  key: 3,
  class: "shrink-0"
};
function Gfe(e, t, n, r, i, a) {
  const s = U("SearchIcon"), o = U("XIcon"), l = U("SearchBarFilter"), c = U("ClearFiltersButton");
  return _(), O("div", Vfe, [
    k("div", Bfe, [
      k("div", Ufe, [
        k("div", qfe, [
          W(s, {
            class: "h-4 w-4 text-gray-400",
            "aria-hidden": "true"
          })
        ]),
        ur(k("input", {
          type: "text",
          class: "block w-full rounded-md pl-9 pr-8 py-1.5 text-sm border-gray-300 focus:ring-primary focus:border-primary",
          placeholder: n.placeholder,
          "aria-label": n.placeholder,
          "onUpdate:modelValue": t[0] || (t[0] = (f) => i.searchContent = f)
        }, null, 8, jfe), [
          [tl, i.searchContent]
        ]),
        a.isKeywordsInputNotEmpty ? (_(), O("button", {
          key: 0,
          type: "button",
          "aria-label": "Clear search",
          class: "absolute inset-y-0 right-0 pr-2 flex items-center text-gray-400 hover:text-gray-600",
          onClick: t[1] || (t[1] = (...f) => a.clear && a.clear(...f))
        }, [
          W(o, {
            class: "h-4 w-4",
            "aria-hidden": "true"
          })
        ])) : L("", !0)
      ]),
      e.$slots.default ? (_(), O("div", Wfe, [
        xe(e.$slots, "default")
      ])) : L("", !0),
      a.hasFilters ? (_(), O("div", zfe, [
        (_(!0), O(Re, null, Ke(a.availableFiltersWithOptions, (f, h, p) => (_(), ae(l, {
          key: h,
          filterName: h,
          filterIdx: p,
          availableFilters: n.availableFilters,
          selectedFilters: n.selectedFilters,
          onUpdateFilterSearch: a.updateFilterSearch
        }, null, 8, ["filterName", "filterIdx", "availableFilters", "selectedFilters", "onUpdateFilterSearch"]))), 128))
      ])) : L("", !0),
      a.canClearFilters ? (_(), ae(c, {
        key: 2,
        class: "shrink-0",
        onClick: a.clearFilters
      }, null, 8, ["onClick"])) : L("", !0),
      e.$slots.append ? (_(), O("div", Hfe, [
        xe(e.$slots, "append")
      ])) : L("", !0)
    ])
  ]);
}
const M0e = /* @__PURE__ */ we($fe, [["render", Gfe]]), Yfe = {
  components: {
    Spinner: Y0
  },
  props: {
    loading: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  }
}, Kfe = ["disabled"];
function Xfe(e, t, n, r, i, a) {
  const s = U("Spinner");
  return _(), O("button", {
    type: "button",
    class: Pe(["inline-flex items-center justify-center rounded-2xl border border-transparent text-button-font-primary bg-primary uppercase px-6 py-3 text-base font-medium text-white shadow-xs", n.loading || n.disabled ? "opacity-60 cursor-not-allowed" : ""]),
    disabled: n.loading || n.disabled
  }, [
    n.loading ? (_(), ae(s, {
      key: 0,
      color: "text-white"
    })) : L("", !0),
    xe(e.$slots, "default")
  ], 10, Kfe);
}
const I0e = /* @__PURE__ */ we(Yfe, [["render", Xfe]]), Zfe = {
  components: {
    Menu: $7,
    MenuButton: V7,
    MenuItems: B7,
    ChevronDownIcon: Qc
  },
  props: {
    label: {
      type: String,
      required: !0
    }
  }
};
function Qfe(e, t, n, r, i, a) {
  const s = U("ChevronDownIcon"), o = U("MenuButton"), l = U("MenuItems"), c = U("Menu");
  return _(), ae(c, {
    as: "div",
    class: "relative"
  }, {
    default: ie(() => [
      W(o, { class: "rounded-md px-2.5 py-1.5 text-sm font-semibold shadow-xs ring-1 ring-inset ring-gray-300 flex items-center bg-white text-gray-900 hover:bg-gray-50" }, {
        default: ie(() => [
          Me(j(n.label) + " ", 1),
          W(s, {
            class: "ml-1 h-4 w-4",
            "aria-hidden": "true"
          })
        ]),
        _: 1
      }),
      W(l, { class: "absolute left-0 z-10 mt-2 w-max rounded-md bg-white py-1 shadow-lg ring-1 ring-black/5 focus:outline-hidden" }, {
        default: ie(() => [
          xe(e.$slots, "default")
        ]),
        _: 3
      })
    ]),
    _: 3
  });
}
const R0e = /* @__PURE__ */ we(Zfe, [["render", Qfe]]), Jfe = {
  inheritAttrs: !1,
  components: {
    MenuItem: U7
  }
};
function ehe(e, t, n, r, i, a) {
  const s = U("MenuItem");
  return _(), ae(s, null, {
    default: ie(({ active: o }) => [
      k("button", or({ type: "button" }, e.$attrs, {
        class: [
          o ? "bg-gray-100 text-gray-900" : "text-gray-700",
          "block w-full px-4 py-2 text-left text-sm"
        ]
      }), [
        xe(e.$slots, "default")
      ], 16)
    ]),
    _: 3
  });
}
const F0e = /* @__PURE__ */ we(Jfe, [["render", ehe]]), the = {
  name: "LinkButton",
  props: {
    href: {
      type: String,
      required: !0
    }
  }
}, nhe = ["href"];
function rhe(e, t, n, r, i, a) {
  return _(), O("a", {
    href: n.href,
    target: "_blank",
    rel: "noopener noreferrer",
    class: "rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 hover:bg-gray-50 inline-flex items-center gap-1.5 cursor-pointer"
  }, [
    xe(e.$slots, "default")
  ], 8, nhe);
}
const N0e = /* @__PURE__ */ we(the, [["render", rhe]]), ihe = {
  props: {
    tabs: {
      type: Array,
      required: !0
    },
    tabClass: {
      type: String,
      default: ""
    }
  },
  methods: {
    selectTab(e) {
      this.$emit("tab-selected", e), this.tabs.forEach((t) => {
        t.current = t.name === e.name;
      });
    }
  }
}, ahe = { class: "mb-4 border-b border-gray-200" }, she = {
  class: "-mb-px flex space-x-8 overflow-x-auto pl-2 pr-2",
  "aria-label": "Tabs"
}, ohe = ["onClick"], lhe = { class: "flex items-center" };
function uhe(e, t, n, r, i, a) {
  return _(), O("div", null, [
    k("div", ahe, [
      k("nav", she, [
        (_(!0), O(Re, null, Ke(n.tabs, (s) => (_(), O("a", {
          key: s.name,
          onClick: sn((o) => a.selectTab(s), ["prevent"]),
          class: Pe([
            s.current ? "border-primary text-primary-dark" : "border-transparent text-gray-600 hover:border-gray-300 hover:text-gray-700",
            "whitespace-nowrap border-b-2 py-2 px-1 text-sm font-medium cursor-pointer",
            n.tabClass
          ])
        }, [
          k("div", lhe, [
            k("span", null, j(s.displayName), 1),
            s.badge ? (_(), O("span", {
              key: 0,
              class: Pe([
                "ml-2 inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium",
                s.badge.class || "bg-red-100 text-red-800"
              ])
            }, j(s.badge.text), 3)) : L("", !0)
          ])
        ], 10, ohe))), 128))
      ])
    ]),
    (_(!0), O(Re, null, Ke(n.tabs, (s) => (_(), O("div", {
      key: s.name
    }, [
      s.current ? xe(e.$slots, s.name, {}, void 0, void 0, 0) : L("", !0)
    ]))), 128))
  ]);
}
const che = /* @__PURE__ */ we(ihe, [["render", uhe]]), dhe = {
  props: {
    modelValue: {
      type: [String, Number],
      required: !0
    },
    options: {
      type: Array,
      required: !0
    }
  },
  emits: ["update:modelValue"]
}, fhe = { class: "inline-flex flex-col sm:flex-row items-stretch sm:items-center rounded-lg bg-gray-100 p-1 border border-gray-200" }, hhe = ["onClick"];
function phe(e, t, n, r, i, a) {
  return _(), O("div", fhe, [
    (_(!0), O(Re, null, Ke(n.options, (s) => (_(), O("button", {
      key: s.value,
      class: Pe([
        "flex items-center gap-1.5 px-4 py-2 text-sm font-medium rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer",
        n.modelValue === s.value ? "bg-primary text-white shadow-xs" : "text-gray-600 hover:text-gray-800"
      ]),
      onClick: (o) => e.$emit("update:modelValue", s.value)
    }, [
      s.icon ? (_(), ae(Lr(s.icon), {
        key: 0,
        class: "w-4 h-4"
      })) : L("", !0),
      Me(" " + j(s.label), 1)
    ], 10, hhe))), 128))
  ]);
}
const L0e = /* @__PURE__ */ we(dhe, [["render", phe]]), mhe = {
  props: {
    modelValue: {
      type: [String, Number],
      required: !0
    },
    options: {
      type: Array,
      required: !0,
      validator: (e) => e.length === 2
    }
  },
  emits: ["update:modelValue"],
  computed: {
    activeLabel() {
      const e = this.options.find((t) => t.value === this.modelValue);
      return e ? e.label : "";
    }
  },
  methods: {
    toggle() {
      const e = this.options.find((t) => t.value !== this.modelValue);
      this.$emit("update:modelValue", e.value);
    }
  }
}, ghe = {
  class: "w-3.5 h-3.5",
  viewBox: "0 0 16 16",
  fill: "currentColor"
}, vhe = {
  key: 0,
  d: "M3.5 3.5a.5.5 0 0 0-1 0v8.793l-1.146-1.147a.5.5 0 0 0-.708.708l2 2a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L3.5 12.293V3.5z"
}, bhe = {
  key: 1,
  d: "M3.5 12.5a.5.5 0 0 1-1 0V3.707L1.354 4.854a.5.5 0 1 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L3.5 3.707V12.5z"
};
function _he(e, t, n, r, i, a) {
  return _(), O("button", {
    class: "inline-flex items-center gap-1 px-2 py-1 text-xs font-medium text-gray-500 hover:text-gray-900 rounded-md hover:bg-gray-100 transition-colors duration-150 cursor-pointer select-none",
    onClick: t[0] || (t[0] = (...s) => a.toggle && a.toggle(...s))
  }, [
    (_(), O("svg", ghe, [
      n.modelValue === n.options[0].value ? (_(), O("path", vhe)) : (_(), O("path", bhe)),
      t[1] || (t[1] = k("path", { d: "M7 6.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5z" }, null, -1)),
      t[2] || (t[2] = k("path", { d: "M7 9.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5z" }, null, -1)),
      t[3] || (t[3] = k("path", { d: "M7 3.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5z" }, null, -1)),
      t[4] || (t[4] = k("path", { d: "M7 12.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5z" }, null, -1))
    ])),
    k("span", null, j(a.activeLabel), 1)
  ]);
}
const $0e = /* @__PURE__ */ we(mhe, [["render", _he]]), yhe = {
  components: { Tabs: che },
  props: {
    tabs: {
      type: Array,
      required: !0
    }
  },
  computed: {
    tabsWithCurrent() {
      const e = this.tabs.map((t) => ({ ...t, current: this.isCurrent(t) }));
      return e.length > 0 && e.every((t) => !t.current) && (e[0].current = !0), e;
    }
  },
  methods: {
    goTo(e) {
      this.$router.push({
        path: e.path || this.$route.path,
        query: { ...this.$route.query, ...e.query }
        // 🔥 On fusionne les paramètres
      });
    },
    isCurrent(e) {
      return e.path ? this.$route.matched.some((t) => t.path === e.path) : e.query ? Object.keys(e.query).every((t) => this.$route.query[t] === e.query[t]) : !1;
    }
  }
};
function xhe(e, t, n, r, i, a) {
  const s = U("Tabs");
  return _(), ae(s, {
    tabs: a.tabsWithCurrent,
    onTabSelected: a.goTo,
    class: "mb-6"
  }, null, 8, ["tabs", "onTabSelected"]);
}
const V0e = /* @__PURE__ */ we(yhe, [["render", xhe]]), whe = {
  props: {
    title: {
      type: String,
      required: !0
    }
  }
}, khe = { class: "flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-4 sm:mb-0" }, She = { class: "text-4xl font-extrabold pl-2 tracking-tight text-gray-900 my-2" };
function Che(e, t, n, r, i, a) {
  return _(), O("div", khe, [
    k("h1", She, j(e.$t(n.title)), 1),
    xe(e.$slots, "default")
  ]);
}
const B0e = /* @__PURE__ */ we(whe, [["render", Che]]), The = {
  name: "ShowPageHeader",
  props: {
    backLabel: {
      type: String,
      required: !0
    },
    backRoute: {
      type: String,
      required: !0
    },
    title: {
      type: String,
      required: !0
    }
  },
  methods: {
    navigateBack() {
      window.history.length > 1 ? this.$router.back() : this.$router.push(this.backRoute);
    }
  }
}, Ahe = { class: "mt-3" }, Dhe = { class: "flex flex-col md:flex-row md:items-center gap-2 md:gap-3" }, Ehe = { class: "text-xl md:text-2xl font-bold text-gray-900" }, Phe = { class: "flex items-center gap-2" }, Ohe = {
  key: 0,
  class: "flex flex-wrap items-center gap-2 mt-4"
};
function Mhe(e, t, n, r, i, a) {
  return _(), O("div", null, [
    k("button", {
      type: "button",
      class: "text-sm font-medium text-primary-dark cursor-pointer hover:underline inline-flex items-center",
      onClick: t[0] || (t[0] = (...s) => a.navigateBack && a.navigateBack(...s))
    }, [
      t[1] || (t[1] = k("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        class: "h-4 w-4 mr-1",
        fill: "none",
        viewBox: "0 0 24 24",
        stroke: "currentColor",
        "stroke-width": "2"
      }, [
        k("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          d: "M15 19l-7-7 7-7"
        })
      ], -1)),
      Me(" " + j(n.backLabel), 1)
    ]),
    k("div", Ahe, [
      k("div", Dhe, [
        k("h1", Ehe, j(n.title), 1),
        k("div", Phe, [
          xe(e.$slots, "badges")
        ])
      ])
    ]),
    e.$slots.actions ? (_(), O("div", Ohe, [
      xe(e.$slots, "actions")
    ])) : L("", !0)
  ]);
}
const U0e = /* @__PURE__ */ we(The, [["render", Mhe]]), Ihe = {
  mounted(e, t) {
    e._clickOutside = (n) => {
      e === n.target || e.contains(n.target) || t.value(n);
    }, document.addEventListener("click", e._clickOutside);
  },
  unmounted(e) {
    document.removeEventListener("click", e._clickOutside);
  }
}, Rhe = {
  name: "FilterButton",
  props: {
    disabled: {
      type: Boolean,
      default: !1
    }
  }
}, Fhe = ["disabled"];
function Nhe(e, t, n, r, i, a) {
  return _(), O("button", {
    type: "button",
    class: "flex items-center px-2.5 py-1 rounded-md bg-white text-gray-600 font-medium text-xs transition-colors duration-150 hover:bg-gray-50 hover:text-gray-800 cursor-pointer",
    disabled: n.disabled
  }, [
    xe(e.$slots, "default")
  ], 8, Fhe);
}
const Lhe = /* @__PURE__ */ we(Rhe, [["render", Nhe]]), $he = {
  components: { FilterButton: Lhe },
  directives: {
    clickOutside: Ihe
  },
  emits: ["open"],
  data() {
    return {
      show: !1
    };
  },
  methods: {
    togglePopover(e) {
      e.stopPropagation();
      const t = !this.show;
      this.show = !this.show, t && this.$nextTick(() => this.$emit("open"));
    },
    closePopover() {
      this.show = !1;
    }
  }
}, Vhe = { class: "relative" };
function Bhe(e, t, n, r, i, a) {
  const s = U("FilterButton"), o = kP("click-outside");
  return _(), O("div", Vhe, [
    W(s, { onClick: a.togglePopover }, {
      default: ie(() => [
        xe(e.$slots, "button")
      ]),
      _: 3
    }, 8, ["onClick"]),
    ur((_(), O("div", {
      class: Pe([
        "absolute inline-block w-64 text-sm transition-opacity duration-300 bg-white border border-gray-200 rounded-lg",
        i.show ? "opacity-100 visible" : "opacity-0 invisible"
      ])
    }, [
      xe(e.$slots, "content")
    ], 2)), [
      [Ws, i.show],
      [o, a.closePopover]
    ])
  ]);
}
const q0e = /* @__PURE__ */ we($he, [["render", Bhe]]), Uhe = {
  name: "FieldRow",
  props: {
    label: {
      type: String,
      required: !0
    },
    value: {
      type: [String, Number],
      default: null
    },
    // Classe(s) complète(s) avec breakpoint, ex. "sm:w-48" (détectée par Tailwind).
    labelWidth: {
      type: String,
      default: "sm:w-48"
    },
    tooltip: {
      type: String,
      default: null
    }
  },
  components: {
    InformationCircleIcon: ds
  },
  computed: {
    displayValue() {
      return this.value != null && this.value !== "" ? this.value : "—";
    }
  }
}, qhe = { class: "flex flex-col sm:flex-row sm:items-start" }, jhe = { class: "text-gray-700 font-light break-words min-w-0 flex-1" };
function Whe(e, t, n, r, i, a) {
  const s = U("InformationCircleIcon"), o = U("VTooltip");
  return _(), O("div", qhe, [
    k("div", {
      class: Pe(["flex gap-x-1 items-center mb-1 sm:mb-0", ["text-gray-900 font-medium shrink-0", n.labelWidth]])
    }, [
      k("span", null, j(n.label), 1),
      n.tooltip ? (_(), ae(o, {
        key: 0,
        theme: "info-tooltip"
      }, {
        popper: ie(() => [
          k("span", null, j(n.tooltip), 1)
        ]),
        default: ie(() => [
          W(s, {
            class: "cursor-pointer h-4 w-4 text-gray-400",
            "aria-hidden": "true"
          })
        ]),
        _: 1
      })) : L("", !0)
    ], 2),
    k("span", jhe, [
      xe(e.$slots, "default", {}, () => [
        Me(j(a.displayValue), 1)
      ])
    ])
  ]);
}
const j0e = /* @__PURE__ */ we(Uhe, [["render", Whe]]), zhe = {
  name: "InlineLink"
}, Hhe = {
  type: "button",
  class: "text-primary hover:text-primary-dark cursor-pointer"
};
function Ghe(e, t, n, r, i, a) {
  return _(), O("button", Hhe, [
    xe(e.$slots, "default")
  ]);
}
const W0e = /* @__PURE__ */ we(zhe, [["render", Ghe]]), Yhe = {
  download: bh,
  external: DP,
  document: ip
}, Khe = {
  name: "LinkField",
  components: {
    CheckCircleIcon: AP,
    ChevronRightIcon: eB,
    DownloadIcon: bh,
    ExternalLinkIcon: DP,
    DocumentTextIcon: ip
  },
  props: {
    label: {
      type: String,
      required: !0
    },
    href: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: "download",
      validator: (e) => ["download", "external", "document"].includes(e)
    },
    variant: {
      type: String,
      default: "inline",
      validator: (e) => ["inline", "card"].includes(e)
    },
    as: {
      type: String,
      default: "link",
      validator: (e) => ["link", "button"].includes(e)
    },
    description: {
      type: String,
      default: ""
    },
    status: {
      type: String,
      default: null,
      validator: (e) => e === null || ["pending", "done"].includes(e)
    },
    statusLabel: {
      type: String,
      default: ""
    }
  },
  computed: {
    iconComponent() {
      return Yhe[this.icon] || bh;
    },
    rootTag() {
      return this.as === "button" ? "button" : "a";
    },
    rootAttrs() {
      return this.as === "button" ? { type: "button" } : this.sanitizedHref ? {
        href: this.sanitizedHref,
        target: "_blank",
        rel: "noopener noreferrer"
      } : {};
    },
    rootClasses() {
      if (this.variant === "card") {
        const e = "flex w-full items-center gap-4 rounded-xl border px-4 py-3 text-left transition focus:outline-hidden focus:ring-2";
        return this.status === "done" ? `${e} border-green-200 bg-green-50 hover:border-green-300 hover:bg-green-100` : this.status === "pending" ? `${e}` : `${e} border-gray-200 bg-white hover:border-primary hover:bg-gray-50`;
      }
      return "inline-flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50";
    },
    iconWrapperClasses() {
      const e = "flex h-10 w-10 items-center justify-center rounded-full";
      return this.status === "done" ? `${e} bg-green-100` : this.status === "pending" ? `${e}` : `${e}`;
    },
    statusBadgeClasses() {
      const e = "inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium";
      return this.status === "done" ? `${e} bg-green-100 text-green-800` : this.status === "pending" ? `${e}` : `${e} bg-gray-100 text-gray-700`;
    },
    sanitizedHref() {
      if (!this.href)
        return null;
      try {
        const e = new URL(this.href, window.location.origin);
        return ["http:", "https:", "mailto:", "tel:"].includes(e.protocol) ? this.href : "#";
      } catch {
        return "#";
      }
    }
  }
}, Xhe = { class: "flex min-w-0 flex-1 flex-col gap-0.5" }, Zhe = { class: "text-sm font-medium text-gray-900" }, Qhe = {
  key: 0,
  class: "text-xs text-gray-500"
};
function Jhe(e, t, n, r, i, a) {
  const s = U("CheckCircleIcon"), o = U("ChevronRightIcon");
  return _(), ae(Lr(a.rootTag), or(a.rootAttrs, { class: a.rootClasses }), {
    default: ie(() => [
      n.variant === "card" ? (_(), O(Re, { key: 0 }, [
        k("span", {
          class: Pe(a.iconWrapperClasses)
        }, [
          (_(), ae(Lr(a.iconComponent), {
            class: "h-5 w-5 text-primary-dark",
            "aria-hidden": "true"
          }))
        ], 2),
        k("span", Xhe, [
          k("span", Zhe, j(n.label), 1),
          n.description ? (_(), O("span", Qhe, j(n.description), 1)) : L("", !0)
        ]),
        n.statusLabel ? (_(), O("span", {
          key: 0,
          class: Pe(a.statusBadgeClasses),
          role: "status"
        }, [
          n.status === "done" ? (_(), ae(s, {
            key: 0,
            class: "h-4 w-4",
            "aria-hidden": "true"
          })) : L("", !0),
          Me(" " + j(n.statusLabel), 1)
        ], 2)) : L("", !0),
        W(o, {
          class: "h-5 w-5 text-gray-400",
          "aria-hidden": "true"
        })
      ], 64)) : (_(), O(Re, { key: 1 }, [
        (_(), ae(Lr(a.iconComponent), {
          class: "h-4 w-4",
          "aria-hidden": "true"
        })),
        Me(" " + j(n.label), 1)
      ], 64))
    ]),
    _: 1
  }, 16, ["class"]);
}
const z0e = /* @__PURE__ */ we(Khe, [["render", Jhe]]), epe = {
  props: ["textToCopy"],
  data() {
    return {
      showSuccessMessage: !1
    };
  },
  methods: {
    copyToClipboard() {
      navigator.clipboard.writeText(this.textToCopy).then(() => {
        this.showSuccessMessage = !0, setTimeout(() => {
          this.showSuccessMessage = !1;
        }, 1e3);
      });
    }
  }
}, tpe = { key: 0 };
function npe(e, t, n, r, i, a) {
  return _(), O("div", null, [
    i.showSuccessMessage ? (_(), O("div", tpe, [...t[1] || (t[1] = [
      k("p", { class: "text-green-400" }, "Copié", -1)
    ])])) : (_(), O("div", {
      key: 1,
      class: "hover:bg-gray-100 rounded-md cursor-pointer",
      onClick: t[0] || (t[0] = (...s) => a.copyToClipboard && a.copyToClipboard(...s))
    }, [
      xe(e.$slots, "default")
    ]))
  ]);
}
const rpe = /* @__PURE__ */ we(epe, [["render", npe]]), ipe = {
  name: "CopyableFieldRow",
  components: {
    StackedField: yp,
    CopyToClipboard: rpe,
    ClipboardListIcon: tB
  },
  props: {
    label: {
      type: String,
      required: !0
    },
    value: {
      type: String,
      required: !0
    },
    maxLength: {
      type: Number,
      default: 40
    }
  },
  computed: {
    truncatedValue() {
      if (!this.value) return "";
      try {
        const e = new URL(this.value), t = e.hostname + e.pathname;
        return t.length > this.maxLength ? t.substring(0, this.maxLength) + "..." : t;
      } catch {
        return this.value.length > this.maxLength ? this.value.substring(0, this.maxLength) + "..." : this.value;
      }
    }
  }
}, ape = { class: "inline-flex items-center gap-1.5 cursor-pointer text-primary hover:text-primary-dark font-light truncate max-w-xs" };
function spe(e, t, n, r, i, a) {
  const s = U("ClipboardListIcon"), o = U("CopyToClipboard"), l = U("StackedField");
  return _(), ae(l, { label: n.label }, {
    default: ie(() => [
      W(o, { textToCopy: n.value }, {
        default: ie(() => [
          k("span", ape, [
            W(s, { class: "h-4 w-4 shrink-0" }),
            Me(" " + j(a.truncatedValue), 1)
          ])
        ]),
        _: 1
      }, 8, ["textToCopy"])
    ]),
    _: 1
  }, 8, ["label"]);
}
const H0e = /* @__PURE__ */ we(ipe, [["render", spe]]);
var js = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function hl(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var yc = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
var ope = yc.exports, wA;
function lpe() {
  return wA || (wA = 1, (function(e, t) {
    (function() {
      var n, r = "4.18.1", i = 200, a = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", s = "Expected a function", o = "Invalid `variable` option passed into `_.template`", l = "Invalid `imports` option passed into `_.template`", c = "__lodash_hash_undefined__", f = 500, h = "__lodash_placeholder__", p = 1, g = 2, v = 4, y = 1, S = 2, x = 1, E = 2, w = 4, C = 8, P = 16, M = 32, T = 64, N = 128, $ = 256, ne = 512, Y = 30, te = "...", _e = 800, Fe = 16, J = 1, oe = 2, A = 3, X = 1 / 0, pe = 9007199254740991, le = 17976931348623157e292, ue = NaN, Te = 4294967295, Ne = Te - 1, Z = Te >>> 1, G = [
        ["ary", N],
        ["bind", x],
        ["bindKey", E],
        ["curry", C],
        ["curryRight", P],
        ["flip", ne],
        ["partial", M],
        ["partialRight", T],
        ["rearg", $]
      ], se = "[object Arguments]", St = "[object Array]", Sn = "[object AsyncFunction]", Vt = "[object Boolean]", nn = "[object Date]", rr = "[object DOMException]", Qe = "[object Error]", Je = "[object Function]", Pt = "[object GeneratorFunction]", Xe = "[object Map]", pt = "[object Number]", Cn = "[object Null]", ut = "[object Object]", dr = "[object Promise]", B = "[object Proxy]", z = "[object RegExp]", ye = "[object Set]", $e = "[object String]", Ct = "[object Symbol]", At = "[object Undefined]", mt = "[object WeakMap]", he = "[object WeakSet]", Ae = "[object ArrayBuffer]", q = "[object DataView]", me = "[object Float32Array]", Be = "[object Float64Array]", He = "[object Int8Array]", gt = "[object Int16Array]", cn = "[object Int32Array]", Yn = "[object Uint8Array]", be = "[object Uint8ClampedArray]", Ue = "[object Uint16Array]", Mn = "[object Uint32Array]", ir = /\b__p \+= '';/g, Ia = /\b(__p \+=) '' \+/g, Ze = /(__e\(.*?\)|\b__t\)) \+\n'';/g, li = /&(?:amp|lt|gt|quot|#39);/g, ot = /[&<>"']/g, pa = RegExp(li.source), ui = RegExp(ot.source), Cd = /<%-([\s\S]+?)%>/g, Td = /<%([\s\S]+?)%>/g, _u = /<%=([\s\S]+?)%>/g, Ad = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Dd = /^\w*$/, ml = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, gs = /[\\^$.*+?()[\]{}|]/g, Ai = RegExp(gs.source), ma = /^\s+/, yu = /\s/, xu = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Zp = /\{\n\/\* \[wrapped with (.+)\] \*/, Ed = /,? & /, wu = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, ku = /[()=,{}\[\]\/\s]/, Su = /\\(\\)?/g, Qp = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, vs = /\w*$/, Jp = /^[-+]0x[0-9a-f]+$/i, em = /^0b[01]+$/i, Tn = /^\[object .+?Constructor\]$/, bs = /^0o[0-7]+$/i, tm = /^(?:0|[1-9]\d*)$/, Pd = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, _s = /($^)/, Od = /['\n\r\u2028\u2029\\]/g, fo = "\\ud800-\\udfff", nm = "\\u0300-\\u036f", rm = "\\ufe20-\\ufe2f", im = "\\u20d0-\\u20ff", Md = nm + rm + im, Zi = "\\u2700-\\u27bf", Cu = "a-z\\xdf-\\xf6\\xf8-\\xff", Tu = "\\xac\\xb1\\xd7\\xf7", ys = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Id = "\\u2000-\\u206f", Au = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", gl = "A-Z\\xc0-\\xd6\\xd8-\\xde", vl = "\\ufe0e\\ufe0f", Rd = Tu + ys + Id + Au, bl = "['’]", am = "[" + fo + "]", Fd = "[" + Rd + "]", _l = "[" + Md + "]", Nd = "\\d+", Ld = "[" + Zi + "]", $d = "[" + Cu + "]", Du = "[^" + fo + Rd + Nd + Zi + Cu + gl + "]", ho = "\\ud83c[\\udffb-\\udfff]", yl = "(?:" + _l + "|" + ho + ")", xl = "[^" + fo + "]", wl = "(?:\\ud83c[\\udde6-\\uddff]){2}", xs = "[\\ud800-\\udbff][\\udc00-\\udfff]", Vr = "[" + gl + "]", ws = "\\u200d", Qr = "(?:" + $d + "|" + Du + ")", sm = "(?:" + Vr + "|" + Du + ")", po = "(?:" + bl + "(?:d|ll|m|re|s|t|ve))?", Vd = "(?:" + bl + "(?:D|LL|M|RE|S|T|VE))?", Eu = yl + "?", Ra = "[" + vl + "]?", Pu = "(?:" + ws + "(?:" + [xl, wl, xs].join("|") + ")" + Ra + Eu + ")*", Bd = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", om = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Ou = Ra + Eu + Pu, lm = "(?:" + [Ld, wl, xs].join("|") + ")" + Ou, um = "(?:" + [xl + _l + "?", _l, wl, xs, am].join("|") + ")", Ud = RegExp(bl, "g"), Mu = RegExp(_l, "g"), Fa = RegExp(ho + "(?=" + ho + ")|" + um + Ou, "g"), Iu = RegExp([
        Vr + "?" + $d + "+" + po + "(?=" + [Fd, Vr, "$"].join("|") + ")",
        sm + "+" + Vd + "(?=" + [Fd, Vr + Qr, "$"].join("|") + ")",
        Vr + "?" + Qr + "+" + po,
        Vr + "+" + Vd,
        om,
        Bd,
        Nd,
        lm
      ].join("|"), "g"), De = RegExp("[" + ws + fo + Md + vl + "]"), F = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, K = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ], ke = -1, fe = {};
      fe[me] = fe[Be] = fe[He] = fe[gt] = fe[cn] = fe[Yn] = fe[be] = fe[Ue] = fe[Mn] = !0, fe[se] = fe[St] = fe[Ae] = fe[Vt] = fe[q] = fe[nn] = fe[Qe] = fe[Je] = fe[Xe] = fe[pt] = fe[ut] = fe[z] = fe[ye] = fe[$e] = fe[mt] = !1;
      var Le = {};
      Le[se] = Le[St] = Le[Ae] = Le[q] = Le[Vt] = Le[nn] = Le[me] = Le[Be] = Le[He] = Le[gt] = Le[cn] = Le[Xe] = Le[pt] = Le[ut] = Le[z] = Le[ye] = Le[$e] = Le[Ct] = Le[Yn] = Le[be] = Le[Ue] = Le[Mn] = !0, Le[Qe] = Le[Je] = Le[mt] = !1;
      var nt = {
        // Latin-1 Supplement block.
        À: "A",
        Á: "A",
        Â: "A",
        Ã: "A",
        Ä: "A",
        Å: "A",
        à: "a",
        á: "a",
        â: "a",
        ã: "a",
        ä: "a",
        å: "a",
        Ç: "C",
        ç: "c",
        Ð: "D",
        ð: "d",
        È: "E",
        É: "E",
        Ê: "E",
        Ë: "E",
        è: "e",
        é: "e",
        ê: "e",
        ë: "e",
        Ì: "I",
        Í: "I",
        Î: "I",
        Ï: "I",
        ì: "i",
        í: "i",
        î: "i",
        ï: "i",
        Ñ: "N",
        ñ: "n",
        Ò: "O",
        Ó: "O",
        Ô: "O",
        Õ: "O",
        Ö: "O",
        Ø: "O",
        ò: "o",
        ó: "o",
        ô: "o",
        õ: "o",
        ö: "o",
        ø: "o",
        Ù: "U",
        Ú: "U",
        Û: "U",
        Ü: "U",
        ù: "u",
        ú: "u",
        û: "u",
        ü: "u",
        Ý: "Y",
        ý: "y",
        ÿ: "y",
        Æ: "Ae",
        æ: "ae",
        Þ: "Th",
        þ: "th",
        ß: "ss",
        // Latin Extended-A block.
        Ā: "A",
        Ă: "A",
        Ą: "A",
        ā: "a",
        ă: "a",
        ą: "a",
        Ć: "C",
        Ĉ: "C",
        Ċ: "C",
        Č: "C",
        ć: "c",
        ĉ: "c",
        ċ: "c",
        č: "c",
        Ď: "D",
        Đ: "D",
        ď: "d",
        đ: "d",
        Ē: "E",
        Ĕ: "E",
        Ė: "E",
        Ę: "E",
        Ě: "E",
        ē: "e",
        ĕ: "e",
        ė: "e",
        ę: "e",
        ě: "e",
        Ĝ: "G",
        Ğ: "G",
        Ġ: "G",
        Ģ: "G",
        ĝ: "g",
        ğ: "g",
        ġ: "g",
        ģ: "g",
        Ĥ: "H",
        Ħ: "H",
        ĥ: "h",
        ħ: "h",
        Ĩ: "I",
        Ī: "I",
        Ĭ: "I",
        Į: "I",
        İ: "I",
        ĩ: "i",
        ī: "i",
        ĭ: "i",
        į: "i",
        ı: "i",
        Ĵ: "J",
        ĵ: "j",
        Ķ: "K",
        ķ: "k",
        ĸ: "k",
        Ĺ: "L",
        Ļ: "L",
        Ľ: "L",
        Ŀ: "L",
        Ł: "L",
        ĺ: "l",
        ļ: "l",
        ľ: "l",
        ŀ: "l",
        ł: "l",
        Ń: "N",
        Ņ: "N",
        Ň: "N",
        Ŋ: "N",
        ń: "n",
        ņ: "n",
        ň: "n",
        ŋ: "n",
        Ō: "O",
        Ŏ: "O",
        Ő: "O",
        ō: "o",
        ŏ: "o",
        ő: "o",
        Ŕ: "R",
        Ŗ: "R",
        Ř: "R",
        ŕ: "r",
        ŗ: "r",
        ř: "r",
        Ś: "S",
        Ŝ: "S",
        Ş: "S",
        Š: "S",
        ś: "s",
        ŝ: "s",
        ş: "s",
        š: "s",
        Ţ: "T",
        Ť: "T",
        Ŧ: "T",
        ţ: "t",
        ť: "t",
        ŧ: "t",
        Ũ: "U",
        Ū: "U",
        Ŭ: "U",
        Ů: "U",
        Ű: "U",
        Ų: "U",
        ũ: "u",
        ū: "u",
        ŭ: "u",
        ů: "u",
        ű: "u",
        ų: "u",
        Ŵ: "W",
        ŵ: "w",
        Ŷ: "Y",
        ŷ: "y",
        Ÿ: "Y",
        Ź: "Z",
        Ż: "Z",
        Ž: "Z",
        ź: "z",
        ż: "z",
        ž: "z",
        Ĳ: "IJ",
        ĳ: "ij",
        Œ: "Oe",
        œ: "oe",
        ŉ: "'n",
        ſ: "s"
      }, xt = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, Bn = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      }, Di = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      }, yr = parseFloat, Dr = parseInt, Na = typeof js == "object" && js && js.Object === Object && js, Er = typeof self == "object" && self && self.Object === Object && self, Kn = Na || Er || Function("return this")(), cm = t && !t.nodeType && t, mo = cm && !0 && e && !e.nodeType && e, Vx = mo && mo.exports === cm, dm = Vx && Na.process, Ei = (function() {
        try {
          var Q = mo && mo.require && mo.require("util").types;
          return Q || dm && dm.binding && dm.binding("util");
        } catch {
        }
      })(), Bx = Ei && Ei.isArrayBuffer, Ux = Ei && Ei.isDate, qx = Ei && Ei.isMap, jx = Ei && Ei.isRegExp, Wx = Ei && Ei.isSet, zx = Ei && Ei.isTypedArray;
      function ci(Q, ve, de) {
        switch (de.length) {
          case 0:
            return Q.call(ve);
          case 1:
            return Q.call(ve, de[0]);
          case 2:
            return Q.call(ve, de[0], de[1]);
          case 3:
            return Q.call(ve, de[0], de[1], de[2]);
        }
        return Q.apply(ve, de);
      }
      function sF(Q, ve, de, je) {
        for (var ct = -1, jt = Q == null ? 0 : Q.length; ++ct < jt; ) {
          var ar = Q[ct];
          ve(je, ar, de(ar), Q);
        }
        return je;
      }
      function di(Q, ve) {
        for (var de = -1, je = Q == null ? 0 : Q.length; ++de < je && ve(Q[de], de, Q) !== !1; )
          ;
        return Q;
      }
      function oF(Q, ve) {
        for (var de = Q == null ? 0 : Q.length; de-- && ve(Q[de], de, Q) !== !1; )
          ;
        return Q;
      }
      function Hx(Q, ve) {
        for (var de = -1, je = Q == null ? 0 : Q.length; ++de < je; )
          if (!ve(Q[de], de, Q))
            return !1;
        return !0;
      }
      function ks(Q, ve) {
        for (var de = -1, je = Q == null ? 0 : Q.length, ct = 0, jt = []; ++de < je; ) {
          var ar = Q[de];
          ve(ar, de, Q) && (jt[ct++] = ar);
        }
        return jt;
      }
      function qd(Q, ve) {
        var de = Q == null ? 0 : Q.length;
        return !!de && kl(Q, ve, 0) > -1;
      }
      function fm(Q, ve, de) {
        for (var je = -1, ct = Q == null ? 0 : Q.length; ++je < ct; )
          if (de(ve, Q[je]))
            return !0;
        return !1;
      }
      function bn(Q, ve) {
        for (var de = -1, je = Q == null ? 0 : Q.length, ct = Array(je); ++de < je; )
          ct[de] = ve(Q[de], de, Q);
        return ct;
      }
      function Ss(Q, ve) {
        for (var de = -1, je = ve.length, ct = Q.length; ++de < je; )
          Q[ct + de] = ve[de];
        return Q;
      }
      function hm(Q, ve, de, je) {
        var ct = -1, jt = Q == null ? 0 : Q.length;
        for (je && jt && (de = Q[++ct]); ++ct < jt; )
          de = ve(de, Q[ct], ct, Q);
        return de;
      }
      function lF(Q, ve, de, je) {
        var ct = Q == null ? 0 : Q.length;
        for (je && ct && (de = Q[--ct]); ct--; )
          de = ve(de, Q[ct], ct, Q);
        return de;
      }
      function pm(Q, ve) {
        for (var de = -1, je = Q == null ? 0 : Q.length; ++de < je; )
          if (ve(Q[de], de, Q))
            return !0;
        return !1;
      }
      var uF = mm("length");
      function cF(Q) {
        return Q.split("");
      }
      function dF(Q) {
        return Q.match(wu) || [];
      }
      function Gx(Q, ve, de) {
        var je;
        return de(Q, function(ct, jt, ar) {
          if (ve(ct, jt, ar))
            return je = jt, !1;
        }), je;
      }
      function jd(Q, ve, de, je) {
        for (var ct = Q.length, jt = de + (je ? 1 : -1); je ? jt-- : ++jt < ct; )
          if (ve(Q[jt], jt, Q))
            return jt;
        return -1;
      }
      function kl(Q, ve, de) {
        return ve === ve ? kF(Q, ve, de) : jd(Q, Yx, de);
      }
      function fF(Q, ve, de, je) {
        for (var ct = de - 1, jt = Q.length; ++ct < jt; )
          if (je(Q[ct], ve))
            return ct;
        return -1;
      }
      function Yx(Q) {
        return Q !== Q;
      }
      function Kx(Q, ve) {
        var de = Q == null ? 0 : Q.length;
        return de ? vm(Q, ve) / de : ue;
      }
      function mm(Q) {
        return function(ve) {
          return ve == null ? n : ve[Q];
        };
      }
      function gm(Q) {
        return function(ve) {
          return Q == null ? n : Q[ve];
        };
      }
      function Xx(Q, ve, de, je, ct) {
        return ct(Q, function(jt, ar, rn) {
          de = je ? (je = !1, jt) : ve(de, jt, ar, rn);
        }), de;
      }
      function hF(Q, ve) {
        var de = Q.length;
        for (Q.sort(ve); de--; )
          Q[de] = Q[de].value;
        return Q;
      }
      function vm(Q, ve) {
        for (var de, je = -1, ct = Q.length; ++je < ct; ) {
          var jt = ve(Q[je]);
          jt !== n && (de = de === n ? jt : de + jt);
        }
        return de;
      }
      function bm(Q, ve) {
        for (var de = -1, je = Array(Q); ++de < Q; )
          je[de] = ve(de);
        return je;
      }
      function pF(Q, ve) {
        return bn(ve, function(de) {
          return [de, Q[de]];
        });
      }
      function Zx(Q) {
        return Q && Q.slice(0, t1(Q) + 1).replace(ma, "");
      }
      function fi(Q) {
        return function(ve) {
          return Q(ve);
        };
      }
      function _m(Q, ve) {
        return bn(ve, function(de) {
          return Q[de];
        });
      }
      function Ru(Q, ve) {
        return Q.has(ve);
      }
      function Qx(Q, ve) {
        for (var de = -1, je = Q.length; ++de < je && kl(ve, Q[de], 0) > -1; )
          ;
        return de;
      }
      function Jx(Q, ve) {
        for (var de = Q.length; de-- && kl(ve, Q[de], 0) > -1; )
          ;
        return de;
      }
      function mF(Q, ve) {
        for (var de = Q.length, je = 0; de--; )
          Q[de] === ve && ++je;
        return je;
      }
      var gF = gm(nt), vF = gm(xt);
      function bF(Q) {
        return "\\" + Di[Q];
      }
      function _F(Q, ve) {
        return Q == null ? n : Q[ve];
      }
      function Sl(Q) {
        return De.test(Q);
      }
      function yF(Q) {
        return F.test(Q);
      }
      function xF(Q) {
        for (var ve, de = []; !(ve = Q.next()).done; )
          de.push(ve.value);
        return de;
      }
      function ym(Q) {
        var ve = -1, de = Array(Q.size);
        return Q.forEach(function(je, ct) {
          de[++ve] = [ct, je];
        }), de;
      }
      function e1(Q, ve) {
        return function(de) {
          return Q(ve(de));
        };
      }
      function Cs(Q, ve) {
        for (var de = -1, je = Q.length, ct = 0, jt = []; ++de < je; ) {
          var ar = Q[de];
          (ar === ve || ar === h) && (Q[de] = h, jt[ct++] = de);
        }
        return jt;
      }
      function Wd(Q) {
        var ve = -1, de = Array(Q.size);
        return Q.forEach(function(je) {
          de[++ve] = je;
        }), de;
      }
      function wF(Q) {
        var ve = -1, de = Array(Q.size);
        return Q.forEach(function(je) {
          de[++ve] = [je, je];
        }), de;
      }
      function kF(Q, ve, de) {
        for (var je = de - 1, ct = Q.length; ++je < ct; )
          if (Q[je] === ve)
            return je;
        return -1;
      }
      function SF(Q, ve, de) {
        for (var je = de + 1; je--; )
          if (Q[je] === ve)
            return je;
        return je;
      }
      function Cl(Q) {
        return Sl(Q) ? TF(Q) : uF(Q);
      }
      function Qi(Q) {
        return Sl(Q) ? AF(Q) : cF(Q);
      }
      function t1(Q) {
        for (var ve = Q.length; ve-- && yu.test(Q.charAt(ve)); )
          ;
        return ve;
      }
      var CF = gm(Bn);
      function TF(Q) {
        for (var ve = Fa.lastIndex = 0; Fa.test(Q); )
          ++ve;
        return ve;
      }
      function AF(Q) {
        return Q.match(Fa) || [];
      }
      function DF(Q) {
        return Q.match(Iu) || [];
      }
      var EF = (function Q(ve) {
        ve = ve == null ? Kn : Tl.defaults(Kn.Object(), ve, Tl.pick(Kn, K));
        var de = ve.Array, je = ve.Date, ct = ve.Error, jt = ve.Function, ar = ve.Math, rn = ve.Object, xm = ve.RegExp, PF = ve.String, Pi = ve.TypeError, zd = de.prototype, OF = jt.prototype, Al = rn.prototype, Hd = ve["__core-js_shared__"], Gd = OF.toString, Ht = Al.hasOwnProperty, MF = 0, n1 = (function() {
          var u = /[^.]+$/.exec(Hd && Hd.keys && Hd.keys.IE_PROTO || "");
          return u ? "Symbol(src)_1." + u : "";
        })(), Yd = Al.toString, IF = Gd.call(rn), RF = Kn._, FF = xm(
          "^" + Gd.call(Ht).replace(gs, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        ), Kd = Vx ? ve.Buffer : n, Ts = ve.Symbol, Xd = ve.Uint8Array, r1 = Kd ? Kd.allocUnsafe : n, Zd = e1(rn.getPrototypeOf, rn), i1 = rn.create, a1 = Al.propertyIsEnumerable, Qd = zd.splice, s1 = Ts ? Ts.isConcatSpreadable : n, Fu = Ts ? Ts.iterator : n, go = Ts ? Ts.toStringTag : n, Jd = (function() {
          try {
            var u = xo(rn, "defineProperty");
            return u({}, "", {}), u;
          } catch {
          }
        })(), NF = ve.clearTimeout !== Kn.clearTimeout && ve.clearTimeout, LF = je && je.now !== Kn.Date.now && je.now, $F = ve.setTimeout !== Kn.setTimeout && ve.setTimeout, ef = ar.ceil, tf = ar.floor, wm = rn.getOwnPropertySymbols, VF = Kd ? Kd.isBuffer : n, o1 = ve.isFinite, BF = zd.join, UF = e1(rn.keys, rn), sr = ar.max, Pr = ar.min, qF = je.now, jF = ve.parseInt, l1 = ar.random, WF = zd.reverse, km = xo(ve, "DataView"), Nu = xo(ve, "Map"), Sm = xo(ve, "Promise"), Dl = xo(ve, "Set"), Lu = xo(ve, "WeakMap"), $u = xo(rn, "create"), nf = Lu && new Lu(), El = {}, zF = wo(km), HF = wo(Nu), GF = wo(Sm), YF = wo(Dl), KF = wo(Lu), rf = Ts ? Ts.prototype : n, Vu = rf ? rf.valueOf : n, u1 = rf ? rf.toString : n;
        function I(u) {
          if (In(u) && !ft(u) && !(u instanceof Ot)) {
            if (u instanceof Oi)
              return u;
            if (Ht.call(u, "__wrapped__"))
              return cw(u);
          }
          return new Oi(u);
        }
        var Pl = /* @__PURE__ */ (function() {
          function u() {
          }
          return function(d) {
            if (!An(d))
              return {};
            if (i1)
              return i1(d);
            u.prototype = d;
            var m = new u();
            return u.prototype = n, m;
          };
        })();
        function af() {
        }
        function Oi(u, d) {
          this.__wrapped__ = u, this.__actions__ = [], this.__chain__ = !!d, this.__index__ = 0, this.__values__ = n;
        }
        I.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          escape: Cd,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          evaluate: Td,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          interpolate: _u,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          variable: "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          imports: {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            _: I
          }
        }, I.prototype = af.prototype, I.prototype.constructor = I, Oi.prototype = Pl(af.prototype), Oi.prototype.constructor = Oi;
        function Ot(u) {
          this.__wrapped__ = u, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Te, this.__views__ = [];
        }
        function XF() {
          var u = new Ot(this.__wrapped__);
          return u.__actions__ = Jr(this.__actions__), u.__dir__ = this.__dir__, u.__filtered__ = this.__filtered__, u.__iteratees__ = Jr(this.__iteratees__), u.__takeCount__ = this.__takeCount__, u.__views__ = Jr(this.__views__), u;
        }
        function ZF() {
          if (this.__filtered__) {
            var u = new Ot(this);
            u.__dir__ = -1, u.__filtered__ = !0;
          } else
            u = this.clone(), u.__dir__ *= -1;
          return u;
        }
        function QF() {
          var u = this.__wrapped__.value(), d = this.__dir__, m = ft(u), b = d < 0, D = m ? u.length : 0, R = cL(0, D, this.__views__), V = R.start, H = R.end, ee = H - V, Se = b ? H : V - 1, Ce = this.__iteratees__, Ee = Ce.length, Ve = 0, Ge = Pr(ee, this.__takeCount__);
          if (!m || !b && D == ee && Ge == ee)
            return I1(u, this.__actions__);
          var rt = [];
          e:
            for (; ee-- && Ve < Ge; ) {
              Se += d;
              for (var wt = -1, et = u[Se]; ++wt < Ee; ) {
                var Dt = Ce[wt], Mt = Dt.iteratee, mi = Dt.type, qr = Mt(et);
                if (mi == oe)
                  et = qr;
                else if (!qr) {
                  if (mi == J)
                    continue e;
                  break e;
                }
              }
              rt[Ve++] = et;
            }
          return rt;
        }
        Ot.prototype = Pl(af.prototype), Ot.prototype.constructor = Ot;
        function vo(u) {
          var d = -1, m = u == null ? 0 : u.length;
          for (this.clear(); ++d < m; ) {
            var b = u[d];
            this.set(b[0], b[1]);
          }
        }
        function JF() {
          this.__data__ = $u ? $u(null) : {}, this.size = 0;
        }
        function eN(u) {
          var d = this.has(u) && delete this.__data__[u];
          return this.size -= d ? 1 : 0, d;
        }
        function tN(u) {
          var d = this.__data__;
          if ($u) {
            var m = d[u];
            return m === c ? n : m;
          }
          return Ht.call(d, u) ? d[u] : n;
        }
        function nN(u) {
          var d = this.__data__;
          return $u ? d[u] !== n : Ht.call(d, u);
        }
        function rN(u, d) {
          var m = this.__data__;
          return this.size += this.has(u) ? 0 : 1, m[u] = $u && d === n ? c : d, this;
        }
        vo.prototype.clear = JF, vo.prototype.delete = eN, vo.prototype.get = tN, vo.prototype.has = nN, vo.prototype.set = rN;
        function La(u) {
          var d = -1, m = u == null ? 0 : u.length;
          for (this.clear(); ++d < m; ) {
            var b = u[d];
            this.set(b[0], b[1]);
          }
        }
        function iN() {
          this.__data__ = [], this.size = 0;
        }
        function aN(u) {
          var d = this.__data__, m = sf(d, u);
          if (m < 0)
            return !1;
          var b = d.length - 1;
          return m == b ? d.pop() : Qd.call(d, m, 1), --this.size, !0;
        }
        function sN(u) {
          var d = this.__data__, m = sf(d, u);
          return m < 0 ? n : d[m][1];
        }
        function oN(u) {
          return sf(this.__data__, u) > -1;
        }
        function lN(u, d) {
          var m = this.__data__, b = sf(m, u);
          return b < 0 ? (++this.size, m.push([u, d])) : m[b][1] = d, this;
        }
        La.prototype.clear = iN, La.prototype.delete = aN, La.prototype.get = sN, La.prototype.has = oN, La.prototype.set = lN;
        function $a(u) {
          var d = -1, m = u == null ? 0 : u.length;
          for (this.clear(); ++d < m; ) {
            var b = u[d];
            this.set(b[0], b[1]);
          }
        }
        function uN() {
          this.size = 0, this.__data__ = {
            hash: new vo(),
            map: new (Nu || La)(),
            string: new vo()
          };
        }
        function cN(u) {
          var d = bf(this, u).delete(u);
          return this.size -= d ? 1 : 0, d;
        }
        function dN(u) {
          return bf(this, u).get(u);
        }
        function fN(u) {
          return bf(this, u).has(u);
        }
        function hN(u, d) {
          var m = bf(this, u), b = m.size;
          return m.set(u, d), this.size += m.size == b ? 0 : 1, this;
        }
        $a.prototype.clear = uN, $a.prototype.delete = cN, $a.prototype.get = dN, $a.prototype.has = fN, $a.prototype.set = hN;
        function bo(u) {
          var d = -1, m = u == null ? 0 : u.length;
          for (this.__data__ = new $a(); ++d < m; )
            this.add(u[d]);
        }
        function pN(u) {
          return this.__data__.set(u, c), this;
        }
        function mN(u) {
          return this.__data__.has(u);
        }
        bo.prototype.add = bo.prototype.push = pN, bo.prototype.has = mN;
        function Ji(u) {
          var d = this.__data__ = new La(u);
          this.size = d.size;
        }
        function gN() {
          this.__data__ = new La(), this.size = 0;
        }
        function vN(u) {
          var d = this.__data__, m = d.delete(u);
          return this.size = d.size, m;
        }
        function bN(u) {
          return this.__data__.get(u);
        }
        function _N(u) {
          return this.__data__.has(u);
        }
        function yN(u, d) {
          var m = this.__data__;
          if (m instanceof La) {
            var b = m.__data__;
            if (!Nu || b.length < i - 1)
              return b.push([u, d]), this.size = ++m.size, this;
            m = this.__data__ = new $a(b);
          }
          return m.set(u, d), this.size = m.size, this;
        }
        Ji.prototype.clear = gN, Ji.prototype.delete = vN, Ji.prototype.get = bN, Ji.prototype.has = _N, Ji.prototype.set = yN;
        function c1(u, d) {
          var m = ft(u), b = !m && ko(u), D = !m && !b && Os(u), R = !m && !b && !D && Rl(u), V = m || b || D || R, H = V ? bm(u.length, PF) : [], ee = H.length;
          for (var Se in u)
            (d || Ht.call(u, Se)) && !(V && // Safari 9 has enumerable `arguments.length` in strict mode.
            (Se == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            D && (Se == "offset" || Se == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            R && (Se == "buffer" || Se == "byteLength" || Se == "byteOffset") || // Skip index properties.
            Ua(Se, ee))) && H.push(Se);
          return H;
        }
        function d1(u) {
          var d = u.length;
          return d ? u[Fm(0, d - 1)] : n;
        }
        function xN(u, d) {
          return _f(Jr(u), _o(d, 0, u.length));
        }
        function wN(u) {
          return _f(Jr(u));
        }
        function Cm(u, d, m) {
          (m !== n && !ta(u[d], m) || m === n && !(d in u)) && ga(u, d, m);
        }
        function Bu(u, d, m) {
          var b = u[d];
          (!(Ht.call(u, d) && ta(b, m)) || m === n && !(d in u)) && ga(u, d, m);
        }
        function sf(u, d) {
          for (var m = u.length; m--; )
            if (ta(u[m][0], d))
              return m;
          return -1;
        }
        function kN(u, d, m, b) {
          return As(u, function(D, R, V) {
            d(b, D, m(D), V);
          }), b;
        }
        function f1(u, d) {
          return u && ba(d, fr(d), u);
        }
        function SN(u, d) {
          return u && ba(d, ti(d), u);
        }
        function ga(u, d, m) {
          d == "__proto__" && Jd ? Jd(u, d, {
            configurable: !0,
            enumerable: !0,
            value: m,
            writable: !0
          }) : u[d] = m;
        }
        function Tm(u, d) {
          for (var m = -1, b = d.length, D = de(b), R = u == null; ++m < b; )
            D[m] = R ? n : og(u, d[m]);
          return D;
        }
        function _o(u, d, m) {
          return u === u && (m !== n && (u = u <= m ? u : m), d !== n && (u = u >= d ? u : d)), u;
        }
        function Mi(u, d, m, b, D, R) {
          var V, H = d & p, ee = d & g, Se = d & v;
          if (m && (V = D ? m(u, b, D, R) : m(u)), V !== n)
            return V;
          if (!An(u))
            return u;
          var Ce = ft(u);
          if (Ce) {
            if (V = fL(u), !H)
              return Jr(u, V);
          } else {
            var Ee = Or(u), Ve = Ee == Je || Ee == Pt;
            if (Os(u))
              return N1(u, H);
            if (Ee == ut || Ee == se || Ve && !D) {
              if (V = ee || Ve ? {} : tw(u), !H)
                return ee ? tL(u, SN(V, u)) : eL(u, f1(V, u));
            } else {
              if (!Le[Ee])
                return D ? u : {};
              V = hL(u, Ee, H);
            }
          }
          R || (R = new Ji());
          var Ge = R.get(u);
          if (Ge)
            return Ge;
          R.set(u, V), Pw(u) ? u.forEach(function(et) {
            V.add(Mi(et, d, m, et, u, R));
          }) : Dw(u) && u.forEach(function(et, Dt) {
            V.set(Dt, Mi(et, d, m, Dt, u, R));
          });
          var rt = Se ? ee ? Hm : zm : ee ? ti : fr, wt = Ce ? n : rt(u);
          return di(wt || u, function(et, Dt) {
            wt && (Dt = et, et = u[Dt]), Bu(V, Dt, Mi(et, d, m, Dt, u, R));
          }), V;
        }
        function CN(u) {
          var d = fr(u);
          return function(m) {
            return h1(m, u, d);
          };
        }
        function h1(u, d, m) {
          var b = m.length;
          if (u == null)
            return !b;
          for (u = rn(u); b--; ) {
            var D = m[b], R = d[D], V = u[D];
            if (V === n && !(D in u) || !R(V))
              return !1;
          }
          return !0;
        }
        function p1(u, d, m) {
          if (typeof u != "function")
            throw new Pi(s);
          return Gu(function() {
            u.apply(n, m);
          }, d);
        }
        function Uu(u, d, m, b) {
          var D = -1, R = qd, V = !0, H = u.length, ee = [], Se = d.length;
          if (!H)
            return ee;
          m && (d = bn(d, fi(m))), b ? (R = fm, V = !1) : d.length >= i && (R = Ru, V = !1, d = new bo(d));
          e:
            for (; ++D < H; ) {
              var Ce = u[D], Ee = m == null ? Ce : m(Ce);
              if (Ce = b || Ce !== 0 ? Ce : 0, V && Ee === Ee) {
                for (var Ve = Se; Ve--; )
                  if (d[Ve] === Ee)
                    continue e;
                ee.push(Ce);
              } else R(d, Ee, b) || ee.push(Ce);
            }
          return ee;
        }
        var As = U1(va), m1 = U1(Dm, !0);
        function TN(u, d) {
          var m = !0;
          return As(u, function(b, D, R) {
            return m = !!d(b, D, R), m;
          }), m;
        }
        function of(u, d, m) {
          for (var b = -1, D = u.length; ++b < D; ) {
            var R = u[b], V = d(R);
            if (V != null && (H === n ? V === V && !pi(V) : m(V, H)))
              var H = V, ee = R;
          }
          return ee;
        }
        function AN(u, d, m, b) {
          var D = u.length;
          for (m = yt(m), m < 0 && (m = -m > D ? 0 : D + m), b = b === n || b > D ? D : yt(b), b < 0 && (b += D), b = m > b ? 0 : Mw(b); m < b; )
            u[m++] = d;
          return u;
        }
        function g1(u, d) {
          var m = [];
          return As(u, function(b, D, R) {
            d(b, D, R) && m.push(b);
          }), m;
        }
        function xr(u, d, m, b, D) {
          var R = -1, V = u.length;
          for (m || (m = mL), D || (D = []); ++R < V; ) {
            var H = u[R];
            d > 0 && m(H) ? d > 1 ? xr(H, d - 1, m, b, D) : Ss(D, H) : b || (D[D.length] = H);
          }
          return D;
        }
        var Am = q1(), v1 = q1(!0);
        function va(u, d) {
          return u && Am(u, d, fr);
        }
        function Dm(u, d) {
          return u && v1(u, d, fr);
        }
        function lf(u, d) {
          return ks(d, function(m) {
            return qa(u[m]);
          });
        }
        function yo(u, d) {
          d = Es(d, u);
          for (var m = 0, b = d.length; u != null && m < b; )
            u = u[ea(d[m++])];
          return m && m == b ? u : n;
        }
        function b1(u, d, m) {
          var b = d(u);
          return ft(u) ? b : Ss(b, m(u));
        }
        function Br(u) {
          return u == null ? u === n ? At : Cn : go && go in rn(u) ? uL(u) : wL(u);
        }
        function Em(u, d) {
          return u > d;
        }
        function DN(u, d) {
          return u != null && Ht.call(u, d);
        }
        function EN(u, d) {
          return u != null && d in rn(u);
        }
        function PN(u, d, m) {
          return u >= Pr(d, m) && u < sr(d, m);
        }
        function Pm(u, d, m) {
          for (var b = m ? fm : qd, D = u[0].length, R = u.length, V = R, H = de(R), ee = 1 / 0, Se = []; V--; ) {
            var Ce = u[V];
            V && d && (Ce = bn(Ce, fi(d))), ee = Pr(Ce.length, ee), H[V] = !m && (d || D >= 120 && Ce.length >= 120) ? new bo(V && Ce) : n;
          }
          Ce = u[0];
          var Ee = -1, Ve = H[0];
          e:
            for (; ++Ee < D && Se.length < ee; ) {
              var Ge = Ce[Ee], rt = d ? d(Ge) : Ge;
              if (Ge = m || Ge !== 0 ? Ge : 0, !(Ve ? Ru(Ve, rt) : b(Se, rt, m))) {
                for (V = R; --V; ) {
                  var wt = H[V];
                  if (!(wt ? Ru(wt, rt) : b(u[V], rt, m)))
                    continue e;
                }
                Ve && Ve.push(rt), Se.push(Ge);
              }
            }
          return Se;
        }
        function ON(u, d, m, b) {
          return va(u, function(D, R, V) {
            d(b, m(D), R, V);
          }), b;
        }
        function qu(u, d, m) {
          d = Es(d, u), u = aw(u, d);
          var b = u == null ? u : u[ea(Ri(d))];
          return b == null ? n : ci(b, u, m);
        }
        function _1(u) {
          return In(u) && Br(u) == se;
        }
        function MN(u) {
          return In(u) && Br(u) == Ae;
        }
        function IN(u) {
          return In(u) && Br(u) == nn;
        }
        function ju(u, d, m, b, D) {
          return u === d ? !0 : u == null || d == null || !In(u) && !In(d) ? u !== u && d !== d : RN(u, d, m, b, ju, D);
        }
        function RN(u, d, m, b, D, R) {
          var V = ft(u), H = ft(d), ee = V ? St : Or(u), Se = H ? St : Or(d);
          ee = ee == se ? ut : ee, Se = Se == se ? ut : Se;
          var Ce = ee == ut, Ee = Se == ut, Ve = ee == Se;
          if (Ve && Os(u)) {
            if (!Os(d))
              return !1;
            V = !0, Ce = !1;
          }
          if (Ve && !Ce)
            return R || (R = new Ji()), V || Rl(u) ? Q1(u, d, m, b, D, R) : oL(u, d, ee, m, b, D, R);
          if (!(m & y)) {
            var Ge = Ce && Ht.call(u, "__wrapped__"), rt = Ee && Ht.call(d, "__wrapped__");
            if (Ge || rt) {
              var wt = Ge ? u.value() : u, et = rt ? d.value() : d;
              return R || (R = new Ji()), D(wt, et, m, b, R);
            }
          }
          return Ve ? (R || (R = new Ji()), lL(u, d, m, b, D, R)) : !1;
        }
        function FN(u) {
          return In(u) && Or(u) == Xe;
        }
        function Om(u, d, m, b) {
          var D = m.length, R = D, V = !b;
          if (u == null)
            return !R;
          for (u = rn(u); D--; ) {
            var H = m[D];
            if (V && H[2] ? H[1] !== u[H[0]] : !(H[0] in u))
              return !1;
          }
          for (; ++D < R; ) {
            H = m[D];
            var ee = H[0], Se = u[ee], Ce = H[1];
            if (V && H[2]) {
              if (Se === n && !(ee in u))
                return !1;
            } else {
              var Ee = new Ji();
              if (b)
                var Ve = b(Se, Ce, ee, u, d, Ee);
              if (!(Ve === n ? ju(Ce, Se, y | S, b, Ee) : Ve))
                return !1;
            }
          }
          return !0;
        }
        function y1(u) {
          if (!An(u) || vL(u))
            return !1;
          var d = qa(u) ? FF : Tn;
          return d.test(wo(u));
        }
        function NN(u) {
          return In(u) && Br(u) == z;
        }
        function LN(u) {
          return In(u) && Or(u) == ye;
        }
        function $N(u) {
          return In(u) && Cf(u.length) && !!fe[Br(u)];
        }
        function x1(u) {
          return typeof u == "function" ? u : u == null ? ni : typeof u == "object" ? ft(u) ? S1(u[0], u[1]) : k1(u) : Ww(u);
        }
        function Mm(u) {
          if (!Hu(u))
            return UF(u);
          var d = [];
          for (var m in rn(u))
            Ht.call(u, m) && m != "constructor" && d.push(m);
          return d;
        }
        function VN(u) {
          if (!An(u))
            return xL(u);
          var d = Hu(u), m = [];
          for (var b in u)
            b == "constructor" && (d || !Ht.call(u, b)) || m.push(b);
          return m;
        }
        function Im(u, d) {
          return u < d;
        }
        function w1(u, d) {
          var m = -1, b = ei(u) ? de(u.length) : [];
          return As(u, function(D, R, V) {
            b[++m] = d(D, R, V);
          }), b;
        }
        function k1(u) {
          var d = Ym(u);
          return d.length == 1 && d[0][2] ? rw(d[0][0], d[0][1]) : function(m) {
            return m === u || Om(m, u, d);
          };
        }
        function S1(u, d) {
          return Xm(u) && nw(d) ? rw(ea(u), d) : function(m) {
            var b = og(m, u);
            return b === n && b === d ? lg(m, u) : ju(d, b, y | S);
          };
        }
        function uf(u, d, m, b, D) {
          u !== d && Am(d, function(R, V) {
            if (D || (D = new Ji()), An(R))
              BN(u, d, V, m, uf, b, D);
            else {
              var H = b ? b(Qm(u, V), R, V + "", u, d, D) : n;
              H === n && (H = R), Cm(u, V, H);
            }
          }, ti);
        }
        function BN(u, d, m, b, D, R, V) {
          var H = Qm(u, m), ee = Qm(d, m), Se = V.get(ee);
          if (Se) {
            Cm(u, m, Se);
            return;
          }
          var Ce = R ? R(H, ee, m + "", u, d, V) : n, Ee = Ce === n;
          if (Ee) {
            var Ve = ft(ee), Ge = !Ve && Os(ee), rt = !Ve && !Ge && Rl(ee);
            Ce = ee, Ve || Ge || rt ? ft(H) ? Ce = H : Un(H) ? Ce = Jr(H) : Ge ? (Ee = !1, Ce = N1(ee, !0)) : rt ? (Ee = !1, Ce = L1(ee, !0)) : Ce = [] : Yu(ee) || ko(ee) ? (Ce = H, ko(H) ? Ce = Iw(H) : (!An(H) || qa(H)) && (Ce = tw(ee))) : Ee = !1;
          }
          Ee && (V.set(ee, Ce), D(Ce, ee, b, R, V), V.delete(ee)), Cm(u, m, Ce);
        }
        function C1(u, d) {
          var m = u.length;
          if (m)
            return d += d < 0 ? m : 0, Ua(d, m) ? u[d] : n;
        }
        function T1(u, d, m) {
          d.length ? d = bn(d, function(R) {
            return ft(R) ? function(V) {
              return yo(V, R.length === 1 ? R[0] : R);
            } : R;
          }) : d = [ni];
          var b = -1;
          d = bn(d, fi(tt()));
          var D = w1(u, function(R, V, H) {
            var ee = bn(d, function(Se) {
              return Se(R);
            });
            return { criteria: ee, index: ++b, value: R };
          });
          return hF(D, function(R, V) {
            return JN(R, V, m);
          });
        }
        function UN(u, d) {
          return A1(u, d, function(m, b) {
            return lg(u, b);
          });
        }
        function A1(u, d, m) {
          for (var b = -1, D = d.length, R = {}; ++b < D; ) {
            var V = d[b], H = yo(u, V);
            m(H, V) && Wu(R, Es(V, u), H);
          }
          return R;
        }
        function qN(u) {
          return function(d) {
            return yo(d, u);
          };
        }
        function Rm(u, d, m, b) {
          var D = b ? fF : kl, R = -1, V = d.length, H = u;
          for (u === d && (d = Jr(d)), m && (H = bn(u, fi(m))); ++R < V; )
            for (var ee = 0, Se = d[R], Ce = m ? m(Se) : Se; (ee = D(H, Ce, ee, b)) > -1; )
              H !== u && Qd.call(H, ee, 1), Qd.call(u, ee, 1);
          return u;
        }
        function D1(u, d) {
          for (var m = u ? d.length : 0, b = m - 1; m--; ) {
            var D = d[m];
            if (m == b || D !== R) {
              var R = D;
              Ua(D) ? Qd.call(u, D, 1) : $m(u, D);
            }
          }
          return u;
        }
        function Fm(u, d) {
          return u + tf(l1() * (d - u + 1));
        }
        function jN(u, d, m, b) {
          for (var D = -1, R = sr(ef((d - u) / (m || 1)), 0), V = de(R); R--; )
            V[b ? R : ++D] = u, u += m;
          return V;
        }
        function Nm(u, d) {
          var m = "";
          if (!u || d < 1 || d > pe)
            return m;
          do
            d % 2 && (m += u), d = tf(d / 2), d && (u += u);
          while (d);
          return m;
        }
        function kt(u, d) {
          return Jm(iw(u, d, ni), u + "");
        }
        function WN(u) {
          return d1(Fl(u));
        }
        function zN(u, d) {
          var m = Fl(u);
          return _f(m, _o(d, 0, m.length));
        }
        function Wu(u, d, m, b) {
          if (!An(u))
            return u;
          d = Es(d, u);
          for (var D = -1, R = d.length, V = R - 1, H = u; H != null && ++D < R; ) {
            var ee = ea(d[D]), Se = m;
            if (ee === "__proto__" || ee === "constructor" || ee === "prototype")
              return u;
            if (D != V) {
              var Ce = H[ee];
              Se = b ? b(Ce, ee, H) : n, Se === n && (Se = An(Ce) ? Ce : Ua(d[D + 1]) ? [] : {});
            }
            Bu(H, ee, Se), H = H[ee];
          }
          return u;
        }
        var E1 = nf ? function(u, d) {
          return nf.set(u, d), u;
        } : ni, HN = Jd ? function(u, d) {
          return Jd(u, "toString", {
            configurable: !0,
            enumerable: !1,
            value: cg(d),
            writable: !0
          });
        } : ni;
        function GN(u) {
          return _f(Fl(u));
        }
        function Ii(u, d, m) {
          var b = -1, D = u.length;
          d < 0 && (d = -d > D ? 0 : D + d), m = m > D ? D : m, m < 0 && (m += D), D = d > m ? 0 : m - d >>> 0, d >>>= 0;
          for (var R = de(D); ++b < D; )
            R[b] = u[b + d];
          return R;
        }
        function YN(u, d) {
          var m;
          return As(u, function(b, D, R) {
            return m = d(b, D, R), !m;
          }), !!m;
        }
        function cf(u, d, m) {
          var b = 0, D = u == null ? b : u.length;
          if (typeof d == "number" && d === d && D <= Z) {
            for (; b < D; ) {
              var R = b + D >>> 1, V = u[R];
              V !== null && !pi(V) && (m ? V <= d : V < d) ? b = R + 1 : D = R;
            }
            return D;
          }
          return Lm(u, d, ni, m);
        }
        function Lm(u, d, m, b) {
          var D = 0, R = u == null ? 0 : u.length;
          if (R === 0)
            return 0;
          d = m(d);
          for (var V = d !== d, H = d === null, ee = pi(d), Se = d === n; D < R; ) {
            var Ce = tf((D + R) / 2), Ee = m(u[Ce]), Ve = Ee !== n, Ge = Ee === null, rt = Ee === Ee, wt = pi(Ee);
            if (V)
              var et = b || rt;
            else Se ? et = rt && (b || Ve) : H ? et = rt && Ve && (b || !Ge) : ee ? et = rt && Ve && !Ge && (b || !wt) : Ge || wt ? et = !1 : et = b ? Ee <= d : Ee < d;
            et ? D = Ce + 1 : R = Ce;
          }
          return Pr(R, Ne);
        }
        function P1(u, d) {
          for (var m = -1, b = u.length, D = 0, R = []; ++m < b; ) {
            var V = u[m], H = d ? d(V) : V;
            if (!m || !ta(H, ee)) {
              var ee = H;
              R[D++] = V === 0 ? 0 : V;
            }
          }
          return R;
        }
        function O1(u) {
          return typeof u == "number" ? u : pi(u) ? ue : +u;
        }
        function hi(u) {
          if (typeof u == "string")
            return u;
          if (ft(u))
            return bn(u, hi) + "";
          if (pi(u))
            return u1 ? u1.call(u) : "";
          var d = u + "";
          return d == "0" && 1 / u == -X ? "-0" : d;
        }
        function Ds(u, d, m) {
          var b = -1, D = qd, R = u.length, V = !0, H = [], ee = H;
          if (m)
            V = !1, D = fm;
          else if (R >= i) {
            var Se = d ? null : aL(u);
            if (Se)
              return Wd(Se);
            V = !1, D = Ru, ee = new bo();
          } else
            ee = d ? [] : H;
          e:
            for (; ++b < R; ) {
              var Ce = u[b], Ee = d ? d(Ce) : Ce;
              if (Ce = m || Ce !== 0 ? Ce : 0, V && Ee === Ee) {
                for (var Ve = ee.length; Ve--; )
                  if (ee[Ve] === Ee)
                    continue e;
                d && ee.push(Ee), H.push(Ce);
              } else D(ee, Ee, m) || (ee !== H && ee.push(Ee), H.push(Ce));
            }
          return H;
        }
        function $m(u, d) {
          d = Es(d, u);
          var m = -1, b = d.length;
          if (!b)
            return !0;
          for (; ++m < b; ) {
            var D = ea(d[m]);
            if (D === "__proto__" && !Ht.call(u, "__proto__") || (D === "constructor" || D === "prototype") && m < b - 1)
              return !1;
          }
          var R = aw(u, d);
          return R == null || delete R[ea(Ri(d))];
        }
        function M1(u, d, m, b) {
          return Wu(u, d, m(yo(u, d)), b);
        }
        function df(u, d, m, b) {
          for (var D = u.length, R = b ? D : -1; (b ? R-- : ++R < D) && d(u[R], R, u); )
            ;
          return m ? Ii(u, b ? 0 : R, b ? R + 1 : D) : Ii(u, b ? R + 1 : 0, b ? D : R);
        }
        function I1(u, d) {
          var m = u;
          return m instanceof Ot && (m = m.value()), hm(d, function(b, D) {
            return D.func.apply(D.thisArg, Ss([b], D.args));
          }, m);
        }
        function Vm(u, d, m) {
          var b = u.length;
          if (b < 2)
            return b ? Ds(u[0]) : [];
          for (var D = -1, R = de(b); ++D < b; )
            for (var V = u[D], H = -1; ++H < b; )
              H != D && (R[D] = Uu(R[D] || V, u[H], d, m));
          return Ds(xr(R, 1), d, m);
        }
        function R1(u, d, m) {
          for (var b = -1, D = u.length, R = d.length, V = {}; ++b < D; ) {
            var H = b < R ? d[b] : n;
            m(V, u[b], H);
          }
          return V;
        }
        function Bm(u) {
          return Un(u) ? u : [];
        }
        function Um(u) {
          return typeof u == "function" ? u : ni;
        }
        function Es(u, d) {
          return ft(u) ? u : Xm(u, d) ? [u] : uw(Gt(u));
        }
        var KN = kt;
        function Ps(u, d, m) {
          var b = u.length;
          return m = m === n ? b : m, !d && m >= b ? u : Ii(u, d, m);
        }
        var F1 = NF || function(u) {
          return Kn.clearTimeout(u);
        };
        function N1(u, d) {
          if (d)
            return u.slice();
          var m = u.length, b = r1 ? r1(m) : new u.constructor(m);
          return u.copy(b), b;
        }
        function qm(u) {
          var d = new u.constructor(u.byteLength);
          return new Xd(d).set(new Xd(u)), d;
        }
        function XN(u, d) {
          var m = d ? qm(u.buffer) : u.buffer;
          return new u.constructor(m, u.byteOffset, u.byteLength);
        }
        function ZN(u) {
          var d = new u.constructor(u.source, vs.exec(u));
          return d.lastIndex = u.lastIndex, d;
        }
        function QN(u) {
          return Vu ? rn(Vu.call(u)) : {};
        }
        function L1(u, d) {
          var m = d ? qm(u.buffer) : u.buffer;
          return new u.constructor(m, u.byteOffset, u.length);
        }
        function $1(u, d) {
          if (u !== d) {
            var m = u !== n, b = u === null, D = u === u, R = pi(u), V = d !== n, H = d === null, ee = d === d, Se = pi(d);
            if (!H && !Se && !R && u > d || R && V && ee && !H && !Se || b && V && ee || !m && ee || !D)
              return 1;
            if (!b && !R && !Se && u < d || Se && m && D && !b && !R || H && m && D || !V && D || !ee)
              return -1;
          }
          return 0;
        }
        function JN(u, d, m) {
          for (var b = -1, D = u.criteria, R = d.criteria, V = D.length, H = m.length; ++b < V; ) {
            var ee = $1(D[b], R[b]);
            if (ee) {
              if (b >= H)
                return ee;
              var Se = m[b];
              return ee * (Se == "desc" ? -1 : 1);
            }
          }
          return u.index - d.index;
        }
        function V1(u, d, m, b) {
          for (var D = -1, R = u.length, V = m.length, H = -1, ee = d.length, Se = sr(R - V, 0), Ce = de(ee + Se), Ee = !b; ++H < ee; )
            Ce[H] = d[H];
          for (; ++D < V; )
            (Ee || D < R) && (Ce[m[D]] = u[D]);
          for (; Se--; )
            Ce[H++] = u[D++];
          return Ce;
        }
        function B1(u, d, m, b) {
          for (var D = -1, R = u.length, V = -1, H = m.length, ee = -1, Se = d.length, Ce = sr(R - H, 0), Ee = de(Ce + Se), Ve = !b; ++D < Ce; )
            Ee[D] = u[D];
          for (var Ge = D; ++ee < Se; )
            Ee[Ge + ee] = d[ee];
          for (; ++V < H; )
            (Ve || D < R) && (Ee[Ge + m[V]] = u[D++]);
          return Ee;
        }
        function Jr(u, d) {
          var m = -1, b = u.length;
          for (d || (d = de(b)); ++m < b; )
            d[m] = u[m];
          return d;
        }
        function ba(u, d, m, b) {
          var D = !m;
          m || (m = {});
          for (var R = -1, V = d.length; ++R < V; ) {
            var H = d[R], ee = b ? b(m[H], u[H], H, m, u) : n;
            ee === n && (ee = u[H]), D ? ga(m, H, ee) : Bu(m, H, ee);
          }
          return m;
        }
        function eL(u, d) {
          return ba(u, Km(u), d);
        }
        function tL(u, d) {
          return ba(u, J1(u), d);
        }
        function ff(u, d) {
          return function(m, b) {
            var D = ft(m) ? sF : kN, R = d ? d() : {};
            return D(m, u, tt(b, 2), R);
          };
        }
        function Ol(u) {
          return kt(function(d, m) {
            var b = -1, D = m.length, R = D > 1 ? m[D - 1] : n, V = D > 2 ? m[2] : n;
            for (R = u.length > 3 && typeof R == "function" ? (D--, R) : n, V && Ur(m[0], m[1], V) && (R = D < 3 ? n : R, D = 1), d = rn(d); ++b < D; ) {
              var H = m[b];
              H && u(d, H, b, R);
            }
            return d;
          });
        }
        function U1(u, d) {
          return function(m, b) {
            if (m == null)
              return m;
            if (!ei(m))
              return u(m, b);
            for (var D = m.length, R = d ? D : -1, V = rn(m); (d ? R-- : ++R < D) && b(V[R], R, V) !== !1; )
              ;
            return m;
          };
        }
        function q1(u) {
          return function(d, m, b) {
            for (var D = -1, R = rn(d), V = b(d), H = V.length; H--; ) {
              var ee = V[u ? H : ++D];
              if (m(R[ee], ee, R) === !1)
                break;
            }
            return d;
          };
        }
        function nL(u, d, m) {
          var b = d & x, D = zu(u);
          function R() {
            var V = this && this !== Kn && this instanceof R ? D : u;
            return V.apply(b ? m : this, arguments);
          }
          return R;
        }
        function j1(u) {
          return function(d) {
            d = Gt(d);
            var m = Sl(d) ? Qi(d) : n, b = m ? m[0] : d.charAt(0), D = m ? Ps(m, 1).join("") : d.slice(1);
            return b[u]() + D;
          };
        }
        function Ml(u) {
          return function(d) {
            return hm(qw(Uw(d).replace(Ud, "")), u, "");
          };
        }
        function zu(u) {
          return function() {
            var d = arguments;
            switch (d.length) {
              case 0:
                return new u();
              case 1:
                return new u(d[0]);
              case 2:
                return new u(d[0], d[1]);
              case 3:
                return new u(d[0], d[1], d[2]);
              case 4:
                return new u(d[0], d[1], d[2], d[3]);
              case 5:
                return new u(d[0], d[1], d[2], d[3], d[4]);
              case 6:
                return new u(d[0], d[1], d[2], d[3], d[4], d[5]);
              case 7:
                return new u(d[0], d[1], d[2], d[3], d[4], d[5], d[6]);
            }
            var m = Pl(u.prototype), b = u.apply(m, d);
            return An(b) ? b : m;
          };
        }
        function rL(u, d, m) {
          var b = zu(u);
          function D() {
            for (var R = arguments.length, V = de(R), H = R, ee = Il(D); H--; )
              V[H] = arguments[H];
            var Se = R < 3 && V[0] !== ee && V[R - 1] !== ee ? [] : Cs(V, ee);
            if (R -= Se.length, R < m)
              return Y1(
                u,
                d,
                hf,
                D.placeholder,
                n,
                V,
                Se,
                n,
                n,
                m - R
              );
            var Ce = this && this !== Kn && this instanceof D ? b : u;
            return ci(Ce, this, V);
          }
          return D;
        }
        function W1(u) {
          return function(d, m, b) {
            var D = rn(d);
            if (!ei(d)) {
              var R = tt(m, 3);
              d = fr(d), m = function(H) {
                return R(D[H], H, D);
              };
            }
            var V = u(d, m, b);
            return V > -1 ? D[R ? d[V] : V] : n;
          };
        }
        function z1(u) {
          return Ba(function(d) {
            var m = d.length, b = m, D = Oi.prototype.thru;
            for (u && d.reverse(); b--; ) {
              var R = d[b];
              if (typeof R != "function")
                throw new Pi(s);
              if (D && !V && vf(R) == "wrapper")
                var V = new Oi([], !0);
            }
            for (b = V ? b : m; ++b < m; ) {
              R = d[b];
              var H = vf(R), ee = H == "wrapper" ? Gm(R) : n;
              ee && Zm(ee[0]) && ee[1] == (N | C | M | $) && !ee[4].length && ee[9] == 1 ? V = V[vf(ee[0])].apply(V, ee[3]) : V = R.length == 1 && Zm(R) ? V[H]() : V.thru(R);
            }
            return function() {
              var Se = arguments, Ce = Se[0];
              if (V && Se.length == 1 && ft(Ce))
                return V.plant(Ce).value();
              for (var Ee = 0, Ve = m ? d[Ee].apply(this, Se) : Ce; ++Ee < m; )
                Ve = d[Ee].call(this, Ve);
              return Ve;
            };
          });
        }
        function hf(u, d, m, b, D, R, V, H, ee, Se) {
          var Ce = d & N, Ee = d & x, Ve = d & E, Ge = d & (C | P), rt = d & ne, wt = Ve ? n : zu(u);
          function et() {
            for (var Dt = arguments.length, Mt = de(Dt), mi = Dt; mi--; )
              Mt[mi] = arguments[mi];
            if (Ge)
              var qr = Il(et), gi = mF(Mt, qr);
            if (b && (Mt = V1(Mt, b, D, Ge)), R && (Mt = B1(Mt, R, V, Ge)), Dt -= gi, Ge && Dt < Se) {
              var qn = Cs(Mt, qr);
              return Y1(
                u,
                d,
                hf,
                et.placeholder,
                m,
                Mt,
                qn,
                H,
                ee,
                Se - Dt
              );
            }
            var na = Ee ? m : this, Wa = Ve ? na[u] : u;
            return Dt = Mt.length, H ? Mt = kL(Mt, H) : rt && Dt > 1 && Mt.reverse(), Ce && ee < Dt && (Mt.length = ee), this && this !== Kn && this instanceof et && (Wa = wt || zu(Wa)), Wa.apply(na, Mt);
          }
          return et;
        }
        function H1(u, d) {
          return function(m, b) {
            return ON(m, u, d(b), {});
          };
        }
        function pf(u, d) {
          return function(m, b) {
            var D;
            if (m === n && b === n)
              return d;
            if (m !== n && (D = m), b !== n) {
              if (D === n)
                return b;
              typeof m == "string" || typeof b == "string" ? (m = hi(m), b = hi(b)) : (m = O1(m), b = O1(b)), D = u(m, b);
            }
            return D;
          };
        }
        function jm(u) {
          return Ba(function(d) {
            return d = bn(d, fi(tt())), kt(function(m) {
              var b = this;
              return u(d, function(D) {
                return ci(D, b, m);
              });
            });
          });
        }
        function mf(u, d) {
          d = d === n ? " " : hi(d);
          var m = d.length;
          if (m < 2)
            return m ? Nm(d, u) : d;
          var b = Nm(d, ef(u / Cl(d)));
          return Sl(d) ? Ps(Qi(b), 0, u).join("") : b.slice(0, u);
        }
        function iL(u, d, m, b) {
          var D = d & x, R = zu(u);
          function V() {
            for (var H = -1, ee = arguments.length, Se = -1, Ce = b.length, Ee = de(Ce + ee), Ve = this && this !== Kn && this instanceof V ? R : u; ++Se < Ce; )
              Ee[Se] = b[Se];
            for (; ee--; )
              Ee[Se++] = arguments[++H];
            return ci(Ve, D ? m : this, Ee);
          }
          return V;
        }
        function G1(u) {
          return function(d, m, b) {
            return b && typeof b != "number" && Ur(d, m, b) && (m = b = n), d = ja(d), m === n ? (m = d, d = 0) : m = ja(m), b = b === n ? d < m ? 1 : -1 : ja(b), jN(d, m, b, u);
          };
        }
        function gf(u) {
          return function(d, m) {
            return typeof d == "string" && typeof m == "string" || (d = Fi(d), m = Fi(m)), u(d, m);
          };
        }
        function Y1(u, d, m, b, D, R, V, H, ee, Se) {
          var Ce = d & C, Ee = Ce ? V : n, Ve = Ce ? n : V, Ge = Ce ? R : n, rt = Ce ? n : R;
          d |= Ce ? M : T, d &= ~(Ce ? T : M), d & w || (d &= -4);
          var wt = [
            u,
            d,
            D,
            Ge,
            Ee,
            rt,
            Ve,
            H,
            ee,
            Se
          ], et = m.apply(n, wt);
          return Zm(u) && sw(et, wt), et.placeholder = b, ow(et, u, d);
        }
        function Wm(u) {
          var d = ar[u];
          return function(m, b) {
            if (m = Fi(m), b = b == null ? 0 : Pr(yt(b), 292), b && o1(m)) {
              var D = (Gt(m) + "e").split("e"), R = d(D[0] + "e" + (+D[1] + b));
              return D = (Gt(R) + "e").split("e"), +(D[0] + "e" + (+D[1] - b));
            }
            return d(m);
          };
        }
        var aL = Dl && 1 / Wd(new Dl([, -0]))[1] == X ? function(u) {
          return new Dl(u);
        } : hg;
        function K1(u) {
          return function(d) {
            var m = Or(d);
            return m == Xe ? ym(d) : m == ye ? wF(d) : pF(d, u(d));
          };
        }
        function Va(u, d, m, b, D, R, V, H) {
          var ee = d & E;
          if (!ee && typeof u != "function")
            throw new Pi(s);
          var Se = b ? b.length : 0;
          if (Se || (d &= -97, b = D = n), V = V === n ? V : sr(yt(V), 0), H = H === n ? H : yt(H), Se -= D ? D.length : 0, d & T) {
            var Ce = b, Ee = D;
            b = D = n;
          }
          var Ve = ee ? n : Gm(u), Ge = [
            u,
            d,
            m,
            b,
            D,
            Ce,
            Ee,
            R,
            V,
            H
          ];
          if (Ve && yL(Ge, Ve), u = Ge[0], d = Ge[1], m = Ge[2], b = Ge[3], D = Ge[4], H = Ge[9] = Ge[9] === n ? ee ? 0 : u.length : sr(Ge[9] - Se, 0), !H && d & (C | P) && (d &= -25), !d || d == x)
            var rt = nL(u, d, m);
          else d == C || d == P ? rt = rL(u, d, H) : (d == M || d == (x | M)) && !D.length ? rt = iL(u, d, m, b) : rt = hf.apply(n, Ge);
          var wt = Ve ? E1 : sw;
          return ow(wt(rt, Ge), u, d);
        }
        function X1(u, d, m, b) {
          return u === n || ta(u, Al[m]) && !Ht.call(b, m) ? d : u;
        }
        function Z1(u, d, m, b, D, R) {
          return An(u) && An(d) && (R.set(d, u), uf(u, d, n, Z1, R), R.delete(d)), u;
        }
        function sL(u) {
          return Yu(u) ? n : u;
        }
        function Q1(u, d, m, b, D, R) {
          var V = m & y, H = u.length, ee = d.length;
          if (H != ee && !(V && ee > H))
            return !1;
          var Se = R.get(u), Ce = R.get(d);
          if (Se && Ce)
            return Se == d && Ce == u;
          var Ee = -1, Ve = !0, Ge = m & S ? new bo() : n;
          for (R.set(u, d), R.set(d, u); ++Ee < H; ) {
            var rt = u[Ee], wt = d[Ee];
            if (b)
              var et = V ? b(wt, rt, Ee, d, u, R) : b(rt, wt, Ee, u, d, R);
            if (et !== n) {
              if (et)
                continue;
              Ve = !1;
              break;
            }
            if (Ge) {
              if (!pm(d, function(Dt, Mt) {
                if (!Ru(Ge, Mt) && (rt === Dt || D(rt, Dt, m, b, R)))
                  return Ge.push(Mt);
              })) {
                Ve = !1;
                break;
              }
            } else if (!(rt === wt || D(rt, wt, m, b, R))) {
              Ve = !1;
              break;
            }
          }
          return R.delete(u), R.delete(d), Ve;
        }
        function oL(u, d, m, b, D, R, V) {
          switch (m) {
            case q:
              if (u.byteLength != d.byteLength || u.byteOffset != d.byteOffset)
                return !1;
              u = u.buffer, d = d.buffer;
            case Ae:
              return !(u.byteLength != d.byteLength || !R(new Xd(u), new Xd(d)));
            case Vt:
            case nn:
            case pt:
              return ta(+u, +d);
            case Qe:
              return u.name == d.name && u.message == d.message;
            case z:
            case $e:
              return u == d + "";
            case Xe:
              var H = ym;
            case ye:
              var ee = b & y;
              if (H || (H = Wd), u.size != d.size && !ee)
                return !1;
              var Se = V.get(u);
              if (Se)
                return Se == d;
              b |= S, V.set(u, d);
              var Ce = Q1(H(u), H(d), b, D, R, V);
              return V.delete(u), Ce;
            case Ct:
              if (Vu)
                return Vu.call(u) == Vu.call(d);
          }
          return !1;
        }
        function lL(u, d, m, b, D, R) {
          var V = m & y, H = zm(u), ee = H.length, Se = zm(d), Ce = Se.length;
          if (ee != Ce && !V)
            return !1;
          for (var Ee = ee; Ee--; ) {
            var Ve = H[Ee];
            if (!(V ? Ve in d : Ht.call(d, Ve)))
              return !1;
          }
          var Ge = R.get(u), rt = R.get(d);
          if (Ge && rt)
            return Ge == d && rt == u;
          var wt = !0;
          R.set(u, d), R.set(d, u);
          for (var et = V; ++Ee < ee; ) {
            Ve = H[Ee];
            var Dt = u[Ve], Mt = d[Ve];
            if (b)
              var mi = V ? b(Mt, Dt, Ve, d, u, R) : b(Dt, Mt, Ve, u, d, R);
            if (!(mi === n ? Dt === Mt || D(Dt, Mt, m, b, R) : mi)) {
              wt = !1;
              break;
            }
            et || (et = Ve == "constructor");
          }
          if (wt && !et) {
            var qr = u.constructor, gi = d.constructor;
            qr != gi && "constructor" in u && "constructor" in d && !(typeof qr == "function" && qr instanceof qr && typeof gi == "function" && gi instanceof gi) && (wt = !1);
          }
          return R.delete(u), R.delete(d), wt;
        }
        function Ba(u) {
          return Jm(iw(u, n, hw), u + "");
        }
        function zm(u) {
          return b1(u, fr, Km);
        }
        function Hm(u) {
          return b1(u, ti, J1);
        }
        var Gm = nf ? function(u) {
          return nf.get(u);
        } : hg;
        function vf(u) {
          for (var d = u.name + "", m = El[d], b = Ht.call(El, d) ? m.length : 0; b--; ) {
            var D = m[b], R = D.func;
            if (R == null || R == u)
              return D.name;
          }
          return d;
        }
        function Il(u) {
          var d = Ht.call(I, "placeholder") ? I : u;
          return d.placeholder;
        }
        function tt() {
          var u = I.iteratee || dg;
          return u = u === dg ? x1 : u, arguments.length ? u(arguments[0], arguments[1]) : u;
        }
        function bf(u, d) {
          var m = u.__data__;
          return gL(d) ? m[typeof d == "string" ? "string" : "hash"] : m.map;
        }
        function Ym(u) {
          for (var d = fr(u), m = d.length; m--; ) {
            var b = d[m], D = u[b];
            d[m] = [b, D, nw(D)];
          }
          return d;
        }
        function xo(u, d) {
          var m = _F(u, d);
          return y1(m) ? m : n;
        }
        function uL(u) {
          var d = Ht.call(u, go), m = u[go];
          try {
            u[go] = n;
            var b = !0;
          } catch {
          }
          var D = Yd.call(u);
          return b && (d ? u[go] = m : delete u[go]), D;
        }
        var Km = wm ? function(u) {
          return u == null ? [] : (u = rn(u), ks(wm(u), function(d) {
            return a1.call(u, d);
          }));
        } : pg, J1 = wm ? function(u) {
          for (var d = []; u; )
            Ss(d, Km(u)), u = Zd(u);
          return d;
        } : pg, Or = Br;
        (km && Or(new km(new ArrayBuffer(1))) != q || Nu && Or(new Nu()) != Xe || Sm && Or(Sm.resolve()) != dr || Dl && Or(new Dl()) != ye || Lu && Or(new Lu()) != mt) && (Or = function(u) {
          var d = Br(u), m = d == ut ? u.constructor : n, b = m ? wo(m) : "";
          if (b)
            switch (b) {
              case zF:
                return q;
              case HF:
                return Xe;
              case GF:
                return dr;
              case YF:
                return ye;
              case KF:
                return mt;
            }
          return d;
        });
        function cL(u, d, m) {
          for (var b = -1, D = m.length; ++b < D; ) {
            var R = m[b], V = R.size;
            switch (R.type) {
              case "drop":
                u += V;
                break;
              case "dropRight":
                d -= V;
                break;
              case "take":
                d = Pr(d, u + V);
                break;
              case "takeRight":
                u = sr(u, d - V);
                break;
            }
          }
          return { start: u, end: d };
        }
        function dL(u) {
          var d = u.match(Zp);
          return d ? d[1].split(Ed) : [];
        }
        function ew(u, d, m) {
          d = Es(d, u);
          for (var b = -1, D = d.length, R = !1; ++b < D; ) {
            var V = ea(d[b]);
            if (!(R = u != null && m(u, V)))
              break;
            u = u[V];
          }
          return R || ++b != D ? R : (D = u == null ? 0 : u.length, !!D && Cf(D) && Ua(V, D) && (ft(u) || ko(u)));
        }
        function fL(u) {
          var d = u.length, m = new u.constructor(d);
          return d && typeof u[0] == "string" && Ht.call(u, "index") && (m.index = u.index, m.input = u.input), m;
        }
        function tw(u) {
          return typeof u.constructor == "function" && !Hu(u) ? Pl(Zd(u)) : {};
        }
        function hL(u, d, m) {
          var b = u.constructor;
          switch (d) {
            case Ae:
              return qm(u);
            case Vt:
            case nn:
              return new b(+u);
            case q:
              return XN(u, m);
            case me:
            case Be:
            case He:
            case gt:
            case cn:
            case Yn:
            case be:
            case Ue:
            case Mn:
              return L1(u, m);
            case Xe:
              return new b();
            case pt:
            case $e:
              return new b(u);
            case z:
              return ZN(u);
            case ye:
              return new b();
            case Ct:
              return QN(u);
          }
        }
        function pL(u, d) {
          var m = d.length;
          if (!m)
            return u;
          var b = m - 1;
          return d[b] = (m > 1 ? "& " : "") + d[b], d = d.join(m > 2 ? ", " : " "), u.replace(xu, `{
/* [wrapped with ` + d + `] */
`);
        }
        function mL(u) {
          return ft(u) || ko(u) || !!(s1 && u && u[s1]);
        }
        function Ua(u, d) {
          var m = typeof u;
          return d = d ?? pe, !!d && (m == "number" || m != "symbol" && tm.test(u)) && u > -1 && u % 1 == 0 && u < d;
        }
        function Ur(u, d, m) {
          if (!An(m))
            return !1;
          var b = typeof d;
          return (b == "number" ? ei(m) && Ua(d, m.length) : b == "string" && d in m) ? ta(m[d], u) : !1;
        }
        function Xm(u, d) {
          if (ft(u))
            return !1;
          var m = typeof u;
          return m == "number" || m == "symbol" || m == "boolean" || u == null || pi(u) ? !0 : Dd.test(u) || !Ad.test(u) || d != null && u in rn(d);
        }
        function gL(u) {
          var d = typeof u;
          return d == "string" || d == "number" || d == "symbol" || d == "boolean" ? u !== "__proto__" : u === null;
        }
        function Zm(u) {
          var d = vf(u), m = I[d];
          if (typeof m != "function" || !(d in Ot.prototype))
            return !1;
          if (u === m)
            return !0;
          var b = Gm(m);
          return !!b && u === b[0];
        }
        function vL(u) {
          return !!n1 && n1 in u;
        }
        var bL = Hd ? qa : mg;
        function Hu(u) {
          var d = u && u.constructor, m = typeof d == "function" && d.prototype || Al;
          return u === m;
        }
        function nw(u) {
          return u === u && !An(u);
        }
        function rw(u, d) {
          return function(m) {
            return m == null ? !1 : m[u] === d && (d !== n || u in rn(m));
          };
        }
        function _L(u) {
          var d = kf(u, function(b) {
            return m.size === f && m.clear(), b;
          }), m = d.cache;
          return d;
        }
        function yL(u, d) {
          var m = u[1], b = d[1], D = m | b, R = D < (x | E | N), V = b == N && m == C || b == N && m == $ && u[7].length <= d[8] || b == (N | $) && d[7].length <= d[8] && m == C;
          if (!(R || V))
            return u;
          b & x && (u[2] = d[2], D |= m & x ? 0 : w);
          var H = d[3];
          if (H) {
            var ee = u[3];
            u[3] = ee ? V1(ee, H, d[4]) : H, u[4] = ee ? Cs(u[3], h) : d[4];
          }
          return H = d[5], H && (ee = u[5], u[5] = ee ? B1(ee, H, d[6]) : H, u[6] = ee ? Cs(u[5], h) : d[6]), H = d[7], H && (u[7] = H), b & N && (u[8] = u[8] == null ? d[8] : Pr(u[8], d[8])), u[9] == null && (u[9] = d[9]), u[0] = d[0], u[1] = D, u;
        }
        function xL(u) {
          var d = [];
          if (u != null)
            for (var m in rn(u))
              d.push(m);
          return d;
        }
        function wL(u) {
          return Yd.call(u);
        }
        function iw(u, d, m) {
          return d = sr(d === n ? u.length - 1 : d, 0), function() {
            for (var b = arguments, D = -1, R = sr(b.length - d, 0), V = de(R); ++D < R; )
              V[D] = b[d + D];
            D = -1;
            for (var H = de(d + 1); ++D < d; )
              H[D] = b[D];
            return H[d] = m(V), ci(u, this, H);
          };
        }
        function aw(u, d) {
          return d.length < 2 ? u : yo(u, Ii(d, 0, -1));
        }
        function kL(u, d) {
          for (var m = u.length, b = Pr(d.length, m), D = Jr(u); b--; ) {
            var R = d[b];
            u[b] = Ua(R, m) ? D[R] : n;
          }
          return u;
        }
        function Qm(u, d) {
          if (!(d === "constructor" && typeof u[d] == "function") && d != "__proto__")
            return u[d];
        }
        var sw = lw(E1), Gu = $F || function(u, d) {
          return Kn.setTimeout(u, d);
        }, Jm = lw(HN);
        function ow(u, d, m) {
          var b = d + "";
          return Jm(u, pL(b, SL(dL(b), m)));
        }
        function lw(u) {
          var d = 0, m = 0;
          return function() {
            var b = qF(), D = Fe - (b - m);
            if (m = b, D > 0) {
              if (++d >= _e)
                return arguments[0];
            } else
              d = 0;
            return u.apply(n, arguments);
          };
        }
        function _f(u, d) {
          var m = -1, b = u.length, D = b - 1;
          for (d = d === n ? b : d; ++m < d; ) {
            var R = Fm(m, D), V = u[R];
            u[R] = u[m], u[m] = V;
          }
          return u.length = d, u;
        }
        var uw = _L(function(u) {
          var d = [];
          return u.charCodeAt(0) === 46 && d.push(""), u.replace(ml, function(m, b, D, R) {
            d.push(D ? R.replace(Su, "$1") : b || m);
          }), d;
        });
        function ea(u) {
          if (typeof u == "string" || pi(u))
            return u;
          var d = u + "";
          return d == "0" && 1 / u == -X ? "-0" : d;
        }
        function wo(u) {
          if (u != null) {
            try {
              return Gd.call(u);
            } catch {
            }
            try {
              return u + "";
            } catch {
            }
          }
          return "";
        }
        function SL(u, d) {
          return di(G, function(m) {
            var b = "_." + m[0];
            d & m[1] && !qd(u, b) && u.push(b);
          }), u.sort();
        }
        function cw(u) {
          if (u instanceof Ot)
            return u.clone();
          var d = new Oi(u.__wrapped__, u.__chain__);
          return d.__actions__ = Jr(u.__actions__), d.__index__ = u.__index__, d.__values__ = u.__values__, d;
        }
        function CL(u, d, m) {
          (m ? Ur(u, d, m) : d === n) ? d = 1 : d = sr(yt(d), 0);
          var b = u == null ? 0 : u.length;
          if (!b || d < 1)
            return [];
          for (var D = 0, R = 0, V = de(ef(b / d)); D < b; )
            V[R++] = Ii(u, D, D += d);
          return V;
        }
        function TL(u) {
          for (var d = -1, m = u == null ? 0 : u.length, b = 0, D = []; ++d < m; ) {
            var R = u[d];
            R && (D[b++] = R);
          }
          return D;
        }
        function AL() {
          var u = arguments.length;
          if (!u)
            return [];
          for (var d = de(u - 1), m = arguments[0], b = u; b--; )
            d[b - 1] = arguments[b];
          return Ss(ft(m) ? Jr(m) : [m], xr(d, 1));
        }
        var DL = kt(function(u, d) {
          return Un(u) ? Uu(u, xr(d, 1, Un, !0)) : [];
        }), EL = kt(function(u, d) {
          var m = Ri(d);
          return Un(m) && (m = n), Un(u) ? Uu(u, xr(d, 1, Un, !0), tt(m, 2)) : [];
        }), PL = kt(function(u, d) {
          var m = Ri(d);
          return Un(m) && (m = n), Un(u) ? Uu(u, xr(d, 1, Un, !0), n, m) : [];
        });
        function OL(u, d, m) {
          var b = u == null ? 0 : u.length;
          return b ? (d = m || d === n ? 1 : yt(d), Ii(u, d < 0 ? 0 : d, b)) : [];
        }
        function ML(u, d, m) {
          var b = u == null ? 0 : u.length;
          return b ? (d = m || d === n ? 1 : yt(d), d = b - d, Ii(u, 0, d < 0 ? 0 : d)) : [];
        }
        function IL(u, d) {
          return u && u.length ? df(u, tt(d, 3), !0, !0) : [];
        }
        function RL(u, d) {
          return u && u.length ? df(u, tt(d, 3), !0) : [];
        }
        function FL(u, d, m, b) {
          var D = u == null ? 0 : u.length;
          return D ? (m && typeof m != "number" && Ur(u, d, m) && (m = 0, b = D), AN(u, d, m, b)) : [];
        }
        function dw(u, d, m) {
          var b = u == null ? 0 : u.length;
          if (!b)
            return -1;
          var D = m == null ? 0 : yt(m);
          return D < 0 && (D = sr(b + D, 0)), jd(u, tt(d, 3), D);
        }
        function fw(u, d, m) {
          var b = u == null ? 0 : u.length;
          if (!b)
            return -1;
          var D = b - 1;
          return m !== n && (D = yt(m), D = m < 0 ? sr(b + D, 0) : Pr(D, b - 1)), jd(u, tt(d, 3), D, !0);
        }
        function hw(u) {
          var d = u == null ? 0 : u.length;
          return d ? xr(u, 1) : [];
        }
        function NL(u) {
          var d = u == null ? 0 : u.length;
          return d ? xr(u, X) : [];
        }
        function LL(u, d) {
          var m = u == null ? 0 : u.length;
          return m ? (d = d === n ? 1 : yt(d), xr(u, d)) : [];
        }
        function $L(u) {
          for (var d = -1, m = u == null ? 0 : u.length, b = {}; ++d < m; ) {
            var D = u[d];
            ga(b, D[0], D[1]);
          }
          return b;
        }
        function pw(u) {
          return u && u.length ? u[0] : n;
        }
        function VL(u, d, m) {
          var b = u == null ? 0 : u.length;
          if (!b)
            return -1;
          var D = m == null ? 0 : yt(m);
          return D < 0 && (D = sr(b + D, 0)), kl(u, d, D);
        }
        function BL(u) {
          var d = u == null ? 0 : u.length;
          return d ? Ii(u, 0, -1) : [];
        }
        var UL = kt(function(u) {
          var d = bn(u, Bm);
          return d.length && d[0] === u[0] ? Pm(d) : [];
        }), qL = kt(function(u) {
          var d = Ri(u), m = bn(u, Bm);
          return d === Ri(m) ? d = n : m.pop(), m.length && m[0] === u[0] ? Pm(m, tt(d, 2)) : [];
        }), jL = kt(function(u) {
          var d = Ri(u), m = bn(u, Bm);
          return d = typeof d == "function" ? d : n, d && m.pop(), m.length && m[0] === u[0] ? Pm(m, n, d) : [];
        });
        function WL(u, d) {
          return u == null ? "" : BF.call(u, d);
        }
        function Ri(u) {
          var d = u == null ? 0 : u.length;
          return d ? u[d - 1] : n;
        }
        function zL(u, d, m) {
          var b = u == null ? 0 : u.length;
          if (!b)
            return -1;
          var D = b;
          return m !== n && (D = yt(m), D = D < 0 ? sr(b + D, 0) : Pr(D, b - 1)), d === d ? SF(u, d, D) : jd(u, Yx, D, !0);
        }
        function HL(u, d) {
          return u && u.length ? C1(u, yt(d)) : n;
        }
        var GL = kt(mw);
        function mw(u, d) {
          return u && u.length && d && d.length ? Rm(u, d) : u;
        }
        function YL(u, d, m) {
          return u && u.length && d && d.length ? Rm(u, d, tt(m, 2)) : u;
        }
        function KL(u, d, m) {
          return u && u.length && d && d.length ? Rm(u, d, n, m) : u;
        }
        var XL = Ba(function(u, d) {
          var m = u == null ? 0 : u.length, b = Tm(u, d);
          return D1(u, bn(d, function(D) {
            return Ua(D, m) ? +D : D;
          }).sort($1)), b;
        });
        function ZL(u, d) {
          var m = [];
          if (!(u && u.length))
            return m;
          var b = -1, D = [], R = u.length;
          for (d = tt(d, 3); ++b < R; ) {
            var V = u[b];
            d(V, b, u) && (m.push(V), D.push(b));
          }
          return D1(u, D), m;
        }
        function eg(u) {
          return u == null ? u : WF.call(u);
        }
        function QL(u, d, m) {
          var b = u == null ? 0 : u.length;
          return b ? (m && typeof m != "number" && Ur(u, d, m) ? (d = 0, m = b) : (d = d == null ? 0 : yt(d), m = m === n ? b : yt(m)), Ii(u, d, m)) : [];
        }
        function JL(u, d) {
          return cf(u, d);
        }
        function e$(u, d, m) {
          return Lm(u, d, tt(m, 2));
        }
        function t$(u, d) {
          var m = u == null ? 0 : u.length;
          if (m) {
            var b = cf(u, d);
            if (b < m && ta(u[b], d))
              return b;
          }
          return -1;
        }
        function n$(u, d) {
          return cf(u, d, !0);
        }
        function r$(u, d, m) {
          return Lm(u, d, tt(m, 2), !0);
        }
        function i$(u, d) {
          var m = u == null ? 0 : u.length;
          if (m) {
            var b = cf(u, d, !0) - 1;
            if (ta(u[b], d))
              return b;
          }
          return -1;
        }
        function a$(u) {
          return u && u.length ? P1(u) : [];
        }
        function s$(u, d) {
          return u && u.length ? P1(u, tt(d, 2)) : [];
        }
        function o$(u) {
          var d = u == null ? 0 : u.length;
          return d ? Ii(u, 1, d) : [];
        }
        function l$(u, d, m) {
          return u && u.length ? (d = m || d === n ? 1 : yt(d), Ii(u, 0, d < 0 ? 0 : d)) : [];
        }
        function u$(u, d, m) {
          var b = u == null ? 0 : u.length;
          return b ? (d = m || d === n ? 1 : yt(d), d = b - d, Ii(u, d < 0 ? 0 : d, b)) : [];
        }
        function c$(u, d) {
          return u && u.length ? df(u, tt(d, 3), !1, !0) : [];
        }
        function d$(u, d) {
          return u && u.length ? df(u, tt(d, 3)) : [];
        }
        var f$ = kt(function(u) {
          return Ds(xr(u, 1, Un, !0));
        }), h$ = kt(function(u) {
          var d = Ri(u);
          return Un(d) && (d = n), Ds(xr(u, 1, Un, !0), tt(d, 2));
        }), p$ = kt(function(u) {
          var d = Ri(u);
          return d = typeof d == "function" ? d : n, Ds(xr(u, 1, Un, !0), n, d);
        });
        function m$(u) {
          return u && u.length ? Ds(u) : [];
        }
        function g$(u, d) {
          return u && u.length ? Ds(u, tt(d, 2)) : [];
        }
        function v$(u, d) {
          return d = typeof d == "function" ? d : n, u && u.length ? Ds(u, n, d) : [];
        }
        function tg(u) {
          if (!(u && u.length))
            return [];
          var d = 0;
          return u = ks(u, function(m) {
            if (Un(m))
              return d = sr(m.length, d), !0;
          }), bm(d, function(m) {
            return bn(u, mm(m));
          });
        }
        function gw(u, d) {
          if (!(u && u.length))
            return [];
          var m = tg(u);
          return d == null ? m : bn(m, function(b) {
            return ci(d, n, b);
          });
        }
        var b$ = kt(function(u, d) {
          return Un(u) ? Uu(u, d) : [];
        }), _$ = kt(function(u) {
          return Vm(ks(u, Un));
        }), y$ = kt(function(u) {
          var d = Ri(u);
          return Un(d) && (d = n), Vm(ks(u, Un), tt(d, 2));
        }), x$ = kt(function(u) {
          var d = Ri(u);
          return d = typeof d == "function" ? d : n, Vm(ks(u, Un), n, d);
        }), w$ = kt(tg);
        function k$(u, d) {
          return R1(u || [], d || [], Bu);
        }
        function S$(u, d) {
          return R1(u || [], d || [], Wu);
        }
        var C$ = kt(function(u) {
          var d = u.length, m = d > 1 ? u[d - 1] : n;
          return m = typeof m == "function" ? (u.pop(), m) : n, gw(u, m);
        });
        function vw(u) {
          var d = I(u);
          return d.__chain__ = !0, d;
        }
        function T$(u, d) {
          return d(u), u;
        }
        function yf(u, d) {
          return d(u);
        }
        var A$ = Ba(function(u) {
          var d = u.length, m = d ? u[0] : 0, b = this.__wrapped__, D = function(R) {
            return Tm(R, u);
          };
          return d > 1 || this.__actions__.length || !(b instanceof Ot) || !Ua(m) ? this.thru(D) : (b = b.slice(m, +m + (d ? 1 : 0)), b.__actions__.push({
            func: yf,
            args: [D],
            thisArg: n
          }), new Oi(b, this.__chain__).thru(function(R) {
            return d && !R.length && R.push(n), R;
          }));
        });
        function D$() {
          return vw(this);
        }
        function E$() {
          return new Oi(this.value(), this.__chain__);
        }
        function P$() {
          this.__values__ === n && (this.__values__ = Ow(this.value()));
          var u = this.__index__ >= this.__values__.length, d = u ? n : this.__values__[this.__index__++];
          return { done: u, value: d };
        }
        function O$() {
          return this;
        }
        function M$(u) {
          for (var d, m = this; m instanceof af; ) {
            var b = cw(m);
            b.__index__ = 0, b.__values__ = n, d ? D.__wrapped__ = b : d = b;
            var D = b;
            m = m.__wrapped__;
          }
          return D.__wrapped__ = u, d;
        }
        function I$() {
          var u = this.__wrapped__;
          if (u instanceof Ot) {
            var d = u;
            return this.__actions__.length && (d = new Ot(this)), d = d.reverse(), d.__actions__.push({
              func: yf,
              args: [eg],
              thisArg: n
            }), new Oi(d, this.__chain__);
          }
          return this.thru(eg);
        }
        function R$() {
          return I1(this.__wrapped__, this.__actions__);
        }
        var F$ = ff(function(u, d, m) {
          Ht.call(u, m) ? ++u[m] : ga(u, m, 1);
        });
        function N$(u, d, m) {
          var b = ft(u) ? Hx : TN;
          return m && Ur(u, d, m) && (d = n), b(u, tt(d, 3));
        }
        function L$(u, d) {
          var m = ft(u) ? ks : g1;
          return m(u, tt(d, 3));
        }
        var $$ = W1(dw), V$ = W1(fw);
        function B$(u, d) {
          return xr(xf(u, d), 1);
        }
        function U$(u, d) {
          return xr(xf(u, d), X);
        }
        function q$(u, d, m) {
          return m = m === n ? 1 : yt(m), xr(xf(u, d), m);
        }
        function bw(u, d) {
          var m = ft(u) ? di : As;
          return m(u, tt(d, 3));
        }
        function _w(u, d) {
          var m = ft(u) ? oF : m1;
          return m(u, tt(d, 3));
        }
        var j$ = ff(function(u, d, m) {
          Ht.call(u, m) ? u[m].push(d) : ga(u, m, [d]);
        });
        function W$(u, d, m, b) {
          u = ei(u) ? u : Fl(u), m = m && !b ? yt(m) : 0;
          var D = u.length;
          return m < 0 && (m = sr(D + m, 0)), Tf(u) ? m <= D && u.indexOf(d, m) > -1 : !!D && kl(u, d, m) > -1;
        }
        var z$ = kt(function(u, d, m) {
          var b = -1, D = typeof d == "function", R = ei(u) ? de(u.length) : [];
          return As(u, function(V) {
            R[++b] = D ? ci(d, V, m) : qu(V, d, m);
          }), R;
        }), H$ = ff(function(u, d, m) {
          ga(u, m, d);
        });
        function xf(u, d) {
          var m = ft(u) ? bn : w1;
          return m(u, tt(d, 3));
        }
        function G$(u, d, m, b) {
          return u == null ? [] : (ft(d) || (d = d == null ? [] : [d]), m = b ? n : m, ft(m) || (m = m == null ? [] : [m]), T1(u, d, m));
        }
        var Y$ = ff(function(u, d, m) {
          u[m ? 0 : 1].push(d);
        }, function() {
          return [[], []];
        });
        function K$(u, d, m) {
          var b = ft(u) ? hm : Xx, D = arguments.length < 3;
          return b(u, tt(d, 4), m, D, As);
        }
        function X$(u, d, m) {
          var b = ft(u) ? lF : Xx, D = arguments.length < 3;
          return b(u, tt(d, 4), m, D, m1);
        }
        function Z$(u, d) {
          var m = ft(u) ? ks : g1;
          return m(u, Sf(tt(d, 3)));
        }
        function Q$(u) {
          var d = ft(u) ? d1 : WN;
          return d(u);
        }
        function J$(u, d, m) {
          (m ? Ur(u, d, m) : d === n) ? d = 1 : d = yt(d);
          var b = ft(u) ? xN : zN;
          return b(u, d);
        }
        function e3(u) {
          var d = ft(u) ? wN : GN;
          return d(u);
        }
        function t3(u) {
          if (u == null)
            return 0;
          if (ei(u))
            return Tf(u) ? Cl(u) : u.length;
          var d = Or(u);
          return d == Xe || d == ye ? u.size : Mm(u).length;
        }
        function n3(u, d, m) {
          var b = ft(u) ? pm : YN;
          return m && Ur(u, d, m) && (d = n), b(u, tt(d, 3));
        }
        var r3 = kt(function(u, d) {
          if (u == null)
            return [];
          var m = d.length;
          return m > 1 && Ur(u, d[0], d[1]) ? d = [] : m > 2 && Ur(d[0], d[1], d[2]) && (d = [d[0]]), T1(u, xr(d, 1), []);
        }), wf = LF || function() {
          return Kn.Date.now();
        };
        function i3(u, d) {
          if (typeof d != "function")
            throw new Pi(s);
          return u = yt(u), function() {
            if (--u < 1)
              return d.apply(this, arguments);
          };
        }
        function yw(u, d, m) {
          return d = m ? n : d, d = u && d == null ? u.length : d, Va(u, N, n, n, n, n, d);
        }
        function xw(u, d) {
          var m;
          if (typeof d != "function")
            throw new Pi(s);
          return u = yt(u), function() {
            return --u > 0 && (m = d.apply(this, arguments)), u <= 1 && (d = n), m;
          };
        }
        var ng = kt(function(u, d, m) {
          var b = x;
          if (m.length) {
            var D = Cs(m, Il(ng));
            b |= M;
          }
          return Va(u, b, d, m, D);
        }), ww = kt(function(u, d, m) {
          var b = x | E;
          if (m.length) {
            var D = Cs(m, Il(ww));
            b |= M;
          }
          return Va(d, b, u, m, D);
        });
        function kw(u, d, m) {
          d = m ? n : d;
          var b = Va(u, C, n, n, n, n, n, d);
          return b.placeholder = kw.placeholder, b;
        }
        function Sw(u, d, m) {
          d = m ? n : d;
          var b = Va(u, P, n, n, n, n, n, d);
          return b.placeholder = Sw.placeholder, b;
        }
        function Cw(u, d, m) {
          var b, D, R, V, H, ee, Se = 0, Ce = !1, Ee = !1, Ve = !0;
          if (typeof u != "function")
            throw new Pi(s);
          d = Fi(d) || 0, An(m) && (Ce = !!m.leading, Ee = "maxWait" in m, R = Ee ? sr(Fi(m.maxWait) || 0, d) : R, Ve = "trailing" in m ? !!m.trailing : Ve);
          function Ge(qn) {
            var na = b, Wa = D;
            return b = D = n, Se = qn, V = u.apply(Wa, na), V;
          }
          function rt(qn) {
            return Se = qn, H = Gu(Dt, d), Ce ? Ge(qn) : V;
          }
          function wt(qn) {
            var na = qn - ee, Wa = qn - Se, zw = d - na;
            return Ee ? Pr(zw, R - Wa) : zw;
          }
          function et(qn) {
            var na = qn - ee, Wa = qn - Se;
            return ee === n || na >= d || na < 0 || Ee && Wa >= R;
          }
          function Dt() {
            var qn = wf();
            if (et(qn))
              return Mt(qn);
            H = Gu(Dt, wt(qn));
          }
          function Mt(qn) {
            return H = n, Ve && b ? Ge(qn) : (b = D = n, V);
          }
          function mi() {
            H !== n && F1(H), Se = 0, b = ee = D = H = n;
          }
          function qr() {
            return H === n ? V : Mt(wf());
          }
          function gi() {
            var qn = wf(), na = et(qn);
            if (b = arguments, D = this, ee = qn, na) {
              if (H === n)
                return rt(ee);
              if (Ee)
                return F1(H), H = Gu(Dt, d), Ge(ee);
            }
            return H === n && (H = Gu(Dt, d)), V;
          }
          return gi.cancel = mi, gi.flush = qr, gi;
        }
        var a3 = kt(function(u, d) {
          return p1(u, 1, d);
        }), s3 = kt(function(u, d, m) {
          return p1(u, Fi(d) || 0, m);
        });
        function o3(u) {
          return Va(u, ne);
        }
        function kf(u, d) {
          if (typeof u != "function" || d != null && typeof d != "function")
            throw new Pi(s);
          var m = function() {
            var b = arguments, D = d ? d.apply(this, b) : b[0], R = m.cache;
            if (R.has(D))
              return R.get(D);
            var V = u.apply(this, b);
            return m.cache = R.set(D, V) || R, V;
          };
          return m.cache = new (kf.Cache || $a)(), m;
        }
        kf.Cache = $a;
        function Sf(u) {
          if (typeof u != "function")
            throw new Pi(s);
          return function() {
            var d = arguments;
            switch (d.length) {
              case 0:
                return !u.call(this);
              case 1:
                return !u.call(this, d[0]);
              case 2:
                return !u.call(this, d[0], d[1]);
              case 3:
                return !u.call(this, d[0], d[1], d[2]);
            }
            return !u.apply(this, d);
          };
        }
        function l3(u) {
          return xw(2, u);
        }
        var u3 = KN(function(u, d) {
          d = d.length == 1 && ft(d[0]) ? bn(d[0], fi(tt())) : bn(xr(d, 1), fi(tt()));
          var m = d.length;
          return kt(function(b) {
            for (var D = -1, R = Pr(b.length, m); ++D < R; )
              b[D] = d[D].call(this, b[D]);
            return ci(u, this, b);
          });
        }), rg = kt(function(u, d) {
          var m = Cs(d, Il(rg));
          return Va(u, M, n, d, m);
        }), Tw = kt(function(u, d) {
          var m = Cs(d, Il(Tw));
          return Va(u, T, n, d, m);
        }), c3 = Ba(function(u, d) {
          return Va(u, $, n, n, n, d);
        });
        function d3(u, d) {
          if (typeof u != "function")
            throw new Pi(s);
          return d = d === n ? d : yt(d), kt(u, d);
        }
        function f3(u, d) {
          if (typeof u != "function")
            throw new Pi(s);
          return d = d == null ? 0 : sr(yt(d), 0), kt(function(m) {
            var b = m[d], D = Ps(m, 0, d);
            return b && Ss(D, b), ci(u, this, D);
          });
        }
        function h3(u, d, m) {
          var b = !0, D = !0;
          if (typeof u != "function")
            throw new Pi(s);
          return An(m) && (b = "leading" in m ? !!m.leading : b, D = "trailing" in m ? !!m.trailing : D), Cw(u, d, {
            leading: b,
            maxWait: d,
            trailing: D
          });
        }
        function p3(u) {
          return yw(u, 1);
        }
        function m3(u, d) {
          return rg(Um(d), u);
        }
        function g3() {
          if (!arguments.length)
            return [];
          var u = arguments[0];
          return ft(u) ? u : [u];
        }
        function v3(u) {
          return Mi(u, v);
        }
        function b3(u, d) {
          return d = typeof d == "function" ? d : n, Mi(u, v, d);
        }
        function _3(u) {
          return Mi(u, p | v);
        }
        function y3(u, d) {
          return d = typeof d == "function" ? d : n, Mi(u, p | v, d);
        }
        function x3(u, d) {
          return d == null || h1(u, d, fr(d));
        }
        function ta(u, d) {
          return u === d || u !== u && d !== d;
        }
        var w3 = gf(Em), k3 = gf(function(u, d) {
          return u >= d;
        }), ko = _1(/* @__PURE__ */ (function() {
          return arguments;
        })()) ? _1 : function(u) {
          return In(u) && Ht.call(u, "callee") && !a1.call(u, "callee");
        }, ft = de.isArray, S3 = Bx ? fi(Bx) : MN;
        function ei(u) {
          return u != null && Cf(u.length) && !qa(u);
        }
        function Un(u) {
          return In(u) && ei(u);
        }
        function C3(u) {
          return u === !0 || u === !1 || In(u) && Br(u) == Vt;
        }
        var Os = VF || mg, T3 = Ux ? fi(Ux) : IN;
        function A3(u) {
          return In(u) && u.nodeType === 1 && !Yu(u);
        }
        function D3(u) {
          if (u == null)
            return !0;
          if (ei(u) && (ft(u) || typeof u == "string" || typeof u.splice == "function" || Os(u) || Rl(u) || ko(u)))
            return !u.length;
          var d = Or(u);
          if (d == Xe || d == ye)
            return !u.size;
          if (Hu(u))
            return !Mm(u).length;
          for (var m in u)
            if (Ht.call(u, m))
              return !1;
          return !0;
        }
        function E3(u, d) {
          return ju(u, d);
        }
        function P3(u, d, m) {
          m = typeof m == "function" ? m : n;
          var b = m ? m(u, d) : n;
          return b === n ? ju(u, d, n, m) : !!b;
        }
        function ig(u) {
          if (!In(u))
            return !1;
          var d = Br(u);
          return d == Qe || d == rr || typeof u.message == "string" && typeof u.name == "string" && !Yu(u);
        }
        function O3(u) {
          return typeof u == "number" && o1(u);
        }
        function qa(u) {
          if (!An(u))
            return !1;
          var d = Br(u);
          return d == Je || d == Pt || d == Sn || d == B;
        }
        function Aw(u) {
          return typeof u == "number" && u == yt(u);
        }
        function Cf(u) {
          return typeof u == "number" && u > -1 && u % 1 == 0 && u <= pe;
        }
        function An(u) {
          var d = typeof u;
          return u != null && (d == "object" || d == "function");
        }
        function In(u) {
          return u != null && typeof u == "object";
        }
        var Dw = qx ? fi(qx) : FN;
        function M3(u, d) {
          return u === d || Om(u, d, Ym(d));
        }
        function I3(u, d, m) {
          return m = typeof m == "function" ? m : n, Om(u, d, Ym(d), m);
        }
        function R3(u) {
          return Ew(u) && u != +u;
        }
        function F3(u) {
          if (bL(u))
            throw new ct(a);
          return y1(u);
        }
        function N3(u) {
          return u === null;
        }
        function L3(u) {
          return u == null;
        }
        function Ew(u) {
          return typeof u == "number" || In(u) && Br(u) == pt;
        }
        function Yu(u) {
          if (!In(u) || Br(u) != ut)
            return !1;
          var d = Zd(u);
          if (d === null)
            return !0;
          var m = Ht.call(d, "constructor") && d.constructor;
          return typeof m == "function" && m instanceof m && Gd.call(m) == IF;
        }
        var ag = jx ? fi(jx) : NN;
        function $3(u) {
          return Aw(u) && u >= -pe && u <= pe;
        }
        var Pw = Wx ? fi(Wx) : LN;
        function Tf(u) {
          return typeof u == "string" || !ft(u) && In(u) && Br(u) == $e;
        }
        function pi(u) {
          return typeof u == "symbol" || In(u) && Br(u) == Ct;
        }
        var Rl = zx ? fi(zx) : $N;
        function V3(u) {
          return u === n;
        }
        function B3(u) {
          return In(u) && Or(u) == mt;
        }
        function U3(u) {
          return In(u) && Br(u) == he;
        }
        var q3 = gf(Im), j3 = gf(function(u, d) {
          return u <= d;
        });
        function Ow(u) {
          if (!u)
            return [];
          if (ei(u))
            return Tf(u) ? Qi(u) : Jr(u);
          if (Fu && u[Fu])
            return xF(u[Fu]());
          var d = Or(u), m = d == Xe ? ym : d == ye ? Wd : Fl;
          return m(u);
        }
        function ja(u) {
          if (!u)
            return u === 0 ? u : 0;
          if (u = Fi(u), u === X || u === -X) {
            var d = u < 0 ? -1 : 1;
            return d * le;
          }
          return u === u ? u : 0;
        }
        function yt(u) {
          var d = ja(u), m = d % 1;
          return d === d ? m ? d - m : d : 0;
        }
        function Mw(u) {
          return u ? _o(yt(u), 0, Te) : 0;
        }
        function Fi(u) {
          if (typeof u == "number")
            return u;
          if (pi(u))
            return ue;
          if (An(u)) {
            var d = typeof u.valueOf == "function" ? u.valueOf() : u;
            u = An(d) ? d + "" : d;
          }
          if (typeof u != "string")
            return u === 0 ? u : +u;
          u = Zx(u);
          var m = em.test(u);
          return m || bs.test(u) ? Dr(u.slice(2), m ? 2 : 8) : Jp.test(u) ? ue : +u;
        }
        function Iw(u) {
          return ba(u, ti(u));
        }
        function W3(u) {
          return u ? _o(yt(u), -pe, pe) : u === 0 ? u : 0;
        }
        function Gt(u) {
          return u == null ? "" : hi(u);
        }
        var z3 = Ol(function(u, d) {
          if (Hu(d) || ei(d)) {
            ba(d, fr(d), u);
            return;
          }
          for (var m in d)
            Ht.call(d, m) && Bu(u, m, d[m]);
        }), Rw = Ol(function(u, d) {
          ba(d, ti(d), u);
        }), Fw = Ol(function(u, d, m, b) {
          ba(d, ti(d), u, b);
        }), sg = Ol(function(u, d, m, b) {
          ba(d, fr(d), u, b);
        }), H3 = Ba(Tm);
        function G3(u, d) {
          var m = Pl(u);
          return d == null ? m : f1(m, d);
        }
        var Y3 = kt(function(u, d) {
          u = rn(u);
          var m = -1, b = d.length, D = b > 2 ? d[2] : n;
          for (D && Ur(d[0], d[1], D) && (b = 1); ++m < b; )
            for (var R = d[m], V = ti(R), H = -1, ee = V.length; ++H < ee; ) {
              var Se = V[H], Ce = u[Se];
              (Ce === n || ta(Ce, Al[Se]) && !Ht.call(u, Se)) && (u[Se] = R[Se]);
            }
          return u;
        }), K3 = kt(function(u) {
          return u.push(n, Z1), ci(Nw, n, u);
        });
        function X3(u, d) {
          return Gx(u, tt(d, 3), va);
        }
        function Z3(u, d) {
          return Gx(u, tt(d, 3), Dm);
        }
        function Q3(u, d) {
          return u == null ? u : Am(u, tt(d, 3), ti);
        }
        function J3(u, d) {
          return u == null ? u : v1(u, tt(d, 3), ti);
        }
        function eV(u, d) {
          return u && va(u, tt(d, 3));
        }
        function tV(u, d) {
          return u && Dm(u, tt(d, 3));
        }
        function nV(u) {
          return u == null ? [] : lf(u, fr(u));
        }
        function rV(u) {
          return u == null ? [] : lf(u, ti(u));
        }
        function og(u, d, m) {
          var b = u == null ? n : yo(u, d);
          return b === n ? m : b;
        }
        function iV(u, d) {
          return u != null && ew(u, d, DN);
        }
        function lg(u, d) {
          return u != null && ew(u, d, EN);
        }
        var aV = H1(function(u, d, m) {
          d != null && typeof d.toString != "function" && (d = Yd.call(d)), u[d] = m;
        }, cg(ni)), sV = H1(function(u, d, m) {
          d != null && typeof d.toString != "function" && (d = Yd.call(d)), Ht.call(u, d) ? u[d].push(m) : u[d] = [m];
        }, tt), oV = kt(qu);
        function fr(u) {
          return ei(u) ? c1(u) : Mm(u);
        }
        function ti(u) {
          return ei(u) ? c1(u, !0) : VN(u);
        }
        function lV(u, d) {
          var m = {};
          return d = tt(d, 3), va(u, function(b, D, R) {
            ga(m, d(b, D, R), b);
          }), m;
        }
        function uV(u, d) {
          var m = {};
          return d = tt(d, 3), va(u, function(b, D, R) {
            ga(m, D, d(b, D, R));
          }), m;
        }
        var cV = Ol(function(u, d, m) {
          uf(u, d, m);
        }), Nw = Ol(function(u, d, m, b) {
          uf(u, d, m, b);
        }), dV = Ba(function(u, d) {
          var m = {};
          if (u == null)
            return m;
          var b = !1;
          d = bn(d, function(R) {
            return R = Es(R, u), b || (b = R.length > 1), R;
          }), ba(u, Hm(u), m), b && (m = Mi(m, p | g | v, sL));
          for (var D = d.length; D--; )
            $m(m, d[D]);
          return m;
        });
        function fV(u, d) {
          return Lw(u, Sf(tt(d)));
        }
        var hV = Ba(function(u, d) {
          return u == null ? {} : UN(u, d);
        });
        function Lw(u, d) {
          if (u == null)
            return {};
          var m = bn(Hm(u), function(b) {
            return [b];
          });
          return d = tt(d), A1(u, m, function(b, D) {
            return d(b, D[0]);
          });
        }
        function pV(u, d, m) {
          d = Es(d, u);
          var b = -1, D = d.length;
          for (D || (D = 1, u = n); ++b < D; ) {
            var R = u == null ? n : u[ea(d[b])];
            R === n && (b = D, R = m), u = qa(R) ? R.call(u) : R;
          }
          return u;
        }
        function mV(u, d, m) {
          return u == null ? u : Wu(u, d, m);
        }
        function gV(u, d, m, b) {
          return b = typeof b == "function" ? b : n, u == null ? u : Wu(u, d, m, b);
        }
        var $w = K1(fr), Vw = K1(ti);
        function vV(u, d, m) {
          var b = ft(u), D = b || Os(u) || Rl(u);
          if (d = tt(d, 4), m == null) {
            var R = u && u.constructor;
            D ? m = b ? new R() : [] : An(u) ? m = qa(R) ? Pl(Zd(u)) : {} : m = {};
          }
          return (D ? di : va)(u, function(V, H, ee) {
            return d(m, V, H, ee);
          }), m;
        }
        function bV(u, d) {
          return u == null ? !0 : $m(u, d);
        }
        function _V(u, d, m) {
          return u == null ? u : M1(u, d, Um(m));
        }
        function yV(u, d, m, b) {
          return b = typeof b == "function" ? b : n, u == null ? u : M1(u, d, Um(m), b);
        }
        function Fl(u) {
          return u == null ? [] : _m(u, fr(u));
        }
        function xV(u) {
          return u == null ? [] : _m(u, ti(u));
        }
        function wV(u, d, m) {
          return m === n && (m = d, d = n), m !== n && (m = Fi(m), m = m === m ? m : 0), d !== n && (d = Fi(d), d = d === d ? d : 0), _o(Fi(u), d, m);
        }
        function kV(u, d, m) {
          return d = ja(d), m === n ? (m = d, d = 0) : m = ja(m), u = Fi(u), PN(u, d, m);
        }
        function SV(u, d, m) {
          if (m && typeof m != "boolean" && Ur(u, d, m) && (d = m = n), m === n && (typeof d == "boolean" ? (m = d, d = n) : typeof u == "boolean" && (m = u, u = n)), u === n && d === n ? (u = 0, d = 1) : (u = ja(u), d === n ? (d = u, u = 0) : d = ja(d)), u > d) {
            var b = u;
            u = d, d = b;
          }
          if (m || u % 1 || d % 1) {
            var D = l1();
            return Pr(u + D * (d - u + yr("1e-" + ((D + "").length - 1))), d);
          }
          return Fm(u, d);
        }
        var CV = Ml(function(u, d, m) {
          return d = d.toLowerCase(), u + (m ? Bw(d) : d);
        });
        function Bw(u) {
          return ug(Gt(u).toLowerCase());
        }
        function Uw(u) {
          return u = Gt(u), u && u.replace(Pd, gF).replace(Mu, "");
        }
        function TV(u, d, m) {
          u = Gt(u), d = hi(d);
          var b = u.length;
          m = m === n ? b : _o(yt(m), 0, b);
          var D = m;
          return m -= d.length, m >= 0 && u.slice(m, D) == d;
        }
        function AV(u) {
          return u = Gt(u), u && ui.test(u) ? u.replace(ot, vF) : u;
        }
        function DV(u) {
          return u = Gt(u), u && Ai.test(u) ? u.replace(gs, "\\$&") : u;
        }
        var EV = Ml(function(u, d, m) {
          return u + (m ? "-" : "") + d.toLowerCase();
        }), PV = Ml(function(u, d, m) {
          return u + (m ? " " : "") + d.toLowerCase();
        }), OV = j1("toLowerCase");
        function MV(u, d, m) {
          u = Gt(u), d = yt(d);
          var b = d ? Cl(u) : 0;
          if (!d || b >= d)
            return u;
          var D = (d - b) / 2;
          return mf(tf(D), m) + u + mf(ef(D), m);
        }
        function IV(u, d, m) {
          u = Gt(u), d = yt(d);
          var b = d ? Cl(u) : 0;
          return d && b < d ? u + mf(d - b, m) : u;
        }
        function RV(u, d, m) {
          u = Gt(u), d = yt(d);
          var b = d ? Cl(u) : 0;
          return d && b < d ? mf(d - b, m) + u : u;
        }
        function FV(u, d, m) {
          return m || d == null ? d = 0 : d && (d = +d), jF(Gt(u).replace(ma, ""), d || 0);
        }
        function NV(u, d, m) {
          return (m ? Ur(u, d, m) : d === n) ? d = 1 : d = yt(d), Nm(Gt(u), d);
        }
        function LV() {
          var u = arguments, d = Gt(u[0]);
          return u.length < 3 ? d : d.replace(u[1], u[2]);
        }
        var $V = Ml(function(u, d, m) {
          return u + (m ? "_" : "") + d.toLowerCase();
        });
        function VV(u, d, m) {
          return m && typeof m != "number" && Ur(u, d, m) && (d = m = n), m = m === n ? Te : m >>> 0, m ? (u = Gt(u), u && (typeof d == "string" || d != null && !ag(d)) && (d = hi(d), !d && Sl(u)) ? Ps(Qi(u), 0, m) : u.split(d, m)) : [];
        }
        var BV = Ml(function(u, d, m) {
          return u + (m ? " " : "") + ug(d);
        });
        function UV(u, d, m) {
          return u = Gt(u), m = m == null ? 0 : _o(yt(m), 0, u.length), d = hi(d), u.slice(m, m + d.length) == d;
        }
        function qV(u, d, m) {
          var b = I.templateSettings;
          m && Ur(u, d, m) && (d = n), u = Gt(u), d = sg({}, d, b, X1);
          var D = sg({}, d.imports, b.imports, X1), R = fr(D), V = _m(D, R);
          di(R, function(et) {
            if (ku.test(et))
              throw new ct(l);
          });
          var H, ee, Se = 0, Ce = d.interpolate || _s, Ee = "__p += '", Ve = xm(
            (d.escape || _s).source + "|" + Ce.source + "|" + (Ce === _u ? Qp : _s).source + "|" + (d.evaluate || _s).source + "|$",
            "g"
          ), Ge = "//# sourceURL=" + (Ht.call(d, "sourceURL") ? (d.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++ke + "]") + `
`;
          u.replace(Ve, function(et, Dt, Mt, mi, qr, gi) {
            return Mt || (Mt = mi), Ee += u.slice(Se, gi).replace(Od, bF), Dt && (H = !0, Ee += `' +
__e(` + Dt + `) +
'`), qr && (ee = !0, Ee += `';
` + qr + `;
__p += '`), Mt && (Ee += `' +
((__t = (` + Mt + `)) == null ? '' : __t) +
'`), Se = gi + et.length, et;
          }), Ee += `';
`;
          var rt = Ht.call(d, "variable") && d.variable;
          if (!rt)
            Ee = `with (obj) {
` + Ee + `
}
`;
          else if (ku.test(rt))
            throw new ct(o);
          Ee = (ee ? Ee.replace(ir, "") : Ee).replace(Ia, "$1").replace(Ze, "$1;"), Ee = "function(" + (rt || "obj") + `) {
` + (rt ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (H ? ", __e = _.escape" : "") + (ee ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + Ee + `return __p
}`;
          var wt = jw(function() {
            return jt(R, Ge + "return " + Ee).apply(n, V);
          });
          if (wt.source = Ee, ig(wt))
            throw wt;
          return wt;
        }
        function jV(u) {
          return Gt(u).toLowerCase();
        }
        function WV(u) {
          return Gt(u).toUpperCase();
        }
        function zV(u, d, m) {
          if (u = Gt(u), u && (m || d === n))
            return Zx(u);
          if (!u || !(d = hi(d)))
            return u;
          var b = Qi(u), D = Qi(d), R = Qx(b, D), V = Jx(b, D) + 1;
          return Ps(b, R, V).join("");
        }
        function HV(u, d, m) {
          if (u = Gt(u), u && (m || d === n))
            return u.slice(0, t1(u) + 1);
          if (!u || !(d = hi(d)))
            return u;
          var b = Qi(u), D = Jx(b, Qi(d)) + 1;
          return Ps(b, 0, D).join("");
        }
        function GV(u, d, m) {
          if (u = Gt(u), u && (m || d === n))
            return u.replace(ma, "");
          if (!u || !(d = hi(d)))
            return u;
          var b = Qi(u), D = Qx(b, Qi(d));
          return Ps(b, D).join("");
        }
        function YV(u, d) {
          var m = Y, b = te;
          if (An(d)) {
            var D = "separator" in d ? d.separator : D;
            m = "length" in d ? yt(d.length) : m, b = "omission" in d ? hi(d.omission) : b;
          }
          u = Gt(u);
          var R = u.length;
          if (Sl(u)) {
            var V = Qi(u);
            R = V.length;
          }
          if (m >= R)
            return u;
          var H = m - Cl(b);
          if (H < 1)
            return b;
          var ee = V ? Ps(V, 0, H).join("") : u.slice(0, H);
          if (D === n)
            return ee + b;
          if (V && (H += ee.length - H), ag(D)) {
            if (u.slice(H).search(D)) {
              var Se, Ce = ee;
              for (D.global || (D = xm(D.source, Gt(vs.exec(D)) + "g")), D.lastIndex = 0; Se = D.exec(Ce); )
                var Ee = Se.index;
              ee = ee.slice(0, Ee === n ? H : Ee);
            }
          } else if (u.indexOf(hi(D), H) != H) {
            var Ve = ee.lastIndexOf(D);
            Ve > -1 && (ee = ee.slice(0, Ve));
          }
          return ee + b;
        }
        function KV(u) {
          return u = Gt(u), u && pa.test(u) ? u.replace(li, CF) : u;
        }
        var XV = Ml(function(u, d, m) {
          return u + (m ? " " : "") + d.toUpperCase();
        }), ug = j1("toUpperCase");
        function qw(u, d, m) {
          return u = Gt(u), d = m ? n : d, d === n ? yF(u) ? DF(u) : dF(u) : u.match(d) || [];
        }
        var jw = kt(function(u, d) {
          try {
            return ci(u, n, d);
          } catch (m) {
            return ig(m) ? m : new ct(m);
          }
        }), ZV = Ba(function(u, d) {
          return di(d, function(m) {
            m = ea(m), ga(u, m, ng(u[m], u));
          }), u;
        });
        function QV(u) {
          var d = u == null ? 0 : u.length, m = tt();
          return u = d ? bn(u, function(b) {
            if (typeof b[1] != "function")
              throw new Pi(s);
            return [m(b[0]), b[1]];
          }) : [], kt(function(b) {
            for (var D = -1; ++D < d; ) {
              var R = u[D];
              if (ci(R[0], this, b))
                return ci(R[1], this, b);
            }
          });
        }
        function JV(u) {
          return CN(Mi(u, p));
        }
        function cg(u) {
          return function() {
            return u;
          };
        }
        function e5(u, d) {
          return u == null || u !== u ? d : u;
        }
        var t5 = z1(), n5 = z1(!0);
        function ni(u) {
          return u;
        }
        function dg(u) {
          return x1(typeof u == "function" ? u : Mi(u, p));
        }
        function r5(u) {
          return k1(Mi(u, p));
        }
        function i5(u, d) {
          return S1(u, Mi(d, p));
        }
        var a5 = kt(function(u, d) {
          return function(m) {
            return qu(m, u, d);
          };
        }), s5 = kt(function(u, d) {
          return function(m) {
            return qu(u, m, d);
          };
        });
        function fg(u, d, m) {
          var b = fr(d), D = lf(d, b);
          m == null && !(An(d) && (D.length || !b.length)) && (m = d, d = u, u = this, D = lf(d, fr(d)));
          var R = !(An(m) && "chain" in m) || !!m.chain, V = qa(u);
          return di(D, function(H) {
            var ee = d[H];
            u[H] = ee, V && (u.prototype[H] = function() {
              var Se = this.__chain__;
              if (R || Se) {
                var Ce = u(this.__wrapped__), Ee = Ce.__actions__ = Jr(this.__actions__);
                return Ee.push({ func: ee, args: arguments, thisArg: u }), Ce.__chain__ = Se, Ce;
              }
              return ee.apply(u, Ss([this.value()], arguments));
            });
          }), u;
        }
        function o5() {
          return Kn._ === this && (Kn._ = RF), this;
        }
        function hg() {
        }
        function l5(u) {
          return u = yt(u), kt(function(d) {
            return C1(d, u);
          });
        }
        var u5 = jm(bn), c5 = jm(Hx), d5 = jm(pm);
        function Ww(u) {
          return Xm(u) ? mm(ea(u)) : qN(u);
        }
        function f5(u) {
          return function(d) {
            return u == null ? n : yo(u, d);
          };
        }
        var h5 = G1(), p5 = G1(!0);
        function pg() {
          return [];
        }
        function mg() {
          return !1;
        }
        function m5() {
          return {};
        }
        function g5() {
          return "";
        }
        function v5() {
          return !0;
        }
        function b5(u, d) {
          if (u = yt(u), u < 1 || u > pe)
            return [];
          var m = Te, b = Pr(u, Te);
          d = tt(d), u -= Te;
          for (var D = bm(b, d); ++m < u; )
            d(m);
          return D;
        }
        function _5(u) {
          return ft(u) ? bn(u, ea) : pi(u) ? [u] : Jr(uw(Gt(u)));
        }
        function y5(u) {
          var d = ++MF;
          return Gt(u) + d;
        }
        var x5 = pf(function(u, d) {
          return u + d;
        }, 0), w5 = Wm("ceil"), k5 = pf(function(u, d) {
          return u / d;
        }, 1), S5 = Wm("floor");
        function C5(u) {
          return u && u.length ? of(u, ni, Em) : n;
        }
        function T5(u, d) {
          return u && u.length ? of(u, tt(d, 2), Em) : n;
        }
        function A5(u) {
          return Kx(u, ni);
        }
        function D5(u, d) {
          return Kx(u, tt(d, 2));
        }
        function E5(u) {
          return u && u.length ? of(u, ni, Im) : n;
        }
        function P5(u, d) {
          return u && u.length ? of(u, tt(d, 2), Im) : n;
        }
        var O5 = pf(function(u, d) {
          return u * d;
        }, 1), M5 = Wm("round"), I5 = pf(function(u, d) {
          return u - d;
        }, 0);
        function R5(u) {
          return u && u.length ? vm(u, ni) : 0;
        }
        function F5(u, d) {
          return u && u.length ? vm(u, tt(d, 2)) : 0;
        }
        return I.after = i3, I.ary = yw, I.assign = z3, I.assignIn = Rw, I.assignInWith = Fw, I.assignWith = sg, I.at = H3, I.before = xw, I.bind = ng, I.bindAll = ZV, I.bindKey = ww, I.castArray = g3, I.chain = vw, I.chunk = CL, I.compact = TL, I.concat = AL, I.cond = QV, I.conforms = JV, I.constant = cg, I.countBy = F$, I.create = G3, I.curry = kw, I.curryRight = Sw, I.debounce = Cw, I.defaults = Y3, I.defaultsDeep = K3, I.defer = a3, I.delay = s3, I.difference = DL, I.differenceBy = EL, I.differenceWith = PL, I.drop = OL, I.dropRight = ML, I.dropRightWhile = IL, I.dropWhile = RL, I.fill = FL, I.filter = L$, I.flatMap = B$, I.flatMapDeep = U$, I.flatMapDepth = q$, I.flatten = hw, I.flattenDeep = NL, I.flattenDepth = LL, I.flip = o3, I.flow = t5, I.flowRight = n5, I.fromPairs = $L, I.functions = nV, I.functionsIn = rV, I.groupBy = j$, I.initial = BL, I.intersection = UL, I.intersectionBy = qL, I.intersectionWith = jL, I.invert = aV, I.invertBy = sV, I.invokeMap = z$, I.iteratee = dg, I.keyBy = H$, I.keys = fr, I.keysIn = ti, I.map = xf, I.mapKeys = lV, I.mapValues = uV, I.matches = r5, I.matchesProperty = i5, I.memoize = kf, I.merge = cV, I.mergeWith = Nw, I.method = a5, I.methodOf = s5, I.mixin = fg, I.negate = Sf, I.nthArg = l5, I.omit = dV, I.omitBy = fV, I.once = l3, I.orderBy = G$, I.over = u5, I.overArgs = u3, I.overEvery = c5, I.overSome = d5, I.partial = rg, I.partialRight = Tw, I.partition = Y$, I.pick = hV, I.pickBy = Lw, I.property = Ww, I.propertyOf = f5, I.pull = GL, I.pullAll = mw, I.pullAllBy = YL, I.pullAllWith = KL, I.pullAt = XL, I.range = h5, I.rangeRight = p5, I.rearg = c3, I.reject = Z$, I.remove = ZL, I.rest = d3, I.reverse = eg, I.sampleSize = J$, I.set = mV, I.setWith = gV, I.shuffle = e3, I.slice = QL, I.sortBy = r3, I.sortedUniq = a$, I.sortedUniqBy = s$, I.split = VV, I.spread = f3, I.tail = o$, I.take = l$, I.takeRight = u$, I.takeRightWhile = c$, I.takeWhile = d$, I.tap = T$, I.throttle = h3, I.thru = yf, I.toArray = Ow, I.toPairs = $w, I.toPairsIn = Vw, I.toPath = _5, I.toPlainObject = Iw, I.transform = vV, I.unary = p3, I.union = f$, I.unionBy = h$, I.unionWith = p$, I.uniq = m$, I.uniqBy = g$, I.uniqWith = v$, I.unset = bV, I.unzip = tg, I.unzipWith = gw, I.update = _V, I.updateWith = yV, I.values = Fl, I.valuesIn = xV, I.without = b$, I.words = qw, I.wrap = m3, I.xor = _$, I.xorBy = y$, I.xorWith = x$, I.zip = w$, I.zipObject = k$, I.zipObjectDeep = S$, I.zipWith = C$, I.entries = $w, I.entriesIn = Vw, I.extend = Rw, I.extendWith = Fw, fg(I, I), I.add = x5, I.attempt = jw, I.camelCase = CV, I.capitalize = Bw, I.ceil = w5, I.clamp = wV, I.clone = v3, I.cloneDeep = _3, I.cloneDeepWith = y3, I.cloneWith = b3, I.conformsTo = x3, I.deburr = Uw, I.defaultTo = e5, I.divide = k5, I.endsWith = TV, I.eq = ta, I.escape = AV, I.escapeRegExp = DV, I.every = N$, I.find = $$, I.findIndex = dw, I.findKey = X3, I.findLast = V$, I.findLastIndex = fw, I.findLastKey = Z3, I.floor = S5, I.forEach = bw, I.forEachRight = _w, I.forIn = Q3, I.forInRight = J3, I.forOwn = eV, I.forOwnRight = tV, I.get = og, I.gt = w3, I.gte = k3, I.has = iV, I.hasIn = lg, I.head = pw, I.identity = ni, I.includes = W$, I.indexOf = VL, I.inRange = kV, I.invoke = oV, I.isArguments = ko, I.isArray = ft, I.isArrayBuffer = S3, I.isArrayLike = ei, I.isArrayLikeObject = Un, I.isBoolean = C3, I.isBuffer = Os, I.isDate = T3, I.isElement = A3, I.isEmpty = D3, I.isEqual = E3, I.isEqualWith = P3, I.isError = ig, I.isFinite = O3, I.isFunction = qa, I.isInteger = Aw, I.isLength = Cf, I.isMap = Dw, I.isMatch = M3, I.isMatchWith = I3, I.isNaN = R3, I.isNative = F3, I.isNil = L3, I.isNull = N3, I.isNumber = Ew, I.isObject = An, I.isObjectLike = In, I.isPlainObject = Yu, I.isRegExp = ag, I.isSafeInteger = $3, I.isSet = Pw, I.isString = Tf, I.isSymbol = pi, I.isTypedArray = Rl, I.isUndefined = V3, I.isWeakMap = B3, I.isWeakSet = U3, I.join = WL, I.kebabCase = EV, I.last = Ri, I.lastIndexOf = zL, I.lowerCase = PV, I.lowerFirst = OV, I.lt = q3, I.lte = j3, I.max = C5, I.maxBy = T5, I.mean = A5, I.meanBy = D5, I.min = E5, I.minBy = P5, I.stubArray = pg, I.stubFalse = mg, I.stubObject = m5, I.stubString = g5, I.stubTrue = v5, I.multiply = O5, I.nth = HL, I.noConflict = o5, I.noop = hg, I.now = wf, I.pad = MV, I.padEnd = IV, I.padStart = RV, I.parseInt = FV, I.random = SV, I.reduce = K$, I.reduceRight = X$, I.repeat = NV, I.replace = LV, I.result = pV, I.round = M5, I.runInContext = Q, I.sample = Q$, I.size = t3, I.snakeCase = $V, I.some = n3, I.sortedIndex = JL, I.sortedIndexBy = e$, I.sortedIndexOf = t$, I.sortedLastIndex = n$, I.sortedLastIndexBy = r$, I.sortedLastIndexOf = i$, I.startCase = BV, I.startsWith = UV, I.subtract = I5, I.sum = R5, I.sumBy = F5, I.template = qV, I.times = b5, I.toFinite = ja, I.toInteger = yt, I.toLength = Mw, I.toLower = jV, I.toNumber = Fi, I.toSafeInteger = W3, I.toString = Gt, I.toUpper = WV, I.trim = zV, I.trimEnd = HV, I.trimStart = GV, I.truncate = YV, I.unescape = KV, I.uniqueId = y5, I.upperCase = XV, I.upperFirst = ug, I.each = bw, I.eachRight = _w, I.first = pw, fg(I, (function() {
          var u = {};
          return va(I, function(d, m) {
            Ht.call(I.prototype, m) || (u[m] = d);
          }), u;
        })(), { chain: !1 }), I.VERSION = r, di(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(u) {
          I[u].placeholder = I;
        }), di(["drop", "take"], function(u, d) {
          Ot.prototype[u] = function(m) {
            m = m === n ? 1 : sr(yt(m), 0);
            var b = this.__filtered__ && !d ? new Ot(this) : this.clone();
            return b.__filtered__ ? b.__takeCount__ = Pr(m, b.__takeCount__) : b.__views__.push({
              size: Pr(m, Te),
              type: u + (b.__dir__ < 0 ? "Right" : "")
            }), b;
          }, Ot.prototype[u + "Right"] = function(m) {
            return this.reverse()[u](m).reverse();
          };
        }), di(["filter", "map", "takeWhile"], function(u, d) {
          var m = d + 1, b = m == J || m == A;
          Ot.prototype[u] = function(D) {
            var R = this.clone();
            return R.__iteratees__.push({
              iteratee: tt(D, 3),
              type: m
            }), R.__filtered__ = R.__filtered__ || b, R;
          };
        }), di(["head", "last"], function(u, d) {
          var m = "take" + (d ? "Right" : "");
          Ot.prototype[u] = function() {
            return this[m](1).value()[0];
          };
        }), di(["initial", "tail"], function(u, d) {
          var m = "drop" + (d ? "" : "Right");
          Ot.prototype[u] = function() {
            return this.__filtered__ ? new Ot(this) : this[m](1);
          };
        }), Ot.prototype.compact = function() {
          return this.filter(ni);
        }, Ot.prototype.find = function(u) {
          return this.filter(u).head();
        }, Ot.prototype.findLast = function(u) {
          return this.reverse().find(u);
        }, Ot.prototype.invokeMap = kt(function(u, d) {
          return typeof u == "function" ? new Ot(this) : this.map(function(m) {
            return qu(m, u, d);
          });
        }), Ot.prototype.reject = function(u) {
          return this.filter(Sf(tt(u)));
        }, Ot.prototype.slice = function(u, d) {
          u = yt(u);
          var m = this;
          return m.__filtered__ && (u > 0 || d < 0) ? new Ot(m) : (u < 0 ? m = m.takeRight(-u) : u && (m = m.drop(u)), d !== n && (d = yt(d), m = d < 0 ? m.dropRight(-d) : m.take(d - u)), m);
        }, Ot.prototype.takeRightWhile = function(u) {
          return this.reverse().takeWhile(u).reverse();
        }, Ot.prototype.toArray = function() {
          return this.take(Te);
        }, va(Ot.prototype, function(u, d) {
          var m = /^(?:filter|find|map|reject)|While$/.test(d), b = /^(?:head|last)$/.test(d), D = I[b ? "take" + (d == "last" ? "Right" : "") : d], R = b || /^find/.test(d);
          D && (I.prototype[d] = function() {
            var V = this.__wrapped__, H = b ? [1] : arguments, ee = V instanceof Ot, Se = H[0], Ce = ee || ft(V), Ee = function(Dt) {
              var Mt = D.apply(I, Ss([Dt], H));
              return b && Ve ? Mt[0] : Mt;
            };
            Ce && m && typeof Se == "function" && Se.length != 1 && (ee = Ce = !1);
            var Ve = this.__chain__, Ge = !!this.__actions__.length, rt = R && !Ve, wt = ee && !Ge;
            if (!R && Ce) {
              V = wt ? V : new Ot(this);
              var et = u.apply(V, H);
              return et.__actions__.push({ func: yf, args: [Ee], thisArg: n }), new Oi(et, Ve);
            }
            return rt && wt ? u.apply(this, H) : (et = this.thru(Ee), rt ? b ? et.value()[0] : et.value() : et);
          });
        }), di(["pop", "push", "shift", "sort", "splice", "unshift"], function(u) {
          var d = zd[u], m = /^(?:push|sort|unshift)$/.test(u) ? "tap" : "thru", b = /^(?:pop|shift)$/.test(u);
          I.prototype[u] = function() {
            var D = arguments;
            if (b && !this.__chain__) {
              var R = this.value();
              return d.apply(ft(R) ? R : [], D);
            }
            return this[m](function(V) {
              return d.apply(ft(V) ? V : [], D);
            });
          };
        }), va(Ot.prototype, function(u, d) {
          var m = I[d];
          if (m) {
            var b = m.name + "";
            Ht.call(El, b) || (El[b] = []), El[b].push({ name: d, func: m });
          }
        }), El[hf(n, E).name] = [{
          name: "wrapper",
          func: n
        }], Ot.prototype.clone = XF, Ot.prototype.reverse = ZF, Ot.prototype.value = QF, I.prototype.at = A$, I.prototype.chain = D$, I.prototype.commit = E$, I.prototype.next = P$, I.prototype.plant = M$, I.prototype.reverse = I$, I.prototype.toJSON = I.prototype.valueOf = I.prototype.value = R$, I.prototype.first = I.prototype.head, Fu && (I.prototype[Fu] = O$), I;
      }), Tl = EF();
      mo ? ((mo.exports = Tl)._ = Tl, cm._ = Tl) : Kn._ = Tl;
    }).call(ope);
  })(yc, yc.exports)), yc.exports;
}
var upe = lpe();
const dR = /* @__PURE__ */ hl(upe), cpe = {
  props: {
    styleToAdd: {
      type: String,
      required: !1,
      default: ""
    },
    value: {
      type: String,
      required: !0
    },
    translationPrefix: {
      type: String,
      required: !1,
      default: ""
    }
  },
  computed: {
    spanText() {
      const e = dR.compact([
        this.translationPrefix,
        this.value
      ]).join(".");
      return uR(this.$t(e));
    }
  }
};
function dpe(e, t, n, r, i, a) {
  return _(), O("span", {
    class: Pe([
      this.styleToAdd,
      "inline-flex items-center px-3 py-0.5 rounded-full text-xs font-medium"
    ])
  }, j(a.spanText), 3);
}
const G0e = /* @__PURE__ */ we(cpe, [["render", dpe]]);
var zy;
try {
  zy = Map;
} catch {
}
var Hy;
try {
  Hy = Set;
} catch {
}
function fR(e, t, n) {
  if (!e || typeof e != "object" || typeof e == "function")
    return e;
  if (e.nodeType && "cloneNode" in e)
    return e.cloneNode(!0);
  if (e instanceof Date)
    return new Date(e.getTime());
  if (e instanceof RegExp)
    return new RegExp(e);
  if (Array.isArray(e))
    return e.map(Gy);
  if (zy && e instanceof zy)
    return new Map(Array.from(e.entries()));
  if (Hy && e instanceof Hy)
    return new Set(Array.from(e.values()));
  if (e instanceof Object) {
    t.push(e);
    var r = Object.create(e);
    n.push(r);
    for (var i in e) {
      var a = t.findIndex(function(s) {
        return s === e[i];
      });
      r[i] = a > -1 ? n[a] : fR(e[i], t, n);
    }
    return r;
  }
  return e;
}
function Gy(e) {
  return fR(e, [], []);
}
const fpe = Object.prototype.toString, hpe = Error.prototype.toString, ppe = RegExp.prototype.toString, mpe = typeof Symbol < "u" ? Symbol.prototype.toString : () => "", gpe = /^Symbol\((.*)\)(.*)$/;
function vpe(e) {
  return e != +e ? "NaN" : e === 0 && 1 / e < 0 ? "-0" : "" + e;
}
function kA(e, t = !1) {
  if (e == null || e === !0 || e === !1) return "" + e;
  const n = typeof e;
  if (n === "number") return vpe(e);
  if (n === "string") return t ? `"${e}"` : e;
  if (n === "function") return "[Function " + (e.name || "anonymous") + "]";
  if (n === "symbol") return mpe.call(e).replace(gpe, "Symbol($1)");
  const r = fpe.call(e).slice(8, -1);
  return r === "Date" ? isNaN(e.getTime()) ? "" + e : e.toISOString(e) : r === "Error" || e instanceof Error ? "[" + hpe.call(e) + "]" : r === "RegExp" ? ppe.call(e) : null;
}
function Xc(e, t) {
  let n = kA(e, t);
  return n !== null ? n : JSON.stringify(e, function(r, i) {
    let a = kA(this[r], t);
    return a !== null ? a : i;
  }, 2);
}
let Fo = {
  default: "${path} is invalid",
  required: "${path} is a required field",
  oneOf: "${path} must be one of the following values: ${values}",
  notOneOf: "${path} must not be one of the following values: ${values}",
  notType: ({
    path: e,
    type: t,
    value: n,
    originalValue: r
  }) => {
    let i = r != null && r !== n, a = `${e} must be a \`${t}\` type, but the final value was: \`${Xc(n, !0)}\`` + (i ? ` (cast from the value \`${Xc(r, !0)}\`).` : ".");
    return n === null && (a += '\n If "null" is intended as an empty value be sure to mark the schema as `.nullable()`'), a;
  },
  defined: "${path} must be defined"
}, ia = {
  length: "${path} must be exactly ${length} characters",
  min: "${path} must be at least ${min} characters",
  max: "${path} must be at most ${max} characters",
  matches: '${path} must match the following: "${regex}"',
  email: "${path} must be a valid email",
  url: "${path} must be a valid URL",
  uuid: "${path} must be a valid UUID",
  trim: "${path} must be a trimmed string",
  lowercase: "${path} must be a lowercase string",
  uppercase: "${path} must be a upper case string"
}, $s = {
  min: "${path} must be greater than or equal to ${min}",
  max: "${path} must be less than or equal to ${max}",
  lessThan: "${path} must be less than ${less}",
  moreThan: "${path} must be greater than ${more}",
  positive: "${path} must be a positive number",
  negative: "${path} must be a negative number",
  integer: "${path} must be an integer"
}, Yy = {
  min: "${path} field must be later than ${min}",
  max: "${path} field must be at earlier than ${max}"
}, bpe = {
  isValue: "${path} field must be ${value}"
}, Ky = {
  noUnknown: "${path} field has unspecified keys: ${unknown}"
}, _pe = {
  min: "${path} field must have at least ${min} items",
  max: "${path} field must have less than or equal to ${max} items",
  length: "${path} must have ${length} items"
};
Object.assign(/* @__PURE__ */ Object.create(null), {
  mixed: Fo,
  string: ia,
  number: $s,
  date: Yy,
  object: Ky,
  array: _pe,
  boolean: bpe
});
var dv, SA;
function ype() {
  if (SA) return dv;
  SA = 1;
  var e = Object.prototype, t = e.hasOwnProperty;
  function n(r, i) {
    return r != null && t.call(r, i);
  }
  return dv = n, dv;
}
var fv, CA;
function co() {
  if (CA) return fv;
  CA = 1;
  var e = Array.isArray;
  return fv = e, fv;
}
var hv, TA;
function hR() {
  if (TA) return hv;
  TA = 1;
  var e = typeof js == "object" && js && js.Object === Object && js;
  return hv = e, hv;
}
var pv, AA;
function ms() {
  if (AA) return pv;
  AA = 1;
  var e = hR(), t = typeof self == "object" && self && self.Object === Object && self, n = e || t || Function("return this")();
  return pv = n, pv;
}
var mv, DA;
function jp() {
  if (DA) return mv;
  DA = 1;
  var e = ms(), t = e.Symbol;
  return mv = t, mv;
}
var gv, EA;
function xpe() {
  if (EA) return gv;
  EA = 1;
  var e = jp(), t = Object.prototype, n = t.hasOwnProperty, r = t.toString, i = e ? e.toStringTag : void 0;
  function a(s) {
    var o = n.call(s, i), l = s[i];
    try {
      s[i] = void 0;
      var c = !0;
    } catch {
    }
    var f = r.call(s);
    return c && (o ? s[i] = l : delete s[i]), f;
  }
  return gv = a, gv;
}
var vv, PA;
function wpe() {
  if (PA) return vv;
  PA = 1;
  var e = Object.prototype, t = e.toString;
  function n(r) {
    return t.call(r);
  }
  return vv = n, vv;
}
var bv, OA;
function wd() {
  if (OA) return bv;
  OA = 1;
  var e = jp(), t = xpe(), n = wpe(), r = "[object Null]", i = "[object Undefined]", a = e ? e.toStringTag : void 0;
  function s(o) {
    return o == null ? o === void 0 ? i : r : a && a in Object(o) ? t(o) : n(o);
  }
  return bv = s, bv;
}
var _v, MA;
function kd() {
  if (MA) return _v;
  MA = 1;
  function e(t) {
    return t != null && typeof t == "object";
  }
  return _v = e, _v;
}
var yv, IA;
function Px() {
  if (IA) return yv;
  IA = 1;
  var e = wd(), t = kd(), n = "[object Symbol]";
  function r(i) {
    return typeof i == "symbol" || t(i) && e(i) == n;
  }
  return yv = r, yv;
}
var xv, RA;
function Ox() {
  if (RA) return xv;
  RA = 1;
  var e = co(), t = Px(), n = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, r = /^\w*$/;
  function i(a, s) {
    if (e(a))
      return !1;
    var o = typeof a;
    return o == "number" || o == "symbol" || o == "boolean" || a == null || t(a) ? !0 : r.test(a) || !n.test(a) || s != null && a in Object(s);
  }
  return xv = i, xv;
}
var wv, FA;
function Mx() {
  if (FA) return wv;
  FA = 1;
  function e(t) {
    var n = typeof t;
    return t != null && (n == "object" || n == "function");
  }
  return wv = e, wv;
}
var kv, NA;
function pR() {
  if (NA) return kv;
  NA = 1;
  var e = wd(), t = Mx(), n = "[object AsyncFunction]", r = "[object Function]", i = "[object GeneratorFunction]", a = "[object Proxy]";
  function s(o) {
    if (!t(o))
      return !1;
    var l = e(o);
    return l == r || l == i || l == n || l == a;
  }
  return kv = s, kv;
}
var Sv, LA;
function kpe() {
  if (LA) return Sv;
  LA = 1;
  var e = ms(), t = e["__core-js_shared__"];
  return Sv = t, Sv;
}
var Cv, $A;
function Spe() {
  if ($A) return Cv;
  $A = 1;
  var e = kpe(), t = (function() {
    var r = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return r ? "Symbol(src)_1." + r : "";
  })();
  function n(r) {
    return !!t && t in r;
  }
  return Cv = n, Cv;
}
var Tv, VA;
function mR() {
  if (VA) return Tv;
  VA = 1;
  var e = Function.prototype, t = e.toString;
  function n(r) {
    if (r != null) {
      try {
        return t.call(r);
      } catch {
      }
      try {
        return r + "";
      } catch {
      }
    }
    return "";
  }
  return Tv = n, Tv;
}
var Av, BA;
function Cpe() {
  if (BA) return Av;
  BA = 1;
  var e = pR(), t = Spe(), n = Mx(), r = mR(), i = /[\\^$.*+?()[\]{}|]/g, a = /^\[object .+?Constructor\]$/, s = Function.prototype, o = Object.prototype, l = s.toString, c = o.hasOwnProperty, f = RegExp(
    "^" + l.call(c).replace(i, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function h(p) {
    if (!n(p) || t(p))
      return !1;
    var g = e(p) ? f : a;
    return g.test(r(p));
  }
  return Av = h, Av;
}
var Dv, UA;
function Tpe() {
  if (UA) return Dv;
  UA = 1;
  function e(t, n) {
    return t == null ? void 0 : t[n];
  }
  return Dv = e, Dv;
}
var Ev, qA;
function pl() {
  if (qA) return Ev;
  qA = 1;
  var e = Cpe(), t = Tpe();
  function n(r, i) {
    var a = t(r, i);
    return e(a) ? a : void 0;
  }
  return Ev = n, Ev;
}
var Pv, jA;
function Wp() {
  if (jA) return Pv;
  jA = 1;
  var e = pl(), t = e(Object, "create");
  return Pv = t, Pv;
}
var Ov, WA;
function Ape() {
  if (WA) return Ov;
  WA = 1;
  var e = Wp();
  function t() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return Ov = t, Ov;
}
var Mv, zA;
function Dpe() {
  if (zA) return Mv;
  zA = 1;
  function e(t) {
    var n = this.has(t) && delete this.__data__[t];
    return this.size -= n ? 1 : 0, n;
  }
  return Mv = e, Mv;
}
var Iv, HA;
function Epe() {
  if (HA) return Iv;
  HA = 1;
  var e = Wp(), t = "__lodash_hash_undefined__", n = Object.prototype, r = n.hasOwnProperty;
  function i(a) {
    var s = this.__data__;
    if (e) {
      var o = s[a];
      return o === t ? void 0 : o;
    }
    return r.call(s, a) ? s[a] : void 0;
  }
  return Iv = i, Iv;
}
var Rv, GA;
function Ppe() {
  if (GA) return Rv;
  GA = 1;
  var e = Wp(), t = Object.prototype, n = t.hasOwnProperty;
  function r(i) {
    var a = this.__data__;
    return e ? a[i] !== void 0 : n.call(a, i);
  }
  return Rv = r, Rv;
}
var Fv, YA;
function Ope() {
  if (YA) return Fv;
  YA = 1;
  var e = Wp(), t = "__lodash_hash_undefined__";
  function n(r, i) {
    var a = this.__data__;
    return this.size += this.has(r) ? 0 : 1, a[r] = e && i === void 0 ? t : i, this;
  }
  return Fv = n, Fv;
}
var Nv, KA;
function Mpe() {
  if (KA) return Nv;
  KA = 1;
  var e = Ape(), t = Dpe(), n = Epe(), r = Ppe(), i = Ope();
  function a(s) {
    var o = -1, l = s == null ? 0 : s.length;
    for (this.clear(); ++o < l; ) {
      var c = s[o];
      this.set(c[0], c[1]);
    }
  }
  return a.prototype.clear = e, a.prototype.delete = t, a.prototype.get = n, a.prototype.has = r, a.prototype.set = i, Nv = a, Nv;
}
var Lv, XA;
function Ipe() {
  if (XA) return Lv;
  XA = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return Lv = e, Lv;
}
var $v, ZA;
function gR() {
  if (ZA) return $v;
  ZA = 1;
  function e(t, n) {
    return t === n || t !== t && n !== n;
  }
  return $v = e, $v;
}
var Vv, QA;
function zp() {
  if (QA) return Vv;
  QA = 1;
  var e = gR();
  function t(n, r) {
    for (var i = n.length; i--; )
      if (e(n[i][0], r))
        return i;
    return -1;
  }
  return Vv = t, Vv;
}
var Bv, JA;
function Rpe() {
  if (JA) return Bv;
  JA = 1;
  var e = zp(), t = Array.prototype, n = t.splice;
  function r(i) {
    var a = this.__data__, s = e(a, i);
    if (s < 0)
      return !1;
    var o = a.length - 1;
    return s == o ? a.pop() : n.call(a, s, 1), --this.size, !0;
  }
  return Bv = r, Bv;
}
var Uv, eD;
function Fpe() {
  if (eD) return Uv;
  eD = 1;
  var e = zp();
  function t(n) {
    var r = this.__data__, i = e(r, n);
    return i < 0 ? void 0 : r[i][1];
  }
  return Uv = t, Uv;
}
var qv, tD;
function Npe() {
  if (tD) return qv;
  tD = 1;
  var e = zp();
  function t(n) {
    return e(this.__data__, n) > -1;
  }
  return qv = t, qv;
}
var jv, nD;
function Lpe() {
  if (nD) return jv;
  nD = 1;
  var e = zp();
  function t(n, r) {
    var i = this.__data__, a = e(i, n);
    return a < 0 ? (++this.size, i.push([n, r])) : i[a][1] = r, this;
  }
  return jv = t, jv;
}
var Wv, rD;
function Hp() {
  if (rD) return Wv;
  rD = 1;
  var e = Ipe(), t = Rpe(), n = Fpe(), r = Npe(), i = Lpe();
  function a(s) {
    var o = -1, l = s == null ? 0 : s.length;
    for (this.clear(); ++o < l; ) {
      var c = s[o];
      this.set(c[0], c[1]);
    }
  }
  return a.prototype.clear = e, a.prototype.delete = t, a.prototype.get = n, a.prototype.has = r, a.prototype.set = i, Wv = a, Wv;
}
var zv, iD;
function Ix() {
  if (iD) return zv;
  iD = 1;
  var e = pl(), t = ms(), n = e(t, "Map");
  return zv = n, zv;
}
var Hv, aD;
function $pe() {
  if (aD) return Hv;
  aD = 1;
  var e = Mpe(), t = Hp(), n = Ix();
  function r() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (n || t)(),
      string: new e()
    };
  }
  return Hv = r, Hv;
}
var Gv, sD;
function Vpe() {
  if (sD) return Gv;
  sD = 1;
  function e(t) {
    var n = typeof t;
    return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? t !== "__proto__" : t === null;
  }
  return Gv = e, Gv;
}
var Yv, oD;
function Gp() {
  if (oD) return Yv;
  oD = 1;
  var e = Vpe();
  function t(n, r) {
    var i = n.__data__;
    return e(r) ? i[typeof r == "string" ? "string" : "hash"] : i.map;
  }
  return Yv = t, Yv;
}
var Kv, lD;
function Bpe() {
  if (lD) return Kv;
  lD = 1;
  var e = Gp();
  function t(n) {
    var r = e(this, n).delete(n);
    return this.size -= r ? 1 : 0, r;
  }
  return Kv = t, Kv;
}
var Xv, uD;
function Upe() {
  if (uD) return Xv;
  uD = 1;
  var e = Gp();
  function t(n) {
    return e(this, n).get(n);
  }
  return Xv = t, Xv;
}
var Zv, cD;
function qpe() {
  if (cD) return Zv;
  cD = 1;
  var e = Gp();
  function t(n) {
    return e(this, n).has(n);
  }
  return Zv = t, Zv;
}
var Qv, dD;
function jpe() {
  if (dD) return Qv;
  dD = 1;
  var e = Gp();
  function t(n, r) {
    var i = e(this, n), a = i.size;
    return i.set(n, r), this.size += i.size == a ? 0 : 1, this;
  }
  return Qv = t, Qv;
}
var Jv, fD;
function Rx() {
  if (fD) return Jv;
  fD = 1;
  var e = $pe(), t = Bpe(), n = Upe(), r = qpe(), i = jpe();
  function a(s) {
    var o = -1, l = s == null ? 0 : s.length;
    for (this.clear(); ++o < l; ) {
      var c = s[o];
      this.set(c[0], c[1]);
    }
  }
  return a.prototype.clear = e, a.prototype.delete = t, a.prototype.get = n, a.prototype.has = r, a.prototype.set = i, Jv = a, Jv;
}
var eb, hD;
function Wpe() {
  if (hD) return eb;
  hD = 1;
  var e = Rx(), t = "Expected a function";
  function n(r, i) {
    if (typeof r != "function" || i != null && typeof i != "function")
      throw new TypeError(t);
    var a = function() {
      var s = arguments, o = i ? i.apply(this, s) : s[0], l = a.cache;
      if (l.has(o))
        return l.get(o);
      var c = r.apply(this, s);
      return a.cache = l.set(o, c) || l, c;
    };
    return a.cache = new (n.Cache || e)(), a;
  }
  return n.Cache = e, eb = n, eb;
}
var tb, pD;
function zpe() {
  if (pD) return tb;
  pD = 1;
  var e = Wpe(), t = 500;
  function n(r) {
    var i = e(r, function(s) {
      return a.size === t && a.clear(), s;
    }), a = i.cache;
    return i;
  }
  return tb = n, tb;
}
var nb, mD;
function Hpe() {
  if (mD) return nb;
  mD = 1;
  var e = zpe(), t = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, n = /\\(\\)?/g, r = e(function(i) {
    var a = [];
    return i.charCodeAt(0) === 46 && a.push(""), i.replace(t, function(s, o, l, c) {
      a.push(l ? c.replace(n, "$1") : o || s);
    }), a;
  });
  return nb = r, nb;
}
var rb, gD;
function Gpe() {
  if (gD) return rb;
  gD = 1;
  function e(t, n) {
    for (var r = -1, i = t == null ? 0 : t.length, a = Array(i); ++r < i; )
      a[r] = n(t[r], r, t);
    return a;
  }
  return rb = e, rb;
}
var ib, vD;
function Ype() {
  if (vD) return ib;
  vD = 1;
  var e = jp(), t = Gpe(), n = co(), r = Px(), i = e ? e.prototype : void 0, a = i ? i.toString : void 0;
  function s(o) {
    if (typeof o == "string")
      return o;
    if (n(o))
      return t(o, s) + "";
    if (r(o))
      return a ? a.call(o) : "";
    var l = o + "";
    return l == "0" && 1 / o == -1 / 0 ? "-0" : l;
  }
  return ib = s, ib;
}
var ab, bD;
function Sd() {
  if (bD) return ab;
  bD = 1;
  var e = Ype();
  function t(n) {
    return n == null ? "" : e(n);
  }
  return ab = t, ab;
}
var sb, _D;
function vR() {
  if (_D) return sb;
  _D = 1;
  var e = co(), t = Ox(), n = Hpe(), r = Sd();
  function i(a, s) {
    return e(a) ? a : t(a, s) ? [a] : n(r(a));
  }
  return sb = i, sb;
}
var ob, yD;
function Kpe() {
  if (yD) return ob;
  yD = 1;
  var e = wd(), t = kd(), n = "[object Arguments]";
  function r(i) {
    return t(i) && e(i) == n;
  }
  return ob = r, ob;
}
var lb, xD;
function bR() {
  if (xD) return lb;
  xD = 1;
  var e = Kpe(), t = kd(), n = Object.prototype, r = n.hasOwnProperty, i = n.propertyIsEnumerable, a = e(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? e : function(s) {
    return t(s) && r.call(s, "callee") && !i.call(s, "callee");
  };
  return lb = a, lb;
}
var ub, wD;
function _R() {
  if (wD) return ub;
  wD = 1;
  var e = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
  function n(r, i) {
    var a = typeof r;
    return i = i ?? e, !!i && (a == "number" || a != "symbol" && t.test(r)) && r > -1 && r % 1 == 0 && r < i;
  }
  return ub = n, ub;
}
var cb, kD;
function Fx() {
  if (kD) return cb;
  kD = 1;
  var e = 9007199254740991;
  function t(n) {
    return typeof n == "number" && n > -1 && n % 1 == 0 && n <= e;
  }
  return cb = t, cb;
}
var db, SD;
function Yp() {
  if (SD) return db;
  SD = 1;
  var e = Px();
  function t(n) {
    if (typeof n == "string" || e(n))
      return n;
    var r = n + "";
    return r == "0" && 1 / n == -1 / 0 ? "-0" : r;
  }
  return db = t, db;
}
var fb, CD;
function yR() {
  if (CD) return fb;
  CD = 1;
  var e = vR(), t = bR(), n = co(), r = _R(), i = Fx(), a = Yp();
  function s(o, l, c) {
    l = e(l, o);
    for (var f = -1, h = l.length, p = !1; ++f < h; ) {
      var g = a(l[f]);
      if (!(p = o != null && c(o, g)))
        break;
      o = o[g];
    }
    return p || ++f != h ? p : (h = o == null ? 0 : o.length, !!h && i(h) && r(g, h) && (n(o) || t(o)));
  }
  return fb = s, fb;
}
var hb, TD;
function Xpe() {
  if (TD) return hb;
  TD = 1;
  var e = ype(), t = yR();
  function n(r, i) {
    return r != null && t(r, i, e);
  }
  return hb = n, hb;
}
var Zpe = Xpe();
const Qh = /* @__PURE__ */ hl(Zpe), xR = (e) => e && e.__isYupSchema__;
class Qpe {
  constructor(t, n) {
    if (this.fn = void 0, this.refs = t, this.refs = t, typeof n == "function") {
      this.fn = n;
      return;
    }
    if (!Qh(n, "is")) throw new TypeError("`is:` is required for `when()` conditions");
    if (!n.then && !n.otherwise) throw new TypeError("either `then:` or `otherwise:` is required for `when()` conditions");
    let {
      is: r,
      then: i,
      otherwise: a
    } = n, s = typeof r == "function" ? r : (...o) => o.every((l) => l === r);
    this.fn = function(...o) {
      let l = o.pop(), c = o.pop(), f = s(...o) ? i : a;
      if (f)
        return typeof f == "function" ? f(c) : c.concat(f.resolve(l));
    };
  }
  resolve(t, n) {
    let r = this.refs.map((a) => a.getValue(n == null ? void 0 : n.value, n == null ? void 0 : n.parent, n == null ? void 0 : n.context)), i = this.fn.apply(t, r.concat(t, n));
    if (i === void 0 || i === t) return t;
    if (!xR(i)) throw new TypeError("conditions must return a schema object");
    return i.resolve(n);
  }
}
function wR(e) {
  return e == null ? [] : [].concat(e);
}
function Xy() {
  return Xy = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Xy.apply(this, arguments);
}
let Jpe = /\$\{\s*(\w+)\s*\}/g;
class ki extends Error {
  static formatError(t, n) {
    const r = n.label || n.path || "this";
    return r !== n.path && (n = Xy({}, n, {
      path: r
    })), typeof t == "string" ? t.replace(Jpe, (i, a) => Xc(n[a])) : typeof t == "function" ? t(n) : t;
  }
  static isError(t) {
    return t && t.name === "ValidationError";
  }
  constructor(t, n, r, i) {
    super(), this.value = void 0, this.path = void 0, this.type = void 0, this.errors = void 0, this.params = void 0, this.inner = void 0, this.name = "ValidationError", this.value = n, this.path = r, this.type = i, this.errors = [], this.inner = [], wR(t).forEach((a) => {
      ki.isError(a) ? (this.errors.push(...a.errors), this.inner = this.inner.concat(a.inner.length ? a.inner : a)) : this.errors.push(a);
    }), this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0], Error.captureStackTrace && Error.captureStackTrace(this, ki);
  }
}
const eme = (e) => {
  let t = !1;
  return (...n) => {
    t || (t = !0, e(...n));
  };
};
function Zy(e, t) {
  let {
    endEarly: n,
    tests: r,
    args: i,
    value: a,
    errors: s,
    sort: o,
    path: l
  } = e, c = eme(t), f = r.length;
  const h = [];
  if (s = s || [], !f) return s.length ? c(new ki(s, a, l)) : c(null, a);
  for (let p = 0; p < r.length; p++) {
    const g = r[p];
    g(i, function(y) {
      if (y) {
        if (!ki.isError(y))
          return c(y, a);
        if (n)
          return y.value = a, c(y, a);
        h.push(y);
      }
      if (--f <= 0) {
        if (h.length && (o && h.sort(o), s.length && h.push(...s), s = h), s.length) {
          c(new ki(s, a, l), a);
          return;
        }
        c(null, a);
      }
    });
  }
}
var pb, AD;
function tme() {
  if (AD) return pb;
  AD = 1;
  var e = pl(), t = (function() {
    try {
      var n = e(Object, "defineProperty");
      return n({}, "", {}), n;
    } catch {
    }
  })();
  return pb = t, pb;
}
var mb, DD;
function kR() {
  if (DD) return mb;
  DD = 1;
  var e = tme();
  function t(n, r, i) {
    r == "__proto__" && e ? e(n, r, {
      configurable: !0,
      enumerable: !0,
      value: i,
      writable: !0
    }) : n[r] = i;
  }
  return mb = t, mb;
}
var gb, ED;
function nme() {
  if (ED) return gb;
  ED = 1;
  function e(t) {
    return function(n, r, i) {
      for (var a = -1, s = Object(n), o = i(n), l = o.length; l--; ) {
        var c = o[t ? l : ++a];
        if (r(s[c], c, s) === !1)
          break;
      }
      return n;
    };
  }
  return gb = e, gb;
}
var vb, PD;
function rme() {
  if (PD) return vb;
  PD = 1;
  var e = nme(), t = e();
  return vb = t, vb;
}
var bb, OD;
function ime() {
  if (OD) return bb;
  OD = 1;
  function e(t, n) {
    for (var r = -1, i = Array(t); ++r < t; )
      i[r] = n(r);
    return i;
  }
  return bb = e, bb;
}
var xc = { exports: {} }, _b, MD;
function ame() {
  if (MD) return _b;
  MD = 1;
  function e() {
    return !1;
  }
  return _b = e, _b;
}
xc.exports;
var ID;
function SR() {
  return ID || (ID = 1, (function(e, t) {
    var n = ms(), r = ame(), i = t && !t.nodeType && t, a = i && !0 && e && !e.nodeType && e, s = a && a.exports === i, o = s ? n.Buffer : void 0, l = o ? o.isBuffer : void 0, c = l || r;
    e.exports = c;
  })(xc, xc.exports)), xc.exports;
}
var yb, RD;
function sme() {
  if (RD) return yb;
  RD = 1;
  var e = wd(), t = Fx(), n = kd(), r = "[object Arguments]", i = "[object Array]", a = "[object Boolean]", s = "[object Date]", o = "[object Error]", l = "[object Function]", c = "[object Map]", f = "[object Number]", h = "[object Object]", p = "[object RegExp]", g = "[object Set]", v = "[object String]", y = "[object WeakMap]", S = "[object ArrayBuffer]", x = "[object DataView]", E = "[object Float32Array]", w = "[object Float64Array]", C = "[object Int8Array]", P = "[object Int16Array]", M = "[object Int32Array]", T = "[object Uint8Array]", N = "[object Uint8ClampedArray]", $ = "[object Uint16Array]", ne = "[object Uint32Array]", Y = {};
  Y[E] = Y[w] = Y[C] = Y[P] = Y[M] = Y[T] = Y[N] = Y[$] = Y[ne] = !0, Y[r] = Y[i] = Y[S] = Y[a] = Y[x] = Y[s] = Y[o] = Y[l] = Y[c] = Y[f] = Y[h] = Y[p] = Y[g] = Y[v] = Y[y] = !1;
  function te(_e) {
    return n(_e) && t(_e.length) && !!Y[e(_e)];
  }
  return yb = te, yb;
}
var xb, FD;
function ome() {
  if (FD) return xb;
  FD = 1;
  function e(t) {
    return function(n) {
      return t(n);
    };
  }
  return xb = e, xb;
}
var wc = { exports: {} };
wc.exports;
var ND;
function lme() {
  return ND || (ND = 1, (function(e, t) {
    var n = hR(), r = t && !t.nodeType && t, i = r && !0 && e && !e.nodeType && e, a = i && i.exports === r, s = a && n.process, o = (function() {
      try {
        var l = i && i.require && i.require("util").types;
        return l || s && s.binding && s.binding("util");
      } catch {
      }
    })();
    e.exports = o;
  })(wc, wc.exports)), wc.exports;
}
var wb, LD;
function CR() {
  if (LD) return wb;
  LD = 1;
  var e = sme(), t = ome(), n = lme(), r = n && n.isTypedArray, i = r ? t(r) : e;
  return wb = i, wb;
}
var kb, $D;
function ume() {
  if ($D) return kb;
  $D = 1;
  var e = ime(), t = bR(), n = co(), r = SR(), i = _R(), a = CR(), s = Object.prototype, o = s.hasOwnProperty;
  function l(c, f) {
    var h = n(c), p = !h && t(c), g = !h && !p && r(c), v = !h && !p && !g && a(c), y = h || p || g || v, S = y ? e(c.length, String) : [], x = S.length;
    for (var E in c)
      (f || o.call(c, E)) && !(y && // Safari 9 has enumerable `arguments.length` in strict mode.
      (E == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      g && (E == "offset" || E == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      v && (E == "buffer" || E == "byteLength" || E == "byteOffset") || // Skip index properties.
      i(E, x))) && S.push(E);
    return S;
  }
  return kb = l, kb;
}
var Sb, VD;
function cme() {
  if (VD) return Sb;
  VD = 1;
  var e = Object.prototype;
  function t(n) {
    var r = n && n.constructor, i = typeof r == "function" && r.prototype || e;
    return n === i;
  }
  return Sb = t, Sb;
}
var Cb, BD;
function dme() {
  if (BD) return Cb;
  BD = 1;
  function e(t, n) {
    return function(r) {
      return t(n(r));
    };
  }
  return Cb = e, Cb;
}
var Tb, UD;
function fme() {
  if (UD) return Tb;
  UD = 1;
  var e = dme(), t = e(Object.keys, Object);
  return Tb = t, Tb;
}
var Ab, qD;
function hme() {
  if (qD) return Ab;
  qD = 1;
  var e = cme(), t = fme(), n = Object.prototype, r = n.hasOwnProperty;
  function i(a) {
    if (!e(a))
      return t(a);
    var s = [];
    for (var o in Object(a))
      r.call(a, o) && o != "constructor" && s.push(o);
    return s;
  }
  return Ab = i, Ab;
}
var Db, jD;
function pme() {
  if (jD) return Db;
  jD = 1;
  var e = pR(), t = Fx();
  function n(r) {
    return r != null && t(r.length) && !e(r);
  }
  return Db = n, Db;
}
var Eb, WD;
function Nx() {
  if (WD) return Eb;
  WD = 1;
  var e = ume(), t = hme(), n = pme();
  function r(i) {
    return n(i) ? e(i) : t(i);
  }
  return Eb = r, Eb;
}
var Pb, zD;
function TR() {
  if (zD) return Pb;
  zD = 1;
  var e = rme(), t = Nx();
  function n(r, i) {
    return r && e(r, i, t);
  }
  return Pb = n, Pb;
}
var Ob, HD;
function mme() {
  if (HD) return Ob;
  HD = 1;
  var e = Hp();
  function t() {
    this.__data__ = new e(), this.size = 0;
  }
  return Ob = t, Ob;
}
var Mb, GD;
function gme() {
  if (GD) return Mb;
  GD = 1;
  function e(t) {
    var n = this.__data__, r = n.delete(t);
    return this.size = n.size, r;
  }
  return Mb = e, Mb;
}
var Ib, YD;
function vme() {
  if (YD) return Ib;
  YD = 1;
  function e(t) {
    return this.__data__.get(t);
  }
  return Ib = e, Ib;
}
var Rb, KD;
function bme() {
  if (KD) return Rb;
  KD = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return Rb = e, Rb;
}
var Fb, XD;
function _me() {
  if (XD) return Fb;
  XD = 1;
  var e = Hp(), t = Ix(), n = Rx(), r = 200;
  function i(a, s) {
    var o = this.__data__;
    if (o instanceof e) {
      var l = o.__data__;
      if (!t || l.length < r - 1)
        return l.push([a, s]), this.size = ++o.size, this;
      o = this.__data__ = new n(l);
    }
    return o.set(a, s), this.size = o.size, this;
  }
  return Fb = i, Fb;
}
var Nb, ZD;
function AR() {
  if (ZD) return Nb;
  ZD = 1;
  var e = Hp(), t = mme(), n = gme(), r = vme(), i = bme(), a = _me();
  function s(o) {
    var l = this.__data__ = new e(o);
    this.size = l.size;
  }
  return s.prototype.clear = t, s.prototype.delete = n, s.prototype.get = r, s.prototype.has = i, s.prototype.set = a, Nb = s, Nb;
}
var Lb, QD;
function yme() {
  if (QD) return Lb;
  QD = 1;
  var e = "__lodash_hash_undefined__";
  function t(n) {
    return this.__data__.set(n, e), this;
  }
  return Lb = t, Lb;
}
var $b, JD;
function xme() {
  if (JD) return $b;
  JD = 1;
  function e(t) {
    return this.__data__.has(t);
  }
  return $b = e, $b;
}
var Vb, eE;
function wme() {
  if (eE) return Vb;
  eE = 1;
  var e = Rx(), t = yme(), n = xme();
  function r(i) {
    var a = -1, s = i == null ? 0 : i.length;
    for (this.__data__ = new e(); ++a < s; )
      this.add(i[a]);
  }
  return r.prototype.add = r.prototype.push = t, r.prototype.has = n, Vb = r, Vb;
}
var Bb, tE;
function kme() {
  if (tE) return Bb;
  tE = 1;
  function e(t, n) {
    for (var r = -1, i = t == null ? 0 : t.length; ++r < i; )
      if (n(t[r], r, t))
        return !0;
    return !1;
  }
  return Bb = e, Bb;
}
var Ub, nE;
function Sme() {
  if (nE) return Ub;
  nE = 1;
  function e(t, n) {
    return t.has(n);
  }
  return Ub = e, Ub;
}
var qb, rE;
function DR() {
  if (rE) return qb;
  rE = 1;
  var e = wme(), t = kme(), n = Sme(), r = 1, i = 2;
  function a(s, o, l, c, f, h) {
    var p = l & r, g = s.length, v = o.length;
    if (g != v && !(p && v > g))
      return !1;
    var y = h.get(s), S = h.get(o);
    if (y && S)
      return y == o && S == s;
    var x = -1, E = !0, w = l & i ? new e() : void 0;
    for (h.set(s, o), h.set(o, s); ++x < g; ) {
      var C = s[x], P = o[x];
      if (c)
        var M = p ? c(P, C, x, o, s, h) : c(C, P, x, s, o, h);
      if (M !== void 0) {
        if (M)
          continue;
        E = !1;
        break;
      }
      if (w) {
        if (!t(o, function(T, N) {
          if (!n(w, N) && (C === T || f(C, T, l, c, h)))
            return w.push(N);
        })) {
          E = !1;
          break;
        }
      } else if (!(C === P || f(C, P, l, c, h))) {
        E = !1;
        break;
      }
    }
    return h.delete(s), h.delete(o), E;
  }
  return qb = a, qb;
}
var jb, iE;
function Cme() {
  if (iE) return jb;
  iE = 1;
  var e = ms(), t = e.Uint8Array;
  return jb = t, jb;
}
var Wb, aE;
function Tme() {
  if (aE) return Wb;
  aE = 1;
  function e(t) {
    var n = -1, r = Array(t.size);
    return t.forEach(function(i, a) {
      r[++n] = [a, i];
    }), r;
  }
  return Wb = e, Wb;
}
var zb, sE;
function Ame() {
  if (sE) return zb;
  sE = 1;
  function e(t) {
    var n = -1, r = Array(t.size);
    return t.forEach(function(i) {
      r[++n] = i;
    }), r;
  }
  return zb = e, zb;
}
var Hb, oE;
function Dme() {
  if (oE) return Hb;
  oE = 1;
  var e = jp(), t = Cme(), n = gR(), r = DR(), i = Tme(), a = Ame(), s = 1, o = 2, l = "[object Boolean]", c = "[object Date]", f = "[object Error]", h = "[object Map]", p = "[object Number]", g = "[object RegExp]", v = "[object Set]", y = "[object String]", S = "[object Symbol]", x = "[object ArrayBuffer]", E = "[object DataView]", w = e ? e.prototype : void 0, C = w ? w.valueOf : void 0;
  function P(M, T, N, $, ne, Y, te) {
    switch (N) {
      case E:
        if (M.byteLength != T.byteLength || M.byteOffset != T.byteOffset)
          return !1;
        M = M.buffer, T = T.buffer;
      case x:
        return !(M.byteLength != T.byteLength || !Y(new t(M), new t(T)));
      case l:
      case c:
      case p:
        return n(+M, +T);
      case f:
        return M.name == T.name && M.message == T.message;
      case g:
      case y:
        return M == T + "";
      case h:
        var _e = i;
      case v:
        var Fe = $ & s;
        if (_e || (_e = a), M.size != T.size && !Fe)
          return !1;
        var J = te.get(M);
        if (J)
          return J == T;
        $ |= o, te.set(M, T);
        var oe = r(_e(M), _e(T), $, ne, Y, te);
        return te.delete(M), oe;
      case S:
        if (C)
          return C.call(M) == C.call(T);
    }
    return !1;
  }
  return Hb = P, Hb;
}
var Gb, lE;
function Eme() {
  if (lE) return Gb;
  lE = 1;
  function e(t, n) {
    for (var r = -1, i = n.length, a = t.length; ++r < i; )
      t[a + r] = n[r];
    return t;
  }
  return Gb = e, Gb;
}
var Yb, uE;
function Pme() {
  if (uE) return Yb;
  uE = 1;
  var e = Eme(), t = co();
  function n(r, i, a) {
    var s = i(r);
    return t(r) ? s : e(s, a(r));
  }
  return Yb = n, Yb;
}
var Kb, cE;
function Ome() {
  if (cE) return Kb;
  cE = 1;
  function e(t, n) {
    for (var r = -1, i = t == null ? 0 : t.length, a = 0, s = []; ++r < i; ) {
      var o = t[r];
      n(o, r, t) && (s[a++] = o);
    }
    return s;
  }
  return Kb = e, Kb;
}
var Xb, dE;
function Mme() {
  if (dE) return Xb;
  dE = 1;
  function e() {
    return [];
  }
  return Xb = e, Xb;
}
var Zb, fE;
function Ime() {
  if (fE) return Zb;
  fE = 1;
  var e = Ome(), t = Mme(), n = Object.prototype, r = n.propertyIsEnumerable, i = Object.getOwnPropertySymbols, a = i ? function(s) {
    return s == null ? [] : (s = Object(s), e(i(s), function(o) {
      return r.call(s, o);
    }));
  } : t;
  return Zb = a, Zb;
}
var Qb, hE;
function Rme() {
  if (hE) return Qb;
  hE = 1;
  var e = Pme(), t = Ime(), n = Nx();
  function r(i) {
    return e(i, n, t);
  }
  return Qb = r, Qb;
}
var Jb, pE;
function Fme() {
  if (pE) return Jb;
  pE = 1;
  var e = Rme(), t = 1, n = Object.prototype, r = n.hasOwnProperty;
  function i(a, s, o, l, c, f) {
    var h = o & t, p = e(a), g = p.length, v = e(s), y = v.length;
    if (g != y && !h)
      return !1;
    for (var S = g; S--; ) {
      var x = p[S];
      if (!(h ? x in s : r.call(s, x)))
        return !1;
    }
    var E = f.get(a), w = f.get(s);
    if (E && w)
      return E == s && w == a;
    var C = !0;
    f.set(a, s), f.set(s, a);
    for (var P = h; ++S < g; ) {
      x = p[S];
      var M = a[x], T = s[x];
      if (l)
        var N = h ? l(T, M, x, s, a, f) : l(M, T, x, a, s, f);
      if (!(N === void 0 ? M === T || c(M, T, o, l, f) : N)) {
        C = !1;
        break;
      }
      P || (P = x == "constructor");
    }
    if (C && !P) {
      var $ = a.constructor, ne = s.constructor;
      $ != ne && "constructor" in a && "constructor" in s && !(typeof $ == "function" && $ instanceof $ && typeof ne == "function" && ne instanceof ne) && (C = !1);
    }
    return f.delete(a), f.delete(s), C;
  }
  return Jb = i, Jb;
}
var e_, mE;
function Nme() {
  if (mE) return e_;
  mE = 1;
  var e = pl(), t = ms(), n = e(t, "DataView");
  return e_ = n, e_;
}
var t_, gE;
function Lme() {
  if (gE) return t_;
  gE = 1;
  var e = pl(), t = ms(), n = e(t, "Promise");
  return t_ = n, t_;
}
var n_, vE;
function $me() {
  if (vE) return n_;
  vE = 1;
  var e = pl(), t = ms(), n = e(t, "Set");
  return n_ = n, n_;
}
var r_, bE;
function Vme() {
  if (bE) return r_;
  bE = 1;
  var e = pl(), t = ms(), n = e(t, "WeakMap");
  return r_ = n, r_;
}
var i_, _E;
function Bme() {
  if (_E) return i_;
  _E = 1;
  var e = Nme(), t = Ix(), n = Lme(), r = $me(), i = Vme(), a = wd(), s = mR(), o = "[object Map]", l = "[object Object]", c = "[object Promise]", f = "[object Set]", h = "[object WeakMap]", p = "[object DataView]", g = s(e), v = s(t), y = s(n), S = s(r), x = s(i), E = a;
  return (e && E(new e(new ArrayBuffer(1))) != p || t && E(new t()) != o || n && E(n.resolve()) != c || r && E(new r()) != f || i && E(new i()) != h) && (E = function(w) {
    var C = a(w), P = C == l ? w.constructor : void 0, M = P ? s(P) : "";
    if (M)
      switch (M) {
        case g:
          return p;
        case v:
          return o;
        case y:
          return c;
        case S:
          return f;
        case x:
          return h;
      }
    return C;
  }), i_ = E, i_;
}
var a_, yE;
function Ume() {
  if (yE) return a_;
  yE = 1;
  var e = AR(), t = DR(), n = Dme(), r = Fme(), i = Bme(), a = co(), s = SR(), o = CR(), l = 1, c = "[object Arguments]", f = "[object Array]", h = "[object Object]", p = Object.prototype, g = p.hasOwnProperty;
  function v(y, S, x, E, w, C) {
    var P = a(y), M = a(S), T = P ? f : i(y), N = M ? f : i(S);
    T = T == c ? h : T, N = N == c ? h : N;
    var $ = T == h, ne = N == h, Y = T == N;
    if (Y && s(y)) {
      if (!s(S))
        return !1;
      P = !0, $ = !1;
    }
    if (Y && !$)
      return C || (C = new e()), P || o(y) ? t(y, S, x, E, w, C) : n(y, S, T, x, E, w, C);
    if (!(x & l)) {
      var te = $ && g.call(y, "__wrapped__"), _e = ne && g.call(S, "__wrapped__");
      if (te || _e) {
        var Fe = te ? y.value() : y, J = _e ? S.value() : S;
        return C || (C = new e()), w(Fe, J, x, E, C);
      }
    }
    return Y ? (C || (C = new e()), r(y, S, x, E, w, C)) : !1;
  }
  return a_ = v, a_;
}
var s_, xE;
function ER() {
  if (xE) return s_;
  xE = 1;
  var e = Ume(), t = kd();
  function n(r, i, a, s, o) {
    return r === i ? !0 : r == null || i == null || !t(r) && !t(i) ? r !== r && i !== i : e(r, i, a, s, n, o);
  }
  return s_ = n, s_;
}
var o_, wE;
function qme() {
  if (wE) return o_;
  wE = 1;
  var e = AR(), t = ER(), n = 1, r = 2;
  function i(a, s, o, l) {
    var c = o.length, f = c, h = !l;
    if (a == null)
      return !f;
    for (a = Object(a); c--; ) {
      var p = o[c];
      if (h && p[2] ? p[1] !== a[p[0]] : !(p[0] in a))
        return !1;
    }
    for (; ++c < f; ) {
      p = o[c];
      var g = p[0], v = a[g], y = p[1];
      if (h && p[2]) {
        if (v === void 0 && !(g in a))
          return !1;
      } else {
        var S = new e();
        if (l)
          var x = l(v, y, g, a, s, S);
        if (!(x === void 0 ? t(y, v, n | r, l, S) : x))
          return !1;
      }
    }
    return !0;
  }
  return o_ = i, o_;
}
var l_, kE;
function PR() {
  if (kE) return l_;
  kE = 1;
  var e = Mx();
  function t(n) {
    return n === n && !e(n);
  }
  return l_ = t, l_;
}
var u_, SE;
function jme() {
  if (SE) return u_;
  SE = 1;
  var e = PR(), t = Nx();
  function n(r) {
    for (var i = t(r), a = i.length; a--; ) {
      var s = i[a], o = r[s];
      i[a] = [s, o, e(o)];
    }
    return i;
  }
  return u_ = n, u_;
}
var c_, CE;
function OR() {
  if (CE) return c_;
  CE = 1;
  function e(t, n) {
    return function(r) {
      return r == null ? !1 : r[t] === n && (n !== void 0 || t in Object(r));
    };
  }
  return c_ = e, c_;
}
var d_, TE;
function Wme() {
  if (TE) return d_;
  TE = 1;
  var e = qme(), t = jme(), n = OR();
  function r(i) {
    var a = t(i);
    return a.length == 1 && a[0][2] ? n(a[0][0], a[0][1]) : function(s) {
      return s === i || e(s, i, a);
    };
  }
  return d_ = r, d_;
}
var f_, AE;
function MR() {
  if (AE) return f_;
  AE = 1;
  var e = vR(), t = Yp();
  function n(r, i) {
    i = e(i, r);
    for (var a = 0, s = i.length; r != null && a < s; )
      r = r[t(i[a++])];
    return a && a == s ? r : void 0;
  }
  return f_ = n, f_;
}
var h_, DE;
function zme() {
  if (DE) return h_;
  DE = 1;
  var e = MR();
  function t(n, r, i) {
    var a = n == null ? void 0 : e(n, r);
    return a === void 0 ? i : a;
  }
  return h_ = t, h_;
}
var p_, EE;
function Hme() {
  if (EE) return p_;
  EE = 1;
  function e(t, n) {
    return t != null && n in Object(t);
  }
  return p_ = e, p_;
}
var m_, PE;
function Gme() {
  if (PE) return m_;
  PE = 1;
  var e = Hme(), t = yR();
  function n(r, i) {
    return r != null && t(r, i, e);
  }
  return m_ = n, m_;
}
var g_, OE;
function Yme() {
  if (OE) return g_;
  OE = 1;
  var e = ER(), t = zme(), n = Gme(), r = Ox(), i = PR(), a = OR(), s = Yp(), o = 1, l = 2;
  function c(f, h) {
    return r(f) && i(h) ? a(s(f), h) : function(p) {
      var g = t(p, f);
      return g === void 0 && g === h ? n(p, f) : e(h, g, o | l);
    };
  }
  return g_ = c, g_;
}
var v_, ME;
function Kme() {
  if (ME) return v_;
  ME = 1;
  function e(t) {
    return t;
  }
  return v_ = e, v_;
}
var b_, IE;
function Xme() {
  if (IE) return b_;
  IE = 1;
  function e(t) {
    return function(n) {
      return n == null ? void 0 : n[t];
    };
  }
  return b_ = e, b_;
}
var __, RE;
function Zme() {
  if (RE) return __;
  RE = 1;
  var e = MR();
  function t(n) {
    return function(r) {
      return e(r, n);
    };
  }
  return __ = t, __;
}
var y_, FE;
function Qme() {
  if (FE) return y_;
  FE = 1;
  var e = Xme(), t = Zme(), n = Ox(), r = Yp();
  function i(a) {
    return n(a) ? e(r(a)) : t(a);
  }
  return y_ = i, y_;
}
var x_, NE;
function IR() {
  if (NE) return x_;
  NE = 1;
  var e = Wme(), t = Yme(), n = Kme(), r = co(), i = Qme();
  function a(s) {
    return typeof s == "function" ? s : s == null ? n : typeof s == "object" ? r(s) ? t(s[0], s[1]) : e(s) : i(s);
  }
  return x_ = a, x_;
}
var w_, LE;
function Jme() {
  if (LE) return w_;
  LE = 1;
  var e = kR(), t = TR(), n = IR();
  function r(i, a) {
    var s = {};
    return a = n(a, 3), t(i, function(o, l, c) {
      e(s, l, a(o, l, c));
    }), s;
  }
  return w_ = r, w_;
}
var ege = Jme();
const RR = /* @__PURE__ */ hl(ege);
var k_, $E;
function tge() {
  if ($E) return k_;
  $E = 1;
  function e(x) {
    this._maxSize = x, this.clear();
  }
  e.prototype.clear = function() {
    this._size = 0, this._values = /* @__PURE__ */ Object.create(null);
  }, e.prototype.get = function(x) {
    return this._values[x];
  }, e.prototype.set = function(x, E) {
    return this._size >= this._maxSize && this.clear(), x in this._values || this._size++, this._values[x] = E;
  };
  var t = /[^.^\]^[]+|(?=\[\]|\.\.)/g, n = /^\d+$/, r = /^\d/, i = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g, a = /^\s*(['"]?)(.*?)(\1)\s*$/, s = 512, o = new e(s), l = new e(s), c = new e(s);
  k_ = {
    Cache: e,
    split: h,
    normalizePath: f,
    setter: function(x) {
      var E = f(x);
      return l.get(x) || l.set(x, function(C, P) {
        for (var M = 0, T = E.length, N = C; M < T - 1; ) {
          var $ = E[M];
          if ($ === "__proto__" || $ === "constructor" || $ === "prototype")
            return C;
          N = N[E[M++]];
        }
        N[E[M]] = P;
      });
    },
    getter: function(x, E) {
      var w = f(x);
      return c.get(x) || c.set(x, function(P) {
        for (var M = 0, T = w.length; M < T; )
          if (P != null || !E) P = P[w[M++]];
          else return;
        return P;
      });
    },
    join: function(x) {
      return x.reduce(function(E, w) {
        return E + (g(w) || n.test(w) ? "[" + w + "]" : (E ? "." : "") + w);
      }, "");
    },
    forEach: function(x, E, w) {
      p(Array.isArray(x) ? x : h(x), E, w);
    }
  };
  function f(x) {
    return o.get(x) || o.set(
      x,
      h(x).map(function(E) {
        return E.replace(a, "$2");
      })
    );
  }
  function h(x) {
    return x.match(t) || [""];
  }
  function p(x, E, w) {
    var C = x.length, P, M, T, N;
    for (M = 0; M < C; M++)
      P = x[M], P && (S(P) && (P = '"' + P + '"'), N = g(P), T = !N && /^\d+$/.test(P), E.call(w, P, N, T, M, x));
  }
  function g(x) {
    return typeof x == "string" && x && ["'", '"'].indexOf(x.charAt(0)) !== -1;
  }
  function v(x) {
    return x.match(r) && !x.match(n);
  }
  function y(x) {
    return i.test(x);
  }
  function S(x) {
    return !g(x) && (v(x) || y(x));
  }
  return k_;
}
var Kp = tge();
const nh = {
  context: "$",
  value: "."
};
class Ks {
  constructor(t, n = {}) {
    if (this.key = void 0, this.isContext = void 0, this.isValue = void 0, this.isSibling = void 0, this.path = void 0, this.getter = void 0, this.map = void 0, typeof t != "string") throw new TypeError("ref must be a string, got: " + t);
    if (this.key = t.trim(), t === "") throw new TypeError("ref must be a non-empty string");
    this.isContext = this.key[0] === nh.context, this.isValue = this.key[0] === nh.value, this.isSibling = !this.isContext && !this.isValue;
    let r = this.isContext ? nh.context : this.isValue ? nh.value : "";
    this.path = this.key.slice(r.length), this.getter = this.path && Kp.getter(this.path, !0), this.map = n.map;
  }
  getValue(t, n, r) {
    let i = this.isContext ? r : this.isValue ? t : n;
    return this.getter && (i = this.getter(i || {})), this.map && (i = this.map(i)), i;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */
  cast(t, n) {
    return this.getValue(t, n == null ? void 0 : n.parent, n == null ? void 0 : n.context);
  }
  resolve() {
    return this;
  }
  describe() {
    return {
      type: "ref",
      key: this.key
    };
  }
  toString() {
    return `Ref(${this.key})`;
  }
  static isRef(t) {
    return t && t.__isYupRef;
  }
}
Ks.prototype.__isYupRef = !0;
function Jh() {
  return Jh = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Jh.apply(this, arguments);
}
function nge(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), i, a;
  for (a = 0; a < r.length; a++)
    i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function rh(e) {
  function t(n, r) {
    let {
      value: i,
      path: a = "",
      label: s,
      options: o,
      originalValue: l,
      sync: c
    } = n, f = nge(n, ["value", "path", "label", "options", "originalValue", "sync"]);
    const {
      name: h,
      test: p,
      params: g,
      message: v
    } = e;
    let {
      parent: y,
      context: S
    } = o;
    function x(M) {
      return Ks.isRef(M) ? M.getValue(i, y, S) : M;
    }
    function E(M = {}) {
      const T = RR(Jh({
        value: i,
        originalValue: l,
        label: s,
        path: M.path || a
      }, g, M.params), x), N = new ki(ki.formatError(M.message || v, T), i, T.path, M.type || h);
      return N.params = T, N;
    }
    let w = Jh({
      path: a,
      parent: y,
      type: h,
      createError: E,
      resolve: x,
      options: o,
      originalValue: l
    }, f);
    if (!c) {
      try {
        Promise.resolve(p.call(w, i, w)).then((M) => {
          ki.isError(M) ? r(M) : M ? r(null, M) : r(E());
        }).catch(r);
      } catch (M) {
        r(M);
      }
      return;
    }
    let C;
    try {
      var P;
      if (C = p.call(w, i, w), typeof ((P = C) == null ? void 0 : P.then) == "function")
        throw new Error(`Validation test of type: "${w.type}" returned a Promise during a synchronous validate. This test will finish after the validate call has returned`);
    } catch (M) {
      r(M);
      return;
    }
    ki.isError(C) ? r(C) : C ? r(null, C) : r(E());
  }
  return t.OPTIONS = e, t;
}
let rge = (e) => e.substr(0, e.length - 1).substr(1);
function ige(e, t, n, r = n) {
  let i, a, s;
  return t ? (Kp.forEach(t, (o, l, c) => {
    let f = l ? rge(o) : o;
    if (e = e.resolve({
      context: r,
      parent: i,
      value: n
    }), e.innerType) {
      let h = c ? parseInt(f, 10) : 0;
      if (n && h >= n.length)
        throw new Error(`Yup.reach cannot resolve an array item at index: ${o}, in the path: ${t}. because there is no value at that index. `);
      i = n, n = n && n[h], e = e.innerType;
    }
    if (!c) {
      if (!e.fields || !e.fields[f]) throw new Error(`The schema does not contain the path: ${t}. (failed at: ${s} which is a type: "${e._type}")`);
      i = n, n = n && n[f], e = e.fields[f];
    }
    a = f, s = l ? "[" + o + "]" : "." + o;
  }), {
    schema: e,
    parent: i,
    parentPath: a
  }) : {
    parent: i,
    parentPath: t,
    schema: e
  };
}
class ep {
  constructor() {
    this.list = void 0, this.refs = void 0, this.list = /* @__PURE__ */ new Set(), this.refs = /* @__PURE__ */ new Map();
  }
  get size() {
    return this.list.size + this.refs.size;
  }
  describe() {
    const t = [];
    for (const n of this.list) t.push(n);
    for (const [, n] of this.refs) t.push(n.describe());
    return t;
  }
  toArray() {
    return Array.from(this.list).concat(Array.from(this.refs.values()));
  }
  resolveAll(t) {
    return this.toArray().reduce((n, r) => n.concat(Ks.isRef(r) ? t(r) : r), []);
  }
  add(t) {
    Ks.isRef(t) ? this.refs.set(t.key, t) : this.list.add(t);
  }
  delete(t) {
    Ks.isRef(t) ? this.refs.delete(t.key) : this.list.delete(t);
  }
  clone() {
    const t = new ep();
    return t.list = new Set(this.list), t.refs = new Map(this.refs), t;
  }
  merge(t, n) {
    const r = this.clone();
    return t.list.forEach((i) => r.add(i)), t.refs.forEach((i) => r.add(i)), n.list.forEach((i) => r.delete(i)), n.refs.forEach((i) => r.delete(i)), r;
  }
}
function Bi() {
  return Bi = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Bi.apply(this, arguments);
}
class oi {
  constructor(t) {
    this.deps = [], this.tests = void 0, this.transforms = void 0, this.conditions = [], this._mutate = void 0, this._typeError = void 0, this._whitelist = new ep(), this._blacklist = new ep(), this.exclusiveTests = /* @__PURE__ */ Object.create(null), this.spec = void 0, this.tests = [], this.transforms = [], this.withMutation(() => {
      this.typeError(Fo.notType);
    }), this.type = (t == null ? void 0 : t.type) || "mixed", this.spec = Bi({
      strip: !1,
      strict: !1,
      abortEarly: !0,
      recursive: !0,
      nullable: !1,
      presence: "optional"
    }, t == null ? void 0 : t.spec);
  }
  // TODO: remove
  get _type() {
    return this.type;
  }
  _typeCheck(t) {
    return !0;
  }
  clone(t) {
    if (this._mutate)
      return t && Object.assign(this.spec, t), this;
    const n = Object.create(Object.getPrototypeOf(this));
    return n.type = this.type, n._typeError = this._typeError, n._whitelistError = this._whitelistError, n._blacklistError = this._blacklistError, n._whitelist = this._whitelist.clone(), n._blacklist = this._blacklist.clone(), n.exclusiveTests = Bi({}, this.exclusiveTests), n.deps = [...this.deps], n.conditions = [...this.conditions], n.tests = [...this.tests], n.transforms = [...this.transforms], n.spec = Gy(Bi({}, this.spec, t)), n;
  }
  label(t) {
    let n = this.clone();
    return n.spec.label = t, n;
  }
  meta(...t) {
    if (t.length === 0) return this.spec.meta;
    let n = this.clone();
    return n.spec.meta = Object.assign(n.spec.meta || {}, t[0]), n;
  }
  // withContext<TContext extends AnyObject>(): BaseSchema<
  //   TCast,
  //   TContext,
  //   TOutput
  // > {
  //   return this as any;
  // }
  withMutation(t) {
    let n = this._mutate;
    this._mutate = !0;
    let r = t(this);
    return this._mutate = n, r;
  }
  concat(t) {
    if (!t || t === this) return this;
    if (t.type !== this.type && this.type !== "mixed") throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${t.type}`);
    let n = this, r = t.clone();
    const i = Bi({}, n.spec, r.spec);
    return r.spec = i, r._typeError || (r._typeError = n._typeError), r._whitelistError || (r._whitelistError = n._whitelistError), r._blacklistError || (r._blacklistError = n._blacklistError), r._whitelist = n._whitelist.merge(t._whitelist, t._blacklist), r._blacklist = n._blacklist.merge(t._blacklist, t._whitelist), r.tests = n.tests, r.exclusiveTests = n.exclusiveTests, r.withMutation((a) => {
      t.tests.forEach((s) => {
        a.test(s.OPTIONS);
      });
    }), r.transforms = [...n.transforms, ...r.transforms], r;
  }
  isType(t) {
    return this.spec.nullable && t === null ? !0 : this._typeCheck(t);
  }
  resolve(t) {
    let n = this;
    if (n.conditions.length) {
      let r = n.conditions;
      n = n.clone(), n.conditions = [], n = r.reduce((i, a) => a.resolve(i, t), n), n = n.resolve(t);
    }
    return n;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {*=} options.parent
   * @param {*=} options.context
   */
  cast(t, n = {}) {
    let r = this.resolve(Bi({
      value: t
    }, n)), i = r._cast(t, n);
    if (t !== void 0 && n.assert !== !1 && r.isType(i) !== !0) {
      let a = Xc(t), s = Xc(i);
      throw new TypeError(`The value of ${n.path || "field"} could not be cast to a value that satisfies the schema type: "${r._type}". 

attempted value: ${a} 
` + (s !== a ? `result of cast: ${s}` : ""));
    }
    return i;
  }
  _cast(t, n) {
    let r = t === void 0 ? t : this.transforms.reduce((i, a) => a.call(this, i, t, this), t);
    return r === void 0 && (r = this.getDefault()), r;
  }
  _validate(t, n = {}, r) {
    let {
      sync: i,
      path: a,
      from: s = [],
      originalValue: o = t,
      strict: l = this.spec.strict,
      abortEarly: c = this.spec.abortEarly
    } = n, f = t;
    l || (f = this._cast(f, Bi({
      assert: !1
    }, n)));
    let h = {
      value: f,
      path: a,
      options: n,
      originalValue: o,
      schema: this,
      label: this.spec.label,
      sync: i,
      from: s
    }, p = [];
    this._typeError && p.push(this._typeError);
    let g = [];
    this._whitelistError && g.push(this._whitelistError), this._blacklistError && g.push(this._blacklistError), Zy({
      args: h,
      value: f,
      path: a,
      tests: p,
      endEarly: c
    }, (v) => {
      if (v) return void r(v, f);
      Zy({
        tests: this.tests.concat(g),
        args: h,
        path: a,
        sync: i,
        value: f,
        endEarly: c
      }, r);
    });
  }
  validate(t, n, r) {
    let i = this.resolve(Bi({}, n, {
      value: t
    }));
    return typeof r == "function" ? i._validate(t, n, r) : new Promise((a, s) => i._validate(t, n, (o, l) => {
      o ? s(o) : a(l);
    }));
  }
  validateSync(t, n) {
    let r = this.resolve(Bi({}, n, {
      value: t
    })), i;
    return r._validate(t, Bi({}, n, {
      sync: !0
    }), (a, s) => {
      if (a) throw a;
      i = s;
    }), i;
  }
  isValid(t, n) {
    return this.validate(t, n).then(() => !0, (r) => {
      if (ki.isError(r)) return !1;
      throw r;
    });
  }
  isValidSync(t, n) {
    try {
      return this.validateSync(t, n), !0;
    } catch (r) {
      if (ki.isError(r)) return !1;
      throw r;
    }
  }
  _getDefault() {
    let t = this.spec.default;
    return t == null ? t : typeof t == "function" ? t.call(this) : Gy(t);
  }
  getDefault(t) {
    return this.resolve(t || {})._getDefault();
  }
  default(t) {
    return arguments.length === 0 ? this._getDefault() : this.clone({
      default: t
    });
  }
  strict(t = !0) {
    let n = this.clone();
    return n.spec.strict = t, n;
  }
  _isPresent(t) {
    return t != null;
  }
  defined(t = Fo.defined) {
    return this.test({
      message: t,
      name: "defined",
      exclusive: !0,
      test(n) {
        return n !== void 0;
      }
    });
  }
  required(t = Fo.required) {
    return this.clone({
      presence: "required"
    }).withMutation((n) => n.test({
      message: t,
      name: "required",
      exclusive: !0,
      test(r) {
        return this.schema._isPresent(r);
      }
    }));
  }
  notRequired() {
    let t = this.clone({
      presence: "optional"
    });
    return t.tests = t.tests.filter((n) => n.OPTIONS.name !== "required"), t;
  }
  nullable(t = !0) {
    return this.clone({
      nullable: t !== !1
    });
  }
  transform(t) {
    let n = this.clone();
    return n.transforms.push(t), n;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */
  test(...t) {
    let n;
    if (t.length === 1 ? typeof t[0] == "function" ? n = {
      test: t[0]
    } : n = t[0] : t.length === 2 ? n = {
      name: t[0],
      test: t[1]
    } : n = {
      name: t[0],
      message: t[1],
      test: t[2]
    }, n.message === void 0 && (n.message = Fo.default), typeof n.test != "function") throw new TypeError("`test` is a required parameters");
    let r = this.clone(), i = rh(n), a = n.exclusive || n.name && r.exclusiveTests[n.name] === !0;
    if (n.exclusive && !n.name)
      throw new TypeError("Exclusive tests must provide a unique `name` identifying the test");
    return n.name && (r.exclusiveTests[n.name] = !!n.exclusive), r.tests = r.tests.filter((s) => !(s.OPTIONS.name === n.name && (a || s.OPTIONS.test === i.OPTIONS.test))), r.tests.push(i), r;
  }
  when(t, n) {
    !Array.isArray(t) && typeof t != "string" && (n = t, t = ".");
    let r = this.clone(), i = wR(t).map((a) => new Ks(a));
    return i.forEach((a) => {
      a.isSibling && r.deps.push(a.key);
    }), r.conditions.push(new Qpe(i, n)), r;
  }
  typeError(t) {
    let n = this.clone();
    return n._typeError = rh({
      message: t,
      name: "typeError",
      test(r) {
        return r !== void 0 && !this.schema.isType(r) ? this.createError({
          params: {
            type: this.schema._type
          }
        }) : !0;
      }
    }), n;
  }
  oneOf(t, n = Fo.oneOf) {
    let r = this.clone();
    return t.forEach((i) => {
      r._whitelist.add(i), r._blacklist.delete(i);
    }), r._whitelistError = rh({
      message: n,
      name: "oneOf",
      test(i) {
        if (i === void 0) return !0;
        let a = this.schema._whitelist, s = a.resolveAll(this.resolve);
        return s.includes(i) ? !0 : this.createError({
          params: {
            values: a.toArray().join(", "),
            resolved: s
          }
        });
      }
    }), r;
  }
  notOneOf(t, n = Fo.notOneOf) {
    let r = this.clone();
    return t.forEach((i) => {
      r._blacklist.add(i), r._whitelist.delete(i);
    }), r._blacklistError = rh({
      message: n,
      name: "notOneOf",
      test(i) {
        let a = this.schema._blacklist, s = a.resolveAll(this.resolve);
        return s.includes(i) ? this.createError({
          params: {
            values: a.toArray().join(", "),
            resolved: s
          }
        }) : !0;
      }
    }), r;
  }
  strip(t = !0) {
    let n = this.clone();
    return n.spec.strip = t, n;
  }
  describe() {
    const t = this.clone(), {
      label: n,
      meta: r
    } = t.spec;
    return {
      meta: r,
      label: n,
      type: t.type,
      oneOf: t._whitelist.describe(),
      notOneOf: t._blacklist.describe(),
      tests: t.tests.map((a) => ({
        name: a.OPTIONS.name,
        params: a.OPTIONS.params
      })).filter((a, s, o) => o.findIndex((l) => l.name === a.name) === s)
    };
  }
}
oi.prototype.__isYupSchema__ = !0;
for (const e of ["validate", "validateSync"]) oi.prototype[`${e}At`] = function(t, n, r = {}) {
  const {
    parent: i,
    parentPath: a,
    schema: s
  } = ige(this, t, n, r.context);
  return s[e](i && i[a], Bi({}, r, {
    parent: i,
    path: t
  }));
};
for (const e of ["equals", "is"]) oi.prototype[e] = oi.prototype.oneOf;
for (const e of ["not", "nope"]) oi.prototype[e] = oi.prototype.notOneOf;
oi.prototype.optional = oi.prototype.notRequired;
const hr = (e) => e == null;
let age = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i, sge = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i, oge = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i, lge = (e) => hr(e) || e === e.trim(), uge = {}.toString();
function Qy() {
  return new FR();
}
class FR extends oi {
  constructor() {
    super({
      type: "string"
    }), this.withMutation(() => {
      this.transform(function(t) {
        if (this.isType(t) || Array.isArray(t)) return t;
        const n = t != null && t.toString ? t.toString() : t;
        return n === uge ? t : n;
      });
    });
  }
  _typeCheck(t) {
    return t instanceof String && (t = t.valueOf()), typeof t == "string";
  }
  _isPresent(t) {
    return super._isPresent(t) && !!t.length;
  }
  length(t, n = ia.length) {
    return this.test({
      message: n,
      name: "length",
      exclusive: !0,
      params: {
        length: t
      },
      test(r) {
        return hr(r) || r.length === this.resolve(t);
      }
    });
  }
  min(t, n = ia.min) {
    return this.test({
      message: n,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test(r) {
        return hr(r) || r.length >= this.resolve(t);
      }
    });
  }
  max(t, n = ia.max) {
    return this.test({
      name: "max",
      exclusive: !0,
      message: n,
      params: {
        max: t
      },
      test(r) {
        return hr(r) || r.length <= this.resolve(t);
      }
    });
  }
  matches(t, n) {
    let r = !1, i, a;
    return n && (typeof n == "object" ? {
      excludeEmptyString: r = !1,
      message: i,
      name: a
    } = n : i = n), this.test({
      name: a || "matches",
      message: i || ia.matches,
      params: {
        regex: t
      },
      test: (s) => hr(s) || s === "" && r || s.search(t) !== -1
    });
  }
  email(t = ia.email) {
    return this.matches(age, {
      name: "email",
      message: t,
      excludeEmptyString: !0
    });
  }
  url(t = ia.url) {
    return this.matches(sge, {
      name: "url",
      message: t,
      excludeEmptyString: !0
    });
  }
  uuid(t = ia.uuid) {
    return this.matches(oge, {
      name: "uuid",
      message: t,
      excludeEmptyString: !1
    });
  }
  //-- transforms --
  ensure() {
    return this.default("").transform((t) => t === null ? "" : t);
  }
  trim(t = ia.trim) {
    return this.transform((n) => n != null ? n.trim() : n).test({
      message: t,
      name: "trim",
      test: lge
    });
  }
  lowercase(t = ia.lowercase) {
    return this.transform((n) => hr(n) ? n : n.toLowerCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      test: (n) => hr(n) || n === n.toLowerCase()
    });
  }
  uppercase(t = ia.uppercase) {
    return this.transform((n) => hr(n) ? n : n.toUpperCase()).test({
      message: t,
      name: "string_case",
      exclusive: !0,
      test: (n) => hr(n) || n === n.toUpperCase()
    });
  }
}
Qy.prototype = FR.prototype;
let cge = (e) => e != +e;
function mh() {
  return new NR();
}
class NR extends oi {
  constructor() {
    super({
      type: "number"
    }), this.withMutation(() => {
      this.transform(function(t) {
        let n = t;
        if (typeof n == "string") {
          if (n = n.replace(/\s/g, ""), n === "") return NaN;
          n = +n;
        }
        return this.isType(n) ? n : parseFloat(n);
      });
    });
  }
  _typeCheck(t) {
    return t instanceof Number && (t = t.valueOf()), typeof t == "number" && !cge(t);
  }
  min(t, n = $s.min) {
    return this.test({
      message: n,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test(r) {
        return hr(r) || r >= this.resolve(t);
      }
    });
  }
  max(t, n = $s.max) {
    return this.test({
      message: n,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      test(r) {
        return hr(r) || r <= this.resolve(t);
      }
    });
  }
  lessThan(t, n = $s.lessThan) {
    return this.test({
      message: n,
      name: "max",
      exclusive: !0,
      params: {
        less: t
      },
      test(r) {
        return hr(r) || r < this.resolve(t);
      }
    });
  }
  moreThan(t, n = $s.moreThan) {
    return this.test({
      message: n,
      name: "min",
      exclusive: !0,
      params: {
        more: t
      },
      test(r) {
        return hr(r) || r > this.resolve(t);
      }
    });
  }
  positive(t = $s.positive) {
    return this.moreThan(0, t);
  }
  negative(t = $s.negative) {
    return this.lessThan(0, t);
  }
  integer(t = $s.integer) {
    return this.test({
      name: "integer",
      message: t,
      test: (n) => hr(n) || Number.isInteger(n)
    });
  }
  truncate() {
    return this.transform((t) => hr(t) ? t : t | 0);
  }
  round(t) {
    var n;
    let r = ["ceil", "floor", "round", "trunc"];
    if (t = ((n = t) == null ? void 0 : n.toLowerCase()) || "round", t === "trunc") return this.truncate();
    if (r.indexOf(t.toLowerCase()) === -1) throw new TypeError("Only valid options for round() are: " + r.join(", "));
    return this.transform((i) => hr(i) ? i : Math[t](i));
  }
}
mh.prototype = NR.prototype;
var dge = /^(\d{4}|[+\-]\d{6})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:[ T]?(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
function fge(e) {
  var t = [1, 4, 5, 6, 7, 10, 11], n = 0, r, i;
  if (i = dge.exec(e)) {
    for (var a = 0, s; s = t[a]; ++a) i[s] = +i[s] || 0;
    i[2] = (+i[2] || 1) - 1, i[3] = +i[3] || 1, i[7] = i[7] ? String(i[7]).substr(0, 3) : 0, (i[8] === void 0 || i[8] === "") && (i[9] === void 0 || i[9] === "") ? r = +new Date(i[1], i[2], i[3], i[4], i[5], i[6], i[7]) : (i[8] !== "Z" && i[9] !== void 0 && (n = i[10] * 60 + i[11], i[9] === "+" && (n = 0 - n)), r = Date.UTC(i[1], i[2], i[3], i[4], i[5] + n, i[6], i[7]));
  } else r = Date.parse ? Date.parse(e) : NaN;
  return r;
}
let LR = /* @__PURE__ */ new Date(""), hge = (e) => Object.prototype.toString.call(e) === "[object Date]";
class pge extends oi {
  constructor() {
    super({
      type: "date"
    }), this.withMutation(() => {
      this.transform(function(t) {
        return this.isType(t) ? t : (t = fge(t), isNaN(t) ? LR : new Date(t));
      });
    });
  }
  _typeCheck(t) {
    return hge(t) && !isNaN(t.getTime());
  }
  prepareParam(t, n) {
    let r;
    if (Ks.isRef(t))
      r = t;
    else {
      let i = this.cast(t);
      if (!this._typeCheck(i)) throw new TypeError(`\`${n}\` must be a Date or a value that can be \`cast()\` to a Date`);
      r = i;
    }
    return r;
  }
  min(t, n = Yy.min) {
    let r = this.prepareParam(t, "min");
    return this.test({
      message: n,
      name: "min",
      exclusive: !0,
      params: {
        min: t
      },
      test(i) {
        return hr(i) || i >= this.resolve(r);
      }
    });
  }
  max(t, n = Yy.max) {
    let r = this.prepareParam(t, "max");
    return this.test({
      message: n,
      name: "max",
      exclusive: !0,
      params: {
        max: t
      },
      test(i) {
        return hr(i) || i <= this.resolve(r);
      }
    });
  }
}
pge.INVALID_DATE = LR;
var S_, VE;
function mge() {
  if (VE) return S_;
  VE = 1;
  function e(t, n, r, i) {
    var a = -1, s = t == null ? 0 : t.length;
    for (i && s && (r = t[++a]); ++a < s; )
      r = n(r, t[a], a, t);
    return r;
  }
  return S_ = e, S_;
}
var C_, BE;
function gge() {
  if (BE) return C_;
  BE = 1;
  function e(t) {
    return function(n) {
      return t == null ? void 0 : t[n];
    };
  }
  return C_ = e, C_;
}
var T_, UE;
function vge() {
  if (UE) return T_;
  UE = 1;
  var e = gge(), t = {
    // Latin-1 Supplement block.
    À: "A",
    Á: "A",
    Â: "A",
    Ã: "A",
    Ä: "A",
    Å: "A",
    à: "a",
    á: "a",
    â: "a",
    ã: "a",
    ä: "a",
    å: "a",
    Ç: "C",
    ç: "c",
    Ð: "D",
    ð: "d",
    È: "E",
    É: "E",
    Ê: "E",
    Ë: "E",
    è: "e",
    é: "e",
    ê: "e",
    ë: "e",
    Ì: "I",
    Í: "I",
    Î: "I",
    Ï: "I",
    ì: "i",
    í: "i",
    î: "i",
    ï: "i",
    Ñ: "N",
    ñ: "n",
    Ò: "O",
    Ó: "O",
    Ô: "O",
    Õ: "O",
    Ö: "O",
    Ø: "O",
    ò: "o",
    ó: "o",
    ô: "o",
    õ: "o",
    ö: "o",
    ø: "o",
    Ù: "U",
    Ú: "U",
    Û: "U",
    Ü: "U",
    ù: "u",
    ú: "u",
    û: "u",
    ü: "u",
    Ý: "Y",
    ý: "y",
    ÿ: "y",
    Æ: "Ae",
    æ: "ae",
    Þ: "Th",
    þ: "th",
    ß: "ss",
    // Latin Extended-A block.
    Ā: "A",
    Ă: "A",
    Ą: "A",
    ā: "a",
    ă: "a",
    ą: "a",
    Ć: "C",
    Ĉ: "C",
    Ċ: "C",
    Č: "C",
    ć: "c",
    ĉ: "c",
    ċ: "c",
    č: "c",
    Ď: "D",
    Đ: "D",
    ď: "d",
    đ: "d",
    Ē: "E",
    Ĕ: "E",
    Ė: "E",
    Ę: "E",
    Ě: "E",
    ē: "e",
    ĕ: "e",
    ė: "e",
    ę: "e",
    ě: "e",
    Ĝ: "G",
    Ğ: "G",
    Ġ: "G",
    Ģ: "G",
    ĝ: "g",
    ğ: "g",
    ġ: "g",
    ģ: "g",
    Ĥ: "H",
    Ħ: "H",
    ĥ: "h",
    ħ: "h",
    Ĩ: "I",
    Ī: "I",
    Ĭ: "I",
    Į: "I",
    İ: "I",
    ĩ: "i",
    ī: "i",
    ĭ: "i",
    į: "i",
    ı: "i",
    Ĵ: "J",
    ĵ: "j",
    Ķ: "K",
    ķ: "k",
    ĸ: "k",
    Ĺ: "L",
    Ļ: "L",
    Ľ: "L",
    Ŀ: "L",
    Ł: "L",
    ĺ: "l",
    ļ: "l",
    ľ: "l",
    ŀ: "l",
    ł: "l",
    Ń: "N",
    Ņ: "N",
    Ň: "N",
    Ŋ: "N",
    ń: "n",
    ņ: "n",
    ň: "n",
    ŋ: "n",
    Ō: "O",
    Ŏ: "O",
    Ő: "O",
    ō: "o",
    ŏ: "o",
    ő: "o",
    Ŕ: "R",
    Ŗ: "R",
    Ř: "R",
    ŕ: "r",
    ŗ: "r",
    ř: "r",
    Ś: "S",
    Ŝ: "S",
    Ş: "S",
    Š: "S",
    ś: "s",
    ŝ: "s",
    ş: "s",
    š: "s",
    Ţ: "T",
    Ť: "T",
    Ŧ: "T",
    ţ: "t",
    ť: "t",
    ŧ: "t",
    Ũ: "U",
    Ū: "U",
    Ŭ: "U",
    Ů: "U",
    Ű: "U",
    Ų: "U",
    ũ: "u",
    ū: "u",
    ŭ: "u",
    ů: "u",
    ű: "u",
    ų: "u",
    Ŵ: "W",
    ŵ: "w",
    Ŷ: "Y",
    ŷ: "y",
    Ÿ: "Y",
    Ź: "Z",
    Ż: "Z",
    Ž: "Z",
    ź: "z",
    ż: "z",
    ž: "z",
    Ĳ: "IJ",
    ĳ: "ij",
    Œ: "Oe",
    œ: "oe",
    ŉ: "'n",
    ſ: "s"
  }, n = e(t);
  return T_ = n, T_;
}
var A_, qE;
function bge() {
  if (qE) return A_;
  qE = 1;
  var e = vge(), t = Sd(), n = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, r = "\\u0300-\\u036f", i = "\\ufe20-\\ufe2f", a = "\\u20d0-\\u20ff", s = r + i + a, o = "[" + s + "]", l = RegExp(o, "g");
  function c(f) {
    return f = t(f), f && f.replace(n, e).replace(l, "");
  }
  return A_ = c, A_;
}
var D_, jE;
function _ge() {
  if (jE) return D_;
  jE = 1;
  var e = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
  function t(n) {
    return n.match(e) || [];
  }
  return D_ = t, D_;
}
var E_, WE;
function yge() {
  if (WE) return E_;
  WE = 1;
  var e = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
  function t(n) {
    return e.test(n);
  }
  return E_ = t, E_;
}
var P_, zE;
function xge() {
  if (zE) return P_;
  zE = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", n = "\\ufe20-\\ufe2f", r = "\\u20d0-\\u20ff", i = t + n + r, a = "\\u2700-\\u27bf", s = "a-z\\xdf-\\xf6\\xf8-\\xff", o = "\\xac\\xb1\\xd7\\xf7", l = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", c = "\\u2000-\\u206f", f = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", h = "A-Z\\xc0-\\xd6\\xd8-\\xde", p = "\\ufe0e\\ufe0f", g = o + l + c + f, v = "['’]", y = "[" + g + "]", S = "[" + i + "]", x = "\\d+", E = "[" + a + "]", w = "[" + s + "]", C = "[^" + e + g + x + a + s + h + "]", P = "\\ud83c[\\udffb-\\udfff]", M = "(?:" + S + "|" + P + ")", T = "[^" + e + "]", N = "(?:\\ud83c[\\udde6-\\uddff]){2}", $ = "[\\ud800-\\udbff][\\udc00-\\udfff]", ne = "[" + h + "]", Y = "\\u200d", te = "(?:" + w + "|" + C + ")", _e = "(?:" + ne + "|" + C + ")", Fe = "(?:" + v + "(?:d|ll|m|re|s|t|ve))?", J = "(?:" + v + "(?:D|LL|M|RE|S|T|VE))?", oe = M + "?", A = "[" + p + "]?", X = "(?:" + Y + "(?:" + [T, N, $].join("|") + ")" + A + oe + ")*", pe = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", le = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", ue = A + oe + X, Te = "(?:" + [E, N, $].join("|") + ")" + ue, Ne = RegExp([
    ne + "?" + w + "+" + Fe + "(?=" + [y, ne, "$"].join("|") + ")",
    _e + "+" + J + "(?=" + [y, ne + te, "$"].join("|") + ")",
    ne + "?" + te + "+" + Fe,
    ne + "+" + J,
    le,
    pe,
    x,
    Te
  ].join("|"), "g");
  function Z(G) {
    return G.match(Ne) || [];
  }
  return P_ = Z, P_;
}
var O_, HE;
function wge() {
  if (HE) return O_;
  HE = 1;
  var e = _ge(), t = yge(), n = Sd(), r = xge();
  function i(a, s, o) {
    return a = n(a), s = o ? void 0 : s, s === void 0 ? t(a) ? r(a) : e(a) : a.match(s) || [];
  }
  return O_ = i, O_;
}
var M_, GE;
function $R() {
  if (GE) return M_;
  GE = 1;
  var e = mge(), t = bge(), n = wge(), r = "['’]", i = RegExp(r, "g");
  function a(s) {
    return function(o) {
      return e(n(t(o).replace(i, "")), s, "");
    };
  }
  return M_ = a, M_;
}
var I_, YE;
function kge() {
  if (YE) return I_;
  YE = 1;
  var e = $R(), t = e(function(n, r, i) {
    return n + (i ? "_" : "") + r.toLowerCase();
  });
  return I_ = t, I_;
}
var Sge = kge();
const KE = /* @__PURE__ */ hl(Sge);
var R_, XE;
function Cge() {
  if (XE) return R_;
  XE = 1;
  function e(t, n, r) {
    var i = -1, a = t.length;
    n < 0 && (n = -n > a ? 0 : a + n), r = r > a ? a : r, r < 0 && (r += a), a = n > r ? 0 : r - n >>> 0, n >>>= 0;
    for (var s = Array(a); ++i < a; )
      s[i] = t[i + n];
    return s;
  }
  return R_ = e, R_;
}
var F_, ZE;
function Tge() {
  if (ZE) return F_;
  ZE = 1;
  var e = Cge();
  function t(n, r, i) {
    var a = n.length;
    return i = i === void 0 ? a : i, !r && i >= a ? n : e(n, r, i);
  }
  return F_ = t, F_;
}
var N_, QE;
function VR() {
  if (QE) return N_;
  QE = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", n = "\\ufe20-\\ufe2f", r = "\\u20d0-\\u20ff", i = t + n + r, a = "\\ufe0e\\ufe0f", s = "\\u200d", o = RegExp("[" + s + e + i + a + "]");
  function l(c) {
    return o.test(c);
  }
  return N_ = l, N_;
}
var L_, JE;
function Age() {
  if (JE) return L_;
  JE = 1;
  function e(t) {
    return t.split("");
  }
  return L_ = e, L_;
}
var $_, eP;
function Dge() {
  if (eP) return $_;
  eP = 1;
  var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", n = "\\ufe20-\\ufe2f", r = "\\u20d0-\\u20ff", i = t + n + r, a = "\\ufe0e\\ufe0f", s = "[" + e + "]", o = "[" + i + "]", l = "\\ud83c[\\udffb-\\udfff]", c = "(?:" + o + "|" + l + ")", f = "[^" + e + "]", h = "(?:\\ud83c[\\udde6-\\uddff]){2}", p = "[\\ud800-\\udbff][\\udc00-\\udfff]", g = "\\u200d", v = c + "?", y = "[" + a + "]?", S = "(?:" + g + "(?:" + [f, h, p].join("|") + ")" + y + v + ")*", x = y + v + S, E = "(?:" + [f + o + "?", o, h, p, s].join("|") + ")", w = RegExp(l + "(?=" + l + ")|" + E + x, "g");
  function C(P) {
    return P.match(w) || [];
  }
  return $_ = C, $_;
}
var V_, tP;
function Ege() {
  if (tP) return V_;
  tP = 1;
  var e = Age(), t = VR(), n = Dge();
  function r(i) {
    return t(i) ? n(i) : e(i);
  }
  return V_ = r, V_;
}
var B_, nP;
function Pge() {
  if (nP) return B_;
  nP = 1;
  var e = Tge(), t = VR(), n = Ege(), r = Sd();
  function i(a) {
    return function(s) {
      s = r(s);
      var o = t(s) ? n(s) : void 0, l = o ? o[0] : s.charAt(0), c = o ? e(o, 1).join("") : s.slice(1);
      return l[a]() + c;
    };
  }
  return B_ = i, B_;
}
var U_, rP;
function Oge() {
  if (rP) return U_;
  rP = 1;
  var e = Pge(), t = e("toUpperCase");
  return U_ = t, U_;
}
var q_, iP;
function Mge() {
  if (iP) return q_;
  iP = 1;
  var e = Sd(), t = Oge();
  function n(r) {
    return t(e(r).toLowerCase());
  }
  return q_ = n, q_;
}
var j_, aP;
function Ige() {
  if (aP) return j_;
  aP = 1;
  var e = Mge(), t = $R(), n = t(function(r, i, a) {
    return i = i.toLowerCase(), r + (a ? e(i) : i);
  });
  return j_ = n, j_;
}
var Rge = Ige();
const Fge = /* @__PURE__ */ hl(Rge);
var W_, sP;
function Nge() {
  if (sP) return W_;
  sP = 1;
  var e = kR(), t = TR(), n = IR();
  function r(i, a) {
    var s = {};
    return a = n(a, 3), t(i, function(o, l, c) {
      e(s, a(o, l, c), o);
    }), s;
  }
  return W_ = r, W_;
}
var Lge = Nge();
const $ge = /* @__PURE__ */ hl(Lge);
var ih = { exports: {} }, oP;
function Vge() {
  if (oP) return ih.exports;
  oP = 1, ih.exports = function(i) {
    return e(t(i), i);
  }, ih.exports.array = e;
  function e(i, a) {
    var s = i.length, o = new Array(s), l = {}, c = s, f = n(a), h = r(i);
    for (a.forEach(function(g) {
      if (!h.has(g[0]) || !h.has(g[1]))
        throw new Error("Unknown node. There is an unknown node in the supplied edges.");
    }); c--; )
      l[c] || p(i[c], c, /* @__PURE__ */ new Set());
    return o;
    function p(g, v, y) {
      if (y.has(g)) {
        var S;
        try {
          S = ", node was:" + JSON.stringify(g);
        } catch {
          S = "";
        }
        throw new Error("Cyclic dependency" + S);
      }
      if (!h.has(g))
        throw new Error("Found unknown node. Make sure to provided all involved nodes. Unknown node: " + JSON.stringify(g));
      if (!l[v]) {
        l[v] = !0;
        var x = f.get(g) || /* @__PURE__ */ new Set();
        if (x = Array.from(x), v = x.length) {
          y.add(g);
          do {
            var E = x[--v];
            p(E, h.get(E), y);
          } while (v);
          y.delete(g);
        }
        o[--s] = g;
      }
    }
  }
  function t(i) {
    for (var a = /* @__PURE__ */ new Set(), s = 0, o = i.length; s < o; s++) {
      var l = i[s];
      a.add(l[0]), a.add(l[1]);
    }
    return Array.from(a);
  }
  function n(i) {
    for (var a = /* @__PURE__ */ new Map(), s = 0, o = i.length; s < o; s++) {
      var l = i[s];
      a.has(l[0]) || a.set(l[0], /* @__PURE__ */ new Set()), a.has(l[1]) || a.set(l[1], /* @__PURE__ */ new Set()), a.get(l[0]).add(l[1]);
    }
    return a;
  }
  function r(i) {
    for (var a = /* @__PURE__ */ new Map(), s = 0, o = i.length; s < o; s++)
      a.set(i[s], s);
    return a;
  }
  return ih.exports;
}
var Bge = Vge();
const Uge = /* @__PURE__ */ hl(Bge);
function qge(e, t = []) {
  let n = [], r = /* @__PURE__ */ new Set(), i = new Set(t.map(([s, o]) => `${s}-${o}`));
  function a(s, o) {
    let l = Kp.split(s)[0];
    r.add(l), i.has(`${o}-${l}`) || n.push([o, l]);
  }
  for (const s in e) if (Qh(e, s)) {
    let o = e[s];
    r.add(s), Ks.isRef(o) && o.isSibling ? a(o.path, s) : xR(o) && "deps" in o && o.deps.forEach((l) => a(l, s));
  }
  return Uge.array(Array.from(r), n).reverse();
}
function lP(e, t) {
  let n = 1 / 0;
  return e.some((r, i) => {
    var a;
    if (((a = t.path) == null ? void 0 : a.indexOf(r)) !== -1)
      return n = i, !0;
  }), n;
}
function BR(e) {
  return (t, n) => lP(e, t) - lP(e, n);
}
function Hl() {
  return Hl = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Hl.apply(this, arguments);
}
let uP = (e) => Object.prototype.toString.call(e) === "[object Object]";
function jge(e, t) {
  let n = Object.keys(e.fields);
  return Object.keys(t).filter((r) => n.indexOf(r) === -1);
}
const Wge = BR([]);
class UR extends oi {
  constructor(t) {
    super({
      type: "object"
    }), this.fields = /* @__PURE__ */ Object.create(null), this._sortErrors = Wge, this._nodes = [], this._excludedEdges = [], this.withMutation(() => {
      this.transform(function(r) {
        if (typeof r == "string")
          try {
            r = JSON.parse(r);
          } catch {
            r = null;
          }
        return this.isType(r) ? r : null;
      }), t && this.shape(t);
    });
  }
  _typeCheck(t) {
    return uP(t) || typeof t == "function";
  }
  _cast(t, n = {}) {
    var r;
    let i = super._cast(t, n);
    if (i === void 0) return this.getDefault();
    if (!this._typeCheck(i)) return i;
    let a = this.fields, s = (r = n.stripUnknown) != null ? r : this.spec.noUnknown, o = this._nodes.concat(Object.keys(i).filter((h) => this._nodes.indexOf(h) === -1)), l = {}, c = Hl({}, n, {
      parent: l,
      __validating: n.__validating || !1
    }), f = !1;
    for (const h of o) {
      let p = a[h], g = Qh(i, h);
      if (p) {
        let v, y = i[h];
        c.path = (n.path ? `${n.path}.` : "") + h, p = p.resolve({
          value: y,
          context: n.context,
          parent: l
        });
        let S = "spec" in p ? p.spec : void 0, x = S == null ? void 0 : S.strict;
        if (S != null && S.strip) {
          f = f || h in i;
          continue;
        }
        v = !n.__validating || !x ? (
          // TODO: use _cast, this is double resolving
          p.cast(i[h], c)
        ) : i[h], v !== void 0 && (l[h] = v);
      } else g && !s && (l[h] = i[h]);
      l[h] !== i[h] && (f = !0);
    }
    return f ? l : i;
  }
  _validate(t, n = {}, r) {
    let i = [], {
      sync: a,
      from: s = [],
      originalValue: o = t,
      abortEarly: l = this.spec.abortEarly,
      recursive: c = this.spec.recursive
    } = n;
    s = [{
      schema: this,
      value: o
    }, ...s], n.__validating = !0, n.originalValue = o, n.from = s, super._validate(t, n, (f, h) => {
      if (f) {
        if (!ki.isError(f) || l)
          return void r(f, h);
        i.push(f);
      }
      if (!c || !uP(h)) {
        r(i[0] || null, h);
        return;
      }
      o = o || h;
      let p = this._nodes.map((g) => (v, y) => {
        let S = g.indexOf(".") === -1 ? (n.path ? `${n.path}.` : "") + g : `${n.path || ""}["${g}"]`, x = this.fields[g];
        if (x && "validate" in x) {
          x.validate(h[g], Hl({}, n, {
            // @ts-ignore
            path: S,
            from: s,
            // inner fields are always strict:
            // 1. this isn't strict so the casting will also have cast inner values
            // 2. this is strict in which case the nested values weren't cast either
            strict: !0,
            parent: h,
            originalValue: o[g]
          }), y);
          return;
        }
        y(null);
      });
      Zy({
        tests: p,
        value: h,
        errors: i,
        endEarly: l,
        sort: this._sortErrors,
        path: n.path
      }, r);
    });
  }
  clone(t) {
    const n = super.clone(t);
    return n.fields = Hl({}, this.fields), n._nodes = this._nodes, n._excludedEdges = this._excludedEdges, n._sortErrors = this._sortErrors, n;
  }
  concat(t) {
    let n = super.concat(t), r = n.fields;
    for (let [i, a] of Object.entries(this.fields)) {
      const s = r[i];
      s === void 0 ? r[i] = a : s instanceof oi && a instanceof oi && (r[i] = a.concat(s));
    }
    return n.withMutation(() => n.shape(r, this._excludedEdges));
  }
  getDefaultFromShape() {
    let t = {};
    return this._nodes.forEach((n) => {
      const r = this.fields[n];
      t[n] = "default" in r ? r.getDefault() : void 0;
    }), t;
  }
  _getDefault() {
    if ("default" in this.spec)
      return super._getDefault();
    if (this._nodes.length)
      return this.getDefaultFromShape();
  }
  shape(t, n = []) {
    let r = this.clone(), i = Object.assign(r.fields, t);
    return r.fields = i, r._sortErrors = BR(Object.keys(i)), n.length && (Array.isArray(n[0]) || (n = [n]), r._excludedEdges = [...r._excludedEdges, ...n]), r._nodes = qge(i, r._excludedEdges), r;
  }
  pick(t) {
    const n = {};
    for (const r of t)
      this.fields[r] && (n[r] = this.fields[r]);
    return this.clone().withMutation((r) => (r.fields = {}, r.shape(n)));
  }
  omit(t) {
    const n = this.clone(), r = n.fields;
    n.fields = {};
    for (const i of t)
      delete r[i];
    return n.withMutation(() => n.shape(r));
  }
  from(t, n, r) {
    let i = Kp.getter(t, !0);
    return this.transform((a) => {
      if (a == null) return a;
      let s = a;
      return Qh(a, t) && (s = Hl({}, a), r || delete s[t], s[n] = i(a)), s;
    });
  }
  noUnknown(t = !0, n = Ky.noUnknown) {
    typeof t == "string" && (n = t, t = !0);
    let r = this.test({
      name: "noUnknown",
      exclusive: !0,
      message: n,
      test(i) {
        if (i == null) return !0;
        const a = jge(this.schema, i);
        return !t || a.length === 0 || this.createError({
          params: {
            unknown: a.join(", ")
          }
        });
      }
    });
    return r.spec.noUnknown = t, r;
  }
  unknown(t = !0, n = Ky.noUnknown) {
    return this.noUnknown(!t, n);
  }
  transformKeys(t) {
    return this.transform((n) => n && $ge(n, (r, i) => t(i)));
  }
  camelCase() {
    return this.transformKeys(Fge);
  }
  snakeCase() {
    return this.transformKeys(KE);
  }
  constantCase() {
    return this.transformKeys((t) => KE(t).toUpperCase());
  }
  describe() {
    let t = super.describe();
    return t.fields = RR(this.fields, (n) => n.describe()), t;
  }
}
function qR(e) {
  return new UR(e);
}
qR.prototype = UR.prototype;
const zge = ["product_return", "reimbursement", "promotion"], Hge = qR().shape({
  description: Qy().required("La description est requise.").max(255, "La description ne peut pas dépasser 255 caractères."),
  unitPriceBeforeTax: mh().required("Le prix unitaire (HT) est requis.").typeError("Le prix unitaire (HT) doit être un nombre.").min(0, "Le prix unitaire (HT) doit être positif."),
  unitPrice: mh().required("Le prix unitaire (TTC) est requis.").typeError("Le prix unitaire (TTC) doit être un nombre.").min(0, "Le prix unitaire (TTC) doit être positif."),
  quantity: mh().required("La quantité est requise.").typeError("La quantité doit être un nombre.").when("type", {
    is: (e) => zge.includes(e),
    then: (e) => e.max(
      -1,
      "La quantité doit être négative (-1 au plus) pour un remboursement, une reprise produit ou une remise."
    ),
    otherwise: (e) => e.min(1, "La quantité doit être au moins 1.")
  }),
  type: Qy().required("Le type est requis").notOneOf([""], "Please select a valid option.")
}), Gge = {
  components: { Field: cu, FormField: hu, PlusIcon: rB, PencilIcon: nB, TrashIcon: t0 },
  props: {
    initialItems: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      schema: Hge,
      items: [],
      displayNewLine: !1,
      editingIndex: null,
      newItem: {},
      addNewItemErrors: null
    };
  },
  created() {
    this.resetNewItem(), Cr(this.initialItems) && (this.items = this.initialItems);
  },
  watch: {
    initialItems(e) {
      e != null && (this.items = e.map((t) => ({ ...t })));
    },
    "newItem.quantity"() {
      this.computeNewItemTotal();
    }
  },
  computed: {
    unitPriceBeforeTaxComputedProperty: {
      get() {
        return this.newItem.unitPriceBeforeTax;
      },
      set(e) {
        this.newItem.unitPriceBeforeTax = e, this.updateNewItemTotal(), this.computeNewItemTotal();
      }
    },
    unitPriceComputedProperty: {
      get() {
        return this.newItem.unitPrice;
      },
      set(e) {
        this.newItem.unitPrice = e, this.updateNewItemTotalBeforeTax(), this.computeNewItemTotal();
      }
    }
  },
  methods: {
    typeBadgeClass(e) {
      return `inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${{
        labor: "bg-blue-100 text-blue-800",
        part: "bg-green-100 text-green-800",
        shipping_cost: "",
        reimbursement: "bg-purple-100 text-purple-800",
        product_return: "bg-red-100 text-red-800",
        promotion: "bg-teal-100 text-teal-800"
      }[e] ?? "bg-gray-100 text-gray-800"}`;
    },
    async addNewItem() {
      try {
        await this.schema.validate(this.newItem);
        const e = (parseFloat(this.newItem.unitPrice.replace("€", "").trim()) * this.newItem.quantity).toFixed(2);
        this.items.push({ ...this.newItem, total: e }), this.$emit("updated-items", this.items), this.displayNewLine = !1, this.resetNewItem();
      } catch (e) {
        this.addNewItemErrors = e.message, console.error(e);
      }
    },
    removeItem(e) {
      this.items.splice(e, 1), this.$emit("updated-items", this.items), this.displayNewLine = !1, this.editingIndex !== null && (e === this.editingIndex ? this.cancelEdit() : e < this.editingIndex && this.editingIndex--);
    },
    computeNewItemTotal() {
      this.newItem.total = ((this.newItem.unitPrice ?? 0) * (this.newItem.quantity ?? 0)).toFixed(2);
    },
    startEdit(e) {
      this.displayNewLine = !1, this.addNewItemErrors = null, this.editingIndex = e, this.newItem = { ...this.items[e] };
    },
    async confirmEdit() {
      try {
        await this.schema.validate(this.newItem);
        const e = (parseFloat(String(this.newItem.unitPrice).replace("€", "").trim()) * this.newItem.quantity).toFixed(2);
        this.items.splice(this.editingIndex, 1, { ...this.newItem, total: e }), this.$emit("updated-items", this.items), this.editingIndex = null, this.resetNewItem();
      } catch (e) {
        this.addNewItemErrors = e.message, console.error(e);
      }
    },
    cancelEdit() {
      this.editingIndex = null, this.addNewItemErrors = null, this.resetNewItem();
    },
    enableNewItemDisplay() {
      this.editingIndex = null, this.displayNewLine = !0, this.addNewItemErrors = null;
    },
    removeNewItemDisplay() {
      this.displayNewLine = !1, this.resetNewItem();
    },
    updateNewItemTotal() {
      this.newItem.unitPrice = (this.newItem.unitPriceBeforeTax * 1.2).toFixed(
        2
      );
    },
    updateNewItemTotalBeforeTax() {
      this.newItem.unitPriceBeforeTax = (this.newItem.unitPrice / 1.2).toFixed(
        2
      );
    },
    resetNewItem() {
      this.newItem = {
        type: "",
        description: "",
        unitPriceBeforeTax: "",
        unitPrice: "",
        quantity: 1,
        total: ""
      };
    }
  }
}, Yge = { class: "space-y-2" }, Kge = { class: "grid grid-cols-2 sm:grid-cols-3 gap-2" }, Xge = ["for"], Zge = { class: "sm:col-span-2" }, Qge = ["for"], Jge = ["for"], eve = ["for"], tve = { class: "grid grid-cols-2 gap-2" }, nve = ["for"], rve = { class: "bg-white border border-gray-200 rounded-md px-2 py-1.5 text-xs text-gray-800 font-medium" }, ive = { class: "flex justify-end gap-2 mt-2" }, ave = { class: "flex items-center justify-between" }, sve = { class: "flex items-center gap-2 min-w-0" }, ove = { class: "text-xs text-gray-800 truncate" }, lve = { class: "flex items-center gap-1 shrink-0 ml-2" }, uve = ["onClick"], cve = ["onClick"], dve = { class: "flex items-center gap-3 mt-1 text-xs text-gray-600 flex-wrap" }, fve = { class: "font-medium text-gray-800" }, hve = {
  key: 0,
  class: "border-2 border-dashed border-gray-300 rounded-lg py-3 text-center text-xs text-gray-500"
}, pve = {
  key: 1,
  class: "border border-dashed border-gray-300 rounded-lg p-3 bg-gray-50"
}, mve = { class: "grid grid-cols-2 sm:grid-cols-3 gap-2" }, gve = { class: "sm:col-span-2" }, vve = { class: "grid grid-cols-2 gap-2" }, bve = { class: "bg-white border border-gray-200 rounded-md px-2 py-1.5 text-xs text-gray-800 font-medium" }, _ve = { class: "flex justify-end gap-2 mt-2" }, yve = {
  key: 1,
  class: "mt-2 px-3 py-2 bg-red-50 border border-red-200 rounded-md text-xs text-red-700"
};
function xve(e, t, n, r, i, a) {
  const s = U("Field"), o = U("FormField"), l = U("PencilIcon"), c = U("TrashIcon"), f = U("PlusIcon");
  return _(), O("div", null, [
    t[29] || (t[29] = k("label", { class: "block mb-1 text-sm font-bold text-gray-900 dark:text-white" }, [
      Me(" Détail des coûts "),
      k("span", { class: "text-red-500" }, "*")
    ], -1)),
    k("div", Yge, [
      (_(!0), O(Re, null, Ke(i.items, (h, p) => (_(), O("div", {
        key: p,
        class: "border border-gray-200 rounded-lg px-3 py-2 bg-white"
      }, [
        i.editingIndex === p ? (_(), O(Re, { key: 0 }, [
          k("div", Kge, [
            k("div", null, [
              k("label", {
                for: `edit-type-${p}`,
                class: "block text-xs font-medium text-gray-700 mb-0.5"
              }, " Type de coût ", 8, Xge),
              W(s, {
                as: "select",
                id: `edit-type-${p}`,
                name: `edit-type-${p}`,
                class: "w-full px-2 py-1.5 rounded-md border border-gray-300 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-primary text-xs",
                modelValue: i.newItem.type,
                "onUpdate:modelValue": t[0] || (t[0] = (g) => i.newItem.type = g)
              }, {
                default: ie(() => [...t[15] || (t[15] = [
                  k("option", {
                    disabled: "",
                    value: ""
                  }, "Choisir une option", -1),
                  k("option", { value: "labor" }, "Main d'oeuvre", -1),
                  k("option", { value: "part" }, "Pièce", -1),
                  k("option", { value: "shipping_cost" }, "Transport", -1),
                  k("option", { value: "reimbursement" }, "Remboursement", -1),
                  k("option", { value: "product_return" }, "Reprise produit", -1),
                  k("option", { value: "promotion" }, "Remise", -1)
                ])]),
                _: 1
              }, 8, ["id", "name", "modelValue"])
            ]),
            k("div", Zge, [
              k("label", {
                for: `edit-description-${p}`,
                class: "block text-xs font-medium text-gray-700 mb-0.5"
              }, " Description ", 8, Qge),
              W(o, {
                id: `edit-description-${p}`,
                modelValue: i.newItem.description,
                "onUpdate:modelValue": t[1] || (t[1] = (g) => i.newItem.description = g),
                name: `edit-description-${p}`,
                placeholder: "Description",
                "field-class": "w-full px-2 py-1.5 border border-gray-300 rounded-md text-xs"
              }, null, 8, ["id", "modelValue", "name"])
            ]),
            k("div", null, [
              k("label", {
                for: `edit-unitPriceBeforeTax-${p}`,
                class: "block text-xs font-medium text-gray-700 mb-0.5"
              }, " Montant HT ", 8, Jge),
              W(o, {
                id: `edit-unitPriceBeforeTax-${p}`,
                name: `edit-unitPriceBeforeTax-${p}`,
                modelValue: a.unitPriceBeforeTaxComputedProperty,
                "onUpdate:modelValue": t[2] || (t[2] = (g) => a.unitPriceBeforeTaxComputedProperty = g),
                placeholder: "0.00",
                "field-class": "w-full px-2 py-1.5 border border-gray-300 rounded-md text-xs"
              }, null, 8, ["id", "name", "modelValue"])
            ]),
            k("div", null, [
              k("label", {
                for: `edit-unitPrice-${p}`,
                class: "block text-xs font-medium text-gray-700 mb-0.5"
              }, " Montant TTC ", 8, eve),
              W(o, {
                id: `edit-unitPrice-${p}`,
                required: "",
                name: `edit-unitPrice-${p}`,
                modelValue: a.unitPriceComputedProperty,
                "onUpdate:modelValue": t[3] || (t[3] = (g) => a.unitPriceComputedProperty = g),
                placeholder: "0.00",
                "field-class": "w-full px-2 py-1.5 border border-gray-300 rounded-md text-xs"
              }, null, 8, ["id", "name", "modelValue"])
            ]),
            k("div", tve, [
              k("div", null, [
                k("label", {
                  for: `edit-quantity-${p}`,
                  class: "block text-xs font-medium text-gray-700 mb-0.5"
                }, " Quantité ", 8, nve),
                W(o, {
                  id: `edit-quantity-${p}`,
                  modelValue: i.newItem.quantity,
                  "onUpdate:modelValue": t[4] || (t[4] = (g) => i.newItem.quantity = g),
                  type: "number",
                  placeholder: "1",
                  "field-class": "w-full px-2 py-1.5 border border-gray-300 rounded-md text-xs",
                  name: `edit-quantity-${p}`
                }, null, 8, ["id", "modelValue", "name"])
              ]),
              k("div", null, [
                t[16] || (t[16] = k("label", { class: "block text-xs font-medium text-gray-700 mb-0.5" }, " Total TTC ", -1)),
                k("div", rve, j(i.newItem.total || "0.00"), 1)
              ])
            ])
          ]),
          k("div", ive, [
            k("button", {
              type: "button",
              onClick: t[5] || (t[5] = (...g) => a.cancelEdit && a.cancelEdit(...g)),
              class: "px-3 py-1.5 text-xs font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors"
            }, " Annuler "),
            k("button", {
              type: "button",
              onClick: t[6] || (t[6] = (...g) => a.confirmEdit && a.confirmEdit(...g)),
              class: "px-3 py-1.5 text-xs font-medium text-white bg-primary rounded-md hover:bg-primary-dark transition-colors"
            }, " Confirmer ")
          ])
        ], 64)) : (_(), O(Re, { key: 1 }, [
          k("div", ave, [
            k("div", sve, [
              k("span", {
                class: Pe(a.typeBadgeClass(h.type))
              }, j(e.$t(`claim.cost_type.${h.type}`)), 3),
              k("span", ove, j(h.description), 1)
            ]),
            k("div", lve, [
              k("button", {
                type: "button",
                "aria-label": "Modifier l'élément",
                class: "text-gray-400 hover:text-blue-500 transition-colors",
                onClick: (g) => a.startEdit(p)
              }, [
                W(l, { class: "h-3.5 w-3.5" })
              ], 8, uve),
              k("button", {
                type: "button",
                "aria-label": "Supprimer l'élément",
                class: "text-gray-400 hover:text-red-500 transition-colors",
                onClick: (g) => a.removeItem(p)
              }, [
                W(c, { class: "h-3.5 w-3.5" })
              ], 8, cve)
            ])
          ]),
          k("div", dve, [
            k("span", null, [
              t[17] || (t[17] = k("span", { class: "text-gray-400" }, "HT:", -1)),
              Me(" " + j(h.unitPriceBeforeTax), 1)
            ]),
            k("span", null, [
              t[18] || (t[18] = k("span", { class: "text-gray-400" }, "TTC:", -1)),
              Me(" " + j(h.unitPrice), 1)
            ]),
            k("span", null, [
              t[19] || (t[19] = k("span", { class: "text-gray-400" }, "Qté:", -1)),
              Me(" " + j(h.quantity), 1)
            ]),
            k("span", fve, [
              t[20] || (t[20] = k("span", { class: "text-gray-400 font-normal" }, "Total:", -1)),
              Me(" " + j(h.total) + " " + j(h.currencyCode), 1)
            ])
          ])
        ], 64))
      ]))), 128)),
      i.items.length === 0 && !i.displayNewLine ? (_(), O("div", hve, " Aucun coût ajouté pour le moment ")) : L("", !0),
      i.displayNewLine ? (_(), O("div", pve, [
        k("div", mve, [
          k("div", null, [
            t[22] || (t[22] = k("label", {
              for: "type",
              class: "block text-xs font-medium text-gray-700 mb-0.5"
            }, " Type de coût ", -1)),
            W(s, {
              as: "select",
              id: "type",
              name: "type",
              class: "w-full px-2 py-1.5 rounded-md border border-gray-300 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-primary text-xs",
              modelValue: i.newItem.type,
              "onUpdate:modelValue": t[7] || (t[7] = (h) => i.newItem.type = h)
            }, {
              default: ie(() => [...t[21] || (t[21] = [
                k("option", {
                  disabled: "",
                  value: ""
                }, "Choisir une option", -1),
                k("option", { value: "labor" }, "Main d'oeuvre", -1),
                k("option", { value: "part" }, "Pièce", -1),
                k("option", { value: "shipping_cost" }, "Transport", -1),
                k("option", { value: "reimbursement" }, "Remboursement", -1),
                k("option", { value: "product_return" }, "Reprise produit", -1),
                k("option", { value: "promotion" }, "Remise", -1)
              ])]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          k("div", gve, [
            t[23] || (t[23] = k("label", {
              for: "description",
              class: "block text-xs font-medium text-gray-700 mb-0.5"
            }, " Description ", -1)),
            W(o, {
              id: "description",
              modelValue: i.newItem.description,
              "onUpdate:modelValue": t[8] || (t[8] = (h) => i.newItem.description = h),
              name: "description",
              placeholder: "Description",
              "field-class": "w-full px-2 py-1.5 border border-gray-300 rounded-md text-xs"
            }, null, 8, ["modelValue"])
          ]),
          k("div", null, [
            t[24] || (t[24] = k("label", {
              for: "unitPriceBeforeTax",
              class: "block text-xs font-medium text-gray-700 mb-0.5"
            }, " Montant HT ", -1)),
            W(o, {
              id: "unitPriceBeforeTax",
              name: "unitPriceBeforeTax",
              modelValue: a.unitPriceBeforeTaxComputedProperty,
              "onUpdate:modelValue": t[9] || (t[9] = (h) => a.unitPriceBeforeTaxComputedProperty = h),
              placeholder: "0.00",
              "field-class": "w-full px-2 py-1.5 border border-gray-300 rounded-md text-xs"
            }, null, 8, ["modelValue"])
          ]),
          k("div", null, [
            t[25] || (t[25] = k("label", {
              for: "unitPrice",
              class: "block text-xs font-medium text-gray-700 mb-0.5"
            }, " Montant TTC ", -1)),
            W(o, {
              id: "unitPrice",
              required: "",
              name: "unitPrice",
              modelValue: a.unitPriceComputedProperty,
              "onUpdate:modelValue": t[10] || (t[10] = (h) => a.unitPriceComputedProperty = h),
              placeholder: "0.00",
              "field-class": "w-full px-2 py-1.5 border border-gray-300 rounded-md text-xs"
            }, null, 8, ["modelValue"])
          ]),
          k("div", vve, [
            k("div", null, [
              t[26] || (t[26] = k("label", {
                for: "quantity",
                class: "block text-xs font-medium text-gray-700 mb-0.5"
              }, " Quantité ", -1)),
              W(o, {
                id: "quantity",
                modelValue: i.newItem.quantity,
                "onUpdate:modelValue": t[11] || (t[11] = (h) => i.newItem.quantity = h),
                type: "number",
                placeholder: "1",
                "field-class": "w-full px-2 py-1.5 border border-gray-300 rounded-md text-xs",
                name: "quantity"
              }, null, 8, ["modelValue"])
            ]),
            k("div", null, [
              t[27] || (t[27] = k("label", { class: "block text-xs font-medium text-gray-700 mb-0.5" }, " Total TTC ", -1)),
              k("div", bve, j(i.newItem.total || "0.00"), 1)
            ])
          ])
        ]),
        k("div", _ve, [
          k("button", {
            type: "button",
            onClick: t[12] || (t[12] = (...h) => a.removeNewItemDisplay && a.removeNewItemDisplay(...h)),
            class: "px-3 py-1.5 text-xs font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors"
          }, " Annuler "),
          k("button", {
            type: "button",
            onClick: t[13] || (t[13] = (...h) => a.addNewItem && a.addNewItem(...h)),
            class: "px-3 py-1.5 text-xs font-medium text-white bg-primary rounded-md hover:bg-primary-dark transition-colors"
          }, " Ajouter ")
        ])
      ])) : L("", !0)
    ]),
    i.displayNewLine ? L("", !0) : (_(), O("button", {
      key: 0,
      type: "button",
      onClick: t[14] || (t[14] = (...h) => a.enableNewItemDisplay && a.enableNewItemDisplay(...h)),
      class: "flex text-xs font-medium justify-center items-center w-full h-9 text-primary border-2 border-dashed rounded-lg cursor-pointer mt-1.5 transition-colors"
    }, [
      W(f, { class: "w-4 h-4 mr-1" }),
      t[28] || (t[28] = k("span", null, "Ajouter une ligne", -1))
    ])),
    i.addNewItemErrors && i.addNewItemErrors.length > 0 ? (_(), O("div", yve, [
      k("p", null, j(i.addNewItemErrors), 1)
    ])) : L("", !0)
  ]);
}
const wve = /* @__PURE__ */ we(Gge, [["render", xve]]);
function kve(e) {
  return !e || !e.length ? "0.00" : e.reduce((t, n) => {
    const r = parseFloat(n.total);
    return t + (Number.isFinite(r) ? r : 0);
  }, 0).toFixed(2);
}
function jR(e) {
  return e.map((t) => {
    let n = parseFloat(t.unit_price || 0), r = parseFloat(t.unit_price_before_tax || 0);
    n || (n = z_(r * 1.2)), r || (r = z_(n / 1.2));
    const i = parseInt(t.quantity, 10) || 1, a = z_(n * i);
    return {
      type: t.cost_type || "",
      description: t.description,
      unitPriceBeforeTax: r,
      unitPrice: n,
      quantity: i,
      total: a,
      currencyCode: ""
    };
  });
}
function z_(e) {
  return parseFloat(e.toFixed(2));
}
function cP(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "",
    resource: {
      fr: {
        total_before_taxes: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Total HT" } },
        taxes: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "TVA" } },
        total: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Total TTC" } }
      },
      en: {
        total_before_taxes: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Total excl. VAT" } },
        taxes: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "VAT" } },
        total: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Total incl. VAT" } }
      }
    }
  });
}
const WR = {
  props: ["costItems"],
  setup() {
    const { t: e } = nr();
    return { t: e };
  },
  computed: {
    totalBeforeTaxes() {
      return this.costItems.reduce((e, t) => {
        const n = parseInt(t.quantity, 10) || 1;
        return e + parseFloat(t.unitPriceBeforeTax ?? 0) * n;
      }, 0).toFixed(2);
    },
    taxes() {
      return (this.total - this.totalBeforeTaxes).toFixed(2);
    },
    total() {
      return kve(this.costItems);
    }
  }
}, Sve = {
  key: 0,
  class: "mt-3 sm:mt-4"
}, Cve = { class: "bg-gray-50 rounded-lg p-3 sm:p-4" }, Tve = { class: "flex justify-between text-xs text-gray-600" }, Ave = { class: "flex justify-between mt-2 text-xs text-gray-600" }, Dve = { class: "border-t border-gray-200 mt-2 pt-2 flex justify-between text-sm font-semibold text-gray-900" };
function Eve(e, t, n, r, i, a) {
  return n.costItems ? (_(), O("div", Sve, [
    k("div", Cve, [
      k("div", Tve, [
        k("span", null, j(r.t("total_before_taxes")), 1),
        k("span", null, j(a.totalBeforeTaxes) + " €", 1)
      ]),
      k("div", Ave, [
        k("span", null, j(r.t("taxes")), 1),
        k("span", null, j(a.taxes) + " €", 1)
      ]),
      k("div", Dve, [
        k("span", null, j(r.t("total")), 1),
        k("span", null, j(a.total) + " €", 1)
      ])
    ])
  ])) : L("", !0);
}
typeof cP == "function" && cP(WR);
const Y0e = /* @__PURE__ */ we(WR, [["render", Eve]]), Pve = {
  components: { FormField: hu, ExtractionStatus: _de, CostItems: wve },
  props: {
    extractCostItems: {
      type: Function,
      default: null
    }
  },
  data: () => ({
    costItems: null,
    productState: null,
    file: null,
    extracting: !1,
    extractionError: !1,
    extractionSuccess: !1,
    extractionToken: 0
  }),
  watch: {
    costItems() {
      this.emitData();
    },
    productState() {
      this.emitData();
    },
    async file(e) {
      var t, n;
      if (this.costItems = [], this.emitData(), e && this.extractCostItems) {
        const r = ++this.extractionToken;
        this.extracting = !0, this.extractionError = !1, this.extractionSuccess = !1;
        try {
          const i = await this.extractCostItems(e);
          if (r !== this.extractionToken) return;
          (n = (t = i == null ? void 0 : i.data) == null ? void 0 : t.cost_items) != null && n.length && (this.costItems = jR(i.data.cost_items), this.extractionSuccess = !0);
        } catch {
          if (r !== this.extractionToken) return;
          this.extractionError = !0, this.extractionSuccess = !1;
        } finally {
          r === this.extractionToken && (this.extracting = !1);
        }
      }
    }
  },
  methods: {
    emitData() {
      this.$emit("update", this.productState, this.file, this.costItems);
    }
  }
};
function Ove(e, t, n, r, i, a) {
  const s = U("FormField"), o = U("ExtractionStatus"), l = U("CostItems");
  return _(), O("div", null, [
    W(s, {
      id: "product_state",
      name: "product_state_input",
      modelValue: e.productState,
      "onUpdate:modelValue": t[0] || (t[0] = (c) => e.productState = c),
      label: "État du produit",
      required: "",
      type: "text",
      "field-class": "block w-full rounded-md border-0 py-1.5 pr-12 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
    }, null, 8, ["modelValue"]),
    W(s, {
      class: "mt-3",
      id: "file_input",
      modelValue: e.file,
      "onUpdate:modelValue": t[1] || (t[1] = (c) => e.file = c),
      required: "",
      type: "file",
      label: "Devis proforma",
      "field-class": "block w-full text-sm text-gray-700 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 dark:text-gray-400 focus:outline-hidden dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400",
      name: "quotation_upload"
    }, null, 8, ["modelValue"]),
    W(o, {
      extracting: e.extracting,
      "extraction-error": e.extractionError,
      "extraction-success": e.extractionSuccess,
      onDismissSuccess: t[2] || (t[2] = (c) => e.extractionSuccess = !1)
    }, null, 8, ["extracting", "extraction-error", "extraction-success"]),
    W(l, {
      class: "mt-4",
      "initial-items": e.costItems,
      onUpdatedItems: t[3] || (t[3] = (c) => e.costItems = c)
    }, null, 8, ["initial-items"])
  ]);
}
const K0e = /* @__PURE__ */ we(Pve, [["render", Ove]]), Mve = {
  name: "ClaimProductSummary",
  components: { StackedField: yp },
  props: {
    claimProduct: {
      type: Object,
      required: !0
    }
  },
  methods: {
    formatPrice: Si
  }
}, Ive = { class: "grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2" }, Rve = { class: "break-all" };
function Fve(e, t, n, r, i, a) {
  const s = U("StackedField");
  return _(), O("div", null, [
    t[0] || (t[0] = k("h3", { class: "text-lg font-bold text-gray-900 mb-4" }, "Produit", -1)),
    k("div", Ive, [
      W(s, {
        label: "Produit",
        value: n.claimProduct.title
      }, null, 8, ["value"]),
      W(s, {
        label: "Prix du produit",
        value: a.formatPrice(n.claimProduct.price)
      }, null, 8, ["value"]),
      W(s, {
        label: "Numéro de série",
        value: n.claimProduct.referenceId
      }, null, 8, ["value"]),
      W(s, {
        label: "Date d'achat",
        value: n.claimProduct.purchaseDate
      }, null, 8, ["value"]),
      n.claimProduct.insuranceStartDate ? (_(), ae(s, {
        key: 0,
        label: "Date d'ajout",
        value: n.claimProduct.insuranceStartDate
      }, null, 8, ["value"])) : L("", !0),
      n.claimProduct.productUrl ? (_(), ae(s, {
        key: 1,
        label: "URL du produit",
        class: "min-w-0"
      }, {
        default: ie(() => [
          k("span", Rve, j(n.claimProduct.productUrl), 1)
        ]),
        _: 1
      })) : L("", !0)
    ])
  ]);
}
const X0e = /* @__PURE__ */ we(Mve, [["render", Fve]]), Nve = {
  components: {
    Alert: so,
    InformationCircleIcon: ds
  },
  props: {
    compensationValue: {
      type: [Number, String],
      required: !0
    },
    type: {
      type: String,
      default: "info"
    }
  },
  methods: {
    formatPrice: Si
  }
}, Lve = { class: "flex items-center space-x-2" }, $ve = {
  type: "button",
  tabindex: "-1",
  class: "inline-flex items-center",
  "aria-label": "Information sur le montant de prise en charge"
};
function Vve(e, t, n, r, i, a) {
  const s = U("InformationCircleIcon"), o = U("VTooltip"), l = U("Alert");
  return _(), ae(l, { type: n.type }, {
    default: ie(() => [
      k("div", Lve, [
        k("span", null, "Montant maximal de prise en charge : " + j(a.formatPrice(n.compensationValue)), 1),
        W(o, { theme: "info-tooltip" }, {
          popper: ie(() => [
            k("span", null, j(e.$t("claim.compensation_value_tooltip")), 1)
          ]),
          default: ie(() => [
            k("button", $ve, [
              W(s, {
                class: "h-4 w-4 text-gray-400",
                "aria-hidden": "true"
              })
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["type"]);
}
const Z0e = /* @__PURE__ */ we(Nve, [["render", Vve]]);
function dP(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "",
    resource: {
      fr: {
        title_invoice: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Confirmez les informations de votre facture" } },
        title_quotation: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Confirmez les informations de votre devis" } },
        description: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Vérifiez les articles et les montants ci-dessous. Le montant que vous confirmez sera celui pris en compte pour la prise en charge." } },
        total_label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Montant total TTC" } },
        confirm_button: { t: 0, b: { t: 2, i: [{ t: 3, v: "Confirmer le montant de " }, { t: 4, k: "amount" }, { t: 3, v: " €" }] } },
        confirmed_message: { t: 0, b: { t: 2, i: [{ t: 3, v: "Montant de " }, { t: 4, k: "amount" }, { t: 3, v: " € confirmé" }] } },
        currency_symbol: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "€" } }
      },
      en: {
        title_invoice: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Confirm your invoice details" } },
        title_quotation: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Confirm your quotation details" } },
        description: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Review the items and amounts below. The amount you confirm will be used for coverage." } },
        total_label: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Total amount incl. tax" } },
        confirm_button: { t: 0, b: { t: 2, i: [{ t: 3, v: "Confirm amount of " }, { t: 4, k: "amount" }, { t: 3, v: " €" }] } },
        confirmed_message: { t: 0, b: { t: 2, i: [{ t: 3, v: "Amount of " }, { t: 4, k: "amount" }, { t: 3, v: " € confirmed" }] } },
        currency_symbol: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "€" } }
      }
    }
  });
}
const zR = {
  name: "CostItemsConfirmation",
  components: { CheckCircleIcon: n0, GenericButton: kn },
  props: {
    confirmed: { type: Boolean, required: !0 },
    documentType: {
      type: String,
      default: "invoice",
      validator: (e) => ["invoice", "quotation"].includes(e)
    },
    totalAmount: { type: String, required: !0 }
  },
  emits: ["confirm"],
  setup() {
    const { t: e } = nr();
    return { t: e };
  }
}, Bve = {
  key: 0,
  class: "bg-blue-50 border border-blue-200 rounded-lg p-4 mt-5"
}, Uve = { class: "text-sm font-semibold text-blue-900" }, qve = { class: "mt-1 text-sm text-blue-700" }, jve = { class: "mt-3 flex items-center justify-between bg-white rounded-md border border-blue-200 px-4 py-3" }, Wve = { class: "text-sm font-medium text-gray-700" }, zve = { class: "text-lg font-bold text-gray-900" }, Hve = {
  key: 1,
  class: "flex items-center gap-2 text-green-700 bg-green-50 border border-green-200 rounded-lg p-3 mt-5"
}, Gve = { class: "text-sm font-medium" };
function Yve(e, t, n, r, i, a) {
  const s = U("GenericButton"), o = U("CheckCircleIcon");
  return n.confirmed ? (_(), O("div", Hve, [
    W(o, { class: "w-5 h-5 shrink-0" }),
    k("span", Gve, j(r.t("confirmed_message", { amount: n.totalAmount })), 1)
  ])) : (_(), O("div", Bve, [
    k("h3", Uve, j(n.documentType === "quotation" ? r.t("title_quotation") : r.t("title_invoice")), 1),
    k("p", qve, j(r.t("description")), 1),
    k("div", jve, [
      k("span", Wve, j(r.t("total_label")), 1),
      k("span", zve, j(n.totalAmount) + " " + j(r.t("currency_symbol")), 1)
    ]),
    W(s, {
      class: "mt-3 w-full",
      onClick: t[0] || (t[0] = (l) => e.$emit("confirm"))
    }, {
      default: ie(() => [
        Me(j(r.t("confirm_button", { amount: n.totalAmount })), 1)
      ]),
      _: 1
    })
  ]));
}
typeof dP == "function" && dP(zR);
const Q0e = /* @__PURE__ */ we(zR, [["render", Yve]]), Kve = {
  props: {
    title: {
      type: String,
      required: !0
    },
    videoUrl: {
      type: String,
      required: !0
    }
  }
}, Xve = { class: "text-center mb-2" }, Zve = { class: "text-lg font-semibold text-gray-900" }, Qve = { class: "w-full h-[calc(100dvh-11rem)] sm:h-[calc(100dvh-7rem)] bg-gray-50 rounded-lg border border-gray-200 overflow-hidden" }, Jve = ["src"];
function ebe(e, t, n, r, i, a) {
  return _(), O("div", null, [
    k("div", Xve, [
      k("h3", Zve, j(n.title), 1)
    ]),
    k("div", Qve, [
      k("iframe", {
        src: n.videoUrl,
        class: "w-full h-full",
        loading: "lazy",
        frameborder: "0",
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        allowfullscreen: ""
      }, null, 8, Jve)
    ])
  ]);
}
const tbe = /* @__PURE__ */ we(Kve, [["render", ebe]]), nbe = {
  props: {
    title: {
      type: String,
      required: !0
    },
    fileUrl: {
      type: String,
      required: !0
    }
  }
}, rbe = { class: "text-center mb-2" }, ibe = { class: "text-lg font-semibold text-gray-900" }, abe = { class: "w-full h-[calc(100dvh-11rem)] sm:h-[calc(100dvh-7rem)] bg-gray-50 rounded-lg border border-gray-200 overflow-auto" }, sbe = ["src"];
function obe(e, t, n, r, i, a) {
  return _(), O("div", null, [
    k("div", rbe, [
      k("h3", ibe, j(n.title), 1)
    ]),
    k("div", abe, [
      k("iframe", {
        src: n.fileUrl,
        class: "w-full h-full",
        loading: "lazy",
        frameborder: "0",
        allowfullscreen: "",
        sandbox: "allow-same-origin allow-scripts allow-forms allow-popups allow-modals"
      }, null, 8, sbe)
    ])
  ]);
}
const lbe = /* @__PURE__ */ we(nbe, [["render", obe]]), fP = {
  yellow: { container: "border-yellow-400 bg-yellow-50", icon: "text-yellow-400", text: "text-yellow-700" },
  red: { container: "border-red-400 bg-red-50", icon: "text-red-400", text: "text-red-700" },
  green: { container: "border-green-400 bg-green-50", icon: "text-green-400", text: "text-green-700" },
  blue: { container: "border-blue-400 bg-blue-50", icon: "text-blue-400", text: "text-blue-700" }
}, ube = {
  props: {
    color: {
      type: String,
      default: "yellow",
      validator: (e) => e in fP
    }
  },
  computed: {
    colorClasses() {
      return fP[this.color];
    }
  }
}, cbe = { class: "flex" };
function dbe(e, t, n, r, i, a) {
  return _(), O("div", {
    class: Pe(["border-l-4 p-4", a.colorClasses.container])
  }, [
    k("div", cbe, [
      k("div", null, [
        (_(), O("svg", {
          viewBox: "0 0 20 20",
          fill: "currentColor",
          "data-slot": "icon",
          "aria-hidden": "true",
          class: Pe(a.colorClasses.icon)
        }, [...t[0] || (t[0] = [
          k("path", {
            d: "M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495ZM10 5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 5Zm0 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
            "clip-rule": "evenodd",
            "fill-rule": "evenodd"
          }, null, -1)
        ])], 2))
      ]),
      k("div", {
        class: Pe(["ml-3 text-sm", a.colorClasses.text])
      }, [
        xe(e.$slots, "default")
      ], 2)
    ])
  ], 2);
}
const J0e = /* @__PURE__ */ we(ube, [["render", dbe]]);
function hP(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "",
    resource: {
      fr: {
        new_badge: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Nouveau" } },
        default_subtitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Guide de formation" } }
      },
      en: {
        new_badge: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "New" } },
        default_subtitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Training guide" } }
      }
    }
  });
}
const HR = {
  setup() {
    const { t: e } = nr();
    return { t: e };
  },
  props: {
    title: {
      type: String,
      required: !0
    },
    text: {
      type: String,
      required: !0
    },
    isNew: {
      type: Boolean,
      default: !1
    },
    subtitle: {
      type: String,
      default: null
    },
    // Stands out from the plain guides (used for interactive training modules)
    highlighted: {
      type: Boolean,
      default: !1
    }
  },
  components: {
    DocumentTextIcon: ip
  }
}, fbe = { class: "p-6" }, hbe = { class: "flex items-center mb-4" }, pbe = { class: "ml-3 flex-1" }, mbe = { class: "flex justify-between items-center gap-2" }, gbe = { class: "text-xl font-semibold text-gray-900" }, vbe = {
  key: 0,
  class: "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800"
}, bbe = { class: "mt-1 flex flex-wrap items-center gap-2" }, _be = { class: "text-gray-600 mb-6" }, ybe = { class: "flex flex-col sm:flex-row gap-3" };
function xbe(e, t, n, r, i, a) {
  const s = U("DocumentTextIcon");
  return _(), O("div", {
    class: Pe([
      "rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow duration-300",
      n.highlighted ? "border-2 border-primary-light bg-gradient-to-br from-purple-50 to-white" : "bg-white border border-gray-200"
    ])
  }, [
    k("div", fbe, [
      k("div", hbe, [
        k("div", {
          class: Pe(["shrink-0 flex items-center justify-center h-12 w-12 rounded-full", n.highlighted ? "bg-primary-light" : "bg-gray-100"])
        }, [
          xe(e.$slots, "icon", {}, () => [
            W(s, { class: "h-7 w-7 text-primary" })
          ])
        ], 2),
        k("div", pbe, [
          k("div", mbe, [
            k("h3", gbe, j(n.title), 1),
            n.isNew ? (_(), O("span", vbe, j(r.t("new_badge")), 1)) : L("", !0)
          ]),
          k("div", bbe, [
            k("span", {
              class: Pe([
                "inline-block rounded-full px-2 py-0.5 text-xs font-bold uppercase tracking-wide",
                n.highlighted ? "bg-primary-light text-primary-dark" : "bg-gray-100 text-gray-500"
              ])
            }, j(n.subtitle || r.t("default_subtitle")), 3),
            xe(e.$slots, "tags")
          ])
        ])
      ]),
      k("p", _be, j(n.text), 1),
      k("div", ybe, [
        xe(e.$slots, "card-footer")
      ])
    ])
  ], 2);
}
typeof hP == "function" && hP(HR);
const wbe = /* @__PURE__ */ we(HR, [["render", xbe]]);
function pP(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "",
    resource: {
      fr: {
        subscription_guide_title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Réaliser une souscription" } },
        subscription_guide_text: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Guide de vente pour la Garantie Dommages Esthétiques." } },
        subscription_guide_modal_title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Guide : Réaliser une souscription" } },
        offer_details_title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "L'offre en détail" } },
        offer_details_text: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Découvrez les détails de l'offre Garantie Dommages Esthétiques." } },
        offer_details_modal_title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Guide : L'offre en détail" } },
        claim_journey_title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Parcours sinistre" } },
        claim_journey_text: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Le parcours sinistre pour la Garantie Dommages Esthétiques." } },
        claim_journey_modal_title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Guide : Parcours sinistre" } },
        roles_title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Qui fait quoi" } },
        roles_text: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Résumé des responsabilités entre le partenaire et Estaly." } },
        roles_modal_title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Guide : Qui fait quoi" } },
        consult_button: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Consulter" } },
        bv_plv_title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "PLV" } },
        bv_plv_text: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Supports de PLV pour l'extension de garantie." } },
        bv_plv_modal_title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Guide : PLV" } },
        bv_book_formation_title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Book de formation" } },
        bv_book_formation_text: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Book de formation pour l'extension de garantie Bureau Vallée." } },
        bv_book_formation_modal_title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Guide : Book de formation" } },
        module_subtitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Module de formation" } },
        start_module_button: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Commencer le module" } },
        module_quiz_tag: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3, v: "Quiz · " }, { t: 4, k: "count" }, { t: 3, v: " question" }] }, { t: 2, i: [{ t: 3, v: "Quiz · " }, { t: 4, k: "count" }, { t: 3, v: " questions" }] }] } }
      },
      en: {
        subscription_guide_title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Complete a subscription" } },
        subscription_guide_text: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Sales guide for the Aesthetic Damage Warranty." } },
        subscription_guide_modal_title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Guide: Complete a subscription" } },
        offer_details_title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Offer details" } },
        offer_details_text: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Discover the details of the Aesthetic Damage Warranty offer." } },
        offer_details_modal_title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Guide: Offer details" } },
        claim_journey_title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Claim journey" } },
        claim_journey_text: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "The claim journey for the Aesthetic Damage Warranty." } },
        claim_journey_modal_title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Guide: Claim journey" } },
        roles_title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Who does what" } },
        roles_text: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Summary of responsibilities between the partner and Estaly." } },
        roles_modal_title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Guide: Who does what" } },
        consult_button: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Consult" } },
        bv_plv_title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "POS Materials" } },
        bv_plv_text: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "POS materials for the warranty extension." } },
        bv_plv_modal_title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Guide: POS Materials" } },
        bv_book_formation_title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Training book" } },
        bv_book_formation_text: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Training book for the Bureau Vallée warranty extension." } },
        bv_book_formation_modal_title: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Guide: Training book" } },
        module_subtitle: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Training module" } },
        start_module_button: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Start the module" } },
        module_quiz_tag: { t: 0, b: { t: 1, c: [{ t: 2, i: [{ t: 3, v: "Quiz · " }, { t: 4, k: "count" }, { t: 3, v: " question" }] }, { t: 2, i: [{ t: 3, v: "Quiz · " }, { t: 4, k: "count" }, { t: 3, v: " questions" }] }] } }
      }
    }
  });
}
const GR = {
  name: "Training",
  emits: ["open-module"],
  props: {
    showSalesGuide: {
      type: Boolean,
      default: !0
    },
    showSeatsFurnitureGuides: {
      type: Boolean,
      default: !1
    },
    showBvWarrantyExtensionGuides: {
      type: Boolean,
      default: !1
    },
    trainingModules: {
      type: Array,
      default: () => []
    }
  },
  setup() {
    const { t: e } = nr();
    return { t: e };
  },
  components: {
    TrainingMaterial: wbe,
    FullScreenModal: Pde,
    FileFrame: lbe,
    VideoFrame: tbe,
    GenericButton: kn,
    SecondaryButton: lR,
    AcademicCapIcon: sB,
    ClipboardCheckIcon: aB,
    DocumentTextIcon: ip,
    PlayIcon: iB
  },
  data() {
    return {
      pdfModalOpen: !1,
      videoModalOpen: !1,
      pdfModalUrl: "",
      videoModalUrl: "",
      pdfModalTitle: "",
      videoModalTitle: "",
      originalPdfUrl: ""
    };
  },
  methods: {
    openPdfModal(e, t) {
      this.originalPdfUrl = e, this.pdfModalUrl = `https://docs.google.com/viewer?url=${encodeURIComponent(e)}&embedded=true`, this.pdfModalTitle = t, this.pdfModalOpen = !0;
    },
    closePdfModal() {
      this.pdfModalOpen = !1, this.pdfModalUrl = "", this.pdfModalTitle = "", this.originalPdfUrl = "";
    },
    openVideoModal(e, t) {
      this.videoModalUrl = e, this.videoModalTitle = t, this.videoModalOpen = !0;
    },
    closeVideoModal() {
      this.videoModalOpen = !1, this.videoModalUrl = "", this.videoModalTitle = "";
    }
  }
}, kbe = { class: "grid grid-cols-1 md:grid-cols-2 gap-6" }, Sbe = { class: "inline-flex items-center rounded-full bg-white border border-primary-light px-2.5 py-0.5 text-xs font-medium text-gray-700" };
function Cbe(e, t, n, r, i, a) {
  const s = U("AcademicCapIcon"), o = U("ClipboardCheckIcon"), l = U("PlayIcon"), c = U("GenericButton"), f = U("TrainingMaterial"), h = U("DocumentTextIcon"), p = U("SecondaryButton"), g = U("FileFrame"), v = U("FullScreenModal"), y = U("VideoFrame");
  return _(), O("div", null, [
    k("div", kbe, [
      (_(!0), O(Re, null, Ke(n.trainingModules, (S) => (_(), ae(f, {
        key: `module-${S.id}`,
        title: S.title,
        text: S.description,
        subtitle: r.t("module_subtitle"),
        highlighted: ""
      }, Gr({
        icon: ie(() => [
          W(s, { class: "h-7 w-7 text-primary-dark" })
        ]),
        "card-footer": ie(() => [
          W(c, {
            onClick: (x) => e.$emit("open-module", S)
          }, {
            default: ie(() => [
              W(l, { class: "h-4 w-4 mr-2" }),
              Me(" " + j(r.t("start_module_button")), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 2
      }, [
        S.hasQuiz ? {
          name: "tags",
          fn: ie(() => [
            k("span", Sbe, [
              W(o, { class: "h-3.5 w-3.5 mr-1 text-primary" }),
              Me(" " + j(r.t("module_quiz_tag", S.questionsCount)), 1)
            ])
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["title", "text", "subtitle"]))), 128)),
      n.showBvWarrantyExtensionGuides ? (_(), ae(f, {
        key: 0,
        title: r.t("bv_book_formation_title"),
        text: r.t("bv_book_formation_text")
      }, {
        "card-footer": ie(() => [
          W(c, {
            onClick: t[0] || (t[0] = (S) => a.openPdfModal(
              "https://estaly-docs.s3.eu-west-3.amazonaws.com/insurance-docs/Book_Extension_Garantie_BV.pdf",
              r.t("bv_book_formation_modal_title")
            ))
          }, {
            default: ie(() => [
              W(h, { class: "h-4 w-4 mr-2" }),
              Me(" " + j(r.t("consult_button")), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["title", "text"])) : L("", !0),
      n.showSeatsFurnitureGuides ? (_(), ae(f, {
        key: 1,
        title: r.t("subscription_guide_title"),
        text: r.t("subscription_guide_text")
      }, {
        "card-footer": ie(() => [
          W(c, {
            onClick: t[1] || (t[1] = (S) => a.openPdfModal(
              "https://estaly-docs.s3.eu-west-3.amazonaws.com/insurance-docs/Guide+de+Vente+%E2%80%93+Garantie+Dommages+Esthe%CC%81tiques+BUT.pdf",
              r.t("subscription_guide_modal_title")
            ))
          }, {
            default: ie(() => [
              W(h, { class: "h-4 w-4 mr-2" }),
              Me(" " + j(r.t("consult_button")), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["title", "text"])) : L("", !0),
      n.showSeatsFurnitureGuides ? (_(), ae(f, {
        key: 2,
        title: r.t("offer_details_title"),
        text: r.t("offer_details_text")
      }, {
        "card-footer": ie(() => [
          W(c, {
            onClick: t[2] || (t[2] = (S) => a.openPdfModal(
              "https://estaly-docs.s3.eu-west-3.amazonaws.com/insurance-docs/L%27offre+en+de%CC%81tail+%E2%80%94+Garantie+Dommages+Esthe%CC%81tiques.pdf",
              r.t("offer_details_modal_title")
            ))
          }, {
            default: ie(() => [
              W(h, { class: "h-4 w-4 mr-2" }),
              Me(" " + j(r.t("consult_button")), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["title", "text"])) : L("", !0),
      n.showSeatsFurnitureGuides ? (_(), ae(f, {
        key: 3,
        title: r.t("claim_journey_title"),
        text: r.t("claim_journey_text")
      }, {
        "card-footer": ie(() => [
          W(c, {
            onClick: t[3] || (t[3] = (S) => a.openPdfModal(
              "https://estaly-docs.s3.eu-west-3.amazonaws.com/insurance-docs/Parcours+sinistre+%E2%80%94+Garantie+Dommages+Esthe%CC%81tiques.pdf",
              r.t("claim_journey_modal_title")
            ))
          }, {
            default: ie(() => [
              W(h, { class: "h-4 w-4 mr-2" }),
              Me(" " + j(r.t("consult_button")), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["title", "text"])) : L("", !0),
      n.showSeatsFurnitureGuides ? (_(), ae(f, {
        key: 4,
        title: r.t("roles_title"),
        text: r.t("roles_text")
      }, {
        "card-footer": ie(() => [
          W(c, {
            onClick: t[4] || (t[4] = (S) => a.openPdfModal(
              "https://estaly-docs.s3.eu-west-3.amazonaws.com/insurance-docs/Qui+fait+quoi+%E2%80%94+BUT+vs+Estaly.pdf",
              r.t("roles_modal_title")
            ))
          }, {
            default: ie(() => [
              W(h, { class: "h-4 w-4 mr-2" }),
              Me(" " + j(r.t("consult_button")), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["title", "text"])) : L("", !0),
      n.showSalesGuide ? (_(), ae(f, {
        key: 5,
        title: "Réaliser une vente",
        text: "Découvrez comment faire une vente avec Estaly en moins de 3 minutes."
      }, {
        "card-footer": ie(() => [
          W(c, {
            onClick: t[5] || (t[5] = (S) => a.openPdfModal(
              "https://estaly-docs.s3.eu-west-3.amazonaws.com/support/realiser-une-vente.pdf",
              "Guide : Réaliser une vente"
            ))
          }, {
            default: ie(() => [
              W(h, { class: "h-4 w-4 mr-2" }),
              t[9] || (t[9] = Me(" Consulter ", -1))
            ]),
            _: 1
          }),
          W(p, {
            onClick: t[6] || (t[6] = (S) => a.openVideoModal(
              "https://www.youtube.com/embed/G86fowe_hes",
              "Vidéo : Réaliser une vente"
            ))
          }, {
            default: ie(() => [
              W(l, { class: "h-4 w-4 mr-2" }),
              t[10] || (t[10] = Me(" Regarder la vidéo ", -1))
            ]),
            _: 1
          })
        ]),
        _: 1
      })) : L("", !0),
      n.showBvWarrantyExtensionGuides ? (_(), ae(f, {
        key: 6,
        title: r.t("bv_plv_title"),
        text: r.t("bv_plv_text")
      }, {
        "card-footer": ie(() => [
          W(c, {
            onClick: t[7] || (t[7] = (S) => a.openPdfModal(
              "https://estaly-docs.s3.eu-west-3.amazonaws.com/insurance-docs/BV_PLV.pdf",
              r.t("bv_plv_modal_title")
            ))
          }, {
            default: ie(() => [
              W(h, { class: "h-4 w-4 mr-2" }),
              Me(" " + j(r.t("consult_button")), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["title", "text"])) : L("", !0),
      W(f, {
        title: "Placement PLV",
        text: "Apprenez à utiliser efficacement la PLV pour capter l'attention des clients."
      }, {
        "card-footer": ie(() => [
          W(c, {
            onClick: t[8] || (t[8] = (S) => a.openPdfModal(
              "https://estaly-docs.s3.eu-west-3.amazonaws.com/support/usage-de-la-plv.pdf",
              "Guide : Placement PLV"
            ))
          }, {
            default: ie(() => [
              W(h, { class: "h-4 w-4 mr-2" }),
              t[11] || (t[11] = Me(" Consulter ", -1))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    W(v, {
      open: i.pdfModalOpen,
      "content-class": "max-w-full",
      onClose: a.closePdfModal
    }, {
      default: ie(() => [
        W(g, {
          title: i.pdfModalTitle,
          "file-url": i.pdfModalUrl
        }, null, 8, ["title", "file-url"])
      ]),
      _: 1
    }, 8, ["open", "onClose"]),
    W(v, {
      open: i.videoModalOpen,
      "content-class": "max-w-full",
      onClose: a.closeVideoModal
    }, {
      default: ie(() => [
        W(y, {
          title: i.videoModalTitle,
          "video-url": i.videoModalUrl
        }, null, 8, ["title", "video-url"])
      ]),
      _: 1
    }, 8, ["open", "onClose"])
  ]);
}
typeof pP == "function" && pP(GR);
const exe = /* @__PURE__ */ we(GR, [["render", Cbe]]), Tbe = {
  name: "TieredProgressBar",
  components: { CheckCircleIcon: n0 },
  props: {
    markers: {
      type: Array,
      required: !0,
      validator: (e) => Array.isArray(e) && e.length > 0
    },
    currentValue: {
      type: Number,
      required: !0,
      default: 0
    },
    // Configurable property keys for accessing marker data
    thresholdKey: {
      type: String,
      default: "threshold"
    },
    idKey: {
      type: String,
      default: null
      // Will use index if not provided
    },
    labelKey: {
      type: String,
      default: "label"
    },
    /** Quand true, retire le padding-right (usage barre seule sans labels/pill) */
    compact: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    sortedMarkers() {
      return [...this.markers].sort((e, t) => {
        const n = Number(e[this.thresholdKey]) || 0, r = Number(t[this.thresholdKey]) || 0;
        return n - r;
      });
    },
    sortedMarkersDesc() {
      return [...this.markers].sort((e, t) => {
        const n = Number(e[this.thresholdKey]) || 0;
        return (Number(t[this.thresholdKey]) || 0) - n;
      });
    },
    maxThreshold() {
      return this.markers.length === 0 ? 0 : Number(this.sortedMarkersDesc[0][this.thresholdKey]) || 0;
    },
    reachedMarker() {
      return this.sortedMarkersDesc.find((e) => this.currentValue >= Number(e[this.thresholdKey] || 0)) || null;
    },
    nextMarker() {
      if (!this.reachedMarker)
        return this.sortedMarkers[0] || null;
      const e = this.sortedMarkers.findIndex(
        (n) => this.getMarkerId(n) === this.getMarkerId(this.reachedMarker)
      ), t = this.sortedMarkers[e + 1];
      return !t && this.reachedMarker ? null : t || null;
    },
    currentProgressPercentage() {
      return this.maxThreshold === 0 ? 0 : Math.min(100, this.currentValue / this.maxThreshold * 100);
    },
    // Build segments between markers (0 -> m1, m1 -> m2, ..., last -> max)
    segments() {
      const e = [0, ...this.sortedMarkers.map((r) => Number(r[this.thresholdKey] || 0))], t = [], n = this.maxThreshold || 1;
      for (let r = 0; r < e.length - 1; r++) {
        const i = e[r], a = e[r + 1], s = (a - i) / n * 100, o = this.currentValue >= a, l = !o && this.currentValue > i && this.currentValue < a ? (this.currentValue - i) / (a - i) * 100 : 0;
        t.push({ start: i, end: a, width: s, filled: o, partial: l });
      }
      return t;
    }
  },
  methods: {
    getMarkerId(e, t) {
      return this.idKey && e[this.idKey] !== void 0 ? e[this.idKey] : t !== void 0 ? t : JSON.stringify(e);
    },
    getMarkerLabel(e, t) {
      return this.labelKey && e[this.labelKey] !== void 0 ? e[this.labelKey] : `Étape ${t + 1}`;
    },
    getMarkerThreshold(e) {
      return Number(e[this.thresholdKey]) || 0;
    },
    isReached(e) {
      return this.currentValue >= this.getMarkerThreshold(e);
    },
    isNextMarker(e) {
      return this.nextMarker ? this.getMarkerId(e) === this.getMarkerId(this.nextMarker) : !1;
    },
    getMarkerPosition(e) {
      const t = this.maxThreshold || 1;
      return this.getMarkerThreshold(e) / t * 100;
    },
    // Style to partially fill a segment if current falls inside it
    segmentFillStyle(e) {
      return e.filled ? { width: "100%" } : e.partial > 0 ? { width: `${e.partial}%` } : { width: "0%" };
    }
  }
}, Abe = { class: "p-6 pb-10 bg-gray-50 overflow-x-visible" }, Dbe = { class: "relative min-h-[60px]" }, Ebe = { class: "relative h-4 rounded-full bg-gray-200 overflow-visible ring-1 ring-gray-200 w-full" }, Pbe = {
  class: "absolute inset-0 flex",
  style: { width: "100%" }
}, Obe = {
  key: 0,
  class: "absolute top-0 bottom-0"
}, Mbe = {
  key: 0,
  class: "w-2.5 h-2.5 rounded-full bg-blue-600"
}, Ibe = {
  key: 2,
  class: "w-2.5 h-2.5 rounded-full bg-gray-400"
}, Rbe = { class: "px-3 py-1.5 rounded-full text-xs font-bold bg-white shadow-lg ring-2 ring-primary-lighter whitespace-nowrap" };
function Fbe(e, t, n, r, i, a) {
  const s = U("CheckCircleIcon");
  return _(), O("div", Abe, [
    k("div", {
      class: "relative",
      style: Zn(n.compact ? {} : { paddingRight: "80px" })
    }, [
      k("div", Dbe, [
        (_(!0), O(Re, null, Ke(a.sortedMarkers, (o, l) => (_(), O("div", {
          key: `label-${a.getMarkerId(o, l)}`,
          class: Pe(["absolute text-center", a.isNextMarker(o) ? "z-10" : "z-0"]),
          style: Zn({ left: `${a.getMarkerPosition(o)}%`, transform: "translateX(-50%)" })
        }, [
          k("div", {
            class: Pe(["px-3 py-1 rounded-lg border shadow-xs whitespace-nowrap", {
              "bg-blue-50 border-blue-600": a.isNextMarker(o),
              "bg-green-50 border-green-300": a.isReached(o) && !a.isNextMarker(o),
              "bg-white border-gray-200 opacity-70": !a.isReached(o) && !a.isNextMarker(o)
            }])
          }, [
            xe(e.$slots, "marker-label", {
              marker: o,
              isReached: a.isReached(o),
              isNext: a.isNextMarker(o)
            }, () => [
              k("div", {
                class: Pe(["text-xs font-semibold", {
                  "text-blue-600": a.isNextMarker(o),
                  "text-green-700": a.isReached(o) && !a.isNextMarker(o),
                  "text-gray-600": !a.isReached(o) && !a.isNextMarker(o)
                }])
              }, j(a.getMarkerLabel(o, l)), 3),
              k("div", {
                class: Pe(["text-sm font-bold tabular-nums", {
                  "text-blue-600": a.isNextMarker(o),
                  "text-green-600": a.isReached(o) && !a.isNextMarker(o),
                  "text-gray-700": !a.isReached(o) && !a.isNextMarker(o)
                }])
              }, j(a.getMarkerThreshold(o)), 3)
            ])
          ], 2)
        ], 6))), 128))
      ]),
      k("div", Ebe, [
        k("div", Pbe, [
          (_(!0), O(Re, null, Ke(a.segments, (o, l) => (_(), O("div", {
            key: `seg-${l}`,
            class: "relative h-full",
            style: Zn({ width: `${o.width}%` })
          }, [
            k("div", {
              class: "h-full transition-all rounded-none bg-yellow-100",
              style: Zn(a.segmentFillStyle(o))
            }, null, 4),
            l > 0 ? (_(), O("div", Obe)) : L("", !0)
          ], 4))), 128))
        ]),
        (_(!0), O(Re, null, Ke(a.sortedMarkers, (o, l) => (_(), O("div", {
          key: `dot-${a.getMarkerId(o, l)}`,
          class: Pe(["absolute rounded-full border-2 flex items-center justify-center transition-all", [
            a.isNextMarker(o) ? "z-10" : "z-0",
            {
              "bg-white border-blue-600": a.isNextMarker(o),
              "bg-green-500 border-green-600 shadow-md": a.isReached(o) && !a.isNextMarker(o),
              "bg-white border-gray-400 opacity-60": !a.isReached(o) && !a.isNextMarker(o)
            }
          ]]),
          style: Zn({ left: `${a.getMarkerPosition(o)}%`, transform: "translateX(-50%)" })
        }, [
          a.isNextMarker(o) ? (_(), O("div", Mbe)) : a.isReached(o) ? (_(), ae(s, {
            key: 1,
            class: "w-3.5 h-3.5 text-white"
          })) : (_(), O("div", Ibe))
        ], 6))), 128)),
        a.currentProgressPercentage > 0 ? (_(), O("div", {
          key: 0,
          class: "absolute",
          style: Zn({ left: `${Math.min(a.currentProgressPercentage, 100)}%`, transform: "translateX(-50%)" })
        }, [...t[0] || (t[0] = [
          k("div", { class: "w-0 h-0 border-transparent" }, null, -1)
        ])], 4)) : L("", !0)
      ]),
      k("div", {
        class: "absolute -bottom-8 left-0 right-0 flex justify-start",
        style: Zn(n.compact ? {} : { paddingRight: "80px" })
      }, [
        k("div", {
          class: "relative",
          style: Zn({ left: `${Math.min(a.currentProgressPercentage, 100)}%`, transform: "translateX(-50%)" })
        }, [
          xe(e.$slots, "current-value", {
            currentValue: n.currentValue,
            reachedMarker: a.reachedMarker
          }, () => [
            k("div", Rbe, j(n.currentValue), 1)
          ])
        ], 4)
      ], 4)
    ], 4)
  ]);
}
const txe = /* @__PURE__ */ we(Tbe, [["render", Fbe]]), Nbe = {
  computed: {
    hasHeader() {
      return !!(this.title || this.subtitle || this.emoji || this.$slots.title || this.$slots.icon || this.$slots.actions || this.$slots.subtitle);
    }
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    },
    emoji: {
      type: String,
      default: ""
    },
    badgeClass: {
      type: String,
      default: ""
    }
  }
}, Lbe = { class: "bg-white rounded-2xl shadow-xl ring-1 ring-gray-100 overflow-hidden" }, $be = {
  key: 0,
  class: "px-6 py-4 flex flex-wrap items-center rounded-t-2xl justify-between gap-3"
}, Vbe = { class: "flex min-w-0 items-center gap-3" }, Bbe = {
  key: 0,
  class: "text-xl"
}, Ube = { class: "flex min-w-0 flex-col" }, qbe = {
  key: 0,
  class: "text-lg sm:text-xl font-bold tracking-tight text-black"
}, jbe = {
  key: 0,
  class: "text-sm text-gray-600"
};
function Wbe(e, t, n, r, i, a) {
  return _(), O("div", Lbe, [
    a.hasHeader ? (_(), O("div", $be, [
      k("div", Vbe, [
        k("div", {
          class: Pe(["flex shrink-0 items-center justify-center w-10 h-10 rounded-lg", n.badgeClass])
        }, [
          xe(e.$slots, "icon", {}, () => [
            n.emoji ? (_(), O("span", Bbe, j(n.emoji), 1)) : L("", !0)
          ])
        ], 2),
        k("div", Ube, [
          xe(e.$slots, "title", {}, () => [
            n.title ? (_(), O("h3", qbe, j(n.title), 1)) : L("", !0)
          ]),
          xe(e.$slots, "subtitle", {}, () => [
            n.subtitle ? (_(), O("p", jbe, j(n.subtitle), 1)) : L("", !0)
          ])
        ])
      ]),
      xe(e.$slots, "actions")
    ])) : L("", !0),
    xe(e.$slots, "default")
  ]);
}
const nxe = /* @__PURE__ */ we(Nbe, [["render", Wbe]]), zbe = {
  props: {
    items: {
      type: Array,
      required: !0
    },
    keyField: {
      type: String,
      default: null
    },
    rowClass: {
      type: Function,
      default: null
    }
  }
}, Hbe = { class: "px-6 pb-4" }, Gbe = { class: "border border-gray-200 rounded-lg divide-y divide-gray-200" };
function Ybe(e, t, n, r, i, a) {
  return _(), O("div", Hbe, [
    k("div", Gbe, [
      (_(!0), O(Re, null, Ke(n.items, (s, o) => (_(), O("div", {
        key: n.keyField ? s[n.keyField] : o,
        class: Pe(["flex items-center justify-between px-3.5 py-2.5 text-xs text-gray-700", n.rowClass ? n.rowClass(s) : ""])
      }, [
        xe(e.$slots, "default", {
          item: s,
          index: o
        })
      ], 2))), 128))
    ])
  ]);
}
const rxe = /* @__PURE__ */ we(zbe, [["render", Ybe]]), Kbe = {
  name: "Banner",
  props: {
    text: {
      type: String,
      required: !0
    },
    route: {
      type: [String, Object],
      default: null
    },
    bgClass: {
      type: String,
      default: "bg-soft-yellow"
    },
    textColorClass: {
      type: String,
      default: "text-black"
    },
    icons: {
      type: Array,
      default: () => []
    },
    customClasses: {
      type: String,
      default: ""
    }
  },
  methods: {
    handleClick() {
      this.route ? this.$router.push(this.route) : this.$emit("click");
    }
  }
}, Xbe = { class: "flex items-center justify-center space-x-3" }, Zbe = {
  key: 0,
  class: "flex items-center space-x-2"
}, Qbe = { class: "font-semibold text-sm uppercase tracking-wide text-center" };
function Jbe(e, t, n, r, i, a) {
  var s;
  return _(), O("div", {
    class: Pe([[n.bgClass, n.textColorClass, n.customClasses], "p-2 cursor-pointer text-black hover:shadow-md transition-all duration-300 ease-in-out border-l-4 border-primary"]),
    onClick: t[0] || (t[0] = (...o) => a.handleClick && a.handleClick(...o))
  }, [
    k("div", Xbe, [
      ((s = n.icons) == null ? void 0 : s.length) > 0 ? (_(), O("div", Zbe, [
        (_(!0), O(Re, null, Ke(n.icons, (o, l) => (_(), O("span", {
          key: l,
          class: "text-lg"
        }, j(o), 1))), 128))
      ])) : L("", !0),
      k("p", Qbe, j(n.text), 1),
      t[1] || (t[1] = k("div", { class: "flex items-center" }, [
        k("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [
          k("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 5l7 7-7 7"
          })
        ])
      ], -1))
    ])
  ], 2);
}
const ixe = /* @__PURE__ */ we(Kbe, [["render", Jbe]]), e_e = {
  props: {
    height: {
      type: String,
      required: !0
    },
    variant: {
      type: String,
      default: "solid",
      validator: (e) => ["solid", "projected", "target"].includes(e)
    },
    color: {
      type: String,
      default: "#ECD9FF"
    }
  },
  computed: {
    barClass() {
      return this.variant === "solid" ? "bg-primary" : this.variant === "target" ? "bg-gray-200" : "";
    },
    barStyle() {
      const e = { height: this.height };
      return this.variant === "projected" ? {
        ...e,
        background: `repeating-linear-gradient(45deg, ${this.color}, ${this.color} 4px, transparent 4px, transparent 8px)`
      } : e;
    }
  }
};
function t_e(e, t, n, r, i, a) {
  return _(), O("div", {
    class: Pe(["w-4 rounded-t-[5px]", a.barClass]),
    style: Zn(a.barStyle)
  }, null, 6);
}
const axe = /* @__PURE__ */ we(e_e, [["render", t_e]]), n_e = {
  props: {
    voucher: {
      type: Object,
      required: !0
    }
  },
  components: {
    StackedField: yp
  },
  methods: {
    formatPrice: Si
  }
}, r_e = { class: "relative bg-white rounded-2xl shadow-md p-6 mx-auto" }, i_e = { class: "grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-2" }, a_e = ["href"];
function s_e(e, t, n, r, i, a) {
  const s = U("StackedField");
  return _(), O("div", null, [
    k("div", r_e, [
      k("div", i_e, [
        W(s, {
          label: "Titre",
          value: n.voucher.title
        }, null, 8, ["value"]),
        W(s, {
          label: "Code",
          value: n.voucher.code
        }, null, 8, ["value"]),
        W(s, {
          label: "Date d'utilisation",
          value: n.voucher.usageDate
        }, null, 8, ["value"]),
        W(s, {
          label: "Montant",
          value: a.formatPrice(n.voucher.amount)
        }, null, 8, ["value"]),
        W(s, {
          label: "Utilisable jusqu'à",
          value: n.voucher.endValidityDate
        }, null, 8, ["value"]),
        n.voucher.pdfUrl ? (_(), ae(s, {
          key: 0,
          label: "PDF"
        }, {
          default: ie(() => [
            k("a", {
              href: n.voucher.pdfUrl,
              target: "_blank",
              rel: "noopener noreferrer",
              class: "text-sm text-blue-500 underline cursor-pointer"
            }, " Télécharger le PDF ", 8, a_e)
          ]),
          _: 1
        })) : L("", !0)
      ])
    ])
  ]);
}
const sxe = /* @__PURE__ */ we(n_e, [["render", s_e]]), o_e = {
  name: "CountryListboxField",
  components: {
    Listbox: EO,
    ListboxButton: PO,
    ListboxOption: MO,
    ListboxOptions: OO,
    ChevronDownIcon: Qc
  },
  props: {
    modelValue: { type: String, default: "" },
    label: { type: String, default: "" },
    placeholder: { type: String, default: "Sélectionner un pays" },
    required: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  computed: {
    inputId() {
      return `country-${this.label.replace(/\./g, "-")}`;
    },
    sortedCountries() {
      const e = [...bM], t = e.find((i) => i.code === "FR"), n = e.filter((i) => i.code !== "FR").sort((i, a) => i.name.localeCompare(a.name)), r = t ? [t, ...n] : n;
      return [{ code: "", name: "" }, ...r];
    }
  },
  methods: {
    onSelect(e) {
      this.$emit("update:modelValue", e || "");
    }
  }
}, l_e = { class: "flex-1" }, u_e = ["for"], c_e = {
  key: 0,
  class: "ml-1 text-red-600"
}, d_e = { class: "relative" }, f_e = { class: "block truncate" }, h_e = { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2" };
function p_e(e, t, n, r, i, a) {
  const s = U("ChevronDownIcon"), o = U("ListboxButton"), l = U("ListboxOption"), c = U("ListboxOptions"), f = U("Listbox");
  return _(), O("div", l_e, [
    k("label", {
      for: a.inputId,
      class: "block text-sm leading-6 text-gray-900 sm:pt-1.5 mb-1 font-semibold"
    }, [
      Me(j(e.$t(n.label)) + " ", 1),
      n.required ? (_(), O("span", c_e, "*")) : L("", !0)
    ], 8, u_e),
    k("div", d_e, [
      W(f, {
        "model-value": n.modelValue,
        "onUpdate:modelValue": a.onSelect
      }, {
        default: ie(() => [
          W(o, {
            id: a.inputId,
            class: "block w-full rounded-md border-0 border-gray-300 py-2 pl-3 pr-10 text-left text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm cursor-pointer"
          }, {
            default: ie(() => [
              k("span", f_e, j(n.modelValue || n.placeholder), 1),
              k("span", h_e, [
                W(s, {
                  class: "h-4 w-4 text-gray-400",
                  "aria-hidden": "true"
                })
              ])
            ]),
            _: 1
          }, 8, ["id"]),
          W(Ea, {
            "leave-active-class": "transition ease-in duration-100",
            "leave-from-class": "opacity-100",
            "leave-to-class": "opacity-0"
          }, {
            default: ie(() => [
              W(c, { class: "absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-inset ring-gray-300 focus:outline-hidden sm:text-sm" }, {
                default: ie(() => [
                  (_(!0), O(Re, null, Ke(a.sortedCountries, (h) => (_(), ae(l, {
                    key: h.code || "__placeholder__",
                    as: "template",
                    value: h.name || ""
                  }, {
                    default: ie(({ active: p, selected: g }) => [
                      k("li", {
                        class: Pe([
                          g ? "text-white bg-primary" : "text-gray-900",
                          p ? "bg-gray-100" : "",
                          "relative select-none py-2 pl-3 pr-3 cursor-pointer text-sm"
                        ])
                      }, [
                        k("span", {
                          class: Pe([g ? "font-medium" : "font-normal", "block truncate"])
                        }, j(h.name || n.placeholder), 3)
                      ], 2)
                    ]),
                    _: 2
                  }, 1032, ["value"]))), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model-value", "onUpdate:modelValue"])
    ])
  ]);
}
const oxe = /* @__PURE__ */ we(o_e, [["render", p_e]]), m_e = {
  components: {
    CheckIcon: ap,
    ArrowRightIcon: fB
  },
  props: {
    loading: {
      type: Boolean,
      default: !1
    },
    success: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    variant: {
      type: String,
      default: "dark",
      validator: (e) => ["dark", "primary"].includes(e)
    },
    type: {
      type: String,
      default: "submit"
    },
    loadingText: {
      type: String,
      default: ""
    },
    successText: {
      type: String,
      default: ""
    }
  },
  computed: {
    buttonClasses() {
      return this.success ? "bg-green-600 cursor-default" : this.loading ? this.variantBg + " cursor-wait opacity-80" : this.variantBg + " " + this.variantHover;
    },
    variantBg() {
      return this.variant === "primary" ? "bg-primary" : "bg-gray-900";
    },
    variantHover() {
      return this.variant === "primary" ? "hover:bg-primary-dark" : "hover:bg-gray-800";
    }
  }
}, g_e = ["type", "disabled"];
function v_e(e, t, n, r, i, a) {
  const s = U("CheckIcon"), o = U("ArrowRightIcon");
  return _(), O("button", {
    type: n.type,
    disabled: n.disabled || n.loading || n.success,
    class: Pe(["w-full flex items-center justify-center gap-2 rounded-xl px-5 py-3 text-sm font-semibold text-white transition-all duration-200", a.buttonClasses])
  }, [
    n.success ? (_(), O(Re, { key: 0 }, [
      W(s, { class: "h-5 w-5" }),
      k("span", null, [
        xe(e.$slots, "success-text", {}, () => [
          Me(j(n.successText), 1)
        ])
      ])
    ], 64)) : n.loading ? (_(), O(Re, { key: 1 }, [
      t[0] || (t[0] = k("span", { class: "h-5 w-5 animate-spin rounded-full border-2 border-current" }, null, -1)),
      k("span", null, [
        xe(e.$slots, "loading-text", {}, () => [
          Me(j(n.loadingText), 1)
        ])
      ])
    ], 64)) : (_(), O(Re, { key: 2 }, [
      k("span", null, [
        xe(e.$slots, "default")
      ]),
      xe(e.$slots, "trailing-icon", {}, () => [
        W(o, { class: "h-4 w-4" })
      ])
    ], 64))
  ], 10, g_e);
}
const lxe = /* @__PURE__ */ we(m_e, [["render", v_e]]), b_e = {
  components: {
    Field: cu,
    ErrorMessage: K5
  },
  props: {
    id: {
      type: String,
      required: !0
    },
    name: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    modelValue: {
      default: ""
    },
    required: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    autocomplete: {
      type: String,
      default: ""
    },
    wrapperClass: {
      type: String,
      default: "mb-5"
    }
  },
  emits: ["update:modelValue"],
  computed: {
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(e) {
        this.$emit("update:modelValue", e);
      }
    }
  }
}, __e = ["for"], y_e = {
  key: 0,
  class: "text-red-600"
}, x_e = {
  key: 1,
  class: "flex items-center rounded-xl border border-gray-200 bg-white transition-colors focus-within:border-gray-900"
}, w_e = { class: "px-3" };
function k_e(e, t, n, r, i, a) {
  const s = U("Field"), o = U("ErrorMessage");
  return _(), O("div", {
    class: Pe(n.wrapperClass)
  }, [
    n.label ? (_(), O("label", {
      key: 0,
      for: n.id,
      class: "block text-sm font-medium text-gray-900 mb-1.5"
    }, [
      Me(j(n.label) + " ", 1),
      n.required ? (_(), O("span", y_e, "*")) : L("", !0)
    ], 8, __e)) : L("", !0),
    e.$slots.suffix ? (_(), O("div", x_e, [
      W(s, {
        id: n.id,
        name: n.name || n.id,
        type: n.type,
        autocomplete: n.autocomplete,
        placeholder: n.placeholder,
        disabled: n.disabled,
        modelValue: a.internalValue,
        "onUpdate:modelValue": t[0] || (t[0] = (l) => a.internalValue = l),
        class: "block w-full bg-transparent px-4 py-3 text-sm text-gray-900 border-none focus:outline-hidden focus:ring-0 focus:shadow-none"
      }, null, 8, ["id", "name", "type", "autocomplete", "placeholder", "disabled", "modelValue"]),
      k("div", w_e, [
        xe(e.$slots, "suffix")
      ])
    ])) : (_(), ae(s, {
      key: 2,
      id: n.id,
      name: n.name || n.id,
      type: n.type,
      autocomplete: n.autocomplete,
      placeholder: n.placeholder,
      disabled: n.disabled,
      modelValue: a.internalValue,
      "onUpdate:modelValue": t[1] || (t[1] = (l) => a.internalValue = l),
      class: "block w-full rounded-xl border border-gray-200 bg-white px-4 py-3 text-sm text-gray-900 transition-colors focus:outline-hidden focus:border-gray-900"
    }, null, 8, ["id", "name", "type", "autocomplete", "placeholder", "disabled", "modelValue"])),
    W(o, {
      name: n.name || n.id,
      class: "mt-1.5 text-xs text-red-600"
    }, null, 8, ["name"])
  ], 2);
}
const uxe = /* @__PURE__ */ we(b_e, [["render", k_e]]), S_e = {
  props: {
    padding: {
      type: String,
      default: "p-8 md:p-11"
    }
  }
};
function C_e(e, t, n, r, i, a) {
  return _(), O("div", {
    class: Pe([
      "w-full max-w-md mx-auto bg-white rounded-2xl border border-gray-200 shadow-lg",
      n.padding
    ])
  }, [
    xe(e.$slots, "default")
  ], 2);
}
const cxe = /* @__PURE__ */ we(S_e, [["render", C_e]]), T_e = {}, A_e = {
  class: "absolute inset-0 pointer-events-none",
  style: { background: `radial-gradient(
        ellipse 60% 50% at 50% 0%,
        rgba(180, 108, 254, 0.12) 0%,
        transparent 70%
      )` }
};
function D_e(e, t) {
  return _(), O("div", A_e);
}
const dxe = /* @__PURE__ */ we(T_e, [["render", D_e]]), E_e = {
  components: {
    EyeIcon: TP,
    EyeOffIcon: oB
  },
  props: {
    visible: {
      type: Boolean,
      required: !0
    },
    showLabel: {
      type: String,
      default: "Show password"
    },
    hideLabel: {
      type: String,
      default: "Hide password"
    }
  },
  emits: ["toggle"]
}, P_e = ["aria-label", "aria-pressed"];
function O_e(e, t, n, r, i, a) {
  const s = U("EyeIcon"), o = U("EyeOffIcon");
  return _(), O("button", {
    type: "button",
    class: "text-gray-400 hover:text-gray-700 transition-colors",
    "aria-label": n.visible ? n.hideLabel : n.showLabel,
    "aria-pressed": n.visible,
    onClick: t[0] || (t[0] = (l) => e.$emit("toggle"))
  }, [
    n.visible ? (_(), ae(o, {
      key: 1,
      class: "h-5 w-5"
    })) : (_(), ae(s, {
      key: 0,
      class: "h-5 w-5"
    }))
  ], 8, P_e);
}
const fxe = /* @__PURE__ */ we(E_e, [["render", O_e]]);
function mP(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "",
    resource: {
      fr: {
        close: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Fermer" } }
      },
      en: {
        close: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Close" } }
      }
    }
  });
}
const YR = {
  components: {
    Dialog: P0,
    DialogOverlay: A7,
    DialogTitle: D7,
    TransitionChild: bp,
    TransitionRoot: _p
  },
  props: {
    message: {
      type: Object,
      required: !0
    }
  },
  computed: {
    // Classes complètes (pas d'interpolation) pour que Tailwind les détecte.
    iconColorClasses() {
      return {
        green: { background: "bg-green-100", icon: "text-green-600" },
        red: { background: "bg-red-100", icon: "text-red-600" },
        blue: { background: "bg-blue-100", icon: "text-blue-600" },
        purple: { background: "bg-purple-100", icon: "text-purple-600" }
      }[this.message.iconColor] || {};
    }
  }
}, M_e = { class: "flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }, I_e = { class: "inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full sm:p-6" }, R_e = { class: "mt-3 text-center sm:mt-5" }, F_e = { class: "mt-2" }, N_e = { class: "text-sm text-gray-500" }, L_e = { class: "mt-5 sm:mt-6" };
function $_e(e, t, n, r, i, a) {
  const s = U("DialogOverlay"), o = U("TransitionChild"), l = U("DialogTitle"), c = U("Dialog"), f = U("TransitionRoot");
  return _(), ae(f, {
    as: "template",
    show: !0
  }, {
    default: ie(() => [
      W(c, {
        as: "div",
        class: "fixed z-50 inset-0 overflow-y-auto",
        onClose: t[1] || (t[1] = (h) => e.$emit("close", n.message.id))
      }, {
        default: ie(() => [
          k("div", M_e, [
            W(o, {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: ie(() => [
                W(s, { class: "fixed inset-0 bg-gray-500/75 transition-opacity" })
              ]),
              _: 1
            }),
            t[2] || (t[2] = k("span", {
              class: "hidden sm:inline-block sm:align-middle sm:h-screen",
              "aria-hidden": "true"
            }, "​", -1)),
            W(o, {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
              "enter-to": "opacity-100 translate-y-0 sm:scale-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100 translate-y-0 sm:scale-100",
              "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            }, {
              default: ie(() => [
                k("div", I_e, [
                  k("div", null, [
                    k("div", {
                      class: Pe(["mx-auto flex items-center justify-center h-12 w-12 rounded-full", a.iconColorClasses.background])
                    }, [
                      typeof n.message.iconComponent == "string" ? (_(), ae(Lr("span"), {
                        key: 0,
                        class: "text-2xl",
                        "aria-hidden": "true"
                      }, {
                        default: ie(() => [
                          Me(j(n.message.iconComponent), 1)
                        ]),
                        _: 1
                      })) : (_(), ae(Lr(n.message.iconComponent), {
                        key: 1,
                        class: Pe(["h-6 w-6", a.iconColorClasses.icon]),
                        "aria-hidden": "true"
                      }, null, 8, ["class"]))
                    ], 2),
                    k("div", R_e, [
                      W(l, {
                        as: "h3",
                        class: "text-lg leading-6 font-medium text-gray-900"
                      }, {
                        default: ie(() => [
                          Me(j(e.$t(n.message.title)), 1)
                        ]),
                        _: 1
                      }),
                      k("div", F_e, [
                        k("p", N_e, j(e.$t(n.message.text)), 1)
                      ])
                    ])
                  ]),
                  k("div", L_e, [
                    k("button", {
                      type: "button",
                      class: "inline-flex justify-center w-full rounded-md border border-transparent shadow-xs px-4 py-2 text-button-font-primary bg-primary text-base font-medium text-white focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-primary sm:text-sm",
                      onClick: t[0] || (t[0] = (h) => e.$emit("close", n.message.id))
                    }, j(e.$t("close")), 1)
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  });
}
typeof mP == "function" && mP(YR);
const V_e = /* @__PURE__ */ we(YR, [["render", $_e]]);
function gP(e) {
  const t = e;
  t.__i18n = t.__i18n || [], t.__i18n.push({
    locale: "",
    resource: {
      fr: {
        close: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Fermer" } }
      },
      en: {
        close: { t: 0, b: { t: 2, i: [{ t: 3 }], s: "Close" } }
      }
    }
  });
}
const KR = {
  components: { XIcon: EP },
  props: {
    message: { required: !0, type: Object }
  },
  methods: {
    openPath() {
      this.message.path && (this.$router.push(this.message.path), this.$emit("close", this.message.id));
    }
  },
  computed: {
    iconColorClass() {
      return {
        green: "text-green-400",
        red: "text-red-400",
        blue: "text-blue-400",
        purple: "text-purple-400"
      };
    }
  }
}, B_e = { class: "p-4 sm:p-5" }, U_e = { class: "flex items-start gap-3" }, q_e = { class: "shrink-0" }, j_e = { class: "min-w-0 flex-1 whitespace-pre-line" }, W_e = { class: "text-sm font-semibold text-gray-900" }, z_e = {
  key: 0,
  class: "mt-1 text-sm text-gray-600"
}, H_e = { class: "sr-only" };
function G_e(e, t, n, r, i, a) {
  const s = U("XIcon");
  return _(), ae(Ea, {
    "enter-active-class": "transform ease-out duration-300 transition",
    "enter-from-class": "translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2",
    "enter-to-class": "translate-y-0 opacity-100 sm:translate-x-0",
    "leave-active-class": "transition ease-in duration-150",
    "leave-from-class": "opacity-100",
    "leave-to-class": "opacity-0"
  }, {
    default: ie(() => [
      n.message ? (_(), O("div", {
        key: 0,
        role: "status",
        "aria-live": "polite",
        "aria-atomic": "true",
        class: Pe(["pointer-events-auto max-w-sm w-full bg-white shadow-xl rounded-xl ring-1 ring-purple-400 overflow-hidden", { "cursor-pointer": n.message.path }]),
        onClick: t[1] || (t[1] = (...o) => a.openPath && a.openPath(...o))
      }, [
        k("div", B_e, [
          k("div", U_e, [
            k("div", q_e, [
              typeof n.message.iconComponent == "string" ? (_(), ae(Lr("span"), {
                key: 0,
                class: "text-2xl",
                "aria-hidden": "true"
              }, {
                default: ie(() => [
                  Me(j(n.message.iconComponent), 1)
                ]),
                _: 1
              })) : (_(), ae(Lr(n.message.iconComponent), {
                key: 1,
                class: Pe([
                  "h-6 w-6",
                  a.iconColorClass[n.message.iconColor] || "text-gray-400"
                ]),
                "aria-hidden": "true"
              }, null, 8, ["class"]))
            ]),
            k("div", j_e, [
              k("p", W_e, j(e.$t(n.message.title)), 1),
              n.message.text ? (_(), O("p", z_e, j(e.$t(n.message.text)), 1)) : L("", !0)
            ]),
            k("button", {
              onClick: t[0] || (t[0] = sn((o) => e.$emit("close", n.message.id), ["stop"])),
              class: "shrink-0 rounded-md text-gray-400 hover:text-gray-600 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-primary"
            }, [
              k("span", H_e, j(e.$t("close")), 1),
              W(s, {
                class: "h-5 w-5",
                "aria-hidden": "true"
              })
            ])
          ])
        ])
      ], 2)) : L("", !0)
    ]),
    _: 1
  });
}
typeof gP == "function" && gP(KR);
const Y_e = /* @__PURE__ */ we(KR, [["render", G_e]]), K_e = {
  components: {
    ModalNotification: V_e,
    SimpleNotification: Y_e
  },
  computed: {
    lastModalMessage() {
      return this.$store.getters["notifications/lastModalMessage"];
    },
    simpleMessages() {
      return this.$store.getters["notifications/simpleMessages"];
    }
  },
  methods: {
    close(e) {
      this.$store.dispatch("notifications/REMOVE_MESSAGE", e);
    }
  },
  watch: {
    simpleMessages: {
      handler(e) {
        e.length > 0 && (document.getElementById("app").inert = !1);
      }
    }
  }
}, X_e = {
  "aria-live": "assertive",
  class: "fixed inset-0 px-4 pointer-events-none sm:px-6 z-50 flex flex-col items-center sm:items-end sm:pt-6 space-y-4"
};
function Z_e(e, t, n, r, i, a) {
  const s = U("SimpleNotification"), o = U("ModalNotification");
  return _(), O("div", null, [
    k("div", X_e, [
      (_(!0), O(Re, null, Ke(a.simpleMessages, (l) => (_(), ae(s, {
        key: l.id,
        message: l,
        onClose: a.close
      }, null, 8, ["message", "onClose"]))), 128))
    ]),
    a.lastModalMessage ? (_(), ae(o, {
      key: 0,
      message: a.lastModalMessage,
      onClose: a.close
    }, null, 8, ["message", "onClose"])) : L("", !0)
  ]);
}
const hxe = /* @__PURE__ */ we(K_e, [["render", Z_e]]);
function Q_e(e) {
  return e.replace(/([a-z])([A-Z])/g, "$1_$2").replace(/([A-Z])([A-Z][a-z])/g, "$1_$2").toLowerCase().replace(/_/g, "_");
}
function vP(e) {
  return Array.isArray(e) ? e.map((t) => vP(t)) : e !== null && typeof e == "object" ? Object.keys(e).reduce((t, n) => {
    const r = Q_e(n);
    return t[r] = vP(e[n]), t;
  }, {}) : e;
}
function bP(e) {
  return Array.isArray(e) ? e.map((t) => bP(t)) : e !== null && typeof e == "object" ? Object.keys(e).reduce((t, n) => {
    const r = dR.camelCase(n);
    return t[r] = bP(e[n]), t;
  }, {}) : e;
}
function J_e(e) {
  let t = e.replace(/([0-9])([A-Za-z])/g, "$1 $2");
  return t = t.replace(/([A-Z])/g, " $1"), t = t.toLowerCase().replace(/(^|\s)\S/g, (n) => n.toUpperCase()), t.trim();
}
function pxe(e) {
  const t = {};
  for (const n in e)
    if (e.hasOwnProperty(n)) {
      const r = J_e(n);
      t[r] = e[n];
    }
  return t;
}
const XR = (e) => e.message === "Network Error", eye = (e) => e.code === "ECONNABORTED" || e.code === "ETIMEDOUT", tye = (e) => e.code === "ERR_CANCELED" || e.message === "canceled", ZR = (e) => e.response ? e.response.status === 404 : !1, QR = (e) => e.response ? e.response.status === 422 : !1, JR = (e) => e.response ? e.response.status === 403 : !1, Xp = (e) => e.response ? e.response.status === 401 : !1, eF = (e) => e.response ? e.response.status === 406 : !1, tF = (e) => e.response ? e.response.status === 409 : !1, nF = (e) => !!e.response && e.response.status === 503, nye = (e) => !!e.response && e.response.status >= 500, rye = (e) => e.response ? e.response.status >= 400 && !ZR(e) && !QR(e) && !JR(e) && !Xp(e) && !eF(e) && !tF(e) && !nF(e) : !1;
function iye(e, t, { appNamespace: n } = {}) {
  let r = null, i = !1;
  async function a() {
    return r || (r = e.post(
      "/user/refreshes",
      {},
      {
        headers: { "X-CSRF-TOKEN": t().state.auth.csrf }
      }
    ).then((l) => l != null && l.success ? (t().commit("auth/refresh", l.data.csrf), l) : Promise.reject(l)).finally(() => {
      r = null;
    }), r);
  }
  function s() {
    if (i) return;
    i = !0, t().commit("auth/unsetCurrentUser"), sessionStorage.clear();
    const l = n ? `vuex_${n}` : "vuex";
    localStorage.removeItem(l), location.replace("/signin");
  }
  function o() {
    return i;
  }
  return { refreshSession: a, clearSessionAndRedirect: s, isRedirecting: o };
}
async function aye(e, t, n) {
  var i, a;
  const r = {
    category: "simple",
    type: "error",
    title: t
  };
  n && (r.text = ((a = (i = n.response) == null ? void 0 : i.data) == null ? void 0 : a.error) || (n == null ? void 0 : n.message)), console.error("Error: ", t, n), await e.dispatch("notifications/notify", r);
}
function ah(e) {
  var r, i;
  const t = (r = e.config) == null ? void 0 : r.url;
  return { url: t ? t.split("?")[0] : void 0, method: (i = e.config) == null ? void 0 : i.method };
}
function rF({ getStore: e, rollbar: t }) {
  async function n(i, a) {
    await aye(e(), i, a);
  }
  async function r(i) {
    var s, o;
    const a = jo.global.t;
    if (Xp(i))
      await n(a("errors.Unauthorized"), i);
    else if (JR(i))
      await n(a("errors.Forbidden"));
    else if (ZR(i))
      await n(
        ((o = (s = i.response) == null ? void 0 : s.data) == null ? void 0 : o.error) || a("errors.NotFound"),
        i
      );
    else if (QR(i) || eF(i))
      await n(a("errors.UnprocessableEntity"), i);
    else if (tF(i))
      await n(a("errors.Conflict"), i);
    else if (nF(i))
      await n(a("errors.Maintenance"));
    else if (eye(i))
      await n(a("errors.Timeout")), t.error(i, ah(i));
    else if (XR(i))
      await n(a("errors.Network")), t.error(i, ah(i));
    else if (rye(i))
      await n(a("errors.Unexpected"), i), nye(i) || (console.error(i), t.error(i, ah(i)));
    else {
      if (tye(i))
        throw i;
      await n(a("errors.Unexpected"), i), t.error(i, ah(i));
    }
  }
  return { dispatchErrorNotification: r, errorNotification: n };
}
function H_(e) {
  return { success: !0, ...e };
}
function G_(e) {
  return { success: !1, ...e };
}
function sye(e) {
  var t, n;
  return Xp(e) && ((n = (t = e.response) == null ? void 0 : t.data) == null ? void 0 : n.error) === "expired_session";
}
function oye({
  securedAxiosInstance: e,
  plainAxiosInstance: t,
  getStore: n,
  rollbar: r,
  appNamespace: i
}) {
  const { dispatchErrorNotification: a } = rF({
    getStore: n,
    rollbar: r
  }), { refreshSession: s, clearSessionAndRedirect: o, isRedirecting: l } = iye(t, n, { appNamespace: i });
  return t.interceptors.request.use((c) => (i && (c.headers["X-App-Namespace"] = i), c)), t.interceptors.response.use(
    H_,
    async (c) => (sye(c) || await a(c), G_(c.response))
  ), e.interceptors.request.use((c) => {
    i && (c.headers["X-App-Namespace"] = i);
    const f = c.method.toUpperCase();
    return f !== "OPTIONS" && f !== "GET" && (c.headers = {
      ...c.headers,
      "X-CSRF-TOKEN": n().state.auth.csrf
    }), c;
  }), e.interceptors.response.use(
    H_,
    async (c) => {
      if (Xp(c)) {
        const f = c.config;
        if (f._retry || l())
          return o(), Promise.reject(c);
        f._retry = !0;
        try {
          return await s(), f.headers["X-CSRF-TOKEN"] = n().state.auth.csrf, e(f);
        } catch (h) {
          return o(), Promise.reject(h);
        }
      }
      return await a(c), G_(c.response);
    }
  ), { successResponse: H_, errorResponse: G_ };
}
const lye = 3e4;
function uye(e) {
  return typeof FormData < "u" && (e == null ? void 0 : e.data) instanceof FormData;
}
function cye(e) {
  return XR(e) && wB(e) && !uye(e.config);
}
const dye = {
  retries: 3,
  retryDelay: PP.exponentialDelay,
  retryCondition: cye
};
function _P({ apiUrl: e, withCredentials: t }) {
  const n = xB.create({
    baseURL: e,
    withCredentials: t,
    timeout: lye,
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json"
    }
  });
  return PP(n, dye), n;
}
function mxe({
  apiUrl: e,
  getStore: t,
  rollbar: n,
  withCredentials: r = !0,
  appNamespace: i
}) {
  r && !i && console.warn("[createApiClient] appNamespace is required when withCredentials is true");
  const a = _P({ apiUrl: e, withCredentials: r });
  if (!r) {
    const { dispatchErrorNotification: o } = rF({
      getStore: t,
      rollbar: n
    });
    return a.interceptors.response.use(
      (l) => ({ success: !0, ...l }),
      async (l) => (await o(l), {
        success: !1,
        ...l.response || { message: l.message, code: l.code }
      })
    ), { plainAxiosInstance: a };
  }
  const s = _P({ apiUrl: e, withCredentials: r });
  return oye({
    securedAxiosInstance: s,
    plainAxiosInstance: a,
    getStore: t,
    rollbar: n,
    appNamespace: i
  }), { plainAxiosInstance: a, securedAxiosInstance: s };
}
const Y_ = "chunk_reload";
function fye(e) {
  const t = (e == null ? void 0 : e.message) || "";
  return /ChunkLoadError|Loading chunk [\w-]+ failed|Failed to fetch dynamically imported|importing a module script failed/i.test(
    t
  );
}
function gxe({
  router: e,
  currentVersion: t,
  pollIntervalMs: n = 300 * 1e3
} = {}) {
  if (e.onError((c) => {
    fye(c) && !sessionStorage.getItem(Y_) && (sessionStorage.setItem(Y_, "1"), window.location.reload());
  }), e.afterEach(() => sessionStorage.removeItem(Y_)), !t)
    return () => {
    };
  let r = !1, i = null;
  const a = () => {
    i !== null && (clearInterval(i), i = null), document.removeEventListener("visibilitychange", l);
  };
  async function s() {
    try {
      const c = await fetch(`/version.json?ts=${Date.now()}`, {
        cache: "no-store"
      });
      if (!c.ok) return null;
      const f = await c.json();
      return (f == null ? void 0 : f.version) ?? null;
    } catch {
      return null;
    }
  }
  async function o() {
    if (r) return;
    const c = await s();
    c && c !== t && (r = !0, a());
  }
  function l() {
    document.visibilityState === "visible" && o();
  }
  return i = setInterval(o, n), document.addEventListener("visibilitychange", l), e.beforeEach((c, f, h) => {
    if (r && c.fullPath !== f.fullPath) {
      window.location.assign(e.resolve(c).href);
      return;
    }
    h();
  }), a;
}
var gh = {
  logger: typeof console < "u" ? console : void 0,
  WebSocket: typeof WebSocket < "u" ? WebSocket : void 0
}, Dn = {
  log(...e) {
    this.enabled && (e.push(Date.now()), gh.logger.log("[ActionCable]", ...e));
  }
};
const kc = () => (/* @__PURE__ */ new Date()).getTime(), sh = (e) => (kc() - e) / 1e3;
class Lx {
  constructor(t) {
    this.visibilityDidChange = this.visibilityDidChange.bind(this), this.connection = t, this.reconnectAttempts = 0;
  }
  start() {
    this.isRunning() || (this.startedAt = kc(), delete this.stoppedAt, this.startPolling(), addEventListener("visibilitychange", this.visibilityDidChange), Dn.log(`ConnectionMonitor started. stale threshold = ${this.constructor.staleThreshold} s`));
  }
  stop() {
    this.isRunning() && (this.stoppedAt = kc(), this.stopPolling(), removeEventListener("visibilitychange", this.visibilityDidChange), Dn.log("ConnectionMonitor stopped"));
  }
  isRunning() {
    return this.startedAt && !this.stoppedAt;
  }
  recordMessage() {
    this.pingedAt = kc();
  }
  recordConnect() {
    this.reconnectAttempts = 0, delete this.disconnectedAt, Dn.log("ConnectionMonitor recorded connect");
  }
  recordDisconnect() {
    this.disconnectedAt = kc(), Dn.log("ConnectionMonitor recorded disconnect");
  }
  startPolling() {
    this.stopPolling(), this.poll();
  }
  stopPolling() {
    clearTimeout(this.pollTimeout);
  }
  poll() {
    this.pollTimeout = setTimeout((() => {
      this.reconnectIfStale(), this.poll();
    }), this.getPollInterval());
  }
  getPollInterval() {
    const { staleThreshold: t, reconnectionBackoffRate: n } = this.constructor, r = Math.pow(1 + n, Math.min(this.reconnectAttempts, 10)), a = (this.reconnectAttempts === 0 ? 1 : n) * Math.random();
    return t * 1e3 * r * (1 + a);
  }
  reconnectIfStale() {
    this.connectionIsStale() && (Dn.log(`ConnectionMonitor detected stale connection. reconnectAttempts = ${this.reconnectAttempts}, time stale = ${sh(this.refreshedAt)} s, stale threshold = ${this.constructor.staleThreshold} s`), this.reconnectAttempts++, this.disconnectedRecently() ? Dn.log(`ConnectionMonitor skipping reopening recent disconnect. time disconnected = ${sh(this.disconnectedAt)} s`) : (Dn.log("ConnectionMonitor reopening"), this.connection.reopen()));
  }
  get refreshedAt() {
    return this.pingedAt ? this.pingedAt : this.startedAt;
  }
  connectionIsStale() {
    return sh(this.refreshedAt) > this.constructor.staleThreshold;
  }
  disconnectedRecently() {
    return this.disconnectedAt && sh(this.disconnectedAt) < this.constructor.staleThreshold;
  }
  visibilityDidChange() {
    document.visibilityState === "visible" && setTimeout((() => {
      (this.connectionIsStale() || !this.connection.isOpen()) && (Dn.log(`ConnectionMonitor reopening stale connection on visibilitychange. visibilityState = ${document.visibilityState}`), this.connection.reopen());
    }), 200);
  }
}
Lx.staleThreshold = 6;
Lx.reconnectionBackoffRate = 0.15;
var iF = {
  message_types: {
    welcome: "welcome",
    disconnect: "disconnect",
    ping: "ping",
    confirmation: "confirm_subscription",
    rejection: "reject_subscription"
  },
  default_mount_path: "/cable",
  protocols: ["actioncable-v1-json", "actioncable-unsupported"]
};
const { message_types: mc, protocols: Jy } = iF, hye = Jy.slice(0, Jy.length - 1), yP = [].indexOf;
class $x {
  constructor(t) {
    this.open = this.open.bind(this), this.consumer = t, this.subscriptions = this.consumer.subscriptions, this.monitor = new Lx(this), this.disconnected = !0;
  }
  send(t) {
    return this.isOpen() ? (this.webSocket.send(JSON.stringify(t)), !0) : !1;
  }
  open() {
    if (this.isActive())
      return Dn.log(`Attempted to open WebSocket, but existing socket is ${this.getState()}`), !1;
    {
      const t = [...Jy, ...this.consumer.subprotocols || []];
      return Dn.log(`Opening WebSocket, current state is ${this.getState()}, subprotocols: ${t}`), this.webSocket && this.uninstallEventHandlers(), this.webSocket = new gh.WebSocket(this.consumer.url, t), this.installEventHandlers(), this.monitor.start(), !0;
    }
  }
  close({ allowReconnect: t } = {
    allowReconnect: !0
  }) {
    if (t || this.monitor.stop(), this.isOpen())
      return this.webSocket.close();
  }
  reopen() {
    if (Dn.log(`Reopening WebSocket, current state is ${this.getState()}`), this.isActive())
      try {
        return this.close();
      } catch (t) {
        Dn.log("Failed to reopen WebSocket", t);
      } finally {
        Dn.log(`Reopening WebSocket in ${this.constructor.reopenDelay}ms`), setTimeout(this.open, this.constructor.reopenDelay);
      }
    else
      return this.open();
  }
  getProtocol() {
    if (this.webSocket)
      return this.webSocket.protocol;
  }
  isOpen() {
    return this.isState("open");
  }
  isActive() {
    return this.isState("open", "connecting");
  }
  triedToReconnect() {
    return this.monitor.reconnectAttempts > 0;
  }
  isProtocolSupported() {
    return yP.call(hye, this.getProtocol()) >= 0;
  }
  isState(...t) {
    return yP.call(t, this.getState()) >= 0;
  }
  getState() {
    if (this.webSocket) {
      for (let t in gh.WebSocket)
        if (gh.WebSocket[t] === this.webSocket.readyState)
          return t.toLowerCase();
    }
    return null;
  }
  installEventHandlers() {
    for (let t in this.events) {
      const n = this.events[t].bind(this);
      this.webSocket[`on${t}`] = n;
    }
  }
  uninstallEventHandlers() {
    for (let t in this.events)
      this.webSocket[`on${t}`] = function() {
      };
  }
}
$x.reopenDelay = 500;
$x.prototype.events = {
  message(e) {
    if (!this.isProtocolSupported())
      return;
    const { identifier: t, message: n, reason: r, reconnect: i, type: a } = JSON.parse(e.data);
    switch (this.monitor.recordMessage(), a) {
      case mc.welcome:
        return this.triedToReconnect() && (this.reconnectAttempted = !0), this.monitor.recordConnect(), this.subscriptions.reload();
      case mc.disconnect:
        return Dn.log(`Disconnecting. Reason: ${r}`), this.close({
          allowReconnect: i
        });
      case mc.ping:
        return null;
      case mc.confirmation:
        return this.subscriptions.confirmSubscription(t), this.reconnectAttempted ? (this.reconnectAttempted = !1, this.subscriptions.notify(t, "connected", {
          reconnected: !0
        })) : this.subscriptions.notify(t, "connected", {
          reconnected: !1
        });
      case mc.rejection:
        return this.subscriptions.reject(t);
      default:
        return this.subscriptions.notify(t, "received", n);
    }
  },
  open() {
    if (Dn.log(`WebSocket onopen event, using '${this.getProtocol()}' subprotocol`), this.disconnected = !1, !this.isProtocolSupported())
      return Dn.log("Protocol is unsupported. Stopping monitor and disconnecting."), this.close({
        allowReconnect: !1
      });
  },
  close(e) {
    if (Dn.log("WebSocket onclose event"), !this.disconnected)
      return this.disconnected = !0, this.monitor.recordDisconnect(), this.subscriptions.notifyAll("disconnected", {
        willAttemptReconnect: this.monitor.isRunning()
      });
  },
  error() {
    Dn.log("WebSocket onerror event");
  }
};
const pye = function(e, t) {
  if (t != null)
    for (let n in t) {
      const r = t[n];
      e[n] = r;
    }
  return e;
};
class mye {
  constructor(t, n = {}, r) {
    this.consumer = t, this.identifier = JSON.stringify(n), pye(this, r);
  }
  perform(t, n = {}) {
    return n.action = t, this.send(n);
  }
  send(t) {
    return this.consumer.send({
      command: "message",
      identifier: this.identifier,
      data: JSON.stringify(t)
    });
  }
  unsubscribe() {
    return this.consumer.subscriptions.remove(this);
  }
}
class gye {
  constructor(t) {
    this.subscriptions = t, this.pendingSubscriptions = [];
  }
  guarantee(t) {
    this.pendingSubscriptions.indexOf(t) == -1 ? (Dn.log(`SubscriptionGuarantor guaranteeing ${t.identifier}`), this.pendingSubscriptions.push(t)) : Dn.log(`SubscriptionGuarantor already guaranteeing ${t.identifier}`), this.startGuaranteeing();
  }
  forget(t) {
    Dn.log(`SubscriptionGuarantor forgetting ${t.identifier}`), this.pendingSubscriptions = this.pendingSubscriptions.filter(((n) => n !== t));
  }
  startGuaranteeing() {
    this.stopGuaranteeing(), this.retrySubscribing();
  }
  stopGuaranteeing() {
    clearTimeout(this.retryTimeout);
  }
  retrySubscribing() {
    this.retryTimeout = setTimeout((() => {
      this.subscriptions && typeof this.subscriptions.subscribe == "function" && this.pendingSubscriptions.map(((t) => {
        Dn.log(`SubscriptionGuarantor resubscribing ${t.identifier}`), this.subscriptions.subscribe(t);
      }));
    }), 500);
  }
}
class vye {
  constructor(t) {
    this.consumer = t, this.guarantor = new gye(this), this.subscriptions = [];
  }
  create(t, n) {
    const r = t, i = typeof r == "object" ? r : {
      channel: r
    }, a = new mye(this.consumer, i, n);
    return this.add(a);
  }
  add(t) {
    return this.subscriptions.push(t), this.consumer.ensureActiveConnection(), this.notify(t, "initialized"), this.subscribe(t), t;
  }
  remove(t) {
    return this.forget(t), this.findAll(t.identifier).length || this.sendCommand(t, "unsubscribe"), t;
  }
  reject(t) {
    return this.findAll(t).map(((n) => (this.forget(n), this.notify(n, "rejected"), n)));
  }
  forget(t) {
    return this.guarantor.forget(t), this.subscriptions = this.subscriptions.filter(((n) => n !== t)), t;
  }
  findAll(t) {
    return this.subscriptions.filter(((n) => n.identifier === t));
  }
  reload() {
    return this.subscriptions.map(((t) => this.subscribe(t)));
  }
  notifyAll(t, ...n) {
    return this.subscriptions.map(((r) => this.notify(r, t, ...n)));
  }
  notify(t, n, ...r) {
    let i;
    return typeof t == "string" ? i = this.findAll(t) : i = [t], i.map(((a) => typeof a[n] == "function" ? a[n](...r) : void 0));
  }
  subscribe(t) {
    this.sendCommand(t, "subscribe") && this.guarantor.guarantee(t);
  }
  confirmSubscription(t) {
    Dn.log(`Subscription confirmed ${t}`), this.findAll(t).map(((n) => this.guarantor.forget(n)));
  }
  sendCommand(t, n) {
    const { identifier: r } = t;
    return this.consumer.send({
      command: n,
      identifier: r
    });
  }
}
class bye {
  constructor(t) {
    this._url = t, this.subscriptions = new vye(this), this.connection = new $x(this), this.subprotocols = [];
  }
  get url() {
    return _ye(this._url);
  }
  send(t) {
    return this.connection.send(t);
  }
  connect() {
    return this.connection.open();
  }
  disconnect() {
    return this.connection.close({
      allowReconnect: !1
    });
  }
  ensureActiveConnection() {
    if (!this.connection.isActive())
      return this.connection.open();
  }
  addSubProtocol(t) {
    this.subprotocols = [...this.subprotocols, t];
  }
}
function _ye(e) {
  if (typeof e == "function" && (e = e()), e && !/^wss?:/i.test(e)) {
    const t = document.createElement("a");
    return t.href = e, t.href = t.href, t.protocol = t.protocol.replace("http", "ws"), t.href;
  } else
    return e;
}
function yye(e = xye("url") || iF.default_mount_path) {
  return new bye(e);
}
function xye(e) {
  const t = document.head.querySelector(`meta[name='action-cable-${e}']`);
  if (t)
    return t.getAttribute("content");
}
let Ja = null, Uo = null;
function vxe({
  apiBaseUrl: e,
  namespace: t,
  onMessage: n,
  onConnected: r
}) {
  if (Ja && Uo && Ja.connection.isActive())
    return { consumer: Ja, subscription: Uo };
  wye();
  const i = location.protocol === "https:" ? "wss:" : "ws:", a = new URL(e), s = `${i}//${a.host}/cable?app_namespace=${t}`;
  return Ja = yye(s), Uo = Ja.subscriptions.create(
    { channel: "NotificationsChannel" },
    {
      connected() {
        r && r();
      },
      disconnected() {
      },
      received(o) {
        n && n(o);
      }
    }
  ), { consumer: Ja, subscription: Uo };
}
function wye() {
  Uo && (Uo.unsubscribe(), Uo = null), Ja && (Ja.disconnect(), Ja = null);
}
const kye = {
  props: {
    name: { type: String, required: !0 }
  },
  computed: {
    initials() {
      return this.name.split(/\s+/).filter(Boolean).slice(0, 2).map((e) => e[0].toUpperCase()).join("");
    }
  }
}, Sye = ["title"];
function Cye(e, t, n, r, i, a) {
  return _(), O("span", {
    class: "inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-50 text-xs font-medium text-primary-dark",
    title: n.name
  }, j(a.initials), 9, Sye);
}
const Tye = /* @__PURE__ */ we(kye, [["render", Cye]]), K_ = "unassigned", Aye = {
  components: {
    ChevronDownIcon: Qc,
    InitialsAvatar: Tye,
    Listbox: EO,
    ListboxButton: PO,
    ListboxOption: MO,
    ListboxOptions: OO
  },
  props: {
    // The current assignee, kept apart from the list so it shows while the list is loading.
    assignee: { type: Object, default: null },
    assignees: { type: Array, required: !0 },
    unassignedLabel: { type: String, required: !0 }
  },
  emits: ["select"],
  data() {
    return { UNASSIGNED: K_ };
  },
  computed: {
    selectedValue() {
      var e;
      return ((e = this.assignee) == null ? void 0 : e.id) ?? K_;
    }
  },
  methods: {
    optionClass(e) {
      return [
        e ? "bg-gray-100 text-gray-900" : "text-gray-700",
        "flex cursor-pointer items-center gap-2 px-3 py-2 text-sm"
      ];
    },
    select(e) {
      this.$emit("select", e === K_ ? null : e);
    }
  }
}, Dye = { class: "min-w-0 flex-1 truncate" }, Eye = ["aria-label"], Pye = { class: "truncate" };
function Oye(e, t, n, r, i, a) {
  const s = U("InitialsAvatar"), o = U("ChevronDownIcon"), l = U("ListboxButton"), c = U("ListboxOption"), f = U("ListboxOptions"), h = U("Listbox");
  return _(), ae(h, {
    as: "div",
    class: "relative",
    "model-value": a.selectedValue,
    "onUpdate:modelValue": a.select
  }, {
    default: ie(() => [
      W(l, {
        "data-test": "assignee-selector",
        class: "flex w-full items-center gap-2 rounded-md bg-white px-2.5 py-1.5 text-left text-sm font-semibold text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"
      }, {
        default: ie(() => {
          var p;
          return [
            n.assignee ? (_(), ae(s, {
              key: 0,
              name: n.assignee.fullName
            }, null, 8, ["name"])) : L("", !0),
            k("span", Dye, j(((p = n.assignee) == null ? void 0 : p.fullName) ?? n.unassignedLabel), 1),
            W(o, {
              class: "h-4 w-4 shrink-0",
              "aria-hidden": "true"
            })
          ];
        }),
        _: 1
      }),
      W(f, { class: "absolute left-0 z-10 mt-2 max-h-60 w-full overflow-auto rounded-md bg-white py-1 shadow-lg ring-1 ring-black/5 focus:outline-none" }, {
        default: ie(() => [
          W(c, {
            value: i.UNASSIGNED,
            as: "template"
          }, {
            default: ie(({ active: p }) => [
              k("li", {
                "data-test": "assignee-option",
                class: Pe(a.optionClass(p))
              }, j(n.unassignedLabel), 3)
            ]),
            _: 1
          }, 8, ["value"]),
          (_(!0), O(Re, null, Ke(n.assignees, (p) => (_(), ae(c, {
            key: p.id,
            value: p.id,
            as: "template"
          }, {
            default: ie(({ active: g }) => [
              k("li", {
                "data-test": "assignee-option",
                "aria-label": p.fullName,
                class: Pe(a.optionClass(g))
              }, [
                W(s, {
                  name: p.fullName
                }, null, 8, ["name"]),
                k("span", Pye, j(p.fullName), 1)
              ], 10, Eye)
            ]),
            _: 2
          }, 1032, ["value"]))), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model-value", "onUpdate:modelValue"]);
}
const bxe = /* @__PURE__ */ we(Aye, [["render", Oye]]);
function _xe(e, t) {
  const n = window.URL.createObjectURL(new Blob([e]));
  Mye(n, t);
}
function Mye(e, t) {
  const n = document.createElement("a");
  n.href = e, n.setAttribute("download", t), document.body.appendChild(n), n.click(), document.body.removeChild(n), window.URL.revokeObjectURL(e);
}
function yxe(e) {
  switch (e) {
    case "to_be_approved":
      return yB;
    case "approved":
    case "resolved":
      return ap;
    case "pending":
      return _B;
    case "processing":
      return bB;
    case "refused":
    case "cancelled":
    case "quotation_refused":
    case "invoice_refused":
      return vB;
    case "pending_additional_info":
    case "waiting_for_quotation":
    case "waiting_for_invoice":
    case "waiting_for_resolution":
      return _h;
    case "pending_deductible_payment":
    case "pending_deductible_payment_and_final_settlement":
    case "pending_final_settlement":
      return gB;
    case "quotation_to_be_approved":
    case "quotation_approved":
    case "invoice_to_be_approved":
    case "invoice_approved":
      return mB;
    case "waiting_for_customer_iban":
      return pB;
    case "waiting_for_return_appointment":
    case "pickup_scheduled":
      return _h;
    default:
      return hB;
  }
}
function xxe(e) {
  switch (e) {
    case "to_be_approved":
    case "quotation_to_be_approved":
    case "invoice_to_be_approved":
      return "bg-yellow-500";
    case "approved":
    case "quotation_approved":
    case "invoice_approved":
    case "resolved":
      return "bg-green-500";
    case "refused":
    case "cancelled":
    case "quotation_refused":
    case "invoice_refused":
      return "bg-red-500";
    case "pending":
    case "pending_additional_info":
      return "bg-purple-500";
    case "processing":
    case "waiting_for_quotation":
    case "waiting_for_invoice":
    case "waiting_for_resolution":
      return "bg-blue-500";
    case "pending_deductible_payment":
    case "pending_deductible_payment_and_final_settlement":
    case "pending_final_settlement":
      return "bg-orange-500";
    case "waiting_for_customer_iban":
      return "bg-purple-500";
    case "waiting_for_return_appointment":
    case "pickup_scheduled":
      return "bg-blue-500";
    default:
      return "bg-gray-400";
  }
}
function wxe(e) {
  return `de ${Si(e.priceBandMin)} à ${Si(e.priceBandMax)}`;
}
function kxe(e) {
  return e.monthlyBilling ? "Mensuel" : K0().global.t(`termLength.${e.termLength}_year`);
}
function Sxe(e) {
  if (e >= 12) {
    const t = e / 12;
    return `${t} an${t > 1 ? "s" : ""}`;
  }
  return `${e} mois`;
}
function Cxe(e) {
  return e ? `${e.slice(0, 4)} •••• ${e.slice(-4)}` : "";
}
const oh = [
  "bg-green-100 text-green-800",
  "bg-blue-100 text-blue-800",
  "bg-yellow-100 text-yellow-800",
  "bg-purple-100 text-purple-800",
  "bg-pink-100 text-pink-800",
  "bg-indigo-100 text-indigo-800"
];
function Txe(e, t) {
  if (!Array.isArray(t)) return oh[0];
  const n = t.indexOf(e);
  return n === -1 ? oh[0] : oh[n % oh.length];
}
function Axe(e) {
  if (!Array.isArray(e)) return [];
  const t = e.filter(
    (n) => parseFloat(n.deductible) > 0 || parseFloat(n.minDeductible) > 0
  );
  return t.length === 0 ? [] : t.map((n) => {
    const r = parseFloat(n.deductible) > 0, i = parseFloat(n.minDeductible) > 0;
    let a;
    if (r) {
      const s = n.deductibleType === "percentage" ? `${n.deductible}%` : Si(n.deductible);
      a = i ? `${s} (min. ${Si(n.minDeductible)})` : s;
    } else
      a = `min. ${Si(n.minDeductible)}`;
    return { coverageName: n.name, value: a };
  });
}
function Dxe(e) {
  if (!e) return "Pas de vétusté";
  const t = Number(e.startMonth), n = Number.isFinite(t) ? t + 1 : 1;
  return e.depreciationType === "monthly" && parseFloat(e.monthlyIncrease) > 0 ? `${e.monthlyIncrease}% par mois à partir du ${n}e mois` : (e.depreciationType === "annual" || e.depreciationType === "annual_from_start") && parseFloat(e.yearlyIncrease) > 0 ? `${e.yearlyIncrease}% par an à partir du ${n}e mois` : "Pas de vétusté";
}
const Iye = ["paymentsNotUpToDate", "withinCommitmentPeriod", "hasApprovedClaim"], Rye = ["paymentsNotUpToDate", "hasApprovedClaim"];
function Exe(e) {
  return e ? Iye.some((t) => !!e[t]) : !1;
}
function Pxe(e) {
  return e ? Rye.some((t) => !!e[t]) : !1;
}
const Fye = /^(chrome-extension|moz-extension|safari-extension|safari-web-extension):\/\//, Nye = /^[^?#]*\.js([?#]|$)/;
function Lye(e) {
  const t = e == null ? void 0 : e.frames;
  return t != null && t.length ? t[t.length - 1].filename : void 0;
}
function $ye(e, t, n) {
  var a, s;
  if (!e) return !1;
  const r = ((a = n == null ? void 0 : n.body) == null ? void 0 : a.trace_chain) || [(s = n == null ? void 0 : n.body) == null ? void 0 : s.trace], i = Lye(r[0]);
  return typeof i == "string" && (Fye.test(i) || !Nye.test(i));
}
function Oxe({ accessToken: e, environment: t }) {
  const n = new kB({
    accessToken: e,
    captureUncaught: !0,
    captureUnhandledRejections: !0,
    checkIgnore: $ye,
    payload: {
      environment: t,
      client: {
        javascript: {
          code_version: "1.0.0"
        }
      }
    }
  });
  return { rollbar: n, RollbarPlugin: {
    install(i) {
      i.config.errorHandler = (a, s, o) => {
        console.error(a), n.error(a, { vueComponent: s, info: o });
      }, i.provide("rollbar", n);
    }
  } };
}
const aF = {
  // MOBILE_PROTECTION
  BRONZE: { color: "text-orange-800", maxCoverage: 500 },
  ARGENT: { color: "text-gray-500", maxCoverage: 1e3 },
  OR: { color: "text-yellow-500", maxCoverage: 3e3 },
  PLATINE: { color: "", maxCoverage: 5e3 },
  // CONNECT_PROTECTION
  PREMIUM: { color: "text-yellow-500", maxCoverage: 150 },
  MEDIUM: { color: "text-orange-500", maxCoverage: 300 },
  PLATINIUM: { color: "text-blue-400", maxCoverage: 600 },
  EXCELLIUM: { color: "text-blue-500", maxCoverage: 900 },
  MAXIMUM: { color: "text-green-500", maxCoverage: 1200 },
  SUMMUM: { color: "text-green-700", maxCoverage: 2500 }
}, Mxe = (e) => {
  var t;
  return ((t = aF[e]) == null ? void 0 : t.color) ?? "";
}, Ixe = (e) => {
  var t;
  return ((t = aF[e]) == null ? void 0 : t.maxCoverage) ?? null;
}, Vye = ["mobile_protection", "connect_protection"], Rxe = (e) => Vye.includes(e), Fxe = (e) => e === "mobile_protection", Nxe = (e) => e === "connect_protection", Bye = [
  "I found a cheaper insurance",
  "Insurance is too expensive",
  "I found no interest in the solution",
  "My product is already covered by another insurance",
  "I cancelled my purchase",
  "I had a poor experience with Estaly",
  "I have no particular reason"
], Uye = [
  "Payments not up-to-date",
  "Termination of old contract for new subscription",
  "Correction"
], Lxe = [
  ...Uye,
  ...Bye
];
function $xe(e) {
  return ((e == null ? void 0 : e.productNature) ?? (e == null ? void 0 : e.product_nature)) === "virtual";
}
function Vxe(e, t) {
  let n = 1, r = null;
  const i = typeof t == "function" ? t : (a) => a[t];
  return e.map((a, s) => {
    const o = i(a);
    return r !== o && (n = s + 1), r = o, { ...a, rank: n };
  });
}
const Bxe = {
  data() {
    return {
      extracting: !1,
      extractionError: !1,
      extractionNotFound: !1,
      extractionSuccess: !1,
      extractionToken: 0
    };
  },
  watch: {
    async file(e) {
      var t, n, r;
      if (e) {
        const i = ++this.extractionToken;
        this.extracting = !0, this.extractionError = !1, this.extractionNotFound = !1, this.extractionSuccess = !1, this.costItems = [];
        try {
          const a = await this.extractCostItems({ file: e });
          if (i !== this.extractionToken) return;
          (n = (t = a == null ? void 0 : a.data) == null ? void 0 : t.cost_items) != null && n.length ? (this.costItems = jR(a.data.cost_items), this.extractionSuccess = !0) : (r = a == null ? void 0 : a.data) != null && r.extraction_error ? this.extractionError = !0 : this.extractionNotFound = !0;
        } catch {
          if (i !== this.extractionToken) return;
          this.extractionError = !0, this.extractionSuccess = !1;
        } finally {
          i === this.extractionToken && (this.extracting = !1);
        }
      }
    }
  }
}, Uxe = {
  data() {
    return {
      extractingIban: !1,
      ibanExtractionError: !1,
      ibanExtractionFailed: !1,
      ibanExtractionSuccess: !1,
      ibanExtractionToken: 0
    };
  },
  methods: {
    async runIbanExtraction(e) {
      if (!e) return;
      const t = ++this.ibanExtractionToken;
      this.extractingIban = !0, this.ibanExtractionError = !1, this.ibanExtractionFailed = !1, this.ibanExtractionSuccess = !1;
      try {
        const n = await this.extractIban({ file: e });
        if (t !== this.ibanExtractionToken) return;
        n ? (this.iban = n, this.ibanExtractionSuccess = !0) : (this.ibanExtractionError = !0, this.ibanExtractionFailed = n == null);
      } catch {
        if (t !== this.ibanExtractionToken) return;
        this.ibanExtractionError = !0, this.ibanExtractionFailed = !0;
      } finally {
        t === this.ibanExtractionToken && (this.extractingIban = !1);
      }
    }
  }
};
class qxe {
  constructor(t, n) {
    this.email = t, this.password = n;
  }
}
export {
  R0e as ActionsMenu,
  F0e as ActionsMenuItem,
  GS as AddressStep,
  so as Alert,
  x0e as AnalyticsClaimCards,
  p0e as AnalyticsDateRangePicker,
  Vce as AnalyticsSalesRepartition,
  rC as AntiTheftDeviceInvoiceStep,
  bxe as AssigneeSelector,
  ixe as Banner,
  J0e as BaseAlert,
  Qj as BirthDateInput,
  nxe as Block,
  rxe as BlockList,
  JS as BreakdownImpactOrDropStep,
  QS as BreakdownQuestionStep,
  Iye as CANCELLATION_BLOCKER_KEYS,
  Rye as CANCELLATION_HARD_BLOCKER_KEYS,
  Bye as CLIENT_CANCELLATION_REASONS,
  c0e as CardSelector,
  axe as ChartBar,
  fs as Checkbox,
  $K as ClaimDeclaration,
  Gn as ClaimDeclarationFormNextButton,
  Vn as ClaimDeclarationFormStep,
  m0e as ClaimNewDeclarationVersionForm,
  X0e as ClaimProductSummary,
  Lfe as ClearFiltersButton,
  q0e as ClickPopoverButton,
  g0e as CollapsableContent,
  Z0e as CompensationValueAlert,
  tC as ComplaintsReceiptStep,
  rpe as CopyToClipboard,
  H0e as CopyableFieldRow,
  wve as CostItems,
  Q0e as CostItemsConfirmation,
  oxe as CountryListboxField,
  XS as CoverageStep,
  k0e as CreateButton,
  w0e as DataCardWithVariation,
  IQ as DataCart,
  e0e as DataList,
  t0e as DateRangePicker,
  hC as DeclarationCompletedStep,
  eC as DescriptionStep,
  _de as ExtractionStatus,
  j0e as FieldRow,
  G0e as FieldSpan,
  hs as FileField,
  lbe as FileFrame,
  Lhe as FilterButton,
  K0e as FixeableProductProcess,
  hu as FormField,
  lC as FraudulentSimUseProofStep,
  oC as FraudulentSimUseStep,
  Pde as FullScreenModal,
  kn as GenericButton,
  s0e as GoogleAddress,
  dxe as GradientHalo,
  dC as HomeInsuranceCertificateStep,
  pde as InfoBanner,
  Tye as InitialsAvatar,
  W0e as InlineLink,
  cC as InvoiceHolderProofStep,
  uC as InvoiceHolderStep,
  S0e as LineChart,
  N0e as LinkButton,
  z0e as LinkField,
  nJ as Loading,
  o0e as LocationField,
  Vye as MPCP_CATEGORIES,
  h0e as MarkdownText,
  sC as MarkingNumberPhotosStep,
  aC as MarkingNumberStep,
  C0e as Modal,
  V_e as ModalNotification,
  lxe as ModernButton,
  cxe as ModernCard,
  uxe as ModernFormField,
  T0e as MonthPicker,
  A0e as MonthSelector,
  dG as MultiSelect,
  u0e as MultiSelectSearch,
  D0e as NotFound,
  hxe as Notifications,
  Lxe as OPS_CANCELLATION_REASONS,
  Uye as OPS_ONLY_CANCELLATION_REASONS,
  YS as OccurrenceDateStep,
  KS as OccurrencePlaceStep,
  B0e as PageHeader,
  E0e as Pagination,
  fxe as PasswordToggleButton,
  HS as PersonalInformationStep,
  Fce as PieChart,
  P0e as Pills,
  Y0e as PricingDetails,
  I0e as PrimaryButton,
  nC as ProductInvoiceStep,
  iC as ProductPhotosStep,
  bQ as ProgressionBar,
  XX as RadioButtons,
  y0e as SalesAnalytics,
  Rfe as SearchBarFilter,
  d0e as SearchSelector,
  M0e as SearchToolbar,
  lR as SecondaryButton,
  hY as Selector,
  HJ as SellerRankingTable,
  U0e as ShowPageHeader,
  Y_e as SimpleNotification,
  $0e as SortToggle,
  Y0 as Spinner,
  yp as StackedField,
  XJ as StoreRankingTable,
  yM as Table,
  che as Tabs,
  V0e as TabsNavigation,
  xY as Textarea,
  ZS as TheftTypeStep,
  txe as TieredProgressBar,
  L0e as ToggleGroup,
  exe as TrainingResources,
  qxe as User,
  QI as Variation,
  tbe as VideoFrame,
  sxe as VoucherInformation,
  iO as compressImage,
  Vxe as computeCompetitionRanking,
  Dxe as computeDepreciationLabel,
  kve as computeTotalTTC,
  vxe as connectCable,
  Q7 as containInViewport,
  Y2 as convertDateFormat,
  bM as countries,
  mxe as createApiClient,
  rF as createErrorNotificationHandler,
  Oxe as createRollbar,
  W2 as currentMonth,
  H2 as currentMonthRange,
  z2 as currentWeek,
  G2 as currentWeekRange,
  Wj as currentYear,
  wye as disconnectCable,
  _xe as download,
  Mye as downloadFromUrl,
  Bxe as extractCostItemsMixin,
  Uxe as extractIbanMixin,
  Axe as formatDeductibles,
  Sxe as formatDuration,
  R6 as formatLocation,
  X0 as formatPercentage,
  Si as formatPrice,
  wxe as formatPriceBand,
  _0e as formatPriceTTC,
  kxe as formatTermLength,
  yxe as getClaimStatusIcon,
  xxe as getClaimStatusIconBackground,
  Txe as getCoverageColorClass,
  Ixe as getMpcpMaxCoverage,
  Mxe as getMpcpOfferColor,
  Exe as hasCancellationBlockers,
  b0e as i18nPluginExtended,
  $ye as ignoreBrowserExtensionErrors,
  Bc as inputDateFormat,
  Jye as isAdult,
  r0e as isArrayEmpty,
  i0e as isArrayNotEmpty,
  Pxe as isCancellationBlocked,
  Nxe as isConnectProtection,
  Fxe as isMobileProtection,
  Rxe as isMpcpCategory,
  n0e as isObjectValid,
  Cr as isPresent,
  Xye as isPurchasedToday,
  Zye as isPurchasedWithin30Days,
  iS as isStringValid,
  $xe as isVirtualProduct,
  Cxe as maskIban,
  Qye as parseClaimDate,
  Hj as parseFrDate,
  a0e as phoneRegex,
  Mj as previousMonth,
  Rj as previousMonthRange,
  Ij as previousWeek,
  Fj as previousWeekRange,
  oye as setupAxiosInterceptors,
  v0e as setupI18n,
  gxe as setupVersionCheck,
  O0e as snakeCaseToWords,
  bP as toCamelCase,
  vP as toSnakeCase,
  pxe as transformHashKeys
};
